(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@readme/variable"), require("@tippyjs/react"), require("react"));
	else if(typeof define === 'function' && define.amd)
		define(["@readme/variable", "@tippyjs/react", "react"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("@readme/variable"), require("@tippyjs/react"), require("react")) : factory(root["@readme/variable"], root["@tippyjs/react"], root["React"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(self, (__WEBPACK_EXTERNAL_MODULE__3689__, __WEBPACK_EXTERNAL_MODULE__578__, __WEBPACK_EXTERNAL_MODULE__4466__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 7228:
/***/ ((module) => {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 2858:
/***/ ((module) => {

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 3646:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayLikeToArray = __webpack_require__(7228);

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}

module.exports = _arrayWithoutHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 1506:
/***/ ((module) => {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 4575:
/***/ ((module) => {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 3913:
/***/ ((module) => {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 9713:
/***/ ((module) => {

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 7154:
/***/ ((module) => {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 6525:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var superPropBase = __webpack_require__(8331);

function _get() {
  if (typeof Reflect !== "undefined" && Reflect.get) {
    module.exports = _get = Reflect.get;
    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _get = function _get(target, property, receiver) {
      var base = superPropBase(target, property);
      if (!base) return;
      var desc = Object.getOwnPropertyDescriptor(base, property);

      if (desc.get) {
        return desc.get.call(arguments.length < 3 ? target : receiver);
      }

      return desc.value;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _get.apply(this, arguments);
}

module.exports = _get;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 9754:
/***/ ((module) => {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 2205:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var setPrototypeOf = __webpack_require__(9489);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 6860:
/***/ ((module) => {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

module.exports = _iterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 3884:
/***/ ((module) => {

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 521:
/***/ ((module) => {

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 8206:
/***/ ((module) => {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 6479:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var objectWithoutPropertiesLoose = __webpack_require__(7316);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 7316:
/***/ ((module) => {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 8585:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = (__webpack_require__(8)["default"]);

var assertThisInitialized = __webpack_require__(1506);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 9489:
/***/ ((module) => {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 3038:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayWithHoles = __webpack_require__(2858);

var iterableToArrayLimit = __webpack_require__(3884);

var unsupportedIterableToArray = __webpack_require__(379);

var nonIterableRest = __webpack_require__(521);

function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 8331:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var getPrototypeOf = __webpack_require__(9754);

function _superPropBase(object, property) {
  while (!Object.prototype.hasOwnProperty.call(object, property)) {
    object = getPrototypeOf(object);
    if (object === null) break;
  }

  return object;
}

module.exports = _superPropBase;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 8551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayWithHoles = __webpack_require__(2858);

var iterableToArray = __webpack_require__(6860);

var unsupportedIterableToArray = __webpack_require__(379);

var nonIterableRest = __webpack_require__(521);

function _toArray(arr) {
  return arrayWithHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableRest();
}

module.exports = _toArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 319:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayWithoutHoles = __webpack_require__(3646);

var iterableToArray = __webpack_require__(6860);

var unsupportedIterableToArray = __webpack_require__(379);

var nonIterableSpread = __webpack_require__(8206);

function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}

module.exports = _toConsumableArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 8:
/***/ ((module) => {

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 379:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var arrayLikeToArray = __webpack_require__(7228);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;

/***/ }),

/***/ 478:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var visit = __webpack_require__(791);

var hasOwnProperty = Object.prototype.hasOwnProperty;
var hastCssPropertyMap = {
  align: 'text-align',
  valign: 'vertical-align',
  height: 'height',
  width: 'width',
};

module.exports = function tableCellStyle(node) {
  visit(node, 'element', visitor);
  return node;
};

function visitor(node) {
  if (node.tagName !== 'tr' && node.tagName !== 'td' && node.tagName !== 'th') {
    return;
  }

  var hastName;
  var cssName;
  for (hastName in hastCssPropertyMap) {
    if (
      !hasOwnProperty.call(hastCssPropertyMap, hastName) ||
      node.properties[hastName] === undefined
    ) {
      continue;
    }
    cssName = hastCssPropertyMap[hastName];
    appendStyle(node, cssName, node.properties[hastName]);
    delete node.properties[hastName];
  }
}

function appendStyle(node, property, value) {
  var prevStyle = (node.properties.style || '').trim();
  if (prevStyle && !/;\s*/.test(prevStyle)) {
    prevStyle += ';';
  }
  if (prevStyle) {
    prevStyle += ' ';
  }
  var nextStyle = prevStyle + property + ': ' + value + ';';
  node.properties.style = nextStyle;
}


/***/ }),

/***/ 791:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = visit

var visitParents = __webpack_require__(9294)

var CONTINUE = visitParents.CONTINUE
var SKIP = visitParents.SKIP
var EXIT = visitParents.EXIT

visit.CONTINUE = CONTINUE
visit.SKIP = SKIP
visit.EXIT = EXIT

function visit(tree, test, visitor, reverse) {
  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor
    visitor = test
    test = null
  }

  visitParents(tree, test, overload, reverse)

  function overload(node, parents) {
    var parent = parents[parents.length - 1]
    var index = parent ? parent.children.indexOf(node) : null
    return visitor(node, index, parent)
  }
}


/***/ }),

/***/ 7721:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var s = __webpack_require__(9505);
var h = __webpack_require__(1742);
var find = __webpack_require__(9560);
var html = __webpack_require__(7247);
var svg = __webpack_require__(1218);
var vfileLocation = __webpack_require__(6976);
var ns = __webpack_require__(6);
module.exports = wrapper;
var own = {}.hasOwnProperty;

// Handlers.
var map = {
  '#document': root,
  '#document-fragment': root,
  '#text': text,
  '#comment': comment,
  '#documentType': doctype
};

// Wrapper to normalise options.
function wrapper(ast, options) {
  var settings = options || {};
  var file;
  if (settings.messages) {
    file = settings;
    settings = {};
  } else {
    file = settings.file;
  }
  return transform(ast, {
    schema: settings.space === 'svg' ? svg : html,
    file: file,
    verbose: settings.verbose
  });
}

// Transform a node.
function transform(ast, config) {
  var schema = config.schema;
  var fn = own.call(map, ast.nodeName) ? map[ast.nodeName] : element;
  var children;
  var result;
  var position;
  if (fn === element) {
    config.schema = ast.namespaceURI === ns.svg ? svg : html;
  }
  if (ast.childNodes) {
    children = nodes(ast.childNodes, config);
  }
  result = fn(ast, children, config);
  if (ast.sourceCodeLocation && config.file) {
    position = location(result, ast.sourceCodeLocation, config);
    if (position) {
      config.location = true;
      result.position = position;
    }
  }
  config.schema = schema;
  return result;
}

// Transform children.
function nodes(children, config) {
  var index = -1;
  var result = [];
  while (++index < children.length) {
    result[index] = transform(children[index], config);
  }
  return result;
}

// Transform a document.
// Stores `ast.quirksMode` in `node.data.quirksMode`.
function root(ast, children, config) {
  var result = {
    type: 'root',
    children: children,
    data: {
      quirksMode: ast.mode === 'quirks' || ast.mode === 'limited-quirks'
    }
  };
  var doc;
  var location;
  if (config.file && config.location) {
    doc = String(config.file);
    location = vfileLocation(doc);
    result.position = {
      start: location.toPoint(0),
      end: location.toPoint(doc.length)
    };
  }
  return result;
}

// Transform a doctype.
function doctype(ast) {
  return {
    type: 'doctype',
    name: ast.name || '',
    public: ast.publicId || null,
    system: ast.systemId || null
  };
}

// Transform a text.
function text(ast) {
  return {
    type: 'text',
    value: ast.value
  };
}

// Transform a comment.
function comment(ast) {
  return {
    type: 'comment',
    value: ast.data
  };
}

// Transform an element.
function element(ast, children, config) {
  var fn = config.schema.space === 'svg' ? s : h;
  var props = {};
  var index = -1;
  var result;
  var attribute;
  var pos;
  var start;
  var end;
  while (++index < ast.attrs.length) {
    attribute = ast.attrs[index];
    props[(attribute.prefix ? attribute.prefix + ':' : '') + attribute.name] = attribute.value;
  }
  result = fn(ast.tagName, props, children);
  if (result.tagName === 'template' && 'content' in ast) {
    pos = ast.sourceCodeLocation;
    start = pos && pos.startTag && position(pos.startTag).end;
    end = pos && pos.endTag && position(pos.endTag).start;
    result.content = transform(ast.content, config);
    if ((start || end) && config.file) {
      result.content.position = {
        start: start,
        end: end
      };
    }
  }
  return result;
}

// Create clean positional information.
function location(node, location, config) {
  var result = position(location);
  var tail;
  var key;
  var props;
  if (node.type === 'element') {
    tail = node.children[node.children.length - 1];

    // Bug for unclosed with children.
    // See: <https://github.com/inikulin/parse5/issues/109>.
    if (!location.endTag && tail && tail.position && tail.position.end) {
      result.end = Object.assign({}, tail.position.end);
    }
    if (config.verbose) {
      props = {};
      for (key in location.attrs) {
        props[find(config.schema, key).property] = position(location.attrs[key]);
      }
      node.data = {
        position: {
          opening: position(location.startTag),
          closing: location.endTag ? position(location.endTag) : null,
          properties: props
        }
      };
    }
  }
  return result;
}
function position(loc) {
  var start = point({
    line: loc.startLine,
    column: loc.startCol,
    offset: loc.startOffset
  });
  var end = point({
    line: loc.endLine,
    column: loc.endCol,
    offset: loc.endOffset
  });
  return start || end ? {
    start: start,
    end: end
  } : null;
}
function point(point) {
  return point.line && point.column ? point : null;
}

/***/ }),

/***/ 6976:
/***/ ((module) => {

"use strict";


module.exports = factory;
function factory(file) {
  var value = String(file);
  var indices = [];
  var search = /\r?\n|\r/g;
  while (search.exec(value)) {
    indices.push(search.lastIndex);
  }
  indices.push(value.length + 1);
  return {
    toPoint: offsetToPoint,
    toPosition: offsetToPoint,
    toOffset: pointToOffset
  };

  // Get the line and column-based `point` for `offset` in the bound indices.
  function offsetToPoint(offset) {
    var index = -1;
    if (offset > -1 && offset < indices[indices.length - 1]) {
      while (++index < indices.length) {
        if (indices[index] > offset) {
          return {
            line: index + 1,
            column: offset - (indices[index - 1] || 0) + 1,
            offset: offset
          };
        }
      }
    }
    return {};
  }

  // Get the `offset` for a line and column-based `point` in the bound
  // indices.
  function pointToOffset(point) {
    var line = point && point.line;
    var column = point && point.column;
    var offset;
    if (!isNaN(line) && !isNaN(column) && line - 1 in indices) {
      offset = (indices[line - 2] || 0) + column - 1 || 0;
    }
    return offset > -1 && offset < indices[indices.length - 1] ? offset : -1;
  }
}

/***/ }),

/***/ 8335:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var xtend = __webpack_require__(7529);
var html = __webpack_require__(7247);
var svg = __webpack_require__(1218);
var find = __webpack_require__(9560);
var toH = __webpack_require__(6331);
var ns = __webpack_require__(6);
var zwitch = __webpack_require__(8019);
module.exports = transform;
var ignoredSpaces = ['svg', 'html'];
var one = zwitch('type');
one.handlers.root = root;
one.handlers.element = element;
one.handlers.text = text;
one.handlers.comment = comment;
one.handlers.doctype = doctype;

// Transform a tree from hast to Parse5’s AST.
function transform(tree, space) {
  return one(tree, space === 'svg' ? svg : html);
}
function root(node, schema) {
  var data = node.data || {};
  var mode = data.quirksMode ? 'quirks' : 'no-quirks';
  return patch(node, {
    nodeName: '#document',
    mode: mode
  }, schema);
}
function fragment(node, schema) {
  return patch(node, {
    nodeName: '#document-fragment'
  }, schema);
}
function doctype(node, schema) {
  return patch(node, {
    nodeName: '#documentType',
    name: node.name,
    publicId: node.public || '',
    systemId: node.system || ''
  }, schema);
}
function text(node, schema) {
  return patch(node, {
    nodeName: '#text',
    value: node.value
  }, schema);
}
function comment(node, schema) {
  return patch(node, {
    nodeName: '#comment',
    data: node.value
  }, schema);
}
function element(node, schema) {
  var space = schema.space;
  var shallow = xtend(node, {
    children: []
  });
  return toH(h, shallow, {
    space: space
  });
  function h(name, attrs) {
    var values = [];
    var p5;
    var attr;
    var value;
    var key;
    var info;
    var pos;
    for (key in attrs) {
      info = find(schema, key);
      attr = attrs[key];
      if (attr === false || info.boolean && !attr) {
        continue;
      }
      value = {
        name: key,
        value: attr === true ? '' : String(attr)
      };
      if (info.space && ignoredSpaces.indexOf(info.space) === -1) {
        pos = key.indexOf(':');
        if (pos === -1) {
          value.prefix = '';
        } else {
          value.name = key.slice(pos + 1);
          value.prefix = key.slice(0, pos);
        }
        value.namespace = ns[info.space];
      }
      values.push(value);
    }
    p5 = patch(node, {
      nodeName: name,
      tagName: name,
      attrs: values
    }, schema);
    if (name === 'template') {
      p5.content = fragment(shallow.content, schema);
    }
    return p5;
  }
}

// Patch specific properties.
function patch(node, p5, parentSchema) {
  var schema = parentSchema;
  var position = node.position;
  var children = node.children;
  var childNodes = [];
  var length = children ? children.length : 0;
  var index = -1;
  var child;
  if (node.type === 'element') {
    if (schema.space === 'html' && node.tagName === 'svg') {
      schema = svg;
    }
    p5.namespaceURI = ns[schema.space];
  }
  while (++index < length) {
    child = one(children[index], schema);
    child.parentNode = p5;
    childNodes[index] = child;
  }
  if (node.type === 'element' || node.type === 'root') {
    p5.childNodes = childNodes;
  }
  if (position && position.start && position.end) {
    p5.sourceCodeLocation = {
      startLine: position.start.line,
      startCol: position.start.column,
      startOffset: position.start.offset,
      endLine: position.end.line,
      endCol: position.end.column,
      endOffset: position.end.offset
    };
  }
  return p5;
}

/***/ }),

/***/ 8980:
/***/ ((module) => {

"use strict";


module.exports = function (value) {
  if (Object.prototype.toString.call(value) !== '[object Object]') {
    return false;
  }
  var prototype = Object.getPrototypeOf(value);
  return prototype === null || prototype === Object.prototype;
};

/***/ }),

/***/ 1794:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _require = __webpack_require__(8869),
  DOCUMENT_MODE = _require.DOCUMENT_MODE;

//Const
var VALID_DOCTYPE_NAME = 'html';
var VALID_SYSTEM_ID = 'about:legacy-compat';
var QUIRKS_MODE_SYSTEM_ID = 'http://www.ibm.com/data/dtd/v11/ibmxhtml1-transitional.dtd';
var QUIRKS_MODE_PUBLIC_ID_PREFIXES = ['+//silmaril//dtd html pro v0r11 19970101//', '-//as//dtd html 3.0 aswedit + extensions//', '-//advasoft ltd//dtd html 3.0 aswedit + extensions//', '-//ietf//dtd html 2.0 level 1//', '-//ietf//dtd html 2.0 level 2//', '-//ietf//dtd html 2.0 strict level 1//', '-//ietf//dtd html 2.0 strict level 2//', '-//ietf//dtd html 2.0 strict//', '-//ietf//dtd html 2.0//', '-//ietf//dtd html 2.1e//', '-//ietf//dtd html 3.0//', '-//ietf//dtd html 3.2 final//', '-//ietf//dtd html 3.2//', '-//ietf//dtd html 3//', '-//ietf//dtd html level 0//', '-//ietf//dtd html level 1//', '-//ietf//dtd html level 2//', '-//ietf//dtd html level 3//', '-//ietf//dtd html strict level 0//', '-//ietf//dtd html strict level 1//', '-//ietf//dtd html strict level 2//', '-//ietf//dtd html strict level 3//', '-//ietf//dtd html strict//', '-//ietf//dtd html//', '-//metrius//dtd metrius presentational//', '-//microsoft//dtd internet explorer 2.0 html strict//', '-//microsoft//dtd internet explorer 2.0 html//', '-//microsoft//dtd internet explorer 2.0 tables//', '-//microsoft//dtd internet explorer 3.0 html strict//', '-//microsoft//dtd internet explorer 3.0 html//', '-//microsoft//dtd internet explorer 3.0 tables//', '-//netscape comm. corp.//dtd html//', '-//netscape comm. corp.//dtd strict html//', "-//o'reilly and associates//dtd html 2.0//", "-//o'reilly and associates//dtd html extended 1.0//", "-//o'reilly and associates//dtd html extended relaxed 1.0//", '-//sq//dtd html 2.0 hotmetal + extensions//', '-//softquad software//dtd hotmetal pro 6.0::19990601::extensions to html 4.0//', '-//softquad//dtd hotmetal pro 4.0::19971010::extensions to html 4.0//', '-//spyglass//dtd html 2.0 extended//', '-//sun microsystems corp.//dtd hotjava html//', '-//sun microsystems corp.//dtd hotjava strict html//', '-//w3c//dtd html 3 1995-03-24//', '-//w3c//dtd html 3.2 draft//', '-//w3c//dtd html 3.2 final//', '-//w3c//dtd html 3.2//', '-//w3c//dtd html 3.2s draft//', '-//w3c//dtd html 4.0 frameset//', '-//w3c//dtd html 4.0 transitional//', '-//w3c//dtd html experimental 19960712//', '-//w3c//dtd html experimental 970421//', '-//w3c//dtd w3 html//', '-//w3o//dtd w3 html 3.0//', '-//webtechs//dtd mozilla html 2.0//', '-//webtechs//dtd mozilla html//'];
var QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES = QUIRKS_MODE_PUBLIC_ID_PREFIXES.concat(['-//w3c//dtd html 4.01 frameset//', '-//w3c//dtd html 4.01 transitional//']);
var QUIRKS_MODE_PUBLIC_IDS = ['-//w3o//dtd w3 html strict 3.0//en//', '-/w3c/dtd html 4.0 transitional/en', 'html'];
var LIMITED_QUIRKS_PUBLIC_ID_PREFIXES = ['-//w3c//dtd xhtml 1.0 frameset//', '-//w3c//dtd xhtml 1.0 transitional//'];
var LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES = LIMITED_QUIRKS_PUBLIC_ID_PREFIXES.concat(['-//w3c//dtd html 4.01 frameset//', '-//w3c//dtd html 4.01 transitional//']);

//Utils
function enquoteDoctypeId(id) {
  var quote = id.indexOf('"') !== -1 ? "'" : '"';
  return quote + id + quote;
}
function hasPrefix(publicId, prefixes) {
  for (var i = 0; i < prefixes.length; i++) {
    if (publicId.indexOf(prefixes[i]) === 0) {
      return true;
    }
  }
  return false;
}

//API
exports.isConforming = function (token) {
  return token.name === VALID_DOCTYPE_NAME && token.publicId === null && (token.systemId === null || token.systemId === VALID_SYSTEM_ID);
};
exports.getDocumentMode = function (token) {
  if (token.name !== VALID_DOCTYPE_NAME) {
    return DOCUMENT_MODE.QUIRKS;
  }
  var systemId = token.systemId;
  if (systemId && systemId.toLowerCase() === QUIRKS_MODE_SYSTEM_ID) {
    return DOCUMENT_MODE.QUIRKS;
  }
  var publicId = token.publicId;
  if (publicId !== null) {
    publicId = publicId.toLowerCase();
    if (QUIRKS_MODE_PUBLIC_IDS.indexOf(publicId) > -1) {
      return DOCUMENT_MODE.QUIRKS;
    }
    var prefixes = systemId === null ? QUIRKS_MODE_NO_SYSTEM_ID_PUBLIC_ID_PREFIXES : QUIRKS_MODE_PUBLIC_ID_PREFIXES;
    if (hasPrefix(publicId, prefixes)) {
      return DOCUMENT_MODE.QUIRKS;
    }
    prefixes = systemId === null ? LIMITED_QUIRKS_PUBLIC_ID_PREFIXES : LIMITED_QUIRKS_WITH_SYSTEM_ID_PUBLIC_ID_PREFIXES;
    if (hasPrefix(publicId, prefixes)) {
      return DOCUMENT_MODE.LIMITED_QUIRKS;
    }
  }
  return DOCUMENT_MODE.NO_QUIRKS;
};
exports.serializeContent = function (name, publicId, systemId) {
  var str = '!DOCTYPE ';
  if (name) {
    str += name;
  }
  if (publicId) {
    str += ' PUBLIC ' + enquoteDoctypeId(publicId);
  } else if (systemId) {
    str += ' SYSTEM';
  }
  if (systemId !== null) {
    str += ' ' + enquoteDoctypeId(systemId);
  }
  return str;
};

/***/ }),

/***/ 4688:
/***/ ((module) => {

"use strict";


module.exports = {
  controlCharacterInInputStream: 'control-character-in-input-stream',
  noncharacterInInputStream: 'noncharacter-in-input-stream',
  surrogateInInputStream: 'surrogate-in-input-stream',
  nonVoidHtmlElementStartTagWithTrailingSolidus: 'non-void-html-element-start-tag-with-trailing-solidus',
  endTagWithAttributes: 'end-tag-with-attributes',
  endTagWithTrailingSolidus: 'end-tag-with-trailing-solidus',
  unexpectedSolidusInTag: 'unexpected-solidus-in-tag',
  unexpectedNullCharacter: 'unexpected-null-character',
  unexpectedQuestionMarkInsteadOfTagName: 'unexpected-question-mark-instead-of-tag-name',
  invalidFirstCharacterOfTagName: 'invalid-first-character-of-tag-name',
  unexpectedEqualsSignBeforeAttributeName: 'unexpected-equals-sign-before-attribute-name',
  missingEndTagName: 'missing-end-tag-name',
  unexpectedCharacterInAttributeName: 'unexpected-character-in-attribute-name',
  unknownNamedCharacterReference: 'unknown-named-character-reference',
  missingSemicolonAfterCharacterReference: 'missing-semicolon-after-character-reference',
  unexpectedCharacterAfterDoctypeSystemIdentifier: 'unexpected-character-after-doctype-system-identifier',
  unexpectedCharacterInUnquotedAttributeValue: 'unexpected-character-in-unquoted-attribute-value',
  eofBeforeTagName: 'eof-before-tag-name',
  eofInTag: 'eof-in-tag',
  missingAttributeValue: 'missing-attribute-value',
  missingWhitespaceBetweenAttributes: 'missing-whitespace-between-attributes',
  missingWhitespaceAfterDoctypePublicKeyword: 'missing-whitespace-after-doctype-public-keyword',
  missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers: 'missing-whitespace-between-doctype-public-and-system-identifiers',
  missingWhitespaceAfterDoctypeSystemKeyword: 'missing-whitespace-after-doctype-system-keyword',
  missingQuoteBeforeDoctypePublicIdentifier: 'missing-quote-before-doctype-public-identifier',
  missingQuoteBeforeDoctypeSystemIdentifier: 'missing-quote-before-doctype-system-identifier',
  missingDoctypePublicIdentifier: 'missing-doctype-public-identifier',
  missingDoctypeSystemIdentifier: 'missing-doctype-system-identifier',
  abruptDoctypePublicIdentifier: 'abrupt-doctype-public-identifier',
  abruptDoctypeSystemIdentifier: 'abrupt-doctype-system-identifier',
  cdataInHtmlContent: 'cdata-in-html-content',
  incorrectlyOpenedComment: 'incorrectly-opened-comment',
  eofInScriptHtmlCommentLikeText: 'eof-in-script-html-comment-like-text',
  eofInDoctype: 'eof-in-doctype',
  nestedComment: 'nested-comment',
  abruptClosingOfEmptyComment: 'abrupt-closing-of-empty-comment',
  eofInComment: 'eof-in-comment',
  incorrectlyClosedComment: 'incorrectly-closed-comment',
  eofInCdata: 'eof-in-cdata',
  absenceOfDigitsInNumericCharacterReference: 'absence-of-digits-in-numeric-character-reference',
  nullCharacterReference: 'null-character-reference',
  surrogateCharacterReference: 'surrogate-character-reference',
  characterReferenceOutsideUnicodeRange: 'character-reference-outside-unicode-range',
  controlCharacterReference: 'control-character-reference',
  noncharacterCharacterReference: 'noncharacter-character-reference',
  missingWhitespaceBeforeDoctypeName: 'missing-whitespace-before-doctype-name',
  missingDoctypeName: 'missing-doctype-name',
  invalidCharacterSequenceAfterDoctypeName: 'invalid-character-sequence-after-doctype-name',
  duplicateAttribute: 'duplicate-attribute',
  nonConformingDoctype: 'non-conforming-doctype',
  missingDoctype: 'missing-doctype',
  misplacedDoctype: 'misplaced-doctype',
  endTagWithoutMatchingOpenElement: 'end-tag-without-matching-open-element',
  closingOfElementWithOpenChildElements: 'closing-of-element-with-open-child-elements',
  disallowedContentInNoscriptInHead: 'disallowed-content-in-noscript-in-head',
  openElementsLeftAfterEof: 'open-elements-left-after-eof',
  abandonedHeadElementChild: 'abandoned-head-element-child',
  misplacedStartTagForHeadElement: 'misplaced-start-tag-for-head-element',
  nestedNoscriptInHead: 'nested-noscript-in-head',
  eofInElementThatCanContainOnlyText: 'eof-in-element-that-can-contain-only-text'
};

/***/ }),

/***/ 533:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _defineProperty = __webpack_require__(9713);
var _EXITS_FOREIGN_CONTEN;
var Tokenizer = __webpack_require__(301);
var HTML = __webpack_require__(8869);

//Aliases
var $ = HTML.TAG_NAMES;
var NS = HTML.NAMESPACES;
var ATTRS = HTML.ATTRS;

//MIME types
var MIME_TYPES = {
  TEXT_HTML: 'text/html',
  APPLICATION_XML: 'application/xhtml+xml'
};

//Attributes
var DEFINITION_URL_ATTR = 'definitionurl';
var ADJUSTED_DEFINITION_URL_ATTR = 'definitionURL';
var SVG_ATTRS_ADJUSTMENT_MAP = {
  attributename: 'attributeName',
  attributetype: 'attributeType',
  basefrequency: 'baseFrequency',
  baseprofile: 'baseProfile',
  calcmode: 'calcMode',
  clippathunits: 'clipPathUnits',
  diffuseconstant: 'diffuseConstant',
  edgemode: 'edgeMode',
  filterunits: 'filterUnits',
  glyphref: 'glyphRef',
  gradienttransform: 'gradientTransform',
  gradientunits: 'gradientUnits',
  kernelmatrix: 'kernelMatrix',
  kernelunitlength: 'kernelUnitLength',
  keypoints: 'keyPoints',
  keysplines: 'keySplines',
  keytimes: 'keyTimes',
  lengthadjust: 'lengthAdjust',
  limitingconeangle: 'limitingConeAngle',
  markerheight: 'markerHeight',
  markerunits: 'markerUnits',
  markerwidth: 'markerWidth',
  maskcontentunits: 'maskContentUnits',
  maskunits: 'maskUnits',
  numoctaves: 'numOctaves',
  pathlength: 'pathLength',
  patterncontentunits: 'patternContentUnits',
  patterntransform: 'patternTransform',
  patternunits: 'patternUnits',
  pointsatx: 'pointsAtX',
  pointsaty: 'pointsAtY',
  pointsatz: 'pointsAtZ',
  preservealpha: 'preserveAlpha',
  preserveaspectratio: 'preserveAspectRatio',
  primitiveunits: 'primitiveUnits',
  refx: 'refX',
  refy: 'refY',
  repeatcount: 'repeatCount',
  repeatdur: 'repeatDur',
  requiredextensions: 'requiredExtensions',
  requiredfeatures: 'requiredFeatures',
  specularconstant: 'specularConstant',
  specularexponent: 'specularExponent',
  spreadmethod: 'spreadMethod',
  startoffset: 'startOffset',
  stddeviation: 'stdDeviation',
  stitchtiles: 'stitchTiles',
  surfacescale: 'surfaceScale',
  systemlanguage: 'systemLanguage',
  tablevalues: 'tableValues',
  targetx: 'targetX',
  targety: 'targetY',
  textlength: 'textLength',
  viewbox: 'viewBox',
  viewtarget: 'viewTarget',
  xchannelselector: 'xChannelSelector',
  ychannelselector: 'yChannelSelector',
  zoomandpan: 'zoomAndPan'
};
var XML_ATTRS_ADJUSTMENT_MAP = {
  'xlink:actuate': {
    prefix: 'xlink',
    name: 'actuate',
    namespace: NS.XLINK
  },
  'xlink:arcrole': {
    prefix: 'xlink',
    name: 'arcrole',
    namespace: NS.XLINK
  },
  'xlink:href': {
    prefix: 'xlink',
    name: 'href',
    namespace: NS.XLINK
  },
  'xlink:role': {
    prefix: 'xlink',
    name: 'role',
    namespace: NS.XLINK
  },
  'xlink:show': {
    prefix: 'xlink',
    name: 'show',
    namespace: NS.XLINK
  },
  'xlink:title': {
    prefix: 'xlink',
    name: 'title',
    namespace: NS.XLINK
  },
  'xlink:type': {
    prefix: 'xlink',
    name: 'type',
    namespace: NS.XLINK
  },
  'xml:base': {
    prefix: 'xml',
    name: 'base',
    namespace: NS.XML
  },
  'xml:lang': {
    prefix: 'xml',
    name: 'lang',
    namespace: NS.XML
  },
  'xml:space': {
    prefix: 'xml',
    name: 'space',
    namespace: NS.XML
  },
  xmlns: {
    prefix: '',
    name: 'xmlns',
    namespace: NS.XMLNS
  },
  'xmlns:xlink': {
    prefix: 'xmlns',
    name: 'xlink',
    namespace: NS.XMLNS
  }
};

//SVG tag names adjustment map
var SVG_TAG_NAMES_ADJUSTMENT_MAP = exports.SVG_TAG_NAMES_ADJUSTMENT_MAP = {
  altglyph: 'altGlyph',
  altglyphdef: 'altGlyphDef',
  altglyphitem: 'altGlyphItem',
  animatecolor: 'animateColor',
  animatemotion: 'animateMotion',
  animatetransform: 'animateTransform',
  clippath: 'clipPath',
  feblend: 'feBlend',
  fecolormatrix: 'feColorMatrix',
  fecomponenttransfer: 'feComponentTransfer',
  fecomposite: 'feComposite',
  feconvolvematrix: 'feConvolveMatrix',
  fediffuselighting: 'feDiffuseLighting',
  fedisplacementmap: 'feDisplacementMap',
  fedistantlight: 'feDistantLight',
  feflood: 'feFlood',
  fefunca: 'feFuncA',
  fefuncb: 'feFuncB',
  fefuncg: 'feFuncG',
  fefuncr: 'feFuncR',
  fegaussianblur: 'feGaussianBlur',
  feimage: 'feImage',
  femerge: 'feMerge',
  femergenode: 'feMergeNode',
  femorphology: 'feMorphology',
  feoffset: 'feOffset',
  fepointlight: 'fePointLight',
  fespecularlighting: 'feSpecularLighting',
  fespotlight: 'feSpotLight',
  fetile: 'feTile',
  feturbulence: 'feTurbulence',
  foreignobject: 'foreignObject',
  glyphref: 'glyphRef',
  lineargradient: 'linearGradient',
  radialgradient: 'radialGradient',
  textpath: 'textPath'
};

//Tags that causes exit from foreign content
var EXITS_FOREIGN_CONTENT = (_EXITS_FOREIGN_CONTEN = {}, _defineProperty(_EXITS_FOREIGN_CONTEN, $.B, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.BIG, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.BLOCKQUOTE, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.BODY, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.BR, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.CENTER, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.CODE, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.DD, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.DIV, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.DL, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.DT, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.EM, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.EMBED, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.H1, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.H2, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.H3, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.H4, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.H5, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.H6, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.HEAD, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.HR, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.I, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.IMG, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.LI, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.LISTING, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.MENU, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.META, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.NOBR, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.OL, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.P, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.PRE, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.RUBY, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.S, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.SMALL, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.SPAN, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.STRONG, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.STRIKE, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.SUB, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.SUP, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.TABLE, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.TT, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.U, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.UL, true), _defineProperty(_EXITS_FOREIGN_CONTEN, $.VAR, true), _EXITS_FOREIGN_CONTEN);

//Check exit from foreign content
exports.causesExit = function (startTagToken) {
  var tn = startTagToken.tagName;
  var isFontWithAttrs = tn === $.FONT && (Tokenizer.getTokenAttr(startTagToken, ATTRS.COLOR) !== null || Tokenizer.getTokenAttr(startTagToken, ATTRS.SIZE) !== null || Tokenizer.getTokenAttr(startTagToken, ATTRS.FACE) !== null);
  return isFontWithAttrs ? true : EXITS_FOREIGN_CONTENT[tn];
};

//Token adjustments
exports.adjustTokenMathMLAttrs = function (token) {
  for (var i = 0; i < token.attrs.length; i++) {
    if (token.attrs[i].name === DEFINITION_URL_ATTR) {
      token.attrs[i].name = ADJUSTED_DEFINITION_URL_ATTR;
      break;
    }
  }
};
exports.adjustTokenSVGAttrs = function (token) {
  for (var i = 0; i < token.attrs.length; i++) {
    var adjustedAttrName = SVG_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];
    if (adjustedAttrName) {
      token.attrs[i].name = adjustedAttrName;
    }
  }
};
exports.adjustTokenXMLAttrs = function (token) {
  for (var i = 0; i < token.attrs.length; i++) {
    var adjustedAttrEntry = XML_ATTRS_ADJUSTMENT_MAP[token.attrs[i].name];
    if (adjustedAttrEntry) {
      token.attrs[i].prefix = adjustedAttrEntry.prefix;
      token.attrs[i].name = adjustedAttrEntry.name;
      token.attrs[i].namespace = adjustedAttrEntry.namespace;
    }
  }
};
exports.adjustTokenSVGTagName = function (token) {
  var adjustedTagName = SVG_TAG_NAMES_ADJUSTMENT_MAP[token.tagName];
  if (adjustedTagName) {
    token.tagName = adjustedTagName;
  }
};

//Integration points
function isMathMLTextIntegrationPoint(tn, ns) {
  return ns === NS.MATHML && (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS || tn === $.MTEXT);
}
function isHtmlIntegrationPoint(tn, ns, attrs) {
  if (ns === NS.MATHML && tn === $.ANNOTATION_XML) {
    for (var i = 0; i < attrs.length; i++) {
      if (attrs[i].name === ATTRS.ENCODING) {
        var value = attrs[i].value.toLowerCase();
        return value === MIME_TYPES.TEXT_HTML || value === MIME_TYPES.APPLICATION_XML;
      }
    }
  }
  return ns === NS.SVG && (tn === $.FOREIGN_OBJECT || tn === $.DESC || tn === $.TITLE);
}
exports.isIntegrationPoint = function (tn, ns, attrs, foreignNS) {
  if ((!foreignNS || foreignNS === NS.HTML) && isHtmlIntegrationPoint(tn, ns, attrs)) {
    return true;
  }
  if ((!foreignNS || foreignNS === NS.MATHML) && isMathMLTextIntegrationPoint(tn, ns)) {
    return true;
  }
  return false;
};

/***/ }),

/***/ 8869:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _defineProperty = __webpack_require__(9713);
var _NS$HTML, _NS$MATHML, _NS$SVG, _exports$SPECIAL_ELEM;
var NS = exports.NAMESPACES = {
  HTML: 'http://www.w3.org/1999/xhtml',
  MATHML: 'http://www.w3.org/1998/Math/MathML',
  SVG: 'http://www.w3.org/2000/svg',
  XLINK: 'http://www.w3.org/1999/xlink',
  XML: 'http://www.w3.org/XML/1998/namespace',
  XMLNS: 'http://www.w3.org/2000/xmlns/'
};
exports.ATTRS = {
  TYPE: 'type',
  ACTION: 'action',
  ENCODING: 'encoding',
  PROMPT: 'prompt',
  NAME: 'name',
  COLOR: 'color',
  FACE: 'face',
  SIZE: 'size'
};
exports.DOCUMENT_MODE = {
  NO_QUIRKS: 'no-quirks',
  QUIRKS: 'quirks',
  LIMITED_QUIRKS: 'limited-quirks'
};
var $ = exports.TAG_NAMES = {
  A: 'a',
  ADDRESS: 'address',
  ANNOTATION_XML: 'annotation-xml',
  APPLET: 'applet',
  AREA: 'area',
  ARTICLE: 'article',
  ASIDE: 'aside',
  B: 'b',
  BASE: 'base',
  BASEFONT: 'basefont',
  BGSOUND: 'bgsound',
  BIG: 'big',
  BLOCKQUOTE: 'blockquote',
  BODY: 'body',
  BR: 'br',
  BUTTON: 'button',
  CAPTION: 'caption',
  CENTER: 'center',
  CODE: 'code',
  COL: 'col',
  COLGROUP: 'colgroup',
  DD: 'dd',
  DESC: 'desc',
  DETAILS: 'details',
  DIALOG: 'dialog',
  DIR: 'dir',
  DIV: 'div',
  DL: 'dl',
  DT: 'dt',
  EM: 'em',
  EMBED: 'embed',
  FIELDSET: 'fieldset',
  FIGCAPTION: 'figcaption',
  FIGURE: 'figure',
  FONT: 'font',
  FOOTER: 'footer',
  FOREIGN_OBJECT: 'foreignObject',
  FORM: 'form',
  FRAME: 'frame',
  FRAMESET: 'frameset',
  H1: 'h1',
  H2: 'h2',
  H3: 'h3',
  H4: 'h4',
  H5: 'h5',
  H6: 'h6',
  HEAD: 'head',
  HEADER: 'header',
  HGROUP: 'hgroup',
  HR: 'hr',
  HTML: 'html',
  I: 'i',
  IMG: 'img',
  IMAGE: 'image',
  INPUT: 'input',
  IFRAME: 'iframe',
  KEYGEN: 'keygen',
  LABEL: 'label',
  LI: 'li',
  LINK: 'link',
  LISTING: 'listing',
  MAIN: 'main',
  MALIGNMARK: 'malignmark',
  MARQUEE: 'marquee',
  MATH: 'math',
  MENU: 'menu',
  META: 'meta',
  MGLYPH: 'mglyph',
  MI: 'mi',
  MO: 'mo',
  MN: 'mn',
  MS: 'ms',
  MTEXT: 'mtext',
  NAV: 'nav',
  NOBR: 'nobr',
  NOFRAMES: 'noframes',
  NOEMBED: 'noembed',
  NOSCRIPT: 'noscript',
  OBJECT: 'object',
  OL: 'ol',
  OPTGROUP: 'optgroup',
  OPTION: 'option',
  P: 'p',
  PARAM: 'param',
  PLAINTEXT: 'plaintext',
  PRE: 'pre',
  RB: 'rb',
  RP: 'rp',
  RT: 'rt',
  RTC: 'rtc',
  RUBY: 'ruby',
  S: 's',
  SCRIPT: 'script',
  SECTION: 'section',
  SELECT: 'select',
  SOURCE: 'source',
  SMALL: 'small',
  SPAN: 'span',
  STRIKE: 'strike',
  STRONG: 'strong',
  STYLE: 'style',
  SUB: 'sub',
  SUMMARY: 'summary',
  SUP: 'sup',
  TABLE: 'table',
  TBODY: 'tbody',
  TEMPLATE: 'template',
  TEXTAREA: 'textarea',
  TFOOT: 'tfoot',
  TD: 'td',
  TH: 'th',
  THEAD: 'thead',
  TITLE: 'title',
  TR: 'tr',
  TRACK: 'track',
  TT: 'tt',
  U: 'u',
  UL: 'ul',
  SVG: 'svg',
  VAR: 'var',
  WBR: 'wbr',
  XMP: 'xmp'
};
exports.SPECIAL_ELEMENTS = (_exports$SPECIAL_ELEM = {}, _defineProperty(_exports$SPECIAL_ELEM, NS.HTML, (_NS$HTML = {}, _defineProperty(_NS$HTML, $.ADDRESS, true), _defineProperty(_NS$HTML, $.APPLET, true), _defineProperty(_NS$HTML, $.AREA, true), _defineProperty(_NS$HTML, $.ARTICLE, true), _defineProperty(_NS$HTML, $.ASIDE, true), _defineProperty(_NS$HTML, $.BASE, true), _defineProperty(_NS$HTML, $.BASEFONT, true), _defineProperty(_NS$HTML, $.BGSOUND, true), _defineProperty(_NS$HTML, $.BLOCKQUOTE, true), _defineProperty(_NS$HTML, $.BODY, true), _defineProperty(_NS$HTML, $.BR, true), _defineProperty(_NS$HTML, $.BUTTON, true), _defineProperty(_NS$HTML, $.CAPTION, true), _defineProperty(_NS$HTML, $.CENTER, true), _defineProperty(_NS$HTML, $.COL, true), _defineProperty(_NS$HTML, $.COLGROUP, true), _defineProperty(_NS$HTML, $.DD, true), _defineProperty(_NS$HTML, $.DETAILS, true), _defineProperty(_NS$HTML, $.DIR, true), _defineProperty(_NS$HTML, $.DIV, true), _defineProperty(_NS$HTML, $.DL, true), _defineProperty(_NS$HTML, $.DT, true), _defineProperty(_NS$HTML, $.EMBED, true), _defineProperty(_NS$HTML, $.FIELDSET, true), _defineProperty(_NS$HTML, $.FIGCAPTION, true), _defineProperty(_NS$HTML, $.FIGURE, true), _defineProperty(_NS$HTML, $.FOOTER, true), _defineProperty(_NS$HTML, $.FORM, true), _defineProperty(_NS$HTML, $.FRAME, true), _defineProperty(_NS$HTML, $.FRAMESET, true), _defineProperty(_NS$HTML, $.H1, true), _defineProperty(_NS$HTML, $.H2, true), _defineProperty(_NS$HTML, $.H3, true), _defineProperty(_NS$HTML, $.H4, true), _defineProperty(_NS$HTML, $.H5, true), _defineProperty(_NS$HTML, $.H6, true), _defineProperty(_NS$HTML, $.HEAD, true), _defineProperty(_NS$HTML, $.HEADER, true), _defineProperty(_NS$HTML, $.HGROUP, true), _defineProperty(_NS$HTML, $.HR, true), _defineProperty(_NS$HTML, $.HTML, true), _defineProperty(_NS$HTML, $.IFRAME, true), _defineProperty(_NS$HTML, $.IMG, true), _defineProperty(_NS$HTML, $.INPUT, true), _defineProperty(_NS$HTML, $.LI, true), _defineProperty(_NS$HTML, $.LINK, true), _defineProperty(_NS$HTML, $.LISTING, true), _defineProperty(_NS$HTML, $.MAIN, true), _defineProperty(_NS$HTML, $.MARQUEE, true), _defineProperty(_NS$HTML, $.MENU, true), _defineProperty(_NS$HTML, $.META, true), _defineProperty(_NS$HTML, $.NAV, true), _defineProperty(_NS$HTML, $.NOEMBED, true), _defineProperty(_NS$HTML, $.NOFRAMES, true), _defineProperty(_NS$HTML, $.NOSCRIPT, true), _defineProperty(_NS$HTML, $.OBJECT, true), _defineProperty(_NS$HTML, $.OL, true), _defineProperty(_NS$HTML, $.P, true), _defineProperty(_NS$HTML, $.PARAM, true), _defineProperty(_NS$HTML, $.PLAINTEXT, true), _defineProperty(_NS$HTML, $.PRE, true), _defineProperty(_NS$HTML, $.SCRIPT, true), _defineProperty(_NS$HTML, $.SECTION, true), _defineProperty(_NS$HTML, $.SELECT, true), _defineProperty(_NS$HTML, $.SOURCE, true), _defineProperty(_NS$HTML, $.STYLE, true), _defineProperty(_NS$HTML, $.SUMMARY, true), _defineProperty(_NS$HTML, $.TABLE, true), _defineProperty(_NS$HTML, $.TBODY, true), _defineProperty(_NS$HTML, $.TD, true), _defineProperty(_NS$HTML, $.TEMPLATE, true), _defineProperty(_NS$HTML, $.TEXTAREA, true), _defineProperty(_NS$HTML, $.TFOOT, true), _defineProperty(_NS$HTML, $.TH, true), _defineProperty(_NS$HTML, $.THEAD, true), _defineProperty(_NS$HTML, $.TITLE, true), _defineProperty(_NS$HTML, $.TR, true), _defineProperty(_NS$HTML, $.TRACK, true), _defineProperty(_NS$HTML, $.UL, true), _defineProperty(_NS$HTML, $.WBR, true), _defineProperty(_NS$HTML, $.XMP, true), _NS$HTML)), _defineProperty(_exports$SPECIAL_ELEM, NS.MATHML, (_NS$MATHML = {}, _defineProperty(_NS$MATHML, $.MI, true), _defineProperty(_NS$MATHML, $.MO, true), _defineProperty(_NS$MATHML, $.MN, true), _defineProperty(_NS$MATHML, $.MS, true), _defineProperty(_NS$MATHML, $.MTEXT, true), _defineProperty(_NS$MATHML, $.ANNOTATION_XML, true), _NS$MATHML)), _defineProperty(_exports$SPECIAL_ELEM, NS.SVG, (_NS$SVG = {}, _defineProperty(_NS$SVG, $.TITLE, true), _defineProperty(_NS$SVG, $.FOREIGN_OBJECT, true), _defineProperty(_NS$SVG, $.DESC, true), _NS$SVG)), _exports$SPECIAL_ELEM);

/***/ }),

/***/ 9879:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


var UNDEFINED_CODE_POINTS = [0xfffe, 0xffff, 0x1fffe, 0x1ffff, 0x2fffe, 0x2ffff, 0x3fffe, 0x3ffff, 0x4fffe, 0x4ffff, 0x5fffe, 0x5ffff, 0x6fffe, 0x6ffff, 0x7fffe, 0x7ffff, 0x8fffe, 0x8ffff, 0x9fffe, 0x9ffff, 0xafffe, 0xaffff, 0xbfffe, 0xbffff, 0xcfffe, 0xcffff, 0xdfffe, 0xdffff, 0xefffe, 0xeffff, 0xffffe, 0xfffff, 0x10fffe, 0x10ffff];
exports.REPLACEMENT_CHARACTER = "\uFFFD";
exports.CODE_POINTS = {
  EOF: -1,
  NULL: 0x00,
  TABULATION: 0x09,
  CARRIAGE_RETURN: 0x0d,
  LINE_FEED: 0x0a,
  FORM_FEED: 0x0c,
  SPACE: 0x20,
  EXCLAMATION_MARK: 0x21,
  QUOTATION_MARK: 0x22,
  NUMBER_SIGN: 0x23,
  AMPERSAND: 0x26,
  APOSTROPHE: 0x27,
  HYPHEN_MINUS: 0x2d,
  SOLIDUS: 0x2f,
  DIGIT_0: 0x30,
  DIGIT_9: 0x39,
  SEMICOLON: 0x3b,
  LESS_THAN_SIGN: 0x3c,
  EQUALS_SIGN: 0x3d,
  GREATER_THAN_SIGN: 0x3e,
  QUESTION_MARK: 0x3f,
  LATIN_CAPITAL_A: 0x41,
  LATIN_CAPITAL_F: 0x46,
  LATIN_CAPITAL_X: 0x58,
  LATIN_CAPITAL_Z: 0x5a,
  RIGHT_SQUARE_BRACKET: 0x5d,
  GRAVE_ACCENT: 0x60,
  LATIN_SMALL_A: 0x61,
  LATIN_SMALL_F: 0x66,
  LATIN_SMALL_X: 0x78,
  LATIN_SMALL_Z: 0x7a,
  REPLACEMENT_CHARACTER: 0xfffd
};
exports.CODE_POINT_SEQUENCES = {
  DASH_DASH_STRING: [0x2d, 0x2d],
  //--
  DOCTYPE_STRING: [0x44, 0x4f, 0x43, 0x54, 0x59, 0x50, 0x45],
  //DOCTYPE
  CDATA_START_STRING: [0x5b, 0x43, 0x44, 0x41, 0x54, 0x41, 0x5b],
  //[CDATA[
  SCRIPT_STRING: [0x73, 0x63, 0x72, 0x69, 0x70, 0x74],
  //script
  PUBLIC_STRING: [0x50, 0x55, 0x42, 0x4c, 0x49, 0x43],
  //PUBLIC
  SYSTEM_STRING: [0x53, 0x59, 0x53, 0x54, 0x45, 0x4d] //SYSTEM
};

//Surrogates
exports.isSurrogate = function (cp) {
  return cp >= 0xd800 && cp <= 0xdfff;
};
exports.isSurrogatePair = function (cp) {
  return cp >= 0xdc00 && cp <= 0xdfff;
};
exports.getSurrogatePairCodePoint = function (cp1, cp2) {
  return (cp1 - 0xd800) * 0x400 + 0x2400 + cp2;
};

//NOTE: excluding NULL and ASCII whitespace
exports.isControlCodePoint = function (cp) {
  return cp !== 0x20 && cp !== 0x0a && cp !== 0x0d && cp !== 0x09 && cp !== 0x0c && cp >= 0x01 && cp <= 0x1f || cp >= 0x7f && cp <= 0x9f;
};
exports.isUndefinedCodePoint = function (cp) {
  return cp >= 0xfdd0 && cp <= 0xfdef || UNDEFINED_CODE_POINTS.indexOf(cp) > -1;
};

/***/ }),

/***/ 9488:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var _inherits = __webpack_require__(2205);
var _possibleConstructorReturn = __webpack_require__(8585);
var _getPrototypeOf = __webpack_require__(9754);
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Mixin = __webpack_require__(4086);
var ErrorReportingMixinBase = /*#__PURE__*/function (_Mixin) {
  _inherits(ErrorReportingMixinBase, _Mixin);
  var _super = _createSuper(ErrorReportingMixinBase);
  function ErrorReportingMixinBase(host, opts) {
    var _this;
    _classCallCheck(this, ErrorReportingMixinBase);
    _this = _super.call(this, host);
    _this.posTracker = null;
    _this.onParseError = opts.onParseError;
    return _this;
  }
  _createClass(ErrorReportingMixinBase, [{
    key: "_setErrorLocation",
    value: function _setErrorLocation(err) {
      err.startLine = err.endLine = this.posTracker.line;
      err.startCol = err.endCol = this.posTracker.col;
      err.startOffset = err.endOffset = this.posTracker.offset;
    }
  }, {
    key: "_reportError",
    value: function _reportError(code) {
      var err = {
        code: code,
        startLine: -1,
        startCol: -1,
        startOffset: -1,
        endLine: -1,
        endCol: -1,
        endOffset: -1
      };
      this._setErrorLocation(err);
      this.onParseError(err);
    }
  }, {
    key: "_getOverriddenMethods",
    value: function _getOverriddenMethods(mxn) {
      return {
        _err: function _err(code) {
          mxn._reportError(code);
        }
      };
    }
  }]);
  return ErrorReportingMixinBase;
}(Mixin);
module.exports = ErrorReportingMixinBase;

/***/ }),

/***/ 2250:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var _inherits = __webpack_require__(2205);
var _possibleConstructorReturn = __webpack_require__(8585);
var _getPrototypeOf = __webpack_require__(9754);
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ErrorReportingMixinBase = __webpack_require__(9488);
var ErrorReportingTokenizerMixin = __webpack_require__(7341);
var LocationInfoTokenizerMixin = __webpack_require__(5348);
var Mixin = __webpack_require__(4086);
var ErrorReportingParserMixin = /*#__PURE__*/function (_ErrorReportingMixinB) {
  _inherits(ErrorReportingParserMixin, _ErrorReportingMixinB);
  var _super = _createSuper(ErrorReportingParserMixin);
  function ErrorReportingParserMixin(parser, opts) {
    var _this;
    _classCallCheck(this, ErrorReportingParserMixin);
    _this = _super.call(this, parser, opts);
    _this.opts = opts;
    _this.ctLoc = null;
    _this.locBeforeToken = false;
    return _this;
  }
  _createClass(ErrorReportingParserMixin, [{
    key: "_setErrorLocation",
    value: function _setErrorLocation(err) {
      if (this.ctLoc) {
        err.startLine = this.ctLoc.startLine;
        err.startCol = this.ctLoc.startCol;
        err.startOffset = this.ctLoc.startOffset;
        err.endLine = this.locBeforeToken ? this.ctLoc.startLine : this.ctLoc.endLine;
        err.endCol = this.locBeforeToken ? this.ctLoc.startCol : this.ctLoc.endCol;
        err.endOffset = this.locBeforeToken ? this.ctLoc.startOffset : this.ctLoc.endOffset;
      }
    }
  }, {
    key: "_getOverriddenMethods",
    value: function _getOverriddenMethods(mxn, orig) {
      return {
        _bootstrap: function _bootstrap(document, fragmentContext) {
          orig._bootstrap.call(this, document, fragmentContext);
          Mixin.install(this.tokenizer, ErrorReportingTokenizerMixin, mxn.opts);
          Mixin.install(this.tokenizer, LocationInfoTokenizerMixin);
        },
        _processInputToken: function _processInputToken(token) {
          mxn.ctLoc = token.location;
          orig._processInputToken.call(this, token);
        },
        _err: function _err(code, options) {
          mxn.locBeforeToken = options && options.beforeToken;
          mxn._reportError(code);
        }
      };
    }
  }]);
  return ErrorReportingParserMixin;
}(ErrorReportingMixinBase);
module.exports = ErrorReportingParserMixin;

/***/ }),

/***/ 3130:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var _get = __webpack_require__(6525);
var _inherits = __webpack_require__(2205);
var _possibleConstructorReturn = __webpack_require__(8585);
var _getPrototypeOf = __webpack_require__(9754);
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ErrorReportingMixinBase = __webpack_require__(9488);
var PositionTrackingPreprocessorMixin = __webpack_require__(2619);
var Mixin = __webpack_require__(4086);
var ErrorReportingPreprocessorMixin = /*#__PURE__*/function (_ErrorReportingMixinB) {
  _inherits(ErrorReportingPreprocessorMixin, _ErrorReportingMixinB);
  var _super = _createSuper(ErrorReportingPreprocessorMixin);
  function ErrorReportingPreprocessorMixin(preprocessor, opts) {
    var _this;
    _classCallCheck(this, ErrorReportingPreprocessorMixin);
    _this = _super.call(this, preprocessor, opts);
    _this.posTracker = Mixin.install(preprocessor, PositionTrackingPreprocessorMixin);
    _this.lastErrOffset = -1;
    return _this;
  }
  _createClass(ErrorReportingPreprocessorMixin, [{
    key: "_reportError",
    value: function _reportError(code) {
      //NOTE: avoid reporting error twice on advance/retreat
      if (this.lastErrOffset !== this.posTracker.offset) {
        this.lastErrOffset = this.posTracker.offset;
        _get(_getPrototypeOf(ErrorReportingPreprocessorMixin.prototype), "_reportError", this).call(this, code);
      }
    }
  }]);
  return ErrorReportingPreprocessorMixin;
}(ErrorReportingMixinBase);
module.exports = ErrorReportingPreprocessorMixin;

/***/ }),

/***/ 7341:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var _createClass = __webpack_require__(3913);
var _classCallCheck = __webpack_require__(4575);
var _inherits = __webpack_require__(2205);
var _possibleConstructorReturn = __webpack_require__(8585);
var _getPrototypeOf = __webpack_require__(9754);
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ErrorReportingMixinBase = __webpack_require__(9488);
var ErrorReportingPreprocessorMixin = __webpack_require__(3130);
var Mixin = __webpack_require__(4086);
var ErrorReportingTokenizerMixin = /*#__PURE__*/function (_ErrorReportingMixinB) {
  _inherits(ErrorReportingTokenizerMixin, _ErrorReportingMixinB);
  var _super = _createSuper(ErrorReportingTokenizerMixin);
  function ErrorReportingTokenizerMixin(tokenizer, opts) {
    var _this;
    _classCallCheck(this, ErrorReportingTokenizerMixin);
    _this = _super.call(this, tokenizer, opts);
    var preprocessorMixin = Mixin.install(tokenizer.preprocessor, ErrorReportingPreprocessorMixin, opts);
    _this.posTracker = preprocessorMixin.posTracker;
    return _this;
  }
  return _createClass(ErrorReportingTokenizerMixin);
}(ErrorReportingMixinBase);
module.exports = ErrorReportingTokenizerMixin;

/***/ }),

/***/ 494:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var _inherits = __webpack_require__(2205);
var _possibleConstructorReturn = __webpack_require__(8585);
var _getPrototypeOf = __webpack_require__(9754);
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Mixin = __webpack_require__(4086);
var LocationInfoOpenElementStackMixin = /*#__PURE__*/function (_Mixin) {
  _inherits(LocationInfoOpenElementStackMixin, _Mixin);
  var _super = _createSuper(LocationInfoOpenElementStackMixin);
  function LocationInfoOpenElementStackMixin(stack, opts) {
    var _this;
    _classCallCheck(this, LocationInfoOpenElementStackMixin);
    _this = _super.call(this, stack);
    _this.onItemPop = opts.onItemPop;
    return _this;
  }
  _createClass(LocationInfoOpenElementStackMixin, [{
    key: "_getOverriddenMethods",
    value: function _getOverriddenMethods(mxn, orig) {
      return {
        pop: function pop() {
          mxn.onItemPop(this.current);
          orig.pop.call(this);
        },
        popAllUpToHtmlElement: function popAllUpToHtmlElement() {
          for (var i = this.stackTop; i > 0; i--) {
            mxn.onItemPop(this.items[i]);
          }
          orig.popAllUpToHtmlElement.call(this);
        },
        remove: function remove(element) {
          mxn.onItemPop(this.current);
          orig.remove.call(this, element);
        }
      };
    }
  }]);
  return LocationInfoOpenElementStackMixin;
}(Mixin);
module.exports = LocationInfoOpenElementStackMixin;

/***/ }),

/***/ 675:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var _inherits = __webpack_require__(2205);
var _possibleConstructorReturn = __webpack_require__(8585);
var _getPrototypeOf = __webpack_require__(9754);
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Mixin = __webpack_require__(4086);
var Tokenizer = __webpack_require__(301);
var LocationInfoTokenizerMixin = __webpack_require__(5348);
var LocationInfoOpenElementStackMixin = __webpack_require__(494);
var HTML = __webpack_require__(8869);

//Aliases
var $ = HTML.TAG_NAMES;
var LocationInfoParserMixin = /*#__PURE__*/function (_Mixin) {
  _inherits(LocationInfoParserMixin, _Mixin);
  var _super = _createSuper(LocationInfoParserMixin);
  function LocationInfoParserMixin(parser) {
    var _this;
    _classCallCheck(this, LocationInfoParserMixin);
    _this = _super.call(this, parser);
    _this.parser = parser;
    _this.treeAdapter = _this.parser.treeAdapter;
    _this.posTracker = null;
    _this.lastStartTagToken = null;
    _this.lastFosterParentingLocation = null;
    _this.currentToken = null;
    return _this;
  }
  _createClass(LocationInfoParserMixin, [{
    key: "_setStartLocation",
    value: function _setStartLocation(element) {
      var loc = null;
      if (this.lastStartTagToken) {
        loc = Object.assign({}, this.lastStartTagToken.location);
        loc.startTag = this.lastStartTagToken.location;
      }
      this.treeAdapter.setNodeSourceCodeLocation(element, loc);
    }
  }, {
    key: "_setEndLocation",
    value: function _setEndLocation(element, closingToken) {
      var loc = this.treeAdapter.getNodeSourceCodeLocation(element);
      if (loc) {
        if (closingToken.location) {
          var ctLoc = closingToken.location;
          var tn = this.treeAdapter.getTagName(element);

          // NOTE: For cases like <p> <p> </p> - First 'p' closes without a closing
          // tag and for cases like <td> <p> </td> - 'p' closes without a closing tag.
          var isClosingEndTag = closingToken.type === Tokenizer.END_TAG_TOKEN && tn === closingToken.tagName;
          var endLoc = {};
          if (isClosingEndTag) {
            endLoc.endTag = Object.assign({}, ctLoc);
            endLoc.endLine = ctLoc.endLine;
            endLoc.endCol = ctLoc.endCol;
            endLoc.endOffset = ctLoc.endOffset;
          } else {
            endLoc.endLine = ctLoc.startLine;
            endLoc.endCol = ctLoc.startCol;
            endLoc.endOffset = ctLoc.startOffset;
          }
          this.treeAdapter.updateNodeSourceCodeLocation(element, endLoc);
        }
      }
    }
  }, {
    key: "_getOverriddenMethods",
    value: function _getOverriddenMethods(mxn, orig) {
      return {
        _bootstrap: function _bootstrap(document, fragmentContext) {
          orig._bootstrap.call(this, document, fragmentContext);
          mxn.lastStartTagToken = null;
          mxn.lastFosterParentingLocation = null;
          mxn.currentToken = null;
          var tokenizerMixin = Mixin.install(this.tokenizer, LocationInfoTokenizerMixin);
          mxn.posTracker = tokenizerMixin.posTracker;
          Mixin.install(this.openElements, LocationInfoOpenElementStackMixin, {
            onItemPop: function onItemPop(element) {
              mxn._setEndLocation(element, mxn.currentToken);
            }
          });
        },
        _runParsingLoop: function _runParsingLoop(scriptHandler) {
          orig._runParsingLoop.call(this, scriptHandler);

          // NOTE: generate location info for elements
          // that remains on open element stack
          for (var i = this.openElements.stackTop; i >= 0; i--) {
            mxn._setEndLocation(this.openElements.items[i], mxn.currentToken);
          }
        },
        //Token processing
        _processTokenInForeignContent: function _processTokenInForeignContent(token) {
          mxn.currentToken = token;
          orig._processTokenInForeignContent.call(this, token);
        },
        _processToken: function _processToken(token) {
          mxn.currentToken = token;
          orig._processToken.call(this, token);

          //NOTE: <body> and <html> are never popped from the stack, so we need to updated
          //their end location explicitly.
          var requireExplicitUpdate = token.type === Tokenizer.END_TAG_TOKEN && (token.tagName === $.HTML || token.tagName === $.BODY && this.openElements.hasInScope($.BODY));
          if (requireExplicitUpdate) {
            for (var i = this.openElements.stackTop; i >= 0; i--) {
              var element = this.openElements.items[i];
              if (this.treeAdapter.getTagName(element) === token.tagName) {
                mxn._setEndLocation(element, token);
                break;
              }
            }
          }
        },
        //Doctype
        _setDocumentType: function _setDocumentType(token) {
          orig._setDocumentType.call(this, token);
          var documentChildren = this.treeAdapter.getChildNodes(this.document);
          var cnLength = documentChildren.length;
          for (var i = 0; i < cnLength; i++) {
            var node = documentChildren[i];
            if (this.treeAdapter.isDocumentTypeNode(node)) {
              this.treeAdapter.setNodeSourceCodeLocation(node, token.location);
              break;
            }
          }
        },
        //Elements
        _attachElementToTree: function _attachElementToTree(element) {
          //NOTE: _attachElementToTree is called from _appendElement, _insertElement and _insertTemplate methods.
          //So we will use token location stored in this methods for the element.
          mxn._setStartLocation(element);
          mxn.lastStartTagToken = null;
          orig._attachElementToTree.call(this, element);
        },
        _appendElement: function _appendElement(token, namespaceURI) {
          mxn.lastStartTagToken = token;
          orig._appendElement.call(this, token, namespaceURI);
        },
        _insertElement: function _insertElement(token, namespaceURI) {
          mxn.lastStartTagToken = token;
          orig._insertElement.call(this, token, namespaceURI);
        },
        _insertTemplate: function _insertTemplate(token) {
          mxn.lastStartTagToken = token;
          orig._insertTemplate.call(this, token);
          var tmplContent = this.treeAdapter.getTemplateContent(this.openElements.current);
          this.treeAdapter.setNodeSourceCodeLocation(tmplContent, null);
        },
        _insertFakeRootElement: function _insertFakeRootElement() {
          orig._insertFakeRootElement.call(this);
          this.treeAdapter.setNodeSourceCodeLocation(this.openElements.current, null);
        },
        //Comments
        _appendCommentNode: function _appendCommentNode(token, parent) {
          orig._appendCommentNode.call(this, token, parent);
          var children = this.treeAdapter.getChildNodes(parent);
          var commentNode = children[children.length - 1];
          this.treeAdapter.setNodeSourceCodeLocation(commentNode, token.location);
        },
        //Text
        _findFosterParentingLocation: function _findFosterParentingLocation() {
          //NOTE: store last foster parenting location, so we will be able to find inserted text
          //in case of foster parenting
          mxn.lastFosterParentingLocation = orig._findFosterParentingLocation.call(this);
          return mxn.lastFosterParentingLocation;
        },
        _insertCharacters: function _insertCharacters(token) {
          orig._insertCharacters.call(this, token);
          var hasFosterParent = this._shouldFosterParentOnInsertion();
          var parent = hasFosterParent && mxn.lastFosterParentingLocation.parent || this.openElements.currentTmplContent || this.openElements.current;
          var siblings = this.treeAdapter.getChildNodes(parent);
          var textNodeIdx = hasFosterParent && mxn.lastFosterParentingLocation.beforeElement ? siblings.indexOf(mxn.lastFosterParentingLocation.beforeElement) - 1 : siblings.length - 1;
          var textNode = siblings[textNodeIdx];

          //NOTE: if we have location assigned by another token, then just update end position
          var tnLoc = this.treeAdapter.getNodeSourceCodeLocation(textNode);
          if (tnLoc) {
            var _token$location = token.location,
              endLine = _token$location.endLine,
              endCol = _token$location.endCol,
              endOffset = _token$location.endOffset;
            this.treeAdapter.updateNodeSourceCodeLocation(textNode, {
              endLine: endLine,
              endCol: endCol,
              endOffset: endOffset
            });
          } else {
            this.treeAdapter.setNodeSourceCodeLocation(textNode, token.location);
          }
        }
      };
    }
  }]);
  return LocationInfoParserMixin;
}(Mixin);
module.exports = LocationInfoParserMixin;

/***/ }),

/***/ 5348:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var _inherits = __webpack_require__(2205);
var _possibleConstructorReturn = __webpack_require__(8585);
var _getPrototypeOf = __webpack_require__(9754);
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Mixin = __webpack_require__(4086);
var Tokenizer = __webpack_require__(301);
var PositionTrackingPreprocessorMixin = __webpack_require__(2619);
var LocationInfoTokenizerMixin = /*#__PURE__*/function (_Mixin) {
  _inherits(LocationInfoTokenizerMixin, _Mixin);
  var _super = _createSuper(LocationInfoTokenizerMixin);
  function LocationInfoTokenizerMixin(tokenizer) {
    var _this;
    _classCallCheck(this, LocationInfoTokenizerMixin);
    _this = _super.call(this, tokenizer);
    _this.tokenizer = tokenizer;
    _this.posTracker = Mixin.install(tokenizer.preprocessor, PositionTrackingPreprocessorMixin);
    _this.currentAttrLocation = null;
    _this.ctLoc = null;
    return _this;
  }
  _createClass(LocationInfoTokenizerMixin, [{
    key: "_getCurrentLocation",
    value: function _getCurrentLocation() {
      return {
        startLine: this.posTracker.line,
        startCol: this.posTracker.col,
        startOffset: this.posTracker.offset,
        endLine: -1,
        endCol: -1,
        endOffset: -1
      };
    }
  }, {
    key: "_attachCurrentAttrLocationInfo",
    value: function _attachCurrentAttrLocationInfo() {
      this.currentAttrLocation.endLine = this.posTracker.line;
      this.currentAttrLocation.endCol = this.posTracker.col;
      this.currentAttrLocation.endOffset = this.posTracker.offset;
      var currentToken = this.tokenizer.currentToken;
      var currentAttr = this.tokenizer.currentAttr;
      if (!currentToken.location.attrs) {
        currentToken.location.attrs = Object.create(null);
      }
      currentToken.location.attrs[currentAttr.name] = this.currentAttrLocation;
    }
  }, {
    key: "_getOverriddenMethods",
    value: function _getOverriddenMethods(mxn, orig) {
      var methods = {
        _createStartTagToken: function _createStartTagToken() {
          orig._createStartTagToken.call(this);
          this.currentToken.location = mxn.ctLoc;
        },
        _createEndTagToken: function _createEndTagToken() {
          orig._createEndTagToken.call(this);
          this.currentToken.location = mxn.ctLoc;
        },
        _createCommentToken: function _createCommentToken() {
          orig._createCommentToken.call(this);
          this.currentToken.location = mxn.ctLoc;
        },
        _createDoctypeToken: function _createDoctypeToken(initialName) {
          orig._createDoctypeToken.call(this, initialName);
          this.currentToken.location = mxn.ctLoc;
        },
        _createCharacterToken: function _createCharacterToken(type, ch) {
          orig._createCharacterToken.call(this, type, ch);
          this.currentCharacterToken.location = mxn.ctLoc;
        },
        _createEOFToken: function _createEOFToken() {
          orig._createEOFToken.call(this);
          this.currentToken.location = mxn._getCurrentLocation();
        },
        _createAttr: function _createAttr(attrNameFirstCh) {
          orig._createAttr.call(this, attrNameFirstCh);
          mxn.currentAttrLocation = mxn._getCurrentLocation();
        },
        _leaveAttrName: function _leaveAttrName(toState) {
          orig._leaveAttrName.call(this, toState);
          mxn._attachCurrentAttrLocationInfo();
        },
        _leaveAttrValue: function _leaveAttrValue(toState) {
          orig._leaveAttrValue.call(this, toState);
          mxn._attachCurrentAttrLocationInfo();
        },
        _emitCurrentToken: function _emitCurrentToken() {
          var ctLoc = this.currentToken.location;

          //NOTE: if we have pending character token make it's end location equal to the
          //current token's start location.
          if (this.currentCharacterToken) {
            this.currentCharacterToken.location.endLine = ctLoc.startLine;
            this.currentCharacterToken.location.endCol = ctLoc.startCol;
            this.currentCharacterToken.location.endOffset = ctLoc.startOffset;
          }
          if (this.currentToken.type === Tokenizer.EOF_TOKEN) {
            ctLoc.endLine = ctLoc.startLine;
            ctLoc.endCol = ctLoc.startCol;
            ctLoc.endOffset = ctLoc.startOffset;
          } else {
            ctLoc.endLine = mxn.posTracker.line;
            ctLoc.endCol = mxn.posTracker.col + 1;
            ctLoc.endOffset = mxn.posTracker.offset + 1;
          }
          orig._emitCurrentToken.call(this);
        },
        _emitCurrentCharacterToken: function _emitCurrentCharacterToken() {
          var ctLoc = this.currentCharacterToken && this.currentCharacterToken.location;

          //NOTE: if we have character token and it's location wasn't set in the _emitCurrentToken(),
          //then set it's location at the current preprocessor position.
          //We don't need to increment preprocessor position, since character token
          //emission is always forced by the start of the next character token here.
          //So, we already have advanced position.
          if (ctLoc && ctLoc.endOffset === -1) {
            ctLoc.endLine = mxn.posTracker.line;
            ctLoc.endCol = mxn.posTracker.col;
            ctLoc.endOffset = mxn.posTracker.offset;
          }
          orig._emitCurrentCharacterToken.call(this);
        }
      };

      //NOTE: patch initial states for each mode to obtain token start position
      Object.keys(Tokenizer.MODE).forEach(function (modeName) {
        var state = Tokenizer.MODE[modeName];
        methods[state] = function (cp) {
          mxn.ctLoc = mxn._getCurrentLocation();
          orig[state].call(this, cp);
        };
      });
      return methods;
    }
  }]);
  return LocationInfoTokenizerMixin;
}(Mixin);
module.exports = LocationInfoTokenizerMixin;

/***/ }),

/***/ 2619:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var _inherits = __webpack_require__(2205);
var _possibleConstructorReturn = __webpack_require__(8585);
var _getPrototypeOf = __webpack_require__(9754);
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var Mixin = __webpack_require__(4086);
var PositionTrackingPreprocessorMixin = /*#__PURE__*/function (_Mixin) {
  _inherits(PositionTrackingPreprocessorMixin, _Mixin);
  var _super = _createSuper(PositionTrackingPreprocessorMixin);
  function PositionTrackingPreprocessorMixin(preprocessor) {
    var _this;
    _classCallCheck(this, PositionTrackingPreprocessorMixin);
    _this = _super.call(this, preprocessor);
    _this.preprocessor = preprocessor;
    _this.isEol = false;
    _this.lineStartPos = 0;
    _this.droppedBufferSize = 0;
    _this.offset = 0;
    _this.col = 0;
    _this.line = 1;
    return _this;
  }
  _createClass(PositionTrackingPreprocessorMixin, [{
    key: "_getOverriddenMethods",
    value: function _getOverriddenMethods(mxn, orig) {
      return {
        advance: function advance() {
          var pos = this.pos + 1;
          var ch = this.html[pos];

          //NOTE: LF should be in the last column of the line
          if (mxn.isEol) {
            mxn.isEol = false;
            mxn.line++;
            mxn.lineStartPos = pos;
          }
          if (ch === '\n' || ch === '\r' && this.html[pos + 1] !== '\n') {
            mxn.isEol = true;
          }
          mxn.col = pos - mxn.lineStartPos + 1;
          mxn.offset = mxn.droppedBufferSize + pos;
          return orig.advance.call(this);
        },
        retreat: function retreat() {
          orig.retreat.call(this);
          mxn.isEol = false;
          mxn.col = this.pos - mxn.lineStartPos + 1;
        },
        dropParsedChunk: function dropParsedChunk() {
          var prevPos = this.pos;
          orig.dropParsedChunk.call(this);
          var reduction = prevPos - this.pos;
          mxn.lineStartPos -= reduction;
          mxn.droppedBufferSize += reduction;
          mxn.offset = mxn.droppedBufferSize + this.pos;
        }
      };
    }
  }]);
  return PositionTrackingPreprocessorMixin;
}(Mixin);
module.exports = PositionTrackingPreprocessorMixin;

/***/ }),

/***/ 4673:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


//Const
var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var NOAH_ARK_CAPACITY = 3;

//List of formatting elements
var FormattingElementList = /*#__PURE__*/function () {
  function FormattingElementList(treeAdapter) {
    _classCallCheck(this, FormattingElementList);
    this.length = 0;
    this.entries = [];
    this.treeAdapter = treeAdapter;
    this.bookmark = null;
  }

  //Noah Ark's condition
  //OPTIMIZATION: at first we try to find possible candidates for exclusion using
  //lightweight heuristics without thorough attributes check.
  _createClass(FormattingElementList, [{
    key: "_getNoahArkConditionCandidates",
    value: function _getNoahArkConditionCandidates(newElement) {
      var candidates = [];
      if (this.length >= NOAH_ARK_CAPACITY) {
        var neAttrsLength = this.treeAdapter.getAttrList(newElement).length;
        var neTagName = this.treeAdapter.getTagName(newElement);
        var neNamespaceURI = this.treeAdapter.getNamespaceURI(newElement);
        for (var i = this.length - 1; i >= 0; i--) {
          var entry = this.entries[i];
          if (entry.type === FormattingElementList.MARKER_ENTRY) {
            break;
          }
          var element = entry.element;
          var elementAttrs = this.treeAdapter.getAttrList(element);
          var isCandidate = this.treeAdapter.getTagName(element) === neTagName && this.treeAdapter.getNamespaceURI(element) === neNamespaceURI && elementAttrs.length === neAttrsLength;
          if (isCandidate) {
            candidates.push({
              idx: i,
              attrs: elementAttrs
            });
          }
        }
      }
      return candidates.length < NOAH_ARK_CAPACITY ? [] : candidates;
    }
  }, {
    key: "_ensureNoahArkCondition",
    value: function _ensureNoahArkCondition(newElement) {
      var candidates = this._getNoahArkConditionCandidates(newElement);
      var cLength = candidates.length;
      if (cLength) {
        var neAttrs = this.treeAdapter.getAttrList(newElement);
        var neAttrsLength = neAttrs.length;
        var neAttrsMap = Object.create(null);

        //NOTE: build attrs map for the new element so we can perform fast lookups
        for (var i = 0; i < neAttrsLength; i++) {
          var neAttr = neAttrs[i];
          neAttrsMap[neAttr.name] = neAttr.value;
        }
        for (var _i = 0; _i < neAttrsLength; _i++) {
          for (var j = 0; j < cLength; j++) {
            var cAttr = candidates[j].attrs[_i];
            if (neAttrsMap[cAttr.name] !== cAttr.value) {
              candidates.splice(j, 1);
              cLength--;
            }
            if (candidates.length < NOAH_ARK_CAPACITY) {
              return;
            }
          }
        }

        //NOTE: remove bottommost candidates until Noah's Ark condition will not be met
        for (var _i2 = cLength - 1; _i2 >= NOAH_ARK_CAPACITY - 1; _i2--) {
          this.entries.splice(candidates[_i2].idx, 1);
          this.length--;
        }
      }
    }

    //Mutations
  }, {
    key: "insertMarker",
    value: function insertMarker() {
      this.entries.push({
        type: FormattingElementList.MARKER_ENTRY
      });
      this.length++;
    }
  }, {
    key: "pushElement",
    value: function pushElement(element, token) {
      this._ensureNoahArkCondition(element);
      this.entries.push({
        type: FormattingElementList.ELEMENT_ENTRY,
        element: element,
        token: token
      });
      this.length++;
    }
  }, {
    key: "insertElementAfterBookmark",
    value: function insertElementAfterBookmark(element, token) {
      var bookmarkIdx = this.length - 1;
      for (; bookmarkIdx >= 0; bookmarkIdx--) {
        if (this.entries[bookmarkIdx] === this.bookmark) {
          break;
        }
      }
      this.entries.splice(bookmarkIdx + 1, 0, {
        type: FormattingElementList.ELEMENT_ENTRY,
        element: element,
        token: token
      });
      this.length++;
    }
  }, {
    key: "removeEntry",
    value: function removeEntry(entry) {
      for (var i = this.length - 1; i >= 0; i--) {
        if (this.entries[i] === entry) {
          this.entries.splice(i, 1);
          this.length--;
          break;
        }
      }
    }
  }, {
    key: "clearToLastMarker",
    value: function clearToLastMarker() {
      while (this.length) {
        var entry = this.entries.pop();
        this.length--;
        if (entry.type === FormattingElementList.MARKER_ENTRY) {
          break;
        }
      }
    }

    //Search
  }, {
    key: "getElementEntryInScopeWithTagName",
    value: function getElementEntryInScopeWithTagName(tagName) {
      for (var i = this.length - 1; i >= 0; i--) {
        var entry = this.entries[i];
        if (entry.type === FormattingElementList.MARKER_ENTRY) {
          return null;
        }
        if (this.treeAdapter.getTagName(entry.element) === tagName) {
          return entry;
        }
      }
      return null;
    }
  }, {
    key: "getElementEntry",
    value: function getElementEntry(element) {
      for (var i = this.length - 1; i >= 0; i--) {
        var entry = this.entries[i];
        if (entry.type === FormattingElementList.ELEMENT_ENTRY && entry.element === element) {
          return entry;
        }
      }
      return null;
    }
  }]);
  return FormattingElementList;
}(); //Entry types
FormattingElementList.MARKER_ENTRY = 'MARKER_ENTRY';
FormattingElementList.ELEMENT_ENTRY = 'ELEMENT_ENTRY';
module.exports = FormattingElementList;

/***/ }),

/***/ 6425:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var _defineProperty = __webpack_require__(9713);
var _INSERTION_MODE_RESET, _TEMPLATE_INSERTION_M, _INITIAL_MODE, _BEFORE_HTML_MODE, _BEFORE_HEAD_MODE, _IN_HEAD_MODE, _IN_HEAD_NO_SCRIPT_MO, _AFTER_HEAD_MODE, _IN_BODY_MODE, _TEXT_MODE, _IN_TABLE_MODE, _IN_TABLE_TEXT_MODE, _IN_CAPTION_MODE, _IN_COLUMN_GROUP_MODE, _IN_TABLE_BODY_MODE, _IN_ROW_MODE, _IN_CELL_MODE, _IN_SELECT_MODE, _IN_SELECT_IN_TABLE_M, _IN_TEMPLATE_MODE, _AFTER_BODY_MODE, _IN_FRAMESET_MODE, _AFTER_FRAMESET_MODE, _AFTER_AFTER_BODY_MOD, _AFTER_AFTER_FRAMESET, _TOKEN_HANDLERS;
var Tokenizer = __webpack_require__(301);
var OpenElementStack = __webpack_require__(7674);
var FormattingElementList = __webpack_require__(4673);
var LocationInfoParserMixin = __webpack_require__(675);
var ErrorReportingParserMixin = __webpack_require__(2250);
var Mixin = __webpack_require__(4086);
var defaultTreeAdapter = __webpack_require__(7423);
var mergeOptions = __webpack_require__(5758);
var doctype = __webpack_require__(1794);
var foreignContent = __webpack_require__(533);
var ERR = __webpack_require__(4688);
var unicode = __webpack_require__(9879);
var HTML = __webpack_require__(8869);

//Aliases
var $ = HTML.TAG_NAMES;
var NS = HTML.NAMESPACES;
var ATTRS = HTML.ATTRS;
var DEFAULT_OPTIONS = {
  scriptingEnabled: true,
  sourceCodeLocationInfo: false,
  onParseError: null,
  treeAdapter: defaultTreeAdapter
};

//Misc constants
var HIDDEN_INPUT_TYPE = 'hidden';

//Adoption agency loops iteration count
var AA_OUTER_LOOP_ITER = 8;
var AA_INNER_LOOP_ITER = 3;

//Insertion modes
var INITIAL_MODE = 'INITIAL_MODE';
var BEFORE_HTML_MODE = 'BEFORE_HTML_MODE';
var BEFORE_HEAD_MODE = 'BEFORE_HEAD_MODE';
var IN_HEAD_MODE = 'IN_HEAD_MODE';
var IN_HEAD_NO_SCRIPT_MODE = 'IN_HEAD_NO_SCRIPT_MODE';
var AFTER_HEAD_MODE = 'AFTER_HEAD_MODE';
var IN_BODY_MODE = 'IN_BODY_MODE';
var TEXT_MODE = 'TEXT_MODE';
var IN_TABLE_MODE = 'IN_TABLE_MODE';
var IN_TABLE_TEXT_MODE = 'IN_TABLE_TEXT_MODE';
var IN_CAPTION_MODE = 'IN_CAPTION_MODE';
var IN_COLUMN_GROUP_MODE = 'IN_COLUMN_GROUP_MODE';
var IN_TABLE_BODY_MODE = 'IN_TABLE_BODY_MODE';
var IN_ROW_MODE = 'IN_ROW_MODE';
var IN_CELL_MODE = 'IN_CELL_MODE';
var IN_SELECT_MODE = 'IN_SELECT_MODE';
var IN_SELECT_IN_TABLE_MODE = 'IN_SELECT_IN_TABLE_MODE';
var IN_TEMPLATE_MODE = 'IN_TEMPLATE_MODE';
var AFTER_BODY_MODE = 'AFTER_BODY_MODE';
var IN_FRAMESET_MODE = 'IN_FRAMESET_MODE';
var AFTER_FRAMESET_MODE = 'AFTER_FRAMESET_MODE';
var AFTER_AFTER_BODY_MODE = 'AFTER_AFTER_BODY_MODE';
var AFTER_AFTER_FRAMESET_MODE = 'AFTER_AFTER_FRAMESET_MODE';

//Insertion mode reset map
var INSERTION_MODE_RESET_MAP = (_INSERTION_MODE_RESET = {}, _defineProperty(_INSERTION_MODE_RESET, $.TR, IN_ROW_MODE), _defineProperty(_INSERTION_MODE_RESET, $.TBODY, IN_TABLE_BODY_MODE), _defineProperty(_INSERTION_MODE_RESET, $.THEAD, IN_TABLE_BODY_MODE), _defineProperty(_INSERTION_MODE_RESET, $.TFOOT, IN_TABLE_BODY_MODE), _defineProperty(_INSERTION_MODE_RESET, $.CAPTION, IN_CAPTION_MODE), _defineProperty(_INSERTION_MODE_RESET, $.COLGROUP, IN_COLUMN_GROUP_MODE), _defineProperty(_INSERTION_MODE_RESET, $.TABLE, IN_TABLE_MODE), _defineProperty(_INSERTION_MODE_RESET, $.BODY, IN_BODY_MODE), _defineProperty(_INSERTION_MODE_RESET, $.FRAMESET, IN_FRAMESET_MODE), _INSERTION_MODE_RESET);

//Template insertion mode switch map
var TEMPLATE_INSERTION_MODE_SWITCH_MAP = (_TEMPLATE_INSERTION_M = {}, _defineProperty(_TEMPLATE_INSERTION_M, $.CAPTION, IN_TABLE_MODE), _defineProperty(_TEMPLATE_INSERTION_M, $.COLGROUP, IN_TABLE_MODE), _defineProperty(_TEMPLATE_INSERTION_M, $.TBODY, IN_TABLE_MODE), _defineProperty(_TEMPLATE_INSERTION_M, $.TFOOT, IN_TABLE_MODE), _defineProperty(_TEMPLATE_INSERTION_M, $.THEAD, IN_TABLE_MODE), _defineProperty(_TEMPLATE_INSERTION_M, $.COL, IN_COLUMN_GROUP_MODE), _defineProperty(_TEMPLATE_INSERTION_M, $.TR, IN_TABLE_BODY_MODE), _defineProperty(_TEMPLATE_INSERTION_M, $.TD, IN_ROW_MODE), _defineProperty(_TEMPLATE_INSERTION_M, $.TH, IN_ROW_MODE), _TEMPLATE_INSERTION_M);

//Token handlers map for insertion modes
var TOKEN_HANDLERS = (_TOKEN_HANDLERS = {}, _defineProperty(_TOKEN_HANDLERS, INITIAL_MODE, (_INITIAL_MODE = {}, _defineProperty(_INITIAL_MODE, Tokenizer.CHARACTER_TOKEN, tokenInInitialMode), _defineProperty(_INITIAL_MODE, Tokenizer.NULL_CHARACTER_TOKEN, tokenInInitialMode), _defineProperty(_INITIAL_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, ignoreToken), _defineProperty(_INITIAL_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_INITIAL_MODE, Tokenizer.DOCTYPE_TOKEN, doctypeInInitialMode), _defineProperty(_INITIAL_MODE, Tokenizer.START_TAG_TOKEN, tokenInInitialMode), _defineProperty(_INITIAL_MODE, Tokenizer.END_TAG_TOKEN, tokenInInitialMode), _defineProperty(_INITIAL_MODE, Tokenizer.EOF_TOKEN, tokenInInitialMode), _INITIAL_MODE)), _defineProperty(_TOKEN_HANDLERS, BEFORE_HTML_MODE, (_BEFORE_HTML_MODE = {}, _defineProperty(_BEFORE_HTML_MODE, Tokenizer.CHARACTER_TOKEN, tokenBeforeHtml), _defineProperty(_BEFORE_HTML_MODE, Tokenizer.NULL_CHARACTER_TOKEN, tokenBeforeHtml), _defineProperty(_BEFORE_HTML_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, ignoreToken), _defineProperty(_BEFORE_HTML_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_BEFORE_HTML_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_BEFORE_HTML_MODE, Tokenizer.START_TAG_TOKEN, startTagBeforeHtml), _defineProperty(_BEFORE_HTML_MODE, Tokenizer.END_TAG_TOKEN, endTagBeforeHtml), _defineProperty(_BEFORE_HTML_MODE, Tokenizer.EOF_TOKEN, tokenBeforeHtml), _BEFORE_HTML_MODE)), _defineProperty(_TOKEN_HANDLERS, BEFORE_HEAD_MODE, (_BEFORE_HEAD_MODE = {}, _defineProperty(_BEFORE_HEAD_MODE, Tokenizer.CHARACTER_TOKEN, tokenBeforeHead), _defineProperty(_BEFORE_HEAD_MODE, Tokenizer.NULL_CHARACTER_TOKEN, tokenBeforeHead), _defineProperty(_BEFORE_HEAD_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, ignoreToken), _defineProperty(_BEFORE_HEAD_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_BEFORE_HEAD_MODE, Tokenizer.DOCTYPE_TOKEN, misplacedDoctype), _defineProperty(_BEFORE_HEAD_MODE, Tokenizer.START_TAG_TOKEN, startTagBeforeHead), _defineProperty(_BEFORE_HEAD_MODE, Tokenizer.END_TAG_TOKEN, endTagBeforeHead), _defineProperty(_BEFORE_HEAD_MODE, Tokenizer.EOF_TOKEN, tokenBeforeHead), _BEFORE_HEAD_MODE)), _defineProperty(_TOKEN_HANDLERS, IN_HEAD_MODE, (_IN_HEAD_MODE = {}, _defineProperty(_IN_HEAD_MODE, Tokenizer.CHARACTER_TOKEN, tokenInHead), _defineProperty(_IN_HEAD_MODE, Tokenizer.NULL_CHARACTER_TOKEN, tokenInHead), _defineProperty(_IN_HEAD_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, insertCharacters), _defineProperty(_IN_HEAD_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_IN_HEAD_MODE, Tokenizer.DOCTYPE_TOKEN, misplacedDoctype), _defineProperty(_IN_HEAD_MODE, Tokenizer.START_TAG_TOKEN, startTagInHead), _defineProperty(_IN_HEAD_MODE, Tokenizer.END_TAG_TOKEN, endTagInHead), _defineProperty(_IN_HEAD_MODE, Tokenizer.EOF_TOKEN, tokenInHead), _IN_HEAD_MODE)), _defineProperty(_TOKEN_HANDLERS, IN_HEAD_NO_SCRIPT_MODE, (_IN_HEAD_NO_SCRIPT_MO = {}, _defineProperty(_IN_HEAD_NO_SCRIPT_MO, Tokenizer.CHARACTER_TOKEN, tokenInHeadNoScript), _defineProperty(_IN_HEAD_NO_SCRIPT_MO, Tokenizer.NULL_CHARACTER_TOKEN, tokenInHeadNoScript), _defineProperty(_IN_HEAD_NO_SCRIPT_MO, Tokenizer.WHITESPACE_CHARACTER_TOKEN, insertCharacters), _defineProperty(_IN_HEAD_NO_SCRIPT_MO, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_IN_HEAD_NO_SCRIPT_MO, Tokenizer.DOCTYPE_TOKEN, misplacedDoctype), _defineProperty(_IN_HEAD_NO_SCRIPT_MO, Tokenizer.START_TAG_TOKEN, startTagInHeadNoScript), _defineProperty(_IN_HEAD_NO_SCRIPT_MO, Tokenizer.END_TAG_TOKEN, endTagInHeadNoScript), _defineProperty(_IN_HEAD_NO_SCRIPT_MO, Tokenizer.EOF_TOKEN, tokenInHeadNoScript), _IN_HEAD_NO_SCRIPT_MO)), _defineProperty(_TOKEN_HANDLERS, AFTER_HEAD_MODE, (_AFTER_HEAD_MODE = {}, _defineProperty(_AFTER_HEAD_MODE, Tokenizer.CHARACTER_TOKEN, tokenAfterHead), _defineProperty(_AFTER_HEAD_MODE, Tokenizer.NULL_CHARACTER_TOKEN, tokenAfterHead), _defineProperty(_AFTER_HEAD_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, insertCharacters), _defineProperty(_AFTER_HEAD_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_AFTER_HEAD_MODE, Tokenizer.DOCTYPE_TOKEN, misplacedDoctype), _defineProperty(_AFTER_HEAD_MODE, Tokenizer.START_TAG_TOKEN, startTagAfterHead), _defineProperty(_AFTER_HEAD_MODE, Tokenizer.END_TAG_TOKEN, endTagAfterHead), _defineProperty(_AFTER_HEAD_MODE, Tokenizer.EOF_TOKEN, tokenAfterHead), _AFTER_HEAD_MODE)), _defineProperty(_TOKEN_HANDLERS, IN_BODY_MODE, (_IN_BODY_MODE = {}, _defineProperty(_IN_BODY_MODE, Tokenizer.CHARACTER_TOKEN, characterInBody), _defineProperty(_IN_BODY_MODE, Tokenizer.NULL_CHARACTER_TOKEN, ignoreToken), _defineProperty(_IN_BODY_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, whitespaceCharacterInBody), _defineProperty(_IN_BODY_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_IN_BODY_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_IN_BODY_MODE, Tokenizer.START_TAG_TOKEN, startTagInBody), _defineProperty(_IN_BODY_MODE, Tokenizer.END_TAG_TOKEN, endTagInBody), _defineProperty(_IN_BODY_MODE, Tokenizer.EOF_TOKEN, eofInBody), _IN_BODY_MODE)), _defineProperty(_TOKEN_HANDLERS, TEXT_MODE, (_TEXT_MODE = {}, _defineProperty(_TEXT_MODE, Tokenizer.CHARACTER_TOKEN, insertCharacters), _defineProperty(_TEXT_MODE, Tokenizer.NULL_CHARACTER_TOKEN, insertCharacters), _defineProperty(_TEXT_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, insertCharacters), _defineProperty(_TEXT_MODE, Tokenizer.COMMENT_TOKEN, ignoreToken), _defineProperty(_TEXT_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_TEXT_MODE, Tokenizer.START_TAG_TOKEN, ignoreToken), _defineProperty(_TEXT_MODE, Tokenizer.END_TAG_TOKEN, endTagInText), _defineProperty(_TEXT_MODE, Tokenizer.EOF_TOKEN, eofInText), _TEXT_MODE)), _defineProperty(_TOKEN_HANDLERS, IN_TABLE_MODE, (_IN_TABLE_MODE = {}, _defineProperty(_IN_TABLE_MODE, Tokenizer.CHARACTER_TOKEN, characterInTable), _defineProperty(_IN_TABLE_MODE, Tokenizer.NULL_CHARACTER_TOKEN, characterInTable), _defineProperty(_IN_TABLE_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, characterInTable), _defineProperty(_IN_TABLE_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_IN_TABLE_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_IN_TABLE_MODE, Tokenizer.START_TAG_TOKEN, startTagInTable), _defineProperty(_IN_TABLE_MODE, Tokenizer.END_TAG_TOKEN, endTagInTable), _defineProperty(_IN_TABLE_MODE, Tokenizer.EOF_TOKEN, eofInBody), _IN_TABLE_MODE)), _defineProperty(_TOKEN_HANDLERS, IN_TABLE_TEXT_MODE, (_IN_TABLE_TEXT_MODE = {}, _defineProperty(_IN_TABLE_TEXT_MODE, Tokenizer.CHARACTER_TOKEN, characterInTableText), _defineProperty(_IN_TABLE_TEXT_MODE, Tokenizer.NULL_CHARACTER_TOKEN, ignoreToken), _defineProperty(_IN_TABLE_TEXT_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, whitespaceCharacterInTableText), _defineProperty(_IN_TABLE_TEXT_MODE, Tokenizer.COMMENT_TOKEN, tokenInTableText), _defineProperty(_IN_TABLE_TEXT_MODE, Tokenizer.DOCTYPE_TOKEN, tokenInTableText), _defineProperty(_IN_TABLE_TEXT_MODE, Tokenizer.START_TAG_TOKEN, tokenInTableText), _defineProperty(_IN_TABLE_TEXT_MODE, Tokenizer.END_TAG_TOKEN, tokenInTableText), _defineProperty(_IN_TABLE_TEXT_MODE, Tokenizer.EOF_TOKEN, tokenInTableText), _IN_TABLE_TEXT_MODE)), _defineProperty(_TOKEN_HANDLERS, IN_CAPTION_MODE, (_IN_CAPTION_MODE = {}, _defineProperty(_IN_CAPTION_MODE, Tokenizer.CHARACTER_TOKEN, characterInBody), _defineProperty(_IN_CAPTION_MODE, Tokenizer.NULL_CHARACTER_TOKEN, ignoreToken), _defineProperty(_IN_CAPTION_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, whitespaceCharacterInBody), _defineProperty(_IN_CAPTION_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_IN_CAPTION_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_IN_CAPTION_MODE, Tokenizer.START_TAG_TOKEN, startTagInCaption), _defineProperty(_IN_CAPTION_MODE, Tokenizer.END_TAG_TOKEN, endTagInCaption), _defineProperty(_IN_CAPTION_MODE, Tokenizer.EOF_TOKEN, eofInBody), _IN_CAPTION_MODE)), _defineProperty(_TOKEN_HANDLERS, IN_COLUMN_GROUP_MODE, (_IN_COLUMN_GROUP_MODE = {}, _defineProperty(_IN_COLUMN_GROUP_MODE, Tokenizer.CHARACTER_TOKEN, tokenInColumnGroup), _defineProperty(_IN_COLUMN_GROUP_MODE, Tokenizer.NULL_CHARACTER_TOKEN, tokenInColumnGroup), _defineProperty(_IN_COLUMN_GROUP_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, insertCharacters), _defineProperty(_IN_COLUMN_GROUP_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_IN_COLUMN_GROUP_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_IN_COLUMN_GROUP_MODE, Tokenizer.START_TAG_TOKEN, startTagInColumnGroup), _defineProperty(_IN_COLUMN_GROUP_MODE, Tokenizer.END_TAG_TOKEN, endTagInColumnGroup), _defineProperty(_IN_COLUMN_GROUP_MODE, Tokenizer.EOF_TOKEN, eofInBody), _IN_COLUMN_GROUP_MODE)), _defineProperty(_TOKEN_HANDLERS, IN_TABLE_BODY_MODE, (_IN_TABLE_BODY_MODE = {}, _defineProperty(_IN_TABLE_BODY_MODE, Tokenizer.CHARACTER_TOKEN, characterInTable), _defineProperty(_IN_TABLE_BODY_MODE, Tokenizer.NULL_CHARACTER_TOKEN, characterInTable), _defineProperty(_IN_TABLE_BODY_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, characterInTable), _defineProperty(_IN_TABLE_BODY_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_IN_TABLE_BODY_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_IN_TABLE_BODY_MODE, Tokenizer.START_TAG_TOKEN, startTagInTableBody), _defineProperty(_IN_TABLE_BODY_MODE, Tokenizer.END_TAG_TOKEN, endTagInTableBody), _defineProperty(_IN_TABLE_BODY_MODE, Tokenizer.EOF_TOKEN, eofInBody), _IN_TABLE_BODY_MODE)), _defineProperty(_TOKEN_HANDLERS, IN_ROW_MODE, (_IN_ROW_MODE = {}, _defineProperty(_IN_ROW_MODE, Tokenizer.CHARACTER_TOKEN, characterInTable), _defineProperty(_IN_ROW_MODE, Tokenizer.NULL_CHARACTER_TOKEN, characterInTable), _defineProperty(_IN_ROW_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, characterInTable), _defineProperty(_IN_ROW_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_IN_ROW_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_IN_ROW_MODE, Tokenizer.START_TAG_TOKEN, startTagInRow), _defineProperty(_IN_ROW_MODE, Tokenizer.END_TAG_TOKEN, endTagInRow), _defineProperty(_IN_ROW_MODE, Tokenizer.EOF_TOKEN, eofInBody), _IN_ROW_MODE)), _defineProperty(_TOKEN_HANDLERS, IN_CELL_MODE, (_IN_CELL_MODE = {}, _defineProperty(_IN_CELL_MODE, Tokenizer.CHARACTER_TOKEN, characterInBody), _defineProperty(_IN_CELL_MODE, Tokenizer.NULL_CHARACTER_TOKEN, ignoreToken), _defineProperty(_IN_CELL_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, whitespaceCharacterInBody), _defineProperty(_IN_CELL_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_IN_CELL_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_IN_CELL_MODE, Tokenizer.START_TAG_TOKEN, startTagInCell), _defineProperty(_IN_CELL_MODE, Tokenizer.END_TAG_TOKEN, endTagInCell), _defineProperty(_IN_CELL_MODE, Tokenizer.EOF_TOKEN, eofInBody), _IN_CELL_MODE)), _defineProperty(_TOKEN_HANDLERS, IN_SELECT_MODE, (_IN_SELECT_MODE = {}, _defineProperty(_IN_SELECT_MODE, Tokenizer.CHARACTER_TOKEN, insertCharacters), _defineProperty(_IN_SELECT_MODE, Tokenizer.NULL_CHARACTER_TOKEN, ignoreToken), _defineProperty(_IN_SELECT_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, insertCharacters), _defineProperty(_IN_SELECT_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_IN_SELECT_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_IN_SELECT_MODE, Tokenizer.START_TAG_TOKEN, startTagInSelect), _defineProperty(_IN_SELECT_MODE, Tokenizer.END_TAG_TOKEN, endTagInSelect), _defineProperty(_IN_SELECT_MODE, Tokenizer.EOF_TOKEN, eofInBody), _IN_SELECT_MODE)), _defineProperty(_TOKEN_HANDLERS, IN_SELECT_IN_TABLE_MODE, (_IN_SELECT_IN_TABLE_M = {}, _defineProperty(_IN_SELECT_IN_TABLE_M, Tokenizer.CHARACTER_TOKEN, insertCharacters), _defineProperty(_IN_SELECT_IN_TABLE_M, Tokenizer.NULL_CHARACTER_TOKEN, ignoreToken), _defineProperty(_IN_SELECT_IN_TABLE_M, Tokenizer.WHITESPACE_CHARACTER_TOKEN, insertCharacters), _defineProperty(_IN_SELECT_IN_TABLE_M, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_IN_SELECT_IN_TABLE_M, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_IN_SELECT_IN_TABLE_M, Tokenizer.START_TAG_TOKEN, startTagInSelectInTable), _defineProperty(_IN_SELECT_IN_TABLE_M, Tokenizer.END_TAG_TOKEN, endTagInSelectInTable), _defineProperty(_IN_SELECT_IN_TABLE_M, Tokenizer.EOF_TOKEN, eofInBody), _IN_SELECT_IN_TABLE_M)), _defineProperty(_TOKEN_HANDLERS, IN_TEMPLATE_MODE, (_IN_TEMPLATE_MODE = {}, _defineProperty(_IN_TEMPLATE_MODE, Tokenizer.CHARACTER_TOKEN, characterInBody), _defineProperty(_IN_TEMPLATE_MODE, Tokenizer.NULL_CHARACTER_TOKEN, ignoreToken), _defineProperty(_IN_TEMPLATE_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, whitespaceCharacterInBody), _defineProperty(_IN_TEMPLATE_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_IN_TEMPLATE_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_IN_TEMPLATE_MODE, Tokenizer.START_TAG_TOKEN, startTagInTemplate), _defineProperty(_IN_TEMPLATE_MODE, Tokenizer.END_TAG_TOKEN, endTagInTemplate), _defineProperty(_IN_TEMPLATE_MODE, Tokenizer.EOF_TOKEN, eofInTemplate), _IN_TEMPLATE_MODE)), _defineProperty(_TOKEN_HANDLERS, AFTER_BODY_MODE, (_AFTER_BODY_MODE = {}, _defineProperty(_AFTER_BODY_MODE, Tokenizer.CHARACTER_TOKEN, tokenAfterBody), _defineProperty(_AFTER_BODY_MODE, Tokenizer.NULL_CHARACTER_TOKEN, tokenAfterBody), _defineProperty(_AFTER_BODY_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, whitespaceCharacterInBody), _defineProperty(_AFTER_BODY_MODE, Tokenizer.COMMENT_TOKEN, appendCommentToRootHtmlElement), _defineProperty(_AFTER_BODY_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_AFTER_BODY_MODE, Tokenizer.START_TAG_TOKEN, startTagAfterBody), _defineProperty(_AFTER_BODY_MODE, Tokenizer.END_TAG_TOKEN, endTagAfterBody), _defineProperty(_AFTER_BODY_MODE, Tokenizer.EOF_TOKEN, stopParsing), _AFTER_BODY_MODE)), _defineProperty(_TOKEN_HANDLERS, IN_FRAMESET_MODE, (_IN_FRAMESET_MODE = {}, _defineProperty(_IN_FRAMESET_MODE, Tokenizer.CHARACTER_TOKEN, ignoreToken), _defineProperty(_IN_FRAMESET_MODE, Tokenizer.NULL_CHARACTER_TOKEN, ignoreToken), _defineProperty(_IN_FRAMESET_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, insertCharacters), _defineProperty(_IN_FRAMESET_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_IN_FRAMESET_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_IN_FRAMESET_MODE, Tokenizer.START_TAG_TOKEN, startTagInFrameset), _defineProperty(_IN_FRAMESET_MODE, Tokenizer.END_TAG_TOKEN, endTagInFrameset), _defineProperty(_IN_FRAMESET_MODE, Tokenizer.EOF_TOKEN, stopParsing), _IN_FRAMESET_MODE)), _defineProperty(_TOKEN_HANDLERS, AFTER_FRAMESET_MODE, (_AFTER_FRAMESET_MODE = {}, _defineProperty(_AFTER_FRAMESET_MODE, Tokenizer.CHARACTER_TOKEN, ignoreToken), _defineProperty(_AFTER_FRAMESET_MODE, Tokenizer.NULL_CHARACTER_TOKEN, ignoreToken), _defineProperty(_AFTER_FRAMESET_MODE, Tokenizer.WHITESPACE_CHARACTER_TOKEN, insertCharacters), _defineProperty(_AFTER_FRAMESET_MODE, Tokenizer.COMMENT_TOKEN, appendComment), _defineProperty(_AFTER_FRAMESET_MODE, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_AFTER_FRAMESET_MODE, Tokenizer.START_TAG_TOKEN, startTagAfterFrameset), _defineProperty(_AFTER_FRAMESET_MODE, Tokenizer.END_TAG_TOKEN, endTagAfterFrameset), _defineProperty(_AFTER_FRAMESET_MODE, Tokenizer.EOF_TOKEN, stopParsing), _AFTER_FRAMESET_MODE)), _defineProperty(_TOKEN_HANDLERS, AFTER_AFTER_BODY_MODE, (_AFTER_AFTER_BODY_MOD = {}, _defineProperty(_AFTER_AFTER_BODY_MOD, Tokenizer.CHARACTER_TOKEN, tokenAfterAfterBody), _defineProperty(_AFTER_AFTER_BODY_MOD, Tokenizer.NULL_CHARACTER_TOKEN, tokenAfterAfterBody), _defineProperty(_AFTER_AFTER_BODY_MOD, Tokenizer.WHITESPACE_CHARACTER_TOKEN, whitespaceCharacterInBody), _defineProperty(_AFTER_AFTER_BODY_MOD, Tokenizer.COMMENT_TOKEN, appendCommentToDocument), _defineProperty(_AFTER_AFTER_BODY_MOD, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_AFTER_AFTER_BODY_MOD, Tokenizer.START_TAG_TOKEN, startTagAfterAfterBody), _defineProperty(_AFTER_AFTER_BODY_MOD, Tokenizer.END_TAG_TOKEN, tokenAfterAfterBody), _defineProperty(_AFTER_AFTER_BODY_MOD, Tokenizer.EOF_TOKEN, stopParsing), _AFTER_AFTER_BODY_MOD)), _defineProperty(_TOKEN_HANDLERS, AFTER_AFTER_FRAMESET_MODE, (_AFTER_AFTER_FRAMESET = {}, _defineProperty(_AFTER_AFTER_FRAMESET, Tokenizer.CHARACTER_TOKEN, ignoreToken), _defineProperty(_AFTER_AFTER_FRAMESET, Tokenizer.NULL_CHARACTER_TOKEN, ignoreToken), _defineProperty(_AFTER_AFTER_FRAMESET, Tokenizer.WHITESPACE_CHARACTER_TOKEN, whitespaceCharacterInBody), _defineProperty(_AFTER_AFTER_FRAMESET, Tokenizer.COMMENT_TOKEN, appendCommentToDocument), _defineProperty(_AFTER_AFTER_FRAMESET, Tokenizer.DOCTYPE_TOKEN, ignoreToken), _defineProperty(_AFTER_AFTER_FRAMESET, Tokenizer.START_TAG_TOKEN, startTagAfterAfterFrameset), _defineProperty(_AFTER_AFTER_FRAMESET, Tokenizer.END_TAG_TOKEN, ignoreToken), _defineProperty(_AFTER_AFTER_FRAMESET, Tokenizer.EOF_TOKEN, stopParsing), _AFTER_AFTER_FRAMESET)), _TOKEN_HANDLERS);

//Parser
var Parser = /*#__PURE__*/function () {
  function Parser(options) {
    _classCallCheck(this, Parser);
    this.options = mergeOptions(DEFAULT_OPTIONS, options);
    this.treeAdapter = this.options.treeAdapter;
    this.pendingScript = null;
    if (this.options.sourceCodeLocationInfo) {
      Mixin.install(this, LocationInfoParserMixin);
    }
    if (this.options.onParseError) {
      Mixin.install(this, ErrorReportingParserMixin, {
        onParseError: this.options.onParseError
      });
    }
  }

  // API
  _createClass(Parser, [{
    key: "parse",
    value: function parse(html) {
      var document = this.treeAdapter.createDocument();
      this._bootstrap(document, null);
      this.tokenizer.write(html, true);
      this._runParsingLoop(null);
      return document;
    }
  }, {
    key: "parseFragment",
    value: function parseFragment(html, fragmentContext) {
      //NOTE: use <template> element as a fragment context if context element was not provided,
      //so we will parse in "forgiving" manner
      if (!fragmentContext) {
        fragmentContext = this.treeAdapter.createElement($.TEMPLATE, NS.HTML, []);
      }

      //NOTE: create fake element which will be used as 'document' for fragment parsing.
      //This is important for jsdom there 'document' can't be recreated, therefore
      //fragment parsing causes messing of the main `document`.
      var documentMock = this.treeAdapter.createElement('documentmock', NS.HTML, []);
      this._bootstrap(documentMock, fragmentContext);
      if (this.treeAdapter.getTagName(fragmentContext) === $.TEMPLATE) {
        this._pushTmplInsertionMode(IN_TEMPLATE_MODE);
      }
      this._initTokenizerForFragmentParsing();
      this._insertFakeRootElement();
      this._resetInsertionMode();
      this._findFormInFragmentContext();
      this.tokenizer.write(html, true);
      this._runParsingLoop(null);
      var rootElement = this.treeAdapter.getFirstChild(documentMock);
      var fragment = this.treeAdapter.createDocumentFragment();
      this._adoptNodes(rootElement, fragment);
      return fragment;
    }

    //Bootstrap parser
  }, {
    key: "_bootstrap",
    value: function _bootstrap(document, fragmentContext) {
      this.tokenizer = new Tokenizer(this.options);
      this.stopped = false;
      this.insertionMode = INITIAL_MODE;
      this.originalInsertionMode = '';
      this.document = document;
      this.fragmentContext = fragmentContext;
      this.headElement = null;
      this.formElement = null;
      this.openElements = new OpenElementStack(this.document, this.treeAdapter);
      this.activeFormattingElements = new FormattingElementList(this.treeAdapter);
      this.tmplInsertionModeStack = [];
      this.tmplInsertionModeStackTop = -1;
      this.currentTmplInsertionMode = null;
      this.pendingCharacterTokens = [];
      this.hasNonWhitespacePendingCharacterToken = false;
      this.framesetOk = true;
      this.skipNextNewLine = false;
      this.fosterParentingEnabled = false;
    }

    //Errors
  }, {
    key: "_err",
    value: function _err() {
      // NOTE: err reporting is noop by default. Enabled by mixin.
    }

    //Parsing loop
  }, {
    key: "_runParsingLoop",
    value: function _runParsingLoop(scriptHandler) {
      while (!this.stopped) {
        this._setupTokenizerCDATAMode();
        var token = this.tokenizer.getNextToken();
        if (token.type === Tokenizer.HIBERNATION_TOKEN) {
          break;
        }
        if (this.skipNextNewLine) {
          this.skipNextNewLine = false;
          if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN && token.chars[0] === '\n') {
            if (token.chars.length === 1) {
              continue;
            }
            token.chars = token.chars.substr(1);
          }
        }
        this._processInputToken(token);
        if (scriptHandler && this.pendingScript) {
          break;
        }
      }
    }
  }, {
    key: "runParsingLoopForCurrentChunk",
    value: function runParsingLoopForCurrentChunk(writeCallback, scriptHandler) {
      this._runParsingLoop(scriptHandler);
      if (scriptHandler && this.pendingScript) {
        var script = this.pendingScript;
        this.pendingScript = null;
        scriptHandler(script);
        return;
      }
      if (writeCallback) {
        writeCallback();
      }
    }

    //Text parsing
  }, {
    key: "_setupTokenizerCDATAMode",
    value: function _setupTokenizerCDATAMode() {
      var current = this._getAdjustedCurrentElement();
      this.tokenizer.allowCDATA = current && current !== this.document && this.treeAdapter.getNamespaceURI(current) !== NS.HTML && !this._isIntegrationPoint(current);
    }
  }, {
    key: "_switchToTextParsing",
    value: function _switchToTextParsing(currentToken, nextTokenizerState) {
      this._insertElement(currentToken, NS.HTML);
      this.tokenizer.state = nextTokenizerState;
      this.originalInsertionMode = this.insertionMode;
      this.insertionMode = TEXT_MODE;
    }
  }, {
    key: "switchToPlaintextParsing",
    value: function switchToPlaintextParsing() {
      this.insertionMode = TEXT_MODE;
      this.originalInsertionMode = IN_BODY_MODE;
      this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
    }

    //Fragment parsing
  }, {
    key: "_getAdjustedCurrentElement",
    value: function _getAdjustedCurrentElement() {
      return this.openElements.stackTop === 0 && this.fragmentContext ? this.fragmentContext : this.openElements.current;
    }
  }, {
    key: "_findFormInFragmentContext",
    value: function _findFormInFragmentContext() {
      var node = this.fragmentContext;
      do {
        if (this.treeAdapter.getTagName(node) === $.FORM) {
          this.formElement = node;
          break;
        }
        node = this.treeAdapter.getParentNode(node);
      } while (node);
    }
  }, {
    key: "_initTokenizerForFragmentParsing",
    value: function _initTokenizerForFragmentParsing() {
      if (this.treeAdapter.getNamespaceURI(this.fragmentContext) === NS.HTML) {
        var tn = this.treeAdapter.getTagName(this.fragmentContext);
        if (tn === $.TITLE || tn === $.TEXTAREA) {
          this.tokenizer.state = Tokenizer.MODE.RCDATA;
        } else if (tn === $.STYLE || tn === $.XMP || tn === $.IFRAME || tn === $.NOEMBED || tn === $.NOFRAMES || tn === $.NOSCRIPT) {
          this.tokenizer.state = Tokenizer.MODE.RAWTEXT;
        } else if (tn === $.SCRIPT) {
          this.tokenizer.state = Tokenizer.MODE.SCRIPT_DATA;
        } else if (tn === $.PLAINTEXT) {
          this.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
        }
      }
    }

    //Tree mutation
  }, {
    key: "_setDocumentType",
    value: function _setDocumentType(token) {
      var name = token.name || '';
      var publicId = token.publicId || '';
      var systemId = token.systemId || '';
      this.treeAdapter.setDocumentType(this.document, name, publicId, systemId);
    }
  }, {
    key: "_attachElementToTree",
    value: function _attachElementToTree(element) {
      if (this._shouldFosterParentOnInsertion()) {
        this._fosterParentElement(element);
      } else {
        var parent = this.openElements.currentTmplContent || this.openElements.current;
        this.treeAdapter.appendChild(parent, element);
      }
    }
  }, {
    key: "_appendElement",
    value: function _appendElement(token, namespaceURI) {
      var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
      this._attachElementToTree(element);
    }
  }, {
    key: "_insertElement",
    value: function _insertElement(token, namespaceURI) {
      var element = this.treeAdapter.createElement(token.tagName, namespaceURI, token.attrs);
      this._attachElementToTree(element);
      this.openElements.push(element);
    }
  }, {
    key: "_insertFakeElement",
    value: function _insertFakeElement(tagName) {
      var element = this.treeAdapter.createElement(tagName, NS.HTML, []);
      this._attachElementToTree(element);
      this.openElements.push(element);
    }
  }, {
    key: "_insertTemplate",
    value: function _insertTemplate(token) {
      var tmpl = this.treeAdapter.createElement(token.tagName, NS.HTML, token.attrs);
      var content = this.treeAdapter.createDocumentFragment();
      this.treeAdapter.setTemplateContent(tmpl, content);
      this._attachElementToTree(tmpl);
      this.openElements.push(tmpl);
    }
  }, {
    key: "_insertFakeRootElement",
    value: function _insertFakeRootElement() {
      var element = this.treeAdapter.createElement($.HTML, NS.HTML, []);
      this.treeAdapter.appendChild(this.openElements.current, element);
      this.openElements.push(element);
    }
  }, {
    key: "_appendCommentNode",
    value: function _appendCommentNode(token, parent) {
      var commentNode = this.treeAdapter.createCommentNode(token.data);
      this.treeAdapter.appendChild(parent, commentNode);
    }
  }, {
    key: "_insertCharacters",
    value: function _insertCharacters(token) {
      if (this._shouldFosterParentOnInsertion()) {
        this._fosterParentText(token.chars);
      } else {
        var parent = this.openElements.currentTmplContent || this.openElements.current;
        this.treeAdapter.insertText(parent, token.chars);
      }
    }
  }, {
    key: "_adoptNodes",
    value: function _adoptNodes(donor, recipient) {
      for (var child = this.treeAdapter.getFirstChild(donor); child; child = this.treeAdapter.getFirstChild(donor)) {
        this.treeAdapter.detachNode(child);
        this.treeAdapter.appendChild(recipient, child);
      }
    }

    //Token processing
  }, {
    key: "_shouldProcessTokenInForeignContent",
    value: function _shouldProcessTokenInForeignContent(token) {
      var current = this._getAdjustedCurrentElement();
      if (!current || current === this.document) {
        return false;
      }
      var ns = this.treeAdapter.getNamespaceURI(current);
      if (ns === NS.HTML) {
        return false;
      }
      if (this.treeAdapter.getTagName(current) === $.ANNOTATION_XML && ns === NS.MATHML && token.type === Tokenizer.START_TAG_TOKEN && token.tagName === $.SVG) {
        return false;
      }
      var isCharacterToken = token.type === Tokenizer.CHARACTER_TOKEN || token.type === Tokenizer.NULL_CHARACTER_TOKEN || token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN;
      var isMathMLTextStartTag = token.type === Tokenizer.START_TAG_TOKEN && token.tagName !== $.MGLYPH && token.tagName !== $.MALIGNMARK;
      if ((isMathMLTextStartTag || isCharacterToken) && this._isIntegrationPoint(current, NS.MATHML)) {
        return false;
      }
      if ((token.type === Tokenizer.START_TAG_TOKEN || isCharacterToken) && this._isIntegrationPoint(current, NS.HTML)) {
        return false;
      }
      return token.type !== Tokenizer.EOF_TOKEN;
    }
  }, {
    key: "_processToken",
    value: function _processToken(token) {
      TOKEN_HANDLERS[this.insertionMode][token.type](this, token);
    }
  }, {
    key: "_processTokenInBodyMode",
    value: function _processTokenInBodyMode(token) {
      TOKEN_HANDLERS[IN_BODY_MODE][token.type](this, token);
    }
  }, {
    key: "_processTokenInForeignContent",
    value: function _processTokenInForeignContent(token) {
      if (token.type === Tokenizer.CHARACTER_TOKEN) {
        characterInForeignContent(this, token);
      } else if (token.type === Tokenizer.NULL_CHARACTER_TOKEN) {
        nullCharacterInForeignContent(this, token);
      } else if (token.type === Tokenizer.WHITESPACE_CHARACTER_TOKEN) {
        insertCharacters(this, token);
      } else if (token.type === Tokenizer.COMMENT_TOKEN) {
        appendComment(this, token);
      } else if (token.type === Tokenizer.START_TAG_TOKEN) {
        startTagInForeignContent(this, token);
      } else if (token.type === Tokenizer.END_TAG_TOKEN) {
        endTagInForeignContent(this, token);
      }
    }
  }, {
    key: "_processInputToken",
    value: function _processInputToken(token) {
      if (this._shouldProcessTokenInForeignContent(token)) {
        this._processTokenInForeignContent(token);
      } else {
        this._processToken(token);
      }
      if (token.type === Tokenizer.START_TAG_TOKEN && token.selfClosing && !token.ackSelfClosing) {
        this._err(ERR.nonVoidHtmlElementStartTagWithTrailingSolidus);
      }
    }

    //Integration points
  }, {
    key: "_isIntegrationPoint",
    value: function _isIntegrationPoint(element, foreignNS) {
      var tn = this.treeAdapter.getTagName(element);
      var ns = this.treeAdapter.getNamespaceURI(element);
      var attrs = this.treeAdapter.getAttrList(element);
      return foreignContent.isIntegrationPoint(tn, ns, attrs, foreignNS);
    }

    //Active formatting elements reconstruction
  }, {
    key: "_reconstructActiveFormattingElements",
    value: function _reconstructActiveFormattingElements() {
      var listLength = this.activeFormattingElements.length;
      if (listLength) {
        var unopenIdx = listLength;
        var entry = null;
        do {
          unopenIdx--;
          entry = this.activeFormattingElements.entries[unopenIdx];
          if (entry.type === FormattingElementList.MARKER_ENTRY || this.openElements.contains(entry.element)) {
            unopenIdx++;
            break;
          }
        } while (unopenIdx > 0);
        for (var i = unopenIdx; i < listLength; i++) {
          entry = this.activeFormattingElements.entries[i];
          this._insertElement(entry.token, this.treeAdapter.getNamespaceURI(entry.element));
          entry.element = this.openElements.current;
        }
      }
    }

    //Close elements
  }, {
    key: "_closeTableCell",
    value: function _closeTableCell() {
      this.openElements.generateImpliedEndTags();
      this.openElements.popUntilTableCellPopped();
      this.activeFormattingElements.clearToLastMarker();
      this.insertionMode = IN_ROW_MODE;
    }
  }, {
    key: "_closePElement",
    value: function _closePElement() {
      this.openElements.generateImpliedEndTagsWithExclusion($.P);
      this.openElements.popUntilTagNamePopped($.P);
    }

    //Insertion modes
  }, {
    key: "_resetInsertionMode",
    value: function _resetInsertionMode() {
      for (var i = this.openElements.stackTop, last = false; i >= 0; i--) {
        var element = this.openElements.items[i];
        if (i === 0) {
          last = true;
          if (this.fragmentContext) {
            element = this.fragmentContext;
          }
        }
        var tn = this.treeAdapter.getTagName(element);
        var newInsertionMode = INSERTION_MODE_RESET_MAP[tn];
        if (newInsertionMode) {
          this.insertionMode = newInsertionMode;
          break;
        } else if (!last && (tn === $.TD || tn === $.TH)) {
          this.insertionMode = IN_CELL_MODE;
          break;
        } else if (!last && tn === $.HEAD) {
          this.insertionMode = IN_HEAD_MODE;
          break;
        } else if (tn === $.SELECT) {
          this._resetInsertionModeForSelect(i);
          break;
        } else if (tn === $.TEMPLATE) {
          this.insertionMode = this.currentTmplInsertionMode;
          break;
        } else if (tn === $.HTML) {
          this.insertionMode = this.headElement ? AFTER_HEAD_MODE : BEFORE_HEAD_MODE;
          break;
        } else if (last) {
          this.insertionMode = IN_BODY_MODE;
          break;
        }
      }
    }
  }, {
    key: "_resetInsertionModeForSelect",
    value: function _resetInsertionModeForSelect(selectIdx) {
      if (selectIdx > 0) {
        for (var i = selectIdx - 1; i > 0; i--) {
          var ancestor = this.openElements.items[i];
          var tn = this.treeAdapter.getTagName(ancestor);
          if (tn === $.TEMPLATE) {
            break;
          } else if (tn === $.TABLE) {
            this.insertionMode = IN_SELECT_IN_TABLE_MODE;
            return;
          }
        }
      }
      this.insertionMode = IN_SELECT_MODE;
    }
  }, {
    key: "_pushTmplInsertionMode",
    value: function _pushTmplInsertionMode(mode) {
      this.tmplInsertionModeStack.push(mode);
      this.tmplInsertionModeStackTop++;
      this.currentTmplInsertionMode = mode;
    }
  }, {
    key: "_popTmplInsertionMode",
    value: function _popTmplInsertionMode() {
      this.tmplInsertionModeStack.pop();
      this.tmplInsertionModeStackTop--;
      this.currentTmplInsertionMode = this.tmplInsertionModeStack[this.tmplInsertionModeStackTop];
    }

    //Foster parenting
  }, {
    key: "_isElementCausesFosterParenting",
    value: function _isElementCausesFosterParenting(element) {
      var tn = this.treeAdapter.getTagName(element);
      return tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR;
    }
  }, {
    key: "_shouldFosterParentOnInsertion",
    value: function _shouldFosterParentOnInsertion() {
      return this.fosterParentingEnabled && this._isElementCausesFosterParenting(this.openElements.current);
    }
  }, {
    key: "_findFosterParentingLocation",
    value: function _findFosterParentingLocation() {
      var location = {
        parent: null,
        beforeElement: null
      };
      for (var i = this.openElements.stackTop; i >= 0; i--) {
        var openElement = this.openElements.items[i];
        var tn = this.treeAdapter.getTagName(openElement);
        var ns = this.treeAdapter.getNamespaceURI(openElement);
        if (tn === $.TEMPLATE && ns === NS.HTML) {
          location.parent = this.treeAdapter.getTemplateContent(openElement);
          break;
        } else if (tn === $.TABLE) {
          location.parent = this.treeAdapter.getParentNode(openElement);
          if (location.parent) {
            location.beforeElement = openElement;
          } else {
            location.parent = this.openElements.items[i - 1];
          }
          break;
        }
      }
      if (!location.parent) {
        location.parent = this.openElements.items[0];
      }
      return location;
    }
  }, {
    key: "_fosterParentElement",
    value: function _fosterParentElement(element) {
      var location = this._findFosterParentingLocation();
      if (location.beforeElement) {
        this.treeAdapter.insertBefore(location.parent, element, location.beforeElement);
      } else {
        this.treeAdapter.appendChild(location.parent, element);
      }
    }
  }, {
    key: "_fosterParentText",
    value: function _fosterParentText(chars) {
      var location = this._findFosterParentingLocation();
      if (location.beforeElement) {
        this.treeAdapter.insertTextBefore(location.parent, chars, location.beforeElement);
      } else {
        this.treeAdapter.insertText(location.parent, chars);
      }
    }

    //Special elements
  }, {
    key: "_isSpecialElement",
    value: function _isSpecialElement(element) {
      var tn = this.treeAdapter.getTagName(element);
      var ns = this.treeAdapter.getNamespaceURI(element);
      return HTML.SPECIAL_ELEMENTS[ns][tn];
    }
  }]);
  return Parser;
}();
module.exports = Parser;

//Adoption agency algorithm
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/tree-construction.html#adoptionAgency)
//------------------------------------------------------------------

//Steps 5-8 of the algorithm
function aaObtainFormattingElementEntry(p, token) {
  var formattingElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName(token.tagName);
  if (formattingElementEntry) {
    if (!p.openElements.contains(formattingElementEntry.element)) {
      p.activeFormattingElements.removeEntry(formattingElementEntry);
      formattingElementEntry = null;
    } else if (!p.openElements.hasInScope(token.tagName)) {
      formattingElementEntry = null;
    }
  } else {
    genericEndTagInBody(p, token);
  }
  return formattingElementEntry;
}

//Steps 9 and 10 of the algorithm
function aaObtainFurthestBlock(p, formattingElementEntry) {
  var furthestBlock = null;
  for (var i = p.openElements.stackTop; i >= 0; i--) {
    var element = p.openElements.items[i];
    if (element === formattingElementEntry.element) {
      break;
    }
    if (p._isSpecialElement(element)) {
      furthestBlock = element;
    }
  }
  if (!furthestBlock) {
    p.openElements.popUntilElementPopped(formattingElementEntry.element);
    p.activeFormattingElements.removeEntry(formattingElementEntry);
  }
  return furthestBlock;
}

//Step 13 of the algorithm
function aaInnerLoop(p, furthestBlock, formattingElement) {
  var lastElement = furthestBlock;
  var nextElement = p.openElements.getCommonAncestor(furthestBlock);
  for (var i = 0, element = nextElement; element !== formattingElement; i++, element = nextElement) {
    //NOTE: store next element for the next loop iteration (it may be deleted from the stack by step 9.5)
    nextElement = p.openElements.getCommonAncestor(element);
    var elementEntry = p.activeFormattingElements.getElementEntry(element);
    var counterOverflow = elementEntry && i >= AA_INNER_LOOP_ITER;
    var shouldRemoveFromOpenElements = !elementEntry || counterOverflow;
    if (shouldRemoveFromOpenElements) {
      if (counterOverflow) {
        p.activeFormattingElements.removeEntry(elementEntry);
      }
      p.openElements.remove(element);
    } else {
      element = aaRecreateElementFromEntry(p, elementEntry);
      if (lastElement === furthestBlock) {
        p.activeFormattingElements.bookmark = elementEntry;
      }
      p.treeAdapter.detachNode(lastElement);
      p.treeAdapter.appendChild(element, lastElement);
      lastElement = element;
    }
  }
  return lastElement;
}

//Step 13.7 of the algorithm
function aaRecreateElementFromEntry(p, elementEntry) {
  var ns = p.treeAdapter.getNamespaceURI(elementEntry.element);
  var newElement = p.treeAdapter.createElement(elementEntry.token.tagName, ns, elementEntry.token.attrs);
  p.openElements.replace(elementEntry.element, newElement);
  elementEntry.element = newElement;
  return newElement;
}

//Step 14 of the algorithm
function aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement) {
  if (p._isElementCausesFosterParenting(commonAncestor)) {
    p._fosterParentElement(lastElement);
  } else {
    var tn = p.treeAdapter.getTagName(commonAncestor);
    var ns = p.treeAdapter.getNamespaceURI(commonAncestor);
    if (tn === $.TEMPLATE && ns === NS.HTML) {
      commonAncestor = p.treeAdapter.getTemplateContent(commonAncestor);
    }
    p.treeAdapter.appendChild(commonAncestor, lastElement);
  }
}

//Steps 15-19 of the algorithm
function aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry) {
  var ns = p.treeAdapter.getNamespaceURI(formattingElementEntry.element);
  var token = formattingElementEntry.token;
  var newElement = p.treeAdapter.createElement(token.tagName, ns, token.attrs);
  p._adoptNodes(furthestBlock, newElement);
  p.treeAdapter.appendChild(furthestBlock, newElement);
  p.activeFormattingElements.insertElementAfterBookmark(newElement, formattingElementEntry.token);
  p.activeFormattingElements.removeEntry(formattingElementEntry);
  p.openElements.remove(formattingElementEntry.element);
  p.openElements.insertAfter(furthestBlock, newElement);
}

//Algorithm entry point
function callAdoptionAgency(p, token) {
  var formattingElementEntry;
  for (var i = 0; i < AA_OUTER_LOOP_ITER; i++) {
    formattingElementEntry = aaObtainFormattingElementEntry(p, token, formattingElementEntry);
    if (!formattingElementEntry) {
      break;
    }
    var furthestBlock = aaObtainFurthestBlock(p, formattingElementEntry);
    if (!furthestBlock) {
      break;
    }
    p.activeFormattingElements.bookmark = formattingElementEntry;
    var lastElement = aaInnerLoop(p, furthestBlock, formattingElementEntry.element);
    var commonAncestor = p.openElements.getCommonAncestor(formattingElementEntry.element);
    p.treeAdapter.detachNode(lastElement);
    aaInsertLastNodeInCommonAncestor(p, commonAncestor, lastElement);
    aaReplaceFormattingElement(p, furthestBlock, formattingElementEntry);
  }
}

//Generic token handlers
//------------------------------------------------------------------
function ignoreToken() {
  //NOTE: do nothing =)
}
function misplacedDoctype(p) {
  p._err(ERR.misplacedDoctype);
}
function appendComment(p, token) {
  p._appendCommentNode(token, p.openElements.currentTmplContent || p.openElements.current);
}
function appendCommentToRootHtmlElement(p, token) {
  p._appendCommentNode(token, p.openElements.items[0]);
}
function appendCommentToDocument(p, token) {
  p._appendCommentNode(token, p.document);
}
function insertCharacters(p, token) {
  p._insertCharacters(token);
}
function stopParsing(p) {
  p.stopped = true;
}

// The "initial" insertion mode
//------------------------------------------------------------------
function doctypeInInitialMode(p, token) {
  p._setDocumentType(token);
  var mode = token.forceQuirks ? HTML.DOCUMENT_MODE.QUIRKS : doctype.getDocumentMode(token);
  if (!doctype.isConforming(token)) {
    p._err(ERR.nonConformingDoctype);
  }
  p.treeAdapter.setDocumentMode(p.document, mode);
  p.insertionMode = BEFORE_HTML_MODE;
}
function tokenInInitialMode(p, token) {
  p._err(ERR.missingDoctype, {
    beforeToken: true
  });
  p.treeAdapter.setDocumentMode(p.document, HTML.DOCUMENT_MODE.QUIRKS);
  p.insertionMode = BEFORE_HTML_MODE;
  p._processToken(token);
}

// The "before html" insertion mode
//------------------------------------------------------------------
function startTagBeforeHtml(p, token) {
  if (token.tagName === $.HTML) {
    p._insertElement(token, NS.HTML);
    p.insertionMode = BEFORE_HEAD_MODE;
  } else {
    tokenBeforeHtml(p, token);
  }
}
function endTagBeforeHtml(p, token) {
  var tn = token.tagName;
  if (tn === $.HTML || tn === $.HEAD || tn === $.BODY || tn === $.BR) {
    tokenBeforeHtml(p, token);
  }
}
function tokenBeforeHtml(p, token) {
  p._insertFakeRootElement();
  p.insertionMode = BEFORE_HEAD_MODE;
  p._processToken(token);
}

// The "before head" insertion mode
//------------------------------------------------------------------
function startTagBeforeHead(p, token) {
  var tn = token.tagName;
  if (tn === $.HTML) {
    startTagInBody(p, token);
  } else if (tn === $.HEAD) {
    p._insertElement(token, NS.HTML);
    p.headElement = p.openElements.current;
    p.insertionMode = IN_HEAD_MODE;
  } else {
    tokenBeforeHead(p, token);
  }
}
function endTagBeforeHead(p, token) {
  var tn = token.tagName;
  if (tn === $.HEAD || tn === $.BODY || tn === $.HTML || tn === $.BR) {
    tokenBeforeHead(p, token);
  } else {
    p._err(ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenBeforeHead(p, token) {
  p._insertFakeElement($.HEAD);
  p.headElement = p.openElements.current;
  p.insertionMode = IN_HEAD_MODE;
  p._processToken(token);
}

// The "in head" insertion mode
//------------------------------------------------------------------
function startTagInHead(p, token) {
  var tn = token.tagName;
  if (tn === $.HTML) {
    startTagInBody(p, token);
  } else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META) {
    p._appendElement(token, NS.HTML);
    token.ackSelfClosing = true;
  } else if (tn === $.TITLE) {
    p._switchToTextParsing(token, Tokenizer.MODE.RCDATA);
  } else if (tn === $.NOSCRIPT) {
    if (p.options.scriptingEnabled) {
      p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
    } else {
      p._insertElement(token, NS.HTML);
      p.insertionMode = IN_HEAD_NO_SCRIPT_MODE;
    }
  } else if (tn === $.NOFRAMES || tn === $.STYLE) {
    p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
  } else if (tn === $.SCRIPT) {
    p._switchToTextParsing(token, Tokenizer.MODE.SCRIPT_DATA);
  } else if (tn === $.TEMPLATE) {
    p._insertTemplate(token, NS.HTML);
    p.activeFormattingElements.insertMarker();
    p.framesetOk = false;
    p.insertionMode = IN_TEMPLATE_MODE;
    p._pushTmplInsertionMode(IN_TEMPLATE_MODE);
  } else if (tn === $.HEAD) {
    p._err(ERR.misplacedStartTagForHeadElement);
  } else {
    tokenInHead(p, token);
  }
}
function endTagInHead(p, token) {
  var tn = token.tagName;
  if (tn === $.HEAD) {
    p.openElements.pop();
    p.insertionMode = AFTER_HEAD_MODE;
  } else if (tn === $.BODY || tn === $.BR || tn === $.HTML) {
    tokenInHead(p, token);
  } else if (tn === $.TEMPLATE) {
    if (p.openElements.tmplCount > 0) {
      p.openElements.generateImpliedEndTagsThoroughly();
      if (p.openElements.currentTagName !== $.TEMPLATE) {
        p._err(ERR.closingOfElementWithOpenChildElements);
      }
      p.openElements.popUntilTagNamePopped($.TEMPLATE);
      p.activeFormattingElements.clearToLastMarker();
      p._popTmplInsertionMode();
      p._resetInsertionMode();
    } else {
      p._err(ERR.endTagWithoutMatchingOpenElement);
    }
  } else {
    p._err(ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenInHead(p, token) {
  p.openElements.pop();
  p.insertionMode = AFTER_HEAD_MODE;
  p._processToken(token);
}

// The "in head no script" insertion mode
//------------------------------------------------------------------
function startTagInHeadNoScript(p, token) {
  var tn = token.tagName;
  if (tn === $.HTML) {
    startTagInBody(p, token);
  } else if (tn === $.BASEFONT || tn === $.BGSOUND || tn === $.HEAD || tn === $.LINK || tn === $.META || tn === $.NOFRAMES || tn === $.STYLE) {
    startTagInHead(p, token);
  } else if (tn === $.NOSCRIPT) {
    p._err(ERR.nestedNoscriptInHead);
  } else {
    tokenInHeadNoScript(p, token);
  }
}
function endTagInHeadNoScript(p, token) {
  var tn = token.tagName;
  if (tn === $.NOSCRIPT) {
    p.openElements.pop();
    p.insertionMode = IN_HEAD_MODE;
  } else if (tn === $.BR) {
    tokenInHeadNoScript(p, token);
  } else {
    p._err(ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenInHeadNoScript(p, token) {
  var errCode = token.type === Tokenizer.EOF_TOKEN ? ERR.openElementsLeftAfterEof : ERR.disallowedContentInNoscriptInHead;
  p._err(errCode);
  p.openElements.pop();
  p.insertionMode = IN_HEAD_MODE;
  p._processToken(token);
}

// The "after head" insertion mode
//------------------------------------------------------------------
function startTagAfterHead(p, token) {
  var tn = token.tagName;
  if (tn === $.HTML) {
    startTagInBody(p, token);
  } else if (tn === $.BODY) {
    p._insertElement(token, NS.HTML);
    p.framesetOk = false;
    p.insertionMode = IN_BODY_MODE;
  } else if (tn === $.FRAMESET) {
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_FRAMESET_MODE;
  } else if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META || tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE) {
    p._err(ERR.abandonedHeadElementChild);
    p.openElements.push(p.headElement);
    startTagInHead(p, token);
    p.openElements.remove(p.headElement);
  } else if (tn === $.HEAD) {
    p._err(ERR.misplacedStartTagForHeadElement);
  } else {
    tokenAfterHead(p, token);
  }
}
function endTagAfterHead(p, token) {
  var tn = token.tagName;
  if (tn === $.BODY || tn === $.HTML || tn === $.BR) {
    tokenAfterHead(p, token);
  } else if (tn === $.TEMPLATE) {
    endTagInHead(p, token);
  } else {
    p._err(ERR.endTagWithoutMatchingOpenElement);
  }
}
function tokenAfterHead(p, token) {
  p._insertFakeElement($.BODY);
  p.insertionMode = IN_BODY_MODE;
  p._processToken(token);
}

// The "in body" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._insertCharacters(token);
}
function characterInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._insertCharacters(token);
  p.framesetOk = false;
}
function htmlStartTagInBody(p, token) {
  if (p.openElements.tmplCount === 0) {
    p.treeAdapter.adoptAttributes(p.openElements.items[0], token.attrs);
  }
}
function bodyStartTagInBody(p, token) {
  var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
  if (bodyElement && p.openElements.tmplCount === 0) {
    p.framesetOk = false;
    p.treeAdapter.adoptAttributes(bodyElement, token.attrs);
  }
}
function framesetStartTagInBody(p, token) {
  var bodyElement = p.openElements.tryPeekProperlyNestedBodyElement();
  if (p.framesetOk && bodyElement) {
    p.treeAdapter.detachNode(bodyElement);
    p.openElements.popAllUpToHtmlElement();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_FRAMESET_MODE;
  }
}
function addressStartTagInBody(p, token) {
  if (p.openElements.hasInButtonScope($.P)) {
    p._closePElement();
  }
  p._insertElement(token, NS.HTML);
}
function numberedHeaderStartTagInBody(p, token) {
  if (p.openElements.hasInButtonScope($.P)) {
    p._closePElement();
  }
  var tn = p.openElements.currentTagName;
  if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) {
    p.openElements.pop();
  }
  p._insertElement(token, NS.HTML);
}
function preStartTagInBody(p, token) {
  if (p.openElements.hasInButtonScope($.P)) {
    p._closePElement();
  }
  p._insertElement(token, NS.HTML);
  //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
  //on to the next one. (Newlines at the start of pre blocks are ignored as an authoring convenience.)
  p.skipNextNewLine = true;
  p.framesetOk = false;
}
function formStartTagInBody(p, token) {
  var inTemplate = p.openElements.tmplCount > 0;
  if (!p.formElement || inTemplate) {
    if (p.openElements.hasInButtonScope($.P)) {
      p._closePElement();
    }
    p._insertElement(token, NS.HTML);
    if (!inTemplate) {
      p.formElement = p.openElements.current;
    }
  }
}
function listItemStartTagInBody(p, token) {
  p.framesetOk = false;
  var tn = token.tagName;
  for (var i = p.openElements.stackTop; i >= 0; i--) {
    var element = p.openElements.items[i];
    var elementTn = p.treeAdapter.getTagName(element);
    var closeTn = null;
    if (tn === $.LI && elementTn === $.LI) {
      closeTn = $.LI;
    } else if ((tn === $.DD || tn === $.DT) && (elementTn === $.DD || elementTn === $.DT)) {
      closeTn = elementTn;
    }
    if (closeTn) {
      p.openElements.generateImpliedEndTagsWithExclusion(closeTn);
      p.openElements.popUntilTagNamePopped(closeTn);
      break;
    }
    if (elementTn !== $.ADDRESS && elementTn !== $.DIV && elementTn !== $.P && p._isSpecialElement(element)) {
      break;
    }
  }
  if (p.openElements.hasInButtonScope($.P)) {
    p._closePElement();
  }
  p._insertElement(token, NS.HTML);
}
function plaintextStartTagInBody(p, token) {
  if (p.openElements.hasInButtonScope($.P)) {
    p._closePElement();
  }
  p._insertElement(token, NS.HTML);
  p.tokenizer.state = Tokenizer.MODE.PLAINTEXT;
}
function buttonStartTagInBody(p, token) {
  if (p.openElements.hasInScope($.BUTTON)) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilTagNamePopped($.BUTTON);
  }
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
  p.framesetOk = false;
}
function aStartTagInBody(p, token) {
  var activeElementEntry = p.activeFormattingElements.getElementEntryInScopeWithTagName($.A);
  if (activeElementEntry) {
    callAdoptionAgency(p, token);
    p.openElements.remove(activeElementEntry.element);
    p.activeFormattingElements.removeEntry(activeElementEntry);
  }
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
  p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function bStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
  p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function nobrStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  if (p.openElements.hasInScope($.NOBR)) {
    callAdoptionAgency(p, token);
    p._reconstructActiveFormattingElements();
  }
  p._insertElement(token, NS.HTML);
  p.activeFormattingElements.pushElement(p.openElements.current, token);
}
function appletStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
  p.activeFormattingElements.insertMarker();
  p.framesetOk = false;
}
function tableStartTagInBody(p, token) {
  if (p.treeAdapter.getDocumentMode(p.document) !== HTML.DOCUMENT_MODE.QUIRKS && p.openElements.hasInButtonScope($.P)) {
    p._closePElement();
  }
  p._insertElement(token, NS.HTML);
  p.framesetOk = false;
  p.insertionMode = IN_TABLE_MODE;
}
function areaStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._appendElement(token, NS.HTML);
  p.framesetOk = false;
  token.ackSelfClosing = true;
}
function inputStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._appendElement(token, NS.HTML);
  var inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);
  if (!inputType || inputType.toLowerCase() !== HIDDEN_INPUT_TYPE) {
    p.framesetOk = false;
  }
  token.ackSelfClosing = true;
}
function paramStartTagInBody(p, token) {
  p._appendElement(token, NS.HTML);
  token.ackSelfClosing = true;
}
function hrStartTagInBody(p, token) {
  if (p.openElements.hasInButtonScope($.P)) {
    p._closePElement();
  }
  p._appendElement(token, NS.HTML);
  p.framesetOk = false;
  token.ackSelfClosing = true;
}
function imageStartTagInBody(p, token) {
  token.tagName = $.IMG;
  areaStartTagInBody(p, token);
}
function textareaStartTagInBody(p, token) {
  p._insertElement(token, NS.HTML);
  //NOTE: If the next token is a U+000A LINE FEED (LF) character token, then ignore that token and move
  //on to the next one. (Newlines at the start of textarea elements are ignored as an authoring convenience.)
  p.skipNextNewLine = true;
  p.tokenizer.state = Tokenizer.MODE.RCDATA;
  p.originalInsertionMode = p.insertionMode;
  p.framesetOk = false;
  p.insertionMode = TEXT_MODE;
}
function xmpStartTagInBody(p, token) {
  if (p.openElements.hasInButtonScope($.P)) {
    p._closePElement();
  }
  p._reconstructActiveFormattingElements();
  p.framesetOk = false;
  p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}
function iframeStartTagInBody(p, token) {
  p.framesetOk = false;
  p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}

//NOTE: here we assume that we always act as an user agent with enabled plugins, so we parse
//<noembed> as a rawtext.
function noembedStartTagInBody(p, token) {
  p._switchToTextParsing(token, Tokenizer.MODE.RAWTEXT);
}
function selectStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
  p.framesetOk = false;
  if (p.insertionMode === IN_TABLE_MODE || p.insertionMode === IN_CAPTION_MODE || p.insertionMode === IN_TABLE_BODY_MODE || p.insertionMode === IN_ROW_MODE || p.insertionMode === IN_CELL_MODE) {
    p.insertionMode = IN_SELECT_IN_TABLE_MODE;
  } else {
    p.insertionMode = IN_SELECT_MODE;
  }
}
function optgroupStartTagInBody(p, token) {
  if (p.openElements.currentTagName === $.OPTION) {
    p.openElements.pop();
  }
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
}
function rbStartTagInBody(p, token) {
  if (p.openElements.hasInScope($.RUBY)) {
    p.openElements.generateImpliedEndTags();
  }
  p._insertElement(token, NS.HTML);
}
function rtStartTagInBody(p, token) {
  if (p.openElements.hasInScope($.RUBY)) {
    p.openElements.generateImpliedEndTagsWithExclusion($.RTC);
  }
  p._insertElement(token, NS.HTML);
}
function menuStartTagInBody(p, token) {
  if (p.openElements.hasInButtonScope($.P)) {
    p._closePElement();
  }
  p._insertElement(token, NS.HTML);
}
function mathStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  foreignContent.adjustTokenMathMLAttrs(token);
  foreignContent.adjustTokenXMLAttrs(token);
  if (token.selfClosing) {
    p._appendElement(token, NS.MATHML);
  } else {
    p._insertElement(token, NS.MATHML);
  }
  token.ackSelfClosing = true;
}
function svgStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  foreignContent.adjustTokenSVGAttrs(token);
  foreignContent.adjustTokenXMLAttrs(token);
  if (token.selfClosing) {
    p._appendElement(token, NS.SVG);
  } else {
    p._insertElement(token, NS.SVG);
  }
  token.ackSelfClosing = true;
}
function genericStartTagInBody(p, token) {
  p._reconstructActiveFormattingElements();
  p._insertElement(token, NS.HTML);
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function startTagInBody(p, token) {
  var tn = token.tagName;
  switch (tn.length) {
    case 1:
      if (tn === $.I || tn === $.S || tn === $.B || tn === $.U) {
        bStartTagInBody(p, token);
      } else if (tn === $.P) {
        addressStartTagInBody(p, token);
      } else if (tn === $.A) {
        aStartTagInBody(p, token);
      } else {
        genericStartTagInBody(p, token);
      }
      break;
    case 2:
      if (tn === $.DL || tn === $.OL || tn === $.UL) {
        addressStartTagInBody(p, token);
      } else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) {
        numberedHeaderStartTagInBody(p, token);
      } else if (tn === $.LI || tn === $.DD || tn === $.DT) {
        listItemStartTagInBody(p, token);
      } else if (tn === $.EM || tn === $.TT) {
        bStartTagInBody(p, token);
      } else if (tn === $.BR) {
        areaStartTagInBody(p, token);
      } else if (tn === $.HR) {
        hrStartTagInBody(p, token);
      } else if (tn === $.RB) {
        rbStartTagInBody(p, token);
      } else if (tn === $.RT || tn === $.RP) {
        rtStartTagInBody(p, token);
      } else if (tn !== $.TH && tn !== $.TD && tn !== $.TR) {
        genericStartTagInBody(p, token);
      }
      break;
    case 3:
      if (tn === $.DIV || tn === $.DIR || tn === $.NAV) {
        addressStartTagInBody(p, token);
      } else if (tn === $.PRE) {
        preStartTagInBody(p, token);
      } else if (tn === $.BIG) {
        bStartTagInBody(p, token);
      } else if (tn === $.IMG || tn === $.WBR) {
        areaStartTagInBody(p, token);
      } else if (tn === $.XMP) {
        xmpStartTagInBody(p, token);
      } else if (tn === $.SVG) {
        svgStartTagInBody(p, token);
      } else if (tn === $.RTC) {
        rbStartTagInBody(p, token);
      } else if (tn !== $.COL) {
        genericStartTagInBody(p, token);
      }
      break;
    case 4:
      if (tn === $.HTML) {
        htmlStartTagInBody(p, token);
      } else if (tn === $.BASE || tn === $.LINK || tn === $.META) {
        startTagInHead(p, token);
      } else if (tn === $.BODY) {
        bodyStartTagInBody(p, token);
      } else if (tn === $.MAIN || tn === $.MENU) {
        addressStartTagInBody(p, token);
      } else if (tn === $.FORM) {
        formStartTagInBody(p, token);
      } else if (tn === $.CODE || tn === $.FONT) {
        bStartTagInBody(p, token);
      } else if (tn === $.NOBR) {
        nobrStartTagInBody(p, token);
      } else if (tn === $.AREA) {
        areaStartTagInBody(p, token);
      } else if (tn === $.MATH) {
        mathStartTagInBody(p, token);
      } else if (tn === $.MENU) {
        menuStartTagInBody(p, token);
      } else if (tn !== $.HEAD) {
        genericStartTagInBody(p, token);
      }
      break;
    case 5:
      if (tn === $.STYLE || tn === $.TITLE) {
        startTagInHead(p, token);
      } else if (tn === $.ASIDE) {
        addressStartTagInBody(p, token);
      } else if (tn === $.SMALL) {
        bStartTagInBody(p, token);
      } else if (tn === $.TABLE) {
        tableStartTagInBody(p, token);
      } else if (tn === $.EMBED) {
        areaStartTagInBody(p, token);
      } else if (tn === $.INPUT) {
        inputStartTagInBody(p, token);
      } else if (tn === $.PARAM || tn === $.TRACK) {
        paramStartTagInBody(p, token);
      } else if (tn === $.IMAGE) {
        imageStartTagInBody(p, token);
      } else if (tn !== $.FRAME && tn !== $.TBODY && tn !== $.TFOOT && tn !== $.THEAD) {
        genericStartTagInBody(p, token);
      }
      break;
    case 6:
      if (tn === $.SCRIPT) {
        startTagInHead(p, token);
      } else if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP || tn === $.DIALOG) {
        addressStartTagInBody(p, token);
      } else if (tn === $.BUTTON) {
        buttonStartTagInBody(p, token);
      } else if (tn === $.STRIKE || tn === $.STRONG) {
        bStartTagInBody(p, token);
      } else if (tn === $.APPLET || tn === $.OBJECT) {
        appletStartTagInBody(p, token);
      } else if (tn === $.KEYGEN) {
        areaStartTagInBody(p, token);
      } else if (tn === $.SOURCE) {
        paramStartTagInBody(p, token);
      } else if (tn === $.IFRAME) {
        iframeStartTagInBody(p, token);
      } else if (tn === $.SELECT) {
        selectStartTagInBody(p, token);
      } else if (tn === $.OPTION) {
        optgroupStartTagInBody(p, token);
      } else {
        genericStartTagInBody(p, token);
      }
      break;
    case 7:
      if (tn === $.BGSOUND) {
        startTagInHead(p, token);
      } else if (tn === $.DETAILS || tn === $.ADDRESS || tn === $.ARTICLE || tn === $.SECTION || tn === $.SUMMARY) {
        addressStartTagInBody(p, token);
      } else if (tn === $.LISTING) {
        preStartTagInBody(p, token);
      } else if (tn === $.MARQUEE) {
        appletStartTagInBody(p, token);
      } else if (tn === $.NOEMBED) {
        noembedStartTagInBody(p, token);
      } else if (tn !== $.CAPTION) {
        genericStartTagInBody(p, token);
      }
      break;
    case 8:
      if (tn === $.BASEFONT) {
        startTagInHead(p, token);
      } else if (tn === $.FRAMESET) {
        framesetStartTagInBody(p, token);
      } else if (tn === $.FIELDSET) {
        addressStartTagInBody(p, token);
      } else if (tn === $.TEXTAREA) {
        textareaStartTagInBody(p, token);
      } else if (tn === $.TEMPLATE) {
        startTagInHead(p, token);
      } else if (tn === $.NOSCRIPT) {
        if (p.options.scriptingEnabled) {
          noembedStartTagInBody(p, token);
        } else {
          genericStartTagInBody(p, token);
        }
      } else if (tn === $.OPTGROUP) {
        optgroupStartTagInBody(p, token);
      } else if (tn !== $.COLGROUP) {
        genericStartTagInBody(p, token);
      }
      break;
    case 9:
      if (tn === $.PLAINTEXT) {
        plaintextStartTagInBody(p, token);
      } else {
        genericStartTagInBody(p, token);
      }
      break;
    case 10:
      if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION) {
        addressStartTagInBody(p, token);
      } else {
        genericStartTagInBody(p, token);
      }
      break;
    default:
      genericStartTagInBody(p, token);
  }
}
function bodyEndTagInBody(p) {
  if (p.openElements.hasInScope($.BODY)) {
    p.insertionMode = AFTER_BODY_MODE;
  }
}
function htmlEndTagInBody(p, token) {
  if (p.openElements.hasInScope($.BODY)) {
    p.insertionMode = AFTER_BODY_MODE;
    p._processToken(token);
  }
}
function addressEndTagInBody(p, token) {
  var tn = token.tagName;
  if (p.openElements.hasInScope(tn)) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilTagNamePopped(tn);
  }
}
function formEndTagInBody(p) {
  var inTemplate = p.openElements.tmplCount > 0;
  var formElement = p.formElement;
  if (!inTemplate) {
    p.formElement = null;
  }
  if ((formElement || inTemplate) && p.openElements.hasInScope($.FORM)) {
    p.openElements.generateImpliedEndTags();
    if (inTemplate) {
      p.openElements.popUntilTagNamePopped($.FORM);
    } else {
      p.openElements.remove(formElement);
    }
  }
}
function pEndTagInBody(p) {
  if (!p.openElements.hasInButtonScope($.P)) {
    p._insertFakeElement($.P);
  }
  p._closePElement();
}
function liEndTagInBody(p) {
  if (p.openElements.hasInListItemScope($.LI)) {
    p.openElements.generateImpliedEndTagsWithExclusion($.LI);
    p.openElements.popUntilTagNamePopped($.LI);
  }
}
function ddEndTagInBody(p, token) {
  var tn = token.tagName;
  if (p.openElements.hasInScope(tn)) {
    p.openElements.generateImpliedEndTagsWithExclusion(tn);
    p.openElements.popUntilTagNamePopped(tn);
  }
}
function numberedHeaderEndTagInBody(p) {
  if (p.openElements.hasNumberedHeaderInScope()) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilNumberedHeaderPopped();
  }
}
function appletEndTagInBody(p, token) {
  var tn = token.tagName;
  if (p.openElements.hasInScope(tn)) {
    p.openElements.generateImpliedEndTags();
    p.openElements.popUntilTagNamePopped(tn);
    p.activeFormattingElements.clearToLastMarker();
  }
}
function brEndTagInBody(p) {
  p._reconstructActiveFormattingElements();
  p._insertFakeElement($.BR);
  p.openElements.pop();
  p.framesetOk = false;
}
function genericEndTagInBody(p, token) {
  var tn = token.tagName;
  for (var i = p.openElements.stackTop; i > 0; i--) {
    var element = p.openElements.items[i];
    if (p.treeAdapter.getTagName(element) === tn) {
      p.openElements.generateImpliedEndTagsWithExclusion(tn);
      p.openElements.popUntilElementPopped(element);
      break;
    }
    if (p._isSpecialElement(element)) {
      break;
    }
  }
}

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function endTagInBody(p, token) {
  var tn = token.tagName;
  switch (tn.length) {
    case 1:
      if (tn === $.A || tn === $.B || tn === $.I || tn === $.S || tn === $.U) {
        callAdoptionAgency(p, token);
      } else if (tn === $.P) {
        pEndTagInBody(p, token);
      } else {
        genericEndTagInBody(p, token);
      }
      break;
    case 2:
      if (tn === $.DL || tn === $.UL || tn === $.OL) {
        addressEndTagInBody(p, token);
      } else if (tn === $.LI) {
        liEndTagInBody(p, token);
      } else if (tn === $.DD || tn === $.DT) {
        ddEndTagInBody(p, token);
      } else if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) {
        numberedHeaderEndTagInBody(p, token);
      } else if (tn === $.BR) {
        brEndTagInBody(p, token);
      } else if (tn === $.EM || tn === $.TT) {
        callAdoptionAgency(p, token);
      } else {
        genericEndTagInBody(p, token);
      }
      break;
    case 3:
      if (tn === $.BIG) {
        callAdoptionAgency(p, token);
      } else if (tn === $.DIR || tn === $.DIV || tn === $.NAV || tn === $.PRE) {
        addressEndTagInBody(p, token);
      } else {
        genericEndTagInBody(p, token);
      }
      break;
    case 4:
      if (tn === $.BODY) {
        bodyEndTagInBody(p, token);
      } else if (tn === $.HTML) {
        htmlEndTagInBody(p, token);
      } else if (tn === $.FORM) {
        formEndTagInBody(p, token);
      } else if (tn === $.CODE || tn === $.FONT || tn === $.NOBR) {
        callAdoptionAgency(p, token);
      } else if (tn === $.MAIN || tn === $.MENU) {
        addressEndTagInBody(p, token);
      } else {
        genericEndTagInBody(p, token);
      }
      break;
    case 5:
      if (tn === $.ASIDE) {
        addressEndTagInBody(p, token);
      } else if (tn === $.SMALL) {
        callAdoptionAgency(p, token);
      } else {
        genericEndTagInBody(p, token);
      }
      break;
    case 6:
      if (tn === $.CENTER || tn === $.FIGURE || tn === $.FOOTER || tn === $.HEADER || tn === $.HGROUP || tn === $.DIALOG) {
        addressEndTagInBody(p, token);
      } else if (tn === $.APPLET || tn === $.OBJECT) {
        appletEndTagInBody(p, token);
      } else if (tn === $.STRIKE || tn === $.STRONG) {
        callAdoptionAgency(p, token);
      } else {
        genericEndTagInBody(p, token);
      }
      break;
    case 7:
      if (tn === $.ADDRESS || tn === $.ARTICLE || tn === $.DETAILS || tn === $.SECTION || tn === $.SUMMARY || tn === $.LISTING) {
        addressEndTagInBody(p, token);
      } else if (tn === $.MARQUEE) {
        appletEndTagInBody(p, token);
      } else {
        genericEndTagInBody(p, token);
      }
      break;
    case 8:
      if (tn === $.FIELDSET) {
        addressEndTagInBody(p, token);
      } else if (tn === $.TEMPLATE) {
        endTagInHead(p, token);
      } else {
        genericEndTagInBody(p, token);
      }
      break;
    case 10:
      if (tn === $.BLOCKQUOTE || tn === $.FIGCAPTION) {
        addressEndTagInBody(p, token);
      } else {
        genericEndTagInBody(p, token);
      }
      break;
    default:
      genericEndTagInBody(p, token);
  }
}
function eofInBody(p, token) {
  if (p.tmplInsertionModeStackTop > -1) {
    eofInTemplate(p, token);
  } else {
    p.stopped = true;
  }
}

// The "text" insertion mode
//------------------------------------------------------------------
function endTagInText(p, token) {
  if (token.tagName === $.SCRIPT) {
    p.pendingScript = p.openElements.current;
  }
  p.openElements.pop();
  p.insertionMode = p.originalInsertionMode;
}
function eofInText(p, token) {
  p._err(ERR.eofInElementThatCanContainOnlyText);
  p.openElements.pop();
  p.insertionMode = p.originalInsertionMode;
  p._processToken(token);
}

// The "in table" insertion mode
//------------------------------------------------------------------
function characterInTable(p, token) {
  var curTn = p.openElements.currentTagName;
  if (curTn === $.TABLE || curTn === $.TBODY || curTn === $.TFOOT || curTn === $.THEAD || curTn === $.TR) {
    p.pendingCharacterTokens = [];
    p.hasNonWhitespacePendingCharacterToken = false;
    p.originalInsertionMode = p.insertionMode;
    p.insertionMode = IN_TABLE_TEXT_MODE;
    p._processToken(token);
  } else {
    tokenInTable(p, token);
  }
}
function captionStartTagInTable(p, token) {
  p.openElements.clearBackToTableContext();
  p.activeFormattingElements.insertMarker();
  p._insertElement(token, NS.HTML);
  p.insertionMode = IN_CAPTION_MODE;
}
function colgroupStartTagInTable(p, token) {
  p.openElements.clearBackToTableContext();
  p._insertElement(token, NS.HTML);
  p.insertionMode = IN_COLUMN_GROUP_MODE;
}
function colStartTagInTable(p, token) {
  p.openElements.clearBackToTableContext();
  p._insertFakeElement($.COLGROUP);
  p.insertionMode = IN_COLUMN_GROUP_MODE;
  p._processToken(token);
}
function tbodyStartTagInTable(p, token) {
  p.openElements.clearBackToTableContext();
  p._insertElement(token, NS.HTML);
  p.insertionMode = IN_TABLE_BODY_MODE;
}
function tdStartTagInTable(p, token) {
  p.openElements.clearBackToTableContext();
  p._insertFakeElement($.TBODY);
  p.insertionMode = IN_TABLE_BODY_MODE;
  p._processToken(token);
}
function tableStartTagInTable(p, token) {
  if (p.openElements.hasInTableScope($.TABLE)) {
    p.openElements.popUntilTagNamePopped($.TABLE);
    p._resetInsertionMode();
    p._processToken(token);
  }
}
function inputStartTagInTable(p, token) {
  var inputType = Tokenizer.getTokenAttr(token, ATTRS.TYPE);
  if (inputType && inputType.toLowerCase() === HIDDEN_INPUT_TYPE) {
    p._appendElement(token, NS.HTML);
  } else {
    tokenInTable(p, token);
  }
  token.ackSelfClosing = true;
}
function formStartTagInTable(p, token) {
  if (!p.formElement && p.openElements.tmplCount === 0) {
    p._insertElement(token, NS.HTML);
    p.formElement = p.openElements.current;
    p.openElements.pop();
  }
}
function startTagInTable(p, token) {
  var tn = token.tagName;
  switch (tn.length) {
    case 2:
      if (tn === $.TD || tn === $.TH || tn === $.TR) {
        tdStartTagInTable(p, token);
      } else {
        tokenInTable(p, token);
      }
      break;
    case 3:
      if (tn === $.COL) {
        colStartTagInTable(p, token);
      } else {
        tokenInTable(p, token);
      }
      break;
    case 4:
      if (tn === $.FORM) {
        formStartTagInTable(p, token);
      } else {
        tokenInTable(p, token);
      }
      break;
    case 5:
      if (tn === $.TABLE) {
        tableStartTagInTable(p, token);
      } else if (tn === $.STYLE) {
        startTagInHead(p, token);
      } else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
        tbodyStartTagInTable(p, token);
      } else if (tn === $.INPUT) {
        inputStartTagInTable(p, token);
      } else {
        tokenInTable(p, token);
      }
      break;
    case 6:
      if (tn === $.SCRIPT) {
        startTagInHead(p, token);
      } else {
        tokenInTable(p, token);
      }
      break;
    case 7:
      if (tn === $.CAPTION) {
        captionStartTagInTable(p, token);
      } else {
        tokenInTable(p, token);
      }
      break;
    case 8:
      if (tn === $.COLGROUP) {
        colgroupStartTagInTable(p, token);
      } else if (tn === $.TEMPLATE) {
        startTagInHead(p, token);
      } else {
        tokenInTable(p, token);
      }
      break;
    default:
      tokenInTable(p, token);
  }
}
function endTagInTable(p, token) {
  var tn = token.tagName;
  if (tn === $.TABLE) {
    if (p.openElements.hasInTableScope($.TABLE)) {
      p.openElements.popUntilTagNamePopped($.TABLE);
      p._resetInsertionMode();
    }
  } else if (tn === $.TEMPLATE) {
    endTagInHead(p, token);
  } else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML && tn !== $.TBODY && tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR) {
    tokenInTable(p, token);
  }
}
function tokenInTable(p, token) {
  var savedFosterParentingState = p.fosterParentingEnabled;
  p.fosterParentingEnabled = true;
  p._processTokenInBodyMode(token);
  p.fosterParentingEnabled = savedFosterParentingState;
}

// The "in table text" insertion mode
//------------------------------------------------------------------
function whitespaceCharacterInTableText(p, token) {
  p.pendingCharacterTokens.push(token);
}
function characterInTableText(p, token) {
  p.pendingCharacterTokens.push(token);
  p.hasNonWhitespacePendingCharacterToken = true;
}
function tokenInTableText(p, token) {
  var i = 0;
  if (p.hasNonWhitespacePendingCharacterToken) {
    for (; i < p.pendingCharacterTokens.length; i++) {
      tokenInTable(p, p.pendingCharacterTokens[i]);
    }
  } else {
    for (; i < p.pendingCharacterTokens.length; i++) {
      p._insertCharacters(p.pendingCharacterTokens[i]);
    }
  }
  p.insertionMode = p.originalInsertionMode;
  p._processToken(token);
}

// The "in caption" insertion mode
//------------------------------------------------------------------
function startTagInCaption(p, token) {
  var tn = token.tagName;
  if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY || tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {
    if (p.openElements.hasInTableScope($.CAPTION)) {
      p.openElements.generateImpliedEndTags();
      p.openElements.popUntilTagNamePopped($.CAPTION);
      p.activeFormattingElements.clearToLastMarker();
      p.insertionMode = IN_TABLE_MODE;
      p._processToken(token);
    }
  } else {
    startTagInBody(p, token);
  }
}
function endTagInCaption(p, token) {
  var tn = token.tagName;
  if (tn === $.CAPTION || tn === $.TABLE) {
    if (p.openElements.hasInTableScope($.CAPTION)) {
      p.openElements.generateImpliedEndTags();
      p.openElements.popUntilTagNamePopped($.CAPTION);
      p.activeFormattingElements.clearToLastMarker();
      p.insertionMode = IN_TABLE_MODE;
      if (tn === $.TABLE) {
        p._processToken(token);
      }
    }
  } else if (tn !== $.BODY && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML && tn !== $.TBODY && tn !== $.TD && tn !== $.TFOOT && tn !== $.TH && tn !== $.THEAD && tn !== $.TR) {
    endTagInBody(p, token);
  }
}

// The "in column group" insertion mode
//------------------------------------------------------------------
function startTagInColumnGroup(p, token) {
  var tn = token.tagName;
  if (tn === $.HTML) {
    startTagInBody(p, token);
  } else if (tn === $.COL) {
    p._appendElement(token, NS.HTML);
    token.ackSelfClosing = true;
  } else if (tn === $.TEMPLATE) {
    startTagInHead(p, token);
  } else {
    tokenInColumnGroup(p, token);
  }
}
function endTagInColumnGroup(p, token) {
  var tn = token.tagName;
  if (tn === $.COLGROUP) {
    if (p.openElements.currentTagName === $.COLGROUP) {
      p.openElements.pop();
      p.insertionMode = IN_TABLE_MODE;
    }
  } else if (tn === $.TEMPLATE) {
    endTagInHead(p, token);
  } else if (tn !== $.COL) {
    tokenInColumnGroup(p, token);
  }
}
function tokenInColumnGroup(p, token) {
  if (p.openElements.currentTagName === $.COLGROUP) {
    p.openElements.pop();
    p.insertionMode = IN_TABLE_MODE;
    p._processToken(token);
  }
}

// The "in table body" insertion mode
//------------------------------------------------------------------
function startTagInTableBody(p, token) {
  var tn = token.tagName;
  if (tn === $.TR) {
    p.openElements.clearBackToTableBodyContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_ROW_MODE;
  } else if (tn === $.TH || tn === $.TD) {
    p.openElements.clearBackToTableBodyContext();
    p._insertFakeElement($.TR);
    p.insertionMode = IN_ROW_MODE;
    p._processToken(token);
  } else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
    if (p.openElements.hasTableBodyContextInTableScope()) {
      p.openElements.clearBackToTableBodyContext();
      p.openElements.pop();
      p.insertionMode = IN_TABLE_MODE;
      p._processToken(token);
    }
  } else {
    startTagInTable(p, token);
  }
}
function endTagInTableBody(p, token) {
  var tn = token.tagName;
  if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
    if (p.openElements.hasInTableScope(tn)) {
      p.openElements.clearBackToTableBodyContext();
      p.openElements.pop();
      p.insertionMode = IN_TABLE_MODE;
    }
  } else if (tn === $.TABLE) {
    if (p.openElements.hasTableBodyContextInTableScope()) {
      p.openElements.clearBackToTableBodyContext();
      p.openElements.pop();
      p.insertionMode = IN_TABLE_MODE;
      p._processToken(token);
    }
  } else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP || tn !== $.HTML && tn !== $.TD && tn !== $.TH && tn !== $.TR) {
    endTagInTable(p, token);
  }
}

// The "in row" insertion mode
//------------------------------------------------------------------
function startTagInRow(p, token) {
  var tn = token.tagName;
  if (tn === $.TH || tn === $.TD) {
    p.openElements.clearBackToTableRowContext();
    p._insertElement(token, NS.HTML);
    p.insertionMode = IN_CELL_MODE;
    p.activeFormattingElements.insertMarker();
  } else if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
    if (p.openElements.hasInTableScope($.TR)) {
      p.openElements.clearBackToTableRowContext();
      p.openElements.pop();
      p.insertionMode = IN_TABLE_BODY_MODE;
      p._processToken(token);
    }
  } else {
    startTagInTable(p, token);
  }
}
function endTagInRow(p, token) {
  var tn = token.tagName;
  if (tn === $.TR) {
    if (p.openElements.hasInTableScope($.TR)) {
      p.openElements.clearBackToTableRowContext();
      p.openElements.pop();
      p.insertionMode = IN_TABLE_BODY_MODE;
    }
  } else if (tn === $.TABLE) {
    if (p.openElements.hasInTableScope($.TR)) {
      p.openElements.clearBackToTableRowContext();
      p.openElements.pop();
      p.insertionMode = IN_TABLE_BODY_MODE;
      p._processToken(token);
    }
  } else if (tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD) {
    if (p.openElements.hasInTableScope(tn) || p.openElements.hasInTableScope($.TR)) {
      p.openElements.clearBackToTableRowContext();
      p.openElements.pop();
      p.insertionMode = IN_TABLE_BODY_MODE;
      p._processToken(token);
    }
  } else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP || tn !== $.HTML && tn !== $.TD && tn !== $.TH) {
    endTagInTable(p, token);
  }
}

// The "in cell" insertion mode
//------------------------------------------------------------------
function startTagInCell(p, token) {
  var tn = token.tagName;
  if (tn === $.CAPTION || tn === $.COL || tn === $.COLGROUP || tn === $.TBODY || tn === $.TD || tn === $.TFOOT || tn === $.TH || tn === $.THEAD || tn === $.TR) {
    if (p.openElements.hasInTableScope($.TD) || p.openElements.hasInTableScope($.TH)) {
      p._closeTableCell();
      p._processToken(token);
    }
  } else {
    startTagInBody(p, token);
  }
}
function endTagInCell(p, token) {
  var tn = token.tagName;
  if (tn === $.TD || tn === $.TH) {
    if (p.openElements.hasInTableScope(tn)) {
      p.openElements.generateImpliedEndTags();
      p.openElements.popUntilTagNamePopped(tn);
      p.activeFormattingElements.clearToLastMarker();
      p.insertionMode = IN_ROW_MODE;
    }
  } else if (tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR) {
    if (p.openElements.hasInTableScope(tn)) {
      p._closeTableCell();
      p._processToken(token);
    }
  } else if (tn !== $.BODY && tn !== $.CAPTION && tn !== $.COL && tn !== $.COLGROUP && tn !== $.HTML) {
    endTagInBody(p, token);
  }
}

// The "in select" insertion mode
//------------------------------------------------------------------
function startTagInSelect(p, token) {
  var tn = token.tagName;
  if (tn === $.HTML) {
    startTagInBody(p, token);
  } else if (tn === $.OPTION) {
    if (p.openElements.currentTagName === $.OPTION) {
      p.openElements.pop();
    }
    p._insertElement(token, NS.HTML);
  } else if (tn === $.OPTGROUP) {
    if (p.openElements.currentTagName === $.OPTION) {
      p.openElements.pop();
    }
    if (p.openElements.currentTagName === $.OPTGROUP) {
      p.openElements.pop();
    }
    p._insertElement(token, NS.HTML);
  } else if (tn === $.INPUT || tn === $.KEYGEN || tn === $.TEXTAREA || tn === $.SELECT) {
    if (p.openElements.hasInSelectScope($.SELECT)) {
      p.openElements.popUntilTagNamePopped($.SELECT);
      p._resetInsertionMode();
      if (tn !== $.SELECT) {
        p._processToken(token);
      }
    }
  } else if (tn === $.SCRIPT || tn === $.TEMPLATE) {
    startTagInHead(p, token);
  }
}
function endTagInSelect(p, token) {
  var tn = token.tagName;
  if (tn === $.OPTGROUP) {
    var prevOpenElement = p.openElements.items[p.openElements.stackTop - 1];
    var prevOpenElementTn = prevOpenElement && p.treeAdapter.getTagName(prevOpenElement);
    if (p.openElements.currentTagName === $.OPTION && prevOpenElementTn === $.OPTGROUP) {
      p.openElements.pop();
    }
    if (p.openElements.currentTagName === $.OPTGROUP) {
      p.openElements.pop();
    }
  } else if (tn === $.OPTION) {
    if (p.openElements.currentTagName === $.OPTION) {
      p.openElements.pop();
    }
  } else if (tn === $.SELECT && p.openElements.hasInSelectScope($.SELECT)) {
    p.openElements.popUntilTagNamePopped($.SELECT);
    p._resetInsertionMode();
  } else if (tn === $.TEMPLATE) {
    endTagInHead(p, token);
  }
}

//12.2.5.4.17 The "in select in table" insertion mode
//------------------------------------------------------------------
function startTagInSelectInTable(p, token) {
  var tn = token.tagName;
  if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
    p.openElements.popUntilTagNamePopped($.SELECT);
    p._resetInsertionMode();
    p._processToken(token);
  } else {
    startTagInSelect(p, token);
  }
}
function endTagInSelectInTable(p, token) {
  var tn = token.tagName;
  if (tn === $.CAPTION || tn === $.TABLE || tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD || tn === $.TR || tn === $.TD || tn === $.TH) {
    if (p.openElements.hasInTableScope(tn)) {
      p.openElements.popUntilTagNamePopped($.SELECT);
      p._resetInsertionMode();
      p._processToken(token);
    }
  } else {
    endTagInSelect(p, token);
  }
}

// The "in template" insertion mode
//------------------------------------------------------------------
function startTagInTemplate(p, token) {
  var tn = token.tagName;
  if (tn === $.BASE || tn === $.BASEFONT || tn === $.BGSOUND || tn === $.LINK || tn === $.META || tn === $.NOFRAMES || tn === $.SCRIPT || tn === $.STYLE || tn === $.TEMPLATE || tn === $.TITLE) {
    startTagInHead(p, token);
  } else {
    var newInsertionMode = TEMPLATE_INSERTION_MODE_SWITCH_MAP[tn] || IN_BODY_MODE;
    p._popTmplInsertionMode();
    p._pushTmplInsertionMode(newInsertionMode);
    p.insertionMode = newInsertionMode;
    p._processToken(token);
  }
}
function endTagInTemplate(p, token) {
  if (token.tagName === $.TEMPLATE) {
    endTagInHead(p, token);
  }
}
function eofInTemplate(p, token) {
  if (p.openElements.tmplCount > 0) {
    p.openElements.popUntilTagNamePopped($.TEMPLATE);
    p.activeFormattingElements.clearToLastMarker();
    p._popTmplInsertionMode();
    p._resetInsertionMode();
    p._processToken(token);
  } else {
    p.stopped = true;
  }
}

// The "after body" insertion mode
//------------------------------------------------------------------
function startTagAfterBody(p, token) {
  if (token.tagName === $.HTML) {
    startTagInBody(p, token);
  } else {
    tokenAfterBody(p, token);
  }
}
function endTagAfterBody(p, token) {
  if (token.tagName === $.HTML) {
    if (!p.fragmentContext) {
      p.insertionMode = AFTER_AFTER_BODY_MODE;
    }
  } else {
    tokenAfterBody(p, token);
  }
}
function tokenAfterBody(p, token) {
  p.insertionMode = IN_BODY_MODE;
  p._processToken(token);
}

// The "in frameset" insertion mode
//------------------------------------------------------------------
function startTagInFrameset(p, token) {
  var tn = token.tagName;
  if (tn === $.HTML) {
    startTagInBody(p, token);
  } else if (tn === $.FRAMESET) {
    p._insertElement(token, NS.HTML);
  } else if (tn === $.FRAME) {
    p._appendElement(token, NS.HTML);
    token.ackSelfClosing = true;
  } else if (tn === $.NOFRAMES) {
    startTagInHead(p, token);
  }
}
function endTagInFrameset(p, token) {
  if (token.tagName === $.FRAMESET && !p.openElements.isRootHtmlElementCurrent()) {
    p.openElements.pop();
    if (!p.fragmentContext && p.openElements.currentTagName !== $.FRAMESET) {
      p.insertionMode = AFTER_FRAMESET_MODE;
    }
  }
}

// The "after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterFrameset(p, token) {
  var tn = token.tagName;
  if (tn === $.HTML) {
    startTagInBody(p, token);
  } else if (tn === $.NOFRAMES) {
    startTagInHead(p, token);
  }
}
function endTagAfterFrameset(p, token) {
  if (token.tagName === $.HTML) {
    p.insertionMode = AFTER_AFTER_FRAMESET_MODE;
  }
}

// The "after after body" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterBody(p, token) {
  if (token.tagName === $.HTML) {
    startTagInBody(p, token);
  } else {
    tokenAfterAfterBody(p, token);
  }
}
function tokenAfterAfterBody(p, token) {
  p.insertionMode = IN_BODY_MODE;
  p._processToken(token);
}

// The "after after frameset" insertion mode
//------------------------------------------------------------------
function startTagAfterAfterFrameset(p, token) {
  var tn = token.tagName;
  if (tn === $.HTML) {
    startTagInBody(p, token);
  } else if (tn === $.NOFRAMES) {
    startTagInHead(p, token);
  }
}

// The rules for parsing tokens in foreign content
//------------------------------------------------------------------
function nullCharacterInForeignContent(p, token) {
  token.chars = unicode.REPLACEMENT_CHARACTER;
  p._insertCharacters(token);
}
function characterInForeignContent(p, token) {
  p._insertCharacters(token);
  p.framesetOk = false;
}
function startTagInForeignContent(p, token) {
  if (foreignContent.causesExit(token) && !p.fragmentContext) {
    while (p.treeAdapter.getNamespaceURI(p.openElements.current) !== NS.HTML && !p._isIntegrationPoint(p.openElements.current)) {
      p.openElements.pop();
    }
    p._processToken(token);
  } else {
    var current = p._getAdjustedCurrentElement();
    var currentNs = p.treeAdapter.getNamespaceURI(current);
    if (currentNs === NS.MATHML) {
      foreignContent.adjustTokenMathMLAttrs(token);
    } else if (currentNs === NS.SVG) {
      foreignContent.adjustTokenSVGTagName(token);
      foreignContent.adjustTokenSVGAttrs(token);
    }
    foreignContent.adjustTokenXMLAttrs(token);
    if (token.selfClosing) {
      p._appendElement(token, currentNs);
    } else {
      p._insertElement(token, currentNs);
    }
    token.ackSelfClosing = true;
  }
}
function endTagInForeignContent(p, token) {
  for (var i = p.openElements.stackTop; i > 0; i--) {
    var element = p.openElements.items[i];
    if (p.treeAdapter.getNamespaceURI(element) === NS.HTML) {
      p._processToken(token);
      break;
    }
    if (p.treeAdapter.getTagName(element).toLowerCase() === token.tagName) {
      p.openElements.popUntilElementPopped(element);
      break;
    }
  }
}

/***/ }),

/***/ 7674:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var HTML = __webpack_require__(8869);

//Aliases
var $ = HTML.TAG_NAMES;
var NS = HTML.NAMESPACES;

//Element utils

//OPTIMIZATION: Integer comparisons are low-cost, so we can use very fast tag name length filters here.
//It's faster than using dictionary.
function isImpliedEndTagRequired(tn) {
  switch (tn.length) {
    case 1:
      return tn === $.P;
    case 2:
      return tn === $.RB || tn === $.RP || tn === $.RT || tn === $.DD || tn === $.DT || tn === $.LI;
    case 3:
      return tn === $.RTC;
    case 6:
      return tn === $.OPTION;
    case 8:
      return tn === $.OPTGROUP;
  }
  return false;
}
function isImpliedEndTagRequiredThoroughly(tn) {
  switch (tn.length) {
    case 1:
      return tn === $.P;
    case 2:
      return tn === $.RB || tn === $.RP || tn === $.RT || tn === $.DD || tn === $.DT || tn === $.LI || tn === $.TD || tn === $.TH || tn === $.TR;
    case 3:
      return tn === $.RTC;
    case 5:
      return tn === $.TBODY || tn === $.TFOOT || tn === $.THEAD;
    case 6:
      return tn === $.OPTION;
    case 7:
      return tn === $.CAPTION;
    case 8:
      return tn === $.OPTGROUP || tn === $.COLGROUP;
  }
  return false;
}
function isScopingElement(tn, ns) {
  switch (tn.length) {
    case 2:
      if (tn === $.TD || tn === $.TH) {
        return ns === NS.HTML;
      } else if (tn === $.MI || tn === $.MO || tn === $.MN || tn === $.MS) {
        return ns === NS.MATHML;
      }
      break;
    case 4:
      if (tn === $.HTML) {
        return ns === NS.HTML;
      } else if (tn === $.DESC) {
        return ns === NS.SVG;
      }
      break;
    case 5:
      if (tn === $.TABLE) {
        return ns === NS.HTML;
      } else if (tn === $.MTEXT) {
        return ns === NS.MATHML;
      } else if (tn === $.TITLE) {
        return ns === NS.SVG;
      }
      break;
    case 6:
      return (tn === $.APPLET || tn === $.OBJECT) && ns === NS.HTML;
    case 7:
      return (tn === $.CAPTION || tn === $.MARQUEE) && ns === NS.HTML;
    case 8:
      return tn === $.TEMPLATE && ns === NS.HTML;
    case 13:
      return tn === $.FOREIGN_OBJECT && ns === NS.SVG;
    case 14:
      return tn === $.ANNOTATION_XML && ns === NS.MATHML;
  }
  return false;
}

//Stack of open elements
var OpenElementStack = /*#__PURE__*/function () {
  function OpenElementStack(document, treeAdapter) {
    _classCallCheck(this, OpenElementStack);
    this.stackTop = -1;
    this.items = [];
    this.current = document;
    this.currentTagName = null;
    this.currentTmplContent = null;
    this.tmplCount = 0;
    this.treeAdapter = treeAdapter;
  }

  //Index of element
  _createClass(OpenElementStack, [{
    key: "_indexOf",
    value: function _indexOf(element) {
      var idx = -1;
      for (var i = this.stackTop; i >= 0; i--) {
        if (this.items[i] === element) {
          idx = i;
          break;
        }
      }
      return idx;
    }

    //Update current element
  }, {
    key: "_isInTemplate",
    value: function _isInTemplate() {
      return this.currentTagName === $.TEMPLATE && this.treeAdapter.getNamespaceURI(this.current) === NS.HTML;
    }
  }, {
    key: "_updateCurrentElement",
    value: function _updateCurrentElement() {
      this.current = this.items[this.stackTop];
      this.currentTagName = this.current && this.treeAdapter.getTagName(this.current);
      this.currentTmplContent = this._isInTemplate() ? this.treeAdapter.getTemplateContent(this.current) : null;
    }

    //Mutations
  }, {
    key: "push",
    value: function push(element) {
      this.items[++this.stackTop] = element;
      this._updateCurrentElement();
      if (this._isInTemplate()) {
        this.tmplCount++;
      }
    }
  }, {
    key: "pop",
    value: function pop() {
      this.stackTop--;
      if (this.tmplCount > 0 && this._isInTemplate()) {
        this.tmplCount--;
      }
      this._updateCurrentElement();
    }
  }, {
    key: "replace",
    value: function replace(oldElement, newElement) {
      var idx = this._indexOf(oldElement);
      this.items[idx] = newElement;
      if (idx === this.stackTop) {
        this._updateCurrentElement();
      }
    }
  }, {
    key: "insertAfter",
    value: function insertAfter(referenceElement, newElement) {
      var insertionIdx = this._indexOf(referenceElement) + 1;
      this.items.splice(insertionIdx, 0, newElement);
      if (insertionIdx === ++this.stackTop) {
        this._updateCurrentElement();
      }
    }
  }, {
    key: "popUntilTagNamePopped",
    value: function popUntilTagNamePopped(tagName) {
      while (this.stackTop > -1) {
        var tn = this.currentTagName;
        var ns = this.treeAdapter.getNamespaceURI(this.current);
        this.pop();
        if (tn === tagName && ns === NS.HTML) {
          break;
        }
      }
    }
  }, {
    key: "popUntilElementPopped",
    value: function popUntilElementPopped(element) {
      while (this.stackTop > -1) {
        var poppedElement = this.current;
        this.pop();
        if (poppedElement === element) {
          break;
        }
      }
    }
  }, {
    key: "popUntilNumberedHeaderPopped",
    value: function popUntilNumberedHeaderPopped() {
      while (this.stackTop > -1) {
        var tn = this.currentTagName;
        var ns = this.treeAdapter.getNamespaceURI(this.current);
        this.pop();
        if (tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6 && ns === NS.HTML) {
          break;
        }
      }
    }
  }, {
    key: "popUntilTableCellPopped",
    value: function popUntilTableCellPopped() {
      while (this.stackTop > -1) {
        var tn = this.currentTagName;
        var ns = this.treeAdapter.getNamespaceURI(this.current);
        this.pop();
        if (tn === $.TD || tn === $.TH && ns === NS.HTML) {
          break;
        }
      }
    }
  }, {
    key: "popAllUpToHtmlElement",
    value: function popAllUpToHtmlElement() {
      //NOTE: here we assume that root <html> element is always first in the open element stack, so
      //we perform this fast stack clean up.
      this.stackTop = 0;
      this._updateCurrentElement();
    }
  }, {
    key: "clearBackToTableContext",
    value: function clearBackToTableContext() {
      while (this.currentTagName !== $.TABLE && this.currentTagName !== $.TEMPLATE && this.currentTagName !== $.HTML || this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML) {
        this.pop();
      }
    }
  }, {
    key: "clearBackToTableBodyContext",
    value: function clearBackToTableBodyContext() {
      while (this.currentTagName !== $.TBODY && this.currentTagName !== $.TFOOT && this.currentTagName !== $.THEAD && this.currentTagName !== $.TEMPLATE && this.currentTagName !== $.HTML || this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML) {
        this.pop();
      }
    }
  }, {
    key: "clearBackToTableRowContext",
    value: function clearBackToTableRowContext() {
      while (this.currentTagName !== $.TR && this.currentTagName !== $.TEMPLATE && this.currentTagName !== $.HTML || this.treeAdapter.getNamespaceURI(this.current) !== NS.HTML) {
        this.pop();
      }
    }
  }, {
    key: "remove",
    value: function remove(element) {
      for (var i = this.stackTop; i >= 0; i--) {
        if (this.items[i] === element) {
          this.items.splice(i, 1);
          this.stackTop--;
          this._updateCurrentElement();
          break;
        }
      }
    }

    //Search
  }, {
    key: "tryPeekProperlyNestedBodyElement",
    value: function tryPeekProperlyNestedBodyElement() {
      //Properly nested <body> element (should be second element in stack).
      var element = this.items[1];
      return element && this.treeAdapter.getTagName(element) === $.BODY ? element : null;
    }
  }, {
    key: "contains",
    value: function contains(element) {
      return this._indexOf(element) > -1;
    }
  }, {
    key: "getCommonAncestor",
    value: function getCommonAncestor(element) {
      var elementIdx = this._indexOf(element);
      return --elementIdx >= 0 ? this.items[elementIdx] : null;
    }
  }, {
    key: "isRootHtmlElementCurrent",
    value: function isRootHtmlElementCurrent() {
      return this.stackTop === 0 && this.currentTagName === $.HTML;
    }

    //Element in scope
  }, {
    key: "hasInScope",
    value: function hasInScope(tagName) {
      for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]);
        var ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (tn === tagName && ns === NS.HTML) {
          return true;
        }
        if (isScopingElement(tn, ns)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasNumberedHeaderInScope",
    value: function hasNumberedHeaderInScope() {
      for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]);
        var ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if ((tn === $.H1 || tn === $.H2 || tn === $.H3 || tn === $.H4 || tn === $.H5 || tn === $.H6) && ns === NS.HTML) {
          return true;
        }
        if (isScopingElement(tn, ns)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasInListItemScope",
    value: function hasInListItemScope(tagName) {
      for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]);
        var ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (tn === tagName && ns === NS.HTML) {
          return true;
        }
        if ((tn === $.UL || tn === $.OL) && ns === NS.HTML || isScopingElement(tn, ns)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasInButtonScope",
    value: function hasInButtonScope(tagName) {
      for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]);
        var ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (tn === tagName && ns === NS.HTML) {
          return true;
        }
        if (tn === $.BUTTON && ns === NS.HTML || isScopingElement(tn, ns)) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasInTableScope",
    value: function hasInTableScope(tagName) {
      for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]);
        var ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (ns !== NS.HTML) {
          continue;
        }
        if (tn === tagName) {
          return true;
        }
        if (tn === $.TABLE || tn === $.TEMPLATE || tn === $.HTML) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasTableBodyContextInTableScope",
    value: function hasTableBodyContextInTableScope() {
      for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]);
        var ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (ns !== NS.HTML) {
          continue;
        }
        if (tn === $.TBODY || tn === $.THEAD || tn === $.TFOOT) {
          return true;
        }
        if (tn === $.TABLE || tn === $.HTML) {
          return false;
        }
      }
      return true;
    }
  }, {
    key: "hasInSelectScope",
    value: function hasInSelectScope(tagName) {
      for (var i = this.stackTop; i >= 0; i--) {
        var tn = this.treeAdapter.getTagName(this.items[i]);
        var ns = this.treeAdapter.getNamespaceURI(this.items[i]);
        if (ns !== NS.HTML) {
          continue;
        }
        if (tn === tagName) {
          return true;
        }
        if (tn !== $.OPTION && tn !== $.OPTGROUP) {
          return false;
        }
      }
      return true;
    }

    //Implied end tags
  }, {
    key: "generateImpliedEndTags",
    value: function generateImpliedEndTags() {
      while (isImpliedEndTagRequired(this.currentTagName)) {
        this.pop();
      }
    }
  }, {
    key: "generateImpliedEndTagsThoroughly",
    value: function generateImpliedEndTagsThoroughly() {
      while (isImpliedEndTagRequiredThoroughly(this.currentTagName)) {
        this.pop();
      }
    }
  }, {
    key: "generateImpliedEndTagsWithExclusion",
    value: function generateImpliedEndTagsWithExclusion(exclusionTagName) {
      while (isImpliedEndTagRequired(this.currentTagName) && this.currentTagName !== exclusionTagName) {
        this.pop();
      }
    }
  }]);
  return OpenElementStack;
}();
module.exports = OpenElementStack;

/***/ }),

/***/ 301:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var Preprocessor = __webpack_require__(7058);
var unicode = __webpack_require__(9879);
var neTree = __webpack_require__(1784);
var ERR = __webpack_require__(4688);

//Aliases
var $ = unicode.CODE_POINTS;
var $$ = unicode.CODE_POINT_SEQUENCES;

//C1 Unicode control character reference replacements
var C1_CONTROLS_REFERENCE_REPLACEMENTS = {
  0x80: 0x20ac,
  0x82: 0x201a,
  0x83: 0x0192,
  0x84: 0x201e,
  0x85: 0x2026,
  0x86: 0x2020,
  0x87: 0x2021,
  0x88: 0x02c6,
  0x89: 0x2030,
  0x8a: 0x0160,
  0x8b: 0x2039,
  0x8c: 0x0152,
  0x8e: 0x017d,
  0x91: 0x2018,
  0x92: 0x2019,
  0x93: 0x201c,
  0x94: 0x201d,
  0x95: 0x2022,
  0x96: 0x2013,
  0x97: 0x2014,
  0x98: 0x02dc,
  0x99: 0x2122,
  0x9a: 0x0161,
  0x9b: 0x203a,
  0x9c: 0x0153,
  0x9e: 0x017e,
  0x9f: 0x0178
};

// Named entity tree flags
var HAS_DATA_FLAG = 1 << 0;
var DATA_DUPLET_FLAG = 1 << 1;
var HAS_BRANCHES_FLAG = 1 << 2;
var MAX_BRANCH_MARKER_VALUE = HAS_DATA_FLAG | DATA_DUPLET_FLAG | HAS_BRANCHES_FLAG;

//States
var DATA_STATE = 'DATA_STATE';
var RCDATA_STATE = 'RCDATA_STATE';
var RAWTEXT_STATE = 'RAWTEXT_STATE';
var SCRIPT_DATA_STATE = 'SCRIPT_DATA_STATE';
var PLAINTEXT_STATE = 'PLAINTEXT_STATE';
var TAG_OPEN_STATE = 'TAG_OPEN_STATE';
var END_TAG_OPEN_STATE = 'END_TAG_OPEN_STATE';
var TAG_NAME_STATE = 'TAG_NAME_STATE';
var RCDATA_LESS_THAN_SIGN_STATE = 'RCDATA_LESS_THAN_SIGN_STATE';
var RCDATA_END_TAG_OPEN_STATE = 'RCDATA_END_TAG_OPEN_STATE';
var RCDATA_END_TAG_NAME_STATE = 'RCDATA_END_TAG_NAME_STATE';
var RAWTEXT_LESS_THAN_SIGN_STATE = 'RAWTEXT_LESS_THAN_SIGN_STATE';
var RAWTEXT_END_TAG_OPEN_STATE = 'RAWTEXT_END_TAG_OPEN_STATE';
var RAWTEXT_END_TAG_NAME_STATE = 'RAWTEXT_END_TAG_NAME_STATE';
var SCRIPT_DATA_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_LESS_THAN_SIGN_STATE';
var SCRIPT_DATA_END_TAG_OPEN_STATE = 'SCRIPT_DATA_END_TAG_OPEN_STATE';
var SCRIPT_DATA_END_TAG_NAME_STATE = 'SCRIPT_DATA_END_TAG_NAME_STATE';
var SCRIPT_DATA_ESCAPE_START_STATE = 'SCRIPT_DATA_ESCAPE_START_STATE';
var SCRIPT_DATA_ESCAPE_START_DASH_STATE = 'SCRIPT_DATA_ESCAPE_START_DASH_STATE';
var SCRIPT_DATA_ESCAPED_STATE = 'SCRIPT_DATA_ESCAPED_STATE';
var SCRIPT_DATA_ESCAPED_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_STATE';
var SCRIPT_DATA_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_ESCAPED_DASH_DASH_STATE';
var SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE';
var SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE';
var SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE = 'SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE';
var SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE';
var SCRIPT_DATA_DOUBLE_ESCAPED_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_STATE';
var SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE';
var SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE';
var SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE';
var SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE = 'SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE';
var BEFORE_ATTRIBUTE_NAME_STATE = 'BEFORE_ATTRIBUTE_NAME_STATE';
var ATTRIBUTE_NAME_STATE = 'ATTRIBUTE_NAME_STATE';
var AFTER_ATTRIBUTE_NAME_STATE = 'AFTER_ATTRIBUTE_NAME_STATE';
var BEFORE_ATTRIBUTE_VALUE_STATE = 'BEFORE_ATTRIBUTE_VALUE_STATE';
var ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE';
var ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE = 'ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE';
var ATTRIBUTE_VALUE_UNQUOTED_STATE = 'ATTRIBUTE_VALUE_UNQUOTED_STATE';
var AFTER_ATTRIBUTE_VALUE_QUOTED_STATE = 'AFTER_ATTRIBUTE_VALUE_QUOTED_STATE';
var SELF_CLOSING_START_TAG_STATE = 'SELF_CLOSING_START_TAG_STATE';
var BOGUS_COMMENT_STATE = 'BOGUS_COMMENT_STATE';
var MARKUP_DECLARATION_OPEN_STATE = 'MARKUP_DECLARATION_OPEN_STATE';
var COMMENT_START_STATE = 'COMMENT_START_STATE';
var COMMENT_START_DASH_STATE = 'COMMENT_START_DASH_STATE';
var COMMENT_STATE = 'COMMENT_STATE';
var COMMENT_LESS_THAN_SIGN_STATE = 'COMMENT_LESS_THAN_SIGN_STATE';
var COMMENT_LESS_THAN_SIGN_BANG_STATE = 'COMMENT_LESS_THAN_SIGN_BANG_STATE';
var COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE = 'COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE';
var COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE = 'COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE';
var COMMENT_END_DASH_STATE = 'COMMENT_END_DASH_STATE';
var COMMENT_END_STATE = 'COMMENT_END_STATE';
var COMMENT_END_BANG_STATE = 'COMMENT_END_BANG_STATE';
var DOCTYPE_STATE = 'DOCTYPE_STATE';
var BEFORE_DOCTYPE_NAME_STATE = 'BEFORE_DOCTYPE_NAME_STATE';
var DOCTYPE_NAME_STATE = 'DOCTYPE_NAME_STATE';
var AFTER_DOCTYPE_NAME_STATE = 'AFTER_DOCTYPE_NAME_STATE';
var AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE = 'AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE';
var BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE';
var DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE';
var DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE';
var AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE = 'AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE';
var BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE = 'BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE';
var AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE = 'AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE';
var BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE';
var DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE';
var DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE = 'DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE';
var AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE = 'AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE';
var BOGUS_DOCTYPE_STATE = 'BOGUS_DOCTYPE_STATE';
var CDATA_SECTION_STATE = 'CDATA_SECTION_STATE';
var CDATA_SECTION_BRACKET_STATE = 'CDATA_SECTION_BRACKET_STATE';
var CDATA_SECTION_END_STATE = 'CDATA_SECTION_END_STATE';
var CHARACTER_REFERENCE_STATE = 'CHARACTER_REFERENCE_STATE';
var NAMED_CHARACTER_REFERENCE_STATE = 'NAMED_CHARACTER_REFERENCE_STATE';
var AMBIGUOUS_AMPERSAND_STATE = 'AMBIGUOS_AMPERSAND_STATE';
var NUMERIC_CHARACTER_REFERENCE_STATE = 'NUMERIC_CHARACTER_REFERENCE_STATE';
var HEXADEMICAL_CHARACTER_REFERENCE_START_STATE = 'HEXADEMICAL_CHARACTER_REFERENCE_START_STATE';
var DECIMAL_CHARACTER_REFERENCE_START_STATE = 'DECIMAL_CHARACTER_REFERENCE_START_STATE';
var HEXADEMICAL_CHARACTER_REFERENCE_STATE = 'HEXADEMICAL_CHARACTER_REFERENCE_STATE';
var DECIMAL_CHARACTER_REFERENCE_STATE = 'DECIMAL_CHARACTER_REFERENCE_STATE';
var NUMERIC_CHARACTER_REFERENCE_END_STATE = 'NUMERIC_CHARACTER_REFERENCE_END_STATE';

//Utils

//OPTIMIZATION: these utility functions should not be moved out of this module. V8 Crankshaft will not inline
//this functions if they will be situated in another module due to context switch.
//Always perform inlining check before modifying this functions ('node --trace-inlining').
function isWhitespace(cp) {
  return cp === $.SPACE || cp === $.LINE_FEED || cp === $.TABULATION || cp === $.FORM_FEED;
}
function isAsciiDigit(cp) {
  return cp >= $.DIGIT_0 && cp <= $.DIGIT_9;
}
function isAsciiUpper(cp) {
  return cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_Z;
}
function isAsciiLower(cp) {
  return cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_Z;
}
function isAsciiLetter(cp) {
  return isAsciiLower(cp) || isAsciiUpper(cp);
}
function isAsciiAlphaNumeric(cp) {
  return isAsciiLetter(cp) || isAsciiDigit(cp);
}
function isAsciiUpperHexDigit(cp) {
  return cp >= $.LATIN_CAPITAL_A && cp <= $.LATIN_CAPITAL_F;
}
function isAsciiLowerHexDigit(cp) {
  return cp >= $.LATIN_SMALL_A && cp <= $.LATIN_SMALL_F;
}
function isAsciiHexDigit(cp) {
  return isAsciiDigit(cp) || isAsciiUpperHexDigit(cp) || isAsciiLowerHexDigit(cp);
}
function toAsciiLowerCodePoint(cp) {
  return cp + 0x0020;
}

//NOTE: String.fromCharCode() function can handle only characters from BMP subset.
//So, we need to workaround this manually.
//(see: https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Global_Objects/String/fromCharCode#Getting_it_to_work_with_higher_values)
function toChar(cp) {
  if (cp <= 0xffff) {
    return String.fromCharCode(cp);
  }
  cp -= 0x10000;
  return String.fromCharCode(cp >>> 10 & 0x3ff | 0xd800) + String.fromCharCode(0xdc00 | cp & 0x3ff);
}
function toAsciiLowerChar(cp) {
  return String.fromCharCode(toAsciiLowerCodePoint(cp));
}
function findNamedEntityTreeBranch(nodeIx, cp) {
  var branchCount = neTree[++nodeIx];
  var lo = ++nodeIx;
  var hi = lo + branchCount - 1;
  while (lo <= hi) {
    var mid = lo + hi >>> 1;
    var midCp = neTree[mid];
    if (midCp < cp) {
      lo = mid + 1;
    } else if (midCp > cp) {
      hi = mid - 1;
    } else {
      return neTree[mid + branchCount];
    }
  }
  return -1;
}

//Tokenizer
var Tokenizer = /*#__PURE__*/function () {
  function Tokenizer() {
    _classCallCheck(this, Tokenizer);
    this.preprocessor = new Preprocessor();
    this.tokenQueue = [];
    this.allowCDATA = false;
    this.state = DATA_STATE;
    this.returnState = '';
    this.charRefCode = -1;
    this.tempBuff = [];
    this.lastStartTagName = '';
    this.consumedAfterSnapshot = -1;
    this.active = false;
    this.currentCharacterToken = null;
    this.currentToken = null;
    this.currentAttr = null;
  }

  //Errors
  _createClass(Tokenizer, [{
    key: "_err",
    value: function _err() {
      // NOTE: err reporting is noop by default. Enabled by mixin.
    }
  }, {
    key: "_errOnNextCodePoint",
    value: function _errOnNextCodePoint(err) {
      this._consume();
      this._err(err);
      this._unconsume();
    }

    //API
  }, {
    key: "getNextToken",
    value: function getNextToken() {
      while (!this.tokenQueue.length && this.active) {
        this.consumedAfterSnapshot = 0;
        var cp = this._consume();
        if (!this._ensureHibernation()) {
          this[this.state](cp);
        }
      }
      return this.tokenQueue.shift();
    }
  }, {
    key: "write",
    value: function write(chunk, isLastChunk) {
      this.active = true;
      this.preprocessor.write(chunk, isLastChunk);
    }
  }, {
    key: "insertHtmlAtCurrentPos",
    value: function insertHtmlAtCurrentPos(chunk) {
      this.active = true;
      this.preprocessor.insertHtmlAtCurrentPos(chunk);
    }

    //Hibernation
  }, {
    key: "_ensureHibernation",
    value: function _ensureHibernation() {
      if (this.preprocessor.endOfChunkHit) {
        for (; this.consumedAfterSnapshot > 0; this.consumedAfterSnapshot--) {
          this.preprocessor.retreat();
        }
        this.active = false;
        this.tokenQueue.push({
          type: Tokenizer.HIBERNATION_TOKEN
        });
        return true;
      }
      return false;
    }

    //Consumption
  }, {
    key: "_consume",
    value: function _consume() {
      this.consumedAfterSnapshot++;
      return this.preprocessor.advance();
    }
  }, {
    key: "_unconsume",
    value: function _unconsume() {
      this.consumedAfterSnapshot--;
      this.preprocessor.retreat();
    }
  }, {
    key: "_reconsumeInState",
    value: function _reconsumeInState(state) {
      this.state = state;
      this._unconsume();
    }
  }, {
    key: "_consumeSequenceIfMatch",
    value: function _consumeSequenceIfMatch(pattern, startCp, caseSensitive) {
      var consumedCount = 0;
      var isMatch = true;
      var patternLength = pattern.length;
      var patternPos = 0;
      var cp = startCp;
      var patternCp = void 0;
      for (; patternPos < patternLength; patternPos++) {
        if (patternPos > 0) {
          cp = this._consume();
          consumedCount++;
        }
        if (cp === $.EOF) {
          isMatch = false;
          break;
        }
        patternCp = pattern[patternPos];
        if (cp !== patternCp && (caseSensitive || cp !== toAsciiLowerCodePoint(patternCp))) {
          isMatch = false;
          break;
        }
      }
      if (!isMatch) {
        while (consumedCount--) {
          this._unconsume();
        }
      }
      return isMatch;
    }

    //Temp buffer
  }, {
    key: "_isTempBufferEqualToScriptString",
    value: function _isTempBufferEqualToScriptString() {
      if (this.tempBuff.length !== $$.SCRIPT_STRING.length) {
        return false;
      }
      for (var i = 0; i < this.tempBuff.length; i++) {
        if (this.tempBuff[i] !== $$.SCRIPT_STRING[i]) {
          return false;
        }
      }
      return true;
    }

    //Token creation
  }, {
    key: "_createStartTagToken",
    value: function _createStartTagToken() {
      this.currentToken = {
        type: Tokenizer.START_TAG_TOKEN,
        tagName: '',
        selfClosing: false,
        ackSelfClosing: false,
        attrs: []
      };
    }
  }, {
    key: "_createEndTagToken",
    value: function _createEndTagToken() {
      this.currentToken = {
        type: Tokenizer.END_TAG_TOKEN,
        tagName: '',
        selfClosing: false,
        attrs: []
      };
    }
  }, {
    key: "_createCommentToken",
    value: function _createCommentToken() {
      this.currentToken = {
        type: Tokenizer.COMMENT_TOKEN,
        data: ''
      };
    }
  }, {
    key: "_createDoctypeToken",
    value: function _createDoctypeToken(initialName) {
      this.currentToken = {
        type: Tokenizer.DOCTYPE_TOKEN,
        name: initialName,
        forceQuirks: false,
        publicId: null,
        systemId: null
      };
    }
  }, {
    key: "_createCharacterToken",
    value: function _createCharacterToken(type, ch) {
      this.currentCharacterToken = {
        type: type,
        chars: ch
      };
    }
  }, {
    key: "_createEOFToken",
    value: function _createEOFToken() {
      this.currentToken = {
        type: Tokenizer.EOF_TOKEN
      };
    }

    //Tag attributes
  }, {
    key: "_createAttr",
    value: function _createAttr(attrNameFirstCh) {
      this.currentAttr = {
        name: attrNameFirstCh,
        value: ''
      };
    }
  }, {
    key: "_leaveAttrName",
    value: function _leaveAttrName(toState) {
      if (Tokenizer.getTokenAttr(this.currentToken, this.currentAttr.name) === null) {
        this.currentToken.attrs.push(this.currentAttr);
      } else {
        this._err(ERR.duplicateAttribute);
      }
      this.state = toState;
    }
  }, {
    key: "_leaveAttrValue",
    value: function _leaveAttrValue(toState) {
      this.state = toState;
    }

    //Token emission
  }, {
    key: "_emitCurrentToken",
    value: function _emitCurrentToken() {
      this._emitCurrentCharacterToken();
      var ct = this.currentToken;
      this.currentToken = null;

      //NOTE: store emited start tag's tagName to determine is the following end tag token is appropriate.
      if (ct.type === Tokenizer.START_TAG_TOKEN) {
        this.lastStartTagName = ct.tagName;
      } else if (ct.type === Tokenizer.END_TAG_TOKEN) {
        if (ct.attrs.length > 0) {
          this._err(ERR.endTagWithAttributes);
        }
        if (ct.selfClosing) {
          this._err(ERR.endTagWithTrailingSolidus);
        }
      }
      this.tokenQueue.push(ct);
    }
  }, {
    key: "_emitCurrentCharacterToken",
    value: function _emitCurrentCharacterToken() {
      if (this.currentCharacterToken) {
        this.tokenQueue.push(this.currentCharacterToken);
        this.currentCharacterToken = null;
      }
    }
  }, {
    key: "_emitEOFToken",
    value: function _emitEOFToken() {
      this._createEOFToken();
      this._emitCurrentToken();
    }

    //Characters emission

    //OPTIMIZATION: specification uses only one type of character tokens (one token per character).
    //This causes a huge memory overhead and a lot of unnecessary parser loops. parse5 uses 3 groups of characters.
    //If we have a sequence of characters that belong to the same group, parser can process it
    //as a single solid character token.
    //So, there are 3 types of character tokens in parse5:
    //1)NULL_CHARACTER_TOKEN - \u0000-character sequences (e.g. '\u0000\u0000\u0000')
    //2)WHITESPACE_CHARACTER_TOKEN - any whitespace/new-line character sequences (e.g. '\n  \r\t   \f')
    //3)CHARACTER_TOKEN - any character sequence which don't belong to groups 1 and 2 (e.g. 'abcdef1234@@#$%^')
  }, {
    key: "_appendCharToCurrentCharacterToken",
    value: function _appendCharToCurrentCharacterToken(type, ch) {
      if (this.currentCharacterToken && this.currentCharacterToken.type !== type) {
        this._emitCurrentCharacterToken();
      }
      if (this.currentCharacterToken) {
        this.currentCharacterToken.chars += ch;
      } else {
        this._createCharacterToken(type, ch);
      }
    }
  }, {
    key: "_emitCodePoint",
    value: function _emitCodePoint(cp) {
      var type = Tokenizer.CHARACTER_TOKEN;
      if (isWhitespace(cp)) {
        type = Tokenizer.WHITESPACE_CHARACTER_TOKEN;
      } else if (cp === $.NULL) {
        type = Tokenizer.NULL_CHARACTER_TOKEN;
      }
      this._appendCharToCurrentCharacterToken(type, toChar(cp));
    }
  }, {
    key: "_emitSeveralCodePoints",
    value: function _emitSeveralCodePoints(codePoints) {
      for (var i = 0; i < codePoints.length; i++) {
        this._emitCodePoint(codePoints[i]);
      }
    }

    //NOTE: used then we emit character explicitly. This is always a non-whitespace and a non-null character.
    //So we can avoid additional checks here.
  }, {
    key: "_emitChars",
    value: function _emitChars(ch) {
      this._appendCharToCurrentCharacterToken(Tokenizer.CHARACTER_TOKEN, ch);
    }

    // Character reference helpers
  }, {
    key: "_matchNamedCharacterReference",
    value: function _matchNamedCharacterReference(startCp) {
      var result = null;
      var excess = 1;
      var i = findNamedEntityTreeBranch(0, startCp);
      this.tempBuff.push(startCp);
      while (i > -1) {
        var current = neTree[i];
        var inNode = current < MAX_BRANCH_MARKER_VALUE;
        var nodeWithData = inNode && current & HAS_DATA_FLAG;
        if (nodeWithData) {
          //NOTE: we use greedy search, so we continue lookup at this point
          result = current & DATA_DUPLET_FLAG ? [neTree[++i], neTree[++i]] : [neTree[++i]];
          excess = 0;
        }
        var cp = this._consume();
        this.tempBuff.push(cp);
        excess++;
        if (cp === $.EOF) {
          break;
        }
        if (inNode) {
          i = current & HAS_BRANCHES_FLAG ? findNamedEntityTreeBranch(i, cp) : -1;
        } else {
          i = cp === current ? ++i : -1;
        }
      }
      while (excess--) {
        this.tempBuff.pop();
        this._unconsume();
      }
      return result;
    }
  }, {
    key: "_isCharacterReferenceInAttribute",
    value: function _isCharacterReferenceInAttribute() {
      return this.returnState === ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE || this.returnState === ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE || this.returnState === ATTRIBUTE_VALUE_UNQUOTED_STATE;
    }
  }, {
    key: "_isCharacterReferenceAttributeQuirk",
    value: function _isCharacterReferenceAttributeQuirk(withSemicolon) {
      if (!withSemicolon && this._isCharacterReferenceInAttribute()) {
        var nextCp = this._consume();
        this._unconsume();
        return nextCp === $.EQUALS_SIGN || isAsciiAlphaNumeric(nextCp);
      }
      return false;
    }
  }, {
    key: "_flushCodePointsConsumedAsCharacterReference",
    value: function _flushCodePointsConsumedAsCharacterReference() {
      if (this._isCharacterReferenceInAttribute()) {
        for (var i = 0; i < this.tempBuff.length; i++) {
          this.currentAttr.value += toChar(this.tempBuff[i]);
        }
      } else {
        this._emitSeveralCodePoints(this.tempBuff);
      }
      this.tempBuff = [];
    }

    // State machine

    // Data state
    //------------------------------------------------------------------
  }, {
    key: DATA_STATE,
    value: function value(cp) {
      this.preprocessor.dropParsedChunk();
      if (cp === $.LESS_THAN_SIGN) {
        this.state = TAG_OPEN_STATE;
      } else if (cp === $.AMPERSAND) {
        this.returnState = DATA_STATE;
        this.state = CHARACTER_REFERENCE_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this._emitCodePoint(cp);
      } else if (cp === $.EOF) {
        this._emitEOFToken();
      } else {
        this._emitCodePoint(cp);
      }
    }

    //  RCDATA state
    //------------------------------------------------------------------
  }, {
    key: RCDATA_STATE,
    value: function value(cp) {
      this.preprocessor.dropParsedChunk();
      if (cp === $.AMPERSAND) {
        this.returnState = RCDATA_STATE;
        this.state = CHARACTER_REFERENCE_STATE;
      } else if (cp === $.LESS_THAN_SIGN) {
        this.state = RCDATA_LESS_THAN_SIGN_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this._emitChars(unicode.REPLACEMENT_CHARACTER);
      } else if (cp === $.EOF) {
        this._emitEOFToken();
      } else {
        this._emitCodePoint(cp);
      }
    }

    // RAWTEXT state
    //------------------------------------------------------------------
  }, {
    key: RAWTEXT_STATE,
    value: function value(cp) {
      this.preprocessor.dropParsedChunk();
      if (cp === $.LESS_THAN_SIGN) {
        this.state = RAWTEXT_LESS_THAN_SIGN_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this._emitChars(unicode.REPLACEMENT_CHARACTER);
      } else if (cp === $.EOF) {
        this._emitEOFToken();
      } else {
        this._emitCodePoint(cp);
      }
    }

    // Script data state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_STATE,
    value: function value(cp) {
      this.preprocessor.dropParsedChunk();
      if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_LESS_THAN_SIGN_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this._emitChars(unicode.REPLACEMENT_CHARACTER);
      } else if (cp === $.EOF) {
        this._emitEOFToken();
      } else {
        this._emitCodePoint(cp);
      }
    }

    // PLAINTEXT state
    //------------------------------------------------------------------
  }, {
    key: PLAINTEXT_STATE,
    value: function value(cp) {
      this.preprocessor.dropParsedChunk();
      if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this._emitChars(unicode.REPLACEMENT_CHARACTER);
      } else if (cp === $.EOF) {
        this._emitEOFToken();
      } else {
        this._emitCodePoint(cp);
      }
    }

    // Tag open state
    //------------------------------------------------------------------
  }, {
    key: TAG_OPEN_STATE,
    value: function value(cp) {
      if (cp === $.EXCLAMATION_MARK) {
        this.state = MARKUP_DECLARATION_OPEN_STATE;
      } else if (cp === $.SOLIDUS) {
        this.state = END_TAG_OPEN_STATE;
      } else if (isAsciiLetter(cp)) {
        this._createStartTagToken();
        this._reconsumeInState(TAG_NAME_STATE);
      } else if (cp === $.QUESTION_MARK) {
        this._err(ERR.unexpectedQuestionMarkInsteadOfTagName);
        this._createCommentToken();
        this._reconsumeInState(BOGUS_COMMENT_STATE);
      } else if (cp === $.EOF) {
        this._err(ERR.eofBeforeTagName);
        this._emitChars('<');
        this._emitEOFToken();
      } else {
        this._err(ERR.invalidFirstCharacterOfTagName);
        this._emitChars('<');
        this._reconsumeInState(DATA_STATE);
      }
    }

    // End tag open state
    //------------------------------------------------------------------
  }, {
    key: END_TAG_OPEN_STATE,
    value: function value(cp) {
      if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(TAG_NAME_STATE);
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.missingEndTagName);
        this.state = DATA_STATE;
      } else if (cp === $.EOF) {
        this._err(ERR.eofBeforeTagName);
        this._emitChars('</');
        this._emitEOFToken();
      } else {
        this._err(ERR.invalidFirstCharacterOfTagName);
        this._createCommentToken();
        this._reconsumeInState(BOGUS_COMMENT_STATE);
      }
    }

    // Tag name state
    //------------------------------------------------------------------
  }, {
    key: TAG_NAME_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        this.state = BEFORE_ATTRIBUTE_NAME_STATE;
      } else if (cp === $.SOLIDUS) {
        this.state = SELF_CLOSING_START_TAG_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.currentToken.tagName += unicode.REPLACEMENT_CHARACTER;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInTag);
        this._emitEOFToken();
      } else {
        this.currentToken.tagName += toChar(cp);
      }
    }

    // RCDATA less-than sign state
    //------------------------------------------------------------------
  }, {
    key: RCDATA_LESS_THAN_SIGN_STATE,
    value: function value(cp) {
      if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = RCDATA_END_TAG_OPEN_STATE;
      } else {
        this._emitChars('<');
        this._reconsumeInState(RCDATA_STATE);
      }
    }

    // RCDATA end tag open state
    //------------------------------------------------------------------
  }, {
    key: RCDATA_END_TAG_OPEN_STATE,
    value: function value(cp) {
      if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(RCDATA_END_TAG_NAME_STATE);
      } else {
        this._emitChars('</');
        this._reconsumeInState(RCDATA_STATE);
      }
    }

    // RCDATA end tag name state
    //------------------------------------------------------------------
  }, {
    key: RCDATA_END_TAG_NAME_STATE,
    value: function value(cp) {
      if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
      } else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
      } else {
        if (this.lastStartTagName === this.currentToken.tagName) {
          if (isWhitespace(cp)) {
            this.state = BEFORE_ATTRIBUTE_NAME_STATE;
            return;
          }
          if (cp === $.SOLIDUS) {
            this.state = SELF_CLOSING_START_TAG_STATE;
            return;
          }
          if (cp === $.GREATER_THAN_SIGN) {
            this.state = DATA_STATE;
            this._emitCurrentToken();
            return;
          }
        }
        this._emitChars('</');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(RCDATA_STATE);
      }
    }

    // RAWTEXT less-than sign state
    //------------------------------------------------------------------
  }, {
    key: RAWTEXT_LESS_THAN_SIGN_STATE,
    value: function value(cp) {
      if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = RAWTEXT_END_TAG_OPEN_STATE;
      } else {
        this._emitChars('<');
        this._reconsumeInState(RAWTEXT_STATE);
      }
    }

    // RAWTEXT end tag open state
    //------------------------------------------------------------------
  }, {
    key: RAWTEXT_END_TAG_OPEN_STATE,
    value: function value(cp) {
      if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(RAWTEXT_END_TAG_NAME_STATE);
      } else {
        this._emitChars('</');
        this._reconsumeInState(RAWTEXT_STATE);
      }
    }

    // RAWTEXT end tag name state
    //------------------------------------------------------------------
  }, {
    key: RAWTEXT_END_TAG_NAME_STATE,
    value: function value(cp) {
      if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
      } else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
      } else {
        if (this.lastStartTagName === this.currentToken.tagName) {
          if (isWhitespace(cp)) {
            this.state = BEFORE_ATTRIBUTE_NAME_STATE;
            return;
          }
          if (cp === $.SOLIDUS) {
            this.state = SELF_CLOSING_START_TAG_STATE;
            return;
          }
          if (cp === $.GREATER_THAN_SIGN) {
            this._emitCurrentToken();
            this.state = DATA_STATE;
            return;
          }
        }
        this._emitChars('</');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(RAWTEXT_STATE);
      }
    }

    // Script data less-than sign state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_LESS_THAN_SIGN_STATE,
    value: function value(cp) {
      if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_END_TAG_OPEN_STATE;
      } else if (cp === $.EXCLAMATION_MARK) {
        this.state = SCRIPT_DATA_ESCAPE_START_STATE;
        this._emitChars('<!');
      } else {
        this._emitChars('<');
        this._reconsumeInState(SCRIPT_DATA_STATE);
      }
    }

    // Script data end tag open state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_END_TAG_OPEN_STATE,
    value: function value(cp) {
      if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(SCRIPT_DATA_END_TAG_NAME_STATE);
      } else {
        this._emitChars('</');
        this._reconsumeInState(SCRIPT_DATA_STATE);
      }
    }

    // Script data end tag name state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_END_TAG_NAME_STATE,
    value: function value(cp) {
      if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
      } else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
      } else {
        if (this.lastStartTagName === this.currentToken.tagName) {
          if (isWhitespace(cp)) {
            this.state = BEFORE_ATTRIBUTE_NAME_STATE;
            return;
          } else if (cp === $.SOLIDUS) {
            this.state = SELF_CLOSING_START_TAG_STATE;
            return;
          } else if (cp === $.GREATER_THAN_SIGN) {
            this._emitCurrentToken();
            this.state = DATA_STATE;
            return;
          }
        }
        this._emitChars('</');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(SCRIPT_DATA_STATE);
      }
    }

    // Script data escape start state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_ESCAPE_START_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPE_START_DASH_STATE;
        this._emitChars('-');
      } else {
        this._reconsumeInState(SCRIPT_DATA_STATE);
      }
    }

    // Script data escape start dash state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_ESCAPE_START_DASH_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
        this._emitChars('-');
      } else {
        this._reconsumeInState(SCRIPT_DATA_STATE);
      }
    }

    // Script data escaped state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_ESCAPED_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_STATE;
        this._emitChars('-');
      } else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this._emitChars(unicode.REPLACEMENT_CHARACTER);
      } else if (cp === $.EOF) {
        this._err(ERR.eofInScriptHtmlCommentLikeText);
        this._emitEOFToken();
      } else {
        this._emitCodePoint(cp);
      }
    }

    // Script data escaped dash state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_ESCAPED_DASH_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_ESCAPED_DASH_DASH_STATE;
        this._emitChars('-');
      } else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitChars(unicode.REPLACEMENT_CHARACTER);
      } else if (cp === $.EOF) {
        this._err(ERR.eofInScriptHtmlCommentLikeText);
        this._emitEOFToken();
      } else {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
      }
    }

    // Script data escaped dash dash state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_ESCAPED_DASH_DASH_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this._emitChars('-');
      } else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this.state = SCRIPT_DATA_STATE;
        this._emitChars('>');
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitChars(unicode.REPLACEMENT_CHARACTER);
      } else if (cp === $.EOF) {
        this._err(ERR.eofInScriptHtmlCommentLikeText);
        this._emitEOFToken();
      } else {
        this.state = SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
      }
    }

    // Script data escaped less-than sign state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_ESCAPED_LESS_THAN_SIGN_STATE,
    value: function value(cp) {
      if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE;
      } else if (isAsciiLetter(cp)) {
        this.tempBuff = [];
        this._emitChars('<');
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE);
      } else {
        this._emitChars('<');
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
      }
    }

    // Script data escaped end tag open state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_ESCAPED_END_TAG_OPEN_STATE,
    value: function value(cp) {
      if (isAsciiLetter(cp)) {
        this._createEndTagToken();
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE);
      } else {
        this._emitChars('</');
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
      }
    }

    // Script data escaped end tag name state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_ESCAPED_END_TAG_NAME_STATE,
    value: function value(cp) {
      if (isAsciiUpper(cp)) {
        this.currentToken.tagName += toAsciiLowerChar(cp);
        this.tempBuff.push(cp);
      } else if (isAsciiLower(cp)) {
        this.currentToken.tagName += toChar(cp);
        this.tempBuff.push(cp);
      } else {
        if (this.lastStartTagName === this.currentToken.tagName) {
          if (isWhitespace(cp)) {
            this.state = BEFORE_ATTRIBUTE_NAME_STATE;
            return;
          }
          if (cp === $.SOLIDUS) {
            this.state = SELF_CLOSING_START_TAG_STATE;
            return;
          }
          if (cp === $.GREATER_THAN_SIGN) {
            this._emitCurrentToken();
            this.state = DATA_STATE;
            return;
          }
        }
        this._emitChars('</');
        this._emitSeveralCodePoints(this.tempBuff);
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
      }
    }

    // Script data double escape start state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_DOUBLE_ESCAPE_START_STATE,
    value: function value(cp) {
      if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
        this.state = this._isTempBufferEqualToScriptString() ? SCRIPT_DATA_DOUBLE_ESCAPED_STATE : SCRIPT_DATA_ESCAPED_STATE;
        this._emitCodePoint(cp);
      } else if (isAsciiUpper(cp)) {
        this.tempBuff.push(toAsciiLowerCodePoint(cp));
        this._emitCodePoint(cp);
      } else if (isAsciiLower(cp)) {
        this.tempBuff.push(cp);
        this._emitCodePoint(cp);
      } else {
        this._reconsumeInState(SCRIPT_DATA_ESCAPED_STATE);
      }
    }

    // Script data double escaped state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_DOUBLE_ESCAPED_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE;
        this._emitChars('-');
      } else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChars('<');
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this._emitChars(unicode.REPLACEMENT_CHARACTER);
      } else if (cp === $.EOF) {
        this._err(ERR.eofInScriptHtmlCommentLikeText);
        this._emitEOFToken();
      } else {
        this._emitCodePoint(cp);
      }
    }

    // Script data double escaped dash state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_DOUBLE_ESCAPED_DASH_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE;
        this._emitChars('-');
      } else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChars('<');
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitChars(unicode.REPLACEMENT_CHARACTER);
      } else if (cp === $.EOF) {
        this._err(ERR.eofInScriptHtmlCommentLikeText);
        this._emitEOFToken();
      } else {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitCodePoint(cp);
      }
    }

    // Script data double escaped dash dash state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_DOUBLE_ESCAPED_DASH_DASH_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this._emitChars('-');
      } else if (cp === $.LESS_THAN_SIGN) {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE;
        this._emitChars('<');
      } else if (cp === $.GREATER_THAN_SIGN) {
        this.state = SCRIPT_DATA_STATE;
        this._emitChars('>');
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitChars(unicode.REPLACEMENT_CHARACTER);
      } else if (cp === $.EOF) {
        this._err(ERR.eofInScriptHtmlCommentLikeText);
        this._emitEOFToken();
      } else {
        this.state = SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitCodePoint(cp);
      }
    }

    // Script data double escaped less-than sign state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_DOUBLE_ESCAPED_LESS_THAN_SIGN_STATE,
    value: function value(cp) {
      if (cp === $.SOLIDUS) {
        this.tempBuff = [];
        this.state = SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE;
        this._emitChars('/');
      } else {
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
      }
    }

    // Script data double escape end state
    //------------------------------------------------------------------
  }, {
    key: SCRIPT_DATA_DOUBLE_ESCAPE_END_STATE,
    value: function value(cp) {
      if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN) {
        this.state = this._isTempBufferEqualToScriptString() ? SCRIPT_DATA_ESCAPED_STATE : SCRIPT_DATA_DOUBLE_ESCAPED_STATE;
        this._emitCodePoint(cp);
      } else if (isAsciiUpper(cp)) {
        this.tempBuff.push(toAsciiLowerCodePoint(cp));
        this._emitCodePoint(cp);
      } else if (isAsciiLower(cp)) {
        this.tempBuff.push(cp);
        this._emitCodePoint(cp);
      } else {
        this._reconsumeInState(SCRIPT_DATA_DOUBLE_ESCAPED_STATE);
      }
    }

    // Before attribute name state
    //------------------------------------------------------------------
  }, {
    key: BEFORE_ATTRIBUTE_NAME_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        return;
      }
      if (cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF) {
        this._reconsumeInState(AFTER_ATTRIBUTE_NAME_STATE);
      } else if (cp === $.EQUALS_SIGN) {
        this._err(ERR.unexpectedEqualsSignBeforeAttributeName);
        this._createAttr('=');
        this.state = ATTRIBUTE_NAME_STATE;
      } else {
        this._createAttr('');
        this._reconsumeInState(ATTRIBUTE_NAME_STATE);
      }
    }

    // Attribute name state
    //------------------------------------------------------------------
  }, {
    key: ATTRIBUTE_NAME_STATE,
    value: function value(cp) {
      if (isWhitespace(cp) || cp === $.SOLIDUS || cp === $.GREATER_THAN_SIGN || cp === $.EOF) {
        this._leaveAttrName(AFTER_ATTRIBUTE_NAME_STATE);
        this._unconsume();
      } else if (cp === $.EQUALS_SIGN) {
        this._leaveAttrName(BEFORE_ATTRIBUTE_VALUE_STATE);
      } else if (isAsciiUpper(cp)) {
        this.currentAttr.name += toAsciiLowerChar(cp);
      } else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN) {
        this._err(ERR.unexpectedCharacterInAttributeName);
        this.currentAttr.name += toChar(cp);
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.currentAttr.name += unicode.REPLACEMENT_CHARACTER;
      } else {
        this.currentAttr.name += toChar(cp);
      }
    }

    // After attribute name state
    //------------------------------------------------------------------
  }, {
    key: AFTER_ATTRIBUTE_NAME_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        return;
      }
      if (cp === $.SOLIDUS) {
        this.state = SELF_CLOSING_START_TAG_STATE;
      } else if (cp === $.EQUALS_SIGN) {
        this.state = BEFORE_ATTRIBUTE_VALUE_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (cp === $.EOF) {
        this._err(ERR.eofInTag);
        this._emitEOFToken();
      } else {
        this._createAttr('');
        this._reconsumeInState(ATTRIBUTE_NAME_STATE);
      }
    }

    // Before attribute value state
    //------------------------------------------------------------------
  }, {
    key: BEFORE_ATTRIBUTE_VALUE_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        return;
      }
      if (cp === $.QUOTATION_MARK) {
        this.state = ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;
      } else if (cp === $.APOSTROPHE) {
        this.state = ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.missingAttributeValue);
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else {
        this._reconsumeInState(ATTRIBUTE_VALUE_UNQUOTED_STATE);
      }
    }

    // Attribute value (double-quoted) state
    //------------------------------------------------------------------
  }, {
    key: ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE,
    value: function value(cp) {
      if (cp === $.QUOTATION_MARK) {
        this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;
      } else if (cp === $.AMPERSAND) {
        this.returnState = ATTRIBUTE_VALUE_DOUBLE_QUOTED_STATE;
        this.state = CHARACTER_REFERENCE_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.currentAttr.value += unicode.REPLACEMENT_CHARACTER;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInTag);
        this._emitEOFToken();
      } else {
        this.currentAttr.value += toChar(cp);
      }
    }

    // Attribute value (single-quoted) state
    //------------------------------------------------------------------
  }, {
    key: ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE,
    value: function value(cp) {
      if (cp === $.APOSTROPHE) {
        this.state = AFTER_ATTRIBUTE_VALUE_QUOTED_STATE;
      } else if (cp === $.AMPERSAND) {
        this.returnState = ATTRIBUTE_VALUE_SINGLE_QUOTED_STATE;
        this.state = CHARACTER_REFERENCE_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.currentAttr.value += unicode.REPLACEMENT_CHARACTER;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInTag);
        this._emitEOFToken();
      } else {
        this.currentAttr.value += toChar(cp);
      }
    }

    // Attribute value (unquoted) state
    //------------------------------------------------------------------
  }, {
    key: ATTRIBUTE_VALUE_UNQUOTED_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);
      } else if (cp === $.AMPERSAND) {
        this.returnState = ATTRIBUTE_VALUE_UNQUOTED_STATE;
        this.state = CHARACTER_REFERENCE_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._leaveAttrValue(DATA_STATE);
        this._emitCurrentToken();
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.currentAttr.value += unicode.REPLACEMENT_CHARACTER;
      } else if (cp === $.QUOTATION_MARK || cp === $.APOSTROPHE || cp === $.LESS_THAN_SIGN || cp === $.EQUALS_SIGN || cp === $.GRAVE_ACCENT) {
        this._err(ERR.unexpectedCharacterInUnquotedAttributeValue);
        this.currentAttr.value += toChar(cp);
      } else if (cp === $.EOF) {
        this._err(ERR.eofInTag);
        this._emitEOFToken();
      } else {
        this.currentAttr.value += toChar(cp);
      }
    }

    // After attribute value (quoted) state
    //------------------------------------------------------------------
  }, {
    key: AFTER_ATTRIBUTE_VALUE_QUOTED_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        this._leaveAttrValue(BEFORE_ATTRIBUTE_NAME_STATE);
      } else if (cp === $.SOLIDUS) {
        this._leaveAttrValue(SELF_CLOSING_START_TAG_STATE);
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._leaveAttrValue(DATA_STATE);
        this._emitCurrentToken();
      } else if (cp === $.EOF) {
        this._err(ERR.eofInTag);
        this._emitEOFToken();
      } else {
        this._err(ERR.missingWhitespaceBetweenAttributes);
        this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
      }
    }

    // Self-closing start tag state
    //------------------------------------------------------------------
  }, {
    key: SELF_CLOSING_START_TAG_STATE,
    value: function value(cp) {
      if (cp === $.GREATER_THAN_SIGN) {
        this.currentToken.selfClosing = true;
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (cp === $.EOF) {
        this._err(ERR.eofInTag);
        this._emitEOFToken();
      } else {
        this._err(ERR.unexpectedSolidusInTag);
        this._reconsumeInState(BEFORE_ATTRIBUTE_NAME_STATE);
      }
    }

    // Bogus comment state
    //------------------------------------------------------------------
  }, {
    key: BOGUS_COMMENT_STATE,
    value: function value(cp) {
      if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._emitEOFToken();
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.currentToken.data += unicode.REPLACEMENT_CHARACTER;
      } else {
        this.currentToken.data += toChar(cp);
      }
    }

    // Markup declaration open state
    //------------------------------------------------------------------
  }, {
    key: MARKUP_DECLARATION_OPEN_STATE,
    value: function value(cp) {
      if (this._consumeSequenceIfMatch($$.DASH_DASH_STRING, cp, true)) {
        this._createCommentToken();
        this.state = COMMENT_START_STATE;
      } else if (this._consumeSequenceIfMatch($$.DOCTYPE_STRING, cp, false)) {
        this.state = DOCTYPE_STATE;
      } else if (this._consumeSequenceIfMatch($$.CDATA_START_STRING, cp, true)) {
        if (this.allowCDATA) {
          this.state = CDATA_SECTION_STATE;
        } else {
          this._err(ERR.cdataInHtmlContent);
          this._createCommentToken();
          this.currentToken.data = '[CDATA[';
          this.state = BOGUS_COMMENT_STATE;
        }
      }

      //NOTE: sequence lookup can be abrupted by hibernation. In that case lookup
      //results are no longer valid and we will need to start over.
      else if (!this._ensureHibernation()) {
        this._err(ERR.incorrectlyOpenedComment);
        this._createCommentToken();
        this._reconsumeInState(BOGUS_COMMENT_STATE);
      }
    }

    // Comment start state
    //------------------------------------------------------------------
  }, {
    key: COMMENT_START_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this.state = COMMENT_START_DASH_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.abruptClosingOfEmptyComment);
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else {
        this._reconsumeInState(COMMENT_STATE);
      }
    }

    // Comment start dash state
    //------------------------------------------------------------------
  }, {
    key: COMMENT_START_DASH_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this.state = COMMENT_END_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.abruptClosingOfEmptyComment);
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (cp === $.EOF) {
        this._err(ERR.eofInComment);
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this.currentToken.data += '-';
        this._reconsumeInState(COMMENT_STATE);
      }
    }

    // Comment state
    //------------------------------------------------------------------
  }, {
    key: COMMENT_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this.state = COMMENT_END_DASH_STATE;
      } else if (cp === $.LESS_THAN_SIGN) {
        this.currentToken.data += '<';
        this.state = COMMENT_LESS_THAN_SIGN_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.currentToken.data += unicode.REPLACEMENT_CHARACTER;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInComment);
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this.currentToken.data += toChar(cp);
      }
    }

    // Comment less-than sign state
    //------------------------------------------------------------------
  }, {
    key: COMMENT_LESS_THAN_SIGN_STATE,
    value: function value(cp) {
      if (cp === $.EXCLAMATION_MARK) {
        this.currentToken.data += '!';
        this.state = COMMENT_LESS_THAN_SIGN_BANG_STATE;
      } else if (cp === $.LESS_THAN_SIGN) {
        this.currentToken.data += '!';
      } else {
        this._reconsumeInState(COMMENT_STATE);
      }
    }

    // Comment less-than sign bang state
    //------------------------------------------------------------------
  }, {
    key: COMMENT_LESS_THAN_SIGN_BANG_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this.state = COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE;
      } else {
        this._reconsumeInState(COMMENT_STATE);
      }
    }

    // Comment less-than sign bang dash state
    //------------------------------------------------------------------
  }, {
    key: COMMENT_LESS_THAN_SIGN_BANG_DASH_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this.state = COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE;
      } else {
        this._reconsumeInState(COMMENT_END_DASH_STATE);
      }
    }

    // Comment less-than sign bang dash dash state
    //------------------------------------------------------------------
  }, {
    key: COMMENT_LESS_THAN_SIGN_BANG_DASH_DASH_STATE,
    value: function value(cp) {
      if (cp !== $.GREATER_THAN_SIGN && cp !== $.EOF) {
        this._err(ERR.nestedComment);
      }
      this._reconsumeInState(COMMENT_END_STATE);
    }

    // Comment end dash state
    //------------------------------------------------------------------
  }, {
    key: COMMENT_END_DASH_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this.state = COMMENT_END_STATE;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInComment);
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this.currentToken.data += '-';
        this._reconsumeInState(COMMENT_STATE);
      }
    }

    // Comment end state
    //------------------------------------------------------------------
  }, {
    key: COMMENT_END_STATE,
    value: function value(cp) {
      if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (cp === $.EXCLAMATION_MARK) {
        this.state = COMMENT_END_BANG_STATE;
      } else if (cp === $.HYPHEN_MINUS) {
        this.currentToken.data += '-';
      } else if (cp === $.EOF) {
        this._err(ERR.eofInComment);
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this.currentToken.data += '--';
        this._reconsumeInState(COMMENT_STATE);
      }
    }

    // Comment end bang state
    //------------------------------------------------------------------
  }, {
    key: COMMENT_END_BANG_STATE,
    value: function value(cp) {
      if (cp === $.HYPHEN_MINUS) {
        this.currentToken.data += '--!';
        this.state = COMMENT_END_DASH_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.incorrectlyClosedComment);
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (cp === $.EOF) {
        this._err(ERR.eofInComment);
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this.currentToken.data += '--!';
        this._reconsumeInState(COMMENT_STATE);
      }
    }

    // DOCTYPE state
    //------------------------------------------------------------------
  }, {
    key: DOCTYPE_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        this.state = BEFORE_DOCTYPE_NAME_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._reconsumeInState(BEFORE_DOCTYPE_NAME_STATE);
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this._createDoctypeToken(null);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this._err(ERR.missingWhitespaceBeforeDoctypeName);
        this._reconsumeInState(BEFORE_DOCTYPE_NAME_STATE);
      }
    }

    // Before DOCTYPE name state
    //------------------------------------------------------------------
  }, {
    key: BEFORE_DOCTYPE_NAME_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        return;
      }
      if (isAsciiUpper(cp)) {
        this._createDoctypeToken(toAsciiLowerChar(cp));
        this.state = DOCTYPE_NAME_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this._createDoctypeToken(unicode.REPLACEMENT_CHARACTER);
        this.state = DOCTYPE_NAME_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.missingDoctypeName);
        this._createDoctypeToken(null);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this._createDoctypeToken(null);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this._createDoctypeToken(toChar(cp));
        this.state = DOCTYPE_NAME_STATE;
      }
    }

    // DOCTYPE name state
    //------------------------------------------------------------------
  }, {
    key: DOCTYPE_NAME_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        this.state = AFTER_DOCTYPE_NAME_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (isAsciiUpper(cp)) {
        this.currentToken.name += toAsciiLowerChar(cp);
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.currentToken.name += unicode.REPLACEMENT_CHARACTER;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this.currentToken.name += toChar(cp);
      }
    }

    // After DOCTYPE name state
    //------------------------------------------------------------------
  }, {
    key: AFTER_DOCTYPE_NAME_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        return;
      }
      if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else if (this._consumeSequenceIfMatch($$.PUBLIC_STRING, cp, false)) {
        this.state = AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE;
      } else if (this._consumeSequenceIfMatch($$.SYSTEM_STRING, cp, false)) {
        this.state = AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE;
      }
      //NOTE: sequence lookup can be abrupted by hibernation. In that case lookup
      //results are no longer valid and we will need to start over.
      else if (!this._ensureHibernation()) {
        this._err(ERR.invalidCharacterSequenceAfterDoctypeName);
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
      }
    }

    // After DOCTYPE public keyword state
    //------------------------------------------------------------------
  }, {
    key: AFTER_DOCTYPE_PUBLIC_KEYWORD_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        this.state = BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
      } else if (cp === $.QUOTATION_MARK) {
        this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword);
        this.currentToken.publicId = '';
        this.state = DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
      } else if (cp === $.APOSTROPHE) {
        this._err(ERR.missingWhitespaceAfterDoctypePublicKeyword);
        this.currentToken.publicId = '';
        this.state = DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.missingDoctypePublicIdentifier);
        this.currentToken.forceQuirks = true;
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier);
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
      }
    }

    // Before DOCTYPE public identifier state
    //------------------------------------------------------------------
  }, {
    key: BEFORE_DOCTYPE_PUBLIC_IDENTIFIER_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        return;
      }
      if (cp === $.QUOTATION_MARK) {
        this.currentToken.publicId = '';
        this.state = DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE;
      } else if (cp === $.APOSTROPHE) {
        this.currentToken.publicId = '';
        this.state = DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.missingDoctypePublicIdentifier);
        this.currentToken.forceQuirks = true;
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this._err(ERR.missingQuoteBeforeDoctypePublicIdentifier);
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
      }
    }

    // DOCTYPE public identifier (double-quoted) state
    //------------------------------------------------------------------
  }, {
    key: DOCTYPE_PUBLIC_IDENTIFIER_DOUBLE_QUOTED_STATE,
    value: function value(cp) {
      if (cp === $.QUOTATION_MARK) {
        this.state = AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.currentToken.publicId += unicode.REPLACEMENT_CHARACTER;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.abruptDoctypePublicIdentifier);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this.currentToken.publicId += toChar(cp);
      }
    }

    // DOCTYPE public identifier (single-quoted) state
    //------------------------------------------------------------------
  }, {
    key: DOCTYPE_PUBLIC_IDENTIFIER_SINGLE_QUOTED_STATE,
    value: function value(cp) {
      if (cp === $.APOSTROPHE) {
        this.state = AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.currentToken.publicId += unicode.REPLACEMENT_CHARACTER;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.abruptDoctypePublicIdentifier);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this.currentToken.publicId += toChar(cp);
      }
    }

    // After DOCTYPE public identifier state
    //------------------------------------------------------------------
  }, {
    key: AFTER_DOCTYPE_PUBLIC_IDENTIFIER_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        this.state = BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (cp === $.QUOTATION_MARK) {
        this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
      } else if (cp === $.APOSTROPHE) {
        this._err(ERR.missingWhitespaceBetweenDoctypePublicAndSystemIdentifiers);
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
      }
    }

    // Between DOCTYPE public and system identifiers state
    //------------------------------------------------------------------
  }, {
    key: BETWEEN_DOCTYPE_PUBLIC_AND_SYSTEM_IDENTIFIERS_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        return;
      }
      if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
      } else if (cp === $.QUOTATION_MARK) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
      } else if (cp === $.APOSTROPHE) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
      }
    }

    // After DOCTYPE system keyword state
    //------------------------------------------------------------------
  }, {
    key: AFTER_DOCTYPE_SYSTEM_KEYWORD_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        this.state = BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
      } else if (cp === $.QUOTATION_MARK) {
        this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword);
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
      } else if (cp === $.APOSTROPHE) {
        this._err(ERR.missingWhitespaceAfterDoctypeSystemKeyword);
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.missingDoctypeSystemIdentifier);
        this.currentToken.forceQuirks = true;
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
      }
    }

    // Before DOCTYPE system identifier state
    //------------------------------------------------------------------
  }, {
    key: BEFORE_DOCTYPE_SYSTEM_IDENTIFIER_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        return;
      }
      if (cp === $.QUOTATION_MARK) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE;
      } else if (cp === $.APOSTROPHE) {
        this.currentToken.systemId = '';
        this.state = DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.missingDoctypeSystemIdentifier);
        this.currentToken.forceQuirks = true;
        this.state = DATA_STATE;
        this._emitCurrentToken();
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this._err(ERR.missingQuoteBeforeDoctypeSystemIdentifier);
        this.currentToken.forceQuirks = true;
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
      }
    }

    // DOCTYPE system identifier (double-quoted) state
    //------------------------------------------------------------------
  }, {
    key: DOCTYPE_SYSTEM_IDENTIFIER_DOUBLE_QUOTED_STATE,
    value: function value(cp) {
      if (cp === $.QUOTATION_MARK) {
        this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.currentToken.systemId += unicode.REPLACEMENT_CHARACTER;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.abruptDoctypeSystemIdentifier);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this.currentToken.systemId += toChar(cp);
      }
    }

    // DOCTYPE system identifier (single-quoted) state
    //------------------------------------------------------------------
  }, {
    key: DOCTYPE_SYSTEM_IDENTIFIER_SINGLE_QUOTED_STATE,
    value: function value(cp) {
      if (cp === $.APOSTROPHE) {
        this.state = AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
        this.currentToken.systemId += unicode.REPLACEMENT_CHARACTER;
      } else if (cp === $.GREATER_THAN_SIGN) {
        this._err(ERR.abruptDoctypeSystemIdentifier);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this.state = DATA_STATE;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this.currentToken.systemId += toChar(cp);
      }
    }

    // After DOCTYPE system identifier state
    //------------------------------------------------------------------
  }, {
    key: AFTER_DOCTYPE_SYSTEM_IDENTIFIER_STATE,
    value: function value(cp) {
      if (isWhitespace(cp)) {
        return;
      }
      if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInDoctype);
        this.currentToken.forceQuirks = true;
        this._emitCurrentToken();
        this._emitEOFToken();
      } else {
        this._err(ERR.unexpectedCharacterAfterDoctypeSystemIdentifier);
        this._reconsumeInState(BOGUS_DOCTYPE_STATE);
      }
    }

    // Bogus DOCTYPE state
    //------------------------------------------------------------------
  }, {
    key: BOGUS_DOCTYPE_STATE,
    value: function value(cp) {
      if (cp === $.GREATER_THAN_SIGN) {
        this._emitCurrentToken();
        this.state = DATA_STATE;
      } else if (cp === $.NULL) {
        this._err(ERR.unexpectedNullCharacter);
      } else if (cp === $.EOF) {
        this._emitCurrentToken();
        this._emitEOFToken();
      }
    }

    // CDATA section state
    //------------------------------------------------------------------
  }, {
    key: CDATA_SECTION_STATE,
    value: function value(cp) {
      if (cp === $.RIGHT_SQUARE_BRACKET) {
        this.state = CDATA_SECTION_BRACKET_STATE;
      } else if (cp === $.EOF) {
        this._err(ERR.eofInCdata);
        this._emitEOFToken();
      } else {
        this._emitCodePoint(cp);
      }
    }

    // CDATA section bracket state
    //------------------------------------------------------------------
  }, {
    key: CDATA_SECTION_BRACKET_STATE,
    value: function value(cp) {
      if (cp === $.RIGHT_SQUARE_BRACKET) {
        this.state = CDATA_SECTION_END_STATE;
      } else {
        this._emitChars(']');
        this._reconsumeInState(CDATA_SECTION_STATE);
      }
    }

    // CDATA section end state
    //------------------------------------------------------------------
  }, {
    key: CDATA_SECTION_END_STATE,
    value: function value(cp) {
      if (cp === $.GREATER_THAN_SIGN) {
        this.state = DATA_STATE;
      } else if (cp === $.RIGHT_SQUARE_BRACKET) {
        this._emitChars(']');
      } else {
        this._emitChars(']]');
        this._reconsumeInState(CDATA_SECTION_STATE);
      }
    }

    // Character reference state
    //------------------------------------------------------------------
  }, {
    key: CHARACTER_REFERENCE_STATE,
    value: function value(cp) {
      this.tempBuff = [$.AMPERSAND];
      if (cp === $.NUMBER_SIGN) {
        this.tempBuff.push(cp);
        this.state = NUMERIC_CHARACTER_REFERENCE_STATE;
      } else if (isAsciiAlphaNumeric(cp)) {
        this._reconsumeInState(NAMED_CHARACTER_REFERENCE_STATE);
      } else {
        this._flushCodePointsConsumedAsCharacterReference();
        this._reconsumeInState(this.returnState);
      }
    }

    // Named character reference state
    //------------------------------------------------------------------
  }, {
    key: NAMED_CHARACTER_REFERENCE_STATE,
    value: function value(cp) {
      var matchResult = this._matchNamedCharacterReference(cp);

      //NOTE: matching can be abrupted by hibernation. In that case match
      //results are no longer valid and we will need to start over.
      if (this._ensureHibernation()) {
        this.tempBuff = [$.AMPERSAND];
      } else if (matchResult) {
        var withSemicolon = this.tempBuff[this.tempBuff.length - 1] === $.SEMICOLON;
        if (!this._isCharacterReferenceAttributeQuirk(withSemicolon)) {
          if (!withSemicolon) {
            this._errOnNextCodePoint(ERR.missingSemicolonAfterCharacterReference);
          }
          this.tempBuff = matchResult;
        }
        this._flushCodePointsConsumedAsCharacterReference();
        this.state = this.returnState;
      } else {
        this._flushCodePointsConsumedAsCharacterReference();
        this.state = AMBIGUOUS_AMPERSAND_STATE;
      }
    }

    // Ambiguos ampersand state
    //------------------------------------------------------------------
  }, {
    key: AMBIGUOUS_AMPERSAND_STATE,
    value: function value(cp) {
      if (isAsciiAlphaNumeric(cp)) {
        if (this._isCharacterReferenceInAttribute()) {
          this.currentAttr.value += toChar(cp);
        } else {
          this._emitCodePoint(cp);
        }
      } else {
        if (cp === $.SEMICOLON) {
          this._err(ERR.unknownNamedCharacterReference);
        }
        this._reconsumeInState(this.returnState);
      }
    }

    // Numeric character reference state
    //------------------------------------------------------------------
  }, {
    key: NUMERIC_CHARACTER_REFERENCE_STATE,
    value: function value(cp) {
      this.charRefCode = 0;
      if (cp === $.LATIN_SMALL_X || cp === $.LATIN_CAPITAL_X) {
        this.tempBuff.push(cp);
        this.state = HEXADEMICAL_CHARACTER_REFERENCE_START_STATE;
      } else {
        this._reconsumeInState(DECIMAL_CHARACTER_REFERENCE_START_STATE);
      }
    }

    // Hexademical character reference start state
    //------------------------------------------------------------------
  }, {
    key: HEXADEMICAL_CHARACTER_REFERENCE_START_STATE,
    value: function value(cp) {
      if (isAsciiHexDigit(cp)) {
        this._reconsumeInState(HEXADEMICAL_CHARACTER_REFERENCE_STATE);
      } else {
        this._err(ERR.absenceOfDigitsInNumericCharacterReference);
        this._flushCodePointsConsumedAsCharacterReference();
        this._reconsumeInState(this.returnState);
      }
    }

    // Decimal character reference start state
    //------------------------------------------------------------------
  }, {
    key: DECIMAL_CHARACTER_REFERENCE_START_STATE,
    value: function value(cp) {
      if (isAsciiDigit(cp)) {
        this._reconsumeInState(DECIMAL_CHARACTER_REFERENCE_STATE);
      } else {
        this._err(ERR.absenceOfDigitsInNumericCharacterReference);
        this._flushCodePointsConsumedAsCharacterReference();
        this._reconsumeInState(this.returnState);
      }
    }

    // Hexademical character reference state
    //------------------------------------------------------------------
  }, {
    key: HEXADEMICAL_CHARACTER_REFERENCE_STATE,
    value: function value(cp) {
      if (isAsciiUpperHexDigit(cp)) {
        this.charRefCode = this.charRefCode * 16 + cp - 0x37;
      } else if (isAsciiLowerHexDigit(cp)) {
        this.charRefCode = this.charRefCode * 16 + cp - 0x57;
      } else if (isAsciiDigit(cp)) {
        this.charRefCode = this.charRefCode * 16 + cp - 0x30;
      } else if (cp === $.SEMICOLON) {
        this.state = NUMERIC_CHARACTER_REFERENCE_END_STATE;
      } else {
        this._err(ERR.missingSemicolonAfterCharacterReference);
        this._reconsumeInState(NUMERIC_CHARACTER_REFERENCE_END_STATE);
      }
    }

    // Decimal character reference state
    //------------------------------------------------------------------
  }, {
    key: DECIMAL_CHARACTER_REFERENCE_STATE,
    value: function value(cp) {
      if (isAsciiDigit(cp)) {
        this.charRefCode = this.charRefCode * 10 + cp - 0x30;
      } else if (cp === $.SEMICOLON) {
        this.state = NUMERIC_CHARACTER_REFERENCE_END_STATE;
      } else {
        this._err(ERR.missingSemicolonAfterCharacterReference);
        this._reconsumeInState(NUMERIC_CHARACTER_REFERENCE_END_STATE);
      }
    }

    // Numeric character reference end state
    //------------------------------------------------------------------
  }, {
    key: NUMERIC_CHARACTER_REFERENCE_END_STATE,
    value: function value() {
      if (this.charRefCode === $.NULL) {
        this._err(ERR.nullCharacterReference);
        this.charRefCode = $.REPLACEMENT_CHARACTER;
      } else if (this.charRefCode > 0x10ffff) {
        this._err(ERR.characterReferenceOutsideUnicodeRange);
        this.charRefCode = $.REPLACEMENT_CHARACTER;
      } else if (unicode.isSurrogate(this.charRefCode)) {
        this._err(ERR.surrogateCharacterReference);
        this.charRefCode = $.REPLACEMENT_CHARACTER;
      } else if (unicode.isUndefinedCodePoint(this.charRefCode)) {
        this._err(ERR.noncharacterCharacterReference);
      } else if (unicode.isControlCodePoint(this.charRefCode) || this.charRefCode === $.CARRIAGE_RETURN) {
        this._err(ERR.controlCharacterReference);
        var replacement = C1_CONTROLS_REFERENCE_REPLACEMENTS[this.charRefCode];
        if (replacement) {
          this.charRefCode = replacement;
        }
      }
      this.tempBuff = [this.charRefCode];
      this._flushCodePointsConsumedAsCharacterReference();
      this._reconsumeInState(this.returnState);
    }
  }]);
  return Tokenizer;
}(); //Token types
Tokenizer.CHARACTER_TOKEN = 'CHARACTER_TOKEN';
Tokenizer.NULL_CHARACTER_TOKEN = 'NULL_CHARACTER_TOKEN';
Tokenizer.WHITESPACE_CHARACTER_TOKEN = 'WHITESPACE_CHARACTER_TOKEN';
Tokenizer.START_TAG_TOKEN = 'START_TAG_TOKEN';
Tokenizer.END_TAG_TOKEN = 'END_TAG_TOKEN';
Tokenizer.COMMENT_TOKEN = 'COMMENT_TOKEN';
Tokenizer.DOCTYPE_TOKEN = 'DOCTYPE_TOKEN';
Tokenizer.EOF_TOKEN = 'EOF_TOKEN';
Tokenizer.HIBERNATION_TOKEN = 'HIBERNATION_TOKEN';

//Tokenizer initial states for different modes
Tokenizer.MODE = {
  DATA: DATA_STATE,
  RCDATA: RCDATA_STATE,
  RAWTEXT: RAWTEXT_STATE,
  SCRIPT_DATA: SCRIPT_DATA_STATE,
  PLAINTEXT: PLAINTEXT_STATE
};

//Static
Tokenizer.getTokenAttr = function (token, attrName) {
  for (var i = token.attrs.length - 1; i >= 0; i--) {
    if (token.attrs[i].name === attrName) {
      return token.attrs[i].value;
    }
  }
  return null;
};
module.exports = Tokenizer;

/***/ }),

/***/ 1784:
/***/ ((module) => {

"use strict";


//NOTE: this file contains auto-generated array mapped radix tree that is used for the named entity references consumption
//(details: https://github.com/inikulin/parse5/tree/master/scripts/generate-named-entity-data/README.md)
module.exports = new Uint16Array([4, 52, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 106, 303, 412, 810, 1432, 1701, 1796, 1987, 2114, 2360, 2420, 2484, 3170, 3251, 4140, 4393, 4575, 4610, 5106, 5512, 5728, 6117, 6274, 6315, 6345, 6427, 6516, 7002, 7910, 8733, 9323, 9870, 10170, 10631, 10893, 11318, 11386, 11467, 12773, 13092, 14474, 14922, 15448, 15542, 16419, 17666, 18166, 18611, 19004, 19095, 19298, 19397, 4, 16, 69, 77, 97, 98, 99, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 140, 150, 158, 169, 176, 194, 199, 210, 216, 222, 226, 242, 256, 266, 283, 294, 108, 105, 103, 5, 198, 1, 59, 148, 1, 198, 80, 5, 38, 1, 59, 156, 1, 38, 99, 117, 116, 101, 5, 193, 1, 59, 167, 1, 193, 114, 101, 118, 101, 59, 1, 258, 4, 2, 105, 121, 182, 191, 114, 99, 5, 194, 1, 59, 189, 1, 194, 59, 1, 1040, 114, 59, 3, 55349, 56580, 114, 97, 118, 101, 5, 192, 1, 59, 208, 1, 192, 112, 104, 97, 59, 1, 913, 97, 99, 114, 59, 1, 256, 100, 59, 1, 10835, 4, 2, 103, 112, 232, 237, 111, 110, 59, 1, 260, 102, 59, 3, 55349, 56632, 112, 108, 121, 70, 117, 110, 99, 116, 105, 111, 110, 59, 1, 8289, 105, 110, 103, 5, 197, 1, 59, 264, 1, 197, 4, 2, 99, 115, 272, 277, 114, 59, 3, 55349, 56476, 105, 103, 110, 59, 1, 8788, 105, 108, 100, 101, 5, 195, 1, 59, 292, 1, 195, 109, 108, 5, 196, 1, 59, 301, 1, 196, 4, 8, 97, 99, 101, 102, 111, 114, 115, 117, 321, 350, 354, 383, 388, 394, 400, 405, 4, 2, 99, 114, 327, 336, 107, 115, 108, 97, 115, 104, 59, 1, 8726, 4, 2, 118, 119, 342, 345, 59, 1, 10983, 101, 100, 59, 1, 8966, 121, 59, 1, 1041, 4, 3, 99, 114, 116, 362, 369, 379, 97, 117, 115, 101, 59, 1, 8757, 110, 111, 117, 108, 108, 105, 115, 59, 1, 8492, 97, 59, 1, 914, 114, 59, 3, 55349, 56581, 112, 102, 59, 3, 55349, 56633, 101, 118, 101, 59, 1, 728, 99, 114, 59, 1, 8492, 109, 112, 101, 113, 59, 1, 8782, 4, 14, 72, 79, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 117, 442, 447, 456, 504, 542, 547, 569, 573, 577, 616, 678, 784, 790, 796, 99, 121, 59, 1, 1063, 80, 89, 5, 169, 1, 59, 454, 1, 169, 4, 3, 99, 112, 121, 464, 470, 497, 117, 116, 101, 59, 1, 262, 4, 2, 59, 105, 476, 478, 1, 8914, 116, 97, 108, 68, 105, 102, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8517, 108, 101, 121, 115, 59, 1, 8493, 4, 4, 97, 101, 105, 111, 514, 520, 530, 535, 114, 111, 110, 59, 1, 268, 100, 105, 108, 5, 199, 1, 59, 528, 1, 199, 114, 99, 59, 1, 264, 110, 105, 110, 116, 59, 1, 8752, 111, 116, 59, 1, 266, 4, 2, 100, 110, 553, 560, 105, 108, 108, 97, 59, 1, 184, 116, 101, 114, 68, 111, 116, 59, 1, 183, 114, 59, 1, 8493, 105, 59, 1, 935, 114, 99, 108, 101, 4, 4, 68, 77, 80, 84, 591, 596, 603, 609, 111, 116, 59, 1, 8857, 105, 110, 117, 115, 59, 1, 8854, 108, 117, 115, 59, 1, 8853, 105, 109, 101, 115, 59, 1, 8855, 111, 4, 2, 99, 115, 623, 646, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8754, 101, 67, 117, 114, 108, 121, 4, 2, 68, 81, 658, 671, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8221, 117, 111, 116, 101, 59, 1, 8217, 4, 4, 108, 110, 112, 117, 688, 701, 736, 753, 111, 110, 4, 2, 59, 101, 696, 698, 1, 8759, 59, 1, 10868, 4, 3, 103, 105, 116, 709, 717, 722, 114, 117, 101, 110, 116, 59, 1, 8801, 110, 116, 59, 1, 8751, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8750, 4, 2, 102, 114, 742, 745, 59, 1, 8450, 111, 100, 117, 99, 116, 59, 1, 8720, 110, 116, 101, 114, 67, 108, 111, 99, 107, 119, 105, 115, 101, 67, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8755, 111, 115, 115, 59, 1, 10799, 99, 114, 59, 3, 55349, 56478, 112, 4, 2, 59, 67, 803, 805, 1, 8915, 97, 112, 59, 1, 8781, 4, 11, 68, 74, 83, 90, 97, 99, 101, 102, 105, 111, 115, 834, 850, 855, 860, 865, 888, 903, 916, 921, 1011, 1415, 4, 2, 59, 111, 840, 842, 1, 8517, 116, 114, 97, 104, 100, 59, 1, 10513, 99, 121, 59, 1, 1026, 99, 121, 59, 1, 1029, 99, 121, 59, 1, 1039, 4, 3, 103, 114, 115, 873, 879, 883, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8609, 104, 118, 59, 1, 10980, 4, 2, 97, 121, 894, 900, 114, 111, 110, 59, 1, 270, 59, 1, 1044, 108, 4, 2, 59, 116, 910, 912, 1, 8711, 97, 59, 1, 916, 114, 59, 3, 55349, 56583, 4, 2, 97, 102, 927, 998, 4, 2, 99, 109, 933, 992, 114, 105, 116, 105, 99, 97, 108, 4, 4, 65, 68, 71, 84, 950, 957, 978, 985, 99, 117, 116, 101, 59, 1, 180, 111, 4, 2, 116, 117, 964, 967, 59, 1, 729, 98, 108, 101, 65, 99, 117, 116, 101, 59, 1, 733, 114, 97, 118, 101, 59, 1, 96, 105, 108, 100, 101, 59, 1, 732, 111, 110, 100, 59, 1, 8900, 102, 101, 114, 101, 110, 116, 105, 97, 108, 68, 59, 1, 8518, 4, 4, 112, 116, 117, 119, 1021, 1026, 1048, 1249, 102, 59, 3, 55349, 56635, 4, 3, 59, 68, 69, 1034, 1036, 1041, 1, 168, 111, 116, 59, 1, 8412, 113, 117, 97, 108, 59, 1, 8784, 98, 108, 101, 4, 6, 67, 68, 76, 82, 85, 86, 1065, 1082, 1101, 1189, 1211, 1236, 111, 110, 116, 111, 117, 114, 73, 110, 116, 101, 103, 114, 97, 108, 59, 1, 8751, 111, 4, 2, 116, 119, 1089, 1092, 59, 1, 168, 110, 65, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 101, 111, 1107, 1141, 102, 116, 4, 3, 65, 82, 84, 1117, 1124, 1136, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8660, 101, 101, 59, 1, 10980, 110, 103, 4, 2, 76, 82, 1149, 1177, 101, 102, 116, 4, 2, 65, 82, 1158, 1165, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10233, 105, 103, 104, 116, 4, 2, 65, 84, 1199, 1206, 114, 114, 111, 119, 59, 1, 8658, 101, 101, 59, 1, 8872, 112, 4, 2, 65, 68, 1218, 1225, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8741, 110, 4, 6, 65, 66, 76, 82, 84, 97, 1264, 1292, 1299, 1352, 1391, 1408, 114, 114, 111, 119, 4, 3, 59, 66, 85, 1276, 1278, 1283, 1, 8595, 97, 114, 59, 1, 10515, 112, 65, 114, 114, 111, 119, 59, 1, 8693, 114, 101, 118, 101, 59, 1, 785, 101, 102, 116, 4, 3, 82, 84, 86, 1310, 1323, 1334, 105, 103, 104, 116, 86, 101, 99, 116, 111, 114, 59, 1, 10576, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10590, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1345, 1347, 1, 8637, 97, 114, 59, 1, 10582, 105, 103, 104, 116, 4, 2, 84, 86, 1362, 1373, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10591, 101, 99, 116, 111, 114, 4, 2, 59, 66, 1384, 1386, 1, 8641, 97, 114, 59, 1, 10583, 101, 101, 4, 2, 59, 65, 1399, 1401, 1, 8868, 114, 114, 111, 119, 59, 1, 8615, 114, 114, 111, 119, 59, 1, 8659, 4, 2, 99, 116, 1421, 1426, 114, 59, 3, 55349, 56479, 114, 111, 107, 59, 1, 272, 4, 16, 78, 84, 97, 99, 100, 102, 103, 108, 109, 111, 112, 113, 115, 116, 117, 120, 1466, 1470, 1478, 1489, 1515, 1520, 1525, 1536, 1544, 1593, 1609, 1617, 1650, 1664, 1668, 1677, 71, 59, 1, 330, 72, 5, 208, 1, 59, 1476, 1, 208, 99, 117, 116, 101, 5, 201, 1, 59, 1487, 1, 201, 4, 3, 97, 105, 121, 1497, 1503, 1512, 114, 111, 110, 59, 1, 282, 114, 99, 5, 202, 1, 59, 1510, 1, 202, 59, 1, 1069, 111, 116, 59, 1, 278, 114, 59, 3, 55349, 56584, 114, 97, 118, 101, 5, 200, 1, 59, 1534, 1, 200, 101, 109, 101, 110, 116, 59, 1, 8712, 4, 2, 97, 112, 1550, 1555, 99, 114, 59, 1, 274, 116, 121, 4, 2, 83, 86, 1563, 1576, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9723, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9643, 4, 2, 103, 112, 1599, 1604, 111, 110, 59, 1, 280, 102, 59, 3, 55349, 56636, 115, 105, 108, 111, 110, 59, 1, 917, 117, 4, 2, 97, 105, 1624, 1640, 108, 4, 2, 59, 84, 1631, 1633, 1, 10869, 105, 108, 100, 101, 59, 1, 8770, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8652, 4, 2, 99, 105, 1656, 1660, 114, 59, 1, 8496, 109, 59, 1, 10867, 97, 59, 1, 919, 109, 108, 5, 203, 1, 59, 1675, 1, 203, 4, 2, 105, 112, 1683, 1689, 115, 116, 115, 59, 1, 8707, 111, 110, 101, 110, 116, 105, 97, 108, 69, 59, 1, 8519, 4, 5, 99, 102, 105, 111, 115, 1713, 1717, 1722, 1762, 1791, 121, 59, 1, 1060, 114, 59, 3, 55349, 56585, 108, 108, 101, 100, 4, 2, 83, 86, 1732, 1745, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9724, 101, 114, 121, 83, 109, 97, 108, 108, 83, 113, 117, 97, 114, 101, 59, 1, 9642, 4, 3, 112, 114, 117, 1770, 1775, 1781, 102, 59, 3, 55349, 56637, 65, 108, 108, 59, 1, 8704, 114, 105, 101, 114, 116, 114, 102, 59, 1, 8497, 99, 114, 59, 1, 8497, 4, 12, 74, 84, 97, 98, 99, 100, 102, 103, 111, 114, 115, 116, 1822, 1827, 1834, 1848, 1855, 1877, 1882, 1887, 1890, 1896, 1978, 1984, 99, 121, 59, 1, 1027, 5, 62, 1, 59, 1832, 1, 62, 109, 109, 97, 4, 2, 59, 100, 1843, 1845, 1, 915, 59, 1, 988, 114, 101, 118, 101, 59, 1, 286, 4, 3, 101, 105, 121, 1863, 1869, 1874, 100, 105, 108, 59, 1, 290, 114, 99, 59, 1, 284, 59, 1, 1043, 111, 116, 59, 1, 288, 114, 59, 3, 55349, 56586, 59, 1, 8921, 112, 102, 59, 3, 55349, 56638, 101, 97, 116, 101, 114, 4, 6, 69, 70, 71, 76, 83, 84, 1915, 1933, 1944, 1953, 1959, 1971, 113, 117, 97, 108, 4, 2, 59, 76, 1925, 1927, 1, 8805, 101, 115, 115, 59, 1, 8923, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8807, 114, 101, 97, 116, 101, 114, 59, 1, 10914, 101, 115, 115, 59, 1, 8823, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10878, 105, 108, 100, 101, 59, 1, 8819, 99, 114, 59, 3, 55349, 56482, 59, 1, 8811, 4, 8, 65, 97, 99, 102, 105, 111, 115, 117, 2005, 2012, 2026, 2032, 2036, 2049, 2073, 2089, 82, 68, 99, 121, 59, 1, 1066, 4, 2, 99, 116, 2018, 2023, 101, 107, 59, 1, 711, 59, 1, 94, 105, 114, 99, 59, 1, 292, 114, 59, 1, 8460, 108, 98, 101, 114, 116, 83, 112, 97, 99, 101, 59, 1, 8459, 4, 2, 112, 114, 2055, 2059, 102, 59, 1, 8461, 105, 122, 111, 110, 116, 97, 108, 76, 105, 110, 101, 59, 1, 9472, 4, 2, 99, 116, 2079, 2083, 114, 59, 1, 8459, 114, 111, 107, 59, 1, 294, 109, 112, 4, 2, 68, 69, 2097, 2107, 111, 119, 110, 72, 117, 109, 112, 59, 1, 8782, 113, 117, 97, 108, 59, 1, 8783, 4, 14, 69, 74, 79, 97, 99, 100, 102, 103, 109, 110, 111, 115, 116, 117, 2144, 2149, 2155, 2160, 2171, 2189, 2194, 2198, 2209, 2245, 2307, 2329, 2334, 2341, 99, 121, 59, 1, 1045, 108, 105, 103, 59, 1, 306, 99, 121, 59, 1, 1025, 99, 117, 116, 101, 5, 205, 1, 59, 2169, 1, 205, 4, 2, 105, 121, 2177, 2186, 114, 99, 5, 206, 1, 59, 2184, 1, 206, 59, 1, 1048, 111, 116, 59, 1, 304, 114, 59, 1, 8465, 114, 97, 118, 101, 5, 204, 1, 59, 2207, 1, 204, 4, 3, 59, 97, 112, 2217, 2219, 2238, 1, 8465, 4, 2, 99, 103, 2225, 2229, 114, 59, 1, 298, 105, 110, 97, 114, 121, 73, 59, 1, 8520, 108, 105, 101, 115, 59, 1, 8658, 4, 2, 116, 118, 2251, 2281, 4, 2, 59, 101, 2257, 2259, 1, 8748, 4, 2, 103, 114, 2265, 2271, 114, 97, 108, 59, 1, 8747, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8898, 105, 115, 105, 98, 108, 101, 4, 2, 67, 84, 2293, 2300, 111, 109, 109, 97, 59, 1, 8291, 105, 109, 101, 115, 59, 1, 8290, 4, 3, 103, 112, 116, 2315, 2320, 2325, 111, 110, 59, 1, 302, 102, 59, 3, 55349, 56640, 97, 59, 1, 921, 99, 114, 59, 1, 8464, 105, 108, 100, 101, 59, 1, 296, 4, 2, 107, 109, 2347, 2352, 99, 121, 59, 1, 1030, 108, 5, 207, 1, 59, 2358, 1, 207, 4, 5, 99, 102, 111, 115, 117, 2372, 2386, 2391, 2397, 2414, 4, 2, 105, 121, 2378, 2383, 114, 99, 59, 1, 308, 59, 1, 1049, 114, 59, 3, 55349, 56589, 112, 102, 59, 3, 55349, 56641, 4, 2, 99, 101, 2403, 2408, 114, 59, 3, 55349, 56485, 114, 99, 121, 59, 1, 1032, 107, 99, 121, 59, 1, 1028, 4, 7, 72, 74, 97, 99, 102, 111, 115, 2436, 2441, 2446, 2452, 2467, 2472, 2478, 99, 121, 59, 1, 1061, 99, 121, 59, 1, 1036, 112, 112, 97, 59, 1, 922, 4, 2, 101, 121, 2458, 2464, 100, 105, 108, 59, 1, 310, 59, 1, 1050, 114, 59, 3, 55349, 56590, 112, 102, 59, 3, 55349, 56642, 99, 114, 59, 3, 55349, 56486, 4, 11, 74, 84, 97, 99, 101, 102, 108, 109, 111, 115, 116, 2508, 2513, 2520, 2562, 2585, 2981, 2986, 3004, 3011, 3146, 3167, 99, 121, 59, 1, 1033, 5, 60, 1, 59, 2518, 1, 60, 4, 5, 99, 109, 110, 112, 114, 2532, 2538, 2544, 2548, 2558, 117, 116, 101, 59, 1, 313, 98, 100, 97, 59, 1, 923, 103, 59, 1, 10218, 108, 97, 99, 101, 116, 114, 102, 59, 1, 8466, 114, 59, 1, 8606, 4, 3, 97, 101, 121, 2570, 2576, 2582, 114, 111, 110, 59, 1, 317, 100, 105, 108, 59, 1, 315, 59, 1, 1051, 4, 2, 102, 115, 2591, 2907, 116, 4, 10, 65, 67, 68, 70, 82, 84, 85, 86, 97, 114, 2614, 2663, 2672, 2728, 2735, 2760, 2820, 2870, 2888, 2895, 4, 2, 110, 114, 2620, 2633, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10216, 114, 111, 119, 4, 3, 59, 66, 82, 2644, 2646, 2651, 1, 8592, 97, 114, 59, 1, 8676, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8646, 101, 105, 108, 105, 110, 103, 59, 1, 8968, 111, 4, 2, 117, 119, 2679, 2692, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10214, 110, 4, 2, 84, 86, 2699, 2710, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10593, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2721, 2723, 1, 8643, 97, 114, 59, 1, 10585, 108, 111, 111, 114, 59, 1, 8970, 105, 103, 104, 116, 4, 2, 65, 86, 2745, 2752, 114, 114, 111, 119, 59, 1, 8596, 101, 99, 116, 111, 114, 59, 1, 10574, 4, 2, 101, 114, 2766, 2792, 101, 4, 3, 59, 65, 86, 2775, 2777, 2784, 1, 8867, 114, 114, 111, 119, 59, 1, 8612, 101, 99, 116, 111, 114, 59, 1, 10586, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 2806, 2808, 2813, 1, 8882, 97, 114, 59, 1, 10703, 113, 117, 97, 108, 59, 1, 8884, 112, 4, 3, 68, 84, 86, 2829, 2841, 2852, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10577, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10592, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2863, 2865, 1, 8639, 97, 114, 59, 1, 10584, 101, 99, 116, 111, 114, 4, 2, 59, 66, 2881, 2883, 1, 8636, 97, 114, 59, 1, 10578, 114, 114, 111, 119, 59, 1, 8656, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8660, 115, 4, 6, 69, 70, 71, 76, 83, 84, 2922, 2936, 2947, 2956, 2962, 2974, 113, 117, 97, 108, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8922, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8806, 114, 101, 97, 116, 101, 114, 59, 1, 8822, 101, 115, 115, 59, 1, 10913, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 10877, 105, 108, 100, 101, 59, 1, 8818, 114, 59, 3, 55349, 56591, 4, 2, 59, 101, 2992, 2994, 1, 8920, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8666, 105, 100, 111, 116, 59, 1, 319, 4, 3, 110, 112, 119, 3019, 3110, 3115, 103, 4, 4, 76, 82, 108, 114, 3030, 3058, 3070, 3098, 101, 102, 116, 4, 2, 65, 82, 3039, 3046, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10231, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 10230, 101, 102, 116, 4, 2, 97, 114, 3079, 3086, 114, 114, 111, 119, 59, 1, 10232, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10234, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10233, 102, 59, 3, 55349, 56643, 101, 114, 4, 2, 76, 82, 3123, 3134, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8601, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8600, 4, 3, 99, 104, 116, 3154, 3158, 3161, 114, 59, 1, 8466, 59, 1, 8624, 114, 111, 107, 59, 1, 321, 59, 1, 8810, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 3188, 3192, 3196, 3222, 3227, 3237, 3243, 3248, 112, 59, 1, 10501, 121, 59, 1, 1052, 4, 2, 100, 108, 3202, 3213, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8287, 108, 105, 110, 116, 114, 102, 59, 1, 8499, 114, 59, 3, 55349, 56592, 110, 117, 115, 80, 108, 117, 115, 59, 1, 8723, 112, 102, 59, 3, 55349, 56644, 99, 114, 59, 1, 8499, 59, 1, 924, 4, 9, 74, 97, 99, 101, 102, 111, 115, 116, 117, 3271, 3276, 3283, 3306, 3422, 3427, 4120, 4126, 4137, 99, 121, 59, 1, 1034, 99, 117, 116, 101, 59, 1, 323, 4, 3, 97, 101, 121, 3291, 3297, 3303, 114, 111, 110, 59, 1, 327, 100, 105, 108, 59, 1, 325, 59, 1, 1053, 4, 3, 103, 115, 119, 3314, 3380, 3415, 97, 116, 105, 118, 101, 4, 3, 77, 84, 86, 3327, 3340, 3365, 101, 100, 105, 117, 109, 83, 112, 97, 99, 101, 59, 1, 8203, 104, 105, 4, 2, 99, 110, 3348, 3357, 107, 83, 112, 97, 99, 101, 59, 1, 8203, 83, 112, 97, 99, 101, 59, 1, 8203, 101, 114, 121, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8203, 116, 101, 100, 4, 2, 71, 76, 3389, 3405, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 1, 8811, 101, 115, 115, 76, 101, 115, 115, 59, 1, 8810, 76, 105, 110, 101, 59, 1, 10, 114, 59, 3, 55349, 56593, 4, 4, 66, 110, 112, 116, 3437, 3444, 3460, 3464, 114, 101, 97, 107, 59, 1, 8288, 66, 114, 101, 97, 107, 105, 110, 103, 83, 112, 97, 99, 101, 59, 1, 160, 102, 59, 1, 8469, 4, 13, 59, 67, 68, 69, 71, 72, 76, 78, 80, 82, 83, 84, 86, 3492, 3494, 3517, 3536, 3578, 3657, 3685, 3784, 3823, 3860, 3915, 4066, 4107, 1, 10988, 4, 2, 111, 117, 3500, 3510, 110, 103, 114, 117, 101, 110, 116, 59, 1, 8802, 112, 67, 97, 112, 59, 1, 8813, 111, 117, 98, 108, 101, 86, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8742, 4, 3, 108, 113, 120, 3544, 3552, 3571, 101, 109, 101, 110, 116, 59, 1, 8713, 117, 97, 108, 4, 2, 59, 84, 3561, 3563, 1, 8800, 105, 108, 100, 101, 59, 3, 8770, 824, 105, 115, 116, 115, 59, 1, 8708, 114, 101, 97, 116, 101, 114, 4, 7, 59, 69, 70, 71, 76, 83, 84, 3600, 3602, 3609, 3621, 3631, 3637, 3650, 1, 8815, 113, 117, 97, 108, 59, 1, 8817, 117, 108, 108, 69, 113, 117, 97, 108, 59, 3, 8807, 824, 114, 101, 97, 116, 101, 114, 59, 3, 8811, 824, 101, 115, 115, 59, 1, 8825, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10878, 824, 105, 108, 100, 101, 59, 1, 8821, 117, 109, 112, 4, 2, 68, 69, 3666, 3677, 111, 119, 110, 72, 117, 109, 112, 59, 3, 8782, 824, 113, 117, 97, 108, 59, 3, 8783, 824, 101, 4, 2, 102, 115, 3692, 3724, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3709, 3711, 3717, 1, 8938, 97, 114, 59, 3, 10703, 824, 113, 117, 97, 108, 59, 1, 8940, 115, 4, 6, 59, 69, 71, 76, 83, 84, 3739, 3741, 3748, 3757, 3764, 3777, 1, 8814, 113, 117, 97, 108, 59, 1, 8816, 114, 101, 97, 116, 101, 114, 59, 1, 8824, 101, 115, 115, 59, 3, 8810, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 3, 10877, 824, 105, 108, 100, 101, 59, 1, 8820, 101, 115, 116, 101, 100, 4, 2, 71, 76, 3795, 3812, 114, 101, 97, 116, 101, 114, 71, 114, 101, 97, 116, 101, 114, 59, 3, 10914, 824, 101, 115, 115, 76, 101, 115, 115, 59, 3, 10913, 824, 114, 101, 99, 101, 100, 101, 115, 4, 3, 59, 69, 83, 3838, 3840, 3848, 1, 8832, 113, 117, 97, 108, 59, 3, 10927, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8928, 4, 2, 101, 105, 3866, 3881, 118, 101, 114, 115, 101, 69, 108, 101, 109, 101, 110, 116, 59, 1, 8716, 103, 104, 116, 84, 114, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 3900, 3902, 3908, 1, 8939, 97, 114, 59, 3, 10704, 824, 113, 117, 97, 108, 59, 1, 8941, 4, 2, 113, 117, 3921, 3973, 117, 97, 114, 101, 83, 117, 4, 2, 98, 112, 3933, 3952, 115, 101, 116, 4, 2, 59, 69, 3942, 3945, 3, 8847, 824, 113, 117, 97, 108, 59, 1, 8930, 101, 114, 115, 101, 116, 4, 2, 59, 69, 3963, 3966, 3, 8848, 824, 113, 117, 97, 108, 59, 1, 8931, 4, 3, 98, 99, 112, 3981, 4000, 4045, 115, 101, 116, 4, 2, 59, 69, 3990, 3993, 3, 8834, 8402, 113, 117, 97, 108, 59, 1, 8840, 99, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 4015, 4017, 4025, 4037, 1, 8833, 113, 117, 97, 108, 59, 3, 10928, 824, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8929, 105, 108, 100, 101, 59, 3, 8831, 824, 101, 114, 115, 101, 116, 4, 2, 59, 69, 4056, 4059, 3, 8835, 8402, 113, 117, 97, 108, 59, 1, 8841, 105, 108, 100, 101, 4, 4, 59, 69, 70, 84, 4080, 4082, 4089, 4100, 1, 8769, 113, 117, 97, 108, 59, 1, 8772, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8775, 105, 108, 100, 101, 59, 1, 8777, 101, 114, 116, 105, 99, 97, 108, 66, 97, 114, 59, 1, 8740, 99, 114, 59, 3, 55349, 56489, 105, 108, 100, 101, 5, 209, 1, 59, 4135, 1, 209, 59, 1, 925, 4, 14, 69, 97, 99, 100, 102, 103, 109, 111, 112, 114, 115, 116, 117, 118, 4170, 4176, 4187, 4205, 4212, 4217, 4228, 4253, 4259, 4292, 4295, 4316, 4337, 4346, 108, 105, 103, 59, 1, 338, 99, 117, 116, 101, 5, 211, 1, 59, 4185, 1, 211, 4, 2, 105, 121, 4193, 4202, 114, 99, 5, 212, 1, 59, 4200, 1, 212, 59, 1, 1054, 98, 108, 97, 99, 59, 1, 336, 114, 59, 3, 55349, 56594, 114, 97, 118, 101, 5, 210, 1, 59, 4226, 1, 210, 4, 3, 97, 101, 105, 4236, 4241, 4246, 99, 114, 59, 1, 332, 103, 97, 59, 1, 937, 99, 114, 111, 110, 59, 1, 927, 112, 102, 59, 3, 55349, 56646, 101, 110, 67, 117, 114, 108, 121, 4, 2, 68, 81, 4272, 4285, 111, 117, 98, 108, 101, 81, 117, 111, 116, 101, 59, 1, 8220, 117, 111, 116, 101, 59, 1, 8216, 59, 1, 10836, 4, 2, 99, 108, 4301, 4306, 114, 59, 3, 55349, 56490, 97, 115, 104, 5, 216, 1, 59, 4314, 1, 216, 105, 4, 2, 108, 109, 4323, 4332, 100, 101, 5, 213, 1, 59, 4330, 1, 213, 101, 115, 59, 1, 10807, 109, 108, 5, 214, 1, 59, 4344, 1, 214, 101, 114, 4, 2, 66, 80, 4354, 4380, 4, 2, 97, 114, 4360, 4364, 114, 59, 1, 8254, 97, 99, 4, 2, 101, 107, 4372, 4375, 59, 1, 9182, 101, 116, 59, 1, 9140, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9180, 4, 9, 97, 99, 102, 104, 105, 108, 111, 114, 115, 4413, 4422, 4426, 4431, 4435, 4438, 4448, 4471, 4561, 114, 116, 105, 97, 108, 68, 59, 1, 8706, 121, 59, 1, 1055, 114, 59, 3, 55349, 56595, 105, 59, 1, 934, 59, 1, 928, 117, 115, 77, 105, 110, 117, 115, 59, 1, 177, 4, 2, 105, 112, 4454, 4467, 110, 99, 97, 114, 101, 112, 108, 97, 110, 101, 59, 1, 8460, 102, 59, 1, 8473, 4, 4, 59, 101, 105, 111, 4481, 4483, 4526, 4531, 1, 10939, 99, 101, 100, 101, 115, 4, 4, 59, 69, 83, 84, 4498, 4500, 4507, 4519, 1, 8826, 113, 117, 97, 108, 59, 1, 10927, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8828, 105, 108, 100, 101, 59, 1, 8830, 109, 101, 59, 1, 8243, 4, 2, 100, 112, 4537, 4543, 117, 99, 116, 59, 1, 8719, 111, 114, 116, 105, 111, 110, 4, 2, 59, 97, 4555, 4557, 1, 8759, 108, 59, 1, 8733, 4, 2, 99, 105, 4567, 4572, 114, 59, 3, 55349, 56491, 59, 1, 936, 4, 4, 85, 102, 111, 115, 4585, 4594, 4599, 4604, 79, 84, 5, 34, 1, 59, 4592, 1, 34, 114, 59, 3, 55349, 56596, 112, 102, 59, 1, 8474, 99, 114, 59, 3, 55349, 56492, 4, 12, 66, 69, 97, 99, 101, 102, 104, 105, 111, 114, 115, 117, 4636, 4642, 4650, 4681, 4704, 4763, 4767, 4771, 5047, 5069, 5081, 5094, 97, 114, 114, 59, 1, 10512, 71, 5, 174, 1, 59, 4648, 1, 174, 4, 3, 99, 110, 114, 4658, 4664, 4668, 117, 116, 101, 59, 1, 340, 103, 59, 1, 10219, 114, 4, 2, 59, 116, 4675, 4677, 1, 8608, 108, 59, 1, 10518, 4, 3, 97, 101, 121, 4689, 4695, 4701, 114, 111, 110, 59, 1, 344, 100, 105, 108, 59, 1, 342, 59, 1, 1056, 4, 2, 59, 118, 4710, 4712, 1, 8476, 101, 114, 115, 101, 4, 2, 69, 85, 4722, 4748, 4, 2, 108, 113, 4728, 4736, 101, 109, 101, 110, 116, 59, 1, 8715, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 8651, 112, 69, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10607, 114, 59, 1, 8476, 111, 59, 1, 929, 103, 104, 116, 4, 8, 65, 67, 68, 70, 84, 85, 86, 97, 4792, 4840, 4849, 4905, 4912, 4972, 5022, 5040, 4, 2, 110, 114, 4798, 4811, 103, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10217, 114, 111, 119, 4, 3, 59, 66, 76, 4822, 4824, 4829, 1, 8594, 97, 114, 59, 1, 8677, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8644, 101, 105, 108, 105, 110, 103, 59, 1, 8969, 111, 4, 2, 117, 119, 4856, 4869, 98, 108, 101, 66, 114, 97, 99, 107, 101, 116, 59, 1, 10215, 110, 4, 2, 84, 86, 4876, 4887, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10589, 101, 99, 116, 111, 114, 4, 2, 59, 66, 4898, 4900, 1, 8642, 97, 114, 59, 1, 10581, 108, 111, 111, 114, 59, 1, 8971, 4, 2, 101, 114, 4918, 4944, 101, 4, 3, 59, 65, 86, 4927, 4929, 4936, 1, 8866, 114, 114, 111, 119, 59, 1, 8614, 101, 99, 116, 111, 114, 59, 1, 10587, 105, 97, 110, 103, 108, 101, 4, 3, 59, 66, 69, 4958, 4960, 4965, 1, 8883, 97, 114, 59, 1, 10704, 113, 117, 97, 108, 59, 1, 8885, 112, 4, 3, 68, 84, 86, 4981, 4993, 5004, 111, 119, 110, 86, 101, 99, 116, 111, 114, 59, 1, 10575, 101, 101, 86, 101, 99, 116, 111, 114, 59, 1, 10588, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5015, 5017, 1, 8638, 97, 114, 59, 1, 10580, 101, 99, 116, 111, 114, 4, 2, 59, 66, 5033, 5035, 1, 8640, 97, 114, 59, 1, 10579, 114, 114, 111, 119, 59, 1, 8658, 4, 2, 112, 117, 5053, 5057, 102, 59, 1, 8477, 110, 100, 73, 109, 112, 108, 105, 101, 115, 59, 1, 10608, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8667, 4, 2, 99, 104, 5087, 5091, 114, 59, 1, 8475, 59, 1, 8625, 108, 101, 68, 101, 108, 97, 121, 101, 100, 59, 1, 10740, 4, 13, 72, 79, 97, 99, 102, 104, 105, 109, 111, 113, 115, 116, 117, 5134, 5150, 5157, 5164, 5198, 5203, 5259, 5265, 5277, 5283, 5374, 5380, 5385, 4, 2, 67, 99, 5140, 5146, 72, 99, 121, 59, 1, 1065, 121, 59, 1, 1064, 70, 84, 99, 121, 59, 1, 1068, 99, 117, 116, 101, 59, 1, 346, 4, 5, 59, 97, 101, 105, 121, 5176, 5178, 5184, 5190, 5195, 1, 10940, 114, 111, 110, 59, 1, 352, 100, 105, 108, 59, 1, 350, 114, 99, 59, 1, 348, 59, 1, 1057, 114, 59, 3, 55349, 56598, 111, 114, 116, 4, 4, 68, 76, 82, 85, 5216, 5227, 5238, 5250, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8595, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8592, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8594, 112, 65, 114, 114, 111, 119, 59, 1, 8593, 103, 109, 97, 59, 1, 931, 97, 108, 108, 67, 105, 114, 99, 108, 101, 59, 1, 8728, 112, 102, 59, 3, 55349, 56650, 4, 2, 114, 117, 5289, 5293, 116, 59, 1, 8730, 97, 114, 101, 4, 4, 59, 73, 83, 85, 5306, 5308, 5322, 5367, 1, 9633, 110, 116, 101, 114, 115, 101, 99, 116, 105, 111, 110, 59, 1, 8851, 117, 4, 2, 98, 112, 5329, 5347, 115, 101, 116, 4, 2, 59, 69, 5338, 5340, 1, 8847, 113, 117, 97, 108, 59, 1, 8849, 101, 114, 115, 101, 116, 4, 2, 59, 69, 5358, 5360, 1, 8848, 113, 117, 97, 108, 59, 1, 8850, 110, 105, 111, 110, 59, 1, 8852, 99, 114, 59, 3, 55349, 56494, 97, 114, 59, 1, 8902, 4, 4, 98, 99, 109, 112, 5395, 5420, 5475, 5478, 4, 2, 59, 115, 5401, 5403, 1, 8912, 101, 116, 4, 2, 59, 69, 5411, 5413, 1, 8912, 113, 117, 97, 108, 59, 1, 8838, 4, 2, 99, 104, 5426, 5468, 101, 101, 100, 115, 4, 4, 59, 69, 83, 84, 5440, 5442, 5449, 5461, 1, 8827, 113, 117, 97, 108, 59, 1, 10928, 108, 97, 110, 116, 69, 113, 117, 97, 108, 59, 1, 8829, 105, 108, 100, 101, 59, 1, 8831, 84, 104, 97, 116, 59, 1, 8715, 59, 1, 8721, 4, 3, 59, 101, 115, 5486, 5488, 5507, 1, 8913, 114, 115, 101, 116, 4, 2, 59, 69, 5498, 5500, 1, 8835, 113, 117, 97, 108, 59, 1, 8839, 101, 116, 59, 1, 8913, 4, 11, 72, 82, 83, 97, 99, 102, 104, 105, 111, 114, 115, 5536, 5546, 5552, 5567, 5579, 5602, 5607, 5655, 5695, 5701, 5711, 79, 82, 78, 5, 222, 1, 59, 5544, 1, 222, 65, 68, 69, 59, 1, 8482, 4, 2, 72, 99, 5558, 5563, 99, 121, 59, 1, 1035, 121, 59, 1, 1062, 4, 2, 98, 117, 5573, 5576, 59, 1, 9, 59, 1, 932, 4, 3, 97, 101, 121, 5587, 5593, 5599, 114, 111, 110, 59, 1, 356, 100, 105, 108, 59, 1, 354, 59, 1, 1058, 114, 59, 3, 55349, 56599, 4, 2, 101, 105, 5613, 5631, 4, 2, 114, 116, 5619, 5627, 101, 102, 111, 114, 101, 59, 1, 8756, 97, 59, 1, 920, 4, 2, 99, 110, 5637, 5647, 107, 83, 112, 97, 99, 101, 59, 3, 8287, 8202, 83, 112, 97, 99, 101, 59, 1, 8201, 108, 100, 101, 4, 4, 59, 69, 70, 84, 5668, 5670, 5677, 5688, 1, 8764, 113, 117, 97, 108, 59, 1, 8771, 117, 108, 108, 69, 113, 117, 97, 108, 59, 1, 8773, 105, 108, 100, 101, 59, 1, 8776, 112, 102, 59, 3, 55349, 56651, 105, 112, 108, 101, 68, 111, 116, 59, 1, 8411, 4, 2, 99, 116, 5717, 5722, 114, 59, 3, 55349, 56495, 114, 111, 107, 59, 1, 358, 4, 14, 97, 98, 99, 100, 102, 103, 109, 110, 111, 112, 114, 115, 116, 117, 5758, 5789, 5805, 5823, 5830, 5835, 5846, 5852, 5921, 5937, 6089, 6095, 6101, 6108, 4, 2, 99, 114, 5764, 5774, 117, 116, 101, 5, 218, 1, 59, 5772, 1, 218, 114, 4, 2, 59, 111, 5781, 5783, 1, 8607, 99, 105, 114, 59, 1, 10569, 114, 4, 2, 99, 101, 5796, 5800, 121, 59, 1, 1038, 118, 101, 59, 1, 364, 4, 2, 105, 121, 5811, 5820, 114, 99, 5, 219, 1, 59, 5818, 1, 219, 59, 1, 1059, 98, 108, 97, 99, 59, 1, 368, 114, 59, 3, 55349, 56600, 114, 97, 118, 101, 5, 217, 1, 59, 5844, 1, 217, 97, 99, 114, 59, 1, 362, 4, 2, 100, 105, 5858, 5905, 101, 114, 4, 2, 66, 80, 5866, 5892, 4, 2, 97, 114, 5872, 5876, 114, 59, 1, 95, 97, 99, 4, 2, 101, 107, 5884, 5887, 59, 1, 9183, 101, 116, 59, 1, 9141, 97, 114, 101, 110, 116, 104, 101, 115, 105, 115, 59, 1, 9181, 111, 110, 4, 2, 59, 80, 5913, 5915, 1, 8899, 108, 117, 115, 59, 1, 8846, 4, 2, 103, 112, 5927, 5932, 111, 110, 59, 1, 370, 102, 59, 3, 55349, 56652, 4, 8, 65, 68, 69, 84, 97, 100, 112, 115, 5955, 5985, 5996, 6009, 6026, 6033, 6044, 6075, 114, 114, 111, 119, 4, 3, 59, 66, 68, 5967, 5969, 5974, 1, 8593, 97, 114, 59, 1, 10514, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8645, 111, 119, 110, 65, 114, 114, 111, 119, 59, 1, 8597, 113, 117, 105, 108, 105, 98, 114, 105, 117, 109, 59, 1, 10606, 101, 101, 4, 2, 59, 65, 6017, 6019, 1, 8869, 114, 114, 111, 119, 59, 1, 8613, 114, 114, 111, 119, 59, 1, 8657, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8661, 101, 114, 4, 2, 76, 82, 6052, 6063, 101, 102, 116, 65, 114, 114, 111, 119, 59, 1, 8598, 105, 103, 104, 116, 65, 114, 114, 111, 119, 59, 1, 8599, 105, 4, 2, 59, 108, 6082, 6084, 1, 978, 111, 110, 59, 1, 933, 105, 110, 103, 59, 1, 366, 99, 114, 59, 3, 55349, 56496, 105, 108, 100, 101, 59, 1, 360, 109, 108, 5, 220, 1, 59, 6115, 1, 220, 4, 9, 68, 98, 99, 100, 101, 102, 111, 115, 118, 6137, 6143, 6148, 6152, 6166, 6250, 6255, 6261, 6267, 97, 115, 104, 59, 1, 8875, 97, 114, 59, 1, 10987, 121, 59, 1, 1042, 97, 115, 104, 4, 2, 59, 108, 6161, 6163, 1, 8873, 59, 1, 10982, 4, 2, 101, 114, 6172, 6175, 59, 1, 8897, 4, 3, 98, 116, 121, 6183, 6188, 6238, 97, 114, 59, 1, 8214, 4, 2, 59, 105, 6194, 6196, 1, 8214, 99, 97, 108, 4, 4, 66, 76, 83, 84, 6209, 6214, 6220, 6231, 97, 114, 59, 1, 8739, 105, 110, 101, 59, 1, 124, 101, 112, 97, 114, 97, 116, 111, 114, 59, 1, 10072, 105, 108, 100, 101, 59, 1, 8768, 84, 104, 105, 110, 83, 112, 97, 99, 101, 59, 1, 8202, 114, 59, 3, 55349, 56601, 112, 102, 59, 3, 55349, 56653, 99, 114, 59, 3, 55349, 56497, 100, 97, 115, 104, 59, 1, 8874, 4, 5, 99, 101, 102, 111, 115, 6286, 6292, 6298, 6303, 6309, 105, 114, 99, 59, 1, 372, 100, 103, 101, 59, 1, 8896, 114, 59, 3, 55349, 56602, 112, 102, 59, 3, 55349, 56654, 99, 114, 59, 3, 55349, 56498, 4, 4, 102, 105, 111, 115, 6325, 6330, 6333, 6339, 114, 59, 3, 55349, 56603, 59, 1, 926, 112, 102, 59, 3, 55349, 56655, 99, 114, 59, 3, 55349, 56499, 4, 9, 65, 73, 85, 97, 99, 102, 111, 115, 117, 6365, 6370, 6375, 6380, 6391, 6405, 6410, 6416, 6422, 99, 121, 59, 1, 1071, 99, 121, 59, 1, 1031, 99, 121, 59, 1, 1070, 99, 117, 116, 101, 5, 221, 1, 59, 6389, 1, 221, 4, 2, 105, 121, 6397, 6402, 114, 99, 59, 1, 374, 59, 1, 1067, 114, 59, 3, 55349, 56604, 112, 102, 59, 3, 55349, 56656, 99, 114, 59, 3, 55349, 56500, 109, 108, 59, 1, 376, 4, 8, 72, 97, 99, 100, 101, 102, 111, 115, 6445, 6450, 6457, 6472, 6477, 6501, 6505, 6510, 99, 121, 59, 1, 1046, 99, 117, 116, 101, 59, 1, 377, 4, 2, 97, 121, 6463, 6469, 114, 111, 110, 59, 1, 381, 59, 1, 1047, 111, 116, 59, 1, 379, 4, 2, 114, 116, 6483, 6497, 111, 87, 105, 100, 116, 104, 83, 112, 97, 99, 101, 59, 1, 8203, 97, 59, 1, 918, 114, 59, 1, 8488, 112, 102, 59, 1, 8484, 99, 114, 59, 3, 55349, 56501, 4, 16, 97, 98, 99, 101, 102, 103, 108, 109, 110, 111, 112, 114, 115, 116, 117, 119, 6550, 6561, 6568, 6612, 6622, 6634, 6645, 6672, 6699, 6854, 6870, 6923, 6933, 6963, 6974, 6983, 99, 117, 116, 101, 5, 225, 1, 59, 6559, 1, 225, 114, 101, 118, 101, 59, 1, 259, 4, 6, 59, 69, 100, 105, 117, 121, 6582, 6584, 6588, 6591, 6600, 6609, 1, 8766, 59, 3, 8766, 819, 59, 1, 8767, 114, 99, 5, 226, 1, 59, 6598, 1, 226, 116, 101, 5, 180, 1, 59, 6607, 1, 180, 59, 1, 1072, 108, 105, 103, 5, 230, 1, 59, 6620, 1, 230, 4, 2, 59, 114, 6628, 6630, 1, 8289, 59, 3, 55349, 56606, 114, 97, 118, 101, 5, 224, 1, 59, 6643, 1, 224, 4, 2, 101, 112, 6651, 6667, 4, 2, 102, 112, 6657, 6663, 115, 121, 109, 59, 1, 8501, 104, 59, 1, 8501, 104, 97, 59, 1, 945, 4, 2, 97, 112, 6678, 6692, 4, 2, 99, 108, 6684, 6688, 114, 59, 1, 257, 103, 59, 1, 10815, 5, 38, 1, 59, 6697, 1, 38, 4, 2, 100, 103, 6705, 6737, 4, 5, 59, 97, 100, 115, 118, 6717, 6719, 6724, 6727, 6734, 1, 8743, 110, 100, 59, 1, 10837, 59, 1, 10844, 108, 111, 112, 101, 59, 1, 10840, 59, 1, 10842, 4, 7, 59, 101, 108, 109, 114, 115, 122, 6753, 6755, 6758, 6762, 6814, 6835, 6848, 1, 8736, 59, 1, 10660, 101, 59, 1, 8736, 115, 100, 4, 2, 59, 97, 6770, 6772, 1, 8737, 4, 8, 97, 98, 99, 100, 101, 102, 103, 104, 6790, 6793, 6796, 6799, 6802, 6805, 6808, 6811, 59, 1, 10664, 59, 1, 10665, 59, 1, 10666, 59, 1, 10667, 59, 1, 10668, 59, 1, 10669, 59, 1, 10670, 59, 1, 10671, 116, 4, 2, 59, 118, 6821, 6823, 1, 8735, 98, 4, 2, 59, 100, 6830, 6832, 1, 8894, 59, 1, 10653, 4, 2, 112, 116, 6841, 6845, 104, 59, 1, 8738, 59, 1, 197, 97, 114, 114, 59, 1, 9084, 4, 2, 103, 112, 6860, 6865, 111, 110, 59, 1, 261, 102, 59, 3, 55349, 56658, 4, 7, 59, 69, 97, 101, 105, 111, 112, 6886, 6888, 6891, 6897, 6900, 6904, 6908, 1, 8776, 59, 1, 10864, 99, 105, 114, 59, 1, 10863, 59, 1, 8778, 100, 59, 1, 8779, 115, 59, 1, 39, 114, 111, 120, 4, 2, 59, 101, 6917, 6919, 1, 8776, 113, 59, 1, 8778, 105, 110, 103, 5, 229, 1, 59, 6931, 1, 229, 4, 3, 99, 116, 121, 6941, 6946, 6949, 114, 59, 3, 55349, 56502, 59, 1, 42, 109, 112, 4, 2, 59, 101, 6957, 6959, 1, 8776, 113, 59, 1, 8781, 105, 108, 100, 101, 5, 227, 1, 59, 6972, 1, 227, 109, 108, 5, 228, 1, 59, 6981, 1, 228, 4, 2, 99, 105, 6989, 6997, 111, 110, 105, 110, 116, 59, 1, 8755, 110, 116, 59, 1, 10769, 4, 16, 78, 97, 98, 99, 100, 101, 102, 105, 107, 108, 110, 111, 112, 114, 115, 117, 7036, 7041, 7119, 7135, 7149, 7155, 7219, 7224, 7347, 7354, 7463, 7489, 7786, 7793, 7814, 7866, 111, 116, 59, 1, 10989, 4, 2, 99, 114, 7047, 7094, 107, 4, 4, 99, 101, 112, 115, 7058, 7064, 7073, 7080, 111, 110, 103, 59, 1, 8780, 112, 115, 105, 108, 111, 110, 59, 1, 1014, 114, 105, 109, 101, 59, 1, 8245, 105, 109, 4, 2, 59, 101, 7088, 7090, 1, 8765, 113, 59, 1, 8909, 4, 2, 118, 119, 7100, 7105, 101, 101, 59, 1, 8893, 101, 100, 4, 2, 59, 103, 7113, 7115, 1, 8965, 101, 59, 1, 8965, 114, 107, 4, 2, 59, 116, 7127, 7129, 1, 9141, 98, 114, 107, 59, 1, 9142, 4, 2, 111, 121, 7141, 7146, 110, 103, 59, 1, 8780, 59, 1, 1073, 113, 117, 111, 59, 1, 8222, 4, 5, 99, 109, 112, 114, 116, 7167, 7181, 7188, 7193, 7199, 97, 117, 115, 4, 2, 59, 101, 7176, 7178, 1, 8757, 59, 1, 8757, 112, 116, 121, 118, 59, 1, 10672, 115, 105, 59, 1, 1014, 110, 111, 117, 59, 1, 8492, 4, 3, 97, 104, 119, 7207, 7210, 7213, 59, 1, 946, 59, 1, 8502, 101, 101, 110, 59, 1, 8812, 114, 59, 3, 55349, 56607, 103, 4, 7, 99, 111, 115, 116, 117, 118, 119, 7241, 7262, 7288, 7305, 7328, 7335, 7340, 4, 3, 97, 105, 117, 7249, 7253, 7258, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 4, 3, 100, 112, 116, 7270, 7275, 7281, 111, 116, 59, 1, 10752, 108, 117, 115, 59, 1, 10753, 105, 109, 101, 115, 59, 1, 10754, 4, 2, 113, 116, 7294, 7300, 99, 117, 112, 59, 1, 10758, 97, 114, 59, 1, 9733, 114, 105, 97, 110, 103, 108, 101, 4, 2, 100, 117, 7318, 7324, 111, 119, 110, 59, 1, 9661, 112, 59, 1, 9651, 112, 108, 117, 115, 59, 1, 10756, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 97, 114, 111, 119, 59, 1, 10509, 4, 3, 97, 107, 111, 7362, 7436, 7458, 4, 2, 99, 110, 7368, 7432, 107, 4, 3, 108, 115, 116, 7377, 7386, 7394, 111, 122, 101, 110, 103, 101, 59, 1, 10731, 113, 117, 97, 114, 101, 59, 1, 9642, 114, 105, 97, 110, 103, 108, 101, 4, 4, 59, 100, 108, 114, 7411, 7413, 7419, 7425, 1, 9652, 111, 119, 110, 59, 1, 9662, 101, 102, 116, 59, 1, 9666, 105, 103, 104, 116, 59, 1, 9656, 107, 59, 1, 9251, 4, 2, 49, 51, 7442, 7454, 4, 2, 50, 52, 7448, 7451, 59, 1, 9618, 59, 1, 9617, 52, 59, 1, 9619, 99, 107, 59, 1, 9608, 4, 2, 101, 111, 7469, 7485, 4, 2, 59, 113, 7475, 7478, 3, 61, 8421, 117, 105, 118, 59, 3, 8801, 8421, 116, 59, 1, 8976, 4, 4, 112, 116, 119, 120, 7499, 7504, 7517, 7523, 102, 59, 3, 55349, 56659, 4, 2, 59, 116, 7510, 7512, 1, 8869, 111, 109, 59, 1, 8869, 116, 105, 101, 59, 1, 8904, 4, 12, 68, 72, 85, 86, 98, 100, 104, 109, 112, 116, 117, 118, 7549, 7571, 7597, 7619, 7655, 7660, 7682, 7708, 7715, 7721, 7728, 7750, 4, 4, 76, 82, 108, 114, 7559, 7562, 7565, 7568, 59, 1, 9559, 59, 1, 9556, 59, 1, 9558, 59, 1, 9555, 4, 5, 59, 68, 85, 100, 117, 7583, 7585, 7588, 7591, 7594, 1, 9552, 59, 1, 9574, 59, 1, 9577, 59, 1, 9572, 59, 1, 9575, 4, 4, 76, 82, 108, 114, 7607, 7610, 7613, 7616, 59, 1, 9565, 59, 1, 9562, 59, 1, 9564, 59, 1, 9561, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7635, 7637, 7640, 7643, 7646, 7649, 7652, 1, 9553, 59, 1, 9580, 59, 1, 9571, 59, 1, 9568, 59, 1, 9579, 59, 1, 9570, 59, 1, 9567, 111, 120, 59, 1, 10697, 4, 4, 76, 82, 108, 114, 7670, 7673, 7676, 7679, 59, 1, 9557, 59, 1, 9554, 59, 1, 9488, 59, 1, 9484, 4, 5, 59, 68, 85, 100, 117, 7694, 7696, 7699, 7702, 7705, 1, 9472, 59, 1, 9573, 59, 1, 9576, 59, 1, 9516, 59, 1, 9524, 105, 110, 117, 115, 59, 1, 8863, 108, 117, 115, 59, 1, 8862, 105, 109, 101, 115, 59, 1, 8864, 4, 4, 76, 82, 108, 114, 7738, 7741, 7744, 7747, 59, 1, 9563, 59, 1, 9560, 59, 1, 9496, 59, 1, 9492, 4, 7, 59, 72, 76, 82, 104, 108, 114, 7766, 7768, 7771, 7774, 7777, 7780, 7783, 1, 9474, 59, 1, 9578, 59, 1, 9569, 59, 1, 9566, 59, 1, 9532, 59, 1, 9508, 59, 1, 9500, 114, 105, 109, 101, 59, 1, 8245, 4, 2, 101, 118, 7799, 7804, 118, 101, 59, 1, 728, 98, 97, 114, 5, 166, 1, 59, 7812, 1, 166, 4, 4, 99, 101, 105, 111, 7824, 7829, 7834, 7846, 114, 59, 3, 55349, 56503, 109, 105, 59, 1, 8271, 109, 4, 2, 59, 101, 7841, 7843, 1, 8765, 59, 1, 8909, 108, 4, 3, 59, 98, 104, 7855, 7857, 7860, 1, 92, 59, 1, 10693, 115, 117, 98, 59, 1, 10184, 4, 2, 108, 109, 7872, 7885, 108, 4, 2, 59, 101, 7879, 7881, 1, 8226, 116, 59, 1, 8226, 112, 4, 3, 59, 69, 101, 7894, 7896, 7899, 1, 8782, 59, 1, 10926, 4, 2, 59, 113, 7905, 7907, 1, 8783, 59, 1, 8783, 4, 15, 97, 99, 100, 101, 102, 104, 105, 108, 111, 114, 115, 116, 117, 119, 121, 7942, 8021, 8075, 8080, 8121, 8126, 8157, 8279, 8295, 8430, 8446, 8485, 8491, 8707, 8726, 4, 3, 99, 112, 114, 7950, 7956, 8007, 117, 116, 101, 59, 1, 263, 4, 6, 59, 97, 98, 99, 100, 115, 7970, 7972, 7977, 7984, 7998, 8003, 1, 8745, 110, 100, 59, 1, 10820, 114, 99, 117, 112, 59, 1, 10825, 4, 2, 97, 117, 7990, 7994, 112, 59, 1, 10827, 112, 59, 1, 10823, 111, 116, 59, 1, 10816, 59, 3, 8745, 65024, 4, 2, 101, 111, 8013, 8017, 116, 59, 1, 8257, 110, 59, 1, 711, 4, 4, 97, 101, 105, 117, 8031, 8046, 8056, 8061, 4, 2, 112, 114, 8037, 8041, 115, 59, 1, 10829, 111, 110, 59, 1, 269, 100, 105, 108, 5, 231, 1, 59, 8054, 1, 231, 114, 99, 59, 1, 265, 112, 115, 4, 2, 59, 115, 8069, 8071, 1, 10828, 109, 59, 1, 10832, 111, 116, 59, 1, 267, 4, 3, 100, 109, 110, 8088, 8097, 8104, 105, 108, 5, 184, 1, 59, 8095, 1, 184, 112, 116, 121, 118, 59, 1, 10674, 116, 5, 162, 2, 59, 101, 8112, 8114, 1, 162, 114, 100, 111, 116, 59, 1, 183, 114, 59, 3, 55349, 56608, 4, 3, 99, 101, 105, 8134, 8138, 8154, 121, 59, 1, 1095, 99, 107, 4, 2, 59, 109, 8146, 8148, 1, 10003, 97, 114, 107, 59, 1, 10003, 59, 1, 967, 114, 4, 7, 59, 69, 99, 101, 102, 109, 115, 8174, 8176, 8179, 8258, 8261, 8268, 8273, 1, 9675, 59, 1, 10691, 4, 3, 59, 101, 108, 8187, 8189, 8193, 1, 710, 113, 59, 1, 8791, 101, 4, 2, 97, 100, 8200, 8223, 114, 114, 111, 119, 4, 2, 108, 114, 8210, 8216, 101, 102, 116, 59, 1, 8634, 105, 103, 104, 116, 59, 1, 8635, 4, 5, 82, 83, 97, 99, 100, 8235, 8238, 8241, 8246, 8252, 59, 1, 174, 59, 1, 9416, 115, 116, 59, 1, 8859, 105, 114, 99, 59, 1, 8858, 97, 115, 104, 59, 1, 8861, 59, 1, 8791, 110, 105, 110, 116, 59, 1, 10768, 105, 100, 59, 1, 10991, 99, 105, 114, 59, 1, 10690, 117, 98, 115, 4, 2, 59, 117, 8288, 8290, 1, 9827, 105, 116, 59, 1, 9827, 4, 4, 108, 109, 110, 112, 8305, 8326, 8376, 8400, 111, 110, 4, 2, 59, 101, 8313, 8315, 1, 58, 4, 2, 59, 113, 8321, 8323, 1, 8788, 59, 1, 8788, 4, 2, 109, 112, 8332, 8344, 97, 4, 2, 59, 116, 8339, 8341, 1, 44, 59, 1, 64, 4, 3, 59, 102, 108, 8352, 8354, 8358, 1, 8705, 110, 59, 1, 8728, 101, 4, 2, 109, 120, 8365, 8371, 101, 110, 116, 59, 1, 8705, 101, 115, 59, 1, 8450, 4, 2, 103, 105, 8382, 8395, 4, 2, 59, 100, 8388, 8390, 1, 8773, 111, 116, 59, 1, 10861, 110, 116, 59, 1, 8750, 4, 3, 102, 114, 121, 8408, 8412, 8417, 59, 3, 55349, 56660, 111, 100, 59, 1, 8720, 5, 169, 2, 59, 115, 8424, 8426, 1, 169, 114, 59, 1, 8471, 4, 2, 97, 111, 8436, 8441, 114, 114, 59, 1, 8629, 115, 115, 59, 1, 10007, 4, 2, 99, 117, 8452, 8457, 114, 59, 3, 55349, 56504, 4, 2, 98, 112, 8463, 8474, 4, 2, 59, 101, 8469, 8471, 1, 10959, 59, 1, 10961, 4, 2, 59, 101, 8480, 8482, 1, 10960, 59, 1, 10962, 100, 111, 116, 59, 1, 8943, 4, 7, 100, 101, 108, 112, 114, 118, 119, 8507, 8522, 8536, 8550, 8600, 8697, 8702, 97, 114, 114, 4, 2, 108, 114, 8516, 8519, 59, 1, 10552, 59, 1, 10549, 4, 2, 112, 115, 8528, 8532, 114, 59, 1, 8926, 99, 59, 1, 8927, 97, 114, 114, 4, 2, 59, 112, 8545, 8547, 1, 8630, 59, 1, 10557, 4, 6, 59, 98, 99, 100, 111, 115, 8564, 8566, 8573, 8587, 8592, 8596, 1, 8746, 114, 99, 97, 112, 59, 1, 10824, 4, 2, 97, 117, 8579, 8583, 112, 59, 1, 10822, 112, 59, 1, 10826, 111, 116, 59, 1, 8845, 114, 59, 1, 10821, 59, 3, 8746, 65024, 4, 4, 97, 108, 114, 118, 8610, 8623, 8663, 8672, 114, 114, 4, 2, 59, 109, 8618, 8620, 1, 8631, 59, 1, 10556, 121, 4, 3, 101, 118, 119, 8632, 8651, 8656, 113, 4, 2, 112, 115, 8639, 8645, 114, 101, 99, 59, 1, 8926, 117, 99, 99, 59, 1, 8927, 101, 101, 59, 1, 8910, 101, 100, 103, 101, 59, 1, 8911, 101, 110, 5, 164, 1, 59, 8670, 1, 164, 101, 97, 114, 114, 111, 119, 4, 2, 108, 114, 8684, 8690, 101, 102, 116, 59, 1, 8630, 105, 103, 104, 116, 59, 1, 8631, 101, 101, 59, 1, 8910, 101, 100, 59, 1, 8911, 4, 2, 99, 105, 8713, 8721, 111, 110, 105, 110, 116, 59, 1, 8754, 110, 116, 59, 1, 8753, 108, 99, 116, 121, 59, 1, 9005, 4, 19, 65, 72, 97, 98, 99, 100, 101, 102, 104, 105, 106, 108, 111, 114, 115, 116, 117, 119, 122, 8773, 8778, 8783, 8821, 8839, 8854, 8887, 8914, 8930, 8944, 9036, 9041, 9058, 9197, 9227, 9258, 9281, 9297, 9305, 114, 114, 59, 1, 8659, 97, 114, 59, 1, 10597, 4, 4, 103, 108, 114, 115, 8793, 8799, 8805, 8809, 103, 101, 114, 59, 1, 8224, 101, 116, 104, 59, 1, 8504, 114, 59, 1, 8595, 104, 4, 2, 59, 118, 8816, 8818, 1, 8208, 59, 1, 8867, 4, 2, 107, 108, 8827, 8834, 97, 114, 111, 119, 59, 1, 10511, 97, 99, 59, 1, 733, 4, 2, 97, 121, 8845, 8851, 114, 111, 110, 59, 1, 271, 59, 1, 1076, 4, 3, 59, 97, 111, 8862, 8864, 8880, 1, 8518, 4, 2, 103, 114, 8870, 8876, 103, 101, 114, 59, 1, 8225, 114, 59, 1, 8650, 116, 115, 101, 113, 59, 1, 10871, 4, 3, 103, 108, 109, 8895, 8902, 8907, 5, 176, 1, 59, 8900, 1, 176, 116, 97, 59, 1, 948, 112, 116, 121, 118, 59, 1, 10673, 4, 2, 105, 114, 8920, 8926, 115, 104, 116, 59, 1, 10623, 59, 3, 55349, 56609, 97, 114, 4, 2, 108, 114, 8938, 8941, 59, 1, 8643, 59, 1, 8642, 4, 5, 97, 101, 103, 115, 118, 8956, 8986, 8989, 8996, 9001, 109, 4, 3, 59, 111, 115, 8965, 8967, 8983, 1, 8900, 110, 100, 4, 2, 59, 115, 8975, 8977, 1, 8900, 117, 105, 116, 59, 1, 9830, 59, 1, 9830, 59, 1, 168, 97, 109, 109, 97, 59, 1, 989, 105, 110, 59, 1, 8946, 4, 3, 59, 105, 111, 9009, 9011, 9031, 1, 247, 100, 101, 5, 247, 2, 59, 111, 9020, 9022, 1, 247, 110, 116, 105, 109, 101, 115, 59, 1, 8903, 110, 120, 59, 1, 8903, 99, 121, 59, 1, 1106, 99, 4, 2, 111, 114, 9048, 9053, 114, 110, 59, 1, 8990, 111, 112, 59, 1, 8973, 4, 5, 108, 112, 116, 117, 119, 9070, 9076, 9081, 9130, 9144, 108, 97, 114, 59, 1, 36, 102, 59, 3, 55349, 56661, 4, 5, 59, 101, 109, 112, 115, 9093, 9095, 9109, 9116, 9122, 1, 729, 113, 4, 2, 59, 100, 9102, 9104, 1, 8784, 111, 116, 59, 1, 8785, 105, 110, 117, 115, 59, 1, 8760, 108, 117, 115, 59, 1, 8724, 113, 117, 97, 114, 101, 59, 1, 8865, 98, 108, 101, 98, 97, 114, 119, 101, 100, 103, 101, 59, 1, 8966, 110, 4, 3, 97, 100, 104, 9153, 9160, 9172, 114, 114, 111, 119, 59, 1, 8595, 111, 119, 110, 97, 114, 114, 111, 119, 115, 59, 1, 8650, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 9184, 9190, 101, 102, 116, 59, 1, 8643, 105, 103, 104, 116, 59, 1, 8642, 4, 2, 98, 99, 9203, 9211, 107, 97, 114, 111, 119, 59, 1, 10512, 4, 2, 111, 114, 9217, 9222, 114, 110, 59, 1, 8991, 111, 112, 59, 1, 8972, 4, 3, 99, 111, 116, 9235, 9248, 9252, 4, 2, 114, 121, 9241, 9245, 59, 3, 55349, 56505, 59, 1, 1109, 108, 59, 1, 10742, 114, 111, 107, 59, 1, 273, 4, 2, 100, 114, 9264, 9269, 111, 116, 59, 1, 8945, 105, 4, 2, 59, 102, 9276, 9278, 1, 9663, 59, 1, 9662, 4, 2, 97, 104, 9287, 9292, 114, 114, 59, 1, 8693, 97, 114, 59, 1, 10607, 97, 110, 103, 108, 101, 59, 1, 10662, 4, 2, 99, 105, 9311, 9315, 121, 59, 1, 1119, 103, 114, 97, 114, 114, 59, 1, 10239, 4, 18, 68, 97, 99, 100, 101, 102, 103, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 120, 9361, 9376, 9398, 9439, 9444, 9447, 9462, 9495, 9531, 9585, 9598, 9614, 9659, 9755, 9771, 9792, 9808, 9826, 4, 2, 68, 111, 9367, 9372, 111, 116, 59, 1, 10871, 116, 59, 1, 8785, 4, 2, 99, 115, 9382, 9392, 117, 116, 101, 5, 233, 1, 59, 9390, 1, 233, 116, 101, 114, 59, 1, 10862, 4, 4, 97, 105, 111, 121, 9408, 9414, 9430, 9436, 114, 111, 110, 59, 1, 283, 114, 4, 2, 59, 99, 9421, 9423, 1, 8790, 5, 234, 1, 59, 9428, 1, 234, 108, 111, 110, 59, 1, 8789, 59, 1, 1101, 111, 116, 59, 1, 279, 59, 1, 8519, 4, 2, 68, 114, 9453, 9458, 111, 116, 59, 1, 8786, 59, 3, 55349, 56610, 4, 3, 59, 114, 115, 9470, 9472, 9482, 1, 10906, 97, 118, 101, 5, 232, 1, 59, 9480, 1, 232, 4, 2, 59, 100, 9488, 9490, 1, 10902, 111, 116, 59, 1, 10904, 4, 4, 59, 105, 108, 115, 9505, 9507, 9515, 9518, 1, 10905, 110, 116, 101, 114, 115, 59, 1, 9191, 59, 1, 8467, 4, 2, 59, 100, 9524, 9526, 1, 10901, 111, 116, 59, 1, 10903, 4, 3, 97, 112, 115, 9539, 9544, 9564, 99, 114, 59, 1, 275, 116, 121, 4, 3, 59, 115, 118, 9554, 9556, 9561, 1, 8709, 101, 116, 59, 1, 8709, 59, 1, 8709, 112, 4, 2, 49, 59, 9571, 9583, 4, 2, 51, 52, 9577, 9580, 59, 1, 8196, 59, 1, 8197, 1, 8195, 4, 2, 103, 115, 9591, 9594, 59, 1, 331, 112, 59, 1, 8194, 4, 2, 103, 112, 9604, 9609, 111, 110, 59, 1, 281, 102, 59, 3, 55349, 56662, 4, 3, 97, 108, 115, 9622, 9635, 9640, 114, 4, 2, 59, 115, 9629, 9631, 1, 8917, 108, 59, 1, 10723, 117, 115, 59, 1, 10865, 105, 4, 3, 59, 108, 118, 9649, 9651, 9656, 1, 949, 111, 110, 59, 1, 949, 59, 1, 1013, 4, 4, 99, 115, 117, 118, 9669, 9686, 9716, 9747, 4, 2, 105, 111, 9675, 9680, 114, 99, 59, 1, 8790, 108, 111, 110, 59, 1, 8789, 4, 2, 105, 108, 9692, 9696, 109, 59, 1, 8770, 97, 110, 116, 4, 2, 103, 108, 9705, 9710, 116, 114, 59, 1, 10902, 101, 115, 115, 59, 1, 10901, 4, 3, 97, 101, 105, 9724, 9729, 9734, 108, 115, 59, 1, 61, 115, 116, 59, 1, 8799, 118, 4, 2, 59, 68, 9741, 9743, 1, 8801, 68, 59, 1, 10872, 112, 97, 114, 115, 108, 59, 1, 10725, 4, 2, 68, 97, 9761, 9766, 111, 116, 59, 1, 8787, 114, 114, 59, 1, 10609, 4, 3, 99, 100, 105, 9779, 9783, 9788, 114, 59, 1, 8495, 111, 116, 59, 1, 8784, 109, 59, 1, 8770, 4, 2, 97, 104, 9798, 9801, 59, 1, 951, 5, 240, 1, 59, 9806, 1, 240, 4, 2, 109, 114, 9814, 9822, 108, 5, 235, 1, 59, 9820, 1, 235, 111, 59, 1, 8364, 4, 3, 99, 105, 112, 9834, 9838, 9843, 108, 59, 1, 33, 115, 116, 59, 1, 8707, 4, 2, 101, 111, 9849, 9859, 99, 116, 97, 116, 105, 111, 110, 59, 1, 8496, 110, 101, 110, 116, 105, 97, 108, 101, 59, 1, 8519, 4, 12, 97, 99, 101, 102, 105, 106, 108, 110, 111, 112, 114, 115, 9896, 9910, 9914, 9921, 9954, 9960, 9967, 9989, 9994, 10027, 10036, 10164, 108, 108, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8786, 121, 59, 1, 1092, 109, 97, 108, 101, 59, 1, 9792, 4, 3, 105, 108, 114, 9929, 9935, 9950, 108, 105, 103, 59, 1, 64259, 4, 2, 105, 108, 9941, 9945, 103, 59, 1, 64256, 105, 103, 59, 1, 64260, 59, 3, 55349, 56611, 108, 105, 103, 59, 1, 64257, 108, 105, 103, 59, 3, 102, 106, 4, 3, 97, 108, 116, 9975, 9979, 9984, 116, 59, 1, 9837, 105, 103, 59, 1, 64258, 110, 115, 59, 1, 9649, 111, 102, 59, 1, 402, 4, 2, 112, 114, 10000, 10005, 102, 59, 3, 55349, 56663, 4, 2, 97, 107, 10011, 10016, 108, 108, 59, 1, 8704, 4, 2, 59, 118, 10022, 10024, 1, 8916, 59, 1, 10969, 97, 114, 116, 105, 110, 116, 59, 1, 10765, 4, 2, 97, 111, 10042, 10159, 4, 2, 99, 115, 10048, 10155, 4, 6, 49, 50, 51, 52, 53, 55, 10062, 10102, 10114, 10135, 10139, 10151, 4, 6, 50, 51, 52, 53, 54, 56, 10076, 10083, 10086, 10093, 10096, 10099, 5, 189, 1, 59, 10081, 1, 189, 59, 1, 8531, 5, 188, 1, 59, 10091, 1, 188, 59, 1, 8533, 59, 1, 8537, 59, 1, 8539, 4, 2, 51, 53, 10108, 10111, 59, 1, 8532, 59, 1, 8534, 4, 3, 52, 53, 56, 10122, 10129, 10132, 5, 190, 1, 59, 10127, 1, 190, 59, 1, 8535, 59, 1, 8540, 53, 59, 1, 8536, 4, 2, 54, 56, 10145, 10148, 59, 1, 8538, 59, 1, 8541, 56, 59, 1, 8542, 108, 59, 1, 8260, 119, 110, 59, 1, 8994, 99, 114, 59, 3, 55349, 56507, 4, 17, 69, 97, 98, 99, 100, 101, 102, 103, 105, 106, 108, 110, 111, 114, 115, 116, 118, 10206, 10217, 10247, 10254, 10268, 10273, 10358, 10363, 10374, 10380, 10385, 10406, 10458, 10464, 10470, 10497, 10610, 4, 2, 59, 108, 10212, 10214, 1, 8807, 59, 1, 10892, 4, 3, 99, 109, 112, 10225, 10231, 10244, 117, 116, 101, 59, 1, 501, 109, 97, 4, 2, 59, 100, 10239, 10241, 1, 947, 59, 1, 989, 59, 1, 10886, 114, 101, 118, 101, 59, 1, 287, 4, 2, 105, 121, 10260, 10265, 114, 99, 59, 1, 285, 59, 1, 1075, 111, 116, 59, 1, 289, 4, 4, 59, 108, 113, 115, 10283, 10285, 10288, 10308, 1, 8805, 59, 1, 8923, 4, 3, 59, 113, 115, 10296, 10298, 10301, 1, 8805, 59, 1, 8807, 108, 97, 110, 116, 59, 1, 10878, 4, 4, 59, 99, 100, 108, 10318, 10320, 10324, 10345, 1, 10878, 99, 59, 1, 10921, 111, 116, 4, 2, 59, 111, 10332, 10334, 1, 10880, 4, 2, 59, 108, 10340, 10342, 1, 10882, 59, 1, 10884, 4, 2, 59, 101, 10351, 10354, 3, 8923, 65024, 115, 59, 1, 10900, 114, 59, 3, 55349, 56612, 4, 2, 59, 103, 10369, 10371, 1, 8811, 59, 1, 8921, 109, 101, 108, 59, 1, 8503, 99, 121, 59, 1, 1107, 4, 4, 59, 69, 97, 106, 10395, 10397, 10400, 10403, 1, 8823, 59, 1, 10898, 59, 1, 10917, 59, 1, 10916, 4, 4, 69, 97, 101, 115, 10416, 10419, 10434, 10453, 59, 1, 8809, 112, 4, 2, 59, 112, 10426, 10428, 1, 10890, 114, 111, 120, 59, 1, 10890, 4, 2, 59, 113, 10440, 10442, 1, 10888, 4, 2, 59, 113, 10448, 10450, 1, 10888, 59, 1, 8809, 105, 109, 59, 1, 8935, 112, 102, 59, 3, 55349, 56664, 97, 118, 101, 59, 1, 96, 4, 2, 99, 105, 10476, 10480, 114, 59, 1, 8458, 109, 4, 3, 59, 101, 108, 10489, 10491, 10494, 1, 8819, 59, 1, 10894, 59, 1, 10896, 5, 62, 6, 59, 99, 100, 108, 113, 114, 10512, 10514, 10527, 10532, 10538, 10545, 1, 62, 4, 2, 99, 105, 10520, 10523, 59, 1, 10919, 114, 59, 1, 10874, 111, 116, 59, 1, 8919, 80, 97, 114, 59, 1, 10645, 117, 101, 115, 116, 59, 1, 10876, 4, 5, 97, 100, 101, 108, 115, 10557, 10574, 10579, 10599, 10605, 4, 2, 112, 114, 10563, 10570, 112, 114, 111, 120, 59, 1, 10886, 114, 59, 1, 10616, 111, 116, 59, 1, 8919, 113, 4, 2, 108, 113, 10586, 10592, 101, 115, 115, 59, 1, 8923, 108, 101, 115, 115, 59, 1, 10892, 101, 115, 115, 59, 1, 8823, 105, 109, 59, 1, 8819, 4, 2, 101, 110, 10616, 10626, 114, 116, 110, 101, 113, 113, 59, 3, 8809, 65024, 69, 59, 3, 8809, 65024, 4, 10, 65, 97, 98, 99, 101, 102, 107, 111, 115, 121, 10653, 10658, 10713, 10718, 10724, 10760, 10765, 10786, 10850, 10875, 114, 114, 59, 1, 8660, 4, 4, 105, 108, 109, 114, 10668, 10674, 10678, 10684, 114, 115, 112, 59, 1, 8202, 102, 59, 1, 189, 105, 108, 116, 59, 1, 8459, 4, 2, 100, 114, 10690, 10695, 99, 121, 59, 1, 1098, 4, 3, 59, 99, 119, 10703, 10705, 10710, 1, 8596, 105, 114, 59, 1, 10568, 59, 1, 8621, 97, 114, 59, 1, 8463, 105, 114, 99, 59, 1, 293, 4, 3, 97, 108, 114, 10732, 10748, 10754, 114, 116, 115, 4, 2, 59, 117, 10741, 10743, 1, 9829, 105, 116, 59, 1, 9829, 108, 105, 112, 59, 1, 8230, 99, 111, 110, 59, 1, 8889, 114, 59, 3, 55349, 56613, 115, 4, 2, 101, 119, 10772, 10779, 97, 114, 111, 119, 59, 1, 10533, 97, 114, 111, 119, 59, 1, 10534, 4, 5, 97, 109, 111, 112, 114, 10798, 10803, 10809, 10839, 10844, 114, 114, 59, 1, 8703, 116, 104, 116, 59, 1, 8763, 107, 4, 2, 108, 114, 10816, 10827, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8617, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8618, 102, 59, 3, 55349, 56665, 98, 97, 114, 59, 1, 8213, 4, 3, 99, 108, 116, 10858, 10863, 10869, 114, 59, 3, 55349, 56509, 97, 115, 104, 59, 1, 8463, 114, 111, 107, 59, 1, 295, 4, 2, 98, 112, 10881, 10887, 117, 108, 108, 59, 1, 8259, 104, 101, 110, 59, 1, 8208, 4, 15, 97, 99, 101, 102, 103, 105, 106, 109, 110, 111, 112, 113, 115, 116, 117, 10925, 10936, 10958, 10977, 10990, 11001, 11039, 11045, 11101, 11192, 11220, 11226, 11237, 11285, 11299, 99, 117, 116, 101, 5, 237, 1, 59, 10934, 1, 237, 4, 3, 59, 105, 121, 10944, 10946, 10955, 1, 8291, 114, 99, 5, 238, 1, 59, 10953, 1, 238, 59, 1, 1080, 4, 2, 99, 120, 10964, 10968, 121, 59, 1, 1077, 99, 108, 5, 161, 1, 59, 10975, 1, 161, 4, 2, 102, 114, 10983, 10986, 59, 1, 8660, 59, 3, 55349, 56614, 114, 97, 118, 101, 5, 236, 1, 59, 10999, 1, 236, 4, 4, 59, 105, 110, 111, 11011, 11013, 11028, 11034, 1, 8520, 4, 2, 105, 110, 11019, 11024, 110, 116, 59, 1, 10764, 116, 59, 1, 8749, 102, 105, 110, 59, 1, 10716, 116, 97, 59, 1, 8489, 108, 105, 103, 59, 1, 307, 4, 3, 97, 111, 112, 11053, 11092, 11096, 4, 3, 99, 103, 116, 11061, 11065, 11088, 114, 59, 1, 299, 4, 3, 101, 108, 112, 11073, 11076, 11082, 59, 1, 8465, 105, 110, 101, 59, 1, 8464, 97, 114, 116, 59, 1, 8465, 104, 59, 1, 305, 102, 59, 1, 8887, 101, 100, 59, 1, 437, 4, 5, 59, 99, 102, 111, 116, 11113, 11115, 11121, 11136, 11142, 1, 8712, 97, 114, 101, 59, 1, 8453, 105, 110, 4, 2, 59, 116, 11129, 11131, 1, 8734, 105, 101, 59, 1, 10717, 100, 111, 116, 59, 1, 305, 4, 5, 59, 99, 101, 108, 112, 11154, 11156, 11161, 11179, 11186, 1, 8747, 97, 108, 59, 1, 8890, 4, 2, 103, 114, 11167, 11173, 101, 114, 115, 59, 1, 8484, 99, 97, 108, 59, 1, 8890, 97, 114, 104, 107, 59, 1, 10775, 114, 111, 100, 59, 1, 10812, 4, 4, 99, 103, 112, 116, 11202, 11206, 11211, 11216, 121, 59, 1, 1105, 111, 110, 59, 1, 303, 102, 59, 3, 55349, 56666, 97, 59, 1, 953, 114, 111, 100, 59, 1, 10812, 117, 101, 115, 116, 5, 191, 1, 59, 11235, 1, 191, 4, 2, 99, 105, 11243, 11248, 114, 59, 3, 55349, 56510, 110, 4, 5, 59, 69, 100, 115, 118, 11261, 11263, 11266, 11271, 11282, 1, 8712, 59, 1, 8953, 111, 116, 59, 1, 8949, 4, 2, 59, 118, 11277, 11279, 1, 8948, 59, 1, 8947, 59, 1, 8712, 4, 2, 59, 105, 11291, 11293, 1, 8290, 108, 100, 101, 59, 1, 297, 4, 2, 107, 109, 11305, 11310, 99, 121, 59, 1, 1110, 108, 5, 239, 1, 59, 11316, 1, 239, 4, 6, 99, 102, 109, 111, 115, 117, 11332, 11346, 11351, 11357, 11363, 11380, 4, 2, 105, 121, 11338, 11343, 114, 99, 59, 1, 309, 59, 1, 1081, 114, 59, 3, 55349, 56615, 97, 116, 104, 59, 1, 567, 112, 102, 59, 3, 55349, 56667, 4, 2, 99, 101, 11369, 11374, 114, 59, 3, 55349, 56511, 114, 99, 121, 59, 1, 1112, 107, 99, 121, 59, 1, 1108, 4, 8, 97, 99, 102, 103, 104, 106, 111, 115, 11404, 11418, 11433, 11438, 11445, 11450, 11455, 11461, 112, 112, 97, 4, 2, 59, 118, 11413, 11415, 1, 954, 59, 1, 1008, 4, 2, 101, 121, 11424, 11430, 100, 105, 108, 59, 1, 311, 59, 1, 1082, 114, 59, 3, 55349, 56616, 114, 101, 101, 110, 59, 1, 312, 99, 121, 59, 1, 1093, 99, 121, 59, 1, 1116, 112, 102, 59, 3, 55349, 56668, 99, 114, 59, 3, 55349, 56512, 4, 23, 65, 66, 69, 72, 97, 98, 99, 100, 101, 102, 103, 104, 106, 108, 109, 110, 111, 112, 114, 115, 116, 117, 118, 11515, 11538, 11544, 11555, 11560, 11721, 11780, 11818, 11868, 12136, 12160, 12171, 12203, 12208, 12246, 12275, 12327, 12509, 12523, 12569, 12641, 12732, 12752, 4, 3, 97, 114, 116, 11523, 11528, 11532, 114, 114, 59, 1, 8666, 114, 59, 1, 8656, 97, 105, 108, 59, 1, 10523, 97, 114, 114, 59, 1, 10510, 4, 2, 59, 103, 11550, 11552, 1, 8806, 59, 1, 10891, 97, 114, 59, 1, 10594, 4, 9, 99, 101, 103, 109, 110, 112, 113, 114, 116, 11580, 11586, 11594, 11600, 11606, 11624, 11627, 11636, 11694, 117, 116, 101, 59, 1, 314, 109, 112, 116, 121, 118, 59, 1, 10676, 114, 97, 110, 59, 1, 8466, 98, 100, 97, 59, 1, 955, 103, 4, 3, 59, 100, 108, 11615, 11617, 11620, 1, 10216, 59, 1, 10641, 101, 59, 1, 10216, 59, 1, 10885, 117, 111, 5, 171, 1, 59, 11634, 1, 171, 114, 4, 8, 59, 98, 102, 104, 108, 112, 115, 116, 11655, 11657, 11669, 11673, 11677, 11681, 11685, 11690, 1, 8592, 4, 2, 59, 102, 11663, 11665, 1, 8676, 115, 59, 1, 10527, 115, 59, 1, 10525, 107, 59, 1, 8617, 112, 59, 1, 8619, 108, 59, 1, 10553, 105, 109, 59, 1, 10611, 108, 59, 1, 8610, 4, 3, 59, 97, 101, 11702, 11704, 11709, 1, 10923, 105, 108, 59, 1, 10521, 4, 2, 59, 115, 11715, 11717, 1, 10925, 59, 3, 10925, 65024, 4, 3, 97, 98, 114, 11729, 11734, 11739, 114, 114, 59, 1, 10508, 114, 107, 59, 1, 10098, 4, 2, 97, 107, 11745, 11758, 99, 4, 2, 101, 107, 11752, 11755, 59, 1, 123, 59, 1, 91, 4, 2, 101, 115, 11764, 11767, 59, 1, 10635, 108, 4, 2, 100, 117, 11774, 11777, 59, 1, 10639, 59, 1, 10637, 4, 4, 97, 101, 117, 121, 11790, 11796, 11811, 11815, 114, 111, 110, 59, 1, 318, 4, 2, 100, 105, 11802, 11807, 105, 108, 59, 1, 316, 108, 59, 1, 8968, 98, 59, 1, 123, 59, 1, 1083, 4, 4, 99, 113, 114, 115, 11828, 11832, 11845, 11864, 97, 59, 1, 10550, 117, 111, 4, 2, 59, 114, 11840, 11842, 1, 8220, 59, 1, 8222, 4, 2, 100, 117, 11851, 11857, 104, 97, 114, 59, 1, 10599, 115, 104, 97, 114, 59, 1, 10571, 104, 59, 1, 8626, 4, 5, 59, 102, 103, 113, 115, 11880, 11882, 12008, 12011, 12031, 1, 8804, 116, 4, 5, 97, 104, 108, 114, 116, 11895, 11913, 11935, 11947, 11996, 114, 114, 111, 119, 4, 2, 59, 116, 11905, 11907, 1, 8592, 97, 105, 108, 59, 1, 8610, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 11925, 11931, 111, 119, 110, 59, 1, 8637, 112, 59, 1, 8636, 101, 102, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8647, 105, 103, 104, 116, 4, 3, 97, 104, 115, 11959, 11974, 11984, 114, 114, 111, 119, 4, 2, 59, 115, 11969, 11971, 1, 8596, 59, 1, 8646, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8651, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8621, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8907, 59, 1, 8922, 4, 3, 59, 113, 115, 12019, 12021, 12024, 1, 8804, 59, 1, 8806, 108, 97, 110, 116, 59, 1, 10877, 4, 5, 59, 99, 100, 103, 115, 12043, 12045, 12049, 12070, 12083, 1, 10877, 99, 59, 1, 10920, 111, 116, 4, 2, 59, 111, 12057, 12059, 1, 10879, 4, 2, 59, 114, 12065, 12067, 1, 10881, 59, 1, 10883, 4, 2, 59, 101, 12076, 12079, 3, 8922, 65024, 115, 59, 1, 10899, 4, 5, 97, 100, 101, 103, 115, 12095, 12103, 12108, 12126, 12131, 112, 112, 114, 111, 120, 59, 1, 10885, 111, 116, 59, 1, 8918, 113, 4, 2, 103, 113, 12115, 12120, 116, 114, 59, 1, 8922, 103, 116, 114, 59, 1, 10891, 116, 114, 59, 1, 8822, 105, 109, 59, 1, 8818, 4, 3, 105, 108, 114, 12144, 12150, 12156, 115, 104, 116, 59, 1, 10620, 111, 111, 114, 59, 1, 8970, 59, 3, 55349, 56617, 4, 2, 59, 69, 12166, 12168, 1, 8822, 59, 1, 10897, 4, 2, 97, 98, 12177, 12198, 114, 4, 2, 100, 117, 12184, 12187, 59, 1, 8637, 4, 2, 59, 108, 12193, 12195, 1, 8636, 59, 1, 10602, 108, 107, 59, 1, 9604, 99, 121, 59, 1, 1113, 4, 5, 59, 97, 99, 104, 116, 12220, 12222, 12227, 12235, 12241, 1, 8810, 114, 114, 59, 1, 8647, 111, 114, 110, 101, 114, 59, 1, 8990, 97, 114, 100, 59, 1, 10603, 114, 105, 59, 1, 9722, 4, 2, 105, 111, 12252, 12258, 100, 111, 116, 59, 1, 320, 117, 115, 116, 4, 2, 59, 97, 12267, 12269, 1, 9136, 99, 104, 101, 59, 1, 9136, 4, 4, 69, 97, 101, 115, 12285, 12288, 12303, 12322, 59, 1, 8808, 112, 4, 2, 59, 112, 12295, 12297, 1, 10889, 114, 111, 120, 59, 1, 10889, 4, 2, 59, 113, 12309, 12311, 1, 10887, 4, 2, 59, 113, 12317, 12319, 1, 10887, 59, 1, 8808, 105, 109, 59, 1, 8934, 4, 8, 97, 98, 110, 111, 112, 116, 119, 122, 12345, 12359, 12364, 12421, 12446, 12467, 12474, 12490, 4, 2, 110, 114, 12351, 12355, 103, 59, 1, 10220, 114, 59, 1, 8701, 114, 107, 59, 1, 10214, 103, 4, 3, 108, 109, 114, 12373, 12401, 12409, 101, 102, 116, 4, 2, 97, 114, 12382, 12389, 114, 114, 111, 119, 59, 1, 10229, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10231, 97, 112, 115, 116, 111, 59, 1, 10236, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 10230, 112, 97, 114, 114, 111, 119, 4, 2, 108, 114, 12433, 12439, 101, 102, 116, 59, 1, 8619, 105, 103, 104, 116, 59, 1, 8620, 4, 3, 97, 102, 108, 12454, 12458, 12462, 114, 59, 1, 10629, 59, 3, 55349, 56669, 117, 115, 59, 1, 10797, 105, 109, 101, 115, 59, 1, 10804, 4, 2, 97, 98, 12480, 12485, 115, 116, 59, 1, 8727, 97, 114, 59, 1, 95, 4, 3, 59, 101, 102, 12498, 12500, 12506, 1, 9674, 110, 103, 101, 59, 1, 9674, 59, 1, 10731, 97, 114, 4, 2, 59, 108, 12517, 12519, 1, 40, 116, 59, 1, 10643, 4, 5, 97, 99, 104, 109, 116, 12535, 12540, 12548, 12561, 12564, 114, 114, 59, 1, 8646, 111, 114, 110, 101, 114, 59, 1, 8991, 97, 114, 4, 2, 59, 100, 12556, 12558, 1, 8651, 59, 1, 10605, 59, 1, 8206, 114, 105, 59, 1, 8895, 4, 6, 97, 99, 104, 105, 113, 116, 12583, 12589, 12594, 12597, 12614, 12635, 113, 117, 111, 59, 1, 8249, 114, 59, 3, 55349, 56513, 59, 1, 8624, 109, 4, 3, 59, 101, 103, 12606, 12608, 12611, 1, 8818, 59, 1, 10893, 59, 1, 10895, 4, 2, 98, 117, 12620, 12623, 59, 1, 91, 111, 4, 2, 59, 114, 12630, 12632, 1, 8216, 59, 1, 8218, 114, 111, 107, 59, 1, 322, 5, 60, 8, 59, 99, 100, 104, 105, 108, 113, 114, 12660, 12662, 12675, 12680, 12686, 12692, 12698, 12705, 1, 60, 4, 2, 99, 105, 12668, 12671, 59, 1, 10918, 114, 59, 1, 10873, 111, 116, 59, 1, 8918, 114, 101, 101, 59, 1, 8907, 109, 101, 115, 59, 1, 8905, 97, 114, 114, 59, 1, 10614, 117, 101, 115, 116, 59, 1, 10875, 4, 2, 80, 105, 12711, 12716, 97, 114, 59, 1, 10646, 4, 3, 59, 101, 102, 12724, 12726, 12729, 1, 9667, 59, 1, 8884, 59, 1, 9666, 114, 4, 2, 100, 117, 12739, 12746, 115, 104, 97, 114, 59, 1, 10570, 104, 97, 114, 59, 1, 10598, 4, 2, 101, 110, 12758, 12768, 114, 116, 110, 101, 113, 113, 59, 3, 8808, 65024, 69, 59, 3, 8808, 65024, 4, 14, 68, 97, 99, 100, 101, 102, 104, 105, 108, 110, 111, 112, 115, 117, 12803, 12809, 12893, 12908, 12914, 12928, 12933, 12937, 13011, 13025, 13032, 13049, 13052, 13069, 68, 111, 116, 59, 1, 8762, 4, 4, 99, 108, 112, 114, 12819, 12827, 12849, 12887, 114, 5, 175, 1, 59, 12825, 1, 175, 4, 2, 101, 116, 12833, 12836, 59, 1, 9794, 4, 2, 59, 101, 12842, 12844, 1, 10016, 115, 101, 59, 1, 10016, 4, 2, 59, 115, 12855, 12857, 1, 8614, 116, 111, 4, 4, 59, 100, 108, 117, 12869, 12871, 12877, 12883, 1, 8614, 111, 119, 110, 59, 1, 8615, 101, 102, 116, 59, 1, 8612, 112, 59, 1, 8613, 107, 101, 114, 59, 1, 9646, 4, 2, 111, 121, 12899, 12905, 109, 109, 97, 59, 1, 10793, 59, 1, 1084, 97, 115, 104, 59, 1, 8212, 97, 115, 117, 114, 101, 100, 97, 110, 103, 108, 101, 59, 1, 8737, 114, 59, 3, 55349, 56618, 111, 59, 1, 8487, 4, 3, 99, 100, 110, 12945, 12954, 12985, 114, 111, 5, 181, 1, 59, 12952, 1, 181, 4, 4, 59, 97, 99, 100, 12964, 12966, 12971, 12976, 1, 8739, 115, 116, 59, 1, 42, 105, 114, 59, 1, 10992, 111, 116, 5, 183, 1, 59, 12983, 1, 183, 117, 115, 4, 3, 59, 98, 100, 12995, 12997, 13000, 1, 8722, 59, 1, 8863, 4, 2, 59, 117, 13006, 13008, 1, 8760, 59, 1, 10794, 4, 2, 99, 100, 13017, 13021, 112, 59, 1, 10971, 114, 59, 1, 8230, 112, 108, 117, 115, 59, 1, 8723, 4, 2, 100, 112, 13038, 13044, 101, 108, 115, 59, 1, 8871, 102, 59, 3, 55349, 56670, 59, 1, 8723, 4, 2, 99, 116, 13058, 13063, 114, 59, 3, 55349, 56514, 112, 111, 115, 59, 1, 8766, 4, 3, 59, 108, 109, 13077, 13079, 13087, 1, 956, 116, 105, 109, 97, 112, 59, 1, 8888, 97, 112, 59, 1, 8888, 4, 24, 71, 76, 82, 86, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 108, 109, 111, 112, 114, 115, 116, 117, 118, 119, 13142, 13165, 13217, 13229, 13247, 13330, 13359, 13414, 13420, 13508, 13513, 13579, 13602, 13626, 13631, 13762, 13767, 13855, 13936, 13995, 14214, 14285, 14312, 14432, 4, 2, 103, 116, 13148, 13152, 59, 3, 8921, 824, 4, 2, 59, 118, 13158, 13161, 3, 8811, 8402, 59, 3, 8811, 824, 4, 3, 101, 108, 116, 13173, 13200, 13204, 102, 116, 4, 2, 97, 114, 13181, 13188, 114, 114, 111, 119, 59, 1, 8653, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8654, 59, 3, 8920, 824, 4, 2, 59, 118, 13210, 13213, 3, 8810, 8402, 59, 3, 8810, 824, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8655, 4, 2, 68, 100, 13235, 13241, 97, 115, 104, 59, 1, 8879, 97, 115, 104, 59, 1, 8878, 4, 5, 98, 99, 110, 112, 116, 13259, 13264, 13270, 13275, 13308, 108, 97, 59, 1, 8711, 117, 116, 101, 59, 1, 324, 103, 59, 3, 8736, 8402, 4, 5, 59, 69, 105, 111, 112, 13287, 13289, 13293, 13298, 13302, 1, 8777, 59, 3, 10864, 824, 100, 59, 3, 8779, 824, 115, 59, 1, 329, 114, 111, 120, 59, 1, 8777, 117, 114, 4, 2, 59, 97, 13316, 13318, 1, 9838, 108, 4, 2, 59, 115, 13325, 13327, 1, 9838, 59, 1, 8469, 4, 2, 115, 117, 13336, 13344, 112, 5, 160, 1, 59, 13342, 1, 160, 109, 112, 4, 2, 59, 101, 13352, 13355, 3, 8782, 824, 59, 3, 8783, 824, 4, 5, 97, 101, 111, 117, 121, 13371, 13385, 13391, 13407, 13411, 4, 2, 112, 114, 13377, 13380, 59, 1, 10819, 111, 110, 59, 1, 328, 100, 105, 108, 59, 1, 326, 110, 103, 4, 2, 59, 100, 13399, 13401, 1, 8775, 111, 116, 59, 3, 10861, 824, 112, 59, 1, 10818, 59, 1, 1085, 97, 115, 104, 59, 1, 8211, 4, 7, 59, 65, 97, 100, 113, 115, 120, 13436, 13438, 13443, 13466, 13472, 13478, 13494, 1, 8800, 114, 114, 59, 1, 8663, 114, 4, 2, 104, 114, 13450, 13454, 107, 59, 1, 10532, 4, 2, 59, 111, 13460, 13462, 1, 8599, 119, 59, 1, 8599, 111, 116, 59, 3, 8784, 824, 117, 105, 118, 59, 1, 8802, 4, 2, 101, 105, 13484, 13489, 97, 114, 59, 1, 10536, 109, 59, 3, 8770, 824, 105, 115, 116, 4, 2, 59, 115, 13503, 13505, 1, 8708, 59, 1, 8708, 114, 59, 3, 55349, 56619, 4, 4, 69, 101, 115, 116, 13523, 13527, 13563, 13568, 59, 3, 8807, 824, 4, 3, 59, 113, 115, 13535, 13537, 13559, 1, 8817, 4, 3, 59, 113, 115, 13545, 13547, 13551, 1, 8817, 59, 3, 8807, 824, 108, 97, 110, 116, 59, 3, 10878, 824, 59, 3, 10878, 824, 105, 109, 59, 1, 8821, 4, 2, 59, 114, 13574, 13576, 1, 8815, 59, 1, 8815, 4, 3, 65, 97, 112, 13587, 13592, 13597, 114, 114, 59, 1, 8654, 114, 114, 59, 1, 8622, 97, 114, 59, 1, 10994, 4, 3, 59, 115, 118, 13610, 13612, 13623, 1, 8715, 4, 2, 59, 100, 13618, 13620, 1, 8956, 59, 1, 8954, 59, 1, 8715, 99, 121, 59, 1, 1114, 4, 7, 65, 69, 97, 100, 101, 115, 116, 13647, 13652, 13656, 13661, 13665, 13737, 13742, 114, 114, 59, 1, 8653, 59, 3, 8806, 824, 114, 114, 59, 1, 8602, 114, 59, 1, 8229, 4, 4, 59, 102, 113, 115, 13675, 13677, 13703, 13725, 1, 8816, 116, 4, 2, 97, 114, 13684, 13691, 114, 114, 111, 119, 59, 1, 8602, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8622, 4, 3, 59, 113, 115, 13711, 13713, 13717, 1, 8816, 59, 3, 8806, 824, 108, 97, 110, 116, 59, 3, 10877, 824, 4, 2, 59, 115, 13731, 13734, 3, 10877, 824, 59, 1, 8814, 105, 109, 59, 1, 8820, 4, 2, 59, 114, 13748, 13750, 1, 8814, 105, 4, 2, 59, 101, 13757, 13759, 1, 8938, 59, 1, 8940, 105, 100, 59, 1, 8740, 4, 2, 112, 116, 13773, 13778, 102, 59, 3, 55349, 56671, 5, 172, 3, 59, 105, 110, 13787, 13789, 13829, 1, 172, 110, 4, 4, 59, 69, 100, 118, 13800, 13802, 13806, 13812, 1, 8713, 59, 3, 8953, 824, 111, 116, 59, 3, 8949, 824, 4, 3, 97, 98, 99, 13820, 13823, 13826, 59, 1, 8713, 59, 1, 8951, 59, 1, 8950, 105, 4, 2, 59, 118, 13836, 13838, 1, 8716, 4, 3, 97, 98, 99, 13846, 13849, 13852, 59, 1, 8716, 59, 1, 8958, 59, 1, 8957, 4, 3, 97, 111, 114, 13863, 13892, 13899, 114, 4, 4, 59, 97, 115, 116, 13874, 13876, 13883, 13888, 1, 8742, 108, 108, 101, 108, 59, 1, 8742, 108, 59, 3, 11005, 8421, 59, 3, 8706, 824, 108, 105, 110, 116, 59, 1, 10772, 4, 3, 59, 99, 101, 13907, 13909, 13914, 1, 8832, 117, 101, 59, 1, 8928, 4, 2, 59, 99, 13920, 13923, 3, 10927, 824, 4, 2, 59, 101, 13929, 13931, 1, 8832, 113, 59, 3, 10927, 824, 4, 4, 65, 97, 105, 116, 13946, 13951, 13971, 13982, 114, 114, 59, 1, 8655, 114, 114, 4, 3, 59, 99, 119, 13961, 13963, 13967, 1, 8603, 59, 3, 10547, 824, 59, 3, 8605, 824, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8603, 114, 105, 4, 2, 59, 101, 13990, 13992, 1, 8939, 59, 1, 8941, 4, 7, 99, 104, 105, 109, 112, 113, 117, 14011, 14036, 14060, 14080, 14085, 14090, 14106, 4, 4, 59, 99, 101, 114, 14021, 14023, 14028, 14032, 1, 8833, 117, 101, 59, 1, 8929, 59, 3, 10928, 824, 59, 3, 55349, 56515, 111, 114, 116, 4, 2, 109, 112, 14045, 14050, 105, 100, 59, 1, 8740, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8742, 109, 4, 2, 59, 101, 14067, 14069, 1, 8769, 4, 2, 59, 113, 14075, 14077, 1, 8772, 59, 1, 8772, 105, 100, 59, 1, 8740, 97, 114, 59, 1, 8742, 115, 117, 4, 2, 98, 112, 14098, 14102, 101, 59, 1, 8930, 101, 59, 1, 8931, 4, 3, 98, 99, 112, 14114, 14157, 14171, 4, 4, 59, 69, 101, 115, 14124, 14126, 14130, 14133, 1, 8836, 59, 3, 10949, 824, 59, 1, 8840, 101, 116, 4, 2, 59, 101, 14141, 14144, 3, 8834, 8402, 113, 4, 2, 59, 113, 14151, 14153, 1, 8840, 59, 3, 10949, 824, 99, 4, 2, 59, 101, 14164, 14166, 1, 8833, 113, 59, 3, 10928, 824, 4, 4, 59, 69, 101, 115, 14181, 14183, 14187, 14190, 1, 8837, 59, 3, 10950, 824, 59, 1, 8841, 101, 116, 4, 2, 59, 101, 14198, 14201, 3, 8835, 8402, 113, 4, 2, 59, 113, 14208, 14210, 1, 8841, 59, 3, 10950, 824, 4, 4, 103, 105, 108, 114, 14224, 14228, 14238, 14242, 108, 59, 1, 8825, 108, 100, 101, 5, 241, 1, 59, 14236, 1, 241, 103, 59, 1, 8824, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 14254, 14269, 101, 102, 116, 4, 2, 59, 101, 14263, 14265, 1, 8938, 113, 59, 1, 8940, 105, 103, 104, 116, 4, 2, 59, 101, 14279, 14281, 1, 8939, 113, 59, 1, 8941, 4, 2, 59, 109, 14291, 14293, 1, 957, 4, 3, 59, 101, 115, 14301, 14303, 14308, 1, 35, 114, 111, 59, 1, 8470, 112, 59, 1, 8199, 4, 9, 68, 72, 97, 100, 103, 105, 108, 114, 115, 14332, 14338, 14344, 14349, 14355, 14369, 14376, 14408, 14426, 97, 115, 104, 59, 1, 8877, 97, 114, 114, 59, 1, 10500, 112, 59, 3, 8781, 8402, 97, 115, 104, 59, 1, 8876, 4, 2, 101, 116, 14361, 14365, 59, 3, 8805, 8402, 59, 3, 62, 8402, 110, 102, 105, 110, 59, 1, 10718, 4, 3, 65, 101, 116, 14384, 14389, 14393, 114, 114, 59, 1, 10498, 59, 3, 8804, 8402, 4, 2, 59, 114, 14399, 14402, 3, 60, 8402, 105, 101, 59, 3, 8884, 8402, 4, 2, 65, 116, 14414, 14419, 114, 114, 59, 1, 10499, 114, 105, 101, 59, 3, 8885, 8402, 105, 109, 59, 3, 8764, 8402, 4, 3, 65, 97, 110, 14440, 14445, 14468, 114, 114, 59, 1, 8662, 114, 4, 2, 104, 114, 14452, 14456, 107, 59, 1, 10531, 4, 2, 59, 111, 14462, 14464, 1, 8598, 119, 59, 1, 8598, 101, 97, 114, 59, 1, 10535, 4, 18, 83, 97, 99, 100, 101, 102, 103, 104, 105, 108, 109, 111, 112, 114, 115, 116, 117, 118, 14512, 14515, 14535, 14560, 14597, 14603, 14618, 14643, 14657, 14662, 14701, 14741, 14747, 14769, 14851, 14877, 14907, 14916, 59, 1, 9416, 4, 2, 99, 115, 14521, 14531, 117, 116, 101, 5, 243, 1, 59, 14529, 1, 243, 116, 59, 1, 8859, 4, 2, 105, 121, 14541, 14557, 114, 4, 2, 59, 99, 14548, 14550, 1, 8858, 5, 244, 1, 59, 14555, 1, 244, 59, 1, 1086, 4, 5, 97, 98, 105, 111, 115, 14572, 14577, 14583, 14587, 14591, 115, 104, 59, 1, 8861, 108, 97, 99, 59, 1, 337, 118, 59, 1, 10808, 116, 59, 1, 8857, 111, 108, 100, 59, 1, 10684, 108, 105, 103, 59, 1, 339, 4, 2, 99, 114, 14609, 14614, 105, 114, 59, 1, 10687, 59, 3, 55349, 56620, 4, 3, 111, 114, 116, 14626, 14630, 14640, 110, 59, 1, 731, 97, 118, 101, 5, 242, 1, 59, 14638, 1, 242, 59, 1, 10689, 4, 2, 98, 109, 14649, 14654, 97, 114, 59, 1, 10677, 59, 1, 937, 110, 116, 59, 1, 8750, 4, 4, 97, 99, 105, 116, 14672, 14677, 14693, 14698, 114, 114, 59, 1, 8634, 4, 2, 105, 114, 14683, 14687, 114, 59, 1, 10686, 111, 115, 115, 59, 1, 10683, 110, 101, 59, 1, 8254, 59, 1, 10688, 4, 3, 97, 101, 105, 14709, 14714, 14719, 99, 114, 59, 1, 333, 103, 97, 59, 1, 969, 4, 3, 99, 100, 110, 14727, 14733, 14736, 114, 111, 110, 59, 1, 959, 59, 1, 10678, 117, 115, 59, 1, 8854, 112, 102, 59, 3, 55349, 56672, 4, 3, 97, 101, 108, 14755, 14759, 14764, 114, 59, 1, 10679, 114, 112, 59, 1, 10681, 117, 115, 59, 1, 8853, 4, 7, 59, 97, 100, 105, 111, 115, 118, 14785, 14787, 14792, 14831, 14837, 14841, 14848, 1, 8744, 114, 114, 59, 1, 8635, 4, 4, 59, 101, 102, 109, 14802, 14804, 14817, 14824, 1, 10845, 114, 4, 2, 59, 111, 14811, 14813, 1, 8500, 102, 59, 1, 8500, 5, 170, 1, 59, 14822, 1, 170, 5, 186, 1, 59, 14829, 1, 186, 103, 111, 102, 59, 1, 8886, 114, 59, 1, 10838, 108, 111, 112, 101, 59, 1, 10839, 59, 1, 10843, 4, 3, 99, 108, 111, 14859, 14863, 14873, 114, 59, 1, 8500, 97, 115, 104, 5, 248, 1, 59, 14871, 1, 248, 108, 59, 1, 8856, 105, 4, 2, 108, 109, 14884, 14893, 100, 101, 5, 245, 1, 59, 14891, 1, 245, 101, 115, 4, 2, 59, 97, 14901, 14903, 1, 8855, 115, 59, 1, 10806, 109, 108, 5, 246, 1, 59, 14914, 1, 246, 98, 97, 114, 59, 1, 9021, 4, 12, 97, 99, 101, 102, 104, 105, 108, 109, 111, 114, 115, 117, 14948, 14992, 14996, 15033, 15038, 15068, 15090, 15189, 15192, 15222, 15427, 15441, 114, 4, 4, 59, 97, 115, 116, 14959, 14961, 14976, 14989, 1, 8741, 5, 182, 2, 59, 108, 14968, 14970, 1, 182, 108, 101, 108, 59, 1, 8741, 4, 2, 105, 108, 14982, 14986, 109, 59, 1, 10995, 59, 1, 11005, 59, 1, 8706, 121, 59, 1, 1087, 114, 4, 5, 99, 105, 109, 112, 116, 15009, 15014, 15019, 15024, 15027, 110, 116, 59, 1, 37, 111, 100, 59, 1, 46, 105, 108, 59, 1, 8240, 59, 1, 8869, 101, 110, 107, 59, 1, 8241, 114, 59, 3, 55349, 56621, 4, 3, 105, 109, 111, 15046, 15057, 15063, 4, 2, 59, 118, 15052, 15054, 1, 966, 59, 1, 981, 109, 97, 116, 59, 1, 8499, 110, 101, 59, 1, 9742, 4, 3, 59, 116, 118, 15076, 15078, 15087, 1, 960, 99, 104, 102, 111, 114, 107, 59, 1, 8916, 59, 1, 982, 4, 2, 97, 117, 15096, 15119, 110, 4, 2, 99, 107, 15103, 15115, 107, 4, 2, 59, 104, 15110, 15112, 1, 8463, 59, 1, 8462, 118, 59, 1, 8463, 115, 4, 9, 59, 97, 98, 99, 100, 101, 109, 115, 116, 15140, 15142, 15148, 15151, 15156, 15168, 15171, 15179, 15184, 1, 43, 99, 105, 114, 59, 1, 10787, 59, 1, 8862, 105, 114, 59, 1, 10786, 4, 2, 111, 117, 15162, 15165, 59, 1, 8724, 59, 1, 10789, 59, 1, 10866, 110, 5, 177, 1, 59, 15177, 1, 177, 105, 109, 59, 1, 10790, 119, 111, 59, 1, 10791, 59, 1, 177, 4, 3, 105, 112, 117, 15200, 15208, 15213, 110, 116, 105, 110, 116, 59, 1, 10773, 102, 59, 3, 55349, 56673, 110, 100, 5, 163, 1, 59, 15220, 1, 163, 4, 10, 59, 69, 97, 99, 101, 105, 110, 111, 115, 117, 15244, 15246, 15249, 15253, 15258, 15334, 15347, 15367, 15416, 15421, 1, 8826, 59, 1, 10931, 112, 59, 1, 10935, 117, 101, 59, 1, 8828, 4, 2, 59, 99, 15264, 15266, 1, 10927, 4, 6, 59, 97, 99, 101, 110, 115, 15280, 15282, 15290, 15299, 15303, 15329, 1, 8826, 112, 112, 114, 111, 120, 59, 1, 10935, 117, 114, 108, 121, 101, 113, 59, 1, 8828, 113, 59, 1, 10927, 4, 3, 97, 101, 115, 15311, 15319, 15324, 112, 112, 114, 111, 120, 59, 1, 10937, 113, 113, 59, 1, 10933, 105, 109, 59, 1, 8936, 105, 109, 59, 1, 8830, 109, 101, 4, 2, 59, 115, 15342, 15344, 1, 8242, 59, 1, 8473, 4, 3, 69, 97, 115, 15355, 15358, 15362, 59, 1, 10933, 112, 59, 1, 10937, 105, 109, 59, 1, 8936, 4, 3, 100, 102, 112, 15375, 15378, 15404, 59, 1, 8719, 4, 3, 97, 108, 115, 15386, 15392, 15398, 108, 97, 114, 59, 1, 9006, 105, 110, 101, 59, 1, 8978, 117, 114, 102, 59, 1, 8979, 4, 2, 59, 116, 15410, 15412, 1, 8733, 111, 59, 1, 8733, 105, 109, 59, 1, 8830, 114, 101, 108, 59, 1, 8880, 4, 2, 99, 105, 15433, 15438, 114, 59, 3, 55349, 56517, 59, 1, 968, 110, 99, 115, 112, 59, 1, 8200, 4, 6, 102, 105, 111, 112, 115, 117, 15462, 15467, 15472, 15478, 15485, 15491, 114, 59, 3, 55349, 56622, 110, 116, 59, 1, 10764, 112, 102, 59, 3, 55349, 56674, 114, 105, 109, 101, 59, 1, 8279, 99, 114, 59, 3, 55349, 56518, 4, 3, 97, 101, 111, 15499, 15520, 15534, 116, 4, 2, 101, 105, 15506, 15515, 114, 110, 105, 111, 110, 115, 59, 1, 8461, 110, 116, 59, 1, 10774, 115, 116, 4, 2, 59, 101, 15528, 15530, 1, 63, 113, 59, 1, 8799, 116, 5, 34, 1, 59, 15540, 1, 34, 4, 21, 65, 66, 72, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 110, 111, 112, 114, 115, 116, 117, 120, 15586, 15609, 15615, 15620, 15796, 15855, 15893, 15931, 15977, 16001, 16039, 16183, 16204, 16222, 16228, 16285, 16312, 16318, 16363, 16408, 16416, 4, 3, 97, 114, 116, 15594, 15599, 15603, 114, 114, 59, 1, 8667, 114, 59, 1, 8658, 97, 105, 108, 59, 1, 10524, 97, 114, 114, 59, 1, 10511, 97, 114, 59, 1, 10596, 4, 7, 99, 100, 101, 110, 113, 114, 116, 15636, 15651, 15656, 15664, 15687, 15696, 15770, 4, 2, 101, 117, 15642, 15646, 59, 3, 8765, 817, 116, 101, 59, 1, 341, 105, 99, 59, 1, 8730, 109, 112, 116, 121, 118, 59, 1, 10675, 103, 4, 4, 59, 100, 101, 108, 15675, 15677, 15680, 15683, 1, 10217, 59, 1, 10642, 59, 1, 10661, 101, 59, 1, 10217, 117, 111, 5, 187, 1, 59, 15694, 1, 187, 114, 4, 11, 59, 97, 98, 99, 102, 104, 108, 112, 115, 116, 119, 15721, 15723, 15727, 15739, 15742, 15746, 15750, 15754, 15758, 15763, 15767, 1, 8594, 112, 59, 1, 10613, 4, 2, 59, 102, 15733, 15735, 1, 8677, 115, 59, 1, 10528, 59, 1, 10547, 115, 59, 1, 10526, 107, 59, 1, 8618, 112, 59, 1, 8620, 108, 59, 1, 10565, 105, 109, 59, 1, 10612, 108, 59, 1, 8611, 59, 1, 8605, 4, 2, 97, 105, 15776, 15781, 105, 108, 59, 1, 10522, 111, 4, 2, 59, 110, 15788, 15790, 1, 8758, 97, 108, 115, 59, 1, 8474, 4, 3, 97, 98, 114, 15804, 15809, 15814, 114, 114, 59, 1, 10509, 114, 107, 59, 1, 10099, 4, 2, 97, 107, 15820, 15833, 99, 4, 2, 101, 107, 15827, 15830, 59, 1, 125, 59, 1, 93, 4, 2, 101, 115, 15839, 15842, 59, 1, 10636, 108, 4, 2, 100, 117, 15849, 15852, 59, 1, 10638, 59, 1, 10640, 4, 4, 97, 101, 117, 121, 15865, 15871, 15886, 15890, 114, 111, 110, 59, 1, 345, 4, 2, 100, 105, 15877, 15882, 105, 108, 59, 1, 343, 108, 59, 1, 8969, 98, 59, 1, 125, 59, 1, 1088, 4, 4, 99, 108, 113, 115, 15903, 15907, 15914, 15927, 97, 59, 1, 10551, 100, 104, 97, 114, 59, 1, 10601, 117, 111, 4, 2, 59, 114, 15922, 15924, 1, 8221, 59, 1, 8221, 104, 59, 1, 8627, 4, 3, 97, 99, 103, 15939, 15966, 15970, 108, 4, 4, 59, 105, 112, 115, 15950, 15952, 15957, 15963, 1, 8476, 110, 101, 59, 1, 8475, 97, 114, 116, 59, 1, 8476, 59, 1, 8477, 116, 59, 1, 9645, 5, 174, 1, 59, 15975, 1, 174, 4, 3, 105, 108, 114, 15985, 15991, 15997, 115, 104, 116, 59, 1, 10621, 111, 111, 114, 59, 1, 8971, 59, 3, 55349, 56623, 4, 2, 97, 111, 16007, 16028, 114, 4, 2, 100, 117, 16014, 16017, 59, 1, 8641, 4, 2, 59, 108, 16023, 16025, 1, 8640, 59, 1, 10604, 4, 2, 59, 118, 16034, 16036, 1, 961, 59, 1, 1009, 4, 3, 103, 110, 115, 16047, 16167, 16171, 104, 116, 4, 6, 97, 104, 108, 114, 115, 116, 16063, 16081, 16103, 16130, 16143, 16155, 114, 114, 111, 119, 4, 2, 59, 116, 16073, 16075, 1, 8594, 97, 105, 108, 59, 1, 8611, 97, 114, 112, 111, 111, 110, 4, 2, 100, 117, 16093, 16099, 111, 119, 110, 59, 1, 8641, 112, 59, 1, 8640, 101, 102, 116, 4, 2, 97, 104, 16112, 16120, 114, 114, 111, 119, 115, 59, 1, 8644, 97, 114, 112, 111, 111, 110, 115, 59, 1, 8652, 105, 103, 104, 116, 97, 114, 114, 111, 119, 115, 59, 1, 8649, 113, 117, 105, 103, 97, 114, 114, 111, 119, 59, 1, 8605, 104, 114, 101, 101, 116, 105, 109, 101, 115, 59, 1, 8908, 103, 59, 1, 730, 105, 110, 103, 100, 111, 116, 115, 101, 113, 59, 1, 8787, 4, 3, 97, 104, 109, 16191, 16196, 16201, 114, 114, 59, 1, 8644, 97, 114, 59, 1, 8652, 59, 1, 8207, 111, 117, 115, 116, 4, 2, 59, 97, 16214, 16216, 1, 9137, 99, 104, 101, 59, 1, 9137, 109, 105, 100, 59, 1, 10990, 4, 4, 97, 98, 112, 116, 16238, 16252, 16257, 16278, 4, 2, 110, 114, 16244, 16248, 103, 59, 1, 10221, 114, 59, 1, 8702, 114, 107, 59, 1, 10215, 4, 3, 97, 102, 108, 16265, 16269, 16273, 114, 59, 1, 10630, 59, 3, 55349, 56675, 117, 115, 59, 1, 10798, 105, 109, 101, 115, 59, 1, 10805, 4, 2, 97, 112, 16291, 16304, 114, 4, 2, 59, 103, 16298, 16300, 1, 41, 116, 59, 1, 10644, 111, 108, 105, 110, 116, 59, 1, 10770, 97, 114, 114, 59, 1, 8649, 4, 4, 97, 99, 104, 113, 16328, 16334, 16339, 16342, 113, 117, 111, 59, 1, 8250, 114, 59, 3, 55349, 56519, 59, 1, 8625, 4, 2, 98, 117, 16348, 16351, 59, 1, 93, 111, 4, 2, 59, 114, 16358, 16360, 1, 8217, 59, 1, 8217, 4, 3, 104, 105, 114, 16371, 16377, 16383, 114, 101, 101, 59, 1, 8908, 109, 101, 115, 59, 1, 8906, 105, 4, 4, 59, 101, 102, 108, 16394, 16396, 16399, 16402, 1, 9657, 59, 1, 8885, 59, 1, 9656, 116, 114, 105, 59, 1, 10702, 108, 117, 104, 97, 114, 59, 1, 10600, 59, 1, 8478, 4, 19, 97, 98, 99, 100, 101, 102, 104, 105, 108, 109, 111, 112, 113, 114, 115, 116, 117, 119, 122, 16459, 16466, 16472, 16572, 16590, 16672, 16687, 16746, 16844, 16850, 16924, 16963, 16988, 17115, 17121, 17154, 17206, 17614, 17656, 99, 117, 116, 101, 59, 1, 347, 113, 117, 111, 59, 1, 8218, 4, 10, 59, 69, 97, 99, 101, 105, 110, 112, 115, 121, 16494, 16496, 16499, 16513, 16518, 16531, 16536, 16556, 16564, 16569, 1, 8827, 59, 1, 10932, 4, 2, 112, 114, 16505, 16508, 59, 1, 10936, 111, 110, 59, 1, 353, 117, 101, 59, 1, 8829, 4, 2, 59, 100, 16524, 16526, 1, 10928, 105, 108, 59, 1, 351, 114, 99, 59, 1, 349, 4, 3, 69, 97, 115, 16544, 16547, 16551, 59, 1, 10934, 112, 59, 1, 10938, 105, 109, 59, 1, 8937, 111, 108, 105, 110, 116, 59, 1, 10771, 105, 109, 59, 1, 8831, 59, 1, 1089, 111, 116, 4, 3, 59, 98, 101, 16582, 16584, 16587, 1, 8901, 59, 1, 8865, 59, 1, 10854, 4, 7, 65, 97, 99, 109, 115, 116, 120, 16606, 16611, 16634, 16642, 16646, 16652, 16668, 114, 114, 59, 1, 8664, 114, 4, 2, 104, 114, 16618, 16622, 107, 59, 1, 10533, 4, 2, 59, 111, 16628, 16630, 1, 8600, 119, 59, 1, 8600, 116, 5, 167, 1, 59, 16640, 1, 167, 105, 59, 1, 59, 119, 97, 114, 59, 1, 10537, 109, 4, 2, 105, 110, 16659, 16665, 110, 117, 115, 59, 1, 8726, 59, 1, 8726, 116, 59, 1, 10038, 114, 4, 2, 59, 111, 16679, 16682, 3, 55349, 56624, 119, 110, 59, 1, 8994, 4, 4, 97, 99, 111, 121, 16697, 16702, 16716, 16739, 114, 112, 59, 1, 9839, 4, 2, 104, 121, 16708, 16713, 99, 121, 59, 1, 1097, 59, 1, 1096, 114, 116, 4, 2, 109, 112, 16724, 16729, 105, 100, 59, 1, 8739, 97, 114, 97, 108, 108, 101, 108, 59, 1, 8741, 5, 173, 1, 59, 16744, 1, 173, 4, 2, 103, 109, 16752, 16770, 109, 97, 4, 3, 59, 102, 118, 16762, 16764, 16767, 1, 963, 59, 1, 962, 59, 1, 962, 4, 8, 59, 100, 101, 103, 108, 110, 112, 114, 16788, 16790, 16795, 16806, 16817, 16828, 16832, 16838, 1, 8764, 111, 116, 59, 1, 10858, 4, 2, 59, 113, 16801, 16803, 1, 8771, 59, 1, 8771, 4, 2, 59, 69, 16812, 16814, 1, 10910, 59, 1, 10912, 4, 2, 59, 69, 16823, 16825, 1, 10909, 59, 1, 10911, 101, 59, 1, 8774, 108, 117, 115, 59, 1, 10788, 97, 114, 114, 59, 1, 10610, 97, 114, 114, 59, 1, 8592, 4, 4, 97, 101, 105, 116, 16860, 16883, 16891, 16904, 4, 2, 108, 115, 16866, 16878, 108, 115, 101, 116, 109, 105, 110, 117, 115, 59, 1, 8726, 104, 112, 59, 1, 10803, 112, 97, 114, 115, 108, 59, 1, 10724, 4, 2, 100, 108, 16897, 16900, 59, 1, 8739, 101, 59, 1, 8995, 4, 2, 59, 101, 16910, 16912, 1, 10922, 4, 2, 59, 115, 16918, 16920, 1, 10924, 59, 3, 10924, 65024, 4, 3, 102, 108, 112, 16932, 16938, 16958, 116, 99, 121, 59, 1, 1100, 4, 2, 59, 98, 16944, 16946, 1, 47, 4, 2, 59, 97, 16952, 16954, 1, 10692, 114, 59, 1, 9023, 102, 59, 3, 55349, 56676, 97, 4, 2, 100, 114, 16970, 16985, 101, 115, 4, 2, 59, 117, 16978, 16980, 1, 9824, 105, 116, 59, 1, 9824, 59, 1, 8741, 4, 3, 99, 115, 117, 16996, 17028, 17089, 4, 2, 97, 117, 17002, 17015, 112, 4, 2, 59, 115, 17009, 17011, 1, 8851, 59, 3, 8851, 65024, 112, 4, 2, 59, 115, 17022, 17024, 1, 8852, 59, 3, 8852, 65024, 117, 4, 2, 98, 112, 17035, 17062, 4, 3, 59, 101, 115, 17043, 17045, 17048, 1, 8847, 59, 1, 8849, 101, 116, 4, 2, 59, 101, 17056, 17058, 1, 8847, 113, 59, 1, 8849, 4, 3, 59, 101, 115, 17070, 17072, 17075, 1, 8848, 59, 1, 8850, 101, 116, 4, 2, 59, 101, 17083, 17085, 1, 8848, 113, 59, 1, 8850, 4, 3, 59, 97, 102, 17097, 17099, 17112, 1, 9633, 114, 4, 2, 101, 102, 17106, 17109, 59, 1, 9633, 59, 1, 9642, 59, 1, 9642, 97, 114, 114, 59, 1, 8594, 4, 4, 99, 101, 109, 116, 17131, 17136, 17142, 17148, 114, 59, 3, 55349, 56520, 116, 109, 110, 59, 1, 8726, 105, 108, 101, 59, 1, 8995, 97, 114, 102, 59, 1, 8902, 4, 2, 97, 114, 17160, 17172, 114, 4, 2, 59, 102, 17167, 17169, 1, 9734, 59, 1, 9733, 4, 2, 97, 110, 17178, 17202, 105, 103, 104, 116, 4, 2, 101, 112, 17188, 17197, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 104, 105, 59, 1, 981, 115, 59, 1, 175, 4, 5, 98, 99, 109, 110, 112, 17218, 17351, 17420, 17423, 17427, 4, 9, 59, 69, 100, 101, 109, 110, 112, 114, 115, 17238, 17240, 17243, 17248, 17261, 17267, 17279, 17285, 17291, 1, 8834, 59, 1, 10949, 111, 116, 59, 1, 10941, 4, 2, 59, 100, 17254, 17256, 1, 8838, 111, 116, 59, 1, 10947, 117, 108, 116, 59, 1, 10945, 4, 2, 69, 101, 17273, 17276, 59, 1, 10955, 59, 1, 8842, 108, 117, 115, 59, 1, 10943, 97, 114, 114, 59, 1, 10617, 4, 3, 101, 105, 117, 17299, 17335, 17339, 116, 4, 3, 59, 101, 110, 17308, 17310, 17322, 1, 8834, 113, 4, 2, 59, 113, 17317, 17319, 1, 8838, 59, 1, 10949, 101, 113, 4, 2, 59, 113, 17330, 17332, 1, 8842, 59, 1, 10955, 109, 59, 1, 10951, 4, 2, 98, 112, 17345, 17348, 59, 1, 10965, 59, 1, 10963, 99, 4, 6, 59, 97, 99, 101, 110, 115, 17366, 17368, 17376, 17385, 17389, 17415, 1, 8827, 112, 112, 114, 111, 120, 59, 1, 10936, 117, 114, 108, 121, 101, 113, 59, 1, 8829, 113, 59, 1, 10928, 4, 3, 97, 101, 115, 17397, 17405, 17410, 112, 112, 114, 111, 120, 59, 1, 10938, 113, 113, 59, 1, 10934, 105, 109, 59, 1, 8937, 105, 109, 59, 1, 8831, 59, 1, 8721, 103, 59, 1, 9834, 4, 13, 49, 50, 51, 59, 69, 100, 101, 104, 108, 109, 110, 112, 115, 17455, 17462, 17469, 17476, 17478, 17481, 17496, 17509, 17524, 17530, 17536, 17548, 17554, 5, 185, 1, 59, 17460, 1, 185, 5, 178, 1, 59, 17467, 1, 178, 5, 179, 1, 59, 17474, 1, 179, 1, 8835, 59, 1, 10950, 4, 2, 111, 115, 17487, 17491, 116, 59, 1, 10942, 117, 98, 59, 1, 10968, 4, 2, 59, 100, 17502, 17504, 1, 8839, 111, 116, 59, 1, 10948, 115, 4, 2, 111, 117, 17516, 17520, 108, 59, 1, 10185, 98, 59, 1, 10967, 97, 114, 114, 59, 1, 10619, 117, 108, 116, 59, 1, 10946, 4, 2, 69, 101, 17542, 17545, 59, 1, 10956, 59, 1, 8843, 108, 117, 115, 59, 1, 10944, 4, 3, 101, 105, 117, 17562, 17598, 17602, 116, 4, 3, 59, 101, 110, 17571, 17573, 17585, 1, 8835, 113, 4, 2, 59, 113, 17580, 17582, 1, 8839, 59, 1, 10950, 101, 113, 4, 2, 59, 113, 17593, 17595, 1, 8843, 59, 1, 10956, 109, 59, 1, 10952, 4, 2, 98, 112, 17608, 17611, 59, 1, 10964, 59, 1, 10966, 4, 3, 65, 97, 110, 17622, 17627, 17650, 114, 114, 59, 1, 8665, 114, 4, 2, 104, 114, 17634, 17638, 107, 59, 1, 10534, 4, 2, 59, 111, 17644, 17646, 1, 8601, 119, 59, 1, 8601, 119, 97, 114, 59, 1, 10538, 108, 105, 103, 5, 223, 1, 59, 17664, 1, 223, 4, 13, 97, 98, 99, 100, 101, 102, 104, 105, 111, 112, 114, 115, 119, 17694, 17709, 17714, 17737, 17742, 17749, 17754, 17860, 17905, 17957, 17964, 18090, 18122, 4, 2, 114, 117, 17700, 17706, 103, 101, 116, 59, 1, 8982, 59, 1, 964, 114, 107, 59, 1, 9140, 4, 3, 97, 101, 121, 17722, 17728, 17734, 114, 111, 110, 59, 1, 357, 100, 105, 108, 59, 1, 355, 59, 1, 1090, 111, 116, 59, 1, 8411, 108, 114, 101, 99, 59, 1, 8981, 114, 59, 3, 55349, 56625, 4, 4, 101, 105, 107, 111, 17764, 17805, 17836, 17851, 4, 2, 114, 116, 17770, 17786, 101, 4, 2, 52, 102, 17777, 17780, 59, 1, 8756, 111, 114, 101, 59, 1, 8756, 97, 4, 3, 59, 115, 118, 17795, 17797, 17802, 1, 952, 121, 109, 59, 1, 977, 59, 1, 977, 4, 2, 99, 110, 17811, 17831, 107, 4, 2, 97, 115, 17818, 17826, 112, 112, 114, 111, 120, 59, 1, 8776, 105, 109, 59, 1, 8764, 115, 112, 59, 1, 8201, 4, 2, 97, 115, 17842, 17846, 112, 59, 1, 8776, 105, 109, 59, 1, 8764, 114, 110, 5, 254, 1, 59, 17858, 1, 254, 4, 3, 108, 109, 110, 17868, 17873, 17901, 100, 101, 59, 1, 732, 101, 115, 5, 215, 3, 59, 98, 100, 17884, 17886, 17898, 1, 215, 4, 2, 59, 97, 17892, 17894, 1, 8864, 114, 59, 1, 10801, 59, 1, 10800, 116, 59, 1, 8749, 4, 3, 101, 112, 115, 17913, 17917, 17953, 97, 59, 1, 10536, 4, 4, 59, 98, 99, 102, 17927, 17929, 17934, 17939, 1, 8868, 111, 116, 59, 1, 9014, 105, 114, 59, 1, 10993, 4, 2, 59, 111, 17945, 17948, 3, 55349, 56677, 114, 107, 59, 1, 10970, 97, 59, 1, 10537, 114, 105, 109, 101, 59, 1, 8244, 4, 3, 97, 105, 112, 17972, 17977, 18082, 100, 101, 59, 1, 8482, 4, 7, 97, 100, 101, 109, 112, 115, 116, 17993, 18051, 18056, 18059, 18066, 18072, 18076, 110, 103, 108, 101, 4, 5, 59, 100, 108, 113, 114, 18009, 18011, 18017, 18032, 18035, 1, 9653, 111, 119, 110, 59, 1, 9663, 101, 102, 116, 4, 2, 59, 101, 18026, 18028, 1, 9667, 113, 59, 1, 8884, 59, 1, 8796, 105, 103, 104, 116, 4, 2, 59, 101, 18045, 18047, 1, 9657, 113, 59, 1, 8885, 111, 116, 59, 1, 9708, 59, 1, 8796, 105, 110, 117, 115, 59, 1, 10810, 108, 117, 115, 59, 1, 10809, 98, 59, 1, 10701, 105, 109, 101, 59, 1, 10811, 101, 122, 105, 117, 109, 59, 1, 9186, 4, 3, 99, 104, 116, 18098, 18111, 18116, 4, 2, 114, 121, 18104, 18108, 59, 3, 55349, 56521, 59, 1, 1094, 99, 121, 59, 1, 1115, 114, 111, 107, 59, 1, 359, 4, 2, 105, 111, 18128, 18133, 120, 116, 59, 1, 8812, 104, 101, 97, 100, 4, 2, 108, 114, 18143, 18154, 101, 102, 116, 97, 114, 114, 111, 119, 59, 1, 8606, 105, 103, 104, 116, 97, 114, 114, 111, 119, 59, 1, 8608, 4, 18, 65, 72, 97, 98, 99, 100, 102, 103, 104, 108, 109, 111, 112, 114, 115, 116, 117, 119, 18204, 18209, 18214, 18234, 18250, 18268, 18292, 18308, 18319, 18343, 18379, 18397, 18413, 18504, 18547, 18553, 18584, 18603, 114, 114, 59, 1, 8657, 97, 114, 59, 1, 10595, 4, 2, 99, 114, 18220, 18230, 117, 116, 101, 5, 250, 1, 59, 18228, 1, 250, 114, 59, 1, 8593, 114, 4, 2, 99, 101, 18241, 18245, 121, 59, 1, 1118, 118, 101, 59, 1, 365, 4, 2, 105, 121, 18256, 18265, 114, 99, 5, 251, 1, 59, 18263, 1, 251, 59, 1, 1091, 4, 3, 97, 98, 104, 18276, 18281, 18287, 114, 114, 59, 1, 8645, 108, 97, 99, 59, 1, 369, 97, 114, 59, 1, 10606, 4, 2, 105, 114, 18298, 18304, 115, 104, 116, 59, 1, 10622, 59, 3, 55349, 56626, 114, 97, 118, 101, 5, 249, 1, 59, 18317, 1, 249, 4, 2, 97, 98, 18325, 18338, 114, 4, 2, 108, 114, 18332, 18335, 59, 1, 8639, 59, 1, 8638, 108, 107, 59, 1, 9600, 4, 2, 99, 116, 18349, 18374, 4, 2, 111, 114, 18355, 18369, 114, 110, 4, 2, 59, 101, 18363, 18365, 1, 8988, 114, 59, 1, 8988, 111, 112, 59, 1, 8975, 114, 105, 59, 1, 9720, 4, 2, 97, 108, 18385, 18390, 99, 114, 59, 1, 363, 5, 168, 1, 59, 18395, 1, 168, 4, 2, 103, 112, 18403, 18408, 111, 110, 59, 1, 371, 102, 59, 3, 55349, 56678, 4, 6, 97, 100, 104, 108, 115, 117, 18427, 18434, 18445, 18470, 18475, 18494, 114, 114, 111, 119, 59, 1, 8593, 111, 119, 110, 97, 114, 114, 111, 119, 59, 1, 8597, 97, 114, 112, 111, 111, 110, 4, 2, 108, 114, 18457, 18463, 101, 102, 116, 59, 1, 8639, 105, 103, 104, 116, 59, 1, 8638, 117, 115, 59, 1, 8846, 105, 4, 3, 59, 104, 108, 18484, 18486, 18489, 1, 965, 59, 1, 978, 111, 110, 59, 1, 965, 112, 97, 114, 114, 111, 119, 115, 59, 1, 8648, 4, 3, 99, 105, 116, 18512, 18537, 18542, 4, 2, 111, 114, 18518, 18532, 114, 110, 4, 2, 59, 101, 18526, 18528, 1, 8989, 114, 59, 1, 8989, 111, 112, 59, 1, 8974, 110, 103, 59, 1, 367, 114, 105, 59, 1, 9721, 99, 114, 59, 3, 55349, 56522, 4, 3, 100, 105, 114, 18561, 18566, 18572, 111, 116, 59, 1, 8944, 108, 100, 101, 59, 1, 361, 105, 4, 2, 59, 102, 18579, 18581, 1, 9653, 59, 1, 9652, 4, 2, 97, 109, 18590, 18595, 114, 114, 59, 1, 8648, 108, 5, 252, 1, 59, 18601, 1, 252, 97, 110, 103, 108, 101, 59, 1, 10663, 4, 15, 65, 66, 68, 97, 99, 100, 101, 102, 108, 110, 111, 112, 114, 115, 122, 18643, 18648, 18661, 18667, 18847, 18851, 18857, 18904, 18909, 18915, 18931, 18937, 18943, 18949, 18996, 114, 114, 59, 1, 8661, 97, 114, 4, 2, 59, 118, 18656, 18658, 1, 10984, 59, 1, 10985, 97, 115, 104, 59, 1, 8872, 4, 2, 110, 114, 18673, 18679, 103, 114, 116, 59, 1, 10652, 4, 7, 101, 107, 110, 112, 114, 115, 116, 18695, 18704, 18711, 18720, 18742, 18754, 18810, 112, 115, 105, 108, 111, 110, 59, 1, 1013, 97, 112, 112, 97, 59, 1, 1008, 111, 116, 104, 105, 110, 103, 59, 1, 8709, 4, 3, 104, 105, 114, 18728, 18732, 18735, 105, 59, 1, 981, 59, 1, 982, 111, 112, 116, 111, 59, 1, 8733, 4, 2, 59, 104, 18748, 18750, 1, 8597, 111, 59, 1, 1009, 4, 2, 105, 117, 18760, 18766, 103, 109, 97, 59, 1, 962, 4, 2, 98, 112, 18772, 18791, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18784, 18787, 3, 8842, 65024, 59, 3, 10955, 65024, 115, 101, 116, 110, 101, 113, 4, 2, 59, 113, 18803, 18806, 3, 8843, 65024, 59, 3, 10956, 65024, 4, 2, 104, 114, 18816, 18822, 101, 116, 97, 59, 1, 977, 105, 97, 110, 103, 108, 101, 4, 2, 108, 114, 18834, 18840, 101, 102, 116, 59, 1, 8882, 105, 103, 104, 116, 59, 1, 8883, 121, 59, 1, 1074, 97, 115, 104, 59, 1, 8866, 4, 3, 101, 108, 114, 18865, 18884, 18890, 4, 3, 59, 98, 101, 18873, 18875, 18880, 1, 8744, 97, 114, 59, 1, 8891, 113, 59, 1, 8794, 108, 105, 112, 59, 1, 8942, 4, 2, 98, 116, 18896, 18901, 97, 114, 59, 1, 124, 59, 1, 124, 114, 59, 3, 55349, 56627, 116, 114, 105, 59, 1, 8882, 115, 117, 4, 2, 98, 112, 18923, 18927, 59, 3, 8834, 8402, 59, 3, 8835, 8402, 112, 102, 59, 3, 55349, 56679, 114, 111, 112, 59, 1, 8733, 116, 114, 105, 59, 1, 8883, 4, 2, 99, 117, 18955, 18960, 114, 59, 3, 55349, 56523, 4, 2, 98, 112, 18966, 18981, 110, 4, 2, 69, 101, 18973, 18977, 59, 3, 10955, 65024, 59, 3, 8842, 65024, 110, 4, 2, 69, 101, 18988, 18992, 59, 3, 10956, 65024, 59, 3, 8843, 65024, 105, 103, 122, 97, 103, 59, 1, 10650, 4, 7, 99, 101, 102, 111, 112, 114, 115, 19020, 19026, 19061, 19066, 19072, 19075, 19089, 105, 114, 99, 59, 1, 373, 4, 2, 100, 105, 19032, 19055, 4, 2, 98, 103, 19038, 19043, 97, 114, 59, 1, 10847, 101, 4, 2, 59, 113, 19050, 19052, 1, 8743, 59, 1, 8793, 101, 114, 112, 59, 1, 8472, 114, 59, 3, 55349, 56628, 112, 102, 59, 3, 55349, 56680, 59, 1, 8472, 4, 2, 59, 101, 19081, 19083, 1, 8768, 97, 116, 104, 59, 1, 8768, 99, 114, 59, 3, 55349, 56524, 4, 14, 99, 100, 102, 104, 105, 108, 109, 110, 111, 114, 115, 117, 118, 119, 19125, 19146, 19152, 19157, 19173, 19176, 19192, 19197, 19202, 19236, 19252, 19269, 19286, 19291, 4, 3, 97, 105, 117, 19133, 19137, 19142, 112, 59, 1, 8898, 114, 99, 59, 1, 9711, 112, 59, 1, 8899, 116, 114, 105, 59, 1, 9661, 114, 59, 3, 55349, 56629, 4, 2, 65, 97, 19163, 19168, 114, 114, 59, 1, 10234, 114, 114, 59, 1, 10231, 59, 1, 958, 4, 2, 65, 97, 19182, 19187, 114, 114, 59, 1, 10232, 114, 114, 59, 1, 10229, 97, 112, 59, 1, 10236, 105, 115, 59, 1, 8955, 4, 3, 100, 112, 116, 19210, 19215, 19230, 111, 116, 59, 1, 10752, 4, 2, 102, 108, 19221, 19225, 59, 3, 55349, 56681, 117, 115, 59, 1, 10753, 105, 109, 101, 59, 1, 10754, 4, 2, 65, 97, 19242, 19247, 114, 114, 59, 1, 10233, 114, 114, 59, 1, 10230, 4, 2, 99, 113, 19258, 19263, 114, 59, 3, 55349, 56525, 99, 117, 112, 59, 1, 10758, 4, 2, 112, 116, 19275, 19281, 108, 117, 115, 59, 1, 10756, 114, 105, 59, 1, 9651, 101, 101, 59, 1, 8897, 101, 100, 103, 101, 59, 1, 8896, 4, 8, 97, 99, 101, 102, 105, 111, 115, 117, 19316, 19335, 19349, 19357, 19362, 19367, 19373, 19379, 99, 4, 2, 117, 121, 19323, 19332, 116, 101, 5, 253, 1, 59, 19330, 1, 253, 59, 1, 1103, 4, 2, 105, 121, 19341, 19346, 114, 99, 59, 1, 375, 59, 1, 1099, 110, 5, 165, 1, 59, 19355, 1, 165, 114, 59, 3, 55349, 56630, 99, 121, 59, 1, 1111, 112, 102, 59, 3, 55349, 56682, 99, 114, 59, 3, 55349, 56526, 4, 2, 99, 109, 19385, 19389, 121, 59, 1, 1102, 108, 5, 255, 1, 59, 19395, 1, 255, 4, 10, 97, 99, 100, 101, 102, 104, 105, 111, 115, 119, 19419, 19426, 19441, 19446, 19462, 19467, 19472, 19480, 19486, 19492, 99, 117, 116, 101, 59, 1, 378, 4, 2, 97, 121, 19432, 19438, 114, 111, 110, 59, 1, 382, 59, 1, 1079, 111, 116, 59, 1, 380, 4, 2, 101, 116, 19452, 19458, 116, 114, 102, 59, 1, 8488, 97, 59, 1, 950, 114, 59, 3, 55349, 56631, 99, 121, 59, 1, 1078, 103, 114, 97, 114, 114, 59, 1, 8669, 112, 102, 59, 3, 55349, 56683, 99, 114, 59, 3, 55349, 56527, 4, 2, 106, 110, 19498, 19501, 59, 1, 8205, 106, 59, 1, 8204]);

/***/ }),

/***/ 7058:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var unicode = __webpack_require__(9879);
var ERR = __webpack_require__(4688);

//Aliases
var $ = unicode.CODE_POINTS;

//Const
var DEFAULT_BUFFER_WATERLINE = 1 << 16;

//Preprocessor
//NOTE: HTML input preprocessing
//(see: http://www.whatwg.org/specs/web-apps/current-work/multipage/parsing.html#preprocessing-the-input-stream)
var Preprocessor = /*#__PURE__*/function () {
  function Preprocessor() {
    _classCallCheck(this, Preprocessor);
    this.html = null;
    this.pos = -1;
    this.lastGapPos = -1;
    this.lastCharPos = -1;
    this.gapStack = [];
    this.skipNextNewLine = false;
    this.lastChunkWritten = false;
    this.endOfChunkHit = false;
    this.bufferWaterline = DEFAULT_BUFFER_WATERLINE;
  }
  _createClass(Preprocessor, [{
    key: "_err",
    value: function _err() {
      // NOTE: err reporting is noop by default. Enabled by mixin.
    }
  }, {
    key: "_addGap",
    value: function _addGap() {
      this.gapStack.push(this.lastGapPos);
      this.lastGapPos = this.pos;
    }
  }, {
    key: "_processSurrogate",
    value: function _processSurrogate(cp) {
      //NOTE: try to peek a surrogate pair
      if (this.pos !== this.lastCharPos) {
        var nextCp = this.html.charCodeAt(this.pos + 1);
        if (unicode.isSurrogatePair(nextCp)) {
          //NOTE: we have a surrogate pair. Peek pair character and recalculate code point.
          this.pos++;

          //NOTE: add gap that should be avoided during retreat
          this._addGap();
          return unicode.getSurrogatePairCodePoint(cp, nextCp);
        }
      }

      //NOTE: we are at the end of a chunk, therefore we can't infer surrogate pair yet.
      else if (!this.lastChunkWritten) {
        this.endOfChunkHit = true;
        return $.EOF;
      }

      //NOTE: isolated surrogate
      this._err(ERR.surrogateInInputStream);
      return cp;
    }
  }, {
    key: "dropParsedChunk",
    value: function dropParsedChunk() {
      if (this.pos > this.bufferWaterline) {
        this.lastCharPos -= this.pos;
        this.html = this.html.substring(this.pos);
        this.pos = 0;
        this.lastGapPos = -1;
        this.gapStack = [];
      }
    }
  }, {
    key: "write",
    value: function write(chunk, isLastChunk) {
      if (this.html) {
        this.html += chunk;
      } else {
        this.html = chunk;
      }
      this.lastCharPos = this.html.length - 1;
      this.endOfChunkHit = false;
      this.lastChunkWritten = isLastChunk;
    }
  }, {
    key: "insertHtmlAtCurrentPos",
    value: function insertHtmlAtCurrentPos(chunk) {
      this.html = this.html.substring(0, this.pos + 1) + chunk + this.html.substring(this.pos + 1, this.html.length);
      this.lastCharPos = this.html.length - 1;
      this.endOfChunkHit = false;
    }
  }, {
    key: "advance",
    value: function advance() {
      this.pos++;
      if (this.pos > this.lastCharPos) {
        this.endOfChunkHit = !this.lastChunkWritten;
        return $.EOF;
      }
      var cp = this.html.charCodeAt(this.pos);

      //NOTE: any U+000A LINE FEED (LF) characters that immediately follow a U+000D CARRIAGE RETURN (CR) character
      //must be ignored.
      if (this.skipNextNewLine && cp === $.LINE_FEED) {
        this.skipNextNewLine = false;
        this._addGap();
        return this.advance();
      }

      //NOTE: all U+000D CARRIAGE RETURN (CR) characters must be converted to U+000A LINE FEED (LF) characters
      if (cp === $.CARRIAGE_RETURN) {
        this.skipNextNewLine = true;
        return $.LINE_FEED;
      }
      this.skipNextNewLine = false;
      if (unicode.isSurrogate(cp)) {
        cp = this._processSurrogate(cp);
      }

      //OPTIMIZATION: first check if code point is in the common allowed
      //range (ASCII alphanumeric, whitespaces, big chunk of BMP)
      //before going into detailed performance cost validation.
      var isCommonValidRange = cp > 0x1f && cp < 0x7f || cp === $.LINE_FEED || cp === $.CARRIAGE_RETURN || cp > 0x9f && cp < 0xfdd0;
      if (!isCommonValidRange) {
        this._checkForProblematicCharacters(cp);
      }
      return cp;
    }
  }, {
    key: "_checkForProblematicCharacters",
    value: function _checkForProblematicCharacters(cp) {
      if (unicode.isControlCodePoint(cp)) {
        this._err(ERR.controlCharacterInInputStream);
      } else if (unicode.isUndefinedCodePoint(cp)) {
        this._err(ERR.noncharacterInInputStream);
      }
    }
  }, {
    key: "retreat",
    value: function retreat() {
      if (this.pos === this.lastGapPos) {
        this.lastGapPos = this.gapStack.pop();
        this.pos--;
      }
      this.pos--;
    }
  }]);
  return Preprocessor;
}();
module.exports = Preprocessor;

/***/ }),

/***/ 7423:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var _require = __webpack_require__(8869),
  DOCUMENT_MODE = _require.DOCUMENT_MODE;

//Node construction
exports.createDocument = function () {
  return {
    nodeName: '#document',
    mode: DOCUMENT_MODE.NO_QUIRKS,
    childNodes: []
  };
};
exports.createDocumentFragment = function () {
  return {
    nodeName: '#document-fragment',
    childNodes: []
  };
};
exports.createElement = function (tagName, namespaceURI, attrs) {
  return {
    nodeName: tagName,
    tagName: tagName,
    attrs: attrs,
    namespaceURI: namespaceURI,
    childNodes: [],
    parentNode: null
  };
};
exports.createCommentNode = function (data) {
  return {
    nodeName: '#comment',
    data: data,
    parentNode: null
  };
};
var createTextNode = function createTextNode(value) {
  return {
    nodeName: '#text',
    value: value,
    parentNode: null
  };
};

//Tree mutation
var appendChild = exports.appendChild = function (parentNode, newNode) {
  parentNode.childNodes.push(newNode);
  newNode.parentNode = parentNode;
};
var insertBefore = exports.insertBefore = function (parentNode, newNode, referenceNode) {
  var insertionIdx = parentNode.childNodes.indexOf(referenceNode);
  parentNode.childNodes.splice(insertionIdx, 0, newNode);
  newNode.parentNode = parentNode;
};
exports.setTemplateContent = function (templateElement, contentElement) {
  templateElement.content = contentElement;
};
exports.getTemplateContent = function (templateElement) {
  return templateElement.content;
};
exports.setDocumentType = function (document, name, publicId, systemId) {
  var doctypeNode = null;
  for (var i = 0; i < document.childNodes.length; i++) {
    if (document.childNodes[i].nodeName === '#documentType') {
      doctypeNode = document.childNodes[i];
      break;
    }
  }
  if (doctypeNode) {
    doctypeNode.name = name;
    doctypeNode.publicId = publicId;
    doctypeNode.systemId = systemId;
  } else {
    appendChild(document, {
      nodeName: '#documentType',
      name: name,
      publicId: publicId,
      systemId: systemId
    });
  }
};
exports.setDocumentMode = function (document, mode) {
  document.mode = mode;
};
exports.getDocumentMode = function (document) {
  return document.mode;
};
exports.detachNode = function (node) {
  if (node.parentNode) {
    var idx = node.parentNode.childNodes.indexOf(node);
    node.parentNode.childNodes.splice(idx, 1);
    node.parentNode = null;
  }
};
exports.insertText = function (parentNode, text) {
  if (parentNode.childNodes.length) {
    var prevNode = parentNode.childNodes[parentNode.childNodes.length - 1];
    if (prevNode.nodeName === '#text') {
      prevNode.value += text;
      return;
    }
  }
  appendChild(parentNode, createTextNode(text));
};
exports.insertTextBefore = function (parentNode, text, referenceNode) {
  var prevNode = parentNode.childNodes[parentNode.childNodes.indexOf(referenceNode) - 1];
  if (prevNode && prevNode.nodeName === '#text') {
    prevNode.value += text;
  } else {
    insertBefore(parentNode, createTextNode(text), referenceNode);
  }
};
exports.adoptAttributes = function (recipient, attrs) {
  var recipientAttrsMap = [];
  for (var i = 0; i < recipient.attrs.length; i++) {
    recipientAttrsMap.push(recipient.attrs[i].name);
  }
  for (var j = 0; j < attrs.length; j++) {
    if (recipientAttrsMap.indexOf(attrs[j].name) === -1) {
      recipient.attrs.push(attrs[j]);
    }
  }
};

//Tree traversing
exports.getFirstChild = function (node) {
  return node.childNodes[0];
};
exports.getChildNodes = function (node) {
  return node.childNodes;
};
exports.getParentNode = function (node) {
  return node.parentNode;
};
exports.getAttrList = function (element) {
  return element.attrs;
};

//Node data
exports.getTagName = function (element) {
  return element.tagName;
};
exports.getNamespaceURI = function (element) {
  return element.namespaceURI;
};
exports.getTextNodeContent = function (textNode) {
  return textNode.value;
};
exports.getCommentNodeContent = function (commentNode) {
  return commentNode.data;
};
exports.getDocumentTypeNodeName = function (doctypeNode) {
  return doctypeNode.name;
};
exports.getDocumentTypeNodePublicId = function (doctypeNode) {
  return doctypeNode.publicId;
};
exports.getDocumentTypeNodeSystemId = function (doctypeNode) {
  return doctypeNode.systemId;
};

//Node types
exports.isTextNode = function (node) {
  return node.nodeName === '#text';
};
exports.isCommentNode = function (node) {
  return node.nodeName === '#comment';
};
exports.isDocumentTypeNode = function (node) {
  return node.nodeName === '#documentType';
};
exports.isElementNode = function (node) {
  return !!node.tagName;
};

// Source code location
exports.setNodeSourceCodeLocation = function (node, location) {
  node.sourceCodeLocation = location;
};
exports.getNodeSourceCodeLocation = function (node) {
  return node.sourceCodeLocation;
};
exports.updateNodeSourceCodeLocation = function (node, endLocation) {
  node.sourceCodeLocation = Object.assign(node.sourceCodeLocation, endLocation);
};

/***/ }),

/***/ 5758:
/***/ ((module) => {

"use strict";


module.exports = function mergeOptions(defaults, options) {
  options = options || Object.create(null);
  return [defaults, options].reduce(function (merged, optObj) {
    Object.keys(optObj).forEach(function (key) {
      merged[key] = optObj[key];
    });
    return merged;
  }, Object.create(null));
};

/***/ }),

/***/ 4086:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var Mixin = /*#__PURE__*/function () {
  function Mixin(host) {
    _classCallCheck(this, Mixin);
    var originalMethods = {};
    var overriddenMethods = this._getOverriddenMethods(this, originalMethods);
    for (var _i = 0, _Object$keys = Object.keys(overriddenMethods); _i < _Object$keys.length; _i++) {
      var key = _Object$keys[_i];
      if (typeof overriddenMethods[key] === 'function') {
        originalMethods[key] = host[key];
        host[key] = overriddenMethods[key];
      }
    }
  }
  _createClass(Mixin, [{
    key: "_getOverriddenMethods",
    value: function _getOverriddenMethods() {
      throw new Error('Not implemented');
    }
  }]);
  return Mixin;
}();
Mixin.install = function (host, Ctor, opts) {
  if (!host.__mixins) {
    host.__mixins = [];
  }
  for (var i = 0; i < host.__mixins.length; i++) {
    if (host.__mixins[i].constructor === Ctor) {
      return host.__mixins[i];
    }
  }
  var mixin = new Ctor(host, opts);
  host.__mixins.push(mixin);
  return mixin;
};
module.exports = Mixin;

/***/ }),

/***/ 8447:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _extends = __webpack_require__(7154);
var _objectWithoutProperties = __webpack_require__(6479);
var _slicedToArray = __webpack_require__(3038);
var _excluded = ["baseUrl", "children", "href", "target", "title"];
var PropTypes = __webpack_require__(5697);
var React = __webpack_require__(4466);
var BaseUrlContext = __webpack_require__(6785);

// Nabbed from here:
// https://github.com/readmeio/api-explorer/blob/0dedafcf71102feedaa4145040d3f57d79d95752/packages/api-explorer/src/lib/markdown/renderer.js#L52
function getHref(href, baseUrl) {
  var _href$split = href.split('#'),
    _href$split2 = _slicedToArray(_href$split, 2),
    path = _href$split2[0],
    hash = _href$split2[1];
  var hashStr = hash ? "#".concat(hash) : '';
  var base = baseUrl === '/' ? '' : baseUrl;
  var doc = path.match(/^doc:([-_a-zA-Z0-9#]*)$/);
  if (doc) {
    return "".concat(base, "/docs/").concat(doc[1]).concat(hashStr);
  }
  var ref = path.match(/^ref:([-_a-zA-Z0-9#]*)$/);
  if (ref) {
    return "".concat(base, "/reference-link/").concat(ref[1]).concat(hashStr);
  }

  // we need to perform two matches for changelogs in case
  // of legacy links that use 'blog' instead of 'changelog'
  var blog = path.match(/^blog:([-_a-zA-Z0-9#]*)$/);
  var changelog = path.match(/^changelog:([-_a-zA-Z0-9#]*)$/);
  var changelogMatch = blog || changelog;
  if (changelogMatch) {
    return "".concat(base, "/changelog/").concat(changelogMatch[1]).concat(hashStr);
  }
  var custompage = path.match(/^page:([-_a-zA-Z0-9#]*)$/);
  if (custompage) {
    return "".concat(base, "/page/").concat(custompage[1]).concat(hashStr);
  }
  return href;
}
function docLink(href) {
  var doc = href.match(/^doc:([-_a-zA-Z0-9#]*)$/);
  if (!doc) return false;
  return {
    className: 'doc-link',
    'data-sidebar': doc[1]
  };
}
function Anchor(props) {
  var baseUrl = props.baseUrl,
    children = props.children,
    href = props.href,
    target = props.target,
    title = props.title,
    attrs = _objectWithoutProperties(props, _excluded);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("a", _extends({}, attrs, {
      href: getHref(href, baseUrl),
      target: target,
      title: title
    }, docLink(href)), children)
  );
}
Anchor.propTypes = {
  baseUrl: PropTypes.string,
  children: PropTypes.node.isRequired,
  download: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  title: PropTypes.string
};
Anchor.defaultProps = {
  baseUrl: '/',
  href: '',
  target: '',
  title: ''
};
var AnchorWithContext = function AnchorWithContext(props) {
  return /*#__PURE__*/React.createElement(BaseUrlContext.Consumer, null, function (baseUrl) {
    return /*#__PURE__*/React.createElement(Anchor, _extends({
      baseUrl: baseUrl
    }, props));
  });
};
AnchorWithContext.sanitize = function (sanitizeSchema) {
  // This is for our custom link formats
  sanitizeSchema.protocols.href.push('doc', 'target', 'ref', 'blog', 'changelog', 'page');
  return sanitizeSchema;
};
module.exports = AnchorWithContext;
AnchorWithContext.getHref = getHref;

/***/ }),

/***/ 2015:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _extends = __webpack_require__(7154);
var _toArray = __webpack_require__(8551);
var PropTypes = __webpack_require__(5697);
var React = __webpack_require__(4466);
var Callout = function Callout(props) {
  var attributes = props.attributes,
    theme = props.theme,
    icon = props.icon;
  var _ref = !props.title ? [null, props.children] : props.children,
    _ref2 = _toArray(_ref),
    title = _ref2[0],
    content = _ref2.slice(1);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("blockquote", _extends({}, attributes, {
      className: "callout callout_".concat(theme),
      theme: icon
    }), /*#__PURE__*/React.createElement("h3", {
      className: "callout-heading".concat(title ? '' : ' empty')
    }, /*#__PURE__*/React.createElement("span", {
      className: "callout-icon"
    }, icon), title), content)
  );
};
Callout.propTypes = {
  attributes: PropTypes.shape({}),
  calloutStyle: PropTypes.string,
  children: PropTypes.arrayOf(PropTypes.any).isRequired,
  icon: PropTypes.string,
  node: PropTypes.shape(),
  theme: PropTypes.string,
  title: PropTypes.string
};
Callout.defaultProps = {
  attributes: null,
  calloutStyle: 'info',
  node: null
};
Callout.sanitize = function (sanitizeSchema) {
  sanitizeSchema.attributes['rdme-callout'] = ['icon', 'theme', 'title'];
  return sanitizeSchema;
};
module.exports = Callout;

/***/ }),

/***/ 8297:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _extends = __webpack_require__(7154);
var copy = __webpack_require__(640);
var PropTypes = __webpack_require__(5697);
var React = __webpack_require__(4466);

// Only load CodeMirror in the browser, for SSR
// apps. Necessary because of people like this:
// https://github.com/codemirror/CodeMirror/issues/3701#issuecomment-164904534
var syntaxHighlighter;
var canonicalLanguage = function canonicalLanguage() {};
if (typeof window !== 'undefined') {
  // eslint-disable-next-line global-require
  syntaxHighlighter = (__webpack_require__(3752)["default"]);
  // eslint-disable-next-line global-require
  var _require = __webpack_require__(3752);
  canonicalLanguage = _require.canonical;
}
function CopyCode(_ref) {
  var codeRef = _ref.codeRef,
    _ref$rootClass = _ref.rootClass,
    rootClass = _ref$rootClass === void 0 ? 'rdmd-code-copy' : _ref$rootClass,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className;
  var copyClass = "".concat(rootClass, "_copied");
  var button = React.createRef();
  /* istanbul ignore next */
  var copier = function copier() {
    var code = codeRef.current.textContent;
    if (copy(code)) {
      var $el = button.current;
      $el.classList.add(copyClass);
      setTimeout(function () {
        return $el.classList.remove(copyClass);
      }, 1500);
    }
  };
  return /*#__PURE__*/React.createElement("button", {
    ref: button,
    "aria-label": "Copy Code",
    className: "".concat(rootClass, " ").concat(className),
    onClick: copier
  });
}
CopyCode.propTypes = {
  className: PropTypes.string,
  codeRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({
    current: PropTypes.instanceOf(React.Element)
  })]).isRequired,
  rootClass: PropTypes.string
};
function Code(props) {
  var children = props.children,
    className = props.className,
    copyButtons = props.copyButtons,
    lang = props.lang,
    meta = props.meta,
    theme = props.theme;
  var langClass = className.search(/lang(?:uage)?-\w+/) >= 0 ? className.match(/\s?lang(?:uage)?-(\w+)/)[1] : '';
  var language = canonicalLanguage(lang) || langClass;
  var codeRef = React.createRef();
  var codeOpts = {
    inline: !lang,
    tokenizeVariables: true,
    dark: theme === 'dark'
  };
  var codeContent = syntaxHighlighter && children ? syntaxHighlighter(children[0], language, codeOpts) : (children === null || children === void 0 ? void 0 : children[0]) || '';
  return /*#__PURE__*/React.createElement(React.Fragment, null, copyButtons && /*#__PURE__*/React.createElement(CopyCode, {
    className: "fa",
    codeRef: codeRef
  }), /*#__PURE__*/React.createElement("code", {
    ref: codeRef,
    className: ['rdmd-code', "lang-".concat(language), "theme-".concat(theme)].join(' '),
    "data-lang": language,
    name: meta,
    suppressHydrationWarning: true
  }, codeContent));
}
function CreateCode(_ref2) {
  var copyButtons = _ref2.copyButtons,
    theme = _ref2.theme;
  // eslint-disable-next-line react/display-name
  return function (props) {
    return /*#__PURE__*/React.createElement(Code, _extends({}, props, {
      copyButtons: copyButtons,
      theme: theme
    }));
  };
}
Code.propTypes = {
  children: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
  copyButtons: PropTypes.bool,
  lang: PropTypes.string,
  meta: PropTypes.string,
  theme: PropTypes.string
};
Code.defaultProps = {
  className: '',
  copyButtons: true,
  lang: '',
  meta: ''
};
CreateCode.sanitize = function (sanitizeSchema) {
  // This is for code blocks class name
  sanitizeSchema.attributes.code = ['className', 'lang', 'meta', 'value'];
  return sanitizeSchema;
};
module.exports = CreateCode;

/***/ }),

/***/ 6553:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _extends = __webpack_require__(7154);
var _require = __webpack_require__(3752),
  uppercase = _require.uppercase;
var PropTypes = __webpack_require__(5697);
var React = __webpack_require__(4466);
var CodeTabs = function CodeTabs(props) {
  var attributes = props.attributes,
    children = props.children,
    theme = props.theme;
  function handleClick(_ref, index) {
    var target = _ref.target;
    var $wrap = target.parentElement.parentElement;
    var $open = [].slice.call($wrap.querySelectorAll('.CodeTabs_active'));
    $open.forEach(function (el) {
      return el.classList.remove('CodeTabs_active');
    });
    $wrap.classList.remove('CodeTabs_initial');
    var codeblocks = $wrap.querySelectorAll('pre');
    codeblocks[index].classList.add('CodeTabs_active');
    target.classList.add('CodeTabs_active');
  }
  return (
    /*#__PURE__*/
    // eslint-disable-next-line react/jsx-props-no-spreading
    React.createElement("div", _extends({}, attributes, {
      className: "CodeTabs CodeTabs_initial theme-".concat(theme)
    }), /*#__PURE__*/React.createElement("div", {
      className: "CodeTabs-toolbar"
    }, children.map(function (_ref2, i) {
      var pre = _ref2.props;
      var _pre$children$0$props = pre.children[0].props,
        meta = _pre$children$0$props.meta,
        lang = _pre$children$0$props.lang;
      /* istanbul ignore next */
      return /*#__PURE__*/React.createElement("button", {
        key: i,
        onClick: function onClick(e) {
          return handleClick(e, i);
        },
        type: "button"
      }, meta || "".concat(!lang ? 'Text' : uppercase(lang)));
    })), /*#__PURE__*/React.createElement("div", {
      className: "CodeTabs-inner"
    }, children))
  );
};
CodeTabs.propTypes = {
  attributes: PropTypes.shape({}),
  children: PropTypes.arrayOf(PropTypes.any).isRequired,
  theme: PropTypes.string
};
CodeTabs.defaultProps = {
  attributes: null
};
function CreateCodeTabs(_ref3) {
  var theme = _ref3.theme;
  // eslint-disable-next-line react/display-name
  return function (props) {
    return /*#__PURE__*/React.createElement(CodeTabs, _extends({}, props, {
      theme: theme
    }));
  };
}
module.exports = CreateCodeTabs;

/***/ }),

/***/ 1053:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var _inherits = __webpack_require__(2205);
var _possibleConstructorReturn = __webpack_require__(8585);
var _getPrototypeOf = __webpack_require__(9754);
var _extends = __webpack_require__(7154);
var _objectWithoutProperties = __webpack_require__(6479);
var _excluded = ["src", "alt"],
  _excluded2 = ["lazy", "provider", "url", "title", "html", "iframe", "image", "favicon"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable react/jsx-props-no-spreading, jsx-a11y/iframe-has-title */
var propTypes = __webpack_require__(5697);
var React = __webpack_require__(4466);
var Favicon = function Favicon(_ref) {
  var src = _ref.src,
    _ref$alt = _ref.alt,
    alt = _ref$alt === void 0 ? 'favicon' : _ref$alt,
    attr = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("img", _extends({}, attr, {
    alt: alt,
    height: "14",
    src: src,
    width: "14"
  }));
};
Favicon.propTypes = {
  alt: propTypes.string,
  src: propTypes.string
};
var Embed = /*#__PURE__*/function (_React$Component) {
  "use strict";

  _inherits(Embed, _React$Component);
  var _super = _createSuper(Embed);
  function Embed() {
    _classCallCheck(this, Embed);
    return _super.apply(this, arguments);
  }
  _createClass(Embed, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$lazy = _this$props.lazy,
        lazy = _this$props$lazy === void 0 ? true : _this$props$lazy,
        provider = _this$props.provider,
        url = _this$props.url,
        title = _this$props.title,
        html = _this$props.html,
        iframe = _this$props.iframe,
        image = _this$props.image,
        favicon = _this$props.favicon,
        attrs = _objectWithoutProperties(_this$props, _excluded2);
      if (!url) {
        return /*#__PURE__*/React.createElement("div", null);
      }
      if ('iframe' in this.props) {
        return /*#__PURE__*/React.createElement("iframe", _extends({}, attrs, {
          border: "none",
          src: url,
          style: {
            border: 'none',
            display: 'flex',
            margin: 'auto'
          }
        }));
      }
      var classes = ['embed', image && 'embed_hasImg'];
      return /*#__PURE__*/React.createElement("div", {
        className: classes.join(' ')
      }, html ? /*#__PURE__*/React.createElement("div", {
        className: "embed-media",
        dangerouslySetInnerHTML: {
          __html: html
        }
      }) : /*#__PURE__*/React.createElement("a", {
        className: "embed-link",
        href: url,
        rel: "noopener noreferrer",
        target: "_blank"
      }, !image || /*#__PURE__*/React.createElement("img", {
        alt: title,
        className: "embed-img",
        loading: lazy ? 'lazy' : '',
        src: image
      }), title ? /*#__PURE__*/React.createElement("div", {
        className: "embed-body"
      }, !favicon || /*#__PURE__*/React.createElement(Favicon, {
        alt: provider,
        className: "embed-favicon",
        loading: lazy ? 'lazy' : '',
        src: favicon,
        style: {
          float: 'left'
        }
      }), provider && /*#__PURE__*/React.createElement("small", {
        className: "embed-provider"
      }, provider.search(/^@{1}/) < 0 ? provider : /*#__PURE__*/React.createElement("code", {
        style: {
          fontFamily: 'var(--md-code-font, monospace)'
        }
      }, url)), /*#__PURE__*/React.createElement("div", {
        className: "embed-title"
      }, title)) : /*#__PURE__*/React.createElement("div", {
        className: "embed-body"
      }, /*#__PURE__*/React.createElement("b", null, "View"), ": ", /*#__PURE__*/React.createElement("span", {
        className: "embed-body-url"
      }, url))));
    }
  }]);
  return Embed;
}(React.Component);
Embed.propTypes = {
  children: propTypes.oneOfType([propTypes.string, propTypes.array, propTypes.shape({}), propTypes.element]),
  favicon: propTypes.string,
  height: propTypes.string,
  html: propTypes.string,
  iframe: propTypes.any,
  image: propTypes.string,
  lazy: propTypes.bool,
  provider: propTypes.string,
  title: propTypes.string,
  url: propTypes.oneOfType([propTypes.string, propTypes.shape({})]),
  width: propTypes.string
};
Embed.defaultProps = {
  height: '300px',
  width: '100%'
};
var CreateEmbed = function CreateEmbed(_ref2) {
  var lazyImages = _ref2.lazyImages;
  return (
    // eslint-disable-next-line react/display-name
    function (props) {
      return /*#__PURE__*/React.createElement(Embed, _extends({}, props, {
        lazy: lazyImages
      }));
    }
  );
};
module.exports = CreateEmbed;

/***/ }),

/***/ 4337:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _extends = __webpack_require__(7154);
var Tooltip = (__webpack_require__(578)["default"]);
var PropTypes = __webpack_require__(5697);
var React = __webpack_require__(4466);
var GlossaryContext = __webpack_require__(1252);

// https://github.com/readmeio/api-explorer/blob/0dedafcf71102feedaa4145040d3f57d79d95752/packages/api-explorer/src/lib/replace-vars.js#L8
function GlossaryItem(_ref) {
  var term = _ref.term,
    terms = _ref.terms;
  var foundTerm = terms.find(function (i) {
    return term.toLowerCase() === i.term.toLowerCase();
  });
  if (!foundTerm) return /*#__PURE__*/React.createElement("span", null, term);
  return /*#__PURE__*/React.createElement(Tooltip, {
    content: /*#__PURE__*/React.createElement("div", {
      className: "GlossaryItem-tooltip-content"
    }, /*#__PURE__*/React.createElement("strong", {
      className: "GlossaryItem-term"
    }, foundTerm.term), " - ", foundTerm.definition),
    offset: [-5, 5],
    placement: "bottom-start"
  }, /*#__PURE__*/React.createElement("span", {
    className: "GlossaryItem-trigger"
  }, term));
}
GlossaryItem.propTypes = {
  term: PropTypes.string.isRequired,
  terms: PropTypes.arrayOf(PropTypes.shape({
    definition: PropTypes.string.isRequired,
    term: PropTypes.string.isRequired
  })).isRequired
};

// eslint-disable-next-line react/display-name
module.exports = function (props) {
  return /*#__PURE__*/React.createElement(GlossaryContext.Consumer, null, function (terms) {
    return terms && /*#__PURE__*/React.createElement(GlossaryItem, _extends({}, props, {
      terms: terms
    }));
  });
};
module.exports.GlossaryItem = GlossaryItem;
module.exports.GlossaryContext = GlossaryContext;

/***/ }),

/***/ 822:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _extends = __webpack_require__(7154);
var _slicedToArray = __webpack_require__(3038);
var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var _inherits = __webpack_require__(2205);
var _possibleConstructorReturn = __webpack_require__(8585);
var _getPrototypeOf = __webpack_require__(9754);
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable no-eval
 */
var escape = __webpack_require__(8686);
var PropTypes = __webpack_require__(5697);
var React = __webpack_require__(4466);
var MATCH_SCRIPT_TAGS = /<script\b[^>]*>([\s\S]*?)<\/script *>\n?/gim;
var extractScripts = function extractScripts() {
  var html = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var scripts = [];
  var match;
  while ((match = MATCH_SCRIPT_TAGS.exec(html)) !== null) {
    scripts.push(match[1]);
  }
  var cleaned = html.replace(MATCH_SCRIPT_TAGS, '');
  return [cleaned, function () {
    return scripts.map(function (js) {
      return window.eval(js);
    });
  }];
};
var HTMLBlock = /*#__PURE__*/function (_React$PureComponent) {
  "use strict";

  _inherits(HTMLBlock, _React$PureComponent);
  var _super = _createSuper(HTMLBlock);
  function HTMLBlock(props) {
    var _this;
    _classCallCheck(this, HTMLBlock);
    _this = _super.call(this, props);
    var _extractScripts = extractScripts(_this.props.html);
    var _extractScripts2 = _slicedToArray(_extractScripts, 2);
    _this.html = _extractScripts2[0];
    _this.exec = _extractScripts2[1];
    return _this;
  }
  _createClass(HTMLBlock, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var runScripts = this.props.runScripts;
      if (typeof window !== 'undefined' && (runScripts === '' || runScripts)) this.exec();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        html = _this$props.html,
        safeMode = _this$props.safeMode;
      if (safeMode) {
        return /*#__PURE__*/React.createElement("pre", {
          className: "html-unsafe"
        }, /*#__PURE__*/React.createElement("code", {
          dangerouslySetInnerHTML: {
            __html: escape(html)
          }
        }));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "rdmd-html",
        dangerouslySetInnerHTML: {
          __html: this.html
        }
      });
    }
  }]);
  return HTMLBlock;
}(React.PureComponent);
HTMLBlock.defaultProps = {
  runScripts: false,
  safeMode: false
};
HTMLBlock.propTypes = {
  html: PropTypes.string,
  runScripts: PropTypes.any,
  safeMode: PropTypes.bool
};
var CreateHtmlBlock = function CreateHtmlBlock(_ref) {
  var safeMode = _ref.safeMode;
  return (
    // eslint-disable-next-line react/display-name
    function (props) {
      return /*#__PURE__*/React.createElement(HTMLBlock, _extends({}, props, {
        safeMode: safeMode
      }));
    }
  );
};
CreateHtmlBlock.sanitize = function (schema) {
  schema.tagNames.push('html-block');
  schema.attributes['html-block'] = ['html', 'runScripts'];
  return schema;
};
module.exports = CreateHtmlBlock;

/***/ }),

/***/ 1984:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _extends = __webpack_require__(7154);
var _objectWithoutProperties = __webpack_require__(6479);
var _excluded = ["tag", "showAnchorIcons"];
var PropTypes = __webpack_require__(5697);
var React = __webpack_require__(4466);
function Heading(_ref) {
  var tag = _ref.tag,
    showAnchorIcons = _ref.showAnchorIcons,
    props = _objectWithoutProperties(_ref, _excluded);
  if (!props.children) return '';
  var attrs = {
    className: "heading heading-".concat(props.level, " header-scroll"),
    align: props.align
  };
  var children = [/*#__PURE__*/React.createElement("div", {
    key: "heading-anchor-".concat(props.id),
    className: "heading-anchor anchor waypoint",
    id: props.id
  }), /*#__PURE__*/React.createElement("div", {
    key: "heading-text-".concat(props.id),
    className: "heading-text"
  }, props.children)];
  if (showAnchorIcons) {
    var headingText = props.children[1];
    children.push(
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/anchor-has-content
    React.createElement("a", {
      key: "heading-anchor-icon-".concat(props.id),
      "aria-label": "Skip link to ".concat(headingText),
      className: "heading-anchor-icon fa fa-anchor",
      href: "#".concat(props.id)
    }));
  }
  return React.createElement(tag, attrs, children);
}
function CreateHeading(level, anchors, _ref2) {
  var showAnchorIcons = _ref2.showAnchorIcons;
  // eslint-disable-next-line react/display-name
  return function (props) {
    return /*#__PURE__*/React.createElement(Heading, _extends({}, props, {
      anchors: anchors,
      level: level,
      showAnchorIcons: showAnchorIcons,
      tag: "h".concat(level)
    }));
  };
}
Heading.propTypes = {
  align: PropTypes.oneOf(['left', 'center', 'right', '']),
  anchors: PropTypes.object,
  children: PropTypes.array.isRequired,
  id: PropTypes.string.isRequired,
  level: PropTypes.number,
  showAnchorIcons: PropTypes.bool,
  tag: PropTypes.string.isRequired
};
Heading.defaultProps = {
  align: '',
  id: '',
  level: 2,
  showAnchorIcons: true
};
module.exports = function (level, anchors, opts) {
  return CreateHeading(level, anchors, opts);
};

/***/ }),

/***/ 9596:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _extends = __webpack_require__(7154);
var _objectWithoutProperties = __webpack_require__(6479);
var _excluded = ["alt", "onScroll", "opened"];
/* eslint-disable jsx-a11y/no-autofocus, jsx-a11y/no-noninteractive-tabindex, react/jsx-props-no-spreading */

var React = __webpack_require__(4466);

/**
 * A very simple, CSS-driven lightbox.
 * @todo currently, a new <Lightbox> instance is rendered for
 *       each individual image! We should refactor to this to
 *       use a single React portal component with public APIs.
 */
// eslint-disable-next-line react/prop-types
var Lightbox = function Lightbox(_ref, ref) {
  var alt = _ref.alt,
    onScroll = _ref.onScroll,
    opened = _ref.opened,
    attr = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("span", {
    ref: ref,
    autoFocus: true,
    className: "lightbox",
    onScrollCapture: onScroll,
    open: opened,
    role: "dialog",
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("span", {
    className: "lightbox-inner"
  }, /*#__PURE__*/React.createElement("img", _extends({}, attr, {
    alt: alt,
    className: "lightbox-img",
    loading: "lazy",
    title: "Click to close..."
  }))));
};

// forwardRef render functions throws a warning with propTypes/defaultProps
/* Lightbox.propTypes = {
  alt: PropTypes.string,
  close: PropTypes.func,
  opened: PropTypes.bool,
  src: PropTypes.string,
}; */

module.exports = React.forwardRef(Lightbox);

/***/ }),

/***/ 9167:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _extends = __webpack_require__(7154);
var _classCallCheck = __webpack_require__(4575);
var _createClass = __webpack_require__(3913);
var _assertThisInitialized = __webpack_require__(1506);
var _inherits = __webpack_require__(2205);
var _possibleConstructorReturn = __webpack_require__(8585);
var _getPrototypeOf = __webpack_require__(9754);
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable no-param-reassign, react/jsx-props-no-spreading, no-fallthrough */

var PropTypes = __webpack_require__(5697);
var React = __webpack_require__(4466);
var Lightbox = __webpack_require__(9596);
var Image = /*#__PURE__*/function (_React$Component) {
  "use strict";

  _inherits(Image, _React$Component);
  var _super = _createSuper(Image);
  function Image(props) {
    var _this;
    _classCallCheck(this, Image);
    _this = _super.call(this, props);
    _this.state = {
      lightbox: false
    };
    _this.lightbox = React.createRef();
    _this.toggle = _this.toggle.bind(_assertThisInitialized(_this));
    _this.handleKey = _this.handleKey.bind(_assertThisInitialized(_this));
    _this.isEmoji = props.className === 'emoji';
    return _this;
  }
  _createClass(Image, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.lightboxSetup();
    }
  }, {
    key: "toggle",
    value: function toggle(toState) {
      if (this.props.className === 'emoji') return;
      if (typeof toState === 'undefined') toState = !this.state.lightbox;
      if (toState) this.lightboxSetup();
      this.setState({
        lightbox: toState
      });
    }
  }, {
    key: "lightboxSetup",
    value: function lightboxSetup() {
      var $el = this.lightbox.current;
      if ($el) setTimeout(function () {
        $el.scrollTop = ($el.scrollHeight - $el.offsetHeight) / 2;
      }, 0);
    }
  }, {
    key: "handleKey",
    value: function handleKey(e) {
      var key = e.key,
        cmd = e.metaKey;
      cmd = cmd ? 'cmd+' : '';
      key = "".concat(cmd).concat(key.toLowerCase());
      switch (key) {
        case 'cmd+.':
        case 'escape':
          // CLOSE
          this.toggle(false);
          break;
        case ' ':
        case 'enter':
          // OPEN
          if (!this.state.open) this.toggle(true);
          e.preventDefault();
        default:
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var props = this.props;
      var alt = props.alt,
        _props$lazy = props.lazy,
        lazy = _props$lazy === void 0 ? true : _props$lazy;
      if (this.isEmoji) {
        return /*#__PURE__*/React.createElement("img", _extends({}, props, {
          alt: alt,
          loading: lazy ? 'lazy' : ''
        }));
      }
      return /*#__PURE__*/React.createElement("span", {
        "aria-label": alt,
        className: "img",
        onClick: function onClick() {
          return _this2.toggle();
        },
        onKeyDown: this.handleKey,
        role: 'button',
        tabIndex: 0
      }, /*#__PURE__*/React.createElement("img", _extends({}, props, {
        alt: alt,
        loading: lazy ? 'lazy' : ''
      })), /*#__PURE__*/React.createElement(Lightbox, _extends({
        ref: this.lightbox
      }, props, {
        onScroll: function onScroll() {
          return _this2.toggle(false);
        },
        opened: this.state.lightbox
      })));
    }
  }]);
  return Image;
}(React.Component);
Image.propTypes = {
  align: PropTypes.string,
  alt: PropTypes.string,
  caption: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  lazy: PropTypes.bool,
  src: PropTypes.string.isRequired,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
Image.defaultProps = {
  align: '',
  alt: '',
  caption: '',
  height: 'auto',
  src: '',
  title: '',
  width: 'auto'
};
Image.sanitize = function (sanitizeSchema) {
  sanitizeSchema.attributes.img = ['className', 'title', 'alt', 'width', 'height', 'align', 'src', 'longDesc'];
  return sanitizeSchema;
};
var CreateImage = function CreateImage(_ref) {
  var lazyImages = _ref.lazyImages;
  return (
    // eslint-disable-next-line react/display-name
    function (props) {
      return /*#__PURE__*/React.createElement(Image, _extends({
        lazy: lazyImages
      }, props));
    }
  );
};
module.exports = CreateImage;

/***/ }),

/***/ 3197:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _extends = __webpack_require__(7154);
var PropTypes = __webpack_require__(5697);
var React = __webpack_require__(4466);
var Style = function Style(_ref) {
  var children = _ref.children,
    safeMode = _ref.safeMode;
  return safeMode ? /*#__PURE__*/React.createElement("pre", null, /*#__PURE__*/React.createElement("code", null, "<style>\n".concat(children, "\n</style>"))) : /*#__PURE__*/React.createElement("style", null, children);
};
Style.propTypes = {
  children: PropTypes.node,
  safeMode: PropTypes.bool
};
var CreateStyle = function CreateStyle(_ref2) {
  var safeMode = _ref2.safeMode;
  return (
    // eslint-disable-next-line react/display-name
    function (props) {
      return /*#__PURE__*/React.createElement(Style, _extends({}, props, {
        safeMode: safeMode
      }));
    }
  );
};
CreateStyle.sanitize = function (sanitize) {
  sanitize.tagNames.push('style');
  return sanitize;
};
module.exports = CreateStyle;

/***/ }),

/***/ 484:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var PropTypes = __webpack_require__(5697);
var React = __webpack_require__(4466);
function Table(props) {
  var children = props.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "rdmd-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "rdmd-table-inner"
  }, /*#__PURE__*/React.createElement("table", null, children)));
}
Table.propTypes = {
  children: PropTypes.arrayOf(PropTypes.node).isRequired
};
module.exports = Table;

/***/ }),

/***/ 4479:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var PropTypes = __webpack_require__(5697);
var React = __webpack_require__(4466);
function TableOfContents(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("ul", {
    className: "toc-list"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
    className: "tocHeader",
    href: "#"
  }, /*#__PURE__*/React.createElement("i", {
    className: "icon icon-text-align-left"
  }), "Table of Contents")), /*#__PURE__*/React.createElement("li", {
    className: "toc-children"
  }, children)));
}
TableOfContents.propTypes = {
  children: PropTypes.element
};
module.exports = TableOfContents;

/***/ }),

/***/ 3354:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Anchor": () => (/* reexport default from dynamic */ _Anchor__WEBPACK_IMPORTED_MODULE_0___default.a),
/* harmony export */   "Callout": () => (/* reexport default from dynamic */ _Callout__WEBPACK_IMPORTED_MODULE_1___default.a),
/* harmony export */   "Code": () => (/* reexport default from dynamic */ _Code__WEBPACK_IMPORTED_MODULE_2___default.a),
/* harmony export */   "CodeTabs": () => (/* reexport default from dynamic */ _CodeTabs__WEBPACK_IMPORTED_MODULE_3___default.a),
/* harmony export */   "Embed": () => (/* reexport default from dynamic */ _Embed__WEBPACK_IMPORTED_MODULE_4___default.a),
/* harmony export */   "GlossaryItem": () => (/* reexport default from dynamic */ _GlossaryItem__WEBPACK_IMPORTED_MODULE_5___default.a),
/* harmony export */   "HTMLBlock": () => (/* reexport default from dynamic */ _HTMLBlock__WEBPACK_IMPORTED_MODULE_6___default.a),
/* harmony export */   "Heading": () => (/* reexport default from dynamic */ _Heading__WEBPACK_IMPORTED_MODULE_7___default.a),
/* harmony export */   "Image": () => (/* reexport default from dynamic */ _Image__WEBPACK_IMPORTED_MODULE_8___default.a),
/* harmony export */   "Style": () => (/* reexport default from dynamic */ _Style__WEBPACK_IMPORTED_MODULE_9___default.a),
/* harmony export */   "Table": () => (/* reexport default from dynamic */ _Table__WEBPACK_IMPORTED_MODULE_10___default.a),
/* harmony export */   "TableOfContents": () => (/* reexport default from dynamic */ _TableOfContents__WEBPACK_IMPORTED_MODULE_11___default.a)
/* harmony export */ });
/* harmony import */ var _Anchor__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8447);
/* harmony import */ var _Anchor__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_Anchor__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Callout__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2015);
/* harmony import */ var _Callout__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Callout__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Code__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8297);
/* harmony import */ var _Code__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_Code__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _CodeTabs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6553);
/* harmony import */ var _CodeTabs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_CodeTabs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Embed__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1053);
/* harmony import */ var _Embed__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Embed__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _GlossaryItem__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4337);
/* harmony import */ var _GlossaryItem__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_GlossaryItem__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _HTMLBlock__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(822);
/* harmony import */ var _HTMLBlock__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_HTMLBlock__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1984);
/* harmony import */ var _Heading__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_Heading__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(9167);
/* harmony import */ var _Image__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Image__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _Style__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(3197);
/* harmony import */ var _Style__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_Style__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _Table__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(484);
/* harmony import */ var _Table__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_Table__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _TableOfContents__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4479);
/* harmony import */ var _TableOfContents__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_TableOfContents__WEBPACK_IMPORTED_MODULE_11__);













/***/ }),

/***/ 6785:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var React = __webpack_require__(4466);
module.exports = React.createContext('/');

/***/ }),

/***/ 1252:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var React = __webpack_require__(4466);
module.exports = React.createContext([]);

/***/ }),

/***/ 1264:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _slicedToArray = __webpack_require__(3038);
/* eslint-disable no-param-reassign
 */
var kebabCase = __webpack_require__(5683);
var registerCustomComponents = function registerCustomComponents(components, sanitize) {
  var prefix = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'x';
  return Object.entries(components).reduce(function (all, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
      tag = _ref2[0],
      component = _ref2[1];
    /* Sanitize + prefix element names.
     */
    tag = kebabCase(tag);
    var isValidOverride = sanitize.tagNames.includes(tag);
    var isValidElemName = tag.includes('-');
    if (!(isValidElemName || isValidOverride)) tag = "".concat(prefix, "-").concat(tag);

    /* Safelist custom tag names.
     */
    sanitize.tagNames.push(tag);

    /* Safelist allowed attributes.
     */
    if (component.propTypes) sanitize.attributes[tag] = [].concat(sanitize.attributes[tag], Object.keys(component.propTypes)).filter(Boolean);

    /* Add element to custom component store.
     */
    all[tag] = component;
    return all;
  }, {});
};
module.exports = registerCustomComponents;

/***/ }),

/***/ 368:
/***/ ((__unused_webpack_module, exports) => {

// Autogenerated by build.js; do not edit!

function Emoji() {
  this.emojis = ["-1", "+1", "100", "1234", "8ball", "a", "ab", "abc", "abcd", "accept", "aerial-tramway", "airplane", "alarm-clock", "alien", "ambulance", "anchor", "angel", "anger", "angry", "anguished", "ant", "apple", "aquarius", "aries", "arrow-backward", "arrow-double-down", "arrow-double-up", "arrow-down-small", "arrow-down", "arrow-forward", "arrow-heading-down", "arrow-heading-up", "arrow-left", "arrow-lower-left", "arrow-lower-right", "arrow-right-hook", "arrow-right", "arrow-up-down", "arrow-up-small", "arrow-up", "arrow-upper-left", "arrow-upper-right", "arrows-clockwise", "arrows-counterclockwise", "art", "articulated-lorry", "astonished", "atm", "b", "baby-bottle", "baby-chick", "baby-symbol", "baby", "baggage-claim", "balloon", "ballot-box-with-check", "bamboo", "banana", "bangbang", "bank", "bar-chart", "barber", "baseball", "basketball", "bath", "bathtub", "battery", "bear", "beer", "beers", "beetle", "beginner", "bell", "bento", "bicyclist", "bike", "bikini", "bird", "birthday", "black-circle", "black-joker", "black-nib", "black-square-button", "blossom", "blowfish", "blue-book", "blue-car", "blue-heart", "blush", "boar", "boat", "bomb", "bookmark-tabs", "bookmark", "books", "boom", "boot", "bouquet", "bow", "bowling", "boy", "bread", "bride-with-veil", "bridge-at-night", "briefcase", "broken-heart", "bug", "bulb", "bullettrain-front", "bullettrain-side", "bus", "busstop", "bust-in-silhouette", "busts-in-silhouette", "cactus", "cake", "calendar", "calling", "camel", "camera", "cancer", "candy", "capital-abcd", "capricorn", "car", "card-index", "carousel-horse", "cat", "cat2", "cd", "chart-with-downwards-trend", "chart-with-upwards-trend", "chart", "checkered-flag", "cherries", "cherry-blossom", "chestnut", "chicken", "children-crossing", "chocolate-bar", "christmas-tree", "church", "cinema", "circus-tent", "city-sunrise", "city-sunset", "cl", "clap", "clapper", "clipboard", "clock1", "clock11", "clock113", "clock12", "clock123", "clock13", "clock2", "clock23", "clock3", "clock33", "clock4", "clock43", "clock5", "clock53", "clock6", "clock63", "clock7", "clock73", "clock8", "clock83", "clock9", "clock93", "closed-book", "closed-lock-with-key", "closed-umbrella", "cloud", "clubs", "cn", "cocktail", "coffee", "cold-sweat", "computer", "confetti-ball", "confounded", "confused", "congratulations", "construction-worker", "construction", "convenience-store", "cookie", "cool", "cop", "copyright", "corn", "couple-with-heart", "couple", "couplekiss", "cow", "cow2", "credit-card", "crocodile", "crossed-flags", "crown", "cry", "crying-cat-face", "crystal-ball", "cupid", "curly-loop", "currency-exchange", "curry", "custard", "customs", "cyclone", "dancer", "dancers", "dango", "dart", "dash", "date", "de", "deciduous-tree", "department-store", "diamond-shape", "diamonds", "disappointed", "dizzy-face", "dizzy", "do-not-litter", "dog", "dog2", "dollar", "dolls", "dolphin", "door", "doughnut", "dragon-face", "dragon", "dress", "dromedary-camel", "droplet", "dvd", "e-mail", "e50a", "ear-of-rice", "ear", "earth-africa", "earth-americas", "earth-asia", "egg", "eggplant", "eight-pointed-star", "eight-spoked-asterisk", "eight", "electric-plug", "elephant", "email", "end", "es", "euro", "european-castle", "european-post-office", "evergreen-tree", "exclamation", "expressionless", "eyeglasses", "eyes", "factory", "fallen-leaf", "family", "fast-forward", "fax", "fearful", "feet", "ferris-wheel", "file-folder", "fire-engine", "fire", "fireworks", "first-quarter-moon-with-face", "first-quarter-moon", "fish-cake", "fish", "fishing-pole-and-fish", "fist", "five", "flags", "flashlight", "floppy-disk", "flower-playing-cards", "flushed", "foggy", "football", "fork-and-knife", "fountain", "four-leaf-clover", "four", "fr", "free", "fried-shrimp", "fries", "frog", "frowning", "fuelpump", "full-moon-with-face", "full-moon", "game-die", "gb", "gem", "gemini", "ghost", "gift-heart", "gift", "girl", "globe-with-meridians", "goat", "golf", "grapes", "green-apple", "green-book", "green-heart", "grey-exclamation", "grey-question", "grimacing", "grin", "grinning", "guardsman", "guitar", "gun", "haircut", "hamburger", "hammer", "hamster", "hand", "handbag", "hash", "hatched-chick", "hatching-chick", "headphones", "hear-no-evil", "heart-decoration", "heart-eyes-cat", "heart-eyes", "heart", "heartbeat", "heartpulse", "hearts", "heavy-check-mark", "heavy-division-sign", "heavy-dollar-sign", "heavy-minus-sign", "heavy-multiplication-x", "heavy-plus-sign", "helicopter", "herb", "hibiscus", "high-brightness", "high-heel", "hocho", "honey-pot", "honeybee", "horse-racing", "horse", "hospital", "hotel", "hotsprings", "hourglass-flowing-sand", "hourglass", "house-with-garden", "house", "hushed", "ice-cream", "icecream", "id", "ideograph-advantage", "imp", "inbox-tray", "incoming-envelope", "information-desk-person", "information-source", "innocent", "interrobang", "iphone", "it", "jack-o-lantern", "japan", "japanese-castle", "japanese-goblin", "japanese-ogre", "jeans", "joy-cat", "joy", "jp", "key", "keycap-ten", "kimono", "kiss", "kissing-cat", "kissing-closed-eyes", "kissing-heart", "kissing-smiling-eyes", "kissing", "koala", "koko", "kr", "large-blue-circle", "large-blue-diamond", "large-orange-diamond", "last-quarter-moon-with-face", "last-quarter-moon", "laughing", "leaves", "ledger", "left-luggage", "left-right-arrow", "leftwards-arrow-with-hook", "lemon", "leo", "leopard", "libra", "light-rail", "link", "lips", "lipstick", "lock-with-ink-pen", "lock", "lollipop", "loop", "loudspeaker", "love-hotel", "love-letter", "low-brightness", "m", "mag-right", "mag", "mahjong", "mailbox-closed", "mailbox-with-mail", "mailbox-with-no-mail", "mailbox", "man-with-gua-pi-mao", "man-with-turban", "man", "mans-shoe", "maple-leaf", "mask", "massage", "meat-on-bone", "mega", "melon", "memo", "mens", "metro", "microphone", "microscope", "milky-way", "minibus", "minidisc", "mobile-phone-off", "money-with-wings", "moneybag", "monkey-face", "monkey", "monorail", "moon", "mortar-board", "mount-fuji", "mountain-bicyclist", "mountain-cableway", "mountain-railway", "mouse", "mouse2", "movie-camera", "moyai", "muscle", "mushroom", "musical-keyboard", "musical-note", "musical-score", "mute", "nail-care", "name-badge", "necktie", "negative-squared-cross", "neutral-face", "new-moon-with-face", "new-moon", "new", "newspaper", "ng", "nine", "no-bell", "no-bicycles", "no-entry-sign", "no-entry", "no-good", "no-mobile-phones", "no-mouth", "no-pedestrians", "no-smoking", "non-potable-water", "nose", "notebook-with-decorative-cover", "notebook", "notes", "nut-and-bolt", "o", "o2", "ocean", "octopus", "oden", "office", "ok-hand", "ok-woman", "ok", "older-man", "older-woman", "on", "oncoming-automobile", "oncoming-bus", "oncoming-police-car", "oncoming-taxi", "one", "open-file-folder", "open-hands", "open-mouth", "ophiuchus", "orange-book", "outbox-tray", "owlbert-books", "owlbert-mask", "owlbert-reading", "owlbert-thinking", "owlbert", "ox", "page-facing-up", "page-with-curl", "pager", "palm-tree", "panda-face", "paperclip", "parking", "part-alternation-mark", "partly-sunny", "passport-control", "paw-prints", "peach", "pear", "pencil2", "penguin", "pensive", "performing-arts", "persevere", "person-frowning", "person-with-blond-hair", "person-with-pouting-face", "phone", "pig-nose", "pig", "pig2", "pill", "pineapple", "pisces", "pizza", "point-down", "point-left", "point-right", "point-up-2", "point-up", "police-car", "poodle", "poop", "post-office", "postal-horn", "postbox", "potable-water", "pouch", "poultry-leg", "pound", "pouting-cat", "pray", "princess", "punch", "purple-heart", "purse", "pushpin", "put-litter-in-its-place", "question", "rabbit", "rabbit2", "racehorse", "radio-button", "radio", "rage", "railway-car", "rainbow", "raised-hand", "raised-hands", "ram", "ramen", "rat", "recycle", "red-circle", "registered", "relaxed", "relieved", "repeat-one", "repeat", "restroom", "revolving-hearts", "rewind", "ribbon", "rice-ball", "rice-cracker", "rice-scene", "rice", "ring", "rocket", "roller-coaster", "rooster", "rose", "rotating-light", "round-pushpin", "rowboat", "ru", "rugby-football", "runner", "running-shirt-with-sash", "sa", "sagittarius", "sake", "sandal", "santa", "satellite", "satisfied", "saxophone", "school-satchel", "school", "scissors", "scorpius", "scream-cat", "scream", "scroll", "seat", "secret", "see-no-evil", "seedling", "seven", "shaved-ice", "sheep", "shell", "ship", "shirt", "shower", "signal-strength", "six-pointed-star", "six", "ski", "skull", "sleeping", "sleepy", "slot-machine", "small-blue-diamond", "small-orange-diamond", "small-red-triangle-down", "small-red-triangle", "smile-cat", "smile", "smiley-cat", "smiley", "smiling-imp", "smirk-cat", "smirk", "smoking", "snail", "snake", "snowboarder", "snowflake", "snowman", "sob", "soccer", "soon", "sos", "sound", "space-invader", "spades", "spaghetti", "sparkler", "sparkles", "sparkling-heart", "speak-no-evil", "speaker", "speech-balloon", "speedboat", "star", "star2", "stars", "station", "statue-of-liberty", "steam-locomotive", "stew", "straight-ruler", "strawberry", "stuck-out-tongue-closed-eyes", "stuck-out-tongue-winking-eye", "stuck-out-tongue", "sun-with-face", "sunflower", "sunglasses", "sunny", "sunrise-over-mountains", "sunrise", "surfer", "sushi", "suspension-railway", "sweat-drops", "sweat-smile", "sweat", "sweet-potato", "swimmer", "symbols", "syringe", "tada", "tanabata-tree", "tangerine", "taurus", "taxi", "tea", "telephone-receiver", "telescope", "tennis", "tent", "thought-balloon", "three", "thumbsdown", "thumbsup", "ticket", "tiger", "tiger2", "tired-face", "tm", "toilet", "tokyo-tower", "tomato", "tongue", "top", "tophat", "tractor", "traffic-light", "train2", "tram", "triangular-flag-on-post", "triangular-ruler", "trident", "triumph", "trolleybus", "trophy", "tropical-drink", "tropical-fish", "truck", "trumpet", "tulip", "turtle", "tv", "twisted-rightwards-arrows", "two-hearts", "two-men-holding-hands", "two-women-holding-hands", "two", "u5272", "u54", "u55b6", "u63", "u67", "u6e8", "u7121", "u7533", "u7981", "u7a7a", "umbrella", "unamused", "underage", "unlock", "up", "us", "v", "vertical-traffic-light", "vhs", "vibration-mode", "video-camera", "video-game", "violin", "virgo", "volcano", "vs", "walking", "waning-crescent-moon", "waning-gibbous-moon", "warning", "watch", "water-buffalo", "watermelon", "wave", "wavy-dash", "waxing-crescent-moon", "waxing-gibbous-moon", "wc", "weary", "wedding", "whale", "whale2", "wheelchair", "white-check-mark", "white-circle", "white-flower", "white-square-button", "wind-chime", "wine-glass", "wink", "wolf", "woman", "womans-clothes", "womans-hat", "womens", "worried", "wrench", "x", "yellow-heart", "yen", "yum", "zap", "zero", "zzz"];
  this.is = function (emoji) {
    return this.emojis.indexOf(emoji) >= 0;
  };
}
;
if (true) {
  exports.r = Emoji;
}

/***/ }),

/***/ 3752:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = __webpack_require__(8);
(function () {
  var e = {
      9338: function _(e, t, r) {
        "use strict";

        var n = this && this.__importDefault || function (e) {
          return e && e.__esModule ? e : {
            default: e
          };
        };
        Object.defineProperty(t, "__esModule", {
          value: !0
        });
        var i = n(r(9074)),
          o = r(4201);
        function a(e, t) {
          var r,
            n,
            i = e.levels;
          return ((i && 0 !== i.length ? i[i.length - 1] - ((null === (r = this.electricInput) || void 0 === r ? void 0 : r.test(t)) ? 1 : 0) : e.indentLevel) || 0) * ((null === (n = this.config) || void 0 === n ? void 0 : n.indentUnit) || 0);
        }
        i.default.defineMode("graphql", function (e) {
          var t = o.onlineParser({
            eatWhitespace: function eatWhitespace(e) {
              return e.eatWhile(o.isIgnored);
            },
            lexRules: o.LexRules,
            parseRules: o.ParseRules,
            editorConfig: {
              tabSize: e.tabSize
            }
          });
          return {
            config: e,
            startState: t.startState,
            token: t.token,
            indent: a,
            electricInput: /^\s*[})\]]/,
            fold: "brace",
            lineComment: "#",
            closeBrackets: {
              pairs: '()[]{}""',
              explode: "()[]{}"
            }
          };
        });
      },
      2661: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.registerHelper("fold", "brace", function (t, r) {
            var n,
              i = r.line,
              o = t.getLine(i);
            function a(a) {
              for (var s = r.ch, l = 0;;) {
                var c = s <= 0 ? -1 : o.lastIndexOf(a, s - 1);
                if (-1 != c) {
                  if (1 == l && c < r.ch) break;
                  if (n = t.getTokenTypeAt(e.Pos(i, c + 1)), !/^(comment|string)/.test(n)) return c + 1;
                  s = c - 1;
                } else {
                  if (1 == l) break;
                  l = 1, s = o.length;
                }
              }
            }
            var s = "{",
              l = "}",
              c = a("{");
            if (null == c && (s = "[", l = "]", c = a("[")), null != c) {
              var u,
                d,
                p = 1,
                f = t.lastLine();
              e: for (var m = i; m <= f; ++m) {
                for (var h = t.getLine(m), g = m == i ? c : 0;;) {
                  var y = h.indexOf(s, g),
                    v = h.indexOf(l, g);
                  if (y < 0 && (y = h.length), v < 0 && (v = h.length), (g = Math.min(y, v)) == h.length) break;
                  if (t.getTokenTypeAt(e.Pos(m, g + 1)) == n) if (g == y) ++p;else if (! --p) {
                    u = m, d = g;
                    break e;
                  }
                  ++g;
                }
              }
              if (null != u && i != u) return {
                from: e.Pos(i, c),
                to: e.Pos(u, d)
              };
            }
          }), e.registerHelper("fold", "import", function (t, r) {
            function n(r) {
              if (r < t.firstLine() || r > t.lastLine()) return null;
              var n = t.getTokenAt(e.Pos(r, 1));
              if (/\S/.test(n.string) || (n = t.getTokenAt(e.Pos(r, n.end + 1))), "keyword" != n.type || "import" != n.string) return null;
              for (var i = r, o = Math.min(t.lastLine(), r + 10); i <= o; ++i) {
                var a = t.getLine(i).indexOf(";");
                if (-1 != a) return {
                  startCh: n.end,
                  end: e.Pos(i, a)
                };
              }
            }
            var i,
              o = r.line,
              a = n(o);
            if (!a || n(o - 1) || (i = n(o - 2)) && i.end.line == o - 1) return null;
            for (var s = a.end;;) {
              var l = n(s.line + 1);
              if (null == l) break;
              s = l.end;
            }
            return {
              from: t.clipPos(e.Pos(o, a.startCh + 1)),
              to: s
            };
          }), e.registerHelper("fold", "include", function (t, r) {
            function n(r) {
              if (r < t.firstLine() || r > t.lastLine()) return null;
              var n = t.getTokenAt(e.Pos(r, 1));
              return /\S/.test(n.string) || (n = t.getTokenAt(e.Pos(r, n.end + 1))), "meta" == n.type && "#include" == n.string.slice(0, 8) ? n.start + 8 : void 0;
            }
            var i = r.line,
              o = n(i);
            if (null == o || null != n(i - 1)) return null;
            for (var a = i; null != n(a + 1);) {
              ++a;
            }
            return {
              from: e.Pos(i, o + 1),
              to: t.clipPos(e.Pos(a))
            };
          });
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      2313: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          function t(t, r, i, o) {
            if (i && i.call) {
              var a = i;
              i = null;
            } else a = n(t, i, "rangeFinder");
            "number" == typeof r && (r = e.Pos(r, 0));
            var s = n(t, i, "minFoldSize");
            function l(e) {
              var n = a(t, r);
              if (!n || n.to.line - n.from.line < s) return null;
              for (var i = t.findMarksAt(n.from), l = 0; l < i.length; ++l) {
                if (i[l].__isFold && "fold" !== o) {
                  if (!e) return null;
                  n.cleared = !0, i[l].clear();
                }
              }
              return n;
            }
            var c = l(!0);
            if (n(t, i, "scanUp")) for (; !c && r.line > t.firstLine();) {
              r = e.Pos(r.line - 1, 0), c = l(!1);
            }
            if (c && !c.cleared && "unfold" !== o) {
              var u = function (e, t, r) {
                var i = n(e, t, "widget");
                if ("function" == typeof i && (i = i(r.from, r.to)), "string" == typeof i) {
                  var o = document.createTextNode(i);
                  (i = document.createElement("span")).appendChild(o), i.className = "CodeMirror-foldmarker";
                } else i && (i = i.cloneNode(!0));
                return i;
              }(t, i, c);
              e.on(u, "mousedown", function (t) {
                d.clear(), e.e_preventDefault(t);
              });
              var d = t.markText(c.from, c.to, {
                replacedWith: u,
                clearOnEnter: n(t, i, "clearOnEnter"),
                __isFold: !0
              });
              d.on("clear", function (r, n) {
                e.signal(t, "unfold", t, r, n);
              }), e.signal(t, "fold", t, c.from, c.to);
            }
          }
          e.newFoldFunction = function (e, r) {
            return function (n, i) {
              t(n, i, {
                rangeFinder: e,
                widget: r
              });
            };
          }, e.defineExtension("foldCode", function (e, r, n) {
            t(this, e, r, n);
          }), e.defineExtension("isFolded", function (e) {
            for (var t = this.findMarksAt(e), r = 0; r < t.length; ++r) {
              if (t[r].__isFold) return !0;
            }
          }), e.commands.toggleFold = function (e) {
            e.foldCode(e.getCursor());
          }, e.commands.fold = function (e) {
            e.foldCode(e.getCursor(), null, "fold");
          }, e.commands.unfold = function (e) {
            e.foldCode(e.getCursor(), null, "unfold");
          }, e.commands.foldAll = function (t) {
            t.operation(function () {
              for (var r = t.firstLine(), n = t.lastLine(); r <= n; r++) {
                t.foldCode(e.Pos(r, 0), null, "fold");
              }
            });
          }, e.commands.unfoldAll = function (t) {
            t.operation(function () {
              for (var r = t.firstLine(), n = t.lastLine(); r <= n; r++) {
                t.foldCode(e.Pos(r, 0), null, "unfold");
              }
            });
          }, e.registerHelper("fold", "combine", function () {
            var e = Array.prototype.slice.call(arguments, 0);
            return function (t, r) {
              for (var n = 0; n < e.length; ++n) {
                var i = e[n](t, r);
                if (i) return i;
              }
            };
          }), e.registerHelper("fold", "auto", function (e, t) {
            for (var r = e.getHelpers(t, "fold"), n = 0; n < r.length; n++) {
              var i = r[n](e, t);
              if (i) return i;
            }
          });
          var r = {
            rangeFinder: e.fold.auto,
            widget: "↔",
            minFoldSize: 0,
            scanUp: !1,
            clearOnEnter: !0
          };
          function n(e, t, n) {
            if (t && void 0 !== t[n]) return t[n];
            var i = e.options.foldOptions;
            return i && void 0 !== i[n] ? i[n] : r[n];
          }
          e.defineOption("foldOptions", null), e.defineExtension("foldOption", function (e, t) {
            return n(this, e, t);
          });
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      5365: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineOption("foldGutter", !1, function (t, n, i) {
            var o;
            i && i != e.Init && (t.clearGutter(t.state.foldGutter.options.gutter), t.state.foldGutter = null, t.off("gutterClick", l), t.off("changes", c), t.off("viewportChange", u), t.off("fold", d), t.off("unfold", d), t.off("swapDoc", c)), n && (t.state.foldGutter = new r((!0 === (o = n) && (o = {}), null == o.gutter && (o.gutter = "CodeMirror-foldgutter"), null == o.indicatorOpen && (o.indicatorOpen = "CodeMirror-foldgutter-open"), null == o.indicatorFolded && (o.indicatorFolded = "CodeMirror-foldgutter-folded"), o)), s(t), t.on("gutterClick", l), t.on("changes", c), t.on("viewportChange", u), t.on("fold", d), t.on("unfold", d), t.on("swapDoc", c));
          });
          var t = e.Pos;
          function r(e) {
            this.options = e, this.from = this.to = 0;
          }
          function n(e, r) {
            for (var n = e.findMarks(t(r, 0), t(r + 1, 0)), i = 0; i < n.length; ++i) {
              if (n[i].__isFold) {
                var o = n[i].find(-1);
                if (o && o.line === r) return n[i];
              }
            }
          }
          function i(e) {
            if ("string" == typeof e) {
              var t = document.createElement("div");
              return t.className = e + " CodeMirror-guttermarker-subtle", t;
            }
            return e.cloneNode(!0);
          }
          function o(e, r, o) {
            var s = e.state.foldGutter.options,
              l = r - 1,
              c = e.foldOption(s, "minFoldSize"),
              u = e.foldOption(s, "rangeFinder"),
              d = "string" == typeof s.indicatorFolded && a(s.indicatorFolded),
              p = "string" == typeof s.indicatorOpen && a(s.indicatorOpen);
            e.eachLine(r, o, function (r) {
              ++l;
              var o = null,
                a = r.gutterMarkers;
              if (a && (a = a[s.gutter]), n(e, l)) {
                if (d && a && d.test(a.className)) return;
                o = i(s.indicatorFolded);
              } else {
                var f = t(l, 0),
                  m = u && u(e, f);
                if (m && m.to.line - m.from.line >= c) {
                  if (p && a && p.test(a.className)) return;
                  o = i(s.indicatorOpen);
                }
              }
              (o || a) && e.setGutterMarker(r, s.gutter, o);
            });
          }
          function a(e) {
            return new RegExp("(^|\\s)" + e + "(?:$|\\s)\\s*");
          }
          function s(e) {
            var t = e.getViewport(),
              r = e.state.foldGutter;
            r && (e.operation(function () {
              o(e, t.from, t.to);
            }), r.from = t.from, r.to = t.to);
          }
          function l(e, r, i) {
            var o = e.state.foldGutter;
            if (o) {
              var a = o.options;
              if (i == a.gutter) {
                var s = n(e, r);
                s ? s.clear() : e.foldCode(t(r, 0), a);
              }
            }
          }
          function c(e) {
            var t = e.state.foldGutter;
            if (t) {
              var r = t.options;
              t.from = t.to = 0, clearTimeout(t.changeUpdate), t.changeUpdate = setTimeout(function () {
                s(e);
              }, r.foldOnChangeTimeSpan || 600);
            }
          }
          function u(e) {
            var t = e.state.foldGutter;
            if (t) {
              var r = t.options;
              clearTimeout(t.changeUpdate), t.changeUpdate = setTimeout(function () {
                var r = e.getViewport();
                t.from == t.to || r.from - t.to > 20 || t.from - r.to > 20 ? s(e) : e.operation(function () {
                  r.from < t.from && (o(e, r.from, t.from), t.from = r.from), r.to > t.to && (o(e, t.to, r.to), t.to = r.to);
                });
              }, r.updateViewportTimeSpan || 400);
            }
          }
          function d(e, t) {
            var r = e.state.foldGutter;
            if (r) {
              var n = t.line;
              n >= r.from && n < r.to && o(e, n, n + 1);
            }
          }
        }, "object" == s(t) && "object" == s(e) ? a(r(9074), r(2313)) : (i = [r(9074), r(2313)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      3740: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          function t(e, t) {
            if (!e.hasOwnProperty(t)) throw new Error("Undefined state " + t + " in simple mode");
          }
          function r(e, t) {
            if (!e) return /(?:)/;
            var r = "";
            return e instanceof RegExp ? (e.ignoreCase && (r = "i"), e = e.source) : e = String(e), new RegExp((!1 === t ? "" : "^") + "(?:" + e + ")", r);
          }
          function n(e, n) {
            (e.next || e.push) && t(n, e.next || e.push), this.regex = r(e.regex), this.token = function (e) {
              if (!e) return null;
              if (e.apply) return e;
              if ("string" == typeof e) return e.replace(/\./g, " ");
              for (var t = [], r = 0; r < e.length; r++) {
                t.push(e[r] && e[r].replace(/\./g, " "));
              }
              return t;
            }(e.token), this.data = e;
          }
          function i(e, t) {
            return function (r, n) {
              if (n.pending) {
                var i = n.pending.shift();
                return 0 == n.pending.length && (n.pending = null), r.pos += i.text.length, i.token;
              }
              if (n.local) {
                if (n.local.end && r.match(n.local.end)) {
                  var o = n.local.endToken || null;
                  return n.local = n.localState = null, o;
                }
                var s;
                return o = n.local.mode.token(r, n.localState), n.local.endScan && (s = n.local.endScan.exec(r.current())) && (r.pos = r.start + s.index), o;
              }
              for (var l = e[n.state], c = 0; c < l.length; c++) {
                var u = l[c],
                  d = (!u.data.sol || r.sol()) && r.match(u.regex);
                if (d) {
                  u.data.next ? n.state = u.data.next : u.data.push ? ((n.stack || (n.stack = [])).push(n.state), n.state = u.data.push) : u.data.pop && n.stack && n.stack.length && (n.state = n.stack.pop()), u.data.mode && a(t, n, u.data.mode, u.token), u.data.indent && n.indent.push(r.indentation() + t.indentUnit), u.data.dedent && n.indent.pop();
                  var p = u.token;
                  if (p && p.apply && (p = p(d)), d.length > 2 && u.token && "string" != typeof u.token) {
                    n.pending = [];
                    for (var f = 2; f < d.length; f++) {
                      d[f] && n.pending.push({
                        text: d[f],
                        token: u.token[f - 1]
                      });
                    }
                    return r.backUp(d[0].length - (d[1] ? d[1].length : 0)), p[0];
                  }
                  return p && p.join ? p[0] : p;
                }
              }
              return r.next(), null;
            };
          }
          function o(e, t) {
            if (e === t) return !0;
            if (!e || "object" != s(e) || !t || "object" != s(t)) return !1;
            var r = 0;
            for (var n in e) {
              if (e.hasOwnProperty(n)) {
                if (!t.hasOwnProperty(n) || !o(e[n], t[n])) return !1;
                r++;
              }
            }
            for (var n in t) {
              t.hasOwnProperty(n) && r--;
            }
            return 0 == r;
          }
          function a(t, n, i, a) {
            var s;
            if (i.persistent) for (var l = n.persistentStates; l && !s; l = l.next) {
              (i.spec ? o(i.spec, l.spec) : i.mode == l.mode) && (s = l);
            }
            var c = s ? s.mode : i.mode || e.getMode(t, i.spec),
              u = s ? s.state : e.startState(c);
            i.persistent && !s && (n.persistentStates = {
              mode: c,
              spec: i.spec,
              state: u,
              next: n.persistentStates
            }), n.localState = u, n.local = {
              mode: c,
              end: i.end && r(i.end),
              endScan: i.end && !1 !== i.forceEnd && r(i.end, !1),
              endToken: a && a.join ? a[a.length - 1] : a
            };
          }
          function l(t, r) {
            return function (n, i, o) {
              if (n.local && n.local.mode.indent) return n.local.mode.indent(n.localState, i, o);
              if (null == n.indent || n.local || r.dontIndentStates && function (e, t) {
                for (var r = 0; r < t.length; r++) {
                  if (t[r] === e) return !0;
                }
              }(n.state, r.dontIndentStates) > -1) return e.Pass;
              var a = n.indent.length - 1,
                s = t[n.state];
              e: for (;;) {
                for (var l = 0; l < s.length; l++) {
                  var c = s[l];
                  if (c.data.dedent && !1 !== c.data.dedentIfLineStart) {
                    var u = c.regex.exec(i);
                    if (u && u[0]) {
                      a--, (c.next || c.push) && (s = t[c.next || c.push]), i = i.slice(u[0].length);
                      continue e;
                    }
                  }
                }
                break;
              }
              return a < 0 ? 0 : n.indent[a];
            };
          }
          e.defineSimpleMode = function (t, r) {
            e.defineMode(t, function (t) {
              return e.simpleMode(t, r);
            });
          }, e.simpleMode = function (r, o) {
            t(o, "start");
            var a = {},
              s = o.meta || {},
              c = !1;
            for (var u in o) {
              if (u != s && o.hasOwnProperty(u)) for (var d = a[u] = [], p = o[u], f = 0; f < p.length; f++) {
                var m = p[f];
                d.push(new n(m, o)), (m.indent || m.dedent) && (c = !0);
              }
            }
            var h = {
              startState: function startState() {
                return {
                  state: "start",
                  pending: null,
                  local: null,
                  localState: null,
                  indent: c ? [] : null
                };
              },
              copyState: function copyState(t) {
                var r = {
                  state: t.state,
                  pending: t.pending,
                  local: t.local,
                  localState: null,
                  indent: t.indent && t.indent.slice(0)
                };
                t.localState && (r.localState = e.copyState(t.local.mode, t.localState)), t.stack && (r.stack = t.stack.slice(0));
                for (var n = t.persistentStates; n; n = n.next) {
                  r.persistentStates = {
                    mode: n.mode,
                    spec: n.spec,
                    state: n.state == t.localState ? r.localState : e.copyState(n.mode, n.state),
                    next: r.persistentStates
                  };
                }
                return r;
              },
              token: i(a, r),
              innerMode: function innerMode(e) {
                return e.local && {
                  mode: e.local.mode,
                  state: e.localState
                };
              },
              indent: l(a, s)
            };
            if (s) for (var g in s) {
              s.hasOwnProperty(g) && (h[g] = s[g]);
            }
            return h;
          };
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      622: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.runMode = function (t, r, n, i) {
            var o = e.getMode(e.defaults, r),
              a = /MSIE \d/.test(navigator.userAgent) && (null == document.documentMode || document.documentMode < 9);
            if (n.appendChild) {
              var s = i && i.tabSize || e.defaults.tabSize,
                l = n,
                c = 0;
              l.innerHTML = "", n = function n(e, t) {
                if ("\n" == e) return l.appendChild(document.createTextNode(a ? "\r" : e)), void (c = 0);
                for (var r = "", n = 0;;) {
                  var i = e.indexOf("\t", n);
                  if (-1 == i) {
                    r += e.slice(n), c += e.length - n;
                    break;
                  }
                  c += i - n, r += e.slice(n, i);
                  var o = s - c % s;
                  c += o;
                  for (var u = 0; u < o; ++u) {
                    r += " ";
                  }
                  n = i + 1;
                }
                if (t) {
                  var d = l.appendChild(document.createElement("span"));
                  d.className = "cm-" + t.replace(/ +/g, " cm-"), d.appendChild(document.createTextNode(r));
                } else l.appendChild(document.createTextNode(r));
              };
            }
            for (var u = e.splitLines(t), d = i && i.state || e.startState(o), p = 0, f = u.length; p < f; ++p) {
              p && n("\n");
              var m = new e.StringStream(u[p], null, {
                lookAhead: function lookAhead(e) {
                  return u[p + e];
                },
                baseToken: function baseToken() {}
              });
              for (!m.string && o.blankLine && o.blankLine(d); !m.eol();) {
                var h = o.token(m, d);
                n(m.current(), h, p, m.start, d), m.start = m.pos;
              }
            }
          };
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      9074: function _(e, t, r) {
        var n, i, o;
        function a(e) {
          return a = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, a(e);
        }
        o = function o() {
          "use strict";

          var e = navigator.userAgent,
            t = navigator.platform,
            r = /gecko\/\d/i.test(e),
            n = /MSIE \d/.test(e),
            i = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(e),
            o = /Edge\/(\d+)/.exec(e),
            s = n || i || o,
            l = s && (n ? document.documentMode || 6 : +(o || i)[1]),
            c = !o && /WebKit\//.test(e),
            u = c && /Qt\/\d+\.\d+/.test(e),
            d = !o && /Chrome\//.test(e),
            p = /Opera\//.test(e),
            f = /Apple Computer/.test(navigator.vendor),
            m = /Mac OS X 1\d\D([8-9]|\d\d)\D/.test(e),
            h = /PhantomJS/.test(e),
            g = !o && /AppleWebKit/.test(e) && /Mobile\/\w+/.test(e),
            y = /Android/.test(e),
            v = g || y || /webOS|BlackBerry|Opera Mini|Opera Mobi|IEMobile/i.test(e),
            b = g || /Mac/.test(t),
            x = /\bCrOS\b/.test(e),
            k = /win/i.test(t),
            w = p && e.match(/Version\/(\d*\.\d*)/);
          w && (w = Number(w[1])), w && w >= 15 && (p = !1, c = !0);
          var _ = b && (u || p && (null == w || w < 12.11)),
            S = r || s && l >= 9;
          function C(e) {
            return new RegExp("(^|\\s)" + e + "(?:$|\\s)\\s*");
          }
          var T,
            M = function M(e, t) {
              var r = e.className,
                n = C(t).exec(r);
              if (n) {
                var i = r.slice(n.index + n[0].length);
                e.className = r.slice(0, n.index) + (i ? n[1] + i : "");
              }
            };
          function E(e) {
            for (var t = e.childNodes.length; t > 0; --t) {
              e.removeChild(e.firstChild);
            }
            return e;
          }
          function L(e, t) {
            return E(e).appendChild(t);
          }
          function A(e, t, r, n) {
            var i = document.createElement(e);
            if (r && (i.className = r), n && (i.style.cssText = n), "string" == typeof t) i.appendChild(document.createTextNode(t));else if (t) for (var o = 0; o < t.length; ++o) {
              i.appendChild(t[o]);
            }
            return i;
          }
          function N(e, t, r, n) {
            var i = A(e, t, r, n);
            return i.setAttribute("role", "presentation"), i;
          }
          function z(e, t) {
            if (3 == t.nodeType && (t = t.parentNode), e.contains) return e.contains(t);
            do {
              if (11 == t.nodeType && (t = t.host), t == e) return !0;
            } while (t = t.parentNode);
          }
          function O() {
            var e;
            try {
              e = document.activeElement;
            } catch (t) {
              e = document.body || null;
            }
            for (; e && e.shadowRoot && e.shadowRoot.activeElement;) {
              e = e.shadowRoot.activeElement;
            }
            return e;
          }
          function D(e, t) {
            var r = e.className;
            C(t).test(r) || (e.className += (r ? " " : "") + t);
          }
          function I(e, t) {
            for (var r = e.split(" "), n = 0; n < r.length; n++) {
              r[n] && !C(r[n]).test(t) && (t += " " + r[n]);
            }
            return t;
          }
          T = document.createRange ? function (e, t, r, n) {
            var i = document.createRange();
            return i.setEnd(n || e, r), i.setStart(e, t), i;
          } : function (e, t, r) {
            var n = document.body.createTextRange();
            try {
              n.moveToElementText(e.parentNode);
            } catch (e) {
              return n;
            }
            return n.collapse(!0), n.moveEnd("character", r), n.moveStart("character", t), n;
          };
          var P = function P(e) {
            e.select();
          };
          function j(e) {
            var t = Array.prototype.slice.call(arguments, 1);
            return function () {
              return e.apply(null, t);
            };
          }
          function q(e, t, r) {
            for (var n in t || (t = {}), e) {
              !e.hasOwnProperty(n) || !1 === r && t.hasOwnProperty(n) || (t[n] = e[n]);
            }
            return t;
          }
          function F(e, t, r, n, i) {
            null == t && -1 == (t = e.search(/[^\s\u00a0]/)) && (t = e.length);
            for (var o = n || 0, a = i || 0;;) {
              var s = e.indexOf("\t", o);
              if (s < 0 || s >= t) return a + (t - o);
              a += s - o, a += r - a % r, o = s + 1;
            }
          }
          g ? P = function P(e) {
            e.selectionStart = 0, e.selectionEnd = e.value.length;
          } : s && (P = function P(e) {
            try {
              e.select();
            } catch (e) {}
          });
          var R = function R() {
            this.id = null, this.f = null, this.time = 0, this.handler = j(this.onTimeout, this);
          };
          function W(e, t) {
            for (var r = 0; r < e.length; ++r) {
              if (e[r] == t) return r;
            }
            return -1;
          }
          R.prototype.onTimeout = function (e) {
            e.id = 0, e.time <= +new Date() ? e.f() : setTimeout(e.handler, e.time - +new Date());
          }, R.prototype.set = function (e, t) {
            this.f = t;
            var r = +new Date() + e;
            (!this.id || r < this.time) && (clearTimeout(this.id), this.id = setTimeout(this.handler, e), this.time = r);
          };
          var $ = {
              toString: function toString() {
                return "CodeMirror.Pass";
              }
            },
            U = {
              scroll: !1
            },
            H = {
              origin: "*mouse"
            },
            B = {
              origin: "+move"
            };
          function V(e, t, r) {
            for (var n = 0, i = 0;;) {
              var o = e.indexOf("\t", n);
              -1 == o && (o = e.length);
              var a = o - n;
              if (o == e.length || i + a >= t) return n + Math.min(a, t - i);
              if (i += o - n, n = o + 1, (i += r - i % r) >= t) return n;
            }
          }
          var G = [""];
          function K(e) {
            for (; G.length <= e;) {
              G.push(Z(G) + " ");
            }
            return G[e];
          }
          function Z(e) {
            return e[e.length - 1];
          }
          function X(e, t) {
            for (var r = [], n = 0; n < e.length; n++) {
              r[n] = t(e[n], n);
            }
            return r;
          }
          function Y() {}
          function Q(e, t) {
            var r;
            return Object.create ? r = Object.create(e) : (Y.prototype = e, r = new Y()), t && q(t, r), r;
          }
          var J = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
          function ee(e) {
            return /\w/.test(e) || e > "" && (e.toUpperCase() != e.toLowerCase() || J.test(e));
          }
          function te(e, t) {
            return t ? !!(t.source.indexOf("\\w") > -1 && ee(e)) || t.test(e) : ee(e);
          }
          function re(e) {
            for (var t in e) {
              if (e.hasOwnProperty(t) && e[t]) return !1;
            }
            return !0;
          }
          var ne = /[\u0300-\u036f\u0483-\u0489\u0591-\u05bd\u05bf\u05c1\u05c2\u05c4\u05c5\u05c7\u0610-\u061a\u064b-\u065e\u0670\u06d6-\u06dc\u06de-\u06e4\u06e7\u06e8\u06ea-\u06ed\u0711\u0730-\u074a\u07a6-\u07b0\u07eb-\u07f3\u0816-\u0819\u081b-\u0823\u0825-\u0827\u0829-\u082d\u0900-\u0902\u093c\u0941-\u0948\u094d\u0951-\u0955\u0962\u0963\u0981\u09bc\u09be\u09c1-\u09c4\u09cd\u09d7\u09e2\u09e3\u0a01\u0a02\u0a3c\u0a41\u0a42\u0a47\u0a48\u0a4b-\u0a4d\u0a51\u0a70\u0a71\u0a75\u0a81\u0a82\u0abc\u0ac1-\u0ac5\u0ac7\u0ac8\u0acd\u0ae2\u0ae3\u0b01\u0b3c\u0b3e\u0b3f\u0b41-\u0b44\u0b4d\u0b56\u0b57\u0b62\u0b63\u0b82\u0bbe\u0bc0\u0bcd\u0bd7\u0c3e-\u0c40\u0c46-\u0c48\u0c4a-\u0c4d\u0c55\u0c56\u0c62\u0c63\u0cbc\u0cbf\u0cc2\u0cc6\u0ccc\u0ccd\u0cd5\u0cd6\u0ce2\u0ce3\u0d3e\u0d41-\u0d44\u0d4d\u0d57\u0d62\u0d63\u0dca\u0dcf\u0dd2-\u0dd4\u0dd6\u0ddf\u0e31\u0e34-\u0e3a\u0e47-\u0e4e\u0eb1\u0eb4-\u0eb9\u0ebb\u0ebc\u0ec8-\u0ecd\u0f18\u0f19\u0f35\u0f37\u0f39\u0f71-\u0f7e\u0f80-\u0f84\u0f86\u0f87\u0f90-\u0f97\u0f99-\u0fbc\u0fc6\u102d-\u1030\u1032-\u1037\u1039\u103a\u103d\u103e\u1058\u1059\u105e-\u1060\u1071-\u1074\u1082\u1085\u1086\u108d\u109d\u135f\u1712-\u1714\u1732-\u1734\u1752\u1753\u1772\u1773\u17b7-\u17bd\u17c6\u17c9-\u17d3\u17dd\u180b-\u180d\u18a9\u1920-\u1922\u1927\u1928\u1932\u1939-\u193b\u1a17\u1a18\u1a56\u1a58-\u1a5e\u1a60\u1a62\u1a65-\u1a6c\u1a73-\u1a7c\u1a7f\u1b00-\u1b03\u1b34\u1b36-\u1b3a\u1b3c\u1b42\u1b6b-\u1b73\u1b80\u1b81\u1ba2-\u1ba5\u1ba8\u1ba9\u1c2c-\u1c33\u1c36\u1c37\u1cd0-\u1cd2\u1cd4-\u1ce0\u1ce2-\u1ce8\u1ced\u1dc0-\u1de6\u1dfd-\u1dff\u200c\u200d\u20d0-\u20f0\u2cef-\u2cf1\u2de0-\u2dff\u302a-\u302f\u3099\u309a\ua66f-\ua672\ua67c\ua67d\ua6f0\ua6f1\ua802\ua806\ua80b\ua825\ua826\ua8c4\ua8e0-\ua8f1\ua926-\ua92d\ua947-\ua951\ua980-\ua982\ua9b3\ua9b6-\ua9b9\ua9bc\uaa29-\uaa2e\uaa31\uaa32\uaa35\uaa36\uaa43\uaa4c\uaab0\uaab2-\uaab4\uaab7\uaab8\uaabe\uaabf\uaac1\uabe5\uabe8\uabed\udc00-\udfff\ufb1e\ufe00-\ufe0f\ufe20-\ufe26\uff9e\uff9f]/;
          function ie(e) {
            return e.charCodeAt(0) >= 768 && ne.test(e);
          }
          function oe(e, t, r) {
            for (; (r < 0 ? t > 0 : t < e.length) && ie(e.charAt(t));) {
              t += r;
            }
            return t;
          }
          function ae(e, t, r) {
            for (var n = t > r ? -1 : 1;;) {
              if (t == r) return t;
              var i = (t + r) / 2,
                o = n < 0 ? Math.ceil(i) : Math.floor(i);
              if (o == t) return e(o) ? t : r;
              e(o) ? r = o : t = o + n;
            }
          }
          var se = null;
          function le(e, t, r) {
            var n;
            se = null;
            for (var i = 0; i < e.length; ++i) {
              var o = e[i];
              if (o.from < t && o.to > t) return i;
              o.to == t && (o.from != o.to && "before" == r ? n = i : se = i), o.from == t && (o.from != o.to && "before" != r ? n = i : se = i);
            }
            return null != n ? n : se;
          }
          var ce = function () {
            var e = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/,
              t = /[stwN]/,
              r = /[LRr]/,
              n = /[Lb1n]/,
              i = /[1n]/;
            function o(e, t, r) {
              this.level = e, this.from = t, this.to = r;
            }
            return function (a, s) {
              var l = "ltr" == s ? "L" : "R";
              if (0 == a.length || "ltr" == s && !e.test(a)) return !1;
              for (var c, u = a.length, d = [], p = 0; p < u; ++p) {
                d.push((c = a.charCodeAt(p)) <= 247 ? "bbbbbbbbbtstwsbbbbbbbbbbbbbbssstwNN%%%NNNNNN,N,N1111111111NNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNNNLLLLLLLLLLLLLLLLLLLLLLLLLLNNNNbbbbbbsbbbbbbbbbbbbbbbbbbbbbbbbbb,N%%%%NNNNLNNNNN%%11NLNNN1LNNNNNLLLLLLLLLLLLLLLLLLLLLLLNLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLLN".charAt(c) : 1424 <= c && c <= 1524 ? "R" : 1536 <= c && c <= 1785 ? "nnnnnnNNr%%r,rNNmmmmmmmmmmmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmmmmmmmmmmmmmmmnnnnnnnnnn%nnrrrmrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrmmmmmmmnNmmmmmmrrmmNmmmmrr1111111111".charAt(c - 1536) : 1774 <= c && c <= 2220 ? "r" : 8192 <= c && c <= 8203 ? "w" : 8204 == c ? "b" : "L");
              }
              for (var f = 0, m = l; f < u; ++f) {
                var h = d[f];
                "m" == h ? d[f] = m : m = h;
              }
              for (var g = 0, y = l; g < u; ++g) {
                var v = d[g];
                "1" == v && "r" == y ? d[g] = "n" : r.test(v) && (y = v, "r" == v && (d[g] = "R"));
              }
              for (var b = 1, x = d[0]; b < u - 1; ++b) {
                var k = d[b];
                "+" == k && "1" == x && "1" == d[b + 1] ? d[b] = "1" : "," != k || x != d[b + 1] || "1" != x && "n" != x || (d[b] = x), x = k;
              }
              for (var w = 0; w < u; ++w) {
                var _ = d[w];
                if ("," == _) d[w] = "N";else if ("%" == _) {
                  var S = void 0;
                  for (S = w + 1; S < u && "%" == d[S]; ++S) {
                    ;
                  }
                  for (var C = w && "!" == d[w - 1] || S < u && "1" == d[S] ? "1" : "N", T = w; T < S; ++T) {
                    d[T] = C;
                  }
                  w = S - 1;
                }
              }
              for (var M = 0, E = l; M < u; ++M) {
                var L = d[M];
                "L" == E && "1" == L ? d[M] = "L" : r.test(L) && (E = L);
              }
              for (var A = 0; A < u; ++A) {
                if (t.test(d[A])) {
                  var N = void 0;
                  for (N = A + 1; N < u && t.test(d[N]); ++N) {
                    ;
                  }
                  for (var z = "L" == (A ? d[A - 1] : l), O = z == ("L" == (N < u ? d[N] : l)) ? z ? "L" : "R" : l, D = A; D < N; ++D) {
                    d[D] = O;
                  }
                  A = N - 1;
                }
              }
              for (var I, P = [], j = 0; j < u;) {
                if (n.test(d[j])) {
                  var q = j;
                  for (++j; j < u && n.test(d[j]); ++j) {
                    ;
                  }
                  P.push(new o(0, q, j));
                } else {
                  var F = j,
                    R = P.length,
                    W = "rtl" == s ? 1 : 0;
                  for (++j; j < u && "L" != d[j]; ++j) {
                    ;
                  }
                  for (var $ = F; $ < j;) {
                    if (i.test(d[$])) {
                      F < $ && (P.splice(R, 0, new o(1, F, $)), R += W);
                      var U = $;
                      for (++$; $ < j && i.test(d[$]); ++$) {
                        ;
                      }
                      P.splice(R, 0, new o(2, U, $)), R += W, F = $;
                    } else ++$;
                  }
                  F < j && P.splice(R, 0, new o(1, F, j));
                }
              }
              return "ltr" == s && (1 == P[0].level && (I = a.match(/^\s+/)) && (P[0].from = I[0].length, P.unshift(new o(0, 0, I[0].length))), 1 == Z(P).level && (I = a.match(/\s+$/)) && (Z(P).to -= I[0].length, P.push(new o(0, u - I[0].length, u)))), "rtl" == s ? P.reverse() : P;
            };
          }();
          function ue(e, t) {
            var r = e.order;
            return null == r && (r = e.order = ce(e.text, t)), r;
          }
          var de = [],
            pe = function pe(e, t, r) {
              if (e.addEventListener) e.addEventListener(t, r, !1);else if (e.attachEvent) e.attachEvent("on" + t, r);else {
                var n = e._handlers || (e._handlers = {});
                n[t] = (n[t] || de).concat(r);
              }
            };
          function fe(e, t) {
            return e._handlers && e._handlers[t] || de;
          }
          function me(e, t, r) {
            if (e.removeEventListener) e.removeEventListener(t, r, !1);else if (e.detachEvent) e.detachEvent("on" + t, r);else {
              var n = e._handlers,
                i = n && n[t];
              if (i) {
                var o = W(i, r);
                o > -1 && (n[t] = i.slice(0, o).concat(i.slice(o + 1)));
              }
            }
          }
          function he(e, t) {
            var r = fe(e, t);
            if (r.length) for (var n = Array.prototype.slice.call(arguments, 2), i = 0; i < r.length; ++i) {
              r[i].apply(null, n);
            }
          }
          function ge(e, t, r) {
            return "string" == typeof t && (t = {
              type: t,
              preventDefault: function preventDefault() {
                this.defaultPrevented = !0;
              }
            }), he(e, r || t.type, e, t), we(t) || t.codemirrorIgnore;
          }
          function ye(e) {
            var t = e._handlers && e._handlers.cursorActivity;
            if (t) for (var r = e.curOp.cursorActivityHandlers || (e.curOp.cursorActivityHandlers = []), n = 0; n < t.length; ++n) {
              -1 == W(r, t[n]) && r.push(t[n]);
            }
          }
          function ve(e, t) {
            return fe(e, t).length > 0;
          }
          function be(e) {
            e.prototype.on = function (e, t) {
              pe(this, e, t);
            }, e.prototype.off = function (e, t) {
              me(this, e, t);
            };
          }
          function xe(e) {
            e.preventDefault ? e.preventDefault() : e.returnValue = !1;
          }
          function ke(e) {
            e.stopPropagation ? e.stopPropagation() : e.cancelBubble = !0;
          }
          function we(e) {
            return null != e.defaultPrevented ? e.defaultPrevented : 0 == e.returnValue;
          }
          function _e(e) {
            xe(e), ke(e);
          }
          function Se(e) {
            return e.target || e.srcElement;
          }
          function Ce(e) {
            var t = e.which;
            return null == t && (1 & e.button ? t = 1 : 2 & e.button ? t = 3 : 4 & e.button && (t = 2)), b && e.ctrlKey && 1 == t && (t = 3), t;
          }
          var Te,
            Me,
            Ee = function () {
              if (s && l < 9) return !1;
              var e = A("div");
              return "draggable" in e || "dragDrop" in e;
            }();
          function Le(e) {
            if (null == Te) {
              var t = A("span", "​");
              L(e, A("span", [t, document.createTextNode("x")])), 0 != e.firstChild.offsetHeight && (Te = t.offsetWidth <= 1 && t.offsetHeight > 2 && !(s && l < 8));
            }
            var r = Te ? A("span", "​") : A("span", " ", null, "display: inline-block; width: 1px; margin-right: -1px");
            return r.setAttribute("cm-text", ""), r;
          }
          function Ae(e) {
            if (null != Me) return Me;
            var t = L(e, document.createTextNode("AخA")),
              r = T(t, 0, 1).getBoundingClientRect(),
              n = T(t, 1, 2).getBoundingClientRect();
            return E(e), !(!r || r.left == r.right) && (Me = n.right - r.right < 3);
          }
          var Ne,
            ze = 3 != "\n\nb".split(/\n/).length ? function (e) {
              for (var t = 0, r = [], n = e.length; t <= n;) {
                var i = e.indexOf("\n", t);
                -1 == i && (i = e.length);
                var o = e.slice(t, "\r" == e.charAt(i - 1) ? i - 1 : i),
                  a = o.indexOf("\r");
                -1 != a ? (r.push(o.slice(0, a)), t += a + 1) : (r.push(o), t = i + 1);
              }
              return r;
            } : function (e) {
              return e.split(/\r\n?|\n/);
            },
            Oe = window.getSelection ? function (e) {
              try {
                return e.selectionStart != e.selectionEnd;
              } catch (e) {
                return !1;
              }
            } : function (e) {
              var t;
              try {
                t = e.ownerDocument.selection.createRange();
              } catch (e) {}
              return !(!t || t.parentElement() != e) && 0 != t.compareEndPoints("StartToEnd", t);
            },
            De = "oncopy" in (Ne = A("div")) || (Ne.setAttribute("oncopy", "return;"), "function" == typeof Ne.oncopy),
            Ie = null,
            Pe = {},
            je = {};
          function qe(e, t) {
            arguments.length > 2 && (t.dependencies = Array.prototype.slice.call(arguments, 2)), Pe[e] = t;
          }
          function Fe(e) {
            if ("string" == typeof e && je.hasOwnProperty(e)) e = je[e];else if (e && "string" == typeof e.name && je.hasOwnProperty(e.name)) {
              var t = je[e.name];
              "string" == typeof t && (t = {
                name: t
              }), (e = Q(t, e)).name = t.name;
            } else {
              if ("string" == typeof e && /^[\w\-]+\/[\w\-]+\+xml$/.test(e)) return Fe("application/xml");
              if ("string" == typeof e && /^[\w\-]+\/[\w\-]+\+json$/.test(e)) return Fe("application/json");
            }
            return "string" == typeof e ? {
              name: e
            } : e || {
              name: "null"
            };
          }
          function Re(e, t) {
            t = Fe(t);
            var r = Pe[t.name];
            if (!r) return Re(e, "text/plain");
            var n = r(e, t);
            if (We.hasOwnProperty(t.name)) {
              var i = We[t.name];
              for (var o in i) {
                i.hasOwnProperty(o) && (n.hasOwnProperty(o) && (n["_" + o] = n[o]), n[o] = i[o]);
              }
            }
            if (n.name = t.name, t.helperType && (n.helperType = t.helperType), t.modeProps) for (var a in t.modeProps) {
              n[a] = t.modeProps[a];
            }
            return n;
          }
          var We = {};
          function $e(e, t) {
            q(t, We.hasOwnProperty(e) ? We[e] : We[e] = {});
          }
          function Ue(e, t) {
            if (!0 === t) return t;
            if (e.copyState) return e.copyState(t);
            var r = {};
            for (var n in t) {
              var i = t[n];
              i instanceof Array && (i = i.concat([])), r[n] = i;
            }
            return r;
          }
          function He(e, t) {
            for (var r; e.innerMode && (r = e.innerMode(t)) && r.mode != e;) {
              t = r.state, e = r.mode;
            }
            return r || {
              mode: e,
              state: t
            };
          }
          function Be(e, t, r) {
            return !e.startState || e.startState(t, r);
          }
          var Ve = function Ve(e, t, r) {
            this.pos = this.start = 0, this.string = e, this.tabSize = t || 8, this.lastColumnPos = this.lastColumnValue = 0, this.lineStart = 0, this.lineOracle = r;
          };
          function Ge(e, t) {
            if ((t -= e.first) < 0 || t >= e.size) throw new Error("There is no line " + (t + e.first) + " in the document.");
            for (var r = e; !r.lines;) {
              for (var n = 0;; ++n) {
                var i = r.children[n],
                  o = i.chunkSize();
                if (t < o) {
                  r = i;
                  break;
                }
                t -= o;
              }
            }
            return r.lines[t];
          }
          function Ke(e, t, r) {
            var n = [],
              i = t.line;
            return e.iter(t.line, r.line + 1, function (e) {
              var o = e.text;
              i == r.line && (o = o.slice(0, r.ch)), i == t.line && (o = o.slice(t.ch)), n.push(o), ++i;
            }), n;
          }
          function Ze(e, t, r) {
            var n = [];
            return e.iter(t, r, function (e) {
              n.push(e.text);
            }), n;
          }
          function Xe(e, t) {
            var r = t - e.height;
            if (r) for (var n = e; n; n = n.parent) {
              n.height += r;
            }
          }
          function Ye(e) {
            if (null == e.parent) return null;
            for (var t = e.parent, r = W(t.lines, e), n = t.parent; n; t = n, n = n.parent) {
              for (var i = 0; n.children[i] != t; ++i) {
                r += n.children[i].chunkSize();
              }
            }
            return r + t.first;
          }
          function Qe(e, t) {
            var r = e.first;
            e: do {
              for (var n = 0; n < e.children.length; ++n) {
                var i = e.children[n],
                  o = i.height;
                if (t < o) {
                  e = i;
                  continue e;
                }
                t -= o, r += i.chunkSize();
              }
              return r;
            } while (!e.lines);
            for (var a = 0; a < e.lines.length; ++a) {
              var s = e.lines[a].height;
              if (t < s) break;
              t -= s;
            }
            return r + a;
          }
          function Je(e, t) {
            return t >= e.first && t < e.first + e.size;
          }
          function et(e, t) {
            return String(e.lineNumberFormatter(t + e.firstLineNumber));
          }
          function tt(e, t, r) {
            if (void 0 === r && (r = null), !(this instanceof tt)) return new tt(e, t, r);
            this.line = e, this.ch = t, this.sticky = r;
          }
          function rt(e, t) {
            return e.line - t.line || e.ch - t.ch;
          }
          function nt(e, t) {
            return e.sticky == t.sticky && 0 == rt(e, t);
          }
          function it(e) {
            return tt(e.line, e.ch);
          }
          function ot(e, t) {
            return rt(e, t) < 0 ? t : e;
          }
          function at(e, t) {
            return rt(e, t) < 0 ? e : t;
          }
          function st(e, t) {
            return Math.max(e.first, Math.min(t, e.first + e.size - 1));
          }
          function lt(e, t) {
            if (t.line < e.first) return tt(e.first, 0);
            var r = e.first + e.size - 1;
            return t.line > r ? tt(r, Ge(e, r).text.length) : function (e, t) {
              var r = e.ch;
              return null == r || r > t ? tt(e.line, t) : r < 0 ? tt(e.line, 0) : e;
            }(t, Ge(e, t.line).text.length);
          }
          function ct(e, t) {
            for (var r = [], n = 0; n < t.length; n++) {
              r[n] = lt(e, t[n]);
            }
            return r;
          }
          Ve.prototype.eol = function () {
            return this.pos >= this.string.length;
          }, Ve.prototype.sol = function () {
            return this.pos == this.lineStart;
          }, Ve.prototype.peek = function () {
            return this.string.charAt(this.pos) || void 0;
          }, Ve.prototype.next = function () {
            if (this.pos < this.string.length) return this.string.charAt(this.pos++);
          }, Ve.prototype.eat = function (e) {
            var t = this.string.charAt(this.pos);
            if ("string" == typeof e ? t == e : t && (e.test ? e.test(t) : e(t))) return ++this.pos, t;
          }, Ve.prototype.eatWhile = function (e) {
            for (var t = this.pos; this.eat(e);) {
              ;
            }
            return this.pos > t;
          }, Ve.prototype.eatSpace = function () {
            for (var e = this.pos; /[\s\u00a0]/.test(this.string.charAt(this.pos));) {
              ++this.pos;
            }
            return this.pos > e;
          }, Ve.prototype.skipToEnd = function () {
            this.pos = this.string.length;
          }, Ve.prototype.skipTo = function (e) {
            var t = this.string.indexOf(e, this.pos);
            if (t > -1) return this.pos = t, !0;
          }, Ve.prototype.backUp = function (e) {
            this.pos -= e;
          }, Ve.prototype.column = function () {
            return this.lastColumnPos < this.start && (this.lastColumnValue = F(this.string, this.start, this.tabSize, this.lastColumnPos, this.lastColumnValue), this.lastColumnPos = this.start), this.lastColumnValue - (this.lineStart ? F(this.string, this.lineStart, this.tabSize) : 0);
          }, Ve.prototype.indentation = function () {
            return F(this.string, null, this.tabSize) - (this.lineStart ? F(this.string, this.lineStart, this.tabSize) : 0);
          }, Ve.prototype.match = function (e, t, r) {
            if ("string" != typeof e) {
              var n = this.string.slice(this.pos).match(e);
              return n && n.index > 0 ? null : (n && !1 !== t && (this.pos += n[0].length), n);
            }
            var i = function i(e) {
              return r ? e.toLowerCase() : e;
            };
            if (i(this.string.substr(this.pos, e.length)) == i(e)) return !1 !== t && (this.pos += e.length), !0;
          }, Ve.prototype.current = function () {
            return this.string.slice(this.start, this.pos);
          }, Ve.prototype.hideFirstChars = function (e, t) {
            this.lineStart += e;
            try {
              return t();
            } finally {
              this.lineStart -= e;
            }
          }, Ve.prototype.lookAhead = function (e) {
            var t = this.lineOracle;
            return t && t.lookAhead(e);
          }, Ve.prototype.baseToken = function () {
            var e = this.lineOracle;
            return e && e.baseToken(this.pos);
          };
          var ut = function ut(e, t) {
              this.state = e, this.lookAhead = t;
            },
            dt = function dt(e, t, r, n) {
              this.state = t, this.doc = e, this.line = r, this.maxLookAhead = n || 0, this.baseTokens = null, this.baseTokenPos = 1;
            };
          function pt(e, t, r, n) {
            var i = [e.state.modeGen],
              o = {};
            kt(e, t.text, e.doc.mode, r, function (e, t) {
              return i.push(e, t);
            }, o, n);
            for (var a = r.state, s = function s(n) {
                r.baseTokens = i;
                var s = e.state.overlays[n],
                  l = 1,
                  c = 0;
                r.state = !0, kt(e, t.text, s.mode, r, function (e, t) {
                  for (var r = l; c < e;) {
                    var n = i[l];
                    n > e && i.splice(l, 1, e, i[l + 1], n), l += 2, c = Math.min(e, n);
                  }
                  if (t) if (s.opaque) i.splice(r, l - r, e, "overlay " + t), l = r + 2;else for (; r < l; r += 2) {
                    var o = i[r + 1];
                    i[r + 1] = (o ? o + " " : "") + "overlay " + t;
                  }
                }, o), r.state = a, r.baseTokens = null, r.baseTokenPos = 1;
              }, l = 0; l < e.state.overlays.length; ++l) {
              s(l);
            }
            return {
              styles: i,
              classes: o.bgClass || o.textClass ? o : null
            };
          }
          function ft(e, t, r) {
            if (!t.styles || t.styles[0] != e.state.modeGen) {
              var n = mt(e, Ye(t)),
                i = t.text.length > e.options.maxHighlightLength && Ue(e.doc.mode, n.state),
                o = pt(e, t, n);
              i && (n.state = i), t.stateAfter = n.save(!i), t.styles = o.styles, o.classes ? t.styleClasses = o.classes : t.styleClasses && (t.styleClasses = null), r === e.doc.highlightFrontier && (e.doc.modeFrontier = Math.max(e.doc.modeFrontier, ++e.doc.highlightFrontier));
            }
            return t.styles;
          }
          function mt(e, t, r) {
            var n = e.doc,
              i = e.display;
            if (!n.mode.startState) return new dt(n, !0, t);
            var o = function (e, t, r) {
                for (var n, i, o = e.doc, a = r ? -1 : t - (e.doc.mode.innerMode ? 1e3 : 100), s = t; s > a; --s) {
                  if (s <= o.first) return o.first;
                  var l = Ge(o, s - 1),
                    c = l.stateAfter;
                  if (c && (!r || s + (c instanceof ut ? c.lookAhead : 0) <= o.modeFrontier)) return s;
                  var u = F(l.text, null, e.options.tabSize);
                  (null == i || n > u) && (i = s - 1, n = u);
                }
                return i;
              }(e, t, r),
              a = o > n.first && Ge(n, o - 1).stateAfter,
              s = a ? dt.fromSaved(n, a, o) : new dt(n, Be(n.mode), o);
            return n.iter(o, t, function (r) {
              ht(e, r.text, s);
              var n = s.line;
              r.stateAfter = n == t - 1 || n % 5 == 0 || n >= i.viewFrom && n < i.viewTo ? s.save() : null, s.nextLine();
            }), r && (n.modeFrontier = s.line), s;
          }
          function ht(e, t, r, n) {
            var i = e.doc.mode,
              o = new Ve(t, e.options.tabSize, r);
            for (o.start = o.pos = n || 0, "" == t && gt(i, r.state); !o.eol();) {
              yt(i, o, r.state), o.start = o.pos;
            }
          }
          function gt(e, t) {
            if (e.blankLine) return e.blankLine(t);
            if (e.innerMode) {
              var r = He(e, t);
              return r.mode.blankLine ? r.mode.blankLine(r.state) : void 0;
            }
          }
          function yt(e, t, r, n) {
            for (var i = 0; i < 10; i++) {
              n && (n[0] = He(e, r).mode);
              var o = e.token(t, r);
              if (t.pos > t.start) return o;
            }
            throw new Error("Mode " + e.name + " failed to advance stream.");
          }
          dt.prototype.lookAhead = function (e) {
            var t = this.doc.getLine(this.line + e);
            return null != t && e > this.maxLookAhead && (this.maxLookAhead = e), t;
          }, dt.prototype.baseToken = function (e) {
            if (!this.baseTokens) return null;
            for (; this.baseTokens[this.baseTokenPos] <= e;) {
              this.baseTokenPos += 2;
            }
            var t = this.baseTokens[this.baseTokenPos + 1];
            return {
              type: t && t.replace(/( |^)overlay .*/, ""),
              size: this.baseTokens[this.baseTokenPos] - e
            };
          }, dt.prototype.nextLine = function () {
            this.line++, this.maxLookAhead > 0 && this.maxLookAhead--;
          }, dt.fromSaved = function (e, t, r) {
            return t instanceof ut ? new dt(e, Ue(e.mode, t.state), r, t.lookAhead) : new dt(e, Ue(e.mode, t), r);
          }, dt.prototype.save = function (e) {
            var t = !1 !== e ? Ue(this.doc.mode, this.state) : this.state;
            return this.maxLookAhead > 0 ? new ut(t, this.maxLookAhead) : t;
          };
          var vt = function vt(e, t, r) {
            this.start = e.start, this.end = e.pos, this.string = e.current(), this.type = t || null, this.state = r;
          };
          function bt(e, t, r, n) {
            var i,
              o,
              a = e.doc,
              s = a.mode,
              l = Ge(a, (t = lt(a, t)).line),
              c = mt(e, t.line, r),
              u = new Ve(l.text, e.options.tabSize, c);
            for (n && (o = []); (n || u.pos < t.ch) && !u.eol();) {
              u.start = u.pos, i = yt(s, u, c.state), n && o.push(new vt(u, i, Ue(a.mode, c.state)));
            }
            return n ? o : new vt(u, i, c.state);
          }
          function xt(e, t) {
            if (e) for (;;) {
              var r = e.match(/(?:^|\s+)line-(background-)?(\S+)/);
              if (!r) break;
              e = e.slice(0, r.index) + e.slice(r.index + r[0].length);
              var n = r[1] ? "bgClass" : "textClass";
              null == t[n] ? t[n] = r[2] : new RegExp("(?:^|\\s)" + r[2] + "(?:$|\\s)").test(t[n]) || (t[n] += " " + r[2]);
            }
            return e;
          }
          function kt(e, t, r, n, i, o, a) {
            var s = r.flattenSpans;
            null == s && (s = e.options.flattenSpans);
            var l,
              c = 0,
              u = null,
              d = new Ve(t, e.options.tabSize, n),
              p = e.options.addModeClass && [null];
            for ("" == t && xt(gt(r, n.state), o); !d.eol();) {
              if (d.pos > e.options.maxHighlightLength ? (s = !1, a && ht(e, t, n, d.pos), d.pos = t.length, l = null) : l = xt(yt(r, d, n.state, p), o), p) {
                var f = p[0].name;
                f && (l = "m-" + (l ? f + " " + l : f));
              }
              if (!s || u != l) {
                for (; c < d.start;) {
                  i(c = Math.min(d.start, c + 5e3), u);
                }
                u = l;
              }
              d.start = d.pos;
            }
            for (; c < d.pos;) {
              var m = Math.min(d.pos, c + 5e3);
              i(m, u), c = m;
            }
          }
          var wt = !1,
            _t = !1;
          function St(e, t, r) {
            this.marker = e, this.from = t, this.to = r;
          }
          function Ct(e, t) {
            if (e) for (var r = 0; r < e.length; ++r) {
              var n = e[r];
              if (n.marker == t) return n;
            }
          }
          function Tt(e, t) {
            for (var r, n = 0; n < e.length; ++n) {
              e[n] != t && (r || (r = [])).push(e[n]);
            }
            return r;
          }
          function Mt(e, t) {
            if (t.full) return null;
            var r = Je(e, t.from.line) && Ge(e, t.from.line).markedSpans,
              n = Je(e, t.to.line) && Ge(e, t.to.line).markedSpans;
            if (!r && !n) return null;
            var i = t.from.ch,
              o = t.to.ch,
              a = 0 == rt(t.from, t.to),
              s = function (e, t, r) {
                var n;
                if (e) for (var i = 0; i < e.length; ++i) {
                  var o = e[i],
                    a = o.marker;
                  if (null == o.from || (a.inclusiveLeft ? o.from <= t : o.from < t) || o.from == t && "bookmark" == a.type && (!r || !o.marker.insertLeft)) {
                    var s = null == o.to || (a.inclusiveRight ? o.to >= t : o.to > t);
                    (n || (n = [])).push(new St(a, o.from, s ? null : o.to));
                  }
                }
                return n;
              }(r, i, a),
              l = function (e, t, r) {
                var n;
                if (e) for (var i = 0; i < e.length; ++i) {
                  var o = e[i],
                    a = o.marker;
                  if (null == o.to || (a.inclusiveRight ? o.to >= t : o.to > t) || o.from == t && "bookmark" == a.type && (!r || o.marker.insertLeft)) {
                    var s = null == o.from || (a.inclusiveLeft ? o.from <= t : o.from < t);
                    (n || (n = [])).push(new St(a, s ? null : o.from - t, null == o.to ? null : o.to - t));
                  }
                }
                return n;
              }(n, o, a),
              c = 1 == t.text.length,
              u = Z(t.text).length + (c ? i : 0);
            if (s) for (var d = 0; d < s.length; ++d) {
              var p = s[d];
              if (null == p.to) {
                var f = Ct(l, p.marker);
                f ? c && (p.to = null == f.to ? null : f.to + u) : p.to = i;
              }
            }
            if (l) for (var m = 0; m < l.length; ++m) {
              var h = l[m];
              null != h.to && (h.to += u), null == h.from ? Ct(s, h.marker) || (h.from = u, c && (s || (s = [])).push(h)) : (h.from += u, c && (s || (s = [])).push(h));
            }
            s && (s = Et(s)), l && l != s && (l = Et(l));
            var g = [s];
            if (!c) {
              var y,
                v = t.text.length - 2;
              if (v > 0 && s) for (var b = 0; b < s.length; ++b) {
                null == s[b].to && (y || (y = [])).push(new St(s[b].marker, null, null));
              }
              for (var x = 0; x < v; ++x) {
                g.push(y);
              }
              g.push(l);
            }
            return g;
          }
          function Et(e) {
            for (var t = 0; t < e.length; ++t) {
              var r = e[t];
              null != r.from && r.from == r.to && !1 !== r.marker.clearWhenEmpty && e.splice(t--, 1);
            }
            return e.length ? e : null;
          }
          function Lt(e) {
            var t = e.markedSpans;
            if (t) {
              for (var r = 0; r < t.length; ++r) {
                t[r].marker.detachLine(e);
              }
              e.markedSpans = null;
            }
          }
          function At(e, t) {
            if (t) {
              for (var r = 0; r < t.length; ++r) {
                t[r].marker.attachLine(e);
              }
              e.markedSpans = t;
            }
          }
          function Nt(e) {
            return e.inclusiveLeft ? -1 : 0;
          }
          function zt(e) {
            return e.inclusiveRight ? 1 : 0;
          }
          function Ot(e, t) {
            var r = e.lines.length - t.lines.length;
            if (0 != r) return r;
            var n = e.find(),
              i = t.find(),
              o = rt(n.from, i.from) || Nt(e) - Nt(t);
            if (o) return -o;
            var a = rt(n.to, i.to) || zt(e) - zt(t);
            return a || t.id - e.id;
          }
          function Dt(e, t) {
            var r,
              n = _t && e.markedSpans;
            if (n) for (var i = void 0, o = 0; o < n.length; ++o) {
              (i = n[o]).marker.collapsed && null == (t ? i.from : i.to) && (!r || Ot(r, i.marker) < 0) && (r = i.marker);
            }
            return r;
          }
          function It(e) {
            return Dt(e, !0);
          }
          function Pt(e) {
            return Dt(e, !1);
          }
          function jt(e, t) {
            var r,
              n = _t && e.markedSpans;
            if (n) for (var i = 0; i < n.length; ++i) {
              var o = n[i];
              o.marker.collapsed && (null == o.from || o.from < t) && (null == o.to || o.to > t) && (!r || Ot(r, o.marker) < 0) && (r = o.marker);
            }
            return r;
          }
          function qt(e, t, r, n, i) {
            var o = Ge(e, t),
              a = _t && o.markedSpans;
            if (a) for (var s = 0; s < a.length; ++s) {
              var l = a[s];
              if (l.marker.collapsed) {
                var c = l.marker.find(0),
                  u = rt(c.from, r) || Nt(l.marker) - Nt(i),
                  d = rt(c.to, n) || zt(l.marker) - zt(i);
                if (!(u >= 0 && d <= 0 || u <= 0 && d >= 0) && (u <= 0 && (l.marker.inclusiveRight && i.inclusiveLeft ? rt(c.to, r) >= 0 : rt(c.to, r) > 0) || u >= 0 && (l.marker.inclusiveRight && i.inclusiveLeft ? rt(c.from, n) <= 0 : rt(c.from, n) < 0))) return !0;
              }
            }
          }
          function Ft(e) {
            for (var t; t = It(e);) {
              e = t.find(-1, !0).line;
            }
            return e;
          }
          function Rt(e, t) {
            var r = Ge(e, t),
              n = Ft(r);
            return r == n ? t : Ye(n);
          }
          function Wt(e, t) {
            if (t > e.lastLine()) return t;
            var r,
              n = Ge(e, t);
            if (!$t(e, n)) return t;
            for (; r = Pt(n);) {
              n = r.find(1, !0).line;
            }
            return Ye(n) + 1;
          }
          function $t(e, t) {
            var r = _t && t.markedSpans;
            if (r) for (var n = void 0, i = 0; i < r.length; ++i) {
              if ((n = r[i]).marker.collapsed) {
                if (null == n.from) return !0;
                if (!n.marker.widgetNode && 0 == n.from && n.marker.inclusiveLeft && Ut(e, t, n)) return !0;
              }
            }
          }
          function Ut(e, t, r) {
            if (null == r.to) {
              var n = r.marker.find(1, !0);
              return Ut(e, n.line, Ct(n.line.markedSpans, r.marker));
            }
            if (r.marker.inclusiveRight && r.to == t.text.length) return !0;
            for (var i = void 0, o = 0; o < t.markedSpans.length; ++o) {
              if ((i = t.markedSpans[o]).marker.collapsed && !i.marker.widgetNode && i.from == r.to && (null == i.to || i.to != r.from) && (i.marker.inclusiveLeft || r.marker.inclusiveRight) && Ut(e, t, i)) return !0;
            }
          }
          function Ht(e) {
            for (var t = 0, r = (e = Ft(e)).parent, n = 0; n < r.lines.length; ++n) {
              var i = r.lines[n];
              if (i == e) break;
              t += i.height;
            }
            for (var o = r.parent; o; o = (r = o).parent) {
              for (var a = 0; a < o.children.length; ++a) {
                var s = o.children[a];
                if (s == r) break;
                t += s.height;
              }
            }
            return t;
          }
          function Bt(e) {
            if (0 == e.height) return 0;
            for (var t, r = e.text.length, n = e; t = It(n);) {
              var i = t.find(0, !0);
              n = i.from.line, r += i.from.ch - i.to.ch;
            }
            for (n = e; t = Pt(n);) {
              var o = t.find(0, !0);
              r -= n.text.length - o.from.ch, r += (n = o.to.line).text.length - o.to.ch;
            }
            return r;
          }
          function Vt(e) {
            var t = e.display,
              r = e.doc;
            t.maxLine = Ge(r, r.first), t.maxLineLength = Bt(t.maxLine), t.maxLineChanged = !0, r.iter(function (e) {
              var r = Bt(e);
              r > t.maxLineLength && (t.maxLineLength = r, t.maxLine = e);
            });
          }
          var Gt = function Gt(e, t, r) {
            this.text = e, At(this, t), this.height = r ? r(this) : 1;
          };
          function Kt(e) {
            e.parent = null, Lt(e);
          }
          Gt.prototype.lineNo = function () {
            return Ye(this);
          }, be(Gt);
          var Zt = {},
            Xt = {};
          function Yt(e, t) {
            if (!e || /^\s*$/.test(e)) return null;
            var r = t.addModeClass ? Xt : Zt;
            return r[e] || (r[e] = e.replace(/\S+/g, "cm-$&"));
          }
          function Qt(e, t) {
            var r = N("span", null, null, c ? "padding-right: .1px" : null),
              n = {
                pre: N("pre", [r], "CodeMirror-line"),
                content: r,
                col: 0,
                pos: 0,
                cm: e,
                trailingSpace: !1,
                splitSpaces: e.getOption("lineWrapping")
              };
            t.measure = {};
            for (var i = 0; i <= (t.rest ? t.rest.length : 0); i++) {
              var o = i ? t.rest[i - 1] : t.line,
                a = void 0;
              n.pos = 0, n.addToken = er, Ae(e.display.measure) && (a = ue(o, e.doc.direction)) && (n.addToken = tr(n.addToken, a)), n.map = [], nr(o, n, ft(e, o, t != e.display.externalMeasured && Ye(o))), o.styleClasses && (o.styleClasses.bgClass && (n.bgClass = I(o.styleClasses.bgClass, n.bgClass || "")), o.styleClasses.textClass && (n.textClass = I(o.styleClasses.textClass, n.textClass || ""))), 0 == n.map.length && n.map.push(0, 0, n.content.appendChild(Le(e.display.measure))), 0 == i ? (t.measure.map = n.map, t.measure.cache = {}) : ((t.measure.maps || (t.measure.maps = [])).push(n.map), (t.measure.caches || (t.measure.caches = [])).push({}));
            }
            if (c) {
              var s = n.content.lastChild;
              (/\bcm-tab\b/.test(s.className) || s.querySelector && s.querySelector(".cm-tab")) && (n.content.className = "cm-tab-wrap-hack");
            }
            return he(e, "renderLine", e, t.line, n.pre), n.pre.className && (n.textClass = I(n.pre.className, n.textClass || "")), n;
          }
          function Jt(e) {
            var t = A("span", "•", "cm-invalidchar");
            return t.title = "\\u" + e.charCodeAt(0).toString(16), t.setAttribute("aria-label", t.title), t;
          }
          function er(e, t, r, n, i, o, a) {
            if (t) {
              var c,
                u = e.splitSpaces ? function (e, t) {
                  if (e.length > 1 && !/  /.test(e)) return e;
                  for (var r = t, n = "", i = 0; i < e.length; i++) {
                    var o = e.charAt(i);
                    " " != o || !r || i != e.length - 1 && 32 != e.charCodeAt(i + 1) || (o = " "), n += o, r = " " == o;
                  }
                  return n;
                }(t, e.trailingSpace) : t,
                d = e.cm.state.specialChars,
                p = !1;
              if (d.test(t)) {
                c = document.createDocumentFragment();
                for (var f = 0;;) {
                  d.lastIndex = f;
                  var m = d.exec(t),
                    h = m ? m.index - f : t.length - f;
                  if (h) {
                    var g = document.createTextNode(u.slice(f, f + h));
                    s && l < 9 ? c.appendChild(A("span", [g])) : c.appendChild(g), e.map.push(e.pos, e.pos + h, g), e.col += h, e.pos += h;
                  }
                  if (!m) break;
                  f += h + 1;
                  var y = void 0;
                  if ("\t" == m[0]) {
                    var v = e.cm.options.tabSize,
                      b = v - e.col % v;
                    (y = c.appendChild(A("span", K(b), "cm-tab"))).setAttribute("role", "presentation"), y.setAttribute("cm-text", "\t"), e.col += b;
                  } else "\r" == m[0] || "\n" == m[0] ? ((y = c.appendChild(A("span", "\r" == m[0] ? "␍" : "␤", "cm-invalidchar"))).setAttribute("cm-text", m[0]), e.col += 1) : ((y = e.cm.options.specialCharPlaceholder(m[0])).setAttribute("cm-text", m[0]), s && l < 9 ? c.appendChild(A("span", [y])) : c.appendChild(y), e.col += 1);
                  e.map.push(e.pos, e.pos + 1, y), e.pos++;
                }
              } else e.col += t.length, c = document.createTextNode(u), e.map.push(e.pos, e.pos + t.length, c), s && l < 9 && (p = !0), e.pos += t.length;
              if (e.trailingSpace = 32 == u.charCodeAt(t.length - 1), r || n || i || p || o) {
                var x = r || "";
                n && (x += n), i && (x += i);
                var k = A("span", [c], x, o);
                if (a) for (var w in a) {
                  a.hasOwnProperty(w) && "style" != w && "class" != w && k.setAttribute(w, a[w]);
                }
                return e.content.appendChild(k);
              }
              e.content.appendChild(c);
            }
          }
          function tr(e, t) {
            return function (r, n, i, o, a, s, l) {
              i = i ? i + " cm-force-border" : "cm-force-border";
              for (var c = r.pos, u = c + n.length;;) {
                for (var d = void 0, p = 0; p < t.length && !((d = t[p]).to > c && d.from <= c); p++) {
                  ;
                }
                if (d.to >= u) return e(r, n, i, o, a, s, l);
                e(r, n.slice(0, d.to - c), i, o, null, s, l), o = null, n = n.slice(d.to - c), c = d.to;
              }
            };
          }
          function rr(e, t, r, n) {
            var i = !n && r.widgetNode;
            i && e.map.push(e.pos, e.pos + t, i), !n && e.cm.display.input.needsContentAttribute && (i || (i = e.content.appendChild(document.createElement("span"))), i.setAttribute("cm-marker", r.id)), i && (e.cm.display.input.setUneditable(i), e.content.appendChild(i)), e.pos += t, e.trailingSpace = !1;
          }
          function nr(e, t, r) {
            var n = e.markedSpans,
              i = e.text,
              o = 0;
            if (n) for (var a, s, l, c, u, d, p, f = i.length, m = 0, h = 1, g = "", y = 0;;) {
              if (y == m) {
                l = c = u = s = "", p = null, d = null, y = 1 / 0;
                for (var v = [], b = void 0, x = 0; x < n.length; ++x) {
                  var k = n[x],
                    w = k.marker;
                  if ("bookmark" == w.type && k.from == m && w.widgetNode) v.push(w);else if (k.from <= m && (null == k.to || k.to > m || w.collapsed && k.to == m && k.from == m)) {
                    if (null != k.to && k.to != m && y > k.to && (y = k.to, c = ""), w.className && (l += " " + w.className), w.css && (s = (s ? s + ";" : "") + w.css), w.startStyle && k.from == m && (u += " " + w.startStyle), w.endStyle && k.to == y && (b || (b = [])).push(w.endStyle, k.to), w.title && ((p || (p = {})).title = w.title), w.attributes) for (var _ in w.attributes) {
                      (p || (p = {}))[_] = w.attributes[_];
                    }
                    w.collapsed && (!d || Ot(d.marker, w) < 0) && (d = k);
                  } else k.from > m && y > k.from && (y = k.from);
                }
                if (b) for (var S = 0; S < b.length; S += 2) {
                  b[S + 1] == y && (c += " " + b[S]);
                }
                if (!d || d.from == m) for (var C = 0; C < v.length; ++C) {
                  rr(t, 0, v[C]);
                }
                if (d && (d.from || 0) == m) {
                  if (rr(t, (null == d.to ? f + 1 : d.to) - m, d.marker, null == d.from), null == d.to) return;
                  d.to == m && (d = !1);
                }
              }
              if (m >= f) break;
              for (var T = Math.min(f, y);;) {
                if (g) {
                  var M = m + g.length;
                  if (!d) {
                    var E = M > T ? g.slice(0, T - m) : g;
                    t.addToken(t, E, a ? a + l : l, u, m + E.length == y ? c : "", s, p);
                  }
                  if (M >= T) {
                    g = g.slice(T - m), m = T;
                    break;
                  }
                  m = M, u = "";
                }
                g = i.slice(o, o = r[h++]), a = Yt(r[h++], t.cm.options);
              }
            } else for (var L = 1; L < r.length; L += 2) {
              t.addToken(t, i.slice(o, o = r[L]), Yt(r[L + 1], t.cm.options));
            }
          }
          function ir(e, t, r) {
            this.line = t, this.rest = function (e) {
              for (var t, r; t = Pt(e);) {
                e = t.find(1, !0).line, (r || (r = [])).push(e);
              }
              return r;
            }(t), this.size = this.rest ? Ye(Z(this.rest)) - r + 1 : 1, this.node = this.text = null, this.hidden = $t(e, t);
          }
          function or(e, t, r) {
            for (var n, i = [], o = t; o < r; o = n) {
              var a = new ir(e.doc, Ge(e.doc, o), o);
              n = o + a.size, i.push(a);
            }
            return i;
          }
          var ar = null,
            sr = null;
          function lr(e, t) {
            var r = fe(e, t);
            if (r.length) {
              var n,
                i = Array.prototype.slice.call(arguments, 2);
              ar ? n = ar.delayedCallbacks : sr ? n = sr : (n = sr = [], setTimeout(cr, 0));
              for (var o = function o(e) {
                  n.push(function () {
                    return r[e].apply(null, i);
                  });
                }, a = 0; a < r.length; ++a) {
                o(a);
              }
            }
          }
          function cr() {
            var e = sr;
            sr = null;
            for (var t = 0; t < e.length; ++t) {
              e[t]();
            }
          }
          function ur(e, t, r, n) {
            for (var i = 0; i < t.changes.length; i++) {
              var o = t.changes[i];
              "text" == o ? fr(e, t) : "gutter" == o ? hr(e, t, r, n) : "class" == o ? mr(e, t) : "widget" == o && gr(e, t, n);
            }
            t.changes = null;
          }
          function dr(e) {
            return e.node == e.text && (e.node = A("div", null, null, "position: relative"), e.text.parentNode && e.text.parentNode.replaceChild(e.node, e.text), e.node.appendChild(e.text), s && l < 8 && (e.node.style.zIndex = 2)), e.node;
          }
          function pr(e, t) {
            var r = e.display.externalMeasured;
            return r && r.line == t.line ? (e.display.externalMeasured = null, t.measure = r.measure, r.built) : Qt(e, t);
          }
          function fr(e, t) {
            var r = t.text.className,
              n = pr(e, t);
            t.text == t.node && (t.node = n.pre), t.text.parentNode.replaceChild(n.pre, t.text), t.text = n.pre, n.bgClass != t.bgClass || n.textClass != t.textClass ? (t.bgClass = n.bgClass, t.textClass = n.textClass, mr(e, t)) : r && (t.text.className = r);
          }
          function mr(e, t) {
            !function (e, t) {
              var r = t.bgClass ? t.bgClass + " " + (t.line.bgClass || "") : t.line.bgClass;
              if (r && (r += " CodeMirror-linebackground"), t.background) r ? t.background.className = r : (t.background.parentNode.removeChild(t.background), t.background = null);else if (r) {
                var n = dr(t);
                t.background = n.insertBefore(A("div", null, r), n.firstChild), e.display.input.setUneditable(t.background);
              }
            }(e, t), t.line.wrapClass ? dr(t).className = t.line.wrapClass : t.node != t.text && (t.node.className = "");
            var r = t.textClass ? t.textClass + " " + (t.line.textClass || "") : t.line.textClass;
            t.text.className = r || "";
          }
          function hr(e, t, r, n) {
            if (t.gutter && (t.node.removeChild(t.gutter), t.gutter = null), t.gutterBackground && (t.node.removeChild(t.gutterBackground), t.gutterBackground = null), t.line.gutterClass) {
              var i = dr(t);
              t.gutterBackground = A("div", null, "CodeMirror-gutter-background " + t.line.gutterClass, "left: " + (e.options.fixedGutter ? n.fixedPos : -n.gutterTotalWidth) + "px; width: " + n.gutterTotalWidth + "px"), e.display.input.setUneditable(t.gutterBackground), i.insertBefore(t.gutterBackground, t.text);
            }
            var o = t.line.gutterMarkers;
            if (e.options.lineNumbers || o) {
              var a = dr(t),
                s = t.gutter = A("div", null, "CodeMirror-gutter-wrapper", "left: " + (e.options.fixedGutter ? n.fixedPos : -n.gutterTotalWidth) + "px");
              if (e.display.input.setUneditable(s), a.insertBefore(s, t.text), t.line.gutterClass && (s.className += " " + t.line.gutterClass), !e.options.lineNumbers || o && o["CodeMirror-linenumbers"] || (t.lineNumber = s.appendChild(A("div", et(e.options, r), "CodeMirror-linenumber CodeMirror-gutter-elt", "left: " + n.gutterLeft["CodeMirror-linenumbers"] + "px; width: " + e.display.lineNumInnerWidth + "px"))), o) for (var l = 0; l < e.display.gutterSpecs.length; ++l) {
                var c = e.display.gutterSpecs[l].className,
                  u = o.hasOwnProperty(c) && o[c];
                u && s.appendChild(A("div", [u], "CodeMirror-gutter-elt", "left: " + n.gutterLeft[c] + "px; width: " + n.gutterWidth[c] + "px"));
              }
            }
          }
          function gr(e, t, r) {
            t.alignable && (t.alignable = null);
            for (var n = C("CodeMirror-linewidget"), i = t.node.firstChild, o = void 0; i; i = o) {
              o = i.nextSibling, n.test(i.className) && t.node.removeChild(i);
            }
            vr(e, t, r);
          }
          function yr(e, t, r, n) {
            var i = pr(e, t);
            return t.text = t.node = i.pre, i.bgClass && (t.bgClass = i.bgClass), i.textClass && (t.textClass = i.textClass), mr(e, t), hr(e, t, r, n), vr(e, t, n), t.node;
          }
          function vr(e, t, r) {
            if (br(e, t.line, t, r, !0), t.rest) for (var n = 0; n < t.rest.length; n++) {
              br(e, t.rest[n], t, r, !1);
            }
          }
          function br(e, t, r, n, i) {
            if (t.widgets) for (var o = dr(r), a = 0, s = t.widgets; a < s.length; ++a) {
              var l = s[a],
                c = A("div", [l.node], "CodeMirror-linewidget" + (l.className ? " " + l.className : ""));
              l.handleMouseEvents || c.setAttribute("cm-ignore-events", "true"), xr(l, c, r, n), e.display.input.setUneditable(c), i && l.above ? o.insertBefore(c, r.gutter || r.text) : o.appendChild(c), lr(l, "redraw");
            }
          }
          function xr(e, t, r, n) {
            if (e.noHScroll) {
              (r.alignable || (r.alignable = [])).push(t);
              var i = n.wrapperWidth;
              t.style.left = n.fixedPos + "px", e.coverGutter || (i -= n.gutterTotalWidth, t.style.paddingLeft = n.gutterTotalWidth + "px"), t.style.width = i + "px";
            }
            e.coverGutter && (t.style.zIndex = 5, t.style.position = "relative", e.noHScroll || (t.style.marginLeft = -n.gutterTotalWidth + "px"));
          }
          function kr(e) {
            if (null != e.height) return e.height;
            var t = e.doc.cm;
            if (!t) return 0;
            if (!z(document.body, e.node)) {
              var r = "position: relative;";
              e.coverGutter && (r += "margin-left: -" + t.display.gutters.offsetWidth + "px;"), e.noHScroll && (r += "width: " + t.display.wrapper.clientWidth + "px;"), L(t.display.measure, A("div", [e.node], null, r));
            }
            return e.height = e.node.parentNode.offsetHeight;
          }
          function wr(e, t) {
            for (var r = Se(t); r != e.wrapper; r = r.parentNode) {
              if (!r || 1 == r.nodeType && "true" == r.getAttribute("cm-ignore-events") || r.parentNode == e.sizer && r != e.mover) return !0;
            }
          }
          function _r(e) {
            return e.lineSpace.offsetTop;
          }
          function Sr(e) {
            return e.mover.offsetHeight - e.lineSpace.offsetHeight;
          }
          function Cr(e) {
            if (e.cachedPaddingH) return e.cachedPaddingH;
            var t = L(e.measure, A("pre", "x", "CodeMirror-line-like")),
              r = window.getComputedStyle ? window.getComputedStyle(t) : t.currentStyle,
              n = {
                left: parseInt(r.paddingLeft),
                right: parseInt(r.paddingRight)
              };
            return isNaN(n.left) || isNaN(n.right) || (e.cachedPaddingH = n), n;
          }
          function Tr(e) {
            return 50 - e.display.nativeBarWidth;
          }
          function Mr(e) {
            return e.display.scroller.clientWidth - Tr(e) - e.display.barWidth;
          }
          function Er(e) {
            return e.display.scroller.clientHeight - Tr(e) - e.display.barHeight;
          }
          function Lr(e, t, r) {
            if (e.line == t) return {
              map: e.measure.map,
              cache: e.measure.cache
            };
            for (var n = 0; n < e.rest.length; n++) {
              if (e.rest[n] == t) return {
                map: e.measure.maps[n],
                cache: e.measure.caches[n]
              };
            }
            for (var i = 0; i < e.rest.length; i++) {
              if (Ye(e.rest[i]) > r) return {
                map: e.measure.maps[i],
                cache: e.measure.caches[i],
                before: !0
              };
            }
          }
          function Ar(e, t, r, n) {
            return Or(e, zr(e, t), r, n);
          }
          function Nr(e, t) {
            if (t >= e.display.viewFrom && t < e.display.viewTo) return e.display.view[dn(e, t)];
            var r = e.display.externalMeasured;
            return r && t >= r.lineN && t < r.lineN + r.size ? r : void 0;
          }
          function zr(e, t) {
            var r = Ye(t),
              n = Nr(e, r);
            n && !n.text ? n = null : n && n.changes && (ur(e, n, r, an(e)), e.curOp.forceUpdate = !0), n || (n = function (e, t) {
              var r = Ye(t = Ft(t)),
                n = e.display.externalMeasured = new ir(e.doc, t, r);
              n.lineN = r;
              var i = n.built = Qt(e, n);
              return n.text = i.pre, L(e.display.lineMeasure, i.pre), n;
            }(e, t));
            var i = Lr(n, t, r);
            return {
              line: t,
              view: n,
              rect: null,
              map: i.map,
              cache: i.cache,
              before: i.before,
              hasHeights: !1
            };
          }
          function Or(e, t, r, n, i) {
            t.before && (r = -1);
            var o,
              a = r + (n || "");
            return t.cache.hasOwnProperty(a) ? o = t.cache[a] : (t.rect || (t.rect = t.view.text.getBoundingClientRect()), t.hasHeights || (function (e, t, r) {
              var n = e.options.lineWrapping,
                i = n && Mr(e);
              if (!t.measure.heights || n && t.measure.width != i) {
                var o = t.measure.heights = [];
                if (n) {
                  t.measure.width = i;
                  for (var a = t.text.firstChild.getClientRects(), s = 0; s < a.length - 1; s++) {
                    var l = a[s],
                      c = a[s + 1];
                    Math.abs(l.bottom - c.bottom) > 2 && o.push((l.bottom + c.top) / 2 - r.top);
                  }
                }
                o.push(r.bottom - r.top);
              }
            }(e, t.view, t.rect), t.hasHeights = !0), o = function (e, t, r, n) {
              var i,
                o = Pr(t.map, r, n),
                a = o.node,
                c = o.start,
                u = o.end,
                d = o.collapse;
              if (3 == a.nodeType) {
                for (var p = 0; p < 4; p++) {
                  for (; c && ie(t.line.text.charAt(o.coverStart + c));) {
                    --c;
                  }
                  for (; o.coverStart + u < o.coverEnd && ie(t.line.text.charAt(o.coverStart + u));) {
                    ++u;
                  }
                  if ((i = s && l < 9 && 0 == c && u == o.coverEnd - o.coverStart ? a.parentNode.getBoundingClientRect() : jr(T(a, c, u).getClientRects(), n)).left || i.right || 0 == c) break;
                  u = c, c -= 1, d = "right";
                }
                s && l < 11 && (i = function (e, t) {
                  if (!window.screen || null == screen.logicalXDPI || screen.logicalXDPI == screen.deviceXDPI || !function (e) {
                    if (null != Ie) return Ie;
                    var t = L(e, A("span", "x")),
                      r = t.getBoundingClientRect(),
                      n = T(t, 0, 1).getBoundingClientRect();
                    return Ie = Math.abs(r.left - n.left) > 1;
                  }(e)) return t;
                  var r = screen.logicalXDPI / screen.deviceXDPI,
                    n = screen.logicalYDPI / screen.deviceYDPI;
                  return {
                    left: t.left * r,
                    right: t.right * r,
                    top: t.top * n,
                    bottom: t.bottom * n
                  };
                }(e.display.measure, i));
              } else {
                var f;
                c > 0 && (d = n = "right"), i = e.options.lineWrapping && (f = a.getClientRects()).length > 1 ? f["right" == n ? f.length - 1 : 0] : a.getBoundingClientRect();
              }
              if (s && l < 9 && !c && (!i || !i.left && !i.right)) {
                var m = a.parentNode.getClientRects()[0];
                i = m ? {
                  left: m.left,
                  right: m.left + on(e.display),
                  top: m.top,
                  bottom: m.bottom
                } : Ir;
              }
              for (var h = i.top - t.rect.top, g = i.bottom - t.rect.top, y = (h + g) / 2, v = t.view.measure.heights, b = 0; b < v.length - 1 && !(y < v[b]); b++) {
                ;
              }
              var x = b ? v[b - 1] : 0,
                k = v[b],
                w = {
                  left: ("right" == d ? i.right : i.left) - t.rect.left,
                  right: ("left" == d ? i.left : i.right) - t.rect.left,
                  top: x,
                  bottom: k
                };
              return i.left || i.right || (w.bogus = !0), e.options.singleCursorHeightPerLine || (w.rtop = h, w.rbottom = g), w;
            }(e, t, r, n), o.bogus || (t.cache[a] = o)), {
              left: o.left,
              right: o.right,
              top: i ? o.rtop : o.top,
              bottom: i ? o.rbottom : o.bottom
            };
          }
          var Dr,
            Ir = {
              left: 0,
              right: 0,
              top: 0,
              bottom: 0
            };
          function Pr(e, t, r) {
            for (var n, i, o, a, s, l, c = 0; c < e.length; c += 3) {
              if (s = e[c], l = e[c + 1], t < s ? (i = 0, o = 1, a = "left") : t < l ? o = 1 + (i = t - s) : (c == e.length - 3 || t == l && e[c + 3] > t) && (i = (o = l - s) - 1, t >= l && (a = "right")), null != i) {
                if (n = e[c + 2], s == l && r == (n.insertLeft ? "left" : "right") && (a = r), "left" == r && 0 == i) for (; c && e[c - 2] == e[c - 3] && e[c - 1].insertLeft;) {
                  n = e[2 + (c -= 3)], a = "left";
                }
                if ("right" == r && i == l - s) for (; c < e.length - 3 && e[c + 3] == e[c + 4] && !e[c + 5].insertLeft;) {
                  n = e[(c += 3) + 2], a = "right";
                }
                break;
              }
            }
            return {
              node: n,
              start: i,
              end: o,
              collapse: a,
              coverStart: s,
              coverEnd: l
            };
          }
          function jr(e, t) {
            var r = Ir;
            if ("left" == t) for (var n = 0; n < e.length && (r = e[n]).left == r.right; n++) {
              ;
            } else for (var i = e.length - 1; i >= 0 && (r = e[i]).left == r.right; i--) {
              ;
            }
            return r;
          }
          function qr(e) {
            if (e.measure && (e.measure.cache = {}, e.measure.heights = null, e.rest)) for (var t = 0; t < e.rest.length; t++) {
              e.measure.caches[t] = {};
            }
          }
          function Fr(e) {
            e.display.externalMeasure = null, E(e.display.lineMeasure);
            for (var t = 0; t < e.display.view.length; t++) {
              qr(e.display.view[t]);
            }
          }
          function Rr(e) {
            Fr(e), e.display.cachedCharWidth = e.display.cachedTextHeight = e.display.cachedPaddingH = null, e.options.lineWrapping || (e.display.maxLineChanged = !0), e.display.lineNumChars = null;
          }
          function Wr() {
            return d && y ? -(document.body.getBoundingClientRect().left - parseInt(getComputedStyle(document.body).marginLeft)) : window.pageXOffset || (document.documentElement || document.body).scrollLeft;
          }
          function $r() {
            return d && y ? -(document.body.getBoundingClientRect().top - parseInt(getComputedStyle(document.body).marginTop)) : window.pageYOffset || (document.documentElement || document.body).scrollTop;
          }
          function Ur(e) {
            var t = 0;
            if (e.widgets) for (var r = 0; r < e.widgets.length; ++r) {
              e.widgets[r].above && (t += kr(e.widgets[r]));
            }
            return t;
          }
          function Hr(e, t, r, n, i) {
            if (!i) {
              var o = Ur(t);
              r.top += o, r.bottom += o;
            }
            if ("line" == n) return r;
            n || (n = "local");
            var a = Ht(t);
            if ("local" == n ? a += _r(e.display) : a -= e.display.viewOffset, "page" == n || "window" == n) {
              var s = e.display.lineSpace.getBoundingClientRect();
              a += s.top + ("window" == n ? 0 : $r());
              var l = s.left + ("window" == n ? 0 : Wr());
              r.left += l, r.right += l;
            }
            return r.top += a, r.bottom += a, r;
          }
          function Br(e, t, r) {
            if ("div" == r) return t;
            var n = t.left,
              i = t.top;
            if ("page" == r) n -= Wr(), i -= $r();else if ("local" == r || !r) {
              var o = e.display.sizer.getBoundingClientRect();
              n += o.left, i += o.top;
            }
            var a = e.display.lineSpace.getBoundingClientRect();
            return {
              left: n - a.left,
              top: i - a.top
            };
          }
          function Vr(e, t, r, n, i) {
            return n || (n = Ge(e.doc, t.line)), Hr(e, n, Ar(e, n, t.ch, i), r);
          }
          function Gr(e, t, r, n, i, o) {
            function a(t, a) {
              var s = Or(e, i, t, a ? "right" : "left", o);
              return a ? s.left = s.right : s.right = s.left, Hr(e, n, s, r);
            }
            n = n || Ge(e.doc, t.line), i || (i = zr(e, n));
            var s = ue(n, e.doc.direction),
              l = t.ch,
              c = t.sticky;
            if (l >= n.text.length ? (l = n.text.length, c = "before") : l <= 0 && (l = 0, c = "after"), !s) return a("before" == c ? l - 1 : l, "before" == c);
            function u(e, t, r) {
              return a(r ? e - 1 : e, 1 == s[t].level != r);
            }
            var d = le(s, l, c),
              p = se,
              f = u(l, d, "before" == c);
            return null != p && (f.other = u(l, p, "before" != c)), f;
          }
          function Kr(e, t) {
            var r = 0;
            t = lt(e.doc, t), e.options.lineWrapping || (r = on(e.display) * t.ch);
            var n = Ge(e.doc, t.line),
              i = Ht(n) + _r(e.display);
            return {
              left: r,
              right: r,
              top: i,
              bottom: i + n.height
            };
          }
          function Zr(e, t, r, n, i) {
            var o = tt(e, t, r);
            return o.xRel = i, n && (o.outside = n), o;
          }
          function Xr(e, t, r) {
            var n = e.doc;
            if ((r += e.display.viewOffset) < 0) return Zr(n.first, 0, null, -1, -1);
            var i = Qe(n, r),
              o = n.first + n.size - 1;
            if (i > o) return Zr(n.first + n.size - 1, Ge(n, o).text.length, null, 1, 1);
            t < 0 && (t = 0);
            for (var a = Ge(n, i);;) {
              var s = en(e, a, i, t, r),
                l = jt(a, s.ch + (s.xRel > 0 || s.outside > 0 ? 1 : 0));
              if (!l) return s;
              var c = l.find(1);
              if (c.line == i) return c;
              a = Ge(n, i = c.line);
            }
          }
          function Yr(e, t, r, n) {
            n -= Ur(t);
            var i = t.text.length,
              o = ae(function (t) {
                return Or(e, r, t - 1).bottom <= n;
              }, i, 0);
            return {
              begin: o,
              end: i = ae(function (t) {
                return Or(e, r, t).top > n;
              }, o, i)
            };
          }
          function Qr(e, t, r, n) {
            return r || (r = zr(e, t)), Yr(e, t, r, Hr(e, t, Or(e, r, n), "line").top);
          }
          function Jr(e, t, r, n) {
            return !(e.bottom <= r) && (e.top > r || (n ? e.left : e.right) > t);
          }
          function en(e, t, r, n, i) {
            i -= Ht(t);
            var o = zr(e, t),
              a = Ur(t),
              s = 0,
              l = t.text.length,
              c = !0,
              u = ue(t, e.doc.direction);
            if (u) {
              var d = (e.options.lineWrapping ? rn : tn)(e, t, r, o, u, n, i);
              s = (c = 1 != d.level) ? d.from : d.to - 1, l = c ? d.to : d.from - 1;
            }
            var p,
              f,
              m = null,
              h = null,
              g = ae(function (t) {
                var r = Or(e, o, t);
                return r.top += a, r.bottom += a, !!Jr(r, n, i, !1) && (r.top <= i && r.left <= n && (m = t, h = r), !0);
              }, s, l),
              y = !1;
            if (h) {
              var v = n - h.left < h.right - n,
                b = v == c;
              g = m + (b ? 0 : 1), f = b ? "after" : "before", p = v ? h.left : h.right;
            } else {
              c || g != l && g != s || g++, f = 0 == g ? "after" : g == t.text.length ? "before" : Or(e, o, g - (c ? 1 : 0)).bottom + a <= i == c ? "after" : "before";
              var x = Gr(e, tt(r, g, f), "line", t, o);
              p = x.left, y = i < x.top ? -1 : i >= x.bottom ? 1 : 0;
            }
            return Zr(r, g = oe(t.text, g, 1), f, y, n - p);
          }
          function tn(e, t, r, n, i, o, a) {
            var s = ae(function (s) {
                var l = i[s],
                  c = 1 != l.level;
                return Jr(Gr(e, tt(r, c ? l.to : l.from, c ? "before" : "after"), "line", t, n), o, a, !0);
              }, 0, i.length - 1),
              l = i[s];
            if (s > 0) {
              var c = 1 != l.level,
                u = Gr(e, tt(r, c ? l.from : l.to, c ? "after" : "before"), "line", t, n);
              Jr(u, o, a, !0) && u.top > a && (l = i[s - 1]);
            }
            return l;
          }
          function rn(e, t, r, n, i, o, a) {
            var s = Yr(e, t, n, a),
              l = s.begin,
              c = s.end;
            /\s/.test(t.text.charAt(c - 1)) && c--;
            for (var u = null, d = null, p = 0; p < i.length; p++) {
              var f = i[p];
              if (!(f.from >= c || f.to <= l)) {
                var m = Or(e, n, 1 != f.level ? Math.min(c, f.to) - 1 : Math.max(l, f.from)).right,
                  h = m < o ? o - m + 1e9 : m - o;
                (!u || d > h) && (u = f, d = h);
              }
            }
            return u || (u = i[i.length - 1]), u.from < l && (u = {
              from: l,
              to: u.to,
              level: u.level
            }), u.to > c && (u = {
              from: u.from,
              to: c,
              level: u.level
            }), u;
          }
          function nn(e) {
            if (null != e.cachedTextHeight) return e.cachedTextHeight;
            if (null == Dr) {
              Dr = A("pre", null, "CodeMirror-line-like");
              for (var t = 0; t < 49; ++t) {
                Dr.appendChild(document.createTextNode("x")), Dr.appendChild(A("br"));
              }
              Dr.appendChild(document.createTextNode("x"));
            }
            L(e.measure, Dr);
            var r = Dr.offsetHeight / 50;
            return r > 3 && (e.cachedTextHeight = r), E(e.measure), r || 1;
          }
          function on(e) {
            if (null != e.cachedCharWidth) return e.cachedCharWidth;
            var t = A("span", "xxxxxxxxxx"),
              r = A("pre", [t], "CodeMirror-line-like");
            L(e.measure, r);
            var n = t.getBoundingClientRect(),
              i = (n.right - n.left) / 10;
            return i > 2 && (e.cachedCharWidth = i), i || 10;
          }
          function an(e) {
            for (var t = e.display, r = {}, n = {}, i = t.gutters.clientLeft, o = t.gutters.firstChild, a = 0; o; o = o.nextSibling, ++a) {
              var s = e.display.gutterSpecs[a].className;
              r[s] = o.offsetLeft + o.clientLeft + i, n[s] = o.clientWidth;
            }
            return {
              fixedPos: sn(t),
              gutterTotalWidth: t.gutters.offsetWidth,
              gutterLeft: r,
              gutterWidth: n,
              wrapperWidth: t.wrapper.clientWidth
            };
          }
          function sn(e) {
            return e.scroller.getBoundingClientRect().left - e.sizer.getBoundingClientRect().left;
          }
          function ln(e) {
            var t = nn(e.display),
              r = e.options.lineWrapping,
              n = r && Math.max(5, e.display.scroller.clientWidth / on(e.display) - 3);
            return function (i) {
              if ($t(e.doc, i)) return 0;
              var o = 0;
              if (i.widgets) for (var a = 0; a < i.widgets.length; a++) {
                i.widgets[a].height && (o += i.widgets[a].height);
              }
              return r ? o + (Math.ceil(i.text.length / n) || 1) * t : o + t;
            };
          }
          function cn(e) {
            var t = e.doc,
              r = ln(e);
            t.iter(function (e) {
              var t = r(e);
              t != e.height && Xe(e, t);
            });
          }
          function un(e, t, r, n) {
            var i = e.display;
            if (!r && "true" == Se(t).getAttribute("cm-not-content")) return null;
            var o,
              a,
              s = i.lineSpace.getBoundingClientRect();
            try {
              o = t.clientX - s.left, a = t.clientY - s.top;
            } catch (t) {
              return null;
            }
            var l,
              c = Xr(e, o, a);
            if (n && c.xRel > 0 && (l = Ge(e.doc, c.line).text).length == c.ch) {
              var u = F(l, l.length, e.options.tabSize) - l.length;
              c = tt(c.line, Math.max(0, Math.round((o - Cr(e.display).left) / on(e.display)) - u));
            }
            return c;
          }
          function dn(e, t) {
            if (t >= e.display.viewTo) return null;
            if ((t -= e.display.viewFrom) < 0) return null;
            for (var r = e.display.view, n = 0; n < r.length; n++) {
              if ((t -= r[n].size) < 0) return n;
            }
          }
          function pn(e, t, r, n) {
            null == t && (t = e.doc.first), null == r && (r = e.doc.first + e.doc.size), n || (n = 0);
            var i = e.display;
            if (n && r < i.viewTo && (null == i.updateLineNumbers || i.updateLineNumbers > t) && (i.updateLineNumbers = t), e.curOp.viewChanged = !0, t >= i.viewTo) _t && Rt(e.doc, t) < i.viewTo && mn(e);else if (r <= i.viewFrom) _t && Wt(e.doc, r + n) > i.viewFrom ? mn(e) : (i.viewFrom += n, i.viewTo += n);else if (t <= i.viewFrom && r >= i.viewTo) mn(e);else if (t <= i.viewFrom) {
              var o = hn(e, r, r + n, 1);
              o ? (i.view = i.view.slice(o.index), i.viewFrom = o.lineN, i.viewTo += n) : mn(e);
            } else if (r >= i.viewTo) {
              var a = hn(e, t, t, -1);
              a ? (i.view = i.view.slice(0, a.index), i.viewTo = a.lineN) : mn(e);
            } else {
              var s = hn(e, t, t, -1),
                l = hn(e, r, r + n, 1);
              s && l ? (i.view = i.view.slice(0, s.index).concat(or(e, s.lineN, l.lineN)).concat(i.view.slice(l.index)), i.viewTo += n) : mn(e);
            }
            var c = i.externalMeasured;
            c && (r < c.lineN ? c.lineN += n : t < c.lineN + c.size && (i.externalMeasured = null));
          }
          function fn(e, t, r) {
            e.curOp.viewChanged = !0;
            var n = e.display,
              i = e.display.externalMeasured;
            if (i && t >= i.lineN && t < i.lineN + i.size && (n.externalMeasured = null), !(t < n.viewFrom || t >= n.viewTo)) {
              var o = n.view[dn(e, t)];
              if (null != o.node) {
                var a = o.changes || (o.changes = []);
                -1 == W(a, r) && a.push(r);
              }
            }
          }
          function mn(e) {
            e.display.viewFrom = e.display.viewTo = e.doc.first, e.display.view = [], e.display.viewOffset = 0;
          }
          function hn(e, t, r, n) {
            var i,
              o = dn(e, t),
              a = e.display.view;
            if (!_t || r == e.doc.first + e.doc.size) return {
              index: o,
              lineN: r
            };
            for (var s = e.display.viewFrom, l = 0; l < o; l++) {
              s += a[l].size;
            }
            if (s != t) {
              if (n > 0) {
                if (o == a.length - 1) return null;
                i = s + a[o].size - t, o++;
              } else i = s - t;
              t += i, r += i;
            }
            for (; Rt(e.doc, r) != r;) {
              if (o == (n < 0 ? 0 : a.length - 1)) return null;
              r += n * a[o - (n < 0 ? 1 : 0)].size, o += n;
            }
            return {
              index: o,
              lineN: r
            };
          }
          function gn(e) {
            for (var t = e.display.view, r = 0, n = 0; n < t.length; n++) {
              var i = t[n];
              i.hidden || i.node && !i.changes || ++r;
            }
            return r;
          }
          function yn(e) {
            e.display.input.showSelection(e.display.input.prepareSelection());
          }
          function vn(e, t) {
            void 0 === t && (t = !0);
            for (var r = e.doc, n = {}, i = n.cursors = document.createDocumentFragment(), o = n.selection = document.createDocumentFragment(), a = 0; a < r.sel.ranges.length; a++) {
              if (t || a != r.sel.primIndex) {
                var s = r.sel.ranges[a];
                if (!(s.from().line >= e.display.viewTo || s.to().line < e.display.viewFrom)) {
                  var l = s.empty();
                  (l || e.options.showCursorWhenSelecting) && bn(e, s.head, i), l || kn(e, s, o);
                }
              }
            }
            return n;
          }
          function bn(e, t, r) {
            var n = Gr(e, t, "div", null, null, !e.options.singleCursorHeightPerLine),
              i = r.appendChild(A("div", " ", "CodeMirror-cursor"));
            if (i.style.left = n.left + "px", i.style.top = n.top + "px", i.style.height = Math.max(0, n.bottom - n.top) * e.options.cursorHeight + "px", n.other) {
              var o = r.appendChild(A("div", " ", "CodeMirror-cursor CodeMirror-secondarycursor"));
              o.style.display = "", o.style.left = n.other.left + "px", o.style.top = n.other.top + "px", o.style.height = .85 * (n.other.bottom - n.other.top) + "px";
            }
          }
          function xn(e, t) {
            return e.top - t.top || e.left - t.left;
          }
          function kn(e, t, r) {
            var n = e.display,
              i = e.doc,
              o = document.createDocumentFragment(),
              a = Cr(e.display),
              s = a.left,
              l = Math.max(n.sizerWidth, Mr(e) - n.sizer.offsetLeft) - a.right,
              c = "ltr" == i.direction;
            function u(e, t, r, n) {
              t < 0 && (t = 0), t = Math.round(t), n = Math.round(n), o.appendChild(A("div", null, "CodeMirror-selected", "position: absolute; left: " + e + "px;\n                             top: " + t + "px; width: " + (null == r ? l - e : r) + "px;\n                             height: " + (n - t) + "px"));
            }
            function d(t, r, n) {
              var o,
                a,
                d = Ge(i, t),
                p = d.text.length;
              function f(r, n) {
                return Vr(e, tt(t, r), "div", d, n);
              }
              function m(t, r, n) {
                var i = Qr(e, d, null, t),
                  o = "ltr" == r == ("after" == n) ? "left" : "right";
                return f("after" == n ? i.begin : i.end - (/\s/.test(d.text.charAt(i.end - 1)) ? 2 : 1), o)[o];
              }
              var h = ue(d, i.direction);
              return function (e, t, r, n) {
                if (!e) return n(t, r, "ltr", 0);
                for (var i = !1, o = 0; o < e.length; ++o) {
                  var a = e[o];
                  (a.from < r && a.to > t || t == r && a.to == t) && (n(Math.max(a.from, t), Math.min(a.to, r), 1 == a.level ? "rtl" : "ltr", o), i = !0);
                }
                i || n(t, r, "ltr");
              }(h, r || 0, null == n ? p : n, function (e, t, i, d) {
                var g = "ltr" == i,
                  y = f(e, g ? "left" : "right"),
                  v = f(t - 1, g ? "right" : "left"),
                  b = null == r && 0 == e,
                  x = null == n && t == p,
                  k = 0 == d,
                  w = !h || d == h.length - 1;
                if (v.top - y.top <= 3) {
                  var _ = (c ? x : b) && w,
                    S = (c ? b : x) && k ? s : (g ? y : v).left,
                    C = _ ? l : (g ? v : y).right;
                  u(S, y.top, C - S, y.bottom);
                } else {
                  var T, M, E, L;
                  g ? (T = c && b && k ? s : y.left, M = c ? l : m(e, i, "before"), E = c ? s : m(t, i, "after"), L = c && x && w ? l : v.right) : (T = c ? m(e, i, "before") : s, M = !c && b && k ? l : y.right, E = !c && x && w ? s : v.left, L = c ? m(t, i, "after") : l), u(T, y.top, M - T, y.bottom), y.bottom < v.top && u(s, y.bottom, null, v.top), u(E, v.top, L - E, v.bottom);
                }
                (!o || xn(y, o) < 0) && (o = y), xn(v, o) < 0 && (o = v), (!a || xn(y, a) < 0) && (a = y), xn(v, a) < 0 && (a = v);
              }), {
                start: o,
                end: a
              };
            }
            var p = t.from(),
              f = t.to();
            if (p.line == f.line) d(p.line, p.ch, f.ch);else {
              var m = Ge(i, p.line),
                h = Ge(i, f.line),
                g = Ft(m) == Ft(h),
                y = d(p.line, p.ch, g ? m.text.length + 1 : null).end,
                v = d(f.line, g ? 0 : null, f.ch).start;
              g && (y.top < v.top - 2 ? (u(y.right, y.top, null, y.bottom), u(s, v.top, v.left, v.bottom)) : u(y.right, y.top, v.left - y.right, y.bottom)), y.bottom < v.top && u(s, y.bottom, null, v.top);
            }
            r.appendChild(o);
          }
          function wn(e) {
            if (e.state.focused) {
              var t = e.display;
              clearInterval(t.blinker);
              var r = !0;
              t.cursorDiv.style.visibility = "", e.options.cursorBlinkRate > 0 ? t.blinker = setInterval(function () {
                return t.cursorDiv.style.visibility = (r = !r) ? "" : "hidden";
              }, e.options.cursorBlinkRate) : e.options.cursorBlinkRate < 0 && (t.cursorDiv.style.visibility = "hidden");
            }
          }
          function _n(e) {
            e.state.focused || (e.display.input.focus(), Cn(e));
          }
          function Sn(e) {
            e.state.delayingBlurEvent = !0, setTimeout(function () {
              e.state.delayingBlurEvent && (e.state.delayingBlurEvent = !1, Tn(e));
            }, 100);
          }
          function Cn(e, t) {
            e.state.delayingBlurEvent && (e.state.delayingBlurEvent = !1), "nocursor" != e.options.readOnly && (e.state.focused || (he(e, "focus", e, t), e.state.focused = !0, D(e.display.wrapper, "CodeMirror-focused"), e.curOp || e.display.selForContextMenu == e.doc.sel || (e.display.input.reset(), c && setTimeout(function () {
              return e.display.input.reset(!0);
            }, 20)), e.display.input.receivedFocus()), wn(e));
          }
          function Tn(e, t) {
            e.state.delayingBlurEvent || (e.state.focused && (he(e, "blur", e, t), e.state.focused = !1, M(e.display.wrapper, "CodeMirror-focused")), clearInterval(e.display.blinker), setTimeout(function () {
              e.state.focused || (e.display.shift = !1);
            }, 150));
          }
          function Mn(e) {
            for (var t = e.display, r = t.lineDiv.offsetTop, n = 0; n < t.view.length; n++) {
              var i = t.view[n],
                o = e.options.lineWrapping,
                a = void 0,
                c = 0;
              if (!i.hidden) {
                if (s && l < 8) {
                  var u = i.node.offsetTop + i.node.offsetHeight;
                  a = u - r, r = u;
                } else {
                  var d = i.node.getBoundingClientRect();
                  a = d.bottom - d.top, !o && i.text.firstChild && (c = i.text.firstChild.getBoundingClientRect().right - d.left - 1);
                }
                var p = i.line.height - a;
                if ((p > .005 || p < -.005) && (Xe(i.line, a), En(i.line), i.rest)) for (var f = 0; f < i.rest.length; f++) {
                  En(i.rest[f]);
                }
                if (c > e.display.sizerWidth) {
                  var m = Math.ceil(c / on(e.display));
                  m > e.display.maxLineLength && (e.display.maxLineLength = m, e.display.maxLine = i.line, e.display.maxLineChanged = !0);
                }
              }
            }
          }
          function En(e) {
            if (e.widgets) for (var t = 0; t < e.widgets.length; ++t) {
              var r = e.widgets[t],
                n = r.node.parentNode;
              n && (r.height = n.offsetHeight);
            }
          }
          function Ln(e, t, r) {
            var n = r && null != r.top ? Math.max(0, r.top) : e.scroller.scrollTop;
            n = Math.floor(n - _r(e));
            var i = r && null != r.bottom ? r.bottom : n + e.wrapper.clientHeight,
              o = Qe(t, n),
              a = Qe(t, i);
            if (r && r.ensure) {
              var s = r.ensure.from.line,
                l = r.ensure.to.line;
              s < o ? (o = s, a = Qe(t, Ht(Ge(t, s)) + e.wrapper.clientHeight)) : Math.min(l, t.lastLine()) >= a && (o = Qe(t, Ht(Ge(t, l)) - e.wrapper.clientHeight), a = l);
            }
            return {
              from: o,
              to: Math.max(a, o + 1)
            };
          }
          function An(e, t) {
            var r = e.display,
              n = nn(e.display);
            t.top < 0 && (t.top = 0);
            var i = e.curOp && null != e.curOp.scrollTop ? e.curOp.scrollTop : r.scroller.scrollTop,
              o = Er(e),
              a = {};
            t.bottom - t.top > o && (t.bottom = t.top + o);
            var s = e.doc.height + Sr(r),
              l = t.top < n,
              c = t.bottom > s - n;
            if (t.top < i) a.scrollTop = l ? 0 : t.top;else if (t.bottom > i + o) {
              var u = Math.min(t.top, (c ? s : t.bottom) - o);
              u != i && (a.scrollTop = u);
            }
            var d = e.curOp && null != e.curOp.scrollLeft ? e.curOp.scrollLeft : r.scroller.scrollLeft,
              p = Mr(e) - (e.options.fixedGutter ? r.gutters.offsetWidth : 0),
              f = t.right - t.left > p;
            return f && (t.right = t.left + p), t.left < 10 ? a.scrollLeft = 0 : t.left < d ? a.scrollLeft = Math.max(0, t.left - (f ? 0 : 10)) : t.right > p + d - 3 && (a.scrollLeft = t.right + (f ? 0 : 10) - p), a;
          }
          function Nn(e, t) {
            null != t && (Dn(e), e.curOp.scrollTop = (null == e.curOp.scrollTop ? e.doc.scrollTop : e.curOp.scrollTop) + t);
          }
          function zn(e) {
            Dn(e);
            var t = e.getCursor();
            e.curOp.scrollToPos = {
              from: t,
              to: t,
              margin: e.options.cursorScrollMargin
            };
          }
          function On(e, t, r) {
            null == t && null == r || Dn(e), null != t && (e.curOp.scrollLeft = t), null != r && (e.curOp.scrollTop = r);
          }
          function Dn(e) {
            var t = e.curOp.scrollToPos;
            t && (e.curOp.scrollToPos = null, In(e, Kr(e, t.from), Kr(e, t.to), t.margin));
          }
          function In(e, t, r, n) {
            var i = An(e, {
              left: Math.min(t.left, r.left),
              top: Math.min(t.top, r.top) - n,
              right: Math.max(t.right, r.right),
              bottom: Math.max(t.bottom, r.bottom) + n
            });
            On(e, i.scrollLeft, i.scrollTop);
          }
          function Pn(e, t) {
            Math.abs(e.doc.scrollTop - t) < 2 || (r || ci(e, {
              top: t
            }), jn(e, t, !0), r && ci(e), ii(e, 100));
          }
          function jn(e, t, r) {
            t = Math.max(0, Math.min(e.display.scroller.scrollHeight - e.display.scroller.clientHeight, t)), (e.display.scroller.scrollTop != t || r) && (e.doc.scrollTop = t, e.display.scrollbars.setScrollTop(t), e.display.scroller.scrollTop != t && (e.display.scroller.scrollTop = t));
          }
          function qn(e, t, r, n) {
            t = Math.max(0, Math.min(t, e.display.scroller.scrollWidth - e.display.scroller.clientWidth)), (r ? t == e.doc.scrollLeft : Math.abs(e.doc.scrollLeft - t) < 2) && !n || (e.doc.scrollLeft = t, pi(e), e.display.scroller.scrollLeft != t && (e.display.scroller.scrollLeft = t), e.display.scrollbars.setScrollLeft(t));
          }
          function Fn(e) {
            var t = e.display,
              r = t.gutters.offsetWidth,
              n = Math.round(e.doc.height + Sr(e.display));
            return {
              clientHeight: t.scroller.clientHeight,
              viewHeight: t.wrapper.clientHeight,
              scrollWidth: t.scroller.scrollWidth,
              clientWidth: t.scroller.clientWidth,
              viewWidth: t.wrapper.clientWidth,
              barLeft: e.options.fixedGutter ? r : 0,
              docHeight: n,
              scrollHeight: n + Tr(e) + t.barHeight,
              nativeBarWidth: t.nativeBarWidth,
              gutterWidth: r
            };
          }
          var Rn = function Rn(e, t, r) {
            this.cm = r;
            var n = this.vert = A("div", [A("div", null, null, "min-width: 1px")], "CodeMirror-vscrollbar"),
              i = this.horiz = A("div", [A("div", null, null, "height: 100%; min-height: 1px")], "CodeMirror-hscrollbar");
            n.tabIndex = i.tabIndex = -1, e(n), e(i), pe(n, "scroll", function () {
              n.clientHeight && t(n.scrollTop, "vertical");
            }), pe(i, "scroll", function () {
              i.clientWidth && t(i.scrollLeft, "horizontal");
            }), this.checkedZeroWidth = !1, s && l < 8 && (this.horiz.style.minHeight = this.vert.style.minWidth = "18px");
          };
          Rn.prototype.update = function (e) {
            var t = e.scrollWidth > e.clientWidth + 1,
              r = e.scrollHeight > e.clientHeight + 1,
              n = e.nativeBarWidth;
            if (r) {
              this.vert.style.display = "block", this.vert.style.bottom = t ? n + "px" : "0";
              var i = e.viewHeight - (t ? n : 0);
              this.vert.firstChild.style.height = Math.max(0, e.scrollHeight - e.clientHeight + i) + "px";
            } else this.vert.style.display = "", this.vert.firstChild.style.height = "0";
            if (t) {
              this.horiz.style.display = "block", this.horiz.style.right = r ? n + "px" : "0", this.horiz.style.left = e.barLeft + "px";
              var o = e.viewWidth - e.barLeft - (r ? n : 0);
              this.horiz.firstChild.style.width = Math.max(0, e.scrollWidth - e.clientWidth + o) + "px";
            } else this.horiz.style.display = "", this.horiz.firstChild.style.width = "0";
            return !this.checkedZeroWidth && e.clientHeight > 0 && (0 == n && this.zeroWidthHack(), this.checkedZeroWidth = !0), {
              right: r ? n : 0,
              bottom: t ? n : 0
            };
          }, Rn.prototype.setScrollLeft = function (e) {
            this.horiz.scrollLeft != e && (this.horiz.scrollLeft = e), this.disableHoriz && this.enableZeroWidthBar(this.horiz, this.disableHoriz, "horiz");
          }, Rn.prototype.setScrollTop = function (e) {
            this.vert.scrollTop != e && (this.vert.scrollTop = e), this.disableVert && this.enableZeroWidthBar(this.vert, this.disableVert, "vert");
          }, Rn.prototype.zeroWidthHack = function () {
            var e = b && !m ? "12px" : "18px";
            this.horiz.style.height = this.vert.style.width = e, this.horiz.style.pointerEvents = this.vert.style.pointerEvents = "none", this.disableHoriz = new R(), this.disableVert = new R();
          }, Rn.prototype.enableZeroWidthBar = function (e, t, r) {
            e.style.pointerEvents = "auto", t.set(1e3, function n() {
              var i = e.getBoundingClientRect();
              ("vert" == r ? document.elementFromPoint(i.right - 1, (i.top + i.bottom) / 2) : document.elementFromPoint((i.right + i.left) / 2, i.bottom - 1)) != e ? e.style.pointerEvents = "none" : t.set(1e3, n);
            });
          }, Rn.prototype.clear = function () {
            var e = this.horiz.parentNode;
            e.removeChild(this.horiz), e.removeChild(this.vert);
          };
          var Wn = function Wn() {};
          function $n(e, t) {
            t || (t = Fn(e));
            var r = e.display.barWidth,
              n = e.display.barHeight;
            Un(e, t);
            for (var i = 0; i < 4 && r != e.display.barWidth || n != e.display.barHeight; i++) {
              r != e.display.barWidth && e.options.lineWrapping && Mn(e), Un(e, Fn(e)), r = e.display.barWidth, n = e.display.barHeight;
            }
          }
          function Un(e, t) {
            var r = e.display,
              n = r.scrollbars.update(t);
            r.sizer.style.paddingRight = (r.barWidth = n.right) + "px", r.sizer.style.paddingBottom = (r.barHeight = n.bottom) + "px", r.heightForcer.style.borderBottom = n.bottom + "px solid transparent", n.right && n.bottom ? (r.scrollbarFiller.style.display = "block", r.scrollbarFiller.style.height = n.bottom + "px", r.scrollbarFiller.style.width = n.right + "px") : r.scrollbarFiller.style.display = "", n.bottom && e.options.coverGutterNextToScrollbar && e.options.fixedGutter ? (r.gutterFiller.style.display = "block", r.gutterFiller.style.height = n.bottom + "px", r.gutterFiller.style.width = t.gutterWidth + "px") : r.gutterFiller.style.display = "";
          }
          Wn.prototype.update = function () {
            return {
              bottom: 0,
              right: 0
            };
          }, Wn.prototype.setScrollLeft = function () {}, Wn.prototype.setScrollTop = function () {}, Wn.prototype.clear = function () {};
          var Hn = {
            native: Rn,
            null: Wn
          };
          function Bn(e) {
            e.display.scrollbars && (e.display.scrollbars.clear(), e.display.scrollbars.addClass && M(e.display.wrapper, e.display.scrollbars.addClass)), e.display.scrollbars = new Hn[e.options.scrollbarStyle](function (t) {
              e.display.wrapper.insertBefore(t, e.display.scrollbarFiller), pe(t, "mousedown", function () {
                e.state.focused && setTimeout(function () {
                  return e.display.input.focus();
                }, 0);
              }), t.setAttribute("cm-not-content", "true");
            }, function (t, r) {
              "horizontal" == r ? qn(e, t) : Pn(e, t);
            }, e), e.display.scrollbars.addClass && D(e.display.wrapper, e.display.scrollbars.addClass);
          }
          var Vn = 0;
          function Gn(e) {
            var t;
            e.curOp = {
              cm: e,
              viewChanged: !1,
              startHeight: e.doc.height,
              forceUpdate: !1,
              updateInput: 0,
              typing: !1,
              changeObjs: null,
              cursorActivityHandlers: null,
              cursorActivityCalled: 0,
              selectionChanged: !1,
              updateMaxLine: !1,
              scrollLeft: null,
              scrollTop: null,
              scrollToPos: null,
              focus: !1,
              id: ++Vn
            }, t = e.curOp, ar ? ar.ops.push(t) : t.ownsGroup = ar = {
              ops: [t],
              delayedCallbacks: []
            };
          }
          function Kn(e) {
            var t = e.curOp;
            t && function (e, t) {
              var r = e.ownsGroup;
              if (r) try {
                !function (e) {
                  var t = e.delayedCallbacks,
                    r = 0;
                  do {
                    for (; r < t.length; r++) {
                      t[r].call(null);
                    }
                    for (var n = 0; n < e.ops.length; n++) {
                      var i = e.ops[n];
                      if (i.cursorActivityHandlers) for (; i.cursorActivityCalled < i.cursorActivityHandlers.length;) {
                        i.cursorActivityHandlers[i.cursorActivityCalled++].call(null, i.cm);
                      }
                    }
                  } while (r < t.length);
                }(r);
              } finally {
                ar = null, t(r);
              }
            }(t, function (e) {
              for (var t = 0; t < e.ops.length; t++) {
                e.ops[t].cm.curOp = null;
              }
              !function (e) {
                for (var t = e.ops, r = 0; r < t.length; r++) {
                  Zn(t[r]);
                }
                for (var n = 0; n < t.length; n++) {
                  Xn(t[n]);
                }
                for (var i = 0; i < t.length; i++) {
                  Yn(t[i]);
                }
                for (var o = 0; o < t.length; o++) {
                  Qn(t[o]);
                }
                for (var a = 0; a < t.length; a++) {
                  Jn(t[a]);
                }
              }(e);
            });
          }
          function Zn(e) {
            var t = e.cm,
              r = t.display;
            !function (e) {
              var t = e.display;
              !t.scrollbarsClipped && t.scroller.offsetWidth && (t.nativeBarWidth = t.scroller.offsetWidth - t.scroller.clientWidth, t.heightForcer.style.height = Tr(e) + "px", t.sizer.style.marginBottom = -t.nativeBarWidth + "px", t.sizer.style.borderRightWidth = Tr(e) + "px", t.scrollbarsClipped = !0);
            }(t), e.updateMaxLine && Vt(t), e.mustUpdate = e.viewChanged || e.forceUpdate || null != e.scrollTop || e.scrollToPos && (e.scrollToPos.from.line < r.viewFrom || e.scrollToPos.to.line >= r.viewTo) || r.maxLineChanged && t.options.lineWrapping, e.update = e.mustUpdate && new ai(t, e.mustUpdate && {
              top: e.scrollTop,
              ensure: e.scrollToPos
            }, e.forceUpdate);
          }
          function Xn(e) {
            e.updatedDisplay = e.mustUpdate && si(e.cm, e.update);
          }
          function Yn(e) {
            var t = e.cm,
              r = t.display;
            e.updatedDisplay && Mn(t), e.barMeasure = Fn(t), r.maxLineChanged && !t.options.lineWrapping && (e.adjustWidthTo = Ar(t, r.maxLine, r.maxLine.text.length).left + 3, t.display.sizerWidth = e.adjustWidthTo, e.barMeasure.scrollWidth = Math.max(r.scroller.clientWidth, r.sizer.offsetLeft + e.adjustWidthTo + Tr(t) + t.display.barWidth), e.maxScrollLeft = Math.max(0, r.sizer.offsetLeft + e.adjustWidthTo - Mr(t))), (e.updatedDisplay || e.selectionChanged) && (e.preparedSelection = r.input.prepareSelection());
          }
          function Qn(e) {
            var t = e.cm;
            null != e.adjustWidthTo && (t.display.sizer.style.minWidth = e.adjustWidthTo + "px", e.maxScrollLeft < t.doc.scrollLeft && qn(t, Math.min(t.display.scroller.scrollLeft, e.maxScrollLeft), !0), t.display.maxLineChanged = !1);
            var r = e.focus && e.focus == O();
            e.preparedSelection && t.display.input.showSelection(e.preparedSelection, r), (e.updatedDisplay || e.startHeight != t.doc.height) && $n(t, e.barMeasure), e.updatedDisplay && di(t, e.barMeasure), e.selectionChanged && wn(t), t.state.focused && e.updateInput && t.display.input.reset(e.typing), r && _n(e.cm);
          }
          function Jn(e) {
            var t = e.cm,
              r = t.display,
              n = t.doc;
            if (e.updatedDisplay && li(t, e.update), null == r.wheelStartX || null == e.scrollTop && null == e.scrollLeft && !e.scrollToPos || (r.wheelStartX = r.wheelStartY = null), null != e.scrollTop && jn(t, e.scrollTop, e.forceScroll), null != e.scrollLeft && qn(t, e.scrollLeft, !0, !0), e.scrollToPos) {
              var i = function (e, t, r, n) {
                var i;
                null == n && (n = 0), e.options.lineWrapping || t != r || (r = "before" == (t = t.ch ? tt(t.line, "before" == t.sticky ? t.ch - 1 : t.ch, "after") : t).sticky ? tt(t.line, t.ch + 1, "before") : t);
                for (var o = 0; o < 5; o++) {
                  var a = !1,
                    s = Gr(e, t),
                    l = r && r != t ? Gr(e, r) : s,
                    c = An(e, i = {
                      left: Math.min(s.left, l.left),
                      top: Math.min(s.top, l.top) - n,
                      right: Math.max(s.left, l.left),
                      bottom: Math.max(s.bottom, l.bottom) + n
                    }),
                    u = e.doc.scrollTop,
                    d = e.doc.scrollLeft;
                  if (null != c.scrollTop && (Pn(e, c.scrollTop), Math.abs(e.doc.scrollTop - u) > 1 && (a = !0)), null != c.scrollLeft && (qn(e, c.scrollLeft), Math.abs(e.doc.scrollLeft - d) > 1 && (a = !0)), !a) break;
                }
                return i;
              }(t, lt(n, e.scrollToPos.from), lt(n, e.scrollToPos.to), e.scrollToPos.margin);
              !function (e, t) {
                if (!ge(e, "scrollCursorIntoView")) {
                  var r = e.display,
                    n = r.sizer.getBoundingClientRect(),
                    i = null;
                  if (t.top + n.top < 0 ? i = !0 : t.bottom + n.top > (window.innerHeight || document.documentElement.clientHeight) && (i = !1), null != i && !h) {
                    var o = A("div", "​", null, "position: absolute;\n                         top: " + (t.top - r.viewOffset - _r(e.display)) + "px;\n                         height: " + (t.bottom - t.top + Tr(e) + r.barHeight) + "px;\n                         left: " + t.left + "px; width: " + Math.max(2, t.right - t.left) + "px;");
                    e.display.lineSpace.appendChild(o), o.scrollIntoView(i), e.display.lineSpace.removeChild(o);
                  }
                }
              }(t, i);
            }
            var o = e.maybeHiddenMarkers,
              a = e.maybeUnhiddenMarkers;
            if (o) for (var s = 0; s < o.length; ++s) {
              o[s].lines.length || he(o[s], "hide");
            }
            if (a) for (var l = 0; l < a.length; ++l) {
              a[l].lines.length && he(a[l], "unhide");
            }
            r.wrapper.offsetHeight && (n.scrollTop = t.display.scroller.scrollTop), e.changeObjs && he(t, "changes", t, e.changeObjs), e.update && e.update.finish();
          }
          function ei(e, t) {
            if (e.curOp) return t();
            Gn(e);
            try {
              return t();
            } finally {
              Kn(e);
            }
          }
          function ti(e, t) {
            return function () {
              if (e.curOp) return t.apply(e, arguments);
              Gn(e);
              try {
                return t.apply(e, arguments);
              } finally {
                Kn(e);
              }
            };
          }
          function ri(e) {
            return function () {
              if (this.curOp) return e.apply(this, arguments);
              Gn(this);
              try {
                return e.apply(this, arguments);
              } finally {
                Kn(this);
              }
            };
          }
          function ni(e) {
            return function () {
              var t = this.cm;
              if (!t || t.curOp) return e.apply(this, arguments);
              Gn(t);
              try {
                return e.apply(this, arguments);
              } finally {
                Kn(t);
              }
            };
          }
          function ii(e, t) {
            e.doc.highlightFrontier < e.display.viewTo && e.state.highlight.set(t, j(oi, e));
          }
          function oi(e) {
            var t = e.doc;
            if (!(t.highlightFrontier >= e.display.viewTo)) {
              var r = +new Date() + e.options.workTime,
                n = mt(e, t.highlightFrontier),
                i = [];
              t.iter(n.line, Math.min(t.first + t.size, e.display.viewTo + 500), function (o) {
                if (n.line >= e.display.viewFrom) {
                  var a = o.styles,
                    s = o.text.length > e.options.maxHighlightLength ? Ue(t.mode, n.state) : null,
                    l = pt(e, o, n, !0);
                  s && (n.state = s), o.styles = l.styles;
                  var c = o.styleClasses,
                    u = l.classes;
                  u ? o.styleClasses = u : c && (o.styleClasses = null);
                  for (var d = !a || a.length != o.styles.length || c != u && (!c || !u || c.bgClass != u.bgClass || c.textClass != u.textClass), p = 0; !d && p < a.length; ++p) {
                    d = a[p] != o.styles[p];
                  }
                  d && i.push(n.line), o.stateAfter = n.save(), n.nextLine();
                } else o.text.length <= e.options.maxHighlightLength && ht(e, o.text, n), o.stateAfter = n.line % 5 == 0 ? n.save() : null, n.nextLine();
                if (+new Date() > r) return ii(e, e.options.workDelay), !0;
              }), t.highlightFrontier = n.line, t.modeFrontier = Math.max(t.modeFrontier, n.line), i.length && ei(e, function () {
                for (var t = 0; t < i.length; t++) {
                  fn(e, i[t], "text");
                }
              });
            }
          }
          var ai = function ai(e, t, r) {
            var n = e.display;
            this.viewport = t, this.visible = Ln(n, e.doc, t), this.editorIsHidden = !n.wrapper.offsetWidth, this.wrapperHeight = n.wrapper.clientHeight, this.wrapperWidth = n.wrapper.clientWidth, this.oldDisplayWidth = Mr(e), this.force = r, this.dims = an(e), this.events = [];
          };
          function si(e, t) {
            var r = e.display,
              n = e.doc;
            if (t.editorIsHidden) return mn(e), !1;
            if (!t.force && t.visible.from >= r.viewFrom && t.visible.to <= r.viewTo && (null == r.updateLineNumbers || r.updateLineNumbers >= r.viewTo) && r.renderedView == r.view && 0 == gn(e)) return !1;
            fi(e) && (mn(e), t.dims = an(e));
            var i = n.first + n.size,
              o = Math.max(t.visible.from - e.options.viewportMargin, n.first),
              a = Math.min(i, t.visible.to + e.options.viewportMargin);
            r.viewFrom < o && o - r.viewFrom < 20 && (o = Math.max(n.first, r.viewFrom)), r.viewTo > a && r.viewTo - a < 20 && (a = Math.min(i, r.viewTo)), _t && (o = Rt(e.doc, o), a = Wt(e.doc, a));
            var s = o != r.viewFrom || a != r.viewTo || r.lastWrapHeight != t.wrapperHeight || r.lastWrapWidth != t.wrapperWidth;
            !function (e, t, r) {
              var n = e.display;
              0 == n.view.length || t >= n.viewTo || r <= n.viewFrom ? (n.view = or(e, t, r), n.viewFrom = t) : (n.viewFrom > t ? n.view = or(e, t, n.viewFrom).concat(n.view) : n.viewFrom < t && (n.view = n.view.slice(dn(e, t))), n.viewFrom = t, n.viewTo < r ? n.view = n.view.concat(or(e, n.viewTo, r)) : n.viewTo > r && (n.view = n.view.slice(0, dn(e, r)))), n.viewTo = r;
            }(e, o, a), r.viewOffset = Ht(Ge(e.doc, r.viewFrom)), e.display.mover.style.top = r.viewOffset + "px";
            var l = gn(e);
            if (!s && 0 == l && !t.force && r.renderedView == r.view && (null == r.updateLineNumbers || r.updateLineNumbers >= r.viewTo)) return !1;
            var u = function (e) {
              if (e.hasFocus()) return null;
              var t = O();
              if (!t || !z(e.display.lineDiv, t)) return null;
              var r = {
                activeElt: t
              };
              if (window.getSelection) {
                var n = window.getSelection();
                n.anchorNode && n.extend && z(e.display.lineDiv, n.anchorNode) && (r.anchorNode = n.anchorNode, r.anchorOffset = n.anchorOffset, r.focusNode = n.focusNode, r.focusOffset = n.focusOffset);
              }
              return r;
            }(e);
            return l > 4 && (r.lineDiv.style.display = "none"), function (e, t, r) {
              var n = e.display,
                i = e.options.lineNumbers,
                o = n.lineDiv,
                a = o.firstChild;
              function s(t) {
                var r = t.nextSibling;
                return c && b && e.display.currentWheelTarget == t ? t.style.display = "none" : t.parentNode.removeChild(t), r;
              }
              for (var l = n.view, u = n.viewFrom, d = 0; d < l.length; d++) {
                var p = l[d];
                if (p.hidden) ;else if (p.node && p.node.parentNode == o) {
                  for (; a != p.node;) {
                    a = s(a);
                  }
                  var f = i && null != t && t <= u && p.lineNumber;
                  p.changes && (W(p.changes, "gutter") > -1 && (f = !1), ur(e, p, u, r)), f && (E(p.lineNumber), p.lineNumber.appendChild(document.createTextNode(et(e.options, u)))), a = p.node.nextSibling;
                } else {
                  var m = yr(e, p, u, r);
                  o.insertBefore(m, a);
                }
                u += p.size;
              }
              for (; a;) {
                a = s(a);
              }
            }(e, r.updateLineNumbers, t.dims), l > 4 && (r.lineDiv.style.display = ""), r.renderedView = r.view, function (e) {
              if (e && e.activeElt && e.activeElt != O() && (e.activeElt.focus(), !/^(INPUT|TEXTAREA)$/.test(e.activeElt.nodeName) && e.anchorNode && z(document.body, e.anchorNode) && z(document.body, e.focusNode))) {
                var t = window.getSelection(),
                  r = document.createRange();
                r.setEnd(e.anchorNode, e.anchorOffset), r.collapse(!1), t.removeAllRanges(), t.addRange(r), t.extend(e.focusNode, e.focusOffset);
              }
            }(u), E(r.cursorDiv), E(r.selectionDiv), r.gutters.style.height = r.sizer.style.minHeight = 0, s && (r.lastWrapHeight = t.wrapperHeight, r.lastWrapWidth = t.wrapperWidth, ii(e, 400)), r.updateLineNumbers = null, !0;
          }
          function li(e, t) {
            for (var r = t.viewport, n = !0;; n = !1) {
              if (n && e.options.lineWrapping && t.oldDisplayWidth != Mr(e)) n && (t.visible = Ln(e.display, e.doc, r));else if (r && null != r.top && (r = {
                top: Math.min(e.doc.height + Sr(e.display) - Er(e), r.top)
              }), t.visible = Ln(e.display, e.doc, r), t.visible.from >= e.display.viewFrom && t.visible.to <= e.display.viewTo) break;
              if (!si(e, t)) break;
              Mn(e);
              var i = Fn(e);
              yn(e), $n(e, i), di(e, i), t.force = !1;
            }
            t.signal(e, "update", e), e.display.viewFrom == e.display.reportedViewFrom && e.display.viewTo == e.display.reportedViewTo || (t.signal(e, "viewportChange", e, e.display.viewFrom, e.display.viewTo), e.display.reportedViewFrom = e.display.viewFrom, e.display.reportedViewTo = e.display.viewTo);
          }
          function ci(e, t) {
            var r = new ai(e, t);
            if (si(e, r)) {
              Mn(e), li(e, r);
              var n = Fn(e);
              yn(e), $n(e, n), di(e, n), r.finish();
            }
          }
          function ui(e) {
            var t = e.gutters.offsetWidth;
            e.sizer.style.marginLeft = t + "px";
          }
          function di(e, t) {
            e.display.sizer.style.minHeight = t.docHeight + "px", e.display.heightForcer.style.top = t.docHeight + "px", e.display.gutters.style.height = t.docHeight + e.display.barHeight + Tr(e) + "px";
          }
          function pi(e) {
            var t = e.display,
              r = t.view;
            if (t.alignWidgets || t.gutters.firstChild && e.options.fixedGutter) {
              for (var n = sn(t) - t.scroller.scrollLeft + e.doc.scrollLeft, i = t.gutters.offsetWidth, o = n + "px", a = 0; a < r.length; a++) {
                if (!r[a].hidden) {
                  e.options.fixedGutter && (r[a].gutter && (r[a].gutter.style.left = o), r[a].gutterBackground && (r[a].gutterBackground.style.left = o));
                  var s = r[a].alignable;
                  if (s) for (var l = 0; l < s.length; l++) {
                    s[l].style.left = o;
                  }
                }
              }
              e.options.fixedGutter && (t.gutters.style.left = n + i + "px");
            }
          }
          function fi(e) {
            if (!e.options.lineNumbers) return !1;
            var t = e.doc,
              r = et(e.options, t.first + t.size - 1),
              n = e.display;
            if (r.length != n.lineNumChars) {
              var i = n.measure.appendChild(A("div", [A("div", r)], "CodeMirror-linenumber CodeMirror-gutter-elt")),
                o = i.firstChild.offsetWidth,
                a = i.offsetWidth - o;
              return n.lineGutter.style.width = "", n.lineNumInnerWidth = Math.max(o, n.lineGutter.offsetWidth - a) + 1, n.lineNumWidth = n.lineNumInnerWidth + a, n.lineNumChars = n.lineNumInnerWidth ? r.length : -1, n.lineGutter.style.width = n.lineNumWidth + "px", ui(e.display), !0;
            }
            return !1;
          }
          function mi(e, t) {
            for (var r = [], n = !1, i = 0; i < e.length; i++) {
              var o = e[i],
                a = null;
              if ("string" != typeof o && (a = o.style, o = o.className), "CodeMirror-linenumbers" == o) {
                if (!t) continue;
                n = !0;
              }
              r.push({
                className: o,
                style: a
              });
            }
            return t && !n && r.push({
              className: "CodeMirror-linenumbers",
              style: null
            }), r;
          }
          function hi(e) {
            var t = e.gutters,
              r = e.gutterSpecs;
            E(t), e.lineGutter = null;
            for (var n = 0; n < r.length; ++n) {
              var i = r[n],
                o = i.className,
                a = i.style,
                s = t.appendChild(A("div", null, "CodeMirror-gutter " + o));
              a && (s.style.cssText = a), "CodeMirror-linenumbers" == o && (e.lineGutter = s, s.style.width = (e.lineNumWidth || 1) + "px");
            }
            t.style.display = r.length ? "" : "none", ui(e);
          }
          function gi(e) {
            hi(e.display), pn(e), pi(e);
          }
          function yi(e, t, n, i) {
            var o = this;
            this.input = n, o.scrollbarFiller = A("div", null, "CodeMirror-scrollbar-filler"), o.scrollbarFiller.setAttribute("cm-not-content", "true"), o.gutterFiller = A("div", null, "CodeMirror-gutter-filler"), o.gutterFiller.setAttribute("cm-not-content", "true"), o.lineDiv = N("div", null, "CodeMirror-code"), o.selectionDiv = A("div", null, null, "position: relative; z-index: 1"), o.cursorDiv = A("div", null, "CodeMirror-cursors"), o.measure = A("div", null, "CodeMirror-measure"), o.lineMeasure = A("div", null, "CodeMirror-measure"), o.lineSpace = N("div", [o.measure, o.lineMeasure, o.selectionDiv, o.cursorDiv, o.lineDiv], null, "position: relative; outline: none");
            var a = N("div", [o.lineSpace], "CodeMirror-lines");
            o.mover = A("div", [a], null, "position: relative"), o.sizer = A("div", [o.mover], "CodeMirror-sizer"), o.sizerWidth = null, o.heightForcer = A("div", null, null, "position: absolute; height: 50px; width: 1px;"), o.gutters = A("div", null, "CodeMirror-gutters"), o.lineGutter = null, o.scroller = A("div", [o.sizer, o.heightForcer, o.gutters], "CodeMirror-scroll"), o.scroller.setAttribute("tabIndex", "-1"), o.wrapper = A("div", [o.scrollbarFiller, o.gutterFiller, o.scroller], "CodeMirror"), s && l < 8 && (o.gutters.style.zIndex = -1, o.scroller.style.paddingRight = 0), c || r && v || (o.scroller.draggable = !0), e && (e.appendChild ? e.appendChild(o.wrapper) : e(o.wrapper)), o.viewFrom = o.viewTo = t.first, o.reportedViewFrom = o.reportedViewTo = t.first, o.view = [], o.renderedView = null, o.externalMeasured = null, o.viewOffset = 0, o.lastWrapHeight = o.lastWrapWidth = 0, o.updateLineNumbers = null, o.nativeBarWidth = o.barHeight = o.barWidth = 0, o.scrollbarsClipped = !1, o.lineNumWidth = o.lineNumInnerWidth = o.lineNumChars = null, o.alignWidgets = !1, o.cachedCharWidth = o.cachedTextHeight = o.cachedPaddingH = null, o.maxLine = null, o.maxLineLength = 0, o.maxLineChanged = !1, o.wheelDX = o.wheelDY = o.wheelStartX = o.wheelStartY = null, o.shift = !1, o.selForContextMenu = null, o.activeTouch = null, o.gutterSpecs = mi(i.gutters, i.lineNumbers), hi(o), n.init(o);
          }
          ai.prototype.signal = function (e, t) {
            ve(e, t) && this.events.push(arguments);
          }, ai.prototype.finish = function () {
            for (var e = 0; e < this.events.length; e++) {
              he.apply(null, this.events[e]);
            }
          };
          var vi = 0,
            bi = null;
          function xi(e) {
            var t = e.wheelDeltaX,
              r = e.wheelDeltaY;
            return null == t && e.detail && e.axis == e.HORIZONTAL_AXIS && (t = e.detail), null == r && e.detail && e.axis == e.VERTICAL_AXIS ? r = e.detail : null == r && (r = e.wheelDelta), {
              x: t,
              y: r
            };
          }
          function ki(e) {
            var t = xi(e);
            return t.x *= bi, t.y *= bi, t;
          }
          function wi(e, t) {
            var n = xi(t),
              i = n.x,
              o = n.y,
              a = e.display,
              s = a.scroller,
              l = s.scrollWidth > s.clientWidth,
              u = s.scrollHeight > s.clientHeight;
            if (i && l || o && u) {
              if (o && b && c) e: for (var d = t.target, f = a.view; d != s; d = d.parentNode) {
                for (var m = 0; m < f.length; m++) {
                  if (f[m].node == d) {
                    e.display.currentWheelTarget = d;
                    break e;
                  }
                }
              }
              if (i && !r && !p && null != bi) return o && u && Pn(e, Math.max(0, s.scrollTop + o * bi)), qn(e, Math.max(0, s.scrollLeft + i * bi)), (!o || o && u) && xe(t), void (a.wheelStartX = null);
              if (o && null != bi) {
                var h = o * bi,
                  g = e.doc.scrollTop,
                  y = g + a.wrapper.clientHeight;
                h < 0 ? g = Math.max(0, g + h - 50) : y = Math.min(e.doc.height, y + h + 50), ci(e, {
                  top: g,
                  bottom: y
                });
              }
              vi < 20 && (null == a.wheelStartX ? (a.wheelStartX = s.scrollLeft, a.wheelStartY = s.scrollTop, a.wheelDX = i, a.wheelDY = o, setTimeout(function () {
                if (null != a.wheelStartX) {
                  var e = s.scrollLeft - a.wheelStartX,
                    t = s.scrollTop - a.wheelStartY,
                    r = t && a.wheelDY && t / a.wheelDY || e && a.wheelDX && e / a.wheelDX;
                  a.wheelStartX = a.wheelStartY = null, r && (bi = (bi * vi + r) / (vi + 1), ++vi);
                }
              }, 200)) : (a.wheelDX += i, a.wheelDY += o));
            }
          }
          s ? bi = -.53 : r ? bi = 15 : d ? bi = -.7 : f && (bi = -1 / 3);
          var _i = function _i(e, t) {
            this.ranges = e, this.primIndex = t;
          };
          _i.prototype.primary = function () {
            return this.ranges[this.primIndex];
          }, _i.prototype.equals = function (e) {
            if (e == this) return !0;
            if (e.primIndex != this.primIndex || e.ranges.length != this.ranges.length) return !1;
            for (var t = 0; t < this.ranges.length; t++) {
              var r = this.ranges[t],
                n = e.ranges[t];
              if (!nt(r.anchor, n.anchor) || !nt(r.head, n.head)) return !1;
            }
            return !0;
          }, _i.prototype.deepCopy = function () {
            for (var e = [], t = 0; t < this.ranges.length; t++) {
              e[t] = new Si(it(this.ranges[t].anchor), it(this.ranges[t].head));
            }
            return new _i(e, this.primIndex);
          }, _i.prototype.somethingSelected = function () {
            for (var e = 0; e < this.ranges.length; e++) {
              if (!this.ranges[e].empty()) return !0;
            }
            return !1;
          }, _i.prototype.contains = function (e, t) {
            t || (t = e);
            for (var r = 0; r < this.ranges.length; r++) {
              var n = this.ranges[r];
              if (rt(t, n.from()) >= 0 && rt(e, n.to()) <= 0) return r;
            }
            return -1;
          };
          var Si = function Si(e, t) {
            this.anchor = e, this.head = t;
          };
          function Ci(e, t, r) {
            var n = e && e.options.selectionsMayTouch,
              i = t[r];
            t.sort(function (e, t) {
              return rt(e.from(), t.from());
            }), r = W(t, i);
            for (var o = 1; o < t.length; o++) {
              var a = t[o],
                s = t[o - 1],
                l = rt(s.to(), a.from());
              if (n && !a.empty() ? l > 0 : l >= 0) {
                var c = at(s.from(), a.from()),
                  u = ot(s.to(), a.to()),
                  d = s.empty() ? a.from() == a.head : s.from() == s.head;
                o <= r && --r, t.splice(--o, 2, new Si(d ? u : c, d ? c : u));
              }
            }
            return new _i(t, r);
          }
          function Ti(e, t) {
            return new _i([new Si(e, t || e)], 0);
          }
          function Mi(e) {
            return e.text ? tt(e.from.line + e.text.length - 1, Z(e.text).length + (1 == e.text.length ? e.from.ch : 0)) : e.to;
          }
          function Ei(e, t) {
            if (rt(e, t.from) < 0) return e;
            if (rt(e, t.to) <= 0) return Mi(t);
            var r = e.line + t.text.length - (t.to.line - t.from.line) - 1,
              n = e.ch;
            return e.line == t.to.line && (n += Mi(t).ch - t.to.ch), tt(r, n);
          }
          function Li(e, t) {
            for (var r = [], n = 0; n < e.sel.ranges.length; n++) {
              var i = e.sel.ranges[n];
              r.push(new Si(Ei(i.anchor, t), Ei(i.head, t)));
            }
            return Ci(e.cm, r, e.sel.primIndex);
          }
          function Ai(e, t, r) {
            return e.line == t.line ? tt(r.line, e.ch - t.ch + r.ch) : tt(r.line + (e.line - t.line), e.ch);
          }
          function Ni(e) {
            e.doc.mode = Re(e.options, e.doc.modeOption), zi(e);
          }
          function zi(e) {
            e.doc.iter(function (e) {
              e.stateAfter && (e.stateAfter = null), e.styles && (e.styles = null);
            }), e.doc.modeFrontier = e.doc.highlightFrontier = e.doc.first, ii(e, 100), e.state.modeGen++, e.curOp && pn(e);
          }
          function Oi(e, t) {
            return 0 == t.from.ch && 0 == t.to.ch && "" == Z(t.text) && (!e.cm || e.cm.options.wholeLineUpdateBefore);
          }
          function Di(e, t, r, n) {
            function i(e) {
              return r ? r[e] : null;
            }
            function o(e, r, i) {
              !function (e, t, r, n) {
                e.text = t, e.stateAfter && (e.stateAfter = null), e.styles && (e.styles = null), null != e.order && (e.order = null), Lt(e), At(e, r);
                var i = n ? n(e) : 1;
                i != e.height && Xe(e, i);
              }(e, r, i, n), lr(e, "change", e, t);
            }
            function a(e, t) {
              for (var r = [], o = e; o < t; ++o) {
                r.push(new Gt(c[o], i(o), n));
              }
              return r;
            }
            var s = t.from,
              l = t.to,
              c = t.text,
              u = Ge(e, s.line),
              d = Ge(e, l.line),
              p = Z(c),
              f = i(c.length - 1),
              m = l.line - s.line;
            if (t.full) e.insert(0, a(0, c.length)), e.remove(c.length, e.size - c.length);else if (Oi(e, t)) {
              var h = a(0, c.length - 1);
              o(d, d.text, f), m && e.remove(s.line, m), h.length && e.insert(s.line, h);
            } else if (u == d) {
              if (1 == c.length) o(u, u.text.slice(0, s.ch) + p + u.text.slice(l.ch), f);else {
                var g = a(1, c.length - 1);
                g.push(new Gt(p + u.text.slice(l.ch), f, n)), o(u, u.text.slice(0, s.ch) + c[0], i(0)), e.insert(s.line + 1, g);
              }
            } else if (1 == c.length) o(u, u.text.slice(0, s.ch) + c[0] + d.text.slice(l.ch), i(0)), e.remove(s.line + 1, m);else {
              o(u, u.text.slice(0, s.ch) + c[0], i(0)), o(d, p + d.text.slice(l.ch), f);
              var y = a(1, c.length - 1);
              m > 1 && e.remove(s.line + 1, m - 1), e.insert(s.line + 1, y);
            }
            lr(e, "change", e, t);
          }
          function Ii(e, t, r) {
            !function e(n, i, o) {
              if (n.linked) for (var a = 0; a < n.linked.length; ++a) {
                var s = n.linked[a];
                if (s.doc != i) {
                  var l = o && s.sharedHist;
                  r && !l || (t(s.doc, l), e(s.doc, n, l));
                }
              }
            }(e, null, !0);
          }
          function Pi(e, t) {
            if (t.cm) throw new Error("This document is already in use.");
            e.doc = t, t.cm = e, cn(e), Ni(e), ji(e), e.options.lineWrapping || Vt(e), e.options.mode = t.modeOption, pn(e);
          }
          function ji(e) {
            ("rtl" == e.doc.direction ? D : M)(e.display.lineDiv, "CodeMirror-rtl");
          }
          function qi(e) {
            this.done = [], this.undone = [], this.undoDepth = 1 / 0, this.lastModTime = this.lastSelTime = 0, this.lastOp = this.lastSelOp = null, this.lastOrigin = this.lastSelOrigin = null, this.generation = this.maxGeneration = e || 1;
          }
          function Fi(e, t) {
            var r = {
              from: it(t.from),
              to: Mi(t),
              text: Ke(e, t.from, t.to)
            };
            return Hi(e, r, t.from.line, t.to.line + 1), Ii(e, function (e) {
              return Hi(e, r, t.from.line, t.to.line + 1);
            }, !0), r;
          }
          function Ri(e) {
            for (; e.length && Z(e).ranges;) {
              e.pop();
            }
          }
          function Wi(e, t, r, n) {
            var i = e.history;
            i.undone.length = 0;
            var o,
              a,
              s = +new Date();
            if ((i.lastOp == n || i.lastOrigin == t.origin && t.origin && ("+" == t.origin.charAt(0) && i.lastModTime > s - (e.cm ? e.cm.options.historyEventDelay : 500) || "*" == t.origin.charAt(0))) && (o = function (e, t) {
              return t ? (Ri(e.done), Z(e.done)) : e.done.length && !Z(e.done).ranges ? Z(e.done) : e.done.length > 1 && !e.done[e.done.length - 2].ranges ? (e.done.pop(), Z(e.done)) : void 0;
            }(i, i.lastOp == n))) a = Z(o.changes), 0 == rt(t.from, t.to) && 0 == rt(t.from, a.to) ? a.to = Mi(t) : o.changes.push(Fi(e, t));else {
              var l = Z(i.done);
              for (l && l.ranges || Ui(e.sel, i.done), o = {
                changes: [Fi(e, t)],
                generation: i.generation
              }, i.done.push(o); i.done.length > i.undoDepth;) {
                i.done.shift(), i.done[0].ranges || i.done.shift();
              }
            }
            i.done.push(r), i.generation = ++i.maxGeneration, i.lastModTime = i.lastSelTime = s, i.lastOp = i.lastSelOp = n, i.lastOrigin = i.lastSelOrigin = t.origin, a || he(e, "historyAdded");
          }
          function $i(e, t, r, n) {
            var i = e.history,
              o = n && n.origin;
            r == i.lastSelOp || o && i.lastSelOrigin == o && (i.lastModTime == i.lastSelTime && i.lastOrigin == o || function (e, t, r, n) {
              var i = t.charAt(0);
              return "*" == i || "+" == i && r.ranges.length == n.ranges.length && r.somethingSelected() == n.somethingSelected() && new Date() - e.history.lastSelTime <= (e.cm ? e.cm.options.historyEventDelay : 500);
            }(e, o, Z(i.done), t)) ? i.done[i.done.length - 1] = t : Ui(t, i.done), i.lastSelTime = +new Date(), i.lastSelOrigin = o, i.lastSelOp = r, n && !1 !== n.clearRedo && Ri(i.undone);
          }
          function Ui(e, t) {
            var r = Z(t);
            r && r.ranges && r.equals(e) || t.push(e);
          }
          function Hi(e, t, r, n) {
            var i = t["spans_" + e.id],
              o = 0;
            e.iter(Math.max(e.first, r), Math.min(e.first + e.size, n), function (r) {
              r.markedSpans && ((i || (i = t["spans_" + e.id] = {}))[o] = r.markedSpans), ++o;
            });
          }
          function Bi(e) {
            if (!e) return null;
            for (var t, r = 0; r < e.length; ++r) {
              e[r].marker.explicitlyCleared ? t || (t = e.slice(0, r)) : t && t.push(e[r]);
            }
            return t ? t.length ? t : null : e;
          }
          function Vi(e, t) {
            var r = function (e, t) {
                var r = t["spans_" + e.id];
                if (!r) return null;
                for (var n = [], i = 0; i < t.text.length; ++i) {
                  n.push(Bi(r[i]));
                }
                return n;
              }(e, t),
              n = Mt(e, t);
            if (!r) return n;
            if (!n) return r;
            for (var i = 0; i < r.length; ++i) {
              var o = r[i],
                a = n[i];
              if (o && a) e: for (var s = 0; s < a.length; ++s) {
                for (var l = a[s], c = 0; c < o.length; ++c) {
                  if (o[c].marker == l.marker) continue e;
                }
                o.push(l);
              } else a && (r[i] = a);
            }
            return r;
          }
          function Gi(e, t, r) {
            for (var n = [], i = 0; i < e.length; ++i) {
              var o = e[i];
              if (o.ranges) n.push(r ? _i.prototype.deepCopy.call(o) : o);else {
                var a = o.changes,
                  s = [];
                n.push({
                  changes: s
                });
                for (var l = 0; l < a.length; ++l) {
                  var c = a[l],
                    u = void 0;
                  if (s.push({
                    from: c.from,
                    to: c.to,
                    text: c.text
                  }), t) for (var d in c) {
                    (u = d.match(/^spans_(\d+)$/)) && W(t, Number(u[1])) > -1 && (Z(s)[d] = c[d], delete c[d]);
                  }
                }
              }
            }
            return n;
          }
          function Ki(e, t, r, n) {
            if (n) {
              var i = e.anchor;
              if (r) {
                var o = rt(t, i) < 0;
                o != rt(r, i) < 0 ? (i = t, t = r) : o != rt(t, r) < 0 && (t = r);
              }
              return new Si(i, t);
            }
            return new Si(r || t, t);
          }
          function Zi(e, t, r, n, i) {
            null == i && (i = e.cm && (e.cm.display.shift || e.extend)), eo(e, new _i([Ki(e.sel.primary(), t, r, i)], 0), n);
          }
          function Xi(e, t, r) {
            for (var n = [], i = e.cm && (e.cm.display.shift || e.extend), o = 0; o < e.sel.ranges.length; o++) {
              n[o] = Ki(e.sel.ranges[o], t[o], null, i);
            }
            eo(e, Ci(e.cm, n, e.sel.primIndex), r);
          }
          function Yi(e, t, r, n) {
            var i = e.sel.ranges.slice(0);
            i[t] = r, eo(e, Ci(e.cm, i, e.sel.primIndex), n);
          }
          function Qi(e, t, r, n) {
            eo(e, Ti(t, r), n);
          }
          function Ji(e, t, r) {
            var n = e.history.done,
              i = Z(n);
            i && i.ranges ? (n[n.length - 1] = t, to(e, t, r)) : eo(e, t, r);
          }
          function eo(e, t, r) {
            to(e, t, r), $i(e, e.sel, e.cm ? e.cm.curOp.id : NaN, r);
          }
          function to(e, t, r) {
            (ve(e, "beforeSelectionChange") || e.cm && ve(e.cm, "beforeSelectionChange")) && (t = function (e, t, r) {
              var n = {
                ranges: t.ranges,
                update: function update(t) {
                  this.ranges = [];
                  for (var r = 0; r < t.length; r++) {
                    this.ranges[r] = new Si(lt(e, t[r].anchor), lt(e, t[r].head));
                  }
                },
                origin: r && r.origin
              };
              return he(e, "beforeSelectionChange", e, n), e.cm && he(e.cm, "beforeSelectionChange", e.cm, n), n.ranges != t.ranges ? Ci(e.cm, n.ranges, n.ranges.length - 1) : t;
            }(e, t, r));
            var n = r && r.bias || (rt(t.primary().head, e.sel.primary().head) < 0 ? -1 : 1);
            ro(e, io(e, t, n, !0)), r && !1 === r.scroll || !e.cm || zn(e.cm);
          }
          function ro(e, t) {
            t.equals(e.sel) || (e.sel = t, e.cm && (e.cm.curOp.updateInput = 1, e.cm.curOp.selectionChanged = !0, ye(e.cm)), lr(e, "cursorActivity", e));
          }
          function no(e) {
            ro(e, io(e, e.sel, null, !1));
          }
          function io(e, t, r, n) {
            for (var i, o = 0; o < t.ranges.length; o++) {
              var a = t.ranges[o],
                s = t.ranges.length == e.sel.ranges.length && e.sel.ranges[o],
                l = ao(e, a.anchor, s && s.anchor, r, n),
                c = ao(e, a.head, s && s.head, r, n);
              (i || l != a.anchor || c != a.head) && (i || (i = t.ranges.slice(0, o)), i[o] = new Si(l, c));
            }
            return i ? Ci(e.cm, i, t.primIndex) : t;
          }
          function oo(e, t, r, n, i) {
            var o = Ge(e, t.line);
            if (o.markedSpans) for (var a = 0; a < o.markedSpans.length; ++a) {
              var s = o.markedSpans[a],
                l = s.marker,
                c = "selectLeft" in l ? !l.selectLeft : l.inclusiveLeft,
                u = "selectRight" in l ? !l.selectRight : l.inclusiveRight;
              if ((null == s.from || (c ? s.from <= t.ch : s.from < t.ch)) && (null == s.to || (u ? s.to >= t.ch : s.to > t.ch))) {
                if (i && (he(l, "beforeCursorEnter"), l.explicitlyCleared)) {
                  if (o.markedSpans) {
                    --a;
                    continue;
                  }
                  break;
                }
                if (!l.atomic) continue;
                if (r) {
                  var d = l.find(n < 0 ? 1 : -1),
                    p = void 0;
                  if ((n < 0 ? u : c) && (d = so(e, d, -n, d && d.line == t.line ? o : null)), d && d.line == t.line && (p = rt(d, r)) && (n < 0 ? p < 0 : p > 0)) return oo(e, d, t, n, i);
                }
                var f = l.find(n < 0 ? -1 : 1);
                return (n < 0 ? c : u) && (f = so(e, f, n, f.line == t.line ? o : null)), f ? oo(e, f, t, n, i) : null;
              }
            }
            return t;
          }
          function ao(e, t, r, n, i) {
            var o = n || 1,
              a = oo(e, t, r, o, i) || !i && oo(e, t, r, o, !0) || oo(e, t, r, -o, i) || !i && oo(e, t, r, -o, !0);
            return a || (e.cantEdit = !0, tt(e.first, 0));
          }
          function so(e, t, r, n) {
            return r < 0 && 0 == t.ch ? t.line > e.first ? lt(e, tt(t.line - 1)) : null : r > 0 && t.ch == (n || Ge(e, t.line)).text.length ? t.line < e.first + e.size - 1 ? tt(t.line + 1, 0) : null : new tt(t.line, t.ch + r);
          }
          function lo(e) {
            e.setSelection(tt(e.firstLine(), 0), tt(e.lastLine()), U);
          }
          function co(e, t, r) {
            var n = {
              canceled: !1,
              from: t.from,
              to: t.to,
              text: t.text,
              origin: t.origin,
              cancel: function cancel() {
                return n.canceled = !0;
              }
            };
            return r && (n.update = function (t, r, i, o) {
              t && (n.from = lt(e, t)), r && (n.to = lt(e, r)), i && (n.text = i), void 0 !== o && (n.origin = o);
            }), he(e, "beforeChange", e, n), e.cm && he(e.cm, "beforeChange", e.cm, n), n.canceled ? (e.cm && (e.cm.curOp.updateInput = 2), null) : {
              from: n.from,
              to: n.to,
              text: n.text,
              origin: n.origin
            };
          }
          function uo(e, t, r) {
            if (e.cm) {
              if (!e.cm.curOp) return ti(e.cm, uo)(e, t, r);
              if (e.cm.state.suppressEdits) return;
            }
            if (!(ve(e, "beforeChange") || e.cm && ve(e.cm, "beforeChange")) || (t = co(e, t, !0))) {
              var n = wt && !r && function (e, t, r) {
                var n = null;
                if (e.iter(t.line, r.line + 1, function (e) {
                  if (e.markedSpans) for (var t = 0; t < e.markedSpans.length; ++t) {
                    var r = e.markedSpans[t].marker;
                    !r.readOnly || n && -1 != W(n, r) || (n || (n = [])).push(r);
                  }
                }), !n) return null;
                for (var i = [{
                    from: t,
                    to: r
                  }], o = 0; o < n.length; ++o) {
                  for (var a = n[o], s = a.find(0), l = 0; l < i.length; ++l) {
                    var c = i[l];
                    if (!(rt(c.to, s.from) < 0 || rt(c.from, s.to) > 0)) {
                      var u = [l, 1],
                        d = rt(c.from, s.from),
                        p = rt(c.to, s.to);
                      (d < 0 || !a.inclusiveLeft && !d) && u.push({
                        from: c.from,
                        to: s.from
                      }), (p > 0 || !a.inclusiveRight && !p) && u.push({
                        from: s.to,
                        to: c.to
                      }), i.splice.apply(i, u), l += u.length - 3;
                    }
                  }
                }
                return i;
              }(e, t.from, t.to);
              if (n) for (var i = n.length - 1; i >= 0; --i) {
                po(e, {
                  from: n[i].from,
                  to: n[i].to,
                  text: i ? [""] : t.text,
                  origin: t.origin
                });
              } else po(e, t);
            }
          }
          function po(e, t) {
            if (1 != t.text.length || "" != t.text[0] || 0 != rt(t.from, t.to)) {
              var r = Li(e, t);
              Wi(e, t, r, e.cm ? e.cm.curOp.id : NaN), ho(e, t, r, Mt(e, t));
              var n = [];
              Ii(e, function (e, r) {
                r || -1 != W(n, e.history) || (bo(e.history, t), n.push(e.history)), ho(e, t, null, Mt(e, t));
              });
            }
          }
          function fo(e, t, r) {
            var n = e.cm && e.cm.state.suppressEdits;
            if (!n || r) {
              for (var i, o = e.history, a = e.sel, s = "undo" == t ? o.done : o.undone, l = "undo" == t ? o.undone : o.done, c = 0; c < s.length && (i = s[c], r ? !i.ranges || i.equals(e.sel) : i.ranges); c++) {
                ;
              }
              if (c != s.length) {
                for (o.lastOrigin = o.lastSelOrigin = null;;) {
                  if (!(i = s.pop()).ranges) {
                    if (n) return void s.push(i);
                    break;
                  }
                  if (Ui(i, l), r && !i.equals(e.sel)) return void eo(e, i, {
                    clearRedo: !1
                  });
                  a = i;
                }
                var u = [];
                Ui(a, l), l.push({
                  changes: u,
                  generation: o.generation
                }), o.generation = i.generation || ++o.maxGeneration;
                for (var d = ve(e, "beforeChange") || e.cm && ve(e.cm, "beforeChange"), p = function p(r) {
                    var n = i.changes[r];
                    if (n.origin = t, d && !co(e, n, !1)) return s.length = 0, {};
                    u.push(Fi(e, n));
                    var o = r ? Li(e, n) : Z(s);
                    ho(e, n, o, Vi(e, n)), !r && e.cm && e.cm.scrollIntoView({
                      from: n.from,
                      to: Mi(n)
                    });
                    var a = [];
                    Ii(e, function (e, t) {
                      t || -1 != W(a, e.history) || (bo(e.history, n), a.push(e.history)), ho(e, n, null, Vi(e, n));
                    });
                  }, f = i.changes.length - 1; f >= 0; --f) {
                  var m = p(f);
                  if (m) return m.v;
                }
              }
            }
          }
          function mo(e, t) {
            if (0 != t && (e.first += t, e.sel = new _i(X(e.sel.ranges, function (e) {
              return new Si(tt(e.anchor.line + t, e.anchor.ch), tt(e.head.line + t, e.head.ch));
            }), e.sel.primIndex), e.cm)) {
              pn(e.cm, e.first, e.first - t, t);
              for (var r = e.cm.display, n = r.viewFrom; n < r.viewTo; n++) {
                fn(e.cm, n, "gutter");
              }
            }
          }
          function ho(e, t, r, n) {
            if (e.cm && !e.cm.curOp) return ti(e.cm, ho)(e, t, r, n);
            if (t.to.line < e.first) mo(e, t.text.length - 1 - (t.to.line - t.from.line));else if (!(t.from.line > e.lastLine())) {
              if (t.from.line < e.first) {
                var i = t.text.length - 1 - (e.first - t.from.line);
                mo(e, i), t = {
                  from: tt(e.first, 0),
                  to: tt(t.to.line + i, t.to.ch),
                  text: [Z(t.text)],
                  origin: t.origin
                };
              }
              var o = e.lastLine();
              t.to.line > o && (t = {
                from: t.from,
                to: tt(o, Ge(e, o).text.length),
                text: [t.text[0]],
                origin: t.origin
              }), t.removed = Ke(e, t.from, t.to), r || (r = Li(e, t)), e.cm ? function (e, t, r) {
                var n = e.doc,
                  i = e.display,
                  o = t.from,
                  a = t.to,
                  s = !1,
                  l = o.line;
                e.options.lineWrapping || (l = Ye(Ft(Ge(n, o.line))), n.iter(l, a.line + 1, function (e) {
                  if (e == i.maxLine) return s = !0, !0;
                })), n.sel.contains(t.from, t.to) > -1 && ye(e), Di(n, t, r, ln(e)), e.options.lineWrapping || (n.iter(l, o.line + t.text.length, function (e) {
                  var t = Bt(e);
                  t > i.maxLineLength && (i.maxLine = e, i.maxLineLength = t, i.maxLineChanged = !0, s = !1);
                }), s && (e.curOp.updateMaxLine = !0)), function (e, t) {
                  if (e.modeFrontier = Math.min(e.modeFrontier, t), !(e.highlightFrontier < t - 10)) {
                    for (var r = e.first, n = t - 1; n > r; n--) {
                      var i = Ge(e, n).stateAfter;
                      if (i && (!(i instanceof ut) || n + i.lookAhead < t)) {
                        r = n + 1;
                        break;
                      }
                    }
                    e.highlightFrontier = Math.min(e.highlightFrontier, r);
                  }
                }(n, o.line), ii(e, 400);
                var c = t.text.length - (a.line - o.line) - 1;
                t.full ? pn(e) : o.line != a.line || 1 != t.text.length || Oi(e.doc, t) ? pn(e, o.line, a.line + 1, c) : fn(e, o.line, "text");
                var u = ve(e, "changes"),
                  d = ve(e, "change");
                if (d || u) {
                  var p = {
                    from: o,
                    to: a,
                    text: t.text,
                    removed: t.removed,
                    origin: t.origin
                  };
                  d && lr(e, "change", e, p), u && (e.curOp.changeObjs || (e.curOp.changeObjs = [])).push(p);
                }
                e.display.selForContextMenu = null;
              }(e.cm, t, n) : Di(e, t, n), to(e, r, U), e.cantEdit && ao(e, tt(e.firstLine(), 0)) && (e.cantEdit = !1);
            }
          }
          function go(e, t, r, n, i) {
            var o;
            n || (n = r), rt(n, r) < 0 && (r = (o = [n, r])[0], n = o[1]), "string" == typeof t && (t = e.splitLines(t)), uo(e, {
              from: r,
              to: n,
              text: t,
              origin: i
            });
          }
          function yo(e, t, r, n) {
            r < e.line ? e.line += n : t < e.line && (e.line = t, e.ch = 0);
          }
          function vo(e, t, r, n) {
            for (var i = 0; i < e.length; ++i) {
              var o = e[i],
                a = !0;
              if (o.ranges) {
                o.copied || ((o = e[i] = o.deepCopy()).copied = !0);
                for (var s = 0; s < o.ranges.length; s++) {
                  yo(o.ranges[s].anchor, t, r, n), yo(o.ranges[s].head, t, r, n);
                }
              } else {
                for (var l = 0; l < o.changes.length; ++l) {
                  var c = o.changes[l];
                  if (r < c.from.line) c.from = tt(c.from.line + n, c.from.ch), c.to = tt(c.to.line + n, c.to.ch);else if (t <= c.to.line) {
                    a = !1;
                    break;
                  }
                }
                a || (e.splice(0, i + 1), i = 0);
              }
            }
          }
          function bo(e, t) {
            var r = t.from.line,
              n = t.to.line,
              i = t.text.length - (n - r) - 1;
            vo(e.done, r, n, i), vo(e.undone, r, n, i);
          }
          function xo(e, t, r, n) {
            var i = t,
              o = t;
            return "number" == typeof t ? o = Ge(e, st(e, t)) : i = Ye(t), null == i ? null : (n(o, i) && e.cm && fn(e.cm, i, r), o);
          }
          function ko(e) {
            this.lines = e, this.parent = null;
            for (var t = 0, r = 0; r < e.length; ++r) {
              e[r].parent = this, t += e[r].height;
            }
            this.height = t;
          }
          function wo(e) {
            this.children = e;
            for (var t = 0, r = 0, n = 0; n < e.length; ++n) {
              var i = e[n];
              t += i.chunkSize(), r += i.height, i.parent = this;
            }
            this.size = t, this.height = r, this.parent = null;
          }
          Si.prototype.from = function () {
            return at(this.anchor, this.head);
          }, Si.prototype.to = function () {
            return ot(this.anchor, this.head);
          }, Si.prototype.empty = function () {
            return this.head.line == this.anchor.line && this.head.ch == this.anchor.ch;
          }, ko.prototype = {
            chunkSize: function chunkSize() {
              return this.lines.length;
            },
            removeInner: function removeInner(e, t) {
              for (var r = e, n = e + t; r < n; ++r) {
                var i = this.lines[r];
                this.height -= i.height, Kt(i), lr(i, "delete");
              }
              this.lines.splice(e, t);
            },
            collapse: function collapse(e) {
              e.push.apply(e, this.lines);
            },
            insertInner: function insertInner(e, t, r) {
              this.height += r, this.lines = this.lines.slice(0, e).concat(t).concat(this.lines.slice(e));
              for (var n = 0; n < t.length; ++n) {
                t[n].parent = this;
              }
            },
            iterN: function iterN(e, t, r) {
              for (var n = e + t; e < n; ++e) {
                if (r(this.lines[e])) return !0;
              }
            }
          }, wo.prototype = {
            chunkSize: function chunkSize() {
              return this.size;
            },
            removeInner: function removeInner(e, t) {
              this.size -= t;
              for (var r = 0; r < this.children.length; ++r) {
                var n = this.children[r],
                  i = n.chunkSize();
                if (e < i) {
                  var o = Math.min(t, i - e),
                    a = n.height;
                  if (n.removeInner(e, o), this.height -= a - n.height, i == o && (this.children.splice(r--, 1), n.parent = null), 0 == (t -= o)) break;
                  e = 0;
                } else e -= i;
              }
              if (this.size - t < 25 && (this.children.length > 1 || !(this.children[0] instanceof ko))) {
                var s = [];
                this.collapse(s), this.children = [new ko(s)], this.children[0].parent = this;
              }
            },
            collapse: function collapse(e) {
              for (var t = 0; t < this.children.length; ++t) {
                this.children[t].collapse(e);
              }
            },
            insertInner: function insertInner(e, t, r) {
              this.size += t.length, this.height += r;
              for (var n = 0; n < this.children.length; ++n) {
                var i = this.children[n],
                  o = i.chunkSize();
                if (e <= o) {
                  if (i.insertInner(e, t, r), i.lines && i.lines.length > 50) {
                    for (var a = i.lines.length % 25 + 25, s = a; s < i.lines.length;) {
                      var l = new ko(i.lines.slice(s, s += 25));
                      i.height -= l.height, this.children.splice(++n, 0, l), l.parent = this;
                    }
                    i.lines = i.lines.slice(0, a), this.maybeSpill();
                  }
                  break;
                }
                e -= o;
              }
            },
            maybeSpill: function maybeSpill() {
              if (!(this.children.length <= 10)) {
                var e = this;
                do {
                  var t = new wo(e.children.splice(e.children.length - 5, 5));
                  if (e.parent) {
                    e.size -= t.size, e.height -= t.height;
                    var r = W(e.parent.children, e);
                    e.parent.children.splice(r + 1, 0, t);
                  } else {
                    var n = new wo(e.children);
                    n.parent = e, e.children = [n, t], e = n;
                  }
                  t.parent = e.parent;
                } while (e.children.length > 10);
                e.parent.maybeSpill();
              }
            },
            iterN: function iterN(e, t, r) {
              for (var n = 0; n < this.children.length; ++n) {
                var i = this.children[n],
                  o = i.chunkSize();
                if (e < o) {
                  var a = Math.min(t, o - e);
                  if (i.iterN(e, a, r)) return !0;
                  if (0 == (t -= a)) break;
                  e = 0;
                } else e -= o;
              }
            }
          };
          var _o = function _o(e, t, r) {
            if (r) for (var n in r) {
              r.hasOwnProperty(n) && (this[n] = r[n]);
            }
            this.doc = e, this.node = t;
          };
          function So(e, t, r) {
            Ht(t) < (e.curOp && e.curOp.scrollTop || e.doc.scrollTop) && Nn(e, r);
          }
          _o.prototype.clear = function () {
            var e = this.doc.cm,
              t = this.line.widgets,
              r = this.line,
              n = Ye(r);
            if (null != n && t) {
              for (var i = 0; i < t.length; ++i) {
                t[i] == this && t.splice(i--, 1);
              }
              t.length || (r.widgets = null);
              var o = kr(this);
              Xe(r, Math.max(0, r.height - o)), e && (ei(e, function () {
                So(e, r, -o), fn(e, n, "widget");
              }), lr(e, "lineWidgetCleared", e, this, n));
            }
          }, _o.prototype.changed = function () {
            var e = this,
              t = this.height,
              r = this.doc.cm,
              n = this.line;
            this.height = null;
            var i = kr(this) - t;
            i && ($t(this.doc, n) || Xe(n, n.height + i), r && ei(r, function () {
              r.curOp.forceUpdate = !0, So(r, n, i), lr(r, "lineWidgetChanged", r, e, Ye(n));
            }));
          }, be(_o);
          var Co = 0,
            To = function To(e, t) {
              this.lines = [], this.type = t, this.doc = e, this.id = ++Co;
            };
          function Mo(e, t, r, n, i) {
            if (n && n.shared) return function (e, t, r, n, i) {
              (n = q(n)).shared = !1;
              var o = [Mo(e, t, r, n, i)],
                a = o[0],
                s = n.widgetNode;
              return Ii(e, function (e) {
                s && (n.widgetNode = s.cloneNode(!0)), o.push(Mo(e, lt(e, t), lt(e, r), n, i));
                for (var l = 0; l < e.linked.length; ++l) {
                  if (e.linked[l].isParent) return;
                }
                a = Z(o);
              }), new Eo(o, a);
            }(e, t, r, n, i);
            if (e.cm && !e.cm.curOp) return ti(e.cm, Mo)(e, t, r, n, i);
            var o = new To(e, i),
              a = rt(t, r);
            if (n && q(n, o, !1), a > 0 || 0 == a && !1 !== o.clearWhenEmpty) return o;
            if (o.replacedWith && (o.collapsed = !0, o.widgetNode = N("span", [o.replacedWith], "CodeMirror-widget"), n.handleMouseEvents || o.widgetNode.setAttribute("cm-ignore-events", "true"), n.insertLeft && (o.widgetNode.insertLeft = !0)), o.collapsed) {
              if (qt(e, t.line, t, r, o) || t.line != r.line && qt(e, r.line, t, r, o)) throw new Error("Inserting collapsed marker partially overlapping an existing one");
              _t = !0;
            }
            o.addToHistory && Wi(e, {
              from: t,
              to: r,
              origin: "markText"
            }, e.sel, NaN);
            var s,
              l = t.line,
              c = e.cm;
            if (e.iter(l, r.line + 1, function (e) {
              c && o.collapsed && !c.options.lineWrapping && Ft(e) == c.display.maxLine && (s = !0), o.collapsed && l != t.line && Xe(e, 0), function (e, t) {
                e.markedSpans = e.markedSpans ? e.markedSpans.concat([t]) : [t], t.marker.attachLine(e);
              }(e, new St(o, l == t.line ? t.ch : null, l == r.line ? r.ch : null)), ++l;
            }), o.collapsed && e.iter(t.line, r.line + 1, function (t) {
              $t(e, t) && Xe(t, 0);
            }), o.clearOnEnter && pe(o, "beforeCursorEnter", function () {
              return o.clear();
            }), o.readOnly && (wt = !0, (e.history.done.length || e.history.undone.length) && e.clearHistory()), o.collapsed && (o.id = ++Co, o.atomic = !0), c) {
              if (s && (c.curOp.updateMaxLine = !0), o.collapsed) pn(c, t.line, r.line + 1);else if (o.className || o.startStyle || o.endStyle || o.css || o.attributes || o.title) for (var u = t.line; u <= r.line; u++) {
                fn(c, u, "text");
              }
              o.atomic && no(c.doc), lr(c, "markerAdded", c, o);
            }
            return o;
          }
          To.prototype.clear = function () {
            if (!this.explicitlyCleared) {
              var e = this.doc.cm,
                t = e && !e.curOp;
              if (t && Gn(e), ve(this, "clear")) {
                var r = this.find();
                r && lr(this, "clear", r.from, r.to);
              }
              for (var n = null, i = null, o = 0; o < this.lines.length; ++o) {
                var a = this.lines[o],
                  s = Ct(a.markedSpans, this);
                e && !this.collapsed ? fn(e, Ye(a), "text") : e && (null != s.to && (i = Ye(a)), null != s.from && (n = Ye(a))), a.markedSpans = Tt(a.markedSpans, s), null == s.from && this.collapsed && !$t(this.doc, a) && e && Xe(a, nn(e.display));
              }
              if (e && this.collapsed && !e.options.lineWrapping) for (var l = 0; l < this.lines.length; ++l) {
                var c = Ft(this.lines[l]),
                  u = Bt(c);
                u > e.display.maxLineLength && (e.display.maxLine = c, e.display.maxLineLength = u, e.display.maxLineChanged = !0);
              }
              null != n && e && this.collapsed && pn(e, n, i + 1), this.lines.length = 0, this.explicitlyCleared = !0, this.atomic && this.doc.cantEdit && (this.doc.cantEdit = !1, e && no(e.doc)), e && lr(e, "markerCleared", e, this, n, i), t && Kn(e), this.parent && this.parent.clear();
            }
          }, To.prototype.find = function (e, t) {
            var r, n;
            null == e && "bookmark" == this.type && (e = 1);
            for (var i = 0; i < this.lines.length; ++i) {
              var o = this.lines[i],
                a = Ct(o.markedSpans, this);
              if (null != a.from && (r = tt(t ? o : Ye(o), a.from), -1 == e)) return r;
              if (null != a.to && (n = tt(t ? o : Ye(o), a.to), 1 == e)) return n;
            }
            return r && {
              from: r,
              to: n
            };
          }, To.prototype.changed = function () {
            var e = this,
              t = this.find(-1, !0),
              r = this,
              n = this.doc.cm;
            t && n && ei(n, function () {
              var i = t.line,
                o = Ye(t.line),
                a = Nr(n, o);
              if (a && (qr(a), n.curOp.selectionChanged = n.curOp.forceUpdate = !0), n.curOp.updateMaxLine = !0, !$t(r.doc, i) && null != r.height) {
                var s = r.height;
                r.height = null;
                var l = kr(r) - s;
                l && Xe(i, i.height + l);
              }
              lr(n, "markerChanged", n, e);
            });
          }, To.prototype.attachLine = function (e) {
            if (!this.lines.length && this.doc.cm) {
              var t = this.doc.cm.curOp;
              t.maybeHiddenMarkers && -1 != W(t.maybeHiddenMarkers, this) || (t.maybeUnhiddenMarkers || (t.maybeUnhiddenMarkers = [])).push(this);
            }
            this.lines.push(e);
          }, To.prototype.detachLine = function (e) {
            if (this.lines.splice(W(this.lines, e), 1), !this.lines.length && this.doc.cm) {
              var t = this.doc.cm.curOp;
              (t.maybeHiddenMarkers || (t.maybeHiddenMarkers = [])).push(this);
            }
          }, be(To);
          var Eo = function Eo(e, t) {
            this.markers = e, this.primary = t;
            for (var r = 0; r < e.length; ++r) {
              e[r].parent = this;
            }
          };
          function Lo(e) {
            return e.findMarks(tt(e.first, 0), e.clipPos(tt(e.lastLine())), function (e) {
              return e.parent;
            });
          }
          function Ao(e) {
            for (var t = function t(_t2) {
                var r = e[_t2],
                  n = [r.primary.doc];
                Ii(r.primary.doc, function (e) {
                  return n.push(e);
                });
                for (var i = 0; i < r.markers.length; i++) {
                  var o = r.markers[i];
                  -1 == W(n, o.doc) && (o.parent = null, r.markers.splice(i--, 1));
                }
              }, r = 0; r < e.length; r++) {
              t(r);
            }
          }
          Eo.prototype.clear = function () {
            if (!this.explicitlyCleared) {
              this.explicitlyCleared = !0;
              for (var e = 0; e < this.markers.length; ++e) {
                this.markers[e].clear();
              }
              lr(this, "clear");
            }
          }, Eo.prototype.find = function (e, t) {
            return this.primary.find(e, t);
          }, be(Eo);
          var No = 0,
            zo = function e(t, r, n, i, o) {
              if (!(this instanceof e)) return new e(t, r, n, i, o);
              null == n && (n = 0), wo.call(this, [new ko([new Gt("", null)])]), this.first = n, this.scrollTop = this.scrollLeft = 0, this.cantEdit = !1, this.cleanGeneration = 1, this.modeFrontier = this.highlightFrontier = n;
              var a = tt(n, 0);
              this.sel = Ti(a), this.history = new qi(null), this.id = ++No, this.modeOption = r, this.lineSep = i, this.direction = "rtl" == o ? "rtl" : "ltr", this.extend = !1, "string" == typeof t && (t = this.splitLines(t)), Di(this, {
                from: a,
                to: a,
                text: t
              }), eo(this, Ti(a), U);
            };
          (zo.prototype = Q(wo.prototype, {
            constructor: zo,
            iter: function iter(e, t, r) {
              r ? this.iterN(e - this.first, t - e, r) : this.iterN(this.first, this.first + this.size, e);
            },
            insert: function insert(e, t) {
              for (var r = 0, n = 0; n < t.length; ++n) {
                r += t[n].height;
              }
              this.insertInner(e - this.first, t, r);
            },
            remove: function remove(e, t) {
              this.removeInner(e - this.first, t);
            },
            getValue: function getValue(e) {
              var t = Ze(this, this.first, this.first + this.size);
              return !1 === e ? t : t.join(e || this.lineSeparator());
            },
            setValue: ni(function (e) {
              var t = tt(this.first, 0),
                r = this.first + this.size - 1;
              uo(this, {
                from: t,
                to: tt(r, Ge(this, r).text.length),
                text: this.splitLines(e),
                origin: "setValue",
                full: !0
              }, !0), this.cm && On(this.cm, 0, 0), eo(this, Ti(t), U);
            }),
            replaceRange: function replaceRange(e, t, r, n) {
              go(this, e, t = lt(this, t), r = r ? lt(this, r) : t, n);
            },
            getRange: function getRange(e, t, r) {
              var n = Ke(this, lt(this, e), lt(this, t));
              return !1 === r ? n : n.join(r || this.lineSeparator());
            },
            getLine: function getLine(e) {
              var t = this.getLineHandle(e);
              return t && t.text;
            },
            getLineHandle: function getLineHandle(e) {
              if (Je(this, e)) return Ge(this, e);
            },
            getLineNumber: function getLineNumber(e) {
              return Ye(e);
            },
            getLineHandleVisualStart: function getLineHandleVisualStart(e) {
              return "number" == typeof e && (e = Ge(this, e)), Ft(e);
            },
            lineCount: function lineCount() {
              return this.size;
            },
            firstLine: function firstLine() {
              return this.first;
            },
            lastLine: function lastLine() {
              return this.first + this.size - 1;
            },
            clipPos: function clipPos(e) {
              return lt(this, e);
            },
            getCursor: function getCursor(e) {
              var t = this.sel.primary();
              return null == e || "head" == e ? t.head : "anchor" == e ? t.anchor : "end" == e || "to" == e || !1 === e ? t.to() : t.from();
            },
            listSelections: function listSelections() {
              return this.sel.ranges;
            },
            somethingSelected: function somethingSelected() {
              return this.sel.somethingSelected();
            },
            setCursor: ni(function (e, t, r) {
              Qi(this, lt(this, "number" == typeof e ? tt(e, t || 0) : e), null, r);
            }),
            setSelection: ni(function (e, t, r) {
              Qi(this, lt(this, e), lt(this, t || e), r);
            }),
            extendSelection: ni(function (e, t, r) {
              Zi(this, lt(this, e), t && lt(this, t), r);
            }),
            extendSelections: ni(function (e, t) {
              Xi(this, ct(this, e), t);
            }),
            extendSelectionsBy: ni(function (e, t) {
              Xi(this, ct(this, X(this.sel.ranges, e)), t);
            }),
            setSelections: ni(function (e, t, r) {
              if (e.length) {
                for (var n = [], i = 0; i < e.length; i++) {
                  n[i] = new Si(lt(this, e[i].anchor), lt(this, e[i].head));
                }
                null == t && (t = Math.min(e.length - 1, this.sel.primIndex)), eo(this, Ci(this.cm, n, t), r);
              }
            }),
            addSelection: ni(function (e, t, r) {
              var n = this.sel.ranges.slice(0);
              n.push(new Si(lt(this, e), lt(this, t || e))), eo(this, Ci(this.cm, n, n.length - 1), r);
            }),
            getSelection: function getSelection(e) {
              for (var t, r = this.sel.ranges, n = 0; n < r.length; n++) {
                var i = Ke(this, r[n].from(), r[n].to());
                t = t ? t.concat(i) : i;
              }
              return !1 === e ? t : t.join(e || this.lineSeparator());
            },
            getSelections: function getSelections(e) {
              for (var t = [], r = this.sel.ranges, n = 0; n < r.length; n++) {
                var i = Ke(this, r[n].from(), r[n].to());
                !1 !== e && (i = i.join(e || this.lineSeparator())), t[n] = i;
              }
              return t;
            },
            replaceSelection: function replaceSelection(e, t, r) {
              for (var n = [], i = 0; i < this.sel.ranges.length; i++) {
                n[i] = e;
              }
              this.replaceSelections(n, t, r || "+input");
            },
            replaceSelections: ni(function (e, t, r) {
              for (var n = [], i = this.sel, o = 0; o < i.ranges.length; o++) {
                var a = i.ranges[o];
                n[o] = {
                  from: a.from(),
                  to: a.to(),
                  text: this.splitLines(e[o]),
                  origin: r
                };
              }
              for (var s = t && "end" != t && function (e, t, r) {
                  for (var n = [], i = tt(e.first, 0), o = i, a = 0; a < t.length; a++) {
                    var s = t[a],
                      l = Ai(s.from, i, o),
                      c = Ai(Mi(s), i, o);
                    if (i = s.to, o = c, "around" == r) {
                      var u = e.sel.ranges[a],
                        d = rt(u.head, u.anchor) < 0;
                      n[a] = new Si(d ? c : l, d ? l : c);
                    } else n[a] = new Si(l, l);
                  }
                  return new _i(n, e.sel.primIndex);
                }(this, n, t), l = n.length - 1; l >= 0; l--) {
                uo(this, n[l]);
              }
              s ? Ji(this, s) : this.cm && zn(this.cm);
            }),
            undo: ni(function () {
              fo(this, "undo");
            }),
            redo: ni(function () {
              fo(this, "redo");
            }),
            undoSelection: ni(function () {
              fo(this, "undo", !0);
            }),
            redoSelection: ni(function () {
              fo(this, "redo", !0);
            }),
            setExtending: function setExtending(e) {
              this.extend = e;
            },
            getExtending: function getExtending() {
              return this.extend;
            },
            historySize: function historySize() {
              for (var e = this.history, t = 0, r = 0, n = 0; n < e.done.length; n++) {
                e.done[n].ranges || ++t;
              }
              for (var i = 0; i < e.undone.length; i++) {
                e.undone[i].ranges || ++r;
              }
              return {
                undo: t,
                redo: r
              };
            },
            clearHistory: function clearHistory() {
              var e = this;
              this.history = new qi(this.history.maxGeneration), Ii(this, function (t) {
                return t.history = e.history;
              }, !0);
            },
            markClean: function markClean() {
              this.cleanGeneration = this.changeGeneration(!0);
            },
            changeGeneration: function changeGeneration(e) {
              return e && (this.history.lastOp = this.history.lastSelOp = this.history.lastOrigin = null), this.history.generation;
            },
            isClean: function isClean(e) {
              return this.history.generation == (e || this.cleanGeneration);
            },
            getHistory: function getHistory() {
              return {
                done: Gi(this.history.done),
                undone: Gi(this.history.undone)
              };
            },
            setHistory: function setHistory(e) {
              var t = this.history = new qi(this.history.maxGeneration);
              t.done = Gi(e.done.slice(0), null, !0), t.undone = Gi(e.undone.slice(0), null, !0);
            },
            setGutterMarker: ni(function (e, t, r) {
              return xo(this, e, "gutter", function (e) {
                var n = e.gutterMarkers || (e.gutterMarkers = {});
                return n[t] = r, !r && re(n) && (e.gutterMarkers = null), !0;
              });
            }),
            clearGutter: ni(function (e) {
              var t = this;
              this.iter(function (r) {
                r.gutterMarkers && r.gutterMarkers[e] && xo(t, r, "gutter", function () {
                  return r.gutterMarkers[e] = null, re(r.gutterMarkers) && (r.gutterMarkers = null), !0;
                });
              });
            }),
            lineInfo: function lineInfo(e) {
              var t;
              if ("number" == typeof e) {
                if (!Je(this, e)) return null;
                if (t = e, !(e = Ge(this, e))) return null;
              } else if (null == (t = Ye(e))) return null;
              return {
                line: t,
                handle: e,
                text: e.text,
                gutterMarkers: e.gutterMarkers,
                textClass: e.textClass,
                bgClass: e.bgClass,
                wrapClass: e.wrapClass,
                widgets: e.widgets
              };
            },
            addLineClass: ni(function (e, t, r) {
              return xo(this, e, "gutter" == t ? "gutter" : "class", function (e) {
                var n = "text" == t ? "textClass" : "background" == t ? "bgClass" : "gutter" == t ? "gutterClass" : "wrapClass";
                if (e[n]) {
                  if (C(r).test(e[n])) return !1;
                  e[n] += " " + r;
                } else e[n] = r;
                return !0;
              });
            }),
            removeLineClass: ni(function (e, t, r) {
              return xo(this, e, "gutter" == t ? "gutter" : "class", function (e) {
                var n = "text" == t ? "textClass" : "background" == t ? "bgClass" : "gutter" == t ? "gutterClass" : "wrapClass",
                  i = e[n];
                if (!i) return !1;
                if (null == r) e[n] = null;else {
                  var o = i.match(C(r));
                  if (!o) return !1;
                  var a = o.index + o[0].length;
                  e[n] = i.slice(0, o.index) + (o.index && a != i.length ? " " : "") + i.slice(a) || null;
                }
                return !0;
              });
            }),
            addLineWidget: ni(function (e, t, r) {
              return function (e, t, r, n) {
                var i = new _o(e, r, n),
                  o = e.cm;
                return o && i.noHScroll && (o.display.alignWidgets = !0), xo(e, t, "widget", function (t) {
                  var r = t.widgets || (t.widgets = []);
                  if (null == i.insertAt ? r.push(i) : r.splice(Math.min(r.length - 1, Math.max(0, i.insertAt)), 0, i), i.line = t, o && !$t(e, t)) {
                    var n = Ht(t) < e.scrollTop;
                    Xe(t, t.height + kr(i)), n && Nn(o, i.height), o.curOp.forceUpdate = !0;
                  }
                  return !0;
                }), o && lr(o, "lineWidgetAdded", o, i, "number" == typeof t ? t : Ye(t)), i;
              }(this, e, t, r);
            }),
            removeLineWidget: function removeLineWidget(e) {
              e.clear();
            },
            markText: function markText(e, t, r) {
              return Mo(this, lt(this, e), lt(this, t), r, r && r.type || "range");
            },
            setBookmark: function setBookmark(e, t) {
              var r = {
                replacedWith: t && (null == t.nodeType ? t.widget : t),
                insertLeft: t && t.insertLeft,
                clearWhenEmpty: !1,
                shared: t && t.shared,
                handleMouseEvents: t && t.handleMouseEvents
              };
              return Mo(this, e = lt(this, e), e, r, "bookmark");
            },
            findMarksAt: function findMarksAt(e) {
              var t = [],
                r = Ge(this, (e = lt(this, e)).line).markedSpans;
              if (r) for (var n = 0; n < r.length; ++n) {
                var i = r[n];
                (null == i.from || i.from <= e.ch) && (null == i.to || i.to >= e.ch) && t.push(i.marker.parent || i.marker);
              }
              return t;
            },
            findMarks: function findMarks(e, t, r) {
              e = lt(this, e), t = lt(this, t);
              var n = [],
                i = e.line;
              return this.iter(e.line, t.line + 1, function (o) {
                var a = o.markedSpans;
                if (a) for (var s = 0; s < a.length; s++) {
                  var l = a[s];
                  null != l.to && i == e.line && e.ch >= l.to || null == l.from && i != e.line || null != l.from && i == t.line && l.from >= t.ch || r && !r(l.marker) || n.push(l.marker.parent || l.marker);
                }
                ++i;
              }), n;
            },
            getAllMarks: function getAllMarks() {
              var e = [];
              return this.iter(function (t) {
                var r = t.markedSpans;
                if (r) for (var n = 0; n < r.length; ++n) {
                  null != r[n].from && e.push(r[n].marker);
                }
              }), e;
            },
            posFromIndex: function posFromIndex(e) {
              var t,
                r = this.first,
                n = this.lineSeparator().length;
              return this.iter(function (i) {
                var o = i.text.length + n;
                if (o > e) return t = e, !0;
                e -= o, ++r;
              }), lt(this, tt(r, t));
            },
            indexFromPos: function indexFromPos(e) {
              var t = (e = lt(this, e)).ch;
              if (e.line < this.first || e.ch < 0) return 0;
              var r = this.lineSeparator().length;
              return this.iter(this.first, e.line, function (e) {
                t += e.text.length + r;
              }), t;
            },
            copy: function copy(e) {
              var t = new zo(Ze(this, this.first, this.first + this.size), this.modeOption, this.first, this.lineSep, this.direction);
              return t.scrollTop = this.scrollTop, t.scrollLeft = this.scrollLeft, t.sel = this.sel, t.extend = !1, e && (t.history.undoDepth = this.history.undoDepth, t.setHistory(this.getHistory())), t;
            },
            linkedDoc: function linkedDoc(e) {
              e || (e = {});
              var t = this.first,
                r = this.first + this.size;
              null != e.from && e.from > t && (t = e.from), null != e.to && e.to < r && (r = e.to);
              var n = new zo(Ze(this, t, r), e.mode || this.modeOption, t, this.lineSep, this.direction);
              return e.sharedHist && (n.history = this.history), (this.linked || (this.linked = [])).push({
                doc: n,
                sharedHist: e.sharedHist
              }), n.linked = [{
                doc: this,
                isParent: !0,
                sharedHist: e.sharedHist
              }], function (e, t) {
                for (var r = 0; r < t.length; r++) {
                  var n = t[r],
                    i = n.find(),
                    o = e.clipPos(i.from),
                    a = e.clipPos(i.to);
                  if (rt(o, a)) {
                    var s = Mo(e, o, a, n.primary, n.primary.type);
                    n.markers.push(s), s.parent = n;
                  }
                }
              }(n, Lo(this)), n;
            },
            unlinkDoc: function unlinkDoc(e) {
              if (e instanceof Ea && (e = e.doc), this.linked) for (var t = 0; t < this.linked.length; ++t) {
                if (this.linked[t].doc == e) {
                  this.linked.splice(t, 1), e.unlinkDoc(this), Ao(Lo(this));
                  break;
                }
              }
              if (e.history == this.history) {
                var r = [e.id];
                Ii(e, function (e) {
                  return r.push(e.id);
                }, !0), e.history = new qi(null), e.history.done = Gi(this.history.done, r), e.history.undone = Gi(this.history.undone, r);
              }
            },
            iterLinkedDocs: function iterLinkedDocs(e) {
              Ii(this, e);
            },
            getMode: function getMode() {
              return this.mode;
            },
            getEditor: function getEditor() {
              return this.cm;
            },
            splitLines: function splitLines(e) {
              return this.lineSep ? e.split(this.lineSep) : ze(e);
            },
            lineSeparator: function lineSeparator() {
              return this.lineSep || "\n";
            },
            setDirection: ni(function (e) {
              var t;
              "rtl" != e && (e = "ltr"), e != this.direction && (this.direction = e, this.iter(function (e) {
                return e.order = null;
              }), this.cm && ei(t = this.cm, function () {
                ji(t), pn(t);
              }));
            })
          })).eachLine = zo.prototype.iter;
          var Oo = 0;
          function Do(e) {
            var t = this;
            if (Io(t), !ge(t, e) && !wr(t.display, e)) {
              xe(e), s && (Oo = +new Date());
              var r = un(t, e, !0),
                n = e.dataTransfer.files;
              if (r && !t.isReadOnly()) if (n && n.length && window.FileReader && window.File) for (var i = n.length, o = Array(i), a = 0, l = function l() {
                  ++a == i && ti(t, function () {
                    var e = {
                      from: r = lt(t.doc, r),
                      to: r,
                      text: t.doc.splitLines(o.filter(function (e) {
                        return null != e;
                      }).join(t.doc.lineSeparator())),
                      origin: "paste"
                    };
                    uo(t.doc, e), Ji(t.doc, Ti(lt(t.doc, r), lt(t.doc, Mi(e))));
                  })();
                }, c = function c(e, r) {
                  if (t.options.allowDropFileTypes && -1 == W(t.options.allowDropFileTypes, e.type)) l();else {
                    var n = new FileReader();
                    n.onerror = function () {
                      return l();
                    }, n.onload = function () {
                      var e = n.result;
                      /[\x00-\x08\x0e-\x1f]{2}/.test(e) || (o[r] = e), l();
                    }, n.readAsText(e);
                  }
                }, u = 0; u < n.length; u++) {
                c(n[u], u);
              } else {
                if (t.state.draggingText && t.doc.sel.contains(r) > -1) return t.state.draggingText(e), void setTimeout(function () {
                  return t.display.input.focus();
                }, 20);
                try {
                  var d = e.dataTransfer.getData("Text");
                  if (d) {
                    var p;
                    if (t.state.draggingText && !t.state.draggingText.copy && (p = t.listSelections()), to(t.doc, Ti(r, r)), p) for (var f = 0; f < p.length; ++f) {
                      go(t.doc, "", p[f].anchor, p[f].head, "drag");
                    }
                    t.replaceSelection(d, "around", "paste"), t.display.input.focus();
                  }
                } catch (e) {}
              }
            }
          }
          function Io(e) {
            e.display.dragCursor && (e.display.lineSpace.removeChild(e.display.dragCursor), e.display.dragCursor = null);
          }
          function Po(e) {
            if (document.getElementsByClassName) {
              for (var t = document.getElementsByClassName("CodeMirror"), r = [], n = 0; n < t.length; n++) {
                var i = t[n].CodeMirror;
                i && r.push(i);
              }
              r.length && r[0].operation(function () {
                for (var t = 0; t < r.length; t++) {
                  e(r[t]);
                }
              });
            }
          }
          var jo = !1;
          function qo() {
            var e;
            jo || (pe(window, "resize", function () {
              null == e && (e = setTimeout(function () {
                e = null, Po(Fo);
              }, 100));
            }), pe(window, "blur", function () {
              return Po(Tn);
            }), jo = !0);
          }
          function Fo(e) {
            var t = e.display;
            t.cachedCharWidth = t.cachedTextHeight = t.cachedPaddingH = null, t.scrollbarsClipped = !1, e.setSize();
          }
          for (var Ro = {
              3: "Pause",
              8: "Backspace",
              9: "Tab",
              13: "Enter",
              16: "Shift",
              17: "Ctrl",
              18: "Alt",
              19: "Pause",
              20: "CapsLock",
              27: "Esc",
              32: "Space",
              33: "PageUp",
              34: "PageDown",
              35: "End",
              36: "Home",
              37: "Left",
              38: "Up",
              39: "Right",
              40: "Down",
              44: "PrintScrn",
              45: "Insert",
              46: "Delete",
              59: ";",
              61: "=",
              91: "Mod",
              92: "Mod",
              93: "Mod",
              106: "*",
              107: "=",
              109: "-",
              110: ".",
              111: "/",
              145: "ScrollLock",
              173: "-",
              186: ";",
              187: "=",
              188: ",",
              189: "-",
              190: ".",
              191: "/",
              192: "`",
              219: "[",
              220: "\\",
              221: "]",
              222: "'",
              63232: "Up",
              63233: "Down",
              63234: "Left",
              63235: "Right",
              63272: "Delete",
              63273: "Home",
              63275: "End",
              63276: "PageUp",
              63277: "PageDown",
              63302: "Insert"
            }, Wo = 0; Wo < 10; Wo++) {
            Ro[Wo + 48] = Ro[Wo + 96] = String(Wo);
          }
          for (var $o = 65; $o <= 90; $o++) {
            Ro[$o] = String.fromCharCode($o);
          }
          for (var Uo = 1; Uo <= 12; Uo++) {
            Ro[Uo + 111] = Ro[Uo + 63235] = "F" + Uo;
          }
          var Ho = {};
          function Bo(e) {
            var t,
              r,
              n,
              i,
              o = e.split(/-(?!$)/);
            e = o[o.length - 1];
            for (var a = 0; a < o.length - 1; a++) {
              var s = o[a];
              if (/^(cmd|meta|m)$/i.test(s)) i = !0;else if (/^a(lt)?$/i.test(s)) t = !0;else if (/^(c|ctrl|control)$/i.test(s)) r = !0;else {
                if (!/^s(hift)?$/i.test(s)) throw new Error("Unrecognized modifier name: " + s);
                n = !0;
              }
            }
            return t && (e = "Alt-" + e), r && (e = "Ctrl-" + e), i && (e = "Cmd-" + e), n && (e = "Shift-" + e), e;
          }
          function Vo(e) {
            var t = {};
            for (var r in e) {
              if (e.hasOwnProperty(r)) {
                var n = e[r];
                if (/^(name|fallthrough|(de|at)tach)$/.test(r)) continue;
                if ("..." == n) {
                  delete e[r];
                  continue;
                }
                for (var i = X(r.split(" "), Bo), o = 0; o < i.length; o++) {
                  var a = void 0,
                    s = void 0;
                  o == i.length - 1 ? (s = i.join(" "), a = n) : (s = i.slice(0, o + 1).join(" "), a = "...");
                  var l = t[s];
                  if (l) {
                    if (l != a) throw new Error("Inconsistent bindings for " + s);
                  } else t[s] = a;
                }
                delete e[r];
              }
            }
            for (var c in t) {
              e[c] = t[c];
            }
            return e;
          }
          function Go(e, t, r, n) {
            var i = (t = Yo(t)).call ? t.call(e, n) : t[e];
            if (!1 === i) return "nothing";
            if ("..." === i) return "multi";
            if (null != i && r(i)) return "handled";
            if (t.fallthrough) {
              if ("[object Array]" != Object.prototype.toString.call(t.fallthrough)) return Go(e, t.fallthrough, r, n);
              for (var o = 0; o < t.fallthrough.length; o++) {
                var a = Go(e, t.fallthrough[o], r, n);
                if (a) return a;
              }
            }
          }
          function Ko(e) {
            var t = "string" == typeof e ? e : Ro[e.keyCode];
            return "Ctrl" == t || "Alt" == t || "Shift" == t || "Mod" == t;
          }
          function Zo(e, t, r) {
            var n = e;
            return t.altKey && "Alt" != n && (e = "Alt-" + e), (_ ? t.metaKey : t.ctrlKey) && "Ctrl" != n && (e = "Ctrl-" + e), (_ ? t.ctrlKey : t.metaKey) && "Cmd" != n && (e = "Cmd-" + e), !r && t.shiftKey && "Shift" != n && (e = "Shift-" + e), e;
          }
          function Xo(e, t) {
            if (p && 34 == e.keyCode && e.char) return !1;
            var r = Ro[e.keyCode];
            return null != r && !e.altGraphKey && (3 == e.keyCode && e.code && (r = e.code), Zo(r, e, t));
          }
          function Yo(e) {
            return "string" == typeof e ? Ho[e] : e;
          }
          function Qo(e, t) {
            for (var r = e.doc.sel.ranges, n = [], i = 0; i < r.length; i++) {
              for (var o = t(r[i]); n.length && rt(o.from, Z(n).to) <= 0;) {
                var a = n.pop();
                if (rt(a.from, o.from) < 0) {
                  o.from = a.from;
                  break;
                }
              }
              n.push(o);
            }
            ei(e, function () {
              for (var t = n.length - 1; t >= 0; t--) {
                go(e.doc, "", n[t].from, n[t].to, "+delete");
              }
              zn(e);
            });
          }
          function Jo(e, t, r) {
            var n = oe(e.text, t + r, r);
            return n < 0 || n > e.text.length ? null : n;
          }
          function ea(e, t, r) {
            var n = Jo(e, t.ch, r);
            return null == n ? null : new tt(t.line, n, r < 0 ? "after" : "before");
          }
          function ta(e, t, r, n, i) {
            if (e) {
              "rtl" == t.doc.direction && (i = -i);
              var o = ue(r, t.doc.direction);
              if (o) {
                var a,
                  s = i < 0 ? Z(o) : o[0],
                  l = i < 0 == (1 == s.level) ? "after" : "before";
                if (s.level > 0 || "rtl" == t.doc.direction) {
                  var c = zr(t, r);
                  a = i < 0 ? r.text.length - 1 : 0;
                  var u = Or(t, c, a).top;
                  a = ae(function (e) {
                    return Or(t, c, e).top == u;
                  }, i < 0 == (1 == s.level) ? s.from : s.to - 1, a), "before" == l && (a = Jo(r, a, 1));
                } else a = i < 0 ? s.to : s.from;
                return new tt(n, a, l);
              }
            }
            return new tt(n, i < 0 ? r.text.length : 0, i < 0 ? "before" : "after");
          }
          Ho.basic = {
            Left: "goCharLeft",
            Right: "goCharRight",
            Up: "goLineUp",
            Down: "goLineDown",
            End: "goLineEnd",
            Home: "goLineStartSmart",
            PageUp: "goPageUp",
            PageDown: "goPageDown",
            Delete: "delCharAfter",
            Backspace: "delCharBefore",
            "Shift-Backspace": "delCharBefore",
            Tab: "defaultTab",
            "Shift-Tab": "indentAuto",
            Enter: "newlineAndIndent",
            Insert: "toggleOverwrite",
            Esc: "singleSelection"
          }, Ho.pcDefault = {
            "Ctrl-A": "selectAll",
            "Ctrl-D": "deleteLine",
            "Ctrl-Z": "undo",
            "Shift-Ctrl-Z": "redo",
            "Ctrl-Y": "redo",
            "Ctrl-Home": "goDocStart",
            "Ctrl-End": "goDocEnd",
            "Ctrl-Up": "goLineUp",
            "Ctrl-Down": "goLineDown",
            "Ctrl-Left": "goGroupLeft",
            "Ctrl-Right": "goGroupRight",
            "Alt-Left": "goLineStart",
            "Alt-Right": "goLineEnd",
            "Ctrl-Backspace": "delGroupBefore",
            "Ctrl-Delete": "delGroupAfter",
            "Ctrl-S": "save",
            "Ctrl-F": "find",
            "Ctrl-G": "findNext",
            "Shift-Ctrl-G": "findPrev",
            "Shift-Ctrl-F": "replace",
            "Shift-Ctrl-R": "replaceAll",
            "Ctrl-[": "indentLess",
            "Ctrl-]": "indentMore",
            "Ctrl-U": "undoSelection",
            "Shift-Ctrl-U": "redoSelection",
            "Alt-U": "redoSelection",
            fallthrough: "basic"
          }, Ho.emacsy = {
            "Ctrl-F": "goCharRight",
            "Ctrl-B": "goCharLeft",
            "Ctrl-P": "goLineUp",
            "Ctrl-N": "goLineDown",
            "Alt-F": "goWordRight",
            "Alt-B": "goWordLeft",
            "Ctrl-A": "goLineStart",
            "Ctrl-E": "goLineEnd",
            "Ctrl-V": "goPageDown",
            "Shift-Ctrl-V": "goPageUp",
            "Ctrl-D": "delCharAfter",
            "Ctrl-H": "delCharBefore",
            "Alt-D": "delWordAfter",
            "Alt-Backspace": "delWordBefore",
            "Ctrl-K": "killLine",
            "Ctrl-T": "transposeChars",
            "Ctrl-O": "openLine"
          }, Ho.macDefault = {
            "Cmd-A": "selectAll",
            "Cmd-D": "deleteLine",
            "Cmd-Z": "undo",
            "Shift-Cmd-Z": "redo",
            "Cmd-Y": "redo",
            "Cmd-Home": "goDocStart",
            "Cmd-Up": "goDocStart",
            "Cmd-End": "goDocEnd",
            "Cmd-Down": "goDocEnd",
            "Alt-Left": "goGroupLeft",
            "Alt-Right": "goGroupRight",
            "Cmd-Left": "goLineLeft",
            "Cmd-Right": "goLineRight",
            "Alt-Backspace": "delGroupBefore",
            "Ctrl-Alt-Backspace": "delGroupAfter",
            "Alt-Delete": "delGroupAfter",
            "Cmd-S": "save",
            "Cmd-F": "find",
            "Cmd-G": "findNext",
            "Shift-Cmd-G": "findPrev",
            "Cmd-Alt-F": "replace",
            "Shift-Cmd-Alt-F": "replaceAll",
            "Cmd-[": "indentLess",
            "Cmd-]": "indentMore",
            "Cmd-Backspace": "delWrappedLineLeft",
            "Cmd-Delete": "delWrappedLineRight",
            "Cmd-U": "undoSelection",
            "Shift-Cmd-U": "redoSelection",
            "Ctrl-Up": "goDocStart",
            "Ctrl-Down": "goDocEnd",
            fallthrough: ["basic", "emacsy"]
          }, Ho.default = b ? Ho.macDefault : Ho.pcDefault;
          var ra = {
            selectAll: lo,
            singleSelection: function singleSelection(e) {
              return e.setSelection(e.getCursor("anchor"), e.getCursor("head"), U);
            },
            killLine: function killLine(e) {
              return Qo(e, function (t) {
                if (t.empty()) {
                  var r = Ge(e.doc, t.head.line).text.length;
                  return t.head.ch == r && t.head.line < e.lastLine() ? {
                    from: t.head,
                    to: tt(t.head.line + 1, 0)
                  } : {
                    from: t.head,
                    to: tt(t.head.line, r)
                  };
                }
                return {
                  from: t.from(),
                  to: t.to()
                };
              });
            },
            deleteLine: function deleteLine(e) {
              return Qo(e, function (t) {
                return {
                  from: tt(t.from().line, 0),
                  to: lt(e.doc, tt(t.to().line + 1, 0))
                };
              });
            },
            delLineLeft: function delLineLeft(e) {
              return Qo(e, function (e) {
                return {
                  from: tt(e.from().line, 0),
                  to: e.from()
                };
              });
            },
            delWrappedLineLeft: function delWrappedLineLeft(e) {
              return Qo(e, function (t) {
                var r = e.charCoords(t.head, "div").top + 5;
                return {
                  from: e.coordsChar({
                    left: 0,
                    top: r
                  }, "div"),
                  to: t.from()
                };
              });
            },
            delWrappedLineRight: function delWrappedLineRight(e) {
              return Qo(e, function (t) {
                var r = e.charCoords(t.head, "div").top + 5,
                  n = e.coordsChar({
                    left: e.display.lineDiv.offsetWidth + 100,
                    top: r
                  }, "div");
                return {
                  from: t.from(),
                  to: n
                };
              });
            },
            undo: function undo(e) {
              return e.undo();
            },
            redo: function redo(e) {
              return e.redo();
            },
            undoSelection: function undoSelection(e) {
              return e.undoSelection();
            },
            redoSelection: function redoSelection(e) {
              return e.redoSelection();
            },
            goDocStart: function goDocStart(e) {
              return e.extendSelection(tt(e.firstLine(), 0));
            },
            goDocEnd: function goDocEnd(e) {
              return e.extendSelection(tt(e.lastLine()));
            },
            goLineStart: function goLineStart(e) {
              return e.extendSelectionsBy(function (t) {
                return na(e, t.head.line);
              }, {
                origin: "+move",
                bias: 1
              });
            },
            goLineStartSmart: function goLineStartSmart(e) {
              return e.extendSelectionsBy(function (t) {
                return ia(e, t.head);
              }, {
                origin: "+move",
                bias: 1
              });
            },
            goLineEnd: function goLineEnd(e) {
              return e.extendSelectionsBy(function (t) {
                return function (e, t) {
                  var r = Ge(e.doc, t),
                    n = function (e) {
                      for (var t; t = Pt(e);) {
                        e = t.find(1, !0).line;
                      }
                      return e;
                    }(r);
                  return n != r && (t = Ye(n)), ta(!0, e, r, t, -1);
                }(e, t.head.line);
              }, {
                origin: "+move",
                bias: -1
              });
            },
            goLineRight: function goLineRight(e) {
              return e.extendSelectionsBy(function (t) {
                var r = e.cursorCoords(t.head, "div").top + 5;
                return e.coordsChar({
                  left: e.display.lineDiv.offsetWidth + 100,
                  top: r
                }, "div");
              }, B);
            },
            goLineLeft: function goLineLeft(e) {
              return e.extendSelectionsBy(function (t) {
                var r = e.cursorCoords(t.head, "div").top + 5;
                return e.coordsChar({
                  left: 0,
                  top: r
                }, "div");
              }, B);
            },
            goLineLeftSmart: function goLineLeftSmart(e) {
              return e.extendSelectionsBy(function (t) {
                var r = e.cursorCoords(t.head, "div").top + 5,
                  n = e.coordsChar({
                    left: 0,
                    top: r
                  }, "div");
                return n.ch < e.getLine(n.line).search(/\S/) ? ia(e, t.head) : n;
              }, B);
            },
            goLineUp: function goLineUp(e) {
              return e.moveV(-1, "line");
            },
            goLineDown: function goLineDown(e) {
              return e.moveV(1, "line");
            },
            goPageUp: function goPageUp(e) {
              return e.moveV(-1, "page");
            },
            goPageDown: function goPageDown(e) {
              return e.moveV(1, "page");
            },
            goCharLeft: function goCharLeft(e) {
              return e.moveH(-1, "char");
            },
            goCharRight: function goCharRight(e) {
              return e.moveH(1, "char");
            },
            goColumnLeft: function goColumnLeft(e) {
              return e.moveH(-1, "column");
            },
            goColumnRight: function goColumnRight(e) {
              return e.moveH(1, "column");
            },
            goWordLeft: function goWordLeft(e) {
              return e.moveH(-1, "word");
            },
            goGroupRight: function goGroupRight(e) {
              return e.moveH(1, "group");
            },
            goGroupLeft: function goGroupLeft(e) {
              return e.moveH(-1, "group");
            },
            goWordRight: function goWordRight(e) {
              return e.moveH(1, "word");
            },
            delCharBefore: function delCharBefore(e) {
              return e.deleteH(-1, "char");
            },
            delCharAfter: function delCharAfter(e) {
              return e.deleteH(1, "char");
            },
            delWordBefore: function delWordBefore(e) {
              return e.deleteH(-1, "word");
            },
            delWordAfter: function delWordAfter(e) {
              return e.deleteH(1, "word");
            },
            delGroupBefore: function delGroupBefore(e) {
              return e.deleteH(-1, "group");
            },
            delGroupAfter: function delGroupAfter(e) {
              return e.deleteH(1, "group");
            },
            indentAuto: function indentAuto(e) {
              return e.indentSelection("smart");
            },
            indentMore: function indentMore(e) {
              return e.indentSelection("add");
            },
            indentLess: function indentLess(e) {
              return e.indentSelection("subtract");
            },
            insertTab: function insertTab(e) {
              return e.replaceSelection("\t");
            },
            insertSoftTab: function insertSoftTab(e) {
              for (var t = [], r = e.listSelections(), n = e.options.tabSize, i = 0; i < r.length; i++) {
                var o = r[i].from(),
                  a = F(e.getLine(o.line), o.ch, n);
                t.push(K(n - a % n));
              }
              e.replaceSelections(t);
            },
            defaultTab: function defaultTab(e) {
              e.somethingSelected() ? e.indentSelection("add") : e.execCommand("insertTab");
            },
            transposeChars: function transposeChars(e) {
              return ei(e, function () {
                for (var t = e.listSelections(), r = [], n = 0; n < t.length; n++) {
                  if (t[n].empty()) {
                    var i = t[n].head,
                      o = Ge(e.doc, i.line).text;
                    if (o) if (i.ch == o.length && (i = new tt(i.line, i.ch - 1)), i.ch > 0) i = new tt(i.line, i.ch + 1), e.replaceRange(o.charAt(i.ch - 1) + o.charAt(i.ch - 2), tt(i.line, i.ch - 2), i, "+transpose");else if (i.line > e.doc.first) {
                      var a = Ge(e.doc, i.line - 1).text;
                      a && (i = new tt(i.line, 1), e.replaceRange(o.charAt(0) + e.doc.lineSeparator() + a.charAt(a.length - 1), tt(i.line - 1, a.length - 1), i, "+transpose"));
                    }
                    r.push(new Si(i, i));
                  }
                }
                e.setSelections(r);
              });
            },
            newlineAndIndent: function newlineAndIndent(e) {
              return ei(e, function () {
                for (var t = e.listSelections(), r = t.length - 1; r >= 0; r--) {
                  e.replaceRange(e.doc.lineSeparator(), t[r].anchor, t[r].head, "+input");
                }
                t = e.listSelections();
                for (var n = 0; n < t.length; n++) {
                  e.indentLine(t[n].from().line, null, !0);
                }
                zn(e);
              });
            },
            openLine: function openLine(e) {
              return e.replaceSelection("\n", "start");
            },
            toggleOverwrite: function toggleOverwrite(e) {
              return e.toggleOverwrite();
            }
          };
          function na(e, t) {
            var r = Ge(e.doc, t),
              n = Ft(r);
            return n != r && (t = Ye(n)), ta(!0, e, n, t, 1);
          }
          function ia(e, t) {
            var r = na(e, t.line),
              n = Ge(e.doc, r.line),
              i = ue(n, e.doc.direction);
            if (!i || 0 == i[0].level) {
              var o = Math.max(r.ch, n.text.search(/\S/)),
                a = t.line == r.line && t.ch <= o && t.ch;
              return tt(r.line, a ? 0 : o, r.sticky);
            }
            return r;
          }
          function oa(e, t, r) {
            if ("string" == typeof t && !(t = ra[t])) return !1;
            e.display.input.ensurePolled();
            var n = e.display.shift,
              i = !1;
            try {
              e.isReadOnly() && (e.state.suppressEdits = !0), r && (e.display.shift = !1), i = t(e) != $;
            } finally {
              e.display.shift = n, e.state.suppressEdits = !1;
            }
            return i;
          }
          var aa = new R();
          function sa(e, t, r, n) {
            var i = e.state.keySeq;
            if (i) {
              if (Ko(t)) return "handled";
              if (/\'$/.test(t) ? e.state.keySeq = null : aa.set(50, function () {
                e.state.keySeq == i && (e.state.keySeq = null, e.display.input.reset());
              }), la(e, i + " " + t, r, n)) return !0;
            }
            return la(e, t, r, n);
          }
          function la(e, t, r, n) {
            var i = function (e, t, r) {
              for (var n = 0; n < e.state.keyMaps.length; n++) {
                var i = Go(t, e.state.keyMaps[n], r, e);
                if (i) return i;
              }
              return e.options.extraKeys && Go(t, e.options.extraKeys, r, e) || Go(t, e.options.keyMap, r, e);
            }(e, t, n);
            return "multi" == i && (e.state.keySeq = t), "handled" == i && lr(e, "keyHandled", e, t, r), "handled" != i && "multi" != i || (xe(r), wn(e)), !!i;
          }
          function ca(e, t) {
            var r = Xo(t, !0);
            return !!r && (t.shiftKey && !e.state.keySeq ? sa(e, "Shift-" + r, t, function (t) {
              return oa(e, t, !0);
            }) || sa(e, r, t, function (t) {
              if ("string" == typeof t ? /^go[A-Z]/.test(t) : t.motion) return oa(e, t);
            }) : sa(e, r, t, function (t) {
              return oa(e, t);
            }));
          }
          var ua = null;
          function da(e) {
            var t = this;
            if (!(e.target && e.target != t.display.input.getField() || (t.curOp.focus = O(), ge(t, e)))) {
              s && l < 11 && 27 == e.keyCode && (e.returnValue = !1);
              var n = e.keyCode;
              t.display.shift = 16 == n || e.shiftKey;
              var i = ca(t, e);
              p && (ua = i ? n : null, i || 88 != n || De || !(b ? e.metaKey : e.ctrlKey) || t.replaceSelection("", null, "cut")), r && !b && !i && 46 == n && e.shiftKey && !e.ctrlKey && document.execCommand && document.execCommand("cut"), 18 != n || /\bCodeMirror-crosshair\b/.test(t.display.lineDiv.className) || function (e) {
                var t = e.display.lineDiv;
                function r(e) {
                  18 != e.keyCode && e.altKey || (M(t, "CodeMirror-crosshair"), me(document, "keyup", r), me(document, "mouseover", r));
                }
                D(t, "CodeMirror-crosshair"), pe(document, "keyup", r), pe(document, "mouseover", r);
              }(t);
            }
          }
          function pa(e) {
            16 == e.keyCode && (this.doc.sel.shift = !1), ge(this, e);
          }
          function fa(e) {
            var t = this;
            if (!(e.target && e.target != t.display.input.getField() || wr(t.display, e) || ge(t, e) || e.ctrlKey && !e.altKey || b && e.metaKey)) {
              var r = e.keyCode,
                n = e.charCode;
              if (p && r == ua) return ua = null, void xe(e);
              if (!p || e.which && !(e.which < 10) || !ca(t, e)) {
                var i = String.fromCharCode(null == n ? r : n);
                "\b" != i && (function (e, t, r) {
                  return sa(e, "'" + r + "'", t, function (t) {
                    return oa(e, t, !0);
                  });
                }(t, e, i) || t.display.input.onKeyPress(e));
              }
            }
          }
          var ma,
            ha,
            ga = function ga(e, t, r) {
              this.time = e, this.pos = t, this.button = r;
            };
          function ya(e) {
            var t = this,
              r = t.display;
            if (!(ge(t, e) || r.activeTouch && r.input.supportsTouch())) if (r.input.ensurePolled(), r.shift = e.shiftKey, wr(r, e)) c || (r.scroller.draggable = !1, setTimeout(function () {
              return r.scroller.draggable = !0;
            }, 100));else if (!xa(t, e)) {
              var n = un(t, e),
                i = Ce(e),
                o = n ? function (e, t) {
                  var r = +new Date();
                  return ha && ha.compare(r, e, t) ? (ma = ha = null, "triple") : ma && ma.compare(r, e, t) ? (ha = new ga(r, e, t), ma = null, "double") : (ma = new ga(r, e, t), ha = null, "single");
                }(n, i) : "single";
              window.focus(), 1 == i && t.state.selectingText && t.state.selectingText(e), n && function (e, t, r, n, i) {
                var o = "Click";
                return "double" == n ? o = "Double" + o : "triple" == n && (o = "Triple" + o), sa(e, Zo(o = (1 == t ? "Left" : 2 == t ? "Middle" : "Right") + o, i), i, function (t) {
                  if ("string" == typeof t && (t = ra[t]), !t) return !1;
                  var n = !1;
                  try {
                    e.isReadOnly() && (e.state.suppressEdits = !0), n = t(e, r) != $;
                  } finally {
                    e.state.suppressEdits = !1;
                  }
                  return n;
                });
              }(t, i, n, o, e) || (1 == i ? n ? function (e, t, r, n) {
                s ? setTimeout(j(_n, e), 0) : e.curOp.focus = O();
                var i,
                  o = function (e, t, r) {
                    var n = e.getOption("configureMouse"),
                      i = n ? n(e, t, r) : {};
                    if (null == i.unit) {
                      var o = x ? r.shiftKey && r.metaKey : r.altKey;
                      i.unit = o ? "rectangle" : "single" == t ? "char" : "double" == t ? "word" : "line";
                    }
                    return (null == i.extend || e.doc.extend) && (i.extend = e.doc.extend || r.shiftKey), null == i.addNew && (i.addNew = b ? r.metaKey : r.ctrlKey), null == i.moveOnDrag && (i.moveOnDrag = !(b ? r.altKey : r.ctrlKey)), i;
                  }(e, r, n),
                  a = e.doc.sel;
                e.options.dragDrop && Ee && !e.isReadOnly() && "single" == r && (i = a.contains(t)) > -1 && (rt((i = a.ranges[i]).from(), t) < 0 || t.xRel > 0) && (rt(i.to(), t) > 0 || t.xRel < 0) ? function (e, t, r, n) {
                  var i = e.display,
                    o = !1,
                    a = ti(e, function (t) {
                      c && (i.scroller.draggable = !1), e.state.draggingText = !1, me(i.wrapper.ownerDocument, "mouseup", a), me(i.wrapper.ownerDocument, "mousemove", u), me(i.scroller, "dragstart", d), me(i.scroller, "drop", a), o || (xe(t), n.addNew || Zi(e.doc, r, null, null, n.extend), c && !f || s && 9 == l ? setTimeout(function () {
                        i.wrapper.ownerDocument.body.focus({
                          preventScroll: !0
                        }), i.input.focus();
                      }, 20) : i.input.focus());
                    }),
                    u = function u(e) {
                      o = o || Math.abs(t.clientX - e.clientX) + Math.abs(t.clientY - e.clientY) >= 10;
                    },
                    d = function d() {
                      return o = !0;
                    };
                  c && (i.scroller.draggable = !0), e.state.draggingText = a, a.copy = !n.moveOnDrag, i.scroller.dragDrop && i.scroller.dragDrop(), pe(i.wrapper.ownerDocument, "mouseup", a), pe(i.wrapper.ownerDocument, "mousemove", u), pe(i.scroller, "dragstart", d), pe(i.scroller, "drop", a), Sn(e), setTimeout(function () {
                    return i.input.focus();
                  }, 20);
                }(e, n, t, o) : function (e, t, r, n) {
                  var i = e.display,
                    o = e.doc;
                  xe(t);
                  var a,
                    s,
                    l = o.sel,
                    c = l.ranges;
                  if (n.addNew && !n.extend ? (s = o.sel.contains(r), a = s > -1 ? c[s] : new Si(r, r)) : (a = o.sel.primary(), s = o.sel.primIndex), "rectangle" == n.unit) n.addNew || (a = new Si(r, r)), r = un(e, t, !0, !0), s = -1;else {
                    var u = va(e, r, n.unit);
                    a = n.extend ? Ki(a, u.anchor, u.head, n.extend) : u;
                  }
                  n.addNew ? -1 == s ? (s = c.length, eo(o, Ci(e, c.concat([a]), s), {
                    scroll: !1,
                    origin: "*mouse"
                  })) : c.length > 1 && c[s].empty() && "char" == n.unit && !n.extend ? (eo(o, Ci(e, c.slice(0, s).concat(c.slice(s + 1)), 0), {
                    scroll: !1,
                    origin: "*mouse"
                  }), l = o.sel) : Yi(o, s, a, H) : (s = 0, eo(o, new _i([a], 0), H), l = o.sel);
                  var d = r;
                  function p(t) {
                    if (0 != rt(d, t)) if (d = t, "rectangle" == n.unit) {
                      for (var i = [], c = e.options.tabSize, u = F(Ge(o, r.line).text, r.ch, c), p = F(Ge(o, t.line).text, t.ch, c), f = Math.min(u, p), m = Math.max(u, p), h = Math.min(r.line, t.line), g = Math.min(e.lastLine(), Math.max(r.line, t.line)); h <= g; h++) {
                        var y = Ge(o, h).text,
                          v = V(y, f, c);
                        f == m ? i.push(new Si(tt(h, v), tt(h, v))) : y.length > v && i.push(new Si(tt(h, v), tt(h, V(y, m, c))));
                      }
                      i.length || i.push(new Si(r, r)), eo(o, Ci(e, l.ranges.slice(0, s).concat(i), s), {
                        origin: "*mouse",
                        scroll: !1
                      }), e.scrollIntoView(t);
                    } else {
                      var b,
                        x = a,
                        k = va(e, t, n.unit),
                        w = x.anchor;
                      rt(k.anchor, w) > 0 ? (b = k.head, w = at(x.from(), k.anchor)) : (b = k.anchor, w = ot(x.to(), k.head));
                      var _ = l.ranges.slice(0);
                      _[s] = function (e, t) {
                        var r = t.anchor,
                          n = t.head,
                          i = Ge(e.doc, r.line);
                        if (0 == rt(r, n) && r.sticky == n.sticky) return t;
                        var o = ue(i);
                        if (!o) return t;
                        var a = le(o, r.ch, r.sticky),
                          s = o[a];
                        if (s.from != r.ch && s.to != r.ch) return t;
                        var l,
                          c = a + (s.from == r.ch == (1 != s.level) ? 0 : 1);
                        if (0 == c || c == o.length) return t;
                        if (n.line != r.line) l = (n.line - r.line) * ("ltr" == e.doc.direction ? 1 : -1) > 0;else {
                          var u = le(o, n.ch, n.sticky),
                            d = u - a || (n.ch - r.ch) * (1 == s.level ? -1 : 1);
                          l = u == c - 1 || u == c ? d < 0 : d > 0;
                        }
                        var p = o[c + (l ? -1 : 0)],
                          f = l == (1 == p.level),
                          m = f ? p.from : p.to,
                          h = f ? "after" : "before";
                        return r.ch == m && r.sticky == h ? t : new Si(new tt(r.line, m, h), n);
                      }(e, new Si(lt(o, w), b)), eo(o, Ci(e, _, s), H);
                    }
                  }
                  var f = i.wrapper.getBoundingClientRect(),
                    m = 0;
                  function h(t) {
                    var r = ++m,
                      a = un(e, t, !0, "rectangle" == n.unit);
                    if (a) if (0 != rt(a, d)) {
                      e.curOp.focus = O(), p(a);
                      var s = Ln(i, o);
                      (a.line >= s.to || a.line < s.from) && setTimeout(ti(e, function () {
                        m == r && h(t);
                      }), 150);
                    } else {
                      var l = t.clientY < f.top ? -20 : t.clientY > f.bottom ? 20 : 0;
                      l && setTimeout(ti(e, function () {
                        m == r && (i.scroller.scrollTop += l, h(t));
                      }), 50);
                    }
                  }
                  function g(t) {
                    e.state.selectingText = !1, m = 1 / 0, t && (xe(t), i.input.focus()), me(i.wrapper.ownerDocument, "mousemove", y), me(i.wrapper.ownerDocument, "mouseup", v), o.history.lastSelOrigin = null;
                  }
                  var y = ti(e, function (e) {
                      0 !== e.buttons && Ce(e) ? h(e) : g(e);
                    }),
                    v = ti(e, g);
                  e.state.selectingText = v, pe(i.wrapper.ownerDocument, "mousemove", y), pe(i.wrapper.ownerDocument, "mouseup", v);
                }(e, n, t, o);
              }(t, n, o, e) : Se(e) == r.scroller && xe(e) : 2 == i ? (n && Zi(t.doc, n), setTimeout(function () {
                return r.input.focus();
              }, 20)) : 3 == i && (S ? t.display.input.onContextMenu(e) : Sn(t)));
            }
          }
          function va(e, t, r) {
            if ("char" == r) return new Si(t, t);
            if ("word" == r) return e.findWordAt(t);
            if ("line" == r) return new Si(tt(t.line, 0), lt(e.doc, tt(t.line + 1, 0)));
            var n = r(e, t);
            return new Si(n.from, n.to);
          }
          function ba(e, t, r, n) {
            var i, o;
            if (t.touches) i = t.touches[0].clientX, o = t.touches[0].clientY;else try {
              i = t.clientX, o = t.clientY;
            } catch (t) {
              return !1;
            }
            if (i >= Math.floor(e.display.gutters.getBoundingClientRect().right)) return !1;
            n && xe(t);
            var a = e.display,
              s = a.lineDiv.getBoundingClientRect();
            if (o > s.bottom || !ve(e, r)) return we(t);
            o -= s.top - a.viewOffset;
            for (var l = 0; l < e.display.gutterSpecs.length; ++l) {
              var c = a.gutters.childNodes[l];
              if (c && c.getBoundingClientRect().right >= i) return he(e, r, e, Qe(e.doc, o), e.display.gutterSpecs[l].className, t), we(t);
            }
          }
          function xa(e, t) {
            return ba(e, t, "gutterClick", !0);
          }
          function ka(e, t) {
            wr(e.display, t) || function (e, t) {
              return !!ve(e, "gutterContextMenu") && ba(e, t, "gutterContextMenu", !1);
            }(e, t) || ge(e, t, "contextmenu") || S || e.display.input.onContextMenu(t);
          }
          function wa(e) {
            e.display.wrapper.className = e.display.wrapper.className.replace(/\s*cm-s-\S+/g, "") + e.options.theme.replace(/(^|\s)\s*/g, " cm-s-"), Rr(e);
          }
          ga.prototype.compare = function (e, t, r) {
            return this.time + 400 > e && 0 == rt(t, this.pos) && r == this.button;
          };
          var _a = {
              toString: function toString() {
                return "CodeMirror.Init";
              }
            },
            Sa = {},
            Ca = {};
          function Ta(e, t, r) {
            if (!t != !(r && r != _a)) {
              var n = e.display.dragFunctions,
                i = t ? pe : me;
              i(e.display.scroller, "dragstart", n.start), i(e.display.scroller, "dragenter", n.enter), i(e.display.scroller, "dragover", n.over), i(e.display.scroller, "dragleave", n.leave), i(e.display.scroller, "drop", n.drop);
            }
          }
          function Ma(e) {
            e.options.lineWrapping ? (D(e.display.wrapper, "CodeMirror-wrap"), e.display.sizer.style.minWidth = "", e.display.sizerWidth = null) : (M(e.display.wrapper, "CodeMirror-wrap"), Vt(e)), cn(e), pn(e), Rr(e), setTimeout(function () {
              return $n(e);
            }, 100);
          }
          function Ea(e, t) {
            var r = this;
            if (!(this instanceof Ea)) return new Ea(e, t);
            this.options = t = t ? q(t) : {}, q(Sa, t, !1);
            var n = t.value;
            "string" == typeof n ? n = new zo(n, t.mode, null, t.lineSeparator, t.direction) : t.mode && (n.modeOption = t.mode), this.doc = n;
            var i = new Ea.inputStyles[t.inputStyle](this),
              o = this.display = new yi(e, n, i, t);
            for (var a in o.wrapper.CodeMirror = this, wa(this), t.lineWrapping && (this.display.wrapper.className += " CodeMirror-wrap"), Bn(this), this.state = {
              keyMaps: [],
              overlays: [],
              modeGen: 0,
              overwrite: !1,
              delayingBlurEvent: !1,
              focused: !1,
              suppressEdits: !1,
              pasteIncoming: -1,
              cutIncoming: -1,
              selectingText: !1,
              draggingText: !1,
              highlight: new R(),
              keySeq: null,
              specialChars: null
            }, t.autofocus && !v && o.input.focus(), s && l < 11 && setTimeout(function () {
              return r.display.input.reset(!0);
            }, 20), function (e) {
              var t = e.display;
              pe(t.scroller, "mousedown", ti(e, ya)), pe(t.scroller, "dblclick", s && l < 11 ? ti(e, function (t) {
                if (!ge(e, t)) {
                  var r = un(e, t);
                  if (r && !xa(e, t) && !wr(e.display, t)) {
                    xe(t);
                    var n = e.findWordAt(r);
                    Zi(e.doc, n.anchor, n.head);
                  }
                }
              }) : function (t) {
                return ge(e, t) || xe(t);
              }), pe(t.scroller, "contextmenu", function (t) {
                return ka(e, t);
              }), pe(t.input.getField(), "contextmenu", function (r) {
                t.scroller.contains(r.target) || ka(e, r);
              });
              var r,
                n = {
                  end: 0
                };
              function i() {
                t.activeTouch && (r = setTimeout(function () {
                  return t.activeTouch = null;
                }, 1e3), (n = t.activeTouch).end = +new Date());
              }
              function o(e) {
                if (1 != e.touches.length) return !1;
                var t = e.touches[0];
                return t.radiusX <= 1 && t.radiusY <= 1;
              }
              function a(e, t) {
                if (null == t.left) return !0;
                var r = t.left - e.left,
                  n = t.top - e.top;
                return r * r + n * n > 400;
              }
              pe(t.scroller, "touchstart", function (i) {
                if (!ge(e, i) && !o(i) && !xa(e, i)) {
                  t.input.ensurePolled(), clearTimeout(r);
                  var a = +new Date();
                  t.activeTouch = {
                    start: a,
                    moved: !1,
                    prev: a - n.end <= 300 ? n : null
                  }, 1 == i.touches.length && (t.activeTouch.left = i.touches[0].pageX, t.activeTouch.top = i.touches[0].pageY);
                }
              }), pe(t.scroller, "touchmove", function () {
                t.activeTouch && (t.activeTouch.moved = !0);
              }), pe(t.scroller, "touchend", function (r) {
                var n = t.activeTouch;
                if (n && !wr(t, r) && null != n.left && !n.moved && new Date() - n.start < 300) {
                  var o,
                    s = e.coordsChar(t.activeTouch, "page");
                  o = !n.prev || a(n, n.prev) ? new Si(s, s) : !n.prev.prev || a(n, n.prev.prev) ? e.findWordAt(s) : new Si(tt(s.line, 0), lt(e.doc, tt(s.line + 1, 0))), e.setSelection(o.anchor, o.head), e.focus(), xe(r);
                }
                i();
              }), pe(t.scroller, "touchcancel", i), pe(t.scroller, "scroll", function () {
                t.scroller.clientHeight && (Pn(e, t.scroller.scrollTop), qn(e, t.scroller.scrollLeft, !0), he(e, "scroll", e));
              }), pe(t.scroller, "mousewheel", function (t) {
                return wi(e, t);
              }), pe(t.scroller, "DOMMouseScroll", function (t) {
                return wi(e, t);
              }), pe(t.wrapper, "scroll", function () {
                return t.wrapper.scrollTop = t.wrapper.scrollLeft = 0;
              }), t.dragFunctions = {
                enter: function enter(t) {
                  ge(e, t) || _e(t);
                },
                over: function over(t) {
                  ge(e, t) || (function (e, t) {
                    var r = un(e, t);
                    if (r) {
                      var n = document.createDocumentFragment();
                      bn(e, r, n), e.display.dragCursor || (e.display.dragCursor = A("div", null, "CodeMirror-cursors CodeMirror-dragcursors"), e.display.lineSpace.insertBefore(e.display.dragCursor, e.display.cursorDiv)), L(e.display.dragCursor, n);
                    }
                  }(e, t), _e(t));
                },
                start: function start(t) {
                  return function (e, t) {
                    if (s && (!e.state.draggingText || +new Date() - Oo < 100)) _e(t);else if (!ge(e, t) && !wr(e.display, t) && (t.dataTransfer.setData("Text", e.getSelection()), t.dataTransfer.effectAllowed = "copyMove", t.dataTransfer.setDragImage && !f)) {
                      var r = A("img", null, null, "position: fixed; left: 0; top: 0;");
                      r.src = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==", p && (r.width = r.height = 1, e.display.wrapper.appendChild(r), r._top = r.offsetTop), t.dataTransfer.setDragImage(r, 0, 0), p && r.parentNode.removeChild(r);
                    }
                  }(e, t);
                },
                drop: ti(e, Do),
                leave: function leave(t) {
                  ge(e, t) || Io(e);
                }
              };
              var c = t.input.getField();
              pe(c, "keyup", function (t) {
                return pa.call(e, t);
              }), pe(c, "keydown", ti(e, da)), pe(c, "keypress", ti(e, fa)), pe(c, "focus", function (t) {
                return Cn(e, t);
              }), pe(c, "blur", function (t) {
                return Tn(e, t);
              });
            }(this), qo(), Gn(this), this.curOp.forceUpdate = !0, Pi(this, n), t.autofocus && !v || this.hasFocus() ? setTimeout(j(Cn, this), 20) : Tn(this), Ca) {
              Ca.hasOwnProperty(a) && Ca[a](this, t[a], _a);
            }
            fi(this), t.finishInit && t.finishInit(this);
            for (var u = 0; u < La.length; ++u) {
              La[u](this);
            }
            Kn(this), c && t.lineWrapping && "optimizelegibility" == getComputedStyle(o.lineDiv).textRendering && (o.lineDiv.style.textRendering = "auto");
          }
          Ea.defaults = Sa, Ea.optionHandlers = Ca;
          var La = [];
          function Aa(e, t, r, n) {
            var i,
              o = e.doc;
            null == r && (r = "add"), "smart" == r && (o.mode.indent ? i = mt(e, t).state : r = "prev");
            var a = e.options.tabSize,
              s = Ge(o, t),
              l = F(s.text, null, a);
            s.stateAfter && (s.stateAfter = null);
            var c,
              u = s.text.match(/^\s*/)[0];
            if (n || /\S/.test(s.text)) {
              if ("smart" == r && ((c = o.mode.indent(i, s.text.slice(u.length), s.text)) == $ || c > 150)) {
                if (!n) return;
                r = "prev";
              }
            } else c = 0, r = "not";
            "prev" == r ? c = t > o.first ? F(Ge(o, t - 1).text, null, a) : 0 : "add" == r ? c = l + e.options.indentUnit : "subtract" == r ? c = l - e.options.indentUnit : "number" == typeof r && (c = l + r), c = Math.max(0, c);
            var d = "",
              p = 0;
            if (e.options.indentWithTabs) for (var f = Math.floor(c / a); f; --f) {
              p += a, d += "\t";
            }
            if (p < c && (d += K(c - p)), d != u) return go(o, d, tt(t, 0), tt(t, u.length), "+input"), s.stateAfter = null, !0;
            for (var m = 0; m < o.sel.ranges.length; m++) {
              var h = o.sel.ranges[m];
              if (h.head.line == t && h.head.ch < u.length) {
                var g = tt(t, u.length);
                Yi(o, m, new Si(g, g));
                break;
              }
            }
          }
          Ea.defineInitHook = function (e) {
            return La.push(e);
          };
          var Na = null;
          function za(e) {
            Na = e;
          }
          function Oa(e, t, r, n, i) {
            var o = e.doc;
            e.display.shift = !1, n || (n = o.sel);
            var a = +new Date() - 200,
              s = "paste" == i || e.state.pasteIncoming > a,
              l = ze(t),
              c = null;
            if (s && n.ranges.length > 1) if (Na && Na.text.join("\n") == t) {
              if (n.ranges.length % Na.text.length == 0) {
                c = [];
                for (var u = 0; u < Na.text.length; u++) {
                  c.push(o.splitLines(Na.text[u]));
                }
              }
            } else l.length == n.ranges.length && e.options.pasteLinesPerSelection && (c = X(l, function (e) {
              return [e];
            }));
            for (var d = e.curOp.updateInput, p = n.ranges.length - 1; p >= 0; p--) {
              var f = n.ranges[p],
                m = f.from(),
                h = f.to();
              f.empty() && (r && r > 0 ? m = tt(m.line, m.ch - r) : e.state.overwrite && !s ? h = tt(h.line, Math.min(Ge(o, h.line).text.length, h.ch + Z(l).length)) : s && Na && Na.lineWise && Na.text.join("\n") == t && (m = h = tt(m.line, 0)));
              var g = {
                from: m,
                to: h,
                text: c ? c[p % c.length] : l,
                origin: i || (s ? "paste" : e.state.cutIncoming > a ? "cut" : "+input")
              };
              uo(e.doc, g), lr(e, "inputRead", e, g);
            }
            t && !s && Ia(e, t), zn(e), e.curOp.updateInput < 2 && (e.curOp.updateInput = d), e.curOp.typing = !0, e.state.pasteIncoming = e.state.cutIncoming = -1;
          }
          function Da(e, t) {
            var r = e.clipboardData && e.clipboardData.getData("Text");
            if (r) return e.preventDefault(), t.isReadOnly() || t.options.disableInput || ei(t, function () {
              return Oa(t, r, 0, null, "paste");
            }), !0;
          }
          function Ia(e, t) {
            if (e.options.electricChars && e.options.smartIndent) for (var r = e.doc.sel, n = r.ranges.length - 1; n >= 0; n--) {
              var i = r.ranges[n];
              if (!(i.head.ch > 100 || n && r.ranges[n - 1].head.line == i.head.line)) {
                var o = e.getModeAt(i.head),
                  a = !1;
                if (o.electricChars) {
                  for (var s = 0; s < o.electricChars.length; s++) {
                    if (t.indexOf(o.electricChars.charAt(s)) > -1) {
                      a = Aa(e, i.head.line, "smart");
                      break;
                    }
                  }
                } else o.electricInput && o.electricInput.test(Ge(e.doc, i.head.line).text.slice(0, i.head.ch)) && (a = Aa(e, i.head.line, "smart"));
                a && lr(e, "electricInput", e, i.head.line);
              }
            }
          }
          function Pa(e) {
            for (var t = [], r = [], n = 0; n < e.doc.sel.ranges.length; n++) {
              var i = e.doc.sel.ranges[n].head.line,
                o = {
                  anchor: tt(i, 0),
                  head: tt(i + 1, 0)
                };
              r.push(o), t.push(e.getRange(o.anchor, o.head));
            }
            return {
              text: t,
              ranges: r
            };
          }
          function ja(e, t, r, n) {
            e.setAttribute("autocorrect", r ? "" : "off"), e.setAttribute("autocapitalize", n ? "" : "off"), e.setAttribute("spellcheck", !!t);
          }
          function qa() {
            var e = A("textarea", null, null, "position: absolute; bottom: -1em; padding: 0; width: 1px; height: 1em; outline: none"),
              t = A("div", [e], null, "overflow: hidden; position: relative; width: 3px; height: 0px;");
            return c ? e.style.width = "1000px" : e.setAttribute("wrap", "off"), g && (e.style.border = "1px solid black"), ja(e), t;
          }
          function Fa(e, t, r, n, i) {
            var o = t,
              a = r,
              s = Ge(e, t.line),
              l = i && "rtl" == e.direction ? -r : r;
            function c(n) {
              var o, a;
              if (o = i ? function (e, t, r, n) {
                var i = ue(t, e.doc.direction);
                if (!i) return ea(t, r, n);
                r.ch >= t.text.length ? (r.ch = t.text.length, r.sticky = "before") : r.ch <= 0 && (r.ch = 0, r.sticky = "after");
                var o = le(i, r.ch, r.sticky),
                  a = i[o];
                if ("ltr" == e.doc.direction && a.level % 2 == 0 && (n > 0 ? a.to > r.ch : a.from < r.ch)) return ea(t, r, n);
                var s,
                  l = function l(e, r) {
                    return Jo(t, e instanceof tt ? e.ch : e, r);
                  },
                  c = function c(r) {
                    return e.options.lineWrapping ? (s = s || zr(e, t), Qr(e, t, s, r)) : {
                      begin: 0,
                      end: t.text.length
                    };
                  },
                  u = c("before" == r.sticky ? l(r, -1) : r.ch);
                if ("rtl" == e.doc.direction || 1 == a.level) {
                  var d = 1 == a.level == n < 0,
                    p = l(r, d ? 1 : -1);
                  if (null != p && (d ? p <= a.to && p <= u.end : p >= a.from && p >= u.begin)) {
                    var f = d ? "before" : "after";
                    return new tt(r.line, p, f);
                  }
                }
                var m = function m(e, t, n) {
                    for (var o = function o(e, t) {
                      return t ? new tt(r.line, l(e, 1), "before") : new tt(r.line, e, "after");
                    }; e >= 0 && e < i.length; e += t) {
                      var a = i[e],
                        s = t > 0 == (1 != a.level),
                        c = s ? n.begin : l(n.end, -1);
                      if (a.from <= c && c < a.to) return o(c, s);
                      if (c = s ? a.from : l(a.to, -1), n.begin <= c && c < n.end) return o(c, s);
                    }
                  },
                  h = m(o + n, n, u);
                if (h) return h;
                var g = n > 0 ? u.end : l(u.begin, -1);
                return null == g || n > 0 && g == t.text.length || !(h = m(n > 0 ? 0 : i.length - 1, n, c(g))) ? null : h;
              }(e.cm, s, t, r) : ea(s, t, r), null == o) {
                if (n || (a = t.line + l) < e.first || a >= e.first + e.size || (t = new tt(a, t.ch, t.sticky), !(s = Ge(e, a)))) return !1;
                t = ta(i, e.cm, s, t.line, l);
              } else t = o;
              return !0;
            }
            if ("char" == n) c();else if ("column" == n) c(!0);else if ("word" == n || "group" == n) for (var u = null, d = "group" == n, p = e.cm && e.cm.getHelper(t, "wordChars"), f = !0; !(r < 0) || c(!f); f = !1) {
              var m = s.text.charAt(t.ch) || "\n",
                h = te(m, p) ? "w" : d && "\n" == m ? "n" : !d || /\s/.test(m) ? null : "p";
              if (!d || f || h || (h = "s"), u && u != h) {
                r < 0 && (r = 1, c(), t.sticky = "after");
                break;
              }
              if (h && (u = h), r > 0 && !c(!f)) break;
            }
            var g = ao(e, t, o, a, !0);
            return nt(o, g) && (g.hitSide = !0), g;
          }
          function Ra(e, t, r, n) {
            var i,
              o,
              a = e.doc,
              s = t.left;
            if ("page" == n) {
              var l = Math.min(e.display.wrapper.clientHeight, window.innerHeight || document.documentElement.clientHeight),
                c = Math.max(l - .5 * nn(e.display), 3);
              i = (r > 0 ? t.bottom : t.top) + r * c;
            } else "line" == n && (i = r > 0 ? t.bottom + 3 : t.top - 3);
            for (; (o = Xr(e, s, i)).outside;) {
              if (r < 0 ? i <= 0 : i >= a.height) {
                o.hitSide = !0;
                break;
              }
              i += 5 * r;
            }
            return o;
          }
          var Wa = function Wa(e) {
            this.cm = e, this.lastAnchorNode = this.lastAnchorOffset = this.lastFocusNode = this.lastFocusOffset = null, this.polling = new R(), this.composing = null, this.gracePeriod = !1, this.readDOMTimeout = null;
          };
          function $a(e, t) {
            var r = Nr(e, t.line);
            if (!r || r.hidden) return null;
            var n = Ge(e.doc, t.line),
              i = Lr(r, n, t.line),
              o = ue(n, e.doc.direction),
              a = "left";
            o && (a = le(o, t.ch) % 2 ? "right" : "left");
            var s = Pr(i.map, t.ch, a);
            return s.offset = "right" == s.collapse ? s.end : s.start, s;
          }
          function Ua(e, t) {
            return t && (e.bad = !0), e;
          }
          function Ha(e, t, r) {
            var n;
            if (t == e.display.lineDiv) {
              if (!(n = e.display.lineDiv.childNodes[r])) return Ua(e.clipPos(tt(e.display.viewTo - 1)), !0);
              t = null, r = 0;
            } else for (n = t;; n = n.parentNode) {
              if (!n || n == e.display.lineDiv) return null;
              if (n.parentNode && n.parentNode == e.display.lineDiv) break;
            }
            for (var i = 0; i < e.display.view.length; i++) {
              var o = e.display.view[i];
              if (o.node == n) return Ba(o, t, r);
            }
          }
          function Ba(e, t, r) {
            var n = e.text.firstChild,
              i = !1;
            if (!t || !z(n, t)) return Ua(tt(Ye(e.line), 0), !0);
            if (t == n && (i = !0, t = n.childNodes[r], r = 0, !t)) {
              var o = e.rest ? Z(e.rest) : e.line;
              return Ua(tt(Ye(o), o.text.length), i);
            }
            var a = 3 == t.nodeType ? t : null,
              s = t;
            for (a || 1 != t.childNodes.length || 3 != t.firstChild.nodeType || (a = t.firstChild, r && (r = a.nodeValue.length)); s.parentNode != n;) {
              s = s.parentNode;
            }
            var l = e.measure,
              c = l.maps;
            function u(t, r, n) {
              for (var i = -1; i < (c ? c.length : 0); i++) {
                for (var o = i < 0 ? l.map : c[i], a = 0; a < o.length; a += 3) {
                  var s = o[a + 2];
                  if (s == t || s == r) {
                    var u = Ye(i < 0 ? e.line : e.rest[i]),
                      d = o[a] + n;
                    return (n < 0 || s != t) && (d = o[a + (n ? 1 : 0)]), tt(u, d);
                  }
                }
              }
            }
            var d = u(a, s, r);
            if (d) return Ua(d, i);
            for (var p = s.nextSibling, f = a ? a.nodeValue.length - r : 0; p; p = p.nextSibling) {
              if (d = u(p, p.firstChild, 0)) return Ua(tt(d.line, d.ch - f), i);
              f += p.textContent.length;
            }
            for (var m = s.previousSibling, h = r; m; m = m.previousSibling) {
              if (d = u(m, m.firstChild, -1)) return Ua(tt(d.line, d.ch + h), i);
              h += m.textContent.length;
            }
          }
          Wa.prototype.init = function (e) {
            var t = this,
              r = this,
              n = r.cm,
              i = r.div = e.lineDiv;
            function o(e) {
              for (var t = e.target; t; t = t.parentNode) {
                if (t == i) return !0;
                if (/\bCodeMirror-(?:line)?widget\b/.test(t.className)) break;
              }
              return !1;
            }
            function a(e) {
              if (o(e) && !ge(n, e)) {
                if (n.somethingSelected()) za({
                  lineWise: !1,
                  text: n.getSelections()
                }), "cut" == e.type && n.replaceSelection("", null, "cut");else {
                  if (!n.options.lineWiseCopyCut) return;
                  var t = Pa(n);
                  za({
                    lineWise: !0,
                    text: t.text
                  }), "cut" == e.type && n.operation(function () {
                    n.setSelections(t.ranges, 0, U), n.replaceSelection("", null, "cut");
                  });
                }
                if (e.clipboardData) {
                  e.clipboardData.clearData();
                  var a = Na.text.join("\n");
                  if (e.clipboardData.setData("Text", a), e.clipboardData.getData("Text") == a) return void e.preventDefault();
                }
                var s = qa(),
                  l = s.firstChild;
                n.display.lineSpace.insertBefore(s, n.display.lineSpace.firstChild), l.value = Na.text.join("\n");
                var c = document.activeElement;
                P(l), setTimeout(function () {
                  n.display.lineSpace.removeChild(s), c.focus(), c == i && r.showPrimarySelection();
                }, 50);
              }
            }
            ja(i, n.options.spellcheck, n.options.autocorrect, n.options.autocapitalize), pe(i, "paste", function (e) {
              !o(e) || ge(n, e) || Da(e, n) || l <= 11 && setTimeout(ti(n, function () {
                return t.updateFromDOM();
              }), 20);
            }), pe(i, "compositionstart", function (e) {
              t.composing = {
                data: e.data,
                done: !1
              };
            }), pe(i, "compositionupdate", function (e) {
              t.composing || (t.composing = {
                data: e.data,
                done: !1
              });
            }), pe(i, "compositionend", function (e) {
              t.composing && (e.data != t.composing.data && t.readFromDOMSoon(), t.composing.done = !0);
            }), pe(i, "touchstart", function () {
              return r.forceCompositionEnd();
            }), pe(i, "input", function () {
              t.composing || t.readFromDOMSoon();
            }), pe(i, "copy", a), pe(i, "cut", a);
          }, Wa.prototype.screenReaderLabelChanged = function (e) {
            e ? this.div.setAttribute("aria-label", e) : this.div.removeAttribute("aria-label");
          }, Wa.prototype.prepareSelection = function () {
            var e = vn(this.cm, !1);
            return e.focus = document.activeElement == this.div, e;
          }, Wa.prototype.showSelection = function (e, t) {
            e && this.cm.display.view.length && ((e.focus || t) && this.showPrimarySelection(), this.showMultipleSelections(e));
          }, Wa.prototype.getSelection = function () {
            return this.cm.display.wrapper.ownerDocument.getSelection();
          }, Wa.prototype.showPrimarySelection = function () {
            var e = this.getSelection(),
              t = this.cm,
              n = t.doc.sel.primary(),
              i = n.from(),
              o = n.to();
            if (t.display.viewTo == t.display.viewFrom || i.line >= t.display.viewTo || o.line < t.display.viewFrom) e.removeAllRanges();else {
              var a = Ha(t, e.anchorNode, e.anchorOffset),
                s = Ha(t, e.focusNode, e.focusOffset);
              if (!a || a.bad || !s || s.bad || 0 != rt(at(a, s), i) || 0 != rt(ot(a, s), o)) {
                var l = t.display.view,
                  c = i.line >= t.display.viewFrom && $a(t, i) || {
                    node: l[0].measure.map[2],
                    offset: 0
                  },
                  u = o.line < t.display.viewTo && $a(t, o);
                if (!u) {
                  var d = l[l.length - 1].measure,
                    p = d.maps ? d.maps[d.maps.length - 1] : d.map;
                  u = {
                    node: p[p.length - 1],
                    offset: p[p.length - 2] - p[p.length - 3]
                  };
                }
                if (c && u) {
                  var f,
                    m = e.rangeCount && e.getRangeAt(0);
                  try {
                    f = T(c.node, c.offset, u.offset, u.node);
                  } catch (e) {}
                  f && (!r && t.state.focused ? (e.collapse(c.node, c.offset), f.collapsed || (e.removeAllRanges(), e.addRange(f))) : (e.removeAllRanges(), e.addRange(f)), m && null == e.anchorNode ? e.addRange(m) : r && this.startGracePeriod()), this.rememberSelection();
                } else e.removeAllRanges();
              }
            }
          }, Wa.prototype.startGracePeriod = function () {
            var e = this;
            clearTimeout(this.gracePeriod), this.gracePeriod = setTimeout(function () {
              e.gracePeriod = !1, e.selectionChanged() && e.cm.operation(function () {
                return e.cm.curOp.selectionChanged = !0;
              });
            }, 20);
          }, Wa.prototype.showMultipleSelections = function (e) {
            L(this.cm.display.cursorDiv, e.cursors), L(this.cm.display.selectionDiv, e.selection);
          }, Wa.prototype.rememberSelection = function () {
            var e = this.getSelection();
            this.lastAnchorNode = e.anchorNode, this.lastAnchorOffset = e.anchorOffset, this.lastFocusNode = e.focusNode, this.lastFocusOffset = e.focusOffset;
          }, Wa.prototype.selectionInEditor = function () {
            var e = this.getSelection();
            if (!e.rangeCount) return !1;
            var t = e.getRangeAt(0).commonAncestorContainer;
            return z(this.div, t);
          }, Wa.prototype.focus = function () {
            "nocursor" != this.cm.options.readOnly && (this.selectionInEditor() && document.activeElement == this.div || this.showSelection(this.prepareSelection(), !0), this.div.focus());
          }, Wa.prototype.blur = function () {
            this.div.blur();
          }, Wa.prototype.getField = function () {
            return this.div;
          }, Wa.prototype.supportsTouch = function () {
            return !0;
          }, Wa.prototype.receivedFocus = function () {
            var e = this;
            this.selectionInEditor() ? this.pollSelection() : ei(this.cm, function () {
              return e.cm.curOp.selectionChanged = !0;
            }), this.polling.set(this.cm.options.pollInterval, function t() {
              e.cm.state.focused && (e.pollSelection(), e.polling.set(e.cm.options.pollInterval, t));
            });
          }, Wa.prototype.selectionChanged = function () {
            var e = this.getSelection();
            return e.anchorNode != this.lastAnchorNode || e.anchorOffset != this.lastAnchorOffset || e.focusNode != this.lastFocusNode || e.focusOffset != this.lastFocusOffset;
          }, Wa.prototype.pollSelection = function () {
            if (null == this.readDOMTimeout && !this.gracePeriod && this.selectionChanged()) {
              var e = this.getSelection(),
                t = this.cm;
              if (y && d && this.cm.display.gutterSpecs.length && function (e) {
                for (var t = e; t; t = t.parentNode) {
                  if (/CodeMirror-gutter-wrapper/.test(t.className)) return !0;
                }
                return !1;
              }(e.anchorNode)) return this.cm.triggerOnKeyDown({
                type: "keydown",
                keyCode: 8,
                preventDefault: Math.abs
              }), this.blur(), void this.focus();
              if (!this.composing) {
                this.rememberSelection();
                var r = Ha(t, e.anchorNode, e.anchorOffset),
                  n = Ha(t, e.focusNode, e.focusOffset);
                r && n && ei(t, function () {
                  eo(t.doc, Ti(r, n), U), (r.bad || n.bad) && (t.curOp.selectionChanged = !0);
                });
              }
            }
          }, Wa.prototype.pollContent = function () {
            null != this.readDOMTimeout && (clearTimeout(this.readDOMTimeout), this.readDOMTimeout = null);
            var e,
              t,
              r,
              n = this.cm,
              i = n.display,
              o = n.doc.sel.primary(),
              a = o.from(),
              s = o.to();
            if (0 == a.ch && a.line > n.firstLine() && (a = tt(a.line - 1, Ge(n.doc, a.line - 1).length)), s.ch == Ge(n.doc, s.line).text.length && s.line < n.lastLine() && (s = tt(s.line + 1, 0)), a.line < i.viewFrom || s.line > i.viewTo - 1) return !1;
            a.line == i.viewFrom || 0 == (e = dn(n, a.line)) ? (t = Ye(i.view[0].line), r = i.view[0].node) : (t = Ye(i.view[e].line), r = i.view[e - 1].node.nextSibling);
            var l,
              c,
              u = dn(n, s.line);
            if (u == i.view.length - 1 ? (l = i.viewTo - 1, c = i.lineDiv.lastChild) : (l = Ye(i.view[u + 1].line) - 1, c = i.view[u + 1].node.previousSibling), !r) return !1;
            for (var d = n.doc.splitLines(function (e, t, r, n, i) {
                var o = "",
                  a = !1,
                  s = e.doc.lineSeparator(),
                  l = !1;
                function c(e) {
                  return function (t) {
                    return t.id == e;
                  };
                }
                function u() {
                  a && (o += s, l && (o += s), a = l = !1);
                }
                function d(e) {
                  e && (u(), o += e);
                }
                function p(t) {
                  if (1 == t.nodeType) {
                    var r = t.getAttribute("cm-text");
                    if (r) return void d(r);
                    var o,
                      f = t.getAttribute("cm-marker");
                    if (f) {
                      var m = e.findMarks(tt(n, 0), tt(i + 1, 0), c(+f));
                      return void (m.length && (o = m[0].find(0)) && d(Ke(e.doc, o.from, o.to).join(s)));
                    }
                    if ("false" == t.getAttribute("contenteditable")) return;
                    var h = /^(pre|div|p|li|table|br)$/i.test(t.nodeName);
                    if (!/^br$/i.test(t.nodeName) && 0 == t.textContent.length) return;
                    h && u();
                    for (var g = 0; g < t.childNodes.length; g++) {
                      p(t.childNodes[g]);
                    }
                    /^(pre|p)$/i.test(t.nodeName) && (l = !0), h && (a = !0);
                  } else 3 == t.nodeType && d(t.nodeValue.replace(/\u200b/g, "").replace(/\u00a0/g, " "));
                }
                for (; p(t), t != r;) {
                  t = t.nextSibling, l = !1;
                }
                return o;
              }(n, r, c, t, l)), p = Ke(n.doc, tt(t, 0), tt(l, Ge(n.doc, l).text.length)); d.length > 1 && p.length > 1;) {
              if (Z(d) == Z(p)) d.pop(), p.pop(), l--;else {
                if (d[0] != p[0]) break;
                d.shift(), p.shift(), t++;
              }
            }
            for (var f = 0, m = 0, h = d[0], g = p[0], y = Math.min(h.length, g.length); f < y && h.charCodeAt(f) == g.charCodeAt(f);) {
              ++f;
            }
            for (var v = Z(d), b = Z(p), x = Math.min(v.length - (1 == d.length ? f : 0), b.length - (1 == p.length ? f : 0)); m < x && v.charCodeAt(v.length - m - 1) == b.charCodeAt(b.length - m - 1);) {
              ++m;
            }
            if (1 == d.length && 1 == p.length && t == a.line) for (; f && f > a.ch && v.charCodeAt(v.length - m - 1) == b.charCodeAt(b.length - m - 1);) {
              f--, m++;
            }
            d[d.length - 1] = v.slice(0, v.length - m).replace(/^\u200b+/, ""), d[0] = d[0].slice(f).replace(/\u200b+$/, "");
            var k = tt(t, f),
              w = tt(l, p.length ? Z(p).length - m : 0);
            return d.length > 1 || d[0] || rt(k, w) ? (go(n.doc, d, k, w, "+input"), !0) : void 0;
          }, Wa.prototype.ensurePolled = function () {
            this.forceCompositionEnd();
          }, Wa.prototype.reset = function () {
            this.forceCompositionEnd();
          }, Wa.prototype.forceCompositionEnd = function () {
            this.composing && (clearTimeout(this.readDOMTimeout), this.composing = null, this.updateFromDOM(), this.div.blur(), this.div.focus());
          }, Wa.prototype.readFromDOMSoon = function () {
            var e = this;
            null == this.readDOMTimeout && (this.readDOMTimeout = setTimeout(function () {
              if (e.readDOMTimeout = null, e.composing) {
                if (!e.composing.done) return;
                e.composing = null;
              }
              e.updateFromDOM();
            }, 80));
          }, Wa.prototype.updateFromDOM = function () {
            var e = this;
            !this.cm.isReadOnly() && this.pollContent() || ei(this.cm, function () {
              return pn(e.cm);
            });
          }, Wa.prototype.setUneditable = function (e) {
            e.contentEditable = "false";
          }, Wa.prototype.onKeyPress = function (e) {
            0 == e.charCode || this.composing || (e.preventDefault(), this.cm.isReadOnly() || ti(this.cm, Oa)(this.cm, String.fromCharCode(null == e.charCode ? e.keyCode : e.charCode), 0));
          }, Wa.prototype.readOnlyChanged = function (e) {
            this.div.contentEditable = String("nocursor" != e);
          }, Wa.prototype.onContextMenu = function () {}, Wa.prototype.resetPosition = function () {}, Wa.prototype.needsContentAttribute = !0;
          var Va = function Va(e) {
            this.cm = e, this.prevInput = "", this.pollingFast = !1, this.polling = new R(), this.hasSelection = !1, this.composing = null;
          };
          Va.prototype.init = function (e) {
            var t = this,
              r = this,
              n = this.cm;
            this.createField(e);
            var i = this.textarea;
            function o(e) {
              if (!ge(n, e)) {
                if (n.somethingSelected()) za({
                  lineWise: !1,
                  text: n.getSelections()
                });else {
                  if (!n.options.lineWiseCopyCut) return;
                  var t = Pa(n);
                  za({
                    lineWise: !0,
                    text: t.text
                  }), "cut" == e.type ? n.setSelections(t.ranges, null, U) : (r.prevInput = "", i.value = t.text.join("\n"), P(i));
                }
                "cut" == e.type && (n.state.cutIncoming = +new Date());
              }
            }
            e.wrapper.insertBefore(this.wrapper, e.wrapper.firstChild), g && (i.style.width = "0px"), pe(i, "input", function () {
              s && l >= 9 && t.hasSelection && (t.hasSelection = null), r.poll();
            }), pe(i, "paste", function (e) {
              ge(n, e) || Da(e, n) || (n.state.pasteIncoming = +new Date(), r.fastPoll());
            }), pe(i, "cut", o), pe(i, "copy", o), pe(e.scroller, "paste", function (t) {
              if (!wr(e, t) && !ge(n, t)) {
                if (!i.dispatchEvent) return n.state.pasteIncoming = +new Date(), void r.focus();
                var o = new Event("paste");
                o.clipboardData = t.clipboardData, i.dispatchEvent(o);
              }
            }), pe(e.lineSpace, "selectstart", function (t) {
              wr(e, t) || xe(t);
            }), pe(i, "compositionstart", function () {
              var e = n.getCursor("from");
              r.composing && r.composing.range.clear(), r.composing = {
                start: e,
                range: n.markText(e, n.getCursor("to"), {
                  className: "CodeMirror-composing"
                })
              };
            }), pe(i, "compositionend", function () {
              r.composing && (r.poll(), r.composing.range.clear(), r.composing = null);
            });
          }, Va.prototype.createField = function (e) {
            this.wrapper = qa(), this.textarea = this.wrapper.firstChild;
          }, Va.prototype.screenReaderLabelChanged = function (e) {
            e ? this.textarea.setAttribute("aria-label", e) : this.textarea.removeAttribute("aria-label");
          }, Va.prototype.prepareSelection = function () {
            var e = this.cm,
              t = e.display,
              r = e.doc,
              n = vn(e);
            if (e.options.moveInputWithCursor) {
              var i = Gr(e, r.sel.primary().head, "div"),
                o = t.wrapper.getBoundingClientRect(),
                a = t.lineDiv.getBoundingClientRect();
              n.teTop = Math.max(0, Math.min(t.wrapper.clientHeight - 10, i.top + a.top - o.top)), n.teLeft = Math.max(0, Math.min(t.wrapper.clientWidth - 10, i.left + a.left - o.left));
            }
            return n;
          }, Va.prototype.showSelection = function (e) {
            var t = this.cm.display;
            L(t.cursorDiv, e.cursors), L(t.selectionDiv, e.selection), null != e.teTop && (this.wrapper.style.top = e.teTop + "px", this.wrapper.style.left = e.teLeft + "px");
          }, Va.prototype.reset = function (e) {
            if (!this.contextMenuPending && !this.composing) {
              var t = this.cm;
              if (t.somethingSelected()) {
                this.prevInput = "";
                var r = t.getSelection();
                this.textarea.value = r, t.state.focused && P(this.textarea), s && l >= 9 && (this.hasSelection = r);
              } else e || (this.prevInput = this.textarea.value = "", s && l >= 9 && (this.hasSelection = null));
            }
          }, Va.prototype.getField = function () {
            return this.textarea;
          }, Va.prototype.supportsTouch = function () {
            return !1;
          }, Va.prototype.focus = function () {
            if ("nocursor" != this.cm.options.readOnly && (!v || O() != this.textarea)) try {
              this.textarea.focus();
            } catch (e) {}
          }, Va.prototype.blur = function () {
            this.textarea.blur();
          }, Va.prototype.resetPosition = function () {
            this.wrapper.style.top = this.wrapper.style.left = 0;
          }, Va.prototype.receivedFocus = function () {
            this.slowPoll();
          }, Va.prototype.slowPoll = function () {
            var e = this;
            this.pollingFast || this.polling.set(this.cm.options.pollInterval, function () {
              e.poll(), e.cm.state.focused && e.slowPoll();
            });
          }, Va.prototype.fastPoll = function () {
            var e = !1,
              t = this;
            t.pollingFast = !0, t.polling.set(20, function r() {
              t.poll() || e ? (t.pollingFast = !1, t.slowPoll()) : (e = !0, t.polling.set(60, r));
            });
          }, Va.prototype.poll = function () {
            var e = this,
              t = this.cm,
              r = this.textarea,
              n = this.prevInput;
            if (this.contextMenuPending || !t.state.focused || Oe(r) && !n && !this.composing || t.isReadOnly() || t.options.disableInput || t.state.keySeq) return !1;
            var i = r.value;
            if (i == n && !t.somethingSelected()) return !1;
            if (s && l >= 9 && this.hasSelection === i || b && /[\uf700-\uf7ff]/.test(i)) return t.display.input.reset(), !1;
            if (t.doc.sel == t.display.selForContextMenu) {
              var o = i.charCodeAt(0);
              if (8203 != o || n || (n = "​"), 8666 == o) return this.reset(), this.cm.execCommand("undo");
            }
            for (var a = 0, c = Math.min(n.length, i.length); a < c && n.charCodeAt(a) == i.charCodeAt(a);) {
              ++a;
            }
            return ei(t, function () {
              Oa(t, i.slice(a), n.length - a, null, e.composing ? "*compose" : null), i.length > 1e3 || i.indexOf("\n") > -1 ? r.value = e.prevInput = "" : e.prevInput = i, e.composing && (e.composing.range.clear(), e.composing.range = t.markText(e.composing.start, t.getCursor("to"), {
                className: "CodeMirror-composing"
              }));
            }), !0;
          }, Va.prototype.ensurePolled = function () {
            this.pollingFast && this.poll() && (this.pollingFast = !1);
          }, Va.prototype.onKeyPress = function () {
            s && l >= 9 && (this.hasSelection = null), this.fastPoll();
          }, Va.prototype.onContextMenu = function (e) {
            var t = this,
              r = t.cm,
              n = r.display,
              i = t.textarea;
            t.contextMenuPending && t.contextMenuPending();
            var o = un(r, e),
              a = n.scroller.scrollTop;
            if (o && !p) {
              r.options.resetSelectionOnContextMenu && -1 == r.doc.sel.contains(o) && ti(r, eo)(r.doc, Ti(o), U);
              var u,
                d = i.style.cssText,
                f = t.wrapper.style.cssText,
                m = t.wrapper.offsetParent.getBoundingClientRect();
              t.wrapper.style.cssText = "position: static", i.style.cssText = "position: absolute; width: 30px; height: 30px;\n      top: " + (e.clientY - m.top - 5) + "px; left: " + (e.clientX - m.left - 5) + "px;\n      z-index: 1000; background: " + (s ? "rgba(255, 255, 255, .05)" : "transparent") + ";\n      outline: none; border-width: 0; outline: none; overflow: hidden; opacity: .05; filter: alpha(opacity=5);", c && (u = window.scrollY), n.input.focus(), c && window.scrollTo(null, u), n.input.reset(), r.somethingSelected() || (i.value = t.prevInput = " "), t.contextMenuPending = g, n.selForContextMenu = r.doc.sel, clearTimeout(n.detectingSelectAll), s && l >= 9 && h(), S ? (_e(e), pe(window, "mouseup", function e() {
                me(window, "mouseup", e), setTimeout(g, 20);
              })) : setTimeout(g, 50);
            }
            function h() {
              if (null != i.selectionStart) {
                var e = r.somethingSelected(),
                  o = "​" + (e ? i.value : "");
                i.value = "⇚", i.value = o, t.prevInput = e ? "" : "​", i.selectionStart = 1, i.selectionEnd = o.length, n.selForContextMenu = r.doc.sel;
              }
            }
            function g() {
              if (t.contextMenuPending == g && (t.contextMenuPending = !1, t.wrapper.style.cssText = f, i.style.cssText = d, s && l < 9 && n.scrollbars.setScrollTop(n.scroller.scrollTop = a), null != i.selectionStart)) {
                (!s || s && l < 9) && h();
                var e = 0;
                n.detectingSelectAll = setTimeout(function o() {
                  n.selForContextMenu == r.doc.sel && 0 == i.selectionStart && i.selectionEnd > 0 && "​" == t.prevInput ? ti(r, lo)(r) : e++ < 10 ? n.detectingSelectAll = setTimeout(o, 500) : (n.selForContextMenu = null, n.input.reset());
                }, 200);
              }
            }
          }, Va.prototype.readOnlyChanged = function (e) {
            e || this.reset(), this.textarea.disabled = "nocursor" == e;
          }, Va.prototype.setUneditable = function () {}, Va.prototype.needsContentAttribute = !1, function (e) {
            var t = e.optionHandlers;
            function r(r, n, i, o) {
              e.defaults[r] = n, i && (t[r] = o ? function (e, t, r) {
                r != _a && i(e, t, r);
              } : i);
            }
            e.defineOption = r, e.Init = _a, r("value", "", function (e, t) {
              return e.setValue(t);
            }, !0), r("mode", null, function (e, t) {
              e.doc.modeOption = t, Ni(e);
            }, !0), r("indentUnit", 2, Ni, !0), r("indentWithTabs", !1), r("smartIndent", !0), r("tabSize", 4, function (e) {
              zi(e), Rr(e), pn(e);
            }, !0), r("lineSeparator", null, function (e, t) {
              if (e.doc.lineSep = t, t) {
                var r = [],
                  n = e.doc.first;
                e.doc.iter(function (e) {
                  for (var i = 0;;) {
                    var o = e.text.indexOf(t, i);
                    if (-1 == o) break;
                    i = o + t.length, r.push(tt(n, o));
                  }
                  n++;
                });
                for (var i = r.length - 1; i >= 0; i--) {
                  go(e.doc, t, r[i], tt(r[i].line, r[i].ch + t.length));
                }
              }
            }), r("specialChars", /[\u0000-\u001f\u007f-\u009f\u00ad\u061c\u200b-\u200f\u2028\u2029\ufeff\ufff9-\ufffc]/g, function (e, t, r) {
              e.state.specialChars = new RegExp(t.source + (t.test("\t") ? "" : "|\t"), "g"), r != _a && e.refresh();
            }), r("specialCharPlaceholder", Jt, function (e) {
              return e.refresh();
            }, !0), r("electricChars", !0), r("inputStyle", v ? "contenteditable" : "textarea", function () {
              throw new Error("inputStyle can not (yet) be changed in a running editor");
            }, !0), r("spellcheck", !1, function (e, t) {
              return e.getInputField().spellcheck = t;
            }, !0), r("autocorrect", !1, function (e, t) {
              return e.getInputField().autocorrect = t;
            }, !0), r("autocapitalize", !1, function (e, t) {
              return e.getInputField().autocapitalize = t;
            }, !0), r("rtlMoveVisually", !k), r("wholeLineUpdateBefore", !0), r("theme", "default", function (e) {
              wa(e), gi(e);
            }, !0), r("keyMap", "default", function (e, t, r) {
              var n = Yo(t),
                i = r != _a && Yo(r);
              i && i.detach && i.detach(e, n), n.attach && n.attach(e, i || null);
            }), r("extraKeys", null), r("configureMouse", null), r("lineWrapping", !1, Ma, !0), r("gutters", [], function (e, t) {
              e.display.gutterSpecs = mi(t, e.options.lineNumbers), gi(e);
            }, !0), r("fixedGutter", !0, function (e, t) {
              e.display.gutters.style.left = t ? sn(e.display) + "px" : "0", e.refresh();
            }, !0), r("coverGutterNextToScrollbar", !1, function (e) {
              return $n(e);
            }, !0), r("scrollbarStyle", "native", function (e) {
              Bn(e), $n(e), e.display.scrollbars.setScrollTop(e.doc.scrollTop), e.display.scrollbars.setScrollLeft(e.doc.scrollLeft);
            }, !0), r("lineNumbers", !1, function (e, t) {
              e.display.gutterSpecs = mi(e.options.gutters, t), gi(e);
            }, !0), r("firstLineNumber", 1, gi, !0), r("lineNumberFormatter", function (e) {
              return e;
            }, gi, !0), r("showCursorWhenSelecting", !1, yn, !0), r("resetSelectionOnContextMenu", !0), r("lineWiseCopyCut", !0), r("pasteLinesPerSelection", !0), r("selectionsMayTouch", !1), r("readOnly", !1, function (e, t) {
              "nocursor" == t && (Tn(e), e.display.input.blur()), e.display.input.readOnlyChanged(t);
            }), r("screenReaderLabel", null, function (e, t) {
              t = "" === t ? null : t, e.display.input.screenReaderLabelChanged(t);
            }), r("disableInput", !1, function (e, t) {
              t || e.display.input.reset();
            }, !0), r("dragDrop", !0, Ta), r("allowDropFileTypes", null), r("cursorBlinkRate", 530), r("cursorScrollMargin", 0), r("cursorHeight", 1, yn, !0), r("singleCursorHeightPerLine", !0, yn, !0), r("workTime", 100), r("workDelay", 100), r("flattenSpans", !0, zi, !0), r("addModeClass", !1, zi, !0), r("pollInterval", 100), r("undoDepth", 200, function (e, t) {
              return e.doc.history.undoDepth = t;
            }), r("historyEventDelay", 1250), r("viewportMargin", 10, function (e) {
              return e.refresh();
            }, !0), r("maxHighlightLength", 1e4, zi, !0), r("moveInputWithCursor", !0, function (e, t) {
              t || e.display.input.resetPosition();
            }), r("tabindex", null, function (e, t) {
              return e.display.input.getField().tabIndex = t || "";
            }), r("autofocus", null), r("direction", "ltr", function (e, t) {
              return e.doc.setDirection(t);
            }, !0), r("phrases", null);
          }(Ea), function (e) {
            var t = e.optionHandlers,
              r = e.helpers = {};
            e.prototype = {
              constructor: e,
              focus: function focus() {
                window.focus(), this.display.input.focus();
              },
              setOption: function setOption(e, r) {
                var n = this.options,
                  i = n[e];
                n[e] == r && "mode" != e || (n[e] = r, t.hasOwnProperty(e) && ti(this, t[e])(this, r, i), he(this, "optionChange", this, e));
              },
              getOption: function getOption(e) {
                return this.options[e];
              },
              getDoc: function getDoc() {
                return this.doc;
              },
              addKeyMap: function addKeyMap(e, t) {
                this.state.keyMaps[t ? "push" : "unshift"](Yo(e));
              },
              removeKeyMap: function removeKeyMap(e) {
                for (var t = this.state.keyMaps, r = 0; r < t.length; ++r) {
                  if (t[r] == e || t[r].name == e) return t.splice(r, 1), !0;
                }
              },
              addOverlay: ri(function (t, r) {
                var n = t.token ? t : e.getMode(this.options, t);
                if (n.startState) throw new Error("Overlays may not be stateful.");
                !function (e, t, r) {
                  for (var n = 0, i = r(t); n < e.length && r(e[n]) <= i;) {
                    n++;
                  }
                  e.splice(n, 0, t);
                }(this.state.overlays, {
                  mode: n,
                  modeSpec: t,
                  opaque: r && r.opaque,
                  priority: r && r.priority || 0
                }, function (e) {
                  return e.priority;
                }), this.state.modeGen++, pn(this);
              }),
              removeOverlay: ri(function (e) {
                for (var t = this.state.overlays, r = 0; r < t.length; ++r) {
                  var n = t[r].modeSpec;
                  if (n == e || "string" == typeof e && n.name == e) return t.splice(r, 1), this.state.modeGen++, void pn(this);
                }
              }),
              indentLine: ri(function (e, t, r) {
                "string" != typeof t && "number" != typeof t && (t = null == t ? this.options.smartIndent ? "smart" : "prev" : t ? "add" : "subtract"), Je(this.doc, e) && Aa(this, e, t, r);
              }),
              indentSelection: ri(function (e) {
                for (var t = this.doc.sel.ranges, r = -1, n = 0; n < t.length; n++) {
                  var i = t[n];
                  if (i.empty()) i.head.line > r && (Aa(this, i.head.line, e, !0), r = i.head.line, n == this.doc.sel.primIndex && zn(this));else {
                    var o = i.from(),
                      a = i.to(),
                      s = Math.max(r, o.line);
                    r = Math.min(this.lastLine(), a.line - (a.ch ? 0 : 1)) + 1;
                    for (var l = s; l < r; ++l) {
                      Aa(this, l, e);
                    }
                    var c = this.doc.sel.ranges;
                    0 == o.ch && t.length == c.length && c[n].from().ch > 0 && Yi(this.doc, n, new Si(o, c[n].to()), U);
                  }
                }
              }),
              getTokenAt: function getTokenAt(e, t) {
                return bt(this, e, t);
              },
              getLineTokens: function getLineTokens(e, t) {
                return bt(this, tt(e), t, !0);
              },
              getTokenTypeAt: function getTokenTypeAt(e) {
                e = lt(this.doc, e);
                var t,
                  r = ft(this, Ge(this.doc, e.line)),
                  n = 0,
                  i = (r.length - 1) / 2,
                  o = e.ch;
                if (0 == o) t = r[2];else for (;;) {
                  var a = n + i >> 1;
                  if ((a ? r[2 * a - 1] : 0) >= o) i = a;else {
                    if (!(r[2 * a + 1] < o)) {
                      t = r[2 * a + 2];
                      break;
                    }
                    n = a + 1;
                  }
                }
                var s = t ? t.indexOf("overlay ") : -1;
                return s < 0 ? t : 0 == s ? null : t.slice(0, s - 1);
              },
              getModeAt: function getModeAt(t) {
                var r = this.doc.mode;
                return r.innerMode ? e.innerMode(r, this.getTokenAt(t).state).mode : r;
              },
              getHelper: function getHelper(e, t) {
                return this.getHelpers(e, t)[0];
              },
              getHelpers: function getHelpers(e, t) {
                var n = [];
                if (!r.hasOwnProperty(t)) return n;
                var i = r[t],
                  o = this.getModeAt(e);
                if ("string" == typeof o[t]) i[o[t]] && n.push(i[o[t]]);else if (o[t]) for (var a = 0; a < o[t].length; a++) {
                  var s = i[o[t][a]];
                  s && n.push(s);
                } else o.helperType && i[o.helperType] ? n.push(i[o.helperType]) : i[o.name] && n.push(i[o.name]);
                for (var l = 0; l < i._global.length; l++) {
                  var c = i._global[l];
                  c.pred(o, this) && -1 == W(n, c.val) && n.push(c.val);
                }
                return n;
              },
              getStateAfter: function getStateAfter(e, t) {
                var r = this.doc;
                return mt(this, (e = st(r, null == e ? r.first + r.size - 1 : e)) + 1, t).state;
              },
              cursorCoords: function cursorCoords(e, t) {
                var r = this.doc.sel.primary();
                return Gr(this, null == e ? r.head : "object" == a(e) ? lt(this.doc, e) : e ? r.from() : r.to(), t || "page");
              },
              charCoords: function charCoords(e, t) {
                return Vr(this, lt(this.doc, e), t || "page");
              },
              coordsChar: function coordsChar(e, t) {
                return Xr(this, (e = Br(this, e, t || "page")).left, e.top);
              },
              lineAtHeight: function lineAtHeight(e, t) {
                return e = Br(this, {
                  top: e,
                  left: 0
                }, t || "page").top, Qe(this.doc, e + this.display.viewOffset);
              },
              heightAtLine: function heightAtLine(e, t, r) {
                var n,
                  i = !1;
                if ("number" == typeof e) {
                  var o = this.doc.first + this.doc.size - 1;
                  e < this.doc.first ? e = this.doc.first : e > o && (e = o, i = !0), n = Ge(this.doc, e);
                } else n = e;
                return Hr(this, n, {
                  top: 0,
                  left: 0
                }, t || "page", r || i).top + (i ? this.doc.height - Ht(n) : 0);
              },
              defaultTextHeight: function defaultTextHeight() {
                return nn(this.display);
              },
              defaultCharWidth: function defaultCharWidth() {
                return on(this.display);
              },
              getViewport: function getViewport() {
                return {
                  from: this.display.viewFrom,
                  to: this.display.viewTo
                };
              },
              addWidget: function addWidget(e, t, r, n, i) {
                var o,
                  a,
                  s,
                  l = this.display,
                  c = (e = Gr(this, lt(this.doc, e))).bottom,
                  u = e.left;
                if (t.style.position = "absolute", t.setAttribute("cm-ignore-events", "true"), this.display.input.setUneditable(t), l.sizer.appendChild(t), "over" == n) c = e.top;else if ("above" == n || "near" == n) {
                  var d = Math.max(l.wrapper.clientHeight, this.doc.height),
                    p = Math.max(l.sizer.clientWidth, l.lineSpace.clientWidth);
                  ("above" == n || e.bottom + t.offsetHeight > d) && e.top > t.offsetHeight ? c = e.top - t.offsetHeight : e.bottom + t.offsetHeight <= d && (c = e.bottom), u + t.offsetWidth > p && (u = p - t.offsetWidth);
                }
                t.style.top = c + "px", t.style.left = t.style.right = "", "right" == i ? (u = l.sizer.clientWidth - t.offsetWidth, t.style.right = "0px") : ("left" == i ? u = 0 : "middle" == i && (u = (l.sizer.clientWidth - t.offsetWidth) / 2), t.style.left = u + "px"), r && (o = this, a = {
                  left: u,
                  top: c,
                  right: u + t.offsetWidth,
                  bottom: c + t.offsetHeight
                }, null != (s = An(o, a)).scrollTop && Pn(o, s.scrollTop), null != s.scrollLeft && qn(o, s.scrollLeft));
              },
              triggerOnKeyDown: ri(da),
              triggerOnKeyPress: ri(fa),
              triggerOnKeyUp: pa,
              triggerOnMouseDown: ri(ya),
              execCommand: function execCommand(e) {
                if (ra.hasOwnProperty(e)) return ra[e].call(null, this);
              },
              triggerElectric: ri(function (e) {
                Ia(this, e);
              }),
              findPosH: function findPosH(e, t, r, n) {
                var i = 1;
                t < 0 && (i = -1, t = -t);
                for (var o = lt(this.doc, e), a = 0; a < t && !(o = Fa(this.doc, o, i, r, n)).hitSide; ++a) {
                  ;
                }
                return o;
              },
              moveH: ri(function (e, t) {
                var r = this;
                this.extendSelectionsBy(function (n) {
                  return r.display.shift || r.doc.extend || n.empty() ? Fa(r.doc, n.head, e, t, r.options.rtlMoveVisually) : e < 0 ? n.from() : n.to();
                }, B);
              }),
              deleteH: ri(function (e, t) {
                var r = this.doc.sel,
                  n = this.doc;
                r.somethingSelected() ? n.replaceSelection("", null, "+delete") : Qo(this, function (r) {
                  var i = Fa(n, r.head, e, t, !1);
                  return e < 0 ? {
                    from: i,
                    to: r.head
                  } : {
                    from: r.head,
                    to: i
                  };
                });
              }),
              findPosV: function findPosV(e, t, r, n) {
                var i = 1,
                  o = n;
                t < 0 && (i = -1, t = -t);
                for (var a = lt(this.doc, e), s = 0; s < t; ++s) {
                  var l = Gr(this, a, "div");
                  if (null == o ? o = l.left : l.left = o, (a = Ra(this, l, i, r)).hitSide) break;
                }
                return a;
              },
              moveV: ri(function (e, t) {
                var r = this,
                  n = this.doc,
                  i = [],
                  o = !this.display.shift && !n.extend && n.sel.somethingSelected();
                if (n.extendSelectionsBy(function (a) {
                  if (o) return e < 0 ? a.from() : a.to();
                  var s = Gr(r, a.head, "div");
                  null != a.goalColumn && (s.left = a.goalColumn), i.push(s.left);
                  var l = Ra(r, s, e, t);
                  return "page" == t && a == n.sel.primary() && Nn(r, Vr(r, l, "div").top - s.top), l;
                }, B), i.length) for (var a = 0; a < n.sel.ranges.length; a++) {
                  n.sel.ranges[a].goalColumn = i[a];
                }
              }),
              findWordAt: function findWordAt(e) {
                var t = Ge(this.doc, e.line).text,
                  r = e.ch,
                  n = e.ch;
                if (t) {
                  var i = this.getHelper(e, "wordChars");
                  "before" != e.sticky && n != t.length || !r ? ++n : --r;
                  for (var o = t.charAt(r), a = te(o, i) ? function (e) {
                      return te(e, i);
                    } : /\s/.test(o) ? function (e) {
                      return /\s/.test(e);
                    } : function (e) {
                      return !/\s/.test(e) && !te(e);
                    }; r > 0 && a(t.charAt(r - 1));) {
                    --r;
                  }
                  for (; n < t.length && a(t.charAt(n));) {
                    ++n;
                  }
                }
                return new Si(tt(e.line, r), tt(e.line, n));
              },
              toggleOverwrite: function toggleOverwrite(e) {
                null != e && e == this.state.overwrite || ((this.state.overwrite = !this.state.overwrite) ? D(this.display.cursorDiv, "CodeMirror-overwrite") : M(this.display.cursorDiv, "CodeMirror-overwrite"), he(this, "overwriteToggle", this, this.state.overwrite));
              },
              hasFocus: function hasFocus() {
                return this.display.input.getField() == O();
              },
              isReadOnly: function isReadOnly() {
                return !(!this.options.readOnly && !this.doc.cantEdit);
              },
              scrollTo: ri(function (e, t) {
                On(this, e, t);
              }),
              getScrollInfo: function getScrollInfo() {
                var e = this.display.scroller;
                return {
                  left: e.scrollLeft,
                  top: e.scrollTop,
                  height: e.scrollHeight - Tr(this) - this.display.barHeight,
                  width: e.scrollWidth - Tr(this) - this.display.barWidth,
                  clientHeight: Er(this),
                  clientWidth: Mr(this)
                };
              },
              scrollIntoView: ri(function (e, t) {
                null == e ? (e = {
                  from: this.doc.sel.primary().head,
                  to: null
                }, null == t && (t = this.options.cursorScrollMargin)) : "number" == typeof e ? e = {
                  from: tt(e, 0),
                  to: null
                } : null == e.from && (e = {
                  from: e,
                  to: null
                }), e.to || (e.to = e.from), e.margin = t || 0, null != e.from.line ? function (e, t) {
                  Dn(e), e.curOp.scrollToPos = t;
                }(this, e) : In(this, e.from, e.to, e.margin);
              }),
              setSize: ri(function (e, t) {
                var r = this,
                  n = function n(e) {
                    return "number" == typeof e || /^\d+$/.test(String(e)) ? e + "px" : e;
                  };
                null != e && (this.display.wrapper.style.width = n(e)), null != t && (this.display.wrapper.style.height = n(t)), this.options.lineWrapping && Fr(this);
                var i = this.display.viewFrom;
                this.doc.iter(i, this.display.viewTo, function (e) {
                  if (e.widgets) for (var t = 0; t < e.widgets.length; t++) {
                    if (e.widgets[t].noHScroll) {
                      fn(r, i, "widget");
                      break;
                    }
                  }
                  ++i;
                }), this.curOp.forceUpdate = !0, he(this, "refresh", this);
              }),
              operation: function operation(e) {
                return ei(this, e);
              },
              startOperation: function startOperation() {
                return Gn(this);
              },
              endOperation: function endOperation() {
                return Kn(this);
              },
              refresh: ri(function () {
                var e = this.display.cachedTextHeight;
                pn(this), this.curOp.forceUpdate = !0, Rr(this), On(this, this.doc.scrollLeft, this.doc.scrollTop), ui(this.display), (null == e || Math.abs(e - nn(this.display)) > .5 || this.options.lineWrapping) && cn(this), he(this, "refresh", this);
              }),
              swapDoc: ri(function (e) {
                var t = this.doc;
                return t.cm = null, this.state.selectingText && this.state.selectingText(), Pi(this, e), Rr(this), this.display.input.reset(), On(this, e.scrollLeft, e.scrollTop), this.curOp.forceScroll = !0, lr(this, "swapDoc", this, t), t;
              }),
              phrase: function phrase(e) {
                var t = this.options.phrases;
                return t && Object.prototype.hasOwnProperty.call(t, e) ? t[e] : e;
              },
              getInputField: function getInputField() {
                return this.display.input.getField();
              },
              getWrapperElement: function getWrapperElement() {
                return this.display.wrapper;
              },
              getScrollerElement: function getScrollerElement() {
                return this.display.scroller;
              },
              getGutterElement: function getGutterElement() {
                return this.display.gutters;
              }
            }, be(e), e.registerHelper = function (t, n, i) {
              r.hasOwnProperty(t) || (r[t] = e[t] = {
                _global: []
              }), r[t][n] = i;
            }, e.registerGlobalHelper = function (t, n, i, o) {
              e.registerHelper(t, n, o), r[t]._global.push({
                pred: i,
                val: o
              });
            };
          }(Ea);
          var Ga = "iter insert remove copy getEditor constructor".split(" ");
          for (var Ka in zo.prototype) {
            zo.prototype.hasOwnProperty(Ka) && W(Ga, Ka) < 0 && (Ea.prototype[Ka] = function (e) {
              return function () {
                return e.apply(this.doc, arguments);
              };
            }(zo.prototype[Ka]));
          }
          return be(zo), Ea.inputStyles = {
            textarea: Va,
            contenteditable: Wa
          }, Ea.defineMode = function (e) {
            Ea.defaults.mode || "null" == e || (Ea.defaults.mode = e), qe.apply(this, arguments);
          }, Ea.defineMIME = function (e, t) {
            je[e] = t;
          }, Ea.defineMode("null", function () {
            return {
              token: function token(e) {
                return e.skipToEnd();
              }
            };
          }), Ea.defineMIME("text/plain", "null"), Ea.defineExtension = function (e, t) {
            Ea.prototype[e] = t;
          }, Ea.defineDocExtension = function (e, t) {
            zo.prototype[e] = t;
          }, Ea.fromTextArea = function (e, t) {
            if ((t = t ? q(t) : {}).value = e.value, !t.tabindex && e.tabIndex && (t.tabindex = e.tabIndex), !t.placeholder && e.placeholder && (t.placeholder = e.placeholder), null == t.autofocus) {
              var r = O();
              t.autofocus = r == e || null != e.getAttribute("autofocus") && r == document.body;
            }
            function n() {
              e.value = s.getValue();
            }
            var i;
            if (e.form && (pe(e.form, "submit", n), !t.leaveSubmitMethodAlone)) {
              var o = e.form;
              i = o.submit;
              try {
                var a = o.submit = function () {
                  n(), o.submit = i, o.submit(), o.submit = a;
                };
              } catch (e) {}
            }
            t.finishInit = function (r) {
              r.save = n, r.getTextArea = function () {
                return e;
              }, r.toTextArea = function () {
                r.toTextArea = isNaN, n(), e.parentNode.removeChild(r.getWrapperElement()), e.style.display = "", e.form && (me(e.form, "submit", n), t.leaveSubmitMethodAlone || "function" != typeof e.form.submit || (e.form.submit = i));
              };
            }, e.style.display = "none";
            var s = Ea(function (t) {
              return e.parentNode.insertBefore(t, e.nextSibling);
            }, t);
            return s;
          }, function (e) {
            e.off = me, e.on = pe, e.wheelEventPixels = ki, e.Doc = zo, e.splitLines = ze, e.countColumn = F, e.findColumn = V, e.isWordChar = ee, e.Pass = $, e.signal = he, e.Line = Gt, e.changeEnd = Mi, e.scrollbarModel = Hn, e.Pos = tt, e.cmpPos = rt, e.modes = Pe, e.mimeModes = je, e.resolveMode = Fe, e.getMode = Re, e.modeExtensions = We, e.extendMode = $e, e.copyState = Ue, e.startState = Be, e.innerMode = He, e.commands = ra, e.keyMap = Ho, e.keyName = Xo, e.isModifierKey = Ko, e.lookupKey = Go, e.normalizeKeyMap = Vo, e.StringStream = Ve, e.SharedTextMarker = Eo, e.TextMarker = To, e.LineWidget = _o, e.e_preventDefault = xe, e.e_stopPropagation = ke, e.e_stop = _e, e.addClass = D, e.contains = z, e.rmClass = M, e.keyNames = Ro;
          }(Ea), Ea.version = "5.54.0", Ea;
        }, "object" === a(t) ? e.exports = o() : void 0 === (i = "function" == typeof (n = o) ? n.call(t, r, t, e) : n) || (e.exports = i);
      },
      1736: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          function t(e, t, r, n, i, o) {
            this.indented = e, this.column = t, this.type = r, this.info = n, this.align = i, this.prev = o;
          }
          function r(e, r, n, i) {
            var o = e.indented;
            return e.context && "statement" == e.context.type && "statement" != n && (o = e.context.indented), e.context = new t(o, r, n, i, null, e.context);
          }
          function n(e) {
            var t = e.context.type;
            return ")" != t && "]" != t && "}" != t || (e.indented = e.context.indented), e.context = e.context.prev;
          }
          function i(e, t, r) {
            return "variable" == t.prevToken || "type" == t.prevToken || !!/\S(?:[^- ]>|[*\]])\s*$|\*$/.test(e.string.slice(0, r)) || !(!t.typeAtEndOfLine || e.column() != e.indentation()) || void 0;
          }
          function o(e) {
            for (;;) {
              if (!e || "top" == e.type) return !0;
              if ("}" == e.type && "namespace" != e.prev.info) return !1;
              e = e.prev;
            }
          }
          function a(e) {
            for (var t = {}, r = e.split(" "), n = 0; n < r.length; ++n) {
              t[r[n]] = !0;
            }
            return t;
          }
          function s(e, t) {
            return "function" == typeof e ? e(t) : e.propertyIsEnumerable(t);
          }
          e.defineMode("clike", function (a, l) {
            var c,
              u,
              d = a.indentUnit,
              p = l.statementIndentUnit || d,
              f = l.dontAlignCalls,
              m = l.keywords || {},
              h = l.types || {},
              g = l.builtin || {},
              y = l.blockKeywords || {},
              v = l.defKeywords || {},
              b = l.atoms || {},
              x = l.hooks || {},
              k = l.multiLineStrings,
              w = !1 !== l.indentStatements,
              _ = !1 !== l.indentSwitch,
              S = l.namespaceSeparator,
              C = l.isPunctuationChar || /[\[\]{}\(\),;\:\.]/,
              T = l.numberStart || /[\d\.]/,
              M = l.number || /^(?:0x[a-f\d]+|0b[01]+|(?:\d+\.?\d*|\.\d+)(?:e[-+]?\d+)?)(u|ll?|l|f)?/i,
              E = l.isOperatorChar || /[+\-*&%=<>!?|\/]/,
              L = l.isIdentifierChar || /[\w\$_\xa1-\uffff]/,
              A = l.isReservedIdentifier || !1;
            function N(e, t) {
              var r,
                n = e.next();
              if (x[n]) {
                var i = x[n](e, t);
                if (!1 !== i) return i;
              }
              if ('"' == n || "'" == n) return t.tokenize = (r = n, function (e, t) {
                for (var n, i = !1, o = !1; null != (n = e.next());) {
                  if (n == r && !i) {
                    o = !0;
                    break;
                  }
                  i = !i && "\\" == n;
                }
                return (o || !i && !k) && (t.tokenize = null), "string";
              }), t.tokenize(e, t);
              if (C.test(n)) return c = n, null;
              if (T.test(n)) {
                if (e.backUp(1), e.match(M)) return "number";
                e.next();
              }
              if ("/" == n) {
                if (e.eat("*")) return t.tokenize = z, z(e, t);
                if (e.eat("/")) return e.skipToEnd(), "comment";
              }
              if (E.test(n)) {
                for (; !e.match(/^\/[\/*]/, !1) && e.eat(E);) {
                  ;
                }
                return "operator";
              }
              if (e.eatWhile(L), S) for (; e.match(S);) {
                e.eatWhile(L);
              }
              var o = e.current();
              return s(m, o) ? (s(y, o) && (c = "newstatement"), s(v, o) && (u = !0), "keyword") : s(h, o) ? "type" : s(g, o) || A && A(o) ? (s(y, o) && (c = "newstatement"), "builtin") : s(b, o) ? "atom" : "variable";
            }
            function z(e, t) {
              for (var r, n = !1; r = e.next();) {
                if ("/" == r && n) {
                  t.tokenize = null;
                  break;
                }
                n = "*" == r;
              }
              return "comment";
            }
            function O(e, t) {
              l.typeFirstDefinitions && e.eol() && o(t.context) && (t.typeAtEndOfLine = i(e, t, e.pos));
            }
            return {
              startState: function startState(e) {
                return {
                  tokenize: null,
                  context: new t((e || 0) - d, 0, "top", null, !1),
                  indented: 0,
                  startOfLine: !0,
                  prevToken: null
                };
              },
              token: function token(e, t) {
                var a = t.context;
                if (e.sol() && (null == a.align && (a.align = !1), t.indented = e.indentation(), t.startOfLine = !0), e.eatSpace()) return O(e, t), null;
                c = u = null;
                var s = (t.tokenize || N)(e, t);
                if ("comment" == s || "meta" == s) return s;
                if (null == a.align && (a.align = !0), ";" == c || ":" == c || "," == c && e.match(/^\s*(?:\/\/.*)?$/, !1)) for (; "statement" == t.context.type;) {
                  n(t);
                } else if ("{" == c) r(t, e.column(), "}");else if ("[" == c) r(t, e.column(), "]");else if ("(" == c) r(t, e.column(), ")");else if ("}" == c) {
                  for (; "statement" == a.type;) {
                    a = n(t);
                  }
                  for ("}" == a.type && (a = n(t)); "statement" == a.type;) {
                    a = n(t);
                  }
                } else c == a.type ? n(t) : w && (("}" == a.type || "top" == a.type) && ";" != c || "statement" == a.type && "newstatement" == c) && r(t, e.column(), "statement", e.current());
                if ("variable" == s && ("def" == t.prevToken || l.typeFirstDefinitions && i(e, t, e.start) && o(t.context) && e.match(/^\s*\(/, !1)) && (s = "def"), x.token) {
                  var d = x.token(e, t, s);
                  void 0 !== d && (s = d);
                }
                return "def" == s && !1 === l.styleDefs && (s = "variable"), t.startOfLine = !1, t.prevToken = u ? "def" : s || c, O(e, t), s;
              },
              indent: function indent(t, r) {
                if (t.tokenize != N && null != t.tokenize || t.typeAtEndOfLine) return e.Pass;
                var n = t.context,
                  i = r && r.charAt(0),
                  o = i == n.type;
                if ("statement" == n.type && "}" == i && (n = n.prev), l.dontIndentStatements) for (; "statement" == n.type && l.dontIndentStatements.test(n.info);) {
                  n = n.prev;
                }
                if (x.indent) {
                  var a = x.indent(t, n, r, d);
                  if ("number" == typeof a) return a;
                }
                var s = n.prev && "switch" == n.prev.info;
                if (l.allmanIndentation && /[{(]/.test(i)) {
                  for (; "top" != n.type && "}" != n.type;) {
                    n = n.prev;
                  }
                  return n.indented;
                }
                return "statement" == n.type ? n.indented + ("{" == i ? 0 : p) : !n.align || f && ")" == n.type ? ")" != n.type || o ? n.indented + (o ? 0 : d) + (o || !s || /^(?:case|default)\b/.test(r) ? 0 : d) : n.indented + p : n.column + (o ? 0 : 1);
              },
              electricInput: _ ? /^\s*(?:case .*?:|default:|\{\}?|\})$/ : /^\s*[{}]$/,
              blockCommentStart: "/*",
              blockCommentEnd: "*/",
              blockCommentContinue: " * ",
              lineComment: "//",
              fold: "brace"
            };
          });
          var l = "auto if break case register continue return default do sizeof static else struct switch extern typedef union for goto while enum const volatile inline restrict asm fortran",
            c = "alignas alignof and and_eq audit axiom bitand bitor catch class compl concept constexpr const_cast decltype delete dynamic_cast explicit export final friend import module mutable namespace new noexcept not not_eq operator or or_eq override private protected public reinterpret_cast requires static_assert static_cast template this thread_local throw try typeid typename using virtual xor xor_eq",
            u = "bycopy byref in inout oneway out self super atomic nonatomic retain copy readwrite readonly strong weak assign typeof nullable nonnull null_resettable _cmd @interface @implementation @end @protocol @encode @property @synthesize @dynamic @class @public @package @private @protected @required @optional @try @catch @finally @import @selector @encode @defs @synchronized @autoreleasepool @compatibility_alias @available",
            d = "FOUNDATION_EXPORT FOUNDATION_EXTERN NS_INLINE NS_FORMAT_FUNCTION  NS_RETURNS_RETAINEDNS_ERROR_ENUM NS_RETURNS_NOT_RETAINED NS_RETURNS_INNER_POINTER NS_DESIGNATED_INITIALIZER NS_ENUM NS_OPTIONS NS_REQUIRES_NIL_TERMINATION NS_ASSUME_NONNULL_BEGIN NS_ASSUME_NONNULL_END NS_SWIFT_NAME NS_REFINED_FOR_SWIFT",
            p = a("int long char short double float unsigned signed void bool"),
            f = a("SEL instancetype id Class Protocol BOOL");
          function m(e) {
            return s(p, e) || /.+_t$/.test(e);
          }
          function h(e) {
            return m(e) || s(f, e);
          }
          var g = "case do else for if switch while struct enum union",
            y = "struct enum union";
          function v(e, t) {
            if (!t.startOfLine) return !1;
            for (var r, n = null; r = e.peek();) {
              if ("\\" == r && e.match(/^.$/)) {
                n = v;
                break;
              }
              if ("/" == r && e.match(/^\/[\/\*]/, !1)) break;
              e.next();
            }
            return t.tokenize = n, "meta";
          }
          function b(e, t) {
            return "type" == t.prevToken && "type";
          }
          function x(e) {
            return !(!e || e.length < 2 || "_" != e[0] || "_" != e[1] && e[1] === e[1].toLowerCase());
          }
          function k(e) {
            return e.eatWhile(/[\w\.']/), "number";
          }
          function w(e, t) {
            if (e.backUp(1), e.match(/(R|u8R|uR|UR|LR)/)) {
              var r = e.match(/"([^\s\\()]{0,16})\(/);
              return !!r && (t.cpp11RawStringDelim = r[1], t.tokenize = C, C(e, t));
            }
            return e.match(/(u8|u|U|L)/) ? !!e.match(/["']/, !1) && "string" : (e.next(), !1);
          }
          function _(e) {
            var t = /(\w+)::~?(\w+)$/.exec(e);
            return t && t[1] == t[2];
          }
          function S(e, t) {
            for (var r; null != (r = e.next());) {
              if ('"' == r && !e.eat('"')) {
                t.tokenize = null;
                break;
              }
            }
            return "string";
          }
          function C(e, t) {
            var r = t.cpp11RawStringDelim.replace(/[^\w\s]/g, "\\$&");
            return e.match(new RegExp(".*?\\)" + r + '"')) ? t.tokenize = null : e.skipToEnd(), "string";
          }
          function T(t, r) {
            "string" == typeof t && (t = [t]);
            var n = [];
            function i(e) {
              if (e) for (var t in e) {
                e.hasOwnProperty(t) && n.push(t);
              }
            }
            i(r.keywords), i(r.types), i(r.builtin), i(r.atoms), n.length && (r.helperType = t[0], e.registerHelper("hintWords", t[0], n));
            for (var o = 0; o < t.length; ++o) {
              e.defineMIME(t[o], r);
            }
          }
          function M(e, t) {
            for (var r = !1; !e.eol();) {
              if (!r && e.match('"""')) {
                t.tokenize = null;
                break;
              }
              r = "\\" == e.next() && !r;
            }
            return "string";
          }
          function E(e) {
            return function (t, r) {
              for (var n; n = t.next();) {
                if ("*" == n && t.eat("/")) {
                  if (1 == e) {
                    r.tokenize = null;
                    break;
                  }
                  return r.tokenize = E(e - 1), r.tokenize(t, r);
                }
                if ("/" == n && t.eat("*")) return r.tokenize = E(e + 1), r.tokenize(t, r);
              }
              return "comment";
            };
          }
          T(["text/x-csrc", "text/x-c", "text/x-chdr"], {
            name: "clike",
            keywords: a(l),
            types: m,
            blockKeywords: a(g),
            defKeywords: a(y),
            typeFirstDefinitions: !0,
            atoms: a("NULL true false"),
            isReservedIdentifier: x,
            hooks: {
              "#": v,
              "*": b
            },
            modeProps: {
              fold: ["brace", "include"]
            }
          }), T(["text/x-c++src", "text/x-c++hdr"], {
            name: "clike",
            keywords: a(l + " " + c),
            types: m,
            blockKeywords: a(g + " class try catch"),
            defKeywords: a(y + " class namespace"),
            typeFirstDefinitions: !0,
            atoms: a("true false NULL nullptr"),
            dontIndentStatements: /^template$/,
            isIdentifierChar: /[\w\$_~\xa1-\uffff]/,
            isReservedIdentifier: x,
            hooks: {
              "#": v,
              "*": b,
              u: w,
              U: w,
              L: w,
              R: w,
              0: k,
              1: k,
              2: k,
              3: k,
              4: k,
              5: k,
              6: k,
              7: k,
              8: k,
              9: k,
              token: function token(e, t, r) {
                if ("variable" == r && "(" == e.peek() && (";" == t.prevToken || null == t.prevToken || "}" == t.prevToken) && _(e.current())) return "def";
              }
            },
            namespaceSeparator: "::",
            modeProps: {
              fold: ["brace", "include"]
            }
          }), T("text/x-java", {
            name: "clike",
            keywords: a("abstract assert break case catch class const continue default do else enum extends final finally for goto if implements import instanceof interface native new package private protected public return static strictfp super switch synchronized this throw throws transient try volatile while @interface"),
            types: a("byte short int long float double boolean char void Boolean Byte Character Double Float Integer Long Number Object Short String StringBuffer StringBuilder Void"),
            blockKeywords: a("catch class do else finally for if switch try while"),
            defKeywords: a("class interface enum @interface"),
            typeFirstDefinitions: !0,
            atoms: a("true false null"),
            number: /^(?:0x[a-f\d_]+|0b[01_]+|(?:[\d_]+\.?\d*|\.\d+)(?:e[-+]?[\d_]+)?)(u|ll?|l|f)?/i,
            hooks: {
              "@": function _(e) {
                return !e.match("interface", !1) && (e.eatWhile(/[\w\$_]/), "meta");
              }
            },
            modeProps: {
              fold: ["brace", "import"]
            }
          }), T("text/x-csharp", {
            name: "clike",
            keywords: a("abstract as async await base break case catch checked class const continue default delegate do else enum event explicit extern finally fixed for foreach goto if implicit in interface internal is lock namespace new operator out override params private protected public readonly ref return sealed sizeof stackalloc static struct switch this throw try typeof unchecked unsafe using virtual void volatile while add alias ascending descending dynamic from get global group into join let orderby partial remove select set value var yield"),
            types: a("Action Boolean Byte Char DateTime DateTimeOffset Decimal Double Func Guid Int16 Int32 Int64 Object SByte Single String Task TimeSpan UInt16 UInt32 UInt64 bool byte char decimal double short int long object sbyte float string ushort uint ulong"),
            blockKeywords: a("catch class do else finally for foreach if struct switch try while"),
            defKeywords: a("class interface namespace struct var"),
            typeFirstDefinitions: !0,
            atoms: a("true false null"),
            hooks: {
              "@": function _(e, t) {
                return e.eat('"') ? (t.tokenize = S, S(e, t)) : (e.eatWhile(/[\w\$_]/), "meta");
              }
            }
          }), T("text/x-scala", {
            name: "clike",
            keywords: a("abstract case catch class def do else extends final finally for forSome if implicit import lazy match new null object override package private protected return sealed super this throw trait try type val var while with yield _ assert assume require print println printf readLine readBoolean readByte readShort readChar readInt readLong readFloat readDouble"),
            types: a("AnyVal App Application Array BufferedIterator BigDecimal BigInt Char Console Either Enumeration Equiv Error Exception Fractional Function IndexedSeq Int Integral Iterable Iterator List Map Numeric Nil NotNull Option Ordered Ordering PartialFunction PartialOrdering Product Proxy Range Responder Seq Serializable Set Specializable Stream StringBuilder StringContext Symbol Throwable Traversable TraversableOnce Tuple Unit Vector Boolean Byte Character CharSequence Class ClassLoader Cloneable Comparable Compiler Double Exception Float Integer Long Math Number Object Package Pair Process Runtime Runnable SecurityManager Short StackTraceElement StrictMath String StringBuffer System Thread ThreadGroup ThreadLocal Throwable Triple Void"),
            multiLineStrings: !0,
            blockKeywords: a("catch class enum do else finally for forSome if match switch try while"),
            defKeywords: a("class enum def object package trait type val var"),
            atoms: a("true false null"),
            indentStatements: !1,
            indentSwitch: !1,
            isOperatorChar: /[+\-*&%=<>!?|\/#:@]/,
            hooks: {
              "@": function _(e) {
                return e.eatWhile(/[\w\$_]/), "meta";
              },
              '"': function _(e, t) {
                return !!e.match('""') && (t.tokenize = M, t.tokenize(e, t));
              },
              "'": function _(e) {
                return e.eatWhile(/[\w\$_\xa1-\uffff]/), "atom";
              },
              "=": function _(e, r) {
                var n = r.context;
                return !("}" != n.type || !n.align || !e.eat(">")) && (r.context = new t(n.indented, n.column, n.type, n.info, null, n.prev), "operator");
              },
              "/": function _(e, t) {
                return !!e.eat("*") && (t.tokenize = E(1), t.tokenize(e, t));
              }
            },
            modeProps: {
              closeBrackets: {
                pairs: '()[]{}""',
                triples: '"'
              }
            }
          }), T("text/x-kotlin", {
            name: "clike",
            keywords: a("package as typealias class interface this super val operator var fun for is in This throw return annotation break continue object if else while do try when !in !is as? file import where by get set abstract enum open inner override private public internal protected catch finally out final vararg reified dynamic companion constructor init sealed field property receiver param sparam lateinit data inline noinline tailrec external annotation crossinline const operator infix suspend actual expect setparam"),
            types: a("Boolean Byte Character CharSequence Class ClassLoader Cloneable Comparable Compiler Double Exception Float Integer Long Math Number Object Package Pair Process Runtime Runnable SecurityManager Short StackTraceElement StrictMath String StringBuffer System Thread ThreadGroup ThreadLocal Throwable Triple Void Annotation Any BooleanArray ByteArray Char CharArray DeprecationLevel DoubleArray Enum FloatArray Function Int IntArray Lazy LazyThreadSafetyMode LongArray Nothing ShortArray Unit"),
            intendSwitch: !1,
            indentStatements: !1,
            multiLineStrings: !0,
            number: /^(?:0x[a-f\d_]+|0b[01_]+|(?:[\d_]+(\.\d+)?|\.\d+)(?:e[-+]?[\d_]+)?)(u|ll?|l|f)?/i,
            blockKeywords: a("catch class do else finally for if where try while enum"),
            defKeywords: a("class val var object interface fun"),
            atoms: a("true false null this"),
            hooks: {
              "@": function _(e) {
                return e.eatWhile(/[\w\$_]/), "meta";
              },
              "*": function _(e, t) {
                return "." == t.prevToken ? "variable" : "operator";
              },
              '"': function _(e, t) {
                var r;
                return t.tokenize = (r = e.match('""'), function (e, t) {
                  for (var n, i = !1, o = !1; !e.eol();) {
                    if (!r && !i && e.match('"')) {
                      o = !0;
                      break;
                    }
                    if (r && e.match('"""')) {
                      o = !0;
                      break;
                    }
                    n = e.next(), !i && "$" == n && e.match("{") && e.skipTo("}"), i = !i && "\\" == n && !r;
                  }
                  return !o && r || (t.tokenize = null), "string";
                }), t.tokenize(e, t);
              },
              "/": function _(e, t) {
                return !!e.eat("*") && (t.tokenize = E(1), t.tokenize(e, t));
              },
              indent: function indent(e, t, r, n) {
                var i = r && r.charAt(0);
                return "}" != e.prevToken && ")" != e.prevToken || "" != r ? "operator" == e.prevToken && "}" != r && "}" != e.context.type || "variable" == e.prevToken && "." == i || ("}" == e.prevToken || ")" == e.prevToken) && "." == i ? 2 * n + t.indented : t.align && "}" == t.type ? t.indented + (e.context.type == (r || "").charAt(0) ? 0 : n) : void 0 : e.indented;
              }
            },
            modeProps: {
              closeBrackets: {
                triples: '"'
              }
            }
          }), T(["x-shader/x-vertex", "x-shader/x-fragment"], {
            name: "clike",
            keywords: a("sampler1D sampler2D sampler3D samplerCube sampler1DShadow sampler2DShadow const attribute uniform varying break continue discard return for while do if else struct in out inout"),
            types: a("float int bool void vec2 vec3 vec4 ivec2 ivec3 ivec4 bvec2 bvec3 bvec4 mat2 mat3 mat4"),
            blockKeywords: a("for while do if else struct"),
            builtin: a("radians degrees sin cos tan asin acos atan pow exp log exp2 sqrt inversesqrt abs sign floor ceil fract mod min max clamp mix step smoothstep length distance dot cross normalize ftransform faceforward reflect refract matrixCompMult lessThan lessThanEqual greaterThan greaterThanEqual equal notEqual any all not texture1D texture1DProj texture1DLod texture1DProjLod texture2D texture2DProj texture2DLod texture2DProjLod texture3D texture3DProj texture3DLod texture3DProjLod textureCube textureCubeLod shadow1D shadow2D shadow1DProj shadow2DProj shadow1DLod shadow2DLod shadow1DProjLod shadow2DProjLod dFdx dFdy fwidth noise1 noise2 noise3 noise4"),
            atoms: a("true false gl_FragColor gl_SecondaryColor gl_Normal gl_Vertex gl_MultiTexCoord0 gl_MultiTexCoord1 gl_MultiTexCoord2 gl_MultiTexCoord3 gl_MultiTexCoord4 gl_MultiTexCoord5 gl_MultiTexCoord6 gl_MultiTexCoord7 gl_FogCoord gl_PointCoord gl_Position gl_PointSize gl_ClipVertex gl_FrontColor gl_BackColor gl_FrontSecondaryColor gl_BackSecondaryColor gl_TexCoord gl_FogFragCoord gl_FragCoord gl_FrontFacing gl_FragData gl_FragDepth gl_ModelViewMatrix gl_ProjectionMatrix gl_ModelViewProjectionMatrix gl_TextureMatrix gl_NormalMatrix gl_ModelViewMatrixInverse gl_ProjectionMatrixInverse gl_ModelViewProjectionMatrixInverse gl_TexureMatrixTranspose gl_ModelViewMatrixInverseTranspose gl_ProjectionMatrixInverseTranspose gl_ModelViewProjectionMatrixInverseTranspose gl_TextureMatrixInverseTranspose gl_NormalScale gl_DepthRange gl_ClipPlane gl_Point gl_FrontMaterial gl_BackMaterial gl_LightSource gl_LightModel gl_FrontLightModelProduct gl_BackLightModelProduct gl_TextureColor gl_EyePlaneS gl_EyePlaneT gl_EyePlaneR gl_EyePlaneQ gl_FogParameters gl_MaxLights gl_MaxClipPlanes gl_MaxTextureUnits gl_MaxTextureCoords gl_MaxVertexAttribs gl_MaxVertexUniformComponents gl_MaxVaryingFloats gl_MaxVertexTextureImageUnits gl_MaxTextureImageUnits gl_MaxFragmentUniformComponents gl_MaxCombineTextureImageUnits gl_MaxDrawBuffers"),
            indentSwitch: !1,
            hooks: {
              "#": v
            },
            modeProps: {
              fold: ["brace", "include"]
            }
          }), T("text/x-nesc", {
            name: "clike",
            keywords: a(l + " as atomic async call command component components configuration event generic implementation includes interface module new norace nx_struct nx_union post provides signal task uses abstract extends"),
            types: m,
            blockKeywords: a(g),
            atoms: a("null true false"),
            hooks: {
              "#": v
            },
            modeProps: {
              fold: ["brace", "include"]
            }
          }), T("text/x-objectivec", {
            name: "clike",
            keywords: a(l + " " + u),
            types: h,
            builtin: a(d),
            blockKeywords: a(g + " @synthesize @try @catch @finally @autoreleasepool @synchronized"),
            defKeywords: a(y + " @interface @implementation @protocol @class"),
            dontIndentStatements: /^@.*$/,
            typeFirstDefinitions: !0,
            atoms: a("YES NO NULL Nil nil true false nullptr"),
            isReservedIdentifier: x,
            hooks: {
              "#": v,
              "*": b
            },
            modeProps: {
              fold: ["brace", "include"]
            }
          }), T("text/x-objectivec++", {
            name: "clike",
            keywords: a(l + " " + u + " " + c),
            types: h,
            builtin: a(d),
            blockKeywords: a(g + " @synthesize @try @catch @finally @autoreleasepool @synchronized class try catch"),
            defKeywords: a(y + " @interface @implementation @protocol @class class namespace"),
            dontIndentStatements: /^@.*$|^template$/,
            typeFirstDefinitions: !0,
            atoms: a("YES NO NULL Nil nil true false nullptr"),
            isReservedIdentifier: x,
            hooks: {
              "#": v,
              "*": b,
              u: w,
              U: w,
              L: w,
              R: w,
              0: k,
              1: k,
              2: k,
              3: k,
              4: k,
              5: k,
              6: k,
              7: k,
              8: k,
              9: k,
              token: function token(e, t, r) {
                if ("variable" == r && "(" == e.peek() && (";" == t.prevToken || null == t.prevToken || "}" == t.prevToken) && _(e.current())) return "def";
              }
            },
            namespaceSeparator: "::",
            modeProps: {
              fold: ["brace", "include"]
            }
          }), T("text/x-squirrel", {
            name: "clike",
            keywords: a("base break clone continue const default delete enum extends function in class foreach local resume return this throw typeof yield constructor instanceof static"),
            types: m,
            blockKeywords: a("case catch class else for foreach if switch try while"),
            defKeywords: a("function local class"),
            typeFirstDefinitions: !0,
            atoms: a("true false null"),
            hooks: {
              "#": v
            },
            modeProps: {
              fold: ["brace", "include"]
            }
          });
          var L = null;
          function A(e) {
            return function (t, r) {
              for (var n, i = !1, o = !1; !t.eol();) {
                if (!i && t.match('"') && ("single" == e || t.match('""'))) {
                  o = !0;
                  break;
                }
                if (!i && t.match("``")) {
                  L = A(e), o = !0;
                  break;
                }
                n = t.next(), i = "single" == e && !i && "\\" == n;
              }
              return o && (r.tokenize = null), "string";
            };
          }
          T("text/x-ceylon", {
            name: "clike",
            keywords: a("abstracts alias assembly assert assign break case catch class continue dynamic else exists extends finally for function given if import in interface is let module new nonempty object of out outer package return satisfies super switch then this throw try value void while"),
            types: function types(e) {
              var t = e.charAt(0);
              return t === t.toUpperCase() && t !== t.toLowerCase();
            },
            blockKeywords: a("case catch class dynamic else finally for function if interface module new object switch try while"),
            defKeywords: a("class dynamic function interface module object package value"),
            builtin: a("abstract actual aliased annotation by default deprecated doc final formal late license native optional sealed see serializable shared suppressWarnings tagged throws variable"),
            isPunctuationChar: /[\[\]{}\(\),;\:\.`]/,
            isOperatorChar: /[+\-*&%=<>!?|^~:\/]/,
            numberStart: /[\d#$]/,
            number: /^(?:#[\da-fA-F_]+|\$[01_]+|[\d_]+[kMGTPmunpf]?|[\d_]+\.[\d_]+(?:[eE][-+]?\d+|[kMGTPmunpf]|)|)/i,
            multiLineStrings: !0,
            typeFirstDefinitions: !0,
            atoms: a("true false null larger smaller equal empty finished"),
            indentSwitch: !1,
            styleDefs: !1,
            hooks: {
              "@": function _(e) {
                return e.eatWhile(/[\w\$_]/), "meta";
              },
              '"': function _(e, t) {
                return t.tokenize = A(e.match('""') ? "triple" : "single"), t.tokenize(e, t);
              },
              "`": function _(e, t) {
                return !(!L || !e.match("`")) && (t.tokenize = L, L = null, t.tokenize(e, t));
              },
              "'": function _(e) {
                return e.eatWhile(/[\w\$_\xa1-\uffff]/), "atom";
              },
              token: function token(e, t, r) {
                if (("variable" == r || "type" == r) && "." == t.prevToken) return "variable-2";
              }
            },
            modeProps: {
              fold: ["brace", "import"],
              closeBrackets: {
                triples: '"'
              }
            }
          });
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      742: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMode("clojure", function (t) {
            var r = ["false", "nil", "true"],
              n = [".", "catch", "def", "do", "if", "monitor-enter", "monitor-exit", "new", "quote", "recur", "set!", "throw", "try", "var"],
              i = ["*", "*'", "*1", "*2", "*3", "*agent*", "*allow-unresolved-vars*", "*assert*", "*clojure-version*", "*command-line-args*", "*compile-files*", "*compile-path*", "*compiler-options*", "*data-readers*", "*default-data-reader-fn*", "*e", "*err*", "*file*", "*flush-on-newline*", "*fn-loader*", "*in*", "*math-context*", "*ns*", "*out*", "*print-dup*", "*print-length*", "*print-level*", "*print-meta*", "*print-namespace-maps*", "*print-readably*", "*read-eval*", "*reader-resolver*", "*source-path*", "*suppress-read*", "*unchecked-math*", "*use-context-classloader*", "*verbose-defrecords*", "*warn-on-reflection*", "+", "+'", "-", "-'", "->", "->>", "->ArrayChunk", "->Eduction", "->Vec", "->VecNode", "->VecSeq", "-cache-protocol-fn", "-reset-methods", "..", "/", "<", "<=", "=", "==", ">", ">=", "EMPTY-NODE", "Inst", "StackTraceElement->vec", "Throwable->map", "accessor", "aclone", "add-classpath", "add-watch", "agent", "agent-error", "agent-errors", "aget", "alength", "alias", "all-ns", "alter", "alter-meta!", "alter-var-root", "amap", "ancestors", "and", "any?", "apply", "areduce", "array-map", "as->", "aset", "aset-boolean", "aset-byte", "aset-char", "aset-double", "aset-float", "aset-int", "aset-long", "aset-short", "assert", "assoc", "assoc!", "assoc-in", "associative?", "atom", "await", "await-for", "await1", "bases", "bean", "bigdec", "bigint", "biginteger", "binding", "bit-and", "bit-and-not", "bit-clear", "bit-flip", "bit-not", "bit-or", "bit-set", "bit-shift-left", "bit-shift-right", "bit-test", "bit-xor", "boolean", "boolean-array", "boolean?", "booleans", "bound-fn", "bound-fn*", "bound?", "bounded-count", "butlast", "byte", "byte-array", "bytes", "bytes?", "case", "cast", "cat", "char", "char-array", "char-escape-string", "char-name-string", "char?", "chars", "chunk", "chunk-append", "chunk-buffer", "chunk-cons", "chunk-first", "chunk-next", "chunk-rest", "chunked-seq?", "class", "class?", "clear-agent-errors", "clojure-version", "coll?", "comment", "commute", "comp", "comparator", "compare", "compare-and-set!", "compile", "complement", "completing", "concat", "cond", "cond->", "cond->>", "condp", "conj", "conj!", "cons", "constantly", "construct-proxy", "contains?", "count", "counted?", "create-ns", "create-struct", "cycle", "dec", "dec'", "decimal?", "declare", "dedupe", "default-data-readers", "definline", "definterface", "defmacro", "defmethod", "defmulti", "defn", "defn-", "defonce", "defprotocol", "defrecord", "defstruct", "deftype", "delay", "delay?", "deliver", "denominator", "deref", "derive", "descendants", "destructure", "disj", "disj!", "dissoc", "dissoc!", "distinct", "distinct?", "doall", "dorun", "doseq", "dosync", "dotimes", "doto", "double", "double-array", "double?", "doubles", "drop", "drop-last", "drop-while", "eduction", "empty", "empty?", "ensure", "ensure-reduced", "enumeration-seq", "error-handler", "error-mode", "eval", "even?", "every-pred", "every?", "ex-data", "ex-info", "extend", "extend-protocol", "extend-type", "extenders", "extends?", "false?", "ffirst", "file-seq", "filter", "filterv", "find", "find-keyword", "find-ns", "find-protocol-impl", "find-protocol-method", "find-var", "first", "flatten", "float", "float-array", "float?", "floats", "flush", "fn", "fn?", "fnext", "fnil", "for", "force", "format", "frequencies", "future", "future-call", "future-cancel", "future-cancelled?", "future-done?", "future?", "gen-class", "gen-interface", "gensym", "get", "get-in", "get-method", "get-proxy-class", "get-thread-bindings", "get-validator", "group-by", "halt-when", "hash", "hash-combine", "hash-map", "hash-ordered-coll", "hash-set", "hash-unordered-coll", "ident?", "identical?", "identity", "if-let", "if-not", "if-some", "ifn?", "import", "in-ns", "inc", "inc'", "indexed?", "init-proxy", "inst-ms", "inst-ms*", "inst?", "instance?", "int", "int-array", "int?", "integer?", "interleave", "intern", "interpose", "into", "into-array", "ints", "io!", "isa?", "iterate", "iterator-seq", "juxt", "keep", "keep-indexed", "key", "keys", "keyword", "keyword?", "last", "lazy-cat", "lazy-seq", "let", "letfn", "line-seq", "list", "list*", "list?", "load", "load-file", "load-reader", "load-string", "loaded-libs", "locking", "long", "long-array", "longs", "loop", "macroexpand", "macroexpand-1", "make-array", "make-hierarchy", "map", "map-entry?", "map-indexed", "map?", "mapcat", "mapv", "max", "max-key", "memfn", "memoize", "merge", "merge-with", "meta", "method-sig", "methods", "min", "min-key", "mix-collection-hash", "mod", "munge", "name", "namespace", "namespace-munge", "nat-int?", "neg-int?", "neg?", "newline", "next", "nfirst", "nil?", "nnext", "not", "not-any?", "not-empty", "not-every?", "not=", "ns", "ns-aliases", "ns-imports", "ns-interns", "ns-map", "ns-name", "ns-publics", "ns-refers", "ns-resolve", "ns-unalias", "ns-unmap", "nth", "nthnext", "nthrest", "num", "number?", "numerator", "object-array", "odd?", "or", "parents", "partial", "partition", "partition-all", "partition-by", "pcalls", "peek", "persistent!", "pmap", "pop", "pop!", "pop-thread-bindings", "pos-int?", "pos?", "pr", "pr-str", "prefer-method", "prefers", "primitives-classnames", "print", "print-ctor", "print-dup", "print-method", "print-simple", "print-str", "printf", "println", "println-str", "prn", "prn-str", "promise", "proxy", "proxy-call-with-super", "proxy-mappings", "proxy-name", "proxy-super", "push-thread-bindings", "pvalues", "qualified-ident?", "qualified-keyword?", "qualified-symbol?", "quot", "rand", "rand-int", "rand-nth", "random-sample", "range", "ratio?", "rational?", "rationalize", "re-find", "re-groups", "re-matcher", "re-matches", "re-pattern", "re-seq", "read", "read-line", "read-string", "reader-conditional", "reader-conditional?", "realized?", "record?", "reduce", "reduce-kv", "reduced", "reduced?", "reductions", "ref", "ref-history-count", "ref-max-history", "ref-min-history", "ref-set", "refer", "refer-clojure", "reify", "release-pending-sends", "rem", "remove", "remove-all-methods", "remove-method", "remove-ns", "remove-watch", "repeat", "repeatedly", "replace", "replicate", "require", "reset!", "reset-meta!", "reset-vals!", "resolve", "rest", "restart-agent", "resultset-seq", "reverse", "reversible?", "rseq", "rsubseq", "run!", "satisfies?", "second", "select-keys", "send", "send-off", "send-via", "seq", "seq?", "seqable?", "seque", "sequence", "sequential?", "set", "set-agent-send-executor!", "set-agent-send-off-executor!", "set-error-handler!", "set-error-mode!", "set-validator!", "set?", "short", "short-array", "shorts", "shuffle", "shutdown-agents", "simple-ident?", "simple-keyword?", "simple-symbol?", "slurp", "some", "some->", "some->>", "some-fn", "some?", "sort", "sort-by", "sorted-map", "sorted-map-by", "sorted-set", "sorted-set-by", "sorted?", "special-symbol?", "spit", "split-at", "split-with", "str", "string?", "struct", "struct-map", "subs", "subseq", "subvec", "supers", "swap!", "swap-vals!", "symbol", "symbol?", "sync", "tagged-literal", "tagged-literal?", "take", "take-last", "take-nth", "take-while", "test", "the-ns", "thread-bound?", "time", "to-array", "to-array-2d", "trampoline", "transduce", "transient", "tree-seq", "true?", "type", "unchecked-add", "unchecked-add-int", "unchecked-byte", "unchecked-char", "unchecked-dec", "unchecked-dec-int", "unchecked-divide-int", "unchecked-double", "unchecked-float", "unchecked-inc", "unchecked-inc-int", "unchecked-int", "unchecked-long", "unchecked-multiply", "unchecked-multiply-int", "unchecked-negate", "unchecked-negate-int", "unchecked-remainder-int", "unchecked-short", "unchecked-subtract", "unchecked-subtract-int", "underive", "unquote", "unquote-splicing", "unreduced", "unsigned-bit-shift-right", "update", "update-in", "update-proxy", "uri?", "use", "uuid?", "val", "vals", "var-get", "var-set", "var?", "vary-meta", "vec", "vector", "vector-of", "vector?", "volatile!", "volatile?", "vreset!", "vswap!", "when", "when-first", "when-let", "when-not", "when-some", "while", "with-bindings", "with-bindings*", "with-in-str", "with-loading-context", "with-local-vars", "with-meta", "with-open", "with-out-str", "with-precision", "with-redefs", "with-redefs-fn", "xml-seq", "zero?", "zipmap"];
            e.registerHelper("hintWords", "clojure", [].concat(r, n, i));
            var o = g(r),
              a = g(n),
              s = g(i),
              l = g(["->", "->>", "as->", "binding", "bound-fn", "case", "catch", "comment", "cond", "cond->", "cond->>", "condp", "def", "definterface", "defmethod", "defn", "defmacro", "defprotocol", "defrecord", "defstruct", "deftype", "do", "doseq", "dotimes", "doto", "extend", "extend-protocol", "extend-type", "fn", "for", "future", "if", "if-let", "if-not", "if-some", "let", "letfn", "locking", "loop", "ns", "proxy", "reify", "struct-map", "some->", "some->>", "try", "when", "when-first", "when-let", "when-not", "when-some", "while", "with-bindings", "with-bindings*", "with-in-str", "with-loading-context", "with-local-vars", "with-meta", "with-open", "with-out-str", "with-precision", "with-redefs", "with-redefs-fn"]),
              c = /^(?:[\\\[\]\s"(),;@^`{}~]|$)/,
              u = /^(?:[+\-]?\d+(?:(?:N|(?:[eE][+\-]?\d+))|(?:\.?\d*(?:M|(?:[eE][+\-]?\d+))?)|\/\d+|[xX][0-9a-fA-F]+|r[0-9a-zA-Z]+)?(?=[\\\[\]\s"#'(),;@^`{}~]|$))/,
              d = /^(?:\\(?:backspace|formfeed|newline|return|space|tab|o[0-7]{3}|u[0-9A-Fa-f]{4}|x[0-9A-Fa-f]{4}|.)?(?=[\\\[\]\s"(),;@^`{}~]|$))/,
              p = /^(?:(?:[^\\\/\[\]\d\s"#'(),;@^`{}~][^\\\[\]\s"(),;@^`{}~]*(?:\.[^\\\/\[\]\d\s"#'(),;@^`{}~][^\\\[\]\s"(),;@^`{}~]*)*\/)?(?:\/|[^\\\/\[\]\d\s"#'(),;@^`{}~][^\\\[\]\s"(),;@^`{}~]*)*(?=[\\\[\]\s"(),;@^`{}~]|$))/;
            function f(e, t) {
              if (e.eatSpace() || e.eat(",")) return ["space", null];
              if (e.match(u)) return [null, "number"];
              if (e.match(d)) return [null, "string-2"];
              if (e.eat(/^"/)) return (t.tokenize = m)(e, t);
              if (e.eat(/^[(\[{]/)) return ["open", "bracket"];
              if (e.eat(/^[)\]}]/)) return ["close", "bracket"];
              if (e.eat(/^;/)) return e.skipToEnd(), ["space", "comment"];
              if (e.eat(/^[#'@^`~]/)) return [null, "meta"];
              var r = e.match(p),
                n = r && r[0];
              return n ? "comment" === n && "(" === t.lastToken ? (t.tokenize = h)(e, t) : y(n, o) || ":" === n.charAt(0) ? ["symbol", "atom"] : y(n, a) || y(n, s) ? ["symbol", "keyword"] : "(" === t.lastToken ? ["symbol", "builtin"] : ["symbol", "variable"] : (e.next(), e.eatWhile(function (e) {
                return !y(e, c);
              }), [null, "error"]);
            }
            function m(e, t) {
              for (var r, n = !1; r = e.next();) {
                if ('"' === r && !n) {
                  t.tokenize = f;
                  break;
                }
                n = !n && "\\" === r;
              }
              return [null, "string"];
            }
            function h(e, t) {
              for (var r, n = 1; r = e.next();) {
                if (")" === r && n--, "(" === r && n++, 0 === n) {
                  e.backUp(1), t.tokenize = f;
                  break;
                }
              }
              return ["space", "comment"];
            }
            function g(e) {
              for (var t = {}, r = 0; r < e.length; ++r) {
                t[e[r]] = !0;
              }
              return t;
            }
            function y(e, t) {
              return t instanceof RegExp ? t.test(e) : t instanceof Object ? t.propertyIsEnumerable(e) : void 0;
            }
            return {
              startState: function startState() {
                return {
                  ctx: {
                    prev: null,
                    start: 0,
                    indentTo: 0
                  },
                  lastToken: null,
                  tokenize: f
                };
              },
              token: function token(e, r) {
                e.sol() && "number" != typeof r.ctx.indentTo && (r.ctx.indentTo = r.ctx.start + 1);
                var n = r.tokenize(e, r),
                  i = n[0],
                  o = n[1],
                  a = e.current();
                return "space" !== i && ("(" === r.lastToken && null === r.ctx.indentTo ? "symbol" === i && y(a, l) ? r.ctx.indentTo = r.ctx.start + t.indentUnit : r.ctx.indentTo = "next" : "next" === r.ctx.indentTo && (r.ctx.indentTo = e.column()), r.lastToken = a), "open" === i ? r.ctx = {
                  prev: r.ctx,
                  start: e.column(),
                  indentTo: null
                } : "close" === i && (r.ctx = r.ctx.prev || r.ctx), o;
              },
              indent: function indent(e) {
                var t = e.ctx.indentTo;
                return "number" == typeof t ? t : e.ctx.start + 1;
              },
              closeBrackets: {
                pairs: '()[]{}""'
              },
              lineComment: ";;"
            };
          }), e.defineMIME("text/x-clojure", "clojure"), e.defineMIME("text/x-clojurescript", "clojure"), e.defineMIME("application/edn", "clojure");
        }, "object" === s(t) && "object" === s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      5239: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          function t(e) {
            for (var t = {}, r = 0; r < e.length; ++r) {
              t[e[r].toLowerCase()] = !0;
            }
            return t;
          }
          e.defineMode("css", function (t, r) {
            var n = r.inline;
            r.propertyKeywords || (r = e.resolveMode("text/css"));
            var i,
              o,
              a = t.indentUnit,
              l = r.tokenHooks,
              c = r.documentTypes || {},
              u = r.mediaTypes || {},
              d = r.mediaFeatures || {},
              p = r.mediaValueKeywords || {},
              f = r.propertyKeywords || {},
              m = r.nonStandardPropertyKeywords || {},
              h = r.fontProperties || {},
              g = r.counterDescriptors || {},
              y = r.colorKeywords || {},
              v = r.valueKeywords || {},
              b = r.allowNested,
              x = r.lineComment,
              k = !0 === r.supportsAtComponent;
            function w(e, t) {
              return i = t, e;
            }
            function _(e, t) {
              var r = e.next();
              if (l[r]) {
                var n = l[r](e, t);
                if (!1 !== n) return n;
              }
              return "@" == r ? (e.eatWhile(/[\w\\\-]/), w("def", e.current())) : "=" == r || ("~" == r || "|" == r) && e.eat("=") ? w(null, "compare") : '"' == r || "'" == r ? (t.tokenize = S(r), t.tokenize(e, t)) : "#" == r ? (e.eatWhile(/[\w\\\-]/), w("atom", "hash")) : "!" == r ? (e.match(/^\s*\w*/), w("keyword", "important")) : /\d/.test(r) || "." == r && e.eat(/\d/) ? (e.eatWhile(/[\w.%]/), w("number", "unit")) : "-" !== r ? /[,+>*\/]/.test(r) ? w(null, "select-op") : "." == r && e.match(/^-?[_a-z][_a-z0-9-]*/i) ? w("qualifier", "qualifier") : /[:;{}\[\]\(\)]/.test(r) ? w(null, r) : e.match(/[\w-.]+(?=\()/) ? (/^(url(-prefix)?|domain|regexp)$/.test(e.current().toLowerCase()) && (t.tokenize = C), w("variable callee", "variable")) : /[\w\\\-]/.test(r) ? (e.eatWhile(/[\w\\\-]/), w("property", "word")) : w(null, null) : /[\d.]/.test(e.peek()) ? (e.eatWhile(/[\w.%]/), w("number", "unit")) : e.match(/^-[\w\\\-]*/) ? (e.eatWhile(/[\w\\\-]/), e.match(/^\s*:/, !1) ? w("variable-2", "variable-definition") : w("variable-2", "variable")) : e.match(/^\w+-/) ? w("meta", "meta") : void 0;
            }
            function S(e) {
              return function (t, r) {
                for (var n, i = !1; null != (n = t.next());) {
                  if (n == e && !i) {
                    ")" == e && t.backUp(1);
                    break;
                  }
                  i = !i && "\\" == n;
                }
                return (n == e || !i && ")" != e) && (r.tokenize = null), w("string", "string");
              };
            }
            function C(e, t) {
              return e.next(), e.match(/\s*[\"\')]/, !1) ? t.tokenize = null : t.tokenize = S(")"), w(null, "(");
            }
            function T(e, t, r) {
              this.type = e, this.indent = t, this.prev = r;
            }
            function M(e, t, r, n) {
              return e.context = new T(r, t.indentation() + (!1 === n ? 0 : a), e.context), r;
            }
            function E(e) {
              return e.context.prev && (e.context = e.context.prev), e.context.type;
            }
            function L(e, t, r) {
              return z[r.context.type](e, t, r);
            }
            function A(e, t, r, n) {
              for (var i = n || 1; i > 0; i--) {
                r.context = r.context.prev;
              }
              return L(e, t, r);
            }
            function N(e) {
              var t = e.current().toLowerCase();
              o = v.hasOwnProperty(t) ? "atom" : y.hasOwnProperty(t) ? "keyword" : "variable";
            }
            var z = {
              top: function top(e, t, r) {
                if ("{" == e) return M(r, t, "block");
                if ("}" == e && r.context.prev) return E(r);
                if (k && /@component/i.test(e)) return M(r, t, "atComponentBlock");
                if (/^@(-moz-)?document$/i.test(e)) return M(r, t, "documentTypes");
                if (/^@(media|supports|(-moz-)?document|import)$/i.test(e)) return M(r, t, "atBlock");
                if (/^@(font-face|counter-style)/i.test(e)) return r.stateArg = e, "restricted_atBlock_before";
                if (/^@(-(moz|ms|o|webkit)-)?keyframes$/i.test(e)) return "keyframes";
                if (e && "@" == e.charAt(0)) return M(r, t, "at");
                if ("hash" == e) o = "builtin";else if ("word" == e) o = "tag";else {
                  if ("variable-definition" == e) return "maybeprop";
                  if ("interpolation" == e) return M(r, t, "interpolation");
                  if (":" == e) return "pseudo";
                  if (b && "(" == e) return M(r, t, "parens");
                }
                return r.context.type;
              },
              block: function block(e, t, r) {
                if ("word" == e) {
                  var n = t.current().toLowerCase();
                  return f.hasOwnProperty(n) ? (o = "property", "maybeprop") : m.hasOwnProperty(n) ? (o = "string-2", "maybeprop") : b ? (o = t.match(/^\s*:(?:\s|$)/, !1) ? "property" : "tag", "block") : (o += " error", "maybeprop");
                }
                return "meta" == e ? "block" : b || "hash" != e && "qualifier" != e ? z.top(e, t, r) : (o = "error", "block");
              },
              maybeprop: function maybeprop(e, t, r) {
                return ":" == e ? M(r, t, "prop") : L(e, t, r);
              },
              prop: function prop(e, t, r) {
                if (";" == e) return E(r);
                if ("{" == e && b) return M(r, t, "propBlock");
                if ("}" == e || "{" == e) return A(e, t, r);
                if ("(" == e) return M(r, t, "parens");
                if ("hash" != e || /^#([0-9a-fA-f]{3,4}|[0-9a-fA-f]{6}|[0-9a-fA-f]{8})$/.test(t.current())) {
                  if ("word" == e) N(t);else if ("interpolation" == e) return M(r, t, "interpolation");
                } else o += " error";
                return "prop";
              },
              propBlock: function propBlock(e, t, r) {
                return "}" == e ? E(r) : "word" == e ? (o = "property", "maybeprop") : r.context.type;
              },
              parens: function parens(e, t, r) {
                return "{" == e || "}" == e ? A(e, t, r) : ")" == e ? E(r) : "(" == e ? M(r, t, "parens") : "interpolation" == e ? M(r, t, "interpolation") : ("word" == e && N(t), "parens");
              },
              pseudo: function pseudo(e, t, r) {
                return "meta" == e ? "pseudo" : "word" == e ? (o = "variable-3", r.context.type) : L(e, t, r);
              },
              documentTypes: function documentTypes(e, t, r) {
                return "word" == e && c.hasOwnProperty(t.current()) ? (o = "tag", r.context.type) : z.atBlock(e, t, r);
              },
              atBlock: function atBlock(e, t, r) {
                if ("(" == e) return M(r, t, "atBlock_parens");
                if ("}" == e || ";" == e) return A(e, t, r);
                if ("{" == e) return E(r) && M(r, t, b ? "block" : "top");
                if ("interpolation" == e) return M(r, t, "interpolation");
                if ("word" == e) {
                  var n = t.current().toLowerCase();
                  o = "only" == n || "not" == n || "and" == n || "or" == n ? "keyword" : u.hasOwnProperty(n) ? "attribute" : d.hasOwnProperty(n) ? "property" : p.hasOwnProperty(n) ? "keyword" : f.hasOwnProperty(n) ? "property" : m.hasOwnProperty(n) ? "string-2" : v.hasOwnProperty(n) ? "atom" : y.hasOwnProperty(n) ? "keyword" : "error";
                }
                return r.context.type;
              },
              atComponentBlock: function atComponentBlock(e, t, r) {
                return "}" == e ? A(e, t, r) : "{" == e ? E(r) && M(r, t, b ? "block" : "top", !1) : ("word" == e && (o = "error"), r.context.type);
              },
              atBlock_parens: function atBlock_parens(e, t, r) {
                return ")" == e ? E(r) : "{" == e || "}" == e ? A(e, t, r, 2) : z.atBlock(e, t, r);
              },
              restricted_atBlock_before: function restricted_atBlock_before(e, t, r) {
                return "{" == e ? M(r, t, "restricted_atBlock") : "word" == e && "@counter-style" == r.stateArg ? (o = "variable", "restricted_atBlock_before") : L(e, t, r);
              },
              restricted_atBlock: function restricted_atBlock(e, t, r) {
                return "}" == e ? (r.stateArg = null, E(r)) : "word" == e ? (o = "@font-face" == r.stateArg && !h.hasOwnProperty(t.current().toLowerCase()) || "@counter-style" == r.stateArg && !g.hasOwnProperty(t.current().toLowerCase()) ? "error" : "property", "maybeprop") : "restricted_atBlock";
              },
              keyframes: function keyframes(e, t, r) {
                return "word" == e ? (o = "variable", "keyframes") : "{" == e ? M(r, t, "top") : L(e, t, r);
              },
              at: function at(e, t, r) {
                return ";" == e ? E(r) : "{" == e || "}" == e ? A(e, t, r) : ("word" == e ? o = "tag" : "hash" == e && (o = "builtin"), "at");
              },
              interpolation: function interpolation(e, t, r) {
                return "}" == e ? E(r) : "{" == e || ";" == e ? A(e, t, r) : ("word" == e ? o = "variable" : "variable" != e && "(" != e && ")" != e && (o = "error"), "interpolation");
              }
            };
            return {
              startState: function startState(e) {
                return {
                  tokenize: null,
                  state: n ? "block" : "top",
                  stateArg: null,
                  context: new T(n ? "block" : "top", e || 0, null)
                };
              },
              token: function token(e, t) {
                if (!t.tokenize && e.eatSpace()) return null;
                var r = (t.tokenize || _)(e, t);
                return r && "object" == s(r) && (i = r[1], r = r[0]), o = r, "comment" != i && (t.state = z[t.state](i, e, t)), o;
              },
              indent: function indent(e, t) {
                var r = e.context,
                  n = t && t.charAt(0),
                  i = r.indent;
                return "prop" != r.type || "}" != n && ")" != n || (r = r.prev), r.prev && ("}" != n || "block" != r.type && "top" != r.type && "interpolation" != r.type && "restricted_atBlock" != r.type ? (")" != n || "parens" != r.type && "atBlock_parens" != r.type) && ("{" != n || "at" != r.type && "atBlock" != r.type) || (i = Math.max(0, r.indent - a)) : i = (r = r.prev).indent), i;
              },
              electricChars: "}",
              blockCommentStart: "/*",
              blockCommentEnd: "*/",
              blockCommentContinue: " * ",
              lineComment: x,
              fold: "brace"
            };
          });
          var r = ["domain", "regexp", "url", "url-prefix"],
            n = t(r),
            i = ["all", "aural", "braille", "handheld", "print", "projection", "screen", "tty", "tv", "embossed"],
            o = t(i),
            a = ["width", "min-width", "max-width", "height", "min-height", "max-height", "device-width", "min-device-width", "max-device-width", "device-height", "min-device-height", "max-device-height", "aspect-ratio", "min-aspect-ratio", "max-aspect-ratio", "device-aspect-ratio", "min-device-aspect-ratio", "max-device-aspect-ratio", "color", "min-color", "max-color", "color-index", "min-color-index", "max-color-index", "monochrome", "min-monochrome", "max-monochrome", "resolution", "min-resolution", "max-resolution", "scan", "grid", "orientation", "device-pixel-ratio", "min-device-pixel-ratio", "max-device-pixel-ratio", "pointer", "any-pointer", "hover", "any-hover"],
            l = t(a),
            c = ["landscape", "portrait", "none", "coarse", "fine", "on-demand", "hover", "interlace", "progressive"],
            u = t(c),
            d = ["align-content", "align-items", "align-self", "alignment-adjust", "alignment-baseline", "anchor-point", "animation", "animation-delay", "animation-direction", "animation-duration", "animation-fill-mode", "animation-iteration-count", "animation-name", "animation-play-state", "animation-timing-function", "appearance", "azimuth", "backdrop-filter", "backface-visibility", "background", "background-attachment", "background-blend-mode", "background-clip", "background-color", "background-image", "background-origin", "background-position", "background-position-x", "background-position-y", "background-repeat", "background-size", "baseline-shift", "binding", "bleed", "block-size", "bookmark-label", "bookmark-level", "bookmark-state", "bookmark-target", "border", "border-bottom", "border-bottom-color", "border-bottom-left-radius", "border-bottom-right-radius", "border-bottom-style", "border-bottom-width", "border-collapse", "border-color", "border-image", "border-image-outset", "border-image-repeat", "border-image-slice", "border-image-source", "border-image-width", "border-left", "border-left-color", "border-left-style", "border-left-width", "border-radius", "border-right", "border-right-color", "border-right-style", "border-right-width", "border-spacing", "border-style", "border-top", "border-top-color", "border-top-left-radius", "border-top-right-radius", "border-top-style", "border-top-width", "border-width", "bottom", "box-decoration-break", "box-shadow", "box-sizing", "break-after", "break-before", "break-inside", "caption-side", "caret-color", "clear", "clip", "color", "color-profile", "column-count", "column-fill", "column-gap", "column-rule", "column-rule-color", "column-rule-style", "column-rule-width", "column-span", "column-width", "columns", "contain", "content", "counter-increment", "counter-reset", "crop", "cue", "cue-after", "cue-before", "cursor", "direction", "display", "dominant-baseline", "drop-initial-after-adjust", "drop-initial-after-align", "drop-initial-before-adjust", "drop-initial-before-align", "drop-initial-size", "drop-initial-value", "elevation", "empty-cells", "fit", "fit-position", "flex", "flex-basis", "flex-direction", "flex-flow", "flex-grow", "flex-shrink", "flex-wrap", "float", "float-offset", "flow-from", "flow-into", "font", "font-family", "font-feature-settings", "font-kerning", "font-language-override", "font-optical-sizing", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-synthesis", "font-variant", "font-variant-alternates", "font-variant-caps", "font-variant-east-asian", "font-variant-ligatures", "font-variant-numeric", "font-variant-position", "font-variation-settings", "font-weight", "gap", "grid", "grid-area", "grid-auto-columns", "grid-auto-flow", "grid-auto-rows", "grid-column", "grid-column-end", "grid-column-gap", "grid-column-start", "grid-gap", "grid-row", "grid-row-end", "grid-row-gap", "grid-row-start", "grid-template", "grid-template-areas", "grid-template-columns", "grid-template-rows", "hanging-punctuation", "height", "hyphens", "icon", "image-orientation", "image-rendering", "image-resolution", "inline-box-align", "inset", "inset-block", "inset-block-end", "inset-block-start", "inset-inline", "inset-inline-end", "inset-inline-start", "isolation", "justify-content", "justify-items", "justify-self", "left", "letter-spacing", "line-break", "line-height", "line-height-step", "line-stacking", "line-stacking-ruby", "line-stacking-shift", "line-stacking-strategy", "list-style", "list-style-image", "list-style-position", "list-style-type", "margin", "margin-bottom", "margin-left", "margin-right", "margin-top", "marks", "marquee-direction", "marquee-loop", "marquee-play-count", "marquee-speed", "marquee-style", "max-block-size", "max-height", "max-inline-size", "max-width", "min-block-size", "min-height", "min-inline-size", "min-width", "mix-blend-mode", "move-to", "nav-down", "nav-index", "nav-left", "nav-right", "nav-up", "object-fit", "object-position", "offset", "offset-anchor", "offset-distance", "offset-path", "offset-position", "offset-rotate", "opacity", "order", "orphans", "outline", "outline-color", "outline-offset", "outline-style", "outline-width", "overflow", "overflow-style", "overflow-wrap", "overflow-x", "overflow-y", "padding", "padding-bottom", "padding-left", "padding-right", "padding-top", "page", "page-break-after", "page-break-before", "page-break-inside", "page-policy", "pause", "pause-after", "pause-before", "perspective", "perspective-origin", "pitch", "pitch-range", "place-content", "place-items", "place-self", "play-during", "position", "presentation-level", "punctuation-trim", "quotes", "region-break-after", "region-break-before", "region-break-inside", "region-fragment", "rendering-intent", "resize", "rest", "rest-after", "rest-before", "richness", "right", "rotate", "rotation", "rotation-point", "row-gap", "ruby-align", "ruby-overhang", "ruby-position", "ruby-span", "scale", "scroll-behavior", "scroll-margin", "scroll-margin-block", "scroll-margin-block-end", "scroll-margin-block-start", "scroll-margin-bottom", "scroll-margin-inline", "scroll-margin-inline-end", "scroll-margin-inline-start", "scroll-margin-left", "scroll-margin-right", "scroll-margin-top", "scroll-padding", "scroll-padding-block", "scroll-padding-block-end", "scroll-padding-block-start", "scroll-padding-bottom", "scroll-padding-inline", "scroll-padding-inline-end", "scroll-padding-inline-start", "scroll-padding-left", "scroll-padding-right", "scroll-padding-top", "scroll-snap-align", "scroll-snap-type", "shape-image-threshold", "shape-inside", "shape-margin", "shape-outside", "size", "speak", "speak-as", "speak-header", "speak-numeral", "speak-punctuation", "speech-rate", "stress", "string-set", "tab-size", "table-layout", "target", "target-name", "target-new", "target-position", "text-align", "text-align-last", "text-combine-upright", "text-decoration", "text-decoration-color", "text-decoration-line", "text-decoration-skip", "text-decoration-skip-ink", "text-decoration-style", "text-emphasis", "text-emphasis-color", "text-emphasis-position", "text-emphasis-style", "text-height", "text-indent", "text-justify", "text-orientation", "text-outline", "text-overflow", "text-rendering", "text-shadow", "text-size-adjust", "text-space-collapse", "text-transform", "text-underline-position", "text-wrap", "top", "transform", "transform-origin", "transform-style", "transition", "transition-delay", "transition-duration", "transition-property", "transition-timing-function", "translate", "unicode-bidi", "user-select", "vertical-align", "visibility", "voice-balance", "voice-duration", "voice-family", "voice-pitch", "voice-range", "voice-rate", "voice-stress", "voice-volume", "volume", "white-space", "widows", "width", "will-change", "word-break", "word-spacing", "word-wrap", "writing-mode", "z-index", "clip-path", "clip-rule", "mask", "enable-background", "filter", "flood-color", "flood-opacity", "lighting-color", "stop-color", "stop-opacity", "pointer-events", "color-interpolation", "color-interpolation-filters", "color-rendering", "fill", "fill-opacity", "fill-rule", "image-rendering", "marker", "marker-end", "marker-mid", "marker-start", "shape-rendering", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-rendering", "baseline-shift", "dominant-baseline", "glyph-orientation-horizontal", "glyph-orientation-vertical", "text-anchor", "writing-mode"],
            p = t(d),
            f = ["border-block", "border-block-color", "border-block-end", "border-block-end-color", "border-block-end-style", "border-block-end-width", "border-block-start", "border-block-start-color", "border-block-start-style", "border-block-start-width", "border-block-style", "border-block-width", "border-inline", "border-inline-color", "border-inline-end", "border-inline-end-color", "border-inline-end-style", "border-inline-end-width", "border-inline-start", "border-inline-start-color", "border-inline-start-style", "border-inline-start-width", "border-inline-style", "border-inline-width", "margin-block", "margin-block-end", "margin-block-start", "margin-inline", "margin-inline-end", "margin-inline-start", "padding-block", "padding-block-end", "padding-block-start", "padding-inline", "padding-inline-end", "padding-inline-start", "scroll-snap-stop", "scrollbar-3d-light-color", "scrollbar-arrow-color", "scrollbar-base-color", "scrollbar-dark-shadow-color", "scrollbar-face-color", "scrollbar-highlight-color", "scrollbar-shadow-color", "scrollbar-track-color", "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button", "searchfield-results-decoration", "shape-inside", "zoom"],
            m = t(f),
            h = t(["font-display", "font-family", "src", "unicode-range", "font-variant", "font-feature-settings", "font-stretch", "font-weight", "font-style"]),
            g = t(["additive-symbols", "fallback", "negative", "pad", "prefix", "range", "speak-as", "suffix", "symbols", "system"]),
            y = ["aliceblue", "antiquewhite", "aqua", "aquamarine", "azure", "beige", "bisque", "black", "blanchedalmond", "blue", "blueviolet", "brown", "burlywood", "cadetblue", "chartreuse", "chocolate", "coral", "cornflowerblue", "cornsilk", "crimson", "cyan", "darkblue", "darkcyan", "darkgoldenrod", "darkgray", "darkgreen", "darkkhaki", "darkmagenta", "darkolivegreen", "darkorange", "darkorchid", "darkred", "darksalmon", "darkseagreen", "darkslateblue", "darkslategray", "darkturquoise", "darkviolet", "deeppink", "deepskyblue", "dimgray", "dodgerblue", "firebrick", "floralwhite", "forestgreen", "fuchsia", "gainsboro", "ghostwhite", "gold", "goldenrod", "gray", "grey", "green", "greenyellow", "honeydew", "hotpink", "indianred", "indigo", "ivory", "khaki", "lavender", "lavenderblush", "lawngreen", "lemonchiffon", "lightblue", "lightcoral", "lightcyan", "lightgoldenrodyellow", "lightgray", "lightgreen", "lightpink", "lightsalmon", "lightseagreen", "lightskyblue", "lightslategray", "lightsteelblue", "lightyellow", "lime", "limegreen", "linen", "magenta", "maroon", "mediumaquamarine", "mediumblue", "mediumorchid", "mediumpurple", "mediumseagreen", "mediumslateblue", "mediumspringgreen", "mediumturquoise", "mediumvioletred", "midnightblue", "mintcream", "mistyrose", "moccasin", "navajowhite", "navy", "oldlace", "olive", "olivedrab", "orange", "orangered", "orchid", "palegoldenrod", "palegreen", "paleturquoise", "palevioletred", "papayawhip", "peachpuff", "peru", "pink", "plum", "powderblue", "purple", "rebeccapurple", "red", "rosybrown", "royalblue", "saddlebrown", "salmon", "sandybrown", "seagreen", "seashell", "sienna", "silver", "skyblue", "slateblue", "slategray", "snow", "springgreen", "steelblue", "tan", "teal", "thistle", "tomato", "turquoise", "violet", "wheat", "white", "whitesmoke", "yellow", "yellowgreen"],
            v = t(y),
            b = ["above", "absolute", "activeborder", "additive", "activecaption", "afar", "after-white-space", "ahead", "alias", "all", "all-scroll", "alphabetic", "alternate", "always", "amharic", "amharic-abegede", "antialiased", "appworkspace", "arabic-indic", "armenian", "asterisks", "attr", "auto", "auto-flow", "avoid", "avoid-column", "avoid-page", "avoid-region", "background", "backwards", "baseline", "below", "bidi-override", "binary", "bengali", "blink", "block", "block-axis", "bold", "bolder", "border", "border-box", "both", "bottom", "break", "break-all", "break-word", "bullets", "button", "button-bevel", "buttonface", "buttonhighlight", "buttonshadow", "buttontext", "calc", "cambodian", "capitalize", "caps-lock-indicator", "caption", "captiontext", "caret", "cell", "center", "checkbox", "circle", "cjk-decimal", "cjk-earthly-branch", "cjk-heavenly-stem", "cjk-ideographic", "clear", "clip", "close-quote", "col-resize", "collapse", "color", "color-burn", "color-dodge", "column", "column-reverse", "compact", "condensed", "contain", "content", "contents", "content-box", "context-menu", "continuous", "copy", "counter", "counters", "cover", "crop", "cross", "crosshair", "currentcolor", "cursive", "cyclic", "darken", "dashed", "decimal", "decimal-leading-zero", "default", "default-button", "dense", "destination-atop", "destination-in", "destination-out", "destination-over", "devanagari", "difference", "disc", "discard", "disclosure-closed", "disclosure-open", "document", "dot-dash", "dot-dot-dash", "dotted", "double", "down", "e-resize", "ease", "ease-in", "ease-in-out", "ease-out", "element", "ellipse", "ellipsis", "embed", "end", "ethiopic", "ethiopic-abegede", "ethiopic-abegede-am-et", "ethiopic-abegede-gez", "ethiopic-abegede-ti-er", "ethiopic-abegede-ti-et", "ethiopic-halehame-aa-er", "ethiopic-halehame-aa-et", "ethiopic-halehame-am-et", "ethiopic-halehame-gez", "ethiopic-halehame-om-et", "ethiopic-halehame-sid-et", "ethiopic-halehame-so-et", "ethiopic-halehame-ti-er", "ethiopic-halehame-ti-et", "ethiopic-halehame-tig", "ethiopic-numeric", "ew-resize", "exclusion", "expanded", "extends", "extra-condensed", "extra-expanded", "fantasy", "fast", "fill", "fixed", "flat", "flex", "flex-end", "flex-start", "footnotes", "forwards", "from", "geometricPrecision", "georgian", "graytext", "grid", "groove", "gujarati", "gurmukhi", "hand", "hangul", "hangul-consonant", "hard-light", "hebrew", "help", "hidden", "hide", "higher", "highlight", "highlighttext", "hiragana", "hiragana-iroha", "horizontal", "hsl", "hsla", "hue", "icon", "ignore", "inactiveborder", "inactivecaption", "inactivecaptiontext", "infinite", "infobackground", "infotext", "inherit", "initial", "inline", "inline-axis", "inline-block", "inline-flex", "inline-grid", "inline-table", "inset", "inside", "intrinsic", "invert", "italic", "japanese-formal", "japanese-informal", "justify", "kannada", "katakana", "katakana-iroha", "keep-all", "khmer", "korean-hangul-formal", "korean-hanja-formal", "korean-hanja-informal", "landscape", "lao", "large", "larger", "left", "level", "lighter", "lighten", "line-through", "linear", "linear-gradient", "lines", "list-item", "listbox", "listitem", "local", "logical", "loud", "lower", "lower-alpha", "lower-armenian", "lower-greek", "lower-hexadecimal", "lower-latin", "lower-norwegian", "lower-roman", "lowercase", "ltr", "luminosity", "malayalam", "match", "matrix", "matrix3d", "media-controls-background", "media-current-time-display", "media-fullscreen-button", "media-mute-button", "media-play-button", "media-return-to-realtime-button", "media-rewind-button", "media-seek-back-button", "media-seek-forward-button", "media-slider", "media-sliderthumb", "media-time-remaining-display", "media-volume-slider", "media-volume-slider-container", "media-volume-sliderthumb", "medium", "menu", "menulist", "menulist-button", "menulist-text", "menulist-textfield", "menutext", "message-box", "middle", "min-intrinsic", "mix", "mongolian", "monospace", "move", "multiple", "multiply", "myanmar", "n-resize", "narrower", "ne-resize", "nesw-resize", "no-close-quote", "no-drop", "no-open-quote", "no-repeat", "none", "normal", "not-allowed", "nowrap", "ns-resize", "numbers", "numeric", "nw-resize", "nwse-resize", "oblique", "octal", "opacity", "open-quote", "optimizeLegibility", "optimizeSpeed", "oriya", "oromo", "outset", "outside", "outside-shape", "overlay", "overline", "padding", "padding-box", "painted", "page", "paused", "persian", "perspective", "plus-darker", "plus-lighter", "pointer", "polygon", "portrait", "pre", "pre-line", "pre-wrap", "preserve-3d", "progress", "push-button", "radial-gradient", "radio", "read-only", "read-write", "read-write-plaintext-only", "rectangle", "region", "relative", "repeat", "repeating-linear-gradient", "repeating-radial-gradient", "repeat-x", "repeat-y", "reset", "reverse", "rgb", "rgba", "ridge", "right", "rotate", "rotate3d", "rotateX", "rotateY", "rotateZ", "round", "row", "row-resize", "row-reverse", "rtl", "run-in", "running", "s-resize", "sans-serif", "saturation", "scale", "scale3d", "scaleX", "scaleY", "scaleZ", "screen", "scroll", "scrollbar", "scroll-position", "se-resize", "searchfield", "searchfield-cancel-button", "searchfield-decoration", "searchfield-results-button", "searchfield-results-decoration", "self-start", "self-end", "semi-condensed", "semi-expanded", "separate", "serif", "show", "sidama", "simp-chinese-formal", "simp-chinese-informal", "single", "skew", "skewX", "skewY", "skip-white-space", "slide", "slider-horizontal", "slider-vertical", "sliderthumb-horizontal", "sliderthumb-vertical", "slow", "small", "small-caps", "small-caption", "smaller", "soft-light", "solid", "somali", "source-atop", "source-in", "source-out", "source-over", "space", "space-around", "space-between", "space-evenly", "spell-out", "square", "square-button", "start", "static", "status-bar", "stretch", "stroke", "sub", "subpixel-antialiased", "super", "sw-resize", "symbolic", "symbols", "system-ui", "table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row", "table-row-group", "tamil", "telugu", "text", "text-bottom", "text-top", "textarea", "textfield", "thai", "thick", "thin", "threeddarkshadow", "threedface", "threedhighlight", "threedlightshadow", "threedshadow", "tibetan", "tigre", "tigrinya-er", "tigrinya-er-abegede", "tigrinya-et", "tigrinya-et-abegede", "to", "top", "trad-chinese-formal", "trad-chinese-informal", "transform", "translate", "translate3d", "translateX", "translateY", "translateZ", "transparent", "ultra-condensed", "ultra-expanded", "underline", "unset", "up", "upper-alpha", "upper-armenian", "upper-greek", "upper-hexadecimal", "upper-latin", "upper-norwegian", "upper-roman", "uppercase", "urdu", "url", "var", "vertical", "vertical-text", "visible", "visibleFill", "visiblePainted", "visibleStroke", "visual", "w-resize", "wait", "wave", "wider", "window", "windowframe", "windowtext", "words", "wrap", "wrap-reverse", "x-large", "x-small", "xor", "xx-large", "xx-small"],
            x = t(b),
            k = r.concat(i).concat(a).concat(c).concat(d).concat(f).concat(y).concat(b);
          function w(e, t) {
            for (var r, n = !1; null != (r = e.next());) {
              if (n && "/" == r) {
                t.tokenize = null;
                break;
              }
              n = "*" == r;
            }
            return ["comment", "comment"];
          }
          e.registerHelper("hintWords", "css", k), e.defineMIME("text/css", {
            documentTypes: n,
            mediaTypes: o,
            mediaFeatures: l,
            mediaValueKeywords: u,
            propertyKeywords: p,
            nonStandardPropertyKeywords: m,
            fontProperties: h,
            counterDescriptors: g,
            colorKeywords: v,
            valueKeywords: x,
            tokenHooks: {
              "/": function _(e, t) {
                return !!e.eat("*") && (t.tokenize = w, w(e, t));
              }
            },
            name: "css"
          }), e.defineMIME("text/x-scss", {
            mediaTypes: o,
            mediaFeatures: l,
            mediaValueKeywords: u,
            propertyKeywords: p,
            nonStandardPropertyKeywords: m,
            colorKeywords: v,
            valueKeywords: x,
            fontProperties: h,
            allowNested: !0,
            lineComment: "//",
            tokenHooks: {
              "/": function _(e, t) {
                return e.eat("/") ? (e.skipToEnd(), ["comment", "comment"]) : e.eat("*") ? (t.tokenize = w, w(e, t)) : ["operator", "operator"];
              },
              ":": function _(e) {
                return !!e.match(/\s*\{/, !1) && [null, null];
              },
              $: function $(e) {
                return e.match(/^[\w-]+/), e.match(/^\s*:/, !1) ? ["variable-2", "variable-definition"] : ["variable-2", "variable"];
              },
              "#": function _(e) {
                return !!e.eat("{") && [null, "interpolation"];
              }
            },
            name: "css",
            helperType: "scss"
          }), e.defineMIME("text/x-less", {
            mediaTypes: o,
            mediaFeatures: l,
            mediaValueKeywords: u,
            propertyKeywords: p,
            nonStandardPropertyKeywords: m,
            colorKeywords: v,
            valueKeywords: x,
            fontProperties: h,
            allowNested: !0,
            lineComment: "//",
            tokenHooks: {
              "/": function _(e, t) {
                return e.eat("/") ? (e.skipToEnd(), ["comment", "comment"]) : e.eat("*") ? (t.tokenize = w, w(e, t)) : ["operator", "operator"];
              },
              "@": function _(e) {
                return e.eat("{") ? [null, "interpolation"] : !e.match(/^(charset|document|font-face|import|(-(moz|ms|o|webkit)-)?keyframes|media|namespace|page|supports)\b/i, !1) && (e.eatWhile(/[\w\\\-]/), e.match(/^\s*:/, !1) ? ["variable-2", "variable-definition"] : ["variable-2", "variable"]);
              },
              "&": function _() {
                return ["atom", "atom"];
              }
            },
            name: "css",
            helperType: "less"
          }), e.defineMIME("text/x-gss", {
            documentTypes: n,
            mediaTypes: o,
            mediaFeatures: l,
            propertyKeywords: p,
            nonStandardPropertyKeywords: m,
            fontProperties: h,
            counterDescriptors: g,
            colorKeywords: v,
            valueKeywords: x,
            supportsAtComponent: !0,
            tokenHooks: {
              "/": function _(e, t) {
                return !!e.eat("*") && (t.tokenize = w, w(e, t));
              }
            },
            name: "css",
            helperType: "gss"
          });
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      6461: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          function t(e) {
            for (var t = {}, r = e.split(" "), n = 0; n < r.length; ++n) {
              t[r[n]] = !0;
            }
            return t;
          }
          e.defineMode("d", function (t, r) {
            var n,
              i = t.indentUnit,
              o = r.statementIndentUnit || i,
              a = r.keywords || {},
              s = r.builtin || {},
              l = r.blockKeywords || {},
              c = r.atoms || {},
              u = r.hooks || {},
              d = r.multiLineStrings,
              p = /[+\-*&%=<>!?|\/]/;
            function f(e, t) {
              var r,
                i = e.next();
              if (u[i]) {
                var o = u[i](e, t);
                if (!1 !== o) return o;
              }
              if ('"' == i || "'" == i || "`" == i) return t.tokenize = (r = i, function (e, t) {
                for (var n, i = !1, o = !1; null != (n = e.next());) {
                  if (n == r && !i) {
                    o = !0;
                    break;
                  }
                  i = !i && "\\" == n;
                }
                return (o || !i && !d) && (t.tokenize = null), "string";
              }), t.tokenize(e, t);
              if (/[\[\]{}\(\),;\:\.]/.test(i)) return n = i, null;
              if (/\d/.test(i)) return e.eatWhile(/[\w\.]/), "number";
              if ("/" == i) {
                if (e.eat("+")) return t.tokenize = h, h(e, t);
                if (e.eat("*")) return t.tokenize = m, m(e, t);
                if (e.eat("/")) return e.skipToEnd(), "comment";
              }
              if (p.test(i)) return e.eatWhile(p), "operator";
              e.eatWhile(/[\w\$_\xa1-\uffff]/);
              var f = e.current();
              return a.propertyIsEnumerable(f) ? (l.propertyIsEnumerable(f) && (n = "newstatement"), "keyword") : s.propertyIsEnumerable(f) ? (l.propertyIsEnumerable(f) && (n = "newstatement"), "builtin") : c.propertyIsEnumerable(f) ? "atom" : "variable";
            }
            function m(e, t) {
              for (var r, n = !1; r = e.next();) {
                if ("/" == r && n) {
                  t.tokenize = null;
                  break;
                }
                n = "*" == r;
              }
              return "comment";
            }
            function h(e, t) {
              for (var r, n = !1; r = e.next();) {
                if ("/" == r && n) {
                  t.tokenize = null;
                  break;
                }
                n = "+" == r;
              }
              return "comment";
            }
            function g(e, t, r, n, i) {
              this.indented = e, this.column = t, this.type = r, this.align = n, this.prev = i;
            }
            function y(e, t, r) {
              var n = e.indented;
              return e.context && "statement" == e.context.type && (n = e.context.indented), e.context = new g(n, t, r, null, e.context);
            }
            function v(e) {
              var t = e.context.type;
              return ")" != t && "]" != t && "}" != t || (e.indented = e.context.indented), e.context = e.context.prev;
            }
            return {
              startState: function startState(e) {
                return {
                  tokenize: null,
                  context: new g((e || 0) - i, 0, "top", !1),
                  indented: 0,
                  startOfLine: !0
                };
              },
              token: function token(e, t) {
                var r = t.context;
                if (e.sol() && (null == r.align && (r.align = !1), t.indented = e.indentation(), t.startOfLine = !0), e.eatSpace()) return null;
                n = null;
                var i = (t.tokenize || f)(e, t);
                if ("comment" == i || "meta" == i) return i;
                if (null == r.align && (r.align = !0), ";" != n && ":" != n && "," != n || "statement" != r.type) {
                  if ("{" == n) y(t, e.column(), "}");else if ("[" == n) y(t, e.column(), "]");else if ("(" == n) y(t, e.column(), ")");else if ("}" == n) {
                    for (; "statement" == r.type;) {
                      r = v(t);
                    }
                    for ("}" == r.type && (r = v(t)); "statement" == r.type;) {
                      r = v(t);
                    }
                  } else n == r.type ? v(t) : (("}" == r.type || "top" == r.type) && ";" != n || "statement" == r.type && "newstatement" == n) && y(t, e.column(), "statement");
                } else v(t);
                return t.startOfLine = !1, i;
              },
              indent: function indent(t, r) {
                if (t.tokenize != f && null != t.tokenize) return e.Pass;
                var n = t.context,
                  a = r && r.charAt(0);
                "statement" == n.type && "}" == a && (n = n.prev);
                var s = a == n.type;
                return "statement" == n.type ? n.indented + ("{" == a ? 0 : o) : n.align ? n.column + (s ? 0 : 1) : n.indented + (s ? 0 : i);
              },
              electricChars: "{}",
              blockCommentStart: "/*",
              blockCommentEnd: "*/",
              blockCommentContinue: " * ",
              lineComment: "//",
              fold: "brace"
            };
          });
          var r = "body catch class do else enum for foreach foreach_reverse if in interface mixin out scope struct switch try union unittest version while with";
          e.defineMIME("text/x-d", {
            name: "d",
            keywords: t("abstract alias align asm assert auto break case cast cdouble cent cfloat const continue debug default delegate delete deprecated export extern final finally function goto immutable import inout invariant is lazy macro module new nothrow override package pragma private protected public pure ref return shared short static super synchronized template this throw typedef typeid typeof volatile __FILE__ __LINE__ __gshared __traits __vector __parameters " + r),
            blockKeywords: t(r),
            builtin: t("bool byte char creal dchar double float idouble ifloat int ireal long real short ubyte ucent uint ulong ushort wchar wstring void size_t sizediff_t"),
            atoms: t("exit failure success true false null"),
            hooks: {
              "@": function _(e, t) {
                return e.eatWhile(/[\w\$_]/), "meta";
              }
            }
          });
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      1702: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          var t = "this super static final const abstract class extends external factory implements mixin get native set typedef with enum throw rethrow assert break case continue default in return new deferred async await covariant try catch finally do else for if switch while import library export part of show hide is as extension on yield late required".split(" "),
            r = "try catch finally do else for if switch while".split(" "),
            n = "true false null".split(" "),
            i = "void bool num int double dynamic var String Null Never".split(" ");
          function o(e) {
            for (var t = {}, r = 0; r < e.length; ++r) {
              t[e[r]] = !0;
            }
            return t;
          }
          function a(e) {
            (e.interpolationStack || (e.interpolationStack = [])).push(e.tokenize);
          }
          function s(e) {
            return (e.interpolationStack || (e.interpolationStack = [])).pop();
          }
          function l(e, t, r, n) {
            var i = !1;
            if (t.eat(e)) {
              if (!t.eat(e)) return "string";
              i = !0;
            }
            function o(t, r) {
              for (var o = !1; !t.eol();) {
                if (!n && !o && "$" == t.peek()) return a(r), r.tokenize = c, "string";
                var s = t.next();
                if (s == e && !o && (!i || t.match(e + e))) {
                  r.tokenize = null;
                  break;
                }
                o = !n && !o && "\\" == s;
              }
              return "string";
            }
            return r.tokenize = o, o(t, r);
          }
          function c(e, t) {
            return e.eat("$"), e.eat("{") ? t.tokenize = null : t.tokenize = u, null;
          }
          function u(e, t) {
            return e.eatWhile(/[\w_]/), t.tokenize = s(t), "variable";
          }
          function d(e) {
            return function (t, r) {
              for (var n; n = t.next();) {
                if ("*" == n && t.eat("/")) {
                  if (1 == e) {
                    r.tokenize = null;
                    break;
                  }
                  return r.tokenize = d(e - 1), r.tokenize(t, r);
                }
                if ("/" == n && t.eat("*")) return r.tokenize = d(e + 1), r.tokenize(t, r);
              }
              return "comment";
            };
          }
          e.defineMIME("application/dart", {
            name: "clike",
            keywords: o(t),
            blockKeywords: o(r),
            builtin: o(i),
            atoms: o(n),
            hooks: {
              "@": function _(e) {
                return e.eatWhile(/[\w\$_\.]/), "meta";
              },
              "'": function _(e, t) {
                return l("'", e, t, !1);
              },
              '"': function _(e, t) {
                return l('"', e, t, !1);
              },
              r: function r(e, t) {
                var r = e.peek();
                return ("'" == r || '"' == r) && l(e.next(), e, t, !0);
              },
              "}": function _(e, t) {
                return function (e) {
                  return e.interpolationStack ? e.interpolationStack.length : 0;
                }(t) > 0 && (t.tokenize = s(t), null);
              },
              "/": function _(e, t) {
                return !!e.eat("*") && (t.tokenize = d(1), t.tokenize(e, t));
              },
              token: function token(e, t, r) {
                if ("variable" == r && RegExp("^[_$]*[A-Z][a-zA-Z0-9_$]*$", "g").test(e.current())) return "variable-2";
              }
            }
          }), e.registerHelper("hintWords", "application/dart", t.concat(n).concat(i)), e.defineMode("dart", function (t) {
            return e.getMode(t, "application/dart");
          }, "clike");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074), r(1736)) : (i = [r(9074), r(1736)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      5844: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMode("diff", function () {
            var e = {
              "+": "positive",
              "-": "negative",
              "@": "meta"
            };
            return {
              token: function token(t) {
                var r = t.string.search(/[\t ]+?$/);
                if (!t.sol() || 0 === r) return t.skipToEnd(), ("error " + (e[t.string.charAt(0)] || "")).replace(/ $/, "");
                var n = e[t.peek()] || t.skipToEnd();
                return -1 === r ? t.skipToEnd() : t.pos = r, n;
              }
            };
          }), e.defineMIME("text/x-diff", "diff");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      5855: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          var t = "from",
            r = new RegExp("^(\\s*)\\b(" + t + ")\\b", "i"),
            n = ["run", "cmd", "entrypoint", "shell"],
            i = new RegExp("^(\\s*)(" + n.join("|") + ")(\\s+\\[)", "i"),
            o = "expose",
            a = new RegExp("^(\\s*)(" + o + ")(\\s+)", "i"),
            s = "(" + [t, o].concat(n).concat(["arg", "from", "maintainer", "label", "env", "add", "copy", "volume", "user", "workdir", "onbuild", "stopsignal", "healthcheck", "shell"]).join("|") + ")",
            l = new RegExp("^(\\s*)" + s + "(\\s*)(#.*)?$", "i"),
            c = new RegExp("^(\\s*)" + s + "(\\s+)", "i");
          e.defineSimpleMode("dockerfile", {
            start: [{
              regex: /^\s*#.*$/,
              sol: !0,
              token: "comment"
            }, {
              regex: r,
              token: [null, "keyword"],
              sol: !0,
              next: "from"
            }, {
              regex: l,
              token: [null, "keyword", null, "error"],
              sol: !0
            }, {
              regex: i,
              token: [null, "keyword", null],
              sol: !0,
              next: "array"
            }, {
              regex: a,
              token: [null, "keyword", null],
              sol: !0,
              next: "expose"
            }, {
              regex: c,
              token: [null, "keyword", null],
              sol: !0,
              next: "arguments"
            }, {
              regex: /./,
              token: null
            }],
            from: [{
              regex: /\s*$/,
              token: null,
              next: "start"
            }, {
              regex: /(\s*)(#.*)$/,
              token: [null, "error"],
              next: "start"
            }, {
              regex: /(\s*\S+\s+)(as)/i,
              token: [null, "keyword"],
              next: "start"
            }, {
              token: null,
              next: "start"
            }],
            single: [{
              regex: /(?:[^\\']|\\.)/,
              token: "string"
            }, {
              regex: /'/,
              token: "string",
              pop: !0
            }],
            double: [{
              regex: /(?:[^\\"]|\\.)/,
              token: "string"
            }, {
              regex: /"/,
              token: "string",
              pop: !0
            }],
            array: [{
              regex: /\]/,
              token: null,
              next: "start"
            }, {
              regex: /"(?:[^\\"]|\\.)*"?/,
              token: "string"
            }],
            expose: [{
              regex: /\d+$/,
              token: "number",
              next: "start"
            }, {
              regex: /[^\d]+$/,
              token: null,
              next: "start"
            }, {
              regex: /\d+/,
              token: "number"
            }, {
              regex: /[^\d]+/,
              token: null
            }, {
              token: null,
              next: "start"
            }],
            arguments: [{
              regex: /^\s*#.*$/,
              sol: !0,
              token: "comment"
            }, {
              regex: /"(?:[^\\"]|\\.)*"?$/,
              token: "string",
              next: "start"
            }, {
              regex: /"/,
              token: "string",
              push: "double"
            }, {
              regex: /'(?:[^\\']|\\.)*'?$/,
              token: "string",
              next: "start"
            }, {
              regex: /'/,
              token: "string",
              push: "single"
            }, {
              regex: /[^#"']+[\\`]$/,
              token: null
            }, {
              regex: /[^#"']+$/,
              token: null,
              next: "start"
            }, {
              regex: /[^#"']+/,
              token: null
            }, {
              token: null,
              next: "start"
            }],
            meta: {
              lineComment: "#"
            }
          }), e.defineMIME("text/x-dockerfile", "dockerfile");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074), r(3740)) : (i = [r(9074), r(3740)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      119: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMIME("text/x-erlang", "erlang"), e.defineMode("erlang", function (t) {
            var r = ["-type", "-spec", "-export_type", "-opaque"],
              n = ["after", "begin", "catch", "case", "cond", "end", "fun", "if", "let", "of", "query", "receive", "try", "when"],
              i = /[\->,;]/,
              o = ["->", ";", ","],
              a = ["and", "andalso", "band", "bnot", "bor", "bsl", "bsr", "bxor", "div", "not", "or", "orelse", "rem", "xor"],
              s = /[\+\-\*\/<>=\|:!]/,
              l = ["=", "+", "-", "*", "/", ">", ">=", "<", "=<", "=:=", "==", "=/=", "/=", "||", "<-", "!"],
              c = /[<\(\[\{]/,
              u = ["<<", "(", "[", "{"],
              d = /[>\)\]\}]/,
              p = ["}", "]", ")", ">>"],
              f = ["is_atom", "is_binary", "is_bitstring", "is_boolean", "is_float", "is_function", "is_integer", "is_list", "is_number", "is_pid", "is_port", "is_record", "is_reference", "is_tuple", "atom", "binary", "bitstring", "boolean", "function", "integer", "list", "number", "pid", "port", "record", "reference", "tuple"],
              m = ["abs", "adler32", "adler32_combine", "alive", "apply", "atom_to_binary", "atom_to_list", "binary_to_atom", "binary_to_existing_atom", "binary_to_list", "binary_to_term", "bit_size", "bitstring_to_list", "byte_size", "check_process_code", "contact_binary", "crc32", "crc32_combine", "date", "decode_packet", "delete_module", "disconnect_node", "element", "erase", "exit", "float", "float_to_list", "garbage_collect", "get", "get_keys", "group_leader", "halt", "hd", "integer_to_list", "internal_bif", "iolist_size", "iolist_to_binary", "is_alive", "is_atom", "is_binary", "is_bitstring", "is_boolean", "is_float", "is_function", "is_integer", "is_list", "is_number", "is_pid", "is_port", "is_process_alive", "is_record", "is_reference", "is_tuple", "length", "link", "list_to_atom", "list_to_binary", "list_to_bitstring", "list_to_existing_atom", "list_to_float", "list_to_integer", "list_to_pid", "list_to_tuple", "load_module", "make_ref", "module_loaded", "monitor_node", "node", "node_link", "node_unlink", "nodes", "notalive", "now", "open_port", "pid_to_list", "port_close", "port_command", "port_connect", "port_control", "pre_loaded", "process_flag", "process_info", "processes", "purge_module", "put", "register", "registered", "round", "self", "setelement", "size", "spawn", "spawn_link", "spawn_monitor", "spawn_opt", "split_binary", "statistics", "term_to_binary", "time", "throw", "tl", "trunc", "tuple_size", "tuple_to_list", "unlink", "unregister", "whereis"],
              h = /[\w@Ø-ÞÀ-Öß-öø-ÿ]/,
              g = /[0-7]{1,3}|[bdefnrstv\\"']|\^[a-zA-Z]|x[0-9a-zA-Z]{2}|x{[0-9a-zA-Z]+}/;
            function y(e, t, r) {
              if (1 == e.current().length && t.test(e.current())) {
                for (e.backUp(1); t.test(e.peek());) {
                  if (e.next(), w(e.current(), r)) return !0;
                }
                e.backUp(e.current().length - 1);
              }
              return !1;
            }
            function v(e, t, r) {
              if (1 == e.current().length && t.test(e.current())) {
                for (; t.test(e.peek());) {
                  e.next();
                }
                for (; 0 < e.current().length;) {
                  if (w(e.current(), r)) return !0;
                  e.backUp(1);
                }
                e.next();
              }
              return !1;
            }
            function b(e) {
              return k(e, '"', "\\");
            }
            function x(e) {
              return k(e, "'", "\\");
            }
            function k(e, t, r) {
              for (; !e.eol();) {
                var n = e.next();
                if (n == t) return !0;
                n == r && e.next();
              }
              return !1;
            }
            function w(e, t) {
              return -1 < t.indexOf(e);
            }
            function _(e, t, r) {
              switch (function (e, t) {
                "comment" != t.type && "whitespace" != t.type && (e.tokenStack = function (e, t) {
                  var r = e.length - 1;
                  return 0 < r && "record" === e[r].type && "dot" === t.type ? e.pop() : 0 < r && "group" === e[r].type ? (e.pop(), e.push(t)) : e.push(t), e;
                }(e.tokenStack, t), e.tokenStack = function (e) {
                  if (!e.length) return e;
                  var t = e.length - 1;
                  if ("dot" === e[t].type) return [];
                  if (t > 1 && "fun" === e[t].type && "fun" === e[t - 1].token) return e.slice(0, t - 1);
                  switch (e[t].token) {
                    case "}":
                      return M(e, {
                        g: ["{"]
                      });
                    case "]":
                      return M(e, {
                        i: ["["]
                      });
                    case ")":
                      return M(e, {
                        i: ["("]
                      });
                    case ">>":
                      return M(e, {
                        i: ["<<"]
                      });
                    case "end":
                      return M(e, {
                        i: ["begin", "case", "fun", "if", "receive", "try"]
                      });
                    case ",":
                      return M(e, {
                        e: ["begin", "try", "when", "->", ",", "(", "[", "{", "<<"]
                      });
                    case "->":
                      return M(e, {
                        r: ["when"],
                        m: ["try", "if", "case", "receive"]
                      });
                    case ";":
                      return M(e, {
                        E: ["case", "fun", "if", "receive", "try", "when"]
                      });
                    case "catch":
                      return M(e, {
                        e: ["try"]
                      });
                    case "of":
                      return M(e, {
                        e: ["case"]
                      });
                    case "after":
                      return M(e, {
                        e: ["receive", "try"]
                      });
                    default:
                      return e;
                  }
                }(e.tokenStack));
              }(e, function (e, t) {
                return S(t.current(), t.column(), t.indentation(), e);
              }(r, t)), r) {
                case "atom":
                case "boolean":
                  return "atom";
                case "attribute":
                  return "attribute";
                case "builtin":
                  return "builtin";
                case "close_paren":
                case "colon":
                case "dot":
                case "open_paren":
                case "separator":
                default:
                  return null;
                case "comment":
                  return "comment";
                case "error":
                  return "error";
                case "fun":
                  return "meta";
                case "function":
                  return "tag";
                case "guard":
                  return "property";
                case "keyword":
                  return "keyword";
                case "macro":
                  return "variable-2";
                case "number":
                  return "number";
                case "operator":
                  return "operator";
                case "record":
                  return "bracket";
                case "string":
                  return "string";
                case "type":
                  return "def";
                case "variable":
                  return "variable";
              }
            }
            function S(e, t, r, n) {
              return {
                token: e,
                column: t,
                indent: r,
                type: n
              };
            }
            function C(e) {
              return S(e, 0, 0, e);
            }
            function T(e, t) {
              var r = e.tokenStack.length,
                n = t || 1;
              return !(r < n) && e.tokenStack[r - n];
            }
            function M(e, t) {
              for (var r in t) {
                for (var n = e.length - 1, i = t[r], o = n - 1; -1 < o; o--) {
                  if (w(e[o].token, i)) {
                    var a = e.slice(0, o);
                    switch (r) {
                      case "m":
                        return a.concat(e[o]).concat(e[n]);
                      case "r":
                        return a.concat(e[n]);
                      case "i":
                        return a;
                      case "g":
                        return a.concat(C("group"));
                      case "E":
                      case "e":
                        return a.concat(e[o]);
                    }
                  }
                }
              }
              return "E" == r ? [] : e;
            }
            function E(r, n) {
              var i,
                o,
                a = t.indentUnit,
                s = N(o = n.match(/,|[a-z]+|\}|\]|\)|>>|\|+|\(/)) && 0 === o.index ? o[0] : "",
                l = T(r, 1),
                c = T(r, 2);
              return r.in_string || r.in_atom ? e.Pass : c ? "when" == l.token ? l.column + a : "when" === s && "function" === c.type ? c.indent + a : "(" === s && "fun" === l.token ? l.column + 3 : "catch" === s && (i = L(r, ["try"])) ? i.column : w(s, ["end", "after", "of"]) ? (i = L(r, ["begin", "case", "fun", "if", "receive", "try"])) ? i.column : e.Pass : w(s, p) ? (i = L(r, u)) ? i.column : e.Pass : w(l.token, [",", "|", "||"]) || w(s, [",", "|", "||"]) ? (i = function (e) {
                var t = e.tokenStack.slice(0, -1),
                  r = A(t, "type", ["open_paren"]);
                return !!N(t[r]) && t[r];
              }(r), i ? i.column + i.token.length : a) : "->" == l.token ? w(c.token, ["receive", "case", "if", "try"]) ? c.column + a + a : c.column + a : w(l.token, u) ? l.column + l.token.length : (i = function (e) {
                var t = e.tokenStack,
                  r = A(t, "type", ["open_paren", "separator", "keyword"]),
                  n = A(t, "type", ["operator"]);
                return N(r) && N(n) && r < n ? t[r + 1] : !!N(r) && t[r];
              }(r), N(i) ? i.column + a : 0) : 0;
            }
            function L(e, t) {
              var r = e.tokenStack,
                n = A(r, "token", t);
              return !!N(r[n]) && r[n];
            }
            function A(e, t, r) {
              for (var n = e.length - 1; -1 < n; n--) {
                if (w(e[n][t], r)) return n;
              }
              return !1;
            }
            function N(e) {
              return !1 !== e && null != e;
            }
            return {
              startState: function startState() {
                return {
                  tokenStack: [],
                  in_string: !1,
                  in_atom: !1
                };
              },
              token: function token(e, t) {
                return function (e, t) {
                  if (t.in_string) return t.in_string = !b(e), _(t, e, "string");
                  if (t.in_atom) return t.in_atom = !x(e), _(t, e, "atom");
                  if (e.eatSpace()) return _(t, e, "whitespace");
                  if (!T(t) && e.match(/-\s*[a-zß-öø-ÿ][\wØ-ÞÀ-Öß-öø-ÿ]*/)) return w(e.current(), r) ? _(t, e, "type") : _(t, e, "attribute");
                  var k = e.next();
                  if ("%" == k) return e.skipToEnd(), _(t, e, "comment");
                  if (":" == k) return _(t, e, "colon");
                  if ("?" == k) return e.eatSpace(), e.eatWhile(h), _(t, e, "macro");
                  if ("#" == k) return e.eatSpace(), e.eatWhile(h), _(t, e, "record");
                  if ("$" == k) return "\\" != e.next() || e.match(g) ? _(t, e, "number") : _(t, e, "error");
                  if ("." == k) return _(t, e, "dot");
                  if ("'" == k) {
                    if (!(t.in_atom = !x(e))) {
                      if (e.match(/\s*\/\s*[0-9]/, !1)) return e.match(/\s*\/\s*[0-9]/, !0), _(t, e, "fun");
                      if (e.match(/\s*\(/, !1) || e.match(/\s*:/, !1)) return _(t, e, "function");
                    }
                    return _(t, e, "atom");
                  }
                  if ('"' == k) return t.in_string = !b(e), _(t, e, "string");
                  if (/[A-Z_Ø-ÞÀ-Ö]/.test(k)) return e.eatWhile(h), _(t, e, "variable");
                  if (/[a-z_ß-öø-ÿ]/.test(k)) {
                    if (e.eatWhile(h), e.match(/\s*\/\s*[0-9]/, !1)) return e.match(/\s*\/\s*[0-9]/, !0), _(t, e, "fun");
                    var S = e.current();
                    return w(S, n) ? _(t, e, "keyword") : w(S, a) ? _(t, e, "operator") : e.match(/\s*\(/, !1) ? !w(S, m) || ":" == T(t).token && "erlang" != T(t, 2).token ? w(S, f) ? _(t, e, "guard") : _(t, e, "function") : _(t, e, "builtin") : ":" == function (e) {
                      var t = e.match(/([\n\s]+|%[^\n]*\n)*(.)/, !1);
                      return t ? t.pop() : "";
                    }(e) ? _(t, e, "erlang" == S ? "builtin" : "function") : w(S, ["true", "false"]) ? _(t, e, "boolean") : _(t, e, "atom");
                  }
                  var C = /[0-9]/;
                  return C.test(k) ? (e.eatWhile(C), e.eat("#") ? e.eatWhile(/[0-9a-zA-Z]/) || e.backUp(1) : e.eat(".") && (e.eatWhile(C) ? e.eat(/[eE]/) && (e.eat(/[-+]/) ? e.eatWhile(C) || e.backUp(2) : e.eatWhile(C) || e.backUp(1)) : e.backUp(1)), _(t, e, "number")) : y(e, c, u) ? _(t, e, "open_paren") : y(e, d, p) ? _(t, e, "close_paren") : v(e, i, o) ? _(t, e, "separator") : v(e, s, l) ? _(t, e, "operator") : _(t, e, null);
                }(e, t);
              },
              indent: function indent(e, t) {
                return E(e, t);
              },
              lineComment: "%"
            };
          });
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      9555: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMode("go", function (t) {
            var r,
              n = t.indentUnit,
              i = {
                break: !0,
                case: !0,
                chan: !0,
                const: !0,
                continue: !0,
                default: !0,
                defer: !0,
                else: !0,
                fallthrough: !0,
                for: !0,
                func: !0,
                go: !0,
                goto: !0,
                if: !0,
                import: !0,
                interface: !0,
                map: !0,
                package: !0,
                range: !0,
                return: !0,
                select: !0,
                struct: !0,
                switch: !0,
                type: !0,
                var: !0,
                bool: !0,
                byte: !0,
                complex64: !0,
                complex128: !0,
                float32: !0,
                float64: !0,
                int8: !0,
                int16: !0,
                int32: !0,
                int64: !0,
                string: !0,
                uint8: !0,
                uint16: !0,
                uint32: !0,
                uint64: !0,
                int: !0,
                uint: !0,
                uintptr: !0,
                error: !0,
                rune: !0
              },
              o = {
                true: !0,
                false: !0,
                iota: !0,
                nil: !0,
                append: !0,
                cap: !0,
                close: !0,
                complex: !0,
                copy: !0,
                delete: !0,
                imag: !0,
                len: !0,
                make: !0,
                new: !0,
                panic: !0,
                print: !0,
                println: !0,
                real: !0,
                recover: !0
              },
              a = /[+\-*&^%:=<>!|\/]/;
            function s(e, t) {
              var n,
                c = e.next();
              if ('"' == c || "'" == c || "`" == c) return t.tokenize = (n = c, function (e, t) {
                for (var r, i = !1, o = !1; null != (r = e.next());) {
                  if (r == n && !i) {
                    o = !0;
                    break;
                  }
                  i = !i && "`" != n && "\\" == r;
                }
                return (o || !i && "`" != n) && (t.tokenize = s), "string";
              }), t.tokenize(e, t);
              if (/[\d\.]/.test(c)) return "." == c ? e.match(/^[0-9]+([eE][\-+]?[0-9]+)?/) : "0" == c ? e.match(/^[xX][0-9a-fA-F]+/) || e.match(/^0[0-7]+/) : e.match(/^[0-9]*\.?[0-9]*([eE][\-+]?[0-9]+)?/), "number";
              if (/[\[\]{}\(\),;\:\.]/.test(c)) return r = c, null;
              if ("/" == c) {
                if (e.eat("*")) return t.tokenize = l, l(e, t);
                if (e.eat("/")) return e.skipToEnd(), "comment";
              }
              if (a.test(c)) return e.eatWhile(a), "operator";
              e.eatWhile(/[\w\$_\xa1-\uffff]/);
              var u = e.current();
              return i.propertyIsEnumerable(u) ? ("case" != u && "default" != u || (r = "case"), "keyword") : o.propertyIsEnumerable(u) ? "atom" : "variable";
            }
            function l(e, t) {
              for (var r, n = !1; r = e.next();) {
                if ("/" == r && n) {
                  t.tokenize = s;
                  break;
                }
                n = "*" == r;
              }
              return "comment";
            }
            function c(e, t, r, n, i) {
              this.indented = e, this.column = t, this.type = r, this.align = n, this.prev = i;
            }
            function u(e, t, r) {
              return e.context = new c(e.indented, t, r, null, e.context);
            }
            function d(e) {
              if (e.context.prev) {
                var t = e.context.type;
                return ")" != t && "]" != t && "}" != t || (e.indented = e.context.indented), e.context = e.context.prev;
              }
            }
            return {
              startState: function startState(e) {
                return {
                  tokenize: null,
                  context: new c((e || 0) - n, 0, "top", !1),
                  indented: 0,
                  startOfLine: !0
                };
              },
              token: function token(e, t) {
                var n = t.context;
                if (e.sol() && (null == n.align && (n.align = !1), t.indented = e.indentation(), t.startOfLine = !0, "case" == n.type && (n.type = "}")), e.eatSpace()) return null;
                r = null;
                var i = (t.tokenize || s)(e, t);
                return "comment" == i || (null == n.align && (n.align = !0), "{" == r ? u(t, e.column(), "}") : "[" == r ? u(t, e.column(), "]") : "(" == r ? u(t, e.column(), ")") : "case" == r ? n.type = "case" : ("}" == r && "}" == n.type || r == n.type) && d(t), t.startOfLine = !1), i;
              },
              indent: function indent(t, r) {
                if (t.tokenize != s && null != t.tokenize) return e.Pass;
                var i = t.context,
                  o = r && r.charAt(0);
                if ("case" == i.type && /^(?:case|default)\b/.test(r)) return t.context.type = "}", i.indented;
                var a = o == i.type;
                return i.align ? i.column + (a ? 0 : 1) : i.indented + (a ? 0 : n);
              },
              electricChars: "{}):",
              closeBrackets: "()[]{}''\"\"``",
              fold: "brace",
              blockCommentStart: "/*",
              blockCommentEnd: "*/",
              lineComment: "//"
            };
          }), e.defineMIME("text/x-go", "go");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      410: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMode("groovy", function (t) {
            function r(e) {
              for (var t = {}, r = e.split(" "), n = 0; n < r.length; ++n) {
                t[r[n]] = !0;
              }
              return t;
            }
            var n,
              i = r("abstract as assert boolean break byte case catch char class const continue def default do double else enum extends final finally float for goto if implements import in instanceof int interface long native new package private protected public return short static strictfp super switch synchronized threadsafe throw throws trait transient try void volatile while"),
              o = r("catch class def do else enum finally for if interface switch trait try while"),
              a = r("return break continue"),
              s = r("null true false this");
            function l(e, t) {
              var r = e.next();
              if ('"' == r || "'" == r) return c(r, e, t);
              if (/[\[\]{}\(\),;\:\.]/.test(r)) return n = r, null;
              if (/\d/.test(r)) return e.eatWhile(/[\w\.]/), e.eat(/eE/) && (e.eat(/\+\-/), e.eatWhile(/\d/)), "number";
              if ("/" == r) {
                if (e.eat("*")) return t.tokenize.push(d), d(e, t);
                if (e.eat("/")) return e.skipToEnd(), "comment";
                if (p(t.lastToken, !1)) return c(r, e, t);
              }
              if ("-" == r && e.eat(">")) return n = "->", null;
              if (/[+\-*&%=<>!?|\/~]/.test(r)) return e.eatWhile(/[+\-*&%=<>|~]/), "operator";
              if (e.eatWhile(/[\w\$_]/), "@" == r) return e.eatWhile(/[\w\$_\.]/), "meta";
              if ("." == t.lastToken) return "property";
              if (e.eat(":")) return n = "proplabel", "property";
              var l = e.current();
              return s.propertyIsEnumerable(l) ? "atom" : i.propertyIsEnumerable(l) ? (o.propertyIsEnumerable(l) ? n = "newstatement" : a.propertyIsEnumerable(l) && (n = "standalone"), "keyword") : "variable";
            }
            function c(e, t, r) {
              var n = !1;
              if ("/" != e && t.eat(e)) {
                if (!t.eat(e)) return "string";
                n = !0;
              }
              function i(t, r) {
                for (var i, o = !1, a = !n; null != (i = t.next());) {
                  if (i == e && !o) {
                    if (!n) break;
                    if (t.match(e + e)) {
                      a = !0;
                      break;
                    }
                  }
                  if ('"' == e && "$" == i && !o && t.eat("{")) return r.tokenize.push(u()), "string";
                  o = !o && "\\" == i;
                }
                return a && r.tokenize.pop(), "string";
              }
              return r.tokenize.push(i), i(t, r);
            }
            function u() {
              var e = 1;
              function t(t, r) {
                if ("}" == t.peek()) {
                  if (0 == --e) return r.tokenize.pop(), r.tokenize[r.tokenize.length - 1](t, r);
                } else "{" == t.peek() && e++;
                return l(t, r);
              }
              return t.isBase = !0, t;
            }
            function d(e, t) {
              for (var r, n = !1; r = e.next();) {
                if ("/" == r && n) {
                  t.tokenize.pop();
                  break;
                }
                n = "*" == r;
              }
              return "comment";
            }
            function p(e, t) {
              return !e || "operator" == e || "->" == e || /[\.\[\{\(,;:]/.test(e) || "newstatement" == e || "keyword" == e || "proplabel" == e || "standalone" == e && !t;
            }
            function f(e, t, r, n, i) {
              this.indented = e, this.column = t, this.type = r, this.align = n, this.prev = i;
            }
            function m(e, t, r) {
              return e.context = new f(e.indented, t, r, null, e.context);
            }
            function h(e) {
              var t = e.context.type;
              return ")" != t && "]" != t && "}" != t || (e.indented = e.context.indented), e.context = e.context.prev;
            }
            return l.isBase = !0, {
              startState: function startState(e) {
                return {
                  tokenize: [l],
                  context: new f((e || 0) - t.indentUnit, 0, "top", !1),
                  indented: 0,
                  startOfLine: !0,
                  lastToken: null
                };
              },
              token: function token(e, t) {
                var r = t.context;
                if (e.sol() && (null == r.align && (r.align = !1), t.indented = e.indentation(), t.startOfLine = !0, "statement" != r.type || p(t.lastToken, !0) || (h(t), r = t.context)), e.eatSpace()) return null;
                n = null;
                var i = t.tokenize[t.tokenize.length - 1](e, t);
                if ("comment" == i) return i;
                if (null == r.align && (r.align = !0), ";" != n && ":" != n || "statement" != r.type) {
                  if ("->" == n && "statement" == r.type && "}" == r.prev.type) h(t), t.context.align = !1;else if ("{" == n) m(t, e.column(), "}");else if ("[" == n) m(t, e.column(), "]");else if ("(" == n) m(t, e.column(), ")");else if ("}" == n) {
                    for (; "statement" == r.type;) {
                      r = h(t);
                    }
                    for ("}" == r.type && (r = h(t)); "statement" == r.type;) {
                      r = h(t);
                    }
                  } else n == r.type ? h(t) : ("}" == r.type || "top" == r.type || "statement" == r.type && "newstatement" == n) && m(t, e.column(), "statement");
                } else h(t);
                return t.startOfLine = !1, t.lastToken = n || i, i;
              },
              indent: function indent(r, n) {
                if (!r.tokenize[r.tokenize.length - 1].isBase) return e.Pass;
                var i = n && n.charAt(0),
                  o = r.context;
                "statement" != o.type || p(r.lastToken, !0) || (o = o.prev);
                var a = i == o.type;
                return "statement" == o.type ? o.indented + ("{" == i ? 0 : t.indentUnit) : o.align ? o.column + (a ? 0 : 1) : o.indented + (a ? 0 : t.indentUnit);
              },
              electricChars: "{}",
              closeBrackets: {
                triples: "'\""
              },
              fold: "brace",
              blockCommentStart: "/*",
              blockCommentEnd: "*/",
              lineComment: "//"
            };
          }), e.defineMIME("text/x-groovy", "groovy");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      3394: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          var t = {
              script: [["lang", /(javascript|babel)/i, "javascript"], ["type", /^(?:text|application)\/(?:x-)?(?:java|ecma)script$|^module$|^$/i, "javascript"], ["type", /./, "text/plain"], [null, null, "javascript"]],
              style: [["lang", /^css$/i, "css"], ["type", /^(text\/)?(x-)?(stylesheet|css)$/i, "css"], ["type", /./, "text/plain"], [null, null, "css"]]
            },
            r = {};
          function n(e, t) {
            var n = e.match(function (e) {
              return r[e] || (r[e] = new RegExp("\\s+" + e + "\\s*=\\s*('|\")?([^'\"]+)('|\")?\\s*"));
            }(t));
            return n ? /^\s*(.*?)\s*$/.exec(n[2])[1] : "";
          }
          function i(e, t) {
            return new RegExp((t ? "^" : "") + "</s*" + e + "s*>", "i");
          }
          function o(e, t) {
            for (var r in e) {
              for (var n = t[r] || (t[r] = []), i = e[r], o = i.length - 1; o >= 0; o--) {
                n.unshift(i[o]);
              }
            }
          }
          e.defineMode("htmlmixed", function (r, a) {
            var s = e.getMode(r, {
                name: "xml",
                htmlMode: !0,
                multilineTagIndentFactor: a.multilineTagIndentFactor,
                multilineTagIndentPastTag: a.multilineTagIndentPastTag
              }),
              l = {},
              c = a && a.tags,
              u = a && a.scriptTypes;
            if (o(t, l), c && o(c, l), u) for (var d = u.length - 1; d >= 0; d--) {
              l.script.unshift(["type", u[d].matches, u[d].mode]);
            }
            function p(t, o) {
              var a,
                c = s.token(t, o.htmlState),
                u = /\btag\b/.test(c);
              if (u && !/[<>\s\/]/.test(t.current()) && (a = o.htmlState.tagName && o.htmlState.tagName.toLowerCase()) && l.hasOwnProperty(a)) o.inTag = a + " ";else if (o.inTag && u && />$/.test(t.current())) {
                var d = /^([\S]+) (.*)/.exec(o.inTag);
                o.inTag = null;
                var f = ">" == t.current() && function (e, t) {
                    for (var r = 0; r < e.length; r++) {
                      var i = e[r];
                      if (!i[0] || i[1].test(n(t, i[0]))) return i[2];
                    }
                  }(l[d[1]], d[2]),
                  m = e.getMode(r, f),
                  h = i(d[1], !0),
                  g = i(d[1], !1);
                o.token = function (e, t) {
                  return e.match(h, !1) ? (t.token = p, t.localState = t.localMode = null, null) : function (e, t, r) {
                    var n = e.current(),
                      i = n.search(t);
                    return i > -1 ? e.backUp(n.length - i) : n.match(/<\/?$/) && (e.backUp(n.length), e.match(t, !1) || e.match(n)), r;
                  }(e, g, t.localMode.token(e, t.localState));
                }, o.localMode = m, o.localState = e.startState(m, s.indent(o.htmlState, "", ""));
              } else o.inTag && (o.inTag += t.current(), t.eol() && (o.inTag += " "));
              return c;
            }
            return {
              startState: function startState() {
                return {
                  token: p,
                  inTag: null,
                  localMode: null,
                  localState: null,
                  htmlState: e.startState(s)
                };
              },
              copyState: function copyState(t) {
                var r;
                return t.localState && (r = e.copyState(t.localMode, t.localState)), {
                  token: t.token,
                  inTag: t.inTag,
                  localMode: t.localMode,
                  localState: r,
                  htmlState: e.copyState(s, t.htmlState)
                };
              },
              token: function token(e, t) {
                return t.token(e, t);
              },
              indent: function indent(t, r, n) {
                return !t.localMode || /^\s*<\//.test(r) ? s.indent(t.htmlState, r, n) : t.localMode.indent ? t.localMode.indent(t.localState, r, n) : e.Pass;
              },
              innerMode: function innerMode(e) {
                return {
                  state: e.localState || e.htmlState,
                  mode: e.localMode || s
                };
              }
            };
          }, "xml", "javascript", "css"), e.defineMIME("text/html", "htmlmixed");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074), r(336), r(9965), r(5239)) : (i = [r(9074), r(336), r(9965), r(5239)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      5372: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMode("http", function () {
            function e(e, t) {
              return e.skipToEnd(), t.cur = a, "error";
            }
            function t(t, n) {
              return t.match(/^HTTP\/\d\.\d/) ? (n.cur = r, "keyword") : t.match(/^[A-Z]+/) && /[ \t]/.test(t.peek()) ? (n.cur = i, "keyword") : e(t, n);
            }
            function r(t, r) {
              var i = t.match(/^\d+/);
              if (!i) return e(t, r);
              r.cur = n;
              var o = Number(i[0]);
              return o >= 100 && o < 200 ? "positive informational" : o >= 200 && o < 300 ? "positive success" : o >= 300 && o < 400 ? "positive redirect" : o >= 400 && o < 500 ? "negative client-error" : o >= 500 && o < 600 ? "negative server-error" : "error";
            }
            function n(e, t) {
              return e.skipToEnd(), t.cur = a, null;
            }
            function i(e, t) {
              return e.eatWhile(/\S/), t.cur = o, "string-2";
            }
            function o(t, r) {
              return t.match(/^HTTP\/\d\.\d$/) ? (r.cur = a, "keyword") : e(t, r);
            }
            function a(e) {
              return e.sol() && !e.eat(/[ \t]/) ? e.match(/^.*?:/) ? "atom" : (e.skipToEnd(), "error") : (e.skipToEnd(), "string");
            }
            function s(e) {
              return e.skipToEnd(), null;
            }
            return {
              token: function token(e, t) {
                var r = t.cur;
                return r != a && r != s && e.eatSpace() ? null : r(e, t);
              },
              blankLine: function blankLine(e) {
                e.cur = s;
              },
              startState: function startState() {
                return {
                  cur: t
                };
              }
            };
          }), e.defineMIME("message/http", "http");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      9965: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMode("javascript", function (t, r) {
            var n,
              i,
              o = t.indentUnit,
              a = r.statementIndent,
              l = r.jsonld,
              c = r.json || l,
              u = r.typescript,
              d = r.wordCharacters || /[\w$\xa1-\uffff]/,
              p = function () {
                function e(e) {
                  return {
                    type: e,
                    style: "keyword"
                  };
                }
                var t = e("keyword a"),
                  r = e("keyword b"),
                  n = e("keyword c"),
                  i = e("keyword d"),
                  o = e("operator"),
                  a = {
                    type: "atom",
                    style: "atom"
                  };
                return {
                  if: e("if"),
                  while: t,
                  with: t,
                  else: r,
                  do: r,
                  try: r,
                  finally: r,
                  return: i,
                  break: i,
                  continue: i,
                  new: e("new"),
                  delete: n,
                  void: n,
                  throw: n,
                  debugger: e("debugger"),
                  var: e("var"),
                  const: e("var"),
                  let: e("var"),
                  function: e("function"),
                  catch: e("catch"),
                  for: e("for"),
                  switch: e("switch"),
                  case: e("case"),
                  default: e("default"),
                  in: o,
                  typeof: o,
                  instanceof: o,
                  true: a,
                  false: a,
                  null: a,
                  undefined: a,
                  NaN: a,
                  Infinity: a,
                  this: e("this"),
                  class: e("class"),
                  super: e("atom"),
                  yield: n,
                  export: e("export"),
                  import: e("import"),
                  extends: n,
                  await: n
                };
              }(),
              f = /[+\-*&%=<>!?|~^@]/,
              m = /^@(context|id|value|language|type|container|list|set|reverse|index|base|vocab|graph)"/;
            function h(e, t, r) {
              return n = e, i = r, t;
            }
            function g(e, t) {
              var r,
                n = e.next();
              if ('"' == n || "'" == n) return t.tokenize = (r = n, function (e, t) {
                var n,
                  i = !1;
                if (l && "@" == e.peek() && e.match(m)) return t.tokenize = g, h("jsonld-keyword", "meta");
                for (; null != (n = e.next()) && (n != r || i);) {
                  i = !i && "\\" == n;
                }
                return i || (t.tokenize = g), h("string", "string");
              }), t.tokenize(e, t);
              if ("." == n && e.match(/^\d[\d_]*(?:[eE][+\-]?[\d_]+)?/)) return h("number", "number");
              if ("." == n && e.match("..")) return h("spread", "meta");
              if (/[\[\]{}\(\),;\:\.]/.test(n)) return h(n);
              if ("=" == n && e.eat(">")) return h("=>", "operator");
              if ("0" == n && e.match(/^(?:x[\dA-Fa-f_]+|o[0-7_]+|b[01_]+)n?/)) return h("number", "number");
              if (/\d/.test(n)) return e.match(/^[\d_]*(?:n|(?:\.[\d_]*)?(?:[eE][+\-]?[\d_]+)?)?/), h("number", "number");
              if ("/" == n) return e.eat("*") ? (t.tokenize = y, y(e, t)) : e.eat("/") ? (e.skipToEnd(), h("comment", "comment")) : Ze(e, t, 1) ? (function (e) {
                for (var t, r = !1, n = !1; null != (t = e.next());) {
                  if (!r) {
                    if ("/" == t && !n) return;
                    "[" == t ? n = !0 : n && "]" == t && (n = !1);
                  }
                  r = !r && "\\" == t;
                }
              }(e), e.match(/^\b(([gimyus])(?![gimyus]*\2))+\b/), h("regexp", "string-2")) : (e.eat("="), h("operator", "operator", e.current()));
              if ("`" == n) return t.tokenize = v, v(e, t);
              if ("#" == n && "!" == e.peek()) return e.skipToEnd(), h("meta", "meta");
              if ("#" == n && e.eatWhile(d)) return h("variable", "property");
              if ("<" == n && e.match("!--") || "-" == n && e.match("->")) return e.skipToEnd(), h("comment", "comment");
              if (f.test(n)) return ">" == n && t.lexical && ">" == t.lexical.type || (e.eat("=") ? "!" != n && "=" != n || e.eat("=") : /[<>*+\-]/.test(n) && (e.eat(n), ">" == n && e.eat(n))), "?" == n && e.eat(".") ? h(".") : h("operator", "operator", e.current());
              if (d.test(n)) {
                e.eatWhile(d);
                var i = e.current();
                if ("." != t.lastType) {
                  if (p.propertyIsEnumerable(i)) {
                    var o = p[i];
                    return h(o.type, o.style, i);
                  }
                  if ("async" == i && e.match(/^(\s|\/\*.*?\*\/)*[\[\(\w]/, !1)) return h("async", "keyword", i);
                }
                return h("variable", "variable", i);
              }
            }
            function y(e, t) {
              for (var r, n = !1; r = e.next();) {
                if ("/" == r && n) {
                  t.tokenize = g;
                  break;
                }
                n = "*" == r;
              }
              return h("comment", "comment");
            }
            function v(e, t) {
              for (var r, n = !1; null != (r = e.next());) {
                if (!n && ("`" == r || "$" == r && e.eat("{"))) {
                  t.tokenize = g;
                  break;
                }
                n = !n && "\\" == r;
              }
              return h("quasi", "string-2", e.current());
            }
            function b(e, t) {
              t.fatArrowAt && (t.fatArrowAt = null);
              var r = e.string.indexOf("=>", e.start);
              if (!(r < 0)) {
                if (u) {
                  var n = /:\s*(?:\w+(?:<[^>]*>|\[\])?|\{[^}]*\})\s*$/.exec(e.string.slice(e.start, r));
                  n && (r = n.index);
                }
                for (var i = 0, o = !1, a = r - 1; a >= 0; --a) {
                  var s = e.string.charAt(a),
                    l = "([{}])".indexOf(s);
                  if (l >= 0 && l < 3) {
                    if (!i) {
                      ++a;
                      break;
                    }
                    if (0 == --i) {
                      "(" == s && (o = !0);
                      break;
                    }
                  } else if (l >= 3 && l < 6) ++i;else if (d.test(s)) o = !0;else if (/["'\/`]/.test(s)) for (;; --a) {
                    if (0 == a) return;
                    if (e.string.charAt(a - 1) == s && "\\" != e.string.charAt(a - 2)) {
                      a--;
                      break;
                    }
                  } else if (o && !i) {
                    ++a;
                    break;
                  }
                }
                o && !i && (t.fatArrowAt = a);
              }
            }
            var x = {
              atom: !0,
              number: !0,
              variable: !0,
              string: !0,
              regexp: !0,
              this: !0,
              "jsonld-keyword": !0
            };
            function k(e, t, r, n, i, o) {
              this.indented = e, this.column = t, this.type = r, this.prev = i, this.info = o, null != n && (this.align = n);
            }
            function w(e, t) {
              for (var r = e.localVars; r; r = r.next) {
                if (r.name == t) return !0;
              }
              for (var n = e.context; n; n = n.prev) {
                for (r = n.vars; r; r = r.next) {
                  if (r.name == t) return !0;
                }
              }
            }
            var _ = {
              state: null,
              column: null,
              marked: null,
              cc: null
            };
            function S() {
              for (var e = arguments.length - 1; e >= 0; e--) {
                _.cc.push(arguments[e]);
              }
            }
            function C() {
              return S.apply(null, arguments), !0;
            }
            function T(e, t) {
              for (var r = t; r; r = r.next) {
                if (r.name == e) return !0;
              }
              return !1;
            }
            function M(e) {
              var t = _.state;
              if (_.marked = "def", t.context) if ("var" == t.lexical.info && t.context && t.context.block) {
                var n = E(e, t.context);
                if (null != n) return void (t.context = n);
              } else if (!T(e, t.localVars)) return void (t.localVars = new N(e, t.localVars));
              r.globalVars && !T(e, t.globalVars) && (t.globalVars = new N(e, t.globalVars));
            }
            function E(e, t) {
              if (t) {
                if (t.block) {
                  var r = E(e, t.prev);
                  return r ? r == t.prev ? t : new A(r, t.vars, !0) : null;
                }
                return T(e, t.vars) ? t : new A(t.prev, new N(e, t.vars), !1);
              }
              return null;
            }
            function L(e) {
              return "public" == e || "private" == e || "protected" == e || "abstract" == e || "readonly" == e;
            }
            function A(e, t, r) {
              this.prev = e, this.vars = t, this.block = r;
            }
            function N(e, t) {
              this.name = e, this.next = t;
            }
            var z = new N("this", new N("arguments", null));
            function O() {
              _.state.context = new A(_.state.context, _.state.localVars, !1), _.state.localVars = z;
            }
            function D() {
              _.state.context = new A(_.state.context, _.state.localVars, !0), _.state.localVars = null;
            }
            function I() {
              _.state.localVars = _.state.context.vars, _.state.context = _.state.context.prev;
            }
            function P(e, t) {
              var r = function r() {
                var r = _.state,
                  n = r.indented;
                if ("stat" == r.lexical.type) n = r.lexical.indented;else for (var i = r.lexical; i && ")" == i.type && i.align; i = i.prev) {
                  n = i.indented;
                }
                r.lexical = new k(n, _.stream.column(), e, null, r.lexical, t);
              };
              return r.lex = !0, r;
            }
            function j() {
              var e = _.state;
              e.lexical.prev && (")" == e.lexical.type && (e.indented = e.lexical.indented), e.lexical = e.lexical.prev);
            }
            function q(e) {
              return function t(r) {
                return r == e ? C() : ";" == e || "}" == r || ")" == r || "]" == r ? S() : C(t);
              };
            }
            function F(e, t) {
              return "var" == e ? C(P("vardef", t), xe, q(";"), j) : "keyword a" == e ? C(P("form"), U, F, j) : "keyword b" == e ? C(P("form"), F, j) : "keyword d" == e ? _.stream.match(/^\s*$/, !1) ? C() : C(P("stat"), B, q(";"), j) : "debugger" == e ? C(q(";")) : "{" == e ? C(P("}"), D, se, j, I) : ";" == e ? C() : "if" == e ? ("else" == _.state.lexical.info && _.state.cc[_.state.cc.length - 1] == j && _.state.cc.pop()(), C(P("form"), U, F, j, Te)) : "function" == e ? C(Ae) : "for" == e ? C(P("form"), Me, F, j) : "class" == e || u && "interface" == t ? (_.marked = "keyword", C(P("form", "class" == e ? e : t), Ie, j)) : "variable" == e ? u && "declare" == t ? (_.marked = "keyword", C(F)) : u && ("module" == t || "enum" == t || "type" == t) && _.stream.match(/^\s*\w/, !1) ? (_.marked = "keyword", "enum" == t ? C(Ge) : "type" == t ? C(ze, q("operator"), pe, q(";")) : C(P("form"), ke, q("{"), P("}"), se, j, j)) : u && "namespace" == t ? (_.marked = "keyword", C(P("form"), W, F, j)) : u && "abstract" == t ? (_.marked = "keyword", C(F)) : C(P("stat"), ee) : "switch" == e ? C(P("form"), U, q("{"), P("}", "switch"), D, se, j, j, I) : "case" == e ? C(W, q(":")) : "default" == e ? C(q(":")) : "catch" == e ? C(P("form"), O, R, F, j, I) : "export" == e ? C(P("stat"), Fe, j) : "import" == e ? C(P("stat"), We, j) : "async" == e ? C(F) : "@" == t ? C(W, F) : S(P("stat"), W, q(";"), j);
            }
            function R(e) {
              if ("(" == e) return C(Oe, q(")"));
            }
            function W(e, t) {
              return H(e, t, !1);
            }
            function $(e, t) {
              return H(e, t, !0);
            }
            function U(e) {
              return "(" != e ? S() : C(P(")"), B, q(")"), j);
            }
            function H(e, t, r) {
              if (_.state.fatArrowAt == _.stream.start) {
                var n = r ? Y : X;
                if ("(" == e) return C(O, P(")"), oe(Oe, ")"), j, q("=>"), n, I);
                if ("variable" == e) return S(O, ke, q("=>"), n, I);
              }
              var i = r ? G : V;
              return x.hasOwnProperty(e) ? C(i) : "function" == e ? C(Ae, i) : "class" == e || u && "interface" == t ? (_.marked = "keyword", C(P("form"), De, j)) : "keyword c" == e || "async" == e ? C(r ? $ : W) : "(" == e ? C(P(")"), B, q(")"), j, i) : "operator" == e || "spread" == e ? C(r ? $ : W) : "[" == e ? C(P("]"), Ve, j, i) : "{" == e ? ae(re, "}", null, i) : "quasi" == e ? S(K, i) : "new" == e ? C(function (e) {
                return function (t) {
                  return "." == t ? C(e ? J : Q) : "variable" == t && u ? C(ye, e ? G : V) : S(e ? $ : W);
                };
              }(r)) : "import" == e ? C(W) : C();
            }
            function B(e) {
              return e.match(/[;\}\)\],]/) ? S() : S(W);
            }
            function V(e, t) {
              return "," == e ? C(B) : G(e, t, !1);
            }
            function G(e, t, r) {
              var n = 0 == r ? V : G,
                i = 0 == r ? W : $;
              return "=>" == e ? C(O, r ? Y : X, I) : "operator" == e ? /\+\+|--/.test(t) || u && "!" == t ? C(n) : u && "<" == t && _.stream.match(/^([^<>]|<[^<>]*>)*>\s*\(/, !1) ? C(P(">"), oe(pe, ">"), j, n) : "?" == t ? C(W, q(":"), i) : C(i) : "quasi" == e ? S(K, n) : ";" != e ? "(" == e ? ae($, ")", "call", n) : "." == e ? C(te, n) : "[" == e ? C(P("]"), B, q("]"), j, n) : u && "as" == t ? (_.marked = "keyword", C(pe, n)) : "regexp" == e ? (_.state.lastType = _.marked = "operator", _.stream.backUp(_.stream.pos - _.stream.start - 1), C(i)) : void 0 : void 0;
            }
            function K(e, t) {
              return "quasi" != e ? S() : "${" != t.slice(t.length - 2) ? C(K) : C(W, Z);
            }
            function Z(e) {
              if ("}" == e) return _.marked = "string-2", _.state.tokenize = v, C(K);
            }
            function X(e) {
              return b(_.stream, _.state), S("{" == e ? F : W);
            }
            function Y(e) {
              return b(_.stream, _.state), S("{" == e ? F : $);
            }
            function Q(e, t) {
              if ("target" == t) return _.marked = "keyword", C(V);
            }
            function J(e, t) {
              if ("target" == t) return _.marked = "keyword", C(G);
            }
            function ee(e) {
              return ":" == e ? C(j, F) : S(V, q(";"), j);
            }
            function te(e) {
              if ("variable" == e) return _.marked = "property", C();
            }
            function re(e, t) {
              return "async" == e ? (_.marked = "property", C(re)) : "variable" == e || "keyword" == _.style ? (_.marked = "property", "get" == t || "set" == t ? C(ne) : (u && _.state.fatArrowAt == _.stream.start && (r = _.stream.match(/^\s*:\s*/, !1)) && (_.state.fatArrowAt = _.stream.pos + r[0].length), C(ie))) : "number" == e || "string" == e ? (_.marked = l ? "property" : _.style + " property", C(ie)) : "jsonld-keyword" == e ? C(ie) : u && L(t) ? (_.marked = "keyword", C(re)) : "[" == e ? C(W, le, q("]"), ie) : "spread" == e ? C($, ie) : "*" == t ? (_.marked = "keyword", C(re)) : ":" == e ? S(ie) : void 0;
              var r;
            }
            function ne(e) {
              return "variable" != e ? S(ie) : (_.marked = "property", C(Ae));
            }
            function ie(e) {
              return ":" == e ? C($) : "(" == e ? S(Ae) : void 0;
            }
            function oe(e, t, r) {
              function n(i, o) {
                if (r ? r.indexOf(i) > -1 : "," == i) {
                  var a = _.state.lexical;
                  return "call" == a.info && (a.pos = (a.pos || 0) + 1), C(function (r, n) {
                    return r == t || n == t ? S() : S(e);
                  }, n);
                }
                return i == t || o == t ? C() : r && r.indexOf(";") > -1 ? S(e) : C(q(t));
              }
              return function (r, i) {
                return r == t || i == t ? C() : S(e, n);
              };
            }
            function ae(e, t, r) {
              for (var n = 3; n < arguments.length; n++) {
                _.cc.push(arguments[n]);
              }
              return C(P(t, r), oe(e, t), j);
            }
            function se(e) {
              return "}" == e ? C() : S(F, se);
            }
            function le(e, t) {
              if (u) {
                if (":" == e) return C(pe);
                if ("?" == t) return C(le);
              }
            }
            function ce(e, t) {
              if (u && (":" == e || "in" == t)) return C(pe);
            }
            function ue(e) {
              if (u && ":" == e) return _.stream.match(/^\s*\w+\s+is\b/, !1) ? C(W, de, pe) : C(pe);
            }
            function de(e, t) {
              if ("is" == t) return _.marked = "keyword", C();
            }
            function pe(e, t) {
              return "keyof" == t || "typeof" == t || "infer" == t ? (_.marked = "keyword", C("typeof" == t ? $ : pe)) : "variable" == e || "void" == t ? (_.marked = "type", C(ge)) : "|" == t || "&" == t ? C(pe) : "string" == e || "number" == e || "atom" == e ? C(ge) : "[" == e ? C(P("]"), oe(pe, "]", ","), j, ge) : "{" == e ? C(P("}"), oe(me, "}", ",;"), j, ge) : "(" == e ? C(oe(he, ")"), fe, ge) : "<" == e ? C(oe(pe, ">"), pe) : void 0;
            }
            function fe(e) {
              if ("=>" == e) return C(pe);
            }
            function me(e, t) {
              return "variable" == e || "keyword" == _.style ? (_.marked = "property", C(me)) : "?" == t || "number" == e || "string" == e ? C(me) : ":" == e ? C(pe) : "[" == e ? C(q("variable"), ce, q("]"), me) : "(" == e ? S(Ne, me) : void 0;
            }
            function he(e, t) {
              return "variable" == e && _.stream.match(/^\s*[?:]/, !1) || "?" == t ? C(he) : ":" == e ? C(pe) : "spread" == e ? C(he) : S(pe);
            }
            function ge(e, t) {
              return "<" == t ? C(P(">"), oe(pe, ">"), j, ge) : "|" == t || "." == e || "&" == t ? C(pe) : "[" == e ? C(pe, q("]"), ge) : "extends" == t || "implements" == t ? (_.marked = "keyword", C(pe)) : "?" == t ? C(pe, q(":"), pe) : void 0;
            }
            function ye(e, t) {
              if ("<" == t) return C(P(">"), oe(pe, ">"), j, ge);
            }
            function ve() {
              return S(pe, be);
            }
            function be(e, t) {
              if ("=" == t) return C(pe);
            }
            function xe(e, t) {
              return "enum" == t ? (_.marked = "keyword", C(Ge)) : S(ke, le, Se, Ce);
            }
            function ke(e, t) {
              return u && L(t) ? (_.marked = "keyword", C(ke)) : "variable" == e ? (M(t), C()) : "spread" == e ? C(ke) : "[" == e ? ae(_e, "]") : "{" == e ? ae(we, "}") : void 0;
            }
            function we(e, t) {
              return "variable" != e || _.stream.match(/^\s*:/, !1) ? ("variable" == e && (_.marked = "property"), "spread" == e ? C(ke) : "}" == e ? S() : "[" == e ? C(W, q("]"), q(":"), we) : C(q(":"), ke, Se)) : (M(t), C(Se));
            }
            function _e() {
              return S(ke, Se);
            }
            function Se(e, t) {
              if ("=" == t) return C($);
            }
            function Ce(e) {
              if ("," == e) return C(xe);
            }
            function Te(e, t) {
              if ("keyword b" == e && "else" == t) return C(P("form", "else"), F, j);
            }
            function Me(e, t) {
              return "await" == t ? C(Me) : "(" == e ? C(P(")"), Ee, j) : void 0;
            }
            function Ee(e) {
              return "var" == e ? C(xe, Le) : "variable" == e ? C(Le) : S(Le);
            }
            function Le(e, t) {
              return ")" == e ? C() : ";" == e ? C(Le) : "in" == t || "of" == t ? (_.marked = "keyword", C(W, Le)) : S(W, Le);
            }
            function Ae(e, t) {
              return "*" == t ? (_.marked = "keyword", C(Ae)) : "variable" == e ? (M(t), C(Ae)) : "(" == e ? C(O, P(")"), oe(Oe, ")"), j, ue, F, I) : u && "<" == t ? C(P(">"), oe(ve, ">"), j, Ae) : void 0;
            }
            function Ne(e, t) {
              return "*" == t ? (_.marked = "keyword", C(Ne)) : "variable" == e ? (M(t), C(Ne)) : "(" == e ? C(O, P(")"), oe(Oe, ")"), j, ue, I) : u && "<" == t ? C(P(">"), oe(ve, ">"), j, Ne) : void 0;
            }
            function ze(e, t) {
              return "keyword" == e || "variable" == e ? (_.marked = "type", C(ze)) : "<" == t ? C(P(">"), oe(ve, ">"), j) : void 0;
            }
            function Oe(e, t) {
              return "@" == t && C(W, Oe), "spread" == e ? C(Oe) : u && L(t) ? (_.marked = "keyword", C(Oe)) : u && "this" == e ? C(le, Se) : S(ke, le, Se);
            }
            function De(e, t) {
              return "variable" == e ? Ie(e, t) : Pe(e, t);
            }
            function Ie(e, t) {
              if ("variable" == e) return M(t), C(Pe);
            }
            function Pe(e, t) {
              return "<" == t ? C(P(">"), oe(ve, ">"), j, Pe) : "extends" == t || "implements" == t || u && "," == e ? ("implements" == t && (_.marked = "keyword"), C(u ? pe : W, Pe)) : "{" == e ? C(P("}"), je, j) : void 0;
            }
            function je(e, t) {
              return "async" == e || "variable" == e && ("static" == t || "get" == t || "set" == t || u && L(t)) && _.stream.match(/^\s+[\w$\xa1-\uffff]/, !1) ? (_.marked = "keyword", C(je)) : "variable" == e || "keyword" == _.style ? (_.marked = "property", C(qe, je)) : "number" == e || "string" == e ? C(qe, je) : "[" == e ? C(W, le, q("]"), qe, je) : "*" == t ? (_.marked = "keyword", C(je)) : u && "(" == e ? S(Ne, je) : ";" == e || "," == e ? C(je) : "}" == e ? C() : "@" == t ? C(W, je) : void 0;
            }
            function qe(e, t) {
              if ("?" == t) return C(qe);
              if (":" == e) return C(pe, Se);
              if ("=" == t) return C($);
              var r = _.state.lexical.prev;
              return S(r && "interface" == r.info ? Ne : Ae);
            }
            function Fe(e, t) {
              return "*" == t ? (_.marked = "keyword", C(Be, q(";"))) : "default" == t ? (_.marked = "keyword", C(W, q(";"))) : "{" == e ? C(oe(Re, "}"), Be, q(";")) : S(F);
            }
            function Re(e, t) {
              return "as" == t ? (_.marked = "keyword", C(q("variable"))) : "variable" == e ? S($, Re) : void 0;
            }
            function We(e) {
              return "string" == e ? C() : "(" == e ? S(W) : S($e, Ue, Be);
            }
            function $e(e, t) {
              return "{" == e ? ae($e, "}") : ("variable" == e && M(t), "*" == t && (_.marked = "keyword"), C(He));
            }
            function Ue(e) {
              if ("," == e) return C($e, Ue);
            }
            function He(e, t) {
              if ("as" == t) return _.marked = "keyword", C($e);
            }
            function Be(e, t) {
              if ("from" == t) return _.marked = "keyword", C(W);
            }
            function Ve(e) {
              return "]" == e ? C() : S(oe($, "]"));
            }
            function Ge() {
              return S(P("form"), ke, q("{"), P("}"), oe(Ke, "}"), j, j);
            }
            function Ke() {
              return S(ke, Se);
            }
            function Ze(e, t, r) {
              return t.tokenize == g && /^(?:operator|sof|keyword [bcd]|case|new|export|default|spread|[\[{}\(,;:]|=>)$/.test(t.lastType) || "quasi" == t.lastType && /\{\s*$/.test(e.string.slice(0, e.pos - (r || 0)));
            }
            return I.lex = !0, j.lex = !0, {
              startState: function startState(e) {
                var t = {
                  tokenize: g,
                  lastType: "sof",
                  cc: [],
                  lexical: new k((e || 0) - o, 0, "block", !1),
                  localVars: r.localVars,
                  context: r.localVars && new A(null, null, !1),
                  indented: e || 0
                };
                return r.globalVars && "object" == s(r.globalVars) && (t.globalVars = r.globalVars), t;
              },
              token: function token(e, t) {
                if (e.sol() && (t.lexical.hasOwnProperty("align") || (t.lexical.align = !1), t.indented = e.indentation(), b(e, t)), t.tokenize != y && e.eatSpace()) return null;
                var r = t.tokenize(e, t);
                return "comment" == n ? r : (t.lastType = "operator" != n || "++" != i && "--" != i ? n : "incdec", function (e, t, r, n, i) {
                  var o = e.cc;
                  for (_.state = e, _.stream = i, _.marked = null, _.cc = o, _.style = t, e.lexical.hasOwnProperty("align") || (e.lexical.align = !0);;) {
                    if ((o.length ? o.pop() : c ? W : F)(r, n)) {
                      for (; o.length && o[o.length - 1].lex;) {
                        o.pop()();
                      }
                      return _.marked ? _.marked : "variable" == r && w(e, n) ? "variable-2" : t;
                    }
                  }
                }(t, r, n, i, e));
              },
              indent: function indent(t, n) {
                if (t.tokenize == y) return e.Pass;
                if (t.tokenize != g) return 0;
                var i,
                  s = n && n.charAt(0),
                  l = t.lexical;
                if (!/^\s*else\b/.test(n)) for (var c = t.cc.length - 1; c >= 0; --c) {
                  var u = t.cc[c];
                  if (u == j) l = l.prev;else if (u != Te) break;
                }
                for (; ("stat" == l.type || "form" == l.type) && ("}" == s || (i = t.cc[t.cc.length - 1]) && (i == V || i == G) && !/^[,\.=+\-*:?[\(]/.test(n));) {
                  l = l.prev;
                }
                a && ")" == l.type && "stat" == l.prev.type && (l = l.prev);
                var d = l.type,
                  p = s == d;
                return "vardef" == d ? l.indented + ("operator" == t.lastType || "," == t.lastType ? l.info.length + 1 : 0) : "form" == d && "{" == s ? l.indented : "form" == d ? l.indented + o : "stat" == d ? l.indented + (function (e, t) {
                  return "operator" == e.lastType || "," == e.lastType || f.test(t.charAt(0)) || /[,.]/.test(t.charAt(0));
                }(t, n) ? a || o : 0) : "switch" != l.info || p || 0 == r.doubleIndentSwitch ? l.align ? l.column + (p ? 0 : 1) : l.indented + (p ? 0 : o) : l.indented + (/^(?:case|default)\b/.test(n) ? o : 2 * o);
              },
              electricInput: /^\s*(?:case .*?:|default:|\{|\})$/,
              blockCommentStart: c ? null : "/*",
              blockCommentEnd: c ? null : "*/",
              blockCommentContinue: c ? null : " * ",
              lineComment: c ? null : "//",
              fold: "brace",
              closeBrackets: "()[]{}''\"\"``",
              helperType: c ? "json" : "javascript",
              jsonldMode: l,
              jsonMode: c,
              expressionAllowed: Ze,
              skipExpression: function skipExpression(e) {
                var t = e.cc[e.cc.length - 1];
                t != W && t != $ || e.cc.pop();
              }
            };
          }), e.registerHelper("wordChars", "javascript", /[\w$]/), e.defineMIME("text/javascript", "javascript"), e.defineMIME("text/ecmascript", "javascript"), e.defineMIME("application/javascript", "javascript"), e.defineMIME("application/x-javascript", "javascript"), e.defineMIME("application/ecmascript", "javascript"), e.defineMIME("application/json", {
            name: "javascript",
            json: !0
          }), e.defineMIME("application/x-json", {
            name: "javascript",
            json: !0
          }), e.defineMIME("application/ld+json", {
            name: "javascript",
            jsonld: !0
          }), e.defineMIME("text/typescript", {
            name: "javascript",
            typescript: !0
          }), e.defineMIME("application/typescript", {
            name: "javascript",
            typescript: !0
          });
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      2375: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          function t(e, t, r, n) {
            this.state = e, this.mode = t, this.depth = r, this.prev = n;
          }
          function r(n) {
            return new t(e.copyState(n.mode, n.state), n.mode, n.depth, n.prev && r(n.prev));
          }
          e.defineMode("jsx", function (n, i) {
            var o = e.getMode(n, {
                name: "xml",
                allowMissing: !0,
                multilineTagIndentPastTag: !1,
                allowMissingTagName: !0
              }),
              a = e.getMode(n, i && i.base || "javascript");
            function s(e) {
              var t = e.tagName;
              e.tagName = null;
              var r = o.indent(e, "", "");
              return e.tagName = t, r;
            }
            function l(r, i) {
              return i.context.mode == o ? function (r, i, c) {
                if (2 == c.depth) return r.match(/^.*?\*\//) ? c.depth = 1 : r.skipToEnd(), "comment";
                if ("{" == r.peek()) {
                  o.skipAttribute(c.state);
                  var u = s(c.state),
                    d = c.state.context;
                  if (d && r.match(/^[^>]*>\s*$/, !1)) {
                    for (; d.prev && !d.startOfLine;) {
                      d = d.prev;
                    }
                    d.startOfLine ? u -= n.indentUnit : c.prev.state.lexical && (u = c.prev.state.lexical.indented);
                  } else 1 == c.depth && (u += n.indentUnit);
                  return i.context = new t(e.startState(a, u), a, 0, i.context), null;
                }
                if (1 == c.depth) {
                  if ("<" == r.peek()) return o.skipAttribute(c.state), i.context = new t(e.startState(o, s(c.state)), o, 0, i.context), null;
                  if (r.match("//")) return r.skipToEnd(), "comment";
                  if (r.match("/*")) return c.depth = 2, l(r, i);
                }
                var p,
                  f = o.token(r, c.state),
                  m = r.current();
                return /\btag\b/.test(f) ? />$/.test(m) ? c.state.context ? c.depth = 0 : i.context = i.context.prev : /^</.test(m) && (c.depth = 1) : !f && (p = m.indexOf("{")) > -1 && r.backUp(m.length - p), f;
              }(r, i, i.context) : function (r, n, i) {
                if ("<" == r.peek() && a.expressionAllowed(r, i.state)) return a.skipExpression(i.state), n.context = new t(e.startState(o, a.indent(i.state, "", "")), o, 0, n.context), null;
                var s = a.token(r, i.state);
                if (!s && null != i.depth) {
                  var l = r.current();
                  "{" == l ? i.depth++ : "}" == l && 0 == --i.depth && (n.context = n.context.prev);
                }
                return s;
              }(r, i, i.context);
            }
            return {
              startState: function startState() {
                return {
                  context: new t(e.startState(a), a)
                };
              },
              copyState: function copyState(e) {
                return {
                  context: r(e.context)
                };
              },
              token: l,
              indent: function indent(e, t, r) {
                return e.context.mode.indent(e.context.state, t, r);
              },
              innerMode: function innerMode(e) {
                return e.context;
              }
            };
          }, "xml", "javascript"), e.defineMIME("text/jsx", "jsx"), e.defineMIME("text/typescript-jsx", {
            name: "jsx",
            base: {
              name: "javascript",
              typescript: !0
            }
          });
        }, "object" == s(t) && "object" == s(e) ? a(r(9074), r(336), r(9965)) : (i = [r(9074), r(336), r(9965)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      2557: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMode("julia", function (t, r) {
            function n(e, t) {
              return void 0 === t && (t = "\\b"), new RegExp("^((" + e.join(")|(") + "))" + t);
            }
            var i = r.operators || n(["[<>]:", "[<>=]=", "<<=?", ">>>?=?", "=>", "->", "\\/\\/", "[\\\\%*+\\-<>!=\\/^|&\\u00F7\\u22BB]=?", "\\?", "\\$", "~", ":", "\\u00D7", "\\u2208", "\\u2209", "\\u220B", "\\u220C", "\\u2218", "\\u221A", "\\u221B", "\\u2229", "\\u222A", "\\u2260", "\\u2264", "\\u2265", "\\u2286", "\\u2288", "\\u228A", "\\u22C5", "\\b(in|isa)\\b(?!.?\\()"], ""),
              o = r.delimiters || /^[;,()[\]{}]/,
              a = r.identifiers || /^[_A-Za-z\u00A1-\u2217\u2219-\uFFFF][\w\u00A1-\u2217\u2219-\uFFFF]*!*/,
              s = n(["\\\\[0-7]{1,3}", "\\\\x[A-Fa-f0-9]{1,2}", "\\\\[abefnrtv0%?'\"\\\\]", "([^\\u0027\\u005C\\uD800-\\uDFFF]|[\\uD800-\\uDFFF][\\uDC00-\\uDFFF])"], "'"),
              l = ["if", "else", "elseif", "while", "for", "begin", "let", "end", "do", "try", "catch", "finally", "return", "break", "continue", "global", "local", "const", "export", "import", "importall", "using", "function", "where", "macro", "module", "baremodule", "struct", "type", "mutable", "immutable", "quote", "typealias", "abstract", "primitive", "bitstype"],
              c = ["true", "false", "nothing", "NaN", "Inf"];
            e.registerHelper("hintWords", "julia", l.concat(c));
            var u = n(["begin", "function", "type", "struct", "immutable", "let", "macro", "for", "while", "quote", "if", "else", "elseif", "try", "finally", "catch", "do"]),
              d = n(["end", "else", "elseif", "catch", "finally"]),
              p = n(l),
              f = n(c),
              m = /^@[_A-Za-z][\w]*/,
              h = /^:[_A-Za-z\u00A1-\uFFFF][\w\u00A1-\uFFFF]*!*/,
              g = /^(`|([_A-Za-z\u00A1-\uFFFF]*"("")?))/;
            function y(e) {
              return e.nestedArrays > 0;
            }
            function v(e, t) {
              return void 0 === t && (t = 0), e.scopes.length <= t ? null : e.scopes[e.scopes.length - (t + 1)];
            }
            function b(e, t) {
              if (e.match(/^#=/, !1)) return t.tokenize = w, t.tokenize(e, t);
              var r = t.leavingExpr;
              if (e.sol() && (r = !1), t.leavingExpr = !1, r && e.match(/^'+/)) return "operator";
              if (e.match(/\.{4,}/)) return "error";
              if (e.match(/\.{1,3}/)) return "operator";
              if (e.eatSpace()) return null;
              var n,
                s = e.peek();
              if ("#" === s) return e.skipToEnd(), "comment";
              if ("[" === s && (t.scopes.push("["), t.nestedArrays++), "(" === s && (t.scopes.push("("), t.nestedGenerators++), y(t) && "]" === s) {
                for (; t.scopes.length && "[" !== v(t);) {
                  t.scopes.pop();
                }
                t.scopes.pop(), t.nestedArrays--, t.leavingExpr = !0;
              }
              if (function (e) {
                return e.nestedGenerators > 0;
              }(t) && ")" === s) {
                for (; t.scopes.length && "(" !== v(t);) {
                  t.scopes.pop();
                }
                t.scopes.pop(), t.nestedGenerators--, t.leavingExpr = !0;
              }
              if (y(t)) {
                if ("end" == t.lastToken && e.match(/^:/)) return "operator";
                if (e.match(/^end/)) return "number";
              }
              if ((n = e.match(u, !1)) && t.scopes.push(n[0]), e.match(d, !1) && t.scopes.pop(), e.match(/^::(?![:\$])/)) return t.tokenize = k, t.tokenize(e, t);
              if (!r && e.match(h) || e.match(/:([<>]:|<<=?|>>>?=?|->|\/\/|\.{2,3}|[\.\\%*+\-<>!\/^|&]=?|[~\?\$])/)) return "builtin";
              if (e.match(i)) return "operator";
              if (e.match(/^\.?\d/, !1)) {
                var l = RegExp(/^im\b/),
                  c = !1;
                if (e.match(/^0x\.[0-9a-f_]+p[\+\-]?[_\d]+/i) && (c = !0), e.match(/^0x[0-9a-f_]+/i) && (c = !0), e.match(/^0b[01_]+/i) && (c = !0), e.match(/^0o[0-7_]+/i) && (c = !0), e.match(/^(?:(?:\d[_\d]*)?\.(?!\.)(?:\d[_\d]*)?|\d[_\d]*\.(?!\.)(?:\d[_\d]*))?([Eef][\+\-]?[_\d]+)?/i) && (c = !0), e.match(/^\d[_\d]*(e[\+\-]?\d+)?/i) && (c = !0), c) return e.match(l), t.leavingExpr = !0, "number";
              }
              if (e.match(/^'/)) return t.tokenize = _, t.tokenize(e, t);
              if (e.match(g)) return t.tokenize = function (e) {
                function t(t, r) {
                  if (t.eat("\\")) t.next();else {
                    if (t.match(e)) return r.tokenize = b, r.leavingExpr = !0, "string";
                    t.eat(/[`"]/);
                  }
                  return t.eatWhile(/[^\\`"]/), "string";
                }
                return '"""' === e.substr(-3) ? e = '"""' : '"' === e.substr(-1) && (e = '"'), t;
              }(e.current()), t.tokenize(e, t);
              if (e.match(m)) return "meta";
              if (e.match(o)) return null;
              if (e.match(p)) return "keyword";
              if (e.match(f)) return "builtin";
              var S = t.isDefinition || "function" == t.lastToken || "macro" == t.lastToken || "type" == t.lastToken || "struct" == t.lastToken || "immutable" == t.lastToken;
              return e.match(a) ? S ? "." === e.peek() ? (t.isDefinition = !0, "variable") : (t.isDefinition = !1, "def") : e.match(/^({[^}]*})*\(/, !1) ? (t.tokenize = x, t.tokenize(e, t)) : (t.leavingExpr = !0, "variable") : (e.next(), "error");
            }
            function x(e, t) {
              var r = e.match(/^(\(\s*)/);
              if (r && (t.firstParenPos < 0 && (t.firstParenPos = t.scopes.length), t.scopes.push("("), t.charsAdvanced += r[1].length), "(" == v(t) && e.match(/^\)/) && (t.scopes.pop(), t.charsAdvanced += 1, t.scopes.length <= t.firstParenPos)) {
                var n = e.match(/^(\s*where\s+[^\s=]+)*\s*?=(?!=)/, !1);
                return e.backUp(t.charsAdvanced), t.firstParenPos = -1, t.charsAdvanced = 0, t.tokenize = b, n ? "def" : "builtin";
              }
              if (e.match(/^$/g, !1)) {
                for (e.backUp(t.charsAdvanced); t.scopes.length > t.firstParenPos;) {
                  t.scopes.pop();
                }
                return t.firstParenPos = -1, t.charsAdvanced = 0, t.tokenize = b, "builtin";
              }
              return t.charsAdvanced += e.match(/^([^()]*)/)[1].length, t.tokenize(e, t);
            }
            function k(e, t) {
              return e.match(/.*?(?=,|;|{|}|\(|\)|=|$|\s)/), e.match(/^{/) ? t.nestedParameters++ : e.match(/^}/) && t.nestedParameters > 0 && t.nestedParameters--, t.nestedParameters > 0 ? e.match(/.*?(?={|})/) || e.next() : 0 == t.nestedParameters && (t.tokenize = b), "builtin";
            }
            function w(e, t) {
              return e.match(/^#=/) && t.nestedComments++, e.match(/.*?(?=(#=|=#))/) || e.skipToEnd(), e.match(/^=#/) && (t.nestedComments--, 0 == t.nestedComments && (t.tokenize = b)), "comment";
            }
            function _(e, t) {
              var r,
                n = !1;
              if (e.match(s)) n = !0;else if (r = e.match(/\\u([a-f0-9]{1,4})(?=')/i)) ((i = parseInt(r[1], 16)) <= 55295 || i >= 57344) && (n = !0, e.next());else if (r = e.match(/\\U([A-Fa-f0-9]{5,8})(?=')/)) {
                var i;
                (i = parseInt(r[1], 16)) <= 1114111 && (n = !0, e.next());
              }
              return n ? (t.leavingExpr = !0, t.tokenize = b, "string") : (e.match(/^[^']+(?=')/) || e.skipToEnd(), e.match(/^'/) && (t.tokenize = b), "error");
            }
            return {
              startState: function startState() {
                return {
                  tokenize: b,
                  scopes: [],
                  lastToken: null,
                  leavingExpr: !1,
                  isDefinition: !1,
                  nestedArrays: 0,
                  nestedComments: 0,
                  nestedGenerators: 0,
                  nestedParameters: 0,
                  charsAdvanced: 0,
                  firstParenPos: -1
                };
              },
              token: function token(e, t) {
                var r = t.tokenize(e, t),
                  n = e.current();
                return n && r && (t.lastToken = n), r;
              },
              indent: function indent(e, r) {
                var n = 0;
                return "]" !== r && ")" !== r && "end" !== r && "else" !== r && "catch" !== r && "elseif" !== r && "finally" !== r || (n = -1), (e.scopes.length + n) * t.indentUnit;
              },
              electricInput: /\b(end|else|catch|finally)\b/,
              blockCommentStart: "#=",
              blockCommentEnd: "=#",
              lineComment: "#",
              closeBrackets: '()[]{}""',
              fold: "indent"
            };
          }), e.defineMIME("text/x-julia", "julia");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      4581: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMode("lua", function (e, t) {
            var r = e.indentUnit;
            function n(e) {
              return new RegExp("^(?:" + e.join("|") + ")$", "i");
            }
            var i = n(t.specials || []),
              o = n(["_G", "_VERSION", "assert", "collectgarbage", "dofile", "error", "getfenv", "getmetatable", "ipairs", "load", "loadfile", "loadstring", "module", "next", "pairs", "pcall", "print", "rawequal", "rawget", "rawset", "require", "select", "setfenv", "setmetatable", "tonumber", "tostring", "type", "unpack", "xpcall", "coroutine.create", "coroutine.resume", "coroutine.running", "coroutine.status", "coroutine.wrap", "coroutine.yield", "debug.debug", "debug.getfenv", "debug.gethook", "debug.getinfo", "debug.getlocal", "debug.getmetatable", "debug.getregistry", "debug.getupvalue", "debug.setfenv", "debug.sethook", "debug.setlocal", "debug.setmetatable", "debug.setupvalue", "debug.traceback", "close", "flush", "lines", "read", "seek", "setvbuf", "write", "io.close", "io.flush", "io.input", "io.lines", "io.open", "io.output", "io.popen", "io.read", "io.stderr", "io.stdin", "io.stdout", "io.tmpfile", "io.type", "io.write", "math.abs", "math.acos", "math.asin", "math.atan", "math.atan2", "math.ceil", "math.cos", "math.cosh", "math.deg", "math.exp", "math.floor", "math.fmod", "math.frexp", "math.huge", "math.ldexp", "math.log", "math.log10", "math.max", "math.min", "math.modf", "math.pi", "math.pow", "math.rad", "math.random", "math.randomseed", "math.sin", "math.sinh", "math.sqrt", "math.tan", "math.tanh", "os.clock", "os.date", "os.difftime", "os.execute", "os.exit", "os.getenv", "os.remove", "os.rename", "os.setlocale", "os.time", "os.tmpname", "package.cpath", "package.loaded", "package.loaders", "package.loadlib", "package.path", "package.preload", "package.seeall", "string.byte", "string.char", "string.dump", "string.find", "string.format", "string.gmatch", "string.gsub", "string.len", "string.lower", "string.match", "string.rep", "string.reverse", "string.sub", "string.upper", "table.concat", "table.insert", "table.maxn", "table.remove", "table.sort"]),
              a = n(["and", "break", "elseif", "false", "nil", "not", "or", "return", "true", "function", "end", "if", "then", "else", "do", "while", "repeat", "until", "for", "in", "local"]),
              s = n(["function", "if", "repeat", "do", "\\(", "{"]),
              l = n(["end", "until", "\\)", "}"]),
              c = new RegExp("^(?:" + ["end", "until", "\\)", "}", "else", "elseif"].join("|") + ")", "i");
            function u(e) {
              for (var t = 0; e.eat("=");) {
                ++t;
              }
              return e.eat("["), t;
            }
            function d(e, t) {
              var r,
                n = e.next();
              return "-" == n && e.eat("-") ? e.eat("[") && e.eat("[") ? (t.cur = p(u(e), "comment"))(e, t) : (e.skipToEnd(), "comment") : '"' == n || "'" == n ? (t.cur = (r = n, function (e, t) {
                for (var n, i = !1; null != (n = e.next()) && (n != r || i);) {
                  i = !i && "\\" == n;
                }
                return i || (t.cur = d), "string";
              }))(e, t) : "[" == n && /[\[=]/.test(e.peek()) ? (t.cur = p(u(e), "string"))(e, t) : /\d/.test(n) ? (e.eatWhile(/[\w.%]/), "number") : /[\w_]/.test(n) ? (e.eatWhile(/[\w\\\-_.]/), "variable") : null;
            }
            function p(e, t) {
              return function (r, n) {
                for (var i, o = null; null != (i = r.next());) {
                  if (null == o) "]" == i && (o = 0);else if ("=" == i) ++o;else {
                    if ("]" == i && o == e) {
                      n.cur = d;
                      break;
                    }
                    o = null;
                  }
                }
                return t;
              };
            }
            return {
              startState: function startState(e) {
                return {
                  basecol: e || 0,
                  indentDepth: 0,
                  cur: d
                };
              },
              token: function token(e, t) {
                if (e.eatSpace()) return null;
                var r = t.cur(e, t),
                  n = e.current();
                return "variable" == r && (a.test(n) ? r = "keyword" : o.test(n) ? r = "builtin" : i.test(n) && (r = "variable-2")), "comment" != r && "string" != r && (s.test(n) ? ++t.indentDepth : l.test(n) && --t.indentDepth), r;
              },
              indent: function indent(e, t) {
                var n = c.test(t);
                return e.basecol + r * (e.indentDepth - (n ? 1 : 0));
              },
              lineComment: "--",
              blockCommentStart: "--[[",
              blockCommentEnd: "]]"
            };
          }), e.defineMIME("text/x-lua", "lua");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      318: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.modeInfo = [{
            name: "APL",
            mime: "text/apl",
            mode: "apl",
            ext: ["dyalog", "apl"]
          }, {
            name: "PGP",
            mimes: ["application/pgp", "application/pgp-encrypted", "application/pgp-keys", "application/pgp-signature"],
            mode: "asciiarmor",
            ext: ["asc", "pgp", "sig"]
          }, {
            name: "ASN.1",
            mime: "text/x-ttcn-asn",
            mode: "asn.1",
            ext: ["asn", "asn1"]
          }, {
            name: "Asterisk",
            mime: "text/x-asterisk",
            mode: "asterisk",
            file: /^extensions\.conf$/i
          }, {
            name: "Brainfuck",
            mime: "text/x-brainfuck",
            mode: "brainfuck",
            ext: ["b", "bf"]
          }, {
            name: "C",
            mime: "text/x-csrc",
            mode: "clike",
            ext: ["c", "h", "ino"]
          }, {
            name: "C++",
            mime: "text/x-c++src",
            mode: "clike",
            ext: ["cpp", "c++", "cc", "cxx", "hpp", "h++", "hh", "hxx"],
            alias: ["cpp"]
          }, {
            name: "Cobol",
            mime: "text/x-cobol",
            mode: "cobol",
            ext: ["cob", "cpy"]
          }, {
            name: "C#",
            mime: "text/x-csharp",
            mode: "clike",
            ext: ["cs"],
            alias: ["csharp", "cs"]
          }, {
            name: "Clojure",
            mime: "text/x-clojure",
            mode: "clojure",
            ext: ["clj", "cljc", "cljx"]
          }, {
            name: "ClojureScript",
            mime: "text/x-clojurescript",
            mode: "clojure",
            ext: ["cljs"]
          }, {
            name: "Closure Stylesheets (GSS)",
            mime: "text/x-gss",
            mode: "css",
            ext: ["gss"]
          }, {
            name: "CMake",
            mime: "text/x-cmake",
            mode: "cmake",
            ext: ["cmake", "cmake.in"],
            file: /^CMakeLists.txt$/
          }, {
            name: "CoffeeScript",
            mimes: ["application/vnd.coffeescript", "text/coffeescript", "text/x-coffeescript"],
            mode: "coffeescript",
            ext: ["coffee"],
            alias: ["coffee", "coffee-script"]
          }, {
            name: "Common Lisp",
            mime: "text/x-common-lisp",
            mode: "commonlisp",
            ext: ["cl", "lisp", "el"],
            alias: ["lisp"]
          }, {
            name: "Cypher",
            mime: "application/x-cypher-query",
            mode: "cypher",
            ext: ["cyp", "cypher"]
          }, {
            name: "Cython",
            mime: "text/x-cython",
            mode: "python",
            ext: ["pyx", "pxd", "pxi"]
          }, {
            name: "Crystal",
            mime: "text/x-crystal",
            mode: "crystal",
            ext: ["cr"]
          }, {
            name: "CSS",
            mime: "text/css",
            mode: "css",
            ext: ["css"]
          }, {
            name: "CQL",
            mime: "text/x-cassandra",
            mode: "sql",
            ext: ["cql"]
          }, {
            name: "D",
            mime: "text/x-d",
            mode: "d",
            ext: ["d"]
          }, {
            name: "Dart",
            mimes: ["application/dart", "text/x-dart"],
            mode: "dart",
            ext: ["dart"]
          }, {
            name: "diff",
            mime: "text/x-diff",
            mode: "diff",
            ext: ["diff", "patch"]
          }, {
            name: "Django",
            mime: "text/x-django",
            mode: "django"
          }, {
            name: "Dockerfile",
            mime: "text/x-dockerfile",
            mode: "dockerfile",
            file: /^Dockerfile$/
          }, {
            name: "DTD",
            mime: "application/xml-dtd",
            mode: "dtd",
            ext: ["dtd"]
          }, {
            name: "Dylan",
            mime: "text/x-dylan",
            mode: "dylan",
            ext: ["dylan", "dyl", "intr"]
          }, {
            name: "EBNF",
            mime: "text/x-ebnf",
            mode: "ebnf"
          }, {
            name: "ECL",
            mime: "text/x-ecl",
            mode: "ecl",
            ext: ["ecl"]
          }, {
            name: "edn",
            mime: "application/edn",
            mode: "clojure",
            ext: ["edn"]
          }, {
            name: "Eiffel",
            mime: "text/x-eiffel",
            mode: "eiffel",
            ext: ["e"]
          }, {
            name: "Elm",
            mime: "text/x-elm",
            mode: "elm",
            ext: ["elm"]
          }, {
            name: "Embedded Javascript",
            mime: "application/x-ejs",
            mode: "htmlembedded",
            ext: ["ejs"]
          }, {
            name: "Embedded Ruby",
            mime: "application/x-erb",
            mode: "htmlembedded",
            ext: ["erb"]
          }, {
            name: "Erlang",
            mime: "text/x-erlang",
            mode: "erlang",
            ext: ["erl"]
          }, {
            name: "Esper",
            mime: "text/x-esper",
            mode: "sql"
          }, {
            name: "Factor",
            mime: "text/x-factor",
            mode: "factor",
            ext: ["factor"]
          }, {
            name: "FCL",
            mime: "text/x-fcl",
            mode: "fcl"
          }, {
            name: "Forth",
            mime: "text/x-forth",
            mode: "forth",
            ext: ["forth", "fth", "4th"]
          }, {
            name: "Fortran",
            mime: "text/x-fortran",
            mode: "fortran",
            ext: ["f", "for", "f77", "f90", "f95"]
          }, {
            name: "F#",
            mime: "text/x-fsharp",
            mode: "mllike",
            ext: ["fs"],
            alias: ["fsharp"]
          }, {
            name: "Gas",
            mime: "text/x-gas",
            mode: "gas",
            ext: ["s"]
          }, {
            name: "Gherkin",
            mime: "text/x-feature",
            mode: "gherkin",
            ext: ["feature"]
          }, {
            name: "GitHub Flavored Markdown",
            mime: "text/x-gfm",
            mode: "gfm",
            file: /^(readme|contributing|history).md$/i
          }, {
            name: "Go",
            mime: "text/x-go",
            mode: "go",
            ext: ["go"]
          }, {
            name: "Groovy",
            mime: "text/x-groovy",
            mode: "groovy",
            ext: ["groovy", "gradle"],
            file: /^Jenkinsfile$/
          }, {
            name: "HAML",
            mime: "text/x-haml",
            mode: "haml",
            ext: ["haml"]
          }, {
            name: "Haskell",
            mime: "text/x-haskell",
            mode: "haskell",
            ext: ["hs"]
          }, {
            name: "Haskell (Literate)",
            mime: "text/x-literate-haskell",
            mode: "haskell-literate",
            ext: ["lhs"]
          }, {
            name: "Haxe",
            mime: "text/x-haxe",
            mode: "haxe",
            ext: ["hx"]
          }, {
            name: "HXML",
            mime: "text/x-hxml",
            mode: "haxe",
            ext: ["hxml"]
          }, {
            name: "ASP.NET",
            mime: "application/x-aspx",
            mode: "htmlembedded",
            ext: ["aspx"],
            alias: ["asp", "aspx"]
          }, {
            name: "HTML",
            mime: "text/html",
            mode: "htmlmixed",
            ext: ["html", "htm", "handlebars", "hbs"],
            alias: ["xhtml"]
          }, {
            name: "HTTP",
            mime: "message/http",
            mode: "http"
          }, {
            name: "IDL",
            mime: "text/x-idl",
            mode: "idl",
            ext: ["pro"]
          }, {
            name: "Pug",
            mime: "text/x-pug",
            mode: "pug",
            ext: ["jade", "pug"],
            alias: ["jade"]
          }, {
            name: "Java",
            mime: "text/x-java",
            mode: "clike",
            ext: ["java"]
          }, {
            name: "Java Server Pages",
            mime: "application/x-jsp",
            mode: "htmlembedded",
            ext: ["jsp"],
            alias: ["jsp"]
          }, {
            name: "JavaScript",
            mimes: ["text/javascript", "text/ecmascript", "application/javascript", "application/x-javascript", "application/ecmascript"],
            mode: "javascript",
            ext: ["js"],
            alias: ["ecmascript", "js", "node"]
          }, {
            name: "JSON",
            mimes: ["application/json", "application/x-json"],
            mode: "javascript",
            ext: ["json", "map"],
            alias: ["json5"]
          }, {
            name: "JSON-LD",
            mime: "application/ld+json",
            mode: "javascript",
            ext: ["jsonld"],
            alias: ["jsonld"]
          }, {
            name: "JSX",
            mime: "text/jsx",
            mode: "jsx",
            ext: ["jsx"]
          }, {
            name: "Jinja2",
            mime: "text/jinja2",
            mode: "jinja2",
            ext: ["j2", "jinja", "jinja2"]
          }, {
            name: "Julia",
            mime: "text/x-julia",
            mode: "julia",
            ext: ["jl"]
          }, {
            name: "Kotlin",
            mime: "text/x-kotlin",
            mode: "clike",
            ext: ["kt"]
          }, {
            name: "LESS",
            mime: "text/x-less",
            mode: "css",
            ext: ["less"]
          }, {
            name: "LiveScript",
            mime: "text/x-livescript",
            mode: "livescript",
            ext: ["ls"],
            alias: ["ls"]
          }, {
            name: "Lua",
            mime: "text/x-lua",
            mode: "lua",
            ext: ["lua"]
          }, {
            name: "Markdown",
            mime: "text/x-markdown",
            mode: "markdown",
            ext: ["markdown", "md", "mkd"]
          }, {
            name: "mIRC",
            mime: "text/mirc",
            mode: "mirc"
          }, {
            name: "MariaDB SQL",
            mime: "text/x-mariadb",
            mode: "sql"
          }, {
            name: "Mathematica",
            mime: "text/x-mathematica",
            mode: "mathematica",
            ext: ["m", "nb", "wl", "wls"]
          }, {
            name: "Modelica",
            mime: "text/x-modelica",
            mode: "modelica",
            ext: ["mo"]
          }, {
            name: "MUMPS",
            mime: "text/x-mumps",
            mode: "mumps",
            ext: ["mps"]
          }, {
            name: "MS SQL",
            mime: "text/x-mssql",
            mode: "sql"
          }, {
            name: "mbox",
            mime: "application/mbox",
            mode: "mbox",
            ext: ["mbox"]
          }, {
            name: "MySQL",
            mime: "text/x-mysql",
            mode: "sql"
          }, {
            name: "Nginx",
            mime: "text/x-nginx-conf",
            mode: "nginx",
            file: /nginx.*\.conf$/i
          }, {
            name: "NSIS",
            mime: "text/x-nsis",
            mode: "nsis",
            ext: ["nsh", "nsi"]
          }, {
            name: "NTriples",
            mimes: ["application/n-triples", "application/n-quads", "text/n-triples"],
            mode: "ntriples",
            ext: ["nt", "nq"]
          }, {
            name: "Objective-C",
            mime: "text/x-objectivec",
            mode: "clike",
            ext: ["m"],
            alias: ["objective-c", "objc"]
          }, {
            name: "Objective-C++",
            mime: "text/x-objectivec++",
            mode: "clike",
            ext: ["mm"],
            alias: ["objective-c++", "objc++"]
          }, {
            name: "OCaml",
            mime: "text/x-ocaml",
            mode: "mllike",
            ext: ["ml", "mli", "mll", "mly"]
          }, {
            name: "Octave",
            mime: "text/x-octave",
            mode: "octave",
            ext: ["m"]
          }, {
            name: "Oz",
            mime: "text/x-oz",
            mode: "oz",
            ext: ["oz"]
          }, {
            name: "Pascal",
            mime: "text/x-pascal",
            mode: "pascal",
            ext: ["p", "pas"]
          }, {
            name: "PEG.js",
            mime: "null",
            mode: "pegjs",
            ext: ["jsonld"]
          }, {
            name: "Perl",
            mime: "text/x-perl",
            mode: "perl",
            ext: ["pl", "pm"]
          }, {
            name: "PHP",
            mimes: ["text/x-php", "application/x-httpd-php", "application/x-httpd-php-open"],
            mode: "php",
            ext: ["php", "php3", "php4", "php5", "php7", "phtml"]
          }, {
            name: "Pig",
            mime: "text/x-pig",
            mode: "pig",
            ext: ["pig"]
          }, {
            name: "Plain Text",
            mime: "text/plain",
            mode: "null",
            ext: ["txt", "text", "conf", "def", "list", "log"]
          }, {
            name: "PLSQL",
            mime: "text/x-plsql",
            mode: "sql",
            ext: ["pls"]
          }, {
            name: "PostgreSQL",
            mime: "text/x-pgsql",
            mode: "sql"
          }, {
            name: "PowerShell",
            mime: "application/x-powershell",
            mode: "powershell",
            ext: ["ps1", "psd1", "psm1"]
          }, {
            name: "Properties files",
            mime: "text/x-properties",
            mode: "properties",
            ext: ["properties", "ini", "in"],
            alias: ["ini", "properties"]
          }, {
            name: "ProtoBuf",
            mime: "text/x-protobuf",
            mode: "protobuf",
            ext: ["proto"]
          }, {
            name: "Python",
            mime: "text/x-python",
            mode: "python",
            ext: ["BUILD", "bzl", "py", "pyw"],
            file: /^(BUCK|BUILD)$/
          }, {
            name: "Puppet",
            mime: "text/x-puppet",
            mode: "puppet",
            ext: ["pp"]
          }, {
            name: "Q",
            mime: "text/x-q",
            mode: "q",
            ext: ["q"]
          }, {
            name: "R",
            mime: "text/x-rsrc",
            mode: "r",
            ext: ["r", "R"],
            alias: ["rscript"]
          }, {
            name: "reStructuredText",
            mime: "text/x-rst",
            mode: "rst",
            ext: ["rst"],
            alias: ["rst"]
          }, {
            name: "RPM Changes",
            mime: "text/x-rpm-changes",
            mode: "rpm"
          }, {
            name: "RPM Spec",
            mime: "text/x-rpm-spec",
            mode: "rpm",
            ext: ["spec"]
          }, {
            name: "Ruby",
            mime: "text/x-ruby",
            mode: "ruby",
            ext: ["rb"],
            alias: ["jruby", "macruby", "rake", "rb", "rbx"]
          }, {
            name: "Rust",
            mime: "text/x-rustsrc",
            mode: "rust",
            ext: ["rs"]
          }, {
            name: "SAS",
            mime: "text/x-sas",
            mode: "sas",
            ext: ["sas"]
          }, {
            name: "Sass",
            mime: "text/x-sass",
            mode: "sass",
            ext: ["sass"]
          }, {
            name: "Scala",
            mime: "text/x-scala",
            mode: "clike",
            ext: ["scala"]
          }, {
            name: "Scheme",
            mime: "text/x-scheme",
            mode: "scheme",
            ext: ["scm", "ss"]
          }, {
            name: "SCSS",
            mime: "text/x-scss",
            mode: "css",
            ext: ["scss"]
          }, {
            name: "Shell",
            mimes: ["text/x-sh", "application/x-sh"],
            mode: "shell",
            ext: ["sh", "ksh", "bash"],
            alias: ["bash", "sh", "zsh"],
            file: /^PKGBUILD$/
          }, {
            name: "Sieve",
            mime: "application/sieve",
            mode: "sieve",
            ext: ["siv", "sieve"]
          }, {
            name: "Slim",
            mimes: ["text/x-slim", "application/x-slim"],
            mode: "slim",
            ext: ["slim"]
          }, {
            name: "Smalltalk",
            mime: "text/x-stsrc",
            mode: "smalltalk",
            ext: ["st"]
          }, {
            name: "Smarty",
            mime: "text/x-smarty",
            mode: "smarty",
            ext: ["tpl"]
          }, {
            name: "Solr",
            mime: "text/x-solr",
            mode: "solr"
          }, {
            name: "SML",
            mime: "text/x-sml",
            mode: "mllike",
            ext: ["sml", "sig", "fun", "smackspec"]
          }, {
            name: "Soy",
            mime: "text/x-soy",
            mode: "soy",
            ext: ["soy"],
            alias: ["closure template"]
          }, {
            name: "SPARQL",
            mime: "application/sparql-query",
            mode: "sparql",
            ext: ["rq", "sparql"],
            alias: ["sparul"]
          }, {
            name: "Spreadsheet",
            mime: "text/x-spreadsheet",
            mode: "spreadsheet",
            alias: ["excel", "formula"]
          }, {
            name: "SQL",
            mime: "text/x-sql",
            mode: "sql",
            ext: ["sql"]
          }, {
            name: "SQLite",
            mime: "text/x-sqlite",
            mode: "sql"
          }, {
            name: "Squirrel",
            mime: "text/x-squirrel",
            mode: "clike",
            ext: ["nut"]
          }, {
            name: "Stylus",
            mime: "text/x-styl",
            mode: "stylus",
            ext: ["styl"]
          }, {
            name: "Swift",
            mime: "text/x-swift",
            mode: "swift",
            ext: ["swift"]
          }, {
            name: "sTeX",
            mime: "text/x-stex",
            mode: "stex"
          }, {
            name: "LaTeX",
            mime: "text/x-latex",
            mode: "stex",
            ext: ["text", "ltx", "tex"],
            alias: ["tex"]
          }, {
            name: "SystemVerilog",
            mime: "text/x-systemverilog",
            mode: "verilog",
            ext: ["v", "sv", "svh"]
          }, {
            name: "Tcl",
            mime: "text/x-tcl",
            mode: "tcl",
            ext: ["tcl"]
          }, {
            name: "Textile",
            mime: "text/x-textile",
            mode: "textile",
            ext: ["textile"]
          }, {
            name: "TiddlyWiki",
            mime: "text/x-tiddlywiki",
            mode: "tiddlywiki"
          }, {
            name: "Tiki wiki",
            mime: "text/tiki",
            mode: "tiki"
          }, {
            name: "TOML",
            mime: "text/x-toml",
            mode: "toml",
            ext: ["toml"]
          }, {
            name: "Tornado",
            mime: "text/x-tornado",
            mode: "tornado"
          }, {
            name: "troff",
            mime: "text/troff",
            mode: "troff",
            ext: ["1", "2", "3", "4", "5", "6", "7", "8", "9"]
          }, {
            name: "TTCN",
            mime: "text/x-ttcn",
            mode: "ttcn",
            ext: ["ttcn", "ttcn3", "ttcnpp"]
          }, {
            name: "TTCN_CFG",
            mime: "text/x-ttcn-cfg",
            mode: "ttcn-cfg",
            ext: ["cfg"]
          }, {
            name: "Turtle",
            mime: "text/turtle",
            mode: "turtle",
            ext: ["ttl"]
          }, {
            name: "TypeScript",
            mime: "application/typescript",
            mode: "javascript",
            ext: ["ts"],
            alias: ["ts"]
          }, {
            name: "TypeScript-JSX",
            mime: "text/typescript-jsx",
            mode: "jsx",
            ext: ["tsx"],
            alias: ["tsx"]
          }, {
            name: "Twig",
            mime: "text/x-twig",
            mode: "twig"
          }, {
            name: "Web IDL",
            mime: "text/x-webidl",
            mode: "webidl",
            ext: ["webidl"]
          }, {
            name: "VB.NET",
            mime: "text/x-vb",
            mode: "vb",
            ext: ["vb"]
          }, {
            name: "VBScript",
            mime: "text/vbscript",
            mode: "vbscript",
            ext: ["vbs"]
          }, {
            name: "Velocity",
            mime: "text/velocity",
            mode: "velocity",
            ext: ["vtl"]
          }, {
            name: "Verilog",
            mime: "text/x-verilog",
            mode: "verilog",
            ext: ["v"]
          }, {
            name: "VHDL",
            mime: "text/x-vhdl",
            mode: "vhdl",
            ext: ["vhd", "vhdl"]
          }, {
            name: "Vue.js Component",
            mimes: ["script/x-vue", "text/x-vue"],
            mode: "vue",
            ext: ["vue"]
          }, {
            name: "XML",
            mimes: ["application/xml", "text/xml"],
            mode: "xml",
            ext: ["xml", "xsl", "xsd", "svg"],
            alias: ["rss", "wsdl", "xsd"]
          }, {
            name: "XQuery",
            mime: "application/xquery",
            mode: "xquery",
            ext: ["xy", "xquery"]
          }, {
            name: "Yacas",
            mime: "text/x-yacas",
            mode: "yacas",
            ext: ["ys"]
          }, {
            name: "YAML",
            mimes: ["text/x-yaml", "text/yaml"],
            mode: "yaml",
            ext: ["yaml", "yml"],
            alias: ["yml"]
          }, {
            name: "Z80",
            mime: "text/x-z80",
            mode: "z80",
            ext: ["z80"]
          }, {
            name: "mscgen",
            mime: "text/x-mscgen",
            mode: "mscgen",
            ext: ["mscgen", "mscin", "msc"]
          }, {
            name: "xu",
            mime: "text/x-xu",
            mode: "mscgen",
            ext: ["xu"]
          }, {
            name: "msgenny",
            mime: "text/x-msgenny",
            mode: "mscgen",
            ext: ["msgenny"]
          }];
          for (var t = 0; t < e.modeInfo.length; t++) {
            var r = e.modeInfo[t];
            r.mimes && (r.mime = r.mimes[0]);
          }
          e.findModeByMIME = function (t) {
            t = t.toLowerCase();
            for (var r = 0; r < e.modeInfo.length; r++) {
              var n = e.modeInfo[r];
              if (n.mime == t) return n;
              if (n.mimes) for (var i = 0; i < n.mimes.length; i++) {
                if (n.mimes[i] == t) return n;
              }
            }
            return /\+xml$/.test(t) ? e.findModeByMIME("application/xml") : /\+json$/.test(t) ? e.findModeByMIME("application/json") : void 0;
          }, e.findModeByExtension = function (t) {
            t = t.toLowerCase();
            for (var r = 0; r < e.modeInfo.length; r++) {
              var n = e.modeInfo[r];
              if (n.ext) for (var i = 0; i < n.ext.length; i++) {
                if (n.ext[i] == t) return n;
              }
            }
          }, e.findModeByFileName = function (t) {
            for (var r = 0; r < e.modeInfo.length; r++) {
              var n = e.modeInfo[r];
              if (n.file && n.file.test(t)) return n;
            }
            var i = t.lastIndexOf("."),
              o = i > -1 && t.substring(i + 1, t.length);
            if (o) return e.findModeByExtension(o);
          }, e.findModeByName = function (t) {
            t = t.toLowerCase();
            for (var r = 0; r < e.modeInfo.length; r++) {
              var n = e.modeInfo[r];
              if (n.name.toLowerCase() == t) return n;
              if (n.alias) for (var i = 0; i < n.alias.length; i++) {
                if (n.alias[i].toLowerCase() == t) return n;
              }
            }
          };
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      7014: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMode("mllike", function (t, r) {
            var n = {
                as: "keyword",
                do: "keyword",
                else: "keyword",
                end: "keyword",
                exception: "keyword",
                fun: "keyword",
                functor: "keyword",
                if: "keyword",
                in: "keyword",
                include: "keyword",
                let: "keyword",
                of: "keyword",
                open: "keyword",
                rec: "keyword",
                struct: "keyword",
                then: "keyword",
                type: "keyword",
                val: "keyword",
                while: "keyword",
                with: "keyword"
              },
              i = r.extraWords || {};
            for (var o in i) {
              i.hasOwnProperty(o) && (n[o] = r.extraWords[o]);
            }
            var a = [];
            for (var s in n) {
              a.push(s);
            }
            function l(e, t) {
              var i = e.next();
              if ('"' === i) return t.tokenize = c, t.tokenize(e, t);
              if ("{" === i && e.eat("|")) return t.longString = !0, t.tokenize = d, t.tokenize(e, t);
              if ("(" === i && e.eat("*")) return t.commentLevel++, t.tokenize = u, t.tokenize(e, t);
              if ("~" === i || "?" === i) return e.eatWhile(/\w/), "variable-2";
              if ("`" === i) return e.eatWhile(/\w/), "quote";
              if ("/" === i && r.slashComments && e.eat("/")) return e.skipToEnd(), "comment";
              if (/\d/.test(i)) return "0" === i && e.eat(/[bB]/) && e.eatWhile(/[01]/), "0" === i && e.eat(/[xX]/) && e.eatWhile(/[0-9a-fA-F]/), "0" === i && e.eat(/[oO]/) ? e.eatWhile(/[0-7]/) : (e.eatWhile(/[\d_]/), e.eat(".") && e.eatWhile(/[\d]/), e.eat(/[eE]/) && e.eatWhile(/[\d\-+]/)), "number";
              if (/[+\-*&%=<>!?|@\.~:]/.test(i)) return "operator";
              if (/[\w\xa1-\uffff]/.test(i)) {
                e.eatWhile(/[\w\xa1-\uffff]/);
                var o = e.current();
                return n.hasOwnProperty(o) ? n[o] : "variable";
              }
              return null;
            }
            function c(e, t) {
              for (var r, n = !1, i = !1; null != (r = e.next());) {
                if ('"' === r && !i) {
                  n = !0;
                  break;
                }
                i = !i && "\\" === r;
              }
              return n && !i && (t.tokenize = l), "string";
            }
            function u(e, t) {
              for (var r, n; t.commentLevel > 0 && null != (n = e.next());) {
                "(" === r && "*" === n && t.commentLevel++, "*" === r && ")" === n && t.commentLevel--, r = n;
              }
              return t.commentLevel <= 0 && (t.tokenize = l), "comment";
            }
            function d(e, t) {
              for (var r, n; t.longString && null != (n = e.next());) {
                "|" === r && "}" === n && (t.longString = !1), r = n;
              }
              return t.longString || (t.tokenize = l), "string";
            }
            return e.registerHelper("hintWords", "mllike", a), {
              startState: function startState() {
                return {
                  tokenize: l,
                  commentLevel: 0,
                  longString: !1
                };
              },
              token: function token(e, t) {
                return e.eatSpace() ? null : t.tokenize(e, t);
              },
              blockCommentStart: "(*",
              blockCommentEnd: "*)",
              lineComment: r.slashComments ? "//" : null
            };
          }), e.defineMIME("text/x-ocaml", {
            name: "mllike",
            extraWords: {
              and: "keyword",
              assert: "keyword",
              begin: "keyword",
              class: "keyword",
              constraint: "keyword",
              done: "keyword",
              downto: "keyword",
              external: "keyword",
              function: "keyword",
              initializer: "keyword",
              lazy: "keyword",
              match: "keyword",
              method: "keyword",
              module: "keyword",
              mutable: "keyword",
              new: "keyword",
              nonrec: "keyword",
              object: "keyword",
              private: "keyword",
              sig: "keyword",
              to: "keyword",
              try: "keyword",
              value: "keyword",
              virtual: "keyword",
              when: "keyword",
              raise: "builtin",
              failwith: "builtin",
              true: "builtin",
              false: "builtin",
              asr: "builtin",
              land: "builtin",
              lor: "builtin",
              lsl: "builtin",
              lsr: "builtin",
              lxor: "builtin",
              mod: "builtin",
              or: "builtin",
              raise_notrace: "builtin",
              trace: "builtin",
              exit: "builtin",
              print_string: "builtin",
              print_endline: "builtin",
              int: "type",
              float: "type",
              bool: "type",
              char: "type",
              string: "type",
              unit: "type",
              List: "builtin"
            }
          }), e.defineMIME("text/x-fsharp", {
            name: "mllike",
            extraWords: {
              abstract: "keyword",
              assert: "keyword",
              base: "keyword",
              begin: "keyword",
              class: "keyword",
              default: "keyword",
              delegate: "keyword",
              "do!": "keyword",
              done: "keyword",
              downcast: "keyword",
              downto: "keyword",
              elif: "keyword",
              extern: "keyword",
              finally: "keyword",
              for: "keyword",
              function: "keyword",
              global: "keyword",
              inherit: "keyword",
              inline: "keyword",
              interface: "keyword",
              internal: "keyword",
              lazy: "keyword",
              "let!": "keyword",
              match: "keyword",
              member: "keyword",
              module: "keyword",
              mutable: "keyword",
              namespace: "keyword",
              new: "keyword",
              null: "keyword",
              override: "keyword",
              private: "keyword",
              public: "keyword",
              "return!": "keyword",
              return: "keyword",
              select: "keyword",
              static: "keyword",
              to: "keyword",
              try: "keyword",
              upcast: "keyword",
              "use!": "keyword",
              use: "keyword",
              void: "keyword",
              when: "keyword",
              "yield!": "keyword",
              yield: "keyword",
              atomic: "keyword",
              break: "keyword",
              checked: "keyword",
              component: "keyword",
              const: "keyword",
              constraint: "keyword",
              constructor: "keyword",
              continue: "keyword",
              eager: "keyword",
              event: "keyword",
              external: "keyword",
              fixed: "keyword",
              method: "keyword",
              mixin: "keyword",
              object: "keyword",
              parallel: "keyword",
              process: "keyword",
              protected: "keyword",
              pure: "keyword",
              sealed: "keyword",
              tailcall: "keyword",
              trait: "keyword",
              virtual: "keyword",
              volatile: "keyword",
              List: "builtin",
              Seq: "builtin",
              Map: "builtin",
              Set: "builtin",
              Option: "builtin",
              int: "builtin",
              string: "builtin",
              not: "builtin",
              true: "builtin",
              false: "builtin",
              raise: "builtin",
              failwith: "builtin"
            },
            slashComments: !0
          }), e.defineMIME("text/x-sml", {
            name: "mllike",
            extraWords: {
              abstype: "keyword",
              and: "keyword",
              andalso: "keyword",
              case: "keyword",
              datatype: "keyword",
              fn: "keyword",
              handle: "keyword",
              infix: "keyword",
              infixr: "keyword",
              local: "keyword",
              nonfix: "keyword",
              op: "keyword",
              orelse: "keyword",
              raise: "keyword",
              withtype: "keyword",
              eqtype: "keyword",
              sharing: "keyword",
              sig: "keyword",
              signature: "keyword",
              structure: "keyword",
              where: "keyword",
              true: "keyword",
              false: "keyword",
              int: "builtin",
              real: "builtin",
              string: "builtin",
              char: "builtin",
              bool: "builtin"
            },
            slashComments: !0
          });
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      1716: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          function t(e, t) {
            return e.string.charAt(e.pos + (t || 0));
          }
          function r(e, t) {
            if (t) {
              var r = e.pos - t;
              return e.string.substr(r >= 0 ? r : 0, t);
            }
            return e.string.substr(0, e.pos - 1);
          }
          function n(e, t) {
            var r = e.string.length,
              n = r - e.pos + 1;
            return e.string.substr(e.pos, t && t < r ? t : n);
          }
          function i(e, t) {
            var r,
              n = e.pos + t;
            n <= 0 ? e.pos = 0 : n >= (r = e.string.length - 1) ? e.pos = r : e.pos = n;
          }
          e.defineMode("perl", function () {
            var e = {
                "->": 4,
                "++": 4,
                "--": 4,
                "**": 4,
                "=~": 4,
                "!~": 4,
                "*": 4,
                "/": 4,
                "%": 4,
                x: 4,
                "+": 4,
                "-": 4,
                ".": 4,
                "<<": 4,
                ">>": 4,
                "<": 4,
                ">": 4,
                "<=": 4,
                ">=": 4,
                lt: 4,
                gt: 4,
                le: 4,
                ge: 4,
                "==": 4,
                "!=": 4,
                "<=>": 4,
                eq: 4,
                ne: 4,
                cmp: 4,
                "~~": 4,
                "&": 4,
                "|": 4,
                "^": 4,
                "&&": 4,
                "||": 4,
                "//": 4,
                "..": 4,
                "...": 4,
                "?": 4,
                ":": 4,
                "=": 4,
                "+=": 4,
                "-=": 4,
                "*=": 4,
                ",": 4,
                "=>": 4,
                "::": 4,
                not: 4,
                and: 4,
                or: 4,
                xor: 4,
                BEGIN: [5, 1],
                END: [5, 1],
                PRINT: [5, 1],
                PRINTF: [5, 1],
                GETC: [5, 1],
                READ: [5, 1],
                READLINE: [5, 1],
                DESTROY: [5, 1],
                TIE: [5, 1],
                TIEHANDLE: [5, 1],
                UNTIE: [5, 1],
                STDIN: 5,
                STDIN_TOP: 5,
                STDOUT: 5,
                STDOUT_TOP: 5,
                STDERR: 5,
                STDERR_TOP: 5,
                $ARG: 5,
                $_: 5,
                "@ARG": 5,
                "@_": 5,
                $LIST_SEPARATOR: 5,
                '$"': 5,
                $PROCESS_ID: 5,
                $PID: 5,
                $$: 5,
                $REAL_GROUP_ID: 5,
                $GID: 5,
                "$(": 5,
                $EFFECTIVE_GROUP_ID: 5,
                $EGID: 5,
                "$)": 5,
                $PROGRAM_NAME: 5,
                $0: 5,
                $SUBSCRIPT_SEPARATOR: 5,
                $SUBSEP: 5,
                "$;": 5,
                $REAL_USER_ID: 5,
                $UID: 5,
                "$<": 5,
                $EFFECTIVE_USER_ID: 5,
                $EUID: 5,
                "$>": 5,
                $a: 5,
                $b: 5,
                $COMPILING: 5,
                "$^C": 5,
                $DEBUGGING: 5,
                "$^D": 5,
                "${^ENCODING}": 5,
                $ENV: 5,
                "%ENV": 5,
                $SYSTEM_FD_MAX: 5,
                "$^F": 5,
                "@F": 5,
                "${^GLOBAL_PHASE}": 5,
                "$^H": 5,
                "%^H": 5,
                "@INC": 5,
                "%INC": 5,
                $INPLACE_EDIT: 5,
                "$^I": 5,
                "$^M": 5,
                $OSNAME: 5,
                "$^O": 5,
                "${^OPEN}": 5,
                $PERLDB: 5,
                "$^P": 5,
                $SIG: 5,
                "%SIG": 5,
                $BASETIME: 5,
                "$^T": 5,
                "${^TAINT}": 5,
                "${^UNICODE}": 5,
                "${^UTF8CACHE}": 5,
                "${^UTF8LOCALE}": 5,
                $PERL_VERSION: 5,
                "$^V": 5,
                "${^WIN32_SLOPPY_STAT}": 5,
                $EXECUTABLE_NAME: 5,
                "$^X": 5,
                $1: 5,
                $MATCH: 5,
                "$&": 5,
                "${^MATCH}": 5,
                $PREMATCH: 5,
                "$`": 5,
                "${^PREMATCH}": 5,
                $POSTMATCH: 5,
                "$'": 5,
                "${^POSTMATCH}": 5,
                $LAST_PAREN_MATCH: 5,
                "$+": 5,
                $LAST_SUBMATCH_RESULT: 5,
                "$^N": 5,
                "@LAST_MATCH_END": 5,
                "@+": 5,
                "%LAST_PAREN_MATCH": 5,
                "%+": 5,
                "@LAST_MATCH_START": 5,
                "@-": 5,
                "%LAST_MATCH_START": 5,
                "%-": 5,
                $LAST_REGEXP_CODE_RESULT: 5,
                "$^R": 5,
                "${^RE_DEBUG_FLAGS}": 5,
                "${^RE_TRIE_MAXBUF}": 5,
                $ARGV: 5,
                "@ARGV": 5,
                ARGV: 5,
                ARGVOUT: 5,
                $OUTPUT_FIELD_SEPARATOR: 5,
                $OFS: 5,
                "$,": 5,
                $INPUT_LINE_NUMBER: 5,
                $NR: 5,
                "$.": 5,
                $INPUT_RECORD_SEPARATOR: 5,
                $RS: 5,
                "$/": 5,
                $OUTPUT_RECORD_SEPARATOR: 5,
                $ORS: 5,
                "$\\": 5,
                $OUTPUT_AUTOFLUSH: 5,
                "$|": 5,
                $ACCUMULATOR: 5,
                "$^A": 5,
                $FORMAT_FORMFEED: 5,
                "$^L": 5,
                $FORMAT_PAGE_NUMBER: 5,
                "$%": 5,
                $FORMAT_LINES_LEFT: 5,
                "$-": 5,
                $FORMAT_LINE_BREAK_CHARACTERS: 5,
                "$:": 5,
                $FORMAT_LINES_PER_PAGE: 5,
                "$=": 5,
                $FORMAT_TOP_NAME: 5,
                "$^": 5,
                $FORMAT_NAME: 5,
                "$~": 5,
                "${^CHILD_ERROR_NATIVE}": 5,
                $EXTENDED_OS_ERROR: 5,
                "$^E": 5,
                $EXCEPTIONS_BEING_CAUGHT: 5,
                "$^S": 5,
                $WARNING: 5,
                "$^W": 5,
                "${^WARNING_BITS}": 5,
                $OS_ERROR: 5,
                $ERRNO: 5,
                "$!": 5,
                "%OS_ERROR": 5,
                "%ERRNO": 5,
                "%!": 5,
                $CHILD_ERROR: 5,
                "$?": 5,
                $EVAL_ERROR: 5,
                "$@": 5,
                $OFMT: 5,
                "$#": 5,
                "$*": 5,
                $ARRAY_BASE: 5,
                "$[": 5,
                $OLD_PERL_VERSION: 5,
                "$]": 5,
                if: [1, 1],
                elsif: [1, 1],
                else: [1, 1],
                while: [1, 1],
                unless: [1, 1],
                for: [1, 1],
                foreach: [1, 1],
                abs: 1,
                accept: 1,
                alarm: 1,
                atan2: 1,
                bind: 1,
                binmode: 1,
                bless: 1,
                bootstrap: 1,
                break: 1,
                caller: 1,
                chdir: 1,
                chmod: 1,
                chomp: 1,
                chop: 1,
                chown: 1,
                chr: 1,
                chroot: 1,
                close: 1,
                closedir: 1,
                connect: 1,
                continue: [1, 1],
                cos: 1,
                crypt: 1,
                dbmclose: 1,
                dbmopen: 1,
                default: 1,
                defined: 1,
                delete: 1,
                die: 1,
                do: 1,
                dump: 1,
                each: 1,
                endgrent: 1,
                endhostent: 1,
                endnetent: 1,
                endprotoent: 1,
                endpwent: 1,
                endservent: 1,
                eof: 1,
                eval: 1,
                exec: 1,
                exists: 1,
                exit: 1,
                exp: 1,
                fcntl: 1,
                fileno: 1,
                flock: 1,
                fork: 1,
                format: 1,
                formline: 1,
                getc: 1,
                getgrent: 1,
                getgrgid: 1,
                getgrnam: 1,
                gethostbyaddr: 1,
                gethostbyname: 1,
                gethostent: 1,
                getlogin: 1,
                getnetbyaddr: 1,
                getnetbyname: 1,
                getnetent: 1,
                getpeername: 1,
                getpgrp: 1,
                getppid: 1,
                getpriority: 1,
                getprotobyname: 1,
                getprotobynumber: 1,
                getprotoent: 1,
                getpwent: 1,
                getpwnam: 1,
                getpwuid: 1,
                getservbyname: 1,
                getservbyport: 1,
                getservent: 1,
                getsockname: 1,
                getsockopt: 1,
                given: 1,
                glob: 1,
                gmtime: 1,
                goto: 1,
                grep: 1,
                hex: 1,
                import: 1,
                index: 1,
                int: 1,
                ioctl: 1,
                join: 1,
                keys: 1,
                kill: 1,
                last: 1,
                lc: 1,
                lcfirst: 1,
                length: 1,
                link: 1,
                listen: 1,
                local: 2,
                localtime: 1,
                lock: 1,
                log: 1,
                lstat: 1,
                m: null,
                map: 1,
                mkdir: 1,
                msgctl: 1,
                msgget: 1,
                msgrcv: 1,
                msgsnd: 1,
                my: 2,
                new: 1,
                next: 1,
                no: 1,
                oct: 1,
                open: 1,
                opendir: 1,
                ord: 1,
                our: 2,
                pack: 1,
                package: 1,
                pipe: 1,
                pop: 1,
                pos: 1,
                print: 1,
                printf: 1,
                prototype: 1,
                push: 1,
                q: null,
                qq: null,
                qr: null,
                quotemeta: null,
                qw: null,
                qx: null,
                rand: 1,
                read: 1,
                readdir: 1,
                readline: 1,
                readlink: 1,
                readpipe: 1,
                recv: 1,
                redo: 1,
                ref: 1,
                rename: 1,
                require: 1,
                reset: 1,
                return: 1,
                reverse: 1,
                rewinddir: 1,
                rindex: 1,
                rmdir: 1,
                s: null,
                say: 1,
                scalar: 1,
                seek: 1,
                seekdir: 1,
                select: 1,
                semctl: 1,
                semget: 1,
                semop: 1,
                send: 1,
                setgrent: 1,
                sethostent: 1,
                setnetent: 1,
                setpgrp: 1,
                setpriority: 1,
                setprotoent: 1,
                setpwent: 1,
                setservent: 1,
                setsockopt: 1,
                shift: 1,
                shmctl: 1,
                shmget: 1,
                shmread: 1,
                shmwrite: 1,
                shutdown: 1,
                sin: 1,
                sleep: 1,
                socket: 1,
                socketpair: 1,
                sort: 1,
                splice: 1,
                split: 1,
                sprintf: 1,
                sqrt: 1,
                srand: 1,
                stat: 1,
                state: 1,
                study: 1,
                sub: 1,
                substr: 1,
                symlink: 1,
                syscall: 1,
                sysopen: 1,
                sysread: 1,
                sysseek: 1,
                system: 1,
                syswrite: 1,
                tell: 1,
                telldir: 1,
                tie: 1,
                tied: 1,
                time: 1,
                times: 1,
                tr: null,
                truncate: 1,
                uc: 1,
                ucfirst: 1,
                umask: 1,
                undef: 1,
                unlink: 1,
                unpack: 1,
                unshift: 1,
                untie: 1,
                use: 1,
                utime: 1,
                values: 1,
                vec: 1,
                wait: 1,
                waitpid: 1,
                wantarray: 1,
                warn: 1,
                when: 1,
                write: 1,
                y: null
              },
              o = "string-2",
              a = /[goseximacplud]/;
            function s(e, t, r, n, i) {
              return t.chain = null, t.style = null, t.tail = null, t.tokenize = function (e, t) {
                for (var o, a = !1, s = 0; o = e.next();) {
                  if (o === r[s] && !a) return void 0 !== r[++s] ? (t.chain = r[s], t.style = n, t.tail = i) : i && e.eatWhile(i), t.tokenize = c, n;
                  a = !a && "\\" == o;
                }
                return n;
              }, t.tokenize(e, t);
            }
            function l(e, t, r) {
              return t.tokenize = function (e, t) {
                return e.string == r && (t.tokenize = c), e.skipToEnd(), "string";
              }, t.tokenize(e, t);
            }
            function c(c, u) {
              if (c.eatSpace()) return null;
              if (u.chain) return s(c, u, u.chain, u.style, u.tail);
              if (c.match(/^\-?[\d\.]/, !1) && c.match(/^(\-?(\d*\.\d+(e[+-]?\d+)?|\d+\.\d*)|0x[\da-fA-F]+|0b[01]+|\d+(e[+-]?\d+)?)/)) return "number";
              if (c.match(/^<<(?=\w)/)) return c.eatWhile(/\w/), l(c, u, c.current().substr(2));
              if (c.sol() && c.match(/^\=item(?!\w)/)) return l(c, u, "=cut");
              var d = c.next();
              if ('"' == d || "'" == d) {
                if (r(c, 3) == "<<" + d) {
                  var p = c.pos;
                  c.eatWhile(/\w/);
                  var f = c.current().substr(1);
                  if (f && c.eat(d)) return l(c, u, f);
                  c.pos = p;
                }
                return s(c, u, [d], "string");
              }
              if (!("q" != d || (m = t(c, -2)) && /\w/.test(m))) if ("x" == (m = t(c, 0))) {
                if ("(" == (m = t(c, 1))) return i(c, 2), s(c, u, [")"], o, a);
                if ("[" == m) return i(c, 2), s(c, u, ["]"], o, a);
                if ("{" == m) return i(c, 2), s(c, u, ["}"], o, a);
                if ("<" == m) return i(c, 2), s(c, u, [">"], o, a);
                if (/[\^'"!~\/]/.test(m)) return i(c, 1), s(c, u, [c.eat(m)], o, a);
              } else if ("q" == m) {
                if ("(" == (m = t(c, 1))) return i(c, 2), s(c, u, [")"], "string");
                if ("[" == m) return i(c, 2), s(c, u, ["]"], "string");
                if ("{" == m) return i(c, 2), s(c, u, ["}"], "string");
                if ("<" == m) return i(c, 2), s(c, u, [">"], "string");
                if (/[\^'"!~\/]/.test(m)) return i(c, 1), s(c, u, [c.eat(m)], "string");
              } else if ("w" == m) {
                if ("(" == (m = t(c, 1))) return i(c, 2), s(c, u, [")"], "bracket");
                if ("[" == m) return i(c, 2), s(c, u, ["]"], "bracket");
                if ("{" == m) return i(c, 2), s(c, u, ["}"], "bracket");
                if ("<" == m) return i(c, 2), s(c, u, [">"], "bracket");
                if (/[\^'"!~\/]/.test(m)) return i(c, 1), s(c, u, [c.eat(m)], "bracket");
              } else if ("r" == m) {
                if ("(" == (m = t(c, 1))) return i(c, 2), s(c, u, [")"], o, a);
                if ("[" == m) return i(c, 2), s(c, u, ["]"], o, a);
                if ("{" == m) return i(c, 2), s(c, u, ["}"], o, a);
                if ("<" == m) return i(c, 2), s(c, u, [">"], o, a);
                if (/[\^'"!~\/]/.test(m)) return i(c, 1), s(c, u, [c.eat(m)], o, a);
              } else if (/[\^'"!~\/(\[{<]/.test(m)) {
                if ("(" == m) return i(c, 1), s(c, u, [")"], "string");
                if ("[" == m) return i(c, 1), s(c, u, ["]"], "string");
                if ("{" == m) return i(c, 1), s(c, u, ["}"], "string");
                if ("<" == m) return i(c, 1), s(c, u, [">"], "string");
                if (/[\^'"!~\/]/.test(m)) return s(c, u, [c.eat(m)], "string");
              }
              if ("m" == d && (!(m = t(c, -2)) || !/\w/.test(m)) && (m = c.eat(/[(\[{<\^'"!~\/]/))) {
                if (/[\^'"!~\/]/.test(m)) return s(c, u, [m], o, a);
                if ("(" == m) return s(c, u, [")"], o, a);
                if ("[" == m) return s(c, u, ["]"], o, a);
                if ("{" == m) return s(c, u, ["}"], o, a);
                if ("<" == m) return s(c, u, [">"], o, a);
              }
              if ("s" == d && !(m = /[\/>\]})\w]/.test(t(c, -2))) && (m = c.eat(/[(\[{<\^'"!~\/]/))) return s(c, u, "[" == m ? ["]", "]"] : "{" == m ? ["}", "}"] : "<" == m ? [">", ">"] : "(" == m ? [")", ")"] : [m, m], o, a);
              if ("y" == d && !(m = /[\/>\]})\w]/.test(t(c, -2))) && (m = c.eat(/[(\[{<\^'"!~\/]/))) return s(c, u, "[" == m ? ["]", "]"] : "{" == m ? ["}", "}"] : "<" == m ? [">", ">"] : "(" == m ? [")", ")"] : [m, m], o, a);
              if ("t" == d && !(m = /[\/>\]})\w]/.test(t(c, -2))) && (m = c.eat("r")) && (m = c.eat(/[(\[{<\^'"!~\/]/))) return s(c, u, "[" == m ? ["]", "]"] : "{" == m ? ["}", "}"] : "<" == m ? [">", ">"] : "(" == m ? [")", ")"] : [m, m], o, a);
              if ("`" == d) return s(c, u, [d], "variable-2");
              if ("/" == d) return /~\s*$/.test(r(c)) ? s(c, u, [d], o, a) : "operator";
              if ("$" == d) {
                if (p = c.pos, c.eatWhile(/\d/) || c.eat("{") && c.eatWhile(/\d/) && c.eat("}")) return "variable-2";
                c.pos = p;
              }
              if (/[$@%]/.test(d)) {
                if (p = c.pos, c.eat("^") && c.eat(/[A-Z]/) || !/[@$%&]/.test(t(c, -2)) && c.eat(/[=|\\\-#?@;:&`~\^!\[\]*'"$+.,\/<>()]/)) {
                  var m = c.current();
                  if (e[m]) return "variable-2";
                }
                c.pos = p;
              }
              if (/[$@%&]/.test(d) && (c.eatWhile(/[\w$\[\]]/) || c.eat("{") && c.eatWhile(/[\w$\[\]]/) && c.eat("}"))) return m = c.current(), e[m] ? "variable-2" : "variable";
              if ("#" == d && "$" != t(c, -2)) return c.skipToEnd(), "comment";
              if (/[:+\-\^*$&%@=<>!?|\/~\.]/.test(d)) {
                if (p = c.pos, c.eatWhile(/[:+\-\^*$&%@=<>!?|\/~\.]/), e[c.current()]) return "operator";
                c.pos = p;
              }
              if ("_" == d && 1 == c.pos) {
                if ("_END__" == n(c, 6)) return s(c, u, ["\0"], "comment");
                if ("_DATA__" == n(c, 7)) return s(c, u, ["\0"], "variable-2");
                if ("_C__" == n(c, 7)) return s(c, u, ["\0"], "string");
              }
              if (/\w/.test(d)) {
                if (p = c.pos, "{" == t(c, -2) && ("}" == t(c, 0) || c.eatWhile(/\w/) && "}" == t(c, 0))) return "string";
                c.pos = p;
              }
              if (/[A-Z]/.test(d)) {
                var h = t(c, -2);
                if (p = c.pos, c.eatWhile(/[A-Z_]/), !/[\da-z]/.test(t(c, 0))) return (m = e[c.current()]) ? (m[1] && (m = m[0]), ":" != h ? 1 == m ? "keyword" : 2 == m ? "def" : 3 == m ? "atom" : 4 == m ? "operator" : 5 == m ? "variable-2" : "meta" : "meta") : "meta";
                c.pos = p;
              }
              return /[a-zA-Z_]/.test(d) ? (h = t(c, -2), c.eatWhile(/\w/), (m = e[c.current()]) ? (m[1] && (m = m[0]), ":" != h ? 1 == m ? "keyword" : 2 == m ? "def" : 3 == m ? "atom" : 4 == m ? "operator" : 5 == m ? "variable-2" : "meta" : "meta") : "meta") : null;
            }
            return {
              startState: function startState() {
                return {
                  tokenize: c,
                  chain: null,
                  style: null,
                  tail: null
                };
              },
              token: function token(e, t) {
                return (t.tokenize || c)(e, t);
              },
              lineComment: "#"
            };
          }), e.registerHelper("wordChars", "perl", /[\w$]/), e.defineMIME("text/x-perl", "perl");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      3612: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          function t(e) {
            for (var t = {}, r = e.split(" "), n = 0; n < r.length; ++n) {
              t[r[n]] = !0;
            }
            return t;
          }
          function r(e, t, i) {
            return 0 == e.length ? n(t) : function (o, a) {
              for (var s = e[0], l = 0; l < s.length; l++) {
                if (o.match(s[l][0])) return a.tokenize = r(e.slice(1), t), s[l][1];
              }
              return a.tokenize = n(t, i), "string";
            };
          }
          function n(e, t) {
            return function (n, i) {
              return function (e, t, n, i) {
                if (!1 !== i && e.match("${", !1) || e.match("{$", !1)) return t.tokenize = null, "string";
                if (!1 !== i && e.match(/^\$[a-zA-Z_][a-zA-Z0-9_]*/)) return e.match("[", !1) && (t.tokenize = r([[["[", null]], [[/\d[\w\.]*/, "number"], [/\$[a-zA-Z_][a-zA-Z0-9_]*/, "variable-2"], [/[\w\$]+/, "variable"]], [["]", null]]], n, i)), e.match(/\-\>\w/, !1) && (t.tokenize = r([[["->", null]], [[/[\w]+/, "variable"]]], n, i)), "variable-2";
                for (var o = !1; !e.eol() && (o || !1 === i || !e.match("{$", !1) && !e.match(/^(\$[a-zA-Z_][a-zA-Z0-9_]*|\$\{)/, !1));) {
                  if (!o && e.match(n)) {
                    t.tokenize = null, t.tokStack.pop(), t.tokStack.pop();
                    break;
                  }
                  o = "\\" == e.next() && !o;
                }
                return "string";
              }(n, i, e, t);
            };
          }
          var i = "abstract and array as break case catch class clone const continue declare default do else elseif enddeclare endfor endforeach endif endswitch endwhile extends final for foreach function global goto if implements interface instanceof namespace new or private protected public static switch throw trait try use var while xor die echo empty exit eval include include_once isset list require require_once return print unset __halt_compiler self static parent yield insteadof finally",
            o = "true false null TRUE FALSE NULL __CLASS__ __DIR__ __FILE__ __LINE__ __METHOD__ __FUNCTION__ __NAMESPACE__ __TRAIT__",
            a = "func_num_args func_get_arg func_get_args strlen strcmp strncmp strcasecmp strncasecmp each error_reporting define defined trigger_error user_error set_error_handler restore_error_handler get_declared_classes get_loaded_extensions extension_loaded get_extension_funcs debug_backtrace constant bin2hex hex2bin sleep usleep time mktime gmmktime strftime gmstrftime strtotime date gmdate getdate localtime checkdate flush wordwrap htmlspecialchars htmlentities html_entity_decode md5 md5_file crc32 getimagesize image_type_to_mime_type phpinfo phpversion phpcredits strnatcmp strnatcasecmp substr_count strspn strcspn strtok strtoupper strtolower strpos strrpos strrev hebrev hebrevc nl2br basename dirname pathinfo stripslashes stripcslashes strstr stristr strrchr str_shuffle str_word_count strcoll substr substr_replace quotemeta ucfirst ucwords strtr addslashes addcslashes rtrim str_replace str_repeat count_chars chunk_split trim ltrim strip_tags similar_text explode implode setlocale localeconv parse_str str_pad chop strchr sprintf printf vprintf vsprintf sscanf fscanf parse_url urlencode urldecode rawurlencode rawurldecode readlink linkinfo link unlink exec system escapeshellcmd escapeshellarg passthru shell_exec proc_open proc_close rand srand getrandmax mt_rand mt_srand mt_getrandmax base64_decode base64_encode abs ceil floor round is_finite is_nan is_infinite bindec hexdec octdec decbin decoct dechex base_convert number_format fmod ip2long long2ip getenv putenv getopt microtime gettimeofday getrusage uniqid quoted_printable_decode set_time_limit get_cfg_var magic_quotes_runtime set_magic_quotes_runtime get_magic_quotes_gpc get_magic_quotes_runtime import_request_variables error_log serialize unserialize memory_get_usage var_dump var_export debug_zval_dump print_r highlight_file show_source highlight_string ini_get ini_get_all ini_set ini_alter ini_restore get_include_path set_include_path restore_include_path setcookie header headers_sent connection_aborted connection_status ignore_user_abort parse_ini_file is_uploaded_file move_uploaded_file intval floatval doubleval strval gettype settype is_null is_resource is_bool is_long is_float is_int is_integer is_double is_real is_numeric is_string is_array is_object is_scalar ereg ereg_replace eregi eregi_replace split spliti join sql_regcase dl pclose popen readfile rewind rmdir umask fclose feof fgetc fgets fgetss fread fopen fpassthru ftruncate fstat fseek ftell fflush fwrite fputs mkdir rename copy tempnam tmpfile file file_get_contents file_put_contents stream_select stream_context_create stream_context_set_params stream_context_set_option stream_context_get_options stream_filter_prepend stream_filter_append fgetcsv flock get_meta_tags stream_set_write_buffer set_file_buffer set_socket_blocking stream_set_blocking socket_set_blocking stream_get_meta_data stream_register_wrapper stream_wrapper_register stream_set_timeout socket_set_timeout socket_get_status realpath fnmatch fsockopen pfsockopen pack unpack get_browser crypt opendir closedir chdir getcwd rewinddir readdir dir glob fileatime filectime filegroup fileinode filemtime fileowner fileperms filesize filetype file_exists is_writable is_writeable is_readable is_executable is_file is_dir is_link stat lstat chown touch clearstatcache mail ob_start ob_flush ob_clean ob_end_flush ob_end_clean ob_get_flush ob_get_clean ob_get_length ob_get_level ob_get_status ob_get_contents ob_implicit_flush ob_list_handlers ksort krsort natsort natcasesort asort arsort sort rsort usort uasort uksort shuffle array_walk count end prev next reset current key min max in_array array_search extract compact array_fill range array_multisort array_push array_pop array_shift array_unshift array_splice array_slice array_merge array_merge_recursive array_keys array_values array_count_values array_reverse array_reduce array_pad array_flip array_change_key_case array_rand array_unique array_intersect array_intersect_assoc array_diff array_diff_assoc array_sum array_filter array_map array_chunk array_key_exists array_intersect_key array_combine array_column pos sizeof key_exists assert assert_options version_compare ftok str_rot13 aggregate session_name session_module_name session_save_path session_id session_regenerate_id session_decode session_register session_unregister session_is_registered session_encode session_start session_destroy session_unset session_set_save_handler session_cache_limiter session_cache_expire session_set_cookie_params session_get_cookie_params session_write_close preg_match preg_match_all preg_replace preg_replace_callback preg_split preg_quote preg_grep overload ctype_alnum ctype_alpha ctype_cntrl ctype_digit ctype_lower ctype_graph ctype_print ctype_punct ctype_space ctype_upper ctype_xdigit virtual apache_request_headers apache_note apache_lookup_uri apache_child_terminate apache_setenv apache_response_headers apache_get_version getallheaders mysql_connect mysql_pconnect mysql_close mysql_select_db mysql_create_db mysql_drop_db mysql_query mysql_unbuffered_query mysql_db_query mysql_list_dbs mysql_list_tables mysql_list_fields mysql_list_processes mysql_error mysql_errno mysql_affected_rows mysql_insert_id mysql_result mysql_num_rows mysql_num_fields mysql_fetch_row mysql_fetch_array mysql_fetch_assoc mysql_fetch_object mysql_data_seek mysql_fetch_lengths mysql_fetch_field mysql_field_seek mysql_free_result mysql_field_name mysql_field_table mysql_field_len mysql_field_type mysql_field_flags mysql_escape_string mysql_real_escape_string mysql_stat mysql_thread_id mysql_client_encoding mysql_get_client_info mysql_get_host_info mysql_get_proto_info mysql_get_server_info mysql_info mysql mysql_fieldname mysql_fieldtable mysql_fieldlen mysql_fieldtype mysql_fieldflags mysql_selectdb mysql_createdb mysql_dropdb mysql_freeresult mysql_numfields mysql_numrows mysql_listdbs mysql_listtables mysql_listfields mysql_db_name mysql_dbname mysql_tablename mysql_table_name pg_connect pg_pconnect pg_close pg_connection_status pg_connection_busy pg_connection_reset pg_host pg_dbname pg_port pg_tty pg_options pg_ping pg_query pg_send_query pg_cancel_query pg_fetch_result pg_fetch_row pg_fetch_assoc pg_fetch_array pg_fetch_object pg_fetch_all pg_affected_rows pg_get_result pg_result_seek pg_result_status pg_free_result pg_last_oid pg_num_rows pg_num_fields pg_field_name pg_field_num pg_field_size pg_field_type pg_field_prtlen pg_field_is_null pg_get_notify pg_get_pid pg_result_error pg_last_error pg_last_notice pg_put_line pg_end_copy pg_copy_to pg_copy_from pg_trace pg_untrace pg_lo_create pg_lo_unlink pg_lo_open pg_lo_close pg_lo_read pg_lo_write pg_lo_read_all pg_lo_import pg_lo_export pg_lo_seek pg_lo_tell pg_escape_string pg_escape_bytea pg_unescape_bytea pg_client_encoding pg_set_client_encoding pg_meta_data pg_convert pg_insert pg_update pg_delete pg_select pg_exec pg_getlastoid pg_cmdtuples pg_errormessage pg_numrows pg_numfields pg_fieldname pg_fieldsize pg_fieldtype pg_fieldnum pg_fieldprtlen pg_fieldisnull pg_freeresult pg_result pg_loreadall pg_locreate pg_lounlink pg_loopen pg_loclose pg_loread pg_lowrite pg_loimport pg_loexport http_response_code get_declared_traits getimagesizefromstring socket_import_stream stream_set_chunk_size trait_exists header_register_callback class_uses session_status session_register_shutdown echo print global static exit array empty eval isset unset die include require include_once require_once json_decode json_encode json_last_error json_last_error_msg curl_close curl_copy_handle curl_errno curl_error curl_escape curl_exec curl_file_create curl_getinfo curl_init curl_multi_add_handle curl_multi_close curl_multi_exec curl_multi_getcontent curl_multi_info_read curl_multi_init curl_multi_remove_handle curl_multi_select curl_multi_setopt curl_multi_strerror curl_pause curl_reset curl_setopt_array curl_setopt curl_share_close curl_share_init curl_share_setopt curl_strerror curl_unescape curl_version mysqli_affected_rows mysqli_autocommit mysqli_change_user mysqli_character_set_name mysqli_close mysqli_commit mysqli_connect_errno mysqli_connect_error mysqli_connect mysqli_data_seek mysqli_debug mysqli_dump_debug_info mysqli_errno mysqli_error_list mysqli_error mysqli_fetch_all mysqli_fetch_array mysqli_fetch_assoc mysqli_fetch_field_direct mysqli_fetch_field mysqli_fetch_fields mysqli_fetch_lengths mysqli_fetch_object mysqli_fetch_row mysqli_field_count mysqli_field_seek mysqli_field_tell mysqli_free_result mysqli_get_charset mysqli_get_client_info mysqli_get_client_stats mysqli_get_client_version mysqli_get_connection_stats mysqli_get_host_info mysqli_get_proto_info mysqli_get_server_info mysqli_get_server_version mysqli_info mysqli_init mysqli_insert_id mysqli_kill mysqli_more_results mysqli_multi_query mysqli_next_result mysqli_num_fields mysqli_num_rows mysqli_options mysqli_ping mysqli_prepare mysqli_query mysqli_real_connect mysqli_real_escape_string mysqli_real_query mysqli_reap_async_query mysqli_refresh mysqli_rollback mysqli_select_db mysqli_set_charset mysqli_set_local_infile_default mysqli_set_local_infile_handler mysqli_sqlstate mysqli_ssl_set mysqli_stat mysqli_stmt_init mysqli_store_result mysqli_thread_id mysqli_thread_safe mysqli_use_result mysqli_warning_count";
          e.registerHelper("hintWords", "php", [i, o, a].join(" ").split(" ")), e.registerHelper("wordChars", "php", /[\w$]/);
          var s = {
            name: "clike",
            helperType: "php",
            keywords: t(i),
            blockKeywords: t("catch do else elseif for foreach if switch try while finally"),
            defKeywords: t("class function interface namespace trait"),
            atoms: t(o),
            builtin: t(a),
            multiLineStrings: !0,
            hooks: {
              $: function $(e) {
                return e.eatWhile(/[\w\$_]/), "variable-2";
              },
              "<": function _(e, t) {
                var r;
                if (r = e.match(/<<\s*/)) {
                  var i = e.eat(/['"]/);
                  e.eatWhile(/[\w\.]/);
                  var o = e.current().slice(r[0].length + (i ? 2 : 1));
                  if (i && e.eat(i), o) return (t.tokStack || (t.tokStack = [])).push(o, 0), t.tokenize = n(o, "'" != i), "string";
                }
                return !1;
              },
              "#": function _(e) {
                for (; !e.eol() && !e.match("?>", !1);) {
                  e.next();
                }
                return "comment";
              },
              "/": function _(e) {
                if (e.eat("/")) {
                  for (; !e.eol() && !e.match("?>", !1);) {
                    e.next();
                  }
                  return "comment";
                }
                return !1;
              },
              '"': function _(e, t) {
                return (t.tokStack || (t.tokStack = [])).push('"', 0), t.tokenize = n('"'), "string";
              },
              "{": function _(e, t) {
                return t.tokStack && t.tokStack.length && t.tokStack[t.tokStack.length - 1]++, !1;
              },
              "}": function _(e, t) {
                return t.tokStack && t.tokStack.length > 0 && ! --t.tokStack[t.tokStack.length - 1] && (t.tokenize = n(t.tokStack[t.tokStack.length - 2])), !1;
              }
            }
          };
          e.defineMode("php", function (t, r) {
            var n = e.getMode(t, r && r.htmlMode || "text/html"),
              i = e.getMode(t, s);
            return {
              startState: function startState() {
                var t = e.startState(n),
                  o = r.startOpen ? e.startState(i) : null;
                return {
                  html: t,
                  php: o,
                  curMode: r.startOpen ? i : n,
                  curState: r.startOpen ? o : t,
                  pending: null
                };
              },
              copyState: function copyState(t) {
                var r,
                  o = t.html,
                  a = e.copyState(n, o),
                  s = t.php,
                  l = s && e.copyState(i, s);
                return r = t.curMode == n ? a : l, {
                  html: a,
                  php: l,
                  curMode: t.curMode,
                  curState: r,
                  pending: t.pending
                };
              },
              token: function token(t, r) {
                var o = r.curMode == i;
                if (t.sol() && r.pending && '"' != r.pending && "'" != r.pending && (r.pending = null), o) return o && null == r.php.tokenize && t.match("?>") ? (r.curMode = n, r.curState = r.html, r.php.context.prev || (r.php = null), "meta") : i.token(t, r.curState);
                if (t.match(/^<\?\w*/)) return r.curMode = i, r.php || (r.php = e.startState(i, n.indent(r.html, "", ""))), r.curState = r.php, "meta";
                if ('"' == r.pending || "'" == r.pending) {
                  for (; !t.eol() && t.next() != r.pending;) {
                    ;
                  }
                  var a = "string";
                } else r.pending && t.pos < r.pending.end ? (t.pos = r.pending.end, a = r.pending.style) : a = n.token(t, r.curState);
                r.pending && (r.pending = null);
                var s,
                  l = t.current(),
                  c = l.search(/<\?/);
                return -1 != c && ("string" == a && (s = l.match(/[\'\"]$/)) && !/\?>/.test(l) ? r.pending = s[0] : r.pending = {
                  end: t.pos,
                  style: a
                }, t.backUp(l.length - c)), a;
              },
              indent: function indent(e, t, r) {
                return e.curMode != i && /^\s*<\//.test(t) || e.curMode == i && /^\?>/.test(t) ? n.indent(e.html, t, r) : e.curMode.indent(e.curState, t, r);
              },
              blockCommentStart: "/*",
              blockCommentEnd: "*/",
              lineComment: "//",
              innerMode: function innerMode(e) {
                return {
                  state: e.curState,
                  mode: e.curMode
                };
              }
            };
          }, "htmlmixed", "clike"), e.defineMIME("application/x-httpd-php", "php"), e.defineMIME("application/x-httpd-php-open", {
            name: "php",
            startOpen: !0
          }), e.defineMIME("text/x-php", s);
        }, "object" == s(t) && "object" == s(e) ? a(r(9074), r(3394), r(1736)) : (i = [r(9074), r(3394), r(1736)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      1459: function _(e, t, r) {
        var n, i, o;
        function a(e) {
          return a = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, a(e);
        }
        e = r.nmd(e), function (s) {
          "use strict";

          "object" == a(t) && "object" == a(e) ? s(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = s) ? n.apply(t, i) : n) || (e.exports = o));
        }(function (e) {
          "use strict";

          e.defineMode("powershell", function () {
            function e(e, t) {
              for (var r = void 0 !== (t = t || {}).prefix ? t.prefix : "^", n = void 0 !== t.suffix ? t.suffix : "\\b", i = 0; i < e.length; i++) {
                e[i] instanceof RegExp ? e[i] = e[i].source : e[i] = e[i].replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
              }
              return new RegExp(r + "(" + e.join("|") + ")" + n, "i");
            }
            var t = "(?=[^A-Za-z\\d\\-_]|$)",
              r = /[\w\-:]/,
              n = e([/begin|break|catch|continue|data|default|do|dynamicparam/, /else|elseif|end|exit|filter|finally|for|foreach|from|function|if|in/, /param|process|return|switch|throw|trap|try|until|where|while/], {
                suffix: t
              }),
              i = e(["f", /b?not/, /[ic]?split/, "join", /is(not)?/, "as", /[ic]?(eq|ne|[gl][te])/, /[ic]?(not)?(like|match|contains)/, /[ic]?replace/, /b?(and|or|xor)/], {
                prefix: "-"
              }),
              o = e([i, /[+\-*\/%]=|\+\+|--|\.\.|[+\-*&^%:=!|\/]|<(?!#)|(?!#)>/], {
                suffix: ""
              }),
              a = e([/Add-(Computer|Content|History|Member|PSSnapin|Type)/, /Checkpoint-Computer/, /Clear-(Content|EventLog|History|Host|Item(Property)?|Variable)/, /Compare-Object/, /Complete-Transaction/, /Connect-PSSession/, /ConvertFrom-(Csv|Json|SecureString|StringData)/, /Convert-Path/, /ConvertTo-(Csv|Html|Json|SecureString|Xml)/, /Copy-Item(Property)?/, /Debug-Process/, /Disable-(ComputerRestore|PSBreakpoint|PSRemoting|PSSessionConfiguration)/, /Disconnect-PSSession/, /Enable-(ComputerRestore|PSBreakpoint|PSRemoting|PSSessionConfiguration)/, /(Enter|Exit)-PSSession/, /Export-(Alias|Clixml|Console|Counter|Csv|FormatData|ModuleMember|PSSession)/, /ForEach-Object/, /Format-(Custom|List|Table|Wide)/, new RegExp("Get-(Acl|Alias|AuthenticodeSignature|ChildItem|Command|ComputerRestorePoint|Content|ControlPanelItem|Counter|Credential|Culture|Date|Event|EventLog|EventSubscriber|ExecutionPolicy|FormatData|Help|History|Host|HotFix|Item|ItemProperty|Job|Location|Member|Module|PfxCertificate|Process|PSBreakpoint|PSCallStack|PSDrive|PSProvider|PSSession|PSSessionConfiguration|PSSnapin|Random|Service|TraceSource|Transaction|TypeData|UICulture|Unique|Variable|Verb|WinEvent|WmiObject)"), /Group-Object/, /Import-(Alias|Clixml|Counter|Csv|LocalizedData|Module|PSSession)/, /ImportSystemModules/, /Invoke-(Command|Expression|History|Item|RestMethod|WebRequest|WmiMethod)/, /Join-Path/, /Limit-EventLog/, /Measure-(Command|Object)/, /Move-Item(Property)?/, new RegExp("New-(Alias|Event|EventLog|Item(Property)?|Module|ModuleManifest|Object|PSDrive|PSSession|PSSessionConfigurationFile|PSSessionOption|PSTransportOption|Service|TimeSpan|Variable|WebServiceProxy|WinEvent)"), /Out-(Default|File|GridView|Host|Null|Printer|String)/, /Pause/, /(Pop|Push)-Location/, /Read-Host/, /Receive-(Job|PSSession)/, /Register-(EngineEvent|ObjectEvent|PSSessionConfiguration|WmiEvent)/, /Remove-(Computer|Event|EventLog|Item(Property)?|Job|Module|PSBreakpoint|PSDrive|PSSession|PSSnapin|TypeData|Variable|WmiObject)/, /Rename-(Computer|Item(Property)?)/, /Reset-ComputerMachinePassword/, /Resolve-Path/, /Restart-(Computer|Service)/, /Restore-Computer/, /Resume-(Job|Service)/, /Save-Help/, /Select-(Object|String|Xml)/, /Send-MailMessage/, new RegExp("Set-(Acl|Alias|AuthenticodeSignature|Content|Date|ExecutionPolicy|Item(Property)?|Location|PSBreakpoint|PSDebug|PSSessionConfiguration|Service|StrictMode|TraceSource|Variable|WmiInstance)"), /Show-(Command|ControlPanelItem|EventLog)/, /Sort-Object/, /Split-Path/, /Start-(Job|Process|Service|Sleep|Transaction|Transcript)/, /Stop-(Computer|Job|Process|Service|Transcript)/, /Suspend-(Job|Service)/, /TabExpansion2/, /Tee-Object/, /Test-(ComputerSecureChannel|Connection|ModuleManifest|Path|PSSessionConfigurationFile)/, /Trace-Command/, /Unblock-File/, /Undo-Transaction/, /Unregister-(Event|PSSessionConfiguration)/, /Update-(FormatData|Help|List|TypeData)/, /Use-Transaction/, /Wait-(Event|Job|Process)/, /Where-Object/, /Write-(Debug|Error|EventLog|Host|Output|Progress|Verbose|Warning)/, /cd|help|mkdir|more|oss|prompt/, /ac|asnp|cat|cd|chdir|clc|clear|clhy|cli|clp|cls|clv|cnsn|compare|copy|cp|cpi|cpp|cvpa|dbp|del|diff|dir|dnsn|ebp/, /echo|epal|epcsv|epsn|erase|etsn|exsn|fc|fl|foreach|ft|fw|gal|gbp|gc|gci|gcm|gcs|gdr|ghy|gi|gjb|gl|gm|gmo|gp|gps/, /group|gsn|gsnp|gsv|gu|gv|gwmi|h|history|icm|iex|ihy|ii|ipal|ipcsv|ipmo|ipsn|irm|ise|iwmi|iwr|kill|lp|ls|man|md/, /measure|mi|mount|move|mp|mv|nal|ndr|ni|nmo|npssc|nsn|nv|ogv|oh|popd|ps|pushd|pwd|r|rbp|rcjb|rcsn|rd|rdr|ren|ri/, /rjb|rm|rmdir|rmo|rni|rnp|rp|rsn|rsnp|rujb|rv|rvpa|rwmi|sajb|sal|saps|sasv|sbp|sc|select|set|shcm|si|sl|sleep|sls/, /sort|sp|spjb|spps|spsv|start|sujb|sv|swmi|tee|trcm|type|where|wjb|write/], {
                prefix: "",
                suffix: ""
              }),
              s = e([/[$?^_]|Args|ConfirmPreference|ConsoleFileName|DebugPreference|Error|ErrorActionPreference|ErrorView|ExecutionContext/, /FormatEnumerationLimit|Home|Host|Input|MaximumAliasCount|MaximumDriveCount|MaximumErrorCount|MaximumFunctionCount/, /MaximumHistoryCount|MaximumVariableCount|MyInvocation|NestedPromptLevel|OutputEncoding|Pid|Profile|ProgressPreference/, /PSBoundParameters|PSCommandPath|PSCulture|PSDefaultParameterValues|PSEmailServer|PSHome|PSScriptRoot|PSSessionApplicationName/, /PSSessionConfigurationName|PSSessionOption|PSUICulture|PSVersionTable|Pwd|ShellId|StackTrace|VerbosePreference/, /WarningPreference|WhatIfPreference/, /Event|EventArgs|EventSubscriber|Sender/, /Matches|Ofs|ForEach|LastExitCode|PSCmdlet|PSItem|PSSenderInfo|This/, /true|false|null/], {
                prefix: "\\$",
                suffix: ""
              }),
              l = {
                keyword: n,
                number: /^((0x[\da-f]+)|((\d+\.\d+|\d\.|\.\d+|\d+)(e[\+\-]?\d+)?))[ld]?([kmgtp]b)?/i,
                operator: o,
                builtin: e([/[A-Z]:|%|\?/i, a, s], {
                  suffix: t
                }),
                punctuation: /[\[\]{},;`\\\.]|@[({]/,
                identifier: /^[A-Za-z\_][A-Za-z\-\_\d]*\b/
              };
            function c(e, t) {
              var n = t.returnStack[t.returnStack.length - 1];
              if (n && n.shouldReturnFrom(t)) return t.tokenize = n.tokenize, t.returnStack.pop(), t.tokenize(e, t);
              if (e.eatSpace()) return null;
              if (e.eat("(")) return t.bracketNesting += 1, "punctuation";
              if (e.eat(")")) return t.bracketNesting -= 1, "punctuation";
              for (var i in l) {
                if (e.match(l[i])) return i;
              }
              var o = e.next();
              if ("'" === o) return function (e, t) {
                var r;
                for (; null != (r = e.peek());) {
                  if (e.next(), "'" === r && !e.eat("'")) return t.tokenize = c, "string";
                }
                return "error";
              }(e, t);
              if ("$" === o) return g(e, t);
              if ('"' === o) return u(e, t);
              if ("<" === o && e.eat("#")) return t.tokenize = h, h(e, t);
              if ("#" === o) return e.skipToEnd(), "comment";
              if ("@" === o) {
                var a = e.eat(/["']/);
                if (a && e.eol()) return t.tokenize = v, t.startQuote = a[0], v(e, t);
                if (e.eol()) return "error";
                if (e.peek().match(/[({]/)) return "punctuation";
                if (e.peek().match(r)) return g(e, t);
              }
              return "error";
            }
            function u(e, t) {
              for (var r; null != (r = e.peek());) {
                if ("$" === r) return t.tokenize = d, "string";
                if (e.next(), "`" !== r) {
                  if ('"' === r && !e.eat('"')) return t.tokenize = c, "string";
                } else e.next();
              }
              return "error";
            }
            function d(e, t) {
              return m(e, t, u);
            }
            function p(e, t) {
              return t.tokenize = v, t.startQuote = '"', v(e, t);
            }
            function f(e, t) {
              return m(e, t, p);
            }
            function m(e, t, r) {
              if (e.match("$(")) {
                var n = t.bracketNesting;
                return t.returnStack.push({
                  shouldReturnFrom: function shouldReturnFrom(e) {
                    return e.bracketNesting === n;
                  },
                  tokenize: r
                }), t.tokenize = c, t.bracketNesting += 1, "punctuation";
              }
              return e.next(), t.returnStack.push({
                shouldReturnFrom: function shouldReturnFrom() {
                  return !0;
                },
                tokenize: r
              }), t.tokenize = g, t.tokenize(e, t);
            }
            function h(e, t) {
              for (var r, n = !1; null != (r = e.next());) {
                if (n && ">" == r) {
                  t.tokenize = c;
                  break;
                }
                n = "#" === r;
              }
              return "comment";
            }
            function g(e, t) {
              var n = e.peek();
              return e.eat("{") ? (t.tokenize = y, y(e, t)) : null != n && n.match(r) ? (e.eatWhile(r), t.tokenize = c, "variable-2") : (t.tokenize = c, "error");
            }
            function y(e, t) {
              for (var r; null != (r = e.next());) {
                if ("}" === r) {
                  t.tokenize = c;
                  break;
                }
              }
              return "variable-2";
            }
            function v(e, t) {
              var r = t.startQuote;
              if (e.sol() && e.match(new RegExp(r + "@"))) t.tokenize = c;else if ('"' === r) for (; !e.eol();) {
                var n = e.peek();
                if ("$" === n) return t.tokenize = f, "string";
                e.next(), "`" === n && e.next();
              } else e.skipToEnd();
              return "string";
            }
            return {
              startState: function startState() {
                return {
                  returnStack: [],
                  bracketNesting: 0,
                  tokenize: c
                };
              },
              token: function token(e, t) {
                return t.tokenize(e, t);
              },
              blockCommentStart: "<#",
              blockCommentEnd: "#>",
              lineComment: "#",
              fold: "brace"
            };
          }), e.defineMIME("application/x-powershell", "powershell");
        });
      },
      7568: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          function t(e) {
            return new RegExp("^((" + e.join(")|(") + "))\\b");
          }
          var r,
            n = t(["and", "or", "not", "is"]),
            i = ["as", "assert", "break", "class", "continue", "def", "del", "elif", "else", "except", "finally", "for", "from", "global", "if", "import", "lambda", "pass", "raise", "return", "try", "while", "with", "yield", "in"],
            o = ["abs", "all", "any", "bin", "bool", "bytearray", "callable", "chr", "classmethod", "compile", "complex", "delattr", "dict", "dir", "divmod", "enumerate", "eval", "filter", "float", "format", "frozenset", "getattr", "globals", "hasattr", "hash", "help", "hex", "id", "input", "int", "isinstance", "issubclass", "iter", "len", "list", "locals", "map", "max", "memoryview", "min", "next", "object", "oct", "open", "ord", "pow", "property", "range", "repr", "reversed", "round", "set", "setattr", "slice", "sorted", "staticmethod", "str", "sum", "super", "tuple", "type", "vars", "zip", "__import__", "NotImplemented", "Ellipsis", "__debug__"];
          function a(e) {
            return e.scopes[e.scopes.length - 1];
          }
          e.registerHelper("hintWords", "python", i.concat(o)), e.defineMode("python", function (r, s) {
            for (var l = "error", c = s.delimiters || s.singleDelimiters || /^[\(\)\[\]\{\}@,:`=;\.\\]/, u = [s.singleOperators, s.doubleOperators, s.doubleDelimiters, s.tripleDelimiters, s.operators || /^([-+*/%\/&|^]=?|[<>=]+|\/\/=?|\*\*=?|!=|[~!@]|\.\.\.)/], d = 0; d < u.length; d++) {
              u[d] || u.splice(d--, 1);
            }
            var p = s.hangingIndent || r.indentUnit,
              f = i,
              m = o;
            null != s.extra_keywords && (f = f.concat(s.extra_keywords)), null != s.extra_builtins && (m = m.concat(s.extra_builtins));
            var h = !(s.version && Number(s.version) < 3);
            if (h) {
              var g = s.identifiers || /^[_A-Za-z\u00A1-\uFFFF][_A-Za-z0-9\u00A1-\uFFFF]*/;
              f = f.concat(["nonlocal", "False", "True", "None", "async", "await"]), m = m.concat(["ascii", "bytes", "exec", "print"]);
              var y = new RegExp("^(([rbuf]|(br)|(fr))?('{3}|\"{3}|['\"]))", "i");
            } else g = s.identifiers || /^[_A-Za-z][_A-Za-z0-9]*/, f = f.concat(["exec", "print"]), m = m.concat(["apply", "basestring", "buffer", "cmp", "coerce", "execfile", "file", "intern", "long", "raw_input", "reduce", "reload", "unichr", "unicode", "xrange", "False", "True", "None"]), y = new RegExp("^(([rubf]|(ur)|(br))?('{3}|\"{3}|['\"]))", "i");
            var v = t(f),
              b = t(m);
            function x(e, t) {
              var r = e.sol() && "\\" != t.lastToken;
              if (r && (t.indent = e.indentation()), r && "py" == a(t).type) {
                var n = a(t).offset;
                if (e.eatSpace()) {
                  var i = e.indentation();
                  return i > n ? w(t) : i < n && _(e, t) && "#" != e.peek() && (t.errorToken = !0), null;
                }
                var o = k(e, t);
                return n > 0 && _(e, t) && (o += " error"), o;
              }
              return k(e, t);
            }
            function k(e, t, r) {
              if (e.eatSpace()) return null;
              if (!r && e.match(/^#.*/)) return "comment";
              if (e.match(/^[0-9\.]/, !1)) {
                var i = !1;
                if (e.match(/^[\d_]*\.\d+(e[\+\-]?\d+)?/i) && (i = !0), e.match(/^[\d_]+\.\d*/) && (i = !0), e.match(/^\.\d+/) && (i = !0), i) return e.eat(/J/i), "number";
                var o = !1;
                if (e.match(/^0x[0-9a-f_]+/i) && (o = !0), e.match(/^0b[01_]+/i) && (o = !0), e.match(/^0o[0-7_]+/i) && (o = !0), e.match(/^[1-9][\d_]*(e[\+\-]?[\d_]+)?/) && (e.eat(/J/i), o = !0), e.match(/^0(?![\dx])/i) && (o = !0), o) return e.eat(/L/i), "number";
              }
              if (e.match(y)) return -1 !== e.current().toLowerCase().indexOf("f") ? (t.tokenize = function (e, t) {
                for (; "rubf".indexOf(e.charAt(0).toLowerCase()) >= 0;) {
                  e = e.substr(1);
                }
                var r = 1 == e.length,
                  n = "string";
                function i(e) {
                  return function (t, r) {
                    var n = k(t, r, !0);
                    return "punctuation" == n && ("{" == t.current() ? r.tokenize = i(e + 1) : "}" == t.current() && (r.tokenize = e > 1 ? i(e - 1) : o)), n;
                  };
                }
                function o(o, a) {
                  for (; !o.eol();) {
                    if (o.eatWhile(/[^'"\{\}\\]/), o.eat("\\")) {
                      if (o.next(), r && o.eol()) return n;
                    } else {
                      if (o.match(e)) return a.tokenize = t, n;
                      if (o.match("{{")) return n;
                      if (o.match("{", !1)) return a.tokenize = i(0), o.current() ? n : a.tokenize(o, a);
                      if (o.match("}}")) return n;
                      if (o.match("}")) return l;
                      o.eat(/['"]/);
                    }
                  }
                  if (r) {
                    if (s.singleLineStringErrors) return l;
                    a.tokenize = t;
                  }
                  return n;
                }
                return o.isString = !0, o;
              }(e.current(), t.tokenize), t.tokenize(e, t)) : (t.tokenize = function (e, t) {
                for (; "rubf".indexOf(e.charAt(0).toLowerCase()) >= 0;) {
                  e = e.substr(1);
                }
                var r = 1 == e.length,
                  n = "string";
                function i(i, o) {
                  for (; !i.eol();) {
                    if (i.eatWhile(/[^'"\\]/), i.eat("\\")) {
                      if (i.next(), r && i.eol()) return n;
                    } else {
                      if (i.match(e)) return o.tokenize = t, n;
                      i.eat(/['"]/);
                    }
                  }
                  if (r) {
                    if (s.singleLineStringErrors) return l;
                    o.tokenize = t;
                  }
                  return n;
                }
                return i.isString = !0, i;
              }(e.current(), t.tokenize), t.tokenize(e, t));
              for (var a = 0; a < u.length; a++) {
                if (e.match(u[a])) return "operator";
              }
              return e.match(c) ? "punctuation" : "." == t.lastToken && e.match(g) ? "property" : e.match(v) || e.match(n) ? "keyword" : e.match(b) ? "builtin" : e.match(/^(self|cls)\b/) ? "variable-2" : e.match(g) ? "def" == t.lastToken || "class" == t.lastToken ? "def" : "variable" : (e.next(), r ? null : l);
            }
            function w(e) {
              for (; "py" != a(e).type;) {
                e.scopes.pop();
              }
              e.scopes.push({
                offset: a(e).offset + r.indentUnit,
                type: "py",
                align: null
              });
            }
            function _(e, t) {
              for (var r = e.indentation(); t.scopes.length > 1 && a(t).offset > r;) {
                if ("py" != a(t).type) return !0;
                t.scopes.pop();
              }
              return a(t).offset != r;
            }
            function S(e, t) {
              e.sol() && (t.beginningOfLine = !0);
              var r = t.tokenize(e, t),
                n = e.current();
              if (t.beginningOfLine && "@" == n) return e.match(g, !1) ? "meta" : h ? "operator" : l;
              if (/\S/.test(n) && (t.beginningOfLine = !1), "variable" != r && "builtin" != r || "meta" != t.lastToken || (r = "meta"), "pass" != n && "return" != n || (t.dedent += 1), "lambda" == n && (t.lambda = !0), ":" != n || t.lambda || "py" != a(t).type || w(t), 1 == n.length && !/string|comment/.test(r)) {
                var i = "[({".indexOf(n);
                if (-1 != i && function (e, t, r) {
                  var n = e.match(/^([\s\[\{\(]|#.*)*$/, !1) ? null : e.column() + 1;
                  t.scopes.push({
                    offset: t.indent + p,
                    type: r,
                    align: n
                  });
                }(e, t, "])}".slice(i, i + 1)), -1 != (i = "])}".indexOf(n))) {
                  if (a(t).type != n) return l;
                  t.indent = t.scopes.pop().offset - p;
                }
              }
              return t.dedent > 0 && e.eol() && "py" == a(t).type && (t.scopes.length > 1 && t.scopes.pop(), t.dedent -= 1), r;
            }
            return {
              startState: function startState(e) {
                return {
                  tokenize: x,
                  scopes: [{
                    offset: e || 0,
                    type: "py",
                    align: null
                  }],
                  indent: e || 0,
                  lastToken: null,
                  lambda: !1,
                  dedent: 0
                };
              },
              token: function token(e, t) {
                var r = t.errorToken;
                r && (t.errorToken = !1);
                var n = S(e, t);
                return n && "comment" != n && (t.lastToken = "keyword" == n || "punctuation" == n ? e.current() : n), "punctuation" == n && (n = null), e.eol() && t.lambda && (t.lambda = !1), r ? n + " " + l : n;
              },
              indent: function indent(t, r) {
                if (t.tokenize != x) return t.tokenize.isString ? e.Pass : 0;
                var n = a(t),
                  i = n.type == r.charAt(0);
                return null != n.align ? n.align - (i ? 1 : 0) : n.offset - (i ? p : 0);
              },
              electricInput: /^\s*[\}\]\)]$/,
              closeBrackets: {
                triples: "'\""
              },
              lineComment: "#",
              fold: "indent"
            };
          }), e.defineMIME("text/x-python", "python"), e.defineMIME("text/x-cython", {
            name: "python",
            extra_keywords: (r = "by cdef cimport cpdef ctypedef enum except extern gil include nogil property public readonly struct union DEF IF ELIF ELSE", r.split(" "))
          });
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      8446: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.registerHelper("wordChars", "r", /[\w.]/), e.defineMode("r", function (t) {
            function r(e) {
              for (var t = {}, r = 0; r < e.length; ++r) {
                t[e[r]] = !0;
              }
              return t;
            }
            var n = ["NULL", "NA", "Inf", "NaN", "NA_integer_", "NA_real_", "NA_complex_", "NA_character_", "TRUE", "FALSE"],
              i = ["list", "quote", "bquote", "eval", "return", "call", "parse", "deparse"],
              o = ["if", "else", "repeat", "while", "function", "for", "in", "next", "break"];
            e.registerHelper("hintWords", "r", n.concat(i, o));
            var a,
              s = r(n),
              l = r(i),
              c = r(o),
              u = r(["if", "else", "repeat", "while", "function", "for"]),
              d = /[+\-*\/^<>=!&|~$:]/;
            function p(e, t) {
              a = null;
              var r,
                n = e.next();
              if ("#" == n) return e.skipToEnd(), "comment";
              if ("0" == n && e.eat("x")) return e.eatWhile(/[\da-f]/i), "number";
              if ("." == n && e.eat(/\d/)) return e.match(/\d*(?:e[+\-]?\d+)?/), "number";
              if (/\d/.test(n)) return e.match(/\d*(?:\.\d+)?(?:e[+\-]\d+)?L?/), "number";
              if ("'" == n || '"' == n) return t.tokenize = (r = n, function (e, t) {
                if (e.eat("\\")) {
                  var n = e.next();
                  return "x" == n ? e.match(/^[a-f0-9]{2}/i) : ("u" == n || "U" == n) && e.eat("{") && e.skipTo("}") ? e.next() : "u" == n ? e.match(/^[a-f0-9]{4}/i) : "U" == n ? e.match(/^[a-f0-9]{8}/i) : /[0-7]/.test(n) && e.match(/^[0-7]{1,2}/), "string-2";
                }
                for (var i; null != (i = e.next());) {
                  if (i == r) {
                    t.tokenize = p;
                    break;
                  }
                  if ("\\" == i) {
                    e.backUp(1);
                    break;
                  }
                }
                return "string";
              }), "string";
              if ("`" == n) return e.match(/[^`]+`/), "variable-3";
              if ("." == n && e.match(/.[.\d]+/)) return "keyword";
              if (/[\w\.]/.test(n) && "_" != n) {
                e.eatWhile(/[\w\.]/);
                var i = e.current();
                return s.propertyIsEnumerable(i) ? "atom" : c.propertyIsEnumerable(i) ? (u.propertyIsEnumerable(i) && !e.match(/\s*if(\s+|$)/, !1) && (a = "block"), "keyword") : l.propertyIsEnumerable(i) ? "builtin" : "variable";
              }
              return "%" == n ? (e.skipTo("%") && e.next(), "operator variable-2") : "<" == n && e.eat("-") || "<" == n && e.match("<-") || "-" == n && e.match(/>>?/) ? "operator arrow" : "=" == n && t.ctx.argList ? "arg-is" : d.test(n) ? "$" == n ? "operator dollar" : (e.eatWhile(d), "operator") : /[\(\){}\[\];]/.test(n) ? (a = n, ";" == n ? "semi" : null) : null;
            }
            function f(e, t, r) {
              e.ctx = {
                type: t,
                indent: e.indent,
                flags: 0,
                column: r.column(),
                prev: e.ctx
              };
            }
            function m(e, t) {
              var r = e.ctx;
              e.ctx = {
                type: r.type,
                indent: r.indent,
                flags: r.flags | t,
                column: r.column,
                prev: r.prev
              };
            }
            function h(e) {
              e.indent = e.ctx.indent, e.ctx = e.ctx.prev;
            }
            return {
              startState: function startState() {
                return {
                  tokenize: p,
                  ctx: {
                    type: "top",
                    indent: -t.indentUnit,
                    flags: 2
                  },
                  indent: 0,
                  afterIdent: !1
                };
              },
              token: function token(e, t) {
                if (e.sol() && (0 == (3 & t.ctx.flags) && (t.ctx.flags |= 2), 4 & t.ctx.flags && h(t), t.indent = e.indentation()), e.eatSpace()) return null;
                var r = t.tokenize(e, t);
                return "comment" != r && 0 == (2 & t.ctx.flags) && m(t, 1), ";" != a && "{" != a && "}" != a || "block" != t.ctx.type || h(t), "{" == a ? f(t, "}", e) : "(" == a ? (f(t, ")", e), t.afterIdent && (t.ctx.argList = !0)) : "[" == a ? f(t, "]", e) : "block" == a ? f(t, "block", e) : a == t.ctx.type ? h(t) : "block" == t.ctx.type && "comment" != r && m(t, 4), t.afterIdent = "variable" == r || "keyword" == r, r;
              },
              indent: function indent(e, r) {
                if (e.tokenize != p) return 0;
                var n = r && r.charAt(0),
                  i = e.ctx,
                  o = n == i.type;
                return 4 & i.flags && (i = i.prev), "block" == i.type ? i.indent + ("{" == n ? 0 : t.indentUnit) : 1 & i.flags ? i.column + (o ? 0 : 1) : i.indent + (o ? 0 : t.indentUnit);
              },
              lineComment: "#"
            };
          }), e.defineMIME("text/x-rsrc", "r");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      8021: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMode("ruby", function (t) {
            function r(e) {
              for (var t = {}, r = 0, n = e.length; r < n; ++r) {
                t[e[r]] = !0;
              }
              return t;
            }
            var n,
              i = r(["alias", "and", "BEGIN", "begin", "break", "case", "class", "def", "defined?", "do", "else", "elsif", "END", "end", "ensure", "false", "for", "if", "in", "module", "next", "not", "or", "redo", "rescue", "retry", "return", "self", "super", "then", "true", "undef", "unless", "until", "when", "while", "yield", "nil", "raise", "throw", "catch", "fail", "loop", "callcc", "caller", "lambda", "proc", "public", "protected", "private", "require", "load", "require_relative", "extend", "autoload", "__END__", "__FILE__", "__LINE__", "__dir__"]),
              o = r(["def", "class", "case", "for", "while", "until", "module", "then", "catch", "loop", "proc", "begin"]),
              a = r(["end", "until"]),
              s = {
                "[": "]",
                "{": "}",
                "(": ")"
              },
              l = {
                "]": "[",
                "}": "{",
                ")": "("
              };
            function c(e, t, r) {
              return r.tokenize.push(e), e(t, r);
            }
            function u(e, t) {
              if (e.sol() && e.match("=begin") && e.eol()) return t.tokenize.push(m), "comment";
              if (e.eatSpace()) return null;
              var r,
                i,
                o,
                a = e.next();
              if ("`" == a || "'" == a || '"' == a) return c(f(a, "string", '"' == a || "`" == a), e, t);
              if ("/" == a) return function (e) {
                for (var t, r = e.pos, n = 0, i = !1, o = !1; null != (t = e.next());) {
                  if (o) o = !1;else {
                    if ("[{(".indexOf(t) > -1) n++;else if ("]})".indexOf(t) > -1) {
                      if (--n < 0) break;
                    } else if ("/" == t && 0 == n) {
                      i = !0;
                      break;
                    }
                    o = "\\" == t;
                  }
                }
                return e.backUp(e.pos - r), i;
              }(e) ? c(f(a, "string-2", !0), e, t) : "operator";
              if ("%" == a) {
                var l = "string",
                  u = !0;
                e.eat("s") ? l = "atom" : e.eat(/[WQ]/) ? l = "string" : e.eat(/[r]/) ? l = "string-2" : e.eat(/[wxq]/) && (l = "string", u = !1);
                var d = e.eat(/[^\w\s=]/);
                return d ? (s.propertyIsEnumerable(d) && (d = s[d]), c(f(d, l, u, !0), e, t)) : "operator";
              }
              if ("#" == a) return e.skipToEnd(), "comment";
              if ("<" == a && (r = e.match(/^<([-~])[\`\"\']?([a-zA-Z_?]\w*)[\`\"\']?(?:;|$)/))) return c((i = r[2], o = r[1], function (e, t) {
                return o && e.eatSpace(), e.match(i) ? t.tokenize.pop() : e.skipToEnd(), "string";
              }), e, t);
              if ("0" == a) return e.eat("x") ? e.eatWhile(/[\da-fA-F]/) : e.eat("b") ? e.eatWhile(/[01]/) : e.eatWhile(/[0-7]/), "number";
              if (/\d/.test(a)) return e.match(/^[\d_]*(?:\.[\d_]+)?(?:[eE][+\-]?[\d_]+)?/), "number";
              if ("?" == a) {
                for (; e.match(/^\\[CM]-/);) {
                  ;
                }
                return e.eat("\\") ? e.eatWhile(/\w/) : e.next(), "string";
              }
              if (":" == a) return e.eat("'") ? c(f("'", "atom", !1), e, t) : e.eat('"') ? c(f('"', "atom", !0), e, t) : e.eat(/[\<\>]/) ? (e.eat(/[\<\>]/), "atom") : e.eat(/[\+\-\*\/\&\|\:\!]/) ? "atom" : e.eat(/[a-zA-Z$@_\xa1-\uffff]/) ? (e.eatWhile(/[\w$\xa1-\uffff]/), e.eat(/[\?\!\=]/), "atom") : "operator";
              if ("@" == a && e.match(/^@?[a-zA-Z_\xa1-\uffff]/)) return e.eat("@"), e.eatWhile(/[\w\xa1-\uffff]/), "variable-2";
              if ("$" == a) return e.eat(/[a-zA-Z_]/) ? e.eatWhile(/[\w]/) : e.eat(/\d/) ? e.eat(/\d/) : e.next(), "variable-3";
              if (/[a-zA-Z_\xa1-\uffff]/.test(a)) return e.eatWhile(/[\w\xa1-\uffff]/), e.eat(/[\?\!]/), e.eat(":") ? "atom" : "ident";
              if ("|" != a || !t.varList && "{" != t.lastTok && "do" != t.lastTok) {
                if (/[\(\)\[\]{}\\;]/.test(a)) return n = a, null;
                if ("-" == a && e.eat(">")) return "arrow";
                if (/[=+\-\/*:\.^%<>~|]/.test(a)) {
                  var p = e.eatWhile(/[=+\-\/*:\.^%<>~|]/);
                  return "." != a || p || (n = "."), "operator";
                }
                return null;
              }
              return n = "|", null;
            }
            function d(e) {
              return e || (e = 1), function (t, r) {
                if ("}" == t.peek()) {
                  if (1 == e) return r.tokenize.pop(), r.tokenize[r.tokenize.length - 1](t, r);
                  r.tokenize[r.tokenize.length - 1] = d(e - 1);
                } else "{" == t.peek() && (r.tokenize[r.tokenize.length - 1] = d(e + 1));
                return u(t, r);
              };
            }
            function p() {
              var e = !1;
              return function (t, r) {
                return e ? (r.tokenize.pop(), r.tokenize[r.tokenize.length - 1](t, r)) : (e = !0, u(t, r));
              };
            }
            function f(e, t, r, n) {
              return function (i, o) {
                var a,
                  s = !1;
                for ("read-quoted-paused" === o.context.type && (o.context = o.context.prev, i.eat("}")); null != (a = i.next());) {
                  if (a == e && (n || !s)) {
                    o.tokenize.pop();
                    break;
                  }
                  if (r && "#" == a && !s) {
                    if (i.eat("{")) {
                      "}" == e && (o.context = {
                        prev: o.context,
                        type: "read-quoted-paused"
                      }), o.tokenize.push(d());
                      break;
                    }
                    if (/[@\$]/.test(i.peek())) {
                      o.tokenize.push(p());
                      break;
                    }
                  }
                  s = !s && "\\" == a;
                }
                return t;
              };
            }
            function m(e, t) {
              return e.sol() && e.match("=end") && e.eol() && t.tokenize.pop(), e.skipToEnd(), "comment";
            }
            return {
              startState: function startState() {
                return {
                  tokenize: [u],
                  indented: 0,
                  context: {
                    type: "top",
                    indented: -t.indentUnit
                  },
                  continuedLine: !1,
                  lastTok: null,
                  varList: !1
                };
              },
              token: function token(e, t) {
                n = null, e.sol() && (t.indented = e.indentation());
                var r,
                  s = t.tokenize[t.tokenize.length - 1](e, t),
                  l = n;
                if ("ident" == s) {
                  var c = e.current();
                  "keyword" == (s = "." == t.lastTok ? "property" : i.propertyIsEnumerable(e.current()) ? "keyword" : /^[A-Z]/.test(c) ? "tag" : "def" == t.lastTok || "class" == t.lastTok || t.varList ? "def" : "variable") && (l = c, o.propertyIsEnumerable(c) ? r = "indent" : a.propertyIsEnumerable(c) ? r = "dedent" : "if" != c && "unless" != c || e.column() != e.indentation() ? "do" == c && t.context.indented < t.indented && (r = "indent") : r = "indent");
                }
                return (n || s && "comment" != s) && (t.lastTok = l), "|" == n && (t.varList = !t.varList), "indent" == r || /[\(\[\{]/.test(n) ? t.context = {
                  prev: t.context,
                  type: n || s,
                  indented: t.indented
                } : ("dedent" == r || /[\)\]\}]/.test(n)) && t.context.prev && (t.context = t.context.prev), e.eol() && (t.continuedLine = "\\" == n || "operator" == s), s;
              },
              indent: function indent(r, n) {
                if (r.tokenize[r.tokenize.length - 1] != u) return e.Pass;
                var i = n && n.charAt(0),
                  o = r.context,
                  a = o.type == l[i] || "keyword" == o.type && /^(?:end|until|else|elsif|when|rescue)\b/.test(n);
                return o.indented + (a ? 0 : t.indentUnit) + (r.continuedLine ? t.indentUnit : 0);
              },
              electricInput: /^\s*(?:end|rescue|elsif|else|\})$/,
              lineComment: "#",
              fold: "indent"
            };
          }), e.defineMIME("text/x-ruby", "ruby");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      8058: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineSimpleMode("rust", {
            start: [{
              regex: /b?"/,
              token: "string",
              next: "string"
            }, {
              regex: /b?r"/,
              token: "string",
              next: "string_raw"
            }, {
              regex: /b?r#+"/,
              token: "string",
              next: "string_raw_hash"
            }, {
              regex: /'(?:[^'\\]|\\(?:[nrt0'"]|x[\da-fA-F]{2}|u\{[\da-fA-F]{6}\}))'/,
              token: "string-2"
            }, {
              regex: /b'(?:[^']|\\(?:['\\nrt0]|x[\da-fA-F]{2}))'/,
              token: "string-2"
            }, {
              regex: /(?:(?:[0-9][0-9_]*)(?:(?:[Ee][+-]?[0-9_]+)|\.[0-9_]+(?:[Ee][+-]?[0-9_]+)?)(?:f32|f64)?)|(?:0(?:b[01_]+|(?:o[0-7_]+)|(?:x[0-9a-fA-F_]+))|(?:[0-9][0-9_]*))(?:u8|u16|u32|u64|i8|i16|i32|i64|isize|usize)?/,
              token: "number"
            }, {
              regex: /(let(?:\s+mut)?|fn|enum|mod|struct|type|union)(\s+)([a-zA-Z_][a-zA-Z0-9_]*)/,
              token: ["keyword", null, "def"]
            }, {
              regex: /(?:abstract|alignof|as|async|await|box|break|continue|const|crate|do|dyn|else|enum|extern|fn|for|final|if|impl|in|loop|macro|match|mod|move|offsetof|override|priv|proc|pub|pure|ref|return|self|sizeof|static|struct|super|trait|type|typeof|union|unsafe|unsized|use|virtual|where|while|yield)\b/,
              token: "keyword"
            }, {
              regex: /\b(?:Self|isize|usize|char|bool|u8|u16|u32|u64|f16|f32|f64|i8|i16|i32|i64|str|Option)\b/,
              token: "atom"
            }, {
              regex: /\b(?:true|false|Some|None|Ok|Err)\b/,
              token: "builtin"
            }, {
              regex: /\b(fn)(\s+)([a-zA-Z_][a-zA-Z0-9_]*)/,
              token: ["keyword", null, "def"]
            }, {
              regex: /#!?\[.*\]/,
              token: "meta"
            }, {
              regex: /\/\/.*/,
              token: "comment"
            }, {
              regex: /\/\*/,
              token: "comment",
              next: "comment"
            }, {
              regex: /[-+\/*=<>!]+/,
              token: "operator"
            }, {
              regex: /[a-zA-Z_]\w*!/,
              token: "variable-3"
            }, {
              regex: /[a-zA-Z_]\w*/,
              token: "variable"
            }, {
              regex: /[\{\[\(]/,
              indent: !0
            }, {
              regex: /[\}\]\)]/,
              dedent: !0
            }],
            string: [{
              regex: /"/,
              token: "string",
              next: "start"
            }, {
              regex: /(?:[^\\"]|\\(?:.|$))*/,
              token: "string"
            }],
            string_raw: [{
              regex: /"/,
              token: "string",
              next: "start"
            }, {
              regex: /[^"]*/,
              token: "string"
            }],
            string_raw_hash: [{
              regex: /"#+/,
              token: "string",
              next: "start"
            }, {
              regex: /(?:[^"]|"(?!#))*/,
              token: "string"
            }],
            comment: [{
              regex: /.*?\*\//,
              token: "comment",
              next: "start"
            }, {
              regex: /.*/,
              token: "comment"
            }],
            meta: {
              dontIndentStates: ["comment"],
              electricInput: /^\s*\}$/,
              blockCommentStart: "/*",
              blockCommentEnd: "*/",
              lineComment: "//",
              fold: "brace"
            }
          }), e.defineMIME("text/x-rustsrc", "rust"), e.defineMIME("text/rust", "rust");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074), r(3740)) : (i = [r(9074), r(3740)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      4949: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMode("shell", function () {
            var t = {};
            function r(e, r) {
              for (var n = 0; n < r.length; n++) {
                t[r[n]] = e;
              }
            }
            var n = ["true", "false"],
              i = ["if", "then", "do", "else", "elif", "while", "until", "for", "in", "esac", "fi", "fin", "fil", "done", "exit", "set", "unset", "export", "function"],
              o = ["ab", "awk", "bash", "beep", "cat", "cc", "cd", "chown", "chmod", "chroot", "clear", "cp", "curl", "cut", "diff", "echo", "find", "gawk", "gcc", "get", "git", "grep", "hg", "kill", "killall", "ln", "ls", "make", "mkdir", "openssl", "mv", "nc", "nl", "node", "npm", "ping", "ps", "restart", "rm", "rmdir", "sed", "service", "sh", "shopt", "shred", "source", "sort", "sleep", "ssh", "start", "stop", "su", "sudo", "svn", "tee", "telnet", "top", "touch", "vi", "vim", "wall", "wc", "wget", "who", "write", "yes", "zsh"];
            function a(e, r) {
              if (e.eatSpace()) return null;
              var n = e.sol(),
                i = e.next();
              if ("\\" === i) return e.next(), null;
              if ("'" === i || '"' === i || "`" === i) return r.tokens.unshift(s(i, "`" === i ? "quote" : "string")), u(e, r);
              if ("#" === i) return n && e.eat("!") ? (e.skipToEnd(), "meta") : (e.skipToEnd(), "comment");
              if ("$" === i) return r.tokens.unshift(c), u(e, r);
              if ("+" === i || "=" === i) return "operator";
              if ("-" === i) return e.eat("-"), e.eatWhile(/\w/), "attribute";
              if (/\d/.test(i) && (e.eatWhile(/\d/), e.eol() || !/\w/.test(e.peek()))) return "number";
              e.eatWhile(/[\w-]/);
              var o = e.current();
              return "=" === e.peek() && /\w+/.test(o) ? "def" : t.hasOwnProperty(o) ? t[o] : null;
            }
            function s(e, t) {
              var r = "(" == e ? ")" : "{" == e ? "}" : e;
              return function (n, i) {
                for (var o, a = !1; null != (o = n.next());) {
                  if (o === r && !a) {
                    i.tokens.shift();
                    break;
                  }
                  if ("$" === o && !a && "'" !== e && n.peek() != r) {
                    a = !0, n.backUp(1), i.tokens.unshift(c);
                    break;
                  }
                  if (!a && e !== r && o === e) return i.tokens.unshift(s(e, t)), u(n, i);
                  if (!a && /['"]/.test(o) && !/['"]/.test(e)) {
                    i.tokens.unshift(l(o, "string")), n.backUp(1);
                    break;
                  }
                  a = !a && "\\" === o;
                }
                return t;
              };
            }
            function l(e, t) {
              return function (r, n) {
                return n.tokens[0] = s(e, t), r.next(), u(r, n);
              };
            }
            e.registerHelper("hintWords", "shell", n.concat(i, o)), r("atom", n), r("keyword", i), r("builtin", o);
            var c = function c(e, t) {
              t.tokens.length > 1 && e.eat("$");
              var r = e.next();
              return /['"({]/.test(r) ? (t.tokens[0] = s(r, "(" == r ? "quote" : "{" == r ? "def" : "string"), u(e, t)) : (/\d/.test(r) || e.eatWhile(/\w/), t.tokens.shift(), "def");
            };
            function u(e, t) {
              return (t.tokens[0] || a)(e, t);
            }
            return {
              startState: function startState() {
                return {
                  tokens: []
                };
              },
              token: function token(e, t) {
                return u(e, t);
              },
              closeBrackets: "()[]{}''\"\"``",
              lineComment: "#",
              fold: "brace"
            };
          }), e.defineMIME("text/x-sh", "shell"), e.defineMIME("application/x-sh", "shell");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      6906: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          function t(e) {
            for (var t; null != (t = e.next());) {
              if ("`" == t && !e.eat("`")) return "variable-2";
            }
            return e.backUp(e.current().length - 1), e.eatWhile(/\w/) ? "variable-2" : null;
          }
          function r(e) {
            return e.eat("@") && (e.match(/^session\./), e.match(/^local\./), e.match(/^global\./)), e.eat("'") ? (e.match(/^.*'/), "variable-2") : e.eat('"') ? (e.match(/^.*"/), "variable-2") : e.eat("`") ? (e.match(/^.*`/), "variable-2") : e.match(/^[0-9a-zA-Z$\.\_]+/) ? "variable-2" : null;
          }
          function n(e) {
            return e.eat("N") ? "atom" : e.match(/^[a-zA-Z.#!?]/) ? "variable-2" : null;
          }
          e.defineMode("sql", function (t, r) {
            var n = r.client || {},
              s = r.atoms || {
                false: !0,
                true: !0,
                null: !0
              },
              l = r.builtin || o(a),
              c = r.keywords || o(i),
              u = r.operatorChars || /^[*+\-%<>!=&|~^\/]/,
              d = r.support || {},
              p = r.hooks || {},
              f = r.dateSQL || {
                date: !0,
                time: !0,
                timestamp: !0
              },
              m = !1 !== r.backslashStringEscapes,
              h = r.brackets || /^[\{}\(\)\[\]]/,
              g = r.punctuation || /^[;.,:]/;
            function y(e, t) {
              var r = e.next();
              if (p[r]) {
                var i = p[r](e, t);
                if (!1 !== i) return i;
              }
              if (d.hexNumber && ("0" == r && e.match(/^[xX][0-9a-fA-F]+/) || ("x" == r || "X" == r) && e.match(/^'[0-9a-fA-F]+'/))) return "number";
              if (d.binaryNumber && (("b" == r || "B" == r) && e.match(/^'[01]+'/) || "0" == r && e.match(/^b[01]+/))) return "number";
              if (r.charCodeAt(0) > 47 && r.charCodeAt(0) < 58) return e.match(/^[0-9]*(\.[0-9]+)?([eE][-+]?[0-9]+)?/), d.decimallessFloat && e.match(/^\.(?!\.)/), "number";
              if ("?" == r && (e.eatSpace() || e.eol() || e.eat(";"))) return "variable-3";
              if ("'" == r || '"' == r && d.doubleQuote) return t.tokenize = v(r), t.tokenize(e, t);
              if ((d.nCharCast && ("n" == r || "N" == r) || d.charsetCast && "_" == r && e.match(/[a-z][a-z0-9]*/i)) && ("'" == e.peek() || '"' == e.peek())) return "keyword";
              if (d.escapeConstant && ("e" == r || "E" == r) && ("'" == e.peek() || '"' == e.peek() && d.doubleQuote)) return t.tokenize = function (e, t) {
                return (t.tokenize = v(e.next(), !0))(e, t);
              }, "keyword";
              if (d.commentSlashSlash && "/" == r && e.eat("/")) return e.skipToEnd(), "comment";
              if (d.commentHash && "#" == r || "-" == r && e.eat("-") && (!d.commentSpaceRequired || e.eat(" "))) return e.skipToEnd(), "comment";
              if ("/" == r && e.eat("*")) return t.tokenize = b(1), t.tokenize(e, t);
              if ("." != r) {
                if (u.test(r)) return e.eatWhile(u), "operator";
                if (h.test(r)) return "bracket";
                if (g.test(r)) return e.eatWhile(g), "punctuation";
                if ("{" == r && (e.match(/^( )*(d|D|t|T|ts|TS)( )*'[^']*'( )*}/) || e.match(/^( )*(d|D|t|T|ts|TS)( )*"[^"]*"( )*}/))) return "number";
                e.eatWhile(/^[_\w\d]/);
                var o = e.current().toLowerCase();
                return f.hasOwnProperty(o) && (e.match(/^( )+'[^']*'/) || e.match(/^( )+"[^"]*"/)) ? "number" : s.hasOwnProperty(o) ? "atom" : l.hasOwnProperty(o) ? "builtin" : c.hasOwnProperty(o) ? "keyword" : n.hasOwnProperty(o) ? "string-2" : null;
              }
              return d.zerolessFloat && e.match(/^(?:\d+(?:e[+-]?\d+)?)/i) ? "number" : e.match(/^\.+/) ? null : d.ODBCdotTable && e.match(/^[\w\d_]+/) ? "variable-2" : void 0;
            }
            function v(e, t) {
              return function (r, n) {
                for (var i, o = !1; null != (i = r.next());) {
                  if (i == e && !o) {
                    n.tokenize = y;
                    break;
                  }
                  o = (m || t) && !o && "\\" == i;
                }
                return "string";
              };
            }
            function b(e) {
              return function (t, r) {
                var n = t.match(/^.*?(\/\*|\*\/)/);
                return n ? "/*" == n[1] ? r.tokenize = b(e + 1) : r.tokenize = e > 1 ? b(e - 1) : y : t.skipToEnd(), "comment";
              };
            }
            function x(e, t, r) {
              t.context = {
                prev: t.context,
                indent: e.indentation(),
                col: e.column(),
                type: r
              };
            }
            return {
              startState: function startState() {
                return {
                  tokenize: y,
                  context: null
                };
              },
              token: function token(e, t) {
                if (e.sol() && t.context && null == t.context.align && (t.context.align = !1), t.tokenize == y && e.eatSpace()) return null;
                var r = t.tokenize(e, t);
                if ("comment" == r) return r;
                t.context && null == t.context.align && (t.context.align = !0);
                var n = e.current();
                return "(" == n ? x(e, t, ")") : "[" == n ? x(e, t, "]") : t.context && t.context.type == n && function (e) {
                  e.indent = e.context.indent, e.context = e.context.prev;
                }(t), r;
              },
              indent: function indent(r, n) {
                var i = r.context;
                if (!i) return e.Pass;
                var o = n.charAt(0) == i.type;
                return i.align ? i.col + (o ? 0 : 1) : i.indent + (o ? 0 : t.indentUnit);
              },
              blockCommentStart: "/*",
              blockCommentEnd: "*/",
              lineComment: d.commentSlashSlash ? "//" : d.commentHash ? "#" : "--",
              closeBrackets: "()[]{}''\"\"``"
            };
          });
          var i = "alter and as asc between by count create delete desc distinct drop from group having in insert into is join like not on or order select set table union update values where limit ";
          function o(e) {
            for (var t = {}, r = e.split(" "), n = 0; n < r.length; ++n) {
              t[r[n]] = !0;
            }
            return t;
          }
          var a = "bool boolean bit blob enum long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision real date datetime year unsigned signed decimal numeric";
          e.defineMIME("text/x-sql", {
            name: "sql",
            keywords: o(i + "begin"),
            builtin: o(a),
            atoms: o("false true null unknown"),
            dateSQL: o("date time timestamp"),
            support: o("ODBCdotTable doubleQuote binaryNumber hexNumber")
          }), e.defineMIME("text/x-mssql", {
            name: "sql",
            client: o("$partition binary_checksum checksum connectionproperty context_info current_request_id error_line error_message error_number error_procedure error_severity error_state formatmessage get_filestream_transaction_context getansinull host_id host_name isnull isnumeric min_active_rowversion newid newsequentialid rowcount_big xact_state object_id"),
            keywords: o(i + "begin trigger proc view index for add constraint key primary foreign collate clustered nonclustered declare exec go if use index holdlock nolock nowait paglock readcommitted readcommittedlock readpast readuncommitted repeatableread rowlock serializable snapshot tablock tablockx updlock with"),
            builtin: o("bigint numeric bit smallint decimal smallmoney int tinyint money float real char varchar text nchar nvarchar ntext binary varbinary image cursor timestamp hierarchyid uniqueidentifier sql_variant xml table "),
            atoms: o("is not null like and or in left right between inner outer join all any some cross unpivot pivot exists"),
            operatorChars: /^[*+\-%<>!=^\&|\/]/,
            brackets: /^[\{}\(\)]/,
            punctuation: /^[;.,:/]/,
            backslashStringEscapes: !1,
            dateSQL: o("date datetimeoffset datetime2 smalldatetime datetime time"),
            hooks: {
              "@": r
            }
          }), e.defineMIME("text/x-mysql", {
            name: "sql",
            client: o("charset clear connect edit ego exit go help nopager notee nowarning pager print prompt quit rehash source status system tee"),
            keywords: o(i + "accessible action add after algorithm all analyze asensitive at authors auto_increment autocommit avg avg_row_length before binary binlog both btree cache call cascade cascaded case catalog_name chain change changed character check checkpoint checksum class_origin client_statistics close coalesce code collate collation collations column columns comment commit committed completion concurrent condition connection consistent constraint contains continue contributors convert cross current current_date current_time current_timestamp current_user cursor data database databases day_hour day_microsecond day_minute day_second deallocate dec declare default delay_key_write delayed delimiter des_key_file describe deterministic dev_pop dev_samp deviance diagnostics directory disable discard distinctrow div dual dumpfile each elseif enable enclosed end ends engine engines enum errors escape escaped even event events every execute exists exit explain extended fast fetch field fields first flush for force foreign found_rows full fulltext function general get global grant grants group group_concat handler hash help high_priority hosts hour_microsecond hour_minute hour_second if ignore ignore_server_ids import index index_statistics infile inner innodb inout insensitive insert_method install interval invoker isolation iterate key keys kill language last leading leave left level limit linear lines list load local localtime localtimestamp lock logs low_priority master master_heartbeat_period master_ssl_verify_server_cert masters match max max_rows maxvalue message_text middleint migrate min min_rows minute_microsecond minute_second mod mode modifies modify mutex mysql_errno natural next no no_write_to_binlog offline offset one online open optimize option optionally out outer outfile pack_keys parser partition partitions password phase plugin plugins prepare preserve prev primary privileges procedure processlist profile profiles purge query quick range read read_write reads real rebuild recover references regexp relaylog release remove rename reorganize repair repeatable replace require resignal restrict resume return returns revoke right rlike rollback rollup row row_format rtree savepoint schedule schema schema_name schemas second_microsecond security sensitive separator serializable server session share show signal slave slow smallint snapshot soname spatial specific sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_no_cache sql_small_result sqlexception sqlstate sqlwarning ssl start starting starts status std stddev stddev_pop stddev_samp storage straight_join subclass_origin sum suspend table_name table_statistics tables tablespace temporary terminated to trailing transaction trigger triggers truncate uncommitted undo uninstall unique unlock upgrade usage use use_frm user user_resources user_statistics using utc_date utc_time utc_timestamp value variables varying view views warnings when while with work write xa xor year_month zerofill begin do then else loop repeat"),
            builtin: o("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision date datetime year unsigned signed numeric"),
            atoms: o("false true null unknown"),
            operatorChars: /^[*+\-%<>!=&|^]/,
            dateSQL: o("date time timestamp"),
            support: o("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber doubleQuote nCharCast charsetCast commentHash commentSpaceRequired"),
            hooks: {
              "@": r,
              "`": t,
              "\\": n
            }
          }), e.defineMIME("text/x-mariadb", {
            name: "sql",
            client: o("charset clear connect edit ego exit go help nopager notee nowarning pager print prompt quit rehash source status system tee"),
            keywords: o(i + "accessible action add after algorithm all always analyze asensitive at authors auto_increment autocommit avg avg_row_length before binary binlog both btree cache call cascade cascaded case catalog_name chain change changed character check checkpoint checksum class_origin client_statistics close coalesce code collate collation collations column columns comment commit committed completion concurrent condition connection consistent constraint contains continue contributors convert cross current current_date current_time current_timestamp current_user cursor data database databases day_hour day_microsecond day_minute day_second deallocate dec declare default delay_key_write delayed delimiter des_key_file describe deterministic dev_pop dev_samp deviance diagnostics directory disable discard distinctrow div dual dumpfile each elseif enable enclosed end ends engine engines enum errors escape escaped even event events every execute exists exit explain extended fast fetch field fields first flush for force foreign found_rows full fulltext function general generated get global grant grants group groupby_concat handler hard hash help high_priority hosts hour_microsecond hour_minute hour_second if ignore ignore_server_ids import index index_statistics infile inner innodb inout insensitive insert_method install interval invoker isolation iterate key keys kill language last leading leave left level limit linear lines list load local localtime localtimestamp lock logs low_priority master master_heartbeat_period master_ssl_verify_server_cert masters match max max_rows maxvalue message_text middleint migrate min min_rows minute_microsecond minute_second mod mode modifies modify mutex mysql_errno natural next no no_write_to_binlog offline offset one online open optimize option optionally out outer outfile pack_keys parser partition partitions password persistent phase plugin plugins prepare preserve prev primary privileges procedure processlist profile profiles purge query quick range read read_write reads real rebuild recover references regexp relaylog release remove rename reorganize repair repeatable replace require resignal restrict resume return returns revoke right rlike rollback rollup row row_format rtree savepoint schedule schema schema_name schemas second_microsecond security sensitive separator serializable server session share show shutdown signal slave slow smallint snapshot soft soname spatial specific sql sql_big_result sql_buffer_result sql_cache sql_calc_found_rows sql_no_cache sql_small_result sqlexception sqlstate sqlwarning ssl start starting starts status std stddev stddev_pop stddev_samp storage straight_join subclass_origin sum suspend table_name table_statistics tables tablespace temporary terminated to trailing transaction trigger triggers truncate uncommitted undo uninstall unique unlock upgrade usage use use_frm user user_resources user_statistics using utc_date utc_time utc_timestamp value variables varying view views virtual warnings when while with work write xa xor year_month zerofill begin do then else loop repeat"),
            builtin: o("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text bigint int int1 int2 int3 int4 int8 integer float float4 float8 double char varbinary varchar varcharacter precision date datetime year unsigned signed numeric"),
            atoms: o("false true null unknown"),
            operatorChars: /^[*+\-%<>!=&|^]/,
            dateSQL: o("date time timestamp"),
            support: o("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber doubleQuote nCharCast charsetCast commentHash commentSpaceRequired"),
            hooks: {
              "@": r,
              "`": t,
              "\\": n
            }
          }), e.defineMIME("text/x-sqlite", {
            name: "sql",
            client: o("auth backup bail binary changes check clone databases dbinfo dump echo eqp exit explain fullschema headers help import imposter indexes iotrace limit lint load log mode nullvalue once open output print prompt quit read restore save scanstats schema separator session shell show stats system tables testcase timeout timer trace vfsinfo vfslist vfsname width"),
            keywords: o(i + "abort action add after all analyze attach autoincrement before begin cascade case cast check collate column commit conflict constraint cross current_date current_time current_timestamp database default deferrable deferred detach each else end escape except exclusive exists explain fail for foreign full glob if ignore immediate index indexed initially inner instead intersect isnull key left limit match natural no notnull null of offset outer plan pragma primary query raise recursive references regexp reindex release rename replace restrict right rollback row savepoint temp temporary then to transaction trigger unique using vacuum view virtual when with without"),
            builtin: o("bool boolean bit blob decimal double float long longblob longtext medium mediumblob mediumint mediumtext time timestamp tinyblob tinyint tinytext text clob bigint int int2 int8 integer float double char varchar date datetime year unsigned signed numeric real"),
            atoms: o("null current_date current_time current_timestamp"),
            operatorChars: /^[*+\-%<>!=&|/~]/,
            dateSQL: o("date time timestamp datetime"),
            support: o("decimallessFloat zerolessFloat"),
            identifierQuote: '"',
            hooks: {
              "@": r,
              ":": r,
              "?": r,
              $: r,
              '"': function _(e) {
                for (var t; null != (t = e.next());) {
                  if ('"' == t && !e.eat('"')) return "variable-2";
                }
                return e.backUp(e.current().length - 1), e.eatWhile(/\w/) ? "variable-2" : null;
              },
              "`": t
            }
          }), e.defineMIME("text/x-cassandra", {
            name: "sql",
            client: {},
            keywords: o("add all allow alter and any apply as asc authorize batch begin by clustering columnfamily compact consistency count create custom delete desc distinct drop each_quorum exists filtering from grant if in index insert into key keyspace keyspaces level limit local_one local_quorum modify nan norecursive nosuperuser not of on one order password permission permissions primary quorum rename revoke schema select set storage superuser table three to token truncate ttl two type unlogged update use user users using values where with writetime"),
            builtin: o("ascii bigint blob boolean counter decimal double float frozen inet int list map static text timestamp timeuuid tuple uuid varchar varint"),
            atoms: o("false true infinity NaN"),
            operatorChars: /^[<>=]/,
            dateSQL: {},
            support: o("commentSlashSlash decimallessFloat"),
            hooks: {}
          }), e.defineMIME("text/x-plsql", {
            name: "sql",
            client: o("appinfo arraysize autocommit autoprint autorecovery autotrace blockterminator break btitle cmdsep colsep compatibility compute concat copycommit copytypecheck define describe echo editfile embedded escape exec execute feedback flagger flush heading headsep instance linesize lno loboffset logsource long longchunksize markup native newpage numformat numwidth pagesize pause pno recsep recsepchar release repfooter repheader serveroutput shiftinout show showmode size spool sqlblanklines sqlcase sqlcode sqlcontinue sqlnumber sqlpluscompatibility sqlprefix sqlprompt sqlterminator suffix tab term termout time timing trimout trimspool ttitle underline verify version wrap"),
            keywords: o("abort accept access add all alter and any array arraylen as asc assert assign at attributes audit authorization avg base_table begin between binary_integer body boolean by case cast char char_base check close cluster clusters colauth column comment commit compress connect connected constant constraint crash create current currval cursor data_base database date dba deallocate debugoff debugon decimal declare default definition delay delete desc digits dispose distinct do drop else elseif elsif enable end entry escape exception exception_init exchange exclusive exists exit external fast fetch file for force form from function generic goto grant group having identified if immediate in increment index indexes indicator initial initrans insert interface intersect into is key level library like limited local lock log logging long loop master maxextents maxtrans member minextents minus mislabel mode modify multiset new next no noaudit nocompress nologging noparallel not nowait number_base object of off offline on online only open option or order out package parallel partition pctfree pctincrease pctused pls_integer positive positiven pragma primary prior private privileges procedure public raise range raw read rebuild record ref references refresh release rename replace resource restrict return returning returns reverse revoke rollback row rowid rowlabel rownum rows run savepoint schema segment select separate session set share snapshot some space split sql start statement storage subtype successful synonym tabauth table tables tablespace task terminate then to trigger truncate type union unique unlimited unrecoverable unusable update use using validate value values variable view views when whenever where while with work"),
            builtin: o("abs acos add_months ascii asin atan atan2 average bfile bfilename bigserial bit blob ceil character chartorowid chr clob concat convert cos cosh count dec decode deref dual dump dup_val_on_index empty error exp false float floor found glb greatest hextoraw initcap instr instrb int integer isopen last_day least length lengthb ln lower lpad ltrim lub make_ref max min mlslabel mod months_between natural naturaln nchar nclob new_time next_day nextval nls_charset_decl_len nls_charset_id nls_charset_name nls_initcap nls_lower nls_sort nls_upper nlssort no_data_found notfound null number numeric nvarchar2 nvl others power rawtohex real reftohex round rowcount rowidtochar rowtype rpad rtrim serial sign signtype sin sinh smallint soundex sqlcode sqlerrm sqrt stddev string substr substrb sum sysdate tan tanh to_char text to_date to_label to_multi_byte to_number to_single_byte translate true trunc uid unlogged upper user userenv varchar varchar2 variance varying vsize xml"),
            operatorChars: /^[*\/+\-%<>!=~]/,
            dateSQL: o("date time timestamp"),
            support: o("doubleQuote nCharCast zerolessFloat binaryNumber hexNumber")
          }), e.defineMIME("text/x-hive", {
            name: "sql",
            keywords: o("select alter $elem$ $key$ $value$ add after all analyze and archive as asc before between binary both bucket buckets by cascade case cast change cluster clustered clusterstatus collection column columns comment compute concatenate continue create cross cursor data database databases dbproperties deferred delete delimited desc describe directory disable distinct distribute drop else enable end escaped exclusive exists explain export extended external fetch fields fileformat first format formatted from full function functions grant group having hold_ddltime idxproperties if import in index indexes inpath inputdriver inputformat insert intersect into is items join keys lateral left like limit lines load local location lock locks mapjoin materialized minus msck no_drop nocompress not of offline on option or order out outer outputdriver outputformat overwrite partition partitioned partitions percent plus preserve procedure purge range rcfile read readonly reads rebuild recordreader recordwriter recover reduce regexp rename repair replace restrict revoke right rlike row schema schemas semi sequencefile serde serdeproperties set shared show show_database sort sorted ssl statistics stored streamtable table tables tablesample tblproperties temporary terminated textfile then tmp to touch transform trigger unarchive undo union uniquejoin unlock update use using utc utc_tmestamp view when where while with admin authorization char compact compactions conf cube current current_date current_timestamp day decimal defined dependency directories elem_type exchange file following for grouping hour ignore inner interval jar less logical macro minute month more none noscan over owner partialscan preceding pretty principals protection reload rewrite role roles rollup rows second server sets skewed transactions truncate unbounded unset uri user values window year"),
            builtin: o("bool boolean long timestamp tinyint smallint bigint int float double date datetime unsigned string array struct map uniontype key_type utctimestamp value_type varchar"),
            atoms: o("false true null unknown"),
            operatorChars: /^[*+\-%<>!=]/,
            dateSQL: o("date timestamp"),
            support: o("ODBCdotTable doubleQuote binaryNumber hexNumber")
          }), e.defineMIME("text/x-pgsql", {
            name: "sql",
            client: o("source"),
            keywords: o(i + "a abort abs absent absolute access according action ada add admin after aggregate alias all allocate also alter always analyse analyze and any are array array_agg array_max_cardinality as asc asensitive assert assertion assignment asymmetric at atomic attach attribute attributes authorization avg backward base64 before begin begin_frame begin_partition bernoulli between bigint binary bit bit_length blob blocked bom boolean both breadth by c cache call called cardinality cascade cascaded case cast catalog catalog_name ceil ceiling chain char char_length character character_length character_set_catalog character_set_name character_set_schema characteristics characters check checkpoint class class_origin clob close cluster coalesce cobol collate collation collation_catalog collation_name collation_schema collect column column_name columns command_function command_function_code comment comments commit committed concurrently condition condition_number configuration conflict connect connection connection_name constant constraint constraint_catalog constraint_name constraint_schema constraints constructor contains content continue control conversion convert copy corr corresponding cost count covar_pop covar_samp create cross csv cube cume_dist current current_catalog current_date current_default_transform_group current_path current_role current_row current_schema current_time current_timestamp current_transform_group_for_type current_user cursor cursor_name cycle data database datalink datatype date datetime_interval_code datetime_interval_precision day db deallocate debug dec decimal declare default defaults deferrable deferred defined definer degree delete delimiter delimiters dense_rank depends depth deref derived desc describe descriptor detach detail deterministic diagnostics dictionary disable discard disconnect dispatch distinct dlnewcopy dlpreviouscopy dlurlcomplete dlurlcompleteonly dlurlcompletewrite dlurlpath dlurlpathonly dlurlpathwrite dlurlscheme dlurlserver dlvalue do document domain double drop dump dynamic dynamic_function dynamic_function_code each element else elseif elsif empty enable encoding encrypted end end_frame end_partition endexec enforced enum equals errcode error escape event every except exception exclude excluding exclusive exec execute exists exit exp explain expression extension external extract false family fetch file filter final first first_value flag float floor following for force foreach foreign fortran forward found frame_row free freeze from fs full function functions fusion g general generated get global go goto grant granted greatest group grouping groups handler having header hex hierarchy hint hold hour id identity if ignore ilike immediate immediately immutable implementation implicit import in include including increment indent index indexes indicator info inherit inherits initially inline inner inout input insensitive insert instance instantiable instead int integer integrity intersect intersection interval into invoker is isnull isolation join k key key_member key_type label lag language large last last_value lateral lead leading leakproof least left length level library like like_regex limit link listen ln load local localtime localtimestamp location locator lock locked log logged loop lower m map mapping match matched materialized max max_cardinality maxvalue member merge message message_length message_octet_length message_text method min minute minvalue mod mode modifies module month more move multiset mumps name names namespace national natural nchar nclob nesting new next nfc nfd nfkc nfkd nil no none normalize normalized not nothing notice notify notnull nowait nth_value ntile null nullable nullif nulls number numeric object occurrences_regex octet_length octets of off offset oids old on only open operator option options or order ordering ordinality others out outer output over overlaps overlay overriding owned owner p pad parallel parameter parameter_mode parameter_name parameter_ordinal_position parameter_specific_catalog parameter_specific_name parameter_specific_schema parser partial partition pascal passing passthrough password path percent percent_rank percentile_cont percentile_disc perform period permission pg_context pg_datatype_name pg_exception_context pg_exception_detail pg_exception_hint placing plans pli policy portion position position_regex power precedes preceding precision prepare prepared preserve primary print_strict_params prior privileges procedural procedure procedures program public publication query quote raise range rank read reads real reassign recheck recovery recursive ref references referencing refresh regr_avgx regr_avgy regr_count regr_intercept regr_r2 regr_slope regr_sxx regr_sxy regr_syy reindex relative release rename repeatable replace replica requiring reset respect restart restore restrict result result_oid return returned_cardinality returned_length returned_octet_length returned_sqlstate returning returns reverse revoke right role rollback rollup routine routine_catalog routine_name routine_schema routines row row_count row_number rows rowtype rule savepoint scale schema schema_name schemas scope scope_catalog scope_name scope_schema scroll search second section security select selective self sensitive sequence sequences serializable server server_name session session_user set setof sets share show similar simple size skip slice smallint snapshot some source space specific specific_name specifictype sql sqlcode sqlerror sqlexception sqlstate sqlwarning sqrt stable stacked standalone start state statement static statistics stddev_pop stddev_samp stdin stdout storage strict strip structure style subclass_origin submultiset subscription substring substring_regex succeeds sum symmetric sysid system system_time system_user t table table_name tables tablesample tablespace temp template temporary text then ties time timestamp timezone_hour timezone_minute to token top_level_count trailing transaction transaction_active transactions_committed transactions_rolled_back transform transforms translate translate_regex translation treat trigger trigger_catalog trigger_name trigger_schema trim trim_array true truncate trusted type types uescape unbounded uncommitted under unencrypted union unique unknown unlink unlisten unlogged unnamed unnest until untyped update upper uri usage use_column use_variable user user_defined_type_catalog user_defined_type_code user_defined_type_name user_defined_type_schema using vacuum valid validate validator value value_of values var_pop var_samp varbinary varchar variable_conflict variadic varying verbose version versioning view views volatile warning when whenever where while whitespace width_bucket window with within without work wrapper write xml xmlagg xmlattributes xmlbinary xmlcast xmlcomment xmlconcat xmldeclaration xmldocument xmlelement xmlexists xmlforest xmliterate xmlnamespaces xmlparse xmlpi xmlquery xmlroot xmlschema xmlserialize xmltable xmltext xmlvalidate year yes zone"),
            builtin: o("bigint int8 bigserial serial8 bit varying varbit boolean bool box bytea character char varchar cidr circle date double precision float8 inet integer int int4 interval json jsonb line lseg macaddr macaddr8 money numeric decimal path pg_lsn point polygon real float4 smallint int2 smallserial serial2 serial serial4 text time without zone with timetz timestamp timestamptz tsquery tsvector txid_snapshot uuid xml"),
            atoms: o("false true null unknown"),
            operatorChars: /^[*\/+\-%<>!=&|^\/#@?~]/,
            backslashStringEscapes: !1,
            dateSQL: o("date time timestamp"),
            support: o("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber nCharCast charsetCast escapeConstant")
          }), e.defineMIME("text/x-gql", {
            name: "sql",
            keywords: o("ancestor and asc by contains desc descendant distinct from group has in is limit offset on order select superset where"),
            atoms: o("false true"),
            builtin: o("blob datetime first key __key__ string integer double boolean null"),
            operatorChars: /^[*+\-%<>!=]/
          }), e.defineMIME("text/x-gpsql", {
            name: "sql",
            client: o("source"),
            keywords: o("abort absolute access action active add admin after aggregate all also alter always analyse analyze and any array as asc assertion assignment asymmetric at authorization backward before begin between bigint binary bit boolean both by cache called cascade cascaded case cast chain char character characteristics check checkpoint class close cluster coalesce codegen collate column comment commit committed concurrency concurrently configuration connection constraint constraints contains content continue conversion copy cost cpu_rate_limit create createdb createexttable createrole createuser cross csv cube current current_catalog current_date current_role current_schema current_time current_timestamp current_user cursor cycle data database day deallocate dec decimal declare decode default defaults deferrable deferred definer delete delimiter delimiters deny desc dictionary disable discard distinct distributed do document domain double drop dxl each else enable encoding encrypted end enum errors escape every except exchange exclude excluding exclusive execute exists explain extension external extract false family fetch fields filespace fill filter first float following for force foreign format forward freeze from full function global grant granted greatest group group_id grouping handler hash having header hold host hour identity if ignore ilike immediate immutable implicit in including inclusive increment index indexes inherit inherits initially inline inner inout input insensitive insert instead int integer intersect interval into invoker is isnull isolation join key language large last leading least left level like limit list listen load local localtime localtimestamp location lock log login mapping master match maxvalue median merge minute minvalue missing mode modifies modify month move name names national natural nchar new newline next no nocreatedb nocreateexttable nocreaterole nocreateuser noinherit nologin none noovercommit nosuperuser not nothing notify notnull nowait null nullif nulls numeric object of off offset oids old on only operator option options or order ordered others out outer over overcommit overlaps overlay owned owner parser partial partition partitions passing password percent percentile_cont percentile_disc placing plans position preceding precision prepare prepared preserve primary prior privileges procedural procedure protocol queue quote randomly range read readable reads real reassign recheck recursive ref references reindex reject relative release rename repeatable replace replica reset resource restart restrict returning returns revoke right role rollback rollup rootpartition row rows rule savepoint scatter schema scroll search second security segment select sequence serializable session session_user set setof sets share show similar simple smallint some split sql stable standalone start statement statistics stdin stdout storage strict strip subpartition subpartitions substring superuser symmetric sysid system table tablespace temp template temporary text then threshold ties time timestamp to trailing transaction treat trigger trim true truncate trusted type unbounded uncommitted unencrypted union unique unknown unlisten until update user using vacuum valid validation validator value values varchar variadic varying verbose version view volatile web when where whitespace window with within without work writable write xml xmlattributes xmlconcat xmlelement xmlexists xmlforest xmlparse xmlpi xmlroot xmlserialize year yes zone"),
            builtin: o("bigint int8 bigserial serial8 bit varying varbit boolean bool box bytea character char varchar cidr circle date double precision float float8 inet integer int int4 interval json jsonb line lseg macaddr macaddr8 money numeric decimal path pg_lsn point polygon real float4 smallint int2 smallserial serial2 serial serial4 text time without zone with timetz timestamp timestamptz tsquery tsvector txid_snapshot uuid xml"),
            atoms: o("false true null unknown"),
            operatorChars: /^[*+\-%<>!=&|^\/#@?~]/,
            dateSQL: o("date time timestamp"),
            support: o("ODBCdotTable decimallessFloat zerolessFloat binaryNumber hexNumber nCharCast charsetCast")
          }), e.defineMIME("text/x-sparksql", {
            name: "sql",
            keywords: o("add after all alter analyze and anti archive array as asc at between bucket buckets by cache cascade case cast change clear cluster clustered codegen collection column columns comment commit compact compactions compute concatenate cost create cross cube current current_date current_timestamp database databases datata dbproperties defined delete delimited deny desc describe dfs directories distinct distribute drop else end escaped except exchange exists explain export extended external false fields fileformat first following for format formatted from full function functions global grant group grouping having if ignore import in index indexes inner inpath inputformat insert intersect interval into is items join keys last lateral lazy left like limit lines list load local location lock locks logical macro map minus msck natural no not null nulls of on optimize option options or order out outer outputformat over overwrite partition partitioned partitions percent preceding principals purge range recordreader recordwriter recover reduce refresh regexp rename repair replace reset restrict revoke right rlike role roles rollback rollup row rows schema schemas select semi separated serde serdeproperties set sets show skewed sort sorted start statistics stored stratify struct table tables tablesample tblproperties temp temporary terminated then to touch transaction transactions transform true truncate unarchive unbounded uncache union unlock unset use using values view when where window with"),
            builtin: o("tinyint smallint int bigint boolean float double string binary timestamp decimal array map struct uniontype delimited serde sequencefile textfile rcfile inputformat outputformat"),
            atoms: o("false true null"),
            operatorChars: /^[*\/+\-%<>!=~&|^]/,
            dateSQL: o("date time timestamp"),
            support: o("ODBCdotTable doubleQuote zerolessFloat")
          }), e.defineMIME("text/x-esper", {
            name: "sql",
            client: o("source"),
            keywords: o("alter and as asc between by count create delete desc distinct drop from group having in insert into is join like not on or order select set table union update values where limit after all and as at asc avedev avg between by case cast coalesce count create current_timestamp day days delete define desc distinct else end escape events every exists false first from full group having hour hours in inner insert instanceof into irstream is istream join last lastweekday left limit like max match_recognize matches median measures metadatasql min minute minutes msec millisecond milliseconds not null offset on or order outer output partition pattern prev prior regexp retain-union retain-intersection right rstream sec second seconds select set some snapshot sql stddev sum then true unidirectional until update variable weekday when where window"),
            builtin: {},
            atoms: o("false true null"),
            operatorChars: /^[*+\-%<>!=&|^\/#@?~]/,
            dateSQL: o("time"),
            support: o("decimallessFloat zerolessFloat binaryNumber hexNumber")
          });
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      1878: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          function t(e) {
            for (var t = {}, r = 0; r < e.length; r++) {
              t[e[r]] = !0;
            }
            return t;
          }
          var r = t(["_", "var", "let", "class", "enum", "extension", "import", "protocol", "struct", "func", "typealias", "associatedtype", "open", "public", "internal", "fileprivate", "private", "deinit", "init", "new", "override", "self", "subscript", "super", "convenience", "dynamic", "final", "indirect", "lazy", "required", "static", "unowned", "unowned(safe)", "unowned(unsafe)", "weak", "as", "is", "break", "case", "continue", "default", "else", "fallthrough", "for", "guard", "if", "in", "repeat", "switch", "where", "while", "defer", "return", "inout", "mutating", "nonmutating", "catch", "do", "rethrows", "throw", "throws", "try", "didSet", "get", "set", "willSet", "assignment", "associativity", "infix", "left", "none", "operator", "postfix", "precedence", "precedencegroup", "prefix", "right", "Any", "AnyObject", "Type", "dynamicType", "Self", "Protocol", "__COLUMN__", "__FILE__", "__FUNCTION__", "__LINE__"]),
            n = t(["var", "let", "class", "enum", "extension", "import", "protocol", "struct", "func", "typealias", "associatedtype", "for"]),
            i = t(["true", "false", "nil", "self", "super", "_"]),
            o = t(["Array", "Bool", "Character", "Dictionary", "Double", "Float", "Int", "Int8", "Int16", "Int32", "Int64", "Never", "Optional", "Set", "String", "UInt8", "UInt16", "UInt32", "UInt64", "Void"]),
            a = /^\-?0b[01][01_]*/,
            s = /^\-?0o[0-7][0-7_]*/,
            l = /^\-?0x[\dA-Fa-f][\dA-Fa-f_]*(?:(?:\.[\dA-Fa-f][\dA-Fa-f_]*)?[Pp]\-?\d[\d_]*)?/,
            c = /^\-?\d[\d_]*(?:\.\d[\d_]*)?(?:[Ee]\-?\d[\d_]*)?/,
            u = /^\$\d+|(`?)[_A-Za-z][_A-Za-z$0-9]*\1/,
            d = /^\.(?:\$\d+|(`?)[_A-Za-z][_A-Za-z$0-9]*\1)/,
            p = /^\#[A-Za-z]+/,
            f = /^@(?:\$\d+|(`?)[_A-Za-z][_A-Za-z$0-9]*\1)/;
          function m(e, t, m) {
            if (e.sol() && (t.indented = e.indentation()), e.eatSpace()) return null;
            var h,
              v = e.peek();
            if ("/" == v) {
              if (e.match("//")) return e.skipToEnd(), "comment";
              if (e.match("/*")) return t.tokenize.push(y), y(e, t);
            }
            if (e.match(p)) return "builtin";
            if (e.match(f)) return "attribute";
            if (e.match(a)) return "number";
            if (e.match(s)) return "number";
            if (e.match(l)) return "number";
            if (e.match(c)) return "number";
            if (e.match(d)) return "property";
            if ("+-/*%=|&<>~^?!".indexOf(v) > -1) return e.next(), "operator";
            if (":;,.(){}[]".indexOf(v) > -1) return e.next(), e.match(".."), "punctuation";
            if (h = e.match(/("""|"|')/)) {
              var b = g.bind(null, h[0]);
              return t.tokenize.push(b), b(e, t);
            }
            if (e.match(u)) {
              var x = e.current();
              return o.hasOwnProperty(x) ? "variable-2" : i.hasOwnProperty(x) ? "atom" : r.hasOwnProperty(x) ? (n.hasOwnProperty(x) && (t.prev = "define"), "keyword") : "define" == m ? "def" : "variable";
            }
            return e.next(), null;
          }
          function h() {
            var e = 0;
            return function (t, r, n) {
              var i = m(t, r, n);
              if ("punctuation" == i) if ("(" == t.current()) ++e;else if (")" == t.current()) {
                if (0 == e) return t.backUp(1), r.tokenize.pop(), r.tokenize[r.tokenize.length - 1](t, r);
                --e;
              }
              return i;
            };
          }
          function g(e, t, r) {
            for (var n, i = 1 == e.length, o = !1; n = t.peek();) {
              if (o) {
                if (t.next(), "(" == n) return r.tokenize.push(h()), "string";
                o = !1;
              } else {
                if (t.match(e)) return r.tokenize.pop(), "string";
                t.next(), o = "\\" == n;
              }
            }
            return i && r.tokenize.pop(), "string";
          }
          function y(e, t) {
            for (var r; e.match(/^[^/*]+/, !0), r = e.next();) {
              "/" === r && e.eat("*") ? t.tokenize.push(y) : "*" === r && e.eat("/") && t.tokenize.pop();
            }
            return "comment";
          }
          function v(e, t, r) {
            this.prev = e, this.align = t, this.indented = r;
          }
          function b(e, t) {
            var r = t.match(/^\s*($|\/[\/\*])/, !1) ? null : t.column() + 1;
            e.context = new v(e.context, r, e.indented);
          }
          function x(e) {
            e.context && (e.indented = e.context.indented, e.context = e.context.prev);
          }
          e.defineMode("swift", function (e) {
            return {
              startState: function startState() {
                return {
                  prev: null,
                  context: null,
                  indented: 0,
                  tokenize: []
                };
              },
              token: function token(e, t) {
                var r = t.prev;
                t.prev = null;
                var n = (t.tokenize[t.tokenize.length - 1] || m)(e, t, r);
                if (n && "comment" != n ? t.prev || (t.prev = n) : t.prev = r, "punctuation" == n) {
                  var i = /[\(\[\{]|([\]\)\}])/.exec(e.current());
                  i && (i[1] ? x : b)(t, e);
                }
                return n;
              },
              indent: function indent(t, r) {
                var n = t.context;
                if (!n) return 0;
                var i = /^[\]\}\)]/.test(r);
                return null != n.align ? n.align - (i ? 1 : 0) : n.indented + (i ? 0 : e.indentUnit);
              },
              electricInput: /^\s*[\)\}\]]$/,
              lineComment: "//",
              blockCommentStart: "/*",
              blockCommentEnd: "*/",
              fold: "brace",
              closeBrackets: "()[]{}''\"\"``"
            };
          }), e.defineMIME("text/x-swift", "swift");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      356: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMode("toml", function () {
            return {
              startState: function startState() {
                return {
                  inString: !1,
                  stringType: "",
                  lhs: !0,
                  inArray: 0
                };
              },
              token: function token(e, t) {
                if (t.inString || '"' != e.peek() && "'" != e.peek() || (t.stringType = e.peek(), e.next(), t.inString = !0), e.sol() && 0 === t.inArray && (t.lhs = !0), t.inString) {
                  for (; t.inString && !e.eol();) {
                    e.peek() === t.stringType ? (e.next(), t.inString = !1) : "\\" === e.peek() ? (e.next(), e.next()) : e.match(/^.[^\\\"\']*/);
                  }
                  return t.lhs ? "property string" : "string";
                }
                return t.inArray && "]" === e.peek() ? (e.next(), t.inArray--, "bracket") : t.lhs && "[" === e.peek() && e.skipTo("]") ? (e.next(), "]" === e.peek() && e.next(), "atom") : "#" === e.peek() ? (e.skipToEnd(), "comment") : e.eatSpace() ? null : t.lhs && e.eatWhile(function (e) {
                  return "=" != e && " " != e;
                }) ? "property" : t.lhs && "=" === e.peek() ? (e.next(), t.lhs = !1, null) : !t.lhs && e.match(/^\d\d\d\d[\d\-\:\.T]*Z/) ? "atom" : t.lhs || !e.match("true") && !e.match("false") ? t.lhs || "[" !== e.peek() ? !t.lhs && e.match(/^\-?\d+(?:\.\d+)?/) ? "number" : (e.eatSpace() || e.next(), null) : (t.inArray++, e.next(), "bracket") : "atom";
              }
            };
          }), e.defineMIME("text/x-toml", "toml");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      336: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          var t = {
              autoSelfClosers: {
                area: !0,
                base: !0,
                br: !0,
                col: !0,
                command: !0,
                embed: !0,
                frame: !0,
                hr: !0,
                img: !0,
                input: !0,
                keygen: !0,
                link: !0,
                meta: !0,
                param: !0,
                source: !0,
                track: !0,
                wbr: !0,
                menuitem: !0
              },
              implicitlyClosed: {
                dd: !0,
                li: !0,
                optgroup: !0,
                option: !0,
                p: !0,
                rp: !0,
                rt: !0,
                tbody: !0,
                td: !0,
                tfoot: !0,
                th: !0,
                tr: !0
              },
              contextGrabbers: {
                dd: {
                  dd: !0,
                  dt: !0
                },
                dt: {
                  dd: !0,
                  dt: !0
                },
                li: {
                  li: !0
                },
                option: {
                  option: !0,
                  optgroup: !0
                },
                optgroup: {
                  optgroup: !0
                },
                p: {
                  address: !0,
                  article: !0,
                  aside: !0,
                  blockquote: !0,
                  dir: !0,
                  div: !0,
                  dl: !0,
                  fieldset: !0,
                  footer: !0,
                  form: !0,
                  h1: !0,
                  h2: !0,
                  h3: !0,
                  h4: !0,
                  h5: !0,
                  h6: !0,
                  header: !0,
                  hgroup: !0,
                  hr: !0,
                  menu: !0,
                  nav: !0,
                  ol: !0,
                  p: !0,
                  pre: !0,
                  section: !0,
                  table: !0,
                  ul: !0
                },
                rp: {
                  rp: !0,
                  rt: !0
                },
                rt: {
                  rp: !0,
                  rt: !0
                },
                tbody: {
                  tbody: !0,
                  tfoot: !0
                },
                td: {
                  td: !0,
                  th: !0
                },
                tfoot: {
                  tbody: !0
                },
                th: {
                  td: !0,
                  th: !0
                },
                thead: {
                  tbody: !0,
                  tfoot: !0
                },
                tr: {
                  tr: !0
                }
              },
              doNotIndent: {
                pre: !0
              },
              allowUnquoted: !0,
              allowMissing: !0,
              caseFold: !0
            },
            r = {
              autoSelfClosers: {},
              implicitlyClosed: {},
              contextGrabbers: {},
              doNotIndent: {},
              allowUnquoted: !1,
              allowMissing: !1,
              allowMissingTagName: !1,
              caseFold: !1
            };
          e.defineMode("xml", function (n, i) {
            var o,
              a,
              s = n.indentUnit,
              l = {},
              c = i.htmlMode ? t : r;
            for (var u in c) {
              l[u] = c[u];
            }
            for (var u in i) {
              l[u] = i[u];
            }
            function d(e, t) {
              function r(r) {
                return t.tokenize = r, r(e, t);
              }
              var n = e.next();
              return "<" == n ? e.eat("!") ? e.eat("[") ? e.match("CDATA[") ? r(f("atom", "]]>")) : null : e.match("--") ? r(f("comment", "--\x3e")) : e.match("DOCTYPE", !0, !0) ? (e.eatWhile(/[\w\._\-]/), r(m(1))) : null : e.eat("?") ? (e.eatWhile(/[\w\._\-]/), t.tokenize = f("meta", "?>"), "meta") : (o = e.eat("/") ? "closeTag" : "openTag", t.tokenize = p, "tag bracket") : "&" == n ? (e.eat("#") ? e.eat("x") ? e.eatWhile(/[a-fA-F\d]/) && e.eat(";") : e.eatWhile(/[\d]/) && e.eat(";") : e.eatWhile(/[\w\.\-:]/) && e.eat(";")) ? "atom" : "error" : (e.eatWhile(/[^&<]/), null);
            }
            function p(e, t) {
              var r,
                n,
                i = e.next();
              if (">" == i || "/" == i && e.eat(">")) return t.tokenize = d, o = ">" == i ? "endTag" : "selfcloseTag", "tag bracket";
              if ("=" == i) return o = "equals", null;
              if ("<" == i) {
                t.tokenize = d, t.state = v, t.tagName = t.tagStart = null;
                var a = t.tokenize(e, t);
                return a ? a + " tag error" : "tag error";
              }
              return /[\'\"]/.test(i) ? (t.tokenize = (r = i, n = function n(e, t) {
                for (; !e.eol();) {
                  if (e.next() == r) {
                    t.tokenize = p;
                    break;
                  }
                }
                return "string";
              }, n.isInAttribute = !0, n), t.stringStartCol = e.column(), t.tokenize(e, t)) : (e.match(/^[^\s\u00a0=<>\"\']*[^\s\u00a0=<>\"\'\/]/), "word");
            }
            function f(e, t) {
              return function (r, n) {
                for (; !r.eol();) {
                  if (r.match(t)) {
                    n.tokenize = d;
                    break;
                  }
                  r.next();
                }
                return e;
              };
            }
            function m(e) {
              return function (t, r) {
                for (var n; null != (n = t.next());) {
                  if ("<" == n) return r.tokenize = m(e + 1), r.tokenize(t, r);
                  if (">" == n) {
                    if (1 == e) {
                      r.tokenize = d;
                      break;
                    }
                    return r.tokenize = m(e - 1), r.tokenize(t, r);
                  }
                }
                return "meta";
              };
            }
            function h(e, t, r) {
              this.prev = e.context, this.tagName = t, this.indent = e.indented, this.startOfLine = r, (l.doNotIndent.hasOwnProperty(t) || e.context && e.context.noIndent) && (this.noIndent = !0);
            }
            function g(e) {
              e.context && (e.context = e.context.prev);
            }
            function y(e, t) {
              for (var r;;) {
                if (!e.context) return;
                if (r = e.context.tagName, !l.contextGrabbers.hasOwnProperty(r) || !l.contextGrabbers[r].hasOwnProperty(t)) return;
                g(e);
              }
            }
            function v(e, t, r) {
              return "openTag" == e ? (r.tagStart = t.column(), b) : "closeTag" == e ? x : v;
            }
            function b(e, t, r) {
              return "word" == e ? (r.tagName = t.current(), a = "tag", _) : l.allowMissingTagName && "endTag" == e ? (a = "tag bracket", _(e, 0, r)) : (a = "error", b);
            }
            function x(e, t, r) {
              if ("word" == e) {
                var n = t.current();
                return r.context && r.context.tagName != n && l.implicitlyClosed.hasOwnProperty(r.context.tagName) && g(r), r.context && r.context.tagName == n || !1 === l.matchClosing ? (a = "tag", k) : (a = "tag error", w);
              }
              return l.allowMissingTagName && "endTag" == e ? (a = "tag bracket", k(e, 0, r)) : (a = "error", w);
            }
            function k(e, t, r) {
              return "endTag" != e ? (a = "error", k) : (g(r), v);
            }
            function w(e, t, r) {
              return a = "error", k(e, 0, r);
            }
            function _(e, t, r) {
              if ("word" == e) return a = "attribute", S;
              if ("endTag" == e || "selfcloseTag" == e) {
                var n = r.tagName,
                  i = r.tagStart;
                return r.tagName = r.tagStart = null, "selfcloseTag" == e || l.autoSelfClosers.hasOwnProperty(n) ? y(r, n) : (y(r, n), r.context = new h(r, n, i == r.indented)), v;
              }
              return a = "error", _;
            }
            function S(e, t, r) {
              return "equals" == e ? C : (l.allowMissing || (a = "error"), _(e, 0, r));
            }
            function C(e, t, r) {
              return "string" == e ? T : "word" == e && l.allowUnquoted ? (a = "string", _) : (a = "error", _(e, 0, r));
            }
            function T(e, t, r) {
              return "string" == e ? T : _(e, 0, r);
            }
            return d.isInText = !0, {
              startState: function startState(e) {
                var t = {
                  tokenize: d,
                  state: v,
                  indented: e || 0,
                  tagName: null,
                  tagStart: null,
                  context: null
                };
                return null != e && (t.baseIndent = e), t;
              },
              token: function token(e, t) {
                if (!t.tagName && e.sol() && (t.indented = e.indentation()), e.eatSpace()) return null;
                o = null;
                var r = t.tokenize(e, t);
                return (r || o) && "comment" != r && (a = null, t.state = t.state(o || r, e, t), a && (r = "error" == a ? r + " error" : a)), r;
              },
              indent: function indent(t, r, n) {
                var i = t.context;
                if (t.tokenize.isInAttribute) return t.tagStart == t.indented ? t.stringStartCol + 1 : t.indented + s;
                if (i && i.noIndent) return e.Pass;
                if (t.tokenize != p && t.tokenize != d) return n ? n.match(/^(\s*)/)[0].length : 0;
                if (t.tagName) return !1 !== l.multilineTagIndentPastTag ? t.tagStart + t.tagName.length + 2 : t.tagStart + s * (l.multilineTagIndentFactor || 1);
                if (l.alignCDATA && /<!\[CDATA\[/.test(r)) return 0;
                var o = r && /^<(\/)?([\w_:\.-]*)/.exec(r);
                if (o && o[1]) for (; i;) {
                  if (i.tagName == o[2]) {
                    i = i.prev;
                    break;
                  }
                  if (!l.implicitlyClosed.hasOwnProperty(i.tagName)) break;
                  i = i.prev;
                } else if (o) for (; i;) {
                  var a = l.contextGrabbers[i.tagName];
                  if (!a || !a.hasOwnProperty(o[2])) break;
                  i = i.prev;
                }
                for (; i && i.prev && !i.startOfLine;) {
                  i = i.prev;
                }
                return i ? i.indent + s : t.baseIndent || 0;
              },
              electricInput: /<\/[\s\w:]+>$/,
              blockCommentStart: "\x3c!--",
              blockCommentEnd: "--\x3e",
              configuration: l.htmlMode ? "html" : "xml",
              helperType: l.htmlMode ? "html" : "xml",
              skipAttribute: function skipAttribute(e) {
                e.state == C && (e.state = _);
              },
              xmlCurrentTag: function xmlCurrentTag(e) {
                return e.tagName ? {
                  name: e.tagName,
                  close: "closeTag" == e.type
                } : null;
              },
              xmlCurrentContext: function xmlCurrentContext(e) {
                for (var t = [], r = e.context; r; r = r.prev) {
                  r.tagName && t.push(r.tagName);
                }
                return t.reverse();
              }
            };
          }), e.defineMIME("text/xml", "xml"), e.defineMIME("application/xml", "xml"), e.mimeModes.hasOwnProperty("text/html") || e.defineMIME("text/html", {
            name: "xml",
            htmlMode: !0
          });
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      9393: function _(e, t, r) {
        var n, i, o, a;
        function s(e) {
          return s = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, s(e);
        }
        e = r.nmd(e), a = function a(e) {
          "use strict";

          e.defineMode("yaml", function () {
            var e = new RegExp("\\b((" + ["true", "false", "on", "off", "yes", "no"].join(")|(") + "))$", "i");
            return {
              token: function token(t, r) {
                var n = t.peek(),
                  i = r.escaped;
                if (r.escaped = !1, "#" == n && (0 == t.pos || /\s/.test(t.string.charAt(t.pos - 1)))) return t.skipToEnd(), "comment";
                if (t.match(/^('([^']|\\.)*'?|"([^"]|\\.)*"?)/)) return "string";
                if (r.literal && t.indentation() > r.keyCol) return t.skipToEnd(), "string";
                if (r.literal && (r.literal = !1), t.sol()) {
                  if (r.keyCol = 0, r.pair = !1, r.pairStart = !1, t.match(/---/)) return "def";
                  if (t.match(/\.\.\./)) return "def";
                  if (t.match(/\s*-\s+/)) return "meta";
                }
                if (t.match(/^(\{|\}|\[|\])/)) return "{" == n ? r.inlinePairs++ : "}" == n ? r.inlinePairs-- : "[" == n ? r.inlineList++ : r.inlineList--, "meta";
                if (r.inlineList > 0 && !i && "," == n) return t.next(), "meta";
                if (r.inlinePairs > 0 && !i && "," == n) return r.keyCol = 0, r.pair = !1, r.pairStart = !1, t.next(), "meta";
                if (r.pairStart) {
                  if (t.match(/^\s*(\||\>)\s*/)) return r.literal = !0, "meta";
                  if (t.match(/^\s*(\&|\*)[a-z0-9\._-]+\b/i)) return "variable-2";
                  if (0 == r.inlinePairs && t.match(/^\s*-?[0-9\.\,]+\s?$/)) return "number";
                  if (r.inlinePairs > 0 && t.match(/^\s*-?[0-9\.\,]+\s?(?=(,|}))/)) return "number";
                  if (t.match(e)) return "keyword";
                }
                return !r.pair && t.match(/^\s*(?:[,\[\]{}&*!|>'"%@`][^\s'":]|[^,\[\]{}#&*!|>'"%@`])[^#]*?(?=\s*:($|\s))/) ? (r.pair = !0, r.keyCol = t.indentation(), "atom") : r.pair && t.match(/^:\s*/) ? (r.pairStart = !0, "meta") : (r.pairStart = !1, r.escaped = "\\" == n, t.next(), null);
              },
              startState: function startState() {
                return {
                  pair: !1,
                  pairStart: !1,
                  keyCol: 0,
                  inlinePairs: 0,
                  inlineList: 0,
                  literal: !1,
                  escaped: !1
                };
              },
              lineComment: "#",
              fold: "indent"
            };
          }), e.defineMIME("text/x-yaml", "yaml"), e.defineMIME("text/yaml", "yaml");
        }, "object" == s(t) && "object" == s(e) ? a(r(9074)) : (i = [r(9074)], void 0 === (o = "function" == typeof (n = a) ? n.apply(t, i) : n) || (e.exports = o));
      },
      8922: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var r = "",
                n = void 0 !== t[5];
              return t[4] && (r += "@supports (".concat(t[4], ") {")), t[2] && (r += "@media ".concat(t[2], " {")), n && (r += "@layer".concat(t[5].length > 0 ? " ".concat(t[5]) : "", " {")), r += e(t), n && (r += "}"), t[2] && (r += "}"), t[4] && (r += "}"), r;
            }).join("");
          }, t.i = function (e, r, n, i, o) {
            "string" == typeof e && (e = [[null, e, void 0]]);
            var a = {};
            if (n) for (var s = 0; s < this.length; s++) {
              var l = this[s][0];
              null != l && (a[l] = !0);
            }
            for (var c = 0; c < e.length; c++) {
              var u = [].concat(e[c]);
              n && a[u[0]] || (void 0 !== o && (void 0 === u[5] || (u[1] = "@layer".concat(u[5].length > 0 ? " ".concat(u[5]) : "", " {").concat(u[1], "}")), u[5] = o), r && (u[2] ? (u[1] = "@media ".concat(u[2], " {").concat(u[1], "}"), u[2] = r) : u[2] = r), i && (u[4] ? (u[1] = "@supports (".concat(u[4], ") {").concat(u[1], "}"), u[4] = i) : u[4] = "".concat(i)), t.push(u));
            }
          }, t;
        };
      },
      7499: function _(e) {
        "use strict";

        e.exports = function (e) {
          return e[1];
        };
      },
      4201: function _(e, t, r) {
        "use strict";

        function n(e, t) {
          for (var r = 0; r < t.length; r++) {
            var n = t[r];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
          }
        }
        r.r(t), r.d(t, {
          AdditionalRuleKinds: function AdditionalRuleKinds() {
            return T;
          },
          CharacterStream: function CharacterStream() {
            return i;
          },
          LexRules: function LexRules() {
            return f;
          },
          ParseRules: function ParseRules() {
            return m;
          },
          RuleKinds: function RuleKinds() {
            return M;
          },
          butNot: function butNot() {
            return s;
          },
          isIgnored: function isIgnored() {
            return p;
          },
          list: function list() {
            return a;
          },
          onlineParser: function onlineParser() {
            return y;
          },
          opt: function opt() {
            return o;
          },
          p: function p() {
            return c;
          },
          t: function t() {
            return l;
          }
        });
        var i = function () {
          function e(t) {
            var r = this;
            !function (e, t) {
              if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
            }(this, e), this.getStartOfToken = function () {
              return r._start;
            }, this.getCurrentPosition = function () {
              return r._pos;
            }, this.eol = function () {
              return r._sourceText.length === r._pos;
            }, this.sol = function () {
              return 0 === r._pos;
            }, this.peek = function () {
              return r._sourceText.charAt(r._pos) ? r._sourceText.charAt(r._pos) : null;
            }, this.next = function () {
              var e = r._sourceText.charAt(r._pos);
              return r._pos++, e;
            }, this.eat = function (e) {
              if (r._testNextCharacter(e)) return r._start = r._pos, r._pos++, r._sourceText.charAt(r._pos - 1);
            }, this.eatWhile = function (e) {
              var t = r._testNextCharacter(e),
                n = !1;
              for (t && (n = t, r._start = r._pos); t;) {
                r._pos++, t = r._testNextCharacter(e), n = !0;
              }
              return n;
            }, this.eatSpace = function () {
              return r.eatWhile(/[\s\u00a0]/);
            }, this.skipToEnd = function () {
              r._pos = r._sourceText.length;
            }, this.skipTo = function (e) {
              r._pos = e;
            }, this.match = function (e) {
              var t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1],
                n = arguments.length > 2 && void 0 !== arguments[2] && arguments[2],
                i = null,
                o = null;
              if ("string" == typeof e) {
                var a = new RegExp(e, n ? "i" : "g");
                o = a.test(r._sourceText.substr(r._pos, e.length)), i = e;
              } else e instanceof RegExp && (i = (o = r._sourceText.slice(r._pos).match(e)) && o[0]);
              return !(null == o || !("string" == typeof e || o instanceof Array && r._sourceText.startsWith(o[0], r._pos))) && (t && (r._start = r._pos, i && i.length && (r._pos += i.length)), o);
            }, this.backUp = function (e) {
              r._pos -= e;
            }, this.column = function () {
              return r._pos;
            }, this.indentation = function () {
              var e = r._sourceText.match(/\s*/),
                t = 0;
              if (e && 0 !== e.length) for (var n = e[0], i = 0; n.length > i;) {
                9 === n.charCodeAt(i) ? t += 2 : t++, i++;
              }
              return t;
            }, this.current = function () {
              return r._sourceText.slice(r._start, r._pos);
            }, this._start = 0, this._pos = 0, this._sourceText = t;
          }
          var t, r, i;
          return t = e, (r = [{
            key: "_testNextCharacter",
            value: function value(e) {
              var t = this._sourceText.charAt(this._pos);
              return "string" == typeof e ? t === e : e instanceof RegExp ? e.test(t) : e(t);
            }
          }]) && n(t.prototype, r), i && n(t, i), e;
        }();
        function o(e) {
          return {
            ofRule: e
          };
        }
        function a(e, t) {
          return {
            ofRule: e,
            isList: !0,
            separator: t
          };
        }
        function s(e, t) {
          var r = e.match;
          return e.match = function (e) {
            var n = !1;
            return r && (n = r(e)), n && t.every(function (t) {
              return t.match && !t.match(e);
            });
          }, e;
        }
        function l(e, t) {
          return {
            style: t,
            match: function match(t) {
              return t.kind === e;
            }
          };
        }
        function c(e, t) {
          return {
            style: t || "punctuation",
            match: function match(t) {
              return "Punctuation" === t.kind && t.value === e;
            }
          };
        }
        var u,
          d = Object.freeze({
            NAME: "Name",
            DOCUMENT: "Document",
            OPERATION_DEFINITION: "OperationDefinition",
            VARIABLE_DEFINITION: "VariableDefinition",
            SELECTION_SET: "SelectionSet",
            FIELD: "Field",
            ARGUMENT: "Argument",
            FRAGMENT_SPREAD: "FragmentSpread",
            INLINE_FRAGMENT: "InlineFragment",
            FRAGMENT_DEFINITION: "FragmentDefinition",
            VARIABLE: "Variable",
            INT: "IntValue",
            FLOAT: "FloatValue",
            STRING: "StringValue",
            BOOLEAN: "BooleanValue",
            NULL: "NullValue",
            ENUM: "EnumValue",
            LIST: "ListValue",
            OBJECT: "ObjectValue",
            OBJECT_FIELD: "ObjectField",
            DIRECTIVE: "Directive",
            NAMED_TYPE: "NamedType",
            LIST_TYPE: "ListType",
            NON_NULL_TYPE: "NonNullType",
            SCHEMA_DEFINITION: "SchemaDefinition",
            OPERATION_TYPE_DEFINITION: "OperationTypeDefinition",
            SCALAR_TYPE_DEFINITION: "ScalarTypeDefinition",
            OBJECT_TYPE_DEFINITION: "ObjectTypeDefinition",
            FIELD_DEFINITION: "FieldDefinition",
            INPUT_VALUE_DEFINITION: "InputValueDefinition",
            INTERFACE_TYPE_DEFINITION: "InterfaceTypeDefinition",
            UNION_TYPE_DEFINITION: "UnionTypeDefinition",
            ENUM_TYPE_DEFINITION: "EnumTypeDefinition",
            ENUM_VALUE_DEFINITION: "EnumValueDefinition",
            INPUT_OBJECT_TYPE_DEFINITION: "InputObjectTypeDefinition",
            DIRECTIVE_DEFINITION: "DirectiveDefinition",
            SCHEMA_EXTENSION: "SchemaExtension",
            SCALAR_TYPE_EXTENSION: "ScalarTypeExtension",
            OBJECT_TYPE_EXTENSION: "ObjectTypeExtension",
            INTERFACE_TYPE_EXTENSION: "InterfaceTypeExtension",
            UNION_TYPE_EXTENSION: "UnionTypeExtension",
            ENUM_TYPE_EXTENSION: "EnumTypeExtension",
            INPUT_OBJECT_TYPE_EXTENSION: "InputObjectTypeExtension"
          }),
          p = function p(e) {
            return " " === e || "\t" === e || "," === e || "\n" === e || "\r" === e || "\uFEFF" === e || " " === e;
          },
          f = {
            Name: /^[_A-Za-z][_0-9A-Za-z]*/,
            Punctuation: /^(?:!|\$|\(|\)|\.\.\.|:|=|&|@|\[|]|\{|\||\})/,
            Number: /^-?(?:0|(?:[1-9][0-9]*))(?:\.[0-9]*)?(?:[eE][+-]?[0-9]+)?/,
            String: /^(?:"""(?:\\"""|[^"]|"[^"]|""[^"])*(?:""")?|"(?:[^"\\]|\\(?:"|\/|\\|b|f|n|r|t|u[0-9a-fA-F]{4}))*"?)/,
            Comment: /^#.*/
          },
          m = {
            Document: [a("Definition")],
            Definition: function Definition(e) {
              switch (e.value) {
                case "{":
                  return "ShortQuery";
                case "query":
                  return "Query";
                case "mutation":
                  return "Mutation";
                case "subscription":
                  return "Subscription";
                case "fragment":
                  return d.FRAGMENT_DEFINITION;
                case "schema":
                  return "SchemaDef";
                case "scalar":
                  return "ScalarDef";
                case "type":
                  return "ObjectTypeDef";
                case "interface":
                  return "InterfaceDef";
                case "union":
                  return "UnionDef";
                case "enum":
                  return "EnumDef";
                case "input":
                  return "InputDef";
                case "extend":
                  return "ExtendDef";
                case "directive":
                  return "DirectiveDef";
              }
            },
            ShortQuery: ["SelectionSet"],
            Query: [h("query"), o(g("def")), o("VariableDefinitions"), a("Directive"), "SelectionSet"],
            Mutation: [h("mutation"), o(g("def")), o("VariableDefinitions"), a("Directive"), "SelectionSet"],
            Subscription: [h("subscription"), o(g("def")), o("VariableDefinitions"), a("Directive"), "SelectionSet"],
            VariableDefinitions: [c("("), a("VariableDefinition"), c(")")],
            VariableDefinition: ["Variable", c(":"), "Type", o("DefaultValue")],
            Variable: [c("$", "variable"), g("variable")],
            DefaultValue: [c("="), "Value"],
            SelectionSet: [c("{"), a("Selection"), c("}")],
            Selection: function Selection(e, t) {
              return "..." === e.value ? t.match(/[\s\u00a0,]*(on\b|@|{)/, !1) ? "InlineFragment" : "FragmentSpread" : t.match(/[\s\u00a0,]*:/, !1) ? "AliasedField" : "Field";
            },
            AliasedField: [g("property"), c(":"), g("qualifier"), o("Arguments"), a("Directive"), o("SelectionSet")],
            Field: [g("property"), o("Arguments"), a("Directive"), o("SelectionSet")],
            Arguments: [c("("), a("Argument"), c(")")],
            Argument: [g("attribute"), c(":"), "Value"],
            FragmentSpread: [c("..."), g("def"), a("Directive")],
            InlineFragment: [c("..."), o("TypeCondition"), a("Directive"), "SelectionSet"],
            FragmentDefinition: [h("fragment"), o(s(g("def"), [h("on")])), "TypeCondition", a("Directive"), "SelectionSet"],
            TypeCondition: [h("on"), "NamedType"],
            Value: function Value(e) {
              switch (e.kind) {
                case "Number":
                  return "NumberValue";
                case "String":
                  return "StringValue";
                case "Punctuation":
                  switch (e.value) {
                    case "[":
                      return "ListValue";
                    case "{":
                      return "ObjectValue";
                    case "$":
                      return "Variable";
                    case "&":
                      return "NamedType";
                  }
                  return null;
                case "Name":
                  switch (e.value) {
                    case "true":
                    case "false":
                      return "BooleanValue";
                  }
                  return "null" === e.value ? "NullValue" : "EnumValue";
              }
            },
            NumberValue: [l("Number", "number")],
            StringValue: [{
              style: "string",
              match: function match(e) {
                return "String" === e.kind;
              },
              update: function update(e, t) {
                t.value.startsWith('"""') && (e.inBlockstring = !t.value.slice(3).endsWith('"""'));
              }
            }],
            BooleanValue: [l("Name", "builtin")],
            NullValue: [l("Name", "keyword")],
            EnumValue: [g("string-2")],
            ListValue: [c("["), a("Value"), c("]")],
            ObjectValue: [c("{"), a("ObjectField"), c("}")],
            ObjectField: [g("attribute"), c(":"), "Value"],
            Type: function Type(e) {
              return "[" === e.value ? "ListType" : "NonNullType";
            },
            ListType: [c("["), "Type", c("]"), o(c("!"))],
            NonNullType: ["NamedType", o(c("!"))],
            NamedType: [(u = "atom", {
              style: u,
              match: function match(e) {
                return "Name" === e.kind;
              },
              update: function update(e, t) {
                e.prevState && e.prevState.prevState && (e.name = t.value, e.prevState.prevState.type = t.value);
              }
            })],
            Directive: [c("@", "meta"), g("meta"), o("Arguments")],
            DirectiveDef: [h("directive"), c("@", "meta"), g("meta"), o("ArgumentsDef"), h("on"), a("DirectiveLocation", c("|"))],
            InterfaceDef: [h("interface"), g("atom"), o("Implements"), a("Directive"), c("{"), a("FieldDef"), c("}")],
            Implements: [h("implements"), a("NamedType", c("&"))],
            DirectiveLocation: [g("string-2")],
            SchemaDef: [h("schema"), a("Directive"), c("{"), a("OperationTypeDef"), c("}")],
            OperationTypeDef: [g("keyword"), c(":"), g("atom")],
            ScalarDef: [h("scalar"), g("atom"), a("Directive")],
            ObjectTypeDef: [h("type"), g("atom"), o("Implements"), a("Directive"), c("{"), a("FieldDef"), c("}")],
            FieldDef: [g("property"), o("ArgumentsDef"), c(":"), "Type", a("Directive")],
            ArgumentsDef: [c("("), a("InputValueDef"), c(")")],
            InputValueDef: [g("attribute"), c(":"), "Type", o("DefaultValue"), a("Directive")],
            UnionDef: [h("union"), g("atom"), a("Directive"), c("="), a("UnionMember", c("|"))],
            UnionMember: ["NamedType"],
            EnumDef: [h("enum"), g("atom"), a("Directive"), c("{"), a("EnumValueDef"), c("}")],
            EnumValueDef: [g("string-2"), a("Directive")],
            InputDef: [h("input"), g("atom"), a("Directive"), c("{"), a("InputValueDef"), c("}")],
            ExtendDef: [h("extend"), "ObjectTypeDef"]
          };
        function h(e) {
          return {
            style: "keyword",
            match: function match(t) {
              return "Name" === t.kind && t.value === e;
            }
          };
        }
        function g(e) {
          return {
            style: e,
            match: function match(e) {
              return "Name" === e.kind;
            },
            update: function update(e, t) {
              e.name = t.value;
            }
          };
        }
        function y() {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
            eatWhitespace: function eatWhitespace(e) {
              return e.eatWhile(p);
            },
            lexRules: f,
            parseRules: m,
            editorConfig: {}
          };
          return {
            startState: function startState() {
              var t = {
                level: 0,
                step: 0,
                name: null,
                kind: null,
                type: null,
                rule: null,
                needsSeperator: !1,
                prevState: null
              };
              return k(e.parseRules, t, d.DOCUMENT), t;
            },
            token: function token(t, r) {
              return v(t, r, e);
            }
          };
        }
        function v(e, t, r) {
          if (t.inBlockstring) return e.match(/.*"""/) ? (t.inBlockstring = !1, "string") : (e.skipToEnd(), "string");
          var n = r.lexRules,
            i = r.parseRules,
            o = r.eatWhitespace,
            a = r.editorConfig;
          if (t.rule && 0 === t.rule.length ? w(t) : t.needsAdvance && (t.needsAdvance = !1, _(t, !0)), e.sol()) {
            var s = a && a.tabSize || 2;
            t.indentLevel = Math.floor(e.indentation() / s);
          }
          if (o(e)) return "ws";
          var l = function (e, t) {
            for (var r = Object.keys(e), n = 0; n < r.length; n++) {
              var i = t.match(e[r[n]]);
              if (i && i instanceof Array) return {
                kind: r[n],
                value: i[0]
              };
            }
          }(n, e);
          if (!l) return e.match(/\S+/) || e.match(/\s/), k(x, t, "Invalid"), "invalidchar";
          if ("Comment" === l.kind) return k(x, t, "Comment"), "comment";
          var c = b({}, t);
          if ("Punctuation" === l.kind) if (/^[{([]/.test(l.value)) void 0 !== t.indentLevel && (t.levels = (t.levels || []).concat(t.indentLevel + 1));else if (/^[})\]]/.test(l.value)) {
            var u = t.levels = (t.levels || []).slice(0, -1);
            t.indentLevel && u.length > 0 && u[u.length - 1] < t.indentLevel && (t.indentLevel = u[u.length - 1]);
          }
          for (; t.rule;) {
            var d = "function" == typeof t.rule ? 0 === t.step ? t.rule(l, e) : null : t.rule[t.step];
            if (t.needsSeperator && (d = d && (null == d ? void 0 : d.separator)), d) {
              if (d.ofRule && (d = d.ofRule), "string" == typeof d) {
                k(i, t, d);
                continue;
              }
              if (d.match && d.match(l)) return d.update && d.update(t, l), "Punctuation" === l.kind ? _(t, !0) : t.needsAdvance = !0, d.style;
            }
            C(t);
          }
          return b(t, c), k(x, t, "Invalid"), "invalidchar";
        }
        function b(e, t) {
          for (var r = Object.keys(t), n = 0; n < r.length; n++) {
            e[r[n]] = t[r[n]];
          }
          return e;
        }
        var x = {
          Invalid: [],
          Comment: []
        };
        function k(e, t, r) {
          if (!e[r]) throw new TypeError("Unknown rule: " + r);
          t.prevState = Object.assign({}, t), t.kind = r, t.name = null, t.type = null, t.rule = e[r], t.step = 0, t.needsSeperator = !1;
        }
        function w(e) {
          e.prevState && (e.kind = e.prevState.kind, e.name = e.prevState.name, e.type = e.prevState.type, e.rule = e.prevState.rule, e.step = e.prevState.step, e.needsSeperator = e.prevState.needsSeperator, e.prevState = e.prevState.prevState);
        }
        function _(e, t) {
          if (S(e) && e.rule) {
            var r = e.rule[e.step];
            if (r.separator) {
              var n = r.separator;
              if (e.needsSeperator = !e.needsSeperator, !e.needsSeperator && n.ofRule) return;
            }
            if (t) return;
          }
          for (e.needsSeperator = !1, e.step++; e.rule && !(Array.isArray(e.rule) && e.step < e.rule.length);) {
            w(e), e.rule && (S(e) ? e.rule && e.rule[e.step].separator && (e.needsSeperator = !e.needsSeperator) : (e.needsSeperator = !1, e.step++));
          }
        }
        function S(e) {
          var t = Array.isArray(e.rule) && "string" != typeof e.rule[e.step] && e.rule[e.step];
          return t && t.isList;
        }
        function C(e) {
          for (; e.rule && (!Array.isArray(e.rule) || !e.rule[e.step].ofRule);) {
            w(e);
          }
          e.rule && _(e, !1);
        }
        var T = {
            ALIASED_FIELD: "AliasedField",
            ARGUMENTS: "Arguments",
            SHORT_QUERY: "ShortQuery",
            QUERY: "Query",
            MUTATION: "Mutation",
            SUBSCRIPTION: "Subscription",
            TYPE_CONDITION: "TypeCondition",
            INVALID: "Invalid",
            COMMENT: "Comment",
            SCHEMA_DEF: "SchemaDef",
            SCALAR_DEF: "ScalarDef",
            OBJECT_TYPE_DEF: "ObjectTypeDef",
            OBJECT_VALUE: "ObjectValue",
            LIST_VALUE: "ListValue",
            INTERFACE_DEF: "InterfaceDef",
            UNION_DEF: "UnionDef",
            ENUM_DEF: "EnumDef",
            ENUM_VALUE: "EnumValue",
            FIELD_DEF: "FieldDef",
            INPUT_DEF: "InputDef",
            INPUT_VALUE_DEF: "InputValueDef",
            ARGUMENTS_DEF: "ArgumentsDef",
            EXTEND_DEF: "ExtendDef",
            DIRECTIVE_DEF: "DirectiveDef",
            IMPLEMENTS: "Implements",
            VARIABLE_DEFINITIONS: "VariableDefinitions",
            TYPE: "Type"
          },
          M = Object.assign(Object.assign({}, d), T);
      },
      9428: function _(e, t, r) {
        "use strict";

        var n = r(2134);
        function i() {}
        function o() {}
        o.resetWarningCache = i, e.exports = function () {
          function e(e, t, r, i, o, a) {
            if (a !== n) {
              var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw s.name = "Invariant Violation", s;
            }
          }
          function t() {
            return e;
          }
          e.isRequired = e;
          var r = {
            array: e,
            bigint: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            elementType: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t,
            checkPropTypes: o,
            resetWarningCache: i
          };
          return r.PropTypes = r, r;
        };
      },
      6526: function _(e, t, r) {
        e.exports = r(9428)();
      },
      2134: function _(e) {
        "use strict";

        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      },
      1022: function _(e, t, r) {
        "use strict";

        function n() {
          return n = Object.assign || function (e) {
            for (var t = 1; t < arguments.length; t++) {
              var r = arguments[t];
              for (var n in r) {
                Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
              }
            }
            return e;
          }, n.apply(this, arguments);
        }
        function i(e) {
          return i = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
            return _typeof(e);
          } : function (e) {
            return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
          }, i(e);
        }
        var _o2,
          a = (_o2 = function o(e, t) {
            return _o2 = Object.setPrototypeOf || {
              __proto__: []
            } instanceof Array && function (e, t) {
              e.__proto__ = t;
            } || function (e, t) {
              for (var r in t) {
                t.hasOwnProperty(r) && (e[r] = t[r]);
              }
            }, _o2(e, t);
          }, function (e, t) {
            function r() {
              this.constructor = e;
            }
            _o2(e, t), e.prototype = null === t ? Object.create(t) : (r.prototype = t.prototype, new r());
          });
        t.fk = void 0;
        var s,
          l = r(6992),
          c = "undefined" == typeof navigator || !0 === r.g.PREVENT_CODEMIRROR_RENDER;
        c || (s = r(9074));
        var u = function () {
            function e() {}
            return e.equals = function (e, t) {
              var r = this,
                n = Object.keys,
                o = i(e),
                a = i(t);
              return e && t && "object" === o && o === a ? n(e).length === n(t).length && n(e).every(function (n) {
                return r.equals(e[n], t[n]);
              }) : e === t;
            }, e;
          }(),
          d = function () {
            function e(e, t) {
              this.editor = e, this.props = t;
            }
            return e.prototype.delegateCursor = function (e, t, r) {
              var n = this.editor.getDoc();
              r && this.editor.focus(), t ? n.setCursor(e) : n.setCursor(e, null, {
                scroll: !1
              });
            }, e.prototype.delegateScroll = function (e) {
              this.editor.scrollTo(e.x, e.y);
            }, e.prototype.delegateSelection = function (e, t) {
              this.editor.getDoc().setSelections(e), t && this.editor.focus();
            }, e.prototype.apply = function (e) {
              e && e.selection && e.selection.ranges && this.delegateSelection(e.selection.ranges, e.selection.focus || !1), e && e.cursor && this.delegateCursor(e.cursor, e.autoScroll || !1, this.editor.getOption("autofocus") || !1), e && e.scroll && this.delegateScroll(e.scroll);
            }, e.prototype.applyNext = function (e, t, r) {
              e && e.selection && e.selection.ranges && t && t.selection && t.selection.ranges && !u.equals(e.selection.ranges, t.selection.ranges) && this.delegateSelection(t.selection.ranges, t.selection.focus || !1), e && e.cursor && t && t.cursor && !u.equals(e.cursor, t.cursor) && this.delegateCursor(r.cursor || t.cursor, t.autoScroll || !1, t.autoCursor || !1), e && e.scroll && t && t.scroll && !u.equals(e.scroll, t.scroll) && this.delegateScroll(t.scroll);
            }, e.prototype.applyUserDefined = function (e, t) {
              t && t.cursor && this.delegateCursor(t.cursor, e.autoScroll || !1, this.editor.getOption("autofocus") || !1);
            }, e.prototype.wire = function (e) {
              var t = this;
              Object.keys(e || {}).filter(function (e) {
                return /^on/.test(e);
              }).forEach(function (e) {
                switch (e) {
                  case "onBlur":
                    t.editor.on("blur", function (e, r) {
                      t.props.onBlur(t.editor, r);
                    });
                    break;
                  case "onContextMenu":
                    t.editor.on("contextmenu", function (e, r) {
                      t.props.onContextMenu(t.editor, r);
                    });
                    break;
                  case "onCopy":
                    t.editor.on("copy", function (e, r) {
                      t.props.onCopy(t.editor, r);
                    });
                    break;
                  case "onCursor":
                    t.editor.on("cursorActivity", function (e) {
                      t.props.onCursor(t.editor, t.editor.getDoc().getCursor());
                    });
                    break;
                  case "onCursorActivity":
                    t.editor.on("cursorActivity", function (e) {
                      t.props.onCursorActivity(t.editor);
                    });
                    break;
                  case "onCut":
                    t.editor.on("cut", function (e, r) {
                      t.props.onCut(t.editor, r);
                    });
                    break;
                  case "onDblClick":
                    t.editor.on("dblclick", function (e, r) {
                      t.props.onDblClick(t.editor, r);
                    });
                    break;
                  case "onDragEnter":
                    t.editor.on("dragenter", function (e, r) {
                      t.props.onDragEnter(t.editor, r);
                    });
                    break;
                  case "onDragLeave":
                    t.editor.on("dragleave", function (e, r) {
                      t.props.onDragLeave(t.editor, r);
                    });
                    break;
                  case "onDragOver":
                    t.editor.on("dragover", function (e, r) {
                      t.props.onDragOver(t.editor, r);
                    });
                    break;
                  case "onDragStart":
                    t.editor.on("dragstart", function (e, r) {
                      t.props.onDragStart(t.editor, r);
                    });
                    break;
                  case "onDrop":
                    t.editor.on("drop", function (e, r) {
                      t.props.onDrop(t.editor, r);
                    });
                    break;
                  case "onFocus":
                    t.editor.on("focus", function (e, r) {
                      t.props.onFocus(t.editor, r);
                    });
                    break;
                  case "onGutterClick":
                    t.editor.on("gutterClick", function (e, r, n, i) {
                      t.props.onGutterClick(t.editor, r, n, i);
                    });
                    break;
                  case "onInputRead":
                    t.editor.on("inputRead", function (e, r) {
                      t.props.onInputRead(t.editor, r);
                    });
                    break;
                  case "onKeyDown":
                    t.editor.on("keydown", function (e, r) {
                      t.props.onKeyDown(t.editor, r);
                    });
                    break;
                  case "onKeyHandled":
                    t.editor.on("keyHandled", function (e, r, n) {
                      t.props.onKeyHandled(t.editor, r, n);
                    });
                    break;
                  case "onKeyPress":
                    t.editor.on("keypress", function (e, r) {
                      t.props.onKeyPress(t.editor, r);
                    });
                    break;
                  case "onKeyUp":
                    t.editor.on("keyup", function (e, r) {
                      t.props.onKeyUp(t.editor, r);
                    });
                    break;
                  case "onMouseDown":
                    t.editor.on("mousedown", function (e, r) {
                      t.props.onMouseDown(t.editor, r);
                    });
                    break;
                  case "onPaste":
                    t.editor.on("paste", function (e, r) {
                      t.props.onPaste(t.editor, r);
                    });
                    break;
                  case "onRenderLine":
                    t.editor.on("renderLine", function (e, r, n) {
                      t.props.onRenderLine(t.editor, r, n);
                    });
                    break;
                  case "onScroll":
                    t.editor.on("scroll", function (e) {
                      t.props.onScroll(t.editor, t.editor.getScrollInfo());
                    });
                    break;
                  case "onSelection":
                    t.editor.on("beforeSelectionChange", function (e, r) {
                      t.props.onSelection(t.editor, r);
                    });
                    break;
                  case "onTouchStart":
                    t.editor.on("touchstart", function (e, r) {
                      t.props.onTouchStart(t.editor, r);
                    });
                    break;
                  case "onUpdate":
                    t.editor.on("update", function (e) {
                      t.props.onUpdate(t.editor);
                    });
                    break;
                  case "onViewportChange":
                    t.editor.on("viewportChange", function (e, r, n) {
                      t.props.onViewportChange(t.editor, r, n);
                    });
                }
              });
            }, e;
          }(),
          p = function (e) {
            function t(t) {
              var r = e.call(this, t) || this;
              return c || (r.applied = !1, r.appliedNext = !1, r.appliedUserDefined = !1, r.deferred = null, r.emulating = !1, r.hydrated = !1, r.initCb = function () {
                r.props.editorDidConfigure && r.props.editorDidConfigure(r.editor);
              }, r.mounted = !1), r;
            }
            return a(t, e), t.prototype.hydrate = function (e) {
              var t = this,
                r = e && e.options ? e.options : {},
                i = n({}, s.defaults, this.editor.options, r);
              Object.keys(i).some(function (e) {
                return t.editor.getOption(e) !== i[e];
              }) && Object.keys(i).forEach(function (e) {
                r.hasOwnProperty(e) && t.editor.getOption(e) !== i[e] && (t.editor.setOption(e, i[e]), t.mirror.setOption(e, i[e]));
              }), this.hydrated || (this.deferred ? this.resolveChange(e.value) : this.initChange(e.value || "")), this.hydrated = !0;
            }, t.prototype.initChange = function (e) {
              this.emulating = !0;
              var t = this.editor.getDoc(),
                r = t.lastLine(),
                n = t.getLine(t.lastLine()).length;
              t.replaceRange(e || "", {
                line: 0,
                ch: 0
              }, {
                line: r,
                ch: n
              }), this.mirror.setValue(e), t.clearHistory(), this.mirror.clearHistory(), this.emulating = !1;
            }, t.prototype.resolveChange = function (e) {
              this.emulating = !0;
              var t = this.editor.getDoc();
              if ("undo" === this.deferred.origin ? t.undo() : "redo" === this.deferred.origin ? t.redo() : t.replaceRange(this.deferred.text, this.deferred.from, this.deferred.to, this.deferred.origin), e && e !== t.getValue()) {
                var r = t.getCursor();
                t.setValue(e), t.setCursor(r);
              }
              this.emulating = !1, this.deferred = null;
            }, t.prototype.mirrorChange = function (e) {
              var t = this.editor.getDoc();
              return "undo" === e.origin ? (t.setHistory(this.mirror.getHistory()), this.mirror.undo()) : "redo" === e.origin ? (t.setHistory(this.mirror.getHistory()), this.mirror.redo()) : this.mirror.replaceRange(e.text, e.from, e.to, e.origin), this.mirror.getValue();
            }, t.prototype.componentDidMount = function () {
              var e = this;
              c || (this.props.defineMode && this.props.defineMode.name && this.props.defineMode.fn && s.defineMode(this.props.defineMode.name, this.props.defineMode.fn), this.editor = s(this.ref, this.props.options), this.shared = new d(this.editor, this.props), this.mirror = s(function () {}, this.props.options), this.editor.on("electricInput", function () {
                e.mirror.setHistory(e.editor.getDoc().getHistory());
              }), this.editor.on("cursorActivity", function () {
                e.mirror.setCursor(e.editor.getDoc().getCursor());
              }), this.editor.on("beforeChange", function (t, r) {
                if (!e.emulating) {
                  r.cancel(), e.deferred = r;
                  var n = e.mirrorChange(e.deferred);
                  e.props.onBeforeChange && e.props.onBeforeChange(e.editor, e.deferred, n);
                }
              }), this.editor.on("change", function (t, r) {
                e.mounted && e.props.onChange && e.props.onChange(e.editor, r, e.editor.getValue());
              }), this.hydrate(this.props), this.shared.apply(this.props), this.applied = !0, this.mounted = !0, this.shared.wire(this.props), this.editor.getOption("autofocus") && this.editor.focus(), this.props.editorDidMount && this.props.editorDidMount(this.editor, this.editor.getValue(), this.initCb));
            }, t.prototype.componentDidUpdate = function (e) {
              if (!c) {
                var t = {
                  cursor: null
                };
                this.props.value !== e.value && (this.hydrated = !1), this.props.autoCursor || void 0 === this.props.autoCursor || (t.cursor = this.editor.getDoc().getCursor()), this.hydrate(this.props), this.appliedNext || (this.shared.applyNext(e, this.props, t), this.appliedNext = !0), this.shared.applyUserDefined(e, t), this.appliedUserDefined = !0;
              }
            }, t.prototype.componentWillUnmount = function () {
              c || this.props.editorWillUnmount && this.props.editorWillUnmount(s);
            }, t.prototype.shouldComponentUpdate = function (e, t) {
              return !c;
            }, t.prototype.render = function () {
              var e = this;
              if (c) return null;
              var t = this.props.className ? "react-codemirror2 " + this.props.className : "react-codemirror2";
              return l.createElement("div", {
                className: t,
                ref: function ref(t) {
                  return e.ref = t;
                }
              });
            }, t;
          }(l.Component);
        t.fk = p, function (e) {
          function t(t) {
            var r = e.call(this, t) || this;
            return c || (r.applied = !1, r.appliedUserDefined = !1, r.continueChange = !1, r.detached = !1, r.hydrated = !1, r.initCb = function () {
              r.props.editorDidConfigure && r.props.editorDidConfigure(r.editor);
            }, r.mounted = !1, r.onBeforeChangeCb = function () {
              r.continueChange = !0;
            }), r;
          }
          a(t, e), t.prototype.hydrate = function (e) {
            var t = this,
              r = e && e.options ? e.options : {},
              i = n({}, s.defaults, this.editor.options, r);
            if (Object.keys(i).some(function (e) {
              return t.editor.getOption(e) !== i[e];
            }) && Object.keys(i).forEach(function (e) {
              r.hasOwnProperty(e) && t.editor.getOption(e) !== i[e] && t.editor.setOption(e, i[e]);
            }), !this.hydrated) {
              var o = this.editor.getDoc(),
                a = o.lastLine(),
                l = o.getLine(o.lastLine()).length;
              o.replaceRange(e.value || "", {
                line: 0,
                ch: 0
              }, {
                line: a,
                ch: l
              });
            }
            this.hydrated = !0;
          }, t.prototype.componentDidMount = function () {
            var e = this;
            c || (this.detached = !0 === this.props.detach, this.props.defineMode && this.props.defineMode.name && this.props.defineMode.fn && s.defineMode(this.props.defineMode.name, this.props.defineMode.fn), this.editor = s(this.ref, this.props.options), this.shared = new d(this.editor, this.props), this.editor.on("beforeChange", function (t, r) {
              e.props.onBeforeChange && e.props.onBeforeChange(e.editor, r, e.editor.getValue(), e.onBeforeChangeCb);
            }), this.editor.on("change", function (t, r) {
              e.mounted && e.props.onChange && (e.props.onBeforeChange ? e.continueChange && e.props.onChange(e.editor, r, e.editor.getValue()) : e.props.onChange(e.editor, r, e.editor.getValue()));
            }), this.hydrate(this.props), this.shared.apply(this.props), this.applied = !0, this.mounted = !0, this.shared.wire(this.props), this.editor.getDoc().clearHistory(), this.props.editorDidMount && this.props.editorDidMount(this.editor, this.editor.getValue(), this.initCb));
          }, t.prototype.componentDidUpdate = function (e) {
            if (this.detached && !1 === this.props.detach && (this.detached = !1, e.editorDidAttach && e.editorDidAttach(this.editor)), this.detached || !0 !== this.props.detach || (this.detached = !0, e.editorDidDetach && e.editorDidDetach(this.editor)), !c && !this.detached) {
              var t = {
                cursor: null
              };
              this.props.value !== e.value && (this.hydrated = !1, this.applied = !1, this.appliedUserDefined = !1), e.autoCursor || void 0 === e.autoCursor || (t.cursor = this.editor.getDoc().getCursor()), this.hydrate(this.props), this.applied || (this.shared.apply(e), this.applied = !0), this.appliedUserDefined || (this.shared.applyUserDefined(e, t), this.appliedUserDefined = !0);
            }
          }, t.prototype.componentWillUnmount = function () {
            c || this.props.editorWillUnmount && this.props.editorWillUnmount(s);
          }, t.prototype.shouldComponentUpdate = function (e, t) {
            var r = !0;
            return c && (r = !1), this.detached && e.detach && (r = !1), r;
          }, t.prototype.render = function () {
            var e = this;
            if (c) return null;
            var t = this.props.className ? "react-codemirror2 " + this.props.className : "react-codemirror2";
            return l.createElement("div", {
              className: t,
              ref: function ref(t) {
                return e.ref = t;
              }
            });
          };
        }(l.Component);
      },
      4190: function _(e) {
        e.exports = {
          theme: "material-palenight",
          tabSize: 2,
          lineNumbers: !0
        };
      },
      559: function _(e) {
        var t = {
          aspx: "asp",
          bash: "shell",
          "c++": "cplusplus",
          "c#": "csharp",
          clj: "clojure",
          cljc: "clojure",
          cljx: "clojure",
          coffeescript: "javascript",
          cpp: "cplusplus",
          cql: "sql",
          cs: "csharp",
          docker: "dockerfile",
          ecmascript: "javascript",
          erl: "erlang",
          gql: "graphql",
          gradle: "groovy",
          handlebars: "html",
          hbs: "html",
          jl: "julia",
          jruby: "ruby",
          js: "javascript",
          kt: "kotlin",
          less: "css",
          macruby: "ruby",
          md: "markdown",
          ml: "ocaml",
          mssql: "sql",
          mysql: "sql",
          node: "javascript",
          "obj-c": "objectivec",
          "obj-c++": "objectivecplusplus",
          "objc++": "objectivecplusplus",
          objc: "objectivec",
          objcpp: "objectivecplusplus",
          objectivecpp: "objectivecplusplus",
          pgsql: "sql",
          pl: "perl",
          plsql: "sql",
          postgres: "sql",
          postgresql: "sql",
          ps1: "powershell",
          py: "python",
          rake: "ruby",
          rb: "ruby",
          rbx: "ruby",
          rs: "rust",
          sass: "css",
          scss: "css",
          sh: "shell",
          solidity: "sol",
          sqlite: "sql",
          styl: "css",
          stylus: "css",
          xhtml: "html",
          yml: "yaml",
          zsh: "shell"
        };
        e.exports = function (e) {
          return e in t ? t[e] : e;
        };
      },
      5355: function _(e, t, r) {
        r(1736), r(742), r(6461), r(1702), r(5844), r(5855), r(119), r(9555), r(410), r(3394), r(5372), r(9965), r(2375), r(2557), r(4581), r(7014), r(1716), r(3612), r(1459), r(7568), r(8446), r(8021), r(8058), r(4949), r(6906), r(1878), r(356), r(9393), r(9338);
      },
      7476: function _(e) {
        function t(e, t) {
          return function (e) {
            if (Array.isArray(e)) return e;
          }(e) || function (e, t) {
            var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (null == r) return;
            var n,
              i,
              o = [],
              a = !0,
              s = !1;
            try {
              for (r = r.call(e); !(a = (n = r.next()).done) && (o.push(n.value), !t || o.length !== t); a = !0) {
                ;
              }
            } catch (e) {
              s = !0, i = e;
            } finally {
              try {
                a || null == r.return || r.return();
              } finally {
                if (s) throw i;
              }
            }
            return o;
          }(e, t) || function (e, t) {
            if (!e) return;
            if ("string" == typeof e) return r(e, t);
            var n = Object.prototype.toString.call(e).slice(8, -1);
            "Object" === n && e.constructor && (n = e.constructor.name);
            if ("Map" === n || "Set" === n) return Array.from(e);
            if ("Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return r(e, t);
          }(e, t) || function () {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }
        function r(e, t) {
          (null == t || t > e.length) && (t = e.length);
          for (var r = 0, n = new Array(t); r < t; r++) {
            n[r] = e[r];
          }
          return n;
        }
        var n = {
          asp: "clike",
          aspx: "clike",
          bash: "shell",
          c: "clike",
          "c#": ["clike", "text/x-csharp"],
          "c++": ["clike", "text/x-c++src"],
          clj: "clojure",
          cljc: "clojure",
          cljx: "clojure",
          coffeescript: "javascript",
          cplusplus: ["clike", "text/x-c++src"],
          cpp: ["clike", "text/x-c++src"],
          cql: ["sql", "text/x-cassandra"],
          cs: ["clike", "text/x-csharp"],
          csharp: ["clike", "text/x-csharp"],
          curl: "shell",
          d: "d",
          diff: "diff",
          ecmascript: "javascript",
          erl: "erlang",
          go: ["go", "text/x-go"],
          gradle: "groovy",
          gql: "graphql",
          handlebars: "htmlmixed",
          hbs: "htmlmixed",
          html: "htmlmixed",
          java: ["clike", "text/x-java"],
          jl: "julia",
          js: "javascript",
          jsx: "jsx",
          json: ["javascript", "application/ld+json"],
          jruby: "ruby",
          kotlin: ["clike", "text/x-kotlin"],
          kt: ["clike", "text/x-kotlin"],
          less: "css",
          liquid: "htmlmixed",
          lua: "lua",
          node: "javascript",
          macruby: "ruby",
          markdown: "gfm",
          ml: ["mllike", "text/x-ocaml"],
          mssql: ["sql", "text/x-mssql"],
          mysql: ["sql", "text/x-mysql"],
          objc: ["clike", "text/x-objectivec"],
          "objc++": ["clike", "text/x-objectivec++"],
          objcpp: ["clike", "text/x-objectivec++"],
          objectivec: ["clike", "text/x-objectivec"],
          objectivecpp: ["clike", "text/x-objectivec++"],
          objectivecplusplus: ["clike", "text/x-objectivec++"],
          ocaml: ["mllike", "text/x-ocaml"],
          php: ["php", "text/x-php"],
          pgsql: ["sql", "text/x-pgsql"],
          pl: "perl",
          plsql: ["sql", "text/x-plsql"],
          postgres: ["sql", "text/x-pgsql"],
          postgresql: ["sql", "text/x-pgsql"],
          ps1: "powershell",
          py: "python",
          r: "r",
          rake: "ruby",
          rb: "ruby",
          rbx: "ruby",
          rs: "rust",
          sass: "css",
          scala: ["clike", "text/x-scala"],
          scss: "css",
          sh: "shell",
          sol: "clike",
          solidity: "clike",
          sql: ["sql", "text/x-sql"],
          sqlite: ["sql", "text/x-sqlite"],
          styl: "css",
          stylus: "css",
          text: ["null", "text/plain"],
          ts: ["javascript", "text/typescript"],
          typescript: ["javascript", "text/typescript"],
          xhtml: "htmlmixed",
          yml: "yaml",
          zsh: "shell"
        };
        e.exports = {
          modes: n,
          getMode: function getMode(e) {
            var r = e;
            return r in n && (r = n[r], Array.isArray(r) && (r = t(r, 2)[1])), r;
          }
        };
      },
      5857: function _(e) {
        var t = {
          asp: "ASP.NET",
          aspx: "ASP.NET",
          bash: "Bash",
          c: "C",
          "c#": "C#",
          "c++": "C++",
          coffeescript: "CoffeeScript",
          clj: "Clojure",
          cljc: "Clojure",
          cljx: "Clojure",
          clojure: "Clojure",
          cplusplus: "C++",
          cpp: "C++",
          cql: "Cassandra",
          cs: "C#",
          csharp: "C#",
          css: "CSS",
          curl: "cURL",
          d: "D",
          dart: "Dart",
          diff: "Diff",
          dockerfile: "Dockerfile",
          ecmascript: "ECMAScript",
          erl: "Erlang",
          erlang: "Erlang",
          go: "Go",
          gql: "GraphQL",
          gradle: "Gradle",
          graphql: "GraphQL",
          groovy: "Groovy",
          handlebars: "Handlebars",
          hbs: "Handlebars",
          haml: "HAML",
          haxe: "Haxe",
          html: "HTML",
          http: "HTTP",
          java: "Java",
          javascript: "JavaScript",
          jinja2: "Jinja2",
          jl: "Julia",
          jruby: "JRuby",
          js: "JavaScript",
          json: "JSON",
          jsx: "JSX",
          julia: "Julia",
          kotlin: "Kotlin",
          kt: "Kotlin",
          less: "LESS",
          liquid: "Liquid",
          lua: "Lua",
          macruby: "MacRuby",
          markdown: "Markdown",
          md: "Markdown",
          ml: "OCaml",
          mssql: "SQL Server",
          mysql: "MySQL",
          node: "Node",
          objc: "Objective-C",
          "objc++": "Objective-C++",
          objcpp: "Objective-C++",
          objectivec: "Objective-C",
          objectivecpp: "Objective-C++",
          objectivecplusplus: "Objective-C++",
          ocaml: "OCaml",
          perl: "Perl",
          php: "PHP",
          pl: "Perl",
          pgsql: "PL/pgSQL",
          plsql: "PL/SQL",
          postgres: "PostgreSQL",
          postgresql: "PostgreSQL",
          powershell: "PowerShell",
          ps1: "PowerShell",
          python: "Python",
          py: "Python",
          r: "R",
          rake: "Rake",
          rb: "Ruby",
          rbx: "Rubinius",
          rs: "Rust",
          ruby: "Ruby",
          rust: "Rust",
          sass: "Sass",
          scala: "Scala",
          scss: "SCSS",
          sh: "Shell",
          shell: "Shell",
          smarty: "Smarty",
          solidity: "Solidity",
          sql: "SQL",
          sqlite: "SQLite",
          stylus: "Stylus",
          styl: "Stylus",
          swift: "Swift",
          text: "Text",
          toml: "TOML",
          twig: "Twig",
          typescript: "TypeScript",
          xhtml: "XHTML",
          xml: "XML",
          yaml: "YAML",
          yml: "YAML",
          zsh: "Zsh"
        };
        e.exports = function (e) {
          return e in t ? t[e] : e;
        };
      },
      9061: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return s;
          }
        });
        var n = r(7499),
          i = r.n(n),
          o = r(8922),
          a = r.n(o)()(i());
        a.push([e.id, '.CodeMirror-foldmarker {\n  color: blue;\n  text-shadow: #b9f 1px 1px 2px, #b9f -1px -1px 2px, #b9f 1px -1px 2px, #b9f -1px 1px 2px;\n  font-family: arial;\n  line-height: .3;\n  cursor: pointer;\n}\n.CodeMirror-foldgutter {\n  width: .7em;\n}\n.CodeMirror-foldgutter-open,\n.CodeMirror-foldgutter-folded {\n  cursor: pointer;\n}\n.CodeMirror-foldgutter-open:after {\n  content: "\\25BE";\n}\n.CodeMirror-foldgutter-folded:after {\n  content: "\\25B8";\n}\n', ""]);
        var s = a;
      },
      1240: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return s;
          }
        });
        var n = r(7499),
          i = r.n(n),
          o = r(8922),
          a = r.n(o)()(i());
        a.push([e.id, "/* BASICS */\n\n.CodeMirror {\n  /* Set height, width, borders, and global font properties here */\n  font-family: monospace;\n  height: 300px;\n  color: black;\n  direction: ltr;\n}\n\n/* PADDING */\n\n.CodeMirror-lines {\n  padding: 4px 0; /* Vertical padding around content */\n}\n.CodeMirror pre.CodeMirror-line,\n.CodeMirror pre.CodeMirror-line-like {\n  padding: 0 4px; /* Horizontal padding of content */\n}\n\n.CodeMirror-scrollbar-filler, .CodeMirror-gutter-filler {\n  background-color: white; /* The little square between H and V scrollbars */\n}\n\n/* GUTTER */\n\n.CodeMirror-gutters {\n  border-right: 1px solid #ddd;\n  background-color: #f7f7f7;\n  white-space: nowrap;\n}\n.CodeMirror-linenumbers {}\n.CodeMirror-linenumber {\n  padding: 0 3px 0 5px;\n  min-width: 20px;\n  text-align: right;\n  color: #999;\n  white-space: nowrap;\n}\n\n.CodeMirror-guttermarker { color: black; }\n.CodeMirror-guttermarker-subtle { color: #999; }\n\n/* CURSOR */\n\n.CodeMirror-cursor {\n  border-left: 1px solid black;\n  border-right: none;\n  width: 0;\n}\n/* Shown when moving in bi-directional text */\n.CodeMirror div.CodeMirror-secondarycursor {\n  border-left: 1px solid silver;\n}\n.cm-fat-cursor .CodeMirror-cursor {\n  width: auto;\n  border: 0 !important;\n  background: #7e7;\n}\n.cm-fat-cursor div.CodeMirror-cursors {\n  z-index: 1;\n}\n.cm-fat-cursor-mark {\n  background-color: rgba(20, 255, 20, 0.5);\n  -webkit-animation: blink 1.06s steps(1) infinite;\n  -moz-animation: blink 1.06s steps(1) infinite;\n  animation: blink 1.06s steps(1) infinite;\n}\n.cm-animate-fat-cursor {\n  width: auto;\n  border: 0;\n  -webkit-animation: blink 1.06s steps(1) infinite;\n  -moz-animation: blink 1.06s steps(1) infinite;\n  animation: blink 1.06s steps(1) infinite;\n  background-color: #7e7;\n}\n@-moz-keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n@-webkit-keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n@keyframes blink {\n  0% {}\n  50% { background-color: transparent; }\n  100% {}\n}\n\n/* Can style cursor different in overwrite (non-insert) mode */\n.CodeMirror-overwrite .CodeMirror-cursor {}\n\n.cm-tab { display: inline-block; text-decoration: inherit; }\n\n.CodeMirror-rulers {\n  position: absolute;\n  left: 0; right: 0; top: -50px; bottom: 0;\n  overflow: hidden;\n}\n.CodeMirror-ruler {\n  border-left: 1px solid #ccc;\n  top: 0; bottom: 0;\n  position: absolute;\n}\n\n/* DEFAULT THEME */\n\n.cm-s-default .cm-header {color: blue;}\n.cm-s-default .cm-quote {color: #090;}\n.cm-negative {color: #d44;}\n.cm-positive {color: #292;}\n.cm-header, .cm-strong {font-weight: bold;}\n.cm-em {font-style: italic;}\n.cm-link {text-decoration: underline;}\n.cm-strikethrough {text-decoration: line-through;}\n\n.cm-s-default .cm-keyword {color: #708;}\n.cm-s-default .cm-atom {color: #219;}\n.cm-s-default .cm-number {color: #164;}\n.cm-s-default .cm-def {color: #00f;}\n.cm-s-default .cm-variable,\n.cm-s-default .cm-punctuation,\n.cm-s-default .cm-property,\n.cm-s-default .cm-operator {}\n.cm-s-default .cm-variable-2 {color: #05a;}\n.cm-s-default .cm-variable-3, .cm-s-default .cm-type {color: #085;}\n.cm-s-default .cm-comment {color: #a50;}\n.cm-s-default .cm-string {color: #a11;}\n.cm-s-default .cm-string-2 {color: #f50;}\n.cm-s-default .cm-meta {color: #555;}\n.cm-s-default .cm-qualifier {color: #555;}\n.cm-s-default .cm-builtin {color: #30a;}\n.cm-s-default .cm-bracket {color: #997;}\n.cm-s-default .cm-tag {color: #170;}\n.cm-s-default .cm-attribute {color: #00c;}\n.cm-s-default .cm-hr {color: #999;}\n.cm-s-default .cm-link {color: #00c;}\n\n.cm-s-default .cm-error {color: #f00;}\n.cm-invalidchar {color: #f00;}\n\n.CodeMirror-composing { border-bottom: 2px solid; }\n\n/* Default styles for common addons */\n\ndiv.CodeMirror span.CodeMirror-matchingbracket {color: #0b0;}\ndiv.CodeMirror span.CodeMirror-nonmatchingbracket {color: #a22;}\n.CodeMirror-matchingtag { background: rgba(255, 150, 0, .3); }\n.CodeMirror-activeline-background {background: #e8f2ff;}\n\n/* STOP */\n\n/* The rest of this file contains styles related to the mechanics of\n   the editor. You probably shouldn't touch them. */\n\n.CodeMirror {\n  position: relative;\n  overflow: hidden;\n  background: white;\n}\n\n.CodeMirror-scroll {\n  overflow: scroll !important; /* Things will break if this is overridden */\n  /* 50px is the magic margin used to hide the element's real scrollbars */\n  /* See overflow: hidden in .CodeMirror */\n  margin-bottom: -50px; margin-right: -50px;\n  padding-bottom: 50px;\n  height: 100%;\n  outline: none; /* Prevent dragging from highlighting the element */\n  position: relative;\n}\n.CodeMirror-sizer {\n  position: relative;\n  border-right: 50px solid transparent;\n}\n\n/* The fake, visible scrollbars. Used to force redraw during scrolling\n   before actual scrolling happens, thus preventing shaking and\n   flickering artifacts. */\n.CodeMirror-vscrollbar, .CodeMirror-hscrollbar, .CodeMirror-scrollbar-filler, .CodeMirror-gutter-filler {\n  position: absolute;\n  z-index: 6;\n  display: none;\n}\n.CodeMirror-vscrollbar {\n  right: 0; top: 0;\n  overflow-x: hidden;\n  overflow-y: scroll;\n}\n.CodeMirror-hscrollbar {\n  bottom: 0; left: 0;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n.CodeMirror-scrollbar-filler {\n  right: 0; bottom: 0;\n}\n.CodeMirror-gutter-filler {\n  left: 0; bottom: 0;\n}\n\n.CodeMirror-gutters {\n  position: absolute; left: 0; top: 0;\n  min-height: 100%;\n  z-index: 3;\n}\n.CodeMirror-gutter {\n  white-space: normal;\n  height: 100%;\n  display: inline-block;\n  vertical-align: top;\n  margin-bottom: -50px;\n}\n.CodeMirror-gutter-wrapper {\n  position: absolute;\n  z-index: 4;\n  background: none !important;\n  border: none !important;\n}\n.CodeMirror-gutter-background {\n  position: absolute;\n  top: 0; bottom: 0;\n  z-index: 4;\n}\n.CodeMirror-gutter-elt {\n  position: absolute;\n  cursor: default;\n  z-index: 4;\n}\n.CodeMirror-gutter-wrapper ::selection { background-color: transparent }\n.CodeMirror-gutter-wrapper ::-moz-selection { background-color: transparent }\n\n.CodeMirror-lines {\n  cursor: text;\n  min-height: 1px; /* prevents collapsing before first draw */\n}\n.CodeMirror pre.CodeMirror-line,\n.CodeMirror pre.CodeMirror-line-like {\n  /* Reset some styles that the rest of the page might have set */\n  -moz-border-radius: 0; -webkit-border-radius: 0; border-radius: 0;\n  border-width: 0;\n  background: transparent;\n  font-family: inherit;\n  font-size: inherit;\n  margin: 0;\n  white-space: pre;\n  word-wrap: normal;\n  line-height: inherit;\n  color: inherit;\n  z-index: 2;\n  position: relative;\n  overflow: visible;\n  -webkit-tap-highlight-color: transparent;\n  -webkit-font-variant-ligatures: contextual;\n  font-variant-ligatures: contextual;\n}\n.CodeMirror-wrap pre.CodeMirror-line,\n.CodeMirror-wrap pre.CodeMirror-line-like {\n  word-wrap: break-word;\n  white-space: pre-wrap;\n  word-break: normal;\n}\n\n.CodeMirror-linebackground {\n  position: absolute;\n  left: 0; right: 0; top: 0; bottom: 0;\n  z-index: 0;\n}\n\n.CodeMirror-linewidget {\n  position: relative;\n  z-index: 2;\n  padding: 0.1px; /* Force widget margins to stay inside of the container */\n}\n\n.CodeMirror-widget {}\n\n.CodeMirror-rtl pre { direction: rtl; }\n\n.CodeMirror-code {\n  outline: none;\n}\n\n/* Force content-box sizing for the elements where we expect it */\n.CodeMirror-scroll,\n.CodeMirror-sizer,\n.CodeMirror-gutter,\n.CodeMirror-gutters,\n.CodeMirror-linenumber {\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\n\n.CodeMirror-measure {\n  position: absolute;\n  width: 100%;\n  height: 0;\n  overflow: hidden;\n  visibility: hidden;\n}\n\n.CodeMirror-cursor {\n  position: absolute;\n  pointer-events: none;\n}\n.CodeMirror-measure pre { position: static; }\n\ndiv.CodeMirror-cursors {\n  visibility: hidden;\n  position: relative;\n  z-index: 3;\n}\ndiv.CodeMirror-dragcursors {\n  visibility: visible;\n}\n\n.CodeMirror-focused div.CodeMirror-cursors {\n  visibility: visible;\n}\n\n.CodeMirror-selected { background: #d9d9d9; }\n.CodeMirror-focused .CodeMirror-selected { background: #d7d4f0; }\n.CodeMirror-crosshair { cursor: crosshair; }\n.CodeMirror-line::selection, .CodeMirror-line > span::selection, .CodeMirror-line > span > span::selection { background: #d7d4f0; }\n.CodeMirror-line::-moz-selection, .CodeMirror-line > span::-moz-selection, .CodeMirror-line > span > span::-moz-selection { background: #d7d4f0; }\n\n.cm-searching {\n  background-color: #ffa;\n  background-color: rgba(255, 255, 0, .4);\n}\n\n/* Used to force a border model for a node */\n.cm-force-border { padding-right: .1px; }\n\n@media print {\n  /* Hide the cursor when printing */\n  .CodeMirror div.CodeMirror-cursors {\n    visibility: hidden;\n  }\n}\n\n/* See issue #2901 */\n.cm-tab-wrap-hack:after { content: ''; }\n\n/* Help users use markselection to safely style text background */\nspan.CodeMirror-selectedtext { background: none; }\n", ""]);
        var s = a;
      },
      9783: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return s;
          }
        });
        var n = r(7499),
          i = r.n(n),
          o = r(8922),
          a = r.n(o)()(i());
        a.push([e.id, "/*\n  Name:       material\n  Author:     Mattia Astorino (http://github.com/equinusocio)\n  Website:    https://material-theme.site/\n*/\n\n.cm-s-material-palenight.CodeMirror {\n  background-color: #292D3E;\n  color: #A6ACCD;\n}\n\n.cm-s-material-palenight .CodeMirror-gutters {\n  background: #292D3E;\n  color: #676E95;\n  border: none;\n}\n\n.cm-s-material-palenight .CodeMirror-guttermarker,\n.cm-s-material-palenight .CodeMirror-guttermarker-subtle,\n.cm-s-material-palenight .CodeMirror-linenumber {\n  color: #676E95;\n}\n\n.cm-s-material-palenight .CodeMirror-cursor {\n  border-left: 1px solid #FFCC00;\n}\n\n.cm-s-material-palenight div.CodeMirror-selected {\n  background: rgba(113, 124, 180, 0.2);\n}\n\n.cm-s-material-palenight.CodeMirror-focused div.CodeMirror-selected {\n  background: rgba(113, 124, 180, 0.2);\n}\n\n.cm-s-material-palenight .CodeMirror-line::selection,\n.cm-s-material-palenight .CodeMirror-line>span::selection,\n.cm-s-material-palenight .CodeMirror-line>span>span::selection {\n  background: rgba(128, 203, 196, 0.2);\n}\n\n.cm-s-material-palenight .CodeMirror-line::-moz-selection,\n.cm-s-material-palenight .CodeMirror-line>span::-moz-selection,\n.cm-s-material-palenight .CodeMirror-line>span>span::-moz-selection {\n  background: rgba(128, 203, 196, 0.2);\n}\n\n.cm-s-material-palenight .CodeMirror-activeline-background {\n  background: rgba(0, 0, 0, 0.5);\n}\n\n.cm-s-material-palenight .cm-keyword {\n  color: #C792EA;\n}\n\n.cm-s-material-palenight .cm-operator {\n  color: #89DDFF;\n}\n\n.cm-s-material-palenight .cm-variable-2 {\n  color: #EEFFFF;\n}\n\n.cm-s-material-palenight .cm-variable-3,\n.cm-s-material-palenight .cm-type {\n  color: #f07178;\n}\n\n.cm-s-material-palenight .cm-builtin {\n  color: #FFCB6B;\n}\n\n.cm-s-material-palenight .cm-atom {\n  color: #F78C6C;\n}\n\n.cm-s-material-palenight .cm-number {\n  color: #FF5370;\n}\n\n.cm-s-material-palenight .cm-def {\n  color: #82AAFF;\n}\n\n.cm-s-material-palenight .cm-string {\n  color: #C3E88D;\n}\n\n.cm-s-material-palenight .cm-string-2 {\n  color: #f07178;\n}\n\n.cm-s-material-palenight .cm-comment {\n  color: #676E95;\n}\n\n.cm-s-material-palenight .cm-variable {\n  color: #f07178;\n}\n\n.cm-s-material-palenight .cm-tag {\n  color: #FF5370;\n}\n\n.cm-s-material-palenight .cm-meta {\n  color: #FFCB6B;\n}\n\n.cm-s-material-palenight .cm-attribute {\n  color: #C792EA;\n}\n\n.cm-s-material-palenight .cm-property {\n  color: #C792EA;\n}\n\n.cm-s-material-palenight .cm-qualifier {\n  color: #DECB6B;\n}\n\n.cm-s-material-palenight .cm-variable-3,\n.cm-s-material-palenight .cm-type {\n  color: #DECB6B;\n}\n\n\n.cm-s-material-palenight .cm-error {\n  color: rgba(255, 255, 255, 1.0);\n  background-color: #FF5370;\n}\n\n.cm-s-material-palenight .CodeMirror-matchingbracket {\n  text-decoration: underline;\n  color: white !important;\n}", ""]);
        var s = a;
      },
      1899: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return s;
          }
        });
        var n = r(7499),
          i = r.n(n),
          o = r(8922),
          a = r.n(o)()(i());
        a.push([e.id, "/* neo theme for codemirror */\n\n/* Color scheme */\n\n.cm-s-neo.CodeMirror {\n  background-color:#ffffff;\n  color:#2e383c;\n  line-height:1.4375;\n}\n.cm-s-neo .cm-comment { color:#75787b; }\n.cm-s-neo .cm-keyword, .cm-s-neo .cm-property { color:#1d75b3; }\n.cm-s-neo .cm-atom,.cm-s-neo .cm-number { color:#75438a; }\n.cm-s-neo .cm-node,.cm-s-neo .cm-tag { color:#9c3328; }\n.cm-s-neo .cm-string { color:#b35e14; }\n.cm-s-neo .cm-variable,.cm-s-neo .cm-qualifier { color:#047d65; }\n\n\n/* Editor styling */\n\n.cm-s-neo pre {\n  padding:0;\n}\n\n.cm-s-neo .CodeMirror-gutters {\n  border:none;\n  border-right:10px solid transparent;\n  background-color:transparent;\n}\n\n.cm-s-neo .CodeMirror-linenumber {\n  padding:0;\n  color:#e0e2e5;\n}\n\n.cm-s-neo .CodeMirror-guttermarker { color: #1d75b3; }\n.cm-s-neo .CodeMirror-guttermarker-subtle { color: #e0e2e5; }\n\n.cm-s-neo .CodeMirror-cursor {\n  width: auto;\n  border: 0;\n  background: rgba(155,157,162,0.37);\n  z-index: 1;\n}\n", ""]);
        var s = a;
      },
      9633: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return p;
          }
        });
        var n = r(7499),
          i = r.n(n),
          o = r(8922),
          a = r.n(o),
          s = r(1240),
          l = r(9783),
          c = r(1899),
          u = r(9061),
          d = a()(i());
        d.i(s.Z), d.i(l.Z), d.i(c.Z), d.i(u.Z), d.push([e.id, ".CodeEditor{}\n", ""]);
        var p = d;
      },
      3223: function _(e, t, r) {
        "use strict";

        r.d(t, {
          Z: function Z() {
            return s;
          }
        });
        var n = r(7499),
          i = r.n(n),
          o = r(8922),
          a = r.n(o)()(i());
        a.push([e.id, ".CodeEditor.cm-s-material-palenight:not(.CodeEditor-Input_highlight) .cm-linerow.cm-overlay,.CodeEditor.cm-s-material-palenight:not(.CodeEditor-Input_highlight) .cm-linerow.cm-overlay>span,.CodeEditor.cm-s-material-palenight:not(.CodeEditor-Input_highlight) .cm-linerow.cm-overlay>p{color:rgba(255,255,255,0.5)}.CodeEditor.cm-s-material-palenight .cm-highlight{background:rgba(0,0,0,0.25)}.CodeEditor.cm-s-material-palenight .CodeMirror{background:#242e34;color:#fff}.CodeEditor.cm-s-neo:not(.CodeEditor-Input_highlight) .cm-linerow.cm-overlay,.CodeEditor.cm-s-neo:not(.CodeEditor-Input_highlight) .cm-linerow.cm-overlay>span,.CodeEditor.cm-s-neo:not(.CodeEditor-Input_highlight) .cm-linerow.cm-overlay>p{color:rgba(0,0,0,0.5)}.CodeEditor.cm-s-neo .cm-highlight{background:rgba(0,0,0,0.1)}.CodeEditor.cm-s-neo .CodeMirror{background:#fff;color:#000}.CodeEditor .cm-linerow.cm-overlay,.CodeEditor .cm-linerow.cm-overlay .cm-lineNumber{opacity:0.75}.cm-linerow{position:relative;text-indent:47px;transition:background 0.5s cubic-bezier(0.16, 1, 0.3, 1),color 0.5s cubic-bezier(0.16, 1, 0.3, 1),opacity 0.5s cubic-bezier(0.16, 1, 0.3, 1)}.cm-linerow>span,.cm-linerow>p{transition:color 0.5s cubic-bezier(0.16, 1, 0.3, 1)}.cm-lineNumber{color:#676e95;display:inline-block;left:0;margin:0;min-width:43px;padding:0 6px 0 10px;position:absolute;right:auto;text-align:right;text-indent:0;top:0;transition:opacity 0.5s cubic-bezier(0.16, 1, 0.3, 1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}\n", ""]);
        var s = a;
      },
      3379: function _(e) {
        "use strict";

        var t = [];
        function r(e) {
          for (var r = -1, n = 0; n < t.length; n++) {
            if (t[n].identifier === e) {
              r = n;
              break;
            }
          }
          return r;
        }
        function n(e, n) {
          for (var o = {}, a = [], s = 0; s < e.length; s++) {
            var l = e[s],
              c = n.base ? l[0] + n.base : l[0],
              u = o[c] || 0,
              d = "".concat(c, " ").concat(u);
            o[c] = u + 1;
            var p = r(d),
              f = {
                css: l[1],
                media: l[2],
                sourceMap: l[3],
                supports: l[4],
                layer: l[5]
              };
            if (-1 !== p) t[p].references++, t[p].updater(f);else {
              var m = i(f, n);
              n.byIndex = s, t.splice(s, 0, {
                identifier: d,
                updater: m,
                references: 1
              });
            }
            a.push(d);
          }
          return a;
        }
        function i(e, t) {
          var r = t.domAPI(t);
          r.update(e);
          return function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap && t.supports === e.supports && t.layer === e.layer) return;
              r.update(e = t);
            } else r.remove();
          };
        }
        e.exports = function (e, i) {
          var o = n(e = e || [], i = i || {});
          return function (e) {
            e = e || [];
            for (var a = 0; a < o.length; a++) {
              var s = r(o[a]);
              t[s].references--;
            }
            for (var l = n(e, i), c = 0; c < o.length; c++) {
              var u = r(o[c]);
              0 === t[u].references && (t[u].updater(), t.splice(u, 1));
            }
            o = l;
          };
        };
      },
      569: function _(e) {
        "use strict";

        var t = {};
        e.exports = function (e, r) {
          var n = function (e) {
            if (void 0 === t[e]) {
              var r = document.querySelector(e);
              if (window.HTMLIFrameElement && r instanceof window.HTMLIFrameElement) try {
                r = r.contentDocument.head;
              } catch (e) {
                r = null;
              }
              t[e] = r;
            }
            return t[e];
          }(e);
          if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
          n.appendChild(r);
        };
      },
      9216: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = document.createElement("style");
          return e.setAttributes(t, e.attributes), e.insert(t, e.options), t;
        };
      },
      3565: function _(e, t, r) {
        "use strict";

        e.exports = function (e) {
          var t = r.nc;
          t && e.setAttribute("nonce", t);
        };
      },
      7795: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = e.insertStyleElement(e);
          return {
            update: function update(r) {
              !function (e, t, r) {
                var n = "";
                r.supports && (n += "@supports (".concat(r.supports, ") {")), r.media && (n += "@media ".concat(r.media, " {"));
                var i = void 0 !== r.layer;
                i && (n += "@layer".concat(r.layer.length > 0 ? " ".concat(r.layer) : "", " {")), n += r.css, i && (n += "}"), r.media && (n += "}"), r.supports && (n += "}");
                var o = r.sourceMap;
                o && "undefined" != typeof btoa && (n += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(o)))), " */")), t.styleTagTransform(n, e, t.options);
              }(t, e, r);
            },
            remove: function remove() {
              !function (e) {
                if (null === e.parentNode) return !1;
                e.parentNode.removeChild(e);
              }(t);
            }
          };
        };
      },
      4589: function _(e) {
        "use strict";

        e.exports = function (e, t) {
          if (t.styleSheet) t.styleSheet.cssText = e;else {
            for (; t.firstChild;) {
              t.removeChild(t.firstChild);
            }
            t.appendChild(document.createTextNode(e));
          }
        };
      },
      6992: function _(e) {
        "use strict";

        e.exports = __webpack_require__(4466);
      }
    },
    t = {};
  function r(n) {
    var i = t[n];
    if (void 0 !== i) return i.exports;
    var o = t[n] = {
      id: n,
      loaded: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.loaded = !0, o.exports;
  }
  r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, {
      a: t
    }), t;
  }, r.d = function (e, t) {
    for (var n in t) {
      r.o(t, n) && !r.o(e, n) && Object.defineProperty(e, n, {
        enumerable: !0,
        get: t[n]
      });
    }
  }, r.g = function () {
    if ("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis))) return globalThis;
    try {
      return this || new Function("return this")();
    } catch (e) {
      if ("object" == (typeof window === "undefined" ? "undefined" : _typeof(window))) return window;
    }
  }(), r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.nmd = function (e) {
    return e.paths = [], e.children || (e.children = []), e;
  }, r.nc = void 0;
  var n = {};
  (function () {
    "use strict";

    r.r(n), r.d(n, {
      canonical: function canonical() {
        return X();
      },
      cmVariableContext: function cmVariableContext() {
        return D.VariablesContext;
      },
      default: function _default() {
        return re;
      },
      modes: function modes() {
        return s.modes;
      },
      uppercase: function uppercase() {
        return Q();
      }
    });
    var e = r(6992),
      t = r.n(e),
      i = r(6526),
      o = r.n(i),
      a = r(1022),
      s = (r(5355), r(7476)),
      l = r(4190),
      c = r.n(l),
      u = r(3379),
      d = r.n(u),
      p = r(7795),
      f = r.n(p),
      m = r(569),
      h = r.n(m),
      g = r(3565),
      y = r.n(g),
      v = r(9216),
      b = r.n(v),
      x = r(4589),
      k = r.n(x),
      w = r(9633),
      _ = {};
    _.styleTagTransform = k(), _.setAttributes = y(), _.insert = h().bind(null, "head"), _.domAPI = f(), _.insertStyleElement = b();
    d()(w.Z, _);
    w.Z && w.Z.locals && w.Z.locals;
    var S = ["className", "code", "lang", "options", "children", "theme"];
    function C() {
      return C = Object.assign || function (e) {
        for (var t = 1; t < arguments.length; t++) {
          var r = arguments[t];
          for (var n in r) {
            Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
          }
        }
        return e;
      }, C.apply(this, arguments);
    }
    function T(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function M(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? T(Object(r), !0).forEach(function (t) {
          E(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : T(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function E(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    function L(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null == r) return;
        var n,
          i,
          o = [],
          a = !0,
          s = !1;
        try {
          for (r = r.call(e); !(a = (n = r.next()).done) && (o.push(n.value), !t || o.length !== t); a = !0) {
            ;
          }
        } catch (e) {
          s = !0, i = e;
        } finally {
          try {
            a || null == r.return || r.return();
          } finally {
            if (s) throw i;
          }
        }
        return o;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return A(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return A(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function A(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }
      return n;
    }
    function N(e, t) {
      if (null == e) return {};
      var r,
        n,
        i = function (e, t) {
          if (null == e) return {};
          var r,
            n,
            i = {},
            o = Object.keys(e);
          for (n = 0; n < o.length; n++) {
            r = o[n], t.indexOf(r) >= 0 || (i[r] = e[r]);
          }
          return i;
        }(e, t);
      if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        for (n = 0; n < o.length; n++) {
          r = o[n], t.indexOf(r) >= 0 || Object.prototype.propertyIsEnumerable.call(e, r) && (i[r] = e[r]);
        }
      }
      return i;
    }
    var z = function z(r) {
      r.className;
      var n = r.code,
        i = r.lang,
        o = r.options,
        l = r.children,
        u = r.theme,
        d = N(r, S),
        p = L((0, e.useState)(l && "string" == typeof l ? l : n), 2),
        f = p[0],
        m = p[1],
        h = L((0, e.useState)((0, s.getMode)(i)), 2),
        g = h[0],
        y = h[1];
      return (0, e.useEffect)(function () {
        m(l && "string" == typeof l ? l : n);
      }, [n, l]), (0, e.useEffect)(function () {
        y(function (e) {
          var t = (0, s.getMode)(i);
          return t !== e ? t : e;
        });
      }, [i]), t().createElement(a.fk, C({}, d, {
        className: "CodeEditor",
        onBeforeChange: function onBeforeChange(e, t, r) {
          return m(r);
        },
        options: M(M(M({}, c()), o), {}, {
          mode: g,
          theme: u
        }),
        value: f
      }));
    };
    z.propTypes = {
      children: o().string,
      className: o().string,
      code: o().string,
      lang: o().string,
      options: o().object,
      theme: o().oneOf(["neo", "material-palenight", "tomorrow-night"])
    }, z.defaultProps = {
      className: "",
      code: "",
      options: {},
      theme: "material-palenight"
    };
    var O = z,
      D = __webpack_require__(3689);
    var I = r.n(D),
      P = r(9074),
      j = r.n(P),
      q = (r(2661), r(5365), r(622), r(318), r(3223)),
      F = {};
    F.styleTagTransform = k(), F.setAttributes = y(), F.insert = h().bind(null, "head"), F.domAPI = f(), F.insertStyleElement = b();
    d()(q.Z, F);
    q.Z && q.Z.locals && q.Z.locals;
    function R(e, t) {
      return function (e) {
        if (Array.isArray(e)) return e;
      }(e) || function (e, t) {
        var r = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
        if (null == r) return;
        var n,
          i,
          o = [],
          a = !0,
          s = !1;
        try {
          for (r = r.call(e); !(a = (n = r.next()).done) && (o.push(n.value), !t || o.length !== t); a = !0) {
            ;
          }
        } catch (e) {
          s = !0, i = e;
        } finally {
          try {
            a || null == r.return || r.return();
          } finally {
            if (s) throw i;
          }
        }
        return o;
      }(e, t) || function (e, t) {
        if (!e) return;
        if ("string" == typeof e) return W(e, t);
        var r = Object.prototype.toString.call(e).slice(8, -1);
        "Object" === r && e.constructor && (r = e.constructor.name);
        if ("Map" === r || "Set" === r) return Array.from(e);
        if ("Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r)) return W(e, t);
      }(e, t) || function () {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
      }();
    }
    function W(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var r = 0, n = new Array(t); r < t; r++) {
        n[r] = e[r];
      }
      return n;
    }
    var $ = function $(e) {
        return t().createElement("span", {
          key: "ln-".concat(e),
          className: "cm-lineNumber"
        }, e);
      },
      U = function U(e) {
        var r = e.className,
          n = e.child;
        return t().createElement("div", {
          className: r
        }, n);
      };
    U.propTypes = {
      child: o().any,
      className: o().string
    };
    var H = function H(e) {
      var r = e.gutteredInput,
        n = e.highlights,
        i = void 0 === n ? [] : n;
      return r.map(function (e, r) {
        return t().createElement(U, {
          key: "cm-wrapped-".concat(r),
          child: e,
          className: ["cm-linerow", i.length ? i[r] : ""].join(" ")
        });
      });
    };
    H.propTypes = {
      gutteredInput: o().any,
      highlights: o().arrayOf(o().string)
    };
    var B = function B(e) {
        var r = e.output,
          n = e.ranges,
          i = /\r?\n/,
          o = [],
          a = [],
          s = 1,
          l = function l(e) {
            e && a.push("\n"), o.push(a), a = [$(s += 1)];
          },
          c = function c(e, t) {
            1 === e.length && i.test(e) ? l(!0) : e.split(i).forEach(function (e) {
              e.length ? (a.push(e), t && l()) : l(!0);
            });
          };
        r.unshift($(1)), r.forEach(function (e, t) {
          t === r.length - 1 ? "string" == typeof e ? c(e, !0) : (a.push(e), o.push(a)) : i.test(e) ? "string" == typeof e && c(e) : a.push(e);
        });
        var u = n && n.length ? function (e, t) {
          var r = [];
          e.forEach(function (e) {
            for (var t = R(e, 2), n = t[0], i = t[1].line, o = n.line; o < i;) {
              r[o] = "cm-highlight", o += 1;
            }
          });
          for (var n = 0; n < t; n += 1) {
            r[n] || (r[n] = "cm-overlay");
          }
          return r;
        }(n, o.length) : [];
        return t().createElement("div", {
          className: "CodeMirror"
        }, t().createElement(H, {
          gutteredInput: o,
          highlights: u
        }));
      },
      V = function V(e) {
        var r = 0,
          n = e.shift();
        return function i(o) {
          if (!n) return o;
          if (r <= n.offset && n.offset <= r + o.length) {
            var a = n.offset - r,
              s = [o.slice(0, a), o.slice(a)],
              l = s[0],
              c = s[1],
              u = t().createElement(I(), {
                key: "variable-".concat(r),
                variable: n.text
              });
            return r += a, n = e.shift(), [l, u, i(c)];
          }
          return r += o.length, o;
        };
      },
      G = function G(e, t) {
        if (!t.tokenizeVariables) return [e, function (e) {
          return e;
        }];
        var r = 0,
          n = [];
        return [e.replace(new RegExp(D.VARIABLE_REGEXP, "g"), function (e, t, i) {
          var o = e.length;
          return n.push({
            text: t,
            offset: i - r
          }), r += o, "";
        }), V(n)];
      };
    B.propTypes = {
      output: o().arrayOf(o().any),
      ranges: o().arrayOf(o().any)
    };
    var K = function K(e, r) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
          tokenizeVariables: !1,
          highlightMode: !1,
          ranges: []
        },
        i = (0, s.getMode)(r),
        o = [],
        a = G(e, n),
        l = R(a, 2),
        c = l[0],
        u = l[1],
        d = null,
        p = "",
        f = 0;
      function m() {
        var e = u(p),
          r = d ? t().createElement("span", {
            key: f++,
            className: "".concat(d.replace(/(^|\s+)/g, "$1cm-"))
          }, e) : e;
        o.push(r);
      }
      return j().runMode(c, i, function (e, t) {
        t !== d || n.highlightMode && /\r?\n/.test(e) ? (m(), d = t, p = e) : p += e;
      }), m(), n.highlightMode ? t().createElement(B, {
        output: o,
        ranges: n.ranges
      }) : o;
    };
    var Z = r(559),
      X = r.n(Z),
      Y = r(5857),
      Q = r.n(Y);
    function J(e, t) {
      var r = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var n = Object.getOwnPropertySymbols(e);
        t && (n = n.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), r.push.apply(r, n);
      }
      return r;
    }
    function ee(e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = null != arguments[t] ? arguments[t] : {};
        t % 2 ? J(Object(r), !0).forEach(function (t) {
          te(e, t, r[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : J(Object(r)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
        });
      }
      return e;
    }
    function te(e, t, r) {
      return t in e ? Object.defineProperty(e, t, {
        value: r,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = r, e;
    }
    var re = function re(e, r) {
      var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {
          className: "",
          customTheme: !1,
          dark: !1,
          editable: !1,
          inline: !1,
          tokenizeVariables: !1
        },
        i = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {},
        o = n.dark ? "material-palenight" : "neo";
      if (n.customTheme && (o = n.customTheme), n.foldGutter && (n.editable = !0, n.gutters = ["CodeMirror-linenumbers", "CodeMirror-foldgutter"]), n.editable) return t().createElement(O, ee(ee({}, i), {}, {
        code: e,
        lang: r,
        theme: o,
        options: n
      }));
      var a = ["cm-s-".concat(o)];
      n.className && a.push(n.className), n.highlightMode && a.push("CodeEditor");
      var s = n.inline ? "span" : "div";
      return t().createElement(s, {
        className: a.join(" ")
      }, K("string" == typeof e ? e : "", r, n));
    };
  })(), module.exports = n;
})();

/***/ }),

/***/ 2531:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "options": () => (/* binding */ options),
/* harmony export */   "parseOptions": () => (/* binding */ parseOptions)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var options = {
  alwaysThrow: false,
  compatibilityMode: false,
  copyButtons: true,
  correctnewlines: false,
  markdownOptions: {
    fences: true,
    commonmark: true,
    gfm: true,
    ruleSpaces: false,
    listItemIndent: '1',
    spacedTable: true,
    paddedTable: true
  },
  lazyImages: true,
  normalize: true,
  safeMode: false,
  settings: {
    position: false
  },
  theme: 'light'
};

/**
 * @note disabling `newline`, `paragraph`, or `text` tokenizers trips Remark into an infinite loop!
 */
var blocks = [
// 'newline',
'indentedCode', 'fencedCode', 'blockquote', 'atxHeading', 'thematicBreak', 'list', 'setextHeading', 'html', 'footnote', 'definition', 'table'
// 'paragraph',
];

var inlines = ['escape', 'autoLink', 'url', 'html', 'link', 'reference', 'strong', 'emphasis', 'deletion', 'code', 'break'
// 'text',
];

var toBeDecorated = {
  inlines: inlines.filter(function (i) {
    return !['link', 'reference'].includes(i);
  }),
  blocks: []
};
var disableTokenizers = {
  inlines: {
    disableTokenizers: {
      inline: toBeDecorated.inlines,
      block: toBeDecorated.blocks
    }
  },
  blocks: {
    disableTokenizers: {
      inline: inlines.filter(function (i) {
        return !toBeDecorated.inlines.includes(i);
      }),
      block: blocks.filter(function (b) {
        return !toBeDecorated.blocks.includes(b);
      })
    }
  }
};
var parseOptions = function parseOptions() {
  var userOpts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var opts = _objectSpread(_objectSpread({}, options), userOpts);
  if (opts.disableTokenizers in disableTokenizers) {
    opts = _objectSpread(_objectSpread({}, opts), disableTokenizers[opts.disableTokenizers]);
  }
  // @note: commenting out for now. While doing dev for @readme/editor, I would
  // like fine-grained control of which tokenizers we are using. We might to
  // remove that at some point?
  // } else if (opts.disableTokenizers) {
  // throw new Error(
  // `opts.disableTokenizers "${opts.disableTokenizers}" not one of "${Object.keys(disableTokenizers)}"`
  // );
  // }

  return opts;
};


/***/ }),

/***/ 3688:
/***/ ((module) => {

module.exports = function BreakCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;

  // @note: We could save this as just '\n' when `correctnewlines: false`, but
  // this is more portable.
  visitors.break = function compile() {
    return '  \n';
  };
};

/***/ }),

/***/ 5733:
/***/ ((module) => {

module.exports = function CalloutCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  visitors['rdme-callout'] = function compile(node) {
    var block = this.block(node).replace(/\n/g, '\n> ');
    block = "> ".concat(node.data.hProperties.icon, " ").concat(block);
    return block;
  };
};

/***/ }),

/***/ 4079:
/***/ ((module) => {

module.exports = function CodeTabsCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  function compile(node) {
    return this.block(node).split('```\n\n').join('```\n');
  }
  visitors['code-tabs'] = compile;
};

/***/ }),

/***/ 58:
/***/ ((module) => {

module.exports = function DivCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  visitors.div = function compile(node) {
    var data = node.data.hProperties;
    return "\n[block:".concat(node.data.hName, "]\n").concat(JSON.stringify(data, null, 2), "\n[/block]\n");
  };
};

/***/ }),

/***/ 4338:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _defineProperty = __webpack_require__(9713);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function EmbedCompiler(node) {
  var data = node.data.hProperties;
  var _data$provider = data.provider,
    provider = _data$provider === void 0 ? 'embed' : _data$provider;
  provider = provider.replace(/^@/, '');
  return "\n[block:embed]\n".concat(JSON.stringify(_objectSpread(_objectSpread({}, data), {}, {
    provider: provider
  }), null, 2), "\n[/block]\n");
}
module.exports = function () {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  visitors.embed = EmbedCompiler;
};

/***/ }),

/***/ 8418:
/***/ ((module) => {

module.exports = function EscapeCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  visitors.escape = function compile(node) {
    return "\\".concat(node.value);
  };
};

/***/ }),

/***/ 8705:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _slicedToArray = __webpack_require__(3038);
var _defineProperty = __webpack_require__(9713);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var _require = __webpack_require__(7589),
  imgSizeByWidth = _require.imgSizeByWidth;
var compileImage = function compileImage(image) {
  var _ref = image.data.hProperties || {},
    className = _ref.className,
    width = _ref.width;
  var img = _objectSpread(_objectSpread({
    image: [image.url, image.title, image.alt]
  }, width && {
    sizing: imgSizeByWidth[width]
  }), className === 'border' && {
    border: true
  });
  return img;
};
module.exports = function FigureCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  visitors.figure = function figureCompiler(node) {
    var image;
    var caption;
    if (node.children) {
      var _node$children = _slicedToArray(node.children, 2);
      image = _node$children[0];
      caption = _node$children[1];
    } else {
      image = node;
    }
    var img = compileImage(image);
    if (caption) img.caption = this.block(caption);
    var block = {
      images: [img]
    };
    return "[block:image]\n".concat(JSON.stringify(block, null, 2), "\n[/block]");
  };
};

/***/ }),

/***/ 2459:
/***/ ((module) => {

module.exports = function RdmeGlossaryCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  visitors['readme-glossary-item'] = function (node) {
    return "<<glossary:".concat(node.data.hProperties.term, ">>");
  };
};

/***/ }),

/***/ 215:
/***/ ((module) => {

module.exports = function () {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  visitors['html-block'] = function (node) {
    var html = node.data.hProperties.html;
    return "[block:html]\n".concat(JSON.stringify({
      html: html
    }, null, 2), "\n[/block]");
  };
};

/***/ }),

/***/ 4258:
/***/ ((module) => {

module.exports = function FaEmojiCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  visitors.i = function compile(node) {
    return ":".concat(node.data.hProperties.className[1], ":");
  };
};

/***/ }),

/***/ 3356:
/***/ ((module) => {

module.exports = function ImageCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  var originalImageCompiler = visitors.image;
  visitors.image = function compile(node) {
    var _node$data, _node$data$hPropertie, _node$data2, _visitors$figure;
    if (((_node$data = node.data) === null || _node$data === void 0 ? void 0 : (_node$data$hPropertie = _node$data.hProperties) === null || _node$data$hPropertie === void 0 ? void 0 : _node$data$hPropertie.className) === 'emoji') return node.title;

    // Use magic block instead of markdown when there are certain defined properties we can't store in markdown
    var _ref = ((_node$data2 = node.data) === null || _node$data2 === void 0 ? void 0 : _node$data2.hProperties) || {},
      className = _ref.className,
      width = _ref.width;
    var useMagicBlock = Boolean(width) || (className === null || className === void 0 ? void 0 : className.length);
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    if (useMagicBlock) return (_visitors$figure = visitors.figure).call.apply(_visitors$figure, [this, node].concat(args));
    return originalImageCompiler.call.apply(originalImageCompiler, [this, node].concat(args));
  };
};

/***/ }),

/***/ 9647:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "breakCompiler": () => (/* reexport default from dynamic */ _break__WEBPACK_IMPORTED_MODULE_0___default.a),
/* harmony export */   "codeTabsCompiler": () => (/* reexport default from dynamic */ _code_tabs__WEBPACK_IMPORTED_MODULE_1___default.a),
/* harmony export */   "divCompiler": () => (/* reexport default from dynamic */ _div__WEBPACK_IMPORTED_MODULE_2___default.a),
/* harmony export */   "escapeCompiler": () => (/* reexport default from dynamic */ _escape__WEBPACK_IMPORTED_MODULE_3___default.a),
/* harmony export */   "figureCompiler": () => (/* reexport default from dynamic */ _figure__WEBPACK_IMPORTED_MODULE_4___default.a),
/* harmony export */   "htmlBlockCompiler": () => (/* reexport default from dynamic */ _html_block__WEBPACK_IMPORTED_MODULE_5___default.a),
/* harmony export */   "iconCompiler": () => (/* reexport default from dynamic */ _i__WEBPACK_IMPORTED_MODULE_6___default.a),
/* harmony export */   "imageCompiler": () => (/* reexport default from dynamic */ _image__WEBPACK_IMPORTED_MODULE_7___default.a),
/* harmony export */   "rdmeCalloutCompiler": () => (/* reexport default from dynamic */ _callout__WEBPACK_IMPORTED_MODULE_8___default.a),
/* harmony export */   "rdmeEmbedCompiler": () => (/* reexport default from dynamic */ _embed__WEBPACK_IMPORTED_MODULE_9___default.a),
/* harmony export */   "rdmeGlossaryCompiler": () => (/* reexport default from dynamic */ _glossary__WEBPACK_IMPORTED_MODULE_10___default.a),
/* harmony export */   "rdmePinCompiler": () => (/* reexport default from dynamic */ _pin__WEBPACK_IMPORTED_MODULE_11___default.a),
/* harmony export */   "rdmeVarCompiler": () => (/* reexport default from dynamic */ _var__WEBPACK_IMPORTED_MODULE_12___default.a),
/* harmony export */   "tableCompiler": () => (/* reexport default from dynamic */ _table__WEBPACK_IMPORTED_MODULE_13___default.a),
/* harmony export */   "tableHeadCompiler": () => (/* reexport default from dynamic */ _table_head__WEBPACK_IMPORTED_MODULE_14___default.a),
/* harmony export */   "yamlCompiler": () => (/* reexport default from dynamic */ _yaml__WEBPACK_IMPORTED_MODULE_15___default.a)
/* harmony export */ });
/* harmony import */ var _break__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3688);
/* harmony import */ var _break__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_break__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _code_tabs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4079);
/* harmony import */ var _code_tabs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_code_tabs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _div__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(58);
/* harmony import */ var _div__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_div__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _escape__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8418);
/* harmony import */ var _escape__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_escape__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _figure__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8705);
/* harmony import */ var _figure__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_figure__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _html_block__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(215);
/* harmony import */ var _html_block__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_html_block__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _i__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4258);
/* harmony import */ var _i__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_i__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3356);
/* harmony import */ var _image__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_image__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _callout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5733);
/* harmony import */ var _callout__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_callout__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _embed__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4338);
/* harmony import */ var _embed__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(_embed__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _glossary__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(2459);
/* harmony import */ var _glossary__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_glossary__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _pin__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(2151);
/* harmony import */ var _pin__WEBPACK_IMPORTED_MODULE_11___default = /*#__PURE__*/__webpack_require__.n(_pin__WEBPACK_IMPORTED_MODULE_11__);
/* harmony import */ var _var__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(1067);
/* harmony import */ var _var__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_var__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _table__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(4669);
/* harmony import */ var _table__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_table__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _table_head__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(186);
/* harmony import */ var _table_head__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_table_head__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var _yaml__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(1773);
/* harmony import */ var _yaml__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(_yaml__WEBPACK_IMPORTED_MODULE_15__);

















/***/ }),

/***/ 2151:
/***/ ((module) => {

module.exports = function PinCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  function compiler(node) {
    return ['<div class="rdmd-pinned">', this.block(node), '</div>'].join('\n\n');
  }
  visitors['rdme-pin'] = compiler;
};

/***/ }),

/***/ 186:
/***/ ((module) => {

module.exports = function TableHeadCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  visitors.tableHead = function compile(node) {
    return visitors.tableCell.call(this, node);
  };
};

/***/ }),

/***/ 4669:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _toConsumableArray = __webpack_require__(319);
var find = function find(node, fn) {
  if (fn(node)) return node;
  if (node.children) return node.children.find(function (n) {
    return find(n, fn);
  });
  return null;
};
module.exports = function TableCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  var original = visitors.table;
  visitors.table = function (node) {
    var _node$children$,
      _node$children$$child,
      _this = this;
    if (!find(node, function (n) {
      return n.type === 'break';
    })) {
      return original.call(this, node);
    }
    var data = {
      data: {},
      cols: ((_node$children$ = node.children[0]) === null || _node$children$ === void 0 ? void 0 : (_node$children$$child = _node$children$.children) === null || _node$children$$child === void 0 ? void 0 : _node$children$$child.length) || 0,
      rows: node.children.length - 1,
      align: _toConsumableArray(node.align)
    };
    node.children.forEach(function (row, i) {
      row.children.forEach(function (cell, j) {
        var col = i === 0 ? 'h' : i - 1;
        var string = _this.all(cell).join('').replace(/\\\n/g, '  \n');
        data.data["".concat(col, "-").concat(j)] = string;
      });
    });
    return "[block:parameters]\n".concat(JSON.stringify(data, null, 2), "\n[/block]");
  };
};

/***/ }),

/***/ 1067:
/***/ ((module) => {

module.exports = function RdmeVarCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  visitors['readme-variable'] = function (node) {
    return "<<".concat(node.text, ">>");
  };
};

/***/ }),

/***/ 1773:
/***/ ((module) => {

module.exports = function YamlCompiler() {
  var Compiler = this.Compiler;
  var visitors = Compiler.prototype.visitors;
  visitors.yaml = function compile(node) {
    return "---\n".concat(node.value, "\n---");
  };
};

/***/ }),

/***/ 8399:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _slicedToArray = __webpack_require__(3038);
var rgx = /^(#{1,6})(?!(?:#|\s))([^\n]+)\n/;
function tokenizer(eat, value) {
  if (!rgx.test(value)) return true;
  var _rgx$exec = rgx.exec(value),
    _rgx$exec2 = _slicedToArray(_rgx$exec, 3),
    match = _rgx$exec2[0],
    hash = _rgx$exec2[1],
    text = _rgx$exec2[2];
  var now = eat.now();
  now.column += match.length;
  now.offset += match.length;
  return eat(match)({
    type: 'heading',
    depth: hash.length,
    children: this.tokenizeInline(text, now)
  });
}
function parser() {
  var Parser = this.Parser;
  var tokenizers = Parser.prototype.blockTokenizers;
  var methods = Parser.prototype.blockMethods;
  tokenizers.compactHeading = tokenizer;
  methods.splice(methods.indexOf('newline'), 0, 'compactHeading');
}
module.exports = parser;
module.exports.sanitize = function (sanitizeSchema) {
  var tags = sanitizeSchema.tagNames;
  tags.push('compactHeading');
  return parser;
};

/***/ }),

/***/ 6284:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ callout),
  "icons": () => (/* binding */ icons),
  "sanitize": () => (/* binding */ sanitize)
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
var arrayLikeToArray = __webpack_require__(907);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,arrayLikeToArray/* default */.Z)(arr);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || (0,unsupportedIterableToArray/* default */.Z)(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js + 3 modules
var slicedToArray = __webpack_require__(1037);
;// CONCATENATED MODULE: ./node_modules/emoji-regex/index.mjs
/* harmony default export */ const emoji_regex = (() => {
	// https://mths.be/emoji
	return /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26F9(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC3\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC08\uDC26](?:\u200D\u2B1B)?|[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE])))?))?|\uDC6F(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDD75(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE88\uDE90-\uDEBD\uDEBF-\uDEC2\uDECE-\uDEDB\uDEE0-\uDEE8]|\uDD3C(?:\u200D[\u2640\u2642]\uFE0F?|\uD83C[\uDFFB-\uDFFF])?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF-\uDDB3\uDDBC\uDDBD]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
});

// EXTERNAL MODULE: ./node_modules/remark-parse/lib/util/interrupt.js
var interrupt = __webpack_require__(6588);
var interrupt_default = /*#__PURE__*/__webpack_require__.n(interrupt);
// EXTERNAL MODULE: ./node_modules/trim/index.js
var trim = __webpack_require__(2745);
var trim_default = /*#__PURE__*/__webpack_require__.n(trim);
;// CONCATENATED MODULE: ./processor/parse/flavored/callout.js


/* eslint-disable no-plusplus */
/* eslint-disable consistent-return */



var themes = {
  "\uD83D\uDCD8": 'info',
  "\uD83D\uDEA7": 'warn',
  "\u26A0\uFE0F": 'warn',
  "\uD83D\uDC4D": 'okay',
  "\u2705": 'okay',
  "\u2757": 'error',
  "\u2757\uFE0F": 'error',
  "\uD83D\uDED1": 'error',
  "\u2049\uFE0F": 'error',
  "\u203C\uFE0F": 'error',
  "\u2139\uFE0F": 'info',
  "\u26A0": 'warn'
};
var icons = Object.entries(themes).reduce(function (acc, _ref) {
  var _ref2 = (0,slicedToArray/* default */.Z)(_ref, 2),
    icon = _ref2[0],
    theme = _ref2[1];
  if (!acc[theme]) acc[theme] = [];
  acc[theme].push(icon);
  return acc;
}, {});
var lineFeed = '\n';
var tab = '\t';
var space = ' ';
var greaterThan = '>';
var regex = "^(".concat(emoji_regex().source, ")(\\s+|$)");

// @note: Copied directly from remark-parse, but it's been updated to match our
// style conventions and to parse Callouts.
function blockquoteReadme(eat, value, silent) {
  var self = this;
  var offsets = self.offset;
  var tokenizers = self.blockTokenizers;
  var interruptors = self.interruptBlockquote;
  var now = eat.now();
  var currentLine = now.line;
  var length = value.length;
  var values = [];
  var contents = [];
  var indents = [];
  var index = 0;
  var character;
  var rest;
  var nextIndex;
  var content;
  var line;
  var startIndex;
  var prefixed;
  while (index < length) {
    character = value.charAt(index);
    if (character !== space && character !== tab) {
      break;
    }
    index++;
  }
  if (value.charAt(index) !== greaterThan) {
    return;
  }
  if (silent) {
    return true;
  }
  index = 0;
  while (index < length) {
    nextIndex = value.indexOf(lineFeed, index);
    startIndex = index;
    prefixed = false;
    if (nextIndex === -1) {
      nextIndex = length;
    }
    while (index < length) {
      character = value.charAt(index);
      if (character !== space && character !== tab) {
        break;
      }
      index++;
    }
    if (value.charAt(index) === greaterThan) {
      index++;
      prefixed = true;
      if (value.charAt(index) === space) {
        index++;
      }
    } else {
      index = startIndex;
    }
    content = value.slice(index, nextIndex);
    if (!prefixed && !trim_default()(content)) {
      index = startIndex;
      break;
    }
    if (!prefixed) {
      rest = value.slice(index);

      // check if the following code contains a possible block.
      if (interrupt_default()(interruptors, tokenizers, self, [eat, rest, true])) {
        break;
      }
    }
    line = startIndex === index ? content : value.slice(startIndex, nextIndex);
    indents.push(index - startIndex);
    values.push(line);
    contents.push(content);
    index = nextIndex + 1;
  }
  index = -1;
  length = indents.length;
  var add = eat(values.join(lineFeed));
  while (++index < length) {
    offsets[currentLine] = (offsets[currentLine] || 0) + indents[index];
    currentLine++;
  }
  var _ref3 = contents[0].match(regex) || [],
    _ref4 = (0,slicedToArray/* default */.Z)(_ref3, 2),
    match = _ref4[0],
    icon = _ref4[1];
  if (icon) {
    var title = trim_default()(contents[0].slice(match.length));
    var body = trim_default()(contents.slice(1).join(lineFeed));
    var data = {
      hName: 'rdme-callout',
      hProperties: {
        title: title,
        value: body,
        icon: icon,
        theme: themes[icon] || 'default'
      }
    };
    var _exit = self.enterBlock();
    var _children = [].concat(_toConsumableArray(self.tokenizeBlock(title, now)), _toConsumableArray(self.tokenizeBlock(body, now)));
    _exit();
    return add({
      type: 'rdme-callout',
      children: _children,
      data: data
    });
  }
  var exit = self.enterBlock();
  var children = self.tokenizeBlock(contents.join(lineFeed), now);
  exit();
  return add({
    type: 'blockquote',
    children: children
  });
}
function parser() {
  var Parser = this.Parser;
  var tokenizers = Parser.prototype.blockTokenizers;
  tokenizers.blockquote = blockquoteReadme;
}
/* harmony default export */ const callout = (parser);
function sanitize(sanitizeSchema) {
  var tags = sanitizeSchema.tagNames;
  var attr = sanitizeSchema.attributes;
  tags.push('rdme-callout');
  attr['rdme-callout'] = ['icon', 'theme', 'title', 'value'];
  return parser;
}
parser.sanitize = sanitize;

/***/ }),

/***/ 5289:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _typeof = __webpack_require__(8);
var _inherits = __webpack_require__(2205);
var _setPrototypeOf = __webpack_require__(9489);
var _slicedToArray = __webpack_require__(3038);
function _wrapRegExp() { _wrapRegExp = function _wrapRegExp(re, groups) { return new BabelRegExp(re, void 0, groups); }; var _super = RegExp.prototype, _groups = new WeakMap(); function BabelRegExp(re, flags, groups) { var _this = new RegExp(re, flags); return _groups.set(_this, groups || _groups.get(re)), _setPrototypeOf(_this, BabelRegExp.prototype); } function buildGroups(result, re) { var g = _groups.get(re); return Object.keys(g).reduce(function (groups, name) { var i = g[name]; if ("number" == typeof i) groups[name] = result[i];else { for (var k = 0; void 0 === result[i[k]] && k + 1 < i.length;) { k++; } groups[name] = result[i[k]]; } return groups; }, Object.create(null)); } return _inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function (str) { var result = _super.exec.call(this, str); return result && (result.groups = buildGroups(result, this)), result; }, BabelRegExp.prototype[Symbol.replace] = function (str, substitution) { if ("string" == typeof substitution) { var groups = _groups.get(this); return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) { return "$" + groups[name]; })); } if ("function" == typeof substitution) { var _this = this; return _super[Symbol.replace].call(this, str, function () { var args = arguments; return "object" != _typeof(args[args.length - 1]) && (args = [].slice.call(args)).push(buildGroups(args, _this)), substitution.apply(this, args); }); } return _super[Symbol.replace].call(this, str, substitution); }, _wrapRegExp.apply(this, arguments); }
function tokenizer(eat, value) {
  // eslint-disable-next-line unicorn/no-unsafe-regex
  var TAB_BLOCK_RGXP = /^(?:(?:^|\n)```(?:(?!\n```)[\s\S])*\n```[^\S\n]*){2,}/g;
  var _ref = TAB_BLOCK_RGXP.exec(value) || [],
    _ref2 = _slicedToArray(_ref, 1),
    match = _ref2[0];
  if (!match) return true;
  var kids = [];
  var codeBlock;

  /*
   * For each of our adjacent code blocks we'll split the matching block in to three parts:
   *    - [lang] syntax extension (optional)
   *    - [meta] tab name (optional)
   *    - [code] snippet text
   */
  // eslint-disable-next-line unicorn/no-unsafe-regex
  var CODE_BLOCK_RGXP = /*#__PURE__*/_wrapRegExp(/(?:^|\n)```[ \t]*([^\s]+)?(?: *([^\n]+))?(((?!\n```)[\s\S])*)?\n```/g, {
    lang: 1,
    meta: 2,
    code: 3
  });
  while ((codeBlock = CODE_BLOCK_RGXP.exec(match)) !== null) {
    // eslint-disable-next-line prefer-const
    var _codeBlock$groups = codeBlock.groups,
      lang = _codeBlock$groups.lang,
      _codeBlock$groups$met = _codeBlock$groups.meta,
      meta = _codeBlock$groups$met === void 0 ? '' : _codeBlock$groups$met,
      _codeBlock$groups$cod = _codeBlock$groups.code,
      code = _codeBlock$groups$cod === void 0 ? '' : _codeBlock$groups$cod;
    meta = meta.trim();
    kids.push({
      type: 'code',
      className: 'tab-panel',
      value: code.replace(/^\n/, ''),
      meta: meta,
      lang: lang,
      data: {
        hName: 'code',
        hProperties: {
          meta: meta,
          lang: lang
        }
      }
    });
  }

  // return a tabbed code block
  return eat(match)({
    type: 'code-tabs',
    className: 'tabs',
    data: {
      hName: 'code-tabs'
    },
    children: kids
  });
}
function parser() {
  var Parser = this.Parser;
  var tokenizers = Parser.prototype.blockTokenizers;
  var methods = Parser.prototype.blockMethods;
  tokenizers.CodeTabs = tokenizer;
  methods.splice(methods.indexOf('newline'), 0, 'CodeTabs');
}
module.exports = parser;
module.exports.sanitize = function (sanitizeSchema) {
  var tags = sanitizeSchema.tagNames;
  tags.push('code-tabs');
  return parser;
};

/***/ }),

/***/ 1559:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _slicedToArray = __webpack_require__(3038);
var rgx = /^\[([^\]]*)\]\((\S*) ["'](@\w+)"\)/;
function tokenizer(eat, value) {
  if (!rgx.test(value)) return true;

  // eslint-disable-next-line prefer-const
  var _rgx$exec = rgx.exec(value),
    _rgx$exec2 = _slicedToArray(_rgx$exec, 4),
    match = _rgx$exec2[0],
    title = _rgx$exec2[1],
    url = _rgx$exec2[2],
    provider = _rgx$exec2[3];
  return eat(match)({
    type: 'embed',
    title: title,
    url: url,
    provider: provider,
    data: {
      title: title,
      url: url,
      provider: provider,
      hProperties: {
        title: title,
        url: url,
        provider: provider
      },
      hName: 'rdme-embed'
    },
    children: [{
      type: 'link',
      url: url,
      title: provider,
      children: [{
        type: 'text',
        value: title
      }]
    }]
  });
}
function parser() {
  var Parser = this.Parser;
  var tokenizers = Parser.prototype.blockTokenizers;
  var methods = Parser.prototype.blockMethods;
  tokenizers.embed = tokenizer;
  methods.splice(methods.indexOf('newline'), 0, 'embed');
}
module.exports = parser;
module.exports.sanitize = function (sanitizeSchema) {
  var tags = sanitizeSchema.tagNames;
  tags.push('embed');
  return parser;
};

/***/ }),

/***/ 7201:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var Emoji = (__webpack_require__(368)/* .emoji */ .r);
var emojis = new Emoji();
var colon = ':';
function tokenize(eat, value, silent) {
  // Check if we’re at a short-code.
  if (value.charAt(0) !== colon) return false;
  var pos = value.indexOf(colon, 1);
  if (pos === -1) return false;
  var subvalue = value.slice(1, pos);

  // Exit with true in silent
  if (silent) return true;
  var match = colon + subvalue + colon;
  if (subvalue.substr(0, 3) === 'fa-') {
    return eat(match)({
      type: 'i',
      data: {
        hName: 'i',
        hProperties: {
          className: ['fa', subvalue]
        }
      }
    });
  }
  if (emojis.is(subvalue)) {
    return eat(match)({
      type: 'image',
      title: ":".concat(subvalue, ":"),
      alt: ":".concat(subvalue, ":"),
      url: "/img/emojis/".concat(subvalue, ".png"),
      data: {
        hProperties: {
          className: 'emoji',
          align: 'absmiddle',
          height: '20',
          width: '20'
        }
      }
    });
  }
  return false;
}
function locate(value, fromIndex) {
  return value.indexOf(colon, fromIndex);
}
tokenize.locator = locate;
function parser() {
  var Parser = this.Parser;
  var tokenizers = Parser.prototype.inlineTokenizers;
  var methods = Parser.prototype.inlineMethods;
  tokenizers.gemoji = tokenize;
  methods.splice(methods.indexOf('text'), 0, 'gemoji');
}
module.exports = parser;
module.exports.sanitize = function (sanitizeSchema) {
  // This is for font awesome gemoji codes
  sanitizeSchema.attributes.i = ['className'];
  return parser;
};

/***/ }),

/***/ 1593:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "compactHeadings": () => (/* reexport */ (compact_headings_default())),
  "escape": () => (/* reexport */ parse_escape),
  "flavorCallout": () => (/* reexport */ callout["default"]),
  "flavorCodeTabs": () => (/* reexport */ (code_tabs_default())),
  "flavorEmbed": () => (/* reexport */ (embed_default())),
  "gemojiParser": () => (/* reexport */ (gemoji_parser_default())),
  "htmlBlockParser": () => (/* reexport */ html_block),
  "magicBlockParser": () => (/* reexport */ (magic_block_parser_default())),
  "variableParser": () => (/* reexport */ (variable_parser_default()))
});

// EXTERNAL MODULE: ./processor/parse/magic-block-parser.js
var magic_block_parser = __webpack_require__(7589);
var magic_block_parser_default = /*#__PURE__*/__webpack_require__.n(magic_block_parser);
// EXTERNAL MODULE: ./processor/parse/flavored/code-tabs.js
var code_tabs = __webpack_require__(5289);
var code_tabs_default = /*#__PURE__*/__webpack_require__.n(code_tabs);
// EXTERNAL MODULE: ./processor/parse/flavored/callout.js + 5 modules
var callout = __webpack_require__(6284);
// EXTERNAL MODULE: ./processor/parse/flavored/embed.js
var flavored_embed = __webpack_require__(1559);
var embed_default = /*#__PURE__*/__webpack_require__.n(flavored_embed);
;// CONCATENATED MODULE: ./processor/parse/escape.js
// @note: this is copied from https://github.com/remarkjs/remark/blob/remark-parse%407.0.2/packages/remark-parse/lib/tokenize/escape.js

var lineFeed = '\n';
var backslash = '\\';

// eslint-disable-next-line consistent-return
function escape_escape(eat, value, silent) {
  var self = this;
  var character;
  var node;
  if (value.charAt(0) === backslash) {
    character = value.charAt(1);
    if (self.escape.indexOf(character) !== -1) {
      if (silent) {
        return true;
      }
      if (character === lineFeed) {
        node = {
          type: 'break'
        };
      } else {
        node = {
          type: 'escape',
          value: character
        };
      }
      return eat(backslash + character)(node);
    }
  }
}
function locate(value, fromIndex) {
  return value.indexOf('\\', fromIndex);
}
escape_escape.locator = locate;
function parser() {
  var Parser = this.Parser;
  var inlineTokenizers = Parser.prototype.inlineTokenizers;
  inlineTokenizers.escape = escape_escape;
}
parser.sanitize = function () {
  return parser;
};
/* harmony default export */ const parse_escape = (parser);
// EXTERNAL MODULE: ./processor/parse/compact-headings.js
var compact_headings = __webpack_require__(8399);
var compact_headings_default = /*#__PURE__*/__webpack_require__.n(compact_headings);
// EXTERNAL MODULE: ./processor/parse/variable-parser.js
var variable_parser = __webpack_require__(2697);
var variable_parser_default = /*#__PURE__*/__webpack_require__.n(variable_parser);
// EXTERNAL MODULE: ./processor/parse/gemoji-parser.js
var gemoji_parser = __webpack_require__(7201);
var gemoji_parser_default = /*#__PURE__*/__webpack_require__.n(gemoji_parser);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}
;// CONCATENATED MODULE: ./processor/parse/html-block.js

var blockHtml = function blockHtml(htmlTokenizer) {
  return function tokenizer() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var node = htmlTokenizer.call.apply(htmlTokenizer, [this].concat(args));
    if (_typeof(node) === 'object') {
      node.block = true;
    }
    return node;
  };
};
function html_block_parser() {
  var Parser = this.Parser;
  var tokenizers = Parser.prototype.blockTokenizers;
  var html = tokenizers.html;
  tokenizers.html = blockHtml(html);
}
/* harmony default export */ const html_block = (html_block_parser);
;// CONCATENATED MODULE: ./processor/parse/index.js










/***/ }),

/***/ 7589:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _toConsumableArray = __webpack_require__(319);
var _defineProperty = __webpack_require__(9713);
var _slicedToArray = __webpack_require__(3038);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable consistent-return */
var RGXP = /^\[block:(.*)\]([^]+?)\[\/block\]/;
var compatibilityMode;
var safeMode;
var alwaysThrow;
var WrapPinnedBlocks = function WrapPinnedBlocks(node, json) {
  if (!json.sidebar) return node;
  return {
    children: [node],
    type: 'rdme-pin',
    data: {
      hName: 'rdme-pin',
      className: 'pin'
    }
  };
};
var imgSizeValues = {
  full: '100%',
  original: 'auto'
};
var imgWidthBySize = new Proxy(imgSizeValues, {
  get: function get(widths, size) {
    return size !== null && size !== void 0 && size.match(/^\d+$/) ? "".concat(size, "%") : size in widths ? widths[size] : size;
  }
});
var imgSizeByWidth = new Proxy(new Map(Array.from(imgSizeValues).reverse()), {
  get: function get(sizes, width) {
    var match = width === null || width === void 0 ? void 0 : width.match(/^(\d+)%$/);
    return match ? match[1] : width in sizes ? sizes[width] : width;
  }
});
function tokenize(eat, value) {
  var _this = this;
  var _ref = RGXP.exec(value) || [],
    _ref2 = _slicedToArray(_ref, 3),
    match = _ref2[0],
    type = _ref2[1],
    json = _ref2[2];
  if (!type) return;
  match = match.trim();
  type = type.trim();
  try {
    json = JSON.parse(json);
  } catch (err) {
    json = {};
    // eslint-disable-next-line no-console
    console.error('Invalid Magic Block JSON:', err);
    if (alwaysThrow) {
      throw new Error('Invalid Magic Block JSON');
    }
  }
  if (Object.keys(json).length < 1) return eat(match);
  switch (type) {
    case 'code':
      {
        var children = json.codes.map(function (obj) {
          return {
            type: 'code',
            value: obj.code.trim(),
            meta: obj.name || null,
            lang: obj.language,
            className: 'tab-panel',
            data: {
              hName: 'code',
              hProperties: {
                meta: obj.name || null,
                lang: obj.language
              }
            }
          };
        });
        if (children.length === 1) {
          if (!children[0].value) return eat(match); // skip empty code tabs
          if (children[0].name) return eat(match)(WrapPinnedBlocks(children[0], json));
        }
        return eat(match)(WrapPinnedBlocks({
          children: children,
          className: 'tabs',
          data: {
            hName: 'code-tabs'
          },
          type: 'code-tabs'
        }, json));
      }
    case 'api-header':
      {
        var depth = json.level || (compatibilityMode ? 1 : 2);
        return eat(match)(WrapPinnedBlocks({
          type: 'heading',
          depth: depth,
          children: 'title' in json ? this.tokenizeInline(json.title, eat.now()) : ''
        }, json));
      }
    case 'image':
      {
        var imgs = json.images.map(function (img) {
          if (!('image' in img)) return null;
          var _img$image = _slicedToArray(img.image, 3),
            url = _img$image[0],
            title = _img$image[1],
            alt = _img$image[2];
          var block = {
            type: 'image',
            url: url,
            title: title,
            alt: alt || ('caption' in img ? img.caption : ''),
            data: {
              hProperties: _objectSpread({
                className: img.border ? 'border' : ''
              }, img.sizing && {
                width: imgWidthBySize[img.sizing]
              })
            }
          };
          if (!img.caption) return block;
          return {
            type: 'figure',
            url: url,
            data: {
              hName: 'figure'
            },
            children: [block, {
              type: 'figcaption',
              data: {
                hName: 'figcaption'
              },
              children: _this.tokenizeBlock(img.caption, eat.now())
            }]
          };
        }).filter(function (e) {
          return e;
        }); // eslint-disable-line unicorn/prefer-array-find
        var img = imgs[0];
        if (!img || !img.url) return eat(match);
        return eat(match)(WrapPinnedBlocks(img, json));
      }
    case 'callout':
      {
        var types = {
          info: ['📘', 'info'],
          success: ['👍', 'okay'],
          warning: ['🚧', 'warn'],
          danger: ['❗️', 'error']
        };
        json.type = json.type in types ? types[json.type] : [json.icon || '👍', json.type];
        var _json$type = _slicedToArray(json.type, 2),
          icon = _json$type[0],
          theme = _json$type[1];
        if (!(json.title || json.body)) return eat(match);
        return eat(match)(WrapPinnedBlocks({
          type: 'rdme-callout',
          data: {
            hName: 'rdme-callout',
            hProperties: {
              theme: theme || 'default',
              icon: icon,
              title: json.title,
              value: json.body
            }
          },
          children: [].concat(_toConsumableArray(this.tokenizeBlock(json.title, eat.now())), _toConsumableArray(this.tokenizeBlock(json.body, eat.now())))
        }, json));
      }
    case 'parameters':
      {
        var _json = json,
          data = _json.data,
          rows = _json.rows,
          cols = _json.cols;
        var tokenizeCell = this[compatibilityMode ? 'tokenizeBlock' : 'tokenizeInline'].bind(this);
        if (!Object.keys(data).length) return eat(match); // skip empty tables

        var sparseData = Object.entries(data).reduce(function (mapped, _ref3) {
          var _row;
          var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            v = _ref4[1];
          var _key$split = key.split('-'),
            _key$split2 = _slicedToArray(_key$split, 2),
            row = _key$split2[0],
            col = _key$split2[1];
          row = row === 'h' ? 0 : parseInt(row, 10) + 1;
          col = parseInt(col, 10);
          mapped[_row = row] || (mapped[_row] = []);
          mapped[row][col] = v;
          return mapped;
        }, []);

        // The header row is not counted in the rows
        var _children = Array.from({
          length: rows + 1
        }, function (_, y) {
          return {
            type: 'tableRow',
            children: Array.from({
              length: cols
            }, function (__, x) {
              var _sparseData$y;
              return {
                type: y === 0 ? 'tableHead' : 'tableCell',
                children: (_sparseData$y = sparseData[y]) !== null && _sparseData$y !== void 0 && _sparseData$y[x] ? tokenizeCell(sparseData[y][x], eat.now()) : [{
                  type: 'text',
                  value: ''
                }]
              };
            })
          };
        });
        var table = {
          type: 'table',
          align: 'align' in json ? json.align : new Array(json.cols).fill('left'),
          children: _children
        };
        return eat(match)(WrapPinnedBlocks(table, json));
      }
    case 'embed':
      {
        var _json2 = json,
          title = _json2.title,
          url = _json2.url,
          html = _json2.html;
        try {
          json.provider = new URL(url).hostname.split(/(?:www)?\./).filter(function (i) {
            return i;
          }).join('.');
        } catch (_unused) {
          json.provider = url;
        }
        var _data = _objectSpread(_objectSpread({}, json), {}, {
          url: url,
          html: html,
          title: title
        });
        return eat(match)(WrapPinnedBlocks({
          type: 'embed',
          children: [{
            type: 'link',
            url: url,
            title: json.provider,
            children: [{
              type: 'text',
              value: title
            }]
          }],
          data: {
            hProperties: _objectSpread(_objectSpread({}, _data), {}, {
              href: url
            }),
            hName: 'rdme-embed'
          }
        }, json));
      }
    case 'html':
      {
        return eat(match)(WrapPinnedBlocks({
          type: 'html-block',
          data: {
            hName: 'html-block',
            hProperties: {
              html: json.html,
              runScripts: compatibilityMode,
              safeMode: safeMode
            }
          }
        }, json));
      }
    default:
      {
        return eat(match)(WrapPinnedBlocks({
          type: 'div',
          children: this.tokenizeBlock(json.text || json.html, eat.now()),
          data: _objectSpread({
            hName: type || 'div',
            hProperties: json
          }, json)
        }, json));
      }
  }
}
function parser() {
  var Parser = this.Parser;
  var tokenizers = Parser.prototype.blockTokenizers;
  var methods = Parser.prototype.blockMethods;
  if (this.data('compatibilityMode')) compatibilityMode = true;
  if (this.data('safeMode')) safeMode = true;
  if (this.data('alwaysThrow')) alwaysThrow = true;
  tokenizers.magicBlocks = tokenize;
  methods.splice(methods.indexOf('newline'), 0, 'magicBlocks');
}
module.exports = parser;
module.exports.sanitize = function (sanitizeSchema) {
  // const tags = sanitizeSchema.tagNames;
  var attr = sanitizeSchema.attributes;
  attr.li = ['className', 'checked'];
  attr.pre = ['className', 'lang', 'meta'];
  attr.code = ['className', 'lang', 'meta'];
  attr.table = ['align'];
  return parser;
};
module.exports.imgSizeByWidth = imgSizeByWidth;

/***/ }),

/***/ 2697:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _require = __webpack_require__(3689),
  VARIABLE_REGEXP = _require.VARIABLE_REGEXP;
function tokenizeVariable(eat, value, silent) {
  // Modifies the regular expression to match from
  // the start of the line
  var match = new RegExp("^".concat(VARIABLE_REGEXP)).exec(value);
  if (!match) return false;

  /* istanbul ignore if */
  if (silent) return true;

  // Escaped variables should just return the text
  if (match[0].startsWith('\\')) {
    return eat(match[0])({
      type: 'text',
      value: match[0].replace(/\\/g, '')
    });
  }
  if (match[1].startsWith('glossary:')) {
    return eat(match[0])({
      type: 'readme-glossary-item',
      data: {
        hName: 'readme-glossary-item',
        hProperties: {
          term: match[1].replace('glossary:', '')
        }
      }
    });
  }
  return eat(match[0])({
    type: 'readme-variable',
    text: match[1],
    data: {
      hName: 'readme-variable',
      hProperties: {
        variable: match[1]
      }
    }
  });
}
function locate(value, fromIndex) {
  return value.indexOf('<<', fromIndex);
}
tokenizeVariable.locator = locate;
function parser() {
  var Parser = this.Parser;
  var tokenizers = Parser.prototype.inlineTokenizers;
  var methods = Parser.prototype.inlineMethods;
  tokenizers.variable = tokenizeVariable;
  methods.splice(methods.indexOf('text'), 0, 'variable');
}
module.exports = parser;
module.exports.sanitize = function (sanitizeSchema) {
  // This is for our custom variable tags <<apiKey>>
  sanitizeSchema.tagNames.push('readme-variable');
  sanitizeSchema.attributes['readme-variable'] = ['variable'];

  // This is for our glossary variable tags <<glossary:item>>
  sanitizeSchema.tagNames.push('readme-glossary-item');
  sanitizeSchema.attributes['readme-glossary-item'] = ['term'];
  return parser;
};

/***/ }),

/***/ 4792:
/***/ ((module) => {

/* @note: copied from https://github.com/rehypejs/rehype-minify/blob/main/packages/hast-util-to-string/index.js
 */
function toString(node) {
  // eslint-disable-next-line no-use-before-define
  return 'children' in node ? all(node) || one(node) : one(node);
}
function one(node) {
  if (node.tagName === 'img') {
    var _node$properties;
    return ((_node$properties = node.properties) === null || _node$properties === void 0 ? void 0 : _node$properties.title) || '';
  }
  if (node.type === 'text') {
    return node.value;
  }
  if ('value' in node) {
    return node.value;
  }

  // eslint-disable-next-line no-use-before-define
  return 'children' in node ? all(node) : ' ';
}
function all(node) {
  var index = -1;
  var result = [];

  // eslint-disable-next-line no-plusplus
  while (++index < node.children.length) {
    result[index] = one(node.children[index]);
  }
  return result.join(' ').trim().replace(/ +/, ' ');
}
var Compiler = function Compiler(node) {
  return toString(node);
};
var toPlainText = function toPlainText() {
  Object.assign(this, {
    Compiler: Compiler
  });
};
module.exports = toPlainText;

/***/ }),

/***/ 9620:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var kebabCase = __webpack_require__(5683);
var flatMap = __webpack_require__(5885);
var matchTag = /^h[1-6]$/g;

/** Concat a deep text value from an AST node's children
 */
var getTexts = function getTexts(node) {
  var text = '';
  flatMap(node, function (kid) {
    text += kid.type === 'text' ? kid.value : '';
    return [kid];
  });
  return text;
};

/** Adds an empty <div id=section-slug> next to all headings
 *  for backwards-compatibility with how we used to do slugs.
 */
function transformer(ast) {
  return flatMap(ast, function (node) {
    if (matchTag.test(node.tagName)) {
      var _node$properties;
      // Parse the node texts to construct
      // a backwards-compatible anchor ID.
      var text = getTexts(node);
      var id = "section-".concat(kebabCase(text));
      if (id && !(node !== null && node !== void 0 && (_node$properties = node.properties) !== null && _node$properties !== void 0 && _node$properties.id)) {
        // Use the compat anchor ID as fallback if
        // GitHubs slugger returns an empty string.
        node.properties.id = id;
      }

      // Create and append a compat anchor element
      // to the section heading.
      var anchor = {
        type: 'element',
        tagName: 'div',
        properties: {
          id: id,
          className: 'heading-anchor_backwardsCompatibility'
        }
      };
      if (node.children) node.children.unshift(anchor);else node.children = [anchor];
    }
    return [node];
  });
}
module.exports = function () {
  return transformer;
};

/***/ }),

/***/ 4625:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _defineProperty = __webpack_require__(9713);
var _slicedToArray = __webpack_require__(3038);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var flatMap = __webpack_require__(5885);
var collectValues = function collectValues(_ref) {
  var value = _ref.value,
    children = _ref.children;
  if (value) return value;
  if (children) return children.flatMap(collectValues);
  return '';
};
var valuesToString = function valuesToString(node) {
  var values = collectValues(node);
  return Array.isArray(values) ? values.join(' ') : values;
};

// Flattens table values and adds them as a seperate, easily-accessible key within children
function transformer(ast) {
  return flatMap(ast, function (node) {
    if (node.tagName === 'table') {
      var _node$children = _slicedToArray(node.children, 2),
        header = _node$children[0],
        body = _node$children[1];
      // hAST tables are deeply nested with an innumerable amount of children
      // This is necessary to pullout all the relevant strings
      return [_objectSpread(_objectSpread({}, node), {}, {
        children: [_objectSpread(_objectSpread({}, node.children[0]), {}, {
          value: valuesToString(header)
        }), _objectSpread(_objectSpread({}, node.children[1]), {}, {
          value: valuesToString(body)
        })]
      })];
    }
    return [node];
  });
}
module.exports = function () {
  return transformer;
};
module.exports.tableFlattening = transformer;

/***/ }),

/***/ 8229:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var _require = __webpack_require__(2781),
  defaultSchema = _require.defaultSchema;
var createSchema = function createSchema() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    safeMode = _ref.safeMode;
  var schema = JSON.parse(JSON.stringify(defaultSchema));

  // Sanitization Schema Defaults
  schema.clobberPrefix = '';
  schema.tagNames.push('span');
  schema.attributes['*'].push('class', 'className', 'align');
  if (!safeMode) {
    schema.attributes['*'].push('style');
  }
  schema.tagNames.push('rdme-pin');
  schema.tagNames.push('rdme-embed');
  schema.attributes['rdme-embed'] = ['url', 'provider', 'html', 'title', 'href', 'iframe', 'width', 'height', 'image', 'favicon'];
  schema.attributes.a = ['href', 'title', 'class', 'className', 'download'];
  schema.tagNames.push('figure');
  schema.tagNames.push('figcaption');
  schema.tagNames.push('input'); // allow GitHub-style todo lists
  schema.ancestors.input = ['li'];
  return schema;
};
module.exports = createSchema;

/***/ }),

/***/ 8841:
/***/ ((module) => {

"use strict";


module.exports = bail

function bail(err) {
  if (err) {
    throw err
  }
}


/***/ }),

/***/ 1073:
/***/ ((module) => {

module.exports = {
	trueFunc: function trueFunc(){
		return true;
	},
	falseFunc: function falseFunc(){
		return false;
	}
};

/***/ }),

/***/ 932:
/***/ ((module) => {

"use strict";


module.exports = ccount

function ccount(value, character) {
  var val = String(value)
  var count = 0
  var index

  if (typeof character !== 'string' || character.length !== 1) {
    throw new Error('Expected character')
  }

  index = val.indexOf(character)

  while (index !== -1) {
    count++
    index = val.indexOf(character, index + 1)
  }

  return count
}


/***/ }),

/***/ 6313:
/***/ ((module) => {

var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if ( true && module.exports) {
  module.exports = clone;
}


/***/ }),

/***/ 9357:
/***/ ((module) => {

"use strict";


module.exports = collapse

// `collapse(' \t\nbar \nbaz\t') // ' bar baz '`
function collapse(value) {
  return String(value).replace(/\s+/g, ' ')
}


/***/ }),

/***/ 6851:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.parse = parse
exports.stringify = stringify

var comma = ','
var space = ' '
var empty = ''

// Parse comma-separated tokens to an array.
function parse(value) {
  var values = []
  var input = String(value || empty)
  var index = input.indexOf(comma)
  var lastIndex = 0
  var end = false
  var val

  while (!end) {
    if (index === -1) {
      index = input.length
      end = true
    }

    val = input.slice(lastIndex, index).trim()

    if (val || !end) {
      values.push(val)
    }

    lastIndex = index + 1
    index = input.indexOf(comma, lastIndex)
  }

  return values
}

// Compile an array to comma-separated tokens.
// `options.padLeft` (default: `true`) pads a space left of each token, and
// `options.padRight` (default: `false`) pads a space to the right of each token.
function stringify(values, options) {
  var settings = options || {}
  var left = settings.padLeft === false ? empty : space
  var right = settings.padRight ? space : empty

  // Ensure the last empty entry is seen.
  if (values[values.length - 1] === empty) {
    values = values.concat(empty)
  }

  return values.join(right + comma + left).trim()
}


/***/ }),

/***/ 640:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var deselectCurrent = __webpack_require__(268);

var clipboardToIE11Formatting = {
  "text/plain": "Text",
  "text/html": "Url",
  "default": "Text"
}

var defaultMessage = "Copy to clipboard: #{key}, Enter";

function format(message) {
  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
  return message.replace(/#{\s*key\s*}/g, copyKey);
}

function copy(text, options) {
  var debug,
    message,
    reselectPrevious,
    range,
    selection,
    mark,
    success = false;
  if (!options) {
    options = {};
  }
  debug = options.debug || false;
  try {
    reselectPrevious = deselectCurrent();

    range = document.createRange();
    selection = document.getSelection();

    mark = document.createElement("span");
    mark.textContent = text;
    // avoid screen readers from reading out loud the text
    mark.ariaHidden = "true"
    // reset user styles for span element
    mark.style.all = "unset";
    // prevents scrolling to the end of the page
    mark.style.position = "fixed";
    mark.style.top = 0;
    mark.style.clip = "rect(0, 0, 0, 0)";
    // used to preserve spaces and line breaks
    mark.style.whiteSpace = "pre";
    // do not inherit user-select (it may be `none`)
    mark.style.webkitUserSelect = "text";
    mark.style.MozUserSelect = "text";
    mark.style.msUserSelect = "text";
    mark.style.userSelect = "text";
    mark.addEventListener("copy", function(e) {
      e.stopPropagation();
      if (options.format) {
        e.preventDefault();
        if (typeof e.clipboardData === "undefined") { // IE 11
          debug && console.warn("unable to use e.clipboardData");
          debug && console.warn("trying IE specific stuff");
          window.clipboardData.clearData();
          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
          window.clipboardData.setData(format, text);
        } else { // all other browsers
          e.clipboardData.clearData();
          e.clipboardData.setData(options.format, text);
        }
      }
      if (options.onCopy) {
        e.preventDefault();
        options.onCopy(e.clipboardData);
      }
    });

    document.body.appendChild(mark);

    range.selectNodeContents(mark);
    selection.addRange(range);

    var successful = document.execCommand("copy");
    if (!successful) {
      throw new Error("copy command was unsuccessful");
    }
    success = true;
  } catch (err) {
    debug && console.error("unable to copy using execCommand: ", err);
    debug && console.warn("trying IE specific stuff");
    try {
      window.clipboardData.setData(options.format || "text", text);
      options.onCopy && options.onCopy(window.clipboardData);
      success = true;
    } catch (err) {
      debug && console.error("unable to copy using clipboardData: ", err);
      debug && console.error("falling back to prompt");
      message = format("message" in options ? options.message : defaultMessage);
      window.prompt(message, text);
    }
  } finally {
    if (selection) {
      if (typeof selection.removeRange == "function") {
        selection.removeRange(range);
      } else {
        selection.removeAllRanges();
      }
    }

    if (mark) {
      document.body.removeChild(mark);
    }
    reselectPrevious();
  }

  return success;
}

module.exports = copy;


/***/ }),

/***/ 8079:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var parser_context_1 = __webpack_require__(5162);
var render_1 = __webpack_require__(5481);
var CssSelectorParser = /** @class */ (function () {
    function CssSelectorParser() {
        this.pseudos = {};
        this.attrEqualityMods = {};
        this.ruleNestingOperators = {};
        this.substitutesEnabled = false;
    }
    CssSelectorParser.prototype.registerSelectorPseudos = function () {
        var pseudos = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            pseudos[_i] = arguments[_i];
        }
        for (var _a = 0, pseudos_1 = pseudos; _a < pseudos_1.length; _a++) {
            var pseudo = pseudos_1[_a];
            this.pseudos[pseudo] = 'selector';
        }
        return this;
    };
    CssSelectorParser.prototype.unregisterSelectorPseudos = function () {
        var pseudos = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            pseudos[_i] = arguments[_i];
        }
        for (var _a = 0, pseudos_2 = pseudos; _a < pseudos_2.length; _a++) {
            var pseudo = pseudos_2[_a];
            delete this.pseudos[pseudo];
        }
        return this;
    };
    CssSelectorParser.prototype.registerNumericPseudos = function () {
        var pseudos = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            pseudos[_i] = arguments[_i];
        }
        for (var _a = 0, pseudos_3 = pseudos; _a < pseudos_3.length; _a++) {
            var pseudo = pseudos_3[_a];
            this.pseudos[pseudo] = 'numeric';
        }
        return this;
    };
    CssSelectorParser.prototype.unregisterNumericPseudos = function () {
        var pseudos = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            pseudos[_i] = arguments[_i];
        }
        for (var _a = 0, pseudos_4 = pseudos; _a < pseudos_4.length; _a++) {
            var pseudo = pseudos_4[_a];
            delete this.pseudos[pseudo];
        }
        return this;
    };
    CssSelectorParser.prototype.registerNestingOperators = function () {
        var operators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operators[_i] = arguments[_i];
        }
        for (var _a = 0, operators_1 = operators; _a < operators_1.length; _a++) {
            var operator = operators_1[_a];
            this.ruleNestingOperators[operator] = true;
        }
        return this;
    };
    CssSelectorParser.prototype.unregisterNestingOperators = function () {
        var operators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operators[_i] = arguments[_i];
        }
        for (var _a = 0, operators_2 = operators; _a < operators_2.length; _a++) {
            var operator = operators_2[_a];
            delete this.ruleNestingOperators[operator];
        }
        return this;
    };
    CssSelectorParser.prototype.registerAttrEqualityMods = function () {
        var mods = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            mods[_i] = arguments[_i];
        }
        for (var _a = 0, mods_1 = mods; _a < mods_1.length; _a++) {
            var mod = mods_1[_a];
            this.attrEqualityMods[mod] = true;
        }
        return this;
    };
    CssSelectorParser.prototype.unregisterAttrEqualityMods = function () {
        var mods = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            mods[_i] = arguments[_i];
        }
        for (var _a = 0, mods_2 = mods; _a < mods_2.length; _a++) {
            var mod = mods_2[_a];
            delete this.attrEqualityMods[mod];
        }
        return this;
    };
    CssSelectorParser.prototype.enableSubstitutes = function () {
        this.substitutesEnabled = true;
        return this;
    };
    CssSelectorParser.prototype.disableSubstitutes = function () {
        this.substitutesEnabled = false;
        return this;
    };
    CssSelectorParser.prototype.parse = function (str) {
        return parser_context_1.parseCssSelector(str, 0, this.pseudos, this.attrEqualityMods, this.ruleNestingOperators, this.substitutesEnabled);
    };
    CssSelectorParser.prototype.render = function (path) {
        return render_1.renderEntity(path).trim();
    };
    return CssSelectorParser;
}());
exports.N = CssSelectorParser;


/***/ }),

/***/ 5162:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(6389);
function parseCssSelector(str, pos, pseudos, attrEqualityMods, ruleNestingOperators, substitutesEnabled) {
    var l = str.length;
    var chr = '';
    function getStr(quote, escapeTable) {
        var result = '';
        pos++;
        chr = str.charAt(pos);
        while (pos < l) {
            if (chr === quote) {
                pos++;
                return result;
            }
            else if (chr === '\\') {
                pos++;
                chr = str.charAt(pos);
                var esc = void 0;
                if (chr === quote) {
                    result += quote;
                }
                else if ((esc = escapeTable[chr]) !== undefined) {
                    result += esc;
                }
                else if (utils_1.isHex(chr)) {
                    var hex = chr;
                    pos++;
                    chr = str.charAt(pos);
                    while (utils_1.isHex(chr)) {
                        hex += chr;
                        pos++;
                        chr = str.charAt(pos);
                    }
                    if (chr === ' ') {
                        pos++;
                        chr = str.charAt(pos);
                    }
                    result += String.fromCharCode(parseInt(hex, 16));
                    continue;
                }
                else {
                    result += chr;
                }
            }
            else {
                result += chr;
            }
            pos++;
            chr = str.charAt(pos);
        }
        return result;
    }
    function getIdent() {
        var result = '';
        chr = str.charAt(pos);
        while (pos < l) {
            if (utils_1.isIdent(chr)) {
                result += chr;
            }
            else if (chr === '\\') {
                pos++;
                if (pos >= l) {
                    throw Error('Expected symbol but end of file reached.');
                }
                chr = str.charAt(pos);
                if (utils_1.identSpecialChars[chr]) {
                    result += chr;
                }
                else if (utils_1.isHex(chr)) {
                    var hex = chr;
                    pos++;
                    chr = str.charAt(pos);
                    while (utils_1.isHex(chr)) {
                        hex += chr;
                        pos++;
                        chr = str.charAt(pos);
                    }
                    if (chr === ' ') {
                        pos++;
                        chr = str.charAt(pos);
                    }
                    result += String.fromCharCode(parseInt(hex, 16));
                    continue;
                }
                else {
                    result += chr;
                }
            }
            else {
                return result;
            }
            pos++;
            chr = str.charAt(pos);
        }
        return result;
    }
    function skipWhitespace() {
        chr = str.charAt(pos);
        var result = false;
        while (chr === ' ' || chr === "\t" || chr === "\n" || chr === "\r" || chr === "\f") {
            result = true;
            pos++;
            chr = str.charAt(pos);
        }
        return result;
    }
    function parse() {
        var res = parseSelector();
        if (pos < l) {
            throw Error('Rule expected but "' + str.charAt(pos) + '" found.');
        }
        return res;
    }
    function parseSelector() {
        var selector = parseSingleSelector();
        if (!selector) {
            return null;
        }
        var res = selector;
        chr = str.charAt(pos);
        while (chr === ',') {
            pos++;
            skipWhitespace();
            if (res.type !== 'selectors') {
                res = {
                    type: 'selectors',
                    selectors: [selector]
                };
            }
            selector = parseSingleSelector();
            if (!selector) {
                throw Error('Rule expected after ",".');
            }
            res.selectors.push(selector);
        }
        return res;
    }
    function parseSingleSelector() {
        skipWhitespace();
        var selector = {
            type: 'ruleSet'
        };
        var rule = parseRule();
        if (!rule) {
            return null;
        }
        var currentRule = selector;
        while (rule) {
            rule.type = 'rule';
            currentRule.rule = rule;
            currentRule = rule;
            skipWhitespace();
            chr = str.charAt(pos);
            if (pos >= l || chr === ',' || chr === ')') {
                break;
            }
            if (ruleNestingOperators[chr]) {
                var op = chr;
                pos++;
                skipWhitespace();
                rule = parseRule();
                if (!rule) {
                    throw Error('Rule expected after "' + op + '".');
                }
                rule.nestingOperator = op;
            }
            else {
                rule = parseRule();
                if (rule) {
                    rule.nestingOperator = null;
                }
            }
        }
        return selector;
    }
    // @ts-ignore no-overlap
    function parseRule() {
        var rule = null;
        while (pos < l) {
            chr = str.charAt(pos);
            if (chr === '*') {
                pos++;
                (rule = rule || {}).tagName = '*';
            }
            else if (utils_1.isIdentStart(chr) || chr === '\\') {
                (rule = rule || {}).tagName = getIdent();
            }
            else if (chr === '.') {
                pos++;
                rule = rule || {};
                (rule.classNames = rule.classNames || []).push(getIdent());
            }
            else if (chr === '#') {
                pos++;
                (rule = rule || {}).id = getIdent();
            }
            else if (chr === '[') {
                pos++;
                skipWhitespace();
                var attr = {
                    name: getIdent()
                };
                skipWhitespace();
                // @ts-ignore
                if (chr === ']') {
                    pos++;
                }
                else {
                    var operator = '';
                    if (attrEqualityMods[chr]) {
                        operator = chr;
                        pos++;
                        chr = str.charAt(pos);
                    }
                    if (pos >= l) {
                        throw Error('Expected "=" but end of file reached.');
                    }
                    if (chr !== '=') {
                        throw Error('Expected "=" but "' + chr + '" found.');
                    }
                    attr.operator = operator + '=';
                    pos++;
                    skipWhitespace();
                    var attrValue = '';
                    attr.valueType = 'string';
                    // @ts-ignore
                    if (chr === '"') {
                        attrValue = getStr('"', utils_1.doubleQuotesEscapeChars);
                        // @ts-ignore
                    }
                    else if (chr === '\'') {
                        attrValue = getStr('\'', utils_1.singleQuoteEscapeChars);
                        // @ts-ignore
                    }
                    else if (substitutesEnabled && chr === '$') {
                        pos++;
                        attrValue = getIdent();
                        attr.valueType = 'substitute';
                    }
                    else {
                        while (pos < l) {
                            if (chr === ']') {
                                break;
                            }
                            attrValue += chr;
                            pos++;
                            chr = str.charAt(pos);
                        }
                        attrValue = attrValue.trim();
                    }
                    skipWhitespace();
                    if (pos >= l) {
                        throw Error('Expected "]" but end of file reached.');
                    }
                    if (chr !== ']') {
                        throw Error('Expected "]" but "' + chr + '" found.');
                    }
                    pos++;
                    attr.value = attrValue;
                }
                rule = rule || {};
                (rule.attrs = rule.attrs || []).push(attr);
            }
            else if (chr === ':') {
                pos++;
                var pseudoName = getIdent();
                var pseudo = {
                    name: pseudoName
                };
                // @ts-ignore
                if (chr === '(') {
                    pos++;
                    var value = '';
                    skipWhitespace();
                    if (pseudos[pseudoName] === 'selector') {
                        pseudo.valueType = 'selector';
                        value = parseSelector();
                    }
                    else {
                        pseudo.valueType = pseudos[pseudoName] || 'string';
                        // @ts-ignore
                        if (chr === '"') {
                            value = getStr('"', utils_1.doubleQuotesEscapeChars);
                            // @ts-ignore
                        }
                        else if (chr === '\'') {
                            value = getStr('\'', utils_1.singleQuoteEscapeChars);
                            // @ts-ignore
                        }
                        else if (substitutesEnabled && chr === '$') {
                            pos++;
                            value = getIdent();
                            pseudo.valueType = 'substitute';
                        }
                        else {
                            while (pos < l) {
                                if (chr === ')') {
                                    break;
                                }
                                value += chr;
                                pos++;
                                chr = str.charAt(pos);
                            }
                            value = value.trim();
                        }
                        skipWhitespace();
                    }
                    if (pos >= l) {
                        throw Error('Expected ")" but end of file reached.');
                    }
                    if (chr !== ')') {
                        throw Error('Expected ")" but "' + chr + '" found.');
                    }
                    pos++;
                    pseudo.value = value;
                }
                rule = rule || {};
                (rule.pseudos = rule.pseudos || []).push(pseudo);
            }
            else {
                break;
            }
        }
        return rule;
    }
    return parse();
}
exports.parseCssSelector = parseCssSelector;


/***/ }),

/***/ 5481:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var utils_1 = __webpack_require__(6389);
function renderEntity(entity) {
    var res = '';
    switch (entity.type) {
        case 'ruleSet':
            var currentEntity = entity.rule;
            var parts = [];
            while (currentEntity) {
                if (currentEntity.nestingOperator) {
                    parts.push(currentEntity.nestingOperator);
                }
                parts.push(renderEntity(currentEntity));
                currentEntity = currentEntity.rule;
            }
            res = parts.join(' ');
            break;
        case 'selectors':
            res = entity.selectors.map(renderEntity).join(', ');
            break;
        case 'rule':
            if (entity.tagName) {
                if (entity.tagName === '*') {
                    res = '*';
                }
                else {
                    res = utils_1.escapeIdentifier(entity.tagName);
                }
            }
            if (entity.id) {
                res += "#" + utils_1.escapeIdentifier(entity.id);
            }
            if (entity.classNames) {
                res += entity.classNames.map(function (cn) {
                    return "." + (utils_1.escapeIdentifier(cn));
                }).join('');
            }
            if (entity.attrs) {
                res += entity.attrs.map(function (attr) {
                    if ('operator' in attr) {
                        if (attr.valueType === 'substitute') {
                            return "[" + utils_1.escapeIdentifier(attr.name) + attr.operator + "$" + attr.value + "]";
                        }
                        else {
                            return "[" + utils_1.escapeIdentifier(attr.name) + attr.operator + utils_1.escapeStr(attr.value) + "]";
                        }
                    }
                    else {
                        return "[" + utils_1.escapeIdentifier(attr.name) + "]";
                    }
                }).join('');
            }
            if (entity.pseudos) {
                res += entity.pseudos.map(function (pseudo) {
                    if (pseudo.valueType) {
                        if (pseudo.valueType === 'selector') {
                            return ":" + utils_1.escapeIdentifier(pseudo.name) + "(" + renderEntity(pseudo.value) + ")";
                        }
                        else if (pseudo.valueType === 'substitute') {
                            return ":" + utils_1.escapeIdentifier(pseudo.name) + "($" + pseudo.value + ")";
                        }
                        else if (pseudo.valueType === 'numeric') {
                            return ":" + utils_1.escapeIdentifier(pseudo.name) + "(" + pseudo.value + ")";
                        }
                        else {
                            return (":" + utils_1.escapeIdentifier(pseudo.name) +
                                "(" + utils_1.escapeIdentifier(pseudo.value) + ")");
                        }
                    }
                    else {
                        return ":" + utils_1.escapeIdentifier(pseudo.name);
                    }
                }).join('');
            }
            break;
        default:
            throw Error('Unknown entity type: "' + entity.type + '".');
    }
    return res;
}
exports.renderEntity = renderEntity;


/***/ }),

/***/ 6389:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
function isIdentStart(c) {
    return (c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') || (c === '-') || (c === '_');
}
exports.isIdentStart = isIdentStart;
function isIdent(c) {
    return (c >= 'a' && c <= 'z') || (c >= 'A' && c <= 'Z') || (c >= '0' && c <= '9') || c === '-' || c === '_';
}
exports.isIdent = isIdent;
function isHex(c) {
    return (c >= 'a' && c <= 'f') || (c >= 'A' && c <= 'F') || (c >= '0' && c <= '9');
}
exports.isHex = isHex;
function escapeIdentifier(s) {
    var len = s.length;
    var result = '';
    var i = 0;
    while (i < len) {
        var chr = s.charAt(i);
        if (exports.identSpecialChars[chr]) {
            result += '\\' + chr;
        }
        else {
            if (!(chr === '_' || chr === '-' ||
                (chr >= 'A' && chr <= 'Z') ||
                (chr >= 'a' && chr <= 'z') ||
                (i !== 0 && chr >= '0' && chr <= '9'))) {
                var charCode = chr.charCodeAt(0);
                if ((charCode & 0xF800) === 0xD800) {
                    var extraCharCode = s.charCodeAt(i++);
                    if ((charCode & 0xFC00) !== 0xD800 || (extraCharCode & 0xFC00) !== 0xDC00) {
                        throw Error('UCS-2(decode): illegal sequence');
                    }
                    charCode = ((charCode & 0x3FF) << 10) + (extraCharCode & 0x3FF) + 0x10000;
                }
                result += '\\' + charCode.toString(16) + ' ';
            }
            else {
                result += chr;
            }
        }
        i++;
    }
    return result;
}
exports.escapeIdentifier = escapeIdentifier;
function escapeStr(s) {
    var len = s.length;
    var result = '';
    var i = 0;
    var replacement;
    while (i < len) {
        var chr = s.charAt(i);
        if (chr === '"') {
            chr = '\\"';
        }
        else if (chr === '\\') {
            chr = '\\\\';
        }
        else if ((replacement = exports.strReplacementsRev[chr]) !== undefined) {
            chr = replacement;
        }
        result += chr;
        i++;
    }
    return "\"" + result + "\"";
}
exports.escapeStr = escapeStr;
exports.identSpecialChars = {
    '!': true,
    '"': true,
    '#': true,
    '$': true,
    '%': true,
    '&': true,
    '\'': true,
    '(': true,
    ')': true,
    '*': true,
    '+': true,
    ',': true,
    '.': true,
    '/': true,
    ';': true,
    '<': true,
    '=': true,
    '>': true,
    '?': true,
    '@': true,
    '[': true,
    '\\': true,
    ']': true,
    '^': true,
    '`': true,
    '{': true,
    '|': true,
    '}': true,
    '~': true
};
exports.strReplacementsRev = {
    '\n': '\\n',
    '\r': '\\r',
    '\t': '\\t',
    '\f': '\\f',
    '\v': '\\v'
};
exports.singleQuoteEscapeChars = {
    n: '\n',
    r: '\r',
    t: '\t',
    f: '\f',
    '\\': '\\',
    '\'': '\''
};
exports.doubleQuotesEscapeChars = {
    n: '\n',
    r: '\r',
    t: '\t',
    f: '\f',
    '\\': '\\',
    '"': '"'
};


/***/ }),

/***/ 3128:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = detab

var repeat = __webpack_require__(6464)

var tab = 0x09
var lineFeed = 0x0a
var carriageReturn = 0x0d

// Replace tabs with spaces, being smart about which column the tab is at and
// which size should be used.
function detab(value, size) {
  var string = typeof value === 'string'
  var length = string && value.length
  var start = 0
  var index = -1
  var column = -1
  var tabSize = size || 4
  var results = []
  var code
  var add

  if (!string) {
    throw new Error('detab expected string')
  }

  while (++index < length) {
    code = value.charCodeAt(index)

    if (code === tab) {
      add = tabSize - ((column + 1) % tabSize)
      column += add
      results.push(value.slice(start, index) + repeat(' ', add))
      start = index + 1
    } else if (code === lineFeed || code === carriageReturn) {
      column = -1
    } else {
      column++
    }
  }

  results.push(value.slice(start))

  return results.join('')
}


/***/ }),

/***/ 4470:
/***/ ((module) => {

"use strict";


var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),

/***/ 1102:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var formatter = __webpack_require__(6291)

var fault = create(Error)

module.exports = fault

fault.eval = create(EvalError)
fault.range = create(RangeError)
fault.reference = create(ReferenceError)
fault.syntax = create(SyntaxError)
fault.type = create(TypeError)
fault.uri = create(URIError)

fault.create = create

// Create a new `EConstructor`, with the formatted `format` as a first argument.
function create(EConstructor) {
  FormattedError.displayName = EConstructor.displayName || EConstructor.name

  return FormattedError

  function FormattedError(format) {
    if (format) {
      format = formatter.apply(null, arguments)
    }

    return new EConstructor(format)
  }
}


/***/ }),

/***/ 6291:
/***/ ((module) => {

//
// format - printf-like string formatting for JavaScript
// github.com/samsonjs/format
// @_sjs
//
// Copyright 2010 - 2013 Sami Samhuri <sami@samhuri.net>
//
// MIT License
// http://sjs.mit-license.org
//

;(function() {

  //// Export the API
  var namespace;

  // CommonJS / Node module
  if (true) {
    namespace = module.exports = format;
  }

  // Browsers and other environments
  else {}

  namespace.format = format;
  namespace.vsprintf = vsprintf;

  if (typeof console !== 'undefined' && typeof console.log === 'function') {
    namespace.printf = printf;
  }

  function printf(/* ... */) {
    console.log(format.apply(null, arguments));
  }

  function vsprintf(fmt, replacements) {
    return format.apply(null, [fmt].concat(replacements));
  }

  function format(fmt) {
    var argIndex = 1 // skip initial format argument
      , args = [].slice.call(arguments)
      , i = 0
      , n = fmt.length
      , result = ''
      , c
      , escaped = false
      , arg
      , tmp
      , leadingZero = false
      , precision
      , nextArg = function() { return args[argIndex++]; }
      , slurpNumber = function() {
          var digits = '';
          while (/\d/.test(fmt[i])) {
            digits += fmt[i++];
            c = fmt[i];
          }
          return digits.length > 0 ? parseInt(digits) : null;
        }
      ;
    for (; i < n; ++i) {
      c = fmt[i];
      if (escaped) {
        escaped = false;
        if (c == '.') {
          leadingZero = false;
          c = fmt[++i];
        }
        else if (c == '0' && fmt[i + 1] == '.') {
          leadingZero = true;
          i += 2;
          c = fmt[i];
        }
        else {
          leadingZero = true;
        }
        precision = slurpNumber();
        switch (c) {
        case 'b': // number in binary
          result += parseInt(nextArg(), 10).toString(2);
          break;
        case 'c': // character
          arg = nextArg();
          if (typeof arg === 'string' || arg instanceof String)
            result += arg;
          else
            result += String.fromCharCode(parseInt(arg, 10));
          break;
        case 'd': // number in decimal
          result += parseInt(nextArg(), 10);
          break;
        case 'f': // floating point number
          tmp = String(parseFloat(nextArg()).toFixed(precision || 6));
          result += leadingZero ? tmp : tmp.replace(/^0/, '');
          break;
        case 'j': // JSON
          result += JSON.stringify(nextArg());
          break;
        case 'o': // number in octal
          result += '0' + parseInt(nextArg(), 10).toString(8);
          break;
        case 's': // string
          result += nextArg();
          break;
        case 'x': // lowercase hexadecimal
          result += '0x' + parseInt(nextArg(), 10).toString(16);
          break;
        case 'X': // uppercase hexadecimal
          result += '0x' + parseInt(nextArg(), 10).toString(16).toUpperCase();
          break;
        default:
          result += c;
          break;
        }
      } else if (c === '%') {
        escaped = true;
      } else {
        result += c;
      }
    }
    return result;
  }

}());


/***/ }),

/***/ 9671:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var emoji = __webpack_require__(2730)

module.exports = BananaSlug

var own = Object.hasOwnProperty
var whitespace = /\s/g
var specials = /[\u2000-\u206F\u2E00-\u2E7F\\'!"#$%&()*+,./:;<=>?@[\]^`{|}~’]/g

function BananaSlug () {
  var self = this

  if (!(self instanceof BananaSlug)) return new BananaSlug()

  self.reset()
}

/**
 * Generate a unique slug.
 * @param  {string} value String of text to slugify
 * @param  {boolean} [false] Keep the current case, otherwise make all lowercase
 * @return {string}       A unique slug string
 */
BananaSlug.prototype.slug = function (value, maintainCase) {
  var self = this
  var slug = slugger(value, maintainCase === true)
  var originalSlug = slug

  while (own.call(self.occurrences, slug)) {
    self.occurrences[originalSlug]++
    slug = originalSlug + '-' + self.occurrences[originalSlug]
  }

  self.occurrences[slug] = 0

  return slug
}

/**
 * Reset - Forget all previous slugs
 * @return void
 */
BananaSlug.prototype.reset = function () {
  this.occurrences = Object.create(null)
}

function slugger (string, maintainCase) {
  if (typeof string !== 'string') return ''
  if (!maintainCase) string = string.toLowerCase()

  return string.trim()
    .replace(specials, '')
    .replace(emoji(), '')
    .replace(whitespace, '-')
}

BananaSlug.slug = slugger


/***/ }),

/***/ 2730:
/***/ ((module) => {

module.exports = function() {
	return /[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2694\u2696\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD79\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED0\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3]|\uD83E[\uDD10-\uDD18\uDD80-\uDD84\uDDC0]|\uD83C\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uD83C\uDDFE\uD83C[\uDDEA\uDDF9]|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDFC\uD83C[\uDDEB\uDDF8]|\uD83C\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uD83C\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF8\uDDFE\uDDFF]|\uD83C\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uD83C\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uD83C\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uD83C\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uD83C\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uD83C\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uD83C\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uD83C\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uD83C\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uD83C\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uD83C\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uD83C\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uD83C\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uD83C\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF]|\uD83C\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uD83C\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|[#\*0-9]\u20E3/g;
};


/***/ }),

/***/ 6331:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var html = __webpack_require__(7247)
var svg = __webpack_require__(1218)
var find = __webpack_require__(9560)
var hastToReact = __webpack_require__(9640)
var spaces = __webpack_require__(6582)
var commas = __webpack_require__(6851)
var style = __webpack_require__(7848)
var ns = __webpack_require__(6)
var convert = __webpack_require__(3175)

var root = convert('root')
var element = convert('element')
var text = convert('text')

module.exports = wrapper

function wrapper(h, node, options) {
  var settings = options || {}
  var r = react(h)
  var v = vue(h)
  var vd = vdom(h)
  var prefix

  if (typeof h !== 'function') {
    throw new Error('h is not a function')
  }

  if (typeof settings === 'string' || typeof settings === 'boolean') {
    prefix = settings
    settings = {}
  } else {
    prefix = settings.prefix
  }

  if (root(node)) {
    node =
      node.children.length === 1 && element(node.children[0])
        ? node.children[0]
        : {
            type: 'element',
            tagName: 'div',
            properties: {},
            children: node.children
          }
  } else if (!element(node)) {
    throw new Error(
      'Expected root or element, not `' + ((node && node.type) || node) + '`'
    )
  }

  return toH(h, node, {
    schema: settings.space === 'svg' ? svg : html,
    prefix: prefix == null ? (r || v || vd ? 'h-' : null) : prefix,
    key: 0,
    react: r,
    vue: v,
    vdom: vd,
    hyperscript: hyperscript(h)
  })
}

// Transform a hast node through a hyperscript interface to *anything*!
function toH(h, node, ctx) {
  var parentSchema = ctx.schema
  var schema = parentSchema
  var name = node.tagName
  var attributes = {}
  var nodes = []
  var index = -1
  var key
  var value

  if (parentSchema.space === 'html' && name.toLowerCase() === 'svg') {
    schema = svg
    ctx.schema = schema
  }

  for (key in node.properties) {
    addAttribute(attributes, key, node.properties[key], ctx, name)
  }

  if (ctx.vdom) {
    if (schema.space === 'html') {
      name = name.toUpperCase()
    } else {
      attributes.namespace = ns[schema.space]
    }
  }

  if (ctx.prefix) {
    ctx.key++
    attributes.key = ctx.prefix + ctx.key
  }

  if (node.children) {
    while (++index < node.children.length) {
      value = node.children[index]

      if (element(value)) {
        nodes.push(toH(h, value, ctx))
      } else if (text(value)) {
        nodes.push(value.value)
      }
    }
  }

  // Restore parent schema.
  ctx.schema = parentSchema

  // Ensure no React warnings are triggered for void elements having children
  // passed in.
  return nodes.length
    ? h.call(node, name, attributes, nodes)
    : h.call(node, name, attributes)
}

function addAttribute(props, prop, value, ctx, name) {
  var info = find(ctx.schema, prop)
  var subprop

  // Ignore nullish and `NaN` values.
  // Ignore `false` and falsey known booleans for hyperlike DSLs.
  if (
    value == null ||
    value !== value ||
    (value === false && (ctx.vue || ctx.vdom || ctx.hyperscript)) ||
    (!value && info.boolean && (ctx.vue || ctx.vdom || ctx.hyperscript))
  ) {
    return
  }

  if (value && typeof value === 'object' && 'length' in value) {
    // Accept `array`.
    // Most props are space-separated.
    value = (info.commaSeparated ? commas : spaces).stringify(value)
  }

  // Treat `true` and truthy known booleans.
  if (info.boolean && ctx.hyperscript) {
    value = ''
  }

  // VDOM, Vue, and React accept `style` as object.
  if (
    info.property === 'style' &&
    typeof value === 'string' &&
    (ctx.react || ctx.vue || ctx.vdom)
  ) {
    value = parseStyle(value, name)
  }

  if (ctx.vue) {
    if (info.property !== 'style') subprop = 'attrs'
  } else if (!info.mustUseProperty) {
    if (ctx.vdom) {
      if (info.property !== 'style') subprop = 'attributes'
    } else if (ctx.hyperscript) {
      subprop = 'attrs'
    }
  }

  if (subprop) {
    if (!props[subprop]) props[subprop] = {}
    props[subprop][info.attribute] = value
  } else if (info.space && ctx.react) {
    props[hastToReact[info.property] || info.property] = value
  } else {
    props[info.attribute] = value
  }
}

// Check if `h` is `react.createElement`.
function react(h) {
  var node = h && h('div')
  return Boolean(
    node && ('_owner' in node || '_store' in node) && node.key == null
  )
}

// Check if `h` is `hyperscript`.
function hyperscript(h) {
  return Boolean(h && h.context && h.cleanup)
}

// Check if `h` is `virtual-dom/h`.
function vdom(h) {
  return h && h('div').type === 'VirtualNode'
}

function vue(h) {
  var node = h && h('div')
  return Boolean(node && node.context && node.context._isVue)
}

function parseStyle(value, tagName) {
  var result = {}

  try {
    style(value, iterator)
  } catch (error) {
    error.message =
      tagName + '[style]' + error.message.slice('undefined'.length)
    throw error
  }

  return result

  function iterator(name, value) {
    if (name.slice(0, 4) === '-ms-') name = 'ms-' + name.slice(4)
    result[name.replace(/-([a-z])/g, styleReplacer)] = value
  }
}

function styleReplacer($0, $1) {
  return $1.toUpperCase()
}


/***/ }),

/***/ 3175:
/***/ ((module) => {

"use strict";


module.exports = convert

function convert(test) {
  if (test == null) {
    return ok
  }

  if (typeof test === 'string') {
    return typeFactory(test)
  }

  if (typeof test === 'object') {
    return 'length' in test ? anyFactory(test) : allFactory(test)
  }

  if (typeof test === 'function') {
    return test
  }

  throw new Error('Expected function, string, or object as test')
}

// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function allFactory(test) {
  return all

  function all(node) {
    var key

    for (key in test) {
      if (node[key] !== test[key]) return false
    }

    return true
  }
}

function anyFactory(tests) {
  var checks = []
  var index = -1

  while (++index < tests.length) {
    checks[index] = convert(tests[index])
  }

  return any

  function any() {
    var index = -1

    while (++index < checks.length) {
      if (checks[index].apply(this, arguments)) {
        return true
      }
    }

    return false
  }
}

// Utility to convert a string into a function which checks a given node’s type
// for said string.
function typeFactory(test) {
  return type

  function type(node) {
    return Boolean(node && node.type === test)
  }
}

// Utility to return true.
function ok() {
  return true
}


/***/ }),

/***/ 8909:
/***/ ((module) => {

"use strict";


module.exports = isElement

// Check if if `node` is an `element` and, if `tagNames` is given, `node`
// matches them `tagNames`.
function isElement(node, tagNames) {
  var name

  if (
    !(
      tagNames === null ||
      tagNames === undefined ||
      typeof tagNames === 'string' ||
      (typeof tagNames === 'object' && tagNames.length !== 0)
    )
  ) {
    throw new Error(
      'Expected `string` or `Array.<string>` for `tagNames`, not `' +
        tagNames +
        '`'
    )
  }

  if (
    !node ||
    typeof node !== 'object' ||
    node.type !== 'element' ||
    typeof node.tagName !== 'string'
  ) {
    return false
  }

  if (tagNames === null || tagNames === undefined) {
    return true
  }

  name = node.tagName

  if (typeof tagNames === 'string') {
    return name === tagNames
  }

  return tagNames.indexOf(name) !== -1
}


/***/ }),

/***/ 8892:
/***/ ((module) => {

"use strict";


module.exports = parse

var search = /[#.]/g

// Create a hast element from a simple CSS selector.
function parse(selector, defaultTagName) {
  var value = selector || ''
  var name = defaultTagName || 'div'
  var props = {}
  var start = 0
  var subvalue
  var previous
  var match

  while (start < value.length) {
    search.lastIndex = start
    match = search.exec(value)
    subvalue = value.slice(start, match ? match.index : value.length)

    if (subvalue) {
      if (!previous) {
        name = subvalue
      } else if (previous === '#') {
        props.id = subvalue
      } else if (props.className) {
        props.className.push(subvalue)
      } else {
        props.className = [subvalue]
      }

      start += subvalue.length
    }

    if (match) {
      previous = match[0]
      start++
    }
  }

  return {type: 'element', tagName: name, properties: props, children: []}
}


/***/ }),

/***/ 6343:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var Parser = __webpack_require__(6425)
var pos = __webpack_require__(7361)
var visit = __webpack_require__(2854)
var fromParse5 = __webpack_require__(7721)
var toParse5 = __webpack_require__(8335)
var voids = __webpack_require__(9878)
var ns = __webpack_require__(6)
var zwitch = __webpack_require__(8019)
var xtend = __webpack_require__(7529)

module.exports = wrap

var inTemplateMode = 'IN_TEMPLATE_MODE'
var dataState = 'DATA_STATE'
var characterToken = 'CHARACTER_TOKEN'
var startTagToken = 'START_TAG_TOKEN'
var endTagToken = 'END_TAG_TOKEN'
var commentToken = 'COMMENT_TOKEN'
var doctypeToken = 'DOCTYPE_TOKEN'

var parseOptions = {sourceCodeLocationInfo: true, scriptingEnabled: false}

function wrap(tree, file, options) {
  var parser = new Parser(parseOptions)
  var one = zwitch('type', {
    handlers: {
      root: root,
      element: element,
      text: text,
      comment: comment,
      doctype: doctype,
      raw: raw
    },
    unknown: unknown
  })
  var stitches
  var tokenizer
  var preprocessor
  var posTracker
  var locationTracker
  var result
  var index

  if (file && !('contents' in file)) {
    options = file
    file = undefined
  }

  if (options && options.passThrough) {
    index = -1

    while (++index < options.passThrough.length) {
      one.handlers[options.passThrough[index]] = stitch
    }
  }

  result = fromParse5(documentMode(tree) ? document() : fragment(), file)

  if (stitches) {
    visit(result, 'comment', mend)
  }

  // Unpack if possible and when not given a `root`.
  if (tree.type !== 'root' && result.children.length === 1) {
    return result.children[0]
  }

  return result

  function mend(node, index, parent) {
    if (node.value.stitch) {
      parent.children[index] = node.value.stitch
      return index
    }
  }

  function fragment() {
    var context = {
      nodeName: 'template',
      tagName: 'template',
      attrs: [],
      namespaceURI: ns.html,
      childNodes: []
    }
    var mock = {
      nodeName: 'documentmock',
      tagName: 'documentmock',
      attrs: [],
      namespaceURI: ns.html,
      childNodes: []
    }
    var doc = {nodeName: '#document-fragment', childNodes: []}

    parser._bootstrap(mock, context)
    parser._pushTmplInsertionMode(inTemplateMode)
    parser._initTokenizerForFragmentParsing()
    parser._insertFakeRootElement()
    parser._resetInsertionMode()
    parser._findFormInFragmentContext()

    tokenizer = parser.tokenizer
    preprocessor = tokenizer.preprocessor
    locationTracker = tokenizer.__mixins[0]
    posTracker = locationTracker.posTracker

    one(tree)

    parser._adoptNodes(mock.childNodes[0], doc)

    return doc
  }

  function document() {
    var doc = parser.treeAdapter.createDocument()

    parser._bootstrap(doc, null)
    tokenizer = parser.tokenizer
    preprocessor = tokenizer.preprocessor
    locationTracker = tokenizer.__mixins[0]
    posTracker = locationTracker.posTracker

    one(tree)

    return doc
  }

  function all(nodes) {
    var index = -1

    /* istanbul ignore else - invalid nodes, see rehypejs/rehype-raw#7. */
    if (nodes) {
      while (++index < nodes.length) {
        one(nodes[index])
      }
    }
  }

  function root(node) {
    all(node.children)
  }

  function element(node) {
    resetTokenizer()
    parser._processToken(startTag(node), ns.html)

    all(node.children)

    if (voids.indexOf(node.tagName) < 0) {
      resetTokenizer()
      parser._processToken(endTag(node))
    }
  }

  function text(node) {
    resetTokenizer()
    parser._processToken({
      type: characterToken,
      chars: node.value,
      location: createParse5Location(node)
    })
  }

  function doctype(node) {
    var p5 = toParse5(node)
    resetTokenizer()
    parser._processToken({
      type: doctypeToken,
      name: p5.name,
      forceQuirks: false,
      publicId: p5.publicId,
      systemId: p5.systemId,
      location: createParse5Location(node)
    })
  }

  function comment(node) {
    resetTokenizer()
    parser._processToken({
      type: commentToken,
      data: node.value,
      location: createParse5Location(node)
    })
  }

  function raw(node) {
    var start = pos.start(node)
    var line = start.line || 1
    var column = start.column || 1
    var offset = start.offset || 0
    var token

    // Reset preprocessor:
    // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/tokenizer/preprocessor.js>.
    preprocessor.html = null
    preprocessor.pos = -1
    preprocessor.lastGapPos = -1
    preprocessor.lastCharPos = -1
    preprocessor.gapStack = []
    preprocessor.skipNextNewLine = false
    preprocessor.lastChunkWritten = false
    preprocessor.endOfChunkHit = false

    // Reset preprocessor mixin:
    // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/extensions/position-tracking/preprocessor-mixin.js>.
    posTracker.isEol = false
    posTracker.lineStartPos = -column + 1 // Looks weird, but ensures we get correct positional info.
    posTracker.droppedBufferSize = offset
    posTracker.offset = 0
    posTracker.col = 1
    posTracker.line = line

    // Reset location tracker:
    // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/extensions/location-info/tokenizer-mixin.js>.
    locationTracker.currentAttrLocation = null
    locationTracker.ctLoc = createParse5Location(node)

    // See the code for `parse` and `parseFragment`:
    // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/parser/index.js#L371>.
    tokenizer.write(node.value)
    parser._runParsingLoop(null)

    // Process final characters if they’re still there after hibernating.
    // Similar to:
    // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/extensions/location-info/tokenizer-mixin.js#L95>.
    token = tokenizer.currentCharacterToken

    if (token) {
      token.location.endLine = posTracker.line
      token.location.endCol = posTracker.col + 1
      token.location.endOffset = posTracker.offset + 1
      parser._processToken(token)
    }
  }

  function stitch(node) {
    var clone = Object.assign({}, node)

    stitches = true

    // Recurse, because to somewhat handle `[<x>]</x>` (where `[]` denotes the
    // passed through node).
    if (node.children) {
      clone.children = wrap(
        {type: 'root', children: node.children},
        file,
        options
      ).children
    }

    // Hack: `value` is supposed to be a string, but as none of the tools
    // (`parse5` or `hast-util-from-parse5`) looks at it, we can pass nodes
    // through.
    comment({value: {stitch: clone}})
  }

  function resetTokenizer() {
    // Reset tokenizer:
    // See: <https://github.com/inikulin/parse5/blob/9c683e1/packages/parse5/lib/tokenizer/index.js#L218-L234>.
    // Especially putting it back in the `data` state is useful: some elements,
    // like textareas and iframes, change the state.
    // See GH-7.
    // But also if broken HTML is in `raw`, and then a correct element is given.
    // See GH-11.
    tokenizer.tokenQueue = []
    tokenizer.state = dataState
    tokenizer.returnState = ''
    tokenizer.charRefCode = -1
    tokenizer.tempBuff = []
    tokenizer.lastStartTagName = ''
    tokenizer.consumedAfterSnapshot = -1
    tokenizer.active = false
    tokenizer.currentCharacterToken = null
    tokenizer.currentToken = null
    tokenizer.currentAttr = null
  }
}

function startTag(node) {
  var location = createParse5Location(node)

  location.startTag = xtend(location)

  return {
    type: startTagToken,
    tagName: node.tagName,
    selfClosing: false,
    attrs: attributes(node),
    location: location
  }
}

function attributes(node) {
  return toParse5({
    tagName: node.tagName,
    type: 'element',
    properties: node.properties
  }).attrs
}

function endTag(node) {
  var location = createParse5Location(node)

  location.endTag = xtend(location)

  return {
    type: endTagToken,
    tagName: node.tagName,
    attrs: [],
    location: location
  }
}

function unknown(node) {
  throw new Error('Cannot compile `' + node.type + '` node')
}

function documentMode(node) {
  var head = node.type === 'root' ? node.children[0] : node

  return head && (head.type === 'doctype' || head.tagName === 'html')
}

function createParse5Location(node) {
  var start = pos.start(node)
  var end = pos.end(node)

  return {
    startLine: start.line,
    startCol: start.column,
    startOffset: start.offset,
    endLine: end.line,
    endCol: end.column,
    endOffset: end.offset
  }
}


/***/ }),

/***/ 773:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(5204)


/***/ }),

/***/ 5802:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var one = __webpack_require__(1878)

module.exports = all

// Stringify all children of `parent`.
function all(ctx, parent) {
  var children = parent && parent.children
  var length = children && children.length
  var index = -1
  var results = []

  while (++index < length) {
    results[index] = one(ctx, children[index], index, parent)
  }

  return results.join('')
}


/***/ }),

/***/ 1928:
/***/ ((module) => {

"use strict";


module.exports = comment

// Stringify a comment `node`.
function comment(ctx, node) {
  return '<!--' + node.value + '-->'
}


/***/ }),

/***/ 5966:
/***/ ((module) => {

"use strict";


// Characters.
var nil = '\0'
var ampersand = '&'
var space = ' '
var tab = '\t'
var graveAccent = '`'
var quotationMark = '"'
var apostrophe = "'"
var equalsTo = '='
var lessThan = '<'
var greaterThan = '>'
var slash = '/'
var lineFeed = '\n'
var carriageReturn = '\r'
var formFeed = '\f'

var whitespace = [space, tab, lineFeed, carriageReturn, formFeed]

// See: <https://html.spec.whatwg.org/#attribute-name-state>.
var name = whitespace.concat(ampersand, slash, greaterThan, equalsTo)

// See: <https://html.spec.whatwg.org/#attribute-value-(unquoted)-state>.
var unquoted = whitespace.concat(ampersand, greaterThan)
var unquotedSafe = unquoted.concat(
  nil,
  quotationMark,
  apostrophe,
  lessThan,
  equalsTo,
  graveAccent
)

// See: <https://html.spec.whatwg.org/#attribute-value-(single-quoted)-state>.
var singleQuoted = [ampersand, apostrophe]

// See: <https://html.spec.whatwg.org/#attribute-value-(double-quoted)-state>.
var doubleQuoted = [ampersand, quotationMark]

// Maps of subsets.
// Each value is a matrix of tuples.
// The first value causes parse errors, the second is valid.
// Of both values, the first value is unsafe, and the second is safe.
module.exports = {
  name: [
    [name, name.concat(quotationMark, apostrophe, graveAccent)],
    [
      name.concat(nil, quotationMark, apostrophe, lessThan),
      name.concat(nil, quotationMark, apostrophe, lessThan, graveAccent)
    ]
  ],
  unquoted: [
    [unquoted, unquotedSafe],
    [unquotedSafe, unquotedSafe]
  ],
  single: [
    [singleQuoted, singleQuoted.concat(quotationMark, graveAccent)],
    [
      singleQuoted.concat(nil),
      singleQuoted.concat(nil, quotationMark, graveAccent)
    ]
  ],
  double: [
    [doubleQuoted, doubleQuoted.concat(apostrophe, graveAccent)],
    [
      doubleQuoted.concat(nil),
      doubleQuoted.concat(nil, apostrophe, graveAccent)
    ]
  ]
}


/***/ }),

/***/ 5842:
/***/ ((module) => {

"use strict";


module.exports = doctype

var docLower = 'doctype'
var docUpper = docLower.toUpperCase()

// Stringify a doctype `node`.
function doctype(ctx, node) {
  var doc = ctx.upperDoctype ? docUpper : docLower
  var sep = ctx.tightDoctype ? '' : ' '
  var name = node.name
  var pub = node.public
  var sys = node.system
  var val = ['<!' + doc]

  if (name) {
    val.push(sep, name)

    if (pub != null) {
      val.push(' public', sep, smart(pub))
    } else if (sys != null) {
      val.push(' system')
    }

    if (sys != null) {
      val.push(sep, smart(sys))
    }
  }

  return val.join('') + '>'
}

function smart(value) {
  var quote = value.indexOf('"') === -1 ? '"' : "'"
  return quote + value + quote
}


/***/ }),

/***/ 4307:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var xtend = __webpack_require__(7529)
var svg = __webpack_require__(1218)
var find = __webpack_require__(9560)
var spaces = (__webpack_require__(6582).stringify)
var commas = (__webpack_require__(6851).stringify)
var entities = __webpack_require__(4860)
var ccount = __webpack_require__(932)
var all = __webpack_require__(5802)
var constants = __webpack_require__(5966)

module.exports = element

var space = ' '
var quotationMark = '"'
var apostrophe = "'"
var equalsTo = '='
var lessThan = '<'
var greaterThan = '>'
var slash = '/'

// Stringify an element `node`.
// eslint-disable-next-line complexity
function element(ctx, node, index, parent) {
  var parentSchema = ctx.schema
  var name = node.tagName
  var value = ''
  var selfClosing
  var close
  var omit
  var root = node
  var content
  var attrs
  var last

  if (parentSchema.space === 'html' && name === 'svg') {
    ctx.schema = svg
  }

  attrs = attributes(ctx, node.properties)

  if (ctx.schema.space === 'svg') {
    omit = false
    close = true
    selfClosing = ctx.closeEmpty
  } else {
    omit = ctx.omit
    close = ctx.close
    selfClosing = ctx.voids.indexOf(name.toLowerCase()) !== -1

    if (name === 'template') {
      root = node.content
    }
  }

  content = all(ctx, root)

  // If the node is categorised as void, but it has children, remove the
  // categorisation.
  // This enables for example `menuitem`s, which are void in W3C HTML but not
  // void in WHATWG HTML, to be stringified properly.
  selfClosing = content ? false : selfClosing

  if (attrs || !omit || !omit.opening(node, index, parent)) {
    value = lessThan + name + (attrs ? space + attrs : '')

    if (selfClosing && close) {
      last = attrs.charAt(attrs.length - 1)
      if (
        !ctx.tightClose ||
        last === slash ||
        (ctx.schema.space === 'svg' &&
          last &&
          last !== quotationMark &&
          last !== apostrophe)
      ) {
        value += space
      }

      value += slash
    }

    value += greaterThan
  }

  value += content

  if (!selfClosing && (!omit || !omit.closing(node, index, parent))) {
    value += lessThan + slash + name + greaterThan
  }

  ctx.schema = parentSchema

  return value
}

// Stringify all attributes.
function attributes(ctx, props) {
  var values = []
  var key
  var value
  var result
  var length
  var index
  var last

  for (key in props) {
    value = props[key]

    if (value == null) {
      continue
    }

    result = attribute(ctx, key, value)

    if (result) {
      values.push(result)
    }
  }

  length = values.length
  index = -1

  while (++index < length) {
    result = values[index]
    last = null

    if (ctx.tight) {
      last = result.charAt(result.length - 1)
    }

    // In tight mode, don’t add a space after quoted attributes.
    if (index !== length - 1 && last !== quotationMark && last !== apostrophe) {
      values[index] = result + space
    }
  }

  return values.join('')
}

// Stringify one attribute.
function attribute(ctx, key, value) {
  var schema = ctx.schema
  var info = find(schema, key)
  var name = info.attribute

  if (info.overloadedBoolean && (value === name || value === '')) {
    value = true
  } else if (
    info.boolean ||
    (info.overloadedBoolean && typeof value !== 'string')
  ) {
    value = Boolean(value)
  }

  if (
    value == null ||
    value === false ||
    (typeof value === 'number' && isNaN(value))
  ) {
    return ''
  }

  name = attributeName(ctx, name)

  if (value === true) {
    // There is currently only one boolean property in SVG: `[download]` on
    // `<a>`.
    // This property does not seem to work in browsers (FF, Sa, Ch), so I can’t
    // test if dropping the value works.
    // But I assume that it should:
    //
    // ```html
    // <!doctype html>
    // <svg viewBox="0 0 100 100">
    //   <a href=https://example.com download>
    //     <circle cx=50 cy=40 r=35 />
    //   </a>
    // </svg>
    // ```
    //
    // See: <https://github.com/wooorm/property-information/blob/master/lib/svg.js>
    return name
  }

  return name + attributeValue(ctx, key, value, info)
}

// Stringify the attribute name.
function attributeName(ctx, name) {
  // Always encode without parse errors in non-HTML.
  var valid = ctx.schema.space === 'html' ? ctx.valid : 1
  var subset = constants.name[valid][ctx.safe]

  return entities(name, xtend(ctx.entities, {subset: subset}))
}

// Stringify the attribute value.
function attributeValue(ctx, key, value, info) {
  var options = ctx.entities
  var quote = ctx.quote
  var alternative = ctx.alternative
  var unquoted
  var subset

  if (typeof value === 'object' && 'length' in value) {
    // `spaces` doesn’t accept a second argument, but it’s given here just to
    // keep the code cleaner.
    value = (info.commaSeparated ? commas : spaces)(value, {
      padLeft: !ctx.tightLists
    })
  }

  value = String(value)

  if (value || !ctx.collapseEmpty) {
    unquoted = value

    // Check unquoted value.
    if (ctx.unquoted) {
      subset = constants.unquoted[ctx.valid][ctx.safe]
      unquoted = entities(
        value,
        xtend(options, {subset: subset, attribute: true})
      )
    }

    // If `value` contains entities when unquoted…
    if (!ctx.unquoted || unquoted !== value) {
      // If the alternative is less common than `quote`, switch.
      if (alternative && ccount(value, quote) > ccount(value, alternative)) {
        quote = alternative
      }

      subset = quote === apostrophe ? constants.single : constants.double
      // Always encode without parse errors in non-HTML.
      subset = subset[ctx.schema.space === 'html' ? ctx.valid : 1][ctx.safe]

      value = entities(value, xtend(options, {subset: subset, attribute: true}))

      value = quote + value + quote
    }

    // Don’t add a `=` for unquoted empties.
    value = value ? equalsTo + value : value
  }

  return value
}


/***/ }),

/***/ 5204:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var html = __webpack_require__(7247)
var svg = __webpack_require__(1218)
var voids = __webpack_require__(9878)
var omission = __webpack_require__(1600)
var one = __webpack_require__(1878)

module.exports = toHtml

var quotationMark = '"'
var apostrophe = "'"

// Stringify the given hast node.
function toHtml(node, options) {
  var settings = options || {}
  var quote = settings.quote || quotationMark
  var alternative = quote === quotationMark ? apostrophe : quotationMark
  var smart = settings.quoteSmart

  if (quote !== quotationMark && quote !== apostrophe) {
    throw new Error(
      'Invalid quote `' +
        quote +
        '`, expected `' +
        apostrophe +
        '` or `' +
        quotationMark +
        '`'
    )
  }

  return one(
    {
      valid: settings.allowParseErrors ? 0 : 1,
      safe: settings.allowDangerousCharacters ? 0 : 1,
      schema: settings.space === 'svg' ? svg : html,
      omit: settings.omitOptionalTags && omission,
      quote: quote,
      alternative: smart ? alternative : null,
      unquoted: Boolean(settings.preferUnquoted),
      tight: settings.tightAttributes,
      upperDoctype: Boolean(settings.upperDoctype),
      tightDoctype: Boolean(settings.tightDoctype),
      tightLists: settings.tightCommaSeparatedLists,
      tightClose: settings.tightSelfClosing,
      collapseEmpty: settings.collapseEmptyAttributes,
      dangerous: settings.allowDangerousHTML,
      voids: settings.voids || voids.concat(),
      entities: settings.entities || {},
      close: settings.closeSelfClosing,
      closeEmpty: settings.closeEmptyElements
    },
    node
  )
}


/***/ }),

/***/ 8639:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var convert = __webpack_require__(8145)
var element = __webpack_require__(8909)
var whiteSpaceLeft = __webpack_require__(885)
var after = (__webpack_require__(3370)/* .after */ .e)
var omission = __webpack_require__(5254)

var isComment = convert('comment')

var optionGroup = 'optgroup'
var options = ['option'].concat(optionGroup)
var dataListItem = ['dt', 'dd']
var listItem = 'li'
var menuContent = ['menuitem', 'hr', 'menu']
var ruby = ['rp', 'rt']
var tableContainer = ['tbody', 'tfoot']
var tableRow = 'tr'
var tableCell = ['td', 'th']

var confusingParagraphParent = [
  'a',
  'audio',
  'del',
  'ins',
  'map',
  'noscript',
  'video'
]

var clearParagraphSibling = [
  'address',
  'article',
  'aside',
  'blockquote',
  'details',
  'div',
  'dl',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'header',
  'hgroup',
  'hr',
  'main',
  'menu',
  'nav',
  'ol',
  'p',
  'pre',
  'section',
  'table',
  'ul'
]

module.exports = omission({
  html: html,
  head: headOrColgroupOrCaption,
  body: body,
  p: p,
  li: li,
  dt: dt,
  dd: dd,
  rt: rubyElement,
  rp: rubyElement,
  optgroup: optgroup,
  option: option,
  menuitem: menuitem,
  colgroup: headOrColgroupOrCaption,
  caption: headOrColgroupOrCaption,
  thead: thead,
  tbody: tbody,
  tfoot: tfoot,
  tr: tr,
  td: cells,
  th: cells
})

// Macro for `</head>`, `</colgroup>`, and `</caption>`.
function headOrColgroupOrCaption(node, index, parent) {
  var next = after(parent, index, true)
  return !next || (!isComment(next) && !whiteSpaceLeft(next))
}

// Whether to omit `</html>`.
function html(node, index, parent) {
  var next = after(parent, index)
  return !next || !isComment(next)
}

// Whether to omit `</body>`.
function body(node, index, parent) {
  var next = after(parent, index)
  return !next || !isComment(next)
}

// Whether to omit `</p>`.
function p(node, index, parent) {
  var next = after(parent, index)
  return next
    ? element(next, clearParagraphSibling)
    : !parent || !element(parent, confusingParagraphParent)
}

// Whether to omit `</li>`.
function li(node, index, parent) {
  var next = after(parent, index)
  return !next || element(next, listItem)
}

// Whether to omit `</dt>`.
function dt(node, index, parent) {
  var next = after(parent, index)
  return next && element(next, dataListItem)
}

// Whether to omit `</dd>`.
function dd(node, index, parent) {
  var next = after(parent, index)
  return !next || element(next, dataListItem)
}

// Whether to omit `</rt>` or `</rp>`.
function rubyElement(node, index, parent) {
  var next = after(parent, index)
  return !next || element(next, ruby)
}

// Whether to omit `</optgroup>`.
function optgroup(node, index, parent) {
  var next = after(parent, index)
  return !next || element(next, optionGroup)
}

// Whether to omit `</option>`.
function option(node, index, parent) {
  var next = after(parent, index)
  return !next || element(next, options)
}

// Whether to omit `</menuitem>`.
function menuitem(node, index, parent) {
  var next = after(parent, index)
  return !next || element(next, menuContent)
}

// Whether to omit `</thead>`.
function thead(node, index, parent) {
  var next = after(parent, index)
  return next && element(next, tableContainer)
}

// Whether to omit `</tbody>`.
function tbody(node, index, parent) {
  var next = after(parent, index)
  return !next || element(next, tableContainer)
}

// Whether to omit `</tfoot>`.
function tfoot(node, index, parent) {
  return !after(parent, index)
}

// Whether to omit `</tr>`.
function tr(node, index, parent) {
  var next = after(parent, index)
  return !next || element(next, tableRow)
}

// Whether to omit `</td>` or `</th>`.
function cells(node, index, parent) {
  var next = after(parent, index)
  return !next || element(next, tableCell)
}


/***/ }),

/***/ 1600:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

exports.opening = __webpack_require__(6014)
exports.closing = __webpack_require__(8639)


/***/ }),

/***/ 5254:
/***/ ((module) => {

"use strict";


module.exports = omission

var own = {}.hasOwnProperty

// Factory to check if a given node can have a tag omitted.
function omission(handlers) {
  return omit

  // Check if a given node can have a tag omitted.
  function omit(node, index, parent) {
    var name = node.tagName
    var fn = own.call(handlers, name) ? handlers[name] : false

    return fn ? fn(node, index, parent) : false
  }
}


/***/ }),

/***/ 6014:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var convert = __webpack_require__(8145)
var element = __webpack_require__(8909)
var before = (__webpack_require__(3370)/* .before */ .b)
var first = __webpack_require__(4414)
var place = __webpack_require__(4997)
var whiteSpaceLeft = __webpack_require__(885)
var closing = __webpack_require__(8639)
var omission = __webpack_require__(5254)

var own = {}.hasOwnProperty

var isComment = convert('comment')

var uniqueHeadMetadata = ['title', 'base']
var meta = ['meta', 'link', 'script', 'style', 'template']
var tableContainers = ['thead', 'tbody']
var tableRow = 'tr'

module.exports = omission({
  html: html,
  head: head,
  body: body,
  colgroup: colgroup,
  tbody: tbody
})

// Whether to omit `<html>`.
function html(node) {
  var head = first(node)
  return !head || !isComment(head)
}

// Whether to omit `<head>`.
function head(node) {
  var children = node.children
  var length = children.length
  var map = {}
  var index = -1
  var child
  var name

  while (++index < length) {
    child = children[index]
    name = child.tagName

    if (element(child, uniqueHeadMetadata)) {
      if (own.call(map, name)) {
        return false
      }

      map[name] = true
    }
  }

  return Boolean(length)
}

// Whether to omit `<body>`.
function body(node) {
  var head = first(node, true)

  return (
    !head || (!isComment(head) && !whiteSpaceLeft(head) && !element(head, meta))
  )
}

// Whether to omit `<colgroup>`.
// The spec describes some logic for the opening tag, but it’s easier to
// implement in the closing tag, to the same effect, so we handle it there
// instead.
function colgroup(node, index, parent) {
  var prev = before(parent, index)
  var head = first(node, true)

  // Previous colgroup was already omitted.
  if (element(prev, 'colgroup') && closing(prev, place(parent, prev), parent)) {
    return false
  }

  return head && element(head, 'col')
}

// Whether to omit `<tbody>`.
function tbody(node, index, parent) {
  var prev = before(parent, index)
  var head = first(node)

  // Previous table section was already omitted.
  if (
    element(prev, tableContainers) &&
    closing(prev, place(parent, prev), parent)
  ) {
    return false
  }

  return head && element(head, tableRow)
}


/***/ }),

/***/ 4414:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var after = (__webpack_require__(3370)/* .after */ .e)

module.exports = first

// Get the first child in `parent`.
function first(parent, includeWhiteSpace) {
  return after(parent, -1, includeWhiteSpace)
}


/***/ }),

/***/ 4997:
/***/ ((module) => {

"use strict";


module.exports = place

// Get the position of `node` in `parent`.
function place(parent, child) {
  return parent && parent.children && parent.children.indexOf(child)
}


/***/ }),

/***/ 3370:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";


var whiteSpace = __webpack_require__(3560)

exports.b = siblings(-1)
exports.e = siblings(1)

// Factory to check siblings in a direction.
function siblings(increment) {
  return sibling

  // Find applicable siblings in a direction.
  function sibling(parent, index, includeWhiteSpace) {
    var siblings = parent && parent.children
    var next

    index += increment
    next = siblings && siblings[index]

    if (!includeWhiteSpace) {
      while (next && whiteSpace(next)) {
        index += increment
        next = siblings[index]
      }
    }

    return next
  }
}


/***/ }),

/***/ 885:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var convert = __webpack_require__(8145)
var whiteSpace = __webpack_require__(3560)

module.exports = whiteSpaceLeft

var isText = convert('text')

// Check if `node` starts with white-space.
function whiteSpaceLeft(node) {
  return isText(node) && whiteSpace(node.value.charAt(0))
}


/***/ }),

/***/ 1878:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = one

var own = {}.hasOwnProperty

var handlers = {}

handlers.root = __webpack_require__(5802)
handlers.text = __webpack_require__(9514)
handlers.element = __webpack_require__(4307)
handlers.doctype = __webpack_require__(5842)
handlers.comment = __webpack_require__(1928)
handlers.raw = __webpack_require__(9044)

// Stringify `node`.
function one(ctx, node, index, parent) {
  var type = node && node.type

  if (!type) {
    throw new Error('Expected node, not `' + node + '`')
  }

  if (!own.call(handlers, type)) {
    throw new Error('Cannot compile unknown node `' + type + '`')
  }

  return handlers[type](ctx, node, index, parent)
}


/***/ }),

/***/ 9044:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var text = __webpack_require__(9514)

module.exports = raw

// Stringify `raw`.
function raw(ctx, node) {
  return ctx.dangerous ? node.value : text(ctx, node)
}


/***/ }),

/***/ 9514:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var xtend = __webpack_require__(7529)
var entities = __webpack_require__(4860)

module.exports = text

// Stringify `text`.
function text(ctx, node, index, parent) {
  var value = node.value

  return isLiteral(parent)
    ? value
    : entities(value, xtend(ctx.entities, {subset: ['<', '&']}))
}

// Check if content of `node` should be escaped.
function isLiteral(node) {
  return node && (node.tagName === 'script' || node.tagName === 'style')
}


/***/ }),

/***/ 3560:
/***/ ((module) => {

"use strict";


module.exports = interElementWhiteSpace

// HTML white-space expression.
// See <https://html.spec.whatwg.org/#space-character>.
var re = /[ \t\n\f\r]/g

function interElementWhiteSpace(node) {
  var value

  if (node && typeof node === 'object' && node.type === 'text') {
    value = node.value || ''
  } else if (typeof node === 'string') {
    value = node
  } else {
    return false
  }

  return value.replace(re, '') === ''
}


/***/ }),

/***/ 2502:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var find = __webpack_require__(9560)
var normalize = __webpack_require__(6632)
var parseSelector = __webpack_require__(8892)
var spaces = (__webpack_require__(6582).parse)
var commas = (__webpack_require__(6851).parse)

module.exports = factory

var own = {}.hasOwnProperty

function factory(schema, defaultTagName, caseSensitive) {
  var adjust = caseSensitive ? createAdjustMap(caseSensitive) : null

  return h

  // Hyperscript compatible DSL for creating virtual hast trees.
  function h(selector, properties) {
    var node = parseSelector(selector, defaultTagName)
    var children = Array.prototype.slice.call(arguments, 2)
    var name = node.tagName.toLowerCase()
    var property

    node.tagName = adjust && own.call(adjust, name) ? adjust[name] : name

    if (properties && isChildren(properties, node)) {
      children.unshift(properties)
      properties = null
    }

    if (properties) {
      for (property in properties) {
        addProperty(node.properties, property, properties[property])
      }
    }

    addChild(node.children, children)

    if (node.tagName === 'template') {
      node.content = {type: 'root', children: node.children}
      node.children = []
    }

    return node
  }

  function addProperty(properties, key, value) {
    var info
    var property
    var result

    // Ignore nullish and NaN values.
    if (value === null || value === undefined || value !== value) {
      return
    }

    info = find(schema, key)
    property = info.property
    result = value

    // Handle list values.
    if (typeof result === 'string') {
      if (info.spaceSeparated) {
        result = spaces(result)
      } else if (info.commaSeparated) {
        result = commas(result)
      } else if (info.commaOrSpaceSeparated) {
        result = spaces(commas(result).join(' '))
      }
    }

    // Accept `object` on style.
    if (property === 'style' && typeof value !== 'string') {
      result = style(result)
    }

    // Class-names (which can be added both on the `selector` and here).
    if (property === 'className' && properties.className) {
      result = properties.className.concat(result)
    }

    properties[property] = parsePrimitives(info, property, result)
  }
}

function isChildren(value, node) {
  return (
    typeof value === 'string' ||
    'length' in value ||
    isNode(node.tagName, value)
  )
}

function isNode(tagName, value) {
  var type = value.type

  if (tagName === 'input' || !type || typeof type !== 'string') {
    return false
  }

  if (typeof value.children === 'object' && 'length' in value.children) {
    return true
  }

  type = type.toLowerCase()

  if (tagName === 'button') {
    return (
      type !== 'menu' &&
      type !== 'submit' &&
      type !== 'reset' &&
      type !== 'button'
    )
  }

  return 'value' in value
}

function addChild(nodes, value) {
  var index
  var length

  if (typeof value === 'string' || typeof value === 'number') {
    nodes.push({type: 'text', value: String(value)})
    return
  }

  if (typeof value === 'object' && 'length' in value) {
    index = -1
    length = value.length

    while (++index < length) {
      addChild(nodes, value[index])
    }

    return
  }

  if (typeof value !== 'object' || !('type' in value)) {
    throw new Error('Expected node, nodes, or string, got `' + value + '`')
  }

  nodes.push(value)
}

// Parse a (list of) primitives.
function parsePrimitives(info, name, value) {
  var index
  var length
  var result

  if (typeof value !== 'object' || !('length' in value)) {
    return parsePrimitive(info, name, value)
  }

  length = value.length
  index = -1
  result = []

  while (++index < length) {
    result[index] = parsePrimitive(info, name, value[index])
  }

  return result
}

// Parse a single primitives.
function parsePrimitive(info, name, value) {
  var result = value

  if (info.number || info.positiveNumber) {
    if (!isNaN(result) && result !== '') {
      result = Number(result)
    }
  } else if (info.boolean || info.overloadedBoolean) {
    // Accept `boolean` and `string`.
    if (
      typeof result === 'string' &&
      (result === '' || normalize(value) === normalize(name))
    ) {
      result = true
    }
  }

  return result
}

function style(value) {
  var result = []
  var key

  for (key in value) {
    result.push([key, value[key]].join(': '))
  }

  return result.join('; ')
}

function createAdjustMap(values) {
  var length = values.length
  var index = -1
  var result = {}
  var value

  while (++index < length) {
    value = values[index]
    result[value.toLowerCase()] = value
  }

  return result
}


/***/ }),

/***/ 2579:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var schema = __webpack_require__(7247)
var factory = __webpack_require__(2502)

var html = factory(schema, 'div')
html.displayName = 'html'

module.exports = html


/***/ }),

/***/ 1742:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = __webpack_require__(2579)


/***/ }),

/***/ 9505:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var schema = __webpack_require__(1218)
var caseSensitive = __webpack_require__(6947)
var factory = __webpack_require__(2502)

var svg = factory(schema, 'g', caseSensitive)
svg.displayName = 'svg'

module.exports = svg


/***/ }),

/***/ 5717:
/***/ ((module) => {

if (typeof Object.create === 'function') {
  // implementation from standard node.js 'util' module
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
          value: ctor,
          enumerable: false,
          writable: true,
          configurable: true
        }
      })
    }
  };
} else {
  // old school shim for old browsers
  module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
      ctor.super_ = superCtor
      var TempCtor = function () {}
      TempCtor.prototype = superCtor.prototype
      ctor.prototype = new TempCtor()
      ctor.prototype.constructor = ctor
    }
  }
}


/***/ }),

/***/ 8139:
/***/ ((module) => {

// http://www.w3.org/TR/CSS21/grammar.html
// https://github.com/visionmedia/css-parse/pull/49#issuecomment-30088027
var COMMENT_REGEX = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g;

var NEWLINE_REGEX = /\n/g;
var WHITESPACE_REGEX = /^\s*/;

// declaration
var PROPERTY_REGEX = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/;
var COLON_REGEX = /^:\s*/;
var VALUE_REGEX = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/;
var SEMICOLON_REGEX = /^[;\s]*/;

// https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/String/Trim#Polyfill
var TRIM_REGEX = /^\s+|\s+$/g;

// strings
var NEWLINE = '\n';
var FORWARD_SLASH = '/';
var ASTERISK = '*';
var EMPTY_STRING = '';

// types
var TYPE_COMMENT = 'comment';
var TYPE_DECLARATION = 'declaration';

/**
 * @param {String} style
 * @param {Object} [options]
 * @return {Object[]}
 * @throws {TypeError}
 * @throws {Error}
 */
module.exports = function(style, options) {
  if (typeof style !== 'string') {
    throw new TypeError('First argument must be a string');
  }

  if (!style) return [];

  options = options || {};

  /**
   * Positional.
   */
  var lineno = 1;
  var column = 1;

  /**
   * Update lineno and column based on `str`.
   *
   * @param {String} str
   */
  function updatePosition(str) {
    var lines = str.match(NEWLINE_REGEX);
    if (lines) lineno += lines.length;
    var i = str.lastIndexOf(NEWLINE);
    column = ~i ? str.length - i : column + str.length;
  }

  /**
   * Mark position and patch `node.position`.
   *
   * @return {Function}
   */
  function position() {
    var start = { line: lineno, column: column };
    return function(node) {
      node.position = new Position(start);
      whitespace();
      return node;
    };
  }

  /**
   * Store position information for a node.
   *
   * @constructor
   * @property {Object} start
   * @property {Object} end
   * @property {undefined|String} source
   */
  function Position(start) {
    this.start = start;
    this.end = { line: lineno, column: column };
    this.source = options.source;
  }

  /**
   * Non-enumerable source string.
   */
  Position.prototype.content = style;

  var errorsList = [];

  /**
   * Error `msg`.
   *
   * @param {String} msg
   * @throws {Error}
   */
  function error(msg) {
    var err = new Error(
      options.source + ':' + lineno + ':' + column + ': ' + msg
    );
    err.reason = msg;
    err.filename = options.source;
    err.line = lineno;
    err.column = column;
    err.source = style;

    if (options.silent) {
      errorsList.push(err);
    } else {
      throw err;
    }
  }

  /**
   * Match `re` and return captures.
   *
   * @param {RegExp} re
   * @return {undefined|Array}
   */
  function match(re) {
    var m = re.exec(style);
    if (!m) return;
    var str = m[0];
    updatePosition(str);
    style = style.slice(str.length);
    return m;
  }

  /**
   * Parse whitespace.
   */
  function whitespace() {
    match(WHITESPACE_REGEX);
  }

  /**
   * Parse comments.
   *
   * @param {Object[]} [rules]
   * @return {Object[]}
   */
  function comments(rules) {
    var c;
    rules = rules || [];
    while ((c = comment())) {
      if (c !== false) {
        rules.push(c);
      }
    }
    return rules;
  }

  /**
   * Parse comment.
   *
   * @return {Object}
   * @throws {Error}
   */
  function comment() {
    var pos = position();
    if (FORWARD_SLASH != style.charAt(0) || ASTERISK != style.charAt(1)) return;

    var i = 2;
    while (
      EMPTY_STRING != style.charAt(i) &&
      (ASTERISK != style.charAt(i) || FORWARD_SLASH != style.charAt(i + 1))
    ) {
      ++i;
    }
    i += 2;

    if (EMPTY_STRING === style.charAt(i - 1)) {
      return error('End of comment missing');
    }

    var str = style.slice(2, i - 2);
    column += 2;
    updatePosition(str);
    style = style.slice(i);
    column += 2;

    return pos({
      type: TYPE_COMMENT,
      comment: str
    });
  }

  /**
   * Parse declaration.
   *
   * @return {Object}
   * @throws {Error}
   */
  function declaration() {
    var pos = position();

    // prop
    var prop = match(PROPERTY_REGEX);
    if (!prop) return;
    comment();

    // :
    if (!match(COLON_REGEX)) return error("property missing ':'");

    // val
    var val = match(VALUE_REGEX);

    var ret = pos({
      type: TYPE_DECLARATION,
      property: trim(prop[0].replace(COMMENT_REGEX, EMPTY_STRING)),
      value: val
        ? trim(val[0].replace(COMMENT_REGEX, EMPTY_STRING))
        : EMPTY_STRING
    });

    // ;
    match(SEMICOLON_REGEX);

    return ret;
  }

  /**
   * Parse declarations.
   *
   * @return {Object[]}
   */
  function declarations() {
    var decls = [];

    comments(decls);

    // declarations
    var decl;
    while ((decl = declaration())) {
      if (decl !== false) {
        decls.push(decl);
        comments(decls);
      }
    }

    return decls;
  }

  whitespace();
  return declarations();
};

/**
 * Trim `str`.
 *
 * @param {String} str
 * @return {String}
 */
function trim(str) {
  return str ? str.replace(TRIM_REGEX, EMPTY_STRING) : EMPTY_STRING;
}


/***/ }),

/***/ 6260:
/***/ ((module) => {

"use strict";


module.exports = alphabetical

// Check if the given character code, or the character code at the first
// character, is alphabetical.
function alphabetical(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character

  return (
    (code >= 97 && code <= 122) /* a-z */ ||
    (code >= 65 && code <= 90) /* A-Z */
  )
}


/***/ }),

/***/ 7504:
/***/ ((module) => {

"use strict";

module.exports = function (str) {
	if (typeof str !== 'string') {
		throw new TypeError('Expected a string');
	}

	return !/[^0-9a-z\xDF-\xFF]/.test(str.toLowerCase());
};


/***/ }),

/***/ 7961:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var alphabetical = __webpack_require__(6260)
var decimal = __webpack_require__(6195)

module.exports = alphanumerical

// Check if the given character code, or the character code at the first
// character, is alphanumerical.
function alphanumerical(character) {
  return alphabetical(character) || decimal(character)
}


/***/ }),

/***/ 8738:
/***/ ((module) => {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),

/***/ 6195:
/***/ ((module) => {

"use strict";


module.exports = decimal

// Check if the given character code, or the character code at the first
// character, is decimal.
function decimal(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character

  return code >= 48 && code <= 57 /* 0-9 */
}


/***/ }),

/***/ 9480:
/***/ ((module) => {

"use strict";


module.exports = hexadecimal

// Check if the given character code, or the character code at the first
// character, is hexadecimal.
function hexadecimal(character) {
  var code = typeof character === 'string' ? character.charCodeAt(0) : character

  return (
    (code >= 97 /* a */ && code <= 102) /* z */ ||
    (code >= 65 /* A */ && code <= 70) /* Z */ ||
    (code >= 48 /* A */ && code <= 57) /* Z */
  )
}


/***/ }),

/***/ 2139:
/***/ ((module) => {

"use strict";


module.exports = whitespace

var fromCode = String.fromCharCode
var re = /\s/

// Check if the given character code, or the character code at the first
// character, is a whitespace character.
function whitespace(character) {
  return re.test(
    typeof character === 'number' ? fromCode(character) : character.charAt(0)
  )
}


/***/ }),

/***/ 3017:
/***/ ((module) => {

"use strict";


module.exports = wordCharacter

var fromCode = String.fromCharCode
var re = /\w/

// Check if the given character code, or the character code at the first
// character, is a word character.
function wordCharacter(character) {
  return re.test(
    typeof character === 'number' ? fromCode(character) : character.charAt(0)
  )
}


/***/ }),

/***/ 8686:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match HTML entities and HTML characters. */
var reUnescapedHtml = /[&<>"'`]/g,
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

/** Used to map characters to HTML entities. */
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '`': '&#96;'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.escape` to convert characters to HTML entities.
 *
 * @private
 * @param {string} chr The matched character to escape.
 * @returns {string} Returns the escaped character.
 */
var escapeHtmlChar = basePropertyOf(htmlEscapes);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts the characters "&", "<", ">", '"', "'", and "\`" in `string` to
 * their corresponding HTML entities.
 *
 * **Note:** No other characters are escaped. To escape additional
 * characters use a third-party library like [_he_](https://mths.be/he).
 *
 * Though the ">" character is escaped for symmetry, characters like
 * ">" and "/" don't need escaping in HTML and have no special meaning
 * unless they're part of a tag or unquoted attribute value. See
 * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
 * (under "semi-related fun fact") for more details.
 *
 * Backticks are escaped because in IE < 9, they can break out of
 * attribute values or HTML comments. See [#59](https://html5sec.org/#59),
 * [#102](https://html5sec.org/#102), [#108](https://html5sec.org/#108), and
 * [#133](https://html5sec.org/#133) of the
 * [HTML5 Security Cheatsheet](https://html5sec.org/) for more details.
 *
 * When working with HTML you should always
 * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
 * XSS vectors.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category String
 * @param {string} [string=''] The string to escape.
 * @returns {string} Returns the escaped string.
 * @example
 *
 * _.escape('fred, barney, & pebbles');
 * // => 'fred, barney, &amp; pebbles'
 */
function escape(string) {
  string = toString(string);
  return (string && reHasUnescapedHtml.test(string))
    ? string.replace(reUnescapedHtml, escapeHtmlChar)
    : string;
}

module.exports = escape;


/***/ }),

/***/ 5683:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f\\ufe20-\\ufe23',
    rsComboSymbolsRange = '\\u20d0-\\u20f0',
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboMarksRange + rsComboSymbolsRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsLowerMisc = '(?:' + rsLower + '|' + rsMisc + ')',
    rsUpperMisc = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptLowerContr = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptUpperContr = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptLowerContr + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsUpperMisc + '+' + rsOptUpperContr + '(?=' + [rsBreak, rsUpper + rsLowerMisc, '$'].join('|') + ')',
  rsUpper + '?' + rsLowerMisc + '+' + rsOptLowerContr,
  rsUpper + '+' + rsOptUpperContr,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 'ss'
};

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

/**
 * Converts `string` to
 * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the kebab cased string.
 * @example
 *
 * _.kebabCase('Foo Bar');
 * // => 'foo-bar'
 *
 * _.kebabCase('fooBar');
 * // => 'foo-bar'
 *
 * _.kebabCase('__FOO_BAR__');
 * // => 'foo-bar'
 */
var kebabCase = createCompounder(function(result, word, index) {
  return result + (index ? '-' : '') + word.toLowerCase();
});

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = kebabCase;


/***/ }),

/***/ 2491:
/***/ ((module) => {

"use strict";


module.exports = longestStreak

// Get the count of the longest repeating streak of `character` in `value`.
function longestStreak(value, character) {
  var count = 0
  var maximum = 0
  var expected
  var index

  if (typeof character !== 'string' || character.length !== 1) {
    throw new Error('Expected character')
  }

  value = String(value)
  index = value.indexOf(character)
  expected = index

  while (index !== -1) {
    count++

    if (index === expected) {
      if (count > maximum) {
        maximum = count
      }
    } else {
      count = 1
    }

    expected = index + 1
    index = value.indexOf(character, expected)
  }

  return maximum
}


/***/ }),

/***/ 2123:
/***/ ((module) => {

"use strict";


module.exports = escapes

var defaults = [
  '\\',
  '`',
  '*',
  '{',
  '}',
  '[',
  ']',
  '(',
  ')',
  '#',
  '+',
  '-',
  '.',
  '!',
  '_',
  '>'
]

var gfm = defaults.concat(['~', '|'])

var commonmark = gfm.concat([
  '\n',
  '"',
  '$',
  '%',
  '&',
  "'",
  ',',
  '/',
  ':',
  ';',
  '<',
  '=',
  '?',
  '@',
  '^'
])

escapes.default = defaults
escapes.gfm = gfm
escapes.commonmark = commonmark

// Get markdown escapes.
function escapes(options) {
  var settings = options || {}

  if (settings.commonmark) {
    return commonmark
  }

  return settings.gfm ? gfm : defaults
}


/***/ }),

/***/ 8234:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var repeat = __webpack_require__(6464)

module.exports = markdownTable

var trailingWhitespace = / +$/

// Characters.
var space = ' '
var lineFeed = '\n'
var dash = '-'
var colon = ':'
var verticalBar = '|'

var x = 0
var C = 67
var L = 76
var R = 82
var c = 99
var l = 108
var r = 114

// Create a table from a matrix of strings.
function markdownTable(table, options) {
  var settings = options || {}
  var padding = settings.padding !== false
  var start = settings.delimiterStart !== false
  var end = settings.delimiterEnd !== false
  var align = (settings.align || []).concat()
  var alignDelimiters = settings.alignDelimiters !== false
  var alignments = []
  var stringLength = settings.stringLength || defaultStringLength
  var rowIndex = -1
  var rowLength = table.length
  var cellMatrix = []
  var sizeMatrix = []
  var row = []
  var sizes = []
  var longestCellByColumn = []
  var mostCellsPerRow = 0
  var cells
  var columnIndex
  var columnLength
  var largest
  var size
  var cell
  var lines
  var line
  var before
  var after
  var code

  // This is a superfluous loop if we don’t align delimiters, but otherwise we’d
  // do superfluous work when aligning, so optimize for aligning.
  while (++rowIndex < rowLength) {
    cells = table[rowIndex]
    columnIndex = -1
    columnLength = cells.length
    row = []
    sizes = []

    if (columnLength > mostCellsPerRow) {
      mostCellsPerRow = columnLength
    }

    while (++columnIndex < columnLength) {
      cell = serialize(cells[columnIndex])

      if (alignDelimiters === true) {
        size = stringLength(cell)
        sizes[columnIndex] = size

        largest = longestCellByColumn[columnIndex]

        if (largest === undefined || size > largest) {
          longestCellByColumn[columnIndex] = size
        }
      }

      row.push(cell)
    }

    cellMatrix[rowIndex] = row
    sizeMatrix[rowIndex] = sizes
  }

  // Figure out which alignments to use.
  columnIndex = -1
  columnLength = mostCellsPerRow

  if (typeof align === 'object' && 'length' in align) {
    while (++columnIndex < columnLength) {
      alignments[columnIndex] = toAlignment(align[columnIndex])
    }
  } else {
    code = toAlignment(align)

    while (++columnIndex < columnLength) {
      alignments[columnIndex] = code
    }
  }

  // Inject the alignment row.
  columnIndex = -1
  columnLength = mostCellsPerRow
  row = []
  sizes = []

  while (++columnIndex < columnLength) {
    code = alignments[columnIndex]
    before = ''
    after = ''

    if (code === l) {
      before = colon
    } else if (code === r) {
      after = colon
    } else if (code === c) {
      before = colon
      after = colon
    }

    // There *must* be at least one hyphen-minus in each alignment cell.
    size = alignDelimiters
      ? Math.max(
          1,
          longestCellByColumn[columnIndex] - before.length - after.length
        )
      : 1

    cell = before + repeat(dash, size) + after

    if (alignDelimiters === true) {
      size = before.length + size + after.length

      if (size > longestCellByColumn[columnIndex]) {
        longestCellByColumn[columnIndex] = size
      }

      sizes[columnIndex] = size
    }

    row[columnIndex] = cell
  }

  // Inject the alignment row.
  cellMatrix.splice(1, 0, row)
  sizeMatrix.splice(1, 0, sizes)

  rowIndex = -1
  rowLength = cellMatrix.length
  lines = []

  while (++rowIndex < rowLength) {
    row = cellMatrix[rowIndex]
    sizes = sizeMatrix[rowIndex]
    columnIndex = -1
    columnLength = mostCellsPerRow
    line = []

    while (++columnIndex < columnLength) {
      cell = row[columnIndex] || ''
      before = ''
      after = ''

      if (alignDelimiters === true) {
        size = longestCellByColumn[columnIndex] - (sizes[columnIndex] || 0)
        code = alignments[columnIndex]

        if (code === r) {
          before = repeat(space, size)
        } else if (code === c) {
          if (size % 2 === 0) {
            before = repeat(space, size / 2)
            after = before
          } else {
            before = repeat(space, size / 2 + 0.5)
            after = repeat(space, size / 2 - 0.5)
          }
        } else {
          after = repeat(space, size)
        }
      }

      if (start === true && columnIndex === 0) {
        line.push(verticalBar)
      }

      if (
        padding === true &&
        // Don’t add the opening space if we’re not aligning and the cell is
        // empty: there will be a closing space.
        !(alignDelimiters === false && cell === '') &&
        (start === true || columnIndex !== 0)
      ) {
        line.push(space)
      }

      if (alignDelimiters === true) {
        line.push(before)
      }

      line.push(cell)

      if (alignDelimiters === true) {
        line.push(after)
      }

      if (padding === true) {
        line.push(space)
      }

      if (end === true || columnIndex !== columnLength - 1) {
        line.push(verticalBar)
      }
    }

    line = line.join('')

    if (end === false) {
      line = line.replace(trailingWhitespace, '')
    }

    lines.push(line)
  }

  return lines.join(lineFeed)
}

function serialize(value) {
  return value === null || value === undefined ? '' : String(value)
}

function defaultStringLength(value) {
  return value.length
}

function toAlignment(value) {
  var code = typeof value === 'string' ? value.charCodeAt(0) : x

  return code === L || code === l
    ? l
    : code === R || code === r
    ? r
    : code === C || code === c
    ? c
    : x
}


/***/ }),

/***/ 4245:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var visit = __webpack_require__(2854)

module.exports = compact

// Make an mdast tree compact by merging adjacent text nodes.
function compact(tree, commonmark) {
  visit(tree, visitor)

  return tree

  function visitor(child, index, parent) {
    var siblings = parent ? parent.children : []
    var prev = index && siblings[index - 1]

    if (
      prev &&
      child.type === prev.type &&
      mergeable(prev, commonmark) &&
      mergeable(child, commonmark)
    ) {
      if (child.value) {
        prev.value += child.value
      }

      if (child.children) {
        prev.children = prev.children.concat(child.children)
      }

      siblings.splice(index, 1)

      if (prev.position && child.position) {
        prev.position.end = child.position.end
      }

      return index
    }
  }
}

function mergeable(node, commonmark) {
  var start
  var end

  if (node.type === 'text') {
    if (!node.position) {
      return true
    }

    start = node.position.start
    end = node.position.end

    // Only merge nodes which occupy the same size as their `value`.
    return (
      start.line !== end.line || end.column - start.column === node.value.length
    )
  }

  return commonmark && node.type === 'blockquote'
}


/***/ }),

/***/ 6630:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var visit = __webpack_require__(2854)

module.exports = getDefinitionFactory

var own = {}.hasOwnProperty

// Get a definition in `node` by `identifier`.
function getDefinitionFactory(node, options) {
  return getterFactory(gather(node, options))
}

// Gather all definitions in `node`
function gather(node, options) {
  var cache = {}

  if (!node || !node.type) {
    throw new Error('mdast-util-definitions expected node')
  }

  visit(node, 'definition', options && options.commonmark ? commonmark : normal)

  return cache

  function commonmark(definition) {
    var id = normalise(definition.identifier)
    if (!own.call(cache, id)) {
      cache[id] = definition
    }
  }

  function normal(definition) {
    cache[normalise(definition.identifier)] = definition
  }
}

// Factory to get a node from the given definition-cache.
function getterFactory(cache) {
  return getter

  // Get a node from the bound definition-cache.
  function getter(identifier) {
    var id = identifier && normalise(identifier)
    return id && own.call(cache, id) ? cache[id] : null
  }
}

function normalise(identifier) {
  return identifier.toUpperCase()
}


/***/ }),

/***/ 5288:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(1601)


/***/ }),

/***/ 5426:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = all

var one = __webpack_require__(719)

function all(h, parent) {
  var nodes = parent.children || []
  var length = nodes.length
  var values = []
  var index = -1
  var result
  var head

  while (++index < length) {
    result = one(h, nodes[index], parent)

    if (result) {
      if (index && nodes[index - 1].type === 'break') {
        if (result.value) {
          result.value = result.value.replace(/^\s+/, '')
        }

        head = result.children && result.children[0]

        if (head && head.value) {
          head.value = head.value.replace(/^\s+/, '')
        }
      }

      values = values.concat(result)
    }
  }

  return values
}


/***/ }),

/***/ 1696:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = generateFootnotes

var thematicBreak = __webpack_require__(7552)
var list = __webpack_require__(7888)
var wrap = __webpack_require__(6115)

function generateFootnotes(h) {
  var footnoteById = h.footnoteById
  var footnoteOrder = h.footnoteOrder
  var length = footnoteOrder.length
  var index = -1
  var listItems = []
  var def
  var backReference
  var content
  var tail

  while (++index < length) {
    def = footnoteById[footnoteOrder[index].toUpperCase()]

    if (!def) {
      continue
    }

    content = def.children.concat()
    tail = content[content.length - 1]
    backReference = {
      type: 'link',
      url: '#fnref-' + def.identifier,
      data: {hProperties: {className: ['footnote-backref']}},
      children: [{type: 'text', value: '↩'}]
    }

    if (!tail || tail.type !== 'paragraph') {
      tail = {type: 'paragraph', children: []}
      content.push(tail)
    }

    tail.children.push(backReference)

    listItems.push({
      type: 'listItem',
      data: {hProperties: {id: 'fn-' + def.identifier}},
      children: content,
      position: def.position
    })
  }

  if (listItems.length === 0) {
    return null
  }

  return h(
    null,
    'div',
    {className: ['footnotes']},
    wrap(
      [
        thematicBreak(h),
        list(h, {type: 'list', ordered: true, children: listItems})
      ],
      true
    )
  )
}


/***/ }),

/***/ 4590:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = blockquote

var wrap = __webpack_require__(6115)
var all = __webpack_require__(5426)

function blockquote(h, node) {
  return h(node, 'blockquote', wrap(all(h, node), true))
}


/***/ }),

/***/ 3562:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = hardBreak

var u = __webpack_require__(914)

function hardBreak(h, node) {
  return [h(node, 'br'), u('text', '\n')]
}


/***/ }),

/***/ 7891:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = code

var detab = __webpack_require__(3128)
var u = __webpack_require__(914)

function code(h, node) {
  var value = node.value ? detab(node.value + '\n') : ''
  var lang = node.lang && node.lang.match(/^[^ \t]+(?=[ \t]|$)/)
  var props = {}

  if (lang) {
    props.className = ['language-' + lang]
  }

  return h(node.position, 'pre', [h(node, 'code', props, [u('text', value)])])
}


/***/ }),

/***/ 9381:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = strikethrough

var all = __webpack_require__(5426)

function strikethrough(h, node) {
  return h(node, 'del', all(h, node))
}


/***/ }),

/***/ 790:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = emphasis

var all = __webpack_require__(5426)

function emphasis(h, node) {
  return h(node, 'em', all(h, node))
}


/***/ }),

/***/ 8235:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = footnoteReference

var u = __webpack_require__(914)

function footnoteReference(h, node) {
  var footnoteOrder = h.footnoteOrder
  var identifier = String(node.identifier)

  if (footnoteOrder.indexOf(identifier) === -1) {
    footnoteOrder.push(identifier)
  }

  return h(node.position, 'sup', {id: 'fnref-' + identifier}, [
    h(node, 'a', {href: '#fn-' + identifier, className: ['footnote-ref']}, [
      u('text', node.label || identifier)
    ])
  ])
}


/***/ }),

/***/ 3208:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = footnote

var footnoteReference = __webpack_require__(8235)

function footnote(h, node) {
  var footnoteById = h.footnoteById
  var footnoteOrder = h.footnoteOrder
  var identifier = 1

  while (identifier in footnoteById) {
    identifier++
  }

  identifier = String(identifier)

  // No need to check if `identifier` exists in `footnoteOrder`, it’s guaranteed
  // to not exist because we just generated it.
  footnoteOrder.push(identifier)

  footnoteById[identifier] = {
    type: 'footnoteDefinition',
    identifier: identifier,
    children: [{type: 'paragraph', children: node.children}],
    position: node.position
  }

  return footnoteReference(h, {
    type: 'footnoteReference',
    identifier: identifier,
    position: node.position
  })
}


/***/ }),

/***/ 4890:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = heading

var all = __webpack_require__(5426)

function heading(h, node) {
  return h(node, 'h' + node.depth, all(h, node))
}


/***/ }),

/***/ 2202:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = html

var u = __webpack_require__(914)

// Return either a `raw` node in dangerous mode, otherwise nothing.
function html(h, node) {
  return h.dangerous ? h.augment(node, u('raw', node.value)) : null
}


/***/ }),

/***/ 1454:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = imageReference

var normalize = __webpack_require__(729)
var revert = __webpack_require__(713)

function imageReference(h, node) {
  var def = h.definition(node.identifier)
  var props

  if (!def) {
    return revert(h, node)
  }

  props = {src: normalize(def.url || ''), alt: node.alt}

  if (def.title !== null && def.title !== undefined) {
    props.title = def.title
  }

  return h(node, 'img', props)
}


/***/ }),

/***/ 5037:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var normalize = __webpack_require__(729)

module.exports = image

function image(h, node) {
  var props = {src: normalize(node.url), alt: node.alt}

  if (node.title !== null && node.title !== undefined) {
    props.title = node.title
  }

  return h(node, 'img', props)
}


/***/ }),

/***/ 4617:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = {
  blockquote: __webpack_require__(4590),
  break: __webpack_require__(3562),
  code: __webpack_require__(7891),
  delete: __webpack_require__(9381),
  emphasis: __webpack_require__(790),
  footnoteReference: __webpack_require__(8235),
  footnote: __webpack_require__(3208),
  heading: __webpack_require__(4890),
  html: __webpack_require__(2202),
  imageReference: __webpack_require__(1454),
  image: __webpack_require__(5037),
  inlineCode: __webpack_require__(8409),
  linkReference: __webpack_require__(9266),
  link: __webpack_require__(404),
  listItem: __webpack_require__(4463),
  list: __webpack_require__(7888),
  paragraph: __webpack_require__(8346),
  root: __webpack_require__(8100),
  strong: __webpack_require__(4970),
  table: __webpack_require__(2605),
  text: __webpack_require__(989),
  thematicBreak: __webpack_require__(7552),
  toml: ignore,
  yaml: ignore,
  definition: ignore,
  footnoteDefinition: ignore
}

// Return nothing for nodes that are ignored.
function ignore() {
  return null
}


/***/ }),

/***/ 8409:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = inlineCode

var collapse = __webpack_require__(9357)
var u = __webpack_require__(914)

function inlineCode(h, node) {
  return h(node, 'code', [u('text', collapse(node.value))])
}


/***/ }),

/***/ 9266:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = linkReference

var normalize = __webpack_require__(729)
var revert = __webpack_require__(713)
var all = __webpack_require__(5426)

function linkReference(h, node) {
  var def = h.definition(node.identifier)
  var props

  if (!def) {
    return revert(h, node)
  }

  props = {href: normalize(def.url || '')}

  if (def.title !== null && def.title !== undefined) {
    props.title = def.title
  }

  return h(node, 'a', props, all(h, node))
}


/***/ }),

/***/ 404:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var normalize = __webpack_require__(729)
var all = __webpack_require__(5426)

module.exports = link

function link(h, node) {
  var props = {href: normalize(node.url)}

  if (node.title !== null && node.title !== undefined) {
    props.title = node.title
  }

  return h(node, 'a', props, all(h, node))
}


/***/ }),

/***/ 4463:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = listItem

var u = __webpack_require__(914)
var wrap = __webpack_require__(6115)
var all = __webpack_require__(5426)

function listItem(h, node, parent) {
  var children = node.children
  var head = children[0]
  var raw = all(h, node)
  var loose = parent ? listLoose(parent) : listItemLoose(node)
  var props = {}
  var result
  var container
  var index
  var length
  var child

  // Tight lists should not render `paragraph` nodes as `p` elements.
  if (loose) {
    result = raw
  } else {
    result = []
    length = raw.length
    index = -1

    while (++index < length) {
      child = raw[index]

      if (child.tagName === 'p') {
        result = result.concat(child.children)
      } else {
        result.push(child)
      }
    }
  }

  if (typeof node.checked === 'boolean') {
    if (loose && (!head || head.type !== 'paragraph')) {
      result.unshift(h(null, 'p', []))
    }

    container = loose ? result[0].children : result

    if (container.length !== 0) {
      container.unshift(u('text', ' '))
    }

    container.unshift(
      h(null, 'input', {
        type: 'checkbox',
        checked: node.checked,
        disabled: true
      })
    )

    // According to github-markdown-css, this class hides bullet.
    // See: <https://github.com/sindresorhus/github-markdown-css>.
    props.className = ['task-list-item']
  }

  if (loose && result.length !== 0) {
    result = wrap(result, true)
  }

  return h(node, 'li', props, result)
}

function listLoose(node) {
  var loose = node.spread
  var children = node.children
  var length = children.length
  var index = -1

  while (!loose && ++index < length) {
    loose = listItemLoose(children[index])
  }

  return loose
}

function listItemLoose(node) {
  var spread = node.spread

  return spread === undefined || spread === null
    ? node.children.length > 1
    : spread
}


/***/ }),

/***/ 7888:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = list

var wrap = __webpack_require__(6115)
var all = __webpack_require__(5426)

function list(h, node) {
  var props = {}
  var name = node.ordered ? 'ol' : 'ul'
  var items
  var index = -1
  var length

  if (typeof node.start === 'number' && node.start !== 1) {
    props.start = node.start
  }

  items = all(h, node)
  length = items.length

  // Like GitHub, add a class for custom styling.
  while (++index < length) {
    if (
      items[index].properties.className &&
      items[index].properties.className.indexOf('task-list-item') !== -1
    ) {
      props.className = ['contains-task-list']
      break
    }
  }

  return h(node, name, props, wrap(items, true))
}


/***/ }),

/***/ 8346:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = paragraph

var all = __webpack_require__(5426)

function paragraph(h, node) {
  return h(node, 'p', all(h, node))
}


/***/ }),

/***/ 8100:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = root

var u = __webpack_require__(914)
var wrap = __webpack_require__(6115)
var all = __webpack_require__(5426)

function root(h, node) {
  return h.augment(node, u('root', wrap(all(h, node))))
}


/***/ }),

/***/ 4970:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = strong

var all = __webpack_require__(5426)

function strong(h, node) {
  return h(node, 'strong', all(h, node))
}


/***/ }),

/***/ 2605:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = table

var position = __webpack_require__(7361)
var wrap = __webpack_require__(6115)
var all = __webpack_require__(5426)

function table(h, node) {
  var rows = node.children
  var index = rows.length
  var align = node.align
  var alignLength = align.length
  var result = []
  var pos
  var row
  var out
  var name
  var cell

  while (index--) {
    row = rows[index].children
    name = index === 0 ? 'th' : 'td'
    pos = alignLength
    out = []

    while (pos--) {
      cell = row[pos]
      out[pos] = h(cell, name, {align: align[pos]}, cell ? all(h, cell) : [])
    }

    result[index] = h(rows[index], 'tr', wrap(out, true))
  }

  return h(
    node,
    'table',
    wrap(
      [
        h(result[0].position, 'thead', wrap([result[0]], true)),
        h(
          {
            start: position.start(result[1]),
            end: position.end(result[result.length - 1])
          },
          'tbody',
          wrap(result.slice(1), true)
        )
      ],
      true
    )
  )
}


/***/ }),

/***/ 989:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = text

var u = __webpack_require__(914)
var trimLines = __webpack_require__(6221)

function text(h, node) {
  return h.augment(node, u('text', trimLines(node.value)))
}


/***/ }),

/***/ 7552:
/***/ ((module) => {

"use strict";


module.exports = thematicBreak

function thematicBreak(h, node) {
  return h(node, 'hr')
}


/***/ }),

/***/ 1601:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = toHast

var u = __webpack_require__(914)
var visit = __webpack_require__(2854)
var position = __webpack_require__(7361)
var generated = __webpack_require__(1744)
var definitions = __webpack_require__(6630)
var one = __webpack_require__(719)
var footer = __webpack_require__(1696)
var handlers = __webpack_require__(4617)

var own = {}.hasOwnProperty

var deprecationWarningIssued = false

// Factory to transform.
function factory(tree, options) {
  var settings = options || {}

  // Issue a warning if the deprecated tag 'allowDangerousHTML' is used
  if (settings.allowDangerousHTML !== undefined && !deprecationWarningIssued) {
    deprecationWarningIssued = true
    console.warn(
      'mdast-util-to-hast: deprecation: `allowDangerousHTML` is nonstandard, use `allowDangerousHtml` instead'
    )
  }

  var dangerous = settings.allowDangerousHtml || settings.allowDangerousHTML
  var footnoteById = {}

  h.dangerous = dangerous
  h.definition = definitions(tree, settings)
  h.footnoteById = footnoteById
  h.footnoteOrder = []
  h.augment = augment
  h.handlers = Object.assign({}, handlers, settings.handlers)
  h.unknownHandler = settings.unknownHandler

  visit(tree, 'footnoteDefinition', onfootnotedefinition)

  return h

  // Finalise the created `right`, a hast node, from `left`, an mdast node.
  function augment(left, right) {
    var data
    var ctx

    // Handle `data.hName`, `data.hProperties, `data.hChildren`.
    if (left && 'data' in left) {
      data = left.data

      if (right.type === 'element' && data.hName) {
        right.tagName = data.hName
      }

      if (right.type === 'element' && data.hProperties) {
        right.properties = Object.assign({}, right.properties, data.hProperties)
      }

      if (right.children && data.hChildren) {
        right.children = data.hChildren
      }
    }

    ctx = left && left.position ? left : {position: left}

    if (!generated(ctx)) {
      right.position = {
        start: position.start(ctx),
        end: position.end(ctx)
      }
    }

    return right
  }

  // Create an element for `node`.
  function h(node, tagName, props, children) {
    if (
      (children === undefined || children === null) &&
      typeof props === 'object' &&
      'length' in props
    ) {
      children = props
      props = {}
    }

    return augment(node, {
      type: 'element',
      tagName: tagName,
      properties: props || {},
      children: children || []
    })
  }

  function onfootnotedefinition(definition) {
    var id = String(definition.identifier).toUpperCase()

    // Mimick CM behavior of link definitions.
    // See: <https://github.com/syntax-tree/mdast-util-definitions/blob/8d48e57/index.js#L26>.
    if (!own.call(footnoteById, id)) {
      footnoteById[id] = definition
    }
  }
}

// Transform `tree`, which is an mdast node, to a hast node.
function toHast(tree, options) {
  var h = factory(tree, options)
  var node = one(h, tree)
  var foot = footer(h)

  if (foot) {
    node.children = node.children.concat(u('text', '\n'), foot)
  }

  return node
}


/***/ }),

/***/ 719:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = one

var u = __webpack_require__(914)
var all = __webpack_require__(5426)

var own = {}.hasOwnProperty

// Transform an unknown node.
function unknown(h, node) {
  if (text(node)) {
    return h.augment(node, u('text', node.value))
  }

  return h(node, 'div', all(h, node))
}

// Visit a node.
function one(h, node, parent) {
  var type = node && node.type
  var fn = own.call(h.handlers, type) ? h.handlers[type] : h.unknownHandler

  // Fail on non-nodes.
  if (!type) {
    throw new Error('Expected node, got `' + node + '`')
  }

  return (typeof fn === 'function' ? fn : unknown)(h, node, parent)
}

// Check if the node should be renderered as a text node.
function text(node) {
  var data = node.data || {}

  if (
    own.call(data, 'hName') ||
    own.call(data, 'hProperties') ||
    own.call(data, 'hChildren')
  ) {
    return false
  }

  return 'value' in node
}


/***/ }),

/***/ 713:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = revert

var u = __webpack_require__(914)
var all = __webpack_require__(5426)

// Return the content of a reference without definition as Markdown.
function revert(h, node) {
  var subtype = node.referenceType
  var suffix = ']'
  var contents
  var head
  var tail

  if (subtype === 'collapsed') {
    suffix += '[]'
  } else if (subtype === 'full') {
    suffix += '[' + (node.label || node.identifier) + ']'
  }

  if (node.type === 'imageReference') {
    return u('text', '![' + node.alt + suffix)
  }

  contents = all(h, node)
  head = contents[0]

  if (head && head.type === 'text') {
    head.value = '[' + head.value
  } else {
    contents.unshift(u('text', '['))
  }

  tail = contents[contents.length - 1]

  if (tail && tail.type === 'text') {
    tail.value += suffix
  } else {
    contents.push(u('text', suffix))
  }

  return contents
}


/***/ }),

/***/ 6115:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = wrap

var u = __webpack_require__(914)

// Wrap `nodes` with line feeds between each entry.
// Optionally adds line feeds at the start and end.
function wrap(nodes, loose) {
  var result = []
  var index = -1
  var length = nodes.length

  if (loose) {
    result.push(u('text', '\n'))
  }

  while (++index < length) {
    if (index) {
      result.push(u('text', '\n'))
    }

    result.push(nodes[index])
  }

  if (loose && nodes.length !== 0) {
    result.push(u('text', '\n'))
  }

  return result
}


/***/ }),

/***/ 4999:
/***/ ((module) => {

"use strict";


module.exports = toString

// Get the text content of a node.
// Prefer the node’s plain-text fields, otherwise serialize its children,
// and if the given value is an array, serialize the nodes in it.
function toString(node) {
  return (
    (node &&
      (node.value ||
        node.alt ||
        node.title ||
        ('children' in node && all(node.children)) ||
        ('length' in node && all(node)))) ||
    ''
  )
}

function all(values) {
  var result = []
  var length = values.length
  var index = -1

  while (++index < length) {
    result[index] = toString(values[index])
  }

  return result.join('')
}


/***/ }),

/***/ 3263:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = __webpack_require__(4212)


/***/ }),

/***/ 4369:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var extend = __webpack_require__(4470)

module.exports = contents

// Transform a list of heading objects to a markdown list.
function contents(map, tight, prefix, ordered) {
  var table = {type: 'list', ordered: ordered, spread: false, children: []}
  var minDepth = Infinity
  var index = -1

  // Find minimum depth.
  while (++index < map.length) {
    if (map[index].depth < minDepth) {
      minDepth = map[index].depth
    }
  }

  // Normalize depth.
  index = -1

  while (++index < map.length) {
    map[index].depth -= minDepth - 1
  }

  // Add TOC to list.
  index = -1

  while (++index < map.length) {
    insert(map[index], table, tight, prefix, ordered)
  }

  return table
}

// Insert an entry into `parent`.
function insert(entry, parent, tight, prefix, ordered) {
  var siblings = parent.children
  var tail = siblings[siblings.length - 1]
  var index = -1
  var item

  if (entry.depth === 1) {
    siblings.push({
      type: 'listItem',
      spread: false,
      children: [
        {
          type: 'paragraph',
          children: [
            {
              type: 'link',
              title: null,
              url: '#' + (prefix || '') + entry.id,
              children: all(entry.children)
            }
          ]
        }
      ]
    })
  } else if (tail && tail.type === 'listItem') {
    insert(entry, siblings[siblings.length - 1], tight, prefix, ordered)
  } else if (tail && tail.type === 'list') {
    entry.depth--
    insert(entry, tail, tight, prefix, ordered)
  } else if (parent.type === 'list') {
    item = {type: 'listItem', spread: false, children: []}
    siblings.push(item)
    insert(entry, item, tight, prefix, ordered)
  } else {
    item = {
      type: 'list',
      ordered: ordered,
      spread: false,
      children: []
    }
    siblings.push(item)
    entry.depth--
    insert(entry, item, tight, prefix, ordered)
  }

  if (parent.type === 'list' && !tight) {
    parent.spread = false

    while (++index < siblings.length) {
      if (siblings[index].children.length > 1) {
        parent.spread = true
        break
      }
    }
  } else {
    parent.spread = !tight
  }
}

function all(children) {
  var result = []
  var index = -1

  if (children) {
    while (++index < children.length) {
      result = result.concat(one(children[index]))
    }
  }

  return result
}

function one(node) {
  var copy

  if (
    node.type === 'link' ||
    node.type === 'linkReference' ||
    node.type === 'footnote' ||
    node.type === 'footnoteReference'
  ) {
    return all(node.children)
  }

  copy = extend({}, node)

  delete copy.children
  delete copy.position

  copy = extend(true, {}, copy)

  if (node.children) {
    copy.children = all(node.children)
  }

  return copy
}


/***/ }),

/***/ 4212:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = toc

var search = __webpack_require__(5910)
var contents = __webpack_require__(4369)
var toExpression = __webpack_require__(6039)

// Get a TOC representation of `node`.
function toc(node, options) {
  var settings = options || {}
  var heading = settings.heading ? toExpression(settings.heading) : null
  var result = search(node, heading, settings)

  result.map = result.map.length
    ? contents(
        result.map,
        settings.tight,
        settings.prefix,
        settings.ordered || false
      )
    : null

  // No given heading.
  if (!heading) {
    result.endIndex = result.index = null
  }

  return result
}


/***/ }),

/***/ 5910:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = search

var toString = __webpack_require__(8161)
var visit = __webpack_require__(2854)
var convert = __webpack_require__(6351)
var slugs = __webpack_require__(9671)()
var toExpression = __webpack_require__(6039)

// Search a node for a location.
function search(root, expression, settings) {
  var skip = settings.skip && toExpression(settings.skip)
  var parents = convert(settings.parents || root)
  var map = []
  var index
  var endIndex
  var opening

  slugs.reset()

  // Visit all headings in `root`.  We `slug` all headings (to account for
  // duplicates), but only create a TOC from top-level headings.
  visit(root, 'heading', onheading)

  return {
    index: index || -1,
    endIndex: index ? endIndex || root.children.length : -1,
    map: map
  }

  function onheading(node, position, parent) {
    var value = toString(node)
    /* istanbul ignore next - to do: remove this when `remark-attr` is up to
     * date w/ micromark. */
    var id = node.data && node.data.hProperties && node.data.hProperties.id
    var slug = slugs.slug(id || value)

    if (!parents(parent)) {
      return
    }

    // Our opening heading.
    if (expression && !index && expression.test(value)) {
      index = position + 1
      opening = node
      return
    }

    // Our closing heading.
    if (opening && !endIndex && node.depth <= opening.depth) {
      endIndex = position
    }

    // A non-empty heading after the closing (if we were looking for one).
    if (
      value &&
      (endIndex || !expression) &&
      (!settings.maxDepth || node.depth <= settings.maxDepth) &&
      (!skip || !skip.test(value))
    ) {
      map.push({depth: node.depth, children: node.children, id: slug})
    }
  }
}


/***/ }),

/***/ 6039:
/***/ ((module) => {

"use strict";


module.exports = toExpression

// Transform a string into an applicable expression.
function toExpression(value) {
  return new RegExp('^(' + value + ')$', 'i')
}


/***/ }),

/***/ 8161:
/***/ ((module) => {

"use strict";


module.exports = toString

// Get the text content of a node.
// Prefer the node’s plain-text fields, otherwise serialize its children,
// and if the given value is an array, serialize the nodes in it.
function toString(node) {
  return (
    (node &&
      (node.value ||
        node.alt ||
        node.title ||
        ('children' in node && all(node.children)) ||
        ('length' in node && all(node)))) ||
    ''
  )
}

function all(values) {
  var result = []
  var index = -1

  while (++index < values.length) {
    result[index] = toString(values[index])
  }

  return result.join('')
}


/***/ }),

/***/ 6351:
/***/ ((module) => {

"use strict";


module.exports = convert

function convert(test) {
  if (test == null) {
    return ok
  }

  if (typeof test === 'string') {
    return typeFactory(test)
  }

  if (typeof test === 'object') {
    return 'length' in test ? anyFactory(test) : allFactory(test)
  }

  if (typeof test === 'function') {
    return test
  }

  throw new Error('Expected function, string, or object as test')
}

// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function allFactory(test) {
  return all

  function all(node) {
    var key

    for (key in test) {
      if (node[key] !== test[key]) return false
    }

    return true
  }
}

function anyFactory(tests) {
  var checks = []
  var index = -1

  while (++index < tests.length) {
    checks[index] = convert(tests[index])
  }

  return any

  function any() {
    var index = -1

    while (++index < checks.length) {
      if (checks[index].apply(this, arguments)) {
        return true
      }
    }

    return false
  }
}

// Utility to convert a string into a function which checks a given node’s type
// for said string.
function typeFactory(test) {
  return type

  function type(node) {
    return Boolean(node && node.type === test)
  }
}

// Utility to return true.
function ok() {
  return true
}


/***/ }),

/***/ 729:
/***/ ((module) => {

"use strict";




var encodeCache = {};


// Create a lookup array where anything but characters in `chars` string
// and alphanumeric chars is percent-encoded.
//
function getEncodeCache(exclude) {
  var i, ch, cache = encodeCache[exclude];
  if (cache) { return cache; }

  cache = encodeCache[exclude] = [];

  for (i = 0; i < 128; i++) {
    ch = String.fromCharCode(i);

    if (/^[0-9a-z]$/i.test(ch)) {
      // always allow unencoded alphanumeric characters
      cache.push(ch);
    } else {
      cache.push('%' + ('0' + i.toString(16).toUpperCase()).slice(-2));
    }
  }

  for (i = 0; i < exclude.length; i++) {
    cache[exclude.charCodeAt(i)] = exclude[i];
  }

  return cache;
}


// Encode unsafe characters with percent-encoding, skipping already
// encoded sequences.
//
//  - string       - string to encode
//  - exclude      - list of characters to ignore (in addition to a-zA-Z0-9)
//  - keepEscaped  - don't encode '%' in a correct escape sequence (default: true)
//
function encode(string, exclude, keepEscaped) {
  var i, l, code, nextCode, cache,
      result = '';

  if (typeof exclude !== 'string') {
    // encode(string, keepEscaped)
    keepEscaped  = exclude;
    exclude = encode.defaultChars;
  }

  if (typeof keepEscaped === 'undefined') {
    keepEscaped = true;
  }

  cache = getEncodeCache(exclude);

  for (i = 0, l = string.length; i < l; i++) {
    code = string.charCodeAt(i);

    if (keepEscaped && code === 0x25 /* % */ && i + 2 < l) {
      if (/^[0-9a-f]{2}$/i.test(string.slice(i + 1, i + 3))) {
        result += string.slice(i, i + 3);
        i += 2;
        continue;
      }
    }

    if (code < 128) {
      result += cache[code];
      continue;
    }

    if (code >= 0xD800 && code <= 0xDFFF) {
      if (code >= 0xD800 && code <= 0xDBFF && i + 1 < l) {
        nextCode = string.charCodeAt(i + 1);
        if (nextCode >= 0xDC00 && nextCode <= 0xDFFF) {
          result += encodeURIComponent(string[i] + string[i + 1]);
          i++;
          continue;
        }
      }
      result += '%EF%BF%BD';
      continue;
    }

    result += encodeURIComponent(string[i]);
  }

  return result;
}

encode.defaultChars   = ";/?:@&=+$,-_.!~*'()#";
encode.componentChars = "-_.!~*'()";


module.exports = encode;


/***/ }),

/***/ 2787:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ 9769:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.compile = void 0;
var boolbase_1 = __webpack_require__(1073);
/**
 * Returns a function that checks if an elements index matches the given rule
 * highly optimized to return the fastest solution.
 *
 * @param parsed A tuple [a, b], as returned by `parse`.
 * @returns A highly optimized function that returns whether an index matches the nth-check.
 * @example
 * const check = nthCheck.compile([2, 3]);
 *
 * check(0); // `false`
 * check(1); // `false`
 * check(2); // `true`
 * check(3); // `false`
 * check(4); // `true`
 * check(5); // `false`
 * check(6); // `true`
 */
function compile(parsed) {
    var a = parsed[0];
    // Subtract 1 from `b`, to convert from one- to zero-indexed.
    var b = parsed[1] - 1;
    /*
     * When `b <= 0`, `a * n` won't be lead to any matches for `a < 0`.
     * Besides, the specification states that no elements are
     * matched when `a` and `b` are 0.
     *
     * `b < 0` here as we subtracted 1 from `b` above.
     */
    if (b < 0 && a <= 0)
        return boolbase_1.falseFunc;
    // When `a` is in the range -1..1, it matches any element (so only `b` is checked).
    if (a === -1)
        return function (index) { return index <= b; };
    if (a === 0)
        return function (index) { return index === b; };
    // When `b <= 0` and `a === 1`, they match any element.
    if (a === 1)
        return b < 0 ? boolbase_1.trueFunc : function (index) { return index >= b; };
    /*
     * Otherwise, modulo can be used to check if there is a match.
     *
     * Modulo doesn't care about the sign, so let's use `a`s absolute value.
     */
    var absA = Math.abs(a);
    // Get `b mod a`, + a if this is negative.
    var bMod = ((b % absA) + absA) % absA;
    return a > 1
        ? function (index) { return index >= b && index % absA === bMod; }
        : function (index) { return index <= b && index % absA === bMod; };
}
exports.compile = compile;


/***/ }),

/***/ 7540:
/***/ ((__unused_webpack_module, exports, __webpack_require__) => {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
__webpack_unused_export__ = __webpack_unused_export__ = void 0;
var parse_1 = __webpack_require__(7766);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return parse_1.parse; } });
var compile_1 = __webpack_require__(9769);
__webpack_unused_export__ = ({ enumerable: true, get: function () { return compile_1.compile; } });
/**
 * Parses and compiles a formula to a highly optimized function.
 * Combination of `parse` and `compile`.
 *
 * If the formula doesn't match any elements,
 * it returns [`boolbase`](https://github.com/fb55/boolbase)'s `falseFunc`.
 * Otherwise, a function accepting an _index_ is returned, which returns
 * whether or not the passed _index_ matches the formula.
 *
 * Note: The nth-rule starts counting at `1`, the returned function at `0`.
 *
 * @param formula The formula to compile.
 * @example
 * const check = nthCheck("2n+3");
 *
 * check(0); // `false`
 * check(1); // `false`
 * check(2); // `true`
 * check(3); // `false`
 * check(4); // `true`
 * check(5); // `false`
 * check(6); // `true`
 */
function nthCheck(formula) {
    return (0, compile_1.compile)((0, parse_1.parse)(formula));
}
exports.ZP = nthCheck;


/***/ }),

/***/ 7766:
/***/ ((__unused_webpack_module, exports) => {

"use strict";

// Following http://www.w3.org/TR/css3-selectors/#nth-child-pseudo
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.parse = void 0;
// Whitespace as per https://www.w3.org/TR/selectors-3/#lex is " \t\r\n\f"
var whitespace = new Set([9, 10, 12, 13, 32]);
var ZERO = "0".charCodeAt(0);
var NINE = "9".charCodeAt(0);
/**
 * Parses an expression.
 *
 * @throws An `Error` if parsing fails.
 * @returns An array containing the integer step size and the integer offset of the nth rule.
 * @example nthCheck.parse("2n+3"); // returns [2, 3]
 */
function parse(formula) {
    formula = formula.trim().toLowerCase();
    if (formula === "even") {
        return [2, 0];
    }
    else if (formula === "odd") {
        return [2, 1];
    }
    // Parse [ ['-'|'+']? INTEGER? {N} [ S* ['-'|'+'] S* INTEGER ]?
    var idx = 0;
    var a = 0;
    var sign = readSign();
    var number = readNumber();
    if (idx < formula.length && formula.charAt(idx) === "n") {
        idx++;
        a = sign * (number !== null && number !== void 0 ? number : 1);
        skipWhitespace();
        if (idx < formula.length) {
            sign = readSign();
            skipWhitespace();
            number = readNumber();
        }
        else {
            sign = number = 0;
        }
    }
    // Throw if there is anything else
    if (number === null || idx < formula.length) {
        throw new Error("n-th rule couldn't be parsed ('" + formula + "')");
    }
    return [a, sign * number];
    function readSign() {
        if (formula.charAt(idx) === "-") {
            idx++;
            return -1;
        }
        if (formula.charAt(idx) === "+") {
            idx++;
        }
        return 1;
    }
    function readNumber() {
        var start = idx;
        var value = 0;
        while (idx < formula.length &&
            formula.charCodeAt(idx) >= ZERO &&
            formula.charCodeAt(idx) <= NINE) {
            value = value * 10 + (formula.charCodeAt(idx) - ZERO);
            idx++;
        }
        // Return `null` if we didn't read anything.
        return idx === start ? null : value;
    }
    function skipWhitespace() {
        while (idx < formula.length &&
            whitespace.has(formula.charCodeAt(idx))) {
            idx++;
        }
    }
}
exports.parse = parse;


/***/ }),

/***/ 9435:
/***/ ((module) => {

"use strict";


/* eslint-env browser */

var el

var semicolon = 59 //  ';'

module.exports = decodeEntity

function decodeEntity(characters) {
  var entity = '&' + characters + ';'
  var char

  el = el || document.createElement('i')
  el.innerHTML = entity
  char = el.textContent

  // Some entities do not require the closing semicolon (`&not` - for instance),
  // which leads to situations where parsing the assumed entity of &notit; will
  // result in the string `¬it;`.  When we encounter a trailing semicolon after
  // parsing and the entity to decode was not a semicolon (`&semi;`), we can
  // assume that the matching was incomplete
  if (char.charCodeAt(char.length - 1) === semicolon && characters !== 'semi') {
    return false
  }

  // If the decoded string is equal to the input, the entity was not valid
  return char === entity ? false : char
}


/***/ }),

/***/ 7574:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var legacy = __webpack_require__(7452)
var invalid = __webpack_require__(3580)
var decimal = __webpack_require__(6195)
var hexadecimal = __webpack_require__(9480)
var alphanumerical = __webpack_require__(7961)
var decodeEntity = __webpack_require__(9435)

module.exports = parseEntities

var own = {}.hasOwnProperty
var fromCharCode = String.fromCharCode
var noop = Function.prototype

// Default settings.
var defaults = {
  warning: null,
  reference: null,
  text: null,
  warningContext: null,
  referenceContext: null,
  textContext: null,
  position: {},
  additional: null,
  attribute: false,
  nonTerminated: true
}

// Characters.
var tab = 9 // '\t'
var lineFeed = 10 // '\n'
var formFeed = 12 //  '\f'
var space = 32 // ' '
var ampersand = 38 //  '&'
var semicolon = 59 //  ';'
var lessThan = 60 //  '<'
var equalsTo = 61 //  '='
var numberSign = 35 //  '#'
var uppercaseX = 88 //  'X'
var lowercaseX = 120 //  'x'
var replacementCharacter = 65533 // '�'

// Reference types.
var name = 'named'
var hexa = 'hexadecimal'
var deci = 'decimal'

// Map of bases.
var bases = {}

bases[hexa] = 16
bases[deci] = 10

// Map of types to tests.
// Each type of character reference accepts different characters.
// This test is used to detect whether a reference has ended (as the semicolon
// is not strictly needed).
var tests = {}

tests[name] = alphanumerical
tests[deci] = decimal
tests[hexa] = hexadecimal

// Warning types.
var namedNotTerminated = 1
var numericNotTerminated = 2
var namedEmpty = 3
var numericEmpty = 4
var namedUnknown = 5
var numericDisallowed = 6
var numericProhibited = 7

// Warning messages.
var messages = {}

messages[namedNotTerminated] =
  'Named character references must be terminated by a semicolon'
messages[numericNotTerminated] =
  'Numeric character references must be terminated by a semicolon'
messages[namedEmpty] = 'Named character references cannot be empty'
messages[numericEmpty] = 'Numeric character references cannot be empty'
messages[namedUnknown] = 'Named character references must be known'
messages[numericDisallowed] =
  'Numeric character references cannot be disallowed'
messages[numericProhibited] =
  'Numeric character references cannot be outside the permissible Unicode range'

// Wrap to ensure clean parameters are given to `parse`.
function parseEntities(value, options) {
  var settings = {}
  var option
  var key

  if (!options) {
    options = {}
  }

  for (key in defaults) {
    option = options[key]
    settings[key] =
      option === null || option === undefined ? defaults[key] : option
  }

  if (settings.position.indent || settings.position.start) {
    settings.indent = settings.position.indent || []
    settings.position = settings.position.start
  }

  return parse(value, settings)
}

// Parse entities.
// eslint-disable-next-line complexity
function parse(value, settings) {
  var additional = settings.additional
  var nonTerminated = settings.nonTerminated
  var handleText = settings.text
  var handleReference = settings.reference
  var handleWarning = settings.warning
  var textContext = settings.textContext
  var referenceContext = settings.referenceContext
  var warningContext = settings.warningContext
  var pos = settings.position
  var indent = settings.indent || []
  var length = value.length
  var index = 0
  var lines = -1
  var column = pos.column || 1
  var line = pos.line || 1
  var queue = ''
  var result = []
  var entityCharacters
  var namedEntity
  var terminated
  var characters
  var character
  var reference
  var following
  var warning
  var reason
  var output
  var entity
  var begin
  var start
  var type
  var test
  var prev
  var next
  var diff
  var end

  if (typeof additional === 'string') {
    additional = additional.charCodeAt(0)
  }

  // Cache the current point.
  prev = now()

  // Wrap `handleWarning`.
  warning = handleWarning ? parseError : noop

  // Ensure the algorithm walks over the first character and the end (inclusive).
  index--
  length++

  while (++index < length) {
    // If the previous character was a newline.
    if (character === lineFeed) {
      column = indent[lines] || 1
    }

    character = value.charCodeAt(index)

    if (character === ampersand) {
      following = value.charCodeAt(index + 1)

      // The behaviour depends on the identity of the next character.
      if (
        following === tab ||
        following === lineFeed ||
        following === formFeed ||
        following === space ||
        following === ampersand ||
        following === lessThan ||
        following !== following ||
        (additional && following === additional)
      ) {
        // Not a character reference.
        // No characters are consumed, and nothing is returned.
        // This is not an error, either.
        queue += fromCharCode(character)
        column++

        continue
      }

      start = index + 1
      begin = start
      end = start

      if (following === numberSign) {
        // Numerical entity.
        end = ++begin

        // The behaviour further depends on the next character.
        following = value.charCodeAt(end)

        if (following === uppercaseX || following === lowercaseX) {
          // ASCII hex digits.
          type = hexa
          end = ++begin
        } else {
          // ASCII digits.
          type = deci
        }
      } else {
        // Named entity.
        type = name
      }

      entityCharacters = ''
      entity = ''
      characters = ''
      test = tests[type]
      end--

      while (++end < length) {
        following = value.charCodeAt(end)

        if (!test(following)) {
          break
        }

        characters += fromCharCode(following)

        // Check if we can match a legacy named reference.
        // If so, we cache that as the last viable named reference.
        // This ensures we do not need to walk backwards later.
        if (type === name && own.call(legacy, characters)) {
          entityCharacters = characters
          entity = legacy[characters]
        }
      }

      terminated = value.charCodeAt(end) === semicolon

      if (terminated) {
        end++

        namedEntity = type === name ? decodeEntity(characters) : false

        if (namedEntity) {
          entityCharacters = characters
          entity = namedEntity
        }
      }

      diff = 1 + end - start

      if (!terminated && !nonTerminated) {
        // Empty.
      } else if (!characters) {
        // An empty (possible) entity is valid, unless it’s numeric (thus an
        // ampersand followed by an octothorp).
        if (type !== name) {
          warning(numericEmpty, diff)
        }
      } else if (type === name) {
        // An ampersand followed by anything unknown, and not terminated, is
        // invalid.
        if (terminated && !entity) {
          warning(namedUnknown, 1)
        } else {
          // If theres something after an entity name which is not known, cap
          // the reference.
          if (entityCharacters !== characters) {
            end = begin + entityCharacters.length
            diff = 1 + end - begin
            terminated = false
          }

          // If the reference is not terminated, warn.
          if (!terminated) {
            reason = entityCharacters ? namedNotTerminated : namedEmpty

            if (settings.attribute) {
              following = value.charCodeAt(end)

              if (following === equalsTo) {
                warning(reason, diff)
                entity = null
              } else if (alphanumerical(following)) {
                entity = null
              } else {
                warning(reason, diff)
              }
            } else {
              warning(reason, diff)
            }
          }
        }

        reference = entity
      } else {
        if (!terminated) {
          // All non-terminated numeric entities are not rendered, and trigger a
          // warning.
          warning(numericNotTerminated, diff)
        }

        // When terminated and number, parse as either hexadecimal or decimal.
        reference = parseInt(characters, bases[type])

        // Trigger a warning when the parsed number is prohibited, and replace
        // with replacement character.
        if (prohibited(reference)) {
          warning(numericProhibited, diff)
          reference = fromCharCode(replacementCharacter)
        } else if (reference in invalid) {
          // Trigger a warning when the parsed number is disallowed, and replace
          // by an alternative.
          warning(numericDisallowed, diff)
          reference = invalid[reference]
        } else {
          // Parse the number.
          output = ''

          // Trigger a warning when the parsed number should not be used.
          if (disallowed(reference)) {
            warning(numericDisallowed, diff)
          }

          // Stringify the number.
          if (reference > 0xffff) {
            reference -= 0x10000
            output += fromCharCode((reference >>> (10 & 0x3ff)) | 0xd800)
            reference = 0xdc00 | (reference & 0x3ff)
          }

          reference = output + fromCharCode(reference)
        }
      }

      // Found it!
      // First eat the queued characters as normal text, then eat an entity.
      if (reference) {
        flush()

        prev = now()
        index = end - 1
        column += end - start + 1
        result.push(reference)
        next = now()
        next.offset++

        if (handleReference) {
          handleReference.call(
            referenceContext,
            reference,
            {start: prev, end: next},
            value.slice(start - 1, end)
          )
        }

        prev = next
      } else {
        // If we could not find a reference, queue the checked characters (as
        // normal characters), and move the pointer to their end.
        // This is possible because we can be certain neither newlines nor
        // ampersands are included.
        characters = value.slice(start - 1, end)
        queue += characters
        column += characters.length
        index = end - 1
      }
    } else {
      // Handle anything other than an ampersand, including newlines and EOF.
      if (
        character === 10 // Line feed
      ) {
        line++
        lines++
        column = 0
      }

      if (character === character) {
        queue += fromCharCode(character)
        column++
      } else {
        flush()
      }
    }
  }

  // Return the reduced nodes, and any possible warnings.
  return result.join('')

  // Get current position.
  function now() {
    return {
      line: line,
      column: column,
      offset: index + (pos.offset || 0)
    }
  }

  // “Throw” a parse-error: a warning.
  function parseError(code, offset) {
    var position = now()

    position.column += offset
    position.offset += offset

    handleWarning.call(warningContext, messages[code], position, code)
  }

  // Flush `queue` (normal text).
  // Macro invoked before each entity and at the end of `value`.
  // Does nothing when `queue` is empty.
  function flush() {
    if (queue) {
      result.push(queue)

      if (handleText) {
        handleText.call(textContext, queue, {start: prev, end: now()})
      }

      queue = ''
    }
  }
}

// Check if `character` is outside the permissible unicode range.
function prohibited(code) {
  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
}

// Check if `character` is disallowed.
function disallowed(code) {
  return (
    (code >= 0x0001 && code <= 0x0008) ||
    code === 0x000b ||
    (code >= 0x000d && code <= 0x001f) ||
    (code >= 0x007f && code <= 0x009f) ||
    (code >= 0xfdd0 && code <= 0xfdef) ||
    (code & 0xffff) === 0xffff ||
    (code & 0xffff) === 0xfffe
  )
}


/***/ }),

/***/ 2703:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(414);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),

/***/ 5697:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(2703)();
}


/***/ }),

/***/ 414:
/***/ ((module) => {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),

/***/ 9560:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var normalize = __webpack_require__(6632)
var DefinedInfo = __webpack_require__(8805)
var Info = __webpack_require__(7643)

var data = 'data'

module.exports = find

var valid = /^data[-\w.:]+$/i
var dash = /-[a-z]/g
var cap = /[A-Z]/g

function find(schema, value) {
  var normal = normalize(value)
  var prop = value
  var Type = Info

  if (normal in schema.normal) {
    return schema.property[schema.normal[normal]]
  }

  if (normal.length > 4 && normal.slice(0, 4) === data && valid.test(value)) {
    // Attribute or property.
    if (value.charAt(4) === '-') {
      prop = datasetToProperty(value)
    } else {
      value = datasetToAttribute(value)
    }

    Type = DefinedInfo
  }

  return new Type(prop, value)
}

function datasetToProperty(attribute) {
  var value = attribute.slice(5).replace(dash, camelcase)
  return data + value.charAt(0).toUpperCase() + value.slice(1)
}

function datasetToAttribute(property) {
  var value = property.slice(4)

  if (dash.test(value)) {
    return property
  }

  value = value.replace(cap, kebab)

  if (value.charAt(0) !== '-') {
    value = '-' + value
  }

  return data + value
}

function kebab($0) {
  return '-' + $0.toLowerCase()
}

function camelcase($0) {
  return $0.charAt(1).toUpperCase()
}


/***/ }),

/***/ 7247:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var merge = __webpack_require__(9940)
var xlink = __webpack_require__(8289)
var xml = __webpack_require__(5812)
var xmlns = __webpack_require__(4397)
var aria = __webpack_require__(7716)
var html = __webpack_require__(1805)

module.exports = merge([xml, xlink, xmlns, aria, html])


/***/ }),

/***/ 7716:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var types = __webpack_require__(7000)
var create = __webpack_require__(7596)

var booleanish = types.booleanish
var number = types.number
var spaceSeparated = types.spaceSeparated

module.exports = create({
  transform: ariaTransform,
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: booleanish,
    ariaAutoComplete: null,
    ariaBusy: booleanish,
    ariaChecked: booleanish,
    ariaColCount: number,
    ariaColIndex: number,
    ariaColSpan: number,
    ariaControls: spaceSeparated,
    ariaCurrent: null,
    ariaDescribedBy: spaceSeparated,
    ariaDetails: null,
    ariaDisabled: booleanish,
    ariaDropEffect: spaceSeparated,
    ariaErrorMessage: null,
    ariaExpanded: booleanish,
    ariaFlowTo: spaceSeparated,
    ariaGrabbed: booleanish,
    ariaHasPopup: null,
    ariaHidden: booleanish,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: spaceSeparated,
    ariaLevel: number,
    ariaLive: null,
    ariaModal: booleanish,
    ariaMultiLine: booleanish,
    ariaMultiSelectable: booleanish,
    ariaOrientation: null,
    ariaOwns: spaceSeparated,
    ariaPlaceholder: null,
    ariaPosInSet: number,
    ariaPressed: booleanish,
    ariaReadOnly: booleanish,
    ariaRelevant: null,
    ariaRequired: booleanish,
    ariaRoleDescription: spaceSeparated,
    ariaRowCount: number,
    ariaRowIndex: number,
    ariaRowSpan: number,
    ariaSelected: booleanish,
    ariaSetSize: number,
    ariaSort: null,
    ariaValueMax: number,
    ariaValueMin: number,
    ariaValueNow: number,
    ariaValueText: null,
    role: null
  }
})

function ariaTransform(_, prop) {
  return prop === 'role' ? prop : 'aria-' + prop.slice(4).toLowerCase()
}


/***/ }),

/***/ 1805:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var types = __webpack_require__(7000)
var create = __webpack_require__(7596)
var caseInsensitiveTransform = __webpack_require__(855)

var boolean = types.boolean
var overloadedBoolean = types.overloadedBoolean
var booleanish = types.booleanish
var number = types.number
var spaceSeparated = types.spaceSeparated
var commaSeparated = types.commaSeparated

module.exports = create({
  space: 'html',
  attributes: {
    acceptcharset: 'accept-charset',
    classname: 'class',
    htmlfor: 'for',
    httpequiv: 'http-equiv'
  },
  transform: caseInsensitiveTransform,
  mustUseProperty: ['checked', 'multiple', 'muted', 'selected'],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: commaSeparated,
    acceptCharset: spaceSeparated,
    accessKey: spaceSeparated,
    action: null,
    allow: null,
    allowFullScreen: boolean,
    allowPaymentRequest: boolean,
    allowUserMedia: boolean,
    alt: null,
    as: null,
    async: boolean,
    autoCapitalize: null,
    autoComplete: spaceSeparated,
    autoFocus: boolean,
    autoPlay: boolean,
    capture: boolean,
    charSet: null,
    checked: boolean,
    cite: null,
    className: spaceSeparated,
    cols: number,
    colSpan: null,
    content: null,
    contentEditable: booleanish,
    controls: boolean,
    controlsList: spaceSeparated,
    coords: number | commaSeparated,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: boolean,
    defer: boolean,
    dir: null,
    dirName: null,
    disabled: boolean,
    download: overloadedBoolean,
    draggable: booleanish,
    encType: null,
    enterKeyHint: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: boolean,
    formTarget: null,
    headers: spaceSeparated,
    height: number,
    hidden: boolean,
    high: number,
    href: null,
    hrefLang: null,
    htmlFor: spaceSeparated,
    httpEquiv: spaceSeparated,
    id: null,
    imageSizes: null,
    imageSrcSet: commaSeparated,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: boolean,
    itemId: null,
    itemProp: spaceSeparated,
    itemRef: spaceSeparated,
    itemScope: boolean,
    itemType: spaceSeparated,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loop: boolean,
    low: number,
    manifest: null,
    max: null,
    maxLength: number,
    media: null,
    method: null,
    min: null,
    minLength: number,
    multiple: boolean,
    muted: boolean,
    name: null,
    nonce: null,
    noModule: boolean,
    noValidate: boolean,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforePrint: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextMenu: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: boolean,
    optimum: number,
    pattern: null,
    ping: spaceSeparated,
    placeholder: null,
    playsInline: boolean,
    poster: null,
    preload: null,
    readOnly: boolean,
    referrerPolicy: null,
    rel: spaceSeparated,
    required: boolean,
    reversed: boolean,
    rows: number,
    rowSpan: number,
    sandbox: spaceSeparated,
    scope: null,
    scoped: boolean,
    seamless: boolean,
    selected: boolean,
    shape: null,
    size: number,
    sizes: null,
    slot: null,
    span: number,
    spellCheck: booleanish,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: commaSeparated,
    start: number,
    step: null,
    style: null,
    tabIndex: number,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: boolean,
    useMap: null,
    value: booleanish,
    width: number,
    wrap: null,

    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null, // Several. Use CSS `text-align` instead,
    aLink: null, // `<body>`. Use CSS `a:active {color}` instead
    archive: spaceSeparated, // `<object>`. List of URIs to archives
    axis: null, // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null, // `<body>`. Use CSS `background-image` instead
    bgColor: null, // `<body>` and table elements. Use CSS `background-color` instead
    border: number, // `<table>`. Use CSS `border-width` instead,
    borderColor: null, // `<table>`. Use CSS `border-color` instead,
    bottomMargin: number, // `<body>`
    cellPadding: null, // `<table>`
    cellSpacing: null, // `<table>`
    char: null, // Several table elements. When `align=char`, sets the character to align on
    charOff: null, // Several table elements. When `char`, offsets the alignment
    classId: null, // `<object>`
    clear: null, // `<br>`. Use CSS `clear` instead
    code: null, // `<object>`
    codeBase: null, // `<object>`
    codeType: null, // `<object>`
    color: null, // `<font>` and `<hr>`. Use CSS instead
    compact: boolean, // Lists. Use CSS to reduce space between items instead
    declare: boolean, // `<object>`
    event: null, // `<script>`
    face: null, // `<font>`. Use CSS instead
    frame: null, // `<table>`
    frameBorder: null, // `<iframe>`. Use CSS `border` instead
    hSpace: number, // `<img>` and `<object>`
    leftMargin: number, // `<body>`
    link: null, // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null, // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null, // `<img>`. Use a `<picture>`
    marginHeight: number, // `<body>`
    marginWidth: number, // `<body>`
    noResize: boolean, // `<frame>`
    noHref: boolean, // `<area>`. Use no href instead of an explicit `nohref`
    noShade: boolean, // `<hr>`. Use background-color and height instead of borders
    noWrap: boolean, // `<td>` and `<th>`
    object: null, // `<applet>`
    profile: null, // `<head>`
    prompt: null, // `<isindex>`
    rev: null, // `<link>`
    rightMargin: number, // `<body>`
    rules: null, // `<table>`
    scheme: null, // `<meta>`
    scrolling: booleanish, // `<frame>`. Use overflow in the child context
    standby: null, // `<object>`
    summary: null, // `<table>`
    text: null, // `<body>`. Use CSS `color` instead
    topMargin: number, // `<body>`
    valueType: null, // `<param>`
    version: null, // `<html>`. Use a doctype.
    vAlign: null, // Several. Use CSS `vertical-align` instead
    vLink: null, // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: number, // `<img>` and `<object>`

    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: boolean,
    disableRemotePlayback: boolean,
    prefix: null,
    property: null,
    results: number,
    security: null,
    unselectable: null
  }
})


/***/ }),

/***/ 5789:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var types = __webpack_require__(7000)
var create = __webpack_require__(7596)
var caseSensitiveTransform = __webpack_require__(8740)

var boolean = types.boolean
var number = types.number
var spaceSeparated = types.spaceSeparated
var commaSeparated = types.commaSeparated
var commaOrSpaceSeparated = types.commaOrSpaceSeparated

module.exports = create({
  space: 'svg',
  attributes: {
    accentHeight: 'accent-height',
    alignmentBaseline: 'alignment-baseline',
    arabicForm: 'arabic-form',
    baselineShift: 'baseline-shift',
    capHeight: 'cap-height',
    className: 'class',
    clipPath: 'clip-path',
    clipRule: 'clip-rule',
    colorInterpolation: 'color-interpolation',
    colorInterpolationFilters: 'color-interpolation-filters',
    colorProfile: 'color-profile',
    colorRendering: 'color-rendering',
    crossOrigin: 'crossorigin',
    dataType: 'datatype',
    dominantBaseline: 'dominant-baseline',
    enableBackground: 'enable-background',
    fillOpacity: 'fill-opacity',
    fillRule: 'fill-rule',
    floodColor: 'flood-color',
    floodOpacity: 'flood-opacity',
    fontFamily: 'font-family',
    fontSize: 'font-size',
    fontSizeAdjust: 'font-size-adjust',
    fontStretch: 'font-stretch',
    fontStyle: 'font-style',
    fontVariant: 'font-variant',
    fontWeight: 'font-weight',
    glyphName: 'glyph-name',
    glyphOrientationHorizontal: 'glyph-orientation-horizontal',
    glyphOrientationVertical: 'glyph-orientation-vertical',
    hrefLang: 'hreflang',
    horizAdvX: 'horiz-adv-x',
    horizOriginX: 'horiz-origin-x',
    horizOriginY: 'horiz-origin-y',
    imageRendering: 'image-rendering',
    letterSpacing: 'letter-spacing',
    lightingColor: 'lighting-color',
    markerEnd: 'marker-end',
    markerMid: 'marker-mid',
    markerStart: 'marker-start',
    navDown: 'nav-down',
    navDownLeft: 'nav-down-left',
    navDownRight: 'nav-down-right',
    navLeft: 'nav-left',
    navNext: 'nav-next',
    navPrev: 'nav-prev',
    navRight: 'nav-right',
    navUp: 'nav-up',
    navUpLeft: 'nav-up-left',
    navUpRight: 'nav-up-right',
    onAbort: 'onabort',
    onActivate: 'onactivate',
    onAfterPrint: 'onafterprint',
    onBeforePrint: 'onbeforeprint',
    onBegin: 'onbegin',
    onCancel: 'oncancel',
    onCanPlay: 'oncanplay',
    onCanPlayThrough: 'oncanplaythrough',
    onChange: 'onchange',
    onClick: 'onclick',
    onClose: 'onclose',
    onCopy: 'oncopy',
    onCueChange: 'oncuechange',
    onCut: 'oncut',
    onDblClick: 'ondblclick',
    onDrag: 'ondrag',
    onDragEnd: 'ondragend',
    onDragEnter: 'ondragenter',
    onDragExit: 'ondragexit',
    onDragLeave: 'ondragleave',
    onDragOver: 'ondragover',
    onDragStart: 'ondragstart',
    onDrop: 'ondrop',
    onDurationChange: 'ondurationchange',
    onEmptied: 'onemptied',
    onEnd: 'onend',
    onEnded: 'onended',
    onError: 'onerror',
    onFocus: 'onfocus',
    onFocusIn: 'onfocusin',
    onFocusOut: 'onfocusout',
    onHashChange: 'onhashchange',
    onInput: 'oninput',
    onInvalid: 'oninvalid',
    onKeyDown: 'onkeydown',
    onKeyPress: 'onkeypress',
    onKeyUp: 'onkeyup',
    onLoad: 'onload',
    onLoadedData: 'onloadeddata',
    onLoadedMetadata: 'onloadedmetadata',
    onLoadStart: 'onloadstart',
    onMessage: 'onmessage',
    onMouseDown: 'onmousedown',
    onMouseEnter: 'onmouseenter',
    onMouseLeave: 'onmouseleave',
    onMouseMove: 'onmousemove',
    onMouseOut: 'onmouseout',
    onMouseOver: 'onmouseover',
    onMouseUp: 'onmouseup',
    onMouseWheel: 'onmousewheel',
    onOffline: 'onoffline',
    onOnline: 'ononline',
    onPageHide: 'onpagehide',
    onPageShow: 'onpageshow',
    onPaste: 'onpaste',
    onPause: 'onpause',
    onPlay: 'onplay',
    onPlaying: 'onplaying',
    onPopState: 'onpopstate',
    onProgress: 'onprogress',
    onRateChange: 'onratechange',
    onRepeat: 'onrepeat',
    onReset: 'onreset',
    onResize: 'onresize',
    onScroll: 'onscroll',
    onSeeked: 'onseeked',
    onSeeking: 'onseeking',
    onSelect: 'onselect',
    onShow: 'onshow',
    onStalled: 'onstalled',
    onStorage: 'onstorage',
    onSubmit: 'onsubmit',
    onSuspend: 'onsuspend',
    onTimeUpdate: 'ontimeupdate',
    onToggle: 'ontoggle',
    onUnload: 'onunload',
    onVolumeChange: 'onvolumechange',
    onWaiting: 'onwaiting',
    onZoom: 'onzoom',
    overlinePosition: 'overline-position',
    overlineThickness: 'overline-thickness',
    paintOrder: 'paint-order',
    panose1: 'panose-1',
    pointerEvents: 'pointer-events',
    referrerPolicy: 'referrerpolicy',
    renderingIntent: 'rendering-intent',
    shapeRendering: 'shape-rendering',
    stopColor: 'stop-color',
    stopOpacity: 'stop-opacity',
    strikethroughPosition: 'strikethrough-position',
    strikethroughThickness: 'strikethrough-thickness',
    strokeDashArray: 'stroke-dasharray',
    strokeDashOffset: 'stroke-dashoffset',
    strokeLineCap: 'stroke-linecap',
    strokeLineJoin: 'stroke-linejoin',
    strokeMiterLimit: 'stroke-miterlimit',
    strokeOpacity: 'stroke-opacity',
    strokeWidth: 'stroke-width',
    tabIndex: 'tabindex',
    textAnchor: 'text-anchor',
    textDecoration: 'text-decoration',
    textRendering: 'text-rendering',
    typeOf: 'typeof',
    underlinePosition: 'underline-position',
    underlineThickness: 'underline-thickness',
    unicodeBidi: 'unicode-bidi',
    unicodeRange: 'unicode-range',
    unitsPerEm: 'units-per-em',
    vAlphabetic: 'v-alphabetic',
    vHanging: 'v-hanging',
    vIdeographic: 'v-ideographic',
    vMathematical: 'v-mathematical',
    vectorEffect: 'vector-effect',
    vertAdvY: 'vert-adv-y',
    vertOriginX: 'vert-origin-x',
    vertOriginY: 'vert-origin-y',
    wordSpacing: 'word-spacing',
    writingMode: 'writing-mode',
    xHeight: 'x-height',
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: 'playbackorder',
    timelineBegin: 'timelinebegin'
  },
  transform: caseSensitiveTransform,
  properties: {
    about: commaOrSpaceSeparated,
    accentHeight: number,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: number,
    amplitude: number,
    arabicForm: null,
    ascent: number,
    attributeName: null,
    attributeType: null,
    azimuth: number,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: number,
    by: null,
    calcMode: null,
    capHeight: number,
    className: spaceSeparated,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: number,
    diffuseConstant: number,
    direction: null,
    display: null,
    dur: null,
    divisor: number,
    dominantBaseline: null,
    download: boolean,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: number,
    enableBackground: null,
    end: null,
    event: null,
    exponent: number,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: number,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: commaSeparated,
    g2: commaSeparated,
    glyphName: commaSeparated,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: number,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: number,
    horizOriginX: number,
    horizOriginY: number,
    id: null,
    ideographic: number,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: number,
    k: number,
    k1: number,
    k2: number,
    k3: number,
    k4: number,
    kernelMatrix: commaOrSpaceSeparated,
    kernelUnitLength: null,
    keyPoints: null, // SEMI_COLON_SEPARATED
    keySplines: null, // SEMI_COLON_SEPARATED
    keyTimes: null, // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: number,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: number,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: number,
    overlineThickness: number,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: number,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: spaceSeparated,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: number,
    pointsAtY: number,
    pointsAtZ: number,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: commaOrSpaceSeparated,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: commaOrSpaceSeparated,
    rev: commaOrSpaceSeparated,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: commaOrSpaceSeparated,
    requiredFeatures: commaOrSpaceSeparated,
    requiredFonts: commaOrSpaceSeparated,
    requiredFormats: commaOrSpaceSeparated,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: number,
    specularExponent: number,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: number,
    strikethroughThickness: number,
    string: null,
    stroke: null,
    strokeDashArray: commaOrSpaceSeparated,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: number,
    strokeOpacity: number,
    strokeWidth: null,
    style: null,
    surfaceScale: number,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: commaOrSpaceSeparated,
    tabIndex: number,
    tableValues: null,
    target: null,
    targetX: number,
    targetY: number,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: commaOrSpaceSeparated,
    to: null,
    transform: null,
    u1: null,
    u2: null,
    underlinePosition: number,
    underlineThickness: number,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: number,
    values: null,
    vAlphabetic: number,
    vMathematical: number,
    vectorEffect: null,
    vHanging: number,
    vIdeographic: number,
    version: null,
    vertAdvY: number,
    vertOriginX: number,
    vertOriginY: number,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: number,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
})


/***/ }),

/***/ 855:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var caseSensitiveTransform = __webpack_require__(8740)

module.exports = caseInsensitiveTransform

function caseInsensitiveTransform(attributes, property) {
  return caseSensitiveTransform(attributes, property.toLowerCase())
}


/***/ }),

/***/ 8740:
/***/ ((module) => {

"use strict";


module.exports = caseSensitiveTransform

function caseSensitiveTransform(attributes, attribute) {
  return attribute in attributes ? attributes[attribute] : attribute
}


/***/ }),

/***/ 7596:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var normalize = __webpack_require__(6632)
var Schema = __webpack_require__(9607)
var DefinedInfo = __webpack_require__(8805)

module.exports = create

function create(definition) {
  var space = definition.space
  var mustUseProperty = definition.mustUseProperty || []
  var attributes = definition.attributes || {}
  var props = definition.properties
  var transform = definition.transform
  var property = {}
  var normal = {}
  var prop
  var info

  for (prop in props) {
    info = new DefinedInfo(
      prop,
      transform(attributes, prop),
      props[prop],
      space
    )

    if (mustUseProperty.indexOf(prop) !== -1) {
      info.mustUseProperty = true
    }

    property[prop] = info

    normal[normalize(prop)] = prop
    normal[normalize(info.attribute)] = prop
  }

  return new Schema(property, normal, space)
}


/***/ }),

/***/ 8805:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var Info = __webpack_require__(7643)
var types = __webpack_require__(7000)

module.exports = DefinedInfo

DefinedInfo.prototype = new Info()
DefinedInfo.prototype.defined = true

var checks = [
  'boolean',
  'booleanish',
  'overloadedBoolean',
  'number',
  'commaSeparated',
  'spaceSeparated',
  'commaOrSpaceSeparated'
]
var checksLength = checks.length

function DefinedInfo(property, attribute, mask, space) {
  var index = -1
  var check

  mark(this, 'space', space)

  Info.call(this, property, attribute)

  while (++index < checksLength) {
    check = checks[index]
    mark(this, check, (mask & types[check]) === types[check])
  }
}

function mark(values, key, value) {
  if (value) {
    values[key] = value
  }
}


/***/ }),

/***/ 7643:
/***/ ((module) => {

"use strict";


module.exports = Info

var proto = Info.prototype

proto.space = null
proto.attribute = null
proto.property = null
proto.boolean = false
proto.booleanish = false
proto.overloadedBoolean = false
proto.number = false
proto.commaSeparated = false
proto.spaceSeparated = false
proto.commaOrSpaceSeparated = false
proto.mustUseProperty = false
proto.defined = false

function Info(property, attribute) {
  this.property = property
  this.attribute = attribute
}


/***/ }),

/***/ 9940:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var xtend = __webpack_require__(7529)
var Schema = __webpack_require__(9607)

module.exports = merge

function merge(definitions) {
  var length = definitions.length
  var property = []
  var normal = []
  var index = -1
  var info
  var space

  while (++index < length) {
    info = definitions[index]
    property.push(info.property)
    normal.push(info.normal)
    space = info.space
  }

  return new Schema(
    xtend.apply(null, property),
    xtend.apply(null, normal),
    space
  )
}


/***/ }),

/***/ 9607:
/***/ ((module) => {

"use strict";


module.exports = Schema

var proto = Schema.prototype

proto.space = null
proto.normal = {}
proto.property = {}

function Schema(property, normal, space) {
  this.property = property
  this.normal = normal

  if (space) {
    this.space = space
  }
}


/***/ }),

/***/ 7000:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


var powers = 0

exports.boolean = increment()
exports.booleanish = increment()
exports.overloadedBoolean = increment()
exports.number = increment()
exports.spaceSeparated = increment()
exports.commaSeparated = increment()
exports.commaOrSpaceSeparated = increment()

function increment() {
  return Math.pow(2, ++powers)
}


/***/ }),

/***/ 8289:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var create = __webpack_require__(7596)

module.exports = create({
  space: 'xlink',
  transform: xlinkTransform,
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
})

function xlinkTransform(_, prop) {
  return 'xlink:' + prop.slice(5).toLowerCase()
}


/***/ }),

/***/ 5812:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var create = __webpack_require__(7596)

module.exports = create({
  space: 'xml',
  transform: xmlTransform,
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
})

function xmlTransform(_, prop) {
  return 'xml:' + prop.slice(3).toLowerCase()
}


/***/ }),

/***/ 4397:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var create = __webpack_require__(7596)
var caseInsensitiveTransform = __webpack_require__(855)

module.exports = create({
  space: 'xmlns',
  attributes: {
    xmlnsxlink: 'xmlns:xlink'
  },
  transform: caseInsensitiveTransform,
  properties: {
    xmlns: null,
    xmlnsXLink: null
  }
})


/***/ }),

/***/ 6632:
/***/ ((module) => {

"use strict";


module.exports = normalize

function normalize(value) {
  return value.toLowerCase()
}


/***/ }),

/***/ 1218:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var merge = __webpack_require__(9940)
var xlink = __webpack_require__(8289)
var xml = __webpack_require__(5812)
var xmlns = __webpack_require__(4397)
var aria = __webpack_require__(7716)
var svg = __webpack_require__(5789)

module.exports = merge([xml, xlink, xmlns, aria, svg])


/***/ }),

/***/ 6388:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var hastUtilRaw = __webpack_require__(6343)

module.exports = rehypeRaw

function rehypeRaw(options) {
  return transform
  function transform(tree, file) {
    return hastUtilRaw(tree, file, options)
  }
}


/***/ }),

/***/ 7431:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var toH = __webpack_require__(6331)
var tableCellStyle = __webpack_require__(478)

module.exports = rehypeReact

var own = {}.hasOwnProperty
var tableElements = new Set([
  'table',
  'thead',
  'tbody',
  'tfoot',
  'tr',
  'th',
  'td'
])

// Add a React compiler.
function rehypeReact(options) {
  var settings = options || {}
  var createElement = settings.createElement

  this.Compiler = compiler

  function compiler(node) {
    var result = toH(h, tableCellStyle(node), settings.prefix)

    if (node.type === 'root') {
      // Invert <https://github.com/syntax-tree/hast-to-hyperscript/blob/d227372/index.js#L46-L56>.
      result =
        result.type === 'div' &&
        (node.children.length !== 1 || node.children[0].type !== 'element')
          ? result.props.children
          : [result]

      return createElement(settings.Fragment || 'div', {}, result)
    }

    return result
  }

  // Wrap `createElement` to pass components in.
  function h(name, props, children) {
    var component = name

    // Currently, a warning is triggered by react for *any* white space in
    // tables.
    // So we remove the pretty lines for now.
    // See: <https://github.com/facebook/react/pull/7081>.
    // See: <https://github.com/facebook/react/pull/7515>.
    // See: <https://github.com/remarkjs/remark-react/issues/64>.
    if (children && tableElements.has(name)) {
      children = children.filter(function (child) {
        return child !== '\n'
      })
    }

    if (settings.components && own.call(settings.components, name)) {
      component = settings.components[name]

      if (settings.passNode) {
        props.node = this
      }
    }

    return createElement(component, props, children)
  }
}


/***/ }),

/***/ 1667:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var clean = __webpack_require__(4841)

module.exports = sanitize

function sanitize(options) {
  return transformer
  function transformer(tree) {
    return clean(tree, options)
  }
}


/***/ }),

/***/ 4841:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";

module.exports = __webpack_require__(1873)


/***/ }),

/***/ 1873:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var xtend = __webpack_require__(7529)
var defaults = __webpack_require__(9052)

module.exports = wrapper

var own = {}.hasOwnProperty
var push = [].push

var nodeSchema = {
  root: {children: all},
  doctype: handleDoctype,
  comment: handleComment,
  element: {
    tagName: handleTagName,
    properties: handleProperties,
    children: all
  },
  text: {value: handleValue},
  '*': {data: allow, position: allow}
}

// Sanitize `node`, according to `schema`.
function wrapper(node, schema) {
  var ctx = {type: 'root', children: []}
  var replace

  if (node && typeof node === 'object' && node.type) {
    replace = one(xtend(defaults, schema || {}), node, [])

    if (replace) {
      if ('length' in replace) {
        if (replace.length === 1) {
          ctx = replace[0]
        } else {
          ctx.children = replace
        }
      } else {
        ctx = replace
      }
    }
  }

  return ctx
}

// Sanitize `node`.
function one(schema, node, stack) {
  var type = node && node.type
  var replacement = {type: node.type}
  var replace
  var definition
  var allowed
  var result
  var key

  if (own.call(nodeSchema, type)) {
    definition = nodeSchema[type]

    if (typeof definition === 'function') {
      definition = definition(schema, node)
    }

    if (definition) {
      replace = true
      allowed = xtend(definition, nodeSchema['*'])

      for (key in allowed) {
        result = allowed[key](schema, node[key], node, stack)

        if (result === false) {
          replace = null
          // Set the non-safe value.
          replacement[key] = node[key]
        } else if (result != null) {
          replacement[key] = result
        }
      }
    }
  }

  if (replace) {
    return replacement
  }

  return replacement.children &&
    replacement.children.length &&
    schema.strip.indexOf(replacement.tagName) < 0
    ? replacement.children
    : null
}

// Sanitize `children`.
function all(schema, children, node, stack) {
  var results = []
  var index = -1
  var value

  if (children) {
    stack.push(node.tagName)

    while (++index < children.length) {
      value = one(schema, children[index], stack)

      if (value) {
        if ('length' in value) {
          push.apply(results, value)
        } else {
          results.push(value)
        }
      }
    }

    stack.pop()
  }

  return results
}

// Sanitize `properties`.
function handleProperties(schema, properties, node, stack) {
  var name = handleTagName(schema, node.tagName, node, stack)
  var reqs = schema.required || /* istanbul ignore next */ {}
  var props = properties || {}
  var allowed = xtend(
    toPropertyValueMap(schema.attributes['*']),
    toPropertyValueMap(
      own.call(schema.attributes, name) ? schema.attributes[name] : []
    )
  )
  var result = {}
  var definition
  var key
  var value

  for (key in props) {
    if (own.call(allowed, key)) {
      definition = allowed[key]
    } else if (data(key) && own.call(allowed, 'data*')) {
      definition = allowed['data*']
    } else {
      continue
    }

    value = props[key]
    value =
      value && typeof value === 'object' && 'length' in value
        ? handlePropertyValues(schema, value, key, definition)
        : handlePropertyValue(schema, value, key, definition)

    if (value != null) {
      result[key] = value
    }
  }

  if (own.call(reqs, name)) {
    for (key in reqs[name]) {
      if (!own.call(result, key)) {
        result[key] = reqs[name][key]
      }
    }
  }

  return result
}

// Sanitize a property value which is a list.
function handlePropertyValues(schema, values, prop, definition) {
  var result = []
  var index = -1
  var value

  while (++index < values.length) {
    value = handlePropertyValue(schema, values[index], prop, definition)

    if (value != null) {
      result.push(value)
    }
  }

  return result
}

// Sanitize a property value.
function handlePropertyValue(schema, value, prop, definition) {
  if (
    (typeof value === 'boolean' ||
      typeof value === 'number' ||
      typeof value === 'string') &&
    handleProtocol(schema, value, prop) &&
    (!definition.length || definition.indexOf(value) > -1)
  ) {
    return schema.clobber.indexOf(prop) < 0
      ? value
      : schema.clobberPrefix + value
  }
}

// Check whether `value` is a safe URL.
function handleProtocol(schema, value, prop) {
  var url = String(value)
  var colon = url.indexOf(':')
  var questionMark = url.indexOf('?')
  var numberSign = url.indexOf('#')
  var slash = url.indexOf('/')
  var protocols = own.call(schema.protocols, prop)
    ? schema.protocols[prop].concat()
    : []
  var index = -1

  if (
    !protocols.length ||
    colon < 0 ||
    // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    (slash > -1 && colon > slash) ||
    (questionMark > -1 && colon > questionMark) ||
    (numberSign > -1 && colon > numberSign)
  ) {
    return true
  }

  while (++index < protocols.length) {
    if (
      colon === protocols[index].length &&
      url.slice(0, protocols[index].length) === protocols[index]
    ) {
      return true
    }
  }

  return false
}

// Always return a valid HTML5 doctype.
function handleDoctypeName() {
  return 'html'
}

// Sanitize `tagName`.
function handleTagName(schema, tagName, node, stack) {
  var name = typeof tagName === 'string' && tagName
  var index = -1

  if (!name || name === '*' || schema.tagNames.indexOf(name) < 0) {
    return false
  }

  // Some nodes can break out of their context if they don’t have a certain
  // ancestor.
  if (own.call(schema.ancestors, name)) {
    while (++index < schema.ancestors[name].length) {
      if (stack.indexOf(schema.ancestors[name][index]) > -1) {
        return name
      }
    }

    return false
  }

  return name
}

function handleDoctype(schema) {
  return schema.allowDoctypes ? {name: handleDoctypeName} : null
}

function handleComment(schema) {
  return schema.allowComments ? {value: handleCommentValue} : null
}

// See <https://html.spec.whatwg.org/multipage/parsing.html#serialising-html-fragments>
function handleCommentValue(schema, value) {
  var result = typeof value === 'string' ? value : ''
  var index = result.indexOf('-->')

  return index < 0 ? result : result.slice(0, index)
}

// Sanitize `value`.
function handleValue(schema, value) {
  return typeof value === 'string' ? value : ''
}

// Create a map from a list of props or a list of properties and values.
function toPropertyValueMap(values) {
  var result = {}
  var index = -1
  var value

  while (++index < values.length) {
    value = values[index]

    if (value && typeof value === 'object' && 'length' in value) {
      result[value[0]] = value.slice(1)
    } else {
      result[value] = []
    }
  }

  return result
}

// Allow `value`.
function allow(schema, value) {
  return value
}

// Check if `prop` is a data property.
function data(prop) {
  return prop.length > 4 && prop.slice(0, 4).toLowerCase() === 'data'
}


/***/ }),

/***/ 7532:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var xtend = __webpack_require__(7529)
var toHTML = __webpack_require__(773)

module.exports = stringify

function stringify(config) {
  var settings = xtend(config, this.data('settings'))

  this.Compiler = compiler

  function compiler(tree) {
    return toHTML(tree, settings)
  }
}


/***/ }),

/***/ 2558:
/***/ ((module) => {

"use strict";


module.exports = breaks

var lineFeed = 10
var space = 32

function breaks() {
  var parser = this.Parser
  var tokenizers

  if (!isRemarkParser(parser)) {
    throw new Error('Missing parser to attach `remark-breaks` to')
  }

  tokenizers = parser.prototype.inlineTokenizers

  tokenizeBreak.locator = tokenizers.break.locator

  tokenizers.break = tokenizeBreak

  function tokenizeBreak(eat, value, silent) {
    var length = value.length
    var index = -1
    var code

    while (++index < length) {
      code = value.charCodeAt(index)

      if (code === lineFeed) {
        /* istanbul ignore if - never used (yet) */
        if (silent) {
          return true
        }

        return eat(value.slice(0, index + 1))({type: 'break'})
      }

      if (code !== space) {
        return
      }
    }
  }
}

function isRemarkParser(parser) {
  return Boolean(
    parser &&
      parser.prototype &&
      parser.prototype.inlineTokenizers &&
      parser.prototype.inlineTokenizers.break &&
      parser.prototype.inlineTokenizers.break.locator
  )
}


/***/ }),

/***/ 9168:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var clone = __webpack_require__(6313);

var noop = function noop() {
  return false;
};

var noopLocator = function noopLocator() {
  return -1;
};

var throwing = function throwing(msg) {
  return function () {
    throw new Error(msg);
  };
};

function plugin() {
  var _this = this;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$block = _ref.block,
      block = _ref$block === void 0 ? [] : _ref$block,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? [] : _ref$inline;

  if (block.length) {
    block.filter(function (key) {
      if (Array.isArray(key)) return block.map(function (xs) {
        return xs[0];
      }).includes(key[0]);
      return block.includes(key);
    }).forEach(function (key) {
      if (Array.isArray(key) && key.length === 2) {
        _this.Parser.prototype.blockTokenizers[key[0]] = throwing(key[1]);
      } else {
        _this.Parser.prototype.blockTokenizers[key] = noop;
      }
    });
  }

  if (inline.length) {
    inline.filter(function (key) {
      if (Array.isArray(key)) return inline.map(function (xs) {
        return xs[0];
      }).includes(key[0]);
      return inline.includes(key);
    }).forEach(function (key) {
      var tokenizerName;
      var replacer;

      if (Array.isArray(key) && key.length === 2) {
        tokenizerName = key[0];
        replacer = throwing(key[1]);
      } else {
        tokenizerName = key;
        replacer = clone(noop);
      }

      if (_this.Parser.prototype.inlineTokenizers[tokenizerName]) {
        Object.keys(_this.Parser.prototype.inlineTokenizers[tokenizerName]).forEach(function (prop) {
          replacer[prop] = _this.Parser.prototype.inlineTokenizers[tokenizerName][prop];
        });
      }

      _this.Parser.prototype.inlineTokenizers[tokenizerName] = replacer;
      _this.Parser.prototype.inlineTokenizers[tokenizerName].locator = noopLocator;
    });
  }
}

module.exports = plugin;

/***/ }),

/***/ 5941:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var matters = __webpack_require__(2376)
var parse = __webpack_require__(9518)
var compile = __webpack_require__(3170)

module.exports = frontmatter

function frontmatter(options) {
  var parser = this.Parser
  var compiler = this.Compiler
  var config = matters(options || ['yaml'])

  if (isRemarkParser(parser)) {
    attachParser(parser, config)
  }

  if (isRemarkCompiler(compiler)) {
    attachCompiler(compiler, config)
  }
}

function attachParser(parser, matters) {
  var proto = parser.prototype
  var tokenizers = wrap(parse, matters)
  var names = []
  var key

  for (key in tokenizers) {
    names.push(key)
  }

  proto.blockMethods = names.concat(proto.blockMethods)
  proto.blockTokenizers = Object.assign({}, tokenizers, proto.blockTokenizers)
}

function attachCompiler(compiler, matters) {
  var proto = compiler.prototype
  proto.visitors = Object.assign({}, wrap(compile, matters), proto.visitors)
}

function wrap(func, matters) {
  var result = {}
  var length = matters.length
  var index = -1
  var tuple

  while (++index < length) {
    tuple = func(matters[index])
    result[tuple[0]] = tuple[1]
  }

  return result
}

function isRemarkParser(parser) {
  return Boolean(parser && parser.prototype && parser.prototype.blockTokenizers)
}

function isRemarkCompiler(compiler) {
  return Boolean(compiler && compiler.prototype && compiler.prototype.visitors)
}


/***/ }),

/***/ 3170:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var fence = __webpack_require__(3619)

module.exports = create

function create(matter) {
  var type = matter.type
  var open = fence(matter, 'open')
  var close = fence(matter, 'close')

  frontmatter.displayName = type + 'FrontMatter'

  return [type, frontmatter]

  function frontmatter(node) {
    return open + (node.value ? '\n' + node.value : '') + '\n' + close
  }
}


/***/ }),

/***/ 3619:
/***/ ((module) => {

"use strict";


module.exports = fence

function fence(matter, prop) {
  var marker

  if (matter.marker) {
    marker = pick(matter.marker, prop)
    return marker + marker + marker
  }

  return pick(matter.fence, prop)
}

function pick(schema, prop) {
  return typeof schema === 'string' ? schema : schema[prop]
}


/***/ }),

/***/ 2376:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var fault = __webpack_require__(1102)

module.exports = matters

var own = {}.hasOwnProperty

var markers = {
  yaml: '-',
  toml: '+'
}

function matters(options) {
  var results = []
  var index = -1
  var length

  // One preset or matter.
  if (typeof options === 'string' || !('length' in options)) {
    options = [options]
  }

  length = options.length

  while (++index < length) {
    results[index] = matter(options[index])
  }

  return results
}

function matter(option) {
  var result = option

  if (typeof result === 'string') {
    if (!own.call(markers, result)) {
      throw fault('Missing matter definition for `%s`', result)
    }

    result = {type: result, marker: markers[result]}
  } else if (typeof result !== 'object') {
    throw fault('Expected matter to be an object, not `%j`', result)
  }

  if (!own.call(result, 'type')) {
    throw fault('Missing `type` in matter `%j`', result)
  }

  if (!own.call(result, 'fence') && !own.call(result, 'marker')) {
    throw fault('Missing `marker` or `fence` in matter `%j`', result)
  }

  return result
}


/***/ }),

/***/ 9518:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var fence = __webpack_require__(3619)

module.exports = create

function create(matter) {
  var name = matter.type + 'FrontMatter'
  var open = fence(matter, 'open')
  var close = fence(matter, 'close')
  var newline = '\n'
  var anywhere = matter.anywhere

  frontmatter.displayName = name
  frontmatter.onlyAtStart = typeof anywhere === 'boolean' ? !anywhere : true

  return [name, frontmatter]

  function frontmatter(eat, value, silent) {
    var index = open.length
    var offset

    if (value.slice(0, index) !== open || value.charAt(index) !== newline) {
      return
    }

    offset = value.indexOf(close, index)

    while (offset !== -1 && value.charAt(offset - 1) !== newline) {
      index = offset + close.length
      offset = value.indexOf(close, index)
    }

    if (offset !== -1) {
      /* istanbul ignore if - never used (yet) */
      if (silent) {
        return true
      }

      return eat(value.slice(0, offset + close.length))({
        type: matter.type,
        value: value.slice(open.length + 1, offset - 1)
      })
    }
  }
}


/***/ }),

/***/ 2861:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var unherit = __webpack_require__(3278)
var xtend = __webpack_require__(7529)
var Parser = __webpack_require__(970)

module.exports = parse
parse.Parser = Parser

function parse(options) {
  var settings = this.data('settings')
  var Local = unherit(Parser)

  Local.prototype.options = xtend(Local.prototype.options, settings, options)

  this.Parser = Local
}


/***/ }),

/***/ 8829:
/***/ ((module) => {

"use strict";


module.exports = [
  'address',
  'article',
  'aside',
  'base',
  'basefont',
  'blockquote',
  'body',
  'caption',
  'center',
  'col',
  'colgroup',
  'dd',
  'details',
  'dialog',
  'dir',
  'div',
  'dl',
  'dt',
  'fieldset',
  'figcaption',
  'figure',
  'footer',
  'form',
  'frame',
  'frameset',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'head',
  'header',
  'hgroup',
  'hr',
  'html',
  'iframe',
  'legend',
  'li',
  'link',
  'main',
  'menu',
  'menuitem',
  'meta',
  'nav',
  'noframes',
  'ol',
  'optgroup',
  'option',
  'p',
  'param',
  'pre',
  'section',
  'source',
  'title',
  'summary',
  'table',
  'tbody',
  'td',
  'tfoot',
  'th',
  'thead',
  'title',
  'tr',
  'track',
  'ul'
]


/***/ }),

/***/ 4870:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var xtend = __webpack_require__(7529)
var entities = __webpack_require__(7574)

module.exports = factory

// Factory to create an entity decoder.
function factory(ctx) {
  decoder.raw = decodeRaw

  return decoder

  // Normalize `position` to add an `indent`.
  function normalize(position) {
    var offsets = ctx.offset
    var line = position.line
    var result = []

    while (++line) {
      if (!(line in offsets)) {
        break
      }

      result.push((offsets[line] || 0) + 1)
    }

    return {start: position, indent: result}
  }

  // Decode `value` (at `position`) into text-nodes.
  function decoder(value, position, handler) {
    entities(value, {
      position: normalize(position),
      warning: handleWarning,
      text: handler,
      reference: handler,
      textContext: ctx,
      referenceContext: ctx
    })
  }

  // Decode `value` (at `position`) into a string.
  function decodeRaw(value, position, options) {
    return entities(
      value,
      xtend(options, {position: normalize(position), warning: handleWarning})
    )
  }

  // Handle a warning.
  // See <https://github.com/wooorm/parse-entities> for the warnings.
  function handleWarning(reason, position, code) {
    if (code !== 3) {
      ctx.file.message(reason, position)
    }
  }
}


/***/ }),

/***/ 8515:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = {
  position: true,
  gfm: true,
  commonmark: false,
  footnotes: false,
  pedantic: false,
  blocks: __webpack_require__(8829)
}


/***/ }),

/***/ 3047:
/***/ ((module) => {

"use strict";


module.exports = locate

function locate(value, fromIndex) {
  var index = value.indexOf('\n', fromIndex)

  while (index > fromIndex) {
    if (value.charAt(index - 1) !== ' ') {
      break
    }

    index--
  }

  return index
}


/***/ }),

/***/ 7993:
/***/ ((module) => {

"use strict";


module.exports = locate

function locate(value, fromIndex) {
  return value.indexOf('`', fromIndex)
}


/***/ }),

/***/ 443:
/***/ ((module) => {

"use strict";


module.exports = locate

function locate(value, fromIndex) {
  return value.indexOf('~~', fromIndex)
}


/***/ }),

/***/ 6131:
/***/ ((module) => {

"use strict";


module.exports = locate

function locate(value, fromIndex) {
  var asterisk = value.indexOf('*', fromIndex)
  var underscore = value.indexOf('_', fromIndex)

  if (underscore === -1) {
    return asterisk
  }

  if (asterisk === -1) {
    return underscore
  }

  return underscore < asterisk ? underscore : asterisk
}


/***/ }),

/***/ 3951:
/***/ ((module) => {

"use strict";


module.exports = locate

function locate(value, fromIndex) {
  return value.indexOf('\\', fromIndex)
}


/***/ }),

/***/ 5460:
/***/ ((module) => {

"use strict";


module.exports = locate

function locate(value, fromIndex) {
  var link = value.indexOf('[', fromIndex)
  var image = value.indexOf('![', fromIndex)

  if (image === -1) {
    return link
  }

  // Link can never be `-1` if an image is found, so we don’t need to check
  // for that :)
  return link < image ? link : image
}


/***/ }),

/***/ 1594:
/***/ ((module) => {

"use strict";


module.exports = locate

function locate(value, fromIndex) {
  var asterisk = value.indexOf('**', fromIndex)
  var underscore = value.indexOf('__', fromIndex)

  if (underscore === -1) {
    return asterisk
  }

  if (asterisk === -1) {
    return underscore
  }

  return underscore < asterisk ? underscore : asterisk
}


/***/ }),

/***/ 4329:
/***/ ((module) => {

"use strict";


module.exports = locate

function locate(value, fromIndex) {
  return value.indexOf('<', fromIndex)
}


/***/ }),

/***/ 1020:
/***/ ((module) => {

"use strict";


module.exports = locate

var protocols = ['https://', 'http://', 'mailto:']

function locate(value, fromIndex) {
  var length = protocols.length
  var index = -1
  var min = -1
  var position

  if (!this.options.gfm) {
    return -1
  }

  while (++index < length) {
    position = value.indexOf(protocols[index], fromIndex)

    if (position !== -1 && (position < min || min === -1)) {
      min = position
    }
  }

  return min
}


/***/ }),

/***/ 4604:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var xtend = __webpack_require__(7529)
var removePosition = __webpack_require__(3183)

module.exports = parse

var lineFeed = '\n'
var lineBreaksExpression = /\r\n|\r/g

// Parse the bound file.
function parse() {
  var self = this
  var value = String(self.file)
  var start = {line: 1, column: 1, offset: 0}
  var content = xtend(start)
  var node

  // Clean non-unix newlines: `\r\n` and `\r` are all changed to `\n`.
  // This should not affect positional information.
  value = value.replace(lineBreaksExpression, lineFeed)

  // BOM.
  if (value.charCodeAt(0) === 0xfeff) {
    value = value.slice(1)

    content.column++
    content.offset++
  }

  node = {
    type: 'root',
    children: self.tokenizeBlock(value, content),
    position: {start: start, end: self.eof || xtend(start)}
  }

  if (!self.options.position) {
    removePosition(node, true)
  }

  return node
}


/***/ }),

/***/ 970:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var xtend = __webpack_require__(7529)
var toggle = __webpack_require__(78)
var vfileLocation = __webpack_require__(4787)
var unescape = __webpack_require__(2816)
var decode = __webpack_require__(4870)
var tokenizer = __webpack_require__(6691)

module.exports = Parser

function Parser(doc, file) {
  this.file = file
  this.offset = {}
  this.options = xtend(this.options)
  this.setOptions({})

  this.inList = false
  this.inBlock = false
  this.inLink = false
  this.atStart = true

  this.toOffset = vfileLocation(file).toOffset
  this.unescape = unescape(this, 'escape')
  this.decode = decode(this)
}

var proto = Parser.prototype

// Expose core.
proto.setOptions = __webpack_require__(7870)
proto.parse = __webpack_require__(4604)

// Expose `defaults`.
proto.options = __webpack_require__(8515)

// Enter and exit helpers.
proto.exitStart = toggle('atStart', true)
proto.enterList = toggle('inList', false)
proto.enterLink = toggle('inLink', false)
proto.enterBlock = toggle('inBlock', false)

// Nodes that can interupt a paragraph:
//
// ```markdown
// A paragraph, followed by a thematic break.
// ___
// ```
//
// In the above example, the thematic break “interupts” the paragraph.
proto.interruptParagraph = [
  ['thematicBreak'],
  ['atxHeading'],
  ['fencedCode'],
  ['blockquote'],
  ['html'],
  ['setextHeading', {commonmark: false}],
  ['definition', {commonmark: false}],
  ['footnote', {commonmark: false}]
]

// Nodes that can interupt a list:
//
// ```markdown
// - One
// ___
// ```
//
// In the above example, the thematic break “interupts” the list.
proto.interruptList = [
  ['atxHeading', {pedantic: false}],
  ['fencedCode', {pedantic: false}],
  ['thematicBreak', {pedantic: false}],
  ['definition', {commonmark: false}],
  ['footnote', {commonmark: false}]
]

// Nodes that can interupt a blockquote:
//
// ```markdown
// > A paragraph.
// ___
// ```
//
// In the above example, the thematic break “interupts” the blockquote.
proto.interruptBlockquote = [
  ['indentedCode', {commonmark: true}],
  ['fencedCode', {commonmark: true}],
  ['atxHeading', {commonmark: true}],
  ['setextHeading', {commonmark: true}],
  ['thematicBreak', {commonmark: true}],
  ['html', {commonmark: true}],
  ['list', {commonmark: true}],
  ['definition', {commonmark: false}],
  ['footnote', {commonmark: false}]
]

// Handlers.
proto.blockTokenizers = {
  newline: __webpack_require__(3885),
  indentedCode: __webpack_require__(1018),
  fencedCode: __webpack_require__(4967),
  blockquote: __webpack_require__(1153),
  atxHeading: __webpack_require__(2867),
  thematicBreak: __webpack_require__(9111),
  list: __webpack_require__(8332),
  setextHeading: __webpack_require__(6530),
  html: __webpack_require__(5215),
  footnote: __webpack_require__(8574),
  definition: __webpack_require__(856),
  table: __webpack_require__(8029),
  paragraph: __webpack_require__(2431)
}

proto.inlineTokenizers = {
  escape: __webpack_require__(4833),
  autoLink: __webpack_require__(6507),
  url: __webpack_require__(5044),
  html: __webpack_require__(3943),
  link: __webpack_require__(8685),
  reference: __webpack_require__(7551),
  strong: __webpack_require__(1420),
  emphasis: __webpack_require__(8210),
  deletion: __webpack_require__(2967),
  code: __webpack_require__(9698),
  break: __webpack_require__(9310),
  text: __webpack_require__(4278)
}

// Expose precedence.
proto.blockMethods = keys(proto.blockTokenizers)
proto.inlineMethods = keys(proto.inlineTokenizers)

// Tokenizers.
proto.tokenizeBlock = tokenizer('block')
proto.tokenizeInline = tokenizer('inline')
proto.tokenizeFactory = tokenizer

// Get all keys in `value`.
function keys(value) {
  var result = []
  var key

  for (key in value) {
    result.push(key)
  }

  return result
}


/***/ }),

/***/ 7870:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var xtend = __webpack_require__(7529)
var escapes = __webpack_require__(2123)
var defaults = __webpack_require__(8515)

module.exports = setOptions

function setOptions(options) {
  var self = this
  var current = self.options
  var key
  var value

  if (options == null) {
    options = {}
  } else if (typeof options === 'object') {
    options = xtend(options)
  } else {
    throw new Error('Invalid value `' + options + '` for setting `options`')
  }

  for (key in defaults) {
    value = options[key]

    if (value == null) {
      value = current[key]
    }

    if (
      (key !== 'blocks' && typeof value !== 'boolean') ||
      (key === 'blocks' && typeof value !== 'object')
    ) {
      throw new Error(
        'Invalid value `' + value + '` for setting `options.' + key + '`'
      )
    }

    options[key] = value
  }

  self.options = options
  self.escape = escapes(options)

  return self
}


/***/ }),

/***/ 6507:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var whitespace = __webpack_require__(2139)
var decode = __webpack_require__(7574)
var locate = __webpack_require__(4329)

module.exports = autoLink
autoLink.locator = locate
autoLink.notInLink = true

var lessThan = '<'
var greaterThan = '>'
var atSign = '@'
var slash = '/'
var mailto = 'mailto:'
var mailtoLength = mailto.length

function autoLink(eat, value, silent) {
  var self = this
  var subvalue = ''
  var length = value.length
  var index = 0
  var queue = ''
  var hasAtCharacter = false
  var link = ''
  var character
  var now
  var content
  var tokenizers
  var exit

  if (value.charAt(0) !== lessThan) {
    return
  }

  index++
  subvalue = lessThan

  while (index < length) {
    character = value.charAt(index)

    if (
      whitespace(character) ||
      character === greaterThan ||
      character === atSign ||
      (character === ':' && value.charAt(index + 1) === slash)
    ) {
      break
    }

    queue += character
    index++
  }

  if (!queue) {
    return
  }

  link += queue
  queue = ''

  character = value.charAt(index)
  link += character
  index++

  if (character === atSign) {
    hasAtCharacter = true
  } else {
    if (character !== ':' || value.charAt(index + 1) !== slash) {
      return
    }

    link += slash
    index++
  }

  while (index < length) {
    character = value.charAt(index)

    if (whitespace(character) || character === greaterThan) {
      break
    }

    queue += character
    index++
  }

  character = value.charAt(index)

  if (!queue || character !== greaterThan) {
    return
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true
  }

  link += queue
  content = link
  subvalue += link + character
  now = eat.now()
  now.column++
  now.offset++

  if (hasAtCharacter) {
    if (link.slice(0, mailtoLength).toLowerCase() === mailto) {
      content = content.slice(mailtoLength)
      now.column += mailtoLength
      now.offset += mailtoLength
    } else {
      link = mailto + link
    }
  }

  // Temporarily remove all tokenizers except text in autolinks.
  tokenizers = self.inlineTokenizers
  self.inlineTokenizers = {text: tokenizers.text}

  exit = self.enterLink()

  content = self.tokenizeInline(content, now)

  self.inlineTokenizers = tokenizers
  exit()

  return eat(subvalue)({
    type: 'link',
    title: null,
    url: decode(link, {nonTerminated: false}),
    children: content
  })
}


/***/ }),

/***/ 1153:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var trim = __webpack_require__(3059)
var interrupt = __webpack_require__(6588)

module.exports = blockquote

var lineFeed = '\n'
var tab = '\t'
var space = ' '
var greaterThan = '>'

function blockquote(eat, value, silent) {
  var self = this
  var offsets = self.offset
  var tokenizers = self.blockTokenizers
  var interruptors = self.interruptBlockquote
  var now = eat.now()
  var currentLine = now.line
  var length = value.length
  var values = []
  var contents = []
  var indents = []
  var add
  var index = 0
  var character
  var rest
  var nextIndex
  var content
  var line
  var startIndex
  var prefixed
  var exit

  while (index < length) {
    character = value.charAt(index)

    if (character !== space && character !== tab) {
      break
    }

    index++
  }

  if (value.charAt(index) !== greaterThan) {
    return
  }

  if (silent) {
    return true
  }

  index = 0

  while (index < length) {
    nextIndex = value.indexOf(lineFeed, index)
    startIndex = index
    prefixed = false

    if (nextIndex === -1) {
      nextIndex = length
    }

    while (index < length) {
      character = value.charAt(index)

      if (character !== space && character !== tab) {
        break
      }

      index++
    }

    if (value.charAt(index) === greaterThan) {
      index++
      prefixed = true

      if (value.charAt(index) === space) {
        index++
      }
    } else {
      index = startIndex
    }

    content = value.slice(index, nextIndex)

    if (!prefixed && !trim(content)) {
      index = startIndex
      break
    }

    if (!prefixed) {
      rest = value.slice(index)

      // Check if the following code contains a possible block.
      if (interrupt(interruptors, tokenizers, self, [eat, rest, true])) {
        break
      }
    }

    line = startIndex === index ? content : value.slice(startIndex, nextIndex)

    indents.push(index - startIndex)
    values.push(line)
    contents.push(content)

    index = nextIndex + 1
  }

  index = -1
  length = indents.length
  add = eat(values.join(lineFeed))

  while (++index < length) {
    offsets[currentLine] = (offsets[currentLine] || 0) + indents[index]
    currentLine++
  }

  exit = self.enterBlock()
  contents = self.tokenizeBlock(contents.join(lineFeed), now)
  exit()

  return add({type: 'blockquote', children: contents})
}


/***/ }),

/***/ 9310:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var locate = __webpack_require__(3047)

module.exports = hardBreak
hardBreak.locator = locate

var space = ' '
var lineFeed = '\n'
var minBreakLength = 2

function hardBreak(eat, value, silent) {
  var length = value.length
  var index = -1
  var queue = ''
  var character

  while (++index < length) {
    character = value.charAt(index)

    if (character === lineFeed) {
      if (index < minBreakLength) {
        return
      }

      /* istanbul ignore if - never used (yet) */
      if (silent) {
        return true
      }

      queue += character

      return eat(queue)({type: 'break'})
    }

    if (character !== space) {
      return
    }

    queue += character
  }
}


/***/ }),

/***/ 4967:
/***/ ((module) => {

"use strict";


module.exports = fencedCode

var lineFeed = '\n'
var tab = '\t'
var space = ' '
var tilde = '~'
var graveAccent = '`'

var minFenceCount = 3
var tabSize = 4

function fencedCode(eat, value, silent) {
  var self = this
  var gfm = self.options.gfm
  var length = value.length + 1
  var index = 0
  var subvalue = ''
  var fenceCount
  var marker
  var character
  var flag
  var lang
  var meta
  var queue
  var content
  var exdentedContent
  var closing
  var exdentedClosing
  var indent
  var now

  if (!gfm) {
    return
  }

  // Eat initial spacing.
  while (index < length) {
    character = value.charAt(index)

    if (character !== space && character !== tab) {
      break
    }

    subvalue += character
    index++
  }

  indent = index

  // Eat the fence.
  character = value.charAt(index)

  if (character !== tilde && character !== graveAccent) {
    return
  }

  index++
  marker = character
  fenceCount = 1
  subvalue += character

  while (index < length) {
    character = value.charAt(index)

    if (character !== marker) {
      break
    }

    subvalue += character
    fenceCount++
    index++
  }

  if (fenceCount < minFenceCount) {
    return
  }

  // Eat spacing before flag.
  while (index < length) {
    character = value.charAt(index)

    if (character !== space && character !== tab) {
      break
    }

    subvalue += character
    index++
  }

  // Eat flag.
  flag = ''
  queue = ''

  while (index < length) {
    character = value.charAt(index)

    if (
      character === lineFeed ||
      (marker === graveAccent && character === marker)
    ) {
      break
    }

    if (character === space || character === tab) {
      queue += character
    } else {
      flag += queue + character
      queue = ''
    }

    index++
  }

  character = value.charAt(index)

  if (character && character !== lineFeed) {
    return
  }

  if (silent) {
    return true
  }

  now = eat.now()
  now.column += subvalue.length
  now.offset += subvalue.length

  subvalue += flag
  flag = self.decode.raw(self.unescape(flag), now)

  if (queue) {
    subvalue += queue
  }

  queue = ''
  closing = ''
  exdentedClosing = ''
  content = ''
  exdentedContent = ''
  var skip = true

  // Eat content.
  while (index < length) {
    character = value.charAt(index)
    content += closing
    exdentedContent += exdentedClosing
    closing = ''
    exdentedClosing = ''

    if (character !== lineFeed) {
      content += character
      exdentedClosing += character
      index++
      continue
    }

    // The first line feed is ignored. Others aren’t.
    if (skip) {
      subvalue += character
      skip = false
    } else {
      closing += character
      exdentedClosing += character
    }

    queue = ''
    index++

    while (index < length) {
      character = value.charAt(index)

      if (character !== space) {
        break
      }

      queue += character
      index++
    }

    closing += queue
    exdentedClosing += queue.slice(indent)

    if (queue.length >= tabSize) {
      continue
    }

    queue = ''

    while (index < length) {
      character = value.charAt(index)

      if (character !== marker) {
        break
      }

      queue += character
      index++
    }

    closing += queue
    exdentedClosing += queue

    if (queue.length < fenceCount) {
      continue
    }

    queue = ''

    while (index < length) {
      character = value.charAt(index)

      if (character !== space && character !== tab) {
        break
      }

      closing += character
      exdentedClosing += character
      index++
    }

    if (!character || character === lineFeed) {
      break
    }
  }

  subvalue += content + closing

  // Get lang and meta from the flag.
  index = -1
  length = flag.length

  while (++index < length) {
    character = flag.charAt(index)

    if (character === space || character === tab) {
      if (!lang) {
        lang = flag.slice(0, index)
      }
    } else if (lang) {
      meta = flag.slice(index)
      break
    }
  }

  return eat(subvalue)({
    type: 'code',
    lang: lang || flag || null,
    meta: meta || null,
    value: exdentedContent
  })
}


/***/ }),

/***/ 1018:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var repeat = __webpack_require__(6464)
var trim = __webpack_require__(7257)

module.exports = indentedCode

var lineFeed = '\n'
var tab = '\t'
var space = ' '

var tabSize = 4
var codeIndent = repeat(space, tabSize)

function indentedCode(eat, value, silent) {
  var index = -1
  var length = value.length
  var subvalue = ''
  var content = ''
  var subvalueQueue = ''
  var contentQueue = ''
  var character
  var blankQueue
  var indent

  while (++index < length) {
    character = value.charAt(index)

    if (indent) {
      indent = false

      subvalue += subvalueQueue
      content += contentQueue
      subvalueQueue = ''
      contentQueue = ''

      if (character === lineFeed) {
        subvalueQueue = character
        contentQueue = character
      } else {
        subvalue += character
        content += character

        while (++index < length) {
          character = value.charAt(index)

          if (!character || character === lineFeed) {
            contentQueue = character
            subvalueQueue = character
            break
          }

          subvalue += character
          content += character
        }
      }
    } else if (
      character === space &&
      value.charAt(index + 1) === character &&
      value.charAt(index + 2) === character &&
      value.charAt(index + 3) === character
    ) {
      subvalueQueue += codeIndent
      index += 3
      indent = true
    } else if (character === tab) {
      subvalueQueue += character
      indent = true
    } else {
      blankQueue = ''

      while (character === tab || character === space) {
        blankQueue += character
        character = value.charAt(++index)
      }

      if (character !== lineFeed) {
        break
      }

      subvalueQueue += blankQueue + character
      contentQueue += character
    }
  }

  if (content) {
    if (silent) {
      return true
    }

    return eat(subvalue)({
      type: 'code',
      lang: null,
      meta: null,
      value: trim(content)
    })
  }
}


/***/ }),

/***/ 9698:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var locate = __webpack_require__(7993)

module.exports = inlineCode
inlineCode.locator = locate

var lineFeed = 10 //  '\n'
var space = 32 // ' '
var graveAccent = 96 //  '`'

function inlineCode(eat, value, silent) {
  var length = value.length
  var index = 0
  var openingFenceEnd
  var closingFenceStart
  var closingFenceEnd
  var code
  var next
  var found

  while (index < length) {
    if (value.charCodeAt(index) !== graveAccent) {
      break
    }

    index++
  }

  if (index === 0 || index === length) {
    return
  }

  openingFenceEnd = index
  next = value.charCodeAt(index)

  while (index < length) {
    code = next
    next = value.charCodeAt(index + 1)

    if (code === graveAccent) {
      if (closingFenceStart === undefined) {
        closingFenceStart = index
      }

      closingFenceEnd = index + 1

      if (
        next !== graveAccent &&
        closingFenceEnd - closingFenceStart === openingFenceEnd
      ) {
        found = true
        break
      }
    } else if (closingFenceStart !== undefined) {
      closingFenceStart = undefined
      closingFenceEnd = undefined
    }

    index++
  }

  if (!found) {
    return
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true
  }

  // Remove the initial and final space (or line feed), iff they exist and there
  // are non-space characters in the content.
  index = openingFenceEnd
  length = closingFenceStart
  code = value.charCodeAt(index)
  next = value.charCodeAt(length - 1)
  found = false

  if (
    length - index > 2 &&
    (code === space || code === lineFeed) &&
    (next === space || next === lineFeed)
  ) {
    index++
    length--

    while (index < length) {
      code = value.charCodeAt(index)

      if (code !== space && code !== lineFeed) {
        found = true
        break
      }

      index++
    }

    if (found === true) {
      openingFenceEnd++
      closingFenceStart--
    }
  }

  return eat(value.slice(0, closingFenceEnd))({
    type: 'inlineCode',
    value: value.slice(openingFenceEnd, closingFenceStart)
  })
}


/***/ }),

/***/ 856:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var whitespace = __webpack_require__(2139)
var normalize = __webpack_require__(4405)

module.exports = definition

var quotationMark = '"'
var apostrophe = "'"
var backslash = '\\'
var lineFeed = '\n'
var tab = '\t'
var space = ' '
var leftSquareBracket = '['
var rightSquareBracket = ']'
var leftParenthesis = '('
var rightParenthesis = ')'
var colon = ':'
var lessThan = '<'
var greaterThan = '>'

function definition(eat, value, silent) {
  var self = this
  var commonmark = self.options.commonmark
  var index = 0
  var length = value.length
  var subvalue = ''
  var beforeURL
  var beforeTitle
  var queue
  var character
  var test
  var identifier
  var url
  var title

  while (index < length) {
    character = value.charAt(index)

    if (character !== space && character !== tab) {
      break
    }

    subvalue += character
    index++
  }

  character = value.charAt(index)

  if (character !== leftSquareBracket) {
    return
  }

  index++
  subvalue += character
  queue = ''

  while (index < length) {
    character = value.charAt(index)

    if (character === rightSquareBracket) {
      break
    } else if (character === backslash) {
      queue += character
      index++
      character = value.charAt(index)
    }

    queue += character
    index++
  }

  if (
    !queue ||
    value.charAt(index) !== rightSquareBracket ||
    value.charAt(index + 1) !== colon
  ) {
    return
  }

  identifier = queue
  subvalue += queue + rightSquareBracket + colon
  index = subvalue.length
  queue = ''

  while (index < length) {
    character = value.charAt(index)

    if (character !== tab && character !== space && character !== lineFeed) {
      break
    }

    subvalue += character
    index++
  }

  character = value.charAt(index)
  queue = ''
  beforeURL = subvalue

  if (character === lessThan) {
    index++

    while (index < length) {
      character = value.charAt(index)

      if (!isEnclosedURLCharacter(character)) {
        break
      }

      queue += character
      index++
    }

    character = value.charAt(index)

    if (character === isEnclosedURLCharacter.delimiter) {
      subvalue += lessThan + queue + character
      index++
    } else {
      if (commonmark) {
        return
      }

      index -= queue.length + 1
      queue = ''
    }
  }

  if (!queue) {
    while (index < length) {
      character = value.charAt(index)

      if (!isUnclosedURLCharacter(character)) {
        break
      }

      queue += character
      index++
    }

    subvalue += queue
  }

  if (!queue) {
    return
  }

  url = queue
  queue = ''

  while (index < length) {
    character = value.charAt(index)

    if (character !== tab && character !== space && character !== lineFeed) {
      break
    }

    queue += character
    index++
  }

  character = value.charAt(index)
  test = null

  if (character === quotationMark) {
    test = quotationMark
  } else if (character === apostrophe) {
    test = apostrophe
  } else if (character === leftParenthesis) {
    test = rightParenthesis
  }

  if (!test) {
    queue = ''
    index = subvalue.length
  } else if (queue) {
    subvalue += queue + character
    index = subvalue.length
    queue = ''

    while (index < length) {
      character = value.charAt(index)

      if (character === test) {
        break
      }

      if (character === lineFeed) {
        index++
        character = value.charAt(index)

        if (character === lineFeed || character === test) {
          return
        }

        queue += lineFeed
      }

      queue += character
      index++
    }

    character = value.charAt(index)

    if (character !== test) {
      return
    }

    beforeTitle = subvalue
    subvalue += queue + character
    index++
    title = queue
    queue = ''
  } else {
    return
  }

  while (index < length) {
    character = value.charAt(index)

    if (character !== tab && character !== space) {
      break
    }

    subvalue += character
    index++
  }

  character = value.charAt(index)

  if (!character || character === lineFeed) {
    if (silent) {
      return true
    }

    beforeURL = eat(beforeURL).test().end
    url = self.decode.raw(self.unescape(url), beforeURL, {nonTerminated: false})

    if (title) {
      beforeTitle = eat(beforeTitle).test().end
      title = self.decode.raw(self.unescape(title), beforeTitle)
    }

    return eat(subvalue)({
      type: 'definition',
      identifier: normalize(identifier),
      label: identifier,
      title: title || null,
      url: url
    })
  }
}

// Check if `character` can be inside an enclosed URI.
function isEnclosedURLCharacter(character) {
  return (
    character !== greaterThan &&
    character !== leftSquareBracket &&
    character !== rightSquareBracket
  )
}

isEnclosedURLCharacter.delimiter = greaterThan

// Check if `character` can be inside an unclosed URI.
function isUnclosedURLCharacter(character) {
  return (
    character !== leftSquareBracket &&
    character !== rightSquareBracket &&
    !whitespace(character)
  )
}


/***/ }),

/***/ 2967:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var whitespace = __webpack_require__(2139)
var locate = __webpack_require__(443)

module.exports = strikethrough
strikethrough.locator = locate

var tilde = '~'
var fence = '~~'

function strikethrough(eat, value, silent) {
  var self = this
  var character = ''
  var previous = ''
  var preceding = ''
  var subvalue = ''
  var index
  var length
  var now

  if (
    !self.options.gfm ||
    value.charAt(0) !== tilde ||
    value.charAt(1) !== tilde ||
    whitespace(value.charAt(2))
  ) {
    return
  }

  index = 1
  length = value.length
  now = eat.now()
  now.column += 2
  now.offset += 2

  while (++index < length) {
    character = value.charAt(index)

    if (
      character === tilde &&
      previous === tilde &&
      (!preceding || !whitespace(preceding))
    ) {
      /* istanbul ignore if - never used (yet) */
      if (silent) {
        return true
      }

      return eat(fence + subvalue + fence)({
        type: 'delete',
        children: self.tokenizeInline(subvalue, now)
      })
    }

    subvalue += previous
    preceding = previous
    previous = character
  }
}


/***/ }),

/***/ 8210:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var trim = __webpack_require__(3059)
var word = __webpack_require__(3017)
var whitespace = __webpack_require__(2139)
var locate = __webpack_require__(6131)

module.exports = emphasis
emphasis.locator = locate

var asterisk = '*'
var underscore = '_'
var backslash = '\\'

function emphasis(eat, value, silent) {
  var self = this
  var index = 0
  var character = value.charAt(index)
  var now
  var pedantic
  var marker
  var queue
  var subvalue
  var length
  var prev

  if (character !== asterisk && character !== underscore) {
    return
  }

  pedantic = self.options.pedantic
  subvalue = character
  marker = character
  length = value.length
  index++
  queue = ''
  character = ''

  if (pedantic && whitespace(value.charAt(index))) {
    return
  }

  while (index < length) {
    prev = character
    character = value.charAt(index)

    if (character === marker && (!pedantic || !whitespace(prev))) {
      character = value.charAt(++index)

      if (character !== marker) {
        if (!trim(queue) || prev === marker) {
          return
        }

        if (!pedantic && marker === underscore && word(character)) {
          queue += marker
          continue
        }

        /* istanbul ignore if - never used (yet) */
        if (silent) {
          return true
        }

        now = eat.now()
        now.column++
        now.offset++

        return eat(subvalue + queue + marker)({
          type: 'emphasis',
          children: self.tokenizeInline(queue, now)
        })
      }

      queue += marker
    }

    if (!pedantic && character === backslash) {
      queue += character
      character = value.charAt(++index)
    }

    queue += character
    index++
  }
}


/***/ }),

/***/ 4833:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var locate = __webpack_require__(3951)

module.exports = escape
escape.locator = locate

var lineFeed = '\n'
var backslash = '\\'

function escape(eat, value, silent) {
  var self = this
  var character
  var node

  if (value.charAt(0) === backslash) {
    character = value.charAt(1)

    if (self.escape.indexOf(character) !== -1) {
      /* istanbul ignore if - never used (yet) */
      if (silent) {
        return true
      }

      if (character === lineFeed) {
        node = {type: 'break'}
      } else {
        node = {type: 'text', value: character}
      }

      return eat(backslash + character)(node)
    }
  }
}


/***/ }),

/***/ 8574:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var whitespace = __webpack_require__(2139)
var normalize = __webpack_require__(4405)

module.exports = footnoteDefinition
footnoteDefinition.notInList = true
footnoteDefinition.notInBlock = true

var backslash = '\\'
var lineFeed = '\n'
var tab = '\t'
var space = ' '
var leftSquareBracket = '['
var rightSquareBracket = ']'
var caret = '^'
var colon = ':'

var EXPRESSION_INITIAL_TAB = /^( {4}|\t)?/gm

function footnoteDefinition(eat, value, silent) {
  var self = this
  var offsets = self.offset
  var index
  var length
  var subvalue
  var now
  var currentLine
  var content
  var queue
  var subqueue
  var character
  var identifier
  var add
  var exit

  if (!self.options.footnotes) {
    return
  }

  index = 0
  length = value.length
  subvalue = ''
  now = eat.now()
  currentLine = now.line

  while (index < length) {
    character = value.charAt(index)

    if (!whitespace(character)) {
      break
    }

    subvalue += character
    index++
  }

  if (
    value.charAt(index) !== leftSquareBracket ||
    value.charAt(index + 1) !== caret
  ) {
    return
  }

  subvalue += leftSquareBracket + caret
  index = subvalue.length
  queue = ''

  while (index < length) {
    character = value.charAt(index)

    if (character === rightSquareBracket) {
      break
    } else if (character === backslash) {
      queue += character
      index++
      character = value.charAt(index)
    }

    queue += character
    index++
  }

  if (
    !queue ||
    value.charAt(index) !== rightSquareBracket ||
    value.charAt(index + 1) !== colon
  ) {
    return
  }

  if (silent) {
    return true
  }

  identifier = queue
  subvalue += queue + rightSquareBracket + colon
  index = subvalue.length

  while (index < length) {
    character = value.charAt(index)

    if (character !== tab && character !== space) {
      break
    }

    subvalue += character
    index++
  }

  now.column += subvalue.length
  now.offset += subvalue.length
  queue = ''
  content = ''
  subqueue = ''

  while (index < length) {
    character = value.charAt(index)

    if (character === lineFeed) {
      subqueue = character
      index++

      while (index < length) {
        character = value.charAt(index)

        if (character !== lineFeed) {
          break
        }

        subqueue += character
        index++
      }

      queue += subqueue
      subqueue = ''

      while (index < length) {
        character = value.charAt(index)

        if (character !== space) {
          break
        }

        subqueue += character
        index++
      }

      if (subqueue.length === 0) {
        break
      }

      queue += subqueue
    }

    if (queue) {
      content += queue
      queue = ''
    }

    content += character
    index++
  }

  subvalue += content

  content = content.replace(EXPRESSION_INITIAL_TAB, function(line) {
    offsets[currentLine] = (offsets[currentLine] || 0) + line.length
    currentLine++

    return ''
  })

  add = eat(subvalue)

  exit = self.enterBlock()
  content = self.tokenizeBlock(content, now)
  exit()

  return add({
    type: 'footnoteDefinition',
    identifier: normalize(identifier),
    label: identifier,
    children: content
  })
}


/***/ }),

/***/ 2867:
/***/ ((module) => {

"use strict";


module.exports = atxHeading

var lineFeed = '\n'
var tab = '\t'
var space = ' '
var numberSign = '#'

var maxFenceCount = 6

function atxHeading(eat, value, silent) {
  var self = this
  var pedantic = self.options.pedantic
  var length = value.length + 1
  var index = -1
  var now = eat.now()
  var subvalue = ''
  var content = ''
  var character
  var queue
  var depth

  // Eat initial spacing.
  while (++index < length) {
    character = value.charAt(index)

    if (character !== space && character !== tab) {
      index--
      break
    }

    subvalue += character
  }

  // Eat hashes.
  depth = 0

  while (++index <= length) {
    character = value.charAt(index)

    if (character !== numberSign) {
      index--
      break
    }

    subvalue += character
    depth++
  }

  if (depth > maxFenceCount) {
    return
  }

  if (!depth || (!pedantic && value.charAt(index + 1) === numberSign)) {
    return
  }

  length = value.length + 1

  // Eat intermediate white-space.
  queue = ''

  while (++index < length) {
    character = value.charAt(index)

    if (character !== space && character !== tab) {
      index--
      break
    }

    queue += character
  }

  // Exit when not in pedantic mode without spacing.
  if (!pedantic && queue.length === 0 && character && character !== lineFeed) {
    return
  }

  if (silent) {
    return true
  }

  // Eat content.
  subvalue += queue
  queue = ''
  content = ''

  while (++index < length) {
    character = value.charAt(index)

    if (!character || character === lineFeed) {
      break
    }

    if (character !== space && character !== tab && character !== numberSign) {
      content += queue + character
      queue = ''
      continue
    }

    while (character === space || character === tab) {
      queue += character
      character = value.charAt(++index)
    }

    // `#` without a queue is part of the content.
    if (!pedantic && content && !queue && character === numberSign) {
      content += character
      continue
    }

    while (character === numberSign) {
      queue += character
      character = value.charAt(++index)
    }

    while (character === space || character === tab) {
      queue += character
      character = value.charAt(++index)
    }

    index--
  }

  now.column += subvalue.length
  now.offset += subvalue.length
  subvalue += content + queue

  return eat(subvalue)({
    type: 'heading',
    depth: depth,
    children: self.tokenizeInline(content, now)
  })
}


/***/ }),

/***/ 6530:
/***/ ((module) => {

"use strict";


module.exports = setextHeading

var lineFeed = '\n'
var tab = '\t'
var space = ' '
var equalsTo = '='
var dash = '-'

var maxIndent = 3

var equalsToDepth = 1
var dashDepth = 2

function setextHeading(eat, value, silent) {
  var self = this
  var now = eat.now()
  var length = value.length
  var index = -1
  var subvalue = ''
  var content
  var queue
  var character
  var marker
  var depth

  // Eat initial indentation.
  while (++index < length) {
    character = value.charAt(index)

    if (character !== space || index >= maxIndent) {
      index--
      break
    }

    subvalue += character
  }

  // Eat content.
  content = ''
  queue = ''

  while (++index < length) {
    character = value.charAt(index)

    if (character === lineFeed) {
      index--
      break
    }

    if (character === space || character === tab) {
      queue += character
    } else {
      content += queue + character
      queue = ''
    }
  }

  now.column += subvalue.length
  now.offset += subvalue.length
  subvalue += content + queue

  // Ensure the content is followed by a newline and a valid marker.
  character = value.charAt(++index)
  marker = value.charAt(++index)

  if (character !== lineFeed || (marker !== equalsTo && marker !== dash)) {
    return
  }

  subvalue += character

  // Eat Setext-line.
  queue = marker
  depth = marker === equalsTo ? equalsToDepth : dashDepth

  while (++index < length) {
    character = value.charAt(index)

    if (character !== marker) {
      if (character !== lineFeed) {
        return
      }

      index--
      break
    }

    queue += character
  }

  if (silent) {
    return true
  }

  return eat(subvalue + queue)({
    type: 'heading',
    depth: depth,
    children: self.tokenizeInline(content, now)
  })
}


/***/ }),

/***/ 5215:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var openCloseTag = (__webpack_require__(4706)/* .openCloseTag */ .g)

module.exports = blockHtml

var tab = '\t'
var space = ' '
var lineFeed = '\n'
var lessThan = '<'

var rawOpenExpression = /^<(script|pre|style)(?=(\s|>|$))/i
var rawCloseExpression = /<\/(script|pre|style)>/i
var commentOpenExpression = /^<!--/
var commentCloseExpression = /-->/
var instructionOpenExpression = /^<\?/
var instructionCloseExpression = /\?>/
var directiveOpenExpression = /^<![A-Za-z]/
var directiveCloseExpression = />/
var cdataOpenExpression = /^<!\[CDATA\[/
var cdataCloseExpression = /\]\]>/
var elementCloseExpression = /^$/
var otherElementOpenExpression = new RegExp(openCloseTag.source + '\\s*$')

function blockHtml(eat, value, silent) {
  var self = this
  var blocks = self.options.blocks.join('|')
  var elementOpenExpression = new RegExp(
    '^</?(' + blocks + ')(?=(\\s|/?>|$))',
    'i'
  )
  var length = value.length
  var index = 0
  var next
  var line
  var offset
  var character
  var count
  var sequence
  var subvalue

  var sequences = [
    [rawOpenExpression, rawCloseExpression, true],
    [commentOpenExpression, commentCloseExpression, true],
    [instructionOpenExpression, instructionCloseExpression, true],
    [directiveOpenExpression, directiveCloseExpression, true],
    [cdataOpenExpression, cdataCloseExpression, true],
    [elementOpenExpression, elementCloseExpression, true],
    [otherElementOpenExpression, elementCloseExpression, false]
  ]

  // Eat initial spacing.
  while (index < length) {
    character = value.charAt(index)

    if (character !== tab && character !== space) {
      break
    }

    index++
  }

  if (value.charAt(index) !== lessThan) {
    return
  }

  next = value.indexOf(lineFeed, index + 1)
  next = next === -1 ? length : next
  line = value.slice(index, next)
  offset = -1
  count = sequences.length

  while (++offset < count) {
    if (sequences[offset][0].test(line)) {
      sequence = sequences[offset]
      break
    }
  }

  if (!sequence) {
    return
  }

  if (silent) {
    return sequence[2]
  }

  index = next

  if (!sequence[1].test(line)) {
    while (index < length) {
      next = value.indexOf(lineFeed, index + 1)
      next = next === -1 ? length : next
      line = value.slice(index + 1, next)

      if (sequence[1].test(line)) {
        if (line) {
          index = next
        }

        break
      }

      index = next
    }
  }

  subvalue = value.slice(0, index)

  return eat(subvalue)({type: 'html', value: subvalue})
}


/***/ }),

/***/ 3943:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var alphabetical = __webpack_require__(6260)
var locate = __webpack_require__(4329)
var tag = (__webpack_require__(4706)/* .tag */ ._)

module.exports = inlineHTML
inlineHTML.locator = locate

var lessThan = '<'
var questionMark = '?'
var exclamationMark = '!'
var slash = '/'

var htmlLinkOpenExpression = /^<a /i
var htmlLinkCloseExpression = /^<\/a>/i

function inlineHTML(eat, value, silent) {
  var self = this
  var length = value.length
  var character
  var subvalue

  if (value.charAt(0) !== lessThan || length < 3) {
    return
  }

  character = value.charAt(1)

  if (
    !alphabetical(character) &&
    character !== questionMark &&
    character !== exclamationMark &&
    character !== slash
  ) {
    return
  }

  subvalue = value.match(tag)

  if (!subvalue) {
    return
  }

  /* istanbul ignore if - not used yet. */
  if (silent) {
    return true
  }

  subvalue = subvalue[0]

  if (!self.inLink && htmlLinkOpenExpression.test(subvalue)) {
    self.inLink = true
  } else if (self.inLink && htmlLinkCloseExpression.test(subvalue)) {
    self.inLink = false
  }

  return eat(subvalue)({type: 'html', value: subvalue})
}


/***/ }),

/***/ 8685:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var whitespace = __webpack_require__(2139)
var locate = __webpack_require__(5460)

module.exports = link
link.locator = locate

var lineFeed = '\n'
var exclamationMark = '!'
var quotationMark = '"'
var apostrophe = "'"
var leftParenthesis = '('
var rightParenthesis = ')'
var lessThan = '<'
var greaterThan = '>'
var leftSquareBracket = '['
var backslash = '\\'
var rightSquareBracket = ']'
var graveAccent = '`'

function link(eat, value, silent) {
  var self = this
  var subvalue = ''
  var index = 0
  var character = value.charAt(0)
  var pedantic = self.options.pedantic
  var commonmark = self.options.commonmark
  var gfm = self.options.gfm
  var closed
  var count
  var opening
  var beforeURL
  var beforeTitle
  var subqueue
  var hasMarker
  var isImage
  var content
  var marker
  var length
  var title
  var depth
  var queue
  var url
  var now
  var exit
  var node

  // Detect whether this is an image.
  if (character === exclamationMark) {
    isImage = true
    subvalue = character
    character = value.charAt(++index)
  }

  // Eat the opening.
  if (character !== leftSquareBracket) {
    return
  }

  // Exit when this is a link and we’re already inside a link.
  if (!isImage && self.inLink) {
    return
  }

  subvalue += character
  queue = ''
  index++

  // Eat the content.
  length = value.length
  now = eat.now()
  depth = 0

  now.column += index
  now.offset += index

  while (index < length) {
    character = value.charAt(index)
    subqueue = character

    if (character === graveAccent) {
      // Inline-code in link content.
      count = 1

      while (value.charAt(index + 1) === graveAccent) {
        subqueue += character
        index++
        count++
      }

      if (!opening) {
        opening = count
      } else if (count >= opening) {
        opening = 0
      }
    } else if (character === backslash) {
      // Allow brackets to be escaped.
      index++
      subqueue += value.charAt(index)
    } else if ((!opening || gfm) && character === leftSquareBracket) {
      // In GFM mode, brackets in code still count.  In all other modes,
      // they don’t.
      depth++
    } else if ((!opening || gfm) && character === rightSquareBracket) {
      if (depth) {
        depth--
      } else {
        // Allow white-space between content and url in GFM mode.
        if (!pedantic) {
          while (index < length) {
            character = value.charAt(index + 1)

            if (!whitespace(character)) {
              break
            }

            subqueue += character
            index++
          }
        }

        if (value.charAt(index + 1) !== leftParenthesis) {
          return
        }

        subqueue += leftParenthesis
        closed = true
        index++

        break
      }
    }

    queue += subqueue
    subqueue = ''
    index++
  }

  // Eat the content closing.
  if (!closed) {
    return
  }

  content = queue
  subvalue += queue + subqueue
  index++

  // Eat white-space.
  while (index < length) {
    character = value.charAt(index)

    if (!whitespace(character)) {
      break
    }

    subvalue += character
    index++
  }

  // Eat the URL.
  character = value.charAt(index)
  queue = ''
  beforeURL = subvalue

  if (character === lessThan) {
    index++
    beforeURL += lessThan

    while (index < length) {
      character = value.charAt(index)

      if (character === greaterThan) {
        break
      }

      if (commonmark && character === lineFeed) {
        return
      }

      queue += character
      index++
    }

    if (value.charAt(index) !== greaterThan) {
      return
    }

    subvalue += lessThan + queue + greaterThan
    url = queue
    index++
  } else {
    character = null
    subqueue = ''

    while (index < length) {
      character = value.charAt(index)

      if (
        subqueue &&
        (character === quotationMark ||
          character === apostrophe ||
          (commonmark && character === leftParenthesis))
      ) {
        break
      }

      if (whitespace(character)) {
        if (!pedantic) {
          break
        }

        subqueue += character
      } else {
        if (character === leftParenthesis) {
          depth++
        } else if (character === rightParenthesis) {
          if (depth === 0) {
            break
          }

          depth--
        }

        queue += subqueue
        subqueue = ''

        if (character === backslash) {
          queue += backslash
          character = value.charAt(++index)
        }

        queue += character
      }

      index++
    }

    subvalue += queue
    url = queue
    index = subvalue.length
  }

  // Eat white-space.
  queue = ''

  while (index < length) {
    character = value.charAt(index)

    if (!whitespace(character)) {
      break
    }

    queue += character
    index++
  }

  character = value.charAt(index)
  subvalue += queue

  // Eat the title.
  if (
    queue &&
    (character === quotationMark ||
      character === apostrophe ||
      (commonmark && character === leftParenthesis))
  ) {
    index++
    subvalue += character
    queue = ''
    marker = character === leftParenthesis ? rightParenthesis : character
    beforeTitle = subvalue

    // In commonmark-mode, things are pretty easy: the marker cannot occur
    // inside the title.  Non-commonmark does, however, support nested
    // delimiters.
    if (commonmark) {
      while (index < length) {
        character = value.charAt(index)

        if (character === marker) {
          break
        }

        if (character === backslash) {
          queue += backslash
          character = value.charAt(++index)
        }

        index++
        queue += character
      }

      character = value.charAt(index)

      if (character !== marker) {
        return
      }

      title = queue
      subvalue += queue + character
      index++

      while (index < length) {
        character = value.charAt(index)

        if (!whitespace(character)) {
          break
        }

        subvalue += character
        index++
      }
    } else {
      subqueue = ''

      while (index < length) {
        character = value.charAt(index)

        if (character === marker) {
          if (hasMarker) {
            queue += marker + subqueue
            subqueue = ''
          }

          hasMarker = true
        } else if (!hasMarker) {
          queue += character
        } else if (character === rightParenthesis) {
          subvalue += queue + marker + subqueue
          title = queue
          break
        } else if (whitespace(character)) {
          subqueue += character
        } else {
          queue += marker + subqueue + character
          subqueue = ''
          hasMarker = false
        }

        index++
      }
    }
  }

  if (value.charAt(index) !== rightParenthesis) {
    return
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true
  }

  subvalue += rightParenthesis

  url = self.decode.raw(self.unescape(url), eat(beforeURL).test().end, {
    nonTerminated: false
  })

  if (title) {
    beforeTitle = eat(beforeTitle).test().end
    title = self.decode.raw(self.unescape(title), beforeTitle)
  }

  node = {
    type: isImage ? 'image' : 'link',
    title: title || null,
    url: url
  }

  if (isImage) {
    node.alt = self.decode.raw(self.unescape(content), now) || null
  } else {
    exit = self.enterLink()
    node.children = self.tokenizeInline(content, now)
    exit()
  }

  return eat(subvalue)(node)
}


/***/ }),

/***/ 8332:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var trim = __webpack_require__(3059)
var repeat = __webpack_require__(6464)
var decimal = __webpack_require__(6195)
var getIndent = __webpack_require__(2299)
var removeIndent = __webpack_require__(6514)
var interrupt = __webpack_require__(6588)

module.exports = list

var asterisk = '*'
var underscore = '_'
var plusSign = '+'
var dash = '-'
var dot = '.'
var space = ' '
var lineFeed = '\n'
var tab = '\t'
var rightParenthesis = ')'
var lowercaseX = 'x'

var tabSize = 4
var looseListItemExpression = /\n\n(?!\s*$)/
var taskItemExpression = /^\[([ \t]|x|X)][ \t]/
var bulletExpression = /^([ \t]*)([*+-]|\d+[.)])( {1,4}(?! )| |\t|$|(?=\n))([^\n]*)/
var pedanticBulletExpression = /^([ \t]*)([*+-]|\d+[.)])([ \t]+)/
var initialIndentExpression = /^( {1,4}|\t)?/gm

function list(eat, value, silent) {
  var self = this
  var commonmark = self.options.commonmark
  var pedantic = self.options.pedantic
  var tokenizers = self.blockTokenizers
  var interuptors = self.interruptList
  var index = 0
  var length = value.length
  var start = null
  var size = 0
  var queue
  var ordered
  var character
  var marker
  var nextIndex
  var startIndex
  var prefixed
  var currentMarker
  var content
  var line
  var prevEmpty
  var empty
  var items
  var allLines
  var emptyLines
  var item
  var enterTop
  var exitBlockquote
  var spread = false
  var node
  var now
  var end
  var indented

  while (index < length) {
    character = value.charAt(index)

    if (character === tab) {
      size += tabSize - (size % tabSize)
    } else if (character === space) {
      size++
    } else {
      break
    }

    index++
  }

  if (size >= tabSize) {
    return
  }

  character = value.charAt(index)

  if (character === asterisk || character === plusSign || character === dash) {
    marker = character
    ordered = false
  } else {
    ordered = true
    queue = ''

    while (index < length) {
      character = value.charAt(index)

      if (!decimal(character)) {
        break
      }

      queue += character
      index++
    }

    character = value.charAt(index)

    if (
      !queue ||
      !(character === dot || (commonmark && character === rightParenthesis))
    ) {
      return
    }

    start = parseInt(queue, 10)
    marker = character
  }

  character = value.charAt(++index)

  if (
    character !== space &&
    character !== tab &&
    (pedantic || (character !== lineFeed && character !== ''))
  ) {
    return
  }

  if (silent) {
    return true
  }

  index = 0
  items = []
  allLines = []
  emptyLines = []

  while (index < length) {
    nextIndex = value.indexOf(lineFeed, index)
    startIndex = index
    prefixed = false
    indented = false

    if (nextIndex === -1) {
      nextIndex = length
    }

    end = index + tabSize
    size = 0

    while (index < length) {
      character = value.charAt(index)

      if (character === tab) {
        size += tabSize - (size % tabSize)
      } else if (character === space) {
        size++
      } else {
        break
      }

      index++
    }

    if (size >= tabSize) {
      indented = true
    }

    if (item && size >= item.indent) {
      indented = true
    }

    character = value.charAt(index)
    currentMarker = null

    if (!indented) {
      if (
        character === asterisk ||
        character === plusSign ||
        character === dash
      ) {
        currentMarker = character
        index++
        size++
      } else {
        queue = ''

        while (index < length) {
          character = value.charAt(index)

          if (!decimal(character)) {
            break
          }

          queue += character
          index++
        }

        character = value.charAt(index)
        index++

        if (
          queue &&
          (character === dot || (commonmark && character === rightParenthesis))
        ) {
          currentMarker = character
          size += queue.length + 1
        }
      }

      if (currentMarker) {
        character = value.charAt(index)

        if (character === tab) {
          size += tabSize - (size % tabSize)
          index++
        } else if (character === space) {
          end = index + tabSize

          while (index < end) {
            if (value.charAt(index) !== space) {
              break
            }

            index++
            size++
          }

          if (index === end && value.charAt(index) === space) {
            index -= tabSize - 1
            size -= tabSize - 1
          }
        } else if (character !== lineFeed && character !== '') {
          currentMarker = null
        }
      }
    }

    if (currentMarker) {
      if (!pedantic && marker !== currentMarker) {
        break
      }

      prefixed = true
    } else {
      if (!commonmark && !indented && value.charAt(startIndex) === space) {
        indented = true
      } else if (commonmark && item) {
        indented = size >= item.indent || size > tabSize
      }

      prefixed = false
      index = startIndex
    }

    line = value.slice(startIndex, nextIndex)
    content = startIndex === index ? line : value.slice(index, nextIndex)

    if (
      currentMarker === asterisk ||
      currentMarker === underscore ||
      currentMarker === dash
    ) {
      if (tokenizers.thematicBreak.call(self, eat, line, true)) {
        break
      }
    }

    prevEmpty = empty
    empty = !prefixed && !trim(content).length

    if (indented && item) {
      item.value = item.value.concat(emptyLines, line)
      allLines = allLines.concat(emptyLines, line)
      emptyLines = []
    } else if (prefixed) {
      if (emptyLines.length !== 0) {
        spread = true
        item.value.push('')
        item.trail = emptyLines.concat()
      }

      item = {
        value: [line],
        indent: size,
        trail: []
      }

      items.push(item)
      allLines = allLines.concat(emptyLines, line)
      emptyLines = []
    } else if (empty) {
      if (prevEmpty && !commonmark) {
        break
      }

      emptyLines.push(line)
    } else {
      if (prevEmpty) {
        break
      }

      if (interrupt(interuptors, tokenizers, self, [eat, line, true])) {
        break
      }

      item.value = item.value.concat(emptyLines, line)
      allLines = allLines.concat(emptyLines, line)
      emptyLines = []
    }

    index = nextIndex + 1
  }

  node = eat(allLines.join(lineFeed)).reset({
    type: 'list',
    ordered: ordered,
    start: start,
    spread: spread,
    children: []
  })

  enterTop = self.enterList()
  exitBlockquote = self.enterBlock()
  index = -1
  length = items.length

  while (++index < length) {
    item = items[index].value.join(lineFeed)
    now = eat.now()

    eat(item)(listItem(self, item, now), node)

    item = items[index].trail.join(lineFeed)

    if (index !== length - 1) {
      item += lineFeed
    }

    eat(item)
  }

  enterTop()
  exitBlockquote()

  return node
}

function listItem(ctx, value, position) {
  var offsets = ctx.offset
  var fn = ctx.options.pedantic ? pedanticListItem : normalListItem
  var checked = null
  var task
  var indent

  value = fn.apply(null, arguments)

  if (ctx.options.gfm) {
    task = value.match(taskItemExpression)

    if (task) {
      indent = task[0].length
      checked = task[1].toLowerCase() === lowercaseX
      offsets[position.line] += indent
      value = value.slice(indent)
    }
  }

  return {
    type: 'listItem',
    spread: looseListItemExpression.test(value),
    checked: checked,
    children: ctx.tokenizeBlock(value, position)
  }
}

// Create a list-item using overly simple mechanics.
function pedanticListItem(ctx, value, position) {
  var offsets = ctx.offset
  var line = position.line

  // Remove the list-item’s bullet.
  value = value.replace(pedanticBulletExpression, replacer)

  // The initial line was also matched by the below, so we reset the `line`.
  line = position.line

  return value.replace(initialIndentExpression, replacer)

  // A simple replacer which removed all matches, and adds their length to
  // `offset`.
  function replacer($0) {
    offsets[line] = (offsets[line] || 0) + $0.length
    line++

    return ''
  }
}

// Create a list-item using sane mechanics.
function normalListItem(ctx, value, position) {
  var offsets = ctx.offset
  var line = position.line
  var max
  var bullet
  var rest
  var lines
  var trimmedLines
  var index
  var length

  // Remove the list-item’s bullet.
  value = value.replace(bulletExpression, replacer)

  lines = value.split(lineFeed)

  trimmedLines = removeIndent(value, getIndent(max).indent).split(lineFeed)

  // We replaced the initial bullet with something else above, which was used
  // to trick `removeIndentation` into removing some more characters when
  // possible.  However, that could result in the initial line to be stripped
  // more than it should be.
  trimmedLines[0] = rest

  offsets[line] = (offsets[line] || 0) + bullet.length
  line++

  index = 0
  length = lines.length

  while (++index < length) {
    offsets[line] =
      (offsets[line] || 0) + lines[index].length - trimmedLines[index].length
    line++
  }

  return trimmedLines.join(lineFeed)

  /* eslint-disable-next-line max-params */
  function replacer($0, $1, $2, $3, $4) {
    bullet = $1 + $2 + $3
    rest = $4

    // Make sure that the first nine numbered list items can indent with an
    // extra space.  That is, when the bullet did not receive an extra final
    // space.
    if (Number($2) < 10 && bullet.length % 2 === 1) {
      $2 = space + $2
    }

    max = $1 + repeat(space, $2.length) + $3

    return max + rest
  }
}


/***/ }),

/***/ 3885:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var whitespace = __webpack_require__(2139)

module.exports = newline

var lineFeed = '\n'

function newline(eat, value, silent) {
  var character = value.charAt(0)
  var length
  var subvalue
  var queue
  var index

  if (character !== lineFeed) {
    return
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true
  }

  index = 1
  length = value.length
  subvalue = character
  queue = ''

  while (index < length) {
    character = value.charAt(index)

    if (!whitespace(character)) {
      break
    }

    queue += character

    if (character === lineFeed) {
      subvalue += queue
      queue = ''
    }

    index++
  }

  eat(subvalue)
}


/***/ }),

/***/ 2431:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var trim = __webpack_require__(3059)
var decimal = __webpack_require__(6195)
var trimTrailingLines = __webpack_require__(7257)
var interrupt = __webpack_require__(6588)

module.exports = paragraph

var tab = '\t'
var lineFeed = '\n'
var space = ' '

var tabSize = 4

// Tokenise paragraph.
function paragraph(eat, value, silent) {
  var self = this
  var settings = self.options
  var commonmark = settings.commonmark
  var gfm = settings.gfm
  var tokenizers = self.blockTokenizers
  var interruptors = self.interruptParagraph
  var index = value.indexOf(lineFeed)
  var length = value.length
  var position
  var subvalue
  var character
  var size
  var now

  while (index < length) {
    // Eat everything if there’s no following newline.
    if (index === -1) {
      index = length
      break
    }

    // Stop if the next character is NEWLINE.
    if (value.charAt(index + 1) === lineFeed) {
      break
    }

    // In commonmark-mode, following indented lines are part of the paragraph.
    if (commonmark) {
      size = 0
      position = index + 1

      while (position < length) {
        character = value.charAt(position)

        if (character === tab) {
          size = tabSize
          break
        } else if (character === space) {
          size++
        } else {
          break
        }

        position++
      }

      if (size >= tabSize && character !== lineFeed) {
        index = value.indexOf(lineFeed, index + 1)
        continue
      }
    }

    subvalue = value.slice(index + 1)

    // Check if the following code contains a possible block.
    if (interrupt(interruptors, tokenizers, self, [eat, subvalue, true])) {
      break
    }

    // Break if the following line starts a list, when already in a list, or
    // when in commonmark, or when in gfm mode and the bullet is *not* numeric.
    if (
      tokenizers.list.call(self, eat, subvalue, true) &&
      (self.inList ||
        commonmark ||
        (gfm && !decimal(trim.left(subvalue).charAt(0))))
    ) {
      break
    }

    position = index
    index = value.indexOf(lineFeed, index + 1)

    if (index !== -1 && trim(value.slice(position, index)) === '') {
      index = position
      break
    }
  }

  subvalue = value.slice(0, index)

  if (trim(subvalue) === '') {
    eat(subvalue)

    return null
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true
  }

  now = eat.now()
  subvalue = trimTrailingLines(subvalue)

  return eat(subvalue)({
    type: 'paragraph',
    children: self.tokenizeInline(subvalue, now)
  })
}


/***/ }),

/***/ 7551:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var whitespace = __webpack_require__(2139)
var locate = __webpack_require__(5460)
var normalize = __webpack_require__(4405)

module.exports = reference
reference.locator = locate

var link = 'link'
var image = 'image'
var footnote = 'footnote'
var shortcut = 'shortcut'
var collapsed = 'collapsed'
var full = 'full'
var space = ' '
var exclamationMark = '!'
var leftSquareBracket = '['
var backslash = '\\'
var rightSquareBracket = ']'
var caret = '^'

function reference(eat, value, silent) {
  var self = this
  var commonmark = self.options.commonmark
  var footnotes = self.options.footnotes
  var character = value.charAt(0)
  var index = 0
  var length = value.length
  var subvalue = ''
  var intro = ''
  var type = link
  var referenceType = shortcut
  var content
  var identifier
  var now
  var node
  var exit
  var queue
  var bracketed
  var depth

  // Check whether we’re eating an image.
  if (character === exclamationMark) {
    type = image
    intro = character
    character = value.charAt(++index)
  }

  if (character !== leftSquareBracket) {
    return
  }

  index++
  intro += character
  queue = ''

  // Check whether we’re eating a footnote.
  if (footnotes && value.charAt(index) === caret) {
    // Exit if `![^` is found, so the `!` will be seen as text after this,
    // and we’ll enter this function again when `[^` is found.
    if (type === image) {
      return
    }

    intro += caret
    index++
    type = footnote
  }

  // Eat the text.
  depth = 0

  while (index < length) {
    character = value.charAt(index)

    if (character === leftSquareBracket) {
      bracketed = true
      depth++
    } else if (character === rightSquareBracket) {
      if (!depth) {
        break
      }

      depth--
    }

    if (character === backslash) {
      queue += backslash
      character = value.charAt(++index)
    }

    queue += character
    index++
  }

  subvalue = queue
  content = queue
  character = value.charAt(index)

  if (character !== rightSquareBracket) {
    return
  }

  index++
  subvalue += character
  queue = ''

  if (!commonmark) {
    // The original markdown syntax definition explicitly allows for whitespace
    // between the link text and link label; commonmark departs from this, in
    // part to improve support for shortcut reference links
    while (index < length) {
      character = value.charAt(index)

      if (!whitespace(character)) {
        break
      }

      queue += character
      index++
    }
  }

  character = value.charAt(index)

  // Inline footnotes cannot have a label.
  // If footnotes are enabled, link labels cannot start with a caret.
  if (
    type !== footnote &&
    character === leftSquareBracket &&
    (!footnotes || value.charAt(index + 1) !== caret)
  ) {
    identifier = ''
    queue += character
    index++

    while (index < length) {
      character = value.charAt(index)

      if (character === leftSquareBracket || character === rightSquareBracket) {
        break
      }

      if (character === backslash) {
        identifier += backslash
        character = value.charAt(++index)
      }

      identifier += character
      index++
    }

    character = value.charAt(index)

    if (character === rightSquareBracket) {
      referenceType = identifier ? full : collapsed
      queue += identifier + character
      index++
    } else {
      identifier = ''
    }

    subvalue += queue
    queue = ''
  } else {
    if (!content) {
      return
    }

    identifier = content
  }

  // Brackets cannot be inside the identifier.
  if (referenceType !== full && bracketed) {
    return
  }

  subvalue = intro + subvalue

  if (type === link && self.inLink) {
    return null
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true
  }

  if (type === footnote && content.indexOf(space) !== -1) {
    return eat(subvalue)({
      type: footnote,
      children: this.tokenizeInline(content, eat.now())
    })
  }

  now = eat.now()
  now.column += intro.length
  now.offset += intro.length
  identifier = referenceType === full ? identifier : content

  node = {
    type: type + 'Reference',
    identifier: normalize(identifier),
    label: identifier
  }

  if (type === link || type === image) {
    node.referenceType = referenceType
  }

  if (type === link) {
    exit = self.enterLink()
    node.children = self.tokenizeInline(content, now)
    exit()
  } else if (type === image) {
    node.alt = self.decode.raw(self.unescape(content), now) || null
  }

  return eat(subvalue)(node)
}


/***/ }),

/***/ 1420:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var trim = __webpack_require__(3059)
var whitespace = __webpack_require__(2139)
var locate = __webpack_require__(1594)

module.exports = strong
strong.locator = locate

var backslash = '\\'
var asterisk = '*'
var underscore = '_'

function strong(eat, value, silent) {
  var self = this
  var index = 0
  var character = value.charAt(index)
  var now
  var pedantic
  var marker
  var queue
  var subvalue
  var length
  var prev

  if (
    (character !== asterisk && character !== underscore) ||
    value.charAt(++index) !== character
  ) {
    return
  }

  pedantic = self.options.pedantic
  marker = character
  subvalue = marker + marker
  length = value.length
  index++
  queue = ''
  character = ''

  if (pedantic && whitespace(value.charAt(index))) {
    return
  }

  while (index < length) {
    prev = character
    character = value.charAt(index)

    if (
      character === marker &&
      value.charAt(index + 1) === marker &&
      (!pedantic || !whitespace(prev))
    ) {
      character = value.charAt(index + 2)

      if (character !== marker) {
        if (!trim(queue)) {
          return
        }

        /* istanbul ignore if - never used (yet) */
        if (silent) {
          return true
        }

        now = eat.now()
        now.column += 2
        now.offset += 2

        return eat(subvalue + queue + subvalue)({
          type: 'strong',
          children: self.tokenizeInline(queue, now)
        })
      }
    }

    if (!pedantic && character === backslash) {
      queue += character
      character = value.charAt(++index)
    }

    queue += character
    index++
  }
}


/***/ }),

/***/ 8029:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var whitespace = __webpack_require__(2139)

module.exports = table

var tab = '\t'
var lineFeed = '\n'
var space = ' '
var dash = '-'
var colon = ':'
var backslash = '\\'
var verticalBar = '|'

var minColumns = 1
var minRows = 2

var left = 'left'
var center = 'center'
var right = 'right'

function table(eat, value, silent) {
  var self = this
  var index
  var alignments
  var alignment
  var subvalue
  var row
  var length
  var lines
  var queue
  var character
  var hasDash
  var align
  var cell
  var preamble
  var now
  var position
  var lineCount
  var line
  var rows
  var table
  var lineIndex
  var pipeIndex
  var first

  // Exit when not in gfm-mode.
  if (!self.options.gfm) {
    return
  }

  // Get the rows.
  // Detecting tables soon is hard, so there are some checks for performance
  // here, such as the minimum number of rows, and allowed characters in the
  // alignment row.
  index = 0
  lineCount = 0
  length = value.length + 1
  lines = []

  while (index < length) {
    lineIndex = value.indexOf(lineFeed, index)
    pipeIndex = value.indexOf(verticalBar, index + 1)

    if (lineIndex === -1) {
      lineIndex = value.length
    }

    if (pipeIndex === -1 || pipeIndex > lineIndex) {
      if (lineCount < minRows) {
        return
      }

      break
    }

    lines.push(value.slice(index, lineIndex))
    lineCount++
    index = lineIndex + 1
  }

  // Parse the alignment row.
  subvalue = lines.join(lineFeed)
  alignments = lines.splice(1, 1)[0] || []
  index = 0
  length = alignments.length
  lineCount--
  alignment = false
  align = []

  while (index < length) {
    character = alignments.charAt(index)

    if (character === verticalBar) {
      hasDash = null

      if (alignment === false) {
        if (first === false) {
          return
        }
      } else {
        align.push(alignment)
        alignment = false
      }

      first = false
    } else if (character === dash) {
      hasDash = true
      alignment = alignment || null
    } else if (character === colon) {
      if (alignment === left) {
        alignment = center
      } else if (hasDash && alignment === null) {
        alignment = right
      } else {
        alignment = left
      }
    } else if (!whitespace(character)) {
      return
    }

    index++
  }

  if (alignment !== false) {
    align.push(alignment)
  }

  // Exit when without enough columns.
  if (align.length < minColumns) {
    return
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true
  }

  // Parse the rows.
  position = -1
  rows = []

  table = eat(subvalue).reset({type: 'table', align: align, children: rows})

  while (++position < lineCount) {
    line = lines[position]
    row = {type: 'tableRow', children: []}

    // Eat a newline character when this is not the first row.
    if (position) {
      eat(lineFeed)
    }

    // Eat the row.
    eat(line).reset(row, table)

    length = line.length + 1
    index = 0
    queue = ''
    cell = ''
    preamble = true

    while (index < length) {
      character = line.charAt(index)

      if (character === tab || character === space) {
        if (cell) {
          queue += character
        } else {
          eat(character)
        }

        index++
        continue
      }

      if (character === '' || character === verticalBar) {
        if (preamble) {
          eat(character)
        } else {
          if ((cell || character) && !preamble) {
            subvalue = cell

            if (queue.length > 1) {
              if (character) {
                subvalue += queue.slice(0, queue.length - 1)
                queue = queue.charAt(queue.length - 1)
              } else {
                subvalue += queue
                queue = ''
              }
            }

            now = eat.now()

            eat(subvalue)(
              {type: 'tableCell', children: self.tokenizeInline(cell, now)},
              row
            )
          }

          eat(queue + character)

          queue = ''
          cell = ''
        }
      } else {
        if (queue) {
          cell += queue
          queue = ''
        }

        cell += character

        if (character === backslash && index !== length - 2) {
          cell += line.charAt(index + 1)
          index++
        }
      }

      preamble = false
      index++
    }

    // Eat the alignment row.
    if (!position) {
      eat(lineFeed + alignments)
    }
  }

  return table
}


/***/ }),

/***/ 4278:
/***/ ((module) => {

"use strict";


module.exports = text

function text(eat, value, silent) {
  var self = this
  var methods
  var tokenizers
  var index
  var length
  var subvalue
  var position
  var tokenizer
  var name
  var min
  var now

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true
  }

  methods = self.inlineMethods
  length = methods.length
  tokenizers = self.inlineTokenizers
  index = -1
  min = value.length

  while (++index < length) {
    name = methods[index]

    if (name === 'text' || !tokenizers[name]) {
      continue
    }

    tokenizer = tokenizers[name].locator

    if (!tokenizer) {
      eat.file.fail('Missing locator: `' + name + '`')
    }

    position = tokenizer.call(self, value, 1)

    if (position !== -1 && position < min) {
      min = position
    }
  }

  subvalue = value.slice(0, min)
  now = eat.now()

  self.decode(subvalue, now, handler)

  function handler(content, position, source) {
    eat(source || content)({type: 'text', value: content})
  }
}


/***/ }),

/***/ 9111:
/***/ ((module) => {

"use strict";


module.exports = thematicBreak

var tab = '\t'
var lineFeed = '\n'
var space = ' '
var asterisk = '*'
var dash = '-'
var underscore = '_'

var maxCount = 3

function thematicBreak(eat, value, silent) {
  var index = -1
  var length = value.length + 1
  var subvalue = ''
  var character
  var marker
  var markerCount
  var queue

  while (++index < length) {
    character = value.charAt(index)

    if (character !== tab && character !== space) {
      break
    }

    subvalue += character
  }

  if (
    character !== asterisk &&
    character !== dash &&
    character !== underscore
  ) {
    return
  }

  marker = character
  subvalue += character
  markerCount = 1
  queue = ''

  while (++index < length) {
    character = value.charAt(index)

    if (character === marker) {
      markerCount++
      subvalue += queue + marker
      queue = ''
    } else if (character === space) {
      queue += character
    } else if (
      markerCount >= maxCount &&
      (!character || character === lineFeed)
    ) {
      subvalue += queue

      if (silent) {
        return true
      }

      return eat(subvalue)({type: 'thematicBreak'})
    } else {
      return
    }
  }
}


/***/ }),

/***/ 5044:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var decode = __webpack_require__(7574)
var whitespace = __webpack_require__(2139)
var locate = __webpack_require__(1020)

module.exports = url
url.locator = locate
url.notInLink = true

var quotationMark = '"'
var apostrophe = "'"
var leftParenthesis = '('
var rightParenthesis = ')'
var comma = ','
var dot = '.'
var colon = ':'
var semicolon = ';'
var lessThan = '<'
var atSign = '@'
var leftSquareBracket = '['
var rightSquareBracket = ']'

var http = 'http://'
var https = 'https://'
var mailto = 'mailto:'

var protocols = [http, https, mailto]

var protocolsLength = protocols.length

function url(eat, value, silent) {
  var self = this
  var subvalue
  var content
  var character
  var index
  var position
  var protocol
  var match
  var length
  var queue
  var parenCount
  var nextCharacter
  var tokenizers
  var exit

  if (!self.options.gfm) {
    return
  }

  subvalue = ''
  index = -1

  while (++index < protocolsLength) {
    protocol = protocols[index]
    match = value.slice(0, protocol.length)

    if (match.toLowerCase() === protocol) {
      subvalue = match
      break
    }
  }

  if (!subvalue) {
    return
  }

  index = subvalue.length
  length = value.length
  queue = ''
  parenCount = 0

  while (index < length) {
    character = value.charAt(index)

    if (whitespace(character) || character === lessThan) {
      break
    }

    if (
      character === dot ||
      character === comma ||
      character === colon ||
      character === semicolon ||
      character === quotationMark ||
      character === apostrophe ||
      character === rightParenthesis ||
      character === rightSquareBracket
    ) {
      nextCharacter = value.charAt(index + 1)

      if (!nextCharacter || whitespace(nextCharacter)) {
        break
      }
    }

    if (character === leftParenthesis || character === leftSquareBracket) {
      parenCount++
    }

    if (character === rightParenthesis || character === rightSquareBracket) {
      parenCount--

      if (parenCount < 0) {
        break
      }
    }

    queue += character
    index++
  }

  if (!queue) {
    return
  }

  subvalue += queue
  content = subvalue

  if (protocol === mailto) {
    position = queue.indexOf(atSign)

    if (position === -1 || position === length - 1) {
      return
    }

    content = content.slice(mailto.length)
  }

  /* istanbul ignore if - never used (yet) */
  if (silent) {
    return true
  }

  exit = self.enterLink()

  // Temporarily remove all tokenizers except text in url.
  tokenizers = self.inlineTokenizers
  self.inlineTokenizers = {text: tokenizers.text}

  content = self.tokenizeInline(content, eat.now())

  self.inlineTokenizers = tokenizers
  exit()

  return eat(subvalue)({
    type: 'link',
    title: null,
    url: decode(subvalue, {nonTerminated: false}),
    children: content
  })
}


/***/ }),

/***/ 6691:
/***/ ((module) => {

"use strict";


module.exports = factory

// Construct a tokenizer.  This creates both `tokenizeInline` and `tokenizeBlock`.
function factory(type) {
  return tokenize

  // Tokenizer for a bound `type`.
  function tokenize(value, location) {
    var self = this
    var offset = self.offset
    var tokens = []
    var methods = self[type + 'Methods']
    var tokenizers = self[type + 'Tokenizers']
    var line = location.line
    var column = location.column
    var index
    var length
    var method
    var name
    var matched
    var valueLength

    // Trim white space only lines.
    if (!value) {
      return tokens
    }

    // Expose on `eat`.
    eat.now = now
    eat.file = self.file

    // Sync initial offset.
    updatePosition('')

    // Iterate over `value`, and iterate over all tokenizers.  When one eats
    // something, re-iterate with the remaining value.  If no tokenizer eats,
    // something failed (should not happen) and an exception is thrown.
    while (value) {
      index = -1
      length = methods.length
      matched = false

      while (++index < length) {
        name = methods[index]
        method = tokenizers[name]

        if (
          method &&
          /* istanbul ignore next */ (!method.onlyAtStart || self.atStart) &&
          (!method.notInList || !self.inList) &&
          (!method.notInBlock || !self.inBlock) &&
          (!method.notInLink || !self.inLink)
        ) {
          valueLength = value.length

          method.apply(self, [eat, value])

          matched = valueLength !== value.length

          if (matched) {
            break
          }
        }
      }

      /* istanbul ignore if */
      if (!matched) {
        self.file.fail(new Error('Infinite loop'), eat.now())
      }
    }

    self.eof = now()

    return tokens

    // Update line, column, and offset based on `value`.
    function updatePosition(subvalue) {
      var lastIndex = -1
      var index = subvalue.indexOf('\n')

      while (index !== -1) {
        line++
        lastIndex = index
        index = subvalue.indexOf('\n', index + 1)
      }

      if (lastIndex === -1) {
        column += subvalue.length
      } else {
        column = subvalue.length - lastIndex
      }

      if (line in offset) {
        if (lastIndex !== -1) {
          column += offset[line]
        } else if (column <= offset[line]) {
          column = offset[line] + 1
        }
      }
    }

    // Get offset.  Called before the first character is eaten to retrieve the
    // range’s offsets.
    function getOffset() {
      var indentation = []
      var pos = line + 1

      // Done.  Called when the last character is eaten to retrieve the range’s
      // offsets.
      return function() {
        var last = line + 1

        while (pos < last) {
          indentation.push((offset[pos] || 0) + 1)

          pos++
        }

        return indentation
      }
    }

    // Get the current position.
    function now() {
      var pos = {line: line, column: column}

      pos.offset = self.toOffset(pos)

      return pos
    }

    // Store position information for a node.
    function Position(start) {
      this.start = start
      this.end = now()
    }

    // Throw when a value is incorrectly eaten.  This shouldn’t happen but will
    // throw on new, incorrect rules.
    function validateEat(subvalue) {
      /* istanbul ignore if */
      if (value.slice(0, subvalue.length) !== subvalue) {
        // Capture stack-trace.
        self.file.fail(
          new Error(
            'Incorrectly eaten value: please report this warning on https://git.io/vg5Ft'
          ),
          now()
        )
      }
    }

    // Mark position and patch `node.position`.
    function position() {
      var before = now()

      return update

      // Add the position to a node.
      function update(node, indent) {
        var prev = node.position
        var start = prev ? prev.start : before
        var combined = []
        var n = prev && prev.end.line
        var l = before.line

        node.position = new Position(start)

        // If there was already a `position`, this node was merged.  Fixing
        // `start` wasn’t hard, but the indent is different.  Especially
        // because some information, the indent between `n` and `l` wasn’t
        // tracked.  Luckily, that space is (should be?) empty, so we can
        // safely check for it now.
        if (prev && indent && prev.indent) {
          combined = prev.indent

          if (n < l) {
            while (++n < l) {
              combined.push((offset[n] || 0) + 1)
            }

            combined.push(before.column)
          }

          indent = combined.concat(indent)
        }

        node.position.indent = indent || []

        return node
      }
    }

    // Add `node` to `parent`s children or to `tokens`.  Performs merges where
    // possible.
    function add(node, parent) {
      var children = parent ? parent.children : tokens
      var prev = children[children.length - 1]
      var fn

      if (
        prev &&
        node.type === prev.type &&
        (node.type === 'text' || node.type === 'blockquote') &&
        mergeable(prev) &&
        mergeable(node)
      ) {
        fn = node.type === 'text' ? mergeText : mergeBlockquote
        node = fn.call(self, prev, node)
      }

      if (node !== prev) {
        children.push(node)
      }

      if (self.atStart && tokens.length !== 0) {
        self.exitStart()
      }

      return node
    }

    // Remove `subvalue` from `value`.  `subvalue` must be at the start of
    // `value`.
    function eat(subvalue) {
      var indent = getOffset()
      var pos = position()
      var current = now()

      validateEat(subvalue)

      apply.reset = reset
      reset.test = test
      apply.test = test

      value = value.slice(subvalue.length)

      updatePosition(subvalue)

      indent = indent()

      return apply

      // Add the given arguments, add `position` to the returned node, and
      // return the node.
      function apply(node, parent) {
        return pos(add(pos(node), parent), indent)
      }

      // Functions just like apply, but resets the content: the line and
      // column are reversed, and the eaten value is re-added.   This is
      // useful for nodes with a single type of content, such as lists and
      // tables.  See `apply` above for what parameters are expected.
      function reset() {
        var node = apply.apply(null, arguments)

        line = current.line
        column = current.column
        value = subvalue + value

        return node
      }

      // Test the position, after eating, and reverse to a not-eaten state.
      function test() {
        var result = pos({})

        line = current.line
        column = current.column
        value = subvalue + value

        return result.position
      }
    }
  }
}

// Check whether a node is mergeable with adjacent nodes.
function mergeable(node) {
  var start
  var end

  if (node.type !== 'text' || !node.position) {
    return true
  }

  start = node.position.start
  end = node.position.end

  // Only merge nodes which occupy the same size as their `value`.
  return (
    start.line !== end.line || end.column - start.column === node.value.length
  )
}

// Merge two text nodes: `node` into `prev`.
function mergeText(prev, node) {
  prev.value += node.value

  return prev
}

// Merge two blockquotes: `node` into `prev`, unless in CommonMark or gfm modes.
function mergeBlockquote(prev, node) {
  if (this.options.commonmark || this.options.gfm) {
    return node
  }

  prev.children = prev.children.concat(node.children)

  return prev
}


/***/ }),

/***/ 2816:
/***/ ((module) => {

"use strict";


module.exports = factory

var backslash = '\\'

// Factory to de-escape a value, based on a list at `key` in `ctx`.
function factory(ctx, key) {
  return unescape

  // De-escape a string using the expression at `key` in `ctx`.
  function unescape(value) {
    var prev = 0
    var index = value.indexOf(backslash)
    var escape = ctx[key]
    var queue = []
    var character

    while (index !== -1) {
      queue.push(value.slice(prev, index))
      prev = index + 1
      character = value.charAt(prev)

      // If the following character is not a valid escape, add the slash.
      if (!character || escape.indexOf(character) === -1) {
        queue.push(backslash)
      }

      index = value.indexOf(backslash, prev + 1)
    }

    queue.push(value.slice(prev))

    return queue.join('')
  }
}


/***/ }),

/***/ 2299:
/***/ ((module) => {

"use strict";


module.exports = indentation

var tab = '\t'
var space = ' '

var spaceSize = 1
var tabSize = 4

// Gets indentation information for a line.
function indentation(value) {
  var index = 0
  var indent = 0
  var character = value.charAt(index)
  var stops = {}
  var size

  while (character === tab || character === space) {
    size = character === tab ? tabSize : spaceSize

    indent += size

    if (size > 1) {
      indent = Math.floor(indent / size) * size
    }

    stops[indent] = index
    character = value.charAt(++index)
  }

  return {indent: indent, stops: stops}
}


/***/ }),

/***/ 4706:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


var attributeName = '[a-zA-Z_:][a-zA-Z0-9:._-]*'
var unquoted = '[^"\'=<>`\\u0000-\\u0020]+'
var singleQuoted = "'[^']*'"
var doubleQuoted = '"[^"]*"'
var attributeValue =
  '(?:' + unquoted + '|' + singleQuoted + '|' + doubleQuoted + ')'
var attribute =
  '(?:\\s+' + attributeName + '(?:\\s*=\\s*' + attributeValue + ')?)'
var openTag = '<[A-Za-z][A-Za-z0-9\\-]*' + attribute + '*\\s*\\/?>'
var closeTag = '<\\/[A-Za-z][A-Za-z0-9\\-]*\\s*>'
var comment = '<!---->|<!--(?:-?[^>-])(?:-?[^-])*-->'
var processing = '<[?].*?[?]>'
var declaration = '<![A-Za-z]+\\s+[^>]*>'
var cdata = '<!\\[CDATA\\[[\\s\\S]*?\\]\\]>'

exports.g = new RegExp('^(?:' + openTag + '|' + closeTag + ')')

exports._ = new RegExp(
  '^(?:' +
    openTag +
    '|' +
    closeTag +
    '|' +
    comment +
    '|' +
    processing +
    '|' +
    declaration +
    '|' +
    cdata +
    ')'
)


/***/ }),

/***/ 6588:
/***/ ((module) => {

"use strict";


module.exports = interrupt

function interrupt(interruptors, tokenizers, ctx, params) {
  var length = interruptors.length
  var index = -1
  var interruptor
  var config

  while (++index < length) {
    interruptor = interruptors[index]
    config = interruptor[1] || {}

    if (
      config.pedantic !== undefined &&
      config.pedantic !== ctx.options.pedantic
    ) {
      continue
    }

    if (
      config.commonmark !== undefined &&
      config.commonmark !== ctx.options.commonmark
    ) {
      continue
    }

    if (tokenizers[interruptor[0]].apply(ctx, params)) {
      return true
    }
  }

  return false
}


/***/ }),

/***/ 4405:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var collapseWhiteSpace = __webpack_require__(9357)

module.exports = normalize

// Normalize an identifier.  Collapses multiple white space characters into a
// single space, and removes casing.
function normalize(value) {
  return collapseWhiteSpace(value).toLowerCase()
}


/***/ }),

/***/ 6514:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var trim = __webpack_require__(3059)
var repeat = __webpack_require__(6464)
var getIndent = __webpack_require__(2299)

module.exports = indentation

var tab = '\t'
var lineFeed = '\n'
var space = ' '
var exclamationMark = '!'

// Remove the minimum indent from every line in `value`.  Supports both tab,
// spaced, and mixed indentation (as well as possible).
function indentation(value, maximum) {
  var values = value.split(lineFeed)
  var position = values.length + 1
  var minIndent = Infinity
  var matrix = []
  var index
  var indentation
  var stops
  var padding

  values.unshift(repeat(space, maximum) + exclamationMark)

  while (position--) {
    indentation = getIndent(values[position])

    matrix[position] = indentation.stops

    if (trim(values[position]).length === 0) {
      continue
    }

    if (indentation.indent) {
      if (indentation.indent > 0 && indentation.indent < minIndent) {
        minIndent = indentation.indent
      }
    } else {
      minIndent = Infinity

      break
    }
  }

  if (minIndent !== Infinity) {
    position = values.length

    while (position--) {
      stops = matrix[position]
      index = minIndent

      while (index && !(index in stops)) {
        index--
      }

      if (
        trim(values[position]).length !== 0 &&
        minIndent &&
        index !== minIndent
      ) {
        padding = tab
      } else {
        padding = ''
      }

      values[position] =
        padding + values[position].slice(index in stops ? stops[index] + 1 : 0)
    }
  }

  values.shift()

  return values.join(lineFeed)
}


/***/ }),

/***/ 3059:
/***/ ((module, exports) => {


exports = module.exports = trim;

function trim(str){
  return str.replace(/^\s*|\s*$/g, '');
}

exports.left = function(str){
  return str.replace(/^\s*/, '');
};

exports.right = function(str){
  return str.replace(/\s*$/, '');
};


/***/ }),

/***/ 8818:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var mdast2hast = __webpack_require__(5288)

module.exports = remark2rehype

// Attacher.
// If a destination is given, runs the destination with the new hast tree
// (bridge mode).
// Without destination, returns the tree: further plugins run on that tree
// (mutate mode).
function remark2rehype(destination, options) {
  if (destination && !destination.process) {
    options = destination
    destination = null
  }

  return destination ? bridge(destination, options) : mutate(options)
}

// Bridge mode.
// Runs the destination with the new hast tree.
function bridge(destination, options) {
  return transformer

  function transformer(node, file, next) {
    destination.run(mdast2hast(node, options), file, done)

    function done(err) {
      next(err)
    }
  }
}

// Mutate-mode.
// Further transformers run on the hast tree.
function mutate(options) {
  return transformer

  function transformer(node) {
    return mdast2hast(node, options)
  }
}


/***/ }),

/***/ 4490:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var toString = __webpack_require__(4999)
var visit = __webpack_require__(2854)
var slugs = __webpack_require__(9671)()

module.exports = slug

function slug() {
  return transformer
}

// Patch slugs on heading nodes.
function transformer(ast) {
  slugs.reset()

  visit(ast, 'heading', visitor)

  function visitor(node) {
    var data = node.data || (node.data = {})
    var props = data.hProperties || (data.hProperties = {})
    var id = props.id

    id = id ? slugs.slug(id, true) : slugs.slug(toString(node))

    data.id = id
    props.id = id
  }
}


/***/ }),

/***/ 3734:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var unherit = __webpack_require__(3278)
var xtend = __webpack_require__(7529)
var Compiler = __webpack_require__(3947)

module.exports = stringify
stringify.Compiler = Compiler

function stringify(options) {
  var Local = unherit(Compiler)
  Local.prototype.options = xtend(
    Local.prototype.options,
    this.data('settings'),
    options
  )
  this.Compiler = Local
}


/***/ }),

/***/ 3947:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var xtend = __webpack_require__(7529)
var toggle = __webpack_require__(78)

module.exports = Compiler

// Construct a new compiler.
function Compiler(tree, file) {
  this.inLink = false
  this.inTable = false
  this.tree = tree
  this.file = file
  this.options = xtend(this.options)
  this.setOptions({})
}

var proto = Compiler.prototype

// Enter and exit helpers. */
proto.enterLink = toggle('inLink', false)
proto.enterTable = toggle('inTable', false)
proto.enterLinkReference = __webpack_require__(9418)

// Configuration.
proto.options = __webpack_require__(9125)
proto.setOptions = __webpack_require__(674)

proto.compile = __webpack_require__(8833)
proto.visit = __webpack_require__(1977)
proto.all = __webpack_require__(1189)
proto.block = __webpack_require__(7889)
proto.visitOrderedItems = __webpack_require__(4536)
proto.visitUnorderedItems = __webpack_require__(1905)

// Expose visitors.
proto.visitors = {
  root: __webpack_require__(9566),
  text: __webpack_require__(2072),
  heading: __webpack_require__(8816),
  paragraph: __webpack_require__(2879),
  blockquote: __webpack_require__(6363),
  list: __webpack_require__(9555),
  listItem: __webpack_require__(631),
  inlineCode: __webpack_require__(5730),
  code: __webpack_require__(7846),
  html: __webpack_require__(5665),
  thematicBreak: __webpack_require__(733),
  strong: __webpack_require__(1291),
  emphasis: __webpack_require__(5469),
  break: __webpack_require__(9720),
  delete: __webpack_require__(2797),
  link: __webpack_require__(4485),
  linkReference: __webpack_require__(2133),
  imageReference: __webpack_require__(1514),
  definition: __webpack_require__(4496),
  image: __webpack_require__(2366),
  table: __webpack_require__(7936),
  tableCell: __webpack_require__(7286)
}


/***/ }),

/***/ 9125:
/***/ ((module) => {

"use strict";


module.exports = {
  gfm: true,
  commonmark: false,
  pedantic: false,
  entities: 'false',
  setext: false,
  closeAtx: false,
  tableCellPadding: true,
  tablePipeAlign: true,
  stringLength: stringLength,
  incrementListMarker: true,
  tightDefinitions: false,
  fences: false,
  fence: '`',
  bullet: '-',
  listItemIndent: 'tab',
  rule: '*',
  ruleSpaces: true,
  ruleRepetition: 3,
  strong: '*',
  emphasis: '_'
}

function stringLength(value) {
  return value.length
}


/***/ }),

/***/ 8826:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var decimal = __webpack_require__(6195)
var alphanumeric = __webpack_require__(7504)
var whitespace = __webpack_require__(2139)
var escapes = __webpack_require__(2123)
var prefix = __webpack_require__(1817)

module.exports = factory

var tab = '\t'
var lineFeed = '\n'
var space = ' '
var numberSign = '#'
var ampersand = '&'
var leftParenthesis = '('
var rightParenthesis = ')'
var asterisk = '*'
var plusSign = '+'
var dash = '-'
var dot = '.'
var colon = ':'
var lessThan = '<'
var greaterThan = '>'
var leftSquareBracket = '['
var backslash = '\\'
var rightSquareBracket = ']'
var underscore = '_'
var graveAccent = '`'
var verticalBar = '|'
var tilde = '~'
var exclamationMark = '!'

var entities = {
  '<': '&lt;',
  ':': '&#x3A;',
  '&': '&amp;',
  '|': '&#x7C;',
  '~': '&#x7E;'
}

var shortcut = 'shortcut'
var mailto = 'mailto'
var https = 'https'
var http = 'http'

var blankExpression = /\n\s*$/

// Factory to escape characters.
function factory(options) {
  return escape

  // Escape punctuation characters in a node’s value.
  function escape(value, node, parent) {
    var self = this
    var gfm = options.gfm
    var commonmark = options.commonmark
    var pedantic = options.pedantic
    var markers = commonmark ? [dot, rightParenthesis] : [dot]
    var siblings = parent && parent.children
    var index = siblings && siblings.indexOf(node)
    var previous = siblings && siblings[index - 1]
    var next = siblings && siblings[index + 1]
    var length = value.length
    var escapable = escapes(options)
    var position = -1
    var queue = []
    var escaped = queue
    var afterNewLine
    var character
    var wordCharBefore
    var wordCharAfter
    var offset
    var replace

    if (previous) {
      afterNewLine = text(previous) && blankExpression.test(previous.value)
    } else {
      afterNewLine =
        !parent || parent.type === 'root' || parent.type === 'paragraph'
    }

    while (++position < length) {
      character = value.charAt(position)
      replace = false

      if (character === '\n') {
        afterNewLine = true
      } else if (
        character === backslash ||
        character === graveAccent ||
        character === asterisk ||
        character === leftSquareBracket ||
        character === lessThan ||
        (character === ampersand && prefix(value.slice(position)) > 0) ||
        (character === rightSquareBracket && self.inLink) ||
        (gfm && character === tilde && value.charAt(position + 1) === tilde) ||
        (gfm &&
          character === verticalBar &&
          (self.inTable || alignment(value, position))) ||
        (character === underscore &&
          // Delegate leading/trailing underscores to the multinode version below.
          position > 0 &&
          position < length - 1 &&
          (pedantic ||
            !alphanumeric(value.charAt(position - 1)) ||
            !alphanumeric(value.charAt(position + 1)))) ||
        (gfm && !self.inLink && character === colon && protocol(queue.join('')))
      ) {
        replace = true
      } else if (afterNewLine) {
        if (
          character === greaterThan ||
          character === numberSign ||
          character === asterisk ||
          character === dash ||
          character === plusSign
        ) {
          replace = true
        } else if (decimal(character)) {
          offset = position + 1

          while (offset < length) {
            if (!decimal(value.charAt(offset))) {
              break
            }

            offset++
          }

          if (markers.indexOf(value.charAt(offset)) !== -1) {
            next = value.charAt(offset + 1)

            if (!next || next === space || next === tab || next === lineFeed) {
              queue.push(value.slice(position, offset))
              position = offset
              character = value.charAt(position)
              replace = true
            }
          }
        }
      }

      if (afterNewLine && !whitespace(character)) {
        afterNewLine = false
      }

      queue.push(replace ? one(character) : character)
    }

    // Multi-node versions.
    if (siblings && text(node)) {
      // Check for an opening parentheses after a link-reference (which can be
      // joined by white-space).
      if (previous && previous.referenceType === shortcut) {
        position = -1
        length = escaped.length

        while (++position < length) {
          character = escaped[position]

          if (character === space || character === tab) {
            continue
          }

          if (character === leftParenthesis || character === colon) {
            escaped[position] = one(character)
          }

          break
        }

        // If the current node is all spaces / tabs, preceded by a shortcut,
        // and followed by a text starting with `(`, escape it.
        if (
          text(next) &&
          position === length &&
          next.value.charAt(0) === leftParenthesis
        ) {
          escaped.push(backslash)
        }
      }

      // Ensure non-auto-links are not seen as links.  This pattern needs to
      // check the preceding nodes too.
      if (
        gfm &&
        !self.inLink &&
        text(previous) &&
        value.charAt(0) === colon &&
        protocol(previous.value.slice(-6))
      ) {
        escaped[0] = one(colon)
      }

      // Escape ampersand if it would otherwise start an entity.
      if (
        text(next) &&
        value.charAt(length - 1) === ampersand &&
        prefix(ampersand + next.value) !== 0
      ) {
        escaped[escaped.length - 1] = one(ampersand)
      }

      // Escape exclamation marks immediately followed by links.
      if (
        next &&
        next.type === 'link' &&
        value.charAt(length - 1) === exclamationMark
      ) {
        escaped[escaped.length - 1] = one(exclamationMark)
      }

      // Escape double tildes in GFM.
      if (
        gfm &&
        text(next) &&
        value.charAt(length - 1) === tilde &&
        next.value.charAt(0) === tilde
      ) {
        escaped.splice(-1, 0, backslash)
      }

      // Escape underscores, but not mid-word (unless in pedantic mode).
      wordCharBefore = text(previous) && alphanumeric(previous.value.slice(-1))
      wordCharAfter = text(next) && alphanumeric(next.value.charAt(0))

      if (length === 1) {
        if (
          value === underscore &&
          (pedantic || !wordCharBefore || !wordCharAfter)
        ) {
          escaped.unshift(backslash)
        }
      } else {
        if (
          value.charAt(0) === underscore &&
          (pedantic || !wordCharBefore || !alphanumeric(value.charAt(1)))
        ) {
          escaped.unshift(backslash)
        }

        if (
          value.charAt(length - 1) === underscore &&
          (pedantic ||
            !wordCharAfter ||
            !alphanumeric(value.charAt(length - 2)))
        ) {
          escaped.splice(-1, 0, backslash)
        }
      }
    }

    return escaped.join('')

    function one(character) {
      return escapable.indexOf(character) === -1
        ? entities[character]
        : backslash + character
    }
  }
}

// Check if `index` in `value` is inside an alignment row.
function alignment(value, index) {
  var start = value.lastIndexOf(lineFeed, index)
  var end = value.indexOf(lineFeed, index)
  var char

  end = end === -1 ? value.length : end

  while (++start < end) {
    char = value.charAt(start)

    if (
      char !== colon &&
      char !== dash &&
      char !== space &&
      char !== verticalBar
    ) {
      return false
    }
  }

  return true
}

// Check if `node` is a text node.
function text(node) {
  return node && node.type === 'text'
}

// Check if `value` ends in a protocol.
function protocol(value) {
  var tail = value.slice(-6).toLowerCase()
  return tail === mailto || tail.slice(-5) === https || tail.slice(-4) === http
}


/***/ }),

/***/ 1189:
/***/ ((module) => {

"use strict";


module.exports = all

// Visit all children of `parent`.
function all(parent) {
  var self = this
  var children = parent.children
  var length = children.length
  var results = []
  var index = -1

  while (++index < length) {
    results[index] = self.visit(children[index], parent)
  }

  return results
}


/***/ }),

/***/ 7889:
/***/ ((module) => {

"use strict";


module.exports = block

var lineFeed = '\n'

var blank = lineFeed + lineFeed
var triple = blank + lineFeed
var comment = blank + '<!---->' + blank

// Stringify a block node with block children (e.g., `root` or `blockquote`).
// Knows about code following a list, or adjacent lists with similar bullets,
// and places an extra line feed between them.
function block(node) {
  var self = this
  var options = self.options
  var fences = options.fences
  var gap = options.commonmark ? comment : triple
  var definitionGap = options.tightDefinitions ? lineFeed : blank
  var values = []
  var children = node.children
  var length = children.length
  var index = -1
  var previous
  var child

  while (++index < length) {
    previous = child
    child = children[index]

    if (previous) {
      // A list preceding another list that are equally ordered, or a
      // list preceding an indented code block, need a gap between them,
      // so as not to see them as one list, or content of the list,
      // respectively.
      //
      // In commonmark, only something that breaks both up can do that,
      // so we opt for an empty, invisible comment.  In other flavours,
      // two blank lines are fine.
      if (
        previous.type === 'list' &&
        ((child.type === 'list' && previous.ordered === child.ordered) ||
          (child.type === 'code' && !child.lang && !fences))
      ) {
        values.push(gap)
      } else if (
        previous.type === 'definition' &&
        child.type === 'definition'
      ) {
        values.push(definitionGap)
      } else {
        values.push(blank)
      }
    }

    values.push(self.visit(child, node))
  }

  return values.join('')
}


/***/ }),

/***/ 8833:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var compact = __webpack_require__(4245)

module.exports = compile

// Stringify the given tree.
function compile() {
  return this.visit(compact(this.tree, this.options.commonmark))
}


/***/ }),

/***/ 1977:
/***/ ((module) => {

"use strict";


module.exports = one

function one(node, parent) {
  var self = this
  var visitors = self.visitors

  // Fail on unknown nodes.
  if (typeof visitors[node.type] !== 'function') {
    self.file.fail(
      new Error(
        'Missing compiler for node of type `' + node.type + '`: `' + node + '`'
      ),
      node
    )
  }

  return visitors[node.type].call(self, node, parent)
}


/***/ }),

/***/ 4536:
/***/ ((module) => {

"use strict";


module.exports = orderedItems

var lineFeed = '\n'
var dot = '.'

var blank = lineFeed + lineFeed

// Visit ordered list items.
//
// Starts the list with
// `node.start` and increments each following list item
// bullet by one:
//
//     2. foo
//     3. bar
//
// In `incrementListMarker: false` mode, does not increment
// each marker and stays on `node.start`:
//
//     1. foo
//     1. bar
function orderedItems(node) {
  var self = this
  var fn = self.visitors.listItem
  var increment = self.options.incrementListMarker
  var values = []
  var start = node.start
  var children = node.children
  var length = children.length
  var index = -1
  var bullet

  start = start == null ? 1 : start

  while (++index < length) {
    bullet = (increment ? start + index : start) + dot
    values[index] = fn.call(self, children[index], node, index, bullet)
  }

  return values.join(node.spread ? blank : lineFeed)
}


/***/ }),

/***/ 1905:
/***/ ((module) => {

"use strict";


module.exports = unorderedItems

var lineFeed = '\n'

var blank = lineFeed + lineFeed

// Visit unordered list items.  Uses `options.bullet` as each item’s bullet.
function unorderedItems(node) {
  var self = this
  var bullet = self.options.bullet
  var fn = self.visitors.listItem
  var children = node.children
  var length = children.length
  var index = -1
  var values = []

  while (++index < length) {
    values[index] = fn.call(self, children[index], node, index, bullet)
  }

  return values.join(node.spread ? blank : lineFeed)
}


/***/ }),

/***/ 674:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var xtend = __webpack_require__(7529)
var encode = __webpack_require__(7089)
var defaults = __webpack_require__(9125)
var escapeFactory = __webpack_require__(8826)
var identity = __webpack_require__(2726)

module.exports = setOptions

// Map of applicable enums.
var maps = {
  entities: {true: true, false: true, numbers: true, escape: true},
  bullet: {'*': true, '-': true, '+': true},
  rule: {'-': true, _: true, '*': true},
  listItemIndent: {tab: true, mixed: true, 1: true},
  emphasis: {_: true, '*': true},
  strong: {_: true, '*': true},
  fence: {'`': true, '~': true}
}

// Expose `validate`.
var validate = {
  boolean: validateBoolean,
  string: validateString,
  number: validateNumber,
  function: validateFunction
}

// Set options.  Does not overwrite previously set options.
function setOptions(options) {
  var self = this
  var current = self.options
  var ruleRepetition
  var key

  if (options == null) {
    options = {}
  } else if (typeof options === 'object') {
    options = xtend(options)
  } else {
    throw new Error('Invalid value `' + options + '` for setting `options`')
  }

  for (key in defaults) {
    validate[typeof defaults[key]](options, key, current[key], maps[key])
  }

  ruleRepetition = options.ruleRepetition

  if (ruleRepetition && ruleRepetition < 3) {
    raise(ruleRepetition, 'options.ruleRepetition')
  }

  self.encode = encodeFactory(String(options.entities))
  self.escape = escapeFactory(options)

  self.options = options

  return self
}

// Validate a value to be boolean. Defaults to `def`.  Raises an exception with
// `context[name]` when not a boolean.
function validateBoolean(context, name, def) {
  var value = context[name]

  if (value == null) {
    value = def
  }

  if (typeof value !== 'boolean') {
    raise(value, 'options.' + name)
  }

  context[name] = value
}

// Validate a value to be boolean. Defaults to `def`.  Raises an exception with
// `context[name]` when not a boolean.
function validateNumber(context, name, def) {
  var value = context[name]

  if (value == null) {
    value = def
  }

  if (isNaN(value)) {
    raise(value, 'options.' + name)
  }

  context[name] = value
}

// Validate a value to be in `map`. Defaults to `def`.  Raises an exception
// with `context[name]` when not in `map`.
function validateString(context, name, def, map) {
  var value = context[name]

  if (value == null) {
    value = def
  }

  value = String(value)

  if (!(value in map)) {
    raise(value, 'options.' + name)
  }

  context[name] = value
}

// Validate a value to be function. Defaults to `def`.  Raises an exception
// with `context[name]` when not a function.
function validateFunction(context, name, def) {
  var value = context[name]

  if (value == null) {
    value = def
  }

  if (typeof value !== 'function') {
    raise(value, 'options.' + name)
  }

  context[name] = value
}

// Factory to encode HTML entities.  Creates a no-operation function when
// `type` is `'false'`, a function which encodes using named references when
// `type` is `'true'`, and a function which encodes using numbered references
// when `type` is `'numbers'`.
function encodeFactory(type) {
  var options = {}

  if (type === 'false') {
    return identity
  }

  if (type === 'true') {
    options.useNamedReferences = true
  }

  if (type === 'escape') {
    options.escapeOnly = true
    options.useNamedReferences = true
  }

  return wrapped

  // Encode HTML entities using the bound options.
  function wrapped(value) {
    return encode(value, options)
  }
}

// Throw an exception with in its `message` `value` and `name`.
function raise(value, name) {
  throw new Error('Invalid value `' + value + '` for setting `' + name + '`')
}


/***/ }),

/***/ 1006:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var entityPrefixLength = __webpack_require__(1817)

module.exports = copy

var ampersand = '&'

var punctuationExppresion = /[-!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~_]/

// For shortcut and collapsed reference links, the contents is also an
// identifier, so we need to restore the original encoding and escaping
// that were present in the source string.
//
// This function takes the unescaped & unencoded value from shortcut’s
// child nodes and the identifier and encodes the former according to
// the latter.
function copy(value, identifier) {
  var length = value.length
  var count = identifier.length
  var result = []
  var position = 0
  var index = 0
  var start

  while (index < length) {
    // Take next non-punctuation characters from `value`.
    start = index

    while (index < length && !punctuationExppresion.test(value.charAt(index))) {
      index += 1
    }

    result.push(value.slice(start, index))

    // Advance `position` to the next punctuation character.
    while (
      position < count &&
      !punctuationExppresion.test(identifier.charAt(position))
    ) {
      position += 1
    }

    // Take next punctuation characters from `identifier`.
    start = position

    while (
      position < count &&
      punctuationExppresion.test(identifier.charAt(position))
    ) {
      if (identifier.charAt(position) === ampersand) {
        position += entityPrefixLength(identifier.slice(position))
      }

      position += 1
    }

    result.push(identifier.slice(start, position))

    // Advance `index` to the next non-punctuation character.
    while (index < length && punctuationExppresion.test(value.charAt(index))) {
      index += 1
    }
  }

  return result.join('')
}


/***/ }),

/***/ 8690:
/***/ ((module) => {

"use strict";


module.exports = enclose

var quotationMark = '"'
var apostrophe = "'"

// There is currently no way to support nested delimiters across Markdown.pl,
// CommonMark, and GitHub (RedCarpet).  The following code supports Markdown.pl
// and GitHub.
// CommonMark is not supported when mixing double- and single quotes inside a
// title.
function enclose(title) {
  var delimiter =
    title.indexOf(quotationMark) === -1 ? quotationMark : apostrophe
  return delimiter + title + delimiter
}


/***/ }),

/***/ 7521:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var count = __webpack_require__(932)

module.exports = enclose

var leftParenthesis = '('
var rightParenthesis = ')'
var lessThan = '<'
var greaterThan = '>'

var expression = /\s/

// Wrap `url` in angle brackets when needed, or when
// forced.
// In links, images, and definitions, the URL part needs
// to be enclosed when it:
//
// - has a length of `0`
// - contains white-space
// - has more or less opening than closing parentheses
function enclose(uri, always) {
  if (
    always ||
    uri.length === 0 ||
    expression.test(uri) ||
    count(uri, leftParenthesis) !== count(uri, rightParenthesis)
  ) {
    return lessThan + uri + greaterThan
  }

  return uri
}


/***/ }),

/***/ 9418:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var identity = __webpack_require__(2726)

module.exports = enter

// Shortcut and collapsed link references need no escaping and encoding during
// the processing of child nodes (it must be implied from identifier).
//
// This toggler turns encoding and escaping off for shortcut and collapsed
// references.
//
// Implies `enterLink`.
function enter(compiler, node) {
  var encode = compiler.encode
  var escape = compiler.escape
  var exitLink = compiler.enterLink()

  if (node.referenceType !== 'shortcut' && node.referenceType !== 'collapsed') {
    return exitLink
  }

  compiler.escape = identity
  compiler.encode = identity

  return exit

  function exit() {
    compiler.encode = encode
    compiler.escape = escape
    exitLink()
  }
}


/***/ }),

/***/ 1817:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var decode = __webpack_require__(4595)

module.exports = length

var ampersand = '&'

// Returns the length of HTML entity that is a prefix of the given string
// (excluding the ampersand), 0 if it does not start with an entity.
function length(value) {
  var prefix

  /* istanbul ignore if - Currently also tested for at implemention, but we
   * keep it here because that’s proper. */
  if (value.charAt(0) !== ampersand) {
    return 0
  }

  prefix = value.split(ampersand, 2).join(ampersand)

  return prefix.length - decode(prefix).length
}


/***/ }),

/***/ 2726:
/***/ ((module) => {

"use strict";


module.exports = identity

function identity(value) {
  return value
}


/***/ }),

/***/ 5086:
/***/ ((module) => {

"use strict";


module.exports = label

var leftSquareBracket = '['
var rightSquareBracket = ']'

var shortcut = 'shortcut'
var collapsed = 'collapsed'

// Stringify a reference label.
// Because link references are easily, mistakingly, created (for example,
// `[foo]`), reference nodes have an extra property depicting how it looked in
// the original document, so stringification can cause minimal changes.
function label(node) {
  var type = node.referenceType

  if (type === shortcut) {
    return ''
  }

  return (
    leftSquareBracket +
    (type === collapsed ? '' : node.label || node.identifier) +
    rightSquareBracket
  )
}


/***/ }),

/***/ 1809:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var repeat = __webpack_require__(6464)

module.exports = pad

var lineFeed = '\n'
var space = ' '

var tabSize = 4

// Pad `value` with `level * tabSize` spaces.  Respects lines.  Ignores empty
// lines.
function pad(value, level) {
  var values = value.split(lineFeed)
  var index = values.length
  var padding = repeat(space, level * tabSize)

  while (index--) {
    if (values[index].length !== 0) {
      values[index] = padding + values[index]
    }
  }

  return values.join(lineFeed)
}


/***/ }),

/***/ 6363:
/***/ ((module) => {

"use strict";


module.exports = blockquote

var lineFeed = '\n'
var space = ' '
var greaterThan = '>'

function blockquote(node) {
  var values = this.block(node).split(lineFeed)
  var result = []
  var length = values.length
  var index = -1
  var value

  while (++index < length) {
    value = values[index]
    result[index] = (value ? space : '') + value
  }

  return greaterThan + result.join(lineFeed + greaterThan)
}


/***/ }),

/***/ 9720:
/***/ ((module) => {

"use strict";


module.exports = lineBreak

var backslash = '\\'
var lineFeed = '\n'
var space = ' '

var commonmark = backslash + lineFeed
var normal = space + space + lineFeed

function lineBreak() {
  return this.options.commonmark ? commonmark : normal
}


/***/ }),

/***/ 7846:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var streak = __webpack_require__(2491)
var repeat = __webpack_require__(6464)
var pad = __webpack_require__(1809)

module.exports = code

var lineFeed = '\n'
var space = ' '
var tilde = '~'
var graveAccent = '`'

// Stringify code.
// Creates indented code when:
//
// - No language tag exists
// - Not in `fences: true` mode
// - A non-empty value exists
//
// Otherwise, GFM fenced code is created:
//
// ````markdown
// ```js
// foo();
// ```
// ````
//
// When in ``fence: `~` `` mode, uses tildes as fences:
//
// ```markdown
// ~~~js
// foo();
// ~~~
// ```
//
// Knows about internal fences:
//
// `````markdown
// ````markdown
// ```javascript
// foo();
// ```
// ````
// `````
function code(node, parent) {
  var self = this
  var value = node.value
  var options = self.options
  var marker = options.fence
  var info = node.lang || ''
  var fence

  if (info && node.meta) {
    info += space + node.meta
  }

  info = self.encode(self.escape(info, node))

  // Without (needed) fences.
  if (
    !info &&
    !options.fences &&
    value &&
    value.charAt(0) !== lineFeed &&
    value.charAt(value.length - 1) !== lineFeed
  ) {
    // Throw when pedantic, in a list item which isn’t compiled using a tab.
    if (
      parent &&
      parent.type === 'listItem' &&
      options.listItemIndent !== 'tab' &&
      options.pedantic
    ) {
      self.file.fail(
        'Cannot indent code properly. See https://git.io/fxKR8',
        node.position
      )
    }

    return pad(value, 1)
  }

  // Backticks in the info string don’t work with backtick fenced code.
  // Backticks (and tildes) are fine in tilde fenced code.
  if (marker === graveAccent && info.indexOf(graveAccent) !== -1) {
    marker = tilde
  }

  fence = repeat(marker, Math.max(streak(value, marker) + 1, 3))

  return fence + info + lineFeed + value + lineFeed + fence
}


/***/ }),

/***/ 4496:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var uri = __webpack_require__(7521)
var title = __webpack_require__(8690)

module.exports = definition

var space = ' '
var colon = ':'
var leftSquareBracket = '['
var rightSquareBracket = ']'

// Stringify an URL definition.
//
// Is smart about enclosing `url` (see `encloseURI()`) and `title` (see
// `encloseTitle()`).
//
// ```markdown
// [foo]: <foo at bar dot com> 'An "example" e-mail'
// ```
function definition(node) {
  var content = uri(node.url)

  if (node.title) {
    content += space + title(node.title)
  }

  return (
    leftSquareBracket +
    (node.label || node.identifier) +
    rightSquareBracket +
    colon +
    space +
    content
  )
}


/***/ }),

/***/ 2797:
/***/ ((module) => {

"use strict";


module.exports = strikethrough

var tilde = '~'

var fence = tilde + tilde

function strikethrough(node) {
  return fence + this.all(node).join('') + fence
}


/***/ }),

/***/ 5469:
/***/ ((module) => {

"use strict";


module.exports = emphasis

var underscore = '_'
var asterisk = '*'

// Stringify an `emphasis`.
//
// The marker used is configurable through `emphasis`, which defaults to an
// underscore (`'_'`) but also accepts an asterisk (`'*'`):
//
// ```markdown
// *foo*
// ```
//
// In `pedantic` mode, text which itself contains an underscore will cause the
// marker to default to an asterisk instead:
//
// ```markdown
// *foo_bar*
// ```
function emphasis(node) {
  var marker = this.options.emphasis
  var content = this.all(node).join('')

  // When in pedantic mode, prevent using underscore as the marker when there
  // are underscores in the content.
  if (
    this.options.pedantic &&
    marker === underscore &&
    content.indexOf(marker) !== -1
  ) {
    marker = asterisk
  }

  return marker + content + marker
}


/***/ }),

/***/ 8816:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var repeat = __webpack_require__(6464)

module.exports = heading

var lineFeed = '\n'
var space = ' '
var numberSign = '#'
var dash = '-'
var equalsTo = '='

// Stringify a heading.
//
// In `setext: true` mode and when `depth` is smaller than three, creates a
// setext header:
//
// ```markdown
// Foo
// ===
// ```
//
// Otherwise, an ATX header is generated:
//
// ```markdown
// ### Foo
// ```
//
// In `closeAtx: true` mode, the header is closed with hashes:
//
// ```markdown
// ### Foo ###
// ```
function heading(node) {
  var self = this
  var depth = node.depth
  var setext = self.options.setext
  var closeAtx = self.options.closeAtx
  var content = self.all(node).join('')
  var prefix

  if (setext && depth < 3) {
    return (
      content + lineFeed + repeat(depth === 1 ? equalsTo : dash, content.length)
    )
  }

  prefix = repeat(numberSign, node.depth)

  return prefix + space + content + (closeAtx ? space + prefix : '')
}


/***/ }),

/***/ 5665:
/***/ ((module) => {

"use strict";


module.exports = html

function html(node) {
  return node.value
}


/***/ }),

/***/ 1514:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var label = __webpack_require__(5086)

module.exports = imageReference

var leftSquareBracket = '['
var rightSquareBracket = ']'
var exclamationMark = '!'

function imageReference(node) {
  return (
    exclamationMark +
    leftSquareBracket +
    (this.encode(node.alt, node) || '') +
    rightSquareBracket +
    label(node)
  )
}


/***/ }),

/***/ 2366:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var uri = __webpack_require__(7521)
var title = __webpack_require__(8690)

module.exports = image

var space = ' '
var leftParenthesis = '('
var rightParenthesis = ')'
var leftSquareBracket = '['
var rightSquareBracket = ']'
var exclamationMark = '!'

// Stringify an image.
//
// Is smart about enclosing `url` (see `encloseURI()`) and `title` (see
// `encloseTitle()`).
//
// ```markdown
// ![foo](</fav icon.png> 'My "favourite" icon')
// ```
//
// Supports named entities in `url`, `alt`, and `title` when in
// `settings.encode` mode.
function image(node) {
  var self = this
  var content = uri(self.encode(node.url || '', node))
  var exit = self.enterLink()
  var alt = self.encode(self.escape(node.alt || '', node))

  exit()

  if (node.title) {
    content += space + title(self.encode(node.title, node))
  }

  return (
    exclamationMark +
    leftSquareBracket +
    alt +
    rightSquareBracket +
    leftParenthesis +
    content +
    rightParenthesis
  )
}


/***/ }),

/***/ 5730:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var streak = __webpack_require__(2491)
var repeat = __webpack_require__(6464)

module.exports = inlineCode

var graveAccentChar = '`'
var lineFeed = 10 //  '\n'
var space = 32 // ' '
var graveAccent = 96 //  '`'

// Stringify inline code.
//
// Knows about internal ticks (`\``), and ensures one more tick is used to
// enclose the inline code:
//
// ````markdown
// ```foo ``bar`` baz```
// ````
//
// Even knows about inital and final ticks:
//
// ``markdown
// `` `foo ``
// `` foo` ``
// ```
function inlineCode(node) {
  var value = node.value
  var ticks = repeat(graveAccentChar, streak(value, graveAccentChar) + 1)
  var start = ticks
  var end = ticks
  var head = value.charCodeAt(0)
  var tail = value.charCodeAt(value.length - 1)
  var wrap = false
  var index
  var length

  if (head === graveAccent || tail === graveAccent) {
    wrap = true
  } else if (value.length > 2 && ws(head) && ws(tail)) {
    index = 1
    length = value.length - 1

    while (++index < length) {
      if (!ws(value.charCodeAt(index))) {
        wrap = true
        break
      }
    }
  }

  if (wrap) {
    start += ' '
    end = ' ' + end
  }

  return start + value + end
}

function ws(code) {
  return code === lineFeed || code === space
}


/***/ }),

/***/ 2133:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var copy = __webpack_require__(1006)
var label = __webpack_require__(5086)

module.exports = linkReference

var leftSquareBracket = '['
var rightSquareBracket = ']'

var shortcut = 'shortcut'
var collapsed = 'collapsed'

function linkReference(node) {
  var self = this
  var type = node.referenceType
  var exit = self.enterLinkReference(self, node)
  var value = self.all(node).join('')

  exit()

  if (type === shortcut || type === collapsed) {
    value = copy(value, node.label || node.identifier)
  }

  return leftSquareBracket + value + rightSquareBracket + label(node)
}


/***/ }),

/***/ 4485:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var uri = __webpack_require__(7521)
var title = __webpack_require__(8690)

module.exports = link

var space = ' '
var leftSquareBracket = '['
var rightSquareBracket = ']'
var leftParenthesis = '('
var rightParenthesis = ')'

// Expression for a protocol:
// See <https://en.wikipedia.org/wiki/Uniform_Resource_Identifier#Generic_syntax>.
var protocol = /^[a-z][a-z+.-]+:\/?/i

// Stringify a link.
//
// When no title exists, the compiled `children` equal `url`, and `url` starts
// with a protocol, an auto link is created:
//
// ```markdown
// <http://example.com>
// ```
//
// Otherwise, is smart about enclosing `url` (see `encloseURI()`) and `title`
// (see `encloseTitle()`).
// ```
//
// ```markdown
// [foo](<foo at bar dot com> 'An "example" e-mail')
// ```
//
// Supports named entities in the `url` and `title` when in `settings.encode`
// mode.
function link(node) {
  var self = this
  var content = self.encode(node.url || '', node)
  var exit = self.enterLink()
  var escaped = self.encode(self.escape(node.url || '', node))
  var value = self.all(node).join('')

  exit()

  if (node.title == null && protocol.test(content) && escaped === value) {
    // Backslash escapes do not work in autolinks, so we do not escape.
    return uri(self.encode(node.url), true)
  }

  content = uri(content)

  if (node.title) {
    content += space + title(self.encode(self.escape(node.title, node), node))
  }

  return (
    leftSquareBracket +
    value +
    rightSquareBracket +
    leftParenthesis +
    content +
    rightParenthesis
  )
}


/***/ }),

/***/ 631:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var repeat = __webpack_require__(6464)
var pad = __webpack_require__(1809)

module.exports = listItem

var lineFeed = '\n'
var space = ' '
var leftSquareBracket = '['
var rightSquareBracket = ']'
var lowercaseX = 'x'

var ceil = Math.ceil
var blank = lineFeed + lineFeed

var tabSize = 4

// Stringify a list item.
//
// Prefixes the content with a checked checkbox when `checked: true`:
//
// ```markdown
// [x] foo
// ```
//
// Prefixes the content with an unchecked checkbox when `checked: false`:
//
// ```markdown
// [ ] foo
// ```
function listItem(node, parent, position, bullet) {
  var self = this
  var style = self.options.listItemIndent
  var marker = bullet || self.options.bullet
  var spread = node.spread == null ? true : node.spread
  var checked = node.checked
  var children = node.children
  var length = children.length
  var values = []
  var index = -1
  var value
  var indent
  var spacing

  while (++index < length) {
    values[index] = self.visit(children[index], node)
  }

  value = values.join(spread ? blank : lineFeed)

  if (typeof checked === 'boolean') {
    // Note: I’d like to be able to only add the space between the check and
    // the value, but unfortunately github does not support empty list-items
    // with a checkbox :(
    value =
      leftSquareBracket +
      (checked ? lowercaseX : space) +
      rightSquareBracket +
      space +
      value
  }

  if (style === '1' || (style === 'mixed' && value.indexOf(lineFeed) === -1)) {
    indent = marker.length + 1
    spacing = space
  } else {
    indent = ceil((marker.length + 1) / tabSize) * tabSize
    spacing = repeat(space, indent - marker.length)
  }

  return value
    ? marker + spacing + pad(value, indent / tabSize).slice(indent)
    : marker
}


/***/ }),

/***/ 9555:
/***/ ((module) => {

"use strict";


module.exports = list

function list(node) {
  var fn = node.ordered ? this.visitOrderedItems : this.visitUnorderedItems
  return fn.call(this, node)
}


/***/ }),

/***/ 2879:
/***/ ((module) => {

"use strict";


module.exports = paragraph

function paragraph(node) {
  return this.all(node).join('')
}


/***/ }),

/***/ 9566:
/***/ ((module) => {

"use strict";


module.exports = root

var lineFeed = '\n'

// Stringify a root.
// Adds a final newline to ensure valid POSIX files. */
function root(node) {
  var doc = this.block(node)

  if (doc.charAt(doc.length - 1) !== lineFeed) {
    doc += lineFeed
  }

  return doc
}


/***/ }),

/***/ 1291:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var repeat = __webpack_require__(6464)

module.exports = strong

// Stringify a `strong`.
//
// The marker used is configurable by `strong`, which defaults to an asterisk
// (`'*'`) but also accepts an underscore (`'_'`):
//
// ```markdown
// __foo__
// ```
function strong(node) {
  var marker = repeat(this.options.strong, 2)
  return marker + this.all(node).join('') + marker
}


/***/ }),

/***/ 7286:
/***/ ((module) => {

"use strict";


module.exports = tableCell

var lineFeed = /\r?\n/g

function tableCell(node) {
  return this.all(node).join('').replace(lineFeed, ' ')
}


/***/ }),

/***/ 7936:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var markdownTable = __webpack_require__(8234)

module.exports = table

// Stringify table.
//
// Creates a fenced table.
// The table has aligned delimiters by default, but not in
// `tablePipeAlign: false`:
//
// ```markdown
// | Header 1 | Header 2 |
// | :-: | - |
// | Alpha | Bravo |
// ```
//
// The table is spaced by default, but not in `tableCellPadding: false`:
//
// ```markdown
// |Foo|Bar|
// |:-:|---|
// |Baz|Qux|
// ```
function table(node) {
  var self = this
  var options = self.options
  var padding = options.tableCellPadding
  var alignDelimiters = options.tablePipeAlign
  var stringLength = options.stringLength
  var rows = node.children
  var index = rows.length
  var exit = self.enterTable()
  var result = []

  while (index--) {
    result[index] = self.all(rows[index])
  }

  exit()

  return markdownTable(result, {
    align: node.align,
    alignDelimiters: alignDelimiters,
    padding: padding,
    stringLength: stringLength
  })
}


/***/ }),

/***/ 2072:
/***/ ((module) => {

"use strict";


module.exports = text

// Stringify text.
// Supports named entities in `settings.encode: true` mode:
//
// ```markdown
// AT&amp;T
// ```
//
// Supports numbered entities in `settings.encode: numbers` mode:
//
// ```markdown
// AT&#x26;T
// ```
function text(node, parent) {
  return this.encode(this.escape(node.value, node, parent), node)
}


/***/ }),

/***/ 733:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var repeat = __webpack_require__(6464)

module.exports = thematic

var space = ' '

// Stringify a `thematic-break`.
// The character used is configurable through `rule`: (`'_'`):
//
// ```markdown
// ___
// ```
//
// The number of repititions is defined through `ruleRepetition` (`6`):
//
// ```markdown
// ******
// ```
//
// Whether spaces delimit each character, is configured through `ruleSpaces`
// (`true`):
// ```markdown
// * * *
// ```
function thematic() {
  var options = this.options
  var rule = repeat(options.rule, options.ruleRepetition)
  return options.ruleSpaces ? rule.split('').join(space) : rule
}


/***/ }),

/***/ 7468:
/***/ ((module) => {

"use strict";


/* eslint-env browser */

var el

var semicolon = 59 //  ';'

module.exports = decodeEntity

function decodeEntity(characters) {
  var entity = '&' + characters + ';'
  var char

  el = el || document.createElement('i')
  el.innerHTML = entity
  char = el.textContent

  // Some entities do not require the closing semicolon (`&not` - for instance),
  // which leads to situations where parsing the assumed entity of &notit; will
  // result in the string `¬it;`.  When we encounter a trailing semicolon after
  // parsing and the entity to decode was not a semicolon (`&semi;`), we can
  // assume that the matching was incomplete
  if (char.charCodeAt(char.length - 1) === semicolon && characters !== 'semi') {
    return false
  }

  // If the decoded string is equal to the input, the entity was not valid
  return char === entity ? false : char
}


/***/ }),

/***/ 4595:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var legacy = __webpack_require__(7452)
var invalid = __webpack_require__(3580)
var decimal = __webpack_require__(6195)
var hexadecimal = __webpack_require__(9480)
var alphanumerical = __webpack_require__(7961)
var decodeEntity = __webpack_require__(7468)

module.exports = parseEntities

var own = {}.hasOwnProperty
var fromCharCode = String.fromCharCode
var noop = Function.prototype

// Default settings.
var defaults = {
  warning: null,
  reference: null,
  text: null,
  warningContext: null,
  referenceContext: null,
  textContext: null,
  position: {},
  additional: null,
  attribute: false,
  nonTerminated: true
}

// Characters.
var tab = 9 // '\t'
var lineFeed = 10 // '\n'
var formFeed = 12 // '\f'
var space = 32 // ' '
var ampersand = 38 // '&'
var semicolon = 59 // ';'
var lessThan = 60 // '<'
var equalsTo = 61 // '='
var numberSign = 35 // '#'
var uppercaseX = 88 // 'X'
var lowercaseX = 120 // 'x'
var replacementCharacter = 65533 // '�'

// Reference types.
var name = 'named'
var hexa = 'hexadecimal'
var deci = 'decimal'

// Map of bases.
var bases = {}

bases[hexa] = 16
bases[deci] = 10

// Map of types to tests.
// Each type of character reference accepts different characters.
// This test is used to detect whether a reference has ended (as the semicolon
// is not strictly needed).
var tests = {}

tests[name] = alphanumerical
tests[deci] = decimal
tests[hexa] = hexadecimal

// Warning types.
var namedNotTerminated = 1
var numericNotTerminated = 2
var namedEmpty = 3
var numericEmpty = 4
var namedUnknown = 5
var numericDisallowed = 6
var numericProhibited = 7

// Warning messages.
var messages = {}

messages[namedNotTerminated] =
  'Named character references must be terminated by a semicolon'
messages[numericNotTerminated] =
  'Numeric character references must be terminated by a semicolon'
messages[namedEmpty] = 'Named character references cannot be empty'
messages[numericEmpty] = 'Numeric character references cannot be empty'
messages[namedUnknown] = 'Named character references must be known'
messages[numericDisallowed] =
  'Numeric character references cannot be disallowed'
messages[numericProhibited] =
  'Numeric character references cannot be outside the permissible Unicode range'

// Wrap to ensure clean parameters are given to `parse`.
function parseEntities(value, options) {
  var settings = {}
  var option
  var key

  if (!options) {
    options = {}
  }

  for (key in defaults) {
    option = options[key]
    settings[key] =
      option === null || option === undefined ? defaults[key] : option
  }

  if (settings.position.indent || settings.position.start) {
    settings.indent = settings.position.indent || []
    settings.position = settings.position.start
  }

  return parse(value, settings)
}

// Parse entities.
// eslint-disable-next-line complexity
function parse(value, settings) {
  var additional = settings.additional
  var nonTerminated = settings.nonTerminated
  var handleText = settings.text
  var handleReference = settings.reference
  var handleWarning = settings.warning
  var textContext = settings.textContext
  var referenceContext = settings.referenceContext
  var warningContext = settings.warningContext
  var pos = settings.position
  var indent = settings.indent || []
  var length = value.length
  var index = 0
  var lines = -1
  var column = pos.column || 1
  var line = pos.line || 1
  var queue = ''
  var result = []
  var entityCharacters
  var namedEntity
  var terminated
  var characters
  var character
  var reference
  var following
  var warning
  var reason
  var output
  var entity
  var begin
  var start
  var type
  var test
  var prev
  var next
  var diff
  var end

  if (typeof additional === 'string') {
    additional = additional.charCodeAt(0)
  }

  // Cache the current point.
  prev = now()

  // Wrap `handleWarning`.
  warning = handleWarning ? parseError : noop

  // Ensure the algorithm walks over the first character and the end
  // (inclusive).
  index--
  length++

  while (++index < length) {
    // If the previous character was a newline.
    if (character === lineFeed) {
      column = indent[lines] || 1
    }

    character = value.charCodeAt(index)

    if (character === ampersand) {
      following = value.charCodeAt(index + 1)

      // The behaviour depends on the identity of the next character.
      if (
        following === tab ||
        following === lineFeed ||
        following === formFeed ||
        following === space ||
        following === ampersand ||
        following === lessThan ||
        following !== following ||
        (additional && following === additional)
      ) {
        // Not a character reference.
        // No characters are consumed, and nothing is returned.
        // This is not an error, either.
        queue += fromCharCode(character)
        column++

        continue
      }

      start = index + 1
      begin = start
      end = start

      if (following === numberSign) {
        // Numerical entity.
        end = ++begin

        // The behaviour further depends on the next character.
        following = value.charCodeAt(end)

        if (following === uppercaseX || following === lowercaseX) {
          // ASCII hex digits.
          type = hexa
          end = ++begin
        } else {
          // ASCII digits.
          type = deci
        }
      } else {
        // Named entity.
        type = name
      }

      entityCharacters = ''
      entity = ''
      characters = ''
      test = tests[type]
      end--

      while (++end < length) {
        following = value.charCodeAt(end)

        if (!test(following)) {
          break
        }

        characters += fromCharCode(following)

        // Check if we can match a legacy named reference.
        // If so, we cache that as the last viable named reference.
        // This ensures we do not need to walk backwards later.
        if (type === name && own.call(legacy, characters)) {
          entityCharacters = characters
          entity = legacy[characters]
        }
      }

      terminated = value.charCodeAt(end) === semicolon

      if (terminated) {
        end++

        namedEntity = type === name ? decodeEntity(characters) : false

        if (namedEntity) {
          entityCharacters = characters
          entity = namedEntity
        }
      }

      diff = 1 + end - start

      if (!terminated && !nonTerminated) {
        // Empty.
      } else if (!characters) {
        // An empty (possible) entity is valid, unless it’s numeric (thus an
        // ampersand followed by an octothorp).
        if (type !== name) {
          warning(numericEmpty, diff)
        }
      } else if (type === name) {
        // An ampersand followed by anything unknown, and not terminated, is
        // invalid.
        if (terminated && !entity) {
          warning(namedUnknown, 1)
        } else {
          // If theres something after an entity name which is not known, cap
          // the reference.
          if (entityCharacters !== characters) {
            end = begin + entityCharacters.length
            diff = 1 + end - begin
            terminated = false
          }

          // If the reference is not terminated, warn.
          if (!terminated) {
            reason = entityCharacters ? namedNotTerminated : namedEmpty

            if (settings.attribute) {
              following = value.charCodeAt(end)

              if (following === equalsTo) {
                warning(reason, diff)
                entity = null
              } else if (alphanumerical(following)) {
                entity = null
              } else {
                warning(reason, diff)
              }
            } else {
              warning(reason, diff)
            }
          }
        }

        reference = entity
      } else {
        if (!terminated) {
          // All non-terminated numeric entities are not rendered, and trigger a
          // warning.
          warning(numericNotTerminated, diff)
        }

        // When terminated and number, parse as either hexadecimal or decimal.
        reference = parseInt(characters, bases[type])

        // Trigger a warning when the parsed number is prohibited, and replace
        // with replacement character.
        if (prohibited(reference)) {
          warning(numericProhibited, diff)
          reference = fromCharCode(replacementCharacter)
        } else if (reference in invalid) {
          // Trigger a warning when the parsed number is disallowed, and replace
          // by an alternative.
          warning(numericDisallowed, diff)
          reference = invalid[reference]
        } else {
          // Parse the number.
          output = ''

          // Trigger a warning when the parsed number should not be used.
          if (disallowed(reference)) {
            warning(numericDisallowed, diff)
          }

          // Stringify the number.
          if (reference > 0xffff) {
            reference -= 0x10000
            output += fromCharCode((reference >>> (10 & 0x3ff)) | 0xd800)
            reference = 0xdc00 | (reference & 0x3ff)
          }

          reference = output + fromCharCode(reference)
        }
      }

      // Found it!
      // First eat the queued characters as normal text, then eat an entity.
      if (reference) {
        flush()

        prev = now()
        index = end - 1
        column += end - start + 1
        result.push(reference)
        next = now()
        next.offset++

        if (handleReference) {
          handleReference.call(
            referenceContext,
            reference,
            {start: prev, end: next},
            value.slice(start - 1, end)
          )
        }

        prev = next
      } else {
        // If we could not find a reference, queue the checked characters (as
        // normal characters), and move the pointer to their end.
        // This is possible because we can be certain neither newlines nor
        // ampersands are included.
        characters = value.slice(start - 1, end)
        queue += characters
        column += characters.length
        index = end - 1
      }
    } else {
      // Handle anything other than an ampersand, including newlines and EOF.
      if (
        character === 10 // Line feed
      ) {
        line++
        lines++
        column = 0
      }

      if (character === character) {
        queue += fromCharCode(character)
        column++
      } else {
        flush()
      }
    }
  }

  // Return the reduced nodes.
  return result.join('')

  // Get current position.
  function now() {
    return {
      line: line,
      column: column,
      offset: index + (pos.offset || 0)
    }
  }

  // “Throw” a parse-error: a warning.
  function parseError(code, offset) {
    var position = now()

    position.column += offset
    position.offset += offset

    handleWarning.call(warningContext, messages[code], position, code)
  }

  // Flush `queue` (normal text).
  // Macro invoked before each entity and at the end of `value`.
  // Does nothing when `queue` is empty.
  function flush() {
    if (queue) {
      result.push(queue)

      if (handleText) {
        handleText.call(textContext, queue, {start: prev, end: now()})
      }

      queue = ''
    }
  }
}

// Check if `character` is outside the permissible unicode range.
function prohibited(code) {
  return (code >= 0xd800 && code <= 0xdfff) || code > 0x10ffff
}

// Check if `character` is disallowed.
function disallowed(code) {
  return (
    (code >= 0x0001 && code <= 0x0008) ||
    code === 0x000b ||
    (code >= 0x000d && code <= 0x001f) ||
    (code >= 0x007f && code <= 0x009f) ||
    (code >= 0xfdd0 && code <= 0xfdef) ||
    (code & 0xffff) === 0xffff ||
    (code & 0xffff) === 0xfffe
  )
}


/***/ }),

/***/ 7089:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var entities = __webpack_require__(8348)
var legacy = __webpack_require__(7452)
var hexadecimal = __webpack_require__(9480)
var decimal = __webpack_require__(6195)
var alphanumerical = __webpack_require__(7961)
var dangerous = __webpack_require__(2702)

module.exports = encode
encode.escape = escape

var own = {}.hasOwnProperty

// Characters
var equalsTo = 61

// List of enforced escapes.
var escapes = ['"', "'", '<', '>', '&', '`']

// Map of characters to names.
var characters = construct()

// Default escapes.
var defaultEscapes = toExpression(escapes)

// Surrogate pairs.
var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g

// Non-ASCII characters.
// eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
var bmp = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g

// Encode special characters in `value`.
function encode(value, options) {
  var settings = options || {}
  var subset = settings.subset
  var set = subset ? toExpression(subset) : defaultEscapes
  var escapeOnly = settings.escapeOnly
  var omit = settings.omitOptionalSemicolons

  value = value.replace(set, replace)

  if (subset || escapeOnly) {
    return value
  }

  return value
    .replace(surrogatePair, replaceSurrogatePair)
    .replace(bmp, replace)

  function replaceSurrogatePair(pair, pos, slice) {
    return toHexReference(
      (pair.charCodeAt(0) - 0xd800) * 0x400 +
        pair.charCodeAt(1) -
        0xdc00 +
        0x10000,
      slice.charCodeAt(pos + 2),
      omit
    )
  }

  function replace(char, pos, slice) {
    return one(char, slice.charCodeAt(pos + 1), settings)
  }
}

// Shortcut to escape special characters in HTML.
function escape(value) {
  return encode(value, {escapeOnly: true, useNamedReferences: true})
}

// Encode `char` according to `options`.
function one(char, next, options) {
  var shortest = options.useShortestReferences
  var omit = options.omitOptionalSemicolons
  var named
  var code
  var numeric
  var decimal

  if ((shortest || options.useNamedReferences) && own.call(characters, char)) {
    named = toNamed(characters[char], next, omit, options.attribute)
  }

  if (shortest || !named) {
    code = char.charCodeAt(0)
    numeric = toHexReference(code, next, omit)

    // Use the shortest numeric reference when requested.
    // A simple algorithm would use decimal for all code points under 100, as
    // those are shorter than hexadecimal:
    //
    // * `&#99;` vs `&#x63;` (decimal shorter)
    // * `&#100;` vs `&#x64;` (equal)
    //
    // However, because we take `next` into consideration when `omit` is used,
    // And it would be possible that decimals are shorter on bigger values as
    // well if `next` is hexadecimal but not decimal, we instead compare both.
    if (shortest) {
      decimal = toDecimalReference(code, next, omit)

      if (decimal.length < numeric.length) {
        numeric = decimal
      }
    }
  }

  if (named && (!shortest || named.length < numeric.length)) {
    return named
  }

  return numeric
}

// Transform `code` into an entity.
function toNamed(name, next, omit, attribute) {
  var value = '&' + name

  if (
    omit &&
    own.call(legacy, name) &&
    dangerous.indexOf(name) === -1 &&
    (!attribute || (next && next !== equalsTo && !alphanumerical(next)))
  ) {
    return value
  }

  return value + ';'
}

// Transform `code` into a hexadecimal character reference.
function toHexReference(code, next, omit) {
  var value = '&#x' + code.toString(16).toUpperCase()
  return omit && next && !hexadecimal(next) ? value : value + ';'
}

// Transform `code` into a decimal character reference.
function toDecimalReference(code, next, omit) {
  var value = '&#' + String(code)
  return omit && next && !decimal(next) ? value : value + ';'
}

// Create an expression for `characters`.
function toExpression(characters) {
  return new RegExp('[' + characters.join('') + ']', 'g')
}

// Construct the map.
function construct() {
  var chars = {}
  var name

  for (name in entities) {
    chars[entities[name]] = name
  }

  return chars
}


/***/ }),

/***/ 6464:
/***/ ((module) => {

"use strict";
/*!
 * repeat-string <https://github.com/jonschlinkert/repeat-string>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */



/**
 * Results cache
 */

var res = '';
var cache;

/**
 * Expose `repeat`
 */

module.exports = repeat;

/**
 * Repeat the given `string` the specified `number`
 * of times.
 *
 * **Example:**
 *
 * ```js
 * var repeat = require('repeat-string');
 * repeat('A', 5);
 * //=> AAAAA
 * ```
 *
 * @param {String} `string` The string to repeat
 * @param {Number} `number` The number of times to repeat the string
 * @return {String} Repeated string
 * @api public
 */

function repeat(str, num) {
  if (typeof str !== 'string') {
    throw new TypeError('expected a string');
  }

  // cover common, quick use cases
  if (num === 1) return str;
  if (num === 2) return str + str;

  var max = str.length * num;
  if (cache !== str || typeof cache === 'undefined') {
    cache = str;
    res = '';
  } else if (res.length >= max) {
    return res.substr(0, max);
  }

  while (max > res.length && num > 1) {
    if (num & 1) {
      res += str;
    }

    num >>= 1;
    str += str;
  }

  res += str;
  res = res.substr(0, max);
  return res;
}


/***/ }),

/***/ 6582:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


exports.parse = parse
exports.stringify = stringify

var empty = ''
var space = ' '
var whiteSpace = /[ \t\n\r\f]+/g

function parse(value) {
  var input = String(value || empty).trim()
  return input === empty ? [] : input.split(whiteSpace)
}

function stringify(values) {
  return values.join(space).trim()
}


/***/ }),

/***/ 78:
/***/ ((module) => {

"use strict";


module.exports = factory

// Construct a state `toggler`: a function which inverses `property` in context
// based on its current value.
// The by `toggler` returned function restores that value.
function factory(key, state, ctx) {
  return enter

  function enter() {
    var context = ctx || this
    var current = context[key]

    context[key] = !state

    return exit

    function exit() {
      context[key] = current
    }
  }
}


/***/ }),

/***/ 4860:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var entities = __webpack_require__(8348)
var legacy = __webpack_require__(7452)
var hexadecimal = __webpack_require__(9480)
var decimal = __webpack_require__(6195)
var alphanumerical = __webpack_require__(7961)
var dangerous = __webpack_require__(3235)

module.exports = encode
encode.escape = escape

var own = {}.hasOwnProperty

// List of enforced escapes.
var escapes = ['"', "'", '<', '>', '&', '`']

// Map of characters to names.
var characters = construct()

// Default escapes.
var defaultEscapes = toExpression(escapes)

// Surrogate pairs.
var surrogatePair = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g

// Non-ASCII characters.
// eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
var bmp = /[\x01-\t\x0B\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g

// Encode special characters in `value`.
function encode(value, options) {
  var settings = options || {}
  var subset = settings.subset
  var set = subset ? toExpression(subset) : defaultEscapes
  var escapeOnly = settings.escapeOnly
  var omit = settings.omitOptionalSemicolons

  value = value.replace(set, replace)

  if (subset || escapeOnly) {
    return value
  }

  return value
    .replace(surrogatePair, replaceSurrogatePair)
    .replace(bmp, replace)

  function replaceSurrogatePair(pair, pos, val) {
    return toHexReference(
      (pair.charCodeAt(0) - 0xd800) * 0x400 +
        pair.charCodeAt(1) -
        0xdc00 +
        0x10000,
      val.charAt(pos + 2),
      omit
    )
  }

  function replace(char, pos, val) {
    return one(char, val.charAt(pos + 1), settings)
  }
}

// Shortcut to escape special characters in HTML.
function escape(value) {
  return encode(value, {escapeOnly: true, useNamedReferences: true})
}

// Encode `char` according to `options`.
function one(char, next, options) {
  var shortest = options.useShortestReferences
  var omit = options.omitOptionalSemicolons
  var named
  var code
  var numeric
  var decimal

  if ((shortest || options.useNamedReferences) && own.call(characters, char)) {
    named = toNamed(characters[char], next, omit, options.attribute)
  }

  if (shortest || !named) {
    code = char.charCodeAt(0)
    numeric = toHexReference(code, next, omit)

    // Use the shortest numeric reference when requested.
    // A simple algorithm would use decimal for all code points under 100, as
    // those are shorter than hexadecimal:
    //
    // * `&#99;` vs `&#x63;` (decimal shorter)
    // * `&#100;` vs `&#x64;` (equal)
    //
    // However, because we take `next` into consideration when `omit` is used,
    // And it would be possible that decimals are shorter on bigger values as
    // well if `next` is hexadecimal but not decimal, we instead compare both.
    if (shortest) {
      decimal = toDecimalReference(code, next, omit)

      if (decimal.length < numeric.length) {
        numeric = decimal
      }
    }
  }

  if (named && (!shortest || named.length < numeric.length)) {
    return named
  }

  return numeric
}

// Transform `code` into an entity.
function toNamed(name, next, omit, attribute) {
  var value = '&' + name

  if (
    omit &&
    own.call(legacy, name) &&
    dangerous.indexOf(name) === -1 &&
    (!attribute || (next && next !== '=' && !alphanumerical(next)))
  ) {
    return value
  }

  return value + ';'
}

// Transform `code` into a hexadecimal character reference.
function toHexReference(code, next, omit) {
  var value = '&#x' + code.toString(16).toUpperCase()
  return omit && next && !hexadecimal(next) ? value : value + ';'
}

// Transform `code` into a decimal character reference.
function toDecimalReference(code, next, omit) {
  var value = '&#' + String(code)
  return omit && next && !decimal(next) ? value : value + ';'
}

// Create an expression for `characters`.
function toExpression(characters) {
  return new RegExp('[' + characters.join('') + ']', 'g')
}

// Construct the map.
function construct() {
  var chars = {}
  var name

  for (name in entities) {
    chars[entities[name]] = name
  }

  return chars
}


/***/ }),

/***/ 7848:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var parse = __webpack_require__(8139);

/**
 * Parses inline style to object.
 *
 * @example
 * // returns { 'line-height': '42' }
 * StyleToObject('line-height: 42;');
 *
 * @param  {String}      style      - The inline style.
 * @param  {Function}    [iterator] - The iterator function.
 * @return {null|Object}
 */
function StyleToObject(style, iterator) {
  var output = null;
  if (!style || typeof style !== 'string') {
    return output;
  }

  var declaration;
  var declarations = parse(style);
  var hasIterator = typeof iterator === 'function';
  var property;
  var value;

  for (var i = 0, len = declarations.length; i < len; i++) {
    declaration = declarations[i];
    property = declaration.property;
    value = declaration.value;

    if (hasIterator) {
      iterator(property, value, declaration);
    } else if (value) {
      output || (output = {});
      output[property] = value;
    }
  }

  return output;
}

module.exports = StyleToObject;


/***/ }),

/***/ 268:
/***/ ((module) => {


module.exports = function () {
  var selection = document.getSelection();
  if (!selection.rangeCount) {
    return function () {};
  }
  var active = document.activeElement;

  var ranges = [];
  for (var i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }

  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
    case 'INPUT':
    case 'TEXTAREA':
      active.blur();
      break;

    default:
      active = null;
      break;
  }

  selection.removeAllRanges();
  return function () {
    selection.type === 'Caret' &&
    selection.removeAllRanges();

    if (!selection.rangeCount) {
      ranges.forEach(function(range) {
        selection.addRange(range);
      });
    }

    active &&
    active.focus();
  };
};


/***/ }),

/***/ 6221:
/***/ ((module) => {

"use strict";


module.exports = trimLines

var ws = /[ \t]*\n+[ \t]*/g
var newline = '\n'

function trimLines(value) {
  return String(value).replace(ws, newline)
}


/***/ }),

/***/ 7257:
/***/ ((module) => {

"use strict";


module.exports = trimTrailingLines

var line = '\n'

// Remove final newline characters from `value`.
function trimTrailingLines(value) {
  var val = String(value)
  var index = val.length

  while (val.charAt(--index) === line) {
    // Empty
  }

  return val.slice(0, index + 1)
}


/***/ }),

/***/ 2745:
/***/ ((module, exports) => {

exports = module.exports = trim;

function trim(str){
  if (str.trim) return str.trim();
  return exports.right(exports.left(str));
}

exports.left = function(str){
  if (str.trimLeft) return str.trimLeft();

  return str.replace(/^\s\s*/, '');
};

exports.right = function(str){
  if (str.trimRight) return str.trimRight();

  var whitespace_pattern = /\s/,
      i = str.length;
  while (whitespace_pattern.test(str.charAt(--i)));

  return str.slice(0, i + 1);
};


/***/ }),

/***/ 8281:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var wrap = __webpack_require__(3368)

module.exports = trough

trough.wrap = wrap

var slice = [].slice

// Create new middleware.
function trough() {
  var fns = []
  var middleware = {}

  middleware.run = run
  middleware.use = use

  return middleware

  // Run `fns`.  Last argument must be a completion handler.
  function run() {
    var index = -1
    var input = slice.call(arguments, 0, -1)
    var done = arguments[arguments.length - 1]

    if (typeof done !== 'function') {
      throw new Error('Expected function as last argument, not ' + done)
    }

    next.apply(null, [null].concat(input))

    // Run the next `fn`, if any.
    function next(err) {
      var fn = fns[++index]
      var params = slice.call(arguments, 0)
      var values = params.slice(1)
      var length = input.length
      var pos = -1

      if (err) {
        done(err)
        return
      }

      // Copy non-nully input into values.
      while (++pos < length) {
        if (values[pos] === null || values[pos] === undefined) {
          values[pos] = input[pos]
        }
      }

      input = values

      // Next or done.
      if (fn) {
        wrap(fn, next).apply(null, input)
      } else {
        done.apply(null, [null].concat(input))
      }
    }
  }

  // Add `fn` to the list.
  function use(fn) {
    if (typeof fn !== 'function') {
      throw new Error('Expected `fn` to be a function, not ' + fn)
    }

    fns.push(fn)

    return middleware
  }
}


/***/ }),

/***/ 3368:
/***/ ((module) => {

"use strict";


var slice = [].slice

module.exports = wrap

// Wrap `fn`.
// Can be sync or async; return a promise, receive a completion handler, return
// new values and errors.
function wrap(fn, callback) {
  var invoked

  return wrapped

  function wrapped() {
    var params = slice.call(arguments, 0)
    var callback = fn.length > params.length
    var result

    if (callback) {
      params.push(done)
    }

    try {
      result = fn.apply(null, params)
    } catch (error) {
      // Well, this is quite the pickle.
      // `fn` received a callback and invoked it (thus continuing the pipeline),
      // but later also threw an error.
      // We’re not about to restart the pipeline again, so the only thing left
      // to do is to throw the thing instead.
      if (callback && invoked) {
        throw error
      }

      return done(error)
    }

    if (!callback) {
      if (result && typeof result.then === 'function') {
        result.then(then, done)
      } else if (result instanceof Error) {
        done(result)
      } else {
        then(result)
      }
    }
  }

  // Invoke `next`, only once.
  function done() {
    if (!invoked) {
      invoked = true

      callback.apply(null, arguments)
    }
  }

  // Invoke `done` with one value.
  // Tracks if an error is passed, too.
  function then(value) {
    done(null, value)
  }
}


/***/ }),

/***/ 3278:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var xtend = __webpack_require__(7529)
var inherits = __webpack_require__(5717)

module.exports = unherit

// Create a custom constructor which can be modified without affecting the
// original class.
function unherit(Super) {
  var result
  var key
  var value

  inherits(Of, Super)
  inherits(From, Of)

  // Clone values.
  result = Of.prototype

  for (key in result) {
    value = result[key]

    if (value && typeof value === 'object') {
      result[key] = 'concat' in value ? value.concat() : xtend(value)
    }
  }

  return Of

  // Constructor accepting a single argument, which itself is an `arguments`
  // object.
  function From(parameters) {
    return Super.apply(this, parameters)
  }

  // Constructor accepting variadic arguments.
  function Of() {
    if (!(this instanceof Of)) {
      return new From(arguments)
    }

    return Super.apply(this, arguments)
  }
}


/***/ }),

/***/ 8835:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var extend = __webpack_require__(4470)
var bail = __webpack_require__(8841)
var vfile = __webpack_require__(939)
var trough = __webpack_require__(8281)
var plain = __webpack_require__(8980)

// Expose a frozen processor.
module.exports = unified().freeze()

var slice = [].slice
var own = {}.hasOwnProperty

// Process pipeline.
var pipeline = trough()
  .use(pipelineParse)
  .use(pipelineRun)
  .use(pipelineStringify)

function pipelineParse(p, ctx) {
  ctx.tree = p.parse(ctx.file)
}

function pipelineRun(p, ctx, next) {
  p.run(ctx.tree, ctx.file, done)

  function done(err, tree, file) {
    if (err) {
      next(err)
    } else {
      ctx.tree = tree
      ctx.file = file
      next()
    }
  }
}

function pipelineStringify(p, ctx) {
  ctx.file.contents = p.stringify(ctx.tree, ctx.file)
}

// Function to create the first processor.
function unified() {
  var attachers = []
  var transformers = trough()
  var namespace = {}
  var frozen = false
  var freezeIndex = -1

  // Data management.
  processor.data = data

  // Lock.
  processor.freeze = freeze

  // Plugins.
  processor.attachers = attachers
  processor.use = use

  // API.
  processor.parse = parse
  processor.stringify = stringify
  processor.run = run
  processor.runSync = runSync
  processor.process = process
  processor.processSync = processSync

  // Expose.
  return processor

  // Create a new processor based on the processor in the current scope.
  function processor() {
    var destination = unified()
    var length = attachers.length
    var index = -1

    while (++index < length) {
      destination.use.apply(null, attachers[index])
    }

    destination.data(extend(true, {}, namespace))

    return destination
  }

  // Freeze: used to signal a processor that has finished configuration.
  //
  // For example, take unified itself: it’s frozen.
  // Plugins should not be added to it.
  // Rather, it should be extended, by invoking it, before modifying it.
  //
  // In essence, always invoke this when exporting a processor.
  function freeze() {
    var values
    var plugin
    var options
    var transformer

    if (frozen) {
      return processor
    }

    while (++freezeIndex < attachers.length) {
      values = attachers[freezeIndex]
      plugin = values[0]
      options = values[1]
      transformer = null

      if (options === false) {
        continue
      }

      if (options === true) {
        values[1] = undefined
      }

      transformer = plugin.apply(processor, values.slice(1))

      if (typeof transformer === 'function') {
        transformers.use(transformer)
      }
    }

    frozen = true
    freezeIndex = Infinity

    return processor
  }

  // Data management.
  // Getter / setter for processor-specific informtion.
  function data(key, value) {
    if (typeof key === 'string') {
      // Set `key`.
      if (arguments.length === 2) {
        assertUnfrozen('data', frozen)

        namespace[key] = value

        return processor
      }

      // Get `key`.
      return (own.call(namespace, key) && namespace[key]) || null
    }

    // Set space.
    if (key) {
      assertUnfrozen('data', frozen)
      namespace = key
      return processor
    }

    // Get space.
    return namespace
  }

  // Plugin management.
  //
  // Pass it:
  // *   an attacher and options,
  // *   a preset,
  // *   a list of presets, attachers, and arguments (list of attachers and
  //     options).
  function use(value) {
    var settings

    assertUnfrozen('use', frozen)

    if (value === null || value === undefined) {
      // Empty.
    } else if (typeof value === 'function') {
      addPlugin.apply(null, arguments)
    } else if (typeof value === 'object') {
      if ('length' in value) {
        addList(value)
      } else {
        addPreset(value)
      }
    } else {
      throw new Error('Expected usable value, not `' + value + '`')
    }

    if (settings) {
      namespace.settings = extend(namespace.settings || {}, settings)
    }

    return processor

    function addPreset(result) {
      addList(result.plugins)

      if (result.settings) {
        settings = extend(settings || {}, result.settings)
      }
    }

    function add(value) {
      if (typeof value === 'function') {
        addPlugin(value)
      } else if (typeof value === 'object') {
        if ('length' in value) {
          addPlugin.apply(null, value)
        } else {
          addPreset(value)
        }
      } else {
        throw new Error('Expected usable value, not `' + value + '`')
      }
    }

    function addList(plugins) {
      var length
      var index

      if (plugins === null || plugins === undefined) {
        // Empty.
      } else if (typeof plugins === 'object' && 'length' in plugins) {
        length = plugins.length
        index = -1

        while (++index < length) {
          add(plugins[index])
        }
      } else {
        throw new Error('Expected a list of plugins, not `' + plugins + '`')
      }
    }

    function addPlugin(plugin, value) {
      var entry = find(plugin)

      if (entry) {
        if (plain(entry[1]) && plain(value)) {
          value = extend(entry[1], value)
        }

        entry[1] = value
      } else {
        attachers.push(slice.call(arguments))
      }
    }
  }

  function find(plugin) {
    var length = attachers.length
    var index = -1
    var entry

    while (++index < length) {
      entry = attachers[index]

      if (entry[0] === plugin) {
        return entry
      }
    }
  }

  // Parse a file (in string or vfile representation) into a unist node using
  // the `Parser` on the processor.
  function parse(doc) {
    var file = vfile(doc)
    var Parser

    freeze()
    Parser = processor.Parser
    assertParser('parse', Parser)

    if (newable(Parser, 'parse')) {
      return new Parser(String(file), file).parse()
    }

    return Parser(String(file), file) // eslint-disable-line new-cap
  }

  // Run transforms on a unist node representation of a file (in string or
  // vfile representation), async.
  function run(node, file, cb) {
    assertNode(node)
    freeze()

    if (!cb && typeof file === 'function') {
      cb = file
      file = null
    }

    if (!cb) {
      return new Promise(executor)
    }

    executor(null, cb)

    function executor(resolve, reject) {
      transformers.run(node, vfile(file), done)

      function done(err, tree, file) {
        tree = tree || node
        if (err) {
          reject(err)
        } else if (resolve) {
          resolve(tree)
        } else {
          cb(null, tree, file)
        }
      }
    }
  }

  // Run transforms on a unist node representation of a file (in string or
  // vfile representation), sync.
  function runSync(node, file) {
    var complete = false
    var result

    run(node, file, done)

    assertDone('runSync', 'run', complete)

    return result

    function done(err, tree) {
      complete = true
      bail(err)
      result = tree
    }
  }

  // Stringify a unist node representation of a file (in string or vfile
  // representation) into a string using the `Compiler` on the processor.
  function stringify(node, doc) {
    var file = vfile(doc)
    var Compiler

    freeze()
    Compiler = processor.Compiler
    assertCompiler('stringify', Compiler)
    assertNode(node)

    if (newable(Compiler, 'compile')) {
      return new Compiler(node, file).compile()
    }

    return Compiler(node, file) // eslint-disable-line new-cap
  }

  // Parse a file (in string or vfile representation) into a unist node using
  // the `Parser` on the processor, then run transforms on that node, and
  // compile the resulting node using the `Compiler` on the processor, and
  // store that result on the vfile.
  function process(doc, cb) {
    freeze()
    assertParser('process', processor.Parser)
    assertCompiler('process', processor.Compiler)

    if (!cb) {
      return new Promise(executor)
    }

    executor(null, cb)

    function executor(resolve, reject) {
      var file = vfile(doc)

      pipeline.run(processor, {file: file}, done)

      function done(err) {
        if (err) {
          reject(err)
        } else if (resolve) {
          resolve(file)
        } else {
          cb(null, file)
        }
      }
    }
  }

  // Process the given document (in string or vfile representation), sync.
  function processSync(doc) {
    var complete = false
    var file

    freeze()
    assertParser('processSync', processor.Parser)
    assertCompiler('processSync', processor.Compiler)
    file = vfile(doc)

    process(file, done)

    assertDone('processSync', 'process', complete)

    return file

    function done(err) {
      complete = true
      bail(err)
    }
  }
}

// Check if `value` is a constructor.
function newable(value, name) {
  return (
    typeof value === 'function' &&
    value.prototype &&
    // A function with keys in its prototype is probably a constructor.
    // Classes’ prototype methods are not enumerable, so we check if some value
    // exists in the prototype.
    (keys(value.prototype) || name in value.prototype)
  )
}

// Check if `value` is an object with keys.
function keys(value) {
  var key
  for (key in value) {
    return true
  }

  return false
}

// Assert a parser is available.
function assertParser(name, Parser) {
  if (typeof Parser !== 'function') {
    throw new Error('Cannot `' + name + '` without `Parser`')
  }
}

// Assert a compiler is available.
function assertCompiler(name, Compiler) {
  if (typeof Compiler !== 'function') {
    throw new Error('Cannot `' + name + '` without `Compiler`')
  }
}

// Assert the processor is not frozen.
function assertUnfrozen(name, frozen) {
  if (frozen) {
    throw new Error(
      'Cannot invoke `' +
        name +
        '` on a frozen processor.\nCreate a new processor first, by invoking it: use `processor()` instead of `processor`.'
    )
  }
}

// Assert `node` is a unist node.
function assertNode(node) {
  if (!node || typeof node.type !== 'string') {
    throw new Error('Expected node, got `' + node + '`')
  }
}

// Assert that `complete` is `true`.
function assertDone(name, asyncName, complete) {
  if (!complete) {
    throw new Error(
      '`' + name + '` finished async. Use `' + asyncName + '` instead'
    )
  }
}


/***/ }),

/***/ 914:
/***/ ((module) => {

"use strict";


module.exports = u

function u(type, props, value) {
  var node

  if (
    (value === null || value === undefined) &&
    (typeof props !== 'object' || Array.isArray(props))
  ) {
    value = props
    props = {}
  }

  node = Object.assign({type: String(type)}, props)

  if (Array.isArray(value)) {
    node.children = value
  } else if (value !== null && value !== undefined) {
    node.value = String(value)
  }

  return node
}


/***/ }),

/***/ 5885:
/***/ ((module) => {

module.exports = flatMap

function flatMap(ast, fn) {
  return transform(ast, 0, null)[0]

  function transform(node, index, parent) {
    if (node.children) {
      var out = []
      for (var i = 0, n = node.children.length; i < n; i++) {
        var xs = transform(node.children[i], i, node)
        if (xs) {
          for (var j = 0, m = xs.length; j < m; j++) {
            out.push(xs[j])
          }
        }
      }
      node.children = out
    }

    return fn(node, index, parent)
  }
}


/***/ }),

/***/ 1744:
/***/ ((module) => {

"use strict";


module.exports = generated

function generated(node) {
  var position = optional(optional(node).position)
  var start = optional(position.start)
  var end = optional(position.end)

  return !start.line || !start.column || !end.line || !end.column
}

function optional(value) {
  return value && typeof value === 'object' ? value : {}
}


/***/ }),

/***/ 8145:
/***/ ((module) => {

"use strict";


module.exports = convert

function convert(test) {
  if (typeof test === 'string') {
    return typeFactory(test)
  }

  if (test === null || test === undefined) {
    return ok
  }

  if (typeof test === 'object') {
    return ('length' in test ? anyFactory : matchesFactory)(test)
  }

  if (typeof test === 'function') {
    return test
  }

  throw new Error('Expected function, string, or object as test')
}

function convertAll(tests) {
  var results = []
  var length = tests.length
  var index = -1

  while (++index < length) {
    results[index] = convert(tests[index])
  }

  return results
}

// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function matchesFactory(test) {
  return matches

  function matches(node) {
    var key

    for (key in test) {
      if (node[key] !== test[key]) {
        return false
      }
    }

    return true
  }
}

function anyFactory(tests) {
  var checks = convertAll(tests)
  var length = checks.length

  return matches

  function matches() {
    var index = -1

    while (++index < length) {
      if (checks[index].apply(this, arguments)) {
        return true
      }
    }

    return false
  }
}

// Utility to convert a string into a function which checks a given node’s type
// for said string.
function typeFactory(test) {
  return type

  function type(node) {
    return Boolean(node && node.type === test)
  }
}

// Utility to return true.
function ok() {
  return true
}


/***/ }),

/***/ 7361:
/***/ ((module) => {

"use strict";


var start = factory('start')
var end = factory('end')

module.exports = position

position.start = start
position.end = end

function position(node) {
  return {start: start(node), end: end(node)}
}

function factory(type) {
  point.displayName = type

  return point

  function point(node) {
    var point = (node && node.position && node.position[type]) || {}

    return {
      line: point.line || null,
      column: point.column || null,
      offset: isNaN(point.offset) ? null : point.offset
    }
  }
}


/***/ }),

/***/ 3183:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var visit = __webpack_require__(750)

module.exports = removePosition

function removePosition(node, force) {
  visit(node, force ? hard : soft)
  return node
}

function hard(node) {
  delete node.position
}

function soft(node) {
  node.position = undefined
}


/***/ }),

/***/ 750:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = visit

var visitParents = __webpack_require__(9294)

var CONTINUE = visitParents.CONTINUE
var SKIP = visitParents.SKIP
var EXIT = visitParents.EXIT

visit.CONTINUE = CONTINUE
visit.SKIP = SKIP
visit.EXIT = EXIT

function visit(tree, test, visitor, reverse) {
  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor
    visitor = test
    test = null
  }

  visitParents(tree, test, overload, reverse)

  function overload(node, parents) {
    var parent = parents[parents.length - 1]
    var index = parent ? parent.children.indexOf(node) : null
    return visitor(node, index, parent)
  }
}


/***/ }),

/***/ 5432:
/***/ ((module) => {

"use strict";


var own = {}.hasOwnProperty

module.exports = stringify

function stringify(value) {
  // Nothing.
  if (!value || typeof value !== 'object') {
    return ''
  }

  // Node.
  if (own.call(value, 'position') || own.call(value, 'type')) {
    return position(value.position)
  }

  // Position.
  if (own.call(value, 'start') || own.call(value, 'end')) {
    return position(value)
  }

  // Point.
  if (own.call(value, 'line') || own.call(value, 'column')) {
    return point(value)
  }

  // ?
  return ''
}

function point(point) {
  if (!point || typeof point !== 'object') {
    point = {}
  }

  return index(point.line) + ':' + index(point.column)
}

function position(pos) {
  if (!pos || typeof pos !== 'object') {
    pos = {}
  }

  return point(pos.start) + '-' + point(pos.end)
}

function index(value) {
  return value && typeof value === 'number' ? value : 1
}


/***/ }),

/***/ 9294:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = visitParents

var convert = __webpack_require__(8145)

var CONTINUE = true
var SKIP = 'skip'
var EXIT = false

visitParents.CONTINUE = CONTINUE
visitParents.SKIP = SKIP
visitParents.EXIT = EXIT

function visitParents(tree, test, visitor, reverse) {
  var is

  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor
    visitor = test
    test = null
  }

  is = convert(test)

  one(tree, null, [])

  // Visit a single node.
  function one(node, index, parents) {
    var result = []
    var subresult

    if (!test || is(node, index, parents[parents.length - 1] || null)) {
      result = toResult(visitor(node, parents))

      if (result[0] === EXIT) {
        return result
      }
    }

    if (node.children && result[0] !== SKIP) {
      subresult = toResult(all(node.children, parents.concat(node)))
      return subresult[0] === EXIT ? subresult : result
    }

    return result
  }

  // Visit children in `parent`.
  function all(children, parents) {
    var min = -1
    var step = reverse ? -1 : 1
    var index = (reverse ? children.length : min) + step
    var result

    while (index > min && index < children.length) {
      result = one(children[index], index, parents)

      if (result[0] === EXIT) {
        return result
      }

      index = typeof result[1] === 'number' ? result[1] : index + step
    }
  }
}

function toResult(value) {
  if (value !== null && typeof value === 'object' && 'length' in value) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return [value]
}


/***/ }),

/***/ 2854:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = visit

var visitParents = __webpack_require__(9858)

var CONTINUE = visitParents.CONTINUE
var SKIP = visitParents.SKIP
var EXIT = visitParents.EXIT

visit.CONTINUE = CONTINUE
visit.SKIP = SKIP
visit.EXIT = EXIT

function visit(tree, test, visitor, reverse) {
  if (typeof test === 'function' && typeof visitor !== 'function') {
    reverse = visitor
    visitor = test
    test = null
  }

  visitParents(tree, test, overload, reverse)

  function overload(node, parents) {
    var parent = parents[parents.length - 1]
    var index = parent ? parent.children.indexOf(node) : null
    return visitor(node, index, parent)
  }
}


/***/ }),

/***/ 350:
/***/ ((module) => {

"use strict";


module.exports = convert

function convert(test) {
  if (typeof test === 'string') {
    return typeFactory(test)
  }

  if (test === null || test === undefined) {
    return ok
  }

  if (typeof test === 'object') {
    return ('length' in test ? anyFactory : matchesFactory)(test)
  }

  if (typeof test === 'function') {
    return test
  }

  throw new Error('Expected function, string, or object as test')
}

function convertAll(tests) {
  var results = []
  var length = tests.length
  var index = -1

  while (++index < length) {
    results[index] = convert(tests[index])
  }

  return results
}

// Utility assert each property in `test` is represented in `node`, and each
// values are strictly equal.
function matchesFactory(test) {
  return matches

  function matches(node) {
    var key

    for (key in test) {
      if (node[key] !== test[key]) {
        return false
      }
    }

    return true
  }
}

function anyFactory(tests) {
  var checks = convertAll(tests)
  var length = checks.length

  return matches

  function matches() {
    var index = -1

    while (++index < length) {
      if (checks[index].apply(this, arguments)) {
        return true
      }
    }

    return false
  }
}

// Utility to convert a string into a function which checks a given node’s type
// for said string.
function typeFactory(test) {
  return type

  function type(node) {
    return Boolean(node && node.type === test)
  }
}

// Utility to return true.
function ok() {
  return true
}


/***/ }),

/***/ 9824:
/***/ ((module) => {

module.exports = identity
function identity(d) {
  return d
}


/***/ }),

/***/ 9858:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = visitParents

var convert = __webpack_require__(350)
var color = __webpack_require__(9824)

var CONTINUE = true
var SKIP = 'skip'
var EXIT = false

visitParents.CONTINUE = CONTINUE
visitParents.SKIP = SKIP
visitParents.EXIT = EXIT

function visitParents(tree, test, visitor, reverse) {
  var is

  if (func(test) && !func(visitor)) {
    reverse = visitor
    visitor = test
    test = null
  }

  is = convert(test)

  one(tree, null, [])()

  function one(child, index, parents) {
    var value = object(child) ? child : {}
    var name

    if (string(value.type)) {
      name = string(value.tagName)
        ? value.tagName
        : string(value.name)
        ? value.name
        : undefined

      node.displayName =
        'node (' + color(value.type + (name ? '<' + name + '>' : '')) + ')'
    }

    return node

    function node() {
      var result = []
      var subresult

      if (!test || is(child, index, parents[parents.length - 1] || null)) {
        result = toResult(visitor(child, parents))

        if (result[0] === EXIT) {
          return result
        }
      }

      if (!child.children || result[0] === SKIP) {
        return result
      }

      subresult = toResult(children(child.children, parents.concat(child)))
      return subresult[0] === EXIT ? subresult : result
    }
  }

  // Visit children in `parent`.
  function children(children, parents) {
    var min = -1
    var step = reverse ? -1 : 1
    var index = (reverse ? children.length : min) + step
    var child
    var result

    while (index > min && index < children.length) {
      child = children[index]
      result = one(child, index, parents)()

      if (result[0] === EXIT) {
        return result
      }

      index = typeof result[1] === 'number' ? result[1] : index + step
    }
  }
}

function toResult(value) {
  if (object(value) && 'length' in value) {
    return value
  }

  if (typeof value === 'number') {
    return [CONTINUE, value]
  }

  return [value]
}

function func(d) {
  return typeof d === 'function'
}

function string(d) {
  return typeof d === 'string'
}

function object(d) {
  return typeof d === 'object' && d !== null
}


/***/ }),

/***/ 4787:
/***/ ((module) => {

"use strict";


module.exports = factory

function factory(file) {
  var contents = indices(String(file))

  return {
    toPosition: offsetToPositionFactory(contents),
    toOffset: positionToOffsetFactory(contents)
  }
}

// Factory to get the line and column-based `position` for `offset` in the bound
// indices.
function offsetToPositionFactory(indices) {
  return offsetToPosition

  // Get the line and column-based `position` for `offset` in the bound indices.
  function offsetToPosition(offset) {
    var index = -1
    var length = indices.length

    if (offset < 0) {
      return {}
    }

    while (++index < length) {
      if (indices[index] > offset) {
        return {
          line: index + 1,
          column: offset - (indices[index - 1] || 0) + 1,
          offset: offset
        }
      }
    }

    return {}
  }
}

// Factory to get the `offset` for a line and column-based `position` in the
// bound indices.
function positionToOffsetFactory(indices) {
  return positionToOffset

  // Get the `offset` for a line and column-based `position` in the bound
  // indices.
  function positionToOffset(position) {
    var line = position && position.line
    var column = position && position.column

    if (!isNaN(line) && !isNaN(column) && line - 1 in indices) {
      return (indices[line - 2] || 0) + column - 1 || 0
    }

    return -1
  }
}

// Get indices of line-breaks in `value`.
function indices(value) {
  var result = []
  var index = value.indexOf('\n')

  while (index !== -1) {
    result.push(index + 1)
    index = value.indexOf('\n', index + 1)
  }

  result.push(value.length + 1)

  return result
}


/***/ }),

/***/ 734:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var stringify = __webpack_require__(5432)

module.exports = VMessage

// Inherit from `Error#`.
function VMessagePrototype() {}
VMessagePrototype.prototype = Error.prototype
VMessage.prototype = new VMessagePrototype()

// Message properties.
var proto = VMessage.prototype

proto.file = ''
proto.name = ''
proto.reason = ''
proto.message = ''
proto.stack = ''
proto.fatal = null
proto.column = null
proto.line = null

// Construct a new VMessage.
//
// Note: We cannot invoke `Error` on the created context, as that adds readonly
// `line` and `column` attributes on Safari 9, thus throwing and failing the
// data.
function VMessage(reason, position, origin) {
  var parts
  var range
  var location

  if (typeof position === 'string') {
    origin = position
    position = null
  }

  parts = parseOrigin(origin)
  range = stringify(position) || '1:1'

  location = {
    start: {line: null, column: null},
    end: {line: null, column: null}
  }

  // Node.
  if (position && position.position) {
    position = position.position
  }

  if (position) {
    // Position.
    if (position.start) {
      location = position
      position = position.start
    } else {
      // Point.
      location.start = position
    }
  }

  if (reason.stack) {
    this.stack = reason.stack
    reason = reason.message
  }

  this.message = reason
  this.name = range
  this.reason = reason
  this.line = position ? position.line : null
  this.column = position ? position.column : null
  this.location = location
  this.source = parts[0]
  this.ruleId = parts[1]
}

function parseOrigin(origin) {
  var result = [null, null]
  var index

  if (typeof origin === 'string') {
    index = origin.indexOf(':')

    if (index === -1) {
      result[1] = origin
    } else {
      result[0] = origin.slice(0, index)
      result[1] = origin.slice(index + 1)
    }
  }

  return result
}


/***/ }),

/***/ 939:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


module.exports = __webpack_require__(5905)


/***/ }),

/***/ 5442:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var p = __webpack_require__(8064)
var proc = __webpack_require__(4228)
var buffer = __webpack_require__(8738)

module.exports = VFile

var own = {}.hasOwnProperty

// Order of setting (least specific to most), we need this because otherwise
// `{stem: 'a', path: '~/b.js'}` would throw, as a path is needed before a
// stem can be set.
var order = ['history', 'path', 'basename', 'stem', 'extname', 'dirname']

VFile.prototype.toString = toString

// Access full path (`~/index.min.js`).
Object.defineProperty(VFile.prototype, 'path', {get: getPath, set: setPath})

// Access parent path (`~`).
Object.defineProperty(VFile.prototype, 'dirname', {
  get: getDirname,
  set: setDirname
})

// Access basename (`index.min.js`).
Object.defineProperty(VFile.prototype, 'basename', {
  get: getBasename,
  set: setBasename
})

// Access extname (`.js`).
Object.defineProperty(VFile.prototype, 'extname', {
  get: getExtname,
  set: setExtname
})

// Access stem (`index.min`).
Object.defineProperty(VFile.prototype, 'stem', {get: getStem, set: setStem})

// Construct a new file.
function VFile(options) {
  var prop
  var index

  if (!options) {
    options = {}
  } else if (typeof options === 'string' || buffer(options)) {
    options = {contents: options}
  } else if ('message' in options && 'messages' in options) {
    return options
  }

  if (!(this instanceof VFile)) {
    return new VFile(options)
  }

  this.data = {}
  this.messages = []
  this.history = []
  this.cwd = proc.cwd()

  // Set path related properties in the correct order.
  index = -1

  while (++index < order.length) {
    prop = order[index]

    if (own.call(options, prop)) {
      this[prop] = options[prop]
    }
  }

  // Set non-path related properties.
  for (prop in options) {
    if (order.indexOf(prop) < 0) {
      this[prop] = options[prop]
    }
  }
}

function getPath() {
  return this.history[this.history.length - 1]
}

function setPath(path) {
  assertNonEmpty(path, 'path')

  if (this.path !== path) {
    this.history.push(path)
  }
}

function getDirname() {
  return typeof this.path === 'string' ? p.dirname(this.path) : undefined
}

function setDirname(dirname) {
  assertPath(this.path, 'dirname')
  this.path = p.join(dirname || '', this.basename)
}

function getBasename() {
  return typeof this.path === 'string' ? p.basename(this.path) : undefined
}

function setBasename(basename) {
  assertNonEmpty(basename, 'basename')
  assertPart(basename, 'basename')
  this.path = p.join(this.dirname || '', basename)
}

function getExtname() {
  return typeof this.path === 'string' ? p.extname(this.path) : undefined
}

function setExtname(extname) {
  assertPart(extname, 'extname')
  assertPath(this.path, 'extname')

  if (extname) {
    if (extname.charCodeAt(0) !== 46 /* `.` */) {
      throw new Error('`extname` must start with `.`')
    }

    if (extname.indexOf('.', 1) > -1) {
      throw new Error('`extname` cannot contain multiple dots')
    }
  }

  this.path = p.join(this.dirname, this.stem + (extname || ''))
}

function getStem() {
  return typeof this.path === 'string'
    ? p.basename(this.path, this.extname)
    : undefined
}

function setStem(stem) {
  assertNonEmpty(stem, 'stem')
  assertPart(stem, 'stem')
  this.path = p.join(this.dirname || '', stem + (this.extname || ''))
}

// Get the value of the file.
function toString(encoding) {
  return (this.contents || '').toString(encoding)
}

// Assert that `part` is not a path (i.e., does not contain `p.sep`).
function assertPart(part, name) {
  if (part && part.indexOf(p.sep) > -1) {
    throw new Error(
      '`' + name + '` cannot be a path: did not expect `' + p.sep + '`'
    )
  }
}

// Assert that `part` is not empty.
function assertNonEmpty(part, name) {
  if (!part) {
    throw new Error('`' + name + '` cannot be empty')
  }
}

// Assert `path` exists.
function assertPath(path, name) {
  if (!path) {
    throw new Error('Setting `' + name + '` requires `path` to be set too')
  }
}


/***/ }),

/***/ 5905:
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

"use strict";


var VMessage = __webpack_require__(734)
var VFile = __webpack_require__(5442)

module.exports = VFile

VFile.prototype.message = message
VFile.prototype.info = info
VFile.prototype.fail = fail

// Create a message with `reason` at `position`.
// When an error is passed in as `reason`, copies the stack.
function message(reason, position, origin) {
  var message = new VMessage(reason, position, origin)

  if (this.path) {
    message.name = this.path + ':' + message.name
    message.file = this.path
  }

  message.fatal = false

  this.messages.push(message)

  return message
}

// Fail: creates a vmessage, associates it with the file, and throws it.
function fail() {
  var message = this.message.apply(this, arguments)

  message.fatal = true

  throw message
}

// Info: creates a vmessage, associates it with the file, and marks the fatality
// as null.
function info() {
  var message = this.message.apply(this, arguments)

  message.fatal = null

  return message
}


/***/ }),

/***/ 8064:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


// A derivative work based on:
// <https://github.com/browserify/path-browserify>.
// Which is licensed:
//
// MIT License
//
// Copyright (c) 2013 James Halliday
//
// Permission is hereby granted, free of charge, to any person obtaining a copy of
// this software and associated documentation files (the "Software"), to deal in
// the Software without restriction, including without limitation the rights to
// use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of
// the Software, and to permit persons to whom the Software is furnished to do so,
// subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS
// FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR
// COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER
// IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN
// CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
// A derivative work based on:
//
// Parts of that are extracted from Node’s internal `path` module:
// <https://github.com/nodejs/node/blob/master/lib/path.js>.
// Which is licensed:
//
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

exports.basename = basename
exports.dirname = dirname
exports.extname = extname
exports.join = join
exports.sep = '/'

function basename(path, ext) {
  var start = 0
  var end = -1
  var index
  var firstNonSlashEnd
  var seenNonSlash
  var extIndex

  if (ext !== undefined && typeof ext !== 'string') {
    throw new TypeError('"ext" argument must be a string')
  }

  assertPath(path)
  index = path.length

  if (ext === undefined || !ext.length || ext.length > path.length) {
    while (index--) {
      if (path.charCodeAt(index) === 47 /* `/` */) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now.
        if (seenNonSlash) {
          start = index + 1
          break
        }
      } else if (end < 0) {
        // We saw the first non-path separator, mark this as the end of our
        // path component.
        seenNonSlash = true
        end = index + 1
      }
    }

    return end < 0 ? '' : path.slice(start, end)
  }

  if (ext === path) {
    return ''
  }

  firstNonSlashEnd = -1
  extIndex = ext.length - 1

  while (index--) {
    if (path.charCodeAt(index) === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (seenNonSlash) {
        start = index + 1
        break
      }
    } else {
      if (firstNonSlashEnd < 0) {
        // We saw the first non-path separator, remember this index in case
        // we need it if the extension ends up not matching.
        seenNonSlash = true
        firstNonSlashEnd = index + 1
      }

      if (extIndex > -1) {
        // Try to match the explicit extension.
        if (path.charCodeAt(index) === ext.charCodeAt(extIndex--)) {
          if (extIndex < 0) {
            // We matched the extension, so mark this as the end of our path
            // component
            end = index
          }
        } else {
          // Extension does not match, so our result is the entire path
          // component
          extIndex = -1
          end = firstNonSlashEnd
        }
      }
    }
  }

  if (start === end) {
    end = firstNonSlashEnd
  } else if (end < 0) {
    end = path.length
  }

  return path.slice(start, end)
}

function dirname(path) {
  var end
  var unmatchedSlash
  var index

  assertPath(path)

  if (!path.length) {
    return '.'
  }

  end = -1
  index = path.length

  // Prefix `--` is important to not run on `0`.
  while (--index) {
    if (path.charCodeAt(index) === 47 /* `/` */) {
      if (unmatchedSlash) {
        end = index
        break
      }
    } else if (!unmatchedSlash) {
      // We saw the first non-path separator
      unmatchedSlash = true
    }
  }

  return end < 0
    ? path.charCodeAt(0) === 47 /* `/` */
      ? '/'
      : '.'
    : end === 1 && path.charCodeAt(0) === 47 /* `/` */
    ? '//'
    : path.slice(0, end)
}

function extname(path) {
  var startDot = -1
  var startPart = 0
  var end = -1
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find.
  var preDotState = 0
  var unmatchedSlash
  var code
  var index

  assertPath(path)

  index = path.length

  while (index--) {
    code = path.charCodeAt(index)

    if (code === 47 /* `/` */) {
      // If we reached a path separator that was not part of a set of path
      // separators at the end of the string, stop now.
      if (unmatchedSlash) {
        startPart = index + 1
        break
      }

      continue
    }

    if (end < 0) {
      // We saw the first non-path separator, mark this as the end of our
      // extension.
      unmatchedSlash = true
      end = index + 1
    }

    if (code === 46 /* `.` */) {
      // If this is our first dot, mark it as the start of our extension.
      if (startDot < 0) {
        startDot = index
      } else if (preDotState !== 1) {
        preDotState = 1
      }
    } else if (startDot > -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension.
      preDotState = -1
    }
  }

  if (
    startDot < 0 ||
    end < 0 ||
    // We saw a non-dot character immediately before the dot.
    preDotState === 0 ||
    // The (right-most) trimmed path component is exactly `..`.
    (preDotState === 1 && startDot === end - 1 && startDot === startPart + 1)
  ) {
    return ''
  }

  return path.slice(startDot, end)
}

function join() {
  var index = -1
  var joined

  while (++index < arguments.length) {
    assertPath(arguments[index])

    if (arguments[index]) {
      joined =
        joined === undefined
          ? arguments[index]
          : joined + '/' + arguments[index]
    }
  }

  return joined === undefined ? '.' : normalize(joined)
}

// Note: `normalize` is not exposed as `path.normalize`, so some code is
// manually removed from it.
function normalize(path) {
  var absolute
  var value

  assertPath(path)

  absolute = path.charCodeAt(0) === 47 /* `/` */

  // Normalize the path according to POSIX rules.
  value = normalizeString(path, !absolute)

  if (!value.length && !absolute) {
    value = '.'
  }

  if (value.length && path.charCodeAt(path.length - 1) === 47 /* / */) {
    value += '/'
  }

  return absolute ? '/' + value : value
}

// Resolve `.` and `..` elements in a path with directory names.
function normalizeString(path, allowAboveRoot) {
  var result = ''
  var lastSegmentLength = 0
  var lastSlash = -1
  var dots = 0
  var index = -1
  var code
  var lastSlashIndex

  while (++index <= path.length) {
    if (index < path.length) {
      code = path.charCodeAt(index)
    } else if (code === 47 /* `/` */) {
      break
    } else {
      code = 47 /* `/` */
    }

    if (code === 47 /* `/` */) {
      if (lastSlash === index - 1 || dots === 1) {
        // Empty.
      } else if (lastSlash !== index - 1 && dots === 2) {
        if (
          result.length < 2 ||
          lastSegmentLength !== 2 ||
          result.charCodeAt(result.length - 1) !== 46 /* `.` */ ||
          result.charCodeAt(result.length - 2) !== 46 /* `.` */
        ) {
          if (result.length > 2) {
            lastSlashIndex = result.lastIndexOf('/')

            /* istanbul ignore else - No clue how to cover it. */
            if (lastSlashIndex !== result.length - 1) {
              if (lastSlashIndex < 0) {
                result = ''
                lastSegmentLength = 0
              } else {
                result = result.slice(0, lastSlashIndex)
                lastSegmentLength = result.length - 1 - result.lastIndexOf('/')
              }

              lastSlash = index
              dots = 0
              continue
            }
          } else if (result.length) {
            result = ''
            lastSegmentLength = 0
            lastSlash = index
            dots = 0
            continue
          }
        }

        if (allowAboveRoot) {
          result = result.length ? result + '/..' : '..'
          lastSegmentLength = 2
        }
      } else {
        if (result.length) {
          result += '/' + path.slice(lastSlash + 1, index)
        } else {
          result = path.slice(lastSlash + 1, index)
        }

        lastSegmentLength = index - lastSlash - 1
      }

      lastSlash = index
      dots = 0
    } else if (code === 46 /* `.` */ && dots > -1) {
      dots++
    } else {
      dots = -1
    }
  }

  return result
}

function assertPath(path) {
  if (typeof path !== 'string') {
    throw new TypeError(
      'Path must be a string. Received ' + JSON.stringify(path)
    )
  }
}


/***/ }),

/***/ 4228:
/***/ ((__unused_webpack_module, exports) => {

"use strict";


// Somewhat based on:
// <https://github.com/defunctzombie/node-process/blob/master/browser.js>.
// But I don’t think one tiny line of code can be copyrighted. 😅
exports.cwd = cwd

function cwd() {
  return '/'
}


/***/ }),

/***/ 7529:
/***/ ((module) => {

module.exports = extend

var hasOwnProperty = Object.prototype.hasOwnProperty;

function extend() {
    var target = {}

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i]

        for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
                target[key] = source[key]
            }
        }
    }

    return target
}


/***/ }),

/***/ 8019:
/***/ ((module) => {

"use strict";


module.exports = factory

var noop = Function.prototype
var own = {}.hasOwnProperty

// Handle values based on a property.
function factory(key, options) {
  var settings = options || {}

  function one(value) {
    var fn = one.invalid
    var handlers = one.handlers

    if (value && own.call(value, key)) {
      fn = own.call(handlers, value[key]) ? handlers[value[key]] : one.unknown
    }

    return (fn || noop).apply(this, arguments)
  }

  one.handlers = settings.handlers || {}
  one.invalid = settings.invalid
  one.unknown = settings.unknown

  return one
}


/***/ }),

/***/ 3689:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__3689__;

/***/ }),

/***/ 578:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__578__;

/***/ }),

/***/ 4466:
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE__4466__;

/***/ }),

/***/ 907:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _arrayLikeToArray)
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

/***/ }),

/***/ 4942:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _defineProperty)
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),

/***/ 1037:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": () => (/* binding */ _slicedToArray)
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
var unsupportedIterableToArray = __webpack_require__(181);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/slicedToArray.js




function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || (0,unsupportedIterableToArray/* default */.Z)(arr, i) || _nonIterableRest();
}

/***/ }),

/***/ 181:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ _unsupportedIterableToArray)
/* harmony export */ });
/* harmony import */ var _arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(907);

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0,_arrayLikeToArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}

/***/ }),

/***/ 2781:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "defaultSchema": () => (/* binding */ defaultSchema)
/* harmony export */ });
/** @type {import('./index.js').Schema} */
const defaultSchema = {
  strip: ['script'],
  clobberPrefix: 'user-content-',
  clobber: ['name', 'id'],
  ancestors: {
    tbody: ['table'],
    tfoot: ['table'],
    thead: ['table'],
    td: ['table'],
    th: ['table'],
    tr: ['table']
  },
  protocols: {
    href: ['http', 'https', 'mailto', 'xmpp', 'irc', 'ircs'],
    cite: ['http', 'https'],
    src: ['http', 'https'],
    longDesc: ['http', 'https']
  },
  tagNames: [
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'br',
    'b',
    'i',
    'strong',
    'em',
    'a',
    'pre',
    'code',
    'img',
    'tt',
    'div',
    'ins',
    'del',
    'sup',
    'sub',
    'p',
    'ol',
    'ul',
    'table',
    'thead',
    'tbody',
    'tfoot',
    'blockquote',
    'dl',
    'dt',
    'dd',
    'kbd',
    'q',
    'samp',
    'var',
    'hr',
    'ruby',
    'rt',
    'rp',
    'li',
    'tr',
    'td',
    'th',
    's',
    'strike',
    'summary',
    'details',
    'caption',
    'figure',
    'figcaption',
    'abbr',
    'bdo',
    'cite',
    'dfn',
    'mark',
    'small',
    'span',
    'time',
    'wbr',
    'input'
  ],
  attributes: {
    a: ['href'],
    img: ['src', 'longDesc'],
    input: [
      ['type', 'checkbox'],
      ['disabled', true]
    ],
    li: [['className', 'task-list-item']],
    div: ['itemScope', 'itemType'],
    blockquote: ['cite'],
    del: ['cite'],
    ins: ['cite'],
    q: ['cite'],
    '*': [
      'abbr',
      'accept',
      'acceptCharset',
      'accessKey',
      'action',
      'align',
      'alt',
      'ariaDescribedBy',
      'ariaHidden',
      'ariaLabel',
      'ariaLabelledBy',
      'axis',
      'border',
      'cellPadding',
      'cellSpacing',
      'char',
      'charOff',
      'charSet',
      'checked',
      'clear',
      'cols',
      'colSpan',
      'color',
      'compact',
      'coords',
      'dateTime',
      'dir',
      'disabled',
      'encType',
      'htmlFor',
      'frame',
      'headers',
      'height',
      'hrefLang',
      'hSpace',
      'isMap',
      'id',
      'label',
      'lang',
      'maxLength',
      'media',
      'method',
      'multiple',
      'name',
      'noHref',
      'noShade',
      'noWrap',
      'open',
      'prompt',
      'readOnly',
      'rel',
      'rev',
      'rows',
      'rowSpan',
      'rules',
      'scope',
      'selected',
      'shape',
      'size',
      'span',
      'start',
      'summary',
      'tabIndex',
      'target',
      'title',
      'type',
      'useMap',
      'vAlign',
      'value',
      'vSpace',
      'width',
      'itemProp'
    ]
  },
  required: {
    input: {
      type: 'checkbox',
      disabled: true
    }
  }
}


/***/ }),

/***/ 1445:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "map": () => (/* binding */ map)
/* harmony export */ });
/**
 * @typedef {import('unist').Node} Node
 */

/**
 * @template {Node} [Tree=Node]
 * @typedef {import('./complex-types.js').MapFunction<Tree>} MapFunction
 *   Function called with a node, its index, and its parent to produce a new
 *   node.
 */

/**
 * Create a new tree by mapping all nodes with the given function.
 *
 * @template {Node} Tree
 *   Type of input tree.
 * @param {Tree} tree
 *   Tree to map.
 * @param {MapFunction<Tree>} mapFunction
 *   Function called with a node, its index, and its parent to produce a new
 *   node.
 * @returns {Tree}
 *   New mapped tree.
 */
function map(tree, mapFunction) {
  // @ts-expect-error Looks like a children.
  return preorder(tree, null, null)

  /** @type {import('./complex-types').MapFunction<Tree>} */
  function preorder(node, index, parent) {
    var newNode = Object.assign({}, mapFunction(node, index, parent))

    if ('children' in node) {
      // @ts-expect-error Looks like a parent.
      newNode.children = node.children.map(function (
        /** @type {import('./complex-types').InclusiveDescendant<Tree>} */ child,
        /** @type {number} */ index
      ) {
        return preorder(child, index, node)
      })
    }

    return newNode
  }
}


/***/ }),

/***/ 5907:
/***/ ((__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) => {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "matches": () => (/* binding */ unist_util_select_matches),
  "select": () => (/* binding */ unist_util_select_select),
  "selectAll": () => (/* binding */ selectAll)
});

;// CONCATENATED MODULE: ./node_modules/unist-util-select/node_modules/zwitch/index.js
var own = {}.hasOwnProperty

/**
 * @callback Handler
 * @param {...unknown} value
 * @return {unknown}
 *
 * @typedef {Record<string, Handler>} Handlers
 *
 * @typedef {Object} Options
 * @property {Handler} [unknown]
 * @property {Handler} [invalid]
 * @property {Handlers} [handlers]
 */

/**
 * Handle values based on a property.
 *
 * @param {string} key
 * @param {Options} [options]
 */
function zwitch(key, options) {
  var settings = options || {}

  /**
   * Handle one value.
   * Based on the bound `key`, a respective handler will be called.
   * If `value` is not an object, or doesn’t have a `key` property, the special
   * “invalid” handler will be called.
   * If `value` has an unknown `key`, the special “unknown” handler will be
   * called.
   *
   * All arguments, and the context object, are passed through to the handler,
   * and it’s result is returned.
   *
   * @param {...unknown} [value]
   * @this {unknown}
   * @returns {unknown}
   * @property {Handler} invalid
   * @property {Handler} unknown
   * @property {Handlers} handlers
   */
  function one(value) {
    var fn = one.invalid
    var handlers = one.handlers

    if (value && own.call(value, key)) {
      fn = own.call(handlers, value[key]) ? handlers[value[key]] : one.unknown
    }

    if (fn) {
      return fn.apply(this, arguments)
    }
  }

  one.handlers = settings.handlers || {}
  one.invalid = settings.invalid
  one.unknown = settings.unknown

  return one
}

;// CONCATENATED MODULE: ./node_modules/unist-util-select/lib/util.js
/**
 * @typedef {import('./types.js').Selector} Selector
 * @typedef {import('./types.js').Selectors} Selectors
 * @typedef {import('./types.js').Rule} Rule
 * @typedef {import('./types.js').RuleSet} RuleSet
 * @typedef {import('./types.js').RulePseudo} RulePseudo
 * @typedef {import('./types.js').Query} Query
 * @typedef {import('./types.js').Node} Node
 * @typedef {import('./types.js').Parent} Parent
 * @typedef {import('./types.js').SelectIterator} SelectIterator
 * @typedef {import('./types.js').SelectState} SelectState
 */

/**
 * @param {Node} node
 * @returns {node is Parent}
 */
function root(node) {
  return (
    // Root in nlcst.
    node.type === 'RootNode' ||
    // Rest
    node.type === 'root'
  )
}

/**
 * @param {Node} node
 * @returns {node is Parent}
 */
function util_parent(node) {
  return Array.isArray(node.children)
}

;// CONCATENATED MODULE: ./node_modules/unist-util-select/lib/nest.js
/**
 * @typedef {import('./types.js').Rule} Rule
 * @typedef {import('./types.js').Query} Query
 * @typedef {import('./types.js').Node} Node
 * @typedef {import('./types.js').Parent} Parent
 * @typedef {import('./types.js').SelectState} SelectState
 * @typedef {import('./types.js').SelectIterator} SelectIterator
 * @typedef {import('./types.js').Handler} Handler
 */




var nest_own = {}.hasOwnProperty

var handle = zwitch('nestingOperator', {
  unknown: unknownNesting,
  invalid: topScan, // `undefined` is the top query selector.
  handlers: {
    null: descendant, // `null` is the descendant combinator.
    '>': child,
    '+': adjacentSibling,
    '~': generalSibling
  }
})

/** @type {Handler} */
function nest(query, node, index, parent, state) {
  return handle(query, node, index, parent, state)
}

// Shouldn’t be invoked, parser gives correct data.
/* c8 ignore next 6 */
/**
 * @param {{[x: string]: unknown, type: string}} query
 */
function unknownNesting(query) {
  throw new Error('Unexpected nesting `' + query.nestingOperator + '`')
}

/** @type {Handler} */
function topScan(query, node, index, parent, state) {
  // Shouldn’t happen.
  /* c8 ignore next 3 */
  if (parent) {
    throw new Error('topScan is supposed to be called from the root node')
  }

  state.iterator(query, node, index, parent, state)
  if (!state.shallow) descendant(query, node, index, parent, state)
}

/** @type {Handler} */
function descendant(query, node, index, parent, state) {
  var previous = state.iterator

  state.iterator = iterator
  child(query, node, index, parent, state)

  /** @type {SelectIterator} */
  function iterator(query, node, index, parent, state) {
    state.iterator = previous
    previous(query, node, index, parent, state)
    state.iterator = iterator

    if (state.one && state.found) return

    child(query, node, index, parent, state)
  }
}

/** @type {Handler} */
function child(query, node, _1, _2, state) {
  if (!util_parent(node)) return
  if (node.children.length === 0) return

  new WalkIterator(query, node, state).each().done()
}

/** @type {Handler} */
function adjacentSibling(query, _, index, parent, state) {
  // Shouldn’t happen.
  /* c8 ignore next */
  if (!parent) return

  new WalkIterator(query, parent, state)
    .prefillTypeIndex(0, ++index)
    .each(index, ++index)
    .prefillTypeIndex(index)
    .done()
}

/** @type {Handler} */
function generalSibling(query, _, index, parent, state) {
  // Shouldn’t happen.
  /* c8 ignore next */
  if (!parent) return

  new WalkIterator(query, parent, state)
    .prefillTypeIndex(0, ++index)
    .each(index)
    .done()
}

class WalkIterator {
  /**
   * Handles typeIndex and typeCount properties for every walker.
   *
   * @param {Rule} query
   * @param {Parent} parent
   * @param {SelectState} state
   */
  constructor(query, parent, state) {
    /** @type {Rule} */
    this.query = query
    /** @type {Parent} */
    this.parent = parent
    /** @type {SelectState} */
    this.state = state
    /** @type {TypeIndex|undefined} */
    this.typeIndex = state.index ? new TypeIndex() : undefined
    /** @type {Array.<Function>} */
    this.delayed = []
  }

  /**
   * @param {number|null|undefined} [x]
   * @param {number|null|undefined} [y]
   * @returns {this}
   */
  prefillTypeIndex(x, y) {
    var [start, end] = this.defaults(x, y)

    if (this.typeIndex) {
      while (start < end) {
        this.typeIndex.index(this.parent.children[start])
        start++
      }
    }

    return this
  }

  /**
   * @param {number|null|undefined} [x]
   * @param {number|null|undefined} [y]
   * @returns {this}
   */
  each(x, y) {
    var [start, end] = this.defaults(x, y)
    var child = this.parent.children[start]
    /** @type {number} */
    var index
    /** @type {number} */
    var nodeIndex

    if (start >= end) return this

    if (this.typeIndex) {
      nodeIndex = this.typeIndex.nodes
      index = this.typeIndex.index(child)
      this.delayed.push(delay)
    } else {
      this.state.iterator(this.query, child, start, this.parent, this.state)
    }

    // Stop if we’re looking for one node and it’s already found.
    if (this.state.one && this.state.found) return this

    return this.each(start + 1, end)

    /**
     * @this {WalkIterator}
     */
    function delay() {
      this.state.typeIndex = index
      this.state.nodeIndex = nodeIndex
      this.state.typeCount = this.typeIndex.count(child)
      this.state.nodeCount = this.typeIndex.nodes
      this.state.iterator(this.query, child, start, this.parent, this.state)
    }
  }

  /**
   * Done!
   * @returns {this}
   */
  done() {
    var index = -1

    while (++index < this.delayed.length) {
      this.delayed[index].call(this)
      if (this.state.one && this.state.found) break
    }

    return this
  }

  /**
   * @param {number|null|undefined} [start]
   * @param {number|null|undefined} [end]
   * @returns {[number, number]}
   */
  defaults(start, end) {
    if (start === null || start === undefined || start < 0) start = 0
    if (end === null || end === undefined || end > this.parent.children.length)
      end = this.parent.children.length
    return [start, end]
  }
}

class TypeIndex {
  constructor() {
    /** @type {Object.<string, number>} */
    this.counts = {}
    /** @type {number} */
    this.nodes = 0
  }

  /**
   * @param {Node} node
   * @returns {number}
   */
  index(node) {
    var type = node.type

    this.nodes++

    if (!nest_own.call(this.counts, type)) this.counts[type] = 0

    // Note: `++` is intended to be postfixed!
    return this.counts[type]++
  }

  /**
   * @param {Node} node
   * @returns {number|undefined}
   */
  count(node) {
    return this.counts[node.type]
  }
}

;// CONCATENATED MODULE: ./node_modules/unist-util-select/node_modules/unist-util-is/index.js
/**
 * @typedef {import('unist').Node} Node
 * @typedef {import('unist').Parent} Parent
 *
 * @typedef {string} Type
 * @typedef {Object<string, unknown>} Props
 *
 * @typedef {null|undefined|Type|Props|TestFunctionAnything|Array.<Type|Props|TestFunctionAnything>} Test
 */

/**
 * Check if a node passes a test
 *
 * @callback TestFunctionAnything
 * @param {Node} node
 * @param {number} [index]
 * @param {Parent} [parent]
 * @returns {boolean|void}
 */

/**
 * Check if a node passes a certain node test
 *
 * @template {Node} X
 * @callback TestFunctionPredicate
 * @param {Node} node
 * @param {number} [index]
 * @param {Parent} [parent]
 * @returns {node is X}
 */

/**
 * @callback AssertAnything
 * @param {unknown} [node]
 * @param {number} [index]
 * @param {Parent} [parent]
 * @returns {boolean}
 */

/**
 * Check if a node passes a certain node test
 *
 * @template {Node} Y
 * @callback AssertPredicate
 * @param {unknown} [node]
 * @param {number} [index]
 * @param {Parent} [parent]
 * @returns {node is Y}
 */

var is =
  /**
   * Check if a node passes a test.
   * When a `parent` node is known the `index` of node should also be given.
   *
   * @type {(
   *   (<T extends Node>(node: unknown, test: T['type']|Partial<T>|TestFunctionPredicate<T>|Array.<T['type']|Partial<T>|TestFunctionPredicate<T>>, index?: number, parent?: Parent, context?: unknown) => node is T) &
   *   ((node?: unknown, test?: Test, index?: number, parent?: Parent, context?: unknown) => boolean)
   * )}
   */
  (
    /**
     * Check if a node passes a test.
     * When a `parent` node is known the `index` of node should also be given.
     *
     * @param {unknown} [node] Node to check
     * @param {Test} [test]
     * When nullish, checks if `node` is a `Node`.
     * When `string`, works like passing `function (node) {return node.type === test}`.
     * When `function` checks if function passed the node is true.
     * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
     * When `array`, checks any one of the subtests pass.
     * @param {number} [index] Position of `node` in `parent`
     * @param {Parent} [parent] Parent of `node`
     * @param {unknown} [context] Context object to invoke `test` with
     * @returns {boolean} Whether test passed and `node` is a `Node` (object with `type` set to non-empty `string`).
     */
    // eslint-disable-next-line max-params
    function is(node, test, index, parent, context) {
      var check = convert(test)

      if (
        index !== undefined &&
        index !== null &&
        (typeof index !== 'number' ||
          index < 0 ||
          index === Number.POSITIVE_INFINITY)
      ) {
        throw new Error('Expected positive finite index')
      }

      if (
        parent !== undefined &&
        parent !== null &&
        (!is(parent) || !parent.children)
      ) {
        throw new Error('Expected parent node')
      }

      if (
        (parent === undefined || parent === null) !==
        (index === undefined || index === null)
      ) {
        throw new Error('Expected both parent and index')
      }

      // @ts-ignore Looks like a node.
      return node && node.type && typeof node.type === 'string'
        ? Boolean(check.call(context, node, index, parent))
        : false
    }
  )

var convert =
  /**
   * @type {(
   *   (<T extends Node>(test: T['type']|Partial<T>|TestFunctionPredicate<T>) => AssertPredicate<T>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  (
    /**
     * Generate an assertion from a check.
     * @param {Test} [test]
     * When nullish, checks if `node` is a `Node`.
     * When `string`, works like passing `function (node) {return node.type === test}`.
     * When `function` checks if function passed the node is true.
     * When `object`, checks that all keys in test are in node, and that they have (strictly) equal values.
     * When `array`, checks any one of the subtests pass.
     * @returns {AssertAnything}
     */
    function (test) {
      if (test === undefined || test === null) {
        return ok
      }

      if (typeof test === 'string') {
        return typeFactory(test)
      }

      if (typeof test === 'object') {
        // @ts-ignore looks like a list of tests / partial test object.
        return 'length' in test ? anyFactory(test) : propsFactory(test)
      }

      if (typeof test === 'function') {
        return castFactory(test)
      }

      throw new Error('Expected function, string, or object as test')
    }
  )
/**
 * @param {Array.<Type|Props|TestFunctionAnything>} tests
 * @returns {AssertAnything}
 */
function anyFactory(tests) {
  /** @type {Array.<AssertAnything>} */
  var checks = []
  var index = -1

  while (++index < tests.length) {
    checks[index] = convert(tests[index])
  }

  return castFactory(any)

  /**
   * @this {unknown}
   * @param {unknown[]} parameters
   * @returns {boolean}
   */
  function any(...parameters) {
    var index = -1

    while (++index < checks.length) {
      if (checks[index].call(this, ...parameters)) return true
    }
  }
}

/**
 * Utility to assert each property in `test` is represented in `node`, and each
 * values are strictly equal.
 *
 * @param {Props} check
 * @returns {AssertAnything}
 */
function propsFactory(check) {
  return castFactory(all)

  /**
   * @param {Node} node
   * @returns {boolean}
   */
  function all(node) {
    /** @type {string} */
    var key

    for (key in check) {
      if (node[key] !== check[key]) return
    }

    return true
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 *
 * @param {Type} check
 * @returns {AssertAnything}
 */
function typeFactory(check) {
  return castFactory(type)

  /**
   * @param {Node} node
   */
  function type(node) {
    return node && node.type === check
  }
}

/**
 * Utility to convert a string into a function which checks a given node’s type
 * for said string.
 * @param {TestFunctionAnything} check
 * @returns {AssertAnything}
 */
function castFactory(check) {
  return assertion

  /**
   * @this {unknown}
   * @param {Array.<unknown>} parameters
   * @returns {boolean}
   */
  function assertion(...parameters) {
    return Boolean(check.call(this, ...parameters))
  }
}

// Utility to return true.
function ok() {
  return true
}

;// CONCATENATED MODULE: ./node_modules/unist-util-select/lib/pseudo.js
/**
 * @typedef {import('./types.js').Rule} Rule
 * @typedef {import('./types.js').RulePseudo} RulePseudo
 * @typedef {import('./types.js').RulePseudoNth} RulePseudoNth
 * @typedef {import('./types.js').RulePseudoSelector} RulePseudoSelector
 * @typedef {import('./types.js').Parent} Parent
 * @typedef {import('./types.js').Selector} Selector
 * @typedef {import('./types.js').Selectors} Selectors
 * @typedef {import('./types.js').SelectState} SelectState
 * @typedef {import('./types.js').Node} Node
 */





var pseudo_is = convert()

var pseudo_handle = zwitch('name', {
  unknown: unknownPseudo,
  invalid: invalidPseudo,
  handlers: {
    any: matches,
    blank: empty,
    empty,
    'first-child': firstChild,
    'first-of-type': firstOfType,
    has: hasSelector,
    'last-child': lastChild,
    'last-of-type': lastOfType,
    matches,
    not,
    'nth-child': nthChild,
    'nth-last-child': nthLastChild,
    'nth-of-type': nthOfType,
    'nth-last-of-type': nthLastOfType,
    'only-child': onlyChild,
    'only-of-type': onlyOfType,
    root: pseudo_root,
    scope
  }
})

pseudo.needsIndex = [
  'first-child',
  'first-of-type',
  'last-child',
  'last-of-type',
  'nth-child',
  'nth-last-child',
  'nth-of-type',
  'nth-last-of-type',
  'only-child',
  'only-of-type'
]

/**
 * @param {Rule} query
 * @param {Node} node
 * @param {number|null} index
 * @param {Parent|null} parent
 * @param {SelectState} state
 * @returns {boolean}
 */
function pseudo(query, node, index, parent, state) {
  var pseudos = query.pseudos
  var offset = -1

  while (++offset < pseudos.length) {
    if (!pseudo_handle(pseudos[offset], node, index, parent, state)) return false
  }

  return true
}

/**
 * @param {RulePseudoSelector} query
 * @param {Node} node
 * @param {number|null} _1
 * @param {Parent|null} _2
 * @param {SelectState} state
 * @returns {boolean}
 */
function matches(query, node, _1, _2, state) {
  var shallow = state.shallow
  var one = state.one
  /** @type {boolean} */
  var result

  state.one = true
  state.shallow = true

  result = state.any(query.value, node, state)[0] === node

  state.shallow = shallow
  state.one = one

  return result
}

/**
 * @param {RulePseudoSelector} query
 * @param {Node} node
 * @param {number|null} index
 * @param {Parent|null} parent
 * @param {SelectState} state
 * @returns {boolean}
 */
function not(query, node, index, parent, state) {
  return !matches(query, node, index, parent, state)
}

/**
 * @param {RulePseudo} _1
 * @param {Node} node
 * @param {number|null} _2
 * @param {Parent|null} parent
 * @returns {boolean}
 */
function pseudo_root(_1, node, _2, parent) {
  return pseudo_is(node) && !parent
}

/**
 * @param {RulePseudo} _1
 * @param {Node} node
 * @param {number|null} _2
 * @param {Parent|null} _3
 * @param {SelectState} state
 * @returns {boolean}
 */
function scope(_1, node, _2, _3, state) {
  return pseudo_is(node) && state.scopeNodes.includes(node)
}

/**
 * @param {RulePseudo} _1
 * @param {Node} node
 * @returns {boolean}
 */
function empty(_1, node) {
  return util_parent(node) ? node.children.length === 0 : !('value' in node)
}

/**
 * @param {RulePseudo} query
 * @param {Node} _1
 * @param {number|null} _2
 * @param {Parent|null} _3
 * @param {SelectState} state
 * @returns {boolean}
 */
function firstChild(query, _1, _2, _3, state) {
  assertDeep(state, query)
  return state.nodeIndex === 0 // Specifically `0`, not falsey.
}

/**
 * @param {RulePseudo} query
 * @param {Node} _1
 * @param {number|null} _2
 * @param {Parent|null} _3
 * @param {SelectState} state
 * @returns {boolean}
 */
function lastChild(query, _1, _2, _3, state) {
  assertDeep(state, query)
  return state.nodeIndex === state.nodeCount - 1
}

/**
 * @param {RulePseudo} query
 * @param {Node} _1
 * @param {number|null} _2
 * @param {Parent|null} _3
 * @param {SelectState} state
 * @returns {boolean}
 */
function onlyChild(query, _1, _2, _3, state) {
  assertDeep(state, query)
  return state.nodeCount === 1
}

/**
 * @param {RulePseudoNth} query
 * @param {Node} _1
 * @param {number|null} _2
 * @param {Parent|null} _3
 * @param {SelectState} state
 * @returns {boolean}
 */
function nthChild(query, _1, _2, _3, state) {
  assertDeep(state, query)
  return query.value(state.nodeIndex)
}

/**
 * @param {RulePseudoNth} query
 * @param {Node} _1
 * @param {number|null} _2
 * @param {Parent|null} _3
 * @param {SelectState} state
 * @returns {boolean}
 */
function nthLastChild(query, _1, _2, _3, state) {
  assertDeep(state, query)
  return query.value(state.nodeCount - state.nodeIndex - 1)
}

/**
 * @param {RulePseudoNth} query
 * @param {Node} _1
 * @param {number|null} _2
 * @param {Parent|null} _3
 * @param {SelectState} state
 * @returns {boolean}
 */
function nthOfType(query, _1, _2, _3, state) {
  assertDeep(state, query)
  return query.value(state.typeIndex)
}

/**
 * @param {RulePseudoNth} query
 * @param {Node} _1
 * @param {number|null} _2
 * @param {Parent|null} _3
 * @param {SelectState} state
 * @returns {boolean}
 */
function nthLastOfType(query, _1, _2, _3, state) {
  assertDeep(state, query)
  return query.value(state.typeCount - 1 - state.typeIndex)
}

/**
 * @param {RulePseudo} query
 * @param {Node} _1
 * @param {number|null} _2
 * @param {Parent|null} _3
 * @param {SelectState} state
 * @returns {boolean}
 */
function firstOfType(query, _1, _2, _3, state) {
  assertDeep(state, query)
  return state.typeIndex === 0
}

/**
 * @param {RulePseudo} query
 * @param {Node} _1
 * @param {number|null} _2
 * @param {Parent|null} _3
 * @param {SelectState} state
 * @returns {boolean}
 */
function lastOfType(query, _1, _2, _3, state) {
  assertDeep(state, query)
  return state.typeIndex === state.typeCount - 1
}

/**
 * @param {RulePseudo} query
 * @param {Node} _1
 * @param {number|null} _2
 * @param {Parent|null} _3
 * @param {SelectState} state
 * @returns {boolean}
 */
function onlyOfType(query, _1, _2, _3, state) {
  assertDeep(state, query)
  return state.typeCount === 1
}

// Shouldn’t be invoked, parser gives correct data.
/* c8 ignore next 3 */
function invalidPseudo() {
  throw new Error('Invalid pseudo-selector')
}

/**
 * @param {RulePseudo} query
 * @returns {boolean}
 */
function unknownPseudo(query) {
  if (query.name) {
    throw new Error('Unknown pseudo-selector `' + query.name + '`')
  }

  throw new Error('Unexpected pseudo-element or empty pseudo-class')
}

/**
 * @param {SelectState} state
 * @param {RulePseudo|RulePseudoNth} query
 */
function assertDeep(state, query) {
  if (state.shallow) {
    throw new Error('Cannot use `:' + query.name + '` without parent')
  }
}

/**
 * @param {RulePseudoSelector} query
 * @param {Node} node
 * @param {number|null} _1
 * @param {Parent|null} _2
 * @param {SelectState} state
 * @returns {boolean}
 */
function hasSelector(query, node, _1, _2, state) {
  var shallow = state.shallow
  var one = state.one
  var scopeNodes = state.scopeNodes
  var value = appendScope(query.value)
  var anything = state.any
  /** @type {boolean} */
  var result

  state.shallow = false
  state.one = true
  state.scopeNodes = [node]

  result = Boolean(anything(value, node, state)[0])

  state.shallow = shallow
  state.one = one
  state.scopeNodes = scopeNodes

  return result
}

/**
 * @param {Selector} value
 */
function appendScope(value) {
  /** @type {Selectors} */
  var selector =
    value.type === 'ruleSet' ? {type: 'selectors', selectors: [value]} : value
  var index = -1
  /** @type {Rule} */
  var rule

  while (++index < selector.selectors.length) {
    rule = selector.selectors[index].rule
    rule.nestingOperator = null

    // Needed if new pseudo’s are added that accepts commas (such as
    // `:lang(en, nl)`)
    /* c8 ignore else */
    if (
      !rule.pseudos ||
      rule.pseudos.length !== 1 ||
      rule.pseudos[0].name !== 'scope'
    ) {
      selector.selectors[index] = {
        type: 'ruleSet',
        rule: {
          type: 'rule',
          rule,
          // @ts-ignore pseudos are fine w/ just a name!
          pseudos: [{name: 'scope'}]
        }
      }
    }
  }

  return selector
}

;// CONCATENATED MODULE: ./node_modules/unist-util-select/lib/attribute.js
/**
 * @typedef {import('./types.js').Rule} Rule
 * @typedef {import('./types.js').RuleAttr} RuleAttr
 * @typedef {import('./types.js').Node} Node
 */



var attribute_handle = zwitch('operator', {
  unknown: unknownOperator,
  invalid: exists,
  handlers: {
    '=': exact,
    '^=': begins,
    '$=': ends,
    '*=': containsString,
    '~=': containsArray
  }
})

/**
 * @param {Rule} query
 * @param {Node} node
 */
function attribute(query, node) {
  var index = -1

  while (++index < query.attrs.length) {
    if (!attribute_handle(query.attrs[index], node)) return false
  }

  return true
}

/**
 * `[attr]`
 *
 * @param {RuleAttr} query
 * @param {Node} node
 */
function exists(query, node) {
  return node[query.name] !== null && node[query.name] !== undefined
}

/**
 * `[attr=value]`
 *
 * @param {RuleAttr} query
 * @param {Node} node
 */
function exact(query, node) {
  return exists(query, node) && String(node[query.name]) === query.value
}

/**
 * `[attr~=value]`
 *
 * @param {RuleAttr} query
 * @param {Node} node
 */
function containsArray(query, node) {
  var value = node[query.name]

  if (value === null || value === undefined) return false

  // If this is an array, and the query is contained in it, return true.
  // Coverage comment in place because TS turns `Array.isArray(unknown)`
  // into `Array.<any>` instead of `Array.<unknown>`.
  // type-coverage:ignore-next-line
  if (Array.isArray(value) && value.includes(query.value)) {
    return true
  }

  // For all other values, return whether this is an exact match.
  return String(value) === query.value
}

/**
 * `[attr^=value]`
 *
 * @param {RuleAttr} query
 * @param {Node} node
 */
function begins(query, node) {
  var value = node[query.name]

  return (
    typeof value === 'string' &&
    value.slice(0, query.value.length) === query.value
  )
}

/**
 * `[attr$=value]`
 *
 * @param {RuleAttr} query
 * @param {Node} node
 */
function ends(query, node) {
  var value = node[query.name]

  return (
    typeof value === 'string' &&
    value.slice(-query.value.length) === query.value
  )
}

/**
 * `[attr*=value]`
 *
 * @param {RuleAttr} query
 * @param {Node} node
 */
function containsString(query, node) {
  var value = node[query.name]
  return typeof value === 'string' && value.includes(query.value)
}

// Shouldn’t be invoked, Parser throws an error instead.
/* c8 ignore next 6 */
/**
 * @param {{[x: string]: unknown, type: string}} query
 */
function unknownOperator(query) {
  throw new Error('Unknown operator `' + query.operator + '`')
}

;// CONCATENATED MODULE: ./node_modules/unist-util-select/lib/name.js
/**
 * @typedef {import('./types.js').Rule} Rule
 * @typedef {import('./types.js').Node} Node
 */

/**
 * @param {Rule} query
 * @param {Node} node
 */
function name_name(query, node) {
  return query.tagName === '*' || query.tagName === node.type
}

;// CONCATENATED MODULE: ./node_modules/unist-util-select/lib/test.js
/**
 * @typedef {import('./types.js').Rule} Rule
 * @typedef {import('./types.js').Node} Node
 * @typedef {import('./types.js').Parent} Parent
 * @typedef {import('./types.js').SelectState} SelectState
 */





/**
 * @param {Rule} query
 * @param {Node} node
 * @param {number|null} index
 * @param {Parent|null} parent
 * @param {SelectState} state
 * @returns {boolean}
 */
function test(query, node, index, parent, state) {
  if (query.id) throw new Error('Invalid selector: id')
  if (query.classNames) throw new Error('Invalid selector: class')

  return Boolean(
    node &&
      (!query.tagName || name_name(query, node)) &&
      (!query.attrs || attribute(query, node)) &&
      (!query.pseudos || pseudo(query, node, index, parent, state))
  )
}

;// CONCATENATED MODULE: ./node_modules/unist-util-select/lib/any.js
/**
 * @typedef {import('./types.js').Selector} Selector
 * @typedef {import('./types.js').Selectors} Selectors
 * @typedef {import('./types.js').Rule} Rule
 * @typedef {import('./types.js').RuleSet} RuleSet
 * @typedef {import('./types.js').RulePseudo} RulePseudo
 * @typedef {import('./types.js').Query} Query
 * @typedef {import('./types.js').Node} Node
 * @typedef {import('./types.js').Parent} Parent
 * @typedef {import('./types.js').SelectIterator} SelectIterator
 * @typedef {import('./types.js').SelectState} SelectState
 */







var type = zwitch('type', {
  unknown: unknownType,
  invalid: invalidType,
  handlers: {selectors, ruleSet, rule}
})

/**
 * @param {Selectors|RuleSet|Rule} query
 * @param {Node} node
 * @param {SelectState} state
 */
function any(query, node, state) {
  // @ts-ignore zwitch types are off.
  return query && node ? type(query, node, state) : []
}

/**
 * @param {Selectors} query
 * @param {Node} node
 * @param {SelectState} state
 */
function selectors(query, node, state) {
  var collect = collector(state.one)
  var index = -1

  while (++index < query.selectors.length) {
    collect(ruleSet(query.selectors[index], node, state))
  }

  return collect.result
}

/**
 * @param {RuleSet} query
 * @param {Node} node
 * @param {SelectState} state
 */
function ruleSet(query, node, state) {
  return rule(query.rule, node, state)
}

/**
 * @param {Rule} query
 * @param {Node} tree
 * @param {SelectState} state
 */
function rule(query, tree, state) {
  var collect = collector(state.one)

  if (state.shallow && query.rule) {
    throw new Error('Expected selector without nesting')
  }

  nest(
    query,
    tree,
    0,
    null,
    configure(query, {
      scopeNodes: root(tree) ? tree.children : [tree],
      index: false,
      iterator,
      one: state.one,
      shallow: state.shallow,
      any: state.any
    })
  )

  return collect.result

  /** @type {SelectIterator} */
  function iterator(query, node, index, parent, state) {
    if (test(query, node, index, parent, state)) {
      if ('rule' in query) {
        nest(query.rule, node, index, parent, configure(query.rule, state))
      } else {
        collect(node)
        state.found = true
      }
    }
  }
}

/**
 * @template {SelectState} S
 * @param {Rule} query
 * @param {S} state
 * @returns {S}
 */
function configure(query, state) {
  var pseudos = query.pseudos || []
  var index = -1

  while (++index < pseudos.length) {
    if (pseudo.needsIndex.includes(pseudos[index].name)) {
      state.index = true
      break
    }
  }

  return state
}

// Shouldn’t be invoked, all data is handled.
/* c8 ignore next 6 */
/**
 * @param {{[x: string]: unknown, type: string}} query
 */
function unknownType(query) {
  throw new Error('Unknown type `' + query.type + '`')
}

// Shouldn’t be invoked, parser gives correct data.
/* c8 ignore next 3 */
function invalidType() {
  throw new Error('Invalid type')
}

/**
 * @param {boolean} one
 */
function collector(one) {
  /** @type {Array.<Node>} */
  var result = []
  /** @type {boolean} */
  var found

  collect.result = result

  return collect

  /**
   * Append nodes to array, filtering out duplicates.
   *
   * @param {Node|Array.<Node>} node
   */
  function collect(node) {
    var index = -1

    if ('length' in node) {
      while (++index < node.length) {
        collectOne(node[index])
      }
    } else {
      collectOne(node)
    }
  }

  /**
   * @param {Node} node
   */
  function collectOne(node) {
    if (one) {
      /* Shouldn’t happen, safeguards performance problems. */
      /* c8 ignore next */
      if (found) throw new Error('Cannot collect multiple nodes')

      found = true
    }

    if (!result.includes(node)) result.push(node)
  }
}

// EXTERNAL MODULE: ./node_modules/css-selector-parser/lib/index.js
var lib = __webpack_require__(8079);
// EXTERNAL MODULE: ./node_modules/nth-check/lib/index.js
var nth_check_lib = __webpack_require__(7540);
;// CONCATENATED MODULE: ./node_modules/unist-util-select/lib/parse.js
/**
 * @typedef {import('./types.js').Selector} Selector
 * @typedef {import('./types.js').Selectors} Selectors
 * @typedef {import('./types.js').RuleSet} RuleSet
 * @typedef {import('./types.js').Rule} Rule
 * @typedef {import('./types.js').RulePseudo} RulePseudo
 * @typedef {import('./types.js').RulePseudoNth} RulePseudoNth
 */





/** @type {import('nth-check').default} */
// @ts-ignore
var nthCheck = nth_check_lib/* default */.ZP

var nth = new Set([
  'nth-child',
  'nth-last-child',
  'nth-of-type',
  'nth-last-of-type'
])

var parser = new lib/* CssSelectorParser */.N()

parser.registerAttrEqualityMods('~', '^', '$', '*')
parser.registerSelectorPseudos('any', 'matches', 'not', 'has')
parser.registerNestingOperators('>', '+', '~')

var compile = zwitch('type', {handlers: {selectors: parse_selectors, ruleSet: parse_ruleSet, rule: parse_rule}})

/**
 * @param {string} selector
 * @returns {Selector}
 */
function parse(selector) {
  if (typeof selector !== 'string') {
    throw new TypeError('Expected `string` as selector, not `' + selector + '`')
  }

  // @ts-ignore types are wrong.
  return compile(parser.parse(selector))
}

/**
 * @param {Selectors} query
 */
function parse_selectors(query) {
  var selectors = query.selectors
  var index = -1

  while (++index < selectors.length) {
    compile(selectors[index])
  }

  return query
}

/**
 * @param {RuleSet} query
 */
function parse_ruleSet(query) {
  return parse_rule(query.rule)
}

/**
 * @param {Rule} query
 */
function parse_rule(query) {
  var pseudos = query.pseudos || []
  var index = -1
  /** @type {RulePseudo|RulePseudoNth} */
  var pseudo

  while (++index < pseudos.length) {
    pseudo = pseudos[index]

    if (nth.has(pseudo.name)) {
      // @ts-ignore Patch a non-primitive type.
      pseudo.value = nthCheck(pseudo.value)
      // @ts-ignore Patch a non-primitive type.
      pseudo.valueType = 'function'
    }
  }

  compile(query.rule)

  return query
}

;// CONCATENATED MODULE: ./node_modules/unist-util-select/index.js
/**
 * @typedef {import('unist').Node} Node
 */




/**
 * @param {string} selector
 * @param {Node} [node]
 * @returns {boolean}
 */
function unist_util_select_matches(selector, node) {
  return Boolean(any(parse(selector), node, {one: true, shallow: true, any: any})[0])
}

/**
 * @param {string} selector
 * @param {Node} [node]
 * @returns {Node|null}
 */
function unist_util_select_select(selector, node) {
  return any(parse(selector), node, {one: true, any: any})[0] || null
}

/**
 * @param {string} selector
 * @param {Node} [node]
 * @returns {Array.<Node>}
 */
function selectAll(selector, node) {
  return any(parse(selector), node, {any: any})
}


/***/ }),

/***/ 8348:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"nbsp":" ","iexcl":"¡","cent":"¢","pound":"£","curren":"¤","yen":"¥","brvbar":"¦","sect":"§","uml":"¨","copy":"©","ordf":"ª","laquo":"«","not":"¬","shy":"­","reg":"®","macr":"¯","deg":"°","plusmn":"±","sup2":"²","sup3":"³","acute":"´","micro":"µ","para":"¶","middot":"·","cedil":"¸","sup1":"¹","ordm":"º","raquo":"»","frac14":"¼","frac12":"½","frac34":"¾","iquest":"¿","Agrave":"À","Aacute":"Á","Acirc":"Â","Atilde":"Ã","Auml":"Ä","Aring":"Å","AElig":"Æ","Ccedil":"Ç","Egrave":"È","Eacute":"É","Ecirc":"Ê","Euml":"Ë","Igrave":"Ì","Iacute":"Í","Icirc":"Î","Iuml":"Ï","ETH":"Ð","Ntilde":"Ñ","Ograve":"Ò","Oacute":"Ó","Ocirc":"Ô","Otilde":"Õ","Ouml":"Ö","times":"×","Oslash":"Ø","Ugrave":"Ù","Uacute":"Ú","Ucirc":"Û","Uuml":"Ü","Yacute":"Ý","THORN":"Þ","szlig":"ß","agrave":"à","aacute":"á","acirc":"â","atilde":"ã","auml":"ä","aring":"å","aelig":"æ","ccedil":"ç","egrave":"è","eacute":"é","ecirc":"ê","euml":"ë","igrave":"ì","iacute":"í","icirc":"î","iuml":"ï","eth":"ð","ntilde":"ñ","ograve":"ò","oacute":"ó","ocirc":"ô","otilde":"õ","ouml":"ö","divide":"÷","oslash":"ø","ugrave":"ù","uacute":"ú","ucirc":"û","uuml":"ü","yacute":"ý","thorn":"þ","yuml":"ÿ","fnof":"ƒ","Alpha":"Α","Beta":"Β","Gamma":"Γ","Delta":"Δ","Epsilon":"Ε","Zeta":"Ζ","Eta":"Η","Theta":"Θ","Iota":"Ι","Kappa":"Κ","Lambda":"Λ","Mu":"Μ","Nu":"Ν","Xi":"Ξ","Omicron":"Ο","Pi":"Π","Rho":"Ρ","Sigma":"Σ","Tau":"Τ","Upsilon":"Υ","Phi":"Φ","Chi":"Χ","Psi":"Ψ","Omega":"Ω","alpha":"α","beta":"β","gamma":"γ","delta":"δ","epsilon":"ε","zeta":"ζ","eta":"η","theta":"θ","iota":"ι","kappa":"κ","lambda":"λ","mu":"μ","nu":"ν","xi":"ξ","omicron":"ο","pi":"π","rho":"ρ","sigmaf":"ς","sigma":"σ","tau":"τ","upsilon":"υ","phi":"φ","chi":"χ","psi":"ψ","omega":"ω","thetasym":"ϑ","upsih":"ϒ","piv":"ϖ","bull":"•","hellip":"…","prime":"′","Prime":"″","oline":"‾","frasl":"⁄","weierp":"℘","image":"ℑ","real":"ℜ","trade":"™","alefsym":"ℵ","larr":"←","uarr":"↑","rarr":"→","darr":"↓","harr":"↔","crarr":"↵","lArr":"⇐","uArr":"⇑","rArr":"⇒","dArr":"⇓","hArr":"⇔","forall":"∀","part":"∂","exist":"∃","empty":"∅","nabla":"∇","isin":"∈","notin":"∉","ni":"∋","prod":"∏","sum":"∑","minus":"−","lowast":"∗","radic":"√","prop":"∝","infin":"∞","ang":"∠","and":"∧","or":"∨","cap":"∩","cup":"∪","int":"∫","there4":"∴","sim":"∼","cong":"≅","asymp":"≈","ne":"≠","equiv":"≡","le":"≤","ge":"≥","sub":"⊂","sup":"⊃","nsub":"⊄","sube":"⊆","supe":"⊇","oplus":"⊕","otimes":"⊗","perp":"⊥","sdot":"⋅","lceil":"⌈","rceil":"⌉","lfloor":"⌊","rfloor":"⌋","lang":"〈","rang":"〉","loz":"◊","spades":"♠","clubs":"♣","hearts":"♥","diams":"♦","quot":"\\"","amp":"&","lt":"<","gt":">","OElig":"Œ","oelig":"œ","Scaron":"Š","scaron":"š","Yuml":"Ÿ","circ":"ˆ","tilde":"˜","ensp":" ","emsp":" ","thinsp":" ","zwnj":"‌","zwj":"‍","lrm":"‎","rlm":"‏","ndash":"–","mdash":"—","lsquo":"‘","rsquo":"’","sbquo":"‚","ldquo":"“","rdquo":"”","bdquo":"„","dagger":"†","Dagger":"‡","permil":"‰","lsaquo":"‹","rsaquo":"›","euro":"€"}');

/***/ }),

/***/ 7452:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"AElig":"Æ","AMP":"&","Aacute":"Á","Acirc":"Â","Agrave":"À","Aring":"Å","Atilde":"Ã","Auml":"Ä","COPY":"©","Ccedil":"Ç","ETH":"Ð","Eacute":"É","Ecirc":"Ê","Egrave":"È","Euml":"Ë","GT":">","Iacute":"Í","Icirc":"Î","Igrave":"Ì","Iuml":"Ï","LT":"<","Ntilde":"Ñ","Oacute":"Ó","Ocirc":"Ô","Ograve":"Ò","Oslash":"Ø","Otilde":"Õ","Ouml":"Ö","QUOT":"\\"","REG":"®","THORN":"Þ","Uacute":"Ú","Ucirc":"Û","Ugrave":"Ù","Uuml":"Ü","Yacute":"Ý","aacute":"á","acirc":"â","acute":"´","aelig":"æ","agrave":"à","amp":"&","aring":"å","atilde":"ã","auml":"ä","brvbar":"¦","ccedil":"ç","cedil":"¸","cent":"¢","copy":"©","curren":"¤","deg":"°","divide":"÷","eacute":"é","ecirc":"ê","egrave":"è","eth":"ð","euml":"ë","frac12":"½","frac14":"¼","frac34":"¾","gt":">","iacute":"í","icirc":"î","iexcl":"¡","igrave":"ì","iquest":"¿","iuml":"ï","laquo":"«","lt":"<","macr":"¯","micro":"µ","middot":"·","nbsp":" ","not":"¬","ntilde":"ñ","oacute":"ó","ocirc":"ô","ograve":"ò","ordf":"ª","ordm":"º","oslash":"ø","otilde":"õ","ouml":"ö","para":"¶","plusmn":"±","pound":"£","quot":"\\"","raquo":"»","reg":"®","sect":"§","shy":"­","sup1":"¹","sup2":"²","sup3":"³","szlig":"ß","thorn":"þ","times":"×","uacute":"ú","ucirc":"û","ugrave":"ù","uml":"¨","uuml":"ü","yacute":"ý","yen":"¥","yuml":"ÿ"}');

/***/ }),

/***/ 3580:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"0":"�","128":"€","130":"‚","131":"ƒ","132":"„","133":"…","134":"†","135":"‡","136":"ˆ","137":"‰","138":"Š","139":"‹","140":"Œ","142":"Ž","145":"‘","146":"’","147":"“","148":"”","149":"•","150":"–","151":"—","152":"˜","153":"™","154":"š","155":"›","156":"œ","158":"ž","159":"Ÿ"}');

/***/ }),

/***/ 6947:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('["altGlyph","altGlyphDef","altGlyphItem","animateColor","animateMotion","animateTransform","clipPath","feBlend","feColorMatrix","feComponentTransfer","feComposite","feConvolveMatrix","feDiffuseLighting","feDisplacementMap","feDistantLight","feDropShadow","feFlood","feFuncA","feFuncB","feFuncG","feFuncR","feGaussianBlur","feImage","feMerge","feMergeNode","feMorphology","feOffset","fePointLight","feSpecularLighting","feSpotLight","feTile","feTurbulence","foreignObject","glyphRef","linearGradient","radialGradient","solidColor","textArea","textPath"]');

/***/ }),

/***/ 9878:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('["area","base","basefont","bgsound","br","col","command","embed","frame","hr","image","img","input","isindex","keygen","link","menuitem","meta","nextid","param","source","track","wbr"]');

/***/ }),

/***/ 9640:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"classId":"classID","dataType":"datatype","itemId":"itemID","strokeDashArray":"strokeDasharray","strokeDashOffset":"strokeDashoffset","strokeLineCap":"strokeLinecap","strokeLineJoin":"strokeLinejoin","strokeMiterLimit":"strokeMiterlimit","typeOf":"typeof","xLinkActuate":"xlinkActuate","xLinkArcRole":"xlinkArcrole","xLinkHref":"xlinkHref","xLinkRole":"xlinkRole","xLinkShow":"xlinkShow","xLinkTitle":"xlinkTitle","xLinkType":"xlinkType","xmlnsXLink":"xmlnsXlink"}');

/***/ }),

/***/ 9052:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"strip":["script"],"clobberPrefix":"user-content-","clobber":["name","id"],"ancestors":{"tbody":["table"],"tfoot":["table"],"thead":["table"],"td":["table"],"th":["table"],"tr":["table"]},"protocols":{"href":["http","https","mailto","xmpp","irc","ircs"],"cite":["http","https"],"src":["http","https"],"longDesc":["http","https"]},"tagNames":["h1","h2","h3","h4","h5","h6","br","b","i","strong","em","a","pre","code","img","tt","div","ins","del","sup","sub","p","ol","ul","table","thead","tbody","tfoot","blockquote","dl","dt","dd","kbd","q","samp","var","hr","ruby","rt","rp","li","tr","td","th","s","strike","summary","details","caption","figure","figcaption","abbr","bdo","cite","dfn","mark","small","span","time","wbr","input"],"attributes":{"a":["href"],"img":["src","longDesc"],"input":[["type","checkbox"],["disabled",true]],"li":[["className","task-list-item"]],"div":["itemScope","itemType"],"blockquote":["cite"],"del":["cite"],"ins":["cite"],"q":["cite"],"*":["abbr","accept","acceptCharset","accessKey","action","align","alt","ariaDescribedBy","ariaHidden","ariaLabel","ariaLabelledBy","axis","border","cellPadding","cellSpacing","char","charOff","charSet","checked","clear","cols","colSpan","color","compact","coords","dateTime","dir","disabled","encType","htmlFor","frame","headers","height","hrefLang","hSpace","isMap","id","label","lang","maxLength","media","method","multiple","name","noHref","noShade","noWrap","open","prompt","readOnly","rel","rev","rows","rowSpan","rules","scope","selected","shape","size","span","start","summary","tabIndex","target","title","type","useMap","vAlign","value","vSpace","width","itemProp"]},"required":{"input":{"type":"checkbox","disabled":true}}}');

/***/ }),

/***/ 2702:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('["cent","copy","divide","gt","lt","not","para","times"]');

/***/ }),

/***/ 3235:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('["cent","copy","divide","gt","lt","not","para","times"]');

/***/ }),

/***/ 6:
/***/ ((module) => {

"use strict";
module.exports = JSON.parse('{"html":"http://www.w3.org/1999/xhtml","mathml":"http://www.w3.org/1998/Math/MathML","svg":"http://www.w3.org/2000/svg","xlink":"http://www.w3.org/1999/xlink","xml":"http://www.w3.org/XML/1998/namespace","xmlns":"http://www.w3.org/2000/xmlns/"}');

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	(() => {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
(() => {
"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Components": () => (/* binding */ Components),
/* harmony export */   "astToPlainText": () => (/* binding */ astToPlainText),
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__),
/* harmony export */   "hast": () => (/* binding */ hast),
/* harmony export */   "html": () => (/* binding */ html),
/* harmony export */   "md": () => (/* binding */ md),
/* harmony export */   "mdast": () => (/* binding */ mdast),
/* harmony export */   "plain": () => (/* binding */ plain),
/* harmony export */   "processor": () => (/* binding */ processor),
/* harmony export */   "react": () => (/* binding */ react),
/* harmony export */   "reactProcessor": () => (/* binding */ reactProcessor),
/* harmony export */   "reactTOC": () => (/* binding */ reactTOC),
/* harmony export */   "setup": () => (/* binding */ setup),
/* harmony export */   "utils": () => (/* binding */ utils)
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4942);
/* harmony import */ var _babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1037);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable no-param-reassign */
__webpack_require__(2787);
var Variable = __webpack_require__(3689);
var generateTOC = __webpack_require__(3263);
var React = __webpack_require__(4466);
var rehypeRaw = __webpack_require__(6388);
var rehypeReact = __webpack_require__(7431);
var rehypeSanitize = __webpack_require__(1667);
var rehypeStringify = __webpack_require__(7532);
var remarkBreaks = __webpack_require__(2558);
var remarkDisableTokenizers = __webpack_require__(9168);
var remarkFrontmatter = __webpack_require__(5941);
var remarkParse = __webpack_require__(2861);
var remarkRehype = __webpack_require__(8818);
var remarkSlug = __webpack_require__(4490);
var remarkStringify = __webpack_require__(3734);
var unified = __webpack_require__(8835);
var _require = __webpack_require__(1445),
  mapNodes = _require.map;
var _require2 = __webpack_require__(5907),
  selectAll = _require2.selectAll;
var Components = __webpack_require__(3354);
var _require3 = __webpack_require__(8447),
  getHref = _require3.getHref;
var BaseUrlContext = __webpack_require__(6785);
var CustomParsers = Object.values(__webpack_require__(1593));
var customCompilers = Object.values(__webpack_require__(9647));
var registerCustomComponents = __webpack_require__(1264);
var _require4 = __webpack_require__(2531),
  options = _require4.options,
  parseOptions = _require4.parseOptions;
var _require5 = __webpack_require__(6284),
  calloutIcons = _require5.icons;
var toPlainText = __webpack_require__(4792);
var sectionAnchorId = __webpack_require__(9620);
var tableFlattening = __webpack_require__(4625);
var createSchema = __webpack_require__(8229);
var GlossaryItem = Components.GlossaryItem,
  Code = Components.Code,
  Table = Components.Table,
  Anchor = Components.Anchor,
  Heading = Components.Heading,
  Callout = Components.Callout,
  CodeTabs = Components.CodeTabs,
  Image = Components.Image,
  Embed = Components.Embed,
  HTMLBlock = Components.HTMLBlock,
  Style = Components.Style,
  TableOfContents = Components.TableOfContents;


/**
 * Setup Options
 * !Normalize Magic Block Raw Text!
 */
function setup(blocks) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // merge default and user options
  opts = parseOptions(opts);
  if (!opts.sanitize) {
    opts.sanitize = createSchema(opts);
    Object.values(Components).forEach(function (Component) {
      return Component.sanitize && Component.sanitize(opts.sanitize);
    });
  }

  // normalize magic block linebreaks
  if (opts.normalize && blocks) {
    blocks = blocks.replace(/\[block:/g, '\n\n[block:').replace(/\[\/block\]/g, '[/block]\n');
  }
  return ["".concat(blocks, "\n\n "), opts];
}
var utils = {
  BaseUrlContext: BaseUrlContext,
  getHref: getHref,
  GlossaryContext: GlossaryItem.GlossaryContext,
  options: options,
  VariablesContext: Variable.VariablesContext,
  calloutIcons: calloutIcons
};

/**
 * Core markdown text processor
 */
function processor() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _setup = setup('', opts);
  var _setup2 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_setup, 2);
  opts = _setup2[1];
  var _opts = opts,
    sanitize = _opts.sanitize;
  return unified().use(remarkParse, opts.markdownOptions).use(remarkFrontmatter, ['yaml', 'toml']).data('settings', opts.settings).data('compatibilityMode', opts.compatibilityMode).data('alwaysThrow', opts.alwaysThrow).use(!opts.correctnewlines ? remarkBreaks : function () {}).use(CustomParsers.map(function (parser) {
    var _parser$sanitize;
    return ((_parser$sanitize = parser.sanitize) === null || _parser$sanitize === void 0 ? void 0 : _parser$sanitize.call(parser, sanitize)) || parser;
  })).use(remarkSlug).use(remarkDisableTokenizers, opts.disableTokenizers).use(remarkRehype, {
    allowDangerousHtml: true
  }).use(rehypeRaw).use(rehypeSanitize, sanitize);
}
function plain(text) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var components = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!text) return null;
  var _setup3 = setup(text, opts);
  var _setup4 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_setup3, 2);
  text = _setup4[0];
  opts = _setup4[1];
  return processor(opts).use(rehypeReact, {
    createElement: React.createElement,
    Fragment: React.Fragment,
    components: components
  }).processSync(text).contents;
}

/**
 *  return a React VDOM component tree
 */
// eslint-disable-next-line react/prop-types
var PinWrap = function PinWrap(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: "pin"
  }, children);
}; // @todo: move this to it's own component
var count = {};
function reactProcessor() {
  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var components = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _setup5 = setup('', opts);
  var _setup6 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_setup5, 2);
  opts = _setup6[1];
  var _opts2 = opts,
    sanitize = _opts2.sanitize;
  return processor(_objectSpread({
    sanitize: sanitize
  }, opts)).use(sectionAnchorId).use(rehypeReact, {
    createElement: React.createElement,
    Fragment: React.Fragment,
    components: _objectSpread({
      'code-tabs': CodeTabs(opts),
      'html-block': HTMLBlock(opts),
      'rdme-callout': Callout,
      'readme-variable': Variable,
      'readme-glossary-item': GlossaryItem,
      'rdme-embed': Embed(opts),
      'rdme-pin': PinWrap,
      table: Table,
      a: Anchor,
      h1: Heading(1, count, opts),
      h2: Heading(2, count, opts),
      h3: Heading(3, count, opts),
      h4: Heading(4, count, opts),
      h5: Heading(5, count, opts),
      h6: Heading(6, count, opts),
      code: Code(opts),
      img: Image(opts),
      style: Style(opts)
    }, registerCustomComponents(components, sanitize, opts.customComponentPrefix))
  });
}
function react(content) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var components = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!content) return null;else if (typeof content === 'string') {
    var _setup7 = setup(content, opts);
    var _setup8 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_setup7, 2);
    content = _setup8[0];
    opts = _setup8[1];
  } else {
    var _setup9 = setup('', opts);
    var _setup10 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_setup9, 2);
    opts = _setup10[1];
  }
  var proc = reactProcessor(opts, components);
  if (typeof content === 'string') content = proc.parse(content);
  return proc.stringify(proc.runSync(content));
}
function reactTOC(tree) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!tree) return null;
  var _setup11 = setup('', opts);
  var _setup12 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_setup11, 2);
  opts = _setup12[1];
  var proc = processor(opts).use(rehypeReact, {
    createElement: React.createElement,
    components: {
      p: React.Fragment,
      'readme-variable': Variable,
      'readme-glossary-item': GlossaryItem
    }
  });

  // Normalize Heading Levels
  var minLevel = selectAll('heading', tree).reduce(function (i, _ref2) {
    var depth = _ref2.depth;
    return !i || depth <= i ? depth : i;
  }, false); // determine "root" depth
  tree = mapNodes(tree, function (n) {
    if (n.type === 'heading') n.depth -= minLevel - 1;
    return n;
  });
  var toc = generateTOC(tree, {
    maxDepth: 2
  }).map;
  var ast = toc ? proc.stringify(proc.runSync(toc)) : false;
  return ast ? React.createElement(TableOfContents, {}, ast) : null;
}

/**
 *  transform markdown in to HTML
 */
function html(text) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!text) return null;
  var _setup13 = setup(text, opts);
  var _setup14 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_setup13, 2);
  text = _setup14[0];
  opts = _setup14[1];
  return processor(opts).use(rehypeStringify).processSync(text).contents;
}

/**
 *  convert markdown to an hast object
 */
function hast(text) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!text) return null;
  var _setup15 = setup(text, opts);
  var _setup16 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_setup15, 2);
  text = _setup16[0];
  opts = _setup16[1];
  var rdmd = processor(opts).use(tableFlattening);
  var node = rdmd.parse(text);
  return rdmd.runSync(node);
}

/**
 *  convert markdown to an mdast object
 */
function mdast(text) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!text) return null;
  var _setup17 = setup(text, opts);
  var _setup18 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_setup17, 2);
  text = _setup18[0];
  opts = _setup18[1];
  return processor(opts).parse(text);
}

/**
 * Converts an AST node to plain text
 */
function astToPlainText(node) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!node) return '';
  var _setup19 = setup('', opts);
  var _setup20 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_setup19, 2);
  opts = _setup20[1];
  return processor(opts).use(toPlainText).stringify(node);
}

/**
 *  compile mdast to ReadMe-flavored markdown
 */
function md(tree) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (!tree) return null;
  var _setup21 = setup('', opts);
  var _setup22 = (0,_babel_runtime_helpers_slicedToArray__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_setup21, 2);
  opts = _setup22[1];
  return processor(opts).use(remarkStringify, opts.markdownOptions).use(customCompilers).stringify(tree);
}
var ReadMeMarkdown = function ReadMeMarkdown(text) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return react(text, opts);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ReadMeMarkdown);
})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});